(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "../../node_modules/axios/lib/adapters/adapters.js":
/*!*********************************************************!*\
  !*** ../../node_modules/axios/lib/adapters/adapters.js ***!
  \*********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils.js */ "../../node_modules/axios/lib/utils.js");
/* harmony import */ var _http_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./http.js */ "../../node_modules/axios/lib/helpers/null.js");
/* harmony import */ var _xhr_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./xhr.js */ "../../node_modules/axios/lib/adapters/xhr.js");
/* harmony import */ var _fetch_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./fetch.js */ "../../node_modules/axios/lib/adapters/fetch.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../core/AxiosError.js */ "../../node_modules/axios/lib/core/AxiosError.js");






const knownAdapters = {
  http: _http_js__WEBPACK_IMPORTED_MODULE_0__["default"],
  xhr: _xhr_js__WEBPACK_IMPORTED_MODULE_1__["default"],
  fetch: _fetch_js__WEBPACK_IMPORTED_MODULE_2__["default"]
}

_utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => _utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].isFunction(adapter) || adapter === null || adapter === false;

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  getAdapter: (adapters) => {
    adapters = _utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_4__["default"](`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_4__["default"](
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
});


/***/ }),

/***/ "../../node_modules/axios/lib/adapters/fetch.js":
/*!******************************************************!*\
  !*** ../../node_modules/axios/lib/adapters/fetch.js ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../platform/index.js */ "../../node_modules/axios/lib/platform/index.js");
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils.js */ "../../node_modules/axios/lib/utils.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../core/AxiosError.js */ "../../node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _helpers_composeSignals_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helpers/composeSignals.js */ "../../node_modules/axios/lib/helpers/composeSignals.js");
/* harmony import */ var _helpers_trackStream_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helpers/trackStream.js */ "../../node_modules/axios/lib/helpers/trackStream.js");
/* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../core/AxiosHeaders.js */ "../../node_modules/axios/lib/core/AxiosHeaders.js");
/* harmony import */ var _helpers_progressEventReducer_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../helpers/progressEventReducer.js */ "../../node_modules/axios/lib/helpers/progressEventReducer.js");
/* harmony import */ var _helpers_resolveConfig_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helpers/resolveConfig.js */ "../../node_modules/axios/lib/helpers/resolveConfig.js");
/* harmony import */ var _core_settle_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../core/settle.js */ "../../node_modules/axios/lib/core/settle.js");










const isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === 'function';

// used only inside the fetch adapter
const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ?
    ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) :
    async (str) => new Uint8Array(await new Response(str).arrayBuffer())
);

const test = (fn, ...args) => {
  try {
    return !!fn(...args);
  } catch (e) {
    return false
  }
}

const supportsRequestStream = isReadableStreamSupported && test(() => {
  let duplexAccessed = false;

  const hasContentType = new Request(_platform_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].origin, {
    body: new ReadableStream(),
    method: 'POST',
    get duplex() {
      duplexAccessed = true;
      return 'half';
    },
  }).headers.has('Content-Type');

  return duplexAccessed && !hasContentType;
});

const DEFAULT_CHUNK_SIZE = 64 * 1024;

const supportsResponseStream = isReadableStreamSupported &&
  test(() => _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isReadableStream(new Response('').body));


const resolvers = {
  stream: supportsResponseStream && ((res) => res.body)
};

isFetchSupported && (((res) => {
  ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach(type => {
    !resolvers[type] && (resolvers[type] = _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isFunction(res[type]) ? (res) => res[type]() :
      (_, config) => {
        throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_2__["default"](`Response type '${type}' is not supported`, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_2__["default"].ERR_NOT_SUPPORT, config);
      })
  });
})(new Response));

const getBodyLength = async (body) => {
  if (body == null) {
    return 0;
  }

  if(_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isBlob(body)) {
    return body.size;
  }

  if(_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isSpecCompliantForm(body)) {
    const _request = new Request(_platform_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].origin, {
      method: 'POST',
      body,
    });
    return (await _request.arrayBuffer()).byteLength;
  }

  if(_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isArrayBufferView(body) || _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isArrayBuffer(body)) {
    return body.byteLength;
  }

  if(_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isURLSearchParams(body)) {
    body = body + '';
  }

  if(_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isString(body)) {
    return (await encodeText(body)).byteLength;
  }
}

const resolveBodyLength = async (headers, body) => {
  const length = _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].toFiniteNumber(headers.getContentLength());

  return length == null ? getBodyLength(body) : length;
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (isFetchSupported && (async (config) => {
  let {
    url,
    method,
    data,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = 'same-origin',
    fetchOptions
  } = (0,_helpers_resolveConfig_js__WEBPACK_IMPORTED_MODULE_3__["default"])(config);

  responseType = responseType ? (responseType + '').toLowerCase() : 'text';

  let composedSignal = (0,_helpers_composeSignals_js__WEBPACK_IMPORTED_MODULE_4__["default"])([signal, cancelToken && cancelToken.toAbortSignal()], timeout);

  let request;

  const unsubscribe = composedSignal && composedSignal.unsubscribe && (() => {
      composedSignal.unsubscribe();
  });

  let requestContentLength;

  try {
    if (
      onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' &&
      (requestContentLength = await resolveBodyLength(headers, data)) !== 0
    ) {
      let _request = new Request(url, {
        method: 'POST',
        body: data,
        duplex: "half"
      });

      let contentTypeHeader;

      if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) {
        headers.setContentType(contentTypeHeader)
      }

      if (_request.body) {
        const [onProgress, flush] = (0,_helpers_progressEventReducer_js__WEBPACK_IMPORTED_MODULE_5__.progressEventDecorator)(
          requestContentLength,
          (0,_helpers_progressEventReducer_js__WEBPACK_IMPORTED_MODULE_5__.progressEventReducer)((0,_helpers_progressEventReducer_js__WEBPACK_IMPORTED_MODULE_5__.asyncDecorator)(onUploadProgress))
        );

        data = (0,_helpers_trackStream_js__WEBPACK_IMPORTED_MODULE_6__.trackStream)(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
      }
    }

    if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isString(withCredentials)) {
      withCredentials = withCredentials ? 'include' : 'omit';
    }

    // Cloudflare Workers throws when credentials are defined
    // see https://github.com/cloudflare/workerd/issues/902
    const isCredentialsSupported = "credentials" in Request.prototype;
    request = new Request(url, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data,
      duplex: "half",
      credentials: isCredentialsSupported ? withCredentials : undefined
    });

    let response = await fetch(request);

    const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');

    if (supportsResponseStream && (onDownloadProgress || (isStreamResponse && unsubscribe))) {
      const options = {};

      ['status', 'statusText', 'headers'].forEach(prop => {
        options[prop] = response[prop];
      });

      const responseContentLength = _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].toFiniteNumber(response.headers.get('content-length'));

      const [onProgress, flush] = onDownloadProgress && (0,_helpers_progressEventReducer_js__WEBPACK_IMPORTED_MODULE_5__.progressEventDecorator)(
        responseContentLength,
        (0,_helpers_progressEventReducer_js__WEBPACK_IMPORTED_MODULE_5__.progressEventReducer)((0,_helpers_progressEventReducer_js__WEBPACK_IMPORTED_MODULE_5__.asyncDecorator)(onDownloadProgress), true)
      ) || [];

      response = new Response(
        (0,_helpers_trackStream_js__WEBPACK_IMPORTED_MODULE_6__.trackStream)(response.body, DEFAULT_CHUNK_SIZE, onProgress, () => {
          flush && flush();
          unsubscribe && unsubscribe();
        }),
        options
      );
    }

    responseType = responseType || 'text';

    let responseData = await resolvers[_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].findKey(resolvers, responseType) || 'text'](response, config);

    !isStreamResponse && unsubscribe && unsubscribe();

    return await new Promise((resolve, reject) => {
      (0,_core_settle_js__WEBPACK_IMPORTED_MODULE_7__["default"])(resolve, reject, {
        data: responseData,
        headers: _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_8__["default"].from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      })
    })
  } catch (err) {
    unsubscribe && unsubscribe();

    if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) {
      throw Object.assign(
        new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_2__["default"]('Network Error', _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_2__["default"].ERR_NETWORK, config, request),
        {
          cause: err.cause || err
        }
      )
    }

    throw _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_2__["default"].from(err, err && err.code, config, request);
  }
}));




/***/ }),

/***/ "../../node_modules/axios/lib/adapters/xhr.js":
/*!****************************************************!*\
  !*** ../../node_modules/axios/lib/adapters/xhr.js ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./../utils.js */ "../../node_modules/axios/lib/utils.js");
/* harmony import */ var _core_settle_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../core/settle.js */ "../../node_modules/axios/lib/core/settle.js");
/* harmony import */ var _defaults_transitional_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../defaults/transitional.js */ "../../node_modules/axios/lib/defaults/transitional.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../core/AxiosError.js */ "../../node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../cancel/CanceledError.js */ "../../node_modules/axios/lib/cancel/CanceledError.js");
/* harmony import */ var _helpers_parseProtocol_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../helpers/parseProtocol.js */ "../../node_modules/axios/lib/helpers/parseProtocol.js");
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../platform/index.js */ "../../node_modules/axios/lib/platform/index.js");
/* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/AxiosHeaders.js */ "../../node_modules/axios/lib/core/AxiosHeaders.js");
/* harmony import */ var _helpers_progressEventReducer_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../helpers/progressEventReducer.js */ "../../node_modules/axios/lib/helpers/progressEventReducer.js");
/* harmony import */ var _helpers_resolveConfig_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/resolveConfig.js */ "../../node_modules/axios/lib/helpers/resolveConfig.js");











const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    const _config = (0,_helpers_resolveConfig_js__WEBPACK_IMPORTED_MODULE_0__["default"])(config);
    let requestData = _config.data;
    const requestHeaders = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(_config.headers).normalize();
    let {responseType, onUploadProgress, onDownloadProgress} = _config;
    let onCanceled;
    let uploadThrottled, downloadThrottled;
    let flushUpload, flushDownload;

    function done() {
      flushUpload && flushUpload(); // flush events
      flushDownload && flushDownload(); // flush events

      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);

      _config.signal && _config.signal.removeEventListener('abort', onCanceled);
    }

    let request = new XMLHttpRequest();

    request.open(_config.method.toUpperCase(), _config.url, true);

    // Set the request timeout in MS
    request.timeout = _config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      (0,_core_settle_js__WEBPACK_IMPORTED_MODULE_2__["default"])(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_3__["default"]('Request aborted', _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_3__["default"].ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_3__["default"]('Network Error', _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_3__["default"].ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = _config.transitional || _defaults_transitional_js__WEBPACK_IMPORTED_MODULE_4__["default"];
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject(new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_3__["default"](
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_3__["default"].ETIMEDOUT : _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_3__["default"].ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      _utils_js__WEBPACK_IMPORTED_MODULE_5__["default"].forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!_utils_js__WEBPACK_IMPORTED_MODULE_5__["default"].isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = _config.responseType;
    }

    // Handle progress if needed
    if (onDownloadProgress) {
      ([downloadThrottled, flushDownload] = (0,_helpers_progressEventReducer_js__WEBPACK_IMPORTED_MODULE_6__.progressEventReducer)(onDownloadProgress, true));
      request.addEventListener('progress', downloadThrottled);
    }

    // Not all browsers support upload events
    if (onUploadProgress && request.upload) {
      ([uploadThrottled, flushUpload] = (0,_helpers_progressEventReducer_js__WEBPACK_IMPORTED_MODULE_6__.progressEventReducer)(onUploadProgress));

      request.upload.addEventListener('progress', uploadThrottled);

      request.upload.addEventListener('loadend', flushUpload);
    }

    if (_config.cancelToken || _config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_7__["default"](null, config, request) : cancel);
        request.abort();
        request = null;
      };

      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = (0,_helpers_parseProtocol_js__WEBPACK_IMPORTED_MODULE_8__["default"])(_config.url);

    if (protocol && _platform_index_js__WEBPACK_IMPORTED_MODULE_9__["default"].protocols.indexOf(protocol) === -1) {
      reject(new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_3__["default"]('Unsupported protocol ' + protocol + ':', _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_3__["default"].ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});


/***/ }),

/***/ "../../node_modules/axios/lib/axios.js":
/*!*********************************************!*\
  !*** ../../node_modules/axios/lib/axios.js ***!
  \*********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils.js */ "../../node_modules/axios/lib/utils.js");
/* harmony import */ var _helpers_bind_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./helpers/bind.js */ "../../node_modules/axios/lib/helpers/bind.js");
/* harmony import */ var _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./core/Axios.js */ "../../node_modules/axios/lib/core/Axios.js");
/* harmony import */ var _core_mergeConfig_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./core/mergeConfig.js */ "../../node_modules/axios/lib/core/mergeConfig.js");
/* harmony import */ var _defaults_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./defaults/index.js */ "../../node_modules/axios/lib/defaults/index.js");
/* harmony import */ var _helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./helpers/formDataToJSON.js */ "../../node_modules/axios/lib/helpers/formDataToJSON.js");
/* harmony import */ var _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./cancel/CanceledError.js */ "../../node_modules/axios/lib/cancel/CanceledError.js");
/* harmony import */ var _cancel_CancelToken_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./cancel/CancelToken.js */ "../../node_modules/axios/lib/cancel/CancelToken.js");
/* harmony import */ var _cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./cancel/isCancel.js */ "../../node_modules/axios/lib/cancel/isCancel.js");
/* harmony import */ var _env_data_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./env/data.js */ "../../node_modules/axios/lib/env/data.js");
/* harmony import */ var _helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./helpers/toFormData.js */ "../../node_modules/axios/lib/helpers/toFormData.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./core/AxiosError.js */ "../../node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _helpers_spread_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./helpers/spread.js */ "../../node_modules/axios/lib/helpers/spread.js");
/* harmony import */ var _helpers_isAxiosError_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./helpers/isAxiosError.js */ "../../node_modules/axios/lib/helpers/isAxiosError.js");
/* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./core/AxiosHeaders.js */ "../../node_modules/axios/lib/core/AxiosHeaders.js");
/* harmony import */ var _adapters_adapters_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./adapters/adapters.js */ "../../node_modules/axios/lib/adapters/adapters.js");
/* harmony import */ var _helpers_HttpStatusCode_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./helpers/HttpStatusCode.js */ "../../node_modules/axios/lib/helpers/HttpStatusCode.js");




















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__["default"](defaultConfig);
  const instance = (0,_helpers_bind_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_core_Axios_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.request, context);

  // Copy axios.prototype to instance
  _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].extend(instance, _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype, context, {allOwnKeys: true});

  // Copy context to instance
  _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance((0,_core_mergeConfig_js__WEBPACK_IMPORTED_MODULE_3__["default"])(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(_defaults_index_js__WEBPACK_IMPORTED_MODULE_4__["default"]);

// Expose Axios class to allow class inheritance
axios.Axios = _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__["default"];

// Expose Cancel & CancelToken
axios.CanceledError = _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_5__["default"];
axios.CancelToken = _cancel_CancelToken_js__WEBPACK_IMPORTED_MODULE_6__["default"];
axios.isCancel = _cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_7__["default"];
axios.VERSION = _env_data_js__WEBPACK_IMPORTED_MODULE_8__.VERSION;
axios.toFormData = _helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_9__["default"];

// Expose AxiosError class
axios.AxiosError = _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_10__["default"];

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = _helpers_spread_js__WEBPACK_IMPORTED_MODULE_11__["default"];

// Expose isAxiosError
axios.isAxiosError = _helpers_isAxiosError_js__WEBPACK_IMPORTED_MODULE_12__["default"];

// Expose mergeConfig
axios.mergeConfig = _core_mergeConfig_js__WEBPACK_IMPORTED_MODULE_3__["default"];

axios.AxiosHeaders = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_13__["default"];

axios.formToJSON = thing => (0,_helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_14__["default"])(_utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = _adapters_adapters_js__WEBPACK_IMPORTED_MODULE_15__["default"].getAdapter;

axios.HttpStatusCode = _helpers_HttpStatusCode_js__WEBPACK_IMPORTED_MODULE_16__["default"];

axios.default = axios;

// this module should only have a default export
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (axios);


/***/ }),

/***/ "../../node_modules/axios/lib/cancel/CancelToken.js":
/*!**********************************************************!*\
  !*** ../../node_modules/axios/lib/cancel/CancelToken.js ***!
  \**********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _CanceledError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CanceledError.js */ "../../node_modules/axios/lib/cancel/CanceledError.js");




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new _CanceledError_js__WEBPACK_IMPORTED_MODULE_0__["default"](message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  toAbortSignal() {
    const controller = new AbortController();

    const abort = (err) => {
      controller.abort(err);
    };

    this.subscribe(abort);

    controller.signal.unsubscribe = () => this.unsubscribe(abort);

    return controller.signal;
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CancelToken);


/***/ }),

/***/ "../../node_modules/axios/lib/cancel/CanceledError.js":
/*!************************************************************!*\
  !*** ../../node_modules/axios/lib/cancel/CanceledError.js ***!
  \************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../core/AxiosError.js */ "../../node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils.js */ "../../node_modules/axios/lib/utils.js");





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"].call(this, message == null ? 'canceled' : message, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"].ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].inherits(CanceledError, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"], {
  __CANCEL__: true
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CanceledError);


/***/ }),

/***/ "../../node_modules/axios/lib/cancel/isCancel.js":
/*!*******************************************************!*\
  !*** ../../node_modules/axios/lib/cancel/isCancel.js ***!
  \*******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isCancel)
/* harmony export */ });


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}


/***/ }),

/***/ "../../node_modules/axios/lib/core/Axios.js":
/*!**************************************************!*\
  !*** ../../node_modules/axios/lib/core/Axios.js ***!
  \**************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./../utils.js */ "../../node_modules/axios/lib/utils.js");
/* harmony import */ var _helpers_buildURL_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helpers/buildURL.js */ "../../node_modules/axios/lib/helpers/buildURL.js");
/* harmony import */ var _InterceptorManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./InterceptorManager.js */ "../../node_modules/axios/lib/core/InterceptorManager.js");
/* harmony import */ var _dispatchRequest_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./dispatchRequest.js */ "../../node_modules/axios/lib/core/dispatchRequest.js");
/* harmony import */ var _mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mergeConfig.js */ "../../node_modules/axios/lib/core/mergeConfig.js");
/* harmony import */ var _buildFullPath_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./buildFullPath.js */ "../../node_modules/axios/lib/core/buildFullPath.js");
/* harmony import */ var _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/validator.js */ "../../node_modules/axios/lib/helpers/validator.js");
/* harmony import */ var _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./AxiosHeaders.js */ "../../node_modules/axios/lib/core/AxiosHeaders.js");











const validators = _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__["default"].validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new _InterceptorManager_js__WEBPACK_IMPORTED_MODULE_1__["default"](),
      response: new _InterceptorManager_js__WEBPACK_IMPORTED_MODULE_1__["default"]()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy = {};

        Error.captureStackTrace ? Error.captureStackTrace(dummy) : (dummy = new Error());

        // slice off the Error: ... line
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
        try {
          if (!err.stack) {
            err.stack = stack;
            // match without the 2 top stack lines
          } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
            err.stack += '\n' + stack
          }
        } catch (e) {
          // ignore the case where "stack" is an un-writable property
        }
      }

      throw err;
    }
  }

  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = (0,_mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__["default"].assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (_utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        }
      } else {
        _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__["default"].assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }

    // Set config.allowAbsoluteUrls
    if (config.allowAbsoluteUrls !== undefined) {
      // do nothing
    } else if (this.defaults.allowAbsoluteUrls !== undefined) {
      config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
    } else {
      config.allowAbsoluteUrls = true;
    }

    _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__["default"].assertOptions(config, {
      baseUrl: validators.spelling('baseURL'),
      withXsrfToken: validators.spelling('withXSRFToken')
    }, true);

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && _utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].merge(
      headers.common,
      headers[config.method]
    );

    headers && _utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_4__["default"].concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [_dispatchRequest_js__WEBPACK_IMPORTED_MODULE_5__["default"].bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = _dispatchRequest_js__WEBPACK_IMPORTED_MODULE_5__["default"].call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = (0,_mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(this.defaults, config);
    const fullPath = (0,_buildFullPath_js__WEBPACK_IMPORTED_MODULE_6__["default"])(config.baseURL, config.url, config.allowAbsoluteUrls);
    return (0,_helpers_buildURL_js__WEBPACK_IMPORTED_MODULE_7__["default"])(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
_utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request((0,_mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

_utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request((0,_mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Axios);


/***/ }),

/***/ "../../node_modules/axios/lib/core/AxiosError.js":
/*!*******************************************************!*\
  !*** ../../node_modules/axios/lib/core/AxiosError.js ***!
  \*******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "../../node_modules/axios/lib/utils.js");




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  if (response) {
    this.response = response;
    this.status = response.status ? response.status : null;
  }
}

_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});

const prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype);

  _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AxiosError);


/***/ }),

/***/ "../../node_modules/axios/lib/core/AxiosHeaders.js":
/*!*********************************************************!*\
  !*** ../../node_modules/axios/lib/core/AxiosHeaders.js ***!
  \*********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "../../node_modules/axios/lib/utils.js");
/* harmony import */ var _helpers_parseHeaders_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helpers/parseHeaders.js */ "../../node_modules/axios/lib/helpers/parseHeaders.js");





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(value)) return;

  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders((0,_helpers_parseHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"])(header), valueOrRewrite);
    } else if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isHeaders(header)) {
      for (const [key, value] of header.entries()) {
        setHeader(value, key, rewrite);
      }
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(this, (value, header) => {
      const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].freezeMethods(AxiosHeaders);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AxiosHeaders);


/***/ }),

/***/ "../../node_modules/axios/lib/core/InterceptorManager.js":
/*!***************************************************************!*\
  !*** ../../node_modules/axios/lib/core/InterceptorManager.js ***!
  \***************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./../utils.js */ "../../node_modules/axios/lib/utils.js");




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InterceptorManager);


/***/ }),

/***/ "../../node_modules/axios/lib/core/buildFullPath.js":
/*!**********************************************************!*\
  !*** ../../node_modules/axios/lib/core/buildFullPath.js ***!
  \**********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ buildFullPath)
/* harmony export */ });
/* harmony import */ var _helpers_isAbsoluteURL_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/isAbsoluteURL.js */ "../../node_modules/axios/lib/helpers/isAbsoluteURL.js");
/* harmony import */ var _helpers_combineURLs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helpers/combineURLs.js */ "../../node_modules/axios/lib/helpers/combineURLs.js");





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls) {
  let isRelativeUrl = !(0,_helpers_isAbsoluteURL_js__WEBPACK_IMPORTED_MODULE_0__["default"])(requestedURL);
  if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) {
    return (0,_helpers_combineURLs_js__WEBPACK_IMPORTED_MODULE_1__["default"])(baseURL, requestedURL);
  }
  return requestedURL;
}


/***/ }),

/***/ "../../node_modules/axios/lib/core/dispatchRequest.js":
/*!************************************************************!*\
  !*** ../../node_modules/axios/lib/core/dispatchRequest.js ***!
  \************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ dispatchRequest)
/* harmony export */ });
/* harmony import */ var _transformData_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./transformData.js */ "../../node_modules/axios/lib/core/transformData.js");
/* harmony import */ var _cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../cancel/isCancel.js */ "../../node_modules/axios/lib/cancel/isCancel.js");
/* harmony import */ var _defaults_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../defaults/index.js */ "../../node_modules/axios/lib/defaults/index.js");
/* harmony import */ var _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../cancel/CanceledError.js */ "../../node_modules/axios/lib/cancel/CanceledError.js");
/* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/AxiosHeaders.js */ "../../node_modules/axios/lib/core/AxiosHeaders.js");
/* harmony import */ var _adapters_adapters_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../adapters/adapters.js */ "../../node_modules/axios/lib/adapters/adapters.js");









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_0__["default"](null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(config.headers);

  // Transform request data
  config.data = _transformData_js__WEBPACK_IMPORTED_MODULE_2__["default"].call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = _adapters_adapters_js__WEBPACK_IMPORTED_MODULE_3__["default"].getAdapter(config.adapter || _defaults_index_js__WEBPACK_IMPORTED_MODULE_4__["default"].adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = _transformData_js__WEBPACK_IMPORTED_MODULE_2__["default"].call(
      config,
      config.transformResponse,
      response
    );

    response.headers = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!(0,_cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_5__["default"])(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = _transformData_js__WEBPACK_IMPORTED_MODULE_2__["default"].call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}


/***/ }),

/***/ "../../node_modules/axios/lib/core/mergeConfig.js":
/*!********************************************************!*\
  !*** ../../node_modules/axios/lib/core/mergeConfig.js ***!
  \********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ mergeConfig)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils.js */ "../../node_modules/axios/lib/utils.js");
/* harmony import */ var _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AxiosHeaders.js */ "../../node_modules/axios/lib/core/AxiosHeaders.js");





const headersToObject = (thing) => thing instanceof _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_0__["default"] ? { ...thing } : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, prop, caseless) {
    if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isPlainObject(target) && _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isPlainObject(source)) {
      return _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge.call({caseless}, target, source);
    } else if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isPlainObject(source)) {
      return _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge({}, source);
    } else if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, prop , caseless) {
    if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(b)) {
      return getMergedValue(a, b, prop , caseless);
    } else if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(a)) {
      return getMergedValue(undefined, a, prop , caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b , prop) => mergeDeepProperties(headersToObject(a), headersToObject(b),prop, true)
  };

  _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}


/***/ }),

/***/ "../../node_modules/axios/lib/core/settle.js":
/*!***************************************************!*\
  !*** ../../node_modules/axios/lib/core/settle.js ***!
  \***************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ settle)
/* harmony export */ });
/* harmony import */ var _AxiosError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AxiosError.js */ "../../node_modules/axios/lib/core/AxiosError.js");




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new _AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"](
      'Request failed with status code ' + response.status,
      [_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"].ERR_BAD_REQUEST, _AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"].ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}


/***/ }),

/***/ "../../node_modules/axios/lib/core/transformData.js":
/*!**********************************************************!*\
  !*** ../../node_modules/axios/lib/core/transformData.js ***!
  \**********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ transformData)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../utils.js */ "../../node_modules/axios/lib/utils.js");
/* harmony import */ var _defaults_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../defaults/index.js */ "../../node_modules/axios/lib/defaults/index.js");
/* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/AxiosHeaders.js */ "../../node_modules/axios/lib/core/AxiosHeaders.js");






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || _defaults_index_js__WEBPACK_IMPORTED_MODULE_0__["default"];
  const context = response || config;
  const headers = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(context.headers);
  let data = context.data;

  _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}


/***/ }),

/***/ "../../node_modules/axios/lib/defaults/index.js":
/*!******************************************************!*\
  !*** ../../node_modules/axios/lib/defaults/index.js ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "../../node_modules/axios/lib/utils.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../core/AxiosError.js */ "../../node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _transitional_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./transitional.js */ "../../node_modules/axios/lib/defaults/transitional.js");
/* harmony import */ var _helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helpers/toFormData.js */ "../../node_modules/axios/lib/helpers/toFormData.js");
/* harmony import */ var _helpers_toURLEncodedForm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helpers/toURLEncodedForm.js */ "../../node_modules/axios/lib/helpers/toURLEncodedForm.js");
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../platform/index.js */ "../../node_modules/axios/lib/platform/index.js");
/* harmony import */ var _helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helpers/formDataToJSON.js */ "../../node_modules/axios/lib/helpers/formDataToJSON.js");










/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: _transitional_js__WEBPACK_IMPORTED_MODULE_1__["default"],

  adapter: ['xhr', 'http', 'fetch'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(data);

    if (isObjectPayload && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify((0,_helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_2__["default"])(data)) : data;
    }

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArrayBuffer(data) ||
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBuffer(data) ||
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isStream(data) ||
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFile(data) ||
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBlob(data) ||
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isReadableStream(data)
    ) {
      return data;
    }
    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArrayBufferView(data)) {
      return data.buffer;
    }
    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return (0,_helpers_toURLEncodedForm_js__WEBPACK_IMPORTED_MODULE_3__["default"])(data, this.formSerializer).toString();
      }

      if ((isFileList = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return (0,_helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_4__["default"])(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isResponse(data) || _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isReadableStream(data)) {
      return data;
    }

    if (data && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(e, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_5__["default"].ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: _platform_index_js__WEBPACK_IMPORTED_MODULE_6__["default"].classes.FormData,
    Blob: _platform_index_js__WEBPACK_IMPORTED_MODULE_6__["default"].classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (defaults);


/***/ }),

/***/ "../../node_modules/axios/lib/defaults/transitional.js":
/*!*************************************************************!*\
  !*** ../../node_modules/axios/lib/defaults/transitional.js ***!
  \*************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});


/***/ }),

/***/ "../../node_modules/axios/lib/env/data.js":
/*!************************************************!*\
  !*** ../../node_modules/axios/lib/env/data.js ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   VERSION: () => (/* binding */ VERSION)
/* harmony export */ });
const VERSION = "1.8.4";

/***/ }),

/***/ "../../node_modules/axios/lib/helpers/AxiosURLSearchParams.js":
/*!********************************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/AxiosURLSearchParams.js ***!
  \********************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _toFormData_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./toFormData.js */ "../../node_modules/axios/lib/helpers/toFormData.js");




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && (0,_toFormData_js__WEBPACK_IMPORTED_MODULE_0__["default"])(params, this, options);
}

const prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AxiosURLSearchParams);


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/HttpStatusCode.js":
/*!**************************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/HttpStatusCode.js ***!
  \**************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HttpStatusCode);


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/bind.js":
/*!****************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/bind.js ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ bind)
/* harmony export */ });


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/buildURL.js":
/*!********************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/buildURL.js ***!
  \********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ buildURL)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "../../node_modules/axios/lib/utils.js");
/* harmony import */ var _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helpers/AxiosURLSearchParams.js */ "../../node_modules/axios/lib/helpers/AxiosURLSearchParams.js");





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?(object|Function)} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || encode;

  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(options)) {
    options = {
      serialize: options
    };
  } 

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isURLSearchParams(params) ?
      params.toString() :
      new _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_1__["default"](params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/combineURLs.js":
/*!***********************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/combineURLs.js ***!
  \***********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ combineURLs)
/* harmony export */ });


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/composeSignals.js":
/*!**************************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/composeSignals.js ***!
  \**************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../cancel/CanceledError.js */ "../../node_modules/axios/lib/cancel/CanceledError.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../core/AxiosError.js */ "../../node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils.js */ "../../node_modules/axios/lib/utils.js");




const composeSignals = (signals, timeout) => {
  const {length} = (signals = signals ? signals.filter(Boolean) : []);

  if (timeout || length) {
    let controller = new AbortController();

    let aborted;

    const onabort = function (reason) {
      if (!aborted) {
        aborted = true;
        unsubscribe();
        const err = reason instanceof Error ? reason : this.reason;
        controller.abort(err instanceof _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"] ? err : new _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_1__["default"](err instanceof Error ? err.message : err));
      }
    }

    let timer = timeout && setTimeout(() => {
      timer = null;
      onabort(new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"](`timeout ${timeout} of ms exceeded`, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"].ETIMEDOUT))
    }, timeout)

    const unsubscribe = () => {
      if (signals) {
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach(signal => {
          signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
      }
    }

    signals.forEach((signal) => signal.addEventListener('abort', onabort));

    const {signal} = controller;

    signal.unsubscribe = () => _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].asap(unsubscribe);

    return signal;
  }
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (composeSignals);


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/cookies.js":
/*!*******************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/cookies.js ***!
  \*******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../utils.js */ "../../node_modules/axios/lib/utils.js");
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../platform/index.js */ "../../node_modules/axios/lib/platform/index.js");



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_platform_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isString(path) && cookie.push('path=' + path);

      _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  });



/***/ }),

/***/ "../../node_modules/axios/lib/helpers/formDataToJSON.js":
/*!**************************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/formDataToJSON.js ***!
  \**************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "../../node_modules/axios/lib/utils.js");




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(target) ? target.length : name;

    if (isLast) {
      if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFormData(formData) && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(formData.entries)) {
    const obj = {};

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (formDataToJSON);


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/isAbsoluteURL.js":
/*!*************************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/isAbsoluteURL.js ***!
  \*************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isAbsoluteURL)
/* harmony export */ });


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/isAxiosError.js":
/*!************************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/isAxiosError.js ***!
  \************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isAxiosError)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./../utils.js */ "../../node_modules/axios/lib/utils.js");




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(payload) && (payload.isAxiosError === true);
}


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/isURLSameOrigin.js":
/*!***************************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/isURLSameOrigin.js ***!
  \***************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../platform/index.js */ "../../node_modules/axios/lib/platform/index.js");


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_platform_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].hasStandardBrowserEnv ? ((origin, isMSIE) => (url) => {
  url = new URL(url, _platform_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].origin);

  return (
    origin.protocol === url.protocol &&
    origin.host === url.host &&
    (isMSIE || origin.port === url.port)
  );
})(
  new URL(_platform_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].origin),
  _platform_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].navigator && /(msie|trident)/i.test(_platform_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].navigator.userAgent)
) : () => true);


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/null.js":
/*!****************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/null.js ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// eslint-disable-next-line strict
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (null);


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/parseHeaders.js":
/*!************************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/parseHeaders.js ***!
  \************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./../utils.js */ "../../node_modules/axios/lib/utils.js");




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/parseProtocol.js":
/*!*************************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/parseProtocol.js ***!
  \*************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ parseProtocol)
/* harmony export */ });


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/progressEventReducer.js":
/*!********************************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/progressEventReducer.js ***!
  \********************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   asyncDecorator: () => (/* binding */ asyncDecorator),
/* harmony export */   progressEventDecorator: () => (/* binding */ progressEventDecorator),
/* harmony export */   progressEventReducer: () => (/* binding */ progressEventReducer)
/* harmony export */ });
/* harmony import */ var _speedometer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./speedometer.js */ "../../node_modules/axios/lib/helpers/speedometer.js");
/* harmony import */ var _throttle_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./throttle.js */ "../../node_modules/axios/lib/helpers/throttle.js");
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils.js */ "../../node_modules/axios/lib/utils.js");




const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = (0,_speedometer_js__WEBPACK_IMPORTED_MODULE_0__["default"])(50, 250);

  return (0,_throttle_js__WEBPACK_IMPORTED_MODULE_1__["default"])(e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e,
      lengthComputable: total != null,
      [isDownloadStream ? 'download' : 'upload']: true
    };

    listener(data);
  }, freq);
}

const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;

  return [(loaded) => throttled[0]({
    lengthComputable,
    total,
    loaded
  }), throttled[1]];
}

const asyncDecorator = (fn) => (...args) => _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].asap(() => fn(...args));


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/resolveConfig.js":
/*!*************************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/resolveConfig.js ***!
  \*************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../platform/index.js */ "../../node_modules/axios/lib/platform/index.js");
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../utils.js */ "../../node_modules/axios/lib/utils.js");
/* harmony import */ var _isURLSameOrigin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./isURLSameOrigin.js */ "../../node_modules/axios/lib/helpers/isURLSameOrigin.js");
/* harmony import */ var _cookies_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./cookies.js */ "../../node_modules/axios/lib/helpers/cookies.js");
/* harmony import */ var _core_buildFullPath_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../core/buildFullPath.js */ "../../node_modules/axios/lib/core/buildFullPath.js");
/* harmony import */ var _core_mergeConfig_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../core/mergeConfig.js */ "../../node_modules/axios/lib/core/mergeConfig.js");
/* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/AxiosHeaders.js */ "../../node_modules/axios/lib/core/AxiosHeaders.js");
/* harmony import */ var _buildURL_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./buildURL.js */ "../../node_modules/axios/lib/helpers/buildURL.js");









/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((config) => {
  const newConfig = (0,_core_mergeConfig_js__WEBPACK_IMPORTED_MODULE_0__["default"])({}, config);

  let {data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth} = newConfig;

  newConfig.headers = headers = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(headers);

  newConfig.url = (0,_buildURL_js__WEBPACK_IMPORTED_MODULE_2__["default"])((0,_core_buildFullPath_js__WEBPACK_IMPORTED_MODULE_3__["default"])(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);

  // HTTP basic authentication
  if (auth) {
    headers.set('Authorization', 'Basic ' +
      btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : ''))
    );
  }

  let contentType;

  if (_utils_js__WEBPACK_IMPORTED_MODULE_4__["default"].isFormData(data)) {
    if (_platform_index_js__WEBPACK_IMPORTED_MODULE_5__["default"].hasStandardBrowserEnv || _platform_index_js__WEBPACK_IMPORTED_MODULE_5__["default"].hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(undefined); // Let the browser set it
    } else if ((contentType = headers.getContentType()) !== false) {
      // fix semicolon duplication issue for ReactNative FormData implementation
      const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
      headers.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
    }
  }

  // Add xsrf header
  // This is only done if running in a standard browser environment.
  // Specifically not if we're in a web worker, or react-native.

  if (_platform_index_js__WEBPACK_IMPORTED_MODULE_5__["default"].hasStandardBrowserEnv) {
    withXSRFToken && _utils_js__WEBPACK_IMPORTED_MODULE_4__["default"].isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));

    if (withXSRFToken || (withXSRFToken !== false && (0,_isURLSameOrigin_js__WEBPACK_IMPORTED_MODULE_6__["default"])(newConfig.url))) {
      // Add xsrf header
      const xsrfValue = xsrfHeaderName && xsrfCookieName && _cookies_js__WEBPACK_IMPORTED_MODULE_7__["default"].read(xsrfCookieName);

      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }

  return newConfig;
});



/***/ }),

/***/ "../../node_modules/axios/lib/helpers/speedometer.js":
/*!***********************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/speedometer.js ***!
  \***********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (speedometer);


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/spread.js":
/*!******************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/spread.js ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ spread)
/* harmony export */ });


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/throttle.js":
/*!********************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/throttle.js ***!
  \********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */
function throttle(fn, freq) {
  let timestamp = 0;
  let threshold = 1000 / freq;
  let lastArgs;
  let timer;

  const invoke = (args, now = Date.now()) => {
    timestamp = now;
    lastArgs = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    fn.apply(null, args);
  }

  const throttled = (...args) => {
    const now = Date.now();
    const passed = now - timestamp;
    if ( passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(lastArgs)
        }, threshold - passed);
      }
    }
  }

  const flush = () => lastArgs && invoke(lastArgs);

  return [throttled, flush];
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (throttle);


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/toFormData.js":
/*!**********************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/toFormData.js ***!
  \**********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "../../node_modules/axios/lib/utils.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../core/AxiosError.js */ "../../node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _platform_node_classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../platform/node/classes/FormData.js */ "../../node_modules/axios/lib/helpers/null.js");




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(thing) || _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(arr) && !arr.some(isVisitable);
}

const predicates = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toFlatObject(_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"], {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (_platform_node_classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__["default"] || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isSpecCompliantForm(formData);

  if (!_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBlob(value)) {
      throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_2__["default"]('Blob is not supported. Use a Buffer instead.');
    }

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArrayBuffer(value) || _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(value) && isFlatArray(value)) ||
        ((_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFileList(value) || _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].endsWith(key, '[]')) && (arr = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(value, function each(el, key) {
      const result = !(_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isUndefined(el) || el === null) && visitor.call(
        formData, el, _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (toFormData);


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/toURLEncodedForm.js":
/*!****************************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/toURLEncodedForm.js ***!
  \****************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ toURLEncodedForm)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils.js */ "../../node_modules/axios/lib/utils.js");
/* harmony import */ var _toFormData_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./toFormData.js */ "../../node_modules/axios/lib/helpers/toFormData.js");
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../platform/index.js */ "../../node_modules/axios/lib/platform/index.js");






function toURLEncodedForm(data, options) {
  return (0,_toFormData_js__WEBPACK_IMPORTED_MODULE_0__["default"])(data, new _platform_index_js__WEBPACK_IMPORTED_MODULE_1__["default"].classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (_platform_index_js__WEBPACK_IMPORTED_MODULE_1__["default"].isNode && _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/trackStream.js":
/*!***********************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/trackStream.js ***!
  \***********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   readBytes: () => (/* binding */ readBytes),
/* harmony export */   streamChunk: () => (/* binding */ streamChunk),
/* harmony export */   trackStream: () => (/* binding */ trackStream)
/* harmony export */ });

const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;

  if (!chunkSize || len < chunkSize) {
    yield chunk;
    return;
  }

  let pos = 0;
  let end;

  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
}

const readBytes = async function* (iterable, chunkSize) {
  for await (const chunk of readStream(iterable)) {
    yield* streamChunk(chunk, chunkSize);
  }
}

const readStream = async function* (stream) {
  if (stream[Symbol.asyncIterator]) {
    yield* stream;
    return;
  }

  const reader = stream.getReader();
  try {
    for (;;) {
      const {done, value} = await reader.read();
      if (done) {
        break;
      }
      yield value;
    }
  } finally {
    await reader.cancel();
  }
}

const trackStream = (stream, chunkSize, onProgress, onFinish) => {
  const iterator = readBytes(stream, chunkSize);

  let bytes = 0;
  let done;
  let _onFinish = (e) => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  }

  return new ReadableStream({
    async pull(controller) {
      try {
        const {done, value} = await iterator.next();

        if (done) {
         _onFinish();
          controller.close();
          return;
        }

        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  })
}


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/validator.js":
/*!*********************************************************!*\
  !*** ../../node_modules/axios/lib/helpers/validator.js ***!
  \*********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _env_data_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../env/data.js */ "../../node_modules/axios/lib/env/data.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/AxiosError.js */ "../../node_modules/axios/lib/core/AxiosError.js");





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + _env_data_js__WEBPACK_IMPORTED_MODULE_0__.VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"](
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

validators.spelling = function spelling(correctSpelling) {
  return (value, opt) => {
    // eslint-disable-next-line no-console
    console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
    return true;
  }
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"]('options must be an object', _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"]('option ' + opt + ' must be ' + result, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"]('Unknown option ' + opt, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  assertOptions,
  validators
});


/***/ }),

/***/ "../../node_modules/axios/lib/platform/browser/classes/Blob.js":
/*!*********************************************************************!*\
  !*** ../../node_modules/axios/lib/platform/browser/classes/Blob.js ***!
  \*********************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (typeof Blob !== 'undefined' ? Blob : null);


/***/ }),

/***/ "../../node_modules/axios/lib/platform/browser/classes/FormData.js":
/*!*************************************************************************!*\
  !*** ../../node_modules/axios/lib/platform/browser/classes/FormData.js ***!
  \*************************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (typeof FormData !== 'undefined' ? FormData : null);


/***/ }),

/***/ "../../node_modules/axios/lib/platform/browser/classes/URLSearchParams.js":
/*!********************************************************************************!*\
  !*** ../../node_modules/axios/lib/platform/browser/classes/URLSearchParams.js ***!
  \********************************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../helpers/AxiosURLSearchParams.js */ "../../node_modules/axios/lib/helpers/AxiosURLSearchParams.js");



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__["default"]);


/***/ }),

/***/ "../../node_modules/axios/lib/platform/browser/index.js":
/*!**************************************************************!*\
  !*** ../../node_modules/axios/lib/platform/browser/index.js ***!
  \**************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _classes_URLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./classes/URLSearchParams.js */ "../../node_modules/axios/lib/platform/browser/classes/URLSearchParams.js");
/* harmony import */ var _classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./classes/FormData.js */ "../../node_modules/axios/lib/platform/browser/classes/FormData.js");
/* harmony import */ var _classes_Blob_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./classes/Blob.js */ "../../node_modules/axios/lib/platform/browser/classes/Blob.js");




/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  isBrowser: true,
  classes: {
    URLSearchParams: _classes_URLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__["default"],
    FormData: _classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__["default"],
    Blob: _classes_Blob_js__WEBPACK_IMPORTED_MODULE_2__["default"]
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});


/***/ }),

/***/ "../../node_modules/axios/lib/platform/common/utils.js":
/*!*************************************************************!*\
  !*** ../../node_modules/axios/lib/platform/common/utils.js ***!
  \*************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   hasBrowserEnv: () => (/* binding */ hasBrowserEnv),
/* harmony export */   hasStandardBrowserEnv: () => (/* binding */ hasStandardBrowserEnv),
/* harmony export */   hasStandardBrowserWebWorkerEnv: () => (/* binding */ hasStandardBrowserWebWorkerEnv),
/* harmony export */   navigator: () => (/* binding */ _navigator),
/* harmony export */   origin: () => (/* binding */ origin)
/* harmony export */ });
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

const _navigator = typeof navigator === 'object' && navigator || undefined;

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = hasBrowserEnv &&
  (!_navigator || ['ReactNative', 'NativeScript', 'NS'].indexOf(_navigator.product) < 0);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();

const origin = hasBrowserEnv && window.location.href || 'http://localhost';




/***/ }),

/***/ "../../node_modules/axios/lib/platform/index.js":
/*!******************************************************!*\
  !*** ../../node_modules/axios/lib/platform/index.js ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./node/index.js */ "../../node_modules/axios/lib/platform/browser/index.js");
/* harmony import */ var _common_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common/utils.js */ "../../node_modules/axios/lib/platform/common/utils.js");



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  ..._common_utils_js__WEBPACK_IMPORTED_MODULE_0__,
  ..._node_index_js__WEBPACK_IMPORTED_MODULE_1__["default"]
});


/***/ }),

/***/ "../../node_modules/axios/lib/utils.js":
/*!*********************************************!*\
  !*** ../../node_modules/axios/lib/utils.js ***!
  \*********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _helpers_bind_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers/bind.js */ "../../node_modules/axios/lib/helpers/bind.js");
/* provided dependency */ var process = __webpack_require__(/*! process/browser.js */ "process/browser.js");




// utils is a library of generic helper functions non-specific to axios

const {toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

const [isReadableStream, isRequest, isResponse, isHeaders] = ['ReadableStream', 'Request', 'Response', 'Headers'].map(kindOfTest);

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = (0,_helpers_bind_js__WEBPACK_IMPORTED_MODULE_0__["default"])(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34

const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }

  return postMessageSupported ? ((token, callbacks) => {
    _global.addEventListener("message", ({source, data}) => {
      if (source === _global && data === token) {
        callbacks.length && callbacks.shift()();
      }
    }, false);

    return (cb) => {
      callbacks.push(cb);
      _global.postMessage(token, "*");
    }
  })(`axios@${Math.random()}`, []) : (cb) => setTimeout(cb);
})(
  typeof setImmediate === 'function',
  isFunction(_global.postMessage)
);

const asap = typeof queueMicrotask !== 'undefined' ?
  queueMicrotask.bind(_global) : ( typeof process !== 'undefined' && process.nextTick || _setImmediate);

// *********************

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap
});


/***/ }),

/***/ "../../node_modules/lodash/lodash.js":
/*!*******************************************!*\
  !*** ../../node_modules/lodash/lodash.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ "./src/assets/images/Cisco_Webex_Logo.svg":
/*!************************************************!*\
  !*** ./src/assets/images/Cisco_Webex_Logo.svg ***!
  \************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "images-mfe-wc/Cisco_Webex_Logo.4be28180.svg";

/***/ }),

/***/ "./src/assets/images/teams-icon-color.svg":
/*!************************************************!*\
  !*** ./src/assets/images/teams-icon-color.svg ***!
  \************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "images-mfe-wc/teams-icon-color.5a6d40fd.svg";

/***/ }),

/***/ "./src/assets/styles/common.scss":
/*!***************************************!*\
  !*** ./src/assets/styles/common.scss ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/common.scss */
/*# sourceURL=common.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2Fzc2V0cy9zdHlsZXMvY29tbW9uLnNjc3MiLCJjb21tb24uc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGtCQUFBO0VBQ0EsVUFBQTtFQUNBLFdBQUE7RUFDQSxVQUFBO0VBQ0EsWUFBQTtFQUNBLGdCQUFBO0VBQ0Esc0JBQUE7RUFDQSxTQUFBO0FDQ0YiLCJmaWxlIjoiY29tbW9uLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuc3Itb25seSB7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgd2lkdGg6IDFweDtcbiAgaGVpZ2h0OiAxcHg7XG4gIHBhZGRpbmc6IDA7XG4gIG1hcmdpbjogLTFweDtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgY2xpcDogcmVjdCgwLCAwLCAwLCAwKTtcbiAgYm9yZGVyOiAwO1xufVxuIiwiLnNyLW9ubHkge1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHdpZHRoOiAxcHg7XG4gIGhlaWdodDogMXB4O1xuICBwYWRkaW5nOiAwO1xuICBtYXJnaW46IC0xcHg7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIGNsaXA6IHJlY3QoMCwgMCwgMCwgMCk7XG4gIGJvcmRlcjogMDtcbn0iXX0= */`);
    

/***/ }),

/***/ "./src/assets/styles/variables.scss":
/*!******************************************!*\
  !*** ./src/assets/styles/variables.scss ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=variables.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/AgentPerformanceReports/AgentPerformanceReports.scss":
/*!*****************************************************************************!*\
  !*** ./src/components/AgentPerformanceReports/AgentPerformanceReports.scss ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --header-height: 65px;
  --tab-height: 51px;
  --more-tab-height: 320px;
  position: relative;
  height: 100%;
}

.agent-performance-reports-container {
  height: 100%;
  display: flex;
}
.agent-performance-reports-container md-tabs {
  width: 100%;
}
.agent-performance-reports-container iframe {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.18);
}
.agent-performance-reports-container #agent-performance-reports-tabs::part(tabs-more-list) {
  max-height: var(--more-tab-height);
  border-bottom: 0;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/AgentPerformanceReports/AgentPerformanceReports.scss */
/*# sourceURL=AgentPerformanceReports.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/AgentPerformanceReports/AgentPerformanceReports.ts":
/*!***************************************************************************!*\
  !*** ./src/components/AgentPerformanceReports/AgentPerformanceReports.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentPerformanceReports: () => (/* binding */ AgentPerformanceReports)
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/config */ "./src/config.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _AgentPerformanceReports_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./AgentPerformanceReports.scss */ "./src/components/AgentPerformanceReports/AgentPerformanceReports.scss");
/* harmony import */ var _AnalyzerSessionHelper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./AnalyzerSessionHelper */ "./src/components/AgentPerformanceReports/AnalyzerSessionHelper.ts");
/* harmony import */ var _agentReportList__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./agentReportList */ "./src/components/AgentPerformanceReports/agentReportList.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-explicit-any */










var AgentPerformanceReports;
(function (AgentPerformanceReports) {
    /**
     * @element agentx-wc-agent-performance-reports
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_5__.LitElement) {
        constructor() {
            super(...arguments);
            this.isDarkTheme = false;
            this.agentReportList = _agentReportList__WEBPACK_IMPORTED_MODULE_9__.agentReportList;
            this.isAnalyzerSessionSet = false;
            this.setMoreActionWidth = () => __awaiter(this, void 0, void 0, function* () {
                yield this.updateComplete;
                setTimeout(() => {
                    var _a, _b, _c, _d, _e;
                    const overlayContent = (_e = (_d = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-tabs")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("md-menu-overlay")) === null || _d === void 0 ? void 0 : _d.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector(".overlay-content");
                    if (overlayContent) {
                        // Default custom width for menu-overlay is 227px.
                        overlayContent.style.minWidth = _constants__WEBPACK_IMPORTED_MODULE_1__.MIN_WIDTH;
                        overlayContent.style.width = "max-content";
                    }
                }, _constants__WEBPACK_IMPORTED_MODULE_1__.TIMEOUT_THOUSAND_MS);
            });
        }
        static get styles() {
            return _AgentPerformanceReports_scss__WEBPACK_IMPORTED_MODULE_7__["default"];
        }
        connectedCallback() {
            const _super = Object.create(null, {
                connectedCallback: { get: () => super.connectedCallback }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.connectedCallback.call(this);
                this.isAnalyzerSessionSet = yield _AnalyzerSessionHelper__WEBPACK_IMPORTED_MODULE_8__.analyzerSessionHelper.create();
                this.addEventListener("selected-changed", this.handleTabClick);
                _agentReportList__WEBPACK_IMPORTED_MODULE_9__.agentReportList.forEach((data, index) => {
                    this.postApsMessage(data.tabId, data.reportId, (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)(`app:apsReports.${data.tabId}`), `report-${index}`);
                });
                this.setMoreActionWidth();
            });
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.removeEventListener("selected-changed", this.handleTabClick);
        }
        handleTabClick(event) {
            const tabTitle = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)(`app:apsReports.${_agentReportList__WEBPACK_IMPORTED_MODULE_9__.agentReportList[event.detail.value].tabId}`);
            const id = `report-${event.detail.value}`;
            this.postApsMessage(_agentReportList__WEBPACK_IMPORTED_MODULE_9__.agentReportList[event.detail.value].tabId, _agentReportList__WEBPACK_IMPORTED_MODULE_9__.agentReportList[event.detail.value].reportId, tabTitle, id);
        }
        postApsMessage(tabId, reportId, tabTitle, id) {
            var _a;
            const message = {
                event: "onReportClick",
                data: { reportId, reportName: tabTitle, tabId }
            };
            const frameElem = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`#${id}`);
            if (frameElem === null || frameElem === void 0 ? void 0 : frameElem.contentWindow) {
                frameElem.contentWindow.postMessage(JSON.stringify(message), "*");
            }
        }
        render() {
            return this.isAnalyzerSessionSet
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
            <div class="agent-performance-reports-container">
              <md-tabs
                id="agent-performance-reports-tabs"
                persist-selection=${true}
                overflowLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)(`app:common.moreTabs`)}
                tabs-id="aps-tabs"
              >
                ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_6__.repeat)(this.agentReportList, ({ tabId, reportId, isDashboard }, index) => {
                    const tabTitle = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)(`app:apsReports.${tabId}`);
                    const id = `report-${index}`;
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                    <md-tab slot="tab" label="${tabTitle}" aria-label="${tabTitle}">${tabTitle}</md-tab>
                    <md-tab-panel slot="panel" class="aps-tab-panel">
                      <iframe
                        src="${_config__WEBPACK_IMPORTED_MODULE_0__.CONF.ANALYZER_HOST}/analyzer/view/${isDashboard
                        ? "embed"
                        : "iframe"}?rId=${reportId}&is_dark_theme=${this.isDarkTheme}"
                        title="${tabTitle}"
                        id="${id}"
                        frameborder="0"
                        class="report-frame"
                      ></iframe>
                    </md-tab-panel>
                  `;
                })}
              </md-tabs>
            </div>
          `
                : (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) ` <uuip-wc-content-loading></uuip-wc-content-loading> `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean, attribute: "is-dark-theme" })
    ], Element.prototype, "isDarkTheme", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
    ], Element.prototype, "agentReportList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ attribute: false })
    ], Element.prototype, "isAnalyzerSessionSet", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-agent-performance-reports")
    ], Element);
    AgentPerformanceReports.Element = Element;
})(AgentPerformanceReports || (AgentPerformanceReports = {}));


/***/ }),

/***/ "./src/components/AgentPerformanceReports/AnalyzerSessionHelper.ts":
/*!*************************************************************************!*\
  !*** ./src/components/AgentPerformanceReports/AnalyzerSessionHelper.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   analyzerSessionHelper: () => (/* binding */ analyzerSessionHelper)
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/config */ "./src/config.ts");

/**
 * *** AnalyzerSessionHelper used for workaround to create analyzer session before loading reports ***
 *
 * AnalyzerSessionHelper is a singleton instance, which created only
 *
 * creating analyzer session before stating to load reports is done to prevent
 * side effects of simultaneous session initializations by multiple reports
 * */
class AnalyzerSessionHelper {
    constructor() {
        this.analyzerSessionIframe = document.createElement("iframe");
        this.isAnalyzerSessionSet = false;
        this.initiated = false;
    }
    create() {
        const clusterId = localStorage.getItem("clusterId");
        if (this.isAnalyzerSessionSet) {
            return Promise.resolve(true);
        }
        if (this.initiated) {
            return this.promiseReference;
        }
        this.initiated = true;
        this.promiseReference = new Promise((resolve) => {
            this.analyzerSessionIframe.setAttribute("style", "display: none");
            this.analyzerSessionIframe.onload = () => {
                this.isAnalyzerSessionSet = true;
                resolve(true);
            };
            const clusterQueryParam = `?ciClusterId=${clusterId}`;
            const analyzerGetVersionUrl = `${_config__WEBPACK_IMPORTED_MODULE_0__.CONF.ANALYZER_HOST}/analyzer/version/get${clusterQueryParam}`;
            this.analyzerSessionIframe.src = analyzerGetVersionUrl;
            document.body.appendChild(this.analyzerSessionIframe);
            /* Analyzer sessions are valid only for 30 mins, on calling /version/get api, session time will be extended for 30 mins */
            this.intervalRef = setInterval(() => {
                this.analyzerSessionIframe.src = `${analyzerGetVersionUrl}&t=${Date.now()}`;
            }, 25 * 60 * 1000);
        });
        return this.promiseReference;
    }
    analyzerLogout() {
        let logoutTimeoutTracker = null;
        this.promiseReference = new Promise((resolve, reject) => {
            this.intervalRef && clearInterval(this.intervalRef); // stop analyzer session extender
            this.analyzerSessionIframe.setAttribute("style", "display: none");
            this.analyzerSessionIframe.onload = () => {
                logoutTimeoutTracker && clearTimeout(logoutTimeoutTracker);
                this.initiated = false;
                this.isAnalyzerSessionSet = false;
                resolve(true);
            };
            this.analyzerSessionIframe.src = `${_config__WEBPACK_IMPORTED_MODULE_0__.CONF.ANALYZER_HOST}/analyzer/app-logout`;
            document.body.appendChild(this.analyzerSessionIframe);
            /* Reject the promise if analyzer logout fails to complete in 5 sec to allow the desktop CI logout */
            logoutTimeoutTracker = setTimeout(() => {
                reject(new Error("Analyzer logout request timed out"));
            }, 5000);
        });
        return this.promiseReference;
    }
}
const analyzerSessionHelper = new AnalyzerSessionHelper();


/***/ }),

/***/ "./src/components/AgentPerformanceReports/agentReportList.ts":
/*!*******************************************************************!*\
  !*** ./src/components/AgentPerformanceReports/agentReportList.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   agentReportList: () => (/* binding */ agentReportList)
/* harmony export */ });
const agentReportList = [
    {
        reportId: "-1207",
        isDashboard: true,
        tabId: "agentSummary"
    },
    {
        reportId: "-1222",
        isDashboard: true,
        tabId: "agentHistoryStats"
    },
    {
        reportId: "-1225",
        isDashboard: true,
        tabId: "agentRealtimeStats"
    },
    {
        reportId: "-1229",
        isDashboard: true,
        tabId: "agentStatsByStateHist"
    },
    {
        reportId: "-1233",
        isDashboard: true,
        tabId: "agentStatsByStateRealtime"
    },
    {
        reportId: "-1234",
        isDashboard: false,
        tabId: "teamStatsHist"
    },
    {
        reportId: "-1235",
        isDashboard: false,
        tabId: "teamStatsRealtime"
    },
    {
        reportId: "-1209",
        isDashboard: false,
        tabId: "contactDetailsInQueueHist"
    },
    {
        reportId: "-1272",
        isDashboard: true,
        tabId: "contactDetailsInQueueRealtime"
    },
    {
        reportId: "-164",
        isDashboard: false,
        tabId: "outdialStatsHistoric"
    },
    {
        reportId: "-165",
        isDashboard: false,
        tabId: "outdialStatsRealtime"
    }
];


/***/ }),

/***/ "./src/components/AgentPerformanceWidget/AgentPerformanceWidget.scss":
/*!***************************************************************************!*\
  !*** ./src/components/AgentPerformanceWidget/AgentPerformanceWidget.scss ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: block;
  height: 100%;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/AgentPerformanceWidget/AgentPerformanceWidget.scss */
/*# sourceURL=AgentPerformanceWidget.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvQWdlbnRQZXJmb3JtYW5jZVdpZGdldC9BZ2VudFBlcmZvcm1hbmNlV2lkZ2V0LnNjc3MiLCJBZ2VudFBlcmZvcm1hbmNlV2lkZ2V0LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxjQUFBO0VBQ0EsWUFBQTtBQ0NGIiwiZmlsZSI6IkFnZW50UGVyZm9ybWFuY2VXaWRnZXQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgZGlzcGxheTogYmxvY2s7XG4gIGhlaWdodDogMTAwJTtcbn1cbiIsIjpob3N0IHtcbiAgZGlzcGxheTogYmxvY2s7XG4gIGhlaWdodDogMTAwJTtcbn0iXX0= */`);
    

/***/ }),

/***/ "./src/components/AgentPerformanceWidget/AgentPerformanceWidget.ts":
/*!*************************************************************************!*\
  !*** ./src/components/AgentPerformanceWidget/AgentPerformanceWidget.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentPerformanceWidget: () => (/* binding */ AgentPerformanceWidget)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Common_WcGrid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Common/WcGrid */ "./src/components/Common/WcGrid/index.ts");
/* harmony import */ var _Common_WcGrid_WcGridConfig__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/WcGrid/WcGridConfig */ "./src/components/Common/WcGrid/WcGridConfig.ts");
/* harmony import */ var _DataFetcher__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./DataFetcher */ "./src/components/AgentPerformanceWidget/DataFetcher.ts");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./config */ "./src/components/AgentPerformanceWidget/config.ts");
/* harmony import */ var _AgentPerformanceWidget_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./AgentPerformanceWidget.scss */ "./src/components/AgentPerformanceWidget/AgentPerformanceWidget.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};







var AgentPerformanceWidget;
(function (AgentPerformanceWidget) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.isDarkMode = false;
            this.dataFetcher = new _DataFetcher__WEBPACK_IMPORTED_MODULE_4__.DataFetcher();
            this.startTime = 0;
            this.endTime = 0;
            this.gridHeaderLeftText = "";
        }
        static get styles() {
            return _AgentPerformanceWidget_scss__WEBPACK_IMPORTED_MODULE_6__["default"];
        }
        getWcGridConfig() {
            const now = Date.now();
            // default time range is last 7 days
            this.startTime = now - 7 * 24 * 60 * 60 * 1000;
            this.endTime = now - (now % (24 * 60 * 60 * 1000));
            return new _Common_WcGrid_WcGridConfig__WEBPACK_IMPORTED_MODULE_3__.WcGridConfig({
                tableName: "agentPerformance",
                enableCharts: true,
                headerConfig: {
                    resetGridStateButton: true,
                    filterButton: "small",
                    columnSelectButton: true,
                    refreshButton: true,
                    datePicker: true,
                    datePickerStartTime: this.startTime,
                    datePickerEndTime: this.endTime,
                    leftText: this.gridHeaderLeftText,
                    unsortedButton: false
                },
                getGridRowData: () => __awaiter(this, void 0, void 0, function* () { return this.fetchRowData(); })
            });
        }
        fetchRowData() {
            return __awaiter(this, void 0, void 0, function* () {
                const allColumns = [];
                for (const key in _DataFetcher__WEBPACK_IMPORTED_MODULE_4__.DataFetcher.ColumnName) {
                    allColumns.push(_DataFetcher__WEBPACK_IMPORTED_MODULE_4__.DataFetcher.ColumnName[key]);
                }
                const agentPerformanceData = yield this.dataFetcher.fetchPerformanceData(this.startTime, this.endTime, allColumns);
                const gridRowData = agentPerformanceData.map((dataFetcherRow) => {
                    const agentRowObject = {};
                    dataFetcherRow.forEach((dataFetcherColumn) => {
                        if (dataFetcherColumn.value !== undefined) {
                            agentRowObject[dataFetcherColumn.name] = dataFetcherColumn.value;
                        }
                    });
                    return agentRowObject;
                });
                return gridRowData;
            });
        }
        onSearchDateRangeUpdated(e) {
            e.stopPropagation();
            this.startTime = e.detail.startTime;
            this.endTime = e.detail.endTime;
        }
        onDisplayedRowCountChanged(e) {
            e.stopPropagation();
            const numberOfAgentsStr = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:agentPerformance.numberOfAgents");
            this.gridHeaderLeftText = `${numberOfAgentsStr} ${e.detail.count}`;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <wc-ag-grid
          .isDarkMode=${this.isDarkMode}
          .wcGridConfig=${this.getWcGridConfig()}
          .wcColumnDefs=${(0,_config__WEBPACK_IMPORTED_MODULE_5__.getWcColumnDefs)()}
          @search-date-range-updated=${this.onSearchDateRangeUpdated}
          @displayed-row-count-changed=${this.onDisplayedRowCountChanged}
        ></wc-ag-grid>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "isDarkMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ attribute: false })
    ], Element.prototype, "dataFetcher", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "startTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "endTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "gridHeaderLeftText", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-agent-performance-widget")
    ], Element);
    AgentPerformanceWidget.Element = Element;
})(AgentPerformanceWidget || (AgentPerformanceWidget = {}));


/***/ }),

/***/ "./src/components/AgentPerformanceWidget/DataFetcher.ts":
/*!**************************************************************!*\
  !*** ./src/components/AgentPerformanceWidget/DataFetcher.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DataFetcher: () => (/* binding */ DataFetcher)
/* harmony export */ });
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


class DataFetcher {
    constructor() {
        this.requiredAgentColumns = [
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.AgentId,
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.TeamId
        ];
        this.requiredTeamColumn = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.TeamId;
        this.forbiddenTeamColumns = [
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.AgentName,
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.AgentId,
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.AgentEmail
        ];
    }
    fetchPerformanceData(startTime, endTime, columns) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!columns || columns.length === 0) {
                _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error("Columns are required to fetch agent performance data");
                return [];
            }
            const serviceColumns = this.columnNamesToServiceColumns(columns);
            const agentPerformanceData = this.getAgentPerformanceData(startTime, endTime, serviceColumns);
            let teamSessions = [];
            const containsTeamAvgColumn = columns.some((column) => this.isTeamAvgColumn(column));
            if (containsTeamAvgColumn) {
                const teamPerformanceData = this.getTeamPerformanceData(startTime, endTime, containsTeamAvgColumn, serviceColumns);
                teamSessions = (yield teamPerformanceData).data.agentSession.agentSessions;
            }
            const agentSessions = (yield agentPerformanceData).data.agentSession.agentSessions;
            return this.processSessions(agentSessions, teamSessions, columns);
        });
    }
    processSessions(agentSessions, teamSessions, columns) {
        const retTable = [];
        const getDurationObject = (value) => {
            return { duration: value };
        };
        agentSessions.forEach((agentSession) => {
            const row = [];
            columns.forEach((column) => {
                switch (column) {
                    case DataFetcher.ColumnName.AgentName:
                        row.push({ name: column, value: agentSession.agentName });
                        break;
                    case DataFetcher.ColumnName.AgentId:
                        row.push({ name: column, value: agentSession.agentId });
                        break;
                    case DataFetcher.ColumnName.AgentEmail:
                        row.push({ name: column, value: agentSession.userLoginId });
                        break;
                    case DataFetcher.ColumnName.TeamId:
                        row.push({ name: column, value: agentSession.teamId });
                        break;
                    case DataFetcher.ColumnName.TeamName:
                        row.push({ name: column, value: agentSession.teamName });
                        break;
                    case DataFetcher.ColumnName.SiteName:
                        row.push({ name: column, value: agentSession.siteName });
                        break;
                    case DataFetcher.ColumnName.ConnectedDuration:
                    case DataFetcher.ColumnName.HoldDuration: {
                        row.push({
                            name: column,
                            value: getDurationObject(this.getAggregationValue(agentSession.aggregation, column))
                        });
                        break;
                    }
                    case DataFetcher.ColumnName.AverageHandleTime: {
                        row.push({ name: column, value: getDurationObject(this.computeAverageHandleTime(agentSession)) });
                        break;
                    }
                    case DataFetcher.ColumnName.TeamAvgHoldDuration: {
                        this.processTeamSessions(teamSessions, agentSession, column, DataFetcher.ColumnName.HoldDuration, row);
                        const calcData = row.pop(); // Get back data to be represented in duration object type
                        row.push({ name: column, value: getDurationObject(Number(calcData === null || calcData === void 0 ? void 0 : calcData.value)) });
                        break;
                    }
                    case DataFetcher.ColumnName.TeamAvgConnectedDuration: {
                        this.processTeamSessions(teamSessions, agentSession, column, DataFetcher.ColumnName.ConnectedDuration, row);
                        const calcData = row.pop(); // Get back data to be represented in duration object type
                        row.push({ name: column, value: getDurationObject(Number(calcData === null || calcData === void 0 ? void 0 : calcData.value)) });
                        break;
                    }
                    case DataFetcher.ColumnName.ConnectedCount:
                    case DataFetcher.ColumnName.ConsultRequestCount:
                    case DataFetcher.ColumnName.ConsultAnswerCount:
                    case DataFetcher.ColumnName.HoldCount:
                    case DataFetcher.ColumnName.TransferCount:
                        row.push({ name: column, value: this.getAggregationValue(agentSession.aggregation, column) });
                        break;
                    case DataFetcher.ColumnName.TeamAvgConnectedCount:
                        this.processTeamSessions(teamSessions, agentSession, column, DataFetcher.ColumnName.ConnectedCount, row);
                        break;
                    case DataFetcher.ColumnName.TeamAvgHoldCount:
                        this.processTeamSessions(teamSessions, agentSession, column, DataFetcher.ColumnName.HoldCount, row);
                        break;
                    case DataFetcher.ColumnName.TeamAvgTransferCount:
                        this.processTeamSessions(teamSessions, agentSession, column, DataFetcher.ColumnName.TransferCount, row);
                        break;
                    case DataFetcher.ColumnName.TeamAvgAverageHandleTime:
                        this.processTeamSessions(teamSessions, agentSession, column, DataFetcher.ColumnName.AverageHandleTime, row);
                        break;
                    case DataFetcher.ColumnName.HoldCountRatio: {
                        const connectedCount = this.getAggregationValue(agentSession.aggregation, DataFetcher.ColumnName.ConnectedCount);
                        const holdCount = this.getAggregationValue(agentSession.aggregation, DataFetcher.ColumnName.HoldCount);
                        const holdCountRatio = this.computeAverage(holdCount, connectedCount);
                        row.push({ name: column, value: holdCountRatio });
                        break;
                    }
                    case DataFetcher.ColumnName.HoldDurationRatio: {
                        const connectedDuration = this.getAggregationValue(agentSession.aggregation, DataFetcher.ColumnName.ConnectedDuration);
                        const holdDuration = this.getAggregationValue(agentSession.aggregation, DataFetcher.ColumnName.HoldDuration);
                        const holdDurationRatio = this.computeAverage(holdDuration, connectedDuration);
                        row.push({ name: column, value: holdDurationRatio });
                        break;
                    }
                    default:
                        break;
                }
            });
            retTable.push(row);
        });
        this.computeAnomalies(retTable);
        return retTable;
    }
    computeAnomalies(table) {
        table.forEach((row) => {
            const anomalies = [];
            const defaultThreshold = 0.5;
            const anomalyConfigs = [
                {
                    column: DataFetcher.ColumnName.ConnectedCount,
                    teamAvgColumn: DataFetcher.ColumnName.TeamAvgConnectedCount,
                    threshold: defaultThreshold
                },
                {
                    column: DataFetcher.ColumnName.ConnectedDuration,
                    teamAvgColumn: DataFetcher.ColumnName.TeamAvgConnectedDuration,
                    threshold: defaultThreshold
                },
                {
                    column: DataFetcher.ColumnName.HoldCount,
                    teamAvgColumn: DataFetcher.ColumnName.TeamAvgHoldCount,
                    threshold: defaultThreshold
                },
                {
                    column: DataFetcher.ColumnName.HoldDuration,
                    teamAvgColumn: DataFetcher.ColumnName.TeamAvgHoldDuration,
                    threshold: defaultThreshold
                },
                {
                    column: DataFetcher.ColumnName.TransferCount,
                    teamAvgColumn: DataFetcher.ColumnName.TeamAvgTransferCount,
                    threshold: defaultThreshold
                },
                {
                    column: DataFetcher.ColumnName.AverageHandleTime,
                    teamAvgColumn: DataFetcher.ColumnName.TeamAvgAverageHandleTime,
                    threshold: defaultThreshold
                }
            ];
            anomalyConfigs.forEach((config) => {
                var _a, _b, _c;
                const columnValue = (_a = row.find((column) => column.name === config.column)) === null || _a === void 0 ? void 0 : _a.value;
                if (typeof columnValue === "number") {
                    const teamAvgColumnValue = (_b = row.find((column) => column.name === config.teamAvgColumn)) === null || _b === void 0 ? void 0 : _b.value;
                    if (columnValue > teamAvgColumnValue + teamAvgColumnValue * config.threshold ||
                        columnValue < teamAvgColumnValue - teamAvgColumnValue * config.threshold) {
                        const anomaly = {
                            [config.column]: true
                        };
                        anomalies.push(anomaly);
                    }
                }
                else if (columnValue && typeof columnValue === "object" && "duration" in columnValue) {
                    const teamAvgColumnValue = (_c = row.find((column) => column.name === config.teamAvgColumn)) === null || _c === void 0 ? void 0 : _c.value;
                    if (teamAvgColumnValue && typeof teamAvgColumnValue === "object" && "duration" in teamAvgColumnValue) {
                        const threshold = teamAvgColumnValue.duration * config.threshold;
                        if (columnValue.duration > teamAvgColumnValue.duration + threshold) {
                            const anomaly = {
                                [config.column]: true
                            };
                            anomalies.push(anomaly);
                        }
                    }
                }
            });
            row.push({ name: DataFetcher.ColumnName.Anomalies, value: anomalies });
        });
    }
    computeAverage(total, numItems) {
        return numItems > 0 ? total / numItems : 0;
    }
    computeAverageHandleTime(agentSession) {
        const connectedCount = this.getAggregationValue(agentSession.aggregation, DataFetcher.ColumnName.ConnectedCount);
        const connectedDuration = this.getAggregationValue(agentSession.aggregation, DataFetcher.ColumnName.ConnectedDuration);
        return this.computeAverage(connectedDuration, connectedCount);
    }
    processTeamSessions(teamSessions, agentSession, teamColumn, agentColumn, row) {
        teamSessions.forEach((teamSession) => {
            if (teamSession.teamId === agentSession.teamId) {
                const agentCount = this.getAggregationValueUsingServiceColumn(teamSession.aggregation, _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.NumAgentsInTeam);
                const aggregationValue = teamColumn === DataFetcher.ColumnName.TeamAvgAverageHandleTime
                    ? this.computeAverageHandleTime(teamSession)
                    : this.getAggregationValue(teamSession.aggregation, agentColumn);
                const averageValue = this.computeAverage(aggregationValue, agentCount);
                row.push({
                    name: teamColumn,
                    value: averageValue
                });
            }
        });
    }
    getTeamPerformanceData(startTime, endTime, containsTeamAvgColumn, columns) {
        return __awaiter(this, void 0, void 0, function* () {
            // remove forbiddenTeamColumns from serviceColumns and add requiredTeamColumn
            columns = columns.filter((column) => !this.forbiddenTeamColumns.includes(column));
            // append requiredTeamColumn to serviceColumns if not already included
            if (!columns.includes(this.requiredTeamColumn)) {
                columns.push(this.requiredTeamColumn);
            }
            if (containsTeamAvgColumn && !columns.includes(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.NumAgentsInTeam)) {
                columns.push(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.NumAgentsInTeam);
            }
            return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.agentPerformance.fetchAgentPerformanceData({ startTime, endTime, columns });
        });
    }
    getAggregationValue(aggregations, column) {
        const serviceColumnName = this.columnNamesToServiceColumns([column]).at(0);
        if (serviceColumnName) {
            return this.getAggregationValueUsingServiceColumn(aggregations, serviceColumnName);
        }
        return 0;
    }
    getAggregationValueUsingServiceColumn(aggregations, column) {
        const aggregationName = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.agentPerformance.getAggregationName(column);
        const aggregation = aggregations.find((agg) => agg.name === aggregationName);
        return aggregation ? Number(aggregation.value) : 0;
    }
    getAgentPerformanceData(startTime, endTime, columns) {
        return __awaiter(this, void 0, void 0, function* () {
            // append requiredAgentColumns to serviceColumns if not already included
            this.requiredAgentColumns.forEach((requiredColumn) => {
                if (!columns.includes(requiredColumn)) {
                    columns.push(requiredColumn);
                }
            });
            return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.agentPerformance.fetchAgentPerformanceData({ startTime, endTime, columns });
        });
    }
    columnNamesToServiceColumns(columns) {
        const convertColumn = (column) => {
            switch (column) {
                case DataFetcher.ColumnName.AgentName:
                    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.AgentName;
                case DataFetcher.ColumnName.AgentId:
                    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.AgentId;
                case DataFetcher.ColumnName.AgentEmail:
                    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.AgentEmail;
                case DataFetcher.ColumnName.TeamId:
                    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.TeamId;
                case DataFetcher.ColumnName.ConnectedCount:
                    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.ConnectedCount;
                case DataFetcher.ColumnName.ConnectedDuration:
                    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.ConnectedDuration;
                case DataFetcher.ColumnName.ConsultRequestCount:
                    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.ConsultRequestCount;
                case DataFetcher.ColumnName.ConsultAnswerCount:
                    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.ConsultAnswerCount;
                case DataFetcher.ColumnName.HoldCount:
                    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.HoldCount;
                case DataFetcher.ColumnName.TeamName:
                    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.TeamName;
                case DataFetcher.ColumnName.HoldDuration:
                    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.HoldDuration;
                case DataFetcher.ColumnName.SiteName:
                    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.SiteName;
                case DataFetcher.ColumnName.TransferCount:
                    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.TransferCount;
                case DataFetcher.ColumnName.HoldDurationRatio:
                case DataFetcher.ColumnName.HoldCountRatio:
                default:
                    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.AgentId;
            }
        };
        let serviceColumns = [];
        if (columns.includes(DataFetcher.ColumnName.AverageHandleTime)) {
            serviceColumns.push(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.ConnectedDuration);
            serviceColumns.push(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.ConnectedCount);
        }
        else if (columns.includes(DataFetcher.ColumnName.HoldCountRatio)) {
            serviceColumns.push(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.ConnectedCount);
            serviceColumns.push(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.HoldCount);
        }
        else if (columns.includes(DataFetcher.ColumnName.HoldDurationRatio)) {
            serviceColumns.push(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.HoldDuration);
            serviceColumns.push(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.ColumnType.ConnectedDuration);
        }
        else {
            serviceColumns = columns.map((column) => convertColumn(column));
        }
        columns.forEach((column) => {
            const serviceColumn = convertColumn(column);
            if (!serviceColumns.includes(serviceColumn)) {
                serviceColumns.push(serviceColumn);
            }
        });
        return Array.from(new Set(serviceColumns));
    }
    isTeamAvgColumn(column) {
        return (column === DataFetcher.ColumnName.TeamAvgConnectedCount ||
            column === DataFetcher.ColumnName.TeamAvgConnectedDuration ||
            column === DataFetcher.ColumnName.TeamAvgHoldCount ||
            column === DataFetcher.ColumnName.TeamAvgHoldDuration ||
            column === DataFetcher.ColumnName.TeamAvgTransferCount ||
            column === DataFetcher.ColumnName.TeamAvgAverageHandleTime);
    }
}
(function (DataFetcher) {
    let ColumnName;
    (function (ColumnName) {
        ColumnName["AgentName"] = "agentName";
        ColumnName["AgentId"] = "agentId";
        ColumnName["AgentEmail"] = "agentEmail";
        ColumnName["TeamName"] = "teamName";
        ColumnName["TeamId"] = "teamId";
        ColumnName["SiteName"] = "siteName";
        ColumnName["SiteId"] = "siteId";
        ColumnName["ConnectedCount"] = "connectedCount";
        ColumnName["ConnectedDuration"] = "connectedDuration";
        ColumnName["ConsultRequestCount"] = "consultRequestCount";
        ColumnName["ConsultAnswerCount"] = "consultAnswerCount";
        ColumnName["HoldCount"] = "holdCount";
        ColumnName["HoldDuration"] = "holdDuration";
        ColumnName["TransferCount"] = "transferCount";
        ColumnName["AverageHandleTime"] = "averageHandleTime";
        // team average columns
        ColumnName["TeamAvgConnectedCount"] = "teamAvgConnectedCount";
        ColumnName["TeamAvgConnectedDuration"] = "teamAvgConnectedDuration";
        ColumnName["TeamAvgHoldCount"] = "teamAvgHoldCount";
        ColumnName["TeamAvgHoldDuration"] = "teamAvgHoldDuration";
        ColumnName["TeamAvgTransferCount"] = "teamAvgTransferCount";
        ColumnName["TeamAvgAverageHandleTime"] = "teamAvgAverageHandleTime";
        // computed columns below this line
        ColumnName["HoldCountRatio"] = "holdCountRatio";
        ColumnName["HoldDurationRatio"] = "holdDurationRatio";
        ColumnName["Anomalies"] = "anomalies";
    })(ColumnName = DataFetcher.ColumnName || (DataFetcher.ColumnName = {}));
})(DataFetcher || (DataFetcher = {}));


/***/ }),

/***/ "./src/components/AgentPerformanceWidget/config.ts":
/*!*********************************************************!*\
  !*** ./src/components/AgentPerformanceWidget/config.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getWcColumnDefs: () => (/* binding */ getWcColumnDefs)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _Common_TableCustomizationMenu_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Common/TableCustomizationMenu/constants */ "./src/components/Common/TableCustomizationMenu/constants.ts");
/* harmony import */ var _DataFetcher__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./DataFetcher */ "./src/components/AgentPerformanceWidget/DataFetcher.ts");
/* harmony import */ var _Common_WcGrid_WcColumns_AgentNameColumn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/WcGrid/WcColumns/AgentNameColumn */ "./src/components/Common/WcGrid/WcColumns/AgentNameColumn.ts");
/* harmony import */ var _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Common/WcGrid/WcColumns/StringColumn */ "./src/components/Common/WcGrid/WcColumns/StringColumn.ts");
/* harmony import */ var _Common_WcGrid_WcColumns_NumberColumn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Common/WcGrid/WcColumns/NumberColumn */ "./src/components/Common/WcGrid/WcColumns/NumberColumn.ts");
/* harmony import */ var _Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Common/WcGrid/WcColumns/DurationColumn */ "./src/components/Common/WcGrid/WcColumns/DurationColumn.ts");
/* harmony import */ var _Common_WcGrid_WcColumns_PercentColumn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Common/WcGrid/WcColumns/PercentColumn */ "./src/components/Common/WcGrid/WcColumns/PercentColumn.ts");
/* harmony import */ var _Common_WcGrid_WcColumns_ActionsButtonsColumn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Common/WcGrid/WcColumns/ActionsButtonsColumn */ "./src/components/Common/WcGrid/WcColumns/ActionsButtonsColumn.ts");
/* harmony import */ var _Common_WcGrid_WcColumns_AnomaliesColumn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Common/WcGrid/WcColumns/AnomaliesColumn */ "./src/components/Common/WcGrid/WcColumns/AnomaliesColumn.ts");
/* harmony import */ var _Common_WcGrid_WcChart_WcChart__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Common/WcGrid/WcChart/WcChart */ "./src/components/Common/WcGrid/WcChart/WcChart.ts");
/* harmony import */ var _Common_WcGrid_WcColumns_WcChartConfig__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../Common/WcGrid/WcColumns/WcChartConfig */ "./src/components/Common/WcGrid/WcColumns/WcChartConfig.ts");












const primaryChartConfig = new _Common_WcGrid_WcColumns_WcChartConfig__WEBPACK_IMPORTED_MODULE_11__.WcChartConfig({
    chartDataType: _Common_WcGrid_WcChart_WcChart__WEBPACK_IMPORTED_MODULE_10__.ChartDataType.Category,
    isPrimaryAxisInChart: true
});
const seriesChartConfig = new _Common_WcGrid_WcColumns_WcChartConfig__WEBPACK_IMPORTED_MODULE_11__.WcChartConfig({
    chartDataType: _Common_WcGrid_WcChart_WcChart__WEBPACK_IMPORTED_MODULE_10__.ChartDataType.Series
});
const avgSeriesChartConfig = new _Common_WcGrid_WcColumns_WcChartConfig__WEBPACK_IMPORTED_MODULE_11__.WcChartConfig({
    chartDataType: _Common_WcGrid_WcChart_WcChart__WEBPACK_IMPORTED_MODULE_10__.ChartDataType.Series,
    isAverageDataColumn: true
});
function getAllColumns() {
    return [
        new _Common_WcGrid_WcColumns_AgentNameColumn__WEBPACK_IMPORTED_MODULE_3__.AgentNameColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.AgentName}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.AgentName).setChartConfig(primaryChartConfig),
        new _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_4__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.AgentId}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.AgentId),
        new _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_4__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.AgentEmail}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.AgentEmail),
        new _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_4__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TeamName}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TeamName),
        new _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_4__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TeamId}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TeamId),
        new _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_4__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.SiteName}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.SiteName),
        new _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_4__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.SiteId}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.SiteId),
        new _Common_WcGrid_WcColumns_NumberColumn__WEBPACK_IMPORTED_MODULE_5__.NumberColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.ConnectedCount}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.ConnectedCount).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_6__.DurationColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.ConnectedDuration}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.ConnectedDuration).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_NumberColumn__WEBPACK_IMPORTED_MODULE_5__.NumberColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.ConsultRequestCount}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.ConsultRequestCount).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_NumberColumn__WEBPACK_IMPORTED_MODULE_5__.NumberColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.ConsultAnswerCount}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.ConsultAnswerCount).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_NumberColumn__WEBPACK_IMPORTED_MODULE_5__.NumberColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.HoldCount}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.HoldCount).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_6__.DurationColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.HoldDuration}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.HoldDuration).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_NumberColumn__WEBPACK_IMPORTED_MODULE_5__.NumberColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TransferCount}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TransferCount).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_6__.DurationColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.AverageHandleTime}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.AverageHandleTime).setChartConfig(avgSeriesChartConfig),
        new _Common_WcGrid_WcColumns_NumberColumn__WEBPACK_IMPORTED_MODULE_5__.NumberColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TeamAvgConnectedCount}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TeamAvgConnectedCount).setChartConfig(avgSeriesChartConfig),
        new _Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_6__.DurationColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TeamAvgConnectedDuration}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TeamAvgConnectedDuration).setChartConfig(avgSeriesChartConfig),
        new _Common_WcGrid_WcColumns_NumberColumn__WEBPACK_IMPORTED_MODULE_5__.NumberColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TeamAvgHoldCount}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TeamAvgHoldCount).setChartConfig(avgSeriesChartConfig),
        new _Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_6__.DurationColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TeamAvgHoldDuration}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TeamAvgHoldDuration).setChartConfig(avgSeriesChartConfig),
        new _Common_WcGrid_WcColumns_NumberColumn__WEBPACK_IMPORTED_MODULE_5__.NumberColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TeamAvgTransferCount}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TeamAvgTransferCount).setChartConfig(avgSeriesChartConfig),
        new _Common_WcGrid_WcColumns_DurationColumn__WEBPACK_IMPORTED_MODULE_6__.DurationColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TeamAvgAverageHandleTime}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TeamAvgAverageHandleTime).setChartConfig(avgSeriesChartConfig),
        new _Common_WcGrid_WcColumns_PercentColumn__WEBPACK_IMPORTED_MODULE_7__.PercentColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.HoldCountRatio}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.HoldCountRatio).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_PercentColumn__WEBPACK_IMPORTED_MODULE_7__.PercentColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.HoldDurationRatio}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.HoldDurationRatio).setChartConfig(seriesChartConfig),
        new _Common_WcGrid_WcColumns_AnomaliesColumn__WEBPACK_IMPORTED_MODULE_9__.AnomaliesColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.Anomalies}`), _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.Anomalies),
        new _Common_WcGrid_WcColumns_ActionsButtonsColumn__WEBPACK_IMPORTED_MODULE_8__.ActionsButtonsColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:agentPerformance.columns.${_Common_TableCustomizationMenu_constants__WEBPACK_IMPORTED_MODULE_1__.ACTIONS_COLUMN_ID}`), _Common_TableCustomizationMenu_constants__WEBPACK_IMPORTED_MODULE_1__.ACTIONS_COLUMN_ID, [])
    ];
}
function getDefaultColumns() {
    const defaultColumns = new Set([
        _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.AgentName,
        _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TeamName,
        _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.Anomalies,
        _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.AverageHandleTime,
        _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.ConnectedCount,
        _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.ConnectedDuration,
        _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.HoldCount,
        _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.HoldDuration,
        _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.TeamAvgConnectedCount,
        _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.HoldCountRatio,
        _DataFetcher__WEBPACK_IMPORTED_MODULE_2__.DataFetcher.ColumnName.HoldDurationRatio
    ]);
    return Array.from(defaultColumns);
}
function getWcColumnDefs() {
    const allColumns = getAllColumns();
    const defaultColumns = getDefaultColumns();
    allColumns.forEach((column) => {
        column.setHidden(!defaultColumns.includes(column.getFieldName()));
    });
    return allColumns;
}


/***/ }),

/***/ "./src/components/CollapseArea/CollapseArea.scss":
/*!*******************************************************!*\
  !*** ./src/components/CollapseArea/CollapseArea.scss ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: block;
  height: 100%;
  position: relative;
  transition: width 350ms ease-in-out;
  width: auto;
  will-change: width;
  border-radius: var(--collapse-area-border-radius);
  box-shadow: var(--collapse-area-box-shadow);
  background: var(--collapse-area-background);
  /**
  * WARNING!!!
  * Do NOT use transform: translateX/Y/X/3d to not break fixed positioning maximized widget inside collapse area.
  * "will-change" rule is enough for gpu animation
  */
}
:host .collapse-area {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  border-right: calc(var(--collapse-area-divider-width, 2px) * -1);
}
:host .collapse-area .collapse-area-inner {
  bottom: 0;
  left: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 0;
}
:host .collapse-area .collapse-area-divider {
  width: var(--collapse-area-divider-width, 2px);
  height: 100%;
  right: 0;
  background: var(--md-nav-divider-primary, --md-primary-seperator-color);
  position: absolute;
}
:host .collapse-area.hovered .collapse-area-divider {
  background: var(--md-nav-divider-primary-hover, --md-primary-seperator-color);
}
:host .displayTaskArea {
  display: none;
}

:host([collapsed]) {
  width: var(--collapse-area-collapsed-width, 0) !important;
  border-right: 0;
  background-color: var(--collapse-area-background, var(--md-primary-bg-color));
}
:host([collapsed]) .collapse-area-divider {
  width: var(--collapse-area-divider-collapsed-width, 0px);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/CollapseArea/CollapseArea.scss */
/*# sourceURL=CollapseArea.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/CollapseArea/CollapseArea.ts":
/*!*****************************************************!*\
  !*** ./src/components/CollapseArea/CollapseArea.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CollapseArea: () => (/* binding */ CollapseArea)
/* harmony export */ });
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/utils/WindowListenersHub */ "./src/utils/WindowListenersHub.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _CollapseArea_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CollapseArea.scss */ "./src/components/CollapseArea/CollapseArea.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var CollapseArea;
(function (CollapseArea) {
    let Direction;
    (function (Direction) {
        Direction["Left"] = "left";
        Direction["Right"] = "right";
    })(Direction = CollapseArea.Direction || (CollapseArea.Direction = {}));
    let Event;
    (function (Event) {
        Event["Toggle"] = "toggle";
    })(Event = CollapseArea.Event || (CollapseArea.Event = {}));
    const VISIBLE_DISTANCE = 100; //px
    const isMouseCloseToRect = (e, rect) => {
        return (rect.left - VISIBLE_DISTANCE <= e.clientX &&
            rect.right + VISIBLE_DISTANCE >= e.clientX &&
            rect.top - VISIBLE_DISTANCE <= e.clientY &&
            rect.bottom + VISIBLE_DISTANCE >= e.clientY);
    };
    /**
     * @element agentx-wc-collapse-area
     * @fires toggle
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement {
        constructor() {
            super(...arguments);
            this.collapsed = false;
            this.direction = Direction.Left;
            this.forceTogglerVisibilityOnMouseOverSelectors = "";
            this.isMouseCloseToToggler = false;
            this.isMouseInSelfArea = false;
            this.isMouseOverSelector = false;
            this.isMouseOverOnCollapseButton = false;
            this.setHoverState = (e) => {
                this.isMouseOverOnCollapseButton = e.detail.hovered;
            };
            this.onSelfMouseEnter = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_0__.throttle)(() => (this.isMouseInSelfArea = true));
            this.onSelfMouseLeave = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_0__.throttle)(() => (this.isMouseInSelfArea = false));
            this.onWindowMouseMove = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_0__.throttle)((e) => {
                const _path = e.composedPath();
                const _selectors = Array.isArray(this.forceTogglerVisibilityOnMouseOverSelectors)
                    ? this.forceTogglerVisibilityOnMouseOverSelectors
                    : this.forceTogglerVisibilityOnMouseOverSelectors.split(" ");
                if (_path.length) {
                    this.isMouseOverSelector = !!_selectors.find((selector) => !!_path.find((eventTarget) => {
                        return (eventTarget && eventTarget.matches && eventTarget.matches(selector));
                    }));
                }
                this.isMouseCloseToToggler = isMouseCloseToRect(e, this.toggler.getBoundingClientRect());
            });
            this.onWindowMouseLeave = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_0__.throttle)(() => {
                this.isMouseOverSelector = false;
                this.isMouseCloseToToggler = false;
            });
        }
        get isTogglerVisible() {
            return this.isMouseCloseToToggler || this.isMouseInSelfArea || this.isMouseOverSelector;
        }
        connectedCallback() {
            super.connectedCallback();
            this.addEventListener("mouseenter", this.onSelfMouseEnter);
            this.addEventListener("mouseleave", this.onSelfMouseLeave);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_1__.WINDOW_LISTENERS_HUB.on("mouseenter", this.onWindowMouseMove);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_1__.WINDOW_LISTENERS_HUB.on("mousemove", this.onWindowMouseMove);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_1__.WINDOW_LISTENERS_HUB.on("mouseleave", this.onWindowMouseLeave);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_1__.WINDOW_LISTENERS_HUB.on("collapseHover", this.setHoverState);
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.removeEventListener("mouseenter", this.onSelfMouseEnter);
            this.removeEventListener("mouseleave", this.onSelfMouseLeave);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_1__.WINDOW_LISTENERS_HUB.off("mouseenter", this.onWindowMouseMove);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_1__.WINDOW_LISTENERS_HUB.off("mousemove", this.onWindowMouseMove);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_1__.WINDOW_LISTENERS_HUB.off("mouseleave", this.onWindowMouseLeave);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_1__.WINDOW_LISTENERS_HUB.off("collapseHover", this.setHoverState);
        }
        static get styles() {
            return _CollapseArea_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        toggle(e) {
            this.dispatchEvent(new CustomEvent(CollapseArea.Event.Toggle, {
                detail: {
                    collapsed: e.detail.collapsed
                }
            }));
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div
          class="collapse-area ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__.classMap)({
                hovered: this.isMouseOverOnCollapseButton
            })}"
        >
          <div
            class="collapse-area-inner ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__.classMap)({
                displayTaskArea: this.collapsed
            })}"
          >
            <slot></slot>
          </div>
          <div class="collapse-area-divider"></div>
          <agentx-wc-collapse-toggler
            .direction="${this.direction}"
            .collapsed="${this.collapsed}"
            .visible="${this.isTogglerVisible}"
            @toggle="${(e) => this.toggle(e)}"
          ></agentx-wc-collapse-toggler>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean, reflect: true })
    ], Element.prototype, "collapsed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String, reflect: true })
    ], Element.prototype, "direction", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "forceTogglerVisibilityOnMouseOverSelectors", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isMouseCloseToToggler", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isMouseInSelfArea", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isMouseOverSelector", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isMouseOverOnCollapseButton", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)("agentx-wc-collapse-toggler")
    ], Element.prototype, "toggler", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-collapse-area")
    ], Element);
    CollapseArea.Element = Element;
})(CollapseArea || (CollapseArea = {}));


/***/ }),

/***/ "./src/components/CollapseArea/components/CollapseToggler.scss":
/*!*********************************************************************!*\
  !*** ./src/components/CollapseArea/components/CollapseToggler.scss ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --column-toggler-height: 44px;
  --column-toggler-width: var(--grabber-width, 12px);
  background-color: transparent;
  cursor: pointer;
  display: flex;
  height: var(--column-toggler-height);
  position: absolute;
  top: calc(50% - var(--column-toggler-height) / 2);
  width: var(--column-toggler-width);
}

:host([direction=left]) {
  left: auto;
  right: calc(var(--column-toggler-width) * -1);
}

:host([direction=right]) {
  left: calc(var(--column-toggler-width) * -1);
  right: auto;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/CollapseArea/components/CollapseToggler.scss */
/*# sourceURL=CollapseToggler.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/CollapseArea/components/CollapseToggler.ts":
/*!*******************************************************************!*\
  !*** ./src/components/CollapseArea/components/CollapseToggler.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CollapseToggler: () => (/* binding */ CollapseToggler)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _CollapseToggler_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CollapseToggler.scss */ "./src/components/CollapseArea/components/CollapseToggler.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





var CollapseToggler;
(function (CollapseToggler) {
    let Event;
    (function (Event) {
        Event["Toggle"] = "toggle";
    })(Event = CollapseToggler.Event || (CollapseToggler.Event = {}));
    let HoverEvent;
    (function (HoverEvent) {
        HoverEvent["Hover"] = "collapseHover";
    })(HoverEvent = CollapseToggler.HoverEvent || (CollapseToggler.HoverEvent = {}));
    let Direction;
    (function (Direction) {
        Direction["Left"] = "left";
        Direction["Right"] = "right";
    })(Direction = CollapseToggler.Direction || (CollapseToggler.Direction = {}));
    /**
     * @element agentx-wc-collapse-toggler
     * @fires toggle
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement {
        constructor() {
            super(...arguments);
            this.collapsed = false;
            this.direction = Direction.Left;
            this.visible = true;
            this.hovered = false;
        }
        toggle() {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.TASK_PANE_TOGGLE);
            this.dispatchEvent(new CustomEvent(CollapseToggler.Event.Toggle, {
                detail: {
                    collapsed: !this.collapsed
                }
            }));
        }
        grabberToggled(_e) {
            this.toggle();
        }
        grabberHoverChanged(e) {
            this.hovered = e.detail.hovered;
            this.dispatchEvent(new CustomEvent(CollapseToggler.HoverEvent.Hover, {
                bubbles: true,
                composed: true,
                detail: { hovered: this.hovered }
            }));
        }
        handleShortcutKeyEvent() {
            const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.event.listenKeyPress((event) => {
                const { data } = event;
                if (data &&
                    data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.REGISTERED_KEYS.EXPAND_COLLAPSE_TASK_LIST_PANEL_KEY &&
                    data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.MODIFIERS.CTRL_SHIFT) {
                    if (this.grabber) {
                        this.grabber.toggleGrabber();
                    }
                    else {
                        this.toggle();
                    }
                }
            });
            this.stopListen = stopListen;
        }
        connectedCallback() {
            const _super = Object.create(null, {
                connectedCallback: { get: () => super.connectedCallback }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.connectedCallback.call(this);
                this.handleShortcutKeyEvent();
            });
        }
        disconnectedCallback() {
            const _super = Object.create(null, {
                connectedCallback: { get: () => super.connectedCallback }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.connectedCallback.call(this);
                this.stopListen();
            });
        }
        static get styles() {
            return _CollapseToggler_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        get grabberAlignment() {
            return this.direction === "left" ? "leading" : "trailing";
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <md-grabber
          alignment=${this.grabberAlignment}
          class="toggler"
          label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.agentTaskPanelExpand")}
          checkedLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.agentTaskPanelCollapsed")}
          .visible=${this.visible || this.collapsed}
          @grabber-toggled=${(e) => this.grabberToggled(e)}
          @grabber-hover-changed=${(e) => this.grabberHoverChanged(e)}
          ?checked=${!this.collapsed}
        >
        </md-grabber>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "collapsed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String, reflect: true })
    ], Element.prototype, "direction", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "visible", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "hovered", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)(".toggler")
    ], Element.prototype, "grabber", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-collapse-toggler")
    ], Element);
    CollapseToggler.Element = Element;
})(CollapseToggler || (CollapseToggler = {}));


/***/ }),

/***/ "./src/components/Common/CellRenderers/ActionButtons.ts":
/*!**************************************************************!*\
  !*** ./src/components/Common/CellRenderers/ActionButtons.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ActionButtonsCellRenderer: () => (/* binding */ ActionButtonsCellRenderer)
/* harmony export */ });
/* harmony import */ var _constants_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./constants/types */ "./src/components/Common/CellRenderers/constants/types.ts");
/* harmony import */ var _BaseCellRenderer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./BaseCellRenderer */ "./src/components/Common/CellRenderers/BaseCellRenderer.ts");


const ActionButtonsIconsMap = {
    [_constants_types__WEBPACK_IMPORTED_MODULE_0__.ActionButtons.view]: {
        label: "View",
        ariaLabel: "View",
        eventName: "action-button-open-details"
    },
    [_constants_types__WEBPACK_IMPORTED_MODULE_0__.ActionButtons.hearing]: {
        icon: "hearing-bold",
        outline: true,
        eventName: "action-button-listen-recording"
    },
    [_constants_types__WEBPACK_IMPORTED_MODULE_0__.ActionButtons.more]: {
        icon: "more-bold",
        outline: false,
        eventName: "action-button-more"
    },
    [_constants_types__WEBPACK_IMPORTED_MODULE_0__.ActionButtons.download]: {
        icon: "download-bold",
        outline: true,
        eventName: "action-button-download"
    },
    [_constants_types__WEBPACK_IMPORTED_MODULE_0__.ActionButtons.actions]: {
        icon: "download-bold",
        outline: true,
        eventName: "actions"
    }
};
class ActionButtonsCellRenderer extends _BaseCellRenderer__WEBPACK_IMPORTED_MODULE_1__.BaseCellRenderer {
    render(params) {
        const actionsWidget = this.eGui.firstChild
            ? this.eGui.firstChild
            : document.createElement("agentx-wc-table-action-buttons");
        actionsWidget.buttons = this.getActionWidgetConfig(params.value.buttons, params.value.context);
        if (!this.eGui.firstChild) {
            this.eGui.appendChild(actionsWidget);
        }
    }
    onButtonClicked(eventName, context, option) {
        this.eGui.dispatchEvent(new CustomEvent(eventName, {
            composed: true,
            bubbles: true,
            detail: { context, option }
        }));
    }
    getActionWidgetConfig(buttons, context) {
        return buttons.map((button) => {
            return Object.assign(Object.assign({}, ActionButtonsIconsMap[button.type]), { id: button.type, options: button.options, onClick: (option) => this.onButtonClicked(ActionButtonsIconsMap[button.type].eventName, context, option) });
        });
    }
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/AgentName.ts":
/*!**********************************************************!*\
  !*** ./src/components/Common/CellRenderers/AgentName.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentNameCellRenderer: () => (/* binding */ AgentNameCellRenderer)
/* harmony export */ });
/* harmony import */ var _BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseCellRenderer */ "./src/components/Common/CellRenderers/BaseCellRenderer.ts");

class AgentNameCellRenderer extends _BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__.BaseCellRenderer {
    render(params) {
        const widget = this.eGui.firstChild
            ? this.eGui.firstChild
            : document.createElement("agentx-wc-table-agent-name");
        widget.name = params.data.agentName;
        // This Cell Renderer requires email column to be present in the grid
        widget.email = params.data.agentEmail;
        if (!this.eGui.firstChild) {
            this.eGui.appendChild(widget);
        }
    }
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/BaseCellRenderer.ts":
/*!*****************************************************************!*\
  !*** ./src/components/Common/CellRenderers/BaseCellRenderer.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   BaseCellRenderer: () => (/* binding */ BaseCellRenderer)
/* harmony export */ });
class BaseCellRenderer {
    constructor() {
        this.eGui = document.createElement("div");
    }
    init(params) {
        this.eGui.classList.add("cell-renderer");
        this.render(params);
    }
    refresh(params) {
        this.render(params);
        return true;
    }
    getGui() {
        return this.eGui;
    }
    destroy() {
        this.eGui.remove();
    }
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/Channel.ts":
/*!********************************************************!*\
  !*** ./src/components/Common/CellRenderers/Channel.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChannelCellRenderer: () => (/* binding */ ChannelCellRenderer)
/* harmony export */ });
/* harmony import */ var _BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseCellRenderer */ "./src/components/Common/CellRenderers/BaseCellRenderer.ts");

class ChannelCellRenderer extends _BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__.BaseCellRenderer {
    render(params) {
        this.eGui.classList.add("channel-type-renderer");
        const channelTypeWidget = this.eGui.firstChild
            ? this.eGui.firstChild
            : document.createElement("agentx-wc-table-channel");
        channelTypeWidget.channelType = params.value.channelType;
        if (!this.eGui.firstChild) {
            this.eGui.appendChild(channelTypeWidget);
        }
    }
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/CustomKeyboardNav.ts":
/*!******************************************************************!*\
  !*** ./src/components/Common/CellRenderers/CustomKeyboardNav.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CustomKeyboardNav: () => (/* binding */ CustomKeyboardNav),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var CustomKeyboardNav;
(function (CustomKeyboardNav) {
    function getDeepActiveElement() {
        var _a, _b;
        let host = (_a = document.activeElement) !== null && _a !== void 0 ? _a : document.body;
        while ((_b = host === null || host === void 0 ? void 0 : host.shadowRoot) === null || _b === void 0 ? void 0 : _b.activeElement) {
            host = host.shadowRoot.activeElement;
        }
        return host;
    }
    CustomKeyboardNav.getDeepActiveElement = getDeepActiveElement;
    function isElementFocusable(element) {
        if (element.tabIndex < 0 || element.style.visibility === "hidden" || element.style.display === "none") {
            return false;
        }
        const focusableTags = ["A", "BUTTON", "INPUT", "TEXTAREA", "SELECT"];
        if (focusableTags.includes(element.tagName)) {
            return true;
        }
        return element.hasAttribute("tabindex") || element.isContentEditable;
    }
    function getFocusableElements(root) {
        var _a, _b;
        if (isElementFocusable(root)) {
            return [root];
        }
        const focusableElements = [];
        const children = [...((_b = (_a = root.shadowRoot) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : []), ...root.children];
        children.forEach((child) => {
            if (isElementFocusable(child)) {
                focusableElements.push(child);
            }
            else {
                focusableElements.push(...getFocusableElements(child));
            }
        });
        return focusableElements;
    }
    CustomKeyboardNav.getFocusableElements = getFocusableElements;
    function getFocusedElementIndex(elements) {
        if (elements) {
            const activeElement = getDeepActiveElement();
            return elements.findIndex((element) => {
                return element === activeElement;
            });
        }
        return -1;
    }
    function focusNext(root) {
        var _a;
        const elements = getFocusableElements(root);
        const length = (_a = elements.length) !== null && _a !== void 0 ? _a : 0;
        if (length > 0) {
            const nextIndex = getFocusedElementIndex(elements) + 1;
            if (nextIndex < length) {
                elements[nextIndex].focus();
                return true;
            }
        }
        return false;
    }
    CustomKeyboardNav.focusNext = focusNext;
    function focusPrevious(root) {
        var _a;
        const elements = getFocusableElements(root);
        const length = (_a = elements === null || elements === void 0 ? void 0 : elements.length) !== null && _a !== void 0 ? _a : 0;
        if (length > 0) {
            const index = getFocusedElementIndex(elements);
            if (index === -1) {
                elements[length - 1].focus();
                return true;
            }
            else if (index > 0) {
                elements[index - 1].focus();
                return true;
            }
        }
        return false;
    }
    CustomKeyboardNav.focusPrevious = focusPrevious;
})(CustomKeyboardNav || (CustomKeyboardNav = {}));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomKeyboardNav);


/***/ }),

/***/ "./src/components/Common/CellRenderers/Duration.ts":
/*!*********************************************************!*\
  !*** ./src/components/Common/CellRenderers/Duration.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DurationCellRenderer: () => (/* binding */ DurationCellRenderer)
/* harmony export */ });
/* harmony import */ var _BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseCellRenderer */ "./src/components/Common/CellRenderers/BaseCellRenderer.ts");

class DurationCellRenderer extends _BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__.BaseCellRenderer {
    render(params) {
        const durationWidget = this.eGui.firstChild
            ? this.eGui.firstChild
            : document.createElement("agentx-wc-table-duration");
        durationWidget.duration = params.value.duration;
        durationWidget.createdTime = params.value.createdTime;
        durationWidget.isActive = params.value.active;
        if (!this.eGui.firstChild) {
            this.eGui.appendChild(durationWidget);
        }
    }
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/InteractionsListItem.ts":
/*!*********************************************************************!*\
  !*** ./src/components/Common/CellRenderers/InteractionsListItem.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsListItemCellRenderer: () => (/* binding */ InteractionsListItemCellRenderer)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _BaseCellRenderer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./BaseCellRenderer */ "./src/components/Common/CellRenderers/BaseCellRenderer.ts");


class InteractionsListItemCellRenderer extends _BaseCellRenderer__WEBPACK_IMPORTED_MODULE_1__.BaseCellRenderer {
    render(params) {
        const listItemWidget = this.eGui.firstChild
            ? this.eGui.firstChild
            : document.createElement("agentx-wc-table-listitem");
        listItemWidget.channelType = params.value.channelType;
        listItemWidget.primaryLabel = params.value.customerId;
        listItemWidget.secondRowTimer = params.value.timer.duration;
        listItemWidget.isSecondRowTimerActive = params.value.timer.isActive;
        switch (params.value.selectedTab) {
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.InteractionsServiceConstants.QueryType.Active:
                listItemWidget.secondRowLeft = params.value.agentName;
                listItemWidget.thirdRowLeft = params.value.queueName;
                listItemWidget.thirdRowRight = params.value.teamName;
                break;
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.InteractionsServiceConstants.QueryType.Queued:
                listItemWidget.secondRowLeft = params.value.queueName;
                listItemWidget.thirdRowLeft = params.value.message;
                break;
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.InteractionsServiceConstants.QueryType.Completed:
                listItemWidget.secondRowLeft = params.value.agentName;
                listItemWidget.thirdRowLeft = params.value.queueName;
                listItemWidget.thirdRowRight = params.value.wrapupCode;
                break;
        }
        if (!this.eGui.firstChild) {
            this.eGui.appendChild(listItemWidget);
        }
    }
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/QueueStatsListItem.ts":
/*!*******************************************************************!*\
  !*** ./src/components/Common/CellRenderers/QueueStatsListItem.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueueStatsListItemCellRenderer: () => (/* binding */ QueueStatsListItemCellRenderer)
/* harmony export */ });
/* harmony import */ var _BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseCellRenderer */ "./src/components/Common/CellRenderers/BaseCellRenderer.ts");

const WAITING_IN_QUEUE = "Waiting in queue: ";
const AVG_WAIT_TIME = "Avg Wait time: ";
class QueueStatsListItemCellRenderer extends _BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__.BaseCellRenderer {
    render(params) {
        const listItemWidget = this.eGui.firstChild
            ? this.eGui.firstChild
            : document.createElement("agentx-wc-table-listitem");
        listItemWidget.channelType = params.value.channelType;
        listItemWidget.primaryLabel = params.value.queueName;
        listItemWidget.secondRowLeft = WAITING_IN_QUEUE + params.value.waitingInQueue;
        listItemWidget.thirdRowLeft = AVG_WAIT_TIME;
        listItemWidget.thirdRowTimer = params.value.avgWaitTime;
        if (!this.eGui.firstChild) {
            this.eGui.appendChild(listItemWidget);
        }
    }
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/Sentiment.ts":
/*!**********************************************************!*\
  !*** ./src/components/Common/CellRenderers/Sentiment.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SentimentCellRenderer: () => (/* binding */ SentimentCellRenderer)
/* harmony export */ });
/* harmony import */ var _BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseCellRenderer */ "./src/components/Common/CellRenderers/BaseCellRenderer.ts");

const NEUTRAL_COLOR = "neutral";
const NEUTRAL_ICON = "emoji-passive-filled";
class SentimentCellRenderer extends _BaseCellRenderer__WEBPACK_IMPORTED_MODULE_0__.BaseCellRenderer {
    render(params) {
        var _a;
        const sentimentWidget = this.eGui.firstChild
            ? this.eGui.firstChild
            : document.createElement("agentx-wc-table-sentiment");
        sentimentWidget.icon = NEUTRAL_ICON;
        sentimentWidget.color = NEUTRAL_COLOR;
        sentimentWidget.text = (_a = params.valueFormatted) !== null && _a !== void 0 ? _a : params.value;
        if (!this.eGui.firstChild) {
            this.eGui.appendChild(sentimentWidget);
        }
    }
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/Utils.ts":
/*!******************************************************!*\
  !*** ./src/components/Common/CellRenderers/Utils.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   agentNameComparator: () => (/* binding */ agentNameComparator),
/* harmony export */   naturalStringComparator: () => (/* binding */ naturalStringComparator)
/* harmony export */ });
function naturalStringComparator(valueA, valueB) {
    return valueA.localeCompare(valueB, undefined, { numeric: true, sensitivity: "base" });
}
function agentNameComparator(valueA, valueB) {
    return naturalStringComparator(valueA.name, valueB.name);
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableActionButtonsElement.scss":
/*!***************************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableActionButtonsElement.scss ***!
  \***************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 4px 0;
  width: 100%;
  height: 100%;
}

md-button {
  display: flex;
}

.options-list {
  padding-top: 8px;
  padding-bottom: 8px;
}

md-list-item {
  padding: 0.25rem 0.5rem;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/CellRenderers/components/TableActionButtonsElement.scss */
/*# sourceURL=TableActionButtonsElement.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvQ29tbW9uL0NlbGxSZW5kZXJlcnMvY29tcG9uZW50cy9UYWJsZUFjdGlvbkJ1dHRvbnNFbGVtZW50LnNjc3MiLCJUYWJsZUFjdGlvbkJ1dHRvbnNFbGVtZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxhQUFBO0VBQ0EsbUJBQUE7RUFDQSxtQkFBQTtFQUNBLDJCQUFBO0VBQ0EsUUFBQTtFQUNBLGNBQUE7RUFDQSxXQUFBO0VBQ0EsWUFBQTtBQ0NGOztBREVBO0VBQ0UsYUFBQTtBQ0NGOztBREVBO0VBQ0UsZ0JBQUE7RUFDQSxtQkFBQTtBQ0NGOztBREVBO0VBQ0UsdUJBQUE7QUNDRiIsImZpbGUiOiJUYWJsZUFjdGlvbkJ1dHRvbnNFbGVtZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogZmxleC1zdGFydDtcbiAgZ2FwOiA4cHg7XG4gIHBhZGRpbmc6IDRweCAwO1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xufVxuXG5tZC1idXR0b24ge1xuICBkaXNwbGF5OiBmbGV4O1xufVxuXG4ub3B0aW9ucy1saXN0IHtcbiAgcGFkZGluZy10b3A6IDhweDtcbiAgcGFkZGluZy1ib3R0b206IDhweDtcbn1cblxubWQtbGlzdC1pdGVtIHtcbiAgcGFkZGluZzogMC4yNXJlbSAwLjVyZW07XG59XG4iLCI6aG9zdCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogZmxleC1zdGFydDtcbiAgZ2FwOiA4cHg7XG4gIHBhZGRpbmc6IDRweCAwO1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xufVxuXG5tZC1idXR0b24ge1xuICBkaXNwbGF5OiBmbGV4O1xufVxuXG4ub3B0aW9ucy1saXN0IHtcbiAgcGFkZGluZy10b3A6IDhweDtcbiAgcGFkZGluZy1ib3R0b206IDhweDtcbn1cblxubWQtbGlzdC1pdGVtIHtcbiAgcGFkZGluZzogMC4yNXJlbSAwLjVyZW07XG59Il19 */`);
    

/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableActionButtonsElement.ts":
/*!*************************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableActionButtonsElement.ts ***!
  \*************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableActionButtonsElement: () => (/* binding */ TableActionButtonsElement)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _TableActionButtonsElement_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./TableActionButtonsElement.scss */ "./src/components/Common/CellRenderers/components/TableActionButtonsElement.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let TableActionButtonsElement = class TableActionButtonsElement extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.buttons = [];
        this._expanded = false;
        this.onClickListOption = (button, option) => {
            var _a;
            this.menuOverlay.isOpen = false;
            (_a = button.onClick) === null || _a === void 0 ? void 0 : _a.call(button, option);
        };
    }
    static get styles() {
        return _TableActionButtonsElement_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    // Every top element should have a class "top-element" to be able to focus on it
    renderSingleIcon(button) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <md-button
        id="${button.id}"
        ariaLabel="${button.ariaLabel ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(button.ariaLabel) : ""}"
        @click=${() => { var _a; return (_a = button.onClick) === null || _a === void 0 ? void 0 : _a.call(button); }}
        size="28"
        circle
        ?outline=${button.outline}
      >
        <md-icon slot="icon" name="${button.icon}" iconSet="momentumDesign"></md-icon>
      </md-button>
    `;
    }
    renderOptionsList(button) {
        var _a;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <md-list>
        ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_2__.repeat)((_a = button.options) !== null && _a !== void 0 ? _a : [], (option) => option, (option) => (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
            <md-list-item slot="list-item" @click=${() => this.onClickListOption(button, option)}
              >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(option)}</md-list-item
            >
          `)}
      </md-list>
    `;
    }
    renderDropDownIcon(button) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <md-menu-overlay
        id="menu-overlay"
        size="small"
        show-arrow
        @menu-overlay-open=${() => {
            this._expanded = true;
        }}
        @menu-overlay-close=${() => {
            this._expanded = false;
        }}
      >
        <md-button
          slot="menu-trigger"
          id="${button.id}"
          ariaLabel="${button.ariaLabel ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(button.ariaLabel) : ""}"
          size="28"
          ?outline=${button.outline}
        >
          <md-icon slot="icon" name="${button.icon}" iconSet="momentumDesign"></md-icon>
          <md-icon
            slot="icon"
            name="${this._expanded ? "arrow-up-bold" : "arrow-down-bold"}"
            iconSet="momentumDesign"
          ></md-icon>
        </md-button>

        <div class="options-list">${this._expanded ? this.renderOptionsList(button) : (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ``}</div>
      </md-menu-overlay>
    `;
    }
    renderLabelButton(button) {
        var _a;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <md-link
        tag="a"
        inline
        inline-style="default"
        @click=${(e) => {
            var _a;
            e.preventDefault();
            (_a = button.onClick) === null || _a === void 0 ? void 0 : _a.call(button);
        }}
        aria-label="${button.ariaLabel ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(button.ariaLabel) : ""}"
      >
        ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)((_a = button.label) !== null && _a !== void 0 ? _a : "")}
      </md-link>
    `;
    }
    renderButton(button) {
        var _a, _b;
        if (button.icon) {
            const hasMoreOptions = (_b = (_a = button.options) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0 > 1;
            if (!hasMoreOptions) {
                return this.renderSingleIcon(button);
            }
            else {
                return this.renderDropDownIcon(button);
            }
        }
        else if (button.label) {
            return this.renderLabelButton(button);
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ``;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_2__.repeat)(this.buttons, (button) => button.id, (button) => this.renderButton(button))}
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Array })
], TableActionButtonsElement.prototype, "buttons", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
], TableActionButtonsElement.prototype, "_expanded", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.query)("#menu-overlay")
], TableActionButtonsElement.prototype, "menuOverlay", void 0);
TableActionButtonsElement = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-table-action-buttons")
], TableActionButtonsElement);



/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableAgentNameElement.scss":
/*!***********************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableAgentNameElement.scss ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: block;
  height: 100%;
}

.container {
  display: flex;
  height: 100%;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}

.label {
  display: flex;
  align-items: center;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/CellRenderers/components/TableAgentNameElement.scss */
/*# sourceURL=TableAgentNameElement.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvQ29tbW9uL0NlbGxSZW5kZXJlcnMvY29tcG9uZW50cy9UYWJsZUFnZW50TmFtZUVsZW1lbnQuc2NzcyIsIlRhYmxlQWdlbnROYW1lRWxlbWVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsY0FBQTtFQUNBLFlBQUE7QUNDRjs7QURFQTtFQUNFLGFBQUE7RUFDQSxZQUFBO0VBQ0EscUJBQUE7RUFDQSxtQkFBQTtFQUNBLDJCQUFBO0VBQ0EsUUFBQTtBQ0NGOztBREVBO0VBQ0UsYUFBQTtFQUNBLG1CQUFBO0FDQ0YiLCJmaWxlIjoiVGFibGVBZ2VudE5hbWVFbGVtZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBoZWlnaHQ6IDEwMCU7XG59XG5cbi5jb250YWluZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBoZWlnaHQ6IDEwMCU7XG4gIGZsZXgtZmxvdzogcm93IG5vd3JhcDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBmbGV4LXN0YXJ0O1xuICBnYXA6IDhweDtcbn1cblxuLmxhYmVsIHtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbn1cbiIsIjpob3N0IHtcbiAgZGlzcGxheTogYmxvY2s7XG4gIGhlaWdodDogMTAwJTtcbn1cblxuLmNvbnRhaW5lciB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGhlaWdodDogMTAwJTtcbiAgZmxleC1mbG93OiByb3cgbm93cmFwO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtc3RhcnQ7XG4gIGdhcDogOHB4O1xufVxuXG4ubGFiZWwge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xufSJdfQ== */`);
    

/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableAgentNameElement.ts":
/*!*********************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableAgentNameElement.ts ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableAgentNameElement: () => (/* binding */ TableAgentNameElement)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _TableAgentNameElement_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./TableAgentNameElement.scss */ "./src/components/Common/CellRenderers/components/TableAgentNameElement.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};






let TableAgentNameElement = class TableAgentNameElement extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
    constructor() {
        super(...arguments);
        this.name = null;
        this.email = "";
    }
    static get styles() {
        return _TableAgentNameElement_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
    }
    update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has("email")) {
            this.fetchAvatarUrl();
        }
    }
    connectedCallback() {
        super.connectedCallback();
        this.fetchAvatarUrl();
    }
    fetchAvatarUrl() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.email && this.email.length > 0) {
                try {
                    this.avatarUrl = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.avatar.getAvatarUrl(this.email);
                }
                catch (err) {
                    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[TableAgentNameElement] error: ", err);
                }
            }
        });
    }
    render() {
        if (this.name !== null) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <div class="container">
        <md-avatar size="24" alt="${this.name}" title="${this.name}" src="${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(this.avatarUrl)}"></md-avatar>
        <div class="label">
          <md-label aria-label="${this.name}">${this.name}</md-label>
        </div>
      </div>`;
        }
        else {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ``;
        }
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], TableAgentNameElement.prototype, "name", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], TableAgentNameElement.prototype, "email", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], TableAgentNameElement.prototype, "avatarUrl", void 0);
TableAgentNameElement = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-table-agent-name")
], TableAgentNameElement);



/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableChannelElement.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableChannelElement.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableChannelElement: () => (/* binding */ TableChannelElement)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let TableChannelElement = class TableChannelElement extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.channelType = "";
        this.text = "";
    }
    render() {
        return this.channelType !== ""
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<md-avatar type="${this.channelType}" avatar-style="table"></md-avatar>`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableChannelElement.prototype, "channelType", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableChannelElement.prototype, "text", void 0);
TableChannelElement = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-table-channel")
], TableChannelElement);



/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableDurationElement.scss":
/*!**********************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableDurationElement.scss ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  gap: 8px;
  padding: 4px 12px;
  width: 100%;
  height: 100%;
}

:host([no-padding]) {
  padding: 0;
}

div {
  font-weight: 500;
  font-size: 14px;
  padding: 0px;
  margin: 0px;
  line-height: 20px;
  flex-grow: 1;
  color: var(--md-secondary-text-color);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/CellRenderers/components/TableDurationElement.scss */
/*# sourceURL=TableDurationElement.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvQ29tbW9uL0NlbGxSZW5kZXJlcnMvY29tcG9uZW50cy9UYWJsZUR1cmF0aW9uRWxlbWVudC5zY3NzIiwiVGFibGVEdXJhdGlvbkVsZW1lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQUE7RUFDQSxtQkFBQTtFQUNBLG1CQUFBO0VBQ0EscUJBQUE7RUFDQSxRQUFBO0VBQ0EsaUJBQUE7RUFDQSxXQUFBO0VBQ0EsWUFBQTtBQ0NGOztBREVBO0VBQ0UsVUFBQTtBQ0NGOztBREVBO0VBQ0UsZ0JBQUE7RUFDQSxlQUFBO0VBQ0EsWUFBQTtFQUNBLFdBQUE7RUFDQSxpQkFBQTtFQUNBLFlBQUE7RUFDQSxxQ0FBQTtBQ0NGIiwiZmlsZSI6IlRhYmxlRHVyYXRpb25FbGVtZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogbGVmdDtcbiAgZ2FwOiA4cHg7XG4gIHBhZGRpbmc6IDRweCAxMnB4O1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xufVxuXG46aG9zdChbbm8tcGFkZGluZ10pIHtcbiAgcGFkZGluZzogMDtcbn1cblxuZGl2IHtcbiAgZm9udC13ZWlnaHQ6IDUwMDtcbiAgZm9udC1zaXplOiAxNHB4O1xuICBwYWRkaW5nOiAwcHg7XG4gIG1hcmdpbjogMHB4O1xuICBsaW5lLWhlaWdodDogMjBweDtcbiAgZmxleC1ncm93OiAxO1xuICBjb2xvcjogdmFyKC0tbWQtc2Vjb25kYXJ5LXRleHQtY29sb3IpO1xufVxuIiwiOmhvc3Qge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGxlZnQ7XG4gIGdhcDogOHB4O1xuICBwYWRkaW5nOiA0cHggMTJweDtcbiAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogMTAwJTtcbn1cblxuOmhvc3QoW25vLXBhZGRpbmddKSB7XG4gIHBhZGRpbmc6IDA7XG59XG5cbmRpdiB7XG4gIGZvbnQtd2VpZ2h0OiA1MDA7XG4gIGZvbnQtc2l6ZTogMTRweDtcbiAgcGFkZGluZzogMHB4O1xuICBtYXJnaW46IDBweDtcbiAgbGluZS1oZWlnaHQ6IDIwcHg7XG4gIGZsZXgtZ3JvdzogMTtcbiAgY29sb3I6IHZhcigtLW1kLXNlY29uZGFyeS10ZXh0LWNvbG9yKTtcbn0iXX0= */`);
    

/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableDurationElement.ts":
/*!********************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableDurationElement.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableDurationElement: () => (/* binding */ TableDurationElement)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _TableDurationElement_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./TableDurationElement.scss */ "./src/components/Common/CellRenderers/components/TableDurationElement.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




const ICON_COLOR = "var(--md-secondary-text-color)";
const DURATION_DISPLAY_FORMAT = "hh:mm:ss";
const ICON_TIMER = "recents-presence-filled";
let TableDurationElement = class TableDurationElement extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.duration = 0;
        this.createdTime = 0;
        this.isActive = false;
        this.hideTimerIcon = false;
        this.visibleDuration = "";
    }
    static get styles() {
        return _TableDurationElement_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    updated(changedProperties) {
        if (changedProperties.has("duration") ||
            changedProperties.has("createdTime") ||
            changedProperties.has("isActive") ||
            changedProperties.has("hideTimerIcon")) {
            this.initializeProperties();
        }
        super.updated(changedProperties);
    }
    renderIcon() {
        if (this.hideTimerIcon) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ``;
        }
        else {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<md-icon name="${ICON_TIMER}" iconSet="momentumDesign" size="16" color="${ICON_COLOR}"></md-icon>`;
        }
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      ${this.renderIcon()}
      <div>${this.visibleDuration}</div>
    `;
    }
    updateProperties(duration) {
        this.visibleDuration = luxon__WEBPACK_IMPORTED_MODULE_2__.Duration.fromMillis(duration).toFormat(DURATION_DISPLAY_FORMAT);
    }
    initializeProperties() {
        if (!this.isActive) {
            this.updateProperties(this.duration);
        }
        else {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = undefined;
            }
            this.updateProperties(Date.now() - this.createdTime);
            this.intervalId = window.setInterval(() => {
                this.updateProperties(Date.now() - this.createdTime);
            }, 1000);
        }
    }
    connectedCallback() {
        super.connectedCallback();
        this.initializeProperties();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = undefined;
        }
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], TableDurationElement.prototype, "duration", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], TableDurationElement.prototype, "createdTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], TableDurationElement.prototype, "isActive", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], TableDurationElement.prototype, "hideTimerIcon", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
], TableDurationElement.prototype, "intervalId", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
], TableDurationElement.prototype, "visibleDuration", void 0);
TableDurationElement = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-table-duration")
], TableDurationElement);



/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableListItemElement.scss":
/*!**********************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableListItemElement.scss ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  font-family: var(--font-family, var(--brand-font-regular));
  width: 100%;
}

.container {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  height: 100%;
  width: 100%;
  min-width: 60px;
  padding: 8px 0px;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px; /* Icon placeholder width, actual icon will be 16x16 */
  height: 100%;
  margin-right: 12px;
  flex-shrink: 0;
}

.text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-width: 0px;
}
.text-container .primary-label {
  font-size: var(--font-size-large, 16px);
  color: var(--md-primary-text-color);
  line-height: 24px;
  font-weight: 500;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  max-width: 90%;
}
.text-container .primary-label[data-selected=true] {
  font-family: var(--brand-font-bold, "CiscoSansTT Bold");
  font-weight: 700;
}
.text-container .secondary-label,
.text-container .tertiary-label {
  font-size: 14px;
  font-weight: 400;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
  max-width: 90%;
  color: var(--md-secondary-text-color);
  line-height: 20px;
  gap: 5px;
}
.text-container .separator {
  color: var(--md-secondary-text-color);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/CellRenderers/components/TableListItemElement.scss */
/*# sourceURL=TableListItemElement.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableListItemElement.ts":
/*!********************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableListItemElement.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableListItemElement: () => (/* binding */ TableListItemElement)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _TableListItemElement_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TableListItemElement.scss */ "./src/components/Common/CellRenderers/components/TableListItemElement.scss");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




const SEPARATOR = "•";
let TableListItemElement = class TableListItemElement extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.channelType = "";
        this.primaryLabel = "";
        this.secondRowLeft = "";
        this.isSecondRowTimerActive = false;
        this.thirdRowLeft = "";
        this.isThirdRowTimerActive = false;
    }
    static get styles() {
        return _TableListItemElement_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
    }
    renderIcon() {
        return this.channelType !== ""
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<md-avatar type="${this.channelType}" avatar-style="default"></md-avatar>`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`;
    }
    renderDuration(duration, isActive) {
        return duration === undefined
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<agentx-wc-table-duration
          no-padding
          duration=${duration}
          ?isActive=${isActive}
          ?hideTimerIcon=${true}
        ></agentx-wc-table-duration>`;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <li class="container">
        <div class="icon-container">${this.renderIcon()}</div>
        <div class="text-container">
          <div class="primary-label">${this.primaryLabel}</div>
          <div class="secondary-label">
            ${this.secondRowLeft}
            ${this.secondRowTimer !== undefined ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<div class="separator">${SEPARATOR}</div>` : (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`}
            ${this.renderDuration(this.secondRowTimer, this.isSecondRowTimerActive)}
          </div>
          <div class="tertiary-label">
            ${this.thirdRowLeft}
            ${this.thirdRowRight !== undefined
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<div class="separator">${SEPARATOR}</div>
                  ${this.thirdRowRight}`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`}
            ${this.renderDuration(this.thirdRowTimer, this.isThirdRowTimerActive)}
          </div>
        </div>
      </li>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableListItemElement.prototype, "channelType", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableListItemElement.prototype, "primaryLabel", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableListItemElement.prototype, "secondRowLeft", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], TableListItemElement.prototype, "secondRowTimer", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], TableListItemElement.prototype, "isSecondRowTimerActive", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableListItemElement.prototype, "thirdRowLeft", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableListItemElement.prototype, "thirdRowRight", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], TableListItemElement.prototype, "thirdRowTimer", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], TableListItemElement.prototype, "isThirdRowTimerActive", void 0);
TableListItemElement = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-table-listitem")
], TableListItemElement);



/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableSentimentElement.scss":
/*!***********************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableSentimentElement.scss ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
}

md-chip {
  display: flex;
}
md-chip::part(chip) {
  display: flex;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/CellRenderers/components/TableSentimentElement.scss */
/*# sourceURL=TableSentimentElement.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvQ29tbW9uL0NlbGxSZW5kZXJlcnMvY29tcG9uZW50cy9UYWJsZVNlbnRpbWVudEVsZW1lbnQuc2NzcyIsIlRhYmxlU2VudGltZW50RWxlbWVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLG1CQUFBO0VBQ0EsWUFBQTtFQUNBLFdBQUE7QUNDRjs7QURFQTtFQUNFLGFBQUE7QUNDRjtBRENFO0VBQ0UsYUFBQTtBQ0NKIiwiZmlsZSI6IlRhYmxlU2VudGltZW50RWxlbWVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3Qge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBoZWlnaHQ6IDEwMCU7XG4gIHdpZHRoOiAxMDAlO1xufVxuXG5tZC1jaGlwIHtcbiAgZGlzcGxheTogZmxleDtcblxuICAmOjpwYXJ0KGNoaXApIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICB9XG59XG4iLCI6aG9zdCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGhlaWdodDogMTAwJTtcbiAgd2lkdGg6IDEwMCU7XG59XG5cbm1kLWNoaXAge1xuICBkaXNwbGF5OiBmbGV4O1xufVxubWQtY2hpcDo6cGFydChjaGlwKSB7XG4gIGRpc3BsYXk6IGZsZXg7XG59Il19 */`);
    

/***/ }),

/***/ "./src/components/Common/CellRenderers/components/TableSentimentElement.ts":
/*!*********************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/components/TableSentimentElement.ts ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableSentimentElement: () => (/* binding */ TableSentimentElement)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _TableSentimentElement_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./TableSentimentElement.scss */ "./src/components/Common/CellRenderers/components/TableSentimentElement.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let TableSentimentElement = class TableSentimentElement extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.color = "";
    }
    static get styles() {
        return _TableSentimentElement_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    renderIcon() {
        if (this.icon && this.icon !== "") {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<md-icon
        name="${this.icon}"
        size="16"
        iconSet="momentumDesign"
        slot="custom-left-content"
      ></md-icon>`;
        }
        else {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`;
        }
    }
    render() {
        if (this.text) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ` <md-chip value="${this.text}" color="${this.color}" small> ${this.renderIcon()} </md-chip> `;
        }
        else {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}`;
        }
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableSentimentElement.prototype, "icon", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableSentimentElement.prototype, "text", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], TableSentimentElement.prototype, "color", void 0);
TableSentimentElement = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-table-sentiment")
], TableSentimentElement);



/***/ }),

/***/ "./src/components/Common/CellRenderers/constants/channel.ts":
/*!******************************************************************!*\
  !*** ./src/components/Common/CellRenderers/constants/channel.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CHANNEL_TYPE_TO_ICON_MAP: () => (/* binding */ CHANNEL_TYPE_TO_ICON_MAP)
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./types */ "./src/components/Common/CellRenderers/constants/types.ts");

const CHANNEL_TYPE_TO_ICON_MAP = {
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelTypes.Telephony]: "channel-call",
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelTypes.Chat]: "channel-chat",
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelTypes.Email]: "channel-email-inbound",
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelSubTypes.Facebook]: "channel-fb-messenger",
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelSubTypes.Twitter]: "channel-twitter-x",
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelSubTypes.SMS]: "channel-sms-inbound",
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelSubTypes.WhatsApp]: "channel-whats-app",
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelSubTypes.AppleMessages]: "channel-apple-chat",
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelSubTypes.RCS]: "channel-we-chat",
    [_types__WEBPACK_IMPORTED_MODULE_0__.ChannelTypes.Social]: "channel-custom"
};


/***/ }),

/***/ "./src/components/Common/CellRenderers/constants/types.ts":
/*!****************************************************************!*\
  !*** ./src/components/Common/CellRenderers/constants/types.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ActionButtons: () => (/* binding */ ActionButtons),
/* harmony export */   ChannelSubTypes: () => (/* binding */ ChannelSubTypes),
/* harmony export */   ChannelTypes: () => (/* binding */ ChannelTypes),
/* harmony export */   InteractionsTab: () => (/* binding */ InteractionsTab)
/* harmony export */ });
var ChannelTypes;
(function (ChannelTypes) {
    ChannelTypes["Telephony"] = "telephony";
    ChannelTypes["Chat"] = "chat";
    ChannelTypes["Email"] = "email";
    ChannelTypes["Social"] = "social";
})(ChannelTypes || (ChannelTypes = {}));
var ChannelSubTypes;
(function (ChannelSubTypes) {
    ChannelSubTypes["Facebook"] = "facebook";
    ChannelSubTypes["Twitter"] = "twitter";
    ChannelSubTypes["SMS"] = "sms";
    ChannelSubTypes["WhatsApp"] = "whatsapp";
    ChannelSubTypes["AppleMessages"] = "appleMessages";
    ChannelSubTypes["RCS"] = "rcs";
    // ...
})(ChannelSubTypes || (ChannelSubTypes = {}));
var ActionButtons;
(function (ActionButtons) {
    ActionButtons["view"] = "view";
    ActionButtons["hearing"] = "hearing";
    ActionButtons["more"] = "more";
    ActionButtons["download"] = "download";
    ActionButtons["actions"] = "actions";
})(ActionButtons || (ActionButtons = {}));
var InteractionsTab;
(function (InteractionsTab) {
    InteractionsTab["Active"] = "Active";
    InteractionsTab["Queued"] = "Queued";
    InteractionsTab["Completed"] = "Completed";
})(InteractionsTab || (InteractionsTab = {}));


/***/ }),

/***/ "./src/components/Common/CellRenderers/filters/TimestampFilter.ts":
/*!************************************************************************!*\
  !*** ./src/components/Common/CellRenderers/filters/TimestampFilter.ts ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TimestampFilter: () => (/* binding */ TimestampFilter)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");

class TimestampFilter {
    constructor() {
        this.filterValue = null;
    }
    init(params) {
        this.params = params;
    }
    getGui() {
        const container = document.createElement("div");
        const options = [
            { label: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats:underOneMinute")}`, value: "under_1_minute" },
            { label: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats:oneToFiveMinutes")}`, value: "1_5_minutes" },
            { label: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats:fiveToTenMinutes")}`, value: "5_15_minutes" },
            { label: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats:overFifteenMinutes")}`, value: "over_15_minutes" }
        ];
        const name = `timestampFilter_${this.params.colDef.field}`;
        options.forEach((option) => {
            const label = document.createElement("label");
            const input = document.createElement("input");
            input.type = "radio";
            input.name = name;
            input.value = option.value;
            input.style.marginBottom = "10px";
            input.style.marginRight = "5px";
            input.style.marginLeft = "10px";
            input.checked = this.filterValue === option.value;
            input.classList.add("ag-input-field-input");
            input.addEventListener("click", (event) => {
                const target = event.target;
                if (this.filterValue === target.value) {
                    target.checked = false;
                    this.filterValue = null;
                }
                else {
                    this.filterValue = target.value;
                }
                this.params.filterChangedCallback();
            });
            label.appendChild(input);
            label.appendChild(document.createTextNode(option.label));
            container.appendChild(label);
            container.appendChild(document.createElement("br"));
        });
        return container;
    }
    doesFilterPass(params) {
        if (this.filterValue === null) {
            return true;
        }
        const field = this.params.colDef.field;
        const value = field ? params.data[field] : undefined;
        switch (this.filterValue) {
            case "under_1_minute":
                return value < 60 * 1000;
            case "1_5_minutes":
                return value >= 60 * 1000 && value <= 5 * 60 * 1000;
            case "5_15_minutes":
                return value > 5 * 60 * 1000 && value <= 15 * 60 * 1000;
            case "over_15_minutes":
                return value > 15 * 60 * 1000;
            default:
                return true;
        }
    }
    isFilterActive() {
        return this.filterValue !== null;
    }
    getModel() {
        return this.filterValue !== null ? { value: this.filterValue } : null;
    }
    setModel(model) {
        this.filterValue = model ? model.value : null;
    }
}


/***/ }),

/***/ "./src/components/Common/CellRenderers/index.ts":
/*!******************************************************!*\
  !*** ./src/components/Common/CellRenderers/index.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ActionButtonsCellRenderer: () => (/* reexport safe */ _ActionButtons__WEBPACK_IMPORTED_MODULE_0__.ActionButtonsCellRenderer),
/* harmony export */   AgentNameCellRenderer: () => (/* reexport safe */ _AgentName__WEBPACK_IMPORTED_MODULE_1__.AgentNameCellRenderer),
/* harmony export */   ChannelCellRenderer: () => (/* reexport safe */ _Channel__WEBPACK_IMPORTED_MODULE_2__.ChannelCellRenderer),
/* harmony export */   DurationCellRenderer: () => (/* reexport safe */ _Duration__WEBPACK_IMPORTED_MODULE_9__.DurationCellRenderer),
/* harmony export */   InteractionsListItemCellRenderer: () => (/* reexport safe */ _InteractionsListItem__WEBPACK_IMPORTED_MODULE_10__.InteractionsListItemCellRenderer),
/* harmony export */   QueueStatsListItemCellRenderer: () => (/* reexport safe */ _QueueStatsListItem__WEBPACK_IMPORTED_MODULE_11__.QueueStatsListItemCellRenderer),
/* harmony export */   SentimentCellRenderer: () => (/* reexport safe */ _Sentiment__WEBPACK_IMPORTED_MODULE_12__.SentimentCellRenderer),
/* harmony export */   TableActionButtonsElement: () => (/* reexport safe */ _components_TableActionButtonsElement__WEBPACK_IMPORTED_MODULE_3__.TableActionButtonsElement),
/* harmony export */   TableAgentNameElement: () => (/* reexport safe */ _components_TableAgentNameElement__WEBPACK_IMPORTED_MODULE_4__.TableAgentNameElement),
/* harmony export */   TableChannelElement: () => (/* reexport safe */ _components_TableChannelElement__WEBPACK_IMPORTED_MODULE_5__.TableChannelElement),
/* harmony export */   TableDurationElement: () => (/* reexport safe */ _components_TableDurationElement__WEBPACK_IMPORTED_MODULE_6__.TableDurationElement),
/* harmony export */   TableListItemElement: () => (/* reexport safe */ _components_TableListItemElement__WEBPACK_IMPORTED_MODULE_7__.TableListItemElement),
/* harmony export */   TableSentimentElement: () => (/* reexport safe */ _components_TableSentimentElement__WEBPACK_IMPORTED_MODULE_8__.TableSentimentElement)
/* harmony export */ });
/* harmony import */ var _ActionButtons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ActionButtons */ "./src/components/Common/CellRenderers/ActionButtons.ts");
/* harmony import */ var _AgentName__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AgentName */ "./src/components/Common/CellRenderers/AgentName.ts");
/* harmony import */ var _Channel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Channel */ "./src/components/Common/CellRenderers/Channel.ts");
/* harmony import */ var _components_TableActionButtonsElement__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/TableActionButtonsElement */ "./src/components/Common/CellRenderers/components/TableActionButtonsElement.ts");
/* harmony import */ var _components_TableAgentNameElement__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/TableAgentNameElement */ "./src/components/Common/CellRenderers/components/TableAgentNameElement.ts");
/* harmony import */ var _components_TableChannelElement__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./components/TableChannelElement */ "./src/components/Common/CellRenderers/components/TableChannelElement.ts");
/* harmony import */ var _components_TableDurationElement__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./components/TableDurationElement */ "./src/components/Common/CellRenderers/components/TableDurationElement.ts");
/* harmony import */ var _components_TableListItemElement__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./components/TableListItemElement */ "./src/components/Common/CellRenderers/components/TableListItemElement.ts");
/* harmony import */ var _components_TableSentimentElement__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./components/TableSentimentElement */ "./src/components/Common/CellRenderers/components/TableSentimentElement.ts");
/* harmony import */ var _Duration__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Duration */ "./src/components/Common/CellRenderers/Duration.ts");
/* harmony import */ var _InteractionsListItem__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./InteractionsListItem */ "./src/components/Common/CellRenderers/InteractionsListItem.ts");
/* harmony import */ var _QueueStatsListItem__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./QueueStatsListItem */ "./src/components/Common/CellRenderers/QueueStatsListItem.ts");
/* harmony import */ var _Sentiment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./Sentiment */ "./src/components/Common/CellRenderers/Sentiment.ts");















/***/ }),

/***/ "./src/components/Common/EmptyDisplayWrapper/EmptyDisplayWrapper.scss":
/*!****************************************************************************!*\
  !*** ./src/components/Common/EmptyDisplayWrapper/EmptyDisplayWrapper.scss ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 400px;
}
.empty-state .empty-header {
  text-align: center;
  font-size: var(--font-size-large);
  font-family: var(--font-family);
  color: var(--md-primary-text-color);
  margin-top: 0;
  margin-bottom: 13px;
  line-height: 24px;
}
.empty-state .empty-body {
  text-align: center;
  width: 296px;
  font-size: var(--font-size-medium);
  font-family: var(--font-family);
  margin-top: 0;
  margin-bottom: 13px;
}
.empty-state .empty-link {
  display: block;
  text-align: center;
  font-size: var(--font-size-large);
  font-family: var(--font-family);
  color: var(--md-primary-text-color);
  line-height: 24px;
}
.empty-state .loading {
  display: flex;
  margin-top: 22px;
  justify-content: center;
  transition: opacity 0.3s ease-in-out;
}
.empty-state .loading-visible {
  opacity: 1;
}
.empty-state .loading-hidden {
  opacity: 0;
}
.empty-state uuip-wc-empty-state::part(img) {
  background-color: transparent;
  box-sizing: border-box;
  height: 100px;
  width: 100px;
}
.empty-state uuip-wc-empty-state::part(container) {
  background-color: transparent;
}
.empty-state uuip-wc-empty-state.inverted::part(img) {
  filter: invert(1);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/EmptyDisplayWrapper/EmptyDisplayWrapper.scss */
/*# sourceURL=EmptyDisplayWrapper.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/EmptyDisplayWrapper/EmptyDisplayWrapper.ts":
/*!**************************************************************************!*\
  !*** ./src/components/Common/EmptyDisplayWrapper/EmptyDisplayWrapper.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EmptyDisplayWrapper: () => (/* binding */ EmptyDisplayWrapper)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _EmptyDisplayWrapper_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./EmptyDisplayWrapper.scss */ "./src/components/Common/EmptyDisplayWrapper/EmptyDisplayWrapper.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */






let EmptyDisplayWrapper = class EmptyDisplayWrapper extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
    constructor() {
        super(...arguments);
        this.type = "";
        this.title = "";
        this.info = "";
        this.link = "";
        this.linkText = "";
        this.loading = false;
        this.isDarkMode = false;
    }
    static get styles() {
        return _EmptyDisplayWrapper_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
    }
    get iconClassMap() {
        return {
            inverted: (this.type === "empty-state" || this.type === "empty-result") && !this.isDarkMode
        };
    }
    get imagePath() {
        switch (this.type) {
            case "empty-state":
                return "/images/design/illustrations/box-open-onetwozero-default.svg";
            case "empty-result":
                return "/images/design/illustrations/desert-open-results-oneninetwo-default.svg";
            case "error-cloud":
                return "/images/design/illustrations/cloud-failure-oneninetwo-onboarding-secondary.svg";
            default:
                return "/images/design/illustrations/box-open-onetwozero-default.svg";
        }
    }
    get spinnerClassMap() {
        return {
            "loading-visible": this.loading,
            "loading-hidden": !this.loading
        };
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div class="empty-state">
        <uuip-wc-empty-state
          illustration-src="${this.imagePath}"
          class="empty-state-illustration ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)(this.iconClassMap)}"
        >
          <div>
            <h4 class="empty-header">${this.title}</h4>
            <p class="empty-body">${this.info}</p>
            ${this.link
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<md-link class="empty-link" size="midsize" href="${this.link}"> ${this.linkText} </md-link>`
            : ""}
            <div id="spinner" class="loading ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)(this.spinnerClassMap)}">
              <md-spinner size="48"></md-spinner>
            </div>
          </div>
        </uuip-wc-empty-state>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String, attribute: "illustration-type" })
], EmptyDisplayWrapper.prototype, "type", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String, attribute: "title" })
], EmptyDisplayWrapper.prototype, "title", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String, attribute: "info-message" })
], EmptyDisplayWrapper.prototype, "info", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String, attribute: "link" })
], EmptyDisplayWrapper.prototype, "link", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String, attribute: "link-text" })
], EmptyDisplayWrapper.prototype, "linkText", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
], EmptyDisplayWrapper.prototype, "loading", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
], EmptyDisplayWrapper.prototype, "isDarkMode", void 0);
EmptyDisplayWrapper = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-empty-display-wrapper")
], EmptyDisplayWrapper);



/***/ }),

/***/ "./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.scss":
/*!************************************************************************!*\
  !*** ./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.scss ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  height: 100%;
  width: 100%;
  display: grid;
}

.empty-state {
  align-items: center;
  display: flex;
  justify-content: center;
  height: calc(100% - 15px);
  width: 100%;
  color: var(--md-secondary-text-color);
  background: var(--md-content-bg-color);
}
.empty-state__container {
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  font-size: var(--font-size-medium);
}
.empty-state__illustration {
  display: flex;
  width: 100%;
  height: auto;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/EmptyStateWrapper/EmptyStateWrapper.scss */
/*# sourceURL=EmptyStateWrapper.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.ts":
/*!**********************************************************************!*\
  !*** ./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.ts ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EmptyStateWrapper: () => (/* binding */ EmptyStateWrapper)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _EmptyStateWrapper_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./EmptyStateWrapper.scss */ "./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */





var EmptyStateWrapper;
(function (EmptyStateWrapper) {
    /**
     * @element agentx-wc-empty-state-wrapper
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        constructor() {
            super(...arguments);
            this.illustrationType = "";
        }
        static get styles() {
            return _EmptyStateWrapper_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        get imagePath() {
            switch (this.illustrationType) {
                case "empty-state":
                    return "/images/illustrations/box-open-120.svg";
                case "empty-result":
                    return "/images/illustrations/desert-open-results-192.svg";
                case "error-cloud":
                    return "/images/illustrations/cloud-failure-192-red-pink.svg";
                default:
                    return "/images/illustrations/box-open-120.svg";
            }
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="empty-state" part="container">
          <div class="empty-state__container">
            <img
              part="img"
              src="${this.imagePath}"
              alt="empty-state"
              aria-hidden="true"
              class="empty-state__illustration"
            />
            <slot></slot>
          </div>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String, attribute: "illustration-type" })
    ], Element.prototype, "illustrationType", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-empty-state-wrapper")
    ], Element);
    EmptyStateWrapper.Element = Element;
})(EmptyStateWrapper || (EmptyStateWrapper = {}));


/***/ }),

/***/ "./src/components/Common/Frame/Frame.scss":
/*!************************************************!*\
  !*** ./src/components/Common/Frame/Frame.scss ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.frame {
  display: flex;
  flex-direction: column;
  height: calc(100% - 1rem);
  padding: 0.75rem 1rem;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/Frame/Frame.scss */
/*# sourceURL=Frame.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvQ29tbW9uL0ZyYW1lL0ZyYW1lLnNjc3MiLCJGcmFtZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLHNCQUFBO0VBQ0EseUJBQUE7RUFDQSxxQkFBQTtBQ0NGIiwiZmlsZSI6IkZyYW1lLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuZnJhbWUge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBoZWlnaHQ6IGNhbGMoMTAwJSAtIDFyZW0pOyAvLyBleGNsdWRlIHBhZGRpbmdcbiAgcGFkZGluZzogMC43NXJlbSAxcmVtO1xufVxuIiwiLmZyYW1lIHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgaGVpZ2h0OiBjYWxjKDEwMCUgLSAxcmVtKTtcbiAgcGFkZGluZzogMC43NXJlbSAxcmVtO1xufSJdfQ== */`);
    

/***/ }),

/***/ "./src/components/Common/Frame/Frame.ts":
/*!**********************************************!*\
  !*** ./src/components/Common/Frame/Frame.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Frame: () => (/* binding */ Frame)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _Frame_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Frame.scss */ "./src/components/Common/Frame/Frame.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let Frame = class Frame extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement) {
    static getStyles() {
        return _Frame_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
      <div class="frame">
        <slot></slot>
      </div>
    `;
    }
};
Frame = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("agentx-wc-frame")
], Frame);



/***/ }),

/***/ "./src/components/Common/GridExportButton/GridExportButton.scss":
/*!**********************************************************************!*\
  !*** ./src/components/Common/GridExportButton/GridExportButton.scss ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.export-overlay-container {
  padding: 0.5rem;
  width: 100%;
  background-color: var(--md-secondary-white-bg-color);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/GridExportButton/GridExportButton.scss */
/*# sourceURL=GridExportButton.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvQ29tbW9uL0dyaWRFeHBvcnRCdXR0b24vR3JpZEV4cG9ydEJ1dHRvbi5zY3NzIiwiR3JpZEV4cG9ydEJ1dHRvbi5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsZUFBQTtFQUNBLFdBQUE7RUFDQSxvREFBQTtBQ0NGIiwiZmlsZSI6IkdyaWRFeHBvcnRCdXR0b24uc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5leHBvcnQtb3ZlcmxheS1jb250YWluZXIge1xuICBwYWRkaW5nOiAwLjVyZW07XG4gIHdpZHRoOiAxMDAlO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1tZC1zZWNvbmRhcnktd2hpdGUtYmctY29sb3IpO1xufVxuIiwiLmV4cG9ydC1vdmVybGF5LWNvbnRhaW5lciB7XG4gIHBhZGRpbmc6IDAuNXJlbTtcbiAgd2lkdGg6IDEwMCU7XG4gIGJhY2tncm91bmQtY29sb3I6IHZhcigtLW1kLXNlY29uZGFyeS13aGl0ZS1iZy1jb2xvcik7XG59Il19 */`);
    

/***/ }),

/***/ "./src/components/Common/GridExportButton/GridExportButton.ts":
/*!********************************************************************!*\
  !*** ./src/components/Common/GridExportButton/GridExportButton.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GridExportButton: () => (/* binding */ GridExportButton)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _GridExportButton_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./GridExportButton.scss */ "./src/components/Common/GridExportButton/GridExportButton.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



const CSV = "csv";
const EXCEL = "excel";
let GridExportButton = class GridExportButton extends lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement {
    constructor() {
        super(...arguments);
        this.exportFileNamePrefix = "";
        this.sheetName = "";
    }
    static get styles() {
        return _GridExportButton_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
    }
    downloadTableData(downloadFormat) {
        var _a, _b;
        switch (downloadFormat) {
            case CSV:
                (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.exportDataAsCsv(this.getExportParams());
                break;
            case EXCEL:
                (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.exportDataAsExcel(this.getExportParams());
                break;
        }
    }
    getExportParams() {
        var _a;
        return Object.assign(Object.assign({}, ((_a = this.exportParams) !== null && _a !== void 0 ? _a : {})), { fileName: `${this.exportFileNamePrefix}_${new Date(Date.now()).toString()}`, sheetName: this.sheetName });
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <md-menu-overlay size="small">
        <div slot="menu-trigger">
          <slot name="menu-trigger">
            <md-button size="28" circle variant="ghost" class="download-btn">
              <md-icon slot="icon" name="export_16" ariaHidden="true"></md-icon>
            </md-button>
          </slot>
        </div>
        <div class="export-overlay-container">
          <md-list label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.downloadTableContent")}>
            <md-list-item
              slot="list-item"
              @click=${() => this.downloadTableData(CSV)}
              @keypress=${(e) => e.key === "Enter" && this.downloadTableData(CSV)}
              >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.csv")}</md-list-item
            >
            <md-list-item
              slot="list-item"
              @click=${() => this.downloadTableData(EXCEL)}
              @keypress=${(e) => e.key === "Enter" && this.downloadTableData(EXCEL)}
              >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.microsoftExcel")}</md-list-item
            >
          </md-list>
        </div>
      </md-menu-overlay>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], GridExportButton.prototype, "exportFileNamePrefix", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], GridExportButton.prototype, "sheetName", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
], GridExportButton.prototype, "gridApi", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
], GridExportButton.prototype, "exportParams", void 0);
GridExportButton = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-grid-export-button")
], GridExportButton);



/***/ }),

/***/ "./src/components/Common/Headers/PageHeader/PageHeader.scss":
/*!******************************************************************!*\
  !*** ./src/components/Common/Headers/PageHeader/PageHeader.scss ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5em;
}
.header.hidden {
  display: none;
}

.title {
  color: var(--md-primary-text-color);
  font-size: 1.25rem;
  font-weight: var(--brand-font-weight-bold);
}

.buttons {
  display: flex;
  flex-direction: row nowrap;
  gap: 4px;
}

.popout-button.hidden,
.close-button.hidden {
  display: none;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/Headers/PageHeader/PageHeader.scss */
/*# sourceURL=PageHeader.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvQ29tbW9uL0hlYWRlcnMvUGFnZUhlYWRlci9QYWdlSGVhZGVyLnNjc3MiLCJQYWdlSGVhZGVyLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxhQUFBO0VBQ0EsOEJBQUE7RUFDQSxtQkFBQTtFQUNBLGNBQUE7QUNDRjtBRENFO0VBQ0UsYUFBQTtBQ0NKOztBREdBO0VBQ0UsbUNBQUE7RUFDQSxrQkFBQTtFQUNBLDBDQUFBO0FDQUY7O0FER0E7RUFDRSxhQUFBO0VBQ0EsMEJBQUE7RUFDQSxRQUFBO0FDQUY7O0FER0E7O0VBRUUsYUFBQTtBQ0FGIiwiZmlsZSI6IlBhZ2VIZWFkZXIuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5oZWFkZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIHBhZGRpbmc6IDAuNWVtO1xuXG4gICYuaGlkZGVuIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbi50aXRsZSB7XG4gIGNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LXRleHQtY29sb3IpO1xuICBmb250LXNpemU6IDEuMjVyZW07XG4gIGZvbnQtd2VpZ2h0OiB2YXIoLS1icmFuZC1mb250LXdlaWdodC1ib2xkKTtcbn1cblxuLmJ1dHRvbnMge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogcm93IG5vd3JhcDtcbiAgZ2FwOiA0cHg7XG59XG5cbi5wb3BvdXQtYnV0dG9uLmhpZGRlbixcbi5jbG9zZS1idXR0b24uaGlkZGVuIHtcbiAgZGlzcGxheTogbm9uZTtcbn1cbiIsIi5oZWFkZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIHBhZGRpbmc6IDAuNWVtO1xufVxuLmhlYWRlci5oaWRkZW4ge1xuICBkaXNwbGF5OiBub25lO1xufVxuXG4udGl0bGUge1xuICBjb2xvcjogdmFyKC0tbWQtcHJpbWFyeS10ZXh0LWNvbG9yKTtcbiAgZm9udC1zaXplOiAxLjI1cmVtO1xuICBmb250LXdlaWdodDogdmFyKC0tYnJhbmQtZm9udC13ZWlnaHQtYm9sZCk7XG59XG5cbi5idXR0b25zIHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IHJvdyBub3dyYXA7XG4gIGdhcDogNHB4O1xufVxuXG4ucG9wb3V0LWJ1dHRvbi5oaWRkZW4sXG4uY2xvc2UtYnV0dG9uLmhpZGRlbiB7XG4gIGRpc3BsYXk6IG5vbmU7XG59Il19 */`);
    

/***/ }),

/***/ "./src/components/Common/Headers/PageHeader/PageHeader.ts":
/*!****************************************************************!*\
  !*** ./src/components/Common/Headers/PageHeader/PageHeader.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PageHeader: () => (/* binding */ PageHeader)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _PageHeader_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./PageHeader.scss */ "./src/components/Common/Headers/PageHeader/PageHeader.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let PageHeader = class PageHeader extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement) {
    constructor() {
        super(...arguments);
        this.title = "";
        this.usePopoutButton = false;
        this.useCloseButton = false;
    }
    static getStyles() {
        return _PageHeader_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    popoutClicked() {
        this.dispatchEvent(new CustomEvent("page-header-popout", {
            bubbles: true,
            composed: true
        }));
    }
    closeClicked() {
        this.dispatchEvent(new CustomEvent("page-header-close", {
            bubbles: true,
            composed: true
        }));
    }
    get isHidden() {
        return this.title.length === 0 && !this.usePopoutButton && !this.useCloseButton;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
      <div class="header ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__.classMap)({ hidden: this.isHidden })}">
        <div class="title">${this.title}</div>
        <div class="buttons">
          <md-button
            class="popout-button ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__.classMap)({ hidden: !this.usePopoutButton })}"
            @click="${this.popoutClicked}"
            circle
          >
            <md-icon slot="icon" name="pop-out-bold" iconSet="momentumDesign"></md-icon>
          </md-button>
          <md-button
            class="close-button ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__.classMap)({ hidden: !this.useCloseButton })}"
            @click="${this.closeClicked}"
            circle
          >
            <md-icon slot="icon" name="cancel-bold" iconSet="momentumDesign"></md-icon>
          </md-button>
        </div>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: String })
], PageHeader.prototype, "title", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Boolean })
], PageHeader.prototype, "usePopoutButton", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Boolean })
], PageHeader.prototype, "useCloseButton", void 0);
PageHeader = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("agentx-wc-page-header")
], PageHeader);



/***/ }),

/***/ "./src/components/Common/Headers/PanelHeader/PanelHeader.scss":
/*!********************************************************************!*\
  !*** ./src/components/Common/Headers/PanelHeader/PanelHeader.scss ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  padding-bottom: 0;
  padding-top: 0.875rem;
  margin-left: 8px;
}
.header.hidden {
  display: none;
}

.heading {
  color: var(--md-primary-text-color);
  font-size: var(--font-size-heading-small);
  font-weight: var(--brand-font-weight-bold);
  font-family: var(--brand-font-bold);
  line-height: var(--font-lineheight-heading-small);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/Headers/PanelHeader/PanelHeader.scss */
/*# sourceURL=PanelHeader.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvQ29tbW9uL0hlYWRlcnMvUGFuZWxIZWFkZXIvUGFuZWxIZWFkZXIuc2NzcyIsIlBhbmVsSGVhZGVyLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxhQUFBO0VBQ0EsOEJBQUE7RUFDQSxtQkFBQTtFQUNBLGVBQUE7RUFDQSxpQkFBQTtFQUNBLHFCQUFBO0VBQ0EsZ0JBQUE7QUNDRjtBRENFO0VBQ0UsYUFBQTtBQ0NKOztBREdBO0VBQ0UsbUNBQUE7RUFDQSx5Q0FBQTtFQUNBLDBDQUFBO0VBQ0EsbUNBQUE7RUFDQSxpREFBQTtBQ0FGIiwiZmlsZSI6IlBhbmVsSGVhZGVyLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuaGVhZGVyIHtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBwYWRkaW5nOiAwLjVyZW07XG4gIHBhZGRpbmctYm90dG9tOiAwO1xuICBwYWRkaW5nLXRvcDogMC44NzVyZW07XG4gIG1hcmdpbi1sZWZ0OiA4cHg7XG5cbiAgJi5oaWRkZW4ge1xuICAgIGRpc3BsYXk6IG5vbmU7XG4gIH1cbn1cblxuLmhlYWRpbmcge1xuICBjb2xvcjogdmFyKC0tbWQtcHJpbWFyeS10ZXh0LWNvbG9yKTtcbiAgZm9udC1zaXplOiB2YXIoLS1mb250LXNpemUtaGVhZGluZy1zbWFsbCk7XG4gIGZvbnQtd2VpZ2h0OiB2YXIoLS1icmFuZC1mb250LXdlaWdodC1ib2xkKTtcbiAgZm9udC1mYW1pbHk6IHZhcigtLWJyYW5kLWZvbnQtYm9sZCk7XG4gIGxpbmUtaGVpZ2h0OiB2YXIoLS1mb250LWxpbmVoZWlnaHQtaGVhZGluZy1zbWFsbCk7XG59XG4iLCIuaGVhZGVyIHtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBwYWRkaW5nOiAwLjVyZW07XG4gIHBhZGRpbmctYm90dG9tOiAwO1xuICBwYWRkaW5nLXRvcDogMC44NzVyZW07XG4gIG1hcmdpbi1sZWZ0OiA4cHg7XG59XG4uaGVhZGVyLmhpZGRlbiB7XG4gIGRpc3BsYXk6IG5vbmU7XG59XG5cbi5oZWFkaW5nIHtcbiAgY29sb3I6IHZhcigtLW1kLXByaW1hcnktdGV4dC1jb2xvcik7XG4gIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplLWhlYWRpbmctc21hbGwpO1xuICBmb250LXdlaWdodDogdmFyKC0tYnJhbmQtZm9udC13ZWlnaHQtYm9sZCk7XG4gIGZvbnQtZmFtaWx5OiB2YXIoLS1icmFuZC1mb250LWJvbGQpO1xuICBsaW5lLWhlaWdodDogdmFyKC0tZm9udC1saW5laGVpZ2h0LWhlYWRpbmctc21hbGwpO1xufSJdfQ== */`);
    

/***/ }),

/***/ "./src/components/Common/Headers/PanelHeader/PanelHeader.ts":
/*!******************************************************************!*\
  !*** ./src/components/Common/Headers/PanelHeader/PanelHeader.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PanelHeader: () => (/* binding */ PanelHeader)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _PanelHeader_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./PanelHeader.scss */ "./src/components/Common/Headers/PanelHeader/PanelHeader.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let PanelHeader = class PanelHeader extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement) {
    constructor() {
        super(...arguments);
        this.heading = "";
    }
    static getStyles() {
        return _PanelHeader_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    updated(changedProperties) {
        if (changedProperties.has("heading") || changedProperties.has("rightContentNodes")) {
            this.requestUpdate();
        }
        super.updated(changedProperties);
    }
    get isHidden() {
        return this.heading.length === 0 && (!this.rightContentNodes || this.rightContentNodes.length === 0);
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
      <div class="header ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__.classMap)({ hidden: this.isHidden })}">
        <div class="heading">${this.heading}</div>
        <slot name="panel-header-right-content"></slot>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: String })
], PanelHeader.prototype, "heading", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.queryAssignedNodes)("panel-header-right-content", true)
], PanelHeader.prototype, "rightContentNodes", void 0);
PanelHeader = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("agentx-wc-panel-header")
], PanelHeader);



/***/ }),

/***/ "./src/components/Common/Headers/index.ts":
/*!************************************************!*\
  !*** ./src/components/Common/Headers/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PageHeader: () => (/* reexport safe */ _PageHeader_PageHeader__WEBPACK_IMPORTED_MODULE_1__.PageHeader),
/* harmony export */   PanelHeader: () => (/* reexport safe */ _PanelHeader_PanelHeader__WEBPACK_IMPORTED_MODULE_0__.PanelHeader)
/* harmony export */ });
/* harmony import */ var _PanelHeader_PanelHeader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./PanelHeader/PanelHeader */ "./src/components/Common/Headers/PanelHeader/PanelHeader.ts");
/* harmony import */ var _PageHeader_PageHeader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./PageHeader/PageHeader */ "./src/components/Common/Headers/PageHeader/PageHeader.ts");




/***/ }),

/***/ "./src/components/Common/Panel/PanelFrame/PanelFrame.scss":
/*!****************************************************************!*\
  !*** ./src/components/Common/Panel/PanelFrame/PanelFrame.scss ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.panel-content {
  flex: 1;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/Panel/PanelFrame/PanelFrame.scss */
/*# sourceURL=PanelFrame.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvQ29tbW9uL1BhbmVsL1BhbmVsRnJhbWUvUGFuZWxGcmFtZS5zY3NzIiwiUGFuZWxGcmFtZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLHNCQUFBO0VBQ0EsWUFBQTtBQ0NGOztBREVBO0VBQ0UsT0FBQTtBQ0NGIiwiZmlsZSI6IlBhbmVsRnJhbWUuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5jb250YWluZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBoZWlnaHQ6IDEwMCU7XG59XG5cbi5wYW5lbC1jb250ZW50IHtcbiAgZmxleDogMTtcbn1cbiIsIi5jb250YWluZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBoZWlnaHQ6IDEwMCU7XG59XG5cbi5wYW5lbC1jb250ZW50IHtcbiAgZmxleDogMTtcbn0iXX0= */`);
    

/***/ }),

/***/ "./src/components/Common/Panel/PanelFrame/PanelFrame.ts":
/*!**************************************************************!*\
  !*** ./src/components/Common/Panel/PanelFrame/PanelFrame.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PanelFrame: () => (/* binding */ PanelFrame)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _PanelFrame_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./PanelFrame.scss */ "./src/components/Common/Panel/PanelFrame/PanelFrame.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let PanelFrame = class PanelFrame extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement) {
    constructor() {
        super(...arguments);
        this.heading = "";
    }
    static getStyles() {
        return _PanelFrame_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
      <div class="container">
        <agentx-wc-panel-header heading=${this.heading}>
          <slot slot="panel-header-right-content" name="header-extra-content"></slot>
        </agentx-wc-panel-header>
        <agentx-wc-frame class="panel-content">
          <slot></slot>
        </agentx-wc-frame>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: String })
], PanelFrame.prototype, "heading", void 0);
PanelFrame = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("agentx-wc-panel-frame")
], PanelFrame);



/***/ }),

/***/ "./src/components/Common/Panel/PanelLayout/PanelLayout.scss":
/*!******************************************************************!*\
  !*** ./src/components/Common/Panel/PanelLayout/PanelLayout.scss ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.container {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  height: 100%;
}

.top {
  width: 100%;
}
.top.hidden {
  display: none;
}

.bottom {
  display: flex;
  gap: 0.5em;
  flex: 1;
}

.left,
.right {
  flex: 1;
}
.left.hidden,
.right.hidden {
  display: none;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/Panel/PanelLayout/PanelLayout.scss */
/*# sourceURL=PanelLayout.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvQ29tbW9uL1BhbmVsL1BhbmVsTGF5b3V0L1BhbmVsTGF5b3V0LnNjc3MiLCJQYW5lbExheW91dC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLHNCQUFBO0VBQ0EsVUFBQTtFQUNBLFlBQUE7QUNDRjs7QURFQTtFQUNFLFdBQUE7QUNDRjtBRENFO0VBQ0UsYUFBQTtBQ0NKOztBREdBO0VBQ0UsYUFBQTtFQUNBLFVBQUE7RUFDQSxPQUFBO0FDQUY7O0FER0E7O0VBRUUsT0FBQTtBQ0FGO0FERUU7O0VBQ0UsYUFBQTtBQ0NKIiwiZmlsZSI6IlBhbmVsTGF5b3V0LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuY29udGFpbmVyIHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgZ2FwOiAwLjVlbTtcbiAgaGVpZ2h0OiAxMDAlO1xufVxuXG4udG9wIHtcbiAgd2lkdGg6IDEwMCU7XG5cbiAgJi5oaWRkZW4ge1xuICAgIGRpc3BsYXk6IG5vbmU7XG4gIH1cbn1cblxuLmJvdHRvbSB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGdhcDogMC41ZW07XG4gIGZsZXg6IDE7XG59XG5cbi5sZWZ0LFxuLnJpZ2h0IHtcbiAgZmxleDogMTtcblxuICAmLmhpZGRlbiB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxufVxuIiwiLmNvbnRhaW5lciB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGdhcDogMC41ZW07XG4gIGhlaWdodDogMTAwJTtcbn1cblxuLnRvcCB7XG4gIHdpZHRoOiAxMDAlO1xufVxuLnRvcC5oaWRkZW4ge1xuICBkaXNwbGF5OiBub25lO1xufVxuXG4uYm90dG9tIHtcbiAgZGlzcGxheTogZmxleDtcbiAgZ2FwOiAwLjVlbTtcbiAgZmxleDogMTtcbn1cblxuLmxlZnQsXG4ucmlnaHQge1xuICBmbGV4OiAxO1xufVxuLmxlZnQuaGlkZGVuLFxuLnJpZ2h0LmhpZGRlbiB7XG4gIGRpc3BsYXk6IG5vbmU7XG59Il19 */`);
    

/***/ }),

/***/ "./src/components/Common/Panel/PanelLayout/PanelLayout.ts":
/*!****************************************************************!*\
  !*** ./src/components/Common/Panel/PanelLayout/PanelLayout.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PanelLayout: () => (/* binding */ PanelLayout)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _PanelLayout_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./PanelLayout.scss */ "./src/components/Common/Panel/PanelLayout/PanelLayout.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let PanelLayout = class PanelLayout extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement) {
    constructor() {
        super(...arguments);
        this.showTopPanel = true;
        this.showLeftPanel = true;
        this.showRightPanel = true;
    }
    static getStyles() {
        return _PanelLayout_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
      <div class="container">
        <div class="top ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__.classMap)({ hidden: !this.showTopPanel })}">
          <slot name="top"></slot>
        </div>
        <div class="bottom">
          <div class="left ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__.classMap)({ hidden: !this.showLeftPanel })}">
            <slot name="left"></slot>
          </div>
          <div class="right ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__.classMap)({ hidden: !this.showRightPanel })}">
            <slot name="right"></slot>
          </div>
        </div>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Boolean })
], PanelLayout.prototype, "showTopPanel", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Boolean })
], PanelLayout.prototype, "showLeftPanel", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Boolean })
], PanelLayout.prototype, "showRightPanel", void 0);
PanelLayout = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("agentx-wc-panel-layout")
], PanelLayout);



/***/ }),

/***/ "./src/components/Common/Panel/index.ts":
/*!**********************************************!*\
  !*** ./src/components/Common/Panel/index.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PanelFrame: () => (/* reexport safe */ _PanelFrame_PanelFrame__WEBPACK_IMPORTED_MODULE_0__.PanelFrame),
/* harmony export */   PanelLayout: () => (/* reexport safe */ _PanelLayout_PanelLayout__WEBPACK_IMPORTED_MODULE_1__.PanelLayout)
/* harmony export */ });
/* harmony import */ var _PanelFrame_PanelFrame__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./PanelFrame/PanelFrame */ "./src/components/Common/Panel/PanelFrame/PanelFrame.ts");
/* harmony import */ var _PanelLayout_PanelLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./PanelLayout/PanelLayout */ "./src/components/Common/Panel/PanelLayout/PanelLayout.ts");




/***/ }),

/***/ "./src/components/Common/SearchInput/searchInput.scss":
/*!************************************************************!*\
  !*** ./src/components/Common/SearchInput/searchInput.scss ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.state-input-wrapper {
  height: var(--state-input-height);
  padding: 0px 2px;
}
.state-input-wrapper md-input::part(md-input-container) {
  margin-bottom: 12px;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/SearchInput/searchInput.scss */
/*# sourceURL=searchInput.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvQ29tbW9uL1NlYXJjaElucHV0L3NlYXJjaElucHV0LnNjc3MiLCJzZWFyY2hJbnB1dC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsaUNBQUE7RUFDQSxnQkFBQTtBQ0NGO0FERUk7RUFDRSxtQkFBQTtBQ0FOIiwiZmlsZSI6InNlYXJjaElucHV0LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuc3RhdGUtaW5wdXQtd3JhcHBlciB7XG4gIGhlaWdodDogdmFyKC0tc3RhdGUtaW5wdXQtaGVpZ2h0KTtcbiAgcGFkZGluZzogMHB4IDJweDtcblxuICBtZC1pbnB1dCB7XG4gICAgJjo6cGFydChtZC1pbnB1dC1jb250YWluZXIpIHtcbiAgICAgIG1hcmdpbi1ib3R0b206IDEycHg7XG4gICAgfVxuICB9XG59XG4iLCIuc3RhdGUtaW5wdXQtd3JhcHBlciB7XG4gIGhlaWdodDogdmFyKC0tc3RhdGUtaW5wdXQtaGVpZ2h0KTtcbiAgcGFkZGluZzogMHB4IDJweDtcbn1cbi5zdGF0ZS1pbnB1dC13cmFwcGVyIG1kLWlucHV0OjpwYXJ0KG1kLWlucHV0LWNvbnRhaW5lcikge1xuICBtYXJnaW4tYm90dG9tOiAxMnB4O1xufSJdfQ== */`);
    

/***/ }),

/***/ "./src/components/Common/SearchInput/searchInput.ts":
/*!**********************************************************!*\
  !*** ./src/components/Common/SearchInput/searchInput.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SearchInput: () => (/* binding */ SearchInput)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _searchInput_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./searchInput.scss */ "./src/components/Common/SearchInput/searchInput.scss");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_6__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var SearchInput;
(function (SearchInput) {
    /**
     * @element search-input
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.isPageLoading = false;
            this.isSearchPageLoading = false;
            this.reset = false;
            this.presetValue = "";
            this.placeholder = "";
            this.ariaLabel = "";
            this.searchQuery = "";
            this.handleSearchDebounced = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__.debounce)((event) => {
                const { value } = event.detail;
                this.searchQuery = value;
                if (this.presetValue) {
                    this.presetValue = "";
                }
                if (value === "") {
                    this.dispatchEvent(new CustomEvent("search-cleared", { detail: value }));
                }
                else if (value.length < _constants__WEBPACK_IMPORTED_MODULE_0__.SEARCH_THRESHOLD) {
                    this.dispatchEvent(new CustomEvent("search-too-short", { detail: value }));
                }
                else if (value.length >= _constants__WEBPACK_IMPORTED_MODULE_0__.SEARCH_THRESHOLD) {
                    this.dispatchEvent(new CustomEvent("search-term-valid", { detail: value }));
                }
            }, _constants__WEBPACK_IMPORTED_MODULE_0__.FILTER_CHANGE_DELAY);
            this.handleSearch = (event) => {
                this.handleSearchDebounced(event);
            };
        }
        static get styles() {
            return _searchInput_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            if (changedProperties.has("reset") && this.reset === false) {
                this.searchQuery = "";
            }
        }
        handleInputKeyDown(event) {
            this.dispatchEvent(new CustomEvent("input-keydown", { detail: event.detail }));
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="state-input-wrapper" part="search-input-wrapper">
          <md-input
            id="pillSearchInput"
            searchable
            newMomentum
            aria-label="${this.ariaLabel || (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.search")}"
            placeholder=${this.placeholder || (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.search")}
            clear
            clearAriaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common:clear")}"
            containerSize="medium-10"
            htmlId="pillSearchInput"
            name="pillSearchInput"
            value="${this.presetValue || this.searchQuery}"
            @input-change="${this.handleSearch}"
            @input-keydown="${this.handleInputKeyDown}"
            type="text"
            shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_5__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_6__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
            .disabled=${this.isPageLoading && !this.isSearchPageLoading}
            autoFocus
          >
          </md-input>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ reflect: true, type: Boolean })
    ], Element.prototype, "isPageLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ reflect: true, type: Boolean })
    ], Element.prototype, "isSearchPageLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ reflect: true, type: Boolean })
    ], Element.prototype, "reset", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "presetValue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "placeholder", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "ariaLabel", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "searchQuery", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)("md-input")
    ], Element.prototype, "input", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("search-input")
    ], Element);
    SearchInput.Element = Element;
})(SearchInput || (SearchInput = {}));


/***/ }),

/***/ "./src/components/Common/Table/TableManager.ts":
/*!*****************************************************!*\
  !*** ./src/components/Common/Table/TableManager.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableManager: () => (/* binding */ TableManager)
/* harmony export */ });
/* harmony import */ var _components_GridWidget_GridCacheUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/GridWidget/GridCacheUtils */ "./src/components/GridWidget/GridCacheUtils.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");


class TableManager {
    /* Public API */
    constructor(config) {
        this.columnDefinitions = {};
        this._customizationColumnsMenuModel = { available: [], selected: [] };
        this.defaultColumnStates = [];
        const { cacheName, columnDefinitions } = config;
        this.cacheName = cacheName;
        if (columnDefinitions.some((colDef) => colDef.colId === undefined)) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[TableManager] setColumnDefinitions requires all column definitions to have colId specified");
            return;
        }
        this.columnDefinitions = Object.fromEntries(columnDefinitions.map((colDef) => [colDef.colId, colDef]));
    }
    get customizationColumnsMenuModel() {
        return this._customizationColumnsMenuModel;
    }
    /* Event Handlers */
    onGridReady(gridApi) {
        var _a, _b;
        this.gridApi = gridApi;
        (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setGridOption("columnDefs", Object.values(this.columnDefinitions));
        this.defaultColumnStates = (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.getColumnState();
        const cachedColumnStates = this.cachedColumnStates;
        if (cachedColumnStates) {
            this.setColumnStates(cachedColumnStates);
        }
        this._customizationColumnsMenuModel = this.buildColumnsMenuModel(cachedColumnStates !== null && cachedColumnStates !== void 0 ? cachedColumnStates : Object.values(this.columnDefinitions));
    }
    onReset() {
        var _a, _b, _c;
        this.deleteCachedColumnStates();
        (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.resetColumnState();
        (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.setFilterModel(null);
        (_c = this.gridApi) === null || _c === void 0 ? void 0 : _c.onFilterChanged();
        this._customizationColumnsMenuModel = this.buildColumnsMenuModel(Object.values(this.columnDefinitions));
    }
    onMenuColumnsMoved(menuModel) {
        if (!this.gridApi) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[TableManager] onColumnsRearranged called before gridApi was set");
            return;
        }
        const oldColumnsState = this.gridApi.getColumnState();
        const newColumnsState = this.getColumnStateWithUpdatedVisiblity(oldColumnsState, menuModel);
        this.setColumnStates(newColumnsState);
        this._customizationColumnsMenuModel = menuModel;
        this.writeColumnStateToLocalStorage(newColumnsState);
    }
    onTableColumnResized(e) {
        this.handleTableEvent(e);
    }
    onTableColumnMoved(e) {
        if (e.source === "api") {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[TableManager] onTableColumnMoved triggered by API, ignoring event");
            return;
        }
        this.handleTableEvent(e);
    }
    onTableSortChanged(e) {
        this.handleTableEvent(e);
    }
    /* Private Methods */
    get cachedColumnStates() {
        var _a, _b;
        if (this.cacheName === undefined) {
            return null;
        }
        const cachedColumnStatesString = (_b = (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem(this.cacheName)) !== null && _b !== void 0 ? _b : "";
        let cachedColumnStates = [];
        try {
            cachedColumnStates = JSON.parse(cachedColumnStatesString);
        }
        catch (err) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[TableManager] Config: error caught loading config from local storage:", err);
            if (cachedColumnStatesString) {
                this.deleteCachedColumnStates();
            }
        }
        if (Array.isArray(cachedColumnStates) && cachedColumnStates.length && Array.isArray(this.defaultColumnStates)) {
            return (0,_components_GridWidget_GridCacheUtils__WEBPACK_IMPORTED_MODULE_0__.mergedSimplifiedStateWithDefault)(cachedColumnStates, this.defaultColumnStates);
        }
        return null;
    }
    setColumnStates(columnStates) {
        if (!this.gridApi) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[TableManager] setColumnStates called before gridApi was set");
            return;
        }
        this.gridApi.applyColumnState({
            state: columnStates,
            applyOrder: true
        });
    }
    deleteCachedColumnStates() {
        var _a;
        if (this.cacheName) {
            (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.removeItem(this.cacheName);
        }
    }
    getColumnStateWithUpdatedVisiblity(initialColumnsState, menuModel) {
        const visibleColumns = menuModel.selected.map((col) => col.id);
        const hiddenColumns = menuModel.available.map((col) => col.id);
        return [...visibleColumns, ...hiddenColumns].map((columnId) => {
            const columnState = initialColumnsState.find((col) => col.colId === columnId);
            return Object.assign(Object.assign({}, columnState), { colId: columnId, hide: !visibleColumns.includes(columnId) });
        });
    }
    handleTableEvent(e) {
        if (!this.gridApi) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[TableManager] cacheColumnStates was called before gridApi was set");
            return;
        }
        if ("finished" in e && !e.finished) {
            return;
        }
        const newColumnStates = this.gridApi.getColumnState();
        this._customizationColumnsMenuModel = this.buildColumnsMenuModel(newColumnStates);
        this.writeColumnStateToLocalStorage(newColumnStates);
    }
    writeColumnStateToLocalStorage(columnState) {
        var _a;
        if (!this.gridApi) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[TableManager] writeColumnStateToLocalStorage was called before gridApi was set");
            return;
        }
        if (!this.cacheName) {
            return;
        }
        const currentColumnState = (0,_components_GridWidget_GridCacheUtils__WEBPACK_IMPORTED_MODULE_0__.simplifyState)(columnState, this.defaultColumnStates);
        (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.setItem(this.cacheName, JSON.stringify(currentColumnState));
    }
    buildColumnsMenuModel(columns) {
        const visibleColumns = columns.filter((col) => col.hide === false);
        const selected = visibleColumns.map((col) => ({
            id: col.colId,
            name: this.columnDefinitions[col.colId].headerName,
            tooltip: "",
            draggable: true,
            pinned: false,
            addButtonIsVisible: true,
            pinButtonIsVisible: false
        }));
        const hiddenColumns = columns.filter((col) => col.hide === true);
        const available = hiddenColumns.map((col) => ({
            id: col.colId,
            name: this.columnDefinitions[col.colId].headerName,
            tooltip: ""
        }));
        return {
            available,
            selected
        };
    }
}


/***/ }),

/***/ "./src/components/Common/Table/config.ts":
/*!***********************************************!*\
  !*** ./src/components/Common/Table/config.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   BASE_GRID_OPTIONS: () => (/* binding */ BASE_GRID_OPTIONS)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./constants */ "./src/components/Common/Table/constants.ts");

const BASE_GRID_OPTIONS = {
    defaultColDef: {
        resizable: true,
        suppressHeaderMenuButton: true,
        sortable: true,
        width: _constants__WEBPACK_IMPORTED_MODULE_0__.DEFAULT_COLUMN_WIDTH
    },
    context: {
        maximumSentimentValue: 5.0
    },
    cacheBlockSize: _constants__WEBPACK_IMPORTED_MODULE_0__.MAX_ROWS_IN_RESPONSE,
    suppressContextMenu: true,
    groupDisplayType: "groupRows",
    suppressAggFuncInHeader: true,
    animateRows: true
};


/***/ }),

/***/ "./src/components/Common/Table/constants.ts":
/*!**************************************************!*\
  !*** ./src/components/Common/Table/constants.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DEFAULT_COLUMN_WIDTH: () => (/* binding */ DEFAULT_COLUMN_WIDTH),
/* harmony export */   MAX_ROWS_IN_RESPONSE: () => (/* binding */ MAX_ROWS_IN_RESPONSE)
/* harmony export */ });
const DEFAULT_COLUMN_WIDTH = 200;
const MAX_ROWS_IN_RESPONSE = 500;


/***/ }),

/***/ "./src/components/Common/TableActiveCustomizationsRow/TableActiveCustomizationsRow.scss":
/*!**********************************************************************************************!*\
  !*** ./src/components/Common/TableActiveCustomizationsRow/TableActiveCustomizationsRow.scss ***!
  \**********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.customizations-row {
  padding: 0.5rem;
  display: flex;
  flex-flow: row wrap;
  column-gap: 0.5rem;
  align-items: center;
}

span#label {
  font-size: 14px;
  font-family: var(--brand-font-regular);
  font-weight: 400;
  color: var(--label-secondary);
}

md-chip::part(chip) {
  height: 24px;
}
md-chip::slotted([slot=custom-right-content]) {
  margin-left: 0.5rem;
}

.chip-close-button {
  background: none;
  border: none;
  height: 16px;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/TableActiveCustomizationsRow/TableActiveCustomizationsRow.scss */
/*# sourceURL=TableActiveCustomizationsRow.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/TableActiveCustomizationsRow/TableActiveCustomizationsRow.ts":
/*!********************************************************************************************!*\
  !*** ./src/components/Common/TableActiveCustomizationsRow/TableActiveCustomizationsRow.ts ***!
  \********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableActiveCustomizationsRow: () => (/* binding */ TableActiveCustomizationsRow)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _TableActiveCustomizationsRow_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./TableActiveCustomizationsRow.scss */ "./src/components/Common/TableActiveCustomizationsRow/TableActiveCustomizationsRow.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






let TableActiveCustomizationsRow = class TableActiveCustomizationsRow extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
    constructor() {
        super(...arguments);
        this.label = "";
        this.customizations = [];
    }
    static get styles() {
        return _TableActiveCustomizationsRow_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
    }
    render() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div class="customizations-row">
        <span id="label">${this.label}</span>

        ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_4__.repeat)(this.customizations, (customization) => JSON.stringify(customization), (customization) => (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
            <md-chip color="neutral" value=${this.renderFilterLabel(customization)}>
              <button class="chip-close-button" slot="custom-right-content">
                <md-icon
                  iconSet="preferMomentumDesign"
                  name="cancel-bold"
                  size="16"
                  @click=${this.onChipRemoved(customization.id)}
                ></md-icon>
              </button>
            </md-chip>
          `)}

        <md-button variant="secondary" size="28" @click=${this.onClearAllClicked}
          >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:clearAll")}</md-button
        >
      </div>
    `;
    }
    renderFilterLabel(filter) {
        let labelText = filter.label;
        if (filter.customizations.multiSelectOptions) {
            labelText += ` (${filter.customizations.multiSelectOptions.length})`;
        }
        return labelText;
    }
    onChipRemoved(customizationId) {
        return (e) => {
            e.stopPropagation();
            this.dispatchRemovedEvent([customizationId]);
        };
    }
    onClearAllClicked(e) {
        e.stopPropagation();
        const customizationIds = this.customizations.map((customization) => customization.id);
        this.dispatchRemovedEvent(customizationIds);
    }
    dispatchRemovedEvent(customizationIds) {
        this.dispatchEvent(new CustomEvent("customizations-removed", {
            bubbles: true,
            composed: true,
            detail: {
                removedCustomizations: customizationIds
            }
        }));
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
], TableActiveCustomizationsRow.prototype, "label", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ attribute: false })
], TableActiveCustomizationsRow.prototype, "customizations", void 0);
TableActiveCustomizationsRow = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-table-active-customizations-row")
], TableActiveCustomizationsRow);



/***/ }),

/***/ "./src/components/Common/TableCustomizationMenu/TableCustomizationMenu.scss":
/*!**********************************************************************************!*\
  !*** ./src/components/Common/TableCustomizationMenu/TableCustomizationMenu.scss ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`#table-customization-menu {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 16px;
  display: grid;
  grid-template-columns: 1fr auto auto;
  grid-template-rows: auto 1fr auto;
  column-gap: 8px;
  overflow: hidden;
}

#title {
  font-size: var(--body-primary-font-size);
  line-height: 1.5;
  font-weight: 700;
  margin: 0 0 8px 0;
  grid-area: 1/1/2/-1;
  color: var(--md-textColor-secondary);
}

#exit-button {
  grid-area: 1/3/2/4;
}

div#buttons-row {
  padding-top: 16px;
  grid-area: 3/1/4/-1;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  column-gap: 8px;
}

div#left-buttons-row {
  padding-top: 16px;
  grid-area: 3/1/4/2;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  column-gap: 8px;
  width: 100%;
}

agentx-wc-table-customize-columns-menu {
  grid-area: 2/1/3/-1;
  height: 100%;
  overflow: hidden;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/TableCustomizationMenu/TableCustomizationMenu.scss */
/*# sourceURL=TableCustomizationMenu.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/TableCustomizationMenu/TableCustomizationMenu.ts":
/*!********************************************************************************!*\
  !*** ./src/components/Common/TableCustomizationMenu/TableCustomizationMenu.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableCustomizationMenu: () => (/* binding */ TableCustomizationMenu)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lodash */ "../../node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _TableCustomizationMenu_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./TableCustomizationMenu.scss */ "./src/components/Common/TableCustomizationMenu/TableCustomizationMenu.scss");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./constants */ "./src/components/Common/TableCustomizationMenu/constants.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






let TableCustomizationMenu = class TableCustomizationMenu extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
    constructor() {
        super(...arguments);
        this.stagedColumnsData = { available: [], selected: [] };
        this._columnsData = { available: [], selected: [] };
    }
    get columnsData() {
        return this._columnsData;
    }
    set columnsData(newValue) {
        const oldVal = this._columnsData;
        this._columnsData = newValue;
        this.requestUpdate("columnsData", oldVal);
        this.stagedColumnsData = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.cloneDeep)(newValue);
    }
    static get styles() {
        return _TableCustomizationMenu_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
      <div id="table-customization-menu">
        <h1 id="title">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:customizeView")}</h1>
        <md-button
          id="exit-button"
          variant="ghost"
          circle
          size="28"
          variant="ghost"
          @click=${this.onCancelClicked}
          ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:cancel")}
        >
          <md-icon slot="icon" name="cancel-bold" iconSet="momentumDesign" size="16" ariaHidden="true"></md-icon>
        </md-button>

        <agentx-wc-table-customize-columns-menu
          .columnsData=${this.stagedColumnsData}
          .maxSelectedColumns=${this.maxSelectedColumns}
          @column-added=${this.onColumnAdded}
          @column-removed=${this.onColumnRemoved}
          @column-pinned=${this.onColumnPinnedChanged}
          @column-unpinned=${this.onColumnPinnedChanged}
          @columns-rearranged=${this.onColumnsRearranged}
        ></agentx-wc-table-customize-columns-menu>

        <div id="left-buttons-row">
          <md-button id="reset-button" variant="secondary" size="32" @click=${this.onResetClicked}>
            <md-icon slot="icon" name="reset-bold" iconSet="momentumDesign" size="16" ariaHidden="true"></md-icon>
            <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats:reset")}</span>
          </md-button>
        </div>

        <div id="buttons-row">
          <md-button id="close-button" size="32" variant="secondary" @click=${this.onCancelClicked}>
            ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:notifications:close")}
          </md-button>
          <md-button
            id="save-button"
            size="32"
            variant="primary"
            @click=${this.onSaveClicked}
            ?disabled=${!this.hasCustomizations}
          >
            ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:apply")}
          </md-button>
        </div>
      </div>
    `;
    }
    onColumnAdded(e) {
        e.stopPropagation();
        if (!("columnId" in e.detail)) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("Failed to add column: columnId not provided");
            return;
        }
        const columnId = e.detail.columnId;
        const newColumnData = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.cloneDeep)(this.stagedColumnsData);
        if (this.maxSelectedColumns && newColumnData.selected.length >= this.maxSelectedColumns) {
            return;
        }
        const oldColIndex = newColumnData.available.findIndex((col) => col.id === columnId);
        const addedColumnData = Object.assign(Object.assign({}, newColumnData.available.splice(oldColIndex, 1)[0]), { draggable: true, pinned: false, addButtonIsVisible: true, pinButtonIsVisible: false });
        const actionsRowIndex = newColumnData.selected.findIndex((col) => col.id === _constants__WEBPACK_IMPORTED_MODULE_5__.ACTIONS_COLUMN_ID);
        if (actionsRowIndex !== -1) {
            newColumnData.selected.splice(actionsRowIndex, 0, addedColumnData);
        }
        else {
            newColumnData.selected.push(addedColumnData);
        }
        this.stagedColumnsData = newColumnData;
    }
    onColumnRemoved(e) {
        e.stopPropagation();
        if (!("columnId" in e.detail)) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("Failed to remove column: columnId not provided");
            return;
        }
        const columnId = e.detail.columnId;
        const newColumnData = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.cloneDeep)(this.stagedColumnsData);
        const oldColIndex = newColumnData.selected.findIndex((col) => col.id === columnId);
        const removedColumnData = newColumnData.selected.splice(oldColIndex, 1)[0];
        newColumnData.available.push({
            id: removedColumnData.id,
            name: removedColumnData.name,
            tooltip: removedColumnData.tooltip
        });
        this.stagedColumnsData = newColumnData;
    }
    onColumnPinnedChanged(e) {
        e.stopPropagation();
        if (!("columnId" in e.detail)) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("Failed to add column: columnId not provided");
            return;
        }
        const columnId = e.detail.columnId;
        const newColumnData = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.cloneDeep)(this.stagedColumnsData);
        const newPinnedValue = e.type === "column-pinned";
        const selectedCol = newColumnData.selected.find((col) => col.id === columnId);
        if (selectedCol) {
            selectedCol.pinned = newPinnedValue;
        }
        this.stagedColumnsData = newColumnData;
    }
    onColumnsRearranged(e) {
        e.stopPropagation();
        if (!("newColumnData" in e.detail)) {
            return;
        }
        this.stagedColumnsData = e.detail.newColumnData;
    }
    onCancelClicked(e) {
        e.stopPropagation();
        this.dispatchEvent(new CustomEvent("close-customize-view", {
            composed: true,
            bubbles: true
        }));
        // reset staged customizations
        this.stagedColumnsData = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.cloneDeep)(this.columnsData);
    }
    get hasCustomizations() {
        return !(0,lodash__WEBPACK_IMPORTED_MODULE_3__.isEqual)(this.stagedColumnsData, this.columnsData);
    }
    onSaveClicked(e) {
        e.stopPropagation();
        // no-op if no staged customizations have been made
        if (!this.hasCustomizations) {
            return;
        }
        this.dispatchEvent(new CustomEvent("save-customizations", {
            composed: true,
            bubbles: true,
            detail: {
                columnsData: this.stagedColumnsData
            }
        }));
    }
    onResetClicked(e) {
        e.stopPropagation();
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ attribute: false })
], TableCustomizationMenu.prototype, "columnsData", null);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
], TableCustomizationMenu.prototype, "maxSelectedColumns", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ attribute: false }),
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], TableCustomizationMenu.prototype, "stagedColumnsData", void 0);
TableCustomizationMenu = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-table-customization-menu")
], TableCustomizationMenu);



/***/ }),

/***/ "./src/components/Common/TableCustomizationMenu/TableCustomizeColumnsMenu/TableCustomizeColumnsMenu.scss":
/*!***************************************************************************************************************!*\
  !*** ./src/components/Common/TableCustomizationMenu/TableCustomizeColumnsMenu/TableCustomizeColumnsMenu.scss ***!
  \***************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`#table-customize-columns-menu {
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1px 1fr;
  column-gap: 16px;
  grid-template-rows: auto auto 1fr;
}

md-input {
  display: block;
  width: 100%;
  height: var(--search-input-height);
  grid-area: 2/1/2/2;
}
md-input::part(md-input-container) {
  margin-bottom: 0;
}

md-input:nth-of-type(2) {
  grid-area: 2/3/2/4;
}

span.column-label {
  display: inline-block;
  padding: 16px 0 12px 0;
  font-size: var(--body-secondary-font-size);
  line-height: 20px;
}
span.column-label#available-column-label {
  grid-area: 1/1/1/2;
}
span.column-label#selected-column-label {
  grid-area: 1/3/1/4;
}

div.column-lists {
  grid-area: 4/1/5/4;
  display: grid;
  grid-template-columns: 1fr 1px 1fr;
  column-gap: 16px;
  height: 100%;
  align-items: start;
}

div.column {
  height: 100%;
  overflow: hidden auto;
  display: flex;
  flex-flow: column nowrap;
  row-gap: 2px;
  position: relative;
  margin-top: 10px;
  margin-bottom: 10px;
}
div.column#available-columns {
  grid-area: 1/1/2/2;
}
div.column#selected-columns {
  grid-area: 1/3/2/4;
}

div#drop-indicator {
  position: absolute;
  left: 8px;
  width: calc(100% - 16px);
  height: 2px;
  background-color: black;
  pointer-events: none;
}

div.separator {
  grid-area: 1/2/4/3;
  width: 1px;
  height: 100%;
  background: var(--md-separator-primary);
  margin: 0;
  padding: 0;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/TableCustomizationMenu/TableCustomizeColumnsMenu/TableCustomizeColumnsMenu.scss */
/*# sourceURL=TableCustomizeColumnsMenu.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/TableCustomizationMenu/TableCustomizeColumnsMenu/TableCustomizeColumnsMenu.ts":
/*!*************************************************************************************************************!*\
  !*** ./src/components/Common/TableCustomizationMenu/TableCustomizeColumnsMenu/TableCustomizeColumnsMenu.ts ***!
  \*************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableCustomizeColumnsMenu: () => (/* binding */ TableCustomizeColumnsMenu)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/style-map */ "lit-html/directives/style-map");
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../constants */ "./src/components/Common/TableCustomizationMenu/constants.ts");
/* harmony import */ var _TableCustomizeColumnsMenu_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./TableCustomizeColumnsMenu.scss */ "./src/components/Common/TableCustomizationMenu/TableCustomizeColumnsMenu/TableCustomizeColumnsMenu.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







let TableCustomizeColumnsMenu = class TableCustomizeColumnsMenu extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.columnsData = { available: [], selected: [] };
        this.dropIndicatorY = null;
        this.availableSearchText = "";
        this.selectedSearchText = "";
    }
    static get styles() {
        return _TableCustomizeColumnsMenu_scss__WEBPACK_IMPORTED_MODULE_6__["default"];
    }
    render() {
        const maxSelectedColumnsString = this.maxSelectedColumns !== undefined ? `/${this.maxSelectedColumns}` : "";
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <div id="table-customize-columns-menu">
        <span class="column-label" id="available-column-label"
          >Available columns (${this.columnsData.available.length})</span
        >
        <span class="column-label" id="selected-column-label"
          >Selected columns (${this.columnsData.selected.length}${maxSelectedColumnsString})</span
        >
        <md-input
          id="available-search"
          searchable
          placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:search")}
          @input-change=${this.onAvailableSearchInputTextChanged}
          ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats:availableSearch")}
        ></md-input>
        <md-input
          id="selected-search"
          searchable
          placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:search")}
          @input-change=${this.onSelectedFilterInputTextChanged}
          ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:queueStats:selectedSearch")}
        ></md-input>

        ${this.renderAvailableColumnList()}
        <div class="separator"></div>
        ${this.renderSelectedColumnList()}
      </div>
    `;
    }
    renderAvailableColumnList() {
        const filteredAvailableColumns = this.columnsData.available.filter((col) => col.name.toLowerCase().includes(this.availableSearchText));
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <div class="column" id="available-column">
        ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_3__.repeat)(filteredAvailableColumns, (columnData) => columnData.id, (columnData) => (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
            <agentx-wc-table-customize-columns-row
              .columnId=${columnData.id}
              name="${columnData.name}"
              tooltip="${columnData.tooltip}"
              addButtonIsVisible
            ></agentx-wc-table-customize-columns-row>
          `)}
      </div>
    `;
    }
    renderSelectedColumnList() {
        var _a;
        const filteredSelectedColumns = this.columnsData.selected.filter((col) => col.name.toLowerCase().includes(this.selectedSearchText));
        const dropIndicatorPosition = `${(_a = this.dropIndicatorY) !== null && _a !== void 0 ? _a : 0}px`;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <div
        class="column"
        id="selected-column"
        @dragover=${this.onDragOver}
        @dragleave=${this.endDrag}
        @drop=${this.onDrop}
        @dragend=${this.endDrag}
      >
        ${this.dropIndicatorY !== null
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ` <div id="drop-indicator" style=${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_4__.styleMap)({ top: dropIndicatorPosition })}></div> `
            : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}
        ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_3__.repeat)(filteredSelectedColumns, (columnData) => columnData.id, (columnData) => (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
            <agentx-wc-table-customize-columns-row
              .columnId=${columnData.id}
              name="${columnData.name}"
              tooltip="${columnData.tooltip}"
              added
              .addButtonIsVisible=${columnData.addButtonIsVisible}
              ?draggable=${columnData.draggable}
              ?pinned=${columnData.pinned}
              .pinButtonIsVisible=${columnData.pinButtonIsVisible}
            ></agentx-wc-table-customize-columns-row>
          `)}
      </div>
    `;
    }
    onDragOver(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!this.selectedColumn) {
            return;
        }
        const dropIndex = this.getDropIndex(e.clientY);
        if (!isNaN(dropIndex)) {
            const selectedColumnRect = this.selectedColumn.getBoundingClientRect();
            const rowViewRects = this.getSelectedRowViewRects();
            if (dropIndex === -1 || dropIndex === 0) {
                this.dropIndicatorY = 1; // 1px prevents the drop indicator from gettling clipped
            }
            else if (dropIndex === rowViewRects.length) {
                this.dropIndicatorY = rowViewRects[rowViewRects.length - 1].bottomY + 1 - selectedColumnRect.top;
            }
            else {
                this.dropIndicatorY = rowViewRects[dropIndex].topY - selectedColumnRect.top;
            }
        }
    }
    onDrop(e) {
        e.preventDefault();
        e.stopPropagation();
        this.dropIndicatorY = null;
        const dropIndex = this.getDropIndex(e.clientY);
        if (isNaN(dropIndex)) {
            return;
        }
        const dragColId = e.dataTransfer.getData("columnId");
        const newColumnData = {
            available: this.columnsData.available,
            selected: this.rearrangeSelectedColumns(dragColId, dropIndex)
        };
        this.dispatchEvent(new CustomEvent("columns-rearranged", {
            bubbles: true,
            composed: true,
            detail: { newColumnData }
        }));
    }
    getSelectedRowViewRects() {
        if (!this.selectedColumnRowViews) {
            return [];
        }
        return Array.from(this.selectedColumnRowViews)
            .filter((_col, i) => this.columnsData.selected[i].id !== _constants__WEBPACK_IMPORTED_MODULE_5__.ACTIONS_COLUMN_ID)
            .map((rowView) => {
            const rowViewRect = rowView.getBoundingClientRect();
            const topY = rowViewRect.top - 1;
            const midY = rowViewRect.top + rowViewRect.height / 2;
            const bottomY = rowViewRect.bottom + 1;
            return { topY, midY, bottomY };
        });
    }
    getDropIndex(mouseY) {
        const rowViewRects = this.getSelectedRowViewRects();
        let dropIndex = NaN;
        for (let i = 0; i < rowViewRects.length; i++) {
            const rowViewPos = rowViewRects[i];
            if (i === 0 && mouseY < rowViewPos.topY) {
                dropIndex = -1;
            }
            else if (mouseY >= rowViewPos.topY && mouseY <= rowViewPos.bottomY) {
                dropIndex = mouseY <= rowViewPos.midY ? i : i + 1;
            }
            else if (i === rowViewRects.length - 1 && mouseY > rowViewPos.bottomY) {
                dropIndex = i + 1;
            }
        }
        return dropIndex;
    }
    rearrangeSelectedColumns(columnId, dropIndex) {
        const selectedColumns = [...this.columnsData.selected];
        const dragColIndex = selectedColumns.findIndex((column) => column.id === columnId);
        if (dropIndex === selectedColumns.length) {
            const draggedCol = selectedColumns.splice(dragColIndex, 1)[0];
            selectedColumns.push(draggedCol);
        }
        else {
            const draggedCol = selectedColumns.splice(dragColIndex, 1)[0];
            const newDropIndex = dragColIndex < dropIndex ? dropIndex - 1 : dropIndex;
            selectedColumns.splice(newDropIndex, 0, draggedCol);
        }
        return selectedColumns;
    }
    onAvailableSearchInputTextChanged(e) {
        e.stopPropagation();
        const newSearchText = typeof e.detail.value === "string" ? e.detail.value.toLowerCase() : "";
        this.availableSearchText = newSearchText;
    }
    onSelectedFilterInputTextChanged(e) {
        e.stopPropagation();
        const newSearchText = typeof e.detail.value === "string" ? e.detail.value.toLowerCase() : "";
        this.selectedSearchText = newSearchText;
    }
    endDrag(e) {
        e.stopPropagation();
        this.dropIndicatorY = null;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ attribute: false })
], TableCustomizeColumnsMenu.prototype, "columnsData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], TableCustomizeColumnsMenu.prototype, "maxSelectedColumns", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.query)("#selected-column")
], TableCustomizeColumnsMenu.prototype, "selectedColumn", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
], TableCustomizeColumnsMenu.prototype, "dropIndicatorY", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
], TableCustomizeColumnsMenu.prototype, "availableSearchText", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
], TableCustomizeColumnsMenu.prototype, "selectedSearchText", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.queryAll)("#selected-column > agentx-wc-table-customize-columns-row")
], TableCustomizeColumnsMenu.prototype, "selectedColumnRowViews", void 0);
TableCustomizeColumnsMenu = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-table-customize-columns-menu")
], TableCustomizeColumnsMenu);



/***/ }),

/***/ "./src/components/Common/TableCustomizationMenu/TableCustomizeColumnsMenu/TableCustomizeColumnsRow/TableCustomizeColumnsRow.scss":
/*!***************************************************************************************************************************************!*\
  !*** ./src/components/Common/TableCustomizationMenu/TableCustomizeColumnsMenu/TableCustomizeColumnsRow/TableCustomizeColumnsRow.scss ***!
  \***************************************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  box-sizing: border-box;
  display: block;
  width: 100%;
}

#table-customize-columns-row {
  height: 36px;
  display: flex;
  max-width: 100%;
  flex-flow: row nowrap;
  align-items: center;
  padding: 0 12px;
  background-color: var(--md-background-secondary);
  gap: 12px;
  border-radius: 8px;
}

#add-icon {
  color: var(--md-gray-60);
}

#remove-icon {
  color: var(--md-red-60);
}

span {
  flex: 1;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/TableCustomizationMenu/TableCustomizeColumnsMenu/TableCustomizeColumnsRow/TableCustomizeColumnsRow.scss */
/*# sourceURL=TableCustomizeColumnsRow.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/TableCustomizationMenu/TableCustomizeColumnsMenu/TableCustomizeColumnsRow/TableCustomizeColumnsRow.ts":
/*!*************************************************************************************************************************************!*\
  !*** ./src/components/Common/TableCustomizationMenu/TableCustomizeColumnsMenu/TableCustomizeColumnsRow/TableCustomizeColumnsRow.ts ***!
  \*************************************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableCustomizeColumnsRow: () => (/* binding */ TableCustomizeColumnsRow)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _TableCustomizeColumnsRow_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./TableCustomizeColumnsRow.scss */ "./src/components/Common/TableCustomizationMenu/TableCustomizeColumnsMenu/TableCustomizeColumnsRow/TableCustomizeColumnsRow.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





let TableCustomizeColumnsRow = class TableCustomizeColumnsRow extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
    constructor() {
        super(...arguments);
        this.name = "";
        this.draggable = false;
        this.added = false;
        this.addButtonIsVisible = false;
        this.pinned = false;
        this.pinButtonIsVisible = false;
        this.tooltip = "";
    }
    static get styles() {
        return _TableCustomizeColumnsRow_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    render() {
        const addButtonId = this.added ? "remove-button" : "add-button";
        const addIcon = this.added ? "remove_16" : "add_16";
        const addIconId = this.added ? "remove-icon" : "add-icon";
        const pinButtonId = this.pinned === true ? "pin-button" : "unpin-button";
        const pinIcon = this.pinned === true ? "pin-active_20" : "pin_16";
        const addButtonClickHandler = this.added ? this.emitChangeEvent("removed") : this.emitChangeEvent("added");
        const pinButtonClickHandler = this.pinned ? this.emitChangeEvent("unpinned") : this.emitChangeEvent("pinned");
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
      <div id="table-customize-columns-row" draggable="${this.draggable}" @dragstart=${this.onDragStart}>
        <!-- drag handle -->
        ${this.draggable
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
              <md-icon id="drag-handle" size="16" iconSet="preferMomentumDesign" name="panel-control-dragger_16">
              </md-icon>
            `
            : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}

        <!-- add/remove button -->
        ${this.addButtonIsVisible
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
              <md-button circle size="28" id="${addButtonId}" @click=${addButtonClickHandler}>
                <md-icon slot="icon" iconSet="preferMomentumDesign" name="${addIcon}" id="${addIconId}"></md-icon>
              </md-button>
            `
            : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}

        <!-- label -->
        <span id="label">${this.name}</span>

        <!-- pinned icon -->
        ${this.pinButtonIsVisible
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
              <md-button circle size="28" id="${pinButtonId}" @click=${pinButtonClickHandler}>
                <md-icon slot="icon" iconSet="preferMomentumDesign" size="16" name="${pinIcon}"></md-icon>
              </md-button>
            `
            : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}

        <!-- info tooltip -->
        ${this.tooltip
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
              <md-tooltip id="tooltip" placement="bottom" message="${this.tooltip}">
                <md-button circle size="28">
                  <md-icon slot="icon" iconSet="preferMomentumDesign" name="webpop_16"></md-icon>
                </md-button>
              </md-tooltip>
            `
            : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
      </div>
    `;
    }
    emitChangeEvent(change) {
        const eventDetail = {
            composed: true,
            bubbles: true,
            detail: {
                columnId: this.columnId
            }
        };
        return (e) => {
            e.stopPropagation();
            if (change === "added") {
                this.dispatchEvent(new CustomEvent("column-added", eventDetail));
            }
            else if (change === "removed") {
                this.dispatchEvent(new CustomEvent("column-removed", eventDetail));
            }
            else if (change === "pinned") {
                this.dispatchEvent(new CustomEvent("column-pinned", eventDetail));
            }
            else if (change === "unpinned") {
                this.dispatchEvent(new CustomEvent("column-unpinned", eventDetail));
            }
            else {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("Unrecognised column data change type: ", change);
                return;
            }
        };
    }
    onDragStart(e) {
        if (!e.dataTransfer) {
            return;
        }
        e.dataTransfer.setData("columnId", this.columnId);
        e.dataTransfer.effectAllowed = "move";
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ attribute: false })
], TableCustomizeColumnsRow.prototype, "columnId", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
], TableCustomizeColumnsRow.prototype, "name", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
], TableCustomizeColumnsRow.prototype, "draggable", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
], TableCustomizeColumnsRow.prototype, "added", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
], TableCustomizeColumnsRow.prototype, "addButtonIsVisible", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
], TableCustomizeColumnsRow.prototype, "pinned", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
], TableCustomizeColumnsRow.prototype, "pinButtonIsVisible", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
], TableCustomizeColumnsRow.prototype, "tooltip", void 0);
TableCustomizeColumnsRow = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-table-customize-columns-row")
], TableCustomizeColumnsRow);



/***/ }),

/***/ "./src/components/Common/TableCustomizationMenu/TableCustomizeGroupByMenu/TableCustomizeGroupByMenu.scss":
/*!***************************************************************************************************************!*\
  !*** ./src/components/Common/TableCustomizationMenu/TableCustomizeGroupByMenu/TableCustomizeGroupByMenu.scss ***!
  \***************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`#table-customize-group-by-menu {
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto 1fr;
  overflow: hidden;
}

md-input {
  display: block;
  width: 50%;
  grid-area: 1/1/2/2;
}

div#rows-container {
  grid-area: 2/1/3/2;
  height: 100%;
  overflow: hidden auto;
  padding: 2px 12px;
}

div#rows-list {
  display: flex;
  flex-flow: column nowrap;
}

md-checkbox {
  display: block;
  padding: 8px 12px;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/TableCustomizationMenu/TableCustomizeGroupByMenu/TableCustomizeGroupByMenu.scss */
/*# sourceURL=TableCustomizeGroupByMenu.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/TableCustomizationMenu/TableCustomizeGroupByMenu/TableCustomizeGroupByMenu.ts":
/*!*************************************************************************************************************!*\
  !*** ./src/components/Common/TableCustomizationMenu/TableCustomizeGroupByMenu/TableCustomizeGroupByMenu.ts ***!
  \*************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableCustomizeGroupByMenu: () => (/* binding */ TableCustomizeGroupByMenu)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _TableCustomizeGroupByMenu_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./TableCustomizeGroupByMenu.scss */ "./src/components/Common/TableCustomizationMenu/TableCustomizeGroupByMenu/TableCustomizeGroupByMenu.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let TableCustomizeGroupByMenu = class TableCustomizeGroupByMenu extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.rowsData = [];
        this.searchText = "";
    }
    static get styles() {
        return _TableCustomizeGroupByMenu_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    render() {
        const filteredGroupRowData = this.rowsData.filter((rowData) => rowData.name.toLowerCase().includes(this.searchText));
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <div id="table-customize-group-by-menu">
        <md-input
          searchable
          placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:search")}"
          @input-change=${this.onSearchTextChanged}
        ></md-input>

        <div id="rows-container">
          <div id="rows-list">
            ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_2__.repeat)(filteredGroupRowData, (rowData) => rowData.id, (rowData) => (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
                <md-checkbox
                  .checked=${rowData.checked}
                  @checkbox-change=${this.emitGroupByDataChangedEvent(rowData.id)}
                >
                  ${rowData.name}
                </md-checkbox>
              `)}
          </div>
        </div>
      </div>
    `;
    }
    emitGroupByDataChangedEvent(groupById) {
        return (e) => {
            e.stopPropagation();
            if (!e.target || !("checked" in e.target)) {
                return;
            }
            this.dispatchEvent(new CustomEvent("group-by-data-changed", {
                bubbles: true,
                composed: true,
                detail: {
                    groupById,
                    newValue: e.target.checked
                }
            }));
        };
    }
    onSearchTextChanged(e) {
        var _a, _b;
        e.stopPropagation();
        this.searchText = (_b = (_a = this.searchInput) === null || _a === void 0 ? void 0 : _a.value.toLowerCase()) !== null && _b !== void 0 ? _b : "";
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ attribute: false })
], TableCustomizeGroupByMenu.prototype, "rowsData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.query)("md-input")
], TableCustomizeGroupByMenu.prototype, "searchInput", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
], TableCustomizeGroupByMenu.prototype, "searchText", void 0);
TableCustomizeGroupByMenu = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-table-customize-group-by-menu")
], TableCustomizeGroupByMenu);



/***/ }),

/***/ "./src/components/Common/TableCustomizationMenu/constants.ts":
/*!*******************************************************************!*\
  !*** ./src/components/Common/TableCustomizationMenu/constants.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ACTIONS_COLUMN_ID: () => (/* binding */ ACTIONS_COLUMN_ID),
/* harmony export */   MAX_SELECTED_COLUMNS: () => (/* binding */ MAX_SELECTED_COLUMNS)
/* harmony export */ });
const ACTIONS_COLUMN_ID = "actions";
const MAX_SELECTED_COLUMNS = 10;


/***/ }),

/***/ "./src/components/Common/TableFilterMenu/TableFilterCategoriesMenu/TableFilterCategoriesMenu.scss":
/*!********************************************************************************************************!*\
  !*** ./src/components/Common/TableFilterMenu/TableFilterCategoriesMenu/TableFilterCategoriesMenu.scss ***!
  \********************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host,
div#categories-menu {
  display: block;
  width: 100%;
  height: 100%;
}

div#categories-menu {
  display: flex;
  flex-flow: column nowrap;
}

h3 {
  font-family: var(--brand-font-medium);
  font-size: var(--body-secondary-font-size);
  font-weight: var(--brand-font-weight-regular);
  line-height: var(--body-primary-line-height);
  color: var(--md-primary-text-color);
  margin: 0;
  margin-bottom: 6px;
}

div#scroll-area {
  flex: 1;
  overflow: hidden auto;
  display: flex;
  flex-flow: column nowrap;
}

div.category-list-item {
  padding: 8px 12px;
  border-radius: 8px;
  display: flex;
  flex-flow: row nowrap;
  cursor: pointer;
}
div.category-list-item:hover {
  background-color: var(--list-hover-background);
}
div.category-list-item > span {
  flex-grow: 1;
  font-family: var(--brand-font-medium);
  font-size: var(--body-secondary-font-size);
  font-weight: var(--brand-font-weight-regular);
  line-height: var(--body-primary-line-height);
  color: var(--md-primary-text-color);
}
div.category-list-item button.info-btn {
  background: none;
  border: none;
  display: inline;
  vertical-align: center;
  padding: 0;
  height: 16px;
}

md-tooltip::part(tooltip_reference) {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  height: 100%;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/TableFilterMenu/TableFilterCategoriesMenu/TableFilterCategoriesMenu.scss */
/*# sourceURL=TableFilterCategoriesMenu.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/TableFilterMenu/TableFilterCategoriesMenu/TableFilterCategoriesMenu.ts":
/*!******************************************************************************************************!*\
  !*** ./src/components/Common/TableFilterMenu/TableFilterCategoriesMenu/TableFilterCategoriesMenu.ts ***!
  \******************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableFilterCategoriesMenu: () => (/* binding */ TableFilterCategoriesMenu)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _TableFilterCategoriesMenu_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TableFilterCategoriesMenu.scss */ "./src/components/Common/TableFilterMenu/TableFilterCategoriesMenu/TableFilterCategoriesMenu.scss");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_3__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let TableFilterCategoriesMenu = class TableFilterCategoriesMenu extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.categories = [];
        this.searchInputText = "";
    }
    static get styles() {
        return _TableFilterCategoriesMenu_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ` <div id="categories-menu">
      <h3>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:categories")}</h3>

      <md-input
        searchable
        placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:search")}
        @input-change=${this.onSearchInputTextChanged}
        newMomentum
      ></md-input>

      ${this.renderCategoriesList()}
    </div>`;
    }
    renderCategoriesList() {
        const matchingCategories = this.searchInputText
            ? this.categories.filter((category) => category.label.toLowerCase().includes(this.searchInputText.toLowerCase()))
            : this.categories;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <div id="scroll-area">
        ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_3__.repeat)(matchingCategories, (category) => category.id, (category) => (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<div class="category-list-item" @click=${() => this.onCategoryClicked(category.id)}>
              <span>${category.label}</span>
              <md-tooltip id="tooltip" placement="bottom" message=${category.tooltip}>
                <button class="info-btn">
                  <md-icon slot="icon" iconSet="preferMomentumDesign" name="webpop_16"></md-icon>
                </button>
              </md-tooltip>
            </div>`)}
      </div>
    `;
    }
    onSearchInputTextChanged(e) {
        const input = e.target;
        this.searchInputText = input.value;
    }
    onCategoryClicked(categoryId) {
        this.dispatchEvent(new CustomEvent("category-selected", {
            detail: { categoryId },
            bubbles: true,
            composed: true
        }));
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ attribute: false })
], TableFilterCategoriesMenu.prototype, "categories", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
], TableFilterCategoriesMenu.prototype, "searchInputText", void 0);
TableFilterCategoriesMenu = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-table-filter-categories-menu")
], TableFilterCategoriesMenu);



/***/ }),

/***/ "./src/components/Common/TableFilterMenu/TableFilterMenu.scss":
/*!********************************************************************!*\
  !*** ./src/components/Common/TableFilterMenu/TableFilterMenu.scss ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`* {
  box-sizing: border-box;
}

:host {
  display: block;
  height: 100%;
  width: 100%;
}

div#filter-menu {
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1px 1fr;
  grid-template-rows: auto 1fr auto;
  padding: var(--vw-padding);
}

div#top {
  grid-row: 1/2;
  grid-column: 1/4;
}

h2 {
  margin: 0;
  line-height: var(--body-primary-line-height);
  font-size: var(--body-primary-font-size);
  font-weight: var(--brand-font-weight-bold);
  font-family: var(--brand-font-medium);
}

div#vertical-separator {
  grid-row: 2/3;
  grid-column: 2/3;
  background-color: gray;
}

div#left {
  grid-row: 2/3;
  grid-column: 1/2;
}

#right {
  grid-row: 2/3;
  grid-column: 3/4;
  overflow: hidden;
}

div#bottom {
  grid-row: 3/4;
  grid-column: 1/4;
  display: flex;
  flex-flow: row nowrap;
  column-gap: 8px;
  font-size: var(--body-secondary-font-size);
  align-items: center;
}

#horizontal-spacer {
  flex: 1;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/TableFilterMenu/TableFilterMenu.scss */
/*# sourceURL=TableFilterMenu.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/TableFilterMenu/TableFilterMenu.ts":
/*!******************************************************************!*\
  !*** ./src/components/Common/TableFilterMenu/TableFilterMenu.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableFilterMenu: () => (/* binding */ TableFilterMenu)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lodash */ "../../node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _TableActiveCustomizationsRow_TableActiveCustomizationsRow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../TableActiveCustomizationsRow/TableActiveCustomizationsRow */ "./src/components/Common/TableActiveCustomizationsRow/TableActiveCustomizationsRow.ts");
/* harmony import */ var _TableFilterMenu_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./TableFilterMenu.scss */ "./src/components/Common/TableFilterMenu/TableFilterMenu.scss");
/* harmony import */ var _TableFilterMultiSelectMenu_TableFilterMultiSelectMenu__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./TableFilterMultiSelectMenu/TableFilterMultiSelectMenu */ "./src/components/Common/TableFilterMenu/TableFilterMultiSelectMenu/TableFilterMultiSelectMenu.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








let TableFilterMenu = class TableFilterMenu extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
    constructor() {
        super(...arguments);
        this.matchedInteractionsCount = 0;
        this.selectedFilters = [];
    }
    static get styles() {
        return _TableFilterMenu_scss__WEBPACK_IMPORTED_MODULE_6__["default"];
    }
    onSelectedFilterValuesChanged(event) {
        if (!("selectedFilterValues" in event.detail) ||
            !Array.isArray(event.detail.selectedFilterValues) ||
            !("categoryId" in event.detail)) {
            return;
        }
        const newSelectedFilters = (0,lodash__WEBPACK_IMPORTED_MODULE_4__.cloneDeep)(this.selectedFilters);
        const hasSelectedFilterValues = event.detail.selectedFilterValues.length > 0;
        const machingFilterIndex = this.selectedFilters.findIndex((filter) => filter.id === event.detail.categoryId);
        if (!hasSelectedFilterValues && machingFilterIndex > -1) {
            newSelectedFilters.splice(machingFilterIndex, 1);
        }
        else if (hasSelectedFilterValues && machingFilterIndex > -1) {
            newSelectedFilters[machingFilterIndex].customizations.multiSelectOptions = event.detail.selectedFilterValues;
        }
        else {
            newSelectedFilters.push({
                id: event.detail.categoryId,
                label: "Channel",
                customizations: {
                    multiSelectOptions: event.detail.selectedFilterValues
                }
            });
        }
        this.selectedFilters = newSelectedFilters;
    }
    onCustomizationsRemoved(event) {
        var _a;
        if (!("removedCustomizations" in event.detail) || !Array.isArray(event.detail.removedCustomizations)) {
            return;
        }
        const removedCustomizations = event.detail.removedCustomizations;
        this.selectedFilters = this.selectedFilters.filter((filter) => !removedCustomizations.includes(filter.id));
        (_a = this.filterMultiSelectMenu) === null || _a === void 0 ? void 0 : _a.unsetCheckboxes();
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
      <div id="filter-menu">
        <div id="top">
          <h2>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:filter")}</h2>

          ${this.selectedFilters.length > 0
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                <agentx-wc-table-active-customizations-row
                  label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:selectedFilters")}
                  .customizations=${this.selectedFilters}
                  @customizations-removed=${this.onCustomizationsRemoved}
                >
                </agentx-wc-table-active-customizations-row>
              `
            : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
        </div>

        <div id="left"></div>

        <div id="vertical-separator"></div>

        <agentx-wc-table-filter-multi-select-menu
          id="right"
          @selected-filter-values-changed=${this.onSelectedFilterValuesChanged}
        ></agentx-wc-table-filter-multi-select-menu>

        <div id="bottom">
          <span id="match-label"
            >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:x_interactions_match_your_filter", undefined, {
            count: this.matchedInteractionsCount
        })}</span
          >

          <div id="horizontal-spacer"></div>

          <md-button variant="secondary" id="close-button" @click=${this.onCancelClicked}
            >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:notifications:close")}</md-button
          >
          <md-button variant="primary" id="apply-button">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:apply")}</md-button>
        </div>
      </div>
    `;
    }
    onCancelClicked() {
        this.dispatchEvent(new CustomEvent("cancel-clicked"));
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)("agentx-wc-table-filter-multi-select-menu")
], TableFilterMenu.prototype, "filterMultiSelectMenu", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
], TableFilterMenu.prototype, "matchedInteractionsCount", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ attribute: false })
], TableFilterMenu.prototype, "selectedFilters", void 0);
TableFilterMenu = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-table-filter-menu")
], TableFilterMenu);



/***/ }),

/***/ "./src/components/Common/TableFilterMenu/TableFilterMultiSelectMenu/TableFilterMultiSelectMenu.scss":
/*!**********************************************************************************************************!*\
  !*** ./src/components/Common/TableFilterMenu/TableFilterMultiSelectMenu/TableFilterMultiSelectMenu.scss ***!
  \**********************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:host {
  display: block;
  height: 100%;
  width: 100%;
}

#multi-select-menu {
  height: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto auto 1fr;
  padding: 0 16px 16px 16px;
}

.title-label,
.selected-label {
  font-family: var(--brand-font-medium);
  font-size: var(--body-secondary-font-size);
  font-weight: var(--brand-font-weight-regular);
}

h3.title-label {
  grid-column: 1/2;
  grid-row: 1/2;
  color: var(--md-primary-text-color);
  margin-bottom: 8px;
}

.selected-label {
  grid-column: 2/3;
  grid-row: 1/2;
  color: var(--md-secondary-text-color);
}

md-input {
  grid-column: 1/3;
  grid-row: 2/3;
  margin-bottom: 8px;
}

md-checkbox {
  display: block;
  overflow: visible;
}

md-checkbox#select-all {
  grid-column: 1/3;
  grid-row: 3/4;
  margin-left: 12px;
}

div#scroll-area {
  grid-column: 1/3;
  grid-row: 4/5;
  overflow: hidden auto;
  padding: 8px 12px;
}
div#scroll-area > md-checkbox:not(:last-child) {
  margin-bottom: 8px;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/TableFilterMenu/TableFilterMultiSelectMenu/TableFilterMultiSelectMenu.scss */
/*# sourceURL=TableFilterMultiSelectMenu.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/TableFilterMenu/TableFilterMultiSelectMenu/TableFilterMultiSelectMenu.ts":
/*!********************************************************************************************************!*\
  !*** ./src/components/Common/TableFilterMenu/TableFilterMultiSelectMenu/TableFilterMultiSelectMenu.ts ***!
  \********************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableFilterMultiSelectMenu: () => (/* binding */ TableFilterMultiSelectMenu)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _TableFilterMultiSelectMenu_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./TableFilterMultiSelectMenu.scss */ "./src/components/Common/TableFilterMenu/TableFilterMultiSelectMenu/TableFilterMultiSelectMenu.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let TableFilterMultiSelectMenu = class TableFilterMultiSelectMenu extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
    constructor() {
        super(...arguments);
        this.title = "";
        this.allRows = [];
        this.selectedRows = new Set();
        this.searchInputText = "";
    }
    static get styles() {
        return _TableFilterMultiSelectMenu_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    onSearchInputTextChanged() {
        var _a, _b;
        this.searchInputText = (_b = (_a = this.searchInput) === null || _a === void 0 ? void 0 : _a.value.toLowerCase()) !== null && _b !== void 0 ? _b : "";
    }
    onCheckboxChange(e, selectedRow) {
        if (!(e.target instanceof _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__.Checkbox.ELEMENT)) {
            return;
        }
        if (e.target.checked) {
            this.selectedRows.add(selectedRow.id);
        }
        else {
            this.selectedRows.delete(selectedRow.id);
        }
        this.updateSelectAllState();
        this.requestUpdate("selectedRows");
        this.dispatchSelectedFiltersEvent();
    }
    onSelectAllChange(_e) {
        if (!this.selectAllCheckbox) {
            return;
        }
        this.selectAllCheckbox.indeterminate = false;
        const checked = this.selectAllCheckbox.checked;
        if (checked) {
            this.selectedRows.clear();
        }
        else {
            this.allRows.forEach((row) => this.selectedRows.add(row.id));
        }
        this.requestUpdate("selectedRows");
        this.dispatchSelectedFiltersEvent();
    }
    updateSelectAllState() {
        const totalRows = this.allRows.length;
        const selectedRowsCount = this.allRows.filter((row) => this.selectedRows.has(row.id)).length;
        this.selectAllCheckbox.indeterminate = selectedRowsCount !== totalRows && selectedRowsCount !== 0;
        this.selectAllCheckbox.checked = selectedRowsCount === totalRows;
    }
    dispatchSelectedFiltersEvent() {
        const selectedFilterValues = Array.from(this.selectedRows);
        this.dispatchEvent(new CustomEvent("selected-filter-values-changed", {
            detail: { categoryId: "channel", selectedFilterValues },
            bubbles: true,
            composed: true
        }));
    }
    unsetCheckboxes() {
        this.selectedRows.clear();
        this.updateSelectAllState();
        this.requestUpdate("selectedRows");
    }
    render() {
        const filteredRows = this.allRows.filter((row) => row.label.toLowerCase().includes(this.searchInputText));
        const selectedCount = this.selectedRows.size;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
      <div id="multi-select-menu">
        <h3 class="title-label">${this.title}</h3>
        <h3 class="selected-label">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:x_selected", "0 selected", { count: selectedCount })}</h3>
        <md-input
          searchable
          placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:search")}
          @input-change=${this.onSearchInputTextChanged}
          newMomentum
        ></md-input>

        <md-checkbox id="select-all" @click=${this.onSelectAllChange}
          >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:selectAll", "Select all", { count: this.allRows.length })}</md-checkbox
        >

        <div id="scroll-area">
          ${filteredRows.map((row) => (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
              <md-checkbox
                class="row-item"
                .checked=${this.selectedRows.has(row.id)}
                @checkbox-change=${(e) => this.onCheckboxChange(e, row)}
              >
                ${row.label}
              </md-checkbox>
            `)}
        </div>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
], TableFilterMultiSelectMenu.prototype, "title", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ attribute: false })
], TableFilterMultiSelectMenu.prototype, "allRows", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ attribute: false })
], TableFilterMultiSelectMenu.prototype, "selectedRows", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], TableFilterMultiSelectMenu.prototype, "searchInputText", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)("md-checkbox#select-all")
], TableFilterMultiSelectMenu.prototype, "selectAllCheckbox", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)("md-input")
], TableFilterMultiSelectMenu.prototype, "searchInput", void 0);
TableFilterMultiSelectMenu = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-table-filter-multi-select-menu")
], TableFilterMultiSelectMenu);



/***/ }),

/***/ "./src/components/Common/TableFilterMenu/TableFilterTimeRangeCategoriesMenu/TableFilterTimeRangeCategoriesMenu.scss":
/*!**************************************************************************************************************************!*\
  !*** ./src/components/Common/TableFilterMenu/TableFilterTimeRangeCategoriesMenu/TableFilterTimeRangeCategoriesMenu.scss ***!
  \**************************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.header {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: repeat(4, auto);
}

.label {
  grid-column: 1/2;
  grid-row: 1/2;
}

.clear-selection-button {
  grid-column: 2/3;
  grid-row: 1/2;
  padding: 0px 0px 0px 17px;
}

h3 {
  font-family: var(--brand-font-medium);
  font-size: var(--body-secondary-font-size);
  font-weight: var(--brand-font-weight-regular);
  color: var(--md-primary-text-color);
  padding: 0;
  margin: 0;
}

.custom-range {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: repeat(4, auto);
}

.custom-range-type {
  grid-column: 1/3;
  grid-row: 1/2;
  padding: 0;
}

.custom-range-duration-type {
  grid-column: 1/2;
  grid-row: 3/4;
  padding: 0;
}

.custom-range-unit-type {
  grid-column: 2/3;
  grid-row: 3/4;
  padding: 0px 0px 0px 8px;
}

.custom-range-input {
  grid-column: 1/2;
  grid-row: 4/5;
  padding: 0;
}

.custom-range-dropdown1 {
  grid-column: 1/3;
  grid-row: 2/3;
  padding: 0px 0px 8px 0px;
}

.custom-range-dropdown2 {
  grid-column: 2/3;
  grid-row: 4/5;
  padding: 0px 0px 0px 8px;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/TableFilterMenu/TableFilterTimeRangeCategoriesMenu/TableFilterTimeRangeCategoriesMenu.scss */
/*# sourceURL=TableFilterTimeRangeCategoriesMenu.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/TableFilterMenu/TableFilterTimeRangeCategoriesMenu/TableFilterTimeRangeCategoriesMenu.ts":
/*!************************************************************************************************************************!*\
  !*** ./src/components/Common/TableFilterMenu/TableFilterTimeRangeCategoriesMenu/TableFilterTimeRangeCategoriesMenu.ts ***!
  \************************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableFilterTimeRangeCategoriesMenu: () => (/* binding */ TableFilterTimeRangeCategoriesMenu)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _TableFilterTimeRangeCategoriesMenu_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./TableFilterTimeRangeCategoriesMenu.scss */ "./src/components/Common/TableFilterMenu/TableFilterTimeRangeCategoriesMenu/TableFilterTimeRangeCategoriesMenu.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






let TableFilterTimeRangeCategoriesMenu = class TableFilterTimeRangeCategoriesMenu extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
    constructor() {
        super(...arguments);
        this.rangeType = "";
        this.duration = -1;
        this.unit = "";
        this.durationOptions = [
            { value: "under-1", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:under-1") },
            { value: "1-5", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:1-5") },
            { value: "5-20", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:5-20") },
            { value: "over-20", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:over_20") },
            { value: "custom", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:custom") }
        ];
        this.dropdownStringOptionsRange = [
            { value: "exactly", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:exactly") },
            { value: "between", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:between") },
            { value: "more_than", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:more_than") },
            { value: "less_than", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:less_than") },
            { value: "date_range", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:date_range") }
        ];
        this.dropdownStringOptionsUnit = [
            { value: "hours", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:hours") },
            { value: "minutes", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:minutes") },
            { value: "seconds", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:seconds") }
        ];
    }
    static get styles() {
        return _TableFilterTimeRangeCategoriesMenu_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
      <div class="header">
        <h3 class="label">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:columns:total_contact_duration")}</h3>
        <md-button variant="ghost" class="clear-selection-button" size="28" @click=${this.clearSelection}
          >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:clear_selection")}</md-button
        >
      </div>
      <md-radiogroup @radio-change=${this.onDurationChange}>
        ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_4__.repeat)(this.durationOptions, (option) => option.value, (option) => (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <md-radio slot="radio" value=${option.value} .checked=${this.selectedDurationPreset === option.value}
              >${option.label}</md-radio
            >
          `)}
      </md-radiogroup>
      <div class="custom-range">
        ${this.selectedDurationPreset === "custom"
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
              <h3 class="custom-range-type">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:selected_range_type")}</h3>
              <md-dropdown
                class="custom-range-dropdown1"
                newMomentum
                .options="${this.dropdownStringOptionsRange}"
                option-id="value"
                option-value="label"
                placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:selectedRangeType")}
                @dropdown-selected=${this.onRangeTypeChange}
              ></md-dropdown>
              <h3 class="custom-range-duration-type">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:selected_duration")}</h3>
              <md-input class="custom-range-input" newMomentum type="number" @input=${this.onDurationInputChange}>
              </md-input>
              <h3 class="custom-range-unit-type">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:filter_menu:selected_unit")}</h3>
              <md-dropdown
                class="custom-range-dropdown2"
                newMomentum
                .options="${this.dropdownStringOptionsUnit}"
                option-id="value"
                option-value="label"
                @dropdown-selected=${this.onUnitChange}
              ></md-dropdown>
            `
            : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
      </div>
    `;
    }
    clearSelection() {
        var _a;
        this.selectedDurationPreset = undefined;
        (_a = this.radioGroup) === null || _a === void 0 ? void 0 : _a.clearSelection();
        this.rangeType = "";
        this.duration = -1;
        this.unit = "";
        this.fireFormChangedEvent();
    }
    onDurationChange(e) {
        const selectedValue = e.detail.selected;
        this.selectedDurationPreset = selectedValue;
        this.fireFormChangedEvent();
    }
    onRangeTypeChange(e) {
        const { option } = e.detail;
        this.rangeType = option.key;
        this.fireFormChangedEvent();
    }
    onDurationInputChange(e) {
        const input = e.target;
        this.duration = Number(input.value);
        if (!isNaN(this.duration) && this.duration > 0) {
            this.fireFormChangedEvent();
        }
    }
    onUnitChange(e) {
        const { option } = e.detail;
        this.unit = option.key;
        this.fireFormChangedEvent();
    }
    fireFormChangedEvent() {
        this.dispatchEvent(new CustomEvent("filter-time-range-changed", {
            composed: true,
            bubbles: true,
            detail: {
                selectedPreset: this.selectedDurationPreset,
                customRangeType: this.rangeType,
                customDuration: this.duration,
                customUnit: this.unit
            }
        }));
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], TableFilterTimeRangeCategoriesMenu.prototype, "selectedDurationPreset", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], TableFilterTimeRangeCategoriesMenu.prototype, "rangeType", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], TableFilterTimeRangeCategoriesMenu.prototype, "duration", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], TableFilterTimeRangeCategoriesMenu.prototype, "unit", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)("md-radiogroup")
], TableFilterTimeRangeCategoriesMenu.prototype, "radioGroup", void 0);
TableFilterTimeRangeCategoriesMenu = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-table-filter-time-range-categories-menu")
], TableFilterTimeRangeCategoriesMenu);



/***/ }),

/***/ "./src/components/Common/TableFilterMenu/index.ts":
/*!********************************************************!*\
  !*** ./src/components/Common/TableFilterMenu/index.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableFilterCategoriesMenu: () => (/* reexport safe */ _TableFilterCategoriesMenu_TableFilterCategoriesMenu__WEBPACK_IMPORTED_MODULE_0__.TableFilterCategoriesMenu),
/* harmony export */   TableFilterMenu: () => (/* reexport safe */ _TableFilterMenu__WEBPACK_IMPORTED_MODULE_1__.TableFilterMenu),
/* harmony export */   TableFilterMultiSelectMenu: () => (/* reexport safe */ _TableFilterMultiSelectMenu_TableFilterMultiSelectMenu__WEBPACK_IMPORTED_MODULE_2__.TableFilterMultiSelectMenu),
/* harmony export */   TableFilterTimeRangeCategoriesMenu: () => (/* reexport safe */ _TableFilterTimeRangeCategoriesMenu_TableFilterTimeRangeCategoriesMenu__WEBPACK_IMPORTED_MODULE_3__.TableFilterTimeRangeCategoriesMenu)
/* harmony export */ });
/* harmony import */ var _TableFilterCategoriesMenu_TableFilterCategoriesMenu__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TableFilterCategoriesMenu/TableFilterCategoriesMenu */ "./src/components/Common/TableFilterMenu/TableFilterCategoriesMenu/TableFilterCategoriesMenu.ts");
/* harmony import */ var _TableFilterMenu__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./TableFilterMenu */ "./src/components/Common/TableFilterMenu/TableFilterMenu.ts");
/* harmony import */ var _TableFilterMultiSelectMenu_TableFilterMultiSelectMenu__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TableFilterMultiSelectMenu/TableFilterMultiSelectMenu */ "./src/components/Common/TableFilterMenu/TableFilterMultiSelectMenu/TableFilterMultiSelectMenu.ts");
/* harmony import */ var _TableFilterTimeRangeCategoriesMenu_TableFilterTimeRangeCategoriesMenu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./TableFilterTimeRangeCategoriesMenu/TableFilterTimeRangeCategoriesMenu */ "./src/components/Common/TableFilterMenu/TableFilterTimeRangeCategoriesMenu/TableFilterTimeRangeCategoriesMenu.ts");






/***/ }),

/***/ "./src/components/Common/TableHeader/TableHeaderWidget.scss":
/*!******************************************************************!*\
  !*** ./src/components/Common/TableHeader/TableHeaderWidget.scss ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`#table-group {
  box-sizing: border-box;
  display: flex;
  height: 44px;
  padding: 0px 8px 0px 12px;
  flex-grow: 1;
  align-items: center;
  margin: 0px;
  border-radius: 8px;
  background: var(--md-glass-overlay-bg-color);
  box-shadow: var(--md-elevation-1);
}

.spacer {
  flex-grow: 1;
  display: flex;
}

#left-group {
  color: var(--md-primary-text-color);
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 8px;
}

#right-group {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 8px;
}

.separator {
  width: 1px;
  height: 16px;
  background: var(--md-separator-primary);
  display: inline-block;
  margin: 0;
  padding: 0;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/TableHeader/TableHeaderWidget.scss */
/*# sourceURL=TableHeaderWidget.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/TableHeader/TableHeaderWidget.ts":
/*!****************************************************************!*\
  !*** ./src/components/Common/TableHeader/TableHeaderWidget.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableHeaderWidget: () => (/* binding */ TableHeaderWidget)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _TableHeaderWidget_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TableHeaderWidget.scss */ "./src/components/Common/TableHeader/TableHeaderWidget.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let TableHeaderWidget = class TableHeaderWidget extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.rowCount = 0;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    static get styles() {
        return _TableHeaderWidget_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <div id="table-group">
        <slot name="left-group"></slot>

        <div class="spacer"></div>

        <slot name="right-group"></slot>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], TableHeaderWidget.prototype, "rowCount", void 0);
TableHeaderWidget = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("table-header-widget")
], TableHeaderWidget);



/***/ }),

/***/ "./src/components/Common/Utils/GridUtils.ts":
/*!**************************************************!*\
  !*** ./src/components/Common/Utils/GridUtils.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   initializeGlobalGridProperties: () => (/* binding */ initializeGlobalGridProperties),
/* harmony export */   registerAgGridChartsModule: () => (/* binding */ registerAgGridChartsModule)
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/config */ "./src/config.ts");
/* harmony import */ var ag_charts_enterprise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ag-charts-enterprise */ "ag-charts-enterprise");
/* harmony import */ var ag_charts_enterprise__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(ag_charts_enterprise__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ag-grid-enterprise */ "ag-grid-enterprise");
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__);



let isGlobalPropertiesInitialized = false;
let isAgGridChartsModuleRegistered = false;
function initializeGlobalGridProperties() {
    var _a;
    if (!isGlobalPropertiesInitialized) {
        ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__.LicenseManager.setLicenseKey((_a = _config__WEBPACK_IMPORTED_MODULE_0__.CONF.AG_GRID_LICENSE_KEY) !== null && _a !== void 0 ? _a : "");
        isGlobalPropertiesInitialized = true;
        ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__.ModuleRegistry.registerModules([ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__.AllEnterpriseModule]);
        (0,ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__.provideGlobalGridOptions)({ theme: "legacy" });
    }
}
function registerAgGridChartsModule() {
    if (!isAgGridChartsModuleRegistered) {
        ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__.ModuleRegistry.registerModules([ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__.IntegratedChartsModule.with(ag_charts_enterprise__WEBPACK_IMPORTED_MODULE_1__.AgChartsEnterpriseModule)]);
        isAgGridChartsModuleRegistered = true;
    }
}


/***/ }),

/***/ "./src/components/Common/Utils/HighlightText.ts":
/*!******************************************************!*\
  !*** ./src/components/Common/Utils/HighlightText.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   highlightText: () => (/* binding */ highlightText)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _TeamPerformanceWidget_components_agentStateSelector_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../TeamPerformanceWidget/components/agentStateSelector/utils */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/utils/index.ts");


const highlightText = (text = "", highlight = "") => {
    if (!highlight.trim()) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) ` <span>${text}</span> `;
    }
    const regex = new RegExp(`(${(0,_TeamPerformanceWidget_components_agentStateSelector_utils__WEBPACK_IMPORTED_MODULE_1__.escapeRegExp)(highlight)})`, "gi");
    const parts = text.split(regex);
    return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
    <span class="highlight-span">
      ${parts
        .filter((part) => part)
        .map((part) => 
    // prettier-ignore
    regex.test(part)
        ? (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `<b>${part}</b>`
        : (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `<span>${part}</span>`)}
    </span>
  `;
};


/***/ }),

/***/ "./src/components/Common/WcGrid/CellComponents/AnomaliesCellComponent.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/Common/WcGrid/CellComponents/AnomaliesCellComponent.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AnomaliesCellComponent: () => (/* binding */ AnomaliesCellComponent)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


const ICON_WARNING = "warning-regular";
const ICON_HAPPY = "emoji-happy-regular";
const ICON_COLOR = "var(--md-secondary-text-color)";
let AnomaliesCellComponent = class AnomaliesCellComponent extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.anomalies = [];
    }
    renderIcon() {
        const icon = this.anomalies.length === 0 ? ICON_HAPPY : ICON_WARNING;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<md-icon name="${icon}" iconSet="momentumDesign" size="16" color="${ICON_COLOR}"> </md-icon>`;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ` ${this.renderIcon()}
      <i>(${this.anomalies.length})</i>`;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Array })
], AnomaliesCellComponent.prototype, "anomalies", void 0);
AnomaliesCellComponent = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-anomalies-cell")
], AnomaliesCellComponent);



/***/ }),

/***/ "./src/components/Common/WcGrid/CellRenderers/WcGridCellRenderer.ts":
/*!**************************************************************************!*\
  !*** ./src/components/Common/WcGrid/CellRenderers/WcGridCellRenderer.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createWcGridCellRendererClass: () => (/* binding */ createWcGridCellRendererClass)
/* harmony export */ });
class WcGridCellRenderer {
    constructor(elementTag, updateElementProperties) {
        this.elementTag = elementTag;
        this.updateElementProperties = updateElementProperties;
    }
    init(params) {
        this.eGui = this.createEGui();
        this.updateElementProperties(this.eGui, params);
    }
    refresh(params) {
        if (this.eGui) {
            this.updateElementProperties(this.eGui, params);
        }
        return true;
    }
    getGui() {
        var _a;
        return (_a = this.eGui) !== null && _a !== void 0 ? _a : this.createEGui();
    }
    createEGui() {
        return document.createElement(this.elementTag);
    }
}
function createWcGridCellRendererClass(elementTag, updateElementProperties) {
    return class extends WcGridCellRenderer {
        constructor() {
            super(elementTag, updateElementProperties);
        }
    };
}


/***/ }),

/***/ "./src/components/Common/WcGrid/DataSources/WcServerSideDataSource.ts":
/*!****************************************************************************!*\
  !*** ./src/components/Common/WcGrid/DataSources/WcServerSideDataSource.ts ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcGridServerSideDataSource: () => (/* binding */ WcGridServerSideDataSource)
/* harmony export */ });
class WcGridServerSideDataSource {
    constructor(fetchRowsFunction) {
        this.fetchRowsFunction = fetchRowsFunction;
    }
    getRows(params) {
        const fetchRowParams = { startRow: params.request.startRow, endRow: params.request.endRow };
        const successCallBack = (successParams) => {
            params.success({ rowData: successParams.rowData, rowCount: successParams.rowCount });
        };
        const failCallback = () => {
            params.fail();
        };
        this.fetchRowsFunction(fetchRowParams, successCallBack, failCallback);
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcChart/WcChart.ts":
/*!*********************************************************!*\
  !*** ./src/components/Common/WcGrid/WcChart/WcChart.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChartDataType: () => (/* binding */ ChartDataType),
/* harmony export */   WcChart: () => (/* binding */ WcChart)
/* harmony export */ });
var ChartDataType;
(function (ChartDataType) {
    ChartDataType["Category"] = "category";
    ChartDataType["Series"] = "series";
    ChartDataType["Time"] = "time";
    ChartDataType["Excluded"] = "excluded";
})(ChartDataType || (ChartDataType = {}));
const MIN_NUMBER_OF_COLUMNS = 2;
/**
 *  Support charting for columns from WcGrid.
 *  Limitations:
 * - Supports 'range' application charts only
 * - Supports 'columnLineCombo' chart-types only
 * - Supports 2 data columns in addition to the primary category, eg. 'agentName'
 */
class WcChart {
    constructor(wcColumnDefs, gridApi) {
        this.wcColumnDefs = wcColumnDefs;
        this.gridApi = gridApi;
        this.nonPrimaryColumnsInChart = [];
    }
    refreshIntegratedChart(event) {
        if (!this.gridApi) {
            throw new Error("Grid API not found");
        }
        if (this.wcColumnDefs.length < MIN_NUMBER_OF_COLUMNS) {
            throw new Error(`Minimum (${MIN_NUMBER_OF_COLUMNS}) columns required to create chart`);
        }
        if (event.detail.columns.length < 1) {
            throw new Error(`Minimum 1 column must be requested to chart data`);
        }
        if (this.getPrimaryAxisColumn() === "") {
            throw new Error("Primary axis column not found. Must set one column as primary axis to create chart");
        }
        const requestedFields = event.detail.columns;
        const chartInstances = this.gridApi.getChartModels();
        if ((chartInstances === null || chartInstances === void 0 ? void 0 : chartInstances.length) === 0) {
            this.createNewChart(requestedFields);
        }
        else {
            this.updateExistingChartCellRanges(requestedFields);
        }
    }
    createNewChart(requestedFields) {
        this.nonPrimaryColumnsInChart = [...requestedFields];
        this.gridApi.createRangeChart({
            chartType: "columnLineCombo",
            seriesChartTypes: this.getSeriesChartTypes(this.nonPrimaryColumnsInChart),
            cellRange: {
                columns: [...this.nonPrimaryColumnsInChart, this.getPrimaryAxisColumn()]
            },
            chartThemeOverrides: {
                common: {
                    axes: {
                        number: {
                            label: {
                                formatter: this.getAxisLabelFormatter(this.nonPrimaryColumnsInChart)
                            }
                        }
                    }
                }
            }
        });
    }
    updateExistingChartCellRanges(requestedFields) {
        // Limit to 2 data columns in addition to the primary category column
        if (this.nonPrimaryColumnsInChart.length === 2) {
            this.nonPrimaryColumnsInChart = [...this.nonPrimaryColumnsInChart.slice(1)];
        }
        this.nonPrimaryColumnsInChart.push(...requestedFields);
        this.gridApi.updateChart({
            chartId: this.getExistingChartId(this.gridApi),
            type: "rangeChartUpdate",
            seriesChartTypes: this.getSeriesChartTypes(this.nonPrimaryColumnsInChart),
            cellRange: {
                columns: [...this.nonPrimaryColumnsInChart, this.getPrimaryAxisColumn()]
            },
            chartThemeOverrides: {
                common: {
                    axes: {
                        number: {
                            label: {
                                formatter: this.getAxisLabelFormatter(this.nonPrimaryColumnsInChart)
                            }
                        }
                    }
                }
            }
        });
    }
    getPrimaryAxisColumn() {
        var _a;
        const primaryAxisColumns = this.wcColumnDefs.filter((col) => { var _a; return (_a = col.getChartConfig()) === null || _a === void 0 ? void 0 : _a.getIsPrimaryAxisInChart(); });
        if (primaryAxisColumns.length > 1) {
            throw new Error("More than one primary axis column found. Must only set one column as primary axis to chart data");
        }
        else if (primaryAxisColumns.length < 1) {
            throw new Error("Primary axis column not found. Must set one column as primary axis to chart data");
        }
        else {
            return (_a = primaryAxisColumns[0].getFieldName()) !== null && _a !== void 0 ? _a : "";
        }
    }
    getWcGridColumnsForFields(columnFields) {
        return this.wcColumnDefs.filter((col) => { var _a; return columnFields.includes((_a = col.getFieldName()) !== null && _a !== void 0 ? _a : ""); });
    }
    getSeriesChartTypes(requestedFields) {
        const seriesChartType = this.getWcGridColumnsForFields(requestedFields).map((col) => {
            var _a;
            return (_a = col.getChartConfig()) === null || _a === void 0 ? void 0 : _a.getSeriesChartType(col.getFieldName());
        });
        return seriesChartType;
    }
    getAxisLabelFormatter(columnFields) {
        var _a, _b;
        return (_b = (_a = this.getWcGridColumnsForFields(columnFields)
            .find((col) => {
            var _a;
            return ((_a = col.getChartConfig()) === null || _a === void 0 ? void 0 : _a.getChartAxisLabelFormatter()) !== undefined;
        })) === null || _a === void 0 ? void 0 : _a.getChartConfig()) === null || _b === void 0 ? void 0 : _b.getChartAxisLabelFormatter();
    }
    getExistingChartId(gridApi) {
        const chartModels = gridApi.getChartModels();
        if (chartModels && chartModels.length > 0) {
            return chartModels[0].chartId;
        }
        return "";
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/ActionsButtonsColumn.ts":
/*!************************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/ActionsButtonsColumn.ts ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ActionsButtonsColumn: () => (/* binding */ ActionsButtonsColumn)
/* harmony export */ });
/* harmony import */ var _components_Common_WcGrid_CellRenderers_WcGridCellRenderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/WcGrid/CellRenderers/WcGridCellRenderer */ "./src/components/Common/WcGrid/CellRenderers/WcGridCellRenderer.ts");
/* harmony import */ var _WcGridColumn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./WcGridColumn */ "./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts");


const updateProperties = (actionsWidget, params) => {
    const { buttons, context } = params.value;
    actionsWidget.buttons = buttons.map((button) => ({
        id: button.id,
        icon: button.icon,
        options: button.options,
        ariaLabel: button.ariaLabel,
        onClick: (option) => {
            actionsWidget.dispatchEvent(new CustomEvent(button.eventName, {
                composed: true,
                bubbles: true,
                detail: { context, option }
            }));
        }
    }));
};
const ActionButtonsCellRenderer = (0,_components_Common_WcGrid_CellRenderers_WcGridCellRenderer__WEBPACK_IMPORTED_MODULE_0__.createWcGridCellRendererClass)("agentx-wc-table-action-buttons", updateProperties);
class ActionsButtonsColumn extends _WcGridColumn__WEBPACK_IMPORTED_MODULE_1__.WcGridColumn {
    constructor(columnTitle, fieldName, buttonConfigs) {
        super(columnTitle, fieldName);
        this.buttonConfigs = [];
        this.buttonConfigs = buttonConfigs;
    }
    actionsValueGetter(params) {
        return {
            buttons: this.buttonConfigs,
            context: params.data
        };
    }
    toAgGridColDef() {
        return Object.assign(Object.assign(Object.assign({}, this.getCommonColDef()), this.getFilterColDef()), { cellRenderer: ActionButtonsCellRenderer, valueGetter: (params) => this.actionsValueGetter(params), filter: false, sortable: false });
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/AgentNameColumn.ts":
/*!*******************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/AgentNameColumn.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentNameColumn: () => (/* binding */ AgentNameColumn)
/* harmony export */ });
/* harmony import */ var _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/CellRenderers/Utils */ "./src/components/Common/CellRenderers/Utils.ts");
/* harmony import */ var _CellRenderers_WcGridCellRenderer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../CellRenderers/WcGridCellRenderer */ "./src/components/Common/WcGrid/CellRenderers/WcGridCellRenderer.ts");
/* harmony import */ var _WcGridColumn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./WcGridColumn */ "./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts");



const updateProperties = (agentNameElement, params) => {
    agentNameElement.name = params.data.agentName;
    agentNameElement.email = params.data.agentEmail;
};
const AgentCellRenderer = (0,_CellRenderers_WcGridCellRenderer__WEBPACK_IMPORTED_MODULE_1__.createWcGridCellRendererClass)("agentx-wc-table-agent-name", updateProperties);
class AgentNameColumn extends _WcGridColumn__WEBPACK_IMPORTED_MODULE_2__.WcGridColumn {
    constructor(columnTitle, fieldName) {
        super(columnTitle, fieldName);
    }
    toAgGridColDef() {
        return Object.assign(Object.assign(Object.assign({}, this.getCommonColDef()), this.getFilterColDef()), { cellRenderer: AgentCellRenderer, filter: "agTextColumnFilter", comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_0__.naturalStringComparator });
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/AnomaliesColumn.ts":
/*!*******************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/AnomaliesColumn.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AnomaliesColumn: () => (/* binding */ AnomaliesColumn)
/* harmony export */ });
/* harmony import */ var _CellComponents_AnomaliesCellComponent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../CellComponents/AnomaliesCellComponent */ "./src/components/Common/WcGrid/CellComponents/AnomaliesCellComponent.ts");
/* harmony import */ var _CellRenderers_WcGridCellRenderer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../CellRenderers/WcGridCellRenderer */ "./src/components/Common/WcGrid/CellRenderers/WcGridCellRenderer.ts");
/* harmony import */ var _WcGridColumn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./WcGridColumn */ "./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts");



function getAnomalies(params) {
    var _a;
    if (!((_a = params.colDef) === null || _a === void 0 ? void 0 : _a.field)) {
        return [];
    }
    return (params.data[params.colDef.field] || []);
}
function updateProperties(anomaliesCellWidget, params) {
    anomaliesCellWidget.anomalies = getAnomalies(params);
}
const AnomaliesCellRenderer = (0,_CellRenderers_WcGridCellRenderer__WEBPACK_IMPORTED_MODULE_1__.createWcGridCellRendererClass)("agentx-wc-anomalies-cell", updateProperties);
class AnomaliesColumn extends _WcGridColumn__WEBPACK_IMPORTED_MODULE_2__.WcGridColumn {
    constructor(columnTitle, fieldName) {
        super(columnTitle, fieldName);
    }
    toAgGridColDef() {
        return Object.assign(Object.assign(Object.assign({}, this.getCommonColDef()), this.getFilterColDef()), { cellRenderer: AnomaliesCellRenderer, filter: "agNumberColumnFilter", valueGetter: (params) => this.anomalyCountValueGetter(params) });
    }
    anomalyCountValueGetter(params) {
        return getAnomalies(params).length;
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/DurationColumn.ts":
/*!******************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/DurationColumn.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DurationColumn: () => (/* binding */ DurationColumn)
/* harmony export */ });
/* harmony import */ var _CellRenderers_WcGridCellRenderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../CellRenderers/WcGridCellRenderer */ "./src/components/Common/WcGrid/CellRenderers/WcGridCellRenderer.ts");
/* harmony import */ var _WcGridColumn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./WcGridColumn */ "./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_2__);



const DURATION_DISPLAY_FORMAT = "hh:mm:ss";
const updateProperties = (durationWidget, params) => {
    var _a, _b, _c, _d;
    if (!((_a = params.colDef) === null || _a === void 0 ? void 0 : _a.field)) {
        return;
    }
    durationWidget.duration = params.data[(_b = params.colDef) === null || _b === void 0 ? void 0 : _b.field].duration;
    durationWidget.createdTime = params.data[(_c = params.colDef) === null || _c === void 0 ? void 0 : _c.field].createdTime;
    durationWidget.isActive = params.data[(_d = params.colDef) === null || _d === void 0 ? void 0 : _d.field].isActive;
};
const DurationCellRenderer = (0,_CellRenderers_WcGridCellRenderer__WEBPACK_IMPORTED_MODULE_0__.createWcGridCellRendererClass)("agentx-wc-table-duration", updateProperties);
class DurationColumn extends _WcGridColumn__WEBPACK_IMPORTED_MODULE_1__.WcGridColumn {
    constructor(columnTitle, fieldName) {
        super(columnTitle, fieldName);
    }
    toAgGridColDef() {
        return Object.assign(Object.assign(Object.assign({}, this.getCommonColDef()), this.getFilterColDef()), { cellRenderer: DurationCellRenderer, filter: "agNumberColumnFilter", valueGetter: this.durationValueGetter });
    }
    durationValueGetter(params) {
        var _a;
        const fieldName = params.column.getColDef().field;
        if (fieldName) {
            return (_a = params.data[fieldName].duration) !== null && _a !== void 0 ? _a : "";
        }
        return "";
    }
    getChartAxisLabelFormatter() {
        return (params) => {
            return luxon__WEBPACK_IMPORTED_MODULE_2__.Duration.fromMillis(Number(params.value)).toFormat(DURATION_DISPLAY_FORMAT);
        };
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/NumberColumn.ts":
/*!****************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/NumberColumn.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NumberColumn: () => (/* binding */ NumberColumn)
/* harmony export */ });
/* harmony import */ var _WcGridColumn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./WcGridColumn */ "./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts");

class NumberColumn extends _WcGridColumn__WEBPACK_IMPORTED_MODULE_0__.WcGridColumn {
    constructor(columnTitle, fieldName, precision = 0) {
        super(columnTitle, fieldName);
        this.precision = 0;
        this.precision = precision;
    }
    toAgGridColDef() {
        return Object.assign(Object.assign(Object.assign({}, this.getCommonColDef()), this.getFilterColDef()), { filter: "agNumberColumnFilter", valueFormatter: (params) => this.numberFormatter(params) });
    }
    numberFormatter(params) {
        const value = Number(params.value);
        if (isNaN(value)) {
            return "";
        }
        return value.toFixed(this.precision);
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/PercentColumn.ts":
/*!*****************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/PercentColumn.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PercentColumn: () => (/* binding */ PercentColumn)
/* harmony export */ });
/* harmony import */ var _WcGridColumn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./WcGridColumn */ "./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts");

class PercentColumn extends _WcGridColumn__WEBPACK_IMPORTED_MODULE_0__.WcGridColumn {
    toAgGridColDef() {
        return Object.assign(Object.assign(Object.assign({}, this.getCommonColDef()), this.getFilterColDef()), { filter: "agNumberColumnFilter", valueFormatter: (params) => this.percentFormatter(params) });
    }
    percentFormatter(params) {
        return `${Math.ceil(params.value * 100)}%`;
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/StringColumn.ts":
/*!****************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/StringColumn.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   StringColumn: () => (/* binding */ StringColumn)
/* harmony export */ });
/* harmony import */ var _WcGridColumn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./WcGridColumn */ "./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts");

class StringColumn extends _WcGridColumn__WEBPACK_IMPORTED_MODULE_0__.WcGridColumn {
    toAgGridColDef() {
        return Object.assign(Object.assign(Object.assign({}, this.getCommonColDef()), this.getFilterColDef()), { filter: "agTextColumnFilter" });
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/WcChartConfig.ts":
/*!*****************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/WcChartConfig.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcChartConfig: () => (/* binding */ WcChartConfig)
/* harmony export */ });
/* harmony import */ var _WcChart_WcChart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../WcChart/WcChart */ "./src/components/Common/WcGrid/WcChart/WcChart.ts");

class WcChartConfig {
    constructor(params) {
        var _a, _b;
        this.isChartingEnabled = false;
        this.chartDataType = _WcChart_WcChart__WEBPACK_IMPORTED_MODULE_0__.ChartDataType.Excluded;
        this.isPrimaryAxisInChart = false;
        this.isAverageDataColumn = false;
        this.chartDataType = params.chartDataType;
        this.isChartingEnabled = params.chartDataType !== _WcChart_WcChart__WEBPACK_IMPORTED_MODULE_0__.ChartDataType.Excluded;
        this.isPrimaryAxisInChart = (_a = params.isPrimaryAxisInChart) !== null && _a !== void 0 ? _a : false;
        this.isAverageDataColumn = (_b = params.isAverageDataColumn) !== null && _b !== void 0 ? _b : false;
    }
    getIsChartingEnabled() {
        return this.isChartingEnabled;
    }
    getIsPrimaryAxisInChart() {
        return this.isPrimaryAxisInChart;
    }
    getSeriesChartType(fieldName) {
        return {
            colId: fieldName,
            chartType: this.isAverageDataColumn ? "line" : "groupedColumn",
            secondaryAxis: false
        };
    }
    getChartAxisLabelFormatter() {
        return undefined; // Default implementation, can be overridden
    }
    getChartDataType() {
        return this.chartDataType;
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/WcColumnInnerHeader.scss":
/*!*************************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/WcColumnInnerHeader.scss ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.chart-button-container {
  padding: 5px;
  min-height: 20px;
  align-items: center;
}

.ag-header-cell-text {
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}

.ag-header-cell-text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/WcGrid/WcColumns/WcColumnInnerHeader.scss */
/*# sourceURL=WcColumnInnerHeader.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvQ29tbW9uL1djR3JpZC9XY0NvbHVtbnMvV2NDb2x1bW5Jbm5lckhlYWRlci5zY3NzIiwiV2NDb2x1bW5Jbm5lckhlYWRlci5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsWUFBQTtFQUNBLGdCQUFBO0VBQ0EsbUJBQUE7QUNDRjs7QURFQTtFQUNFLHVCQUFBO0VBQ0EsYUFBQTtFQUNBLG1CQUFBO0FDQ0Y7O0FERUE7RUFDRSxnQkFBQTtFQUNBLHVCQUFBO0VBQ0EsbUJBQUE7QUNDRiIsImZpbGUiOiJXY0NvbHVtbklubmVySGVhZGVyLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuY2hhcnQtYnV0dG9uLWNvbnRhaW5lciB7XG4gIHBhZGRpbmc6IDVweDtcbiAgbWluLWhlaWdodDogMjBweDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbn1cblxuLmFnLWhlYWRlci1jZWxsLXRleHQge1xuICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbn1cblxuLmFnLWhlYWRlci1jZWxsLXRleHQtY29udGVudCB7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuICB3aGl0ZS1zcGFjZTogbm93cmFwO1xufVxuIiwiLmNoYXJ0LWJ1dHRvbi1jb250YWluZXIge1xuICBwYWRkaW5nOiA1cHg7XG4gIG1pbi1oZWlnaHQ6IDIwcHg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG59XG5cbi5hZy1oZWFkZXItY2VsbC10ZXh0IHtcbiAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG59XG5cbi5hZy1oZWFkZXItY2VsbC10ZXh0LWNvbnRlbnQge1xuICBvdmVyZmxvdzogaGlkZGVuO1xuICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbn0iXX0= */`);
    

/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/WcColumnInnerHeader.ts":
/*!***********************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/WcColumnInnerHeader.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcColumnInnerHeader: () => (/* binding */ WcColumnInnerHeader)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _WcColumnInnerHeader_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./WcColumnInnerHeader.scss */ "./src/components/Common/WcGrid/WcColumns/WcColumnInnerHeader.scss");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



let WcColumnInnerHeader = class WcColumnInnerHeader extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement) {
    static get styles() {
        return [_WcColumnInnerHeader_scss__WEBPACK_IMPORTED_MODULE_1__["default"]];
    }
    onChartButtonClicked(event) {
        var _a, _b;
        event.stopPropagation();
        const customEvent = new CustomEvent("wc-chart-column", {
            detail: {
                columns: [(_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.chartButton) === null || _b === void 0 ? void 0 : _b.columnField]
            },
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(customEvent);
    }
    render() {
        var _a;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
      <div class="ag-header-cell-text">
        ${((_a = this.params) === null || _a === void 0 ? void 0 : _a.chartButton)
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
              <span class="chart-button-container">
                <md-button class="chart-button" @click="${this.onChartButtonClicked}" size="20" circle>
                  <md-icon name="add-poll-regular" iconSet="momentumDesign"></md-icon>
                </md-button>
              </span>
            `
            : null}
        <span class="ag-header-cell-text-content">${this.params.displayName}</span>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Object })
], WcColumnInnerHeader.prototype, "params", void 0);
WcColumnInnerHeader = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("wc-grid-column-inner-header")
], WcColumnInnerHeader);



/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/WcColumnInnerHeaderRenderer.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/WcColumnInnerHeaderRenderer.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcColumnInnerHeaderRenderer: () => (/* binding */ WcColumnInnerHeaderRenderer)
/* harmony export */ });
/* harmony import */ var _WcColumnInnerHeader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./WcColumnInnerHeader */ "./src/components/Common/WcGrid/WcColumns/WcColumnInnerHeader.ts");

class WcColumnInnerHeaderRenderer {
    constructor() {
        this.eGui = document.createElement("div");
        this.innerHeaderElement = document.createElement("wc-grid-column-inner-header");
        this.eGui.appendChild(this.innerHeaderElement);
    }
    init(params) {
        this.innerHeaderElement.params = params;
    }
    getGui() {
        return this.eGui;
    }
    refresh(params) {
        this.innerHeaderElement.params = params;
        return true;
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts":
/*!****************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcGridColumn: () => (/* binding */ WcGridColumn)
/* harmony export */ });
/* harmony import */ var _WcColumnInnerHeaderRenderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./WcColumnInnerHeaderRenderer */ "./src/components/Common/WcGrid/WcColumns/WcColumnInnerHeaderRenderer.ts");

class WcGridColumn {
    constructor(columnTitle, fieldName) {
        this.columnTitle = columnTitle;
        this.fieldName = fieldName;
        this.hidden = true;
    }
    getCommonColDef() {
        var _a, _b;
        let colDef = {};
        if ((_a = this.chartConfig) === null || _a === void 0 ? void 0 : _a.getIsChartingEnabled()) {
            colDef = {
                headerComponentParams: {
                    innerHeaderComponent: _WcColumnInnerHeaderRenderer__WEBPACK_IMPORTED_MODULE_0__.WcColumnInnerHeaderRenderer,
                    innerHeaderComponentParams: {
                        chartButton: {
                            columnField: this.fieldName
                        }
                    }
                }
            };
        }
        return Object.assign({ headerName: this.columnTitle, field: this.fieldName, colId: this.fieldName, resizable: true, sortable: true, suppressHeaderMenuButton: true, suppressHeaderFilterButton: true, hide: this.hidden, chartDataType: (_b = this.chartConfig) === null || _b === void 0 ? void 0 : _b.getChartDataType() }, colDef);
    }
    getFilterColDef() {
        return {};
    }
    setHidden(hidden) {
        this.hidden = hidden;
        return this;
    }
    getFieldName() {
        return this.fieldName;
    }
    getChartConfig() {
        return this.chartConfig;
    }
    setChartConfig(chartConfig) {
        this.chartConfig = chartConfig;
        return this;
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcGrid.scss":
/*!**************************************************!*\
  !*** ./src/components/Common/WcGrid/WcGrid.scss ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  --grid-header-height: 60px;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  --sentiment-chip-padding: 8px;
  --sentiment-chip-negative-background: rgba(255, 232, 234, 1);
  --sentiment-chip-negative-color: rgba(171, 10, 21, 1);
  --sentiment-chip-neutral-background: rgba(222, 222, 222, 1);
  --sentiment-chip-neutral-color: rgba(0, 0, 0, 0.7);
  --sentiment-chip-positive-background: rgba(206, 245, 235, 1);
  --sentiment-chip-positive-color: rgba(24, 94, 70, 1);
  --visualizer-title-width: 100px;
  --visualizer-title-margin-left: 24px;
  --visualizer-container-max-height: 40px;
  --visualizer-container-max-width: 900px;
  --visualizer-container-gap: 16px;
  --visualizer-bar-max-width: 577px;
  --visualizer-bar-max-height: 4px;
  --player-controls-row-height: 50px;
  --player-controls-gap: 8px;
  --volume-popover-width: 180px;
  --volume-popover-height: 21px;
  --volume-popover-gap: 12px;
  --volume-popover-top-offset: 120%;
  --volume-popover-left-offset: 50%;
  --volume-popover-padding: 12px;
  --seek-bar-height: 8px;
  --seek-bar-thumb-size: 16px;
  --popover-arrow-size: 10px;
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --interaction-details-height: 250px;
  --interaction-details-padding: 3px;
  --interaction-details-item-margin: 10px 0;
  --interaction-details-item-grid-template-columns: 150px auto;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

:host {
  --grid-wrapper-h-padding: 12px;
  --grid-header-display: flex;
  --grid-cell-border-radius: 0px;
  --grid-focus-border-radius: 4px;
  display: block;
  height: 100%;
}

.ag-theme-alpine,
.ag-theme-alpine-dark {
  --ag-row-hover-color: var(--grid-row-hover-color, rgba(33, 150, 243, 0.1));
  --ag-header-cell-moving-background-color: var(--ag-row-hover-color);
  --ag-input-focus-border-color: transparent;
}

.hide {
  display: none;
}

.grid-wrapper {
  height: 100%;
  --ag-row-hover-color: var(--grid-row-hover-color, rgba(33, 150, 243, 0.1));
  --ag-header-cell-moving-background-color: var(--ag-row-hover-color);
  --ag-text-color: var(--md-primary-text-color);
  --ag-subtle-text-color: var(--md-primary-text-color);
  --ag-drag-handle-color: var(--md-primary-text-color);
  --ag-input-background-color: var(--input-default-bg-color);
  --ag-input-text-color: var(--input-default-text-color);
  --ag-input-placeholder-text-color: var(--input-default-placeholder-color);
  --ag-input-border-radius: var(--input-border-radius);
  --ag-input-focus-text-color: var(--input-default-text-color);
  --ag-input-text-color: var(--input-default-text-color);
  --ag-checkbox-checked-shape-color: var(--checkbox-icon-color);
  --ag-checkbox-unchecked-background-color: var(--checkbox-bg-color);
  --ag-checkbox-unchecked-border-color: var(--checkbox-border-color);
  --ag-checkbox-checked-background-color: var(--checkbox-selected-bg-color);
  --ag-checkbox-checked-border-color: var(--checkbox-selected-border-color);
  --ag-checkbox-indeterminate-shape-color: var(--checkbox-icon-color);
  --ag-checkbox-indeterminate-background-color: var(--checkbox-selected-bg-color);
  --ag-checkbox-indeterminate-border-color: var(--checkbox-selected-border-color);
  --ag-picker-button-background-color: var(--combobox-bg-color);
  --ag-picker-button-focus-background-color: var(--combobox-focus-bg-color);
  --ag-picker-list-background-color: var(--combobox-bg-color);
}
.grid-wrapper .grid-container {
  height: calc(100% - (var(--grid-header-height)));
  background-color: var(--md-glass-overlay-bg-color);
  border-radius: var(--grid-container-border-radius);
  padding-left: var(--grid-container-h-padding);
  padding-right: var(--grid-container-h-padding);
  padding-top: var(--grid-container-top-padding);
}
.grid-wrapper .grid-container .ag-overlay-wrapper {
  display: block;
}
.grid-wrapper .grid-container .ag-root-wrapper {
  border-right: 0px;
  border-left: 0px;
  border-bottom: 0px;
  border-color: var(--md-table-primary-bg-color);
  background-color: transparent;
}
.grid-wrapper .grid-container .ag-row {
  border-color: var(--md-table-primary-bg-color);
  border-bottom: var(--md-table-cell-border-bottom);
  z-index: 0;
}
.grid-wrapper .grid-container .ag-row,
.grid-wrapper .grid-container .ag-body-viewport {
  background-color: transparent;
}
.grid-wrapper .grid-container .ag-cell-focus {
  box-shadow: none;
  background-color: var(--list-hover-background);
  border-radius: var(--grid-cell-border-radius);
}
.grid-wrapper .grid-container .ag-row-hover {
  border-radius: var(--grid-cell-border-radius);
  overflow: hidden;
}
.grid-wrapper .grid-container .ag-cell {
  padding-left: var(--grid-wrapper-h-padding);
  padding-right: var(--grid-wrapper-h-padding);
}
.grid-wrapper .grid-container .ag-cell.ag-cell-focus:focus-within {
  outline: 2px solid var(--list-focus-border-color) !important;
  outline-offset: -2px;
  border-radius: var(--grid-focus-border-radius);
}
.grid-wrapper .grid-container .ag-ltr .ag-cell-focus:not(.ag-cell-range-selected):focus-within,
.grid-wrapper .grid-container .ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.grid-wrapper .grid-container .ag-ltr .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,
.grid-wrapper .grid-container .ag-ltr .ag-cell-range-single-cell,
.grid-wrapper .grid-container .ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle,
.grid-wrapper .grid-container .ag-rtl .ag-cell-focus:not(.ag-cell-range-selected):focus-within,
.grid-wrapper .grid-container .ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.grid-wrapper .grid-container .ag-rtl .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,
.grid-wrapper .grid-container .ag-rtl .ag-cell-range-single-cell,
.grid-wrapper .grid-container .ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle {
  border: none;
}
.grid-wrapper .grid-container .ag-cell,
.grid-wrapper .grid-container .ag-pinned-left-header,
.grid-wrapper .grid-container .ag-pinned-right-header,
.grid-wrapper .grid-container .ag-pinned-right-cols-container {
  color: var(--md-primary-text-color);
  border: none;
  border-width: 1px;
  border-right-style: solid;
  border-color: var(--md-table-column-divider-color) !important;
}
.grid-wrapper .grid-container .ag-header {
  z-index: var(--z-index-tpw-header);
  border: none;
  border-width: 1px;
  border-right-style: var(--md-table-border-style);
  border-bottom-style: solid;
  color: var(--md-primary-text-color);
  background-color: var(--md-table-header-bg-color);
  border-color: var(--md-table-header-border-bottom-color);
  display: var(--grid-header-display);
}
.grid-wrapper .grid-container .ag-header-cell {
  padding-left: var(--grid-wrapper-h-padding);
  padding-right: var(--grid-wrapper-h-padding);
}
.grid-wrapper .grid-container .ag-header-cell.ag-header-active, .grid-wrapper .grid-container .ag-header-cell:focus {
  outline: 2px solid var(--list-focus-border-color) !important;
  outline-offset: -2px;
  border-radius: 4px;
}
.grid-wrapper .grid-container .ag-header-cell.ag-header-active::after, .grid-wrapper .grid-container .ag-header-cell:focus::after {
  border: none;
}
.grid-wrapper .grid-container .ag-header-cell-text {
  color: var(--md-table-header-text-color, var(--md-secondary-text-color));
  font-size: 14px;
  font-family: var(--brand-font-bold, "CiscoSansTT Regular"), sans-serif;
  font-weight: var(--brand-font-weight-bold, 100);
}
.grid-wrapper .grid-container .actions-cell {
  overflow: visible;
}
.grid-wrapper .grid-container .ag-row.ag-row-focus {
  z-index: 1;
}
.grid-wrapper .grid-container .ag-header-cell-resize {
  right: -5px;
}
.grid-wrapper .grid-container .ag-pinned-left-header .ag-header-cell-resize {
  right: -4px;
}
.grid-wrapper .grid-container .ag-header-cell-resize::after {
  height: 100%;
  top: 0;
  background-color: var(--md-table-primary-bg-color);
  width: 1px !important;
  box-shadow: none;
}
.grid-wrapper .grid-container .ag-pinned-right-header .ag-header-cell-resize::after {
  left: calc(50% - 1px);
  width: 2px !important;
}
.grid-wrapper .grid-container .ag-cell.ag-cell-last-left-pinned,
.grid-wrapper .grid-container .ag-pinned-left-header {
  border-width: 1px;
  right: 0px;
  left: auto !important;
}
.grid-wrapper .grid-container .ag-pinned-right-header {
  border-right: none;
}
.grid-wrapper .grid-container .ag-pinned-right-header,
.grid-wrapper .grid-container .ag-pinned-right-cols-container {
  border-left-style: solid;
  border-left-color: var(--md-table-pinned-border-color) !important;
  border-left-width: 1px;
  box-shadow: var(--pinned-column-elevation);
}
.grid-wrapper .grid-container .ag-pinned-right-header .ag-row,
.grid-wrapper .grid-container .ag-pinned-right-cols-container .ag-row {
  background-color: var(--md-table-pinned-bg-color);
}
.grid-wrapper .grid-container .ag-pinned-right-header .ag-row .ag-cell,
.grid-wrapper .grid-container .ag-pinned-right-cols-container .ag-row .ag-cell {
  border-left-style: none;
}
.grid-wrapper .grid-container .ag-pinned-right-header .ag-header-cell,
.grid-wrapper .grid-container .ag-pinned-right-cols-container .ag-header-cell {
  background-color: var(--pinned-column-header-bg-color);
}
.grid-wrapper .grid-container .ag-pinned-left-header,
.grid-wrapper .grid-container .ag-pinned-left-cols-container {
  border-right-style: solid;
  border-right-width: 1px;
  border-right-color: var(--md-table-pinned-border-color) !important;
  box-shadow: var(--pinned-column-elevation);
}
.grid-wrapper .grid-container .ag-pinned-left-header .ag-row,
.grid-wrapper .grid-container .ag-pinned-left-cols-container .ag-row {
  background-color: var(--md-table-pinned-bg-color);
}
.grid-wrapper .grid-container .ag-pinned-left-header .ag-row .ag-cell,
.grid-wrapper .grid-container .ag-pinned-left-cols-container .ag-row .ag-cell {
  border-right-style: none;
}
.grid-wrapper .grid-container .ag-pinned-left-header .ag-header-cell,
.grid-wrapper .grid-container .ag-pinned-left-cols-container .ag-header-cell {
  background-color: var(--pinned-column-header-bg-color);
}
.grid-wrapper .grid-container .ag-cell-expandable {
  font-weight: bold;
}
.grid-wrapper .grid-container .ag-row.ag-row-level-0.ag-full-width-row {
  background-color: var(--md-tertiary-bg-color);
}
.grid-wrapper .grid-container .ag-header-icon.ag-header-cell-menu-button {
  opacity: 1;
}
.grid-wrapper .grid-container div.ag-row {
  font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", sans-serif;
}
.grid-wrapper .grid-container .ag-theme-alpine .ag-menu-header,
.grid-wrapper .grid-container .ag-theme-alpine-dark .ag-menu-header {
  display: none;
}
.grid-wrapper .grid-container .ag-group-expanded,
.grid-wrapper .grid-container .ag-group-contracted {
  margin-right: 20px;
}
.grid-wrapper .ag-menu {
  border-radius: var(--border-radius-medium);
  color: var(--md-primary-text-color);
  border-color: var(--md-menu-overlay-border-color);
  box-shadow: 0 1px 4px 1px var(--md-menu-overlay-border-color);
  margin-top: 25px;
  margin-left: 15px;
}
.grid-wrapper .ag-header-icon {
  color: var(--md-secondary-text-color);
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-0.ag-full-width-row .ag-row-group.ag-row-group-indent-0 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-1.ag-full-width-row .ag-row-group.ag-row-group-indent-1 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-2.ag-full-width-row .ag-row-group.ag-row-group-indent-2 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-3.ag-full-width-row .ag-row-group.ag-row-group-indent-3 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-4.ag-full-width-row .ag-row-group.ag-row-group-indent-4 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-5.ag-full-width-row .ag-row-group.ag-row-group-indent-5 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-6.ag-full-width-row .ag-row-group.ag-row-group-indent-6 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-7.ag-full-width-row .ag-row-group.ag-row-group-indent-7 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-8.ag-full-width-row .ag-row-group.ag-row-group-indent-8 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-9.ag-full-width-row .ag-row-group.ag-row-group-indent-9 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-10.ag-full-width-row .ag-row-group.ag-row-group-indent-10 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-11.ag-full-width-row .ag-row-group.ag-row-group-indent-11 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-12.ag-full-width-row .ag-row-group.ag-row-group-indent-12 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-13.ag-full-width-row .ag-row-group.ag-row-group-indent-13 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-14.ag-full-width-row .ag-row-group.ag-row-group-indent-14 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-15.ag-full-width-row .ag-row-group.ag-row-group-indent-15 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-16.ag-full-width-row .ag-row-group.ag-row-group-indent-16 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-17.ag-full-width-row .ag-row-group.ag-row-group-indent-17 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-18.ag-full-width-row .ag-row-group.ag-row-group-indent-18 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-19.ag-full-width-row .ag-row-group.ag-row-group-indent-19 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-1 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-2 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-3 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-4 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-5 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-6 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-7 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-8 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-9 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-10 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-11 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-12 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-13 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-14 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-15 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-16 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-17 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-18 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-19 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}

.channel-type-renderer {
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
}

.qmw-actions-cell {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 2px 0 0 6px;
  height: 100%;
}
.qmw-actions-cell .qmw-play-btn:focus {
  box-shadow: 0 0 0 0.125rem var(--button-focus-ring-color, #007aa3);
  border-radius: 2px;
}

.cell-renderer {
  width: 100%;
  height: 100%;
}

.listitem-cell-renderer {
  width: 100%;
  height: 100%;
  display: flex;
}

.ag-side-buttons,
.ag-tool-panel-horizontal-resize {
  display: none;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=WcGrid.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/WcGrid/variables.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-services/dist/styles/z-index.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/WcGrid/WcGrid.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/WcGrid/WcGrid.ts":
/*!************************************************!*\
  !*** ./src/components/Common/WcGrid/WcGrid.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcGridWidget: () => (/* binding */ WcGridWidget)
/* harmony export */ });
/* harmony import */ var _components_Common_CellRenderers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/CellRenderers */ "./src/components/Common/CellRenderers/index.ts");
/* harmony import */ var _components_Common_Utils_GridUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/components/Common/Utils/GridUtils */ "./src/components/Common/Utils/GridUtils.ts");
/* harmony import */ var _components_InteractionsTab__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/components/InteractionsTab */ "./src/components/InteractionsTab/index.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ag-grid-enterprise */ "ag-grid-enterprise");
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _DataSources_WcServerSideDataSource__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./DataSources/WcServerSideDataSource */ "./src/components/Common/WcGrid/DataSources/WcServerSideDataSource.ts");
/* harmony import */ var _WcGrid_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./WcGrid.scss */ "./src/components/Common/WcGrid/WcGrid.scss");
/* harmony import */ var _WcGridConfig__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./WcGridConfig */ "./src/components/Common/WcGrid/WcGridConfig.ts");
/* harmony import */ var _WcGridHeader_WcGridHeader__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./WcGridHeader/WcGridHeader */ "./src/components/Common/WcGrid/WcGridHeader/WcGridHeader.ts");
/* harmony import */ var _WcChart_WcChart__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./WcChart/WcChart */ "./src/components/Common/WcGrid/WcChart/WcChart.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};











let WcGridWidget = class WcGridWidget extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_5__.LitElement) {
    constructor() {
        super();
        this.isDarkMode = false;
        this.wcGridConfig = new _WcGridConfig__WEBPACK_IMPORTED_MODULE_8__.WcGridConfig({
            tableName: "",
            enableCharts: false,
            headerConfig: {
                resetGridStateButton: false,
                filterButton: false,
                columnSelectButton: false,
                refreshButton: false,
                datePicker: false
            },
            getGridRowData: () => __awaiter(this, void 0, void 0, function* () { return []; })
        });
        this.wcColumnDefs = [];
        (0,_components_Common_Utils_GridUtils__WEBPACK_IMPORTED_MODULE_1__.initializeGlobalGridProperties)();
    }
    connectedCallback() {
        var _a;
        super.connectedCallback();
        this.createGridOptions();
        if ((_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.enableCharts) {
            this.addEventListener("wc-chart-column", this.refreshIntegratedWcChart);
        }
    }
    createGridOptions() {
        var _a;
        this.gridOptions = this.wcGridConfig.toAgGridConfig();
        if (this.gridOptions.enableCharts) {
            (0,_components_Common_Utils_GridUtils__WEBPACK_IMPORTED_MODULE_1__.registerAgGridChartsModule)();
        }
        this.gridOptions.onGridReady = () => {
            this.onGridReady();
        };
        this.gridOptions.onModelUpdated = () => {
            this.fireDisplayedRowCountChangedEvent();
        };
        this.gridOptions.components = {
            actionButtonsRenderer: _components_Common_CellRenderers__WEBPACK_IMPORTED_MODULE_0__.ActionButtonsCellRenderer,
            agentNameRenderer: _components_Common_CellRenderers__WEBPACK_IMPORTED_MODULE_0__.AgentNameCellRenderer,
            durationRenderer: _components_Common_CellRenderers__WEBPACK_IMPORTED_MODULE_0__.DurationCellRenderer,
            channelRenderer: _components_Common_CellRenderers__WEBPACK_IMPORTED_MODULE_0__.ChannelCellRenderer,
            interactionsListItemRenderer: _components_Common_CellRenderers__WEBPACK_IMPORTED_MODULE_0__.InteractionsListItemCellRenderer,
            queueStatsListItemRenderer: _components_Common_CellRenderers__WEBPACK_IMPORTED_MODULE_0__.QueueStatsListItemCellRenderer,
            sentimentRenderer: _components_Common_CellRenderers__WEBPACK_IMPORTED_MODULE_0__.SentimentCellRenderer
        };
        this.gridOptions.defaultColDef = {
            resizable: true,
            sortable: true,
            width: 200
        };
        const agGridColDef = [];
        this.wcColumnDefs.forEach((column) => {
            agGridColDef.push(column.toAgGridColDef());
        });
        this.gridOptions.columnDefs = agGridColDef;
        if (this.wcGridConfig.saveGridStateEnabled()) {
            this.gridOptions.onStateUpdated = (event) => {
                this.onStateUpdated(event);
            };
        }
        // Load grid state from local storage if it exists and saveGridState is true
        const cacheKey = this.wcGridConfig.getTableName();
        if (this.wcGridConfig.saveGridStateEnabled() && cacheKey !== "") {
            const cache = (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem(cacheKey);
            if (cache) {
                this.gridOptions.initialState = JSON.parse(cache);
            }
        }
        if (this.wcGridConfig.serverSideRowModel && this.wcGridConfig.fetchServerRows) {
            this.gridOptions.serverSideDatasource = new _DataSources_WcServerSideDataSource__WEBPACK_IMPORTED_MODULE_6__.WcGridServerSideDataSource(this.wcGridConfig.fetchServerRows);
        }
        this.gridOptions.theme = ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_4__.themeAlpine.withParams({
            sideBarBackgroundColor: "transparent",
            chromeBackgroundColor: "transparent"
        });
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.destroy();
        this.wcChart = undefined;
        this.removeEventListener("wc-chart-column", this.refreshIntegratedWcChart);
    }
    fireDisplayedRowCountChangedEvent() {
        var _a;
        const rowCount = ((_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.getDisplayedRowCount()) || 0;
        this.dispatchEvent(new CustomEvent("displayed-row-count-changed", {
            detail: {
                count: rowCount
            },
            bubbles: true,
            composed: true
        }));
    }
    onGridReady() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.wcGridConfig.getGridRowData) {
                const rowData = yield this.wcGridConfig.getGridRowData();
                (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setGridOption("rowData", rowData);
            }
        });
    }
    static get styles() {
        return [_WcGrid_scss__WEBPACK_IMPORTED_MODULE_7__["default"]];
    }
    onStateUpdated(event) {
        var _a;
        const cacheKey = this.wcGridConfig.getTableName();
        if (this.wcGridConfig.saveGridStateEnabled() && cacheKey !== "") {
            (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.setItem(cacheKey, JSON.stringify(event.state));
        }
    }
    initializeGrid() {
        if (!this.gridOptions) {
            return;
        }
        this.gridApi = (0,ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_4__.createGrid)(this.gridDiv, this.gridOptions);
        if (this.gridApiCallback) {
            this.gridApiCallback(this.gridApi);
        }
        if (this.gridApi && this.gridOptions.enableCharts) {
            this.wcChart = new _WcChart_WcChart__WEBPACK_IMPORTED_MODULE_10__.WcChart(this.wcColumnDefs, this.gridApi);
        }
    }
    refreshIntegratedWcChart(event) {
        if (this.wcChart && event) {
            this.wcChart.refreshIntegratedChart(event);
        }
    }
    updated(changedProperties) {
        var _a;
        super.updated(changedProperties);
        if (changedProperties.has("gridOptions")) {
            (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.destroy();
            if (this.gridOptions) {
                this.initializeGrid();
            }
        }
        else if (this.hasDateRangeChanged(changedProperties)) {
            this.onGridReady();
        }
    }
    hasDateRangeChanged(changedProperties) {
        if (changedProperties.has("wcGridConfig") && changedProperties.get("wcGridConfig") instanceof _WcGridConfig__WEBPACK_IMPORTED_MODULE_8__.WcGridConfig) {
            const oldConfig = changedProperties.get("wcGridConfig");
            const oldStartTime = oldConfig.getHeaderConfig().datePickerStartTime;
            const oldEndTime = oldConfig.getHeaderConfig().datePickerEndTime;
            const currentStartTime = this.wcGridConfig.getHeaderConfig().datePickerStartTime;
            const currentEndTime = this.wcGridConfig.getHeaderConfig().datePickerEndTime;
            return oldStartTime !== currentStartTime || oldEndTime !== currentEndTime;
        }
        return false;
    }
    get agGridLinkTemplate() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) ` <link href="/css/momentum-ui-icons.min.css" rel="stylesheet" />
      <link href="/css/momentum-ui.min.css" rel="stylesheet" />`;
    }
    onResetWcGrid(e) {
        var _a;
        e.stopPropagation();
        // delete the config from local storage
        const cacheKey = this.wcGridConfig.getTableName();
        if (this.wcGridConfig.saveGridStateEnabled() && cacheKey !== "") {
            (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.removeItem(cacheKey);
        }
        // re-create the grid options after deleting the cache
        this.createGridOptions();
    }
    onColumnSelectClicked(e) {
        e.stopPropagation();
        this.toggleToolPanel("columns");
    }
    onFilterButtonClicked(e) {
        e.stopPropagation();
        this.toggleToolPanel("filters");
    }
    toggleToolPanel(toolPanel) {
        const gridApi = this.gridApi;
        if (gridApi) {
            const openToolPanel = gridApi.getOpenedToolPanel();
            if (openToolPanel === toolPanel) {
                gridApi.closeToolPanel();
            }
            else {
                gridApi.openToolPanel(toolPanel);
            }
        }
    }
    onRefreshGridClicked() {
        this.onGridReady();
    }
    onDateRangeSearchUpdated(e) {
        e.stopPropagation();
        this.dispatchEvent(new CustomEvent("search-date-range-updated", {
            detail: {
                startTime: e.detail.startTime,
                endTime: e.detail.endTime
            },
            bubbles: true,
            composed: true
        }));
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
      <div data-testid="wc-grid" class="grid-wrapper">
        ${this.agGridLinkTemplate}
        <wc-grid-header
          .wcGridHeaderConfig=${this.wcGridConfig.getHeaderConfig()}
          @reset-wc-grid-state=${this.onResetWcGrid}
          @column-select=${this.onColumnSelectClicked}
          @filter-button-clicked=${this.onFilterButtonClicked}
          @refresh-grid-clicked=${this.onRefreshGridClicked}
          @search-date-range-updated=${this.onDateRangeSearchUpdated}
        ></wc-grid-header>
        <div class=${`grid-container  ${this.isDarkMode ? "ag-theme-alpine-dark" : "ag-theme-alpine"}`}></div>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)(".grid-container")
], WcGridWidget.prototype, "gridDiv", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
], WcGridWidget.prototype, "isDarkMode", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
], WcGridWidget.prototype, "wcGridConfig", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
], WcGridWidget.prototype, "wcColumnDefs", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object, attribute: false })
], WcGridWidget.prototype, "gridApiCallback", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], WcGridWidget.prototype, "gridApi", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], WcGridWidget.prototype, "gridOptions", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], WcGridWidget.prototype, "wcChart", void 0);
WcGridWidget = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("wc-ag-grid")
], WcGridWidget);



/***/ }),

/***/ "./src/components/Common/WcGrid/WcGrid.types.ts":
/*!******************************************************!*\
  !*** ./src/components/Common/WcGrid/WcGrid.types.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);



/***/ }),

/***/ "./src/components/Common/WcGrid/WcGridConfig.ts":
/*!******************************************************!*\
  !*** ./src/components/Common/WcGrid/WcGridConfig.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcGridConfig: () => (/* binding */ WcGridConfig),
/* harmony export */   wcCustomIcons: () => (/* binding */ wcCustomIcons)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");

//See https://www.ag-grid.com/javascript-data-grid/custom-icons/#icon-names for full list of icons
const wcCustomIcons = {
    filter: '<md-icon name="filter-bold" iconSet="momentumDesign" size="16"></md-icon>',
    sortAscending: `<div class="sorted up">
          <md-icon name="sort-ascending-bold" iconSet="momentumDesign" size="16"></md-icon>
          </div>`,
    sortDescending: `<div class="sorted down">
          <md-icon name="sort-descending-bold" iconSet="momentumDesign" size="16"></md-icon>
          </div>`,
    clipboardCopy: '<md-icon name="copy-bold" iconSet="momentumDesign" size="16" class="icon-copy_16" />',
    advancedFilterBuilderDrag: '<md-icon name="dragger-vertical-bold" iconSet="momentumDesign" size="16"></md-icon>',
    rowDrag: '<md-icon name="dragger-vertical-bold" iconSet="momentumDesign" size="16"></md-icon>',
    columnDrag: '<md-icon name="dragger-vertical-bold" iconSet="momentumDesign" size="16"></md-icon>',
    columnSelectClosed: '<md-icon name="arrow-right-bold" iconSet="momentumDesign" size="16"></md-icon>',
    columnSelectOpen: '<md-icon name="arrow-down-bold" iconSet="momentumDesign" size="16"></md-icon>',
    filterActive: '<md-icon name="filter-bold" iconSet="momentumDesign" size="16"></md-icon>',
    menu: '<md-icon name="settings-bold" iconSet="momentumDesign" size="16" class="settings-icon"><md-icon/>'
};
class WcGridConfig {
    constructor(params) {
        var _a;
        this.serverSideRowModel = false;
        this.tableName = "";
        this.enableCharts = false;
        this.headerConfig = {
            resetGridStateButton: false,
            filterButton: false,
            columnSelectButton: false,
            refreshButton: false,
            datePicker: false
        };
        this.tableName = params.tableName;
        this.headerConfig = params.headerConfig;
        this.enableCharts = params.enableCharts;
        this.serverSideRowModel = (_a = params.serverSideRowModel) !== null && _a !== void 0 ? _a : false;
        this.getGridRowData = params.getGridRowData;
        this.fetchServerRows = params.fetchServerRows;
    }
    toAgGridConfig() {
        const filtersToolPanel = {
            id: "filters",
            labelDefault: "Filters",
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel",
            toolPanelParams: {
                suppressExpandAll: true,
                suppressFilterSearch: false
            }
        };
        const columnsToolPanel = {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
            toolPanelParams: {
                suppressRowGroups: true,
                suppressValues: true,
                suppressPivots: true,
                suppressPivotMode: true,
                suppressColumnFilter: false,
                suppressColumnSelectAll: false,
                suppressColumnExpandAll: true
            }
        };
        const toolPanelsArray = [];
        if (this.headerConfig.filterButton) {
            toolPanelsArray.push(filtersToolPanel);
        }
        if (this.headerConfig.columnSelectButton) {
            toolPanelsArray.push(columnsToolPanel);
        }
        const sidebar = {
            toolPanels: toolPanelsArray,
            hiddenByDefault: false
        };
        return {
            sideBar: sidebar,
            icons: wcCustomIcons,
            enableCharts: this.enableCharts,
            cellSelection: this.enableCharts,
            animateRows: false,
            suppressAnimationFrame: true,
            rowModelType: this.serverSideRowModel ? "serverSide" : "clientSide",
            blockLoadDebounceMillis: 350,
            localeText: {
                loadingOoo: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.loading") //Replaces AGGrids default "Loading..."
            }
        };
    }
    getHeaderConfig() {
        return this.headerConfig;
    }
    saveGridStateEnabled() {
        return this.headerConfig.resetGridStateButton;
    }
    getTableName() {
        return this.tableName;
    }
}


/***/ }),

/***/ "./src/components/Common/WcGrid/WcGridDateRangePicker/WcGridDateRangePicker.scss":
/*!***************************************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcGridDateRangePicker/WcGridDateRangePicker.scss ***!
  \***************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.date-range-picker-controls {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin: 0.25rem 0.75rem 0.75rem;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/WcGrid/WcGridDateRangePicker/WcGridDateRangePicker.scss */
/*# sourceURL=WcGridDateRangePicker.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvQ29tbW9uL1djR3JpZC9XY0dyaWREYXRlUmFuZ2VQaWNrZXIvV2NHcmlkRGF0ZVJhbmdlUGlja2VyLnNjc3MiLCJXY0dyaWREYXRlUmFuZ2VQaWNrZXIuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQUE7RUFDQSx5QkFBQTtFQUNBLFdBQUE7RUFDQSwrQkFBQTtBQ0NGIiwiZmlsZSI6IldjR3JpZERhdGVSYW5nZVBpY2tlci5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmRhdGUtcmFuZ2UtcGlja2VyLWNvbnRyb2xzIHtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbiAgZ2FwOiAwLjVyZW07XG4gIG1hcmdpbjogMC4yNXJlbSAwLjc1cmVtIDAuNzVyZW07XG59XG4iLCIuZGF0ZS1yYW5nZS1waWNrZXItY29udHJvbHMge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kO1xuICBnYXA6IDAuNXJlbTtcbiAgbWFyZ2luOiAwLjI1cmVtIDAuNzVyZW0gMC43NXJlbTtcbn0iXX0= */`);
    

/***/ }),

/***/ "./src/components/Common/WcGrid/WcGridDateRangePicker/WcGridDateRangePicker.ts":
/*!*************************************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcGridDateRangePicker/WcGridDateRangePicker.ts ***!
  \*************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcGridDateRangePicker: () => (/* binding */ WcGridDateRangePicker)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _WcGridDateRangePicker_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./WcGridDateRangePicker.scss */ "./src/components/Common/WcGrid/WcGridDateRangePicker/WcGridDateRangePicker.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * @element wc-grid-date-range-picker
 */
let WcGridDateRangePicker = class WcGridDateRangePicker extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
    constructor() {
        super(...arguments);
        this.startTime = 0;
        this.endTime = 0;
    }
    static get styles() {
        return _WcGridDateRangePicker_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    onDateRangeChange(e) {
        var _a;
        if (!((_a = e.detail) === null || _a === void 0 ? void 0 : _a.startDate) || !e.detail.endDate) {
            return;
        }
        this.pendingStartTime = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(e.detail.startDate).toMillis();
        this.pendingEndTime = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(e.detail.endDate).toMillis();
    }
    onCancelDateRangeSelection() {
        this.dateRangePicker.setOpen(false);
    }
    onAcceptDateRangeSelection() {
        this.dateRangePicker.setOpen(false);
        if (!this.pendingStartTime ||
            !this.pendingEndTime ||
            (this.pendingStartTime === this.startTime && this.pendingEndTime === this.endTime)) {
            return;
        }
        this.startTime = this.pendingStartTime;
        this.endTime = this.pendingEndTime;
        this.dispatchEvent(new CustomEvent("search-date-range-updated", {
            detail: {
                startTime: this.startTime,
                endTime: this.endTime
            },
            bubbles: true,
            composed: true
        }));
    }
    render() {
        var _a, _b;
        const startDate = (_a = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(this.startTime).toISODate()) !== null && _a !== void 0 ? _a : "";
        const endDate = (_b = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(this.endTime).toISODate()) !== null && _b !== void 0 ? _b : "";
        const datePickerValue = `${startDate} - ${endDate}`;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
      <md-date-range-picker
        value=${datePickerValue}
        .endDate=${endDate}
        .startDate=${startDate}
        @date-range-change=${this.onDateRangeChange}
      >
        <div slot="time-picker" class="date-range-picker-controls">
          <md-button class="date-range-cancel-button" variant="secondary" @click=${this.onCancelDateRangeSelection}>
            <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.cancelButton")}</span>
          </md-button>
          <md-button class="date-range-apply-button" variant="primary" @click=${this.onAcceptDateRangeSelection}>
            <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.apply")}</span>
          </md-button>
        </div>
      </md-date-range-picker>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
], WcGridDateRangePicker.prototype, "startTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
], WcGridDateRangePicker.prototype, "endTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], WcGridDateRangePicker.prototype, "pendingStartTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], WcGridDateRangePicker.prototype, "pendingEndTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)("md-date-range-picker")
], WcGridDateRangePicker.prototype, "dateRangePicker", void 0);
WcGridDateRangePicker = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("wc-grid-date-range-picker")
], WcGridDateRangePicker);



/***/ }),

/***/ "./src/components/Common/WcGrid/WcGridHeader/WcGridHeader.scss":
/*!*********************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcGridHeader/WcGridHeader.scss ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.wc-grid-header {
  display: flex;
  height: 44px;
  padding: 0px 8px 0px 12px;
  align-items: center;
  margin: 8px;
  border-radius: 8px;
  background: var(--md-glass-overlay-bg-color);
  box-shadow: var(--md-elevation-1);
}

.left-group {
  margin-right: auto;
}

.center-group {
  margin-right: auto;
}

.right-group {
  display: flex;
  flex-flow: row;
  align-items: center;
  gap: 8px;
}

wc-grid-date-range-picker {
  top: 8px;
  position: relative;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/WcGrid/WcGridHeader/WcGridHeader.scss */
/*# sourceURL=WcGridHeader.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvQ29tbW9uL1djR3JpZC9XY0dyaWRIZWFkZXIvV2NHcmlkSGVhZGVyLnNjc3MiLCJXY0dyaWRIZWFkZXIuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQUE7RUFDQSxZQUFBO0VBQ0EseUJBQUE7RUFDQSxtQkFBQTtFQUNBLFdBQUE7RUFDQSxrQkFBQTtFQUNBLDRDQUFBO0VBQ0EsaUNBQUE7QUNDRjs7QURFQTtFQUNFLGtCQUFBO0FDQ0Y7O0FERUE7RUFDRSxrQkFBQTtBQ0NGOztBREVBO0VBQ0UsYUFBQTtFQUNBLGNBQUE7RUFDQSxtQkFBQTtFQUNBLFFBQUE7QUNDRjs7QURFQTtFQUNFLFFBQUE7RUFDQSxrQkFBQTtBQ0NGIiwiZmlsZSI6IldjR3JpZEhlYWRlci5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLndjLWdyaWQtaGVhZGVyIHtcbiAgZGlzcGxheTogZmxleDtcbiAgaGVpZ2h0OiA0NHB4O1xuICBwYWRkaW5nOiAwcHggOHB4IDBweCAxMnB4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBtYXJnaW46IDhweDtcbiAgYm9yZGVyLXJhZGl1czogOHB4O1xuICBiYWNrZ3JvdW5kOiB2YXIoLS1tZC1nbGFzcy1vdmVybGF5LWJnLWNvbG9yKTtcbiAgYm94LXNoYWRvdzogdmFyKC0tbWQtZWxldmF0aW9uLTEpO1xufVxuXG4ubGVmdC1ncm91cCB7XG4gIG1hcmdpbi1yaWdodDogYXV0bztcbn1cblxuLmNlbnRlci1ncm91cCB7XG4gIG1hcmdpbi1yaWdodDogYXV0bztcbn1cblxuLnJpZ2h0LWdyb3VwIHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1mbG93OiByb3c7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGdhcDogOHB4O1xufVxuXG53Yy1ncmlkLWRhdGUtcmFuZ2UtcGlja2VyIHtcbiAgdG9wOiA4cHg7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbn1cbiIsIi53Yy1ncmlkLWhlYWRlciB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGhlaWdodDogNDRweDtcbiAgcGFkZGluZzogMHB4IDhweCAwcHggMTJweDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgbWFyZ2luOiA4cHg7XG4gIGJvcmRlci1yYWRpdXM6IDhweDtcbiAgYmFja2dyb3VuZDogdmFyKC0tbWQtZ2xhc3Mtb3ZlcmxheS1iZy1jb2xvcik7XG4gIGJveC1zaGFkb3c6IHZhcigtLW1kLWVsZXZhdGlvbi0xKTtcbn1cblxuLmxlZnQtZ3JvdXAge1xuICBtYXJnaW4tcmlnaHQ6IGF1dG87XG59XG5cbi5jZW50ZXItZ3JvdXAge1xuICBtYXJnaW4tcmlnaHQ6IGF1dG87XG59XG5cbi5yaWdodC1ncm91cCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZmxvdzogcm93O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBnYXA6IDhweDtcbn1cblxud2MtZ3JpZC1kYXRlLXJhbmdlLXBpY2tlciB7XG4gIHRvcDogOHB4O1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG59Il19 */`);
    

/***/ }),

/***/ "./src/components/Common/WcGrid/WcGridHeader/WcGridHeader.ts":
/*!*******************************************************************!*\
  !*** ./src/components/Common/WcGrid/WcGridHeader/WcGridHeader.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcGridHeaderWidget: () => (/* binding */ WcGridHeaderWidget)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _WcGridHeader_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./WcGridHeader.scss */ "./src/components/Common/WcGrid/WcGridHeader/WcGridHeader.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var WcGridHeaderWidget;
(function (WcGridHeaderWidget) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.wcGridHeaderConfig = {
                resetGridStateButton: false,
                filterButton: false,
                columnSelectButton: false,
                refreshButton: false,
                datePicker: false,
                datePickerStartTime: 0,
                datePickerEndTime: 0,
                leftText: ""
            };
        }
        static get styles() {
            return [_WcGridHeader_scss__WEBPACK_IMPORTED_MODULE_2__["default"]];
        }
        onResetWcGrid(_e) {
            this.dispatchEvent(new CustomEvent("reset-wc-grid-state", {
                bubbles: true,
                composed: true
            }));
        }
        onColumnSelect(_e) {
            this.dispatchEvent(new CustomEvent("column-select", {
                bubbles: true,
                composed: true
            }));
        }
        onFilterButtonClicked() {
            this.dispatchEvent(new CustomEvent("filter-button-clicked", {
                bubbles: true,
                composed: true
            }));
        }
        onUnsortedButtonClicked() {
            this.dispatchEvent(new CustomEvent("unsorted-button-clicked", {
                bubbles: true,
                composed: true
            }));
        }
        showGridHeader() {
            return (this.wcGridHeaderConfig.resetGridStateButton ||
                this.wcGridHeaderConfig.filterButton !== false ||
                this.wcGridHeaderConfig.unsortedButton ||
                this.wcGridHeaderConfig.columnSelectButton ||
                this.wcGridHeaderConfig.refreshButton ||
                this.wcGridHeaderConfig.datePicker ||
                (this.wcGridHeaderConfig.leftText !== undefined && this.wcGridHeaderConfig.leftText.length > 0));
        }
        onDateRangeSearchUpdated(e) {
            e.stopPropagation();
            this.dispatchEvent(new CustomEvent("search-date-range-updated", {
                detail: {
                    startTime: e.detail.startTime,
                    endTime: e.detail.endTime
                },
                bubbles: true,
                composed: true
            }));
        }
        onRefreshClicked(e) {
            e.stopPropagation();
            this.dispatchEvent(new CustomEvent("refresh-grid-clicked", {
                bubbles: true,
                composed: true
            }));
        }
        renderResetButton() {
            if (!this.wcGridHeaderConfig.resetGridStateButton) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ``;
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<md-button
        id="reset-customization-button"
        circle
        size="28"
        variant="ghost"
        @click=${this.onResetWcGrid}
        ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:wcGrid:reset")}
      >
        <md-icon slot="icon" name="reset-bold" iconSet="momentumDesign" size="16"></md-icon>
      </md-button>`;
        }
        renderColumnSelectButton() {
            if (!this.wcGridHeaderConfig.columnSelectButton) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ``;
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<md-button id="customization-button" circle size="28" variant="ghost" @click=${this.onColumnSelect}>
        <md-icon slot="icon" iconSet="momentumDesign" name="settings-bold" size="16"></md-icon>
      </md-button>`;
        }
        renderFilterButton() {
            if (!this.wcGridHeaderConfig.filterButton) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ``;
            }
            if (this.wcGridHeaderConfig.filterButton === "small") {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
          <md-button id="filter-button" circle variant="ghost" size="28" @click=${() => this.onFilterButtonClicked()}>
            <md-icon slot="icon" iconSet="momentumDesign" name="filter-bold" size="16" ariaHidden="true"></md-icon>
          </md-button>
        `;
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-button id="filter-button" variant="secondary" size="28" @click=${() => this.onFilterButtonClicked()}>
          <md-icon slot="icon" iconSet="momentumDesign" name="filter-bold" size="16" ariaHidden="true"></md-icon>
          ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:wcGrid:filter")}
        </md-button>
      `;
        }
        renderRefreshButton() {
            if (!this.wcGridHeaderConfig.refreshButton) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ``;
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<md-button id="refresh-grid-button" circle size="28" variant="ghost" @click=${this.onRefreshClicked}>
        <md-icon slot="icon" name="refresh-bold" iconSet="momentumDesign" size="16"></md-icon>
      </md-button>`;
        }
        renderUnsortedButton() {
            if (!this.wcGridHeaderConfig.unsortedButton) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ``;
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-button id="unsorted-button" circle variant="ghost" size="28" @click=${() => this.onUnsortedButtonClicked()}>
          <md-icon slot="icon" iconSet="momentumDesign" name="unsorted-bold" size="16" ariaHidden="true"></md-icon>
        </md-button>
      `;
        }
        renderDatePicker() {
            var _a, _b;
            if (!this.wcGridHeaderConfig.datePicker) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ``;
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <wc-grid-date-range-picker
          .startTime=${(_a = this.wcGridHeaderConfig.datePickerStartTime) !== null && _a !== void 0 ? _a : 0}
          .endTime=${(_b = this.wcGridHeaderConfig.datePickerEndTime) !== null && _b !== void 0 ? _b : 0}
          @search-date-range-updated=${this.onDateRangeSearchUpdated}
        ></wc-grid-date-range-picker>
      `;
        }
        render() {
            if (!this.showGridHeader()) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ``;
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ` <div class="wc-grid-header">
        <div class="left-group">${this.wcGridHeaderConfig.leftText}</div>
        <div class="center-group"></div>
        <div class="right-group">
          ${this.renderDatePicker()} ${this.renderRefreshButton()} ${this.renderResetButton()}
          ${this.renderColumnSelectButton()} ${this.renderUnsortedButton()} ${this.renderFilterButton()}
        </div>
      </div>`;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "wcGridHeaderConfig", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("wc-grid-header")
    ], Element);
    WcGridHeaderWidget.Element = Element;
})(WcGridHeaderWidget || (WcGridHeaderWidget = {}));


/***/ }),

/***/ "./src/components/Common/WcGrid/index.ts":
/*!***********************************************!*\
  !*** ./src/components/Common/WcGrid/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WcGridColumn: () => (/* reexport safe */ _WcColumns_WcGridColumn__WEBPACK_IMPORTED_MODULE_0__.WcGridColumn),
/* harmony export */   WcGridConfig: () => (/* reexport safe */ _WcGridConfig__WEBPACK_IMPORTED_MODULE_3__.WcGridConfig),
/* harmony export */   WcGridWidget: () => (/* reexport safe */ _WcGrid__WEBPACK_IMPORTED_MODULE_1__.WcGridWidget),
/* harmony export */   wcCustomIcons: () => (/* reexport safe */ _WcGridConfig__WEBPACK_IMPORTED_MODULE_3__.wcCustomIcons)
/* harmony export */ });
/* harmony import */ var _WcColumns_WcGridColumn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./WcColumns/WcGridColumn */ "./src/components/Common/WcGrid/WcColumns/WcGridColumn.ts");
/* harmony import */ var _WcGrid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./WcGrid */ "./src/components/Common/WcGrid/WcGrid.ts");
/* harmony import */ var _WcGrid_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./WcGrid.types */ "./src/components/Common/WcGrid/WcGrid.types.ts");
/* harmony import */ var _WcGridConfig__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./WcGridConfig */ "./src/components/Common/WcGrid/WcGridConfig.ts");






/***/ }),

/***/ "./src/components/Common/WidgetError/WidgetError.scss":
/*!************************************************************!*\
  !*** ./src/components/Common/WidgetError/WidgetError.scss ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

:host {
  height: 100%;
  width: 100%;
  display: flex;
}

.widget-error {
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: var(--border-radius-medium);
  background-color: var(--md-primary-bg-color);
  color: var(--md-primary-text-color);
  max-height: 312px;
}
.widget-error-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.widget-error-icon {
  background-color: var(--badge-red-bg-color);
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  margin-bottom: calc(var(--space-token-cardinal) * 2);
}
.widget-error-icon md-icon {
  color: var(--input-error-message-text-color);
}
.widget-error-heading {
  font-size: var(--font-size-large);
  margin: 0 auto calc(var(--space-token-cardinal) * 6);
  text-align: center;
}
.widget-error-detail {
  padding: calc(var(--space-token-cardinal) * 2);
  display: flex;
  flex-direction: column;
  max-width: 80%;
  margin: 0 auto;
  align-items: center;
  overflow: hidden;
}
.widget-error-toggle {
  text-decoration: underline;
  margin-bottom: calc(var(--space-token-cardinal) * 2) 0;
  cursor: pointer;
  position: relative;
  z-index: var(--z-overflow-scroll-button, 1);
}
.widget-error-info {
  max-height: 0;
  opacity: 0;
  display: flex;
  flex-direction: column;
  text-align: center;
  transition: max-height 0.25s, opacity 0.25s;
  font-size: var(--font-size-small);
}
.widget-error-info.visible {
  max-height: 100px;
  opacity: 1;
}
.widget-error-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: calc(var(--space-token-cardinal) * 2) 0;
}
.widget-error .trackingid-label {
  display: flex;
  flex: 0 0 auto;
}
.widget-error .trackingid-input {
  margin: 0 calc(var(--space-token-cardinal) * 2);
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.widget-error .copy-trackingid-icon {
  color: var(--md-default-focus-outline-color);
  display: flex;
  flex: 0 0 auto;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=WidgetError.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-services/dist/styles/z-index.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/WidgetError/WidgetError.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/WidgetError/WidgetError.ts":
/*!**********************************************************!*\
  !*** ./src/components/Common/WidgetError/WidgetError.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WidgetError: () => (/* binding */ WidgetError)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _WidgetError_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./WidgetError.scss */ "./src/components/Common/WidgetError/WidgetError.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var WidgetError;
(function (WidgetError) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.show = false;
            this.hideDetails = false;
            this.isCopied = false;
        }
        retry() {
            this.dispatchEvent(new CustomEvent("reload", {
                composed: true,
                bubbles: true
            }));
        }
        copyTrackingID() {
            var _a;
            const text = (_a = this.detail) === null || _a === void 0 ? void 0 : _a.trackingId;
            const inputTemp = document.createElement("input");
            if (inputTemp && text) {
                inputTemp.value = text;
                document.body.appendChild(inputTemp);
                inputTemp.select();
                document.execCommand("copy");
                document.body.removeChild(inputTemp);
                this.isCopied = true;
                setTimeout(() => {
                    this.isCopied = false;
                }, 1500);
            }
        }
        showMore() {
            this.show = !this.show;
        }
        get widgetErrorClassMap() {
            return {
                visible: this.show
            };
        }
        static get styles() {
            return _WidgetError_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
        }
        render() {
            var _a, _b, _c;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="widget-error">
          <div class="widget-error-content">
            <div class="widget-error-icon">
              <md-icon name="icon-warning_32"></md-icon>
            </div>
            <strong class="widget-error-heading">${((_a = this.detail) === null || _a === void 0 ? void 0 : _a.header) || (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.loadFail")}</strong>
            ${!this.hideDetails
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                  <md-button ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.tryAgain")}" @click=${this.retry} variant="primary"
                    >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.tryAgain")}</md-button
                  >
                  <div class="widget-error-detail">
                    <span class="widget-error-toggle" @click="${this.showMore}" part="widget-error-btn">
                      ${this.show
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorDetail.errorLessButton")} `
                    : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorDetail.errorMoreButton")} `}
                    </span>
                    <div class="widget-error-info ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)(this.widgetErrorClassMap)}">
                      <span>${(_b = this.detail) === null || _b === void 0 ? void 0 : _b.message}</span>
                      <div class="widget-error-wrapper">
                        <label class="trackingid-label">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorModal.trackingIdLabel")}:</label>
                        <div id="trackingid-input" class="trackingid-input">${(_c = this.detail) === null || _c === void 0 ? void 0 : _c.trackingId}</div>
                        <md-icon
                          id="copy-trackingid-icon"
                          name=${this.isCopied ? "icon-check_12" : "icon-copy_12"}
                          title=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorModal.trackingIdTitle")}
                          class="copy-trackingid-icon"
                          @click=${this.copyTrackingID}
                          ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorModal.trackingIdTitle")}
                          tabindex="0"
                        ></md-icon>
                      </div>
                    </div>
                  </div>
                `
                : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
          </div>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "show", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "detail", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "hideDetails", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isCopied", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)(".trackingid-input")
    ], Element.prototype, "trackID", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-widget-error")
    ], Element);
    WidgetError.Element = Element;
})(WidgetError || (WidgetError = {}));


/***/ }),

/***/ "./src/components/Common/WidgetLoader/WidgetLoader.scss":
/*!**************************************************************!*\
  !*** ./src/components/Common/WidgetLoader/WidgetLoader.scss ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.widget-loader {
  justify-content: center;
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: var(--border-radius-medium);
  background-color: var(--md-primary-bg-color);
  color: var(--md-primary-text-color);
  max-height: 312px;
}
.widget-loader-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.widget-loader-heading {
  font-size: var(--font-size-large);
  padding-top: calc(var(--space-token-even) * 3);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=WidgetLoader.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Common/WidgetLoader/WidgetLoader.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Common/WidgetLoader/WidgetLoader.ts":
/*!************************************************************!*\
  !*** ./src/components/Common/WidgetLoader/WidgetLoader.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WidgetLoader: () => (/* binding */ WidgetLoader)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _WidgetLoader_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./WidgetLoader.scss */ "./src/components/Common/WidgetLoader/WidgetLoader.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */




var WidgetLoader;
(function (WidgetLoader) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        static get styles() {
            return _WidgetLoader_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="widget-loader">
          <div class="widget-loader-wrapper">
            <md-spinner role="alert" aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.loading")} size="56"></md-spinner>
            <strong class="widget-loader-heading">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.loading")}...</strong>
          </div>
        </div>
      `;
        }
    };
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-widget-loader")
    ], Element);
    WidgetLoader.Element = Element;
})(WidgetLoader || (WidgetLoader = {}));


/***/ }),

/***/ "./src/components/CountDownTimer/CountDownTimer.ts":
/*!*********************************************************!*\
  !*** ./src/components/CountDownTimer/CountDownTimer.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CountDownTimer: () => (/* binding */ CountDownTimer)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _open_wc_testing_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @open-wc/testing-helpers */ "@open-wc/testing-helpers");
/* harmony import */ var _open_wc_testing_helpers__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_open_wc_testing_helpers__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _TeamPerformanceWidget_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../TeamPerformanceWidget/TeamPerformanceUtils */ "./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var CountDownTimer;
(function (CountDownTimer) {
    /**
     * @element agentx-wc-count-down-timer
     * @fires close-inactivity-modal
     * @fires countdown-start
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        constructor() {
            super(...arguments);
            this.countdownStartTime = 0; //seconds
            this.isDurationTimer = false;
            this.showDefaultHours = true;
            this.duration = "0";
            this.futureTimeStamp = luxon__WEBPACK_IMPORTED_MODULE_5__.DateTime.local().plus({ seconds: this.countdownStartTime });
            this.durationTimer = () => {
                this.durationTime = (0,_TeamPerformanceWidget_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_6__.getTimerValue)(this.duration, this.showDefaultHours);
            };
            this.countdownTimer = () => {
                if (parseInt(this.futureTimeStamp.diff(luxon__WEBPACK_IMPORTED_MODULE_5__.DateTime.local()).toFormat("ss")) > 0) {
                    this.requestUpdate();
                }
                else {
                    _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_2__.clearInterval(this.intervalId);
                    this.dispatchEvent(new CustomEvent("close-inactivity-modal", { bubbles: true, detail: true }));
                }
            };
        }
        connectedCallback() {
            super.connectedCallback();
            if (this.isDurationTimer) {
                if (this.duration !== "0") {
                    this.intervalId = setInterval(this.durationTimer, 1000);
                }
            }
            else {
                this.futureTimeStamp = luxon__WEBPACK_IMPORTED_MODULE_5__.DateTime.local().plus({ seconds: this.countdownStartTime });
                this.intervalId = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_2__.setInterval(this.countdownTimer, 1000);
                this.dispatchEvent(new CustomEvent("countdown-start", { bubbles: true, detail: { intervalId: this.intervalId } }));
            }
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            clearInterval(this.intervalId);
        }
        render() {
            var _a;
            return !this.isDurationTimer
                ? this.countdownStartTime > 0
                    ? (0,_open_wc_testing_helpers__WEBPACK_IMPORTED_MODULE_1__.html) `
              <span class="timeperiod">
                <time role="timer">${this.futureTimeStamp.diff(luxon__WEBPACK_IMPORTED_MODULE_5__.DateTime.local()).toFormat("ss")}</time>
              </span>
            `
                    : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing
                : (0,_open_wc_testing_helpers__WEBPACK_IMPORTED_MODULE_1__.html) `
            <time role="timer" datetime=${(_a = this.durationTime) !== null && _a !== void 0 ? _a : ""}>
              ${this.durationTime && this.durationTime !== "Invalid Duration" ? this.durationTime : "-"}
            </time>
          `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)()
    ], Element.prototype, "countdownStartTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)()
    ], Element.prototype, "isDurationTimer", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)()
    ], Element.prototype, "showDefaultHours", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)()
    ], Element.prototype, "duration", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "futureTimeStamp", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "intervalId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "durationTime", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-count-down-timer")
    ], Element);
    CountDownTimer.Element = Element;
})(CountDownTimer || (CountDownTimer = {}));


/***/ }),

/***/ "./src/components/EmergencyNotification/EmergencyNotificationContent.scss":
/*!********************************************************************************!*\
  !*** ./src/components/EmergencyNotification/EmergencyNotificationContent.scss ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.emergency-notification-content {
  font-size: 14px;
  line-height: 21px;
}
.emergency-notification-content .md-alert-banner__text {
  padding: 0;
}

.heading {
  font-weight: 700;
  margin: 8px 0px;
}

label {
  color: var(--md-secondary-text-color);
}

md-link::part(link) {
  color: var(--alert-banner-warning-text-color);
}

.emergency-modal-warning-content {
  display: flex;
  text-align: start;
  margin-left: -1.75rem;
  margin-right: -1.75rem;
}

.emergency-modal-warning-text {
  margin-left: 10px;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/EmergencyNotification/EmergencyNotificationContent.scss */
/*# sourceURL=EmergencyNotificationContent.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/EmergencyNotification/EmergencyNotificationContent.ts":
/*!******************************************************************************!*\
  !*** ./src/components/EmergencyNotification/EmergencyNotificationContent.ts ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EmergencyNotificationContent: () => (/* binding */ EmergencyNotificationContent)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _EmergencyNotificationContent_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./EmergencyNotificationContent.scss */ "./src/components/EmergencyNotification/EmergencyNotificationContent.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





var EmergencyNotificationContent;
(function (EmergencyNotificationContent) {
    /**
     * @element agentx-wc-emergency-notification-content
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        static get styles() {
            return _EmergencyNotificationContent_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        firstUpdated() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                const link = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-link");
                if (link) {
                    yield link.updateComplete;
                    const linkAnchor = (_b = link.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("a");
                    linkAnchor === null || linkAnchor === void 0 ? void 0 : linkAnchor.focus();
                }
            });
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="emergency-notification-container">
          <div class="emergency-notification-content">
            <md-alert-banner class="md-alert-banner-wrapper" show type="warning">
              <div class="emergency-modal-warning-content">
                <md-icon aria-hidden="true" name="warning-badge-filled" size="14" iconSet="momentumDesign"></md-icon>
                <div
                  class="emergency-modal-warning-text"
                  aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:emergencyServiceNotification.updateCurrentAddressContent")}"
                >
                  ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:emergencyServiceNotification.updateCurrentAddressContent")}
                  <md-link
                    inline
                    class="help-section-link"
                    aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:emergencyServiceNotification.seeHelpSection")}
                    tag="a"
                    href=${_constants__WEBPACK_IMPORTED_MODULE_0__.emergency911HelpLink}
                    target="_blank"
                    >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:emergencyServiceNotification.seeHelpSection")}</md-link
                  >
                </div>
              </div>
            </md-alert-banner>
          </div>
          <div class="emergency-notification-content">
            <div class="heading">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:emergencyServiceNotification.dialingEmergencyServices")}</div>
            <label>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:emergencyServiceNotification.dialingEmergencyServicesContent")}</label>
          </div>
        </div>
      `;
        }
    };
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-emergency-notification-content")
    ], Element);
    EmergencyNotificationContent.Element = Element;
})(EmergencyNotificationContent || (EmergencyNotificationContent = {}));


/***/ }),

/***/ "./src/components/EvaluationManager/EvaluationManagerForm.scss":
/*!*********************************************************************!*\
  !*** ./src/components/EvaluationManager/EvaluationManagerForm.scss ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  /* Spacing */
  --spacing-small: 10px;
  --spacing-medium: 16px;
  --spacing-large: 20px;
  --gap-medium: 12px;
  --button-padding-vertical: 10px;
  --button-padding-horizontal: 20px;
  /* Borders */
  --border-radius-small: 8px;
  /* Widths */
  --max-input-width: 400px;
  /* Heights */
  --full-height: 100%;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--gap-medium);
  padding: var(--button-padding-vertical) var(--button-padding-horizontal);
}

md-input::part(input) {
  max-width: var(--max-input-width);
}

.item__container {
  padding: var(--spacing-large);
  border: solid 1px var(--color-gray-border);
  border-radius: var(--border-radius-small);
  margin: 0 var(--spacing-small) var(--spacing-large);
  display: grid;
  grid-template-rows: var(--grid-template-rows);
  background: white;
}

.remove-question__button {
  justify-self: end;
  align-self: start;
}

.empty-state__header {
  display: flex;
  justify-content: flex-end;
}
.empty-state__header .close-icon {
  display: flex;
}

.outer__details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: start;
}

.questions__container {
  margin-left: var(--spacing-large);
}
.questions__container .question {
  display: grid;
  grid-template-rows: auto auto;
  padding: var(--spacing-medium);
  border: 1px solid var(--color-gray-border);
  border-radius: var(--border-radius-small);
  background: white;
}

.answers__container {
  margin-left: var(--spacing-large);
}
.answers__container .answer {
  align-items: center;
  display: grid;
  width: 25%;
  grid-template-columns: 1fr 1fr;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=EvaluationManagerForm.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/EvaluationManager/variables.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/EvaluationManager/EvaluationManagerForm.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/EvaluationManager/EvaluationManagerForm.ts":
/*!*******************************************************************!*\
  !*** ./src/components/EvaluationManager/EvaluationManagerForm.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EvaluationManagerForm: () => (/* binding */ EvaluationManagerForm)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! mobx */ "mobx");
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(mobx__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _EvaluationManagerForm_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./EvaluationManagerForm.scss */ "./src/components/EvaluationManager/EvaluationManagerForm.scss");
/* harmony import */ var _EvaluationManagerTable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./EvaluationManagerTable */ "./src/components/EvaluationManager/EvaluationManagerTable.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};








let EvaluationManagerForm = class EvaluationManagerForm extends _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__.MobxLitElement {
    constructor() {
        super();
        this.initializeFormData();
    }
    //Mobx actions for updating form data
    initializeFormData() {
        this.formData = { id: "", name: "", description: "", sections: [], status: "DRAFT" };
    }
    updateSectionField(index, name) {
        this.formData.sections[index].name = name;
    }
    updateStatus(status) {
        this.formData.status = status;
    }
    addSection() {
        this.formData.sections = [...this.formData.sections, { id: "", name: "", questions: [] }];
    }
    removeSection(index) {
        this.formData.sections.splice(index, 1);
    }
    updateField(field, value) {
        this.formData[field] = value;
    }
    updateQuestionTooltipText(sectionIndex, questionIndex, value) {
        this.formData.sections[sectionIndex].questions[questionIndex].tooltipText = value;
    }
    updateQuestionField(sectionIndex, questionIndex, value) {
        this.formData.sections[sectionIndex].questions[questionIndex].text = value;
    }
    addQuestion(sectionIndex) {
        this.formData.sections[sectionIndex].questions.push({
            id: "",
            text: "",
            tooltipText: "",
            type: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.QuestionType.SINGLE_CHOICE,
            weight: 0,
            autoFailThreshold: 0,
            options: [
                { text: "Yes", weight: "100", autoFail: false },
                { text: "No", weight: "0", autoFail: false },
                { text: "N/A", weight: "100", autoFail: false }
            ]
        });
    }
    removeQuestion(sectionIndex, questionIndex) {
        this.formData.sections[sectionIndex].questions.splice(questionIndex, 1);
    }
    updateAnswerField(sectionIndex, questionIndex, optionIndex, field, value) {
        this.formData.sections[sectionIndex].questions[questionIndex].options[optionIndex][field] = value;
    }
    getFormData() {
        return this.formData;
    }
    handleInput(callback) {
        return (event) => {
            const input = event.target;
            callback(input.value);
        };
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <md-form>
        <h3>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationManagerFormHeader")}</h3>

        <div>${this.renderFormDetails()}</div>

        <h4>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.sectionsHeader")}</h4>
        <div>${this.formData.sections.map((section, sectionIndex) => this.renderSection(section, sectionIndex))}</div>

        <md-button class="add-section__button" variant="primary" @click=${this.addSection}
          >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.addSection")}</md-button
        >

        <div class="form-actions">
          <md-button
            class="draft__button"
            @click=${() => this.saveForm(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationStatus.DRAFT)}
            variant="secondary"
            >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.saveAsDraft")}</md-button
          >
          <md-button
            class="publish__button"
            @click=${() => this.saveForm(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.AgentPerformanceTypes.EvaluationStatus.ACTIVE)}
            variant="primary"
            >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.publishForm")}</md-button
          >
        </div>
      </md-form>
    `;
    }
    saveForm(status) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.updateStatus(status);
            const cleanFormData = JSON.parse(JSON.stringify((0,mobx__WEBPACK_IMPORTED_MODULE_5__.toJS)(this.formData), (key, value) => (key === "id" && !this.formData.id ? undefined : value)));
            try {
                yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.agentPerformance.saveEvaluationForm({
                    orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || "",
                    data: cleanFormData
                });
                this.dispatchSetModeEvent(_EvaluationManagerTable__WEBPACK_IMPORTED_MODULE_7__.ViewMode.LIST);
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("Error saving evaluation form:", error);
            }
        });
    }
    dispatchSetModeEvent(mode) {
        this.dispatchEvent(new CustomEvent("set-mode-event", {
            detail: { mode },
            bubbles: true,
            composed: true
        }));
    }
    renderFormDetails() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <md-input
        name="name"
        label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.formNameLabel")}"
        value=${this.formData.name}
        placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.formNameLabel")}"
        @input=${this.handleInput((value) => this.updateField("name", value))}
      ></md-input>

      <md-input
        name="description"
        label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.formDescriptionLabel")}"
        value=${this.formData.description}
        placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.formDescriptionLabel")}"
        @input=${this.handleInput((value) => this.updateField("description", value))}
      ></md-input>
    `;
    }
    renderSection(section, sectionIndex) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <div class="item__container">
        <div class="outer__details">
          <div class="section__inputs">
            <md-input
              label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.sectionNameLabel")}"
              value=${section.name}
              placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.sectionNameLabel")}"
              @input=${this.handleInput((value) => this.updateSectionField(sectionIndex, value))}
            ></md-input>

            <md-button
              class="remove-section__button"
              variant="secondary"
              @click=${() => this.removeSection(sectionIndex)}
            >
              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.removeSection")}
            </md-button>

            <div class="questions__container">
              <h4>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.questionsHeader")}</h4>
              <div>
                ${section.questions.map((question, questionIndex) => this.renderQuestion(sectionIndex, question, questionIndex))}
              </div>

              <md-button
                class="remove-question__button"
                circle
                color="red"
                @click=${() => this.removeSection(sectionIndex)}
              >
                <md-icon name="delete-bold" size="16" iconSet="momentumDesign"></md-icon>
              </md-button>
            </div>

            <div class="questions__container">
              <h4>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.questionsHeader")}</h4>
              <div>
                ${section.questions.map((question, questionIndex) => this.renderQuestion(sectionIndex, question, questionIndex))}
              </div>
              <md-button class="add-question__button" variant="primary" @click=${() => this.addQuestion(sectionIndex)}>
                ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.addQuestion")}
              </md-button>
            </div>
          </div>
        </div>
      </div>
    `;
    }
    renderQuestion(sectionIndex, question, questionIndex) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <div class="question item__container">
        <div class="outer__details">
          <div class="question__inputs">
            <md-input
              class="question__input"
              label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.questionsLabel")} ${questionIndex + 1}"
              value=${question.text}
              placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.questionPlaceholder")}"
              @input=${this.handleInput((value) => this.updateQuestionField(sectionIndex, questionIndex, value))}
            ></md-input>

            <md-input
              class="question__input"
              label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.questionDescription")}"
              value=${question.tooltipText || ""}
              placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.questionDescription")}"
              @input=${this.handleInput((value) => this.updateQuestionTooltipText(sectionIndex, questionIndex, value))}
            ></md-input>
          </div>
          <md-button
            class="remove-question__button"
            circle
            color="red"
            @click=${() => this.removeQuestion(sectionIndex, questionIndex)}
          >
            <md-icon name="delete-bold" size="16" iconSet="momentumDesign"></md-icon>
          </md-button>
        </div>

        <div class="answers__container">
          <h4>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.answersHeader")}</h4>
          <div>
            ${question.options.map((option, optionIndex) => this.renderAnswer(sectionIndex, questionIndex, option, optionIndex))}
          </div>
        </div>
      </div>
    `;
    }
    renderAnswer(sectionIndex, questionIndex, option, optionIndex) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
      <div class="answer">
        <span>${option.text}</span>

        <md-input
          label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.weightLabel")}"
          type="number"
          name="weight"
          value=${option.weight}
          @input=${this.handleInput((value) => this.updateAnswerField(sectionIndex, questionIndex, optionIndex, "weight", value))}
        ></md-input>
      </div>
    `;
    }
    static get styles() {
        return _EvaluationManagerForm_scss__WEBPACK_IMPORTED_MODULE_6__["default"];
    }
};
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.observable
], EvaluationManagerForm.prototype, "formData", void 0);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "initializeFormData", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "updateSectionField", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "updateStatus", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "addSection", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "removeSection", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "updateField", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "updateQuestionTooltipText", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "updateQuestionField", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "addQuestion", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "removeQuestion", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_5__.action
], EvaluationManagerForm.prototype, "updateAnswerField", null);
EvaluationManagerForm = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("agentx-wc-evaluation-manager-form")
], EvaluationManagerForm);



/***/ }),

/***/ "./src/components/EvaluationManager/EvaluationManagerTable.scss":
/*!**********************************************************************!*\
  !*** ./src/components/EvaluationManager/EvaluationManagerTable.scss ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  /* Spacing */
  --spacing-small: 10px;
  --spacing-medium: 16px;
  --spacing-large: 20px;
  --gap-medium: 12px;
  --button-padding-vertical: 10px;
  --button-padding-horizontal: 20px;
  /* Borders */
  --border-radius-small: 8px;
  /* Widths */
  --max-input-width: 400px;
  /* Heights */
  --full-height: 100%;
}

.table__container {
  height: var(--full-height);
  padding: var(--spacing-large);
  background-color: white;
}

.table__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: var(--spacing-small);
}

.create__button {
  padding: var(--button-padding-vertical) var(--button-padding-horizontal);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=EvaluationManagerTable.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/EvaluationManager/variables.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/EvaluationManager/EvaluationManagerTable.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/EvaluationManager/EvaluationManagerTable.ts":
/*!********************************************************************!*\
  !*** ./src/components/EvaluationManager/EvaluationManagerTable.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EvaluationManagerTable: () => (/* binding */ EvaluationManagerTable),
/* harmony export */   ViewMode: () => (/* binding */ ViewMode),
/* harmony export */   formDefinitionColumn: () => (/* binding */ formDefinitionColumn)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Common/WcGrid/WcColumns/StringColumn */ "./src/components/Common/WcGrid/WcColumns/StringColumn.ts");
/* harmony import */ var _Common_WcGrid_WcGrid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Common/WcGrid/WcGrid */ "./src/components/Common/WcGrid/WcGrid.ts");
/* harmony import */ var _Common_WcGrid_WcGridConfig__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Common/WcGrid/WcGridConfig */ "./src/components/Common/WcGrid/WcGridConfig.ts");
/* harmony import */ var _EvaluationManagerTable_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./EvaluationManagerTable.scss */ "./src/components/EvaluationManager/EvaluationManagerTable.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};








var formDefinitionColumn;
(function (formDefinitionColumn) {
    formDefinitionColumn["Name"] = "name";
    formDefinitionColumn["Description"] = "description";
    formDefinitionColumn["Status"] = "status";
})(formDefinitionColumn || (formDefinitionColumn = {}));
var ViewMode;
(function (ViewMode) {
    ViewMode["LIST"] = "list";
    ViewMode["CREATE"] = "create";
})(ViewMode || (ViewMode = {}));
let EvaluationManagerTable = class EvaluationManagerTable extends lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement {
    constructor() {
        super(...arguments);
        this.selectedEvaluation = {
            id: "",
            name: "",
            sections: [],
            status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.EvaluationStatus.ACTIVE
        };
        this.mode = ViewMode.LIST;
        this.orgEvaluationForms = { data: [] };
    }
    connectedCallback() {
        super.connectedCallback();
    }
    getWcGridConfig() {
        return new _Common_WcGrid_WcGridConfig__WEBPACK_IMPORTED_MODULE_6__.WcGridConfig({
            tableName: "evaluationManager",
            enableCharts: false,
            headerConfig: {
                datePicker: false,
                resetGridStateButton: true,
                filterButton: "small",
                refreshButton: true,
                columnSelectButton: false
            },
            getGridRowData: () => __awaiter(this, void 0, void 0, function* () { return this.fetchRowData(); })
        });
    }
    handleCreateNewForm() {
        this.mode = ViewMode.CREATE;
    }
    fetchRowData() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile) {
                return [];
            }
            try {
                this.orgEvaluationForms = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.agentPerformance.fetchOrgEvaluationForms({
                    orgId: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile.orgId
                });
                const gridRowData = (_b = (_a = this.orgEvaluationForms) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map((form) => {
                    return {
                        name: form.name,
                        description: form.description,
                        status: form.status
                    };
                });
                return gridRowData;
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("Error fetching evaluation forms:", error);
                return [];
            }
        });
    }
    getWcColumnDefs() {
        const columns = [
            new _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_4__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:evaluations.columns.${formDefinitionColumn.Name}`), formDefinitionColumn.Name).setHidden(false),
            new _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_4__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:evaluations.columns.${formDefinitionColumn.Description}`), formDefinitionColumn.Description).setHidden(false),
            new _Common_WcGrid_WcColumns_StringColumn__WEBPACK_IMPORTED_MODULE_4__.StringColumn((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:evaluations.columns.${formDefinitionColumn.Status}`), formDefinitionColumn.Status).setHidden(false)
        ];
        return columns;
    }
    handleSetModeEvent(event) {
        this.mode = event.detail.mode;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div class="table__container">
        ${this.mode === ViewMode.LIST
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
              <div class="table__header">
                <h3>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationManagerTable")}</h3>
                <md-button class="create__button" variant="primary" @click=${this.handleCreateNewForm}>
                  ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.createNewForm")}
                </md-button>
              </div>
              <wc-ag-grid .wcGridConfig=${this.getWcGridConfig()} .wcColumnDefs=${this.getWcColumnDefs()}></wc-ag-grid>
            `
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
              <agentx-wc-evaluation-manager-form
                @set-mode-event=${this.handleSetModeEvent}
              ></agentx-wc-evaluation-manager-form>
            `}
      </div>
    `;
    }
    static get styles() {
        return _EvaluationManagerTable_scss__WEBPACK_IMPORTED_MODULE_7__["default"];
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
], EvaluationManagerTable.prototype, "selectedEvaluation", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], EvaluationManagerTable.prototype, "mode", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], EvaluationManagerTable.prototype, "orgEvaluationForms", void 0);
EvaluationManagerTable = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-evaluation-manager-table")
], EvaluationManagerTable);



/***/ }),

/***/ "./src/components/GridWidget/Grid.scss":
/*!*********************************************!*\
  !*** ./src/components/GridWidget/Grid.scss ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  --grid-header-height: 60px;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  --sentiment-chip-padding: 8px;
  --sentiment-chip-negative-background: rgba(255, 232, 234, 1);
  --sentiment-chip-negative-color: rgba(171, 10, 21, 1);
  --sentiment-chip-neutral-background: rgba(222, 222, 222, 1);
  --sentiment-chip-neutral-color: rgba(0, 0, 0, 0.7);
  --sentiment-chip-positive-background: rgba(206, 245, 235, 1);
  --sentiment-chip-positive-color: rgba(24, 94, 70, 1);
  --visualizer-title-width: 100px;
  --visualizer-title-margin-left: 24px;
  --visualizer-container-max-height: 40px;
  --visualizer-container-max-width: 900px;
  --visualizer-container-gap: 16px;
  --visualizer-bar-max-width: 577px;
  --visualizer-bar-max-height: 4px;
  --player-controls-row-height: 50px;
  --player-controls-gap: 8px;
  --volume-popover-width: 180px;
  --volume-popover-height: 21px;
  --volume-popover-gap: 12px;
  --volume-popover-top-offset: 120%;
  --volume-popover-left-offset: 50%;
  --volume-popover-padding: 12px;
  --seek-bar-height: 8px;
  --seek-bar-thumb-size: 16px;
  --popover-arrow-size: 10px;
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --interaction-details-height: 250px;
  --interaction-details-padding: 3px;
  --interaction-details-item-margin: 10px 0;
  --interaction-details-item-grid-template-columns: 150px auto;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

:host {
  --grid-wrapper-h-padding: 12px;
  --grid-header-display: flex;
  --grid-cell-border-radius: 0px;
  --grid-focus-border-radius: 4px;
}

.ag-theme-alpine,
.ag-theme-alpine-dark {
  --ag-row-hover-color: var(--grid-row-hover-color, rgba(33, 150, 243, 0.1));
  --ag-header-cell-moving-background-color: var(--ag-row-hover-color);
  --ag-input-focus-border-color: transparent;
}

.hide {
  display: none;
}

.grid-wrapper {
  height: 100%;
  --ag-row-hover-color: var(--grid-row-hover-color, rgba(33, 150, 243, 0.1));
  --ag-header-cell-moving-background-color: var(--ag-row-hover-color);
  --ag-text-color: var(--md-primary-text-color);
  --ag-subtle-text-color: var(--md-primary-text-color);
  --ag-drag-handle-color: var(--md-primary-text-color);
  --ag-input-background-color: var(--input-default-bg-color);
  --ag-input-text-color: var(--input-default-text-color);
  --ag-input-placeholder-text-color: var(--input-default-placeholder-color);
  --ag-input-border-radius: var(--input-border-radius);
  --ag-input-focus-text-color: var(--input-default-text-color);
  --ag-input-text-color: var(--input-default-text-color);
  --ag-checkbox-checked-shape-color: var(--checkbox-icon-color);
  --ag-checkbox-unchecked-background-color: var(--checkbox-bg-color);
  --ag-checkbox-unchecked-border-color: var(--checkbox-border-color);
  --ag-checkbox-checked-background-color: var(--checkbox-selected-bg-color);
  --ag-checkbox-checked-border-color: var(--checkbox-selected-border-color);
  --ag-checkbox-indeterminate-shape-color: var(--checkbox-icon-color);
  --ag-checkbox-indeterminate-background-color: var(--checkbox-selected-bg-color);
  --ag-checkbox-indeterminate-border-color: var(--checkbox-selected-border-color);
  --ag-picker-button-background-color: var(--combobox-bg-color);
  --ag-picker-button-focus-background-color: var(--combobox-focus-bg-color);
  --ag-picker-list-background-color: var(--combobox-bg-color);
}
.grid-wrapper .grid-container {
  height: calc(100% - (var(--grid-header-height)));
  background-color: var(--md-glass-overlay-bg-color);
  border-radius: var(--grid-container-border-radius);
  padding-left: var(--grid-container-h-padding);
  padding-right: var(--grid-container-h-padding);
  padding-top: var(--grid-container-top-padding);
}
.grid-wrapper .grid-container .ag-overlay-wrapper {
  display: block;
}
.grid-wrapper .grid-container .ag-root-wrapper {
  border-right: 0px;
  border-left: 0px;
  border-bottom: 0px;
  border-color: var(--md-table-primary-bg-color);
  background-color: transparent;
}
.grid-wrapper .grid-container .ag-row {
  border-color: var(--md-table-primary-bg-color);
  border-bottom: var(--md-table-cell-border-bottom);
  z-index: 0;
}
.grid-wrapper .grid-container .ag-row,
.grid-wrapper .grid-container .ag-body-viewport {
  background-color: transparent;
}
.grid-wrapper .grid-container .ag-cell-focus {
  box-shadow: none;
  background-color: var(--list-hover-background);
  border-radius: var(--grid-cell-border-radius);
}
.grid-wrapper .grid-container .ag-row-hover {
  border-radius: var(--grid-cell-border-radius);
  overflow: hidden;
}
.grid-wrapper .grid-container .ag-cell {
  padding-left: var(--grid-wrapper-h-padding);
  padding-right: var(--grid-wrapper-h-padding);
}
.grid-wrapper .grid-container .ag-cell.ag-cell-focus:focus-within {
  outline: 2px solid var(--list-focus-border-color) !important;
  outline-offset: -2px;
  border-radius: var(--grid-focus-border-radius);
}
.grid-wrapper .grid-container .ag-ltr .ag-cell-focus:not(.ag-cell-range-selected):focus-within,
.grid-wrapper .grid-container .ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.grid-wrapper .grid-container .ag-ltr .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,
.grid-wrapper .grid-container .ag-ltr .ag-cell-range-single-cell,
.grid-wrapper .grid-container .ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle,
.grid-wrapper .grid-container .ag-rtl .ag-cell-focus:not(.ag-cell-range-selected):focus-within,
.grid-wrapper .grid-container .ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.grid-wrapper .grid-container .ag-rtl .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,
.grid-wrapper .grid-container .ag-rtl .ag-cell-range-single-cell,
.grid-wrapper .grid-container .ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle {
  border: none;
}
.grid-wrapper .grid-container .ag-cell,
.grid-wrapper .grid-container .ag-pinned-left-header,
.grid-wrapper .grid-container .ag-pinned-right-header,
.grid-wrapper .grid-container .ag-pinned-right-cols-container {
  color: var(--md-primary-text-color);
  border: none;
  border-width: 1px;
  border-right-style: solid;
  border-color: var(--md-table-column-divider-color) !important;
}
.grid-wrapper .grid-container .ag-header {
  z-index: var(--z-index-tpw-header);
  border: none;
  border-width: 1px;
  border-right-style: var(--md-table-border-style);
  border-bottom-style: solid;
  color: var(--md-primary-text-color);
  background-color: var(--md-table-header-bg-color);
  border-color: var(--md-table-header-border-bottom-color);
  display: var(--grid-header-display);
}
.grid-wrapper .grid-container .ag-header-cell {
  padding-left: var(--grid-wrapper-h-padding);
  padding-right: var(--grid-wrapper-h-padding);
}
.grid-wrapper .grid-container .ag-header-cell.ag-header-active, .grid-wrapper .grid-container .ag-header-cell:focus {
  outline: 2px solid var(--list-focus-border-color) !important;
  outline-offset: -2px;
  border-radius: 4px;
}
.grid-wrapper .grid-container .ag-header-cell.ag-header-active::after, .grid-wrapper .grid-container .ag-header-cell:focus::after {
  border: none;
}
.grid-wrapper .grid-container .ag-header-cell-text {
  color: var(--md-table-header-text-color, var(--md-secondary-text-color));
  font-size: 14px;
  font-family: var(--brand-font-bold, "CiscoSansTT Regular"), sans-serif;
  font-weight: var(--brand-font-weight-bold, 100);
}
.grid-wrapper .grid-container .actions-cell {
  overflow: visible;
}
.grid-wrapper .grid-container .ag-row.ag-row-focus {
  z-index: 1;
}
.grid-wrapper .grid-container .ag-header-cell-resize {
  right: -5px;
}
.grid-wrapper .grid-container .ag-pinned-left-header .ag-header-cell-resize {
  right: -4px;
}
.grid-wrapper .grid-container .ag-header-cell-resize::after {
  height: 100%;
  top: 0;
  background-color: var(--md-table-primary-bg-color);
  width: 1px !important;
  box-shadow: none;
}
.grid-wrapper .grid-container .ag-pinned-right-header .ag-header-cell-resize::after {
  left: calc(50% - 1px);
  width: 2px !important;
}
.grid-wrapper .grid-container .ag-cell.ag-cell-last-left-pinned,
.grid-wrapper .grid-container .ag-pinned-left-header {
  border-width: 1px;
  right: 0px;
  left: auto !important;
}
.grid-wrapper .grid-container .ag-pinned-right-header {
  border-right: none;
}
.grid-wrapper .grid-container .ag-pinned-right-header,
.grid-wrapper .grid-container .ag-pinned-right-cols-container {
  border-left-style: solid;
  border-left-color: var(--md-table-pinned-border-color) !important;
  border-left-width: 1px;
  box-shadow: var(--pinned-column-elevation);
}
.grid-wrapper .grid-container .ag-pinned-right-header .ag-row,
.grid-wrapper .grid-container .ag-pinned-right-cols-container .ag-row {
  background-color: var(--md-table-pinned-bg-color);
}
.grid-wrapper .grid-container .ag-pinned-right-header .ag-row .ag-cell,
.grid-wrapper .grid-container .ag-pinned-right-cols-container .ag-row .ag-cell {
  border-left-style: none;
}
.grid-wrapper .grid-container .ag-pinned-right-header .ag-header-cell,
.grid-wrapper .grid-container .ag-pinned-right-cols-container .ag-header-cell {
  background-color: var(--pinned-column-header-bg-color);
}
.grid-wrapper .grid-container .ag-pinned-left-header,
.grid-wrapper .grid-container .ag-pinned-left-cols-container {
  border-right-style: solid;
  border-right-width: 1px;
  border-right-color: var(--md-table-pinned-border-color) !important;
  box-shadow: var(--pinned-column-elevation);
}
.grid-wrapper .grid-container .ag-pinned-left-header .ag-row,
.grid-wrapper .grid-container .ag-pinned-left-cols-container .ag-row {
  background-color: var(--md-table-pinned-bg-color);
}
.grid-wrapper .grid-container .ag-pinned-left-header .ag-row .ag-cell,
.grid-wrapper .grid-container .ag-pinned-left-cols-container .ag-row .ag-cell {
  border-right-style: none;
}
.grid-wrapper .grid-container .ag-pinned-left-header .ag-header-cell,
.grid-wrapper .grid-container .ag-pinned-left-cols-container .ag-header-cell {
  background-color: var(--pinned-column-header-bg-color);
}
.grid-wrapper .grid-container .ag-cell-expandable {
  font-weight: bold;
}
.grid-wrapper .grid-container .ag-row.ag-row-level-0.ag-full-width-row {
  background-color: var(--md-tertiary-bg-color);
}
.grid-wrapper .grid-container .ag-header-icon.ag-header-cell-menu-button {
  opacity: 1;
}
.grid-wrapper .grid-container div.ag-row {
  font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", sans-serif;
}
.grid-wrapper .grid-container .ag-theme-alpine .ag-menu-header,
.grid-wrapper .grid-container .ag-theme-alpine-dark .ag-menu-header {
  display: none;
}
.grid-wrapper .grid-container .ag-group-expanded,
.grid-wrapper .grid-container .ag-group-contracted {
  margin-right: 20px;
}
.grid-wrapper .ag-menu {
  border-radius: var(--border-radius-medium);
  color: var(--md-primary-text-color);
  border-color: var(--md-menu-overlay-border-color);
  box-shadow: 0 1px 4px 1px var(--md-menu-overlay-border-color);
  margin-top: 25px;
  margin-left: 15px;
}
.grid-wrapper .ag-header-icon {
  color: var(--md-secondary-text-color);
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-0.ag-full-width-row .ag-row-group.ag-row-group-indent-0 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-1.ag-full-width-row .ag-row-group.ag-row-group-indent-1 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-2.ag-full-width-row .ag-row-group.ag-row-group-indent-2 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-3.ag-full-width-row .ag-row-group.ag-row-group-indent-3 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-4.ag-full-width-row .ag-row-group.ag-row-group-indent-4 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-5.ag-full-width-row .ag-row-group.ag-row-group-indent-5 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-6.ag-full-width-row .ag-row-group.ag-row-group-indent-6 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-7.ag-full-width-row .ag-row-group.ag-row-group-indent-7 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-8.ag-full-width-row .ag-row-group.ag-row-group-indent-8 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-9.ag-full-width-row .ag-row-group.ag-row-group-indent-9 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-10.ag-full-width-row .ag-row-group.ag-row-group-indent-10 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-11.ag-full-width-row .ag-row-group.ag-row-group-indent-11 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-12.ag-full-width-row .ag-row-group.ag-row-group-indent-12 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-13.ag-full-width-row .ag-row-group.ag-row-group-indent-13 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-14.ag-full-width-row .ag-row-group.ag-row-group-indent-14 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-15.ag-full-width-row .ag-row-group.ag-row-group-indent-15 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-16.ag-full-width-row .ag-row-group.ag-row-group-indent-16 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-17.ag-full-width-row .ag-row-group.ag-row-group-indent-17 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-18.ag-full-width-row .ag-row-group.ag-row-group-indent-18 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-19.ag-full-width-row .ag-row-group.ag-row-group-indent-19 {
  padding-left: 8px;
}
.grid-wrapper .ag-row.ag-row-level-1 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-2 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-3 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-4 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-5 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-6 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-7 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-8 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-9 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-10 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-11 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-12 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-13 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-14 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-15 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-16 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-17 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-18 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}
.grid-wrapper .ag-row.ag-row-level-19 div[role=gridcell][aria-colindex="1"],
.grid-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--grid-wrapper-h-padding);
}

.channel-type-renderer {
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  padding-top: 8px;
}

.qmw-actions-cell {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 2px 0 0 6px;
  height: 100%;
}
.qmw-actions-cell .qmw-play-btn:focus {
  box-shadow: 0 0 0 0.125rem var(--button-focus-ring-color, #007aa3);
  border-radius: 2px;
}

.cell-renderer {
  width: 100%;
  height: 100%;
}

.listitem-cell-renderer {
  width: 100%;
  height: 100%;
  display: flex;
}

.ag-side-buttons,
.ag-tool-panel-horizontal-resize {
  display: none;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=Grid.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/GridWidget/variables.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-services/dist/styles/z-index.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/GridWidget/Grid.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/GridWidget/Grid.ts":
/*!*******************************************!*\
  !*** ./src/components/GridWidget/Grid.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GridWidget: () => (/* binding */ GridWidget)
/* harmony export */ });
/* harmony import */ var _components_Common_Utils_GridUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/Utils/GridUtils */ "./src/components/Common/Utils/GridUtils.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ag-grid-enterprise */ "ag-grid-enterprise");
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Grid_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Grid.scss */ "./src/components/GridWidget/Grid.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var GridWidget;
(function (GridWidget) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        get areScriptsLoaded() {
            return this.isAgGridLoaded && this.isAlpineLoaded;
        }
        get gridWrapperClassMap() {
            return {
                "grid-wrapper": true,
                hide: !this.areScriptsLoaded && !this.newTheme
            };
        }
        get gridContainerClassMap() {
            return {
                "grid-container": true,
                "ag-theme-alpine": !this.isDarkMode,
                "ag-theme-alpine-dark": this.isDarkMode
            };
        }
        getGridApi() {
            return this.gridApi;
        }
        static get styles() {
            return [_Grid_scss__WEBPACK_IMPORTED_MODULE_5__["default"]];
        }
        constructor() {
            super();
            this.gridOptions = {};
            this.isDarkMode = false;
            this.isLoggedIntoStation = false;
            this.newTheme = false;
            this.isAgGridLoaded = false;
            this.isAlpineLoaded = false;
            (0,_components_Common_Utils_GridUtils__WEBPACK_IMPORTED_MODULE_0__.initializeGlobalGridProperties)();
        }
        initializeGrid() {
            this.gridApi = (0,ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_2__.createGrid)(this._gridDiv, this.gridOptions);
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            this.loadAGGridScript();
        }
        createHTMLLink(href) {
            const linkElement = document.createElement("link");
            linkElement.setAttribute("rel", "stylesheet");
            linkElement.setAttribute("href", href);
            return linkElement;
        }
        loadAGGridScript() {
            var _a;
            const momentumIcons = this.createHTMLLink("/css/momentum-ui-icons.min.css");
            const momentumCore = this.createHTMLLink("/css/momentum-ui.min.css");
            const rootElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".grid-wrapper");
            rootElement === null || rootElement === void 0 ? void 0 : rootElement.prepend(momentumIcons);
            rootElement === null || rootElement === void 0 ? void 0 : rootElement.prepend(momentumCore);
            if (!this.newTheme) {
                const agGridLink = this.createHTMLLink("ag-grid/ag-grid.css");
                const agThemeAlpineLink = this.createHTMLLink("ag-grid/ag-theme-alpine.css");
                rootElement === null || rootElement === void 0 ? void 0 : rootElement.prepend(agThemeAlpineLink);
                rootElement === null || rootElement === void 0 ? void 0 : rootElement.prepend(agGridLink);
                agGridLink.onload = () => {
                    this.isAgGridLoaded = true;
                };
                agThemeAlpineLink.onload = () => {
                    this.isAlpineLoaded = true;
                };
            }
        }
        updated(changedProperties) {
            var _a;
            super.updated(changedProperties);
            if (changedProperties.has("gridOptions") && this.isLoggedIntoStation) {
                if (changedProperties.get("gridOptions")) {
                    (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.destroy();
                }
                this.initializeGrid();
            }
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class=${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)(this.gridWrapperClassMap)}>
          ${this.newTheme
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<div id="agentx-wc-ag-grid-container" class=${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)(this.gridContainerClassMap)}></div>`
                : (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<div
                id="agentx-wc-ag-grid-container"
                style="width: 100%; height: 100%;"
                class=${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)(this.gridContainerClassMap)}
              ></div>`}
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)("#agentx-wc-ag-grid-container")
    ], Element.prototype, "_gridDiv", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
    ], Element.prototype, "gridOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isDarkMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isLoggedIntoStation", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "newTheme", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "gridApi", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isAgGridLoaded", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isAlpineLoaded", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-ag-grid")
    ], Element);
    GridWidget.Element = Element;
})(GridWidget || (GridWidget = {}));


/***/ }),

/***/ "./src/components/GridWidget/GridCacheUtils.ts":
/*!*****************************************************!*\
  !*** ./src/components/GridWidget/GridCacheUtils.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   mergedSimplifiedStateWithDefault: () => (/* binding */ mergedSimplifiedStateWithDefault),
/* harmony export */   simplifyState: () => (/* binding */ simplifyState)
/* harmony export */ });
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");

function simplifyState(stateToSimplify, defaultState) {
    if (!stateToSimplify) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error("[GridCacheUtils] stateToSimplify is null state found. stateToSimplify:");
        return stateToSimplify;
    }
    else if (stateToSimplify === defaultState) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info("[GridCacheUtils] stateToSimplify === defaultState:");
        return null;
    }
    const simplifiedColumnStates = [];
    stateToSimplify.forEach((column) => {
        const defaultColumn = defaultState.find((defCol) => defCol.colId === column.colId);
        if (!defaultColumn) {
            _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info("[GridCacheUtils] column with colId ", column.colId, " not found in default state.");
            return;
        }
        let simplifiedColumn = {};
        simplifiedColumn.colId = column.colId;
        for (const key in column) {
            const k = key;
            if (column[k] !== defaultColumn[k]) {
                simplifiedColumn = Object.assign(Object.assign({}, simplifiedColumn), { [key]: column[k] });
            }
        }
        simplifiedColumnStates.push(simplifiedColumn);
    });
    return simplifiedColumnStates.length > 0 ? simplifiedColumnStates : null;
}
function mergedSimplifiedStateWithDefault(simplifiedState, defaultState) {
    if (!simplifiedState) {
        return null;
    }
    const mergedState = [];
    for (const simplifiedColumn of simplifiedState) {
        const defaultColumn = defaultState.find((col) => col.colId === simplifiedColumn.colId);
        if (defaultColumn) {
            const defaultColumnShallowCopy = Object.assign({}, defaultColumn);
            Object.assign(defaultColumnShallowCopy, simplifiedColumn);
            mergedState.push(defaultColumnShallowCopy);
        }
    }
    return mergedState;
}


/***/ }),

/***/ "./src/components/GridWidget/KeySuppressor.ts":
/*!****************************************************!*\
  !*** ./src/components/GridWidget/KeySuppressor.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   KeySuppressor: () => (/* binding */ KeySuppressor)
/* harmony export */ });
/* harmony import */ var _Common_CellRenderers_CustomKeyboardNav__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/CellRenderers/CustomKeyboardNav */ "./src/components/Common/CellRenderers/CustomKeyboardNav.ts");

class KeySuppressor {
    constructor(colIds, querySelector) {
        this.colIds = [];
        this.querySelector = "";
        this.suppressKeyboardEvent = ({ event }) => {
            const { key, shiftKey } = event;
            const path = this.getEventPath(event);
            const isTabForward = key === "Tab" && shiftKey === false;
            const isTabBackward = key === "Tab" && shiftKey === true;
            let suppressEvent = false;
            // Handle cell children tabbing
            if (isTabForward || isTabBackward) {
                const eGridCell = path.find((el) => {
                    var _a, _b;
                    if (el.attributes === undefined) {
                        return false;
                    }
                    const colId = (_b = (_a = el.attributes.getNamedItem("col-id")) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase();
                    return colId && this.colIds.includes(colId);
                });
                if (eGridCell) {
                    const actionButtons = eGridCell.querySelector(this.querySelector);
                    if (actionButtons) {
                        if (isTabForward) {
                            suppressEvent = _Common_CellRenderers_CustomKeyboardNav__WEBPACK_IMPORTED_MODULE_0__["default"].focusNext(actionButtons);
                        }
                        else {
                            suppressEvent = _Common_CellRenderers_CustomKeyboardNav__WEBPACK_IMPORTED_MODULE_0__["default"].focusPrevious(actionButtons);
                        }
                    }
                }
            }
            if (suppressEvent) {
                event.preventDefault();
            }
            return suppressEvent;
        };
        this.colIds = colIds;
        this.querySelector = querySelector;
    }
    getEventPath(event) {
        const path = [];
        let currentTarget = event.target;
        while (currentTarget) {
            path.push(currentTarget);
            currentTarget = currentTarget.parentElement;
        }
        return path;
    }
}


/***/ }),

/***/ "./src/components/IframeBase/IframeBase.scss":
/*!***************************************************!*\
  !*** ./src/components/IframeBase/IframeBase.scss ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host .iframe {
  width: 100%;
  height: 100%;
  border: 0;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/IframeBase/IframeBase.scss */
/*# sourceURL=IframeBase.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvSWZyYW1lQmFzZS9JZnJhbWVCYXNlLnNjc3MiLCJJZnJhbWVCYXNlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0U7RUFDRSxXQUFBO0VBQ0EsWUFBQTtFQUNBLFNBQUE7QUNBSiIsImZpbGUiOiJJZnJhbWVCYXNlLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XG4gIC5pZnJhbWUge1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIGhlaWdodDogMTAwJTtcbiAgICBib3JkZXI6IDA7XG4gIH1cbn1cbiIsIjpob3N0IC5pZnJhbWUge1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xuICBib3JkZXI6IDA7XG59Il19 */`);
    

/***/ }),

/***/ "./src/components/IframeBase/IframeBase.ts":
/*!*************************************************!*\
  !*** ./src/components/IframeBase/IframeBase.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   IframeBase: () => (/* binding */ IframeBase)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _IframeBase_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./IframeBase.scss */ "./src/components/IframeBase/IframeBase.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var IframeBase;
(function (IframeBase) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.src = "";
            this.isDarkTheme = false;
            this.allowedParams = "";
            this.title = "";
            this.finalUrl = this.src;
        }
        static get styles() {
            return _IframeBase_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
        }
        render() {
            if (this.src) {
                const url = new URL(this.src);
                url.searchParams.set("is_dark_theme", this.isDarkTheme.toString());
                this.finalUrl = url.href;
            }
            return this.src
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <iframe class="iframe" allow="${this.allowedParams}" src="${this.finalUrl}" title="${this.title}"></iframe>
          `
                : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <uuip-wc-content-error>
              <span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:badUrl")}}</span>
            </uuip-wc-content-error>
          `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "src", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean, attribute: "is-dark-theme" })
    ], Element.prototype, "isDarkTheme", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "allowedParams", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "title", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "finalUrl", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-iframe")
    ], Element);
    IframeBase.Element = Element;
})(IframeBase || (IframeBase = {}));


/***/ }),

/***/ "./src/components/IframeLogin/IframeLogin.scss":
/*!*****************************************************!*\
  !*** ./src/components/IframeLogin/IframeLogin.scss ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  --logo-width: 190px;
  --logo-height: 1.5rem;
  --max-logo-height: 80px;
  --max-wrapper-width: 262px;
}

.login-container {
  width: 100vw;
  height: 100vh;
  display: flex;
}

.login-wrapper {
  margin: auto;
  display: flex;
  width: 100%;
  max-width: var(--max-wrapper-width);
  flex-direction: column;
  align-items: center;
}

.ci-login-logo {
  width: 100%;
  max-width: var(--logo-width);
  max-height: var(--max-logo-height);
  margin-bottom: calc(var(--space-token-cardinal) * 9);
  font-size: 5rem;
}

.ci-login-logo img {
  width: var(--logo-width);
  height: var(--logo-height);
}

.user-message {
  text-align: center;
  font-size: var(--font-size-medium);
  font-style: normal;
  font-family: var(--font-family-light);
  font-weight: var(--font-weight-lite);
  line-height: calc(var(--space-token-cardinal) * 4);
}

.signin-button {
  margin-bottom: calc(var(--space-token-cardinal) * 5);
}

.signin-div {
  width: 180px;
}
.signin-div span {
  margin: auto;
  font-family: var(--font-family);
  font-size: var(--font-size-medium);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=IframeLogin.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/IframeLogin/IframeLogin.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/IframeLogin/IframeLogin.ts":
/*!***************************************************!*\
  !*** ./src/components/IframeLogin/IframeLogin.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   IframeLogin: () => (/* binding */ IframeLogin)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _IframeLogin_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./IframeLogin.scss */ "./src/components/IframeLogin/IframeLogin.scss");
/* harmony import */ var _img_Cisco_Webex_Logo_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @img/Cisco_Webex_Logo.svg */ "./src/assets/images/Cisco_Webex_Logo.svg");
/* harmony import */ var _img_Cisco_Webex_Logo_svg__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_img_Cisco_Webex_Logo_svg__WEBPACK_IMPORTED_MODULE_5__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var IframeLogin;
(function (IframeLogin) {
    /**
     * @element agentx-wc-iframe-login
     * @fires request-iframe-login
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        constructor() {
            super(...arguments);
            this.isLoading = false;
        }
        static get styles() {
            return _IframeLogin_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        login() {
            this.dispatchEvent(new CustomEvent("request-iframe-login", { bubbles: true, composed: true }));
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[IframeLogin]: request-iframe-login");
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="login-container">
          <div class="login-wrapper">
            <div class="ci-login-logo">
              <img src=${(_img_Cisco_Webex_Logo_svg__WEBPACK_IMPORTED_MODULE_5___default())} alt="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.webex")}" />
            </div>
            <div class="signin-button">
              ${this.isLoading
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <md-spinner></md-spinner> `
                : (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                    <md-button ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:iframeLogin.signIn")}" variant="primary" @click="${this.login}"
                      ><div class="signin-div">
                        <span> ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:iframeLogin.signIn")} </span>
                      </div>
                    </md-button>
                  `}
            </div>
            <div class="user-message">
              ${this.isLoading ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:iframeLogin.signingIn") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:iframeLogin.userMessage")}
            </div>
          </div>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isLoading", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-iframe-login")
    ], Element);
    IframeLogin.Element = Element;
})(IframeLogin || (IframeLogin = {}));


/***/ }),

/***/ "./src/components/ImiChatWrapper/ImiChatWrapper.scss":
/*!***********************************************************!*\
  !*** ./src/components/ImiChatWrapper/ImiChatWrapper.scss ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.imi-chat {
  width: 100%;
  height: 100%;
  position: relative;
}

.widget-loader {
  justify-content: center;
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: var(--border-radius-medium);
  background-color: var(--md-primary-bg-color);
  color: var(--md-primary-text-color);
}
.widget-loader-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.hidden {
  display: none;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/ImiChatWrapper/ImiChatWrapper.scss */
/*# sourceURL=ImiChatWrapper.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvSW1pQ2hhdFdyYXBwZXIvSW1pQ2hhdFdyYXBwZXIuc2NzcyIsIkltaUNoYXRXcmFwcGVyLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxXQUFBO0VBQ0EsWUFBQTtFQUNBLGtCQUFBO0FDQ0Y7O0FERUE7RUFDRSx1QkFBQTtFQUNBLGFBQUE7RUFDQSxXQUFBO0VBQ0EsWUFBQTtFQUNBLDBDQUFBO0VBQ0EsNENBQUE7RUFDQSxtQ0FBQTtBQ0NGO0FEQ0U7RUFDRSxhQUFBO0VBQ0Esc0JBQUE7RUFDQSx1QkFBQTtFQUNBLG1CQUFBO0FDQ0o7O0FER0E7RUFDRSxhQUFBO0FDQUYiLCJmaWxlIjoiSW1pQ2hhdFdyYXBwZXIuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5pbWktY2hhdCB7XG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IDEwMCU7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbn1cblxuLndpZGdldC1sb2FkZXIge1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgZGlzcGxheTogZmxleDtcbiAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogMTAwJTtcbiAgYm9yZGVyLXJhZGl1czogdmFyKC0tYm9yZGVyLXJhZGl1cy1tZWRpdW0pO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LWJnLWNvbG9yKTtcbiAgY29sb3I6IHZhcigtLW1kLXByaW1hcnktdGV4dC1jb2xvcik7XG5cbiAgJi13cmFwcGVyIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgfVxufVxuXG4uaGlkZGVuIHtcbiAgZGlzcGxheTogbm9uZTtcbn1cbiIsIi5pbWktY2hhdCB7XG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IDEwMCU7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbn1cblxuLndpZGdldC1sb2FkZXIge1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgZGlzcGxheTogZmxleDtcbiAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogMTAwJTtcbiAgYm9yZGVyLXJhZGl1czogdmFyKC0tYm9yZGVyLXJhZGl1cy1tZWRpdW0pO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LWJnLWNvbG9yKTtcbiAgY29sb3I6IHZhcigtLW1kLXByaW1hcnktdGV4dC1jb2xvcik7XG59XG4ud2lkZ2V0LWxvYWRlci13cmFwcGVyIHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG59XG5cbi5oaWRkZW4ge1xuICBkaXNwbGF5OiBub25lO1xufSJdfQ== */`);
    

/***/ }),

/***/ "./src/components/ImiChatWrapper/ImiChatWrapper.ts":
/*!*********************************************************!*\
  !*** ./src/components/ImiChatWrapper/ImiChatWrapper.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ImiChatWrapper: () => (/* binding */ ImiChatWrapper)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ImiChatWrapper_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ImiChatWrapper.scss */ "./src/components/ImiChatWrapper/ImiChatWrapper.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var ImiChatWrapper;
(function (ImiChatWrapper) {
    /**
     * @element imi-chat-wrapper
     * @fires update-imi-init-status
     *
     */
    let ImiChatWrapperWidget = class ImiChatWrapperWidget extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.convId = "";
            this.isDarkMode = false;
            this.isLoading = true;
        }
        update(changedProperties) {
            super.update(changedProperties);
            changedProperties.forEach((oldValue, name) => {
                if (name === "convId") {
                    this.evt("update-imi-init-status", true);
                }
            });
        }
        evt(name, detail) {
            this.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true, detail }));
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[IMIWrapper] Dispatching", name, detail);
        }
        connectedCallback() {
            super.connectedCallback();
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[IMIWrapper: Render] => Is imi-chat-widget defined`);
        }
        static get styles() {
            return _ImiChatWrapper_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="imi-chat ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)({ hidden: this.isLoading })}">
          <imi-engage conversationid="${this.convId}" theme="${this.isDarkMode ? "DARK" : "LIGHT"}" lang="en-US">
          </imi-engage>
        </div>
        ${this.isLoading
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
              <div class="widget-loader">
                <div class="widget-loader-wrapper">
                  <md-spinner aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.loading")} size="56"></md-spinner>
                </div>
              </div>
            `
                : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], ImiChatWrapperWidget.prototype, "convId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean, attribute: "is-dark-mode" })
    ], ImiChatWrapperWidget.prototype, "isDarkMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], ImiChatWrapperWidget.prototype, "isLoading", void 0);
    ImiChatWrapperWidget = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("imi-chat-wrapper")
    ], ImiChatWrapperWidget);
    ImiChatWrapper.ImiChatWrapperWidget = ImiChatWrapperWidget;
})(ImiChatWrapper || (ImiChatWrapper = {}));


/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabDateRangePicker/InteractionsTabDateRangePicker.scss":
/*!***********************************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabDateRangePicker/InteractionsTabDateRangePicker.scss ***!
  \***********************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.date-range-picker-controls {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin: 0.25rem 0.75rem 0.75rem;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/InteractionsTab/InteractionsTabDateRangePicker/InteractionsTabDateRangePicker.scss */
/*# sourceURL=InteractionsTabDateRangePicker.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvSW50ZXJhY3Rpb25zVGFiL0ludGVyYWN0aW9uc1RhYkRhdGVSYW5nZVBpY2tlci9JbnRlcmFjdGlvbnNUYWJEYXRlUmFuZ2VQaWNrZXIuc2NzcyIsIkludGVyYWN0aW9uc1RhYkRhdGVSYW5nZVBpY2tlci5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLHlCQUFBO0VBQ0EsV0FBQTtFQUNBLCtCQUFBO0FDQ0YiLCJmaWxlIjoiSW50ZXJhY3Rpb25zVGFiRGF0ZVJhbmdlUGlja2VyLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuZGF0ZS1yYW5nZS1waWNrZXItY29udHJvbHMge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kO1xuICBnYXA6IDAuNXJlbTtcbiAgbWFyZ2luOiAwLjI1cmVtIDAuNzVyZW0gMC43NXJlbTtcbn1cbiIsIi5kYXRlLXJhbmdlLXBpY2tlci1jb250cm9scyB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogZmxleC1lbmQ7XG4gIGdhcDogMC41cmVtO1xuICBtYXJnaW46IDAuMjVyZW0gMC43NXJlbSAwLjc1cmVtO1xufSJdfQ== */`);
    

/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabDateRangePicker/InteractionsTabDateRangePicker.ts":
/*!*********************************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabDateRangePicker/InteractionsTabDateRangePicker.ts ***!
  \*********************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsTabDateRangePicker: () => (/* binding */ InteractionsTabDateRangePicker)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _InteractionsTabDateRangePicker_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./InteractionsTabDateRangePicker.scss */ "./src/components/InteractionsTab/InteractionsTabDateRangePicker/InteractionsTabDateRangePicker.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * @element agentx-wc-interactions-tab-date-range-picker
 */
let InteractionsTabDateRangePicker = class InteractionsTabDateRangePicker extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
    constructor() {
        super(...arguments);
        this.startTime = 0;
        this.endTime = 0;
    }
    static get styles() {
        return _InteractionsTabDateRangePicker_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    render() {
        var _a, _b;
        const startDate = (_a = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(this.startTime).toISODate()) !== null && _a !== void 0 ? _a : "";
        const endDate = (_b = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(this.endTime).toISODate()) !== null && _b !== void 0 ? _b : "";
        const datePickerValue = `${startDate} - ${endDate}`;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
      <md-date-range-picker
        value=${datePickerValue}
        .endDate=${endDate}
        .startDate=${startDate}
        @date-range-change=${this.onDateRangeChange}
      >
        <div slot="time-picker" class="date-range-picker-controls">
          <md-button
            class="date-range-cancel-button"
            variant="secondary"
            size="28"
            @click=${this.onCancelDateRangeSelection}
          >
            <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.cancelButton")}</span>
          </md-button>
          <md-button
            class="date-range-apply-button"
            variant="primary"
            size="28"
            @click=${this.onAcceptDateRangeSelection}
          >
            <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.apply")}</span>
          </md-button>
        </div>
      </md-date-range-picker>
    `;
    }
    onDateRangeChange(e) {
        var _a;
        if (!((_a = e.detail) === null || _a === void 0 ? void 0 : _a.startDate) || !e.detail.endDate) {
            return;
        }
        this.pendingStartTime = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(e.detail.startDate).toMillis();
        this.pendingEndTime = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(e.detail.endDate).toMillis();
    }
    onCancelDateRangeSelection() {
        this.dateRangePicker.setOpen(false);
    }
    onAcceptDateRangeSelection() {
        this.dateRangePicker.setOpen(false);
        if (!this.pendingStartTime ||
            !this.pendingEndTime ||
            (this.pendingStartTime === this.startTime && this.pendingEndTime === this.endTime)) {
            return;
        }
        this.startTime = this.pendingStartTime;
        this.endTime = this.pendingEndTime;
        this.dispatchEvent(new CustomEvent("search-date-range-updated", {
            detail: {
                startTime: this.startTime,
                endTime: this.endTime
            },
            bubbles: true,
            composed: true
        }));
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
], InteractionsTabDateRangePicker.prototype, "startTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
], InteractionsTabDateRangePicker.prototype, "endTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], InteractionsTabDateRangePicker.prototype, "pendingStartTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], InteractionsTabDateRangePicker.prototype, "pendingEndTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)("md-date-range-picker")
], InteractionsTabDateRangePicker.prototype, "dateRangePicker", void 0);
InteractionsTabDateRangePicker = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-interactions-tab-date-range-picker")
], InteractionsTabDateRangePicker);



/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabDetailsView/InteractionsTabDetailsWidget.scss":
/*!*****************************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabDetailsView/InteractionsTabDetailsWidget.scss ***!
  \*****************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.panel-layout {
  flex: 1;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/InteractionsTab/InteractionsTabDetailsView/InteractionsTabDetailsWidget.scss */
/*# sourceURL=InteractionsTabDetailsWidget.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvSW50ZXJhY3Rpb25zVGFiL0ludGVyYWN0aW9uc1RhYkRldGFpbHNWaWV3L0ludGVyYWN0aW9uc1RhYkRldGFpbHNXaWRnZXQuc2NzcyIsIkludGVyYWN0aW9uc1RhYkRldGFpbHNXaWRnZXQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLE9BQUE7QUNDRiIsImZpbGUiOiJJbnRlcmFjdGlvbnNUYWJEZXRhaWxzV2lkZ2V0LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIucGFuZWwtbGF5b3V0IHtcbiAgZmxleDogMTtcbn1cbiIsIi5wYW5lbC1sYXlvdXQge1xuICBmbGV4OiAxO1xufSJdfQ== */`);
    

/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabDetailsView/InteractionsTabDetailsWidget.ts":
/*!***************************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabDetailsView/InteractionsTabDetailsWidget.ts ***!
  \***************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsTabDetailsWidget: () => (/* binding */ InteractionsTabDetailsWidget)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _InteractionsTabDetailsWidget_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./InteractionsTabDetailsWidget.scss */ "./src/components/InteractionsTab/InteractionsTabDetailsView/InteractionsTabDetailsWidget.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





let InteractionsTabDetailsWidget = class InteractionsTabDetailsWidget extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_1__.MobxLitElement) {
    static getStyles() {
        return _InteractionsTabDetailsWidget_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    closeDetails() {
        var _a;
        this.dispatchEvent(new CustomEvent("interactions-details-close", {
            bubbles: true,
            composed: true
        }));
        (_a = this.interactionsStore) === null || _a === void 0 ? void 0 : _a.updateSelectedInteraction("");
    }
    render() {
        var _a, _b;
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
      <agentx-wc-frame>
        <agentx-wc-page-header
          title="${((_b = (_a = this.interactionsStore) === null || _a === void 0 ? void 0 : _a.selectedInteraction) === null || _b === void 0 ? void 0 : _b.id) || ""}"
          useCloseButton
          @page-header-close="${this.closeDetails}"
        ></agentx-wc-page-header>
        <agentx-wc-panel-layout class="panel-layout" showTopPanel showLeftPanel showRightPanel>
          <slot name="top-panel-content" slot="top">
            <agentx-wc-panel-frame title="Top panel">
              <div>Top panel content</div>
            </agentx-wc-panel-frame>
          </slot>
          <agentx-wc-panel-frame slot="left" title="Left panel">
            <md-button slot="header-extra-content" circle>X</md-button>
            <div>Left panel content</div>
          </agentx-wc-panel-frame>
          <agentx-wc-panel-frame slot="right">
            <div>Right panel content</div>
          </agentx-wc-panel-frame>
        </agentx-wc-panel-layout>
      </agentx-wc-frame>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object, attribute: false })
], InteractionsTabDetailsWidget.prototype, "interactionsStore", void 0);
InteractionsTabDetailsWidget = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-interactions-tab-details-widget")
], InteractionsTabDetailsWidget);



/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabTableHeader/InteractionsTabTableHeader.scss":
/*!***************************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabTableHeader/InteractionsTabTableHeader.scss ***!
  \***************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.interactions-tab-table-header {
  display: flex;
  box-sizing: border-box;
  flex-grow: 1;
  margin-top: 8px;
  margin-bottom: 12px;
}

*[slot=left-group] {
  display: inline-block;
  font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: var(--label-secondary);
  font-size: var(--body-secondary-font-size);
}

.time-icon {
  display: inline-flex;
  align-items: center;
  margin: 6px 0px 6px 16px;
}

.refreshed-time {
  margin: 6px 0px 6px 4px;
}

md-menu-overlay#customize-menu-overlay::part(overlay) {
  width: 600px;
  height: 725px;
}
md-menu-overlay#filter-menu-overlay::part(overlay) {
  width: 640px;
  height: 800px;
}
md-menu-overlay::part(overlay-content) {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

agentx-wc-table-customization-menu {
  width: 100%;
  height: 100%;
}

agentx-wc-interactions-tab-date-range-picker {
  top: 8px;
  position: relative;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/InteractionsTab/InteractionsTabTableHeader/InteractionsTabTableHeader.scss */
/*# sourceURL=InteractionsTabTableHeader.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabTableHeader/InteractionsTabTableHeader.ts":
/*!*************************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabTableHeader/InteractionsTabTableHeader.ts ***!
  \*************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsTabTableHeader: () => (/* binding */ InteractionsTabTableHeader)
/* harmony export */ });
/* harmony import */ var _components_Common_TableCustomizationMenu_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/TableCustomizationMenu/constants */ "./src/components/Common/TableCustomizationMenu/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Common_GridExportButton_GridExportButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../Common/GridExportButton/GridExportButton */ "./src/components/Common/GridExportButton/GridExportButton.ts");
/* harmony import */ var _Common_TableHeader_TableHeaderWidget__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Common/TableHeader/TableHeaderWidget */ "./src/components/Common/TableHeader/TableHeaderWidget.ts");
/* harmony import */ var _Common_TableHeader_TableHeaderWidget_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../Common/TableHeader/TableHeaderWidget.scss */ "./src/components/Common/TableHeader/TableHeaderWidget.scss");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../constants */ "./src/components/InteractionsTab/constants.ts");
/* harmony import */ var _InteractionsTabDateRangePicker_InteractionsTabDateRangePicker__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../InteractionsTabDateRangePicker/InteractionsTabDateRangePicker */ "./src/components/InteractionsTab/InteractionsTabDateRangePicker/InteractionsTabDateRangePicker.ts");
/* harmony import */ var _InteractionsTabTableHeader_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./InteractionsTabTableHeader.scss */ "./src/components/InteractionsTab/InteractionsTabTableHeader/InteractionsTabTableHeader.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};











const EXPORT_FILE_NAME_PREFIX = "interactions";
const EXCEL_SHEET_NAME = "Interactions";
/**
 * @element agentx-wc-interactions-tab-table-header
 */
let InteractionsTabTableHeader = class InteractionsTabTableHeader extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
    constructor() {
        super(...arguments);
        this.interactionsCount = 0;
        this.selectedTab = (0,_constants__WEBPACK_IMPORTED_MODULE_8__.getDefaultSelectedTab)();
        this.columnsData = {
            available: [],
            selected: []
        };
        this.startTime = 0;
        this.endTime = 0;
        this.countLabelText = "";
        this.gridApi = null;
    }
    static get styles() {
        return [_InteractionsTabTableHeader_scss__WEBPACK_IMPORTED_MODULE_10__["default"], _Common_TableHeader_TableHeaderWidget_scss__WEBPACK_IMPORTED_MODULE_7__["default"]];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <table-header-widget class="interactions-tab-table-header">
        <span class="count-label" slot="left-group">${this.countLabelText}</span>
        ${this.refreshLabelText !== undefined
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <md-icon
                name="recents-bold"
                iconSet="momentumDesign"
                size="14"
                slot="left-group"
                class="time-icon"
              ></md-icon>
              <span slot="left-group" class="refreshed-time">${this.refreshLabelText}</span>`
            : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}

        <div slot="right-group" id="right-group">
          ${this.selectedTab === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.InteractionsServiceConstants.QueryType.Completed
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                <agentx-wc-interactions-tab-date-range-picker
                  .startTime=${this.startTime}
                  .endTime=${this.endTime}
                ></agentx-wc-interactions-tab-date-range-picker>
              `
            : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}

          <md-button id="reset-customization-button" circle size="28" variant="ghost" @click=${this.onResetClicked}>
            <md-icon slot="icon" name="reset-bold" iconSet="momentumDesign" size="16"></md-icon>
          </md-button>

          <md-menu-overlay id="customize-menu-overlay">
            <md-button slot="menu-trigger" circle size="28" variant="ghost">
              <md-icon slot="icon" iconSet="momentumDesign" name="settings-bold" size="16"></md-icon>
            </md-button>

            <agentx-wc-table-customization-menu
              .columnsData=${this.columnsData}
              .maxSelectedColumns=${_components_Common_TableCustomizationMenu_constants__WEBPACK_IMPORTED_MODULE_0__.MAX_SELECTED_COLUMNS}
              @close-customize-view=${this.closeCustomizationMenu}
              @save-customizations=${this.closeCustomizationMenu}
            ></agentx-wc-table-customization-menu>
          </md-menu-overlay>

          <div class="separator"></div>

          <agentx-wc-grid-export-button
            .exportFileNamePrefix=${EXPORT_FILE_NAME_PREFIX}
            .gridApi=${this.gridApi}
            .sheetName=${EXCEL_SHEET_NAME}
          >
          </agentx-wc-grid-export-button>

          <md-menu-overlay id="filter-menu-overlay">
            <md-button variant="secondary" size="28" slot="menu-trigger">
              <md-icon slot="icon" iconSet="momentumDesign" name="filter-bold" size="16"></md-icon>
              <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common:filter")}</span>
            </md-button>

            <agentx-wc-table-filter-menu @cancel-clicked=${this.closeFilterMenu}></agentx-wc-table-filter-menu>
          </md-menu-overlay>
        </div>
      </table-header-widget>
    `;
    }
    /* Event Handlers */
    onResetClicked() {
        this.dispatchEvent(new CustomEvent("reset-customization", {
            bubbles: true,
            composed: true
        }));
    }
    /* Private Methods */
    closeCustomizationMenu() {
        this.customizeMenuOverlay.isOpen = false;
    }
    closeFilterMenu() {
        this.filterMenuOverlay.isOpen = false;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Number })
], InteractionsTabTableHeader.prototype, "interactionsCount", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], InteractionsTabTableHeader.prototype, "selectedTab", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ attribute: false })
], InteractionsTabTableHeader.prototype, "columnsData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Number })
], InteractionsTabTableHeader.prototype, "startTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Number })
], InteractionsTabTableHeader.prototype, "endTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], InteractionsTabTableHeader.prototype, "countLabelText", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], InteractionsTabTableHeader.prototype, "refreshLabelText", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
], InteractionsTabTableHeader.prototype, "gridApi", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)("md-menu-overlay#customize-menu-overlay")
], InteractionsTabTableHeader.prototype, "customizeMenuOverlay", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)("md-menu-overlay#filter-menu-overlay")
], InteractionsTabTableHeader.prototype, "filterMenuOverlay", void 0);
InteractionsTabTableHeader = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-interactions-tab-table-header")
], InteractionsTabTableHeader);



/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabWidget/InteractionTabWidget.constants.ts":
/*!************************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabWidget/InteractionTabWidget.constants.ts ***!
  \************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionTabType: () => (/* binding */ InteractionTabType),
/* harmony export */   SECOND_IN_MILLIS: () => (/* binding */ SECOND_IN_MILLIS)
/* harmony export */ });
var InteractionTabType;
(function (InteractionTabType) {
    InteractionTabType["Interactions"] = "interactions";
    InteractionTabType["Tasks"] = "tasks";
})(InteractionTabType || (InteractionTabType = {}));
const SECOND_IN_MILLIS = 1000;


/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabWidget.scss":
/*!*****************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabWidget.scss ***!
  \*****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host,
#interactions-tab-widget,
md-theme,
md-theme::part(theme-wrapper) {
  width: 100%;
  height: 100%;
}

md-tabs {
  display: inline-block;
  width: 100%;
  height: auto;
}
md-tabs::part(tabs-content) {
  display: none;
}

md-alert-banner {
  display: block;
  margin-bottom: 8px;
}

agentx-wc-interactions-tab-table-header {
  margin-top: 8px;
  margin-bottom: 8px;
}

div#table-container {
  display: block;
  width: 100%;
  height: 100%;
}
div#table-container.hidden {
  display: none;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabWidget.scss */
/*# sourceURL=InteractionsTabWidget.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabWidget.ts":
/*!***************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabWidget.ts ***!
  \***************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsTabWidget: () => (/* binding */ InteractionsTabWidget)
/* harmony export */ });
/* harmony import */ var _components_Common_Table_TableManager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/Table/TableManager */ "./src/components/Common/Table/TableManager.ts");
/* harmony import */ var _components_Common_Table_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/components/Common/Table/config */ "./src/components/Common/Table/config.ts");
/* harmony import */ var _components_Common_WcGrid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/components/Common/WcGrid */ "./src/components/Common/WcGrid/index.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ag-grid-enterprise */ "ag-grid-enterprise");
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! lodash */ "../../node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! mobx */ "mobx");
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(mobx__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _InteractionsTabWidgetEmptyState_InteractionsTabWidgetEmptyState__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../InteractionsTabWidgetEmptyState/InteractionsTabWidgetEmptyState */ "./src/components/InteractionsTab/InteractionsTabWidgetEmptyState/InteractionsTabWidgetEmptyState.ts");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../config */ "./src/components/InteractionsTab/config.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../constants */ "./src/components/InteractionsTab/constants.ts");
/* harmony import */ var _InteractionTabWidget_constants__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./InteractionTabWidget.constants */ "./src/components/InteractionsTab/InteractionsTabWidget/InteractionTabWidget.constants.ts");
/* harmony import */ var _InteractionsTabWidget_scss__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./InteractionsTabWidget.scss */ "./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabWidget.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




















let InteractionsTabWidget = class InteractionsTabWidget extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_5__.MobxLitElement) {
    constructor() {
        super(...arguments);
        this.tableManagers = {
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryType.Active]: new _components_Common_Table_TableManager__WEBPACK_IMPORTED_MODULE_0__.TableManager({
                cacheName: "wxcc_interactions_active_table",
                columnDefinitions: (0,_config__WEBPACK_IMPORTED_MODULE_15__.getActiveTabDefaultColumnDefinitions)()
            }),
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryType.Queued]: new _components_Common_Table_TableManager__WEBPACK_IMPORTED_MODULE_0__.TableManager({
                cacheName: "wxcc_interactions_queued_table",
                columnDefinitions: (0,_config__WEBPACK_IMPORTED_MODULE_15__.getQueuedTabDefaultColumnDefinitions)()
            }),
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryType.Completed]: new _components_Common_Table_TableManager__WEBPACK_IMPORTED_MODULE_0__.TableManager({
                cacheName: "wxcc_interactions_completed_table",
                columnDefinitions: (0,_config__WEBPACK_IMPORTED_MODULE_15__.getCompletedTabDefaultColumnDefinitions)()
            })
        };
        this.collapsedTableManagers = this.createCollapsedTableManagers();
        this.selectedTab = (0,_constants__WEBPACK_IMPORTED_MODULE_16__.getDefaultSelectedTab)();
        this.interactionTabType = _InteractionTabWidget_constants__WEBPACK_IMPORTED_MODULE_17__.InteractionTabType.Interactions;
        this.isQueuedTasksEnabled = false;
        this.displayedRowCount = 0;
        this.isEmptyStateVisible = true;
        this.columnsData = this.currentTableManager.customizationColumnsMenuModel;
        this.maximumSentimentValue = 5.0;
        this.isDarkMode = false;
        this.pendingInteractionsCount = 0; // TODO liroddy - in future when fully wired up with WS we can remove this
        this.userRole = "";
        this.timeRanges = this.defaultTimeRange;
        this.api = null;
        this.serverSideDataSource = this.createDatasource();
        this.gridOptions = Object.assign(Object.assign({}, _components_Common_Table_config__WEBPACK_IMPORTED_MODULE_1__.BASE_GRID_OPTIONS), { columnDefs: [], onColumnResized: (e) => this.currentTableManager.onTableColumnResized(e), onColumnMoved: (e) => this.onColumnMoved(e), onSortChanged: (e) => this.currentTableManager.onTableSortChanged(e), onModelUpdated: (_event) => {
                if (this.api) {
                    this.displayedRowCount = this.api.getDisplayedRowCount();
                }
                this.dispatchEvent(new CustomEvent("onInteractionsTabWidgetModelUpdated"));
            }, onRowClicked: (e) => {
                this.onRowClicked(e);
            }, getRowId: (params) => {
                var _a, _b;
                return (_b = (_a = params.data) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : "";
            }, context: Object.assign(Object.assign({}, _components_Common_Table_config__WEBPACK_IMPORTED_MODULE_1__.BASE_GRID_OPTIONS.context), { userRole: this.userRole, selectedTab: this.selectedTab }) });
    }
    get isCollapsed() {
        var _a;
        return (((_a = this.interactionsStore) === null || _a === void 0 ? void 0 : _a.selectedInteraction) !== undefined || this.interactionTabType === _InteractionTabWidget_constants__WEBPACK_IMPORTED_MODULE_17__.InteractionTabType.Tasks);
    }
    get currentTableManager() {
        return this.isCollapsed ? this.collapsedTableManagers[this.selectedTab] : this.tableManagers[this.selectedTab];
    }
    isQueueTabVisible() {
        return (this.interactionTabType === _InteractionTabWidget_constants__WEBPACK_IMPORTED_MODULE_17__.InteractionTabType.Interactions ||
            (this.interactionTabType === _InteractionTabWidget_constants__WEBPACK_IMPORTED_MODULE_17__.InteractionTabType.Tasks && this.isQueuedTasksEnabled));
    }
    static get styles() {
        return _InteractionsTabWidget_scss__WEBPACK_IMPORTED_MODULE_18__["default"];
    }
    createCollapsedTableManagers() {
        const tableManager = new _components_Common_Table_TableManager__WEBPACK_IMPORTED_MODULE_0__.TableManager({
            columnDefinitions: (0,_config__WEBPACK_IMPORTED_MODULE_15__.getCollapsedColumnDefinitions)()
        });
        return {
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryType.Active]: tableManager,
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryType.Queued]: tableManager,
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryType.Completed]: tableManager
        };
    }
    get openTabLabel() {
        return this.interactionTabType === "tasks" ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)("app:interactions:open") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)("app:interactions:active");
    }
    get queuedTabLabel() {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)("app:interactions:queued");
    }
    get closedTabLabel() {
        return this.interactionTabType === "tasks" ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)("app:interactions:closed") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)("app:interactions:completed");
    }
    get defaultTimeRange() {
        return {
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryType.Active]: {
                start: _constants__WEBPACK_IMPORTED_MODULE_16__.DEFAULT_SEARCH_START_TIME,
                end: _constants__WEBPACK_IMPORTED_MODULE_16__.DEFAULT_SEARCH_END_TIME
            },
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryType.Queued]: {
                start: _constants__WEBPACK_IMPORTED_MODULE_16__.DEFAULT_SEARCH_START_TIME,
                end: _constants__WEBPACK_IMPORTED_MODULE_16__.DEFAULT_SEARCH_END_TIME
            },
            [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryType.Completed]: {
                start: _constants__WEBPACK_IMPORTED_MODULE_16__.DEFAULT_SEARCH_START_TIME,
                end: _constants__WEBPACK_IMPORTED_MODULE_16__.DEFAULT_SEARCH_END_TIME
            }
        };
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has("userRole")) {
            this.gridOptions.context.userRole = this.userRole;
        }
    }
    updateHeaderVisibility(isCollapsed) {
        var _a, _b;
        const grid = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("agentx-wc-ag-grid");
        const header = (_b = grid === null || grid === void 0 ? void 0 : grid.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector(".ag-header");
        if (header) {
            header.style.display = isCollapsed ? "none" : "flex";
        }
    }
    categorizeInteractionsChanges(interactions, api) {
        const add = [];
        const update = [];
        const remove = [];
        api.forEachNode((node) => {
            const found = interactions.find((interaction) => interaction.id === node.id);
            if (found) {
                update.push(found);
            }
            else if (node.data) {
                remove.push(node.data);
            }
        });
        add.push(...interactions.filter((interaction) => !update.includes(interaction) && !remove.includes(interaction)));
        return { add, update, remove };
    }
    applySubscriptionUpdatesToGrid(add, update, remove) {
        var _a, _b, _c, _d;
        const result = (_a = this.api) === null || _a === void 0 ? void 0 : _a.applyServerSideTransaction({ add, update, remove });
        if (result && result.status === ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_8__.ServerSideTransactionResultStatus.Applied) {
            this.isEmptyStateVisible = ((_c = (_b = this.api) === null || _b === void 0 ? void 0 : _b.getDisplayedRowCount()) !== null && _c !== void 0 ? _c : 0) === 0;
        }
        (_d = this.interactionsStore) === null || _d === void 0 ? void 0 : _d.updateInteractions(this.selectedTab, add, update, remove);
    }
    handleSubscriptionUpdates(searchResults) {
        const interactions = searchResults.data.taskDetails.tasks;
        if (!this.api) {
            _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error(`[App:Interactions] No gridApi in the grid`);
            return;
        }
        const { add, update, remove } = this.categorizeInteractionsChanges(interactions, this.api);
        this.applySubscriptionUpdatesToGrid(add, update, remove);
    }
    createDatasource() {
        const getPage = (startRow = 0) => {
            if (startRow && startRow !== 0) {
                return startRow / _constants__WEBPACK_IMPORTED_MODULE_16__.MAX_ROWS_IN_RESPONSE;
            }
            else {
                return startRow;
            }
        };
        const getSortByFromModel = (sortModel) => {
            let sortBy = undefined;
            if (sortModel && sortModel.length > 0) {
                // we use only the first item as our service supports only one sort field,
                // we can add possibility to sort by multiple fields in the future if needed
                const sort = sortModel[0];
                if (sort.colId && sort.sort) {
                    sortBy = {
                        fields: (0,_config__WEBPACK_IMPORTED_MODULE_15__.mapColumnIdToQueryField)(sort.colId),
                        order: sort.sort === "asc"
                            ? _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.SortOrder.Ascending
                            : _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.SortOrder.Descending
                    };
                }
            }
            return sortBy;
        };
        const fetchData = (params, success) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const startTime = this.timeRanges[this.selectedTab].start;
            const endTime = this.timeRanges[this.selectedTab].end;
            const pageNumber = getPage(params.startRow);
            const queryType = this.selectedTab;
            const sortBy = getSortByFromModel(params.sortModel);
            const searchData = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.SERVICE.interactions.fetchInteractions({
                startTime,
                endTime,
                pageNumber,
                queryType,
                sortBy
            });
            const interactions = searchData.data.taskDetails.tasks;
            const pageInfoData = searchData.data.taskDetails.pageInfo;
            this.isEmptyStateVisible = interactions.length === 0;
            (_a = this.interactionsStore) === null || _a === void 0 ? void 0 : _a.updateInteractions(queryType, interactions, [], []);
            if (pageInfoData.hasNextPage) {
                success({ rowData: interactions });
            }
            else {
                let rowCount = interactions.length;
                if (pageNumber !== 0) {
                    const previousRowCount = pageNumber * _constants__WEBPACK_IMPORTED_MODULE_16__.MAX_ROWS_IN_RESPONSE;
                    rowCount += previousRowCount;
                }
                success({ rowData: interactions, rowCount });
            }
        });
        return {
            getRows: (params, success, fail) => {
                fetchData(params, success).catch((err) => {
                    if (err instanceof _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_7__.Err.Details) {
                        if (err.details.statusCode === 429 && err.details.retryAfter) {
                            _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info(`[App:Interactions] Failed to fetch interactions due to rate limit. Retrying`);
                            setTimeout(() => {
                                //Need to rework this.
                                fetchData(params, success).catch(fail);
                            }, err.details.retryAfter * _InteractionTabWidget_constants__WEBPACK_IMPORTED_MODULE_17__.SECOND_IN_MILLIS);
                        }
                        else {
                            _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error(`[App:Interactions] Failed to fetch interactions:`, err);
                            fail();
                        }
                    }
                    else if (err instanceof Error) {
                        _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error(`[App:Interactions] Error message:`, err.message);
                        fail();
                    }
                    else {
                        _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error(`[App:Interactions] An unknown error occurred:`, err);
                        fail();
                    }
                });
            }
        };
    }
    //TEMPORARY, will be removed DO NOT COPY, DO NOT BASE TESTS OFF THIS.
    updateGridApi(gridApi) {
        this.api = gridApi;
        gridApi.updateGridOptions(this.gridOptions);
        this.currentTableManager.onGridReady(gridApi);
        this.columnsData = this.currentTableManager.customizationColumnsMenuModel;
        if (this.selectedTab !== _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryType.Completed) {
            this.serviceSubscriptionId = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.SERVICE.interactions.subscribeInteractionUpdates((results) => this.handleSubscriptionUpdates(results));
        }
    }
    connectedCallback() {
        super.connectedCallback();
        this.autoRunDisposer = (0,mobx__WEBPACK_IMPORTED_MODULE_13__.autorun)(() => {
            this.refreshColumnsData();
            this.updateHeaderVisibility(this.isCollapsed);
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.serviceSubscriptionId) {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.SERVICE.interactions.unsubscribeInteractionUpdates(this.serviceSubscriptionId);
        }
        if (this.autoRunDisposer) {
            this.autoRunDisposer();
            this.autoRunDisposer = undefined;
        }
    }
    render() {
        const alertBanner = (0,lit_html__WEBPACK_IMPORTED_MODULE_10__.html) `
      <md-alert-banner
        type="default"
        ?show=${this.pendingInteractionsCount > 0}
        ?closable=${false}
        ?showBannerTypeIcon=${true}
        ?showRefreshButton=${true}
        @alertBanner-refresh-button-click=${() => {
            this.onBannerRefreshButtonClick();
        }}
      >
        ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)("app:interactions:refreshToSeeNewInteractions", undefined, { count: this.pendingInteractionsCount })}
      </md-alert-banner>
    `;
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_10__.html) `
      <div id="interactions-tab-widget">
        <md-tabs
          .selectedIndex=${Object.values(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryType).indexOf(this.selectedTab)}
          @selected-changed=${this.onSelectedTabChanged}
          newMomentum
          type="rounded"
          variant="primary"
        >
          <!-- We have to add tab panels for the tabs to work, but these aren't used or visible -->

          <md-tab slot="tab" name="${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryType.Active}">${this.openTabLabel}</md-tab>
          <md-tab-panel slot="panel"></md-tab-panel>

          ${this.isQueueTabVisible()
            ? (0,lit_html__WEBPACK_IMPORTED_MODULE_10__.html) `
                <md-tab slot="tab" name="${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryType.Queued}"
                  >${this.queuedTabLabel}</md-tab
                >
                <md-tab-panel slot="panel"></md-tab-panel>
              `
            : lit_html__WEBPACK_IMPORTED_MODULE_10__.nothing}

          <md-tab slot="tab" name="${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryType.Completed}">${this.closedTabLabel}</md-tab>
          <md-tab-panel slot="panel"></md-tab-panel>
        </md-tabs>

        ${this.isEmptyStateVisible
            ? (0,lit_html__WEBPACK_IMPORTED_MODULE_10__.html) `
              ${alertBanner}
              <agentx-wc-interactions-tab-widget-empty-state
                selectedTab="${this.selectedTab}"
                .startTime=${this.timeRanges[this.selectedTab].start}
                .endTime=${this.timeRanges[this.selectedTab].end}
                @search-date-range-updated=${this.onUpdateDateRange}
              ></agentx-wc-interactions-tab-widget-empty-state>
            `
            : lit_html__WEBPACK_IMPORTED_MODULE_10__.nothing}

        <div id="table-container" class="${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_11__.classMap)({ hidden: this.isEmptyStateVisible })}">
          <agentx-wc-interactions-tab-table-header
            .startTime=${this.timeRanges[this.selectedTab].start}
            .endTime=${this.timeRanges[this.selectedTab].end}
            .gridApi=${this.api}
            .selectedTab=${this.selectedTab}
            .columnsData=${this.columnsData}
            .countLabelText=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)("app:interactions:x_interaction", undefined, { count: this.displayedRowCount })}
            .refreshLabelText=${this.refreshedMinutesAgo
            ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_3__.t)("app:interactions:refreshed_x_minutes_ago", undefined, { count: this.refreshedMinutesAgo })
            : undefined}
            @reset-customization=${this.onResetCustomization}
            @save-customizations=${this.onSaveCustomization}
            @search-date-range-updated=${this.onUpdateDateRange}
          >
          </agentx-wc-interactions-tab-table-header>

          ${alertBanner}
          <wc-ag-grid
            @action-button-open-details=${(e) => {
            var _a;
            if (e.detail.context.interactionId) {
                (_a = this.interactionsStore) === null || _a === void 0 ? void 0 : _a.updateSelectedInteraction(e.detail.context.interactionId);
            }
            else {
                _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.warn("No interactionId provided in action-button-open-details event");
            }
        }}
            .wcGridConfig=${new _components_Common_WcGrid__WEBPACK_IMPORTED_MODULE_2__.WcGridConfig({
            tableName: "InteractionsTab",
            enableCharts: false,
            headerConfig: {
                resetGridStateButton: false,
                filterButton: this.isCollapsed ? "small" : "large",
                columnSelectButton: false,
                refreshButton: false,
                datePicker: false,
                unsortedButton: this.isCollapsed
            },
            serverSideRowModel: true,
            fetchServerRows: (params, success, fail) => this.serverSideDataSource.getRows(params, success, fail)
        })}
            .isDarkMode=${this.isDarkMode}
            .gridApiCallback=${
        //DO NOT USE, DO NOT COPY, This is temporary and will be removed (https://jira-eng-sjc12.cisco.com/jira/browse/CX-18397)
        (gridApi) => {
            this.updateGridApi(gridApi);
        }}
          ></wc-ag-grid>
        </div>
      </div>
    `;
    }
    refreshColumnsData() {
        if (this.api) {
            this.currentTableManager.onGridReady(this.api);
        }
    }
    onBannerRefreshButtonClick() {
        this.dispatchEvent(new CustomEvent("interactions-tab-banner-refreshed", {
            bubbles: true,
            composed: true
        }));
    }
    onRowClicked(e) {
        var _a, _b;
        if (this.isCollapsed && ((_a = e.data) === null || _a === void 0 ? void 0 : _a.id)) {
            (_b = this.interactionsStore) === null || _b === void 0 ? void 0 : _b.updateSelectedInteraction(e.data.id);
        }
    }
    onSelectedTabChanged(e) {
        var _a;
        if (!("value" in e.detail) || !("tabsOrder" in e.detail)) {
            return;
        }
        const { value, tabsOrder } = e.detail;
        if (this.selectedTab === tabsOrder[value]) {
            return;
        }
        this.selectedTab = tabsOrder[value];
        if (this.serviceSubscriptionId) {
            if (this.selectedTab === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryType.Completed) {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.SERVICE.interactions.unsubscribeInteractionUpdates(this.serviceSubscriptionId);
                this.serviceSubscriptionId = undefined;
            }
        }
        else if (this.selectedTab !== _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.InteractionsServiceConstants.QueryType.Completed) {
            this.serviceSubscriptionId = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.SERVICE.interactions.subscribeInteractionUpdates((results) => this.handleSubscriptionUpdates(results));
        }
        //TODO: Remove gridOptions.context
        this.gridOptions.context.selectedTab = this.selectedTab;
        this.refreshColumnsData();
        this.isEmptyStateVisible = true;
        (_a = this.api) === null || _a === void 0 ? void 0 : _a.refreshServerSide({ purge: true });
    }
    onResetCustomization(e) {
        e.stopPropagation();
        this.currentTableManager.onReset();
        this.columnsData = this.currentTableManager.customizationColumnsMenuModel;
    }
    onUpdateDateRange(e) {
        var _a;
        e.stopPropagation();
        if (!e.detail || !("startTime" in e.detail) || !("endTime" in e.detail)) {
            return;
        }
        if (e.detail.startTime === this.timeRanges[this.selectedTab].start &&
            e.detail.endTime === this.timeRanges[this.selectedTab].end) {
            return;
        }
        this.timeRanges[this.selectedTab].start = e.detail.startTime;
        this.timeRanges[this.selectedTab].end = e.detail.endTime;
        (_a = this.api) === null || _a === void 0 ? void 0 : _a.refreshServerSide();
    }
    onSaveCustomization(e) {
        e.stopPropagation();
        if (!("columnsData" in e.detail)) {
            _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error("Failed to save customization: columnsData not provided");
            return;
        }
        const oldColumnData = this.columnsData;
        this.columnsData = e.detail.columnsData;
        if (!(0,lodash__WEBPACK_IMPORTED_MODULE_12__.isEqual)(oldColumnData, this.columnsData)) {
            this.currentTableManager.onMenuColumnsMoved(this.columnsData);
        }
    }
    onColumnMoved(e) {
        if (!e.finished) {
            return;
        }
        this.currentTableManager.onTableColumnMoved(e);
        this.columnsData = this.currentTableManager.customizationColumnsMenuModel;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_9__.property)({ type: Object, attribute: false })
], InteractionsTabWidget.prototype, "interactionsStore", void 0);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_13__.computed
], InteractionsTabWidget.prototype, "isCollapsed", null);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_9__.property)({ type: String })
], InteractionsTabWidget.prototype, "selectedTab", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_9__.property)({ type: String, attribute: "interaction-tab-type" })
], InteractionsTabWidget.prototype, "interactionTabType", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_9__.property)({ type: Boolean, attribute: "is-queued-tasks-enabled" })
], InteractionsTabWidget.prototype, "isQueuedTasksEnabled", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_9__.property)({ attribute: false })
], InteractionsTabWidget.prototype, "currentTableManager", null);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_9__.internalProperty)()
], InteractionsTabWidget.prototype, "displayedRowCount", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_9__.internalProperty)()
], InteractionsTabWidget.prototype, "isEmptyStateVisible", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_9__.internalProperty)()
], InteractionsTabWidget.prototype, "columnsData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_9__.property)({ type: Number })
], InteractionsTabWidget.prototype, "maximumSentimentValue", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_9__.property)({ type: Boolean })
], InteractionsTabWidget.prototype, "isDarkMode", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_9__.property)({ type: Number })
], InteractionsTabWidget.prototype, "pendingInteractionsCount", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_9__.property)({ type: Number })
], InteractionsTabWidget.prototype, "refreshedMinutesAgo", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_9__.property)({ type: String, attribute: "user-role" })
], InteractionsTabWidget.prototype, "userRole", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_9__.property)({ type: Object })
], InteractionsTabWidget.prototype, "timeRanges", void 0);
InteractionsTabWidget = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_9__.customElement)("agentx-wc-interactions-tab-widget")
], InteractionsTabWidget);



/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabWidgetEmptyState/InteractionsTabWidgetEmptyState.scss":
/*!*************************************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabWidgetEmptyState/InteractionsTabWidgetEmptyState.scss ***!
  \*************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host,
md-theme {
  width: 100%;
  height: 100%;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-align: center;
}
.empty-state .error-header {
  color: var(--md-primary-text-color);
  font-size: var(--body-primary-font-size, 16px);
  line-height: 24px;
  margin-bottom: 8px;
}
.empty-state .error-body {
  color: var(--md-secondary-text-color);
  font-size: var(--body-secondary-font-size, 14px);
  line-height: 20px;
}
.empty-state uuip-wc-empty-state::part(img) {
  width: 192px;
  height: 192px;
}
.empty-state uuip-wc-empty-state::part(container) {
  background-color: transparent;
}

agentx-wc-interactions-tab-date-range-picker {
  margin-top: 10px;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/InteractionsTab/InteractionsTabWidgetEmptyState/InteractionsTabWidgetEmptyState.scss */
/*# sourceURL=InteractionsTabWidgetEmptyState.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/InteractionsTab/InteractionsTabWidgetEmptyState/InteractionsTabWidgetEmptyState.ts":
/*!***********************************************************************************************************!*\
  !*** ./src/components/InteractionsTab/InteractionsTabWidgetEmptyState/InteractionsTabWidgetEmptyState.ts ***!
  \***********************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsTabWidgetEmptyState: () => (/* binding */ InteractionsTabWidgetEmptyState)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../constants */ "./src/components/InteractionsTab/constants.ts");
/* harmony import */ var _InteractionsTabDateRangePicker_InteractionsTabDateRangePicker__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../InteractionsTabDateRangePicker/InteractionsTabDateRangePicker */ "./src/components/InteractionsTab/InteractionsTabDateRangePicker/InteractionsTabDateRangePicker.ts");
/* harmony import */ var _InteractionsTabWidgetEmptyState_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./InteractionsTabWidgetEmptyState.scss */ "./src/components/InteractionsTab/InteractionsTabWidgetEmptyState/InteractionsTabWidgetEmptyState.scss");
/* harmony import */ var _InteractionsTabWidget_InteractionTabWidget_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../InteractionsTabWidget/InteractionTabWidget.constants */ "./src/components/InteractionsTab/InteractionsTabWidget/InteractionTabWidget.constants.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









let InteractionsTabWidgetEmptyState = class InteractionsTabWidgetEmptyState extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
    constructor() {
        super(...arguments);
        this.selectedTab = (0,_constants__WEBPACK_IMPORTED_MODULE_5__.getDefaultSelectedTab)();
        this.startTime = 0;
        this.endTime = 0;
        this.interactionTabType = _InteractionsTabWidget_InteractionTabWidget_constants__WEBPACK_IMPORTED_MODULE_8__.InteractionTabType.Interactions;
    }
    get openHeader() {
        return this.interactionTabType === _InteractionsTabWidget_InteractionTabWidget_constants__WEBPACK_IMPORTED_MODULE_8__.InteractionTabType.Tasks
            ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:no_open_tasks")
            : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:no_active_interactions");
    }
    get queuedHeader() {
        return this.interactionTabType === _InteractionsTabWidget_InteractionTabWidget_constants__WEBPACK_IMPORTED_MODULE_8__.InteractionTabType.Tasks
            ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:no_queued_tasks")
            : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:no_queued_interactions");
    }
    get closedHeader() {
        return this.interactionTabType === _InteractionsTabWidget_InteractionTabWidget_constants__WEBPACK_IMPORTED_MODULE_8__.InteractionTabType.Tasks
            ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:no_closed_tasks")
            : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:no_completed_interactions");
    }
    get openBody() {
        return this.interactionTabType === _InteractionsTabWidget_InteractionTabWidget_constants__WEBPACK_IMPORTED_MODULE_8__.InteractionTabType.Tasks
            ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:no_open_tasks_description")
            : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:no_active_interactions_description");
    }
    get queuedBody() {
        return this.interactionTabType === _InteractionsTabWidget_InteractionTabWidget_constants__WEBPACK_IMPORTED_MODULE_8__.InteractionTabType.Tasks
            ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:no_queued_tasks_description")
            : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:no_queued_interactions_description");
    }
    get closedBody() {
        return this.interactionTabType === _InteractionsTabWidget_InteractionTabWidget_constants__WEBPACK_IMPORTED_MODULE_8__.InteractionTabType.Tasks
            ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:no_closed_tasks_description")
            : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions:no_completed_interactions_description");
    }
    get headerText() {
        switch (this.selectedTab) {
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants.QueryType.Active:
                return this.openHeader;
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants.QueryType.Queued:
                return this.queuedHeader;
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants.QueryType.Completed:
                return this.closedHeader;
            default:
                return "";
        }
    }
    get bodyText() {
        switch (this.selectedTab) {
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants.QueryType.Active:
                return this.openBody;
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants.QueryType.Queued:
                return this.queuedBody;
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants.QueryType.Completed:
                return this.closedBody;
            default:
                return "";
        }
    }
    static get styles() {
        return _InteractionsTabWidgetEmptyState_scss__WEBPACK_IMPORTED_MODULE_7__["default"];
    }
    render() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_4__.html) `
      <div class="empty-state">
        <uuip-wc-empty-state
          illustration-src="/images/illustrations/cliff-open-192-cobalt-lime.svg"
          class="empty-state-illustration"
          illustration-name="cliff-open-192-cobalt-lime"
        >
          <div class="error-text">
            <h4 class="error-header">${this.headerText}</h4>
            <p class="error-body">
              ${this.bodyText} <br />
              <md-link
                size="midsize"
                inline
                inline-style="default"
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions.no_interactions_learn_more")}
                href="/"
              >
                ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:interactions.no_interactions_learn_more")}
              </md-link>
            </p>
          </div>
          ${this.selectedTab === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants.QueryType.Completed
            ? (0,lit_html__WEBPACK_IMPORTED_MODULE_4__.html) `
                <agentx-wc-interactions-tab-date-range-picker
                  .startTime=${this.startTime}
                  .endTime=${this.endTime}
                ></agentx-wc-interactions-tab-date-range-picker>
              `
            : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
        </uuip-wc-empty-state>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)()
], InteractionsTabWidgetEmptyState.prototype, "selectedTab", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Number })
], InteractionsTabWidgetEmptyState.prototype, "startTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Number })
], InteractionsTabWidgetEmptyState.prototype, "endTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String, attribute: "interaction-tab-type" })
], InteractionsTabWidgetEmptyState.prototype, "interactionTabType", void 0);
InteractionsTabWidgetEmptyState = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-interactions-tab-widget-empty-state")
], InteractionsTabWidgetEmptyState);



/***/ }),

/***/ "./src/components/InteractionsTab/config.ts":
/*!**************************************************!*\
  !*** ./src/components/InteractionsTab/config.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   actionsValueGetter: () => (/* binding */ actionsValueGetter),
/* harmony export */   agentNameGetter: () => (/* binding */ agentNameGetter),
/* harmony export */   durationValueFormatter: () => (/* binding */ durationValueFormatter),
/* harmony export */   formatDuration: () => (/* binding */ formatDuration),
/* harmony export */   getActiveTabDefaultColumnDefinitions: () => (/* binding */ getActiveTabDefaultColumnDefinitions),
/* harmony export */   getCollapsedColumnDefinitions: () => (/* binding */ getCollapsedColumnDefinitions),
/* harmony export */   getCompletedTabDefaultColumnDefinitions: () => (/* binding */ getCompletedTabDefaultColumnDefinitions),
/* harmony export */   getQueuedTabDefaultColumnDefinitions: () => (/* binding */ getQueuedTabDefaultColumnDefinitions),
/* harmony export */   mapColumnIdToQueryField: () => (/* binding */ mapColumnIdToQueryField)
/* harmony export */ });
/* harmony import */ var _components_Common_CellRenderers_constants_channel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/CellRenderers/constants/channel */ "./src/components/Common/CellRenderers/constants/channel.ts");
/* harmony import */ var _components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/components/Common/CellRenderers/constants/types */ "./src/components/Common/CellRenderers/constants/types.ts");
/* harmony import */ var _components_InteractionsTab_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/components/InteractionsTab/constants */ "./src/components/InteractionsTab/constants.ts");
/* harmony import */ var _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/components/InteractionsTab/types */ "./src/components/InteractionsTab/types.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Common/CellRenderers/Utils */ "./src/components/Common/CellRenderers/Utils.ts");
/* harmony import */ var _GridWidget_KeySuppressor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../GridWidget/KeySuppressor */ "./src/components/GridWidget/KeySuppressor.ts");
/* harmony import */ var _multirowValueGetter__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./multirowValueGetter */ "./src/components/InteractionsTab/multirowValueGetter.ts");










const keySuppressor = new _GridWidget_KeySuppressor__WEBPACK_IMPORTED_MODULE_8__.KeySuppressor(["actions"], "agentx-wc-table-action-buttons");
function formatDuration(milliseconds) {
    if (typeof milliseconds !== "number" || milliseconds <= 0) {
        return "00:00:00";
    }
    return luxon__WEBPACK_IMPORTED_MODULE_6__.Duration.fromMillis(milliseconds).toFormat("hh:mm:ss");
}
function durationValueFormatter(params) {
    if (params.value) {
        if (typeof params.value === "number") {
            // e.g. WaitTime
            return formatDuration(params.value);
        }
        else if (params.value.duration && params.value.duration > 0) {
            // e.g. TotalDuration
            return formatDuration(params.value.duration);
        }
        else if (params.value.createdTime && params.value.createdTime > 0) {
            // e.g. HandleTime
            const diff = Date.now() >= params.value.createdTime
                ? luxon__WEBPACK_IMPORTED_MODULE_6__.Duration.fromMillis(Date.now() - params.value.createdTime)
                : luxon__WEBPACK_IMPORTED_MODULE_6__.Duration.fromMillis(0);
            return formatDuration(diff.milliseconds);
        }
    }
    return "00:00:00";
}
function csatValueFormatter(params) {
    var _a;
    return (_a = params.value.toFixed(1)) !== null && _a !== void 0 ? _a : "0.0";
}
function timeValueGetter(params) {
    const createdTime = params.data["createdTime"] || 0;
    const active = params.data["isActive"] || false;
    const duration = params.data[params.colDef.field] || 0;
    return {
        duration,
        createdTime,
        active
    };
}
function channelValueGetter(params) {
    const channelType = params.data[params.colDef.field] || "";
    const channelSubType = params.data["channelSubType"] || "";
    const type = channelType === _components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__.ChannelTypes.Social ? channelSubType : channelType;
    const value = _components_Common_CellRenderers_constants_channel__WEBPACK_IMPORTED_MODULE_0__.CHANNEL_TYPE_TO_ICON_MAP[type];
    return {
        channelType: value
    };
}
function customerIdValueGetter(params) {
    const customer = params.data[params.colDef.field] || null;
    if (customer) {
        if (customer.phoneNumber && customer.phoneNumber.length > 0) {
            return customer.phoneNumber.toString();
        }
        else if (customer.email && customer.email.length > 0) {
            return customer.email;
        }
    }
    return "";
}
function dateTimeValueGetter(params) {
    const value = params.data[params.colDef.field] || 0;
    if (value <= 0) {
        return "";
    }
    return new Date(value).toLocaleString();
}
function emailCcValueGetter(params) {
    const emailCcList = params.data[params.colDef.field] || "";
    const emailBccList = params.data["emailBccList"] || "";
    const emailList = emailCcList
        .split(",")
        .concat(emailBccList.split(","))
        .filter((email) => email.length > 0);
    return emailList.join(", ");
}
function wrapupReasonValueGetter(params) {
    const wrapupCodeId = params.data[params.colDef.field] || "";
    const wrapupCodeName = params.data["lastWrapupCodeName"] || "";
    return `${wrapupCodeId}; ${wrapupCodeName}`;
}
function consultsValueGetter(params) {
    const consults = params.data[params.colDef.field] || [];
    const consultsCount = params.data["consultCount"] || 0;
    const consultsDuration = params.data["consultDuration"] || 0;
    const consultContacts = consults
        .map((consult) => `${consult.name}:${consult.id}`)
        .join(", ");
    let consultInfo = "";
    if (consultsCount !== 0) {
        consultInfo = `${consultsCount}`;
    }
    if (consultsDuration !== 0) {
        consultInfo = `${consultInfo} (${formatDuration(consultsDuration)})`;
    }
    if (consultContacts.length > 0) {
        consultInfo = `${consultInfo}: ${consultContacts}`;
    }
    return consultInfo;
}
function conferencesValueGetter(params) {
    const conferenceCount = params.data[params.colDef.field] || 0;
    const conferenceDuration = params.data["conferenceDuration"] || 0;
    const contributors = params.data["contributors"] || [];
    const contributorContacts = contributors
        .map((contributor) => `${contributor.name}:${contributor.id}`)
        .join(", ");
    let conferenceInfo = "";
    if (conferenceCount !== 0) {
        conferenceInfo = `${conferenceCount}`;
    }
    if (conferenceDuration !== 0) {
        conferenceInfo = `${conferenceInfo} (${formatDuration(conferenceDuration)})`;
    }
    if (contributorContacts.length > 0) {
        conferenceInfo = `${conferenceInfo}: ${contributorContacts}`;
    }
    return conferenceInfo;
}
function skillsValueGetter(params) {
    const matchedSkills = params.data["matchedSkills"] || "";
    const requiredSkills = params.data["requiredSkills"] || "";
    const matchedSkillsProfile = params.data["matchedSkillsProfile"] || "";
    return `${matchedSkills}; ${requiredSkills}; ${matchedSkillsProfile}`;
}
function previousQueueValueGetter(params) {
    const previousQueue = params.data[params.colDef.field] || null;
    if (previousQueue) {
        return `${previousQueue.name}; ${previousQueue.id}`;
    }
    return "";
}
function previousAgentValueGetter(params) {
    const previousAgentId = params.data["previousAgentId"] || "";
    const previousAgentName = params.data["previousAgentName"] || "";
    const previousAgentSessionId = params.data["previousAgentSessionId"] || "";
    return `${previousAgentName}; ${previousAgentId}; ${previousAgentSessionId}`;
}
function actionsValueGetter(params) {
    return {
        buttons: [
            { type: _components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__.ActionButtons.view },
            { type: _components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__.ActionButtons.download, options: ["audio", "transcript"] },
            { type: _components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__.ActionButtons.more }
        ],
        context: {
            interactionId: params.data["id"]
        }
    };
}
function agentNameGetter(params) {
    const _lastAgent = params.data["lastAgent"];
    const _agentName = _lastAgent.name;
    const _agentEmail = _lastAgent.signInId;
    return { name: _agentName, email: _agentEmail };
}
const COLUMN_DEFINITION_FIELDS = {
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Id]: "id",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Multirow]: "multirow",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Channel]: "channelType",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.StartTime]: "createdTime",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.EndTime]: "endedTime",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CustomerName]: "customer.name",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Customer]: "customer",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Direction]: "direction",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.EntryPoint]: "lastEntryPoint.name",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Queue]: "lastQueue.name",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Team]: "lastTeam.name",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Site]: "lastSite.name",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ContactStatus]: "status",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Agent]: "lastAgent.name",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CSAT]: "csatScore",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.HandleTime]: "connectedDuration",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Transfers]: "transferCount",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.BlindTransfers]: "blindTransferCount",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.HoldTime]: "holdDuration",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Timestamp]: "lastActivityTime",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.WrapUpTime]: "wrapupDuration",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TotalContactDuration]: "totalDuration",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Recipients]: "emailToList",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CCRecipients]: "emailCcList",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.EmailSubject]: "channelMetadata.email.subject",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.WrapUpReason]: "lastWrapUpCodeId",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ConsultingAgents]: "consults",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ConferencingAgents]: "conferenceCount",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Skills]: "skills",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.QueuedFrom]: "previousQueue",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TransferredToQueue]: "agentToQueueTransferCount",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TransferredByAgent]: "previousAgent",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.WaitTime]: "queueDuration",
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Actions]: "actions"
};
function mapColumnIdToQueryField(columnId) {
    var _a;
    const COLUMN_ID_TO_QUERY_FIELD_MAP = {
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Id]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.Id],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Channel]: [
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.ChannelType,
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.ChannelSubType
        ],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.StartTime]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.CreatedTime],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.EndTime]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.EndedTime],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CustomerName]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.CustomerName],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Customer]: [
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.CustomerEmail,
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.CustomerPhone
        ],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Direction]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.Direction],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.EntryPoint]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.EntryPointName],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Queue]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.QueueName],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Team]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.TeamName],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Site]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.SiteName],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ContactStatus]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.Status],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Agent]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.AgentName],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CSAT]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.CSATScore],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.HandleTime]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.ConnectedDuration],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Transfers]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.TransferCount],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.BlindTransfers]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.BlindTransferCount],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.HoldTime]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.HoldDuration],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Timestamp]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.LastActivityTime],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.WrapUpTime]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.WrapUpDuration],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TotalContactDuration]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.ConnectedDuration],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Recipients]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.EmailToList],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CCRecipients]: [
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.EmailCcList,
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.EmailBccList
        ],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.EmailSubject]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.EmailSubject],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.WrapUpReason]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.WrapUpCodeName],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ConsultingAgents]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.ConsultsName],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ConferencingAgents]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.ConferenceCount],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Skills]: [
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.MatchedSkills,
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.RequiredSkills,
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.MatchedSkillsProfile
        ],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.QueuedFrom]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.PreviousQueueName],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TransferredToQueue]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.AgentToQueueTransferCount],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TransferredByAgent]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.PreviousAgentName],
        [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.WaitTime]: [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.InteractionsServiceConstants.QueryField.QueueDuration]
    };
    return (_a = COLUMN_ID_TO_QUERY_FIELD_MAP[columnId]) !== null && _a !== void 0 ? _a : [];
}
function getBaseColumnDefinition(colId) {
    return {
        colId,
        field: COLUMN_DEFINITION_FIELDS[colId],
        autoHeight: false
    };
}
const ALL_INTERACTIONS_COLUMN_DEFINTIONS = {
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Id]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Id)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.naturalStringComparator }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Multirow]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Multirow)), { cellRenderer: "listItemRenderer", valueGetter: _multirowValueGetter__WEBPACK_IMPORTED_MODULE_9__.multirowValueGetter, width: _components_InteractionsTab_constants__WEBPACK_IMPORTED_MODULE_2__.COLLAPSED_COLUMN_WIDTH, minWidth: _components_InteractionsTab_constants__WEBPACK_IMPORTED_MODULE_2__.COLLAPSED_COLUMN_WIDTH, autoHeight: true }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Channel]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Channel)), { valueGetter: channelValueGetter, valueFormatter: (params) => params.value.text, useValueFormatterForExport: true, cellRenderer: "channelRenderer", comparator: (valueA, valueB) => (0,_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.naturalStringComparator)(valueA.text, valueB.text) }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.StartTime]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.StartTime)), { valueGetter: dateTimeValueGetter }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.EndTime]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.EndTime)), { valueGetter: dateTimeValueGetter }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CustomerName]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CustomerName)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.naturalStringComparator }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Customer]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Customer)), { valueGetter: customerIdValueGetter, comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.naturalStringComparator }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Direction]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Direction)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.naturalStringComparator }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.EntryPoint]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.EntryPoint)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.naturalStringComparator }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Queue]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Queue)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.naturalStringComparator }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Team]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Team)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.naturalStringComparator }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Site]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Site)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.naturalStringComparator }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ContactStatus]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ContactStatus)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.naturalStringComparator }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Agent]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Agent)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.agentNameComparator, cellRenderer: "agentNameRenderer", valueGetter: agentNameGetter, valueFormatter: (params) => params.value.name, useValueFormatterForExport: true }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CSAT]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CSAT)), { cellRenderer: "sentimentRenderer", valueFormatter: csatValueFormatter, useValueFormatterForExport: true }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.HandleTime]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.HandleTime)), { valueGetter: timeValueGetter, cellRenderer: "durationRenderer", valueFormatter: durationValueFormatter, useValueFormatterForExport: true }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Transfers]: getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Transfers),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.BlindTransfers]: getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.BlindTransfers),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.HoldTime]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.HoldTime)), { valueFormatter: durationValueFormatter }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Timestamp]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Timestamp)), { valueGetter: dateTimeValueGetter }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.WrapUpTime]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.WrapUpTime)), { valueFormatter: durationValueFormatter }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TotalContactDuration]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TotalContactDuration)), { valueGetter: timeValueGetter, cellRenderer: "durationRenderer", valueFormatter: durationValueFormatter, useValueFormatterForExport: true }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Recipients]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Recipients)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.naturalStringComparator }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CCRecipients]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CCRecipients)), { valueGetter: emailCcValueGetter, comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.naturalStringComparator }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.EmailSubject]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.EmailSubject)), { comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.naturalStringComparator }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.WrapUpReason]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.WrapUpReason)), { valueGetter: wrapupReasonValueGetter, comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.naturalStringComparator }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ConsultingAgents]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ConsultingAgents)), { valueGetter: consultsValueGetter, comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.naturalStringComparator }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ConferencingAgents]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ConferencingAgents)), { valueGetter: conferencesValueGetter, comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.naturalStringComparator }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Skills]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Skills)), { valueGetter: skillsValueGetter, comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.naturalStringComparator }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.QueuedFrom]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.QueuedFrom)), { valueGetter: previousQueueValueGetter, comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.naturalStringComparator }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TransferredToQueue]: getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TransferredToQueue),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TransferredByAgent]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TransferredByAgent)), { valueGetter: previousAgentValueGetter, comparator: _Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_7__.naturalStringComparator }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.WaitTime]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.WaitTime)), { valueFormatter: durationValueFormatter, useValueFormatterForExport: true }),
    [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Actions]: Object.assign(Object.assign({}, getBaseColumnDefinition(_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Actions)), { sortable: false, pinned: "right", lockPinned: true, cellRenderer: "actionButtonsRenderer", valueGetter: actionsValueGetter, cellClass: "actions-cell", suppressKeyboardEvent: keySuppressor.suppressKeyboardEvent, autoHeight: true, valueFormatter: () => " ", useValueFormatterForExport: true })
};
function reduceColumnDefinitions({ allColumns, availableColumns, selectedColumns }) {
    if (!_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_5__.SERVICE.featureflag.isInteractionsViewActionsColumnEnabled()) {
        availableColumns = availableColumns.filter((colId) => colId !== _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Actions);
    }
    return availableColumns.map((colId) => (Object.assign(Object.assign({}, allColumns[colId]), { headerName: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_4__.t)(`app:interactions.columns.${colId}`), hide: !selectedColumns.includes(colId) })));
}
function getActiveTabDefaultColumnDefinitions() {
    return reduceColumnDefinitions({
        allColumns: ALL_INTERACTIONS_COLUMN_DEFINTIONS,
        availableColumns: [
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Id,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Channel,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.StartTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CustomerName,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Customer,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Direction,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.EntryPoint,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Queue,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Team,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Site,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ContactStatus,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Agent,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CSAT,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Transfers,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.BlindTransfers,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.HoldTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Timestamp,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Recipients,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CCRecipients,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.EmailSubject,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ConsultingAgents,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ConferencingAgents,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Skills,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.QueuedFrom,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TransferredToQueue,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TransferredByAgent,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.WaitTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Actions
        ],
        selectedColumns: [
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Id,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Channel,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Queue,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Team,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ContactStatus,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Agent,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Actions
        ]
    });
}
function getQueuedTabDefaultColumnDefinitions() {
    return reduceColumnDefinitions({
        allColumns: ALL_INTERACTIONS_COLUMN_DEFINTIONS,
        availableColumns: [
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Id,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Channel,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.StartTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CustomerName,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Customer,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Direction,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.EntryPoint,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Queue,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Team,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Site,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ContactStatus,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CSAT,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Transfers,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.BlindTransfers,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.HoldTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Timestamp,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TotalContactDuration,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Recipients,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CCRecipients,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.EmailSubject,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Skills,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.QueuedFrom,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TransferredToQueue,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TransferredByAgent,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.WaitTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Actions
        ],
        selectedColumns: [
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Id,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Channel,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Queue,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TotalContactDuration,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Skills,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.WaitTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Actions
        ]
    });
}
function getCompletedTabDefaultColumnDefinitions() {
    return reduceColumnDefinitions({
        allColumns: ALL_INTERACTIONS_COLUMN_DEFINTIONS,
        availableColumns: [
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Id,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Channel,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.StartTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.EndTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CustomerName,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Customer,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Direction,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.EntryPoint,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Queue,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Team,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Site,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ContactStatus,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Agent,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CSAT,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.HandleTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Transfers,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.BlindTransfers,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.HoldTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Timestamp,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.WrapUpTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TotalContactDuration,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Recipients,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CCRecipients,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.EmailSubject,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.WrapUpReason,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ConsultingAgents,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.ConferencingAgents,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Skills,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.QueuedFrom,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TransferredToQueue,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TransferredByAgent,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.WaitTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Actions
        ],
        selectedColumns: [
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Id,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Channel,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.StartTime,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Queue,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Agent,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.CSAT,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.TotalContactDuration,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.WrapUpReason,
            _components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Actions
        ]
    });
}
function getCollapsedColumnDefinitions() {
    return reduceColumnDefinitions({
        allColumns: ALL_INTERACTIONS_COLUMN_DEFINTIONS,
        availableColumns: [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Multirow],
        selectedColumns: [_components_InteractionsTab_types__WEBPACK_IMPORTED_MODULE_3__.InteractionsTableColumnId.Multirow]
    });
}


/***/ }),

/***/ "./src/components/InteractionsTab/constants.ts":
/*!*****************************************************!*\
  !*** ./src/components/InteractionsTab/constants.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   COLLAPSED_COLUMN_WIDTH: () => (/* binding */ COLLAPSED_COLUMN_WIDTH),
/* harmony export */   DEFAULT_COLUMN_WIDTH: () => (/* binding */ DEFAULT_COLUMN_WIDTH),
/* harmony export */   DEFAULT_GROUP_BY_DATA: () => (/* binding */ DEFAULT_GROUP_BY_DATA),
/* harmony export */   DEFAULT_SEARCH_END_TIME: () => (/* binding */ DEFAULT_SEARCH_END_TIME),
/* harmony export */   DEFAULT_SEARCH_START_TIME: () => (/* binding */ DEFAULT_SEARCH_START_TIME),
/* harmony export */   ICON_EMOJI_HAPPY: () => (/* binding */ ICON_EMOJI_HAPPY),
/* harmony export */   ICON_EMOJI_PASSIVE: () => (/* binding */ ICON_EMOJI_PASSIVE),
/* harmony export */   ICON_EMOJI_SAD: () => (/* binding */ ICON_EMOJI_SAD),
/* harmony export */   MAX_ROWS_IN_RESPONSE: () => (/* binding */ MAX_ROWS_IN_RESPONSE),
/* harmony export */   SENTIMENT_NEGATIVE: () => (/* binding */ SENTIMENT_NEGATIVE),
/* harmony export */   SENTIMENT_NEUTRAL: () => (/* binding */ SENTIMENT_NEUTRAL),
/* harmony export */   SENTIMENT_POSITIVE: () => (/* binding */ SENTIMENT_POSITIVE),
/* harmony export */   getDefaultSelectedTab: () => (/* binding */ getDefaultSelectedTab)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./types */ "./src/components/InteractionsTab/types.ts");



const MAX_ROWS_IN_RESPONSE = 500;
const ICON_EMOJI_SAD = "emoji-sad-filled";
const ICON_EMOJI_PASSIVE = "emoji-passive-filled";
const ICON_EMOJI_HAPPY = "emoji-happy-filled";
const SENTIMENT_NEGATIVE = "negative";
const SENTIMENT_NEUTRAL = "neutral";
const SENTIMENT_POSITIVE = "positive";
const DEFAULT_COLUMN_WIDTH = 200; // default column width in px used by ag-grid
const COLLAPSED_COLUMN_WIDTH = 284;
const DEFAULT_SEARCH_START_TIME = luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.local().minus({ days: 1 }).toMillis();
const DEFAULT_SEARCH_END_TIME = luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.local().minus({ seconds: 1 }).toMillis();
const DEFAULT_GROUP_BY_DATA = [
    { id: _types__WEBPACK_IMPORTED_MODULE_2__.InteractionsTableGroupById.InteractionId, name: "Interaction Id", checked: false },
    { id: _types__WEBPACK_IMPORTED_MODULE_2__.InteractionsTableGroupById.CreatedOn, name: "Created On", checked: false },
    { id: _types__WEBPACK_IMPORTED_MODULE_2__.InteractionsTableGroupById.ClosedOn, name: "Closed On", checked: false },
    { id: _types__WEBPACK_IMPORTED_MODULE_2__.InteractionsTableGroupById.DateAndTime, name: "Date and Time", checked: false },
    { id: _types__WEBPACK_IMPORTED_MODULE_2__.InteractionsTableGroupById.CustomerIdentifier, name: "Customer Identifier", checked: false },
    { id: _types__WEBPACK_IMPORTED_MODULE_2__.InteractionsTableGroupById.CustomerName, name: "Customer Name", checked: false },
    { id: _types__WEBPACK_IMPORTED_MODULE_2__.InteractionsTableGroupById.BusinessIdentifier, name: "Business Identifier", checked: false },
    { id: _types__WEBPACK_IMPORTED_MODULE_2__.InteractionsTableGroupById.Direction, name: "Direction", checked: false },
    { id: _types__WEBPACK_IMPORTED_MODULE_2__.InteractionsTableGroupById.Channel, name: "Channel", checked: false },
    { id: _types__WEBPACK_IMPORTED_MODULE_2__.InteractionsTableGroupById.EntryPoint, name: "Entry Point", checked: false },
    { id: _types__WEBPACK_IMPORTED_MODULE_2__.InteractionsTableGroupById.SkillsNeeded, name: "Skills Needed", checked: false },
    { id: _types__WEBPACK_IMPORTED_MODULE_2__.InteractionsTableGroupById.Queue, name: "Queue", checked: false },
    { id: _types__WEBPACK_IMPORTED_MODULE_2__.InteractionsTableGroupById.TotalContactDuration, name: "Total Contact Duration", checked: false },
    { id: _types__WEBPACK_IMPORTED_MODULE_2__.InteractionsTableGroupById.WaitTime, name: "Wait Time", checked: false },
    { id: _types__WEBPACK_IMPORTED_MODULE_2__.InteractionsTableGroupById.HandleTime, name: "Handle Time", checked: false },
    { id: _types__WEBPACK_IMPORTED_MODULE_2__.InteractionsTableGroupById.HoldTime, name: "Hold Time", checked: false },
    { id: _types__WEBPACK_IMPORTED_MODULE_2__.InteractionsTableGroupById.WrapUpTime, name: "Wrap-up Time", checked: false }
];
function getDefaultSelectedTab() {
    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.InteractionsServiceConstants.QueryType.Active;
}


/***/ }),

/***/ "./src/components/InteractionsTab/index.ts":
/*!*************************************************!*\
  !*** ./src/components/InteractionsTab/index.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsTabDetailsWidget: () => (/* reexport safe */ _InteractionsTabDetailsView_InteractionsTabDetailsWidget__WEBPACK_IMPORTED_MODULE_0__.InteractionsTabDetailsWidget),
/* harmony export */   InteractionsTabTableHeader: () => (/* reexport safe */ _InteractionsTabTableHeader_InteractionsTabTableHeader__WEBPACK_IMPORTED_MODULE_1__.InteractionsTabTableHeader),
/* harmony export */   InteractionsTabWidget: () => (/* reexport safe */ _InteractionsTabWidget_InteractionsTabWidget__WEBPACK_IMPORTED_MODULE_2__.InteractionsTabWidget)
/* harmony export */ });
/* harmony import */ var _InteractionsTabDetailsView_InteractionsTabDetailsWidget__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./InteractionsTabDetailsView/InteractionsTabDetailsWidget */ "./src/components/InteractionsTab/InteractionsTabDetailsView/InteractionsTabDetailsWidget.ts");
/* harmony import */ var _InteractionsTabTableHeader_InteractionsTabTableHeader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./InteractionsTabTableHeader/InteractionsTabTableHeader */ "./src/components/InteractionsTab/InteractionsTabTableHeader/InteractionsTabTableHeader.ts");
/* harmony import */ var _InteractionsTabWidget_InteractionsTabWidget__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./InteractionsTabWidget/InteractionsTabWidget */ "./src/components/InteractionsTab/InteractionsTabWidget/InteractionsTabWidget.ts");





/***/ }),

/***/ "./src/components/InteractionsTab/multirowValueGetter.ts":
/*!***************************************************************!*\
  !*** ./src/components/InteractionsTab/multirowValueGetter.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   multirowValueGetter: () => (/* binding */ multirowValueGetter)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Common/CellRenderers/constants/types */ "./src/components/Common/CellRenderers/constants/types.ts");


function getDuration(params) {
    var _a, _b, _c, _d;
    let duration = (_a = params.data["createdTime"]) !== null && _a !== void 0 ? _a : 0;
    const isActive = (_b = params.data["isActive"]) !== null && _b !== void 0 ? _b : false;
    if (((_c = params.context) === null || _c === void 0 ? void 0 : _c.selectedTab) === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.InteractionsServiceConstants.QueryType.Completed) {
        duration = (_d = params.data["totalDuration"]) !== null && _d !== void 0 ? _d : 0;
    }
    return {
        duration,
        isActive
    };
}
function getActiveContent(params) {
    var _a, _b, _c, _d, _e, _f;
    return {
        agentName: (_b = (_a = params.data["lastAgent"]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "",
        timer: getDuration(params),
        queueName: (_d = (_c = params.data["lastQueue"]) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : "",
        teamName: (_f = (_e = params.data["lastTeam"]) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : ""
    };
}
function getQueuedContent(params) {
    var _a, _b;
    return {
        queueName: (_b = (_a = params.data["lastQueue"]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "",
        timer: getDuration(params)
        //message: TODO: Add message
    };
}
function getCompletedContent(params) {
    var _a, _b, _c, _d, _e;
    return {
        agentName: (_b = (_a = params.data["lastAgent"]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "",
        timer: getDuration(params),
        queueName: (_d = (_c = params.data["lastQueue"]) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : "",
        wrapupCode: (_e = params.data["lastWrapupCodeName"]) !== null && _e !== void 0 ? _e : ""
    };
}
function getContent(params, selectedTab) {
    switch (selectedTab) {
        case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.InteractionsServiceConstants.QueryType.Active:
            return getActiveContent(params);
        case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.InteractionsServiceConstants.QueryType.Queued:
            return getQueuedContent(params);
        case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.InteractionsServiceConstants.QueryType.Completed:
            return getCompletedContent(params);
        default:
            return "";
    }
}
function multirowValueGetter(params) {
    const { selectedTab } = params.context;
    const { channelType, channelSubType } = params.data;
    const type = channelType === _Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__.ChannelTypes.Social ? channelSubType : channelType;
    const values = getContent(params, selectedTab);
    return Object.assign({ selectedTab: params.context.selectedTab, channelType: type, customerId: params.data["id"] }, values);
}


/***/ }),

/***/ "./src/components/InteractionsTab/types.ts":
/*!*************************************************!*\
  !*** ./src/components/InteractionsTab/types.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsTableColumnId: () => (/* binding */ InteractionsTableColumnId),
/* harmony export */   InteractionsTableGroupById: () => (/* binding */ InteractionsTableGroupById)
/* harmony export */ });
var InteractionsTableColumnId;
(function (InteractionsTableColumnId) {
    InteractionsTableColumnId["Id"] = "id";
    InteractionsTableColumnId["Multirow"] = "multirow";
    InteractionsTableColumnId["Channel"] = "channel";
    InteractionsTableColumnId["StartTime"] = "start_time";
    InteractionsTableColumnId["EndTime"] = "end_time";
    InteractionsTableColumnId["CustomerName"] = "customer_name";
    InteractionsTableColumnId["Customer"] = "customer";
    InteractionsTableColumnId["Direction"] = "direction";
    InteractionsTableColumnId["EntryPoint"] = "entry_point";
    InteractionsTableColumnId["Queue"] = "queue";
    InteractionsTableColumnId["Team"] = "team";
    InteractionsTableColumnId["Site"] = "site";
    InteractionsTableColumnId["ContactStatus"] = "contact_status";
    InteractionsTableColumnId["Agent"] = "agent";
    InteractionsTableColumnId["CSAT"] = "csat";
    InteractionsTableColumnId["HandleTime"] = "handle_time";
    InteractionsTableColumnId["Transfers"] = "transfers";
    InteractionsTableColumnId["BlindTransfers"] = "blind_transfers";
    InteractionsTableColumnId["HoldTime"] = "hold_time";
    InteractionsTableColumnId["Timestamp"] = "timestamp";
    InteractionsTableColumnId["WrapUpTime"] = "wrap_up_time";
    InteractionsTableColumnId["TotalContactDuration"] = "total_contact_duration";
    InteractionsTableColumnId["Recipients"] = "recipients";
    InteractionsTableColumnId["CCRecipients"] = "cc_recipients";
    InteractionsTableColumnId["EmailSubject"] = "email_subject";
    InteractionsTableColumnId["WrapUpReason"] = "wrap_up_reason";
    InteractionsTableColumnId["ConsultingAgents"] = "consulting_agents";
    InteractionsTableColumnId["ConferencingAgents"] = "conferencing_agents";
    InteractionsTableColumnId["Skills"] = "skills";
    InteractionsTableColumnId["QueuedFrom"] = "queued_from";
    InteractionsTableColumnId["TransferredToQueue"] = "transferred_to_queue";
    InteractionsTableColumnId["TransferredByAgent"] = "transferred_by_agent";
    InteractionsTableColumnId["WaitTime"] = "wait_time";
    InteractionsTableColumnId["Actions"] = "actions";
})(InteractionsTableColumnId || (InteractionsTableColumnId = {}));
var InteractionsTableGroupById;
(function (InteractionsTableGroupById) {
    InteractionsTableGroupById["InteractionId"] = "interaction-id";
    InteractionsTableGroupById["CreatedOn"] = "created-on";
    InteractionsTableGroupById["ClosedOn"] = "closed-on";
    InteractionsTableGroupById["DateAndTime"] = "date-and-time";
    InteractionsTableGroupById["CustomerIdentifier"] = "customer-identifier";
    InteractionsTableGroupById["CustomerName"] = "customer-name";
    InteractionsTableGroupById["BusinessIdentifier"] = "business-identifier";
    InteractionsTableGroupById["Direction"] = "direction";
    InteractionsTableGroupById["Channel"] = "channel";
    InteractionsTableGroupById["EntryPoint"] = "entry-point";
    InteractionsTableGroupById["SkillsNeeded"] = "skills-needed";
    InteractionsTableGroupById["Queue"] = "queue";
    InteractionsTableGroupById["TotalContactDuration"] = "total-contact-duration";
    InteractionsTableGroupById["WaitTime"] = "wait-time";
    InteractionsTableGroupById["HandleTime"] = "handle-time";
    InteractionsTableGroupById["HoldTime"] = "hold-time";
    InteractionsTableGroupById["WrapUpTime"] = "wrap-up-time";
})(InteractionsTableGroupById || (InteractionsTableGroupById = {}));


/***/ }),

/***/ "./src/components/IvrTranscripts/IvrTranscripts.scss":
/*!***********************************************************!*\
  !*** ./src/components/IvrTranscripts/IvrTranscripts.scss ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  --transcript-badge-left-max-width: 130px;
  --transcript-wrapper-padding: calc(var(--space-token-cardinal) * 3);
  --transcript-wrapper-margin: calc(var(--space-token-even) * 2);
  --header-height: 48px;
  --transcript-padding: calc(var(--space-token-even) * 4);
  color: var(--md-primary-text-color);
  font-family: var(--font-family);
  font-weight: var(--font-weight);
}

.ivr-transcripts {
  position: absolute;
  background: var(--md-secondary-bg-color);
  height: calc(100% - (var(--transcript-padding) + var(--header-height)));
  width: calc(100% - var(--transcript-padding));
  overflow: hidden;
  padding: var(--transcript-padding);
  display: flex;
}

.transcript-wrapper {
  width: 100%;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=IvrTranscripts.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/IvrTranscripts/IvrTranscripts.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/IvrTranscripts/IvrTranscripts.ts":
/*!*********************************************************!*\
  !*** ./src/components/IvrTranscripts/IvrTranscripts.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DEFAULT_TRANSCRIPT_COLOR: () => (/* binding */ DEFAULT_TRANSCRIPT_COLOR),
/* harmony export */   IvrTranscripts: () => (/* binding */ IvrTranscripts)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Common_WidgetError_WidgetError__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Common/WidgetError/WidgetError */ "./src/components/Common/WidgetError/WidgetError.ts");
/* harmony import */ var _Common_WidgetLoader_WidgetLoader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Common/WidgetLoader/WidgetLoader */ "./src/components/Common/WidgetLoader/WidgetLoader.ts");
/* harmony import */ var _components_IntentWrapper_IntentWrapper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./components/IntentWrapper/IntentWrapper */ "./src/components/IvrTranscripts/components/IntentWrapper/IntentWrapper.ts");
/* harmony import */ var _components_TranscriptWrapper_TranscriptWrapper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./components/TranscriptWrapper/TranscriptWrapper */ "./src/components/IvrTranscripts/components/TranscriptWrapper/TranscriptWrapper.ts");
/* harmony import */ var _IvrTranscripts_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./IvrTranscripts.scss */ "./src/components/IvrTranscripts/IvrTranscripts.scss");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./utils/utils */ "./src/components/IvrTranscripts/utils/utils.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-explicit-any */













const DEFAULT_TRANSCRIPT_COLOR = "default";
const CONVERSATION_API_TIMEOUT = 5;
var IvrTranscripts;
(function (IvrTranscripts) {
    /**
     * @element agentx-wc-ivr-transcripts
     * @fires save-ivr-conversation
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_5__.LitElement) {
        constructor() {
            super(...arguments);
            this.selectedIntent = -1;
            this.ivrConversations = undefined;
            this.orgId = "";
            this.interactionId = "";
            this.isLoading = false;
            this.trackingId = "";
            this.setSelectedIntent = (index) => {
                this.selectedIntent = index;
            };
            this.reFetchTranscriptData = () => {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[IvrTranscript] re-fetching ivr transcript data");
                this.fetchIvrConversations();
            };
        }
        static get styles() {
            return _IvrTranscripts_scss__WEBPACK_IMPORTED_MODULE_11__["default"];
        }
        connectedCallback() {
            const _super = Object.create(null, {
                connectedCallback: { get: () => super.connectedCallback }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.connectedCallback.call(this);
                if (!this.ivrConversations) {
                    this.fetchIvrConversations();
                }
            });
        }
        fetchIvrConversations() {
            return __awaiter(this, void 0, void 0, function* () {
                this.isLoading = true;
                this.ivrConversations = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.mediaStorage.fetchIVRTranscript(this.orgId, this.interactionId, CONVERSATION_API_TIMEOUT);
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_util.trackInitialCallEvents({
                    eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.IVR_TRANSCRIPT,
                    interactionId: this.interactionId,
                    contactDirection: "INBOUND",
                    mediaType: "telephony",
                    status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS,
                    ivrConversation: JSON.stringify(this.ivrConversations)
                });
                this.dispatchEvent(new CustomEvent("save-ivr-conversation", {
                    detail: {
                        interactionId: this.interactionId,
                        ivrConversation: this.ivrConversations
                    }
                }));
                this.isLoading = false;
            });
        }
        render() {
            return this.ivrConversations
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
            <div class="ivr-transcripts">
              ${(0,_utils_utils__WEBPACK_IMPORTED_MODULE_12__.showIntent)(this.ivrConversations)
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                    <agentx-wc-ivr-intent-wrapper
                      .transcriptList=${this.ivrConversations}
                      @on-intent-select="${(e) => this.setSelectedIntent(e.detail.index)}"
                    ></agentx-wc-ivr-intent-wrapper>
                  `
                    : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
              <agentx-wc-ivr-transcript-wrapper
                class="transcript-wrapper"
                .transcriptList=${this.ivrConversations}
                selectedIntent=${this.selectedIntent}
              ></agentx-wc-ivr-transcript-wrapper>
            </div>
          `
                : this.isLoading
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) ` <agentx-wc-widget-loader></agentx-wc-widget-loader> `
                    : (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) ` <agentx-wc-widget-error @retry="${() => this.reFetchTranscriptData()}"></agentx-wc-widget-error> `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Number })
    ], Element.prototype, "selectedIntent", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
    ], Element.prototype, "ivrConversations", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "orgId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "interactionId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "trackingId", void 0);
    __decorate([
        _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__.Decorator.Handle({
            "Service.mediaStorage.metaData": ({ ctx, details }) => {
                var _a, _b;
                ctx.isLoading = false;
                ctx.trackingId = (_b = (_a = details.axiosError) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.trackingid;
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[IvrTranscript] Failed to fetch Transcript Meta data  ${JSON.stringify(details)}`);
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_util.trackInitialCallEvents({
                    eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.IVR_TRANSCRIPT,
                    interactionId: ctx.trackingId,
                    contactDirection: "INBOUND",
                    mediaType: "telephony",
                    status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                    reasonCode: "TRANSCRIPT_FETCH_FAIL"
                });
            },
            "Service.mediaStorage.conversation": ({ ctx, details }) => {
                var _a, _b;
                ctx.isLoading = false;
                ctx.trackingId = (_b = (_a = details.axiosError) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.trackingid;
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[IvrTranscript] Failed to fetch Conversation Meta data  ${JSON.stringify(details)}`);
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_util.trackInitialCallEvents({
                    eventName: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.IVR_TRANSCRIPT,
                    interactionId: ctx.trackingId,
                    contactDirection: "INBOUND",
                    mediaType: "telephony",
                    status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                    reasonCode: "CONVERSATION_FETCH_FAIL"
                });
            }
        })
    ], Element.prototype, "fetchIvrConversations", null);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-ivr-transcripts")
    ], Element);
    IvrTranscripts.Element = Element;
})(IvrTranscripts || (IvrTranscripts = {}));


/***/ }),

/***/ "./src/components/IvrTranscripts/components/ConfidenceBadge/Confidence.scss":
/*!**********************************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/ConfidenceBadge/Confidence.scss ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.badge-left-split {
  padding-left: calc(var(--space-token-cardinal) * 2);
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: var(--transcript-badge-left-max-width);
  display: inline-block;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=Confidence.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/IvrTranscripts/components/ConfidenceBadge/Confidence.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/IvrTranscripts/components/ConfidenceBadge/ConfidenceBadge.ts":
/*!*************************************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/ConfidenceBadge/ConfidenceBadge.ts ***!
  \*************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ConfidenceBadge: () => (/* binding */ ConfidenceBadge)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _IvrTranscripts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../IvrTranscripts */ "./src/components/IvrTranscripts/IvrTranscripts.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/utils */ "./src/components/IvrTranscripts/utils/utils.ts");
/* harmony import */ var _Confidence_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Confidence.scss */ "./src/components/IvrTranscripts/components/ConfidenceBadge/Confidence.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */






var ConfidenceBadge;
(function (ConfidenceBadge) {
    /**
     * @element agentx-wc-confidence-badge
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.confidence = 1;
            this.intentName = undefined;
            this.color = _IvrTranscripts__WEBPACK_IMPORTED_MODULE_3__.DEFAULT_TRANSCRIPT_COLOR;
        }
        static get styles() {
            return _Confidence_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-badge split color=${this.color} textColor="var(--md-primary-text-color)">
          <span slot="split-left" title=${this.intentName ? this.intentName : ""} class="badge-left-split"
            >${this.intentName}</span
          >
          <span slot="split-right"
            >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:ivrTranscripts.confidence")}: ${this.confidence ? (0,_utils_utils__WEBPACK_IMPORTED_MODULE_4__.getRoundedValue)(this.confidence) : 0}</span
          >
        </md-badge>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
    ], Element.prototype, "confidence", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "intentName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "color", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-confidence-badge")
    ], Element);
    ConfidenceBadge.Element = Element;
})(ConfidenceBadge || (ConfidenceBadge = {}));


/***/ }),

/***/ "./src/components/IvrTranscripts/components/Intent/Intent.scss":
/*!*********************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/Intent/Intent.scss ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.ivr-intent {
  background-color: var(--md-primary-bg-color);
  padding: calc(var(--space-token-cardinal) * 3);
  border-radius: var(--border-radius-large);
  margin: 0 calc(var(--space-token-even) * 4) calc(var(--space-token-even) * 4) 0;
}

.transcript-timer {
  font-family: var(--font-family-light);
  font-size: var(--font-size-small);
  float: right;
  padding-right: calc(var(--space-token-even) * 2);
}

.intent-params {
  padding: calc(var(--space-token-even) * 2);
  display: flex;
}

.intent-params span:first-child {
  width: 33.3333333333%;
  display: inline-block;
  font-family: var(--font-family-light);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.intent-params span:last-child {
  padding-left: calc(var(--space-token-even) * 4);
  width: 66.6666666667%;
  display: inline-block;
  word-break: break-word;
}

.params-wrapper .intent-params:first-child {
  padding-top: calc(var(--space-token-even) * 4);
}

.params-wrapper .intent-params:last-child {
  padding-bottom: 0;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=Intent.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/IvrTranscripts/components/Intent/Intent.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2Fzc2V0cy9zdHlsZXMvdmFyaWFibGVzLnNjc3MiLCJJbnRlbnQuc2NzcyIsIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvSXZyVHJhbnNjcmlwdHMvY29tcG9uZW50cy9JbnRlbnQvSW50ZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxjQUFBO0VBQ0EsdUJBQUE7RUFDQSx3QkFBQTtFQUNBLHVCQUFBO0VBRUEsbUJBQUE7RUFDQSwyQkFBQTtFQUNBLHVCQUFBO0VBQ0EsNEJBQUE7RUFFQSxZQUFBO0VBQ0EsMEJBQUE7RUFFQSxnQkFBQTtFQUNBLHVCQUFBO0VBQ0Esb0RBQUE7RUFDQSwyREFBQTtFQUVBLGdCQUFBO0VBQ0EsOERBQUE7RUFDQTs7Y0FBQTtFQUdBLGlIQUFBO0VBRUEsV0FBQTtFQUNBLDRCQUFBO0VBQ0Esd0JBQUE7RUFDQSx3QkFBQTtFQUNBLHdCQUFBO0VBQ0EseUJBQUE7RUFDQSx3QkFBQTtFQUNBLHFCQUFBO0VBQ0EsNkJBQUE7RUFDQSx5QkFBQTtFQUNBLDJCQUFBO0VBQ0EsaUNBQUE7RUFFQSxrQkFBQTtFQUNBLDBCQUFBO0VBQ0EsMkJBQUE7RUFDQSwyQkFBQTtFQUNBLDRCQUFBO0VBRUEsY0FBQTtFQUNBLG1EQUFBO0VBQ0EsbUNBQUE7RUFDQSxpQ0FBQTtFQUVBLGVBQUE7RUFDQSxzQkFBQTtFQUNBLHVCQUFBO0VBRUEsZUFBQTtFQUNBLGlEQUFBO0VBQ0EsZ0RBQUE7RUFDQSx3QkFBQTtFQUNBLGdEQUFBO0VBRUEsb0JBQUE7RUFDQSxZQUFBO0VBQ0EsWUFBQTtFQUNBLGNBQUE7RUFFQSxzQkFBQTtFQUNBLGVBQUE7RUFDQSxpQkFBQTtFQUNBLGlCQUFBO0VBQ0EsaUJBQUE7QUNWRjs7QUN6REE7RUFDRSw0Q0FBQTtFQUNBLDhDQUFBO0VBQ0EseUNBQUE7RUFDQSwrRUFBQTtBRDRERjs7QUN6REE7RUFDRSxxQ0FBQTtFQUNBLGlDQUFBO0VBQ0EsWUFBQTtFQUNBLGdEQUFBO0FENERGOztBQ3pEQTtFQUNFLDBDQUFBO0VBQ0EsYUFBQTtBRDRERjs7QUN6REE7RUFDRSxxQkFBQTtFQUNBLHFCQUFBO0VBQ0EscUNBQUE7RUFDQSxnQkFBQTtFQUNBLG1CQUFBO0VBQ0EsdUJBQUE7QUQ0REY7O0FDekRBO0VBQ0UsK0NBQUE7RUFDQSxxQkFBQTtFQUNBLHFCQUFBO0VBQ0Esc0JBQUE7QUQ0REY7O0FDekRBO0VBQ0UsOENBQUE7QUQ0REY7O0FDekRBO0VBQ0UsaUJBQUE7QUQ0REYiLCJmaWxlIjoiSW50ZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XG4gIC8qIEZvbnQgU2l6ZSAqL1xuICAtLWZvbnQtc2l6ZS1zbWFsbDogMTJweDtcbiAgLS1mb250LXNpemUtbWVkaXVtOiAxNHB4O1xuICAtLWZvbnQtc2l6ZS1sYXJnZTogMTZweDtcblxuICAvKiBTcGFjaW5nIHRva2VucyAqL1xuICAtLXNwYWNlLXRva2VuLWNhcmRpbmFsOiA1cHg7XG4gIC0tc3BhY2UtdG9rZW4tZXZlbjogMnB4O1xuICAtLXNwYWNlLWVycm9yLWlucHV0OiA0cHggOHB4O1xuXG4gIC8qIEhlaWdodHMgKi9cbiAgLS1lcnJvci1pbnB1dC1oZWlnaHQ6IDMycHg7XG5cbiAgLyogRm9udCBXZWlnaHQgKi9cbiAgLS1mb250LXdlaWdodC1saXRlOiAzMDA7XG4gIC0tZm9udC13ZWlnaHQ6IHZhcigtLWJyYW5kLWZvbnQtd2VpZ2h0LXJlZ3VsYXIsIDQwMCk7XG4gIC0tZm9udC13ZWlnaHQtbWVkaXVtOiB2YXIoLS1icmFuZC1mb250LXdlaWdodC1yZWd1bGFyLCA1MDApO1xuXG4gIC8qIEZvbnQgZmFtaWx5ICovXG4gIC0tZm9udC1mYW1pbHktYm9sZDogdmFyKC0tYnJhbmQtZm9udC1ib2xkLCBcIkNpc2NvU2Fuc1RUIEJvbGRcIik7XG4gIC0tZm9udC1mYW1pbHk6XG4gICAgdmFyKC0tYnJhbmQtZm9udC1yZWd1bGFyLCBcIkNpc2NvU2Fuc1RUIFJlZ3VsYXJcIiksIFwiQ2lzY29TYW5zVFQgUmVndWxhclwiLCBcIkhlbHZldGljYSBOZXVlXCIsIEhlbHZldGljYSwgQXJpYWwsXG4gICAgc2Fucy1zZXJpZjtcbiAgLS1mb250LWZhbWlseS1saWdodDogdmFyKC0tYnJhbmQtZm9udC1saWdodCwgXCJDaXNjb1NhbnNUVCBMaWdodFwiKSwgXCJIZWx2ZXRpY2EgTmV1ZVwiLCBIZWx2ZXRpY2EsIEFyaWFsLCBzYW5zLXNlcmlmO1xuXG4gIC8qIENvbG9ycyAqL1xuICAtLWxpZ2h0LWdyZWVuLWNvbG9yOiAjNDRjZjUwO1xuICAtLWNvbG9yLWdyYXktMTA6ICNlZGVkZWQ7XG4gIC0tY29sb3ItZ3JheS0zMDogI2QyZDVkNjtcbiAgLS1jb2xvci1ncmF5LTcwOiAjNTQ1NDU0O1xuICAtLWNvbG9yLWdyYXktMTAwOiAjMTIxMjEyO1xuICAtLWNvbG9yLWJsdWUtNzA6ICMwMDVlN2Q7XG4gIC0tY29sb3ItbGluazogIzAwYTBkMTtcbiAgLS1jb2xvci1lcnJvci1kZXRhaWw6ICM1MzU3NTk7XG4gIC0tY29sb3ItZ3JheS1ib3JkZXI6ICNjY2M7XG4gIC0tY29sb3ItZXJyb3ItdGV4dDogI2ExMjUxMjtcbiAgLS1jb2xvci1jb3VudC1ub3RpZmljYXRpb25zOiAjZmZmO1xuXG4gIC8qIEJvcmRlciByYWRpdXMgKi9cbiAgLS1ib3JkZXItcmFkaXVzLXNtYWxsOiA0cHg7XG4gIC0tYm9yZGVyLXJhZGl1cy1tZWRpdW06IDhweDtcbiAgLS1ib3JkZXItcmFkaXVzLWxhcmdlOiAxMnB4O1xuICAtLWJvcmRlci1yYWRpdXMtY2lyY2xlOiAxMDAlO1xuXG4gIC8qIEFuaW1hdGlvbiAqL1xuICAtLWVhc2UtaW4tb3V0LXF1aW50OiBjdWJpYy1iZXppZXIoMC44MywgMCwgMC4xNywgMSk7XG4gIC0tZGVmYXVsdC1hbmltYXRpb24tZHVyYXRpb246IDMwMG1zO1xuICAtLXF1aWNrLWFuaW1hdGlvbi1kdXJhdGlvbjogMTUwbXM7XG5cbiAgLyogc2Nyb2xsIGJhciAqL1xuICAtLXNjcm9sbGJhci13aWR0aDogNnB4O1xuICAtLXNjcm9sbGJhci1oZWlnaHQ6IDhweDtcblxuICAvKiBCb3ggc2hhZG93ICovXG4gIC0tYm94LXNoYWRvdzogMCAwIDRweCAycHggcmdiYSgwLCAxNjAsIDIwOSwgMC43NSk7XG4gIC0tYm94LXNoYWRvdy1ncmF5OiAwIDRweCA4cHggcmdiYSgwLCAwLCAwLCAwLjA4KTtcbiAgLS10cHctZmlsdGVyLWhlaWdodDogMHB4O1xuICAtLXdlYmtpdC1ib3gtc2hhZG93OiAwIDAgMXB4IHJnYmEoODQsIDg0LCA4NCwgMSk7XG5cbiAgLyogR2FwIGFuZCBwYWRkaW5nICovXG4gIC0tZ2FwLTQ6IDRweDtcbiAgLS1nYXAtODogOHB4O1xuICAtLWdhcC0xMjogMTJweDtcblxuICAvKiBXaWR0aHMgYW5kIGhlaWdodHMqL1xuICAtLWxlbmd0aC00OiA0cHg7XG4gIC0tbGVuZ3RoLTIwOiAyMHB4O1xuICAtLWxlbmd0aC0yNDogMjRweDtcbiAgLS1sZW5ndGgtMzI6IDMycHg7XG59XG4iLCI6aG9zdCB7XG4gIC8qIEZvbnQgU2l6ZSAqL1xuICAtLWZvbnQtc2l6ZS1zbWFsbDogMTJweDtcbiAgLS1mb250LXNpemUtbWVkaXVtOiAxNHB4O1xuICAtLWZvbnQtc2l6ZS1sYXJnZTogMTZweDtcbiAgLyogU3BhY2luZyB0b2tlbnMgKi9cbiAgLS1zcGFjZS10b2tlbi1jYXJkaW5hbDogNXB4O1xuICAtLXNwYWNlLXRva2VuLWV2ZW46IDJweDtcbiAgLS1zcGFjZS1lcnJvci1pbnB1dDogNHB4IDhweDtcbiAgLyogSGVpZ2h0cyAqL1xuICAtLWVycm9yLWlucHV0LWhlaWdodDogMzJweDtcbiAgLyogRm9udCBXZWlnaHQgKi9cbiAgLS1mb250LXdlaWdodC1saXRlOiAzMDA7XG4gIC0tZm9udC13ZWlnaHQ6IHZhcigtLWJyYW5kLWZvbnQtd2VpZ2h0LXJlZ3VsYXIsIDQwMCk7XG4gIC0tZm9udC13ZWlnaHQtbWVkaXVtOiB2YXIoLS1icmFuZC1mb250LXdlaWdodC1yZWd1bGFyLCA1MDApO1xuICAvKiBGb250IGZhbWlseSAqL1xuICAtLWZvbnQtZmFtaWx5LWJvbGQ6IHZhcigtLWJyYW5kLWZvbnQtYm9sZCwgXCJDaXNjb1NhbnNUVCBCb2xkXCIpO1xuICAtLWZvbnQtZmFtaWx5OlxuICAgIHZhcigtLWJyYW5kLWZvbnQtcmVndWxhciwgXCJDaXNjb1NhbnNUVCBSZWd1bGFyXCIpLCBcIkNpc2NvU2Fuc1RUIFJlZ3VsYXJcIiwgXCJIZWx2ZXRpY2EgTmV1ZVwiLCBIZWx2ZXRpY2EsIEFyaWFsLFxuICAgIHNhbnMtc2VyaWY7XG4gIC0tZm9udC1mYW1pbHktbGlnaHQ6IHZhcigtLWJyYW5kLWZvbnQtbGlnaHQsIFwiQ2lzY29TYW5zVFQgTGlnaHRcIiksIFwiSGVsdmV0aWNhIE5ldWVcIiwgSGVsdmV0aWNhLCBBcmlhbCwgc2Fucy1zZXJpZjtcbiAgLyogQ29sb3JzICovXG4gIC0tbGlnaHQtZ3JlZW4tY29sb3I6ICM0NGNmNTA7XG4gIC0tY29sb3ItZ3JheS0xMDogI2VkZWRlZDtcbiAgLS1jb2xvci1ncmF5LTMwOiAjZDJkNWQ2O1xuICAtLWNvbG9yLWdyYXktNzA6ICM1NDU0NTQ7XG4gIC0tY29sb3ItZ3JheS0xMDA6ICMxMjEyMTI7XG4gIC0tY29sb3ItYmx1ZS03MDogIzAwNWU3ZDtcbiAgLS1jb2xvci1saW5rOiAjMDBhMGQxO1xuICAtLWNvbG9yLWVycm9yLWRldGFpbDogIzUzNTc1OTtcbiAgLS1jb2xvci1ncmF5LWJvcmRlcjogI2NjYztcbiAgLS1jb2xvci1lcnJvci10ZXh0OiAjYTEyNTEyO1xuICAtLWNvbG9yLWNvdW50LW5vdGlmaWNhdGlvbnM6ICNmZmY7XG4gIC8qIEJvcmRlciByYWRpdXMgKi9cbiAgLS1ib3JkZXItcmFkaXVzLXNtYWxsOiA0cHg7XG4gIC0tYm9yZGVyLXJhZGl1cy1tZWRpdW06IDhweDtcbiAgLS1ib3JkZXItcmFkaXVzLWxhcmdlOiAxMnB4O1xuICAtLWJvcmRlci1yYWRpdXMtY2lyY2xlOiAxMDAlO1xuICAvKiBBbmltYXRpb24gKi9cbiAgLS1lYXNlLWluLW91dC1xdWludDogY3ViaWMtYmV6aWVyKDAuODMsIDAsIDAuMTcsIDEpO1xuICAtLWRlZmF1bHQtYW5pbWF0aW9uLWR1cmF0aW9uOiAzMDBtcztcbiAgLS1xdWljay1hbmltYXRpb24tZHVyYXRpb246IDE1MG1zO1xuICAvKiBzY3JvbGwgYmFyICovXG4gIC0tc2Nyb2xsYmFyLXdpZHRoOiA2cHg7XG4gIC0tc2Nyb2xsYmFyLWhlaWdodDogOHB4O1xuICAvKiBCb3ggc2hhZG93ICovXG4gIC0tYm94LXNoYWRvdzogMCAwIDRweCAycHggcmdiYSgwLCAxNjAsIDIwOSwgMC43NSk7XG4gIC0tYm94LXNoYWRvdy1ncmF5OiAwIDRweCA4cHggcmdiYSgwLCAwLCAwLCAwLjA4KTtcbiAgLS10cHctZmlsdGVyLWhlaWdodDogMHB4O1xuICAtLXdlYmtpdC1ib3gtc2hhZG93OiAwIDAgMXB4IHJnYmEoODQsIDg0LCA4NCwgMSk7XG4gIC8qIEdhcCBhbmQgcGFkZGluZyAqL1xuICAtLWdhcC00OiA0cHg7XG4gIC0tZ2FwLTg6IDhweDtcbiAgLS1nYXAtMTI6IDEycHg7XG4gIC8qIFdpZHRocyBhbmQgaGVpZ2h0cyovXG4gIC0tbGVuZ3RoLTQ6IDRweDtcbiAgLS1sZW5ndGgtMjA6IDIwcHg7XG4gIC0tbGVuZ3RoLTI0OiAyNHB4O1xuICAtLWxlbmd0aC0zMjogMzJweDtcbn1cblxuLml2ci1pbnRlbnQge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LWJnLWNvbG9yKTtcbiAgcGFkZGluZzogY2FsYyh2YXIoLS1zcGFjZS10b2tlbi1jYXJkaW5hbCkgKiAzKTtcbiAgYm9yZGVyLXJhZGl1czogdmFyKC0tYm9yZGVyLXJhZGl1cy1sYXJnZSk7XG4gIG1hcmdpbjogMCBjYWxjKHZhcigtLXNwYWNlLXRva2VuLWV2ZW4pICogNCkgY2FsYyh2YXIoLS1zcGFjZS10b2tlbi1ldmVuKSAqIDQpIDA7XG59XG5cbi50cmFuc2NyaXB0LXRpbWVyIHtcbiAgZm9udC1mYW1pbHk6IHZhcigtLWZvbnQtZmFtaWx5LWxpZ2h0KTtcbiAgZm9udC1zaXplOiB2YXIoLS1mb250LXNpemUtc21hbGwpO1xuICBmbG9hdDogcmlnaHQ7XG4gIHBhZGRpbmctcmlnaHQ6IGNhbGModmFyKC0tc3BhY2UtdG9rZW4tZXZlbikgKiAyKTtcbn1cblxuLmludGVudC1wYXJhbXMge1xuICBwYWRkaW5nOiBjYWxjKHZhcigtLXNwYWNlLXRva2VuLWV2ZW4pICogMik7XG4gIGRpc3BsYXk6IGZsZXg7XG59XG5cbi5pbnRlbnQtcGFyYW1zIHNwYW46Zmlyc3QtY2hpbGQge1xuICB3aWR0aDogMzMuMzMzMzMzMzMzMyU7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgZm9udC1mYW1pbHk6IHZhcigtLWZvbnQtZmFtaWx5LWxpZ2h0KTtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbiAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7XG59XG5cbi5pbnRlbnQtcGFyYW1zIHNwYW46bGFzdC1jaGlsZCB7XG4gIHBhZGRpbmctbGVmdDogY2FsYyh2YXIoLS1zcGFjZS10b2tlbi1ldmVuKSAqIDQpO1xuICB3aWR0aDogNjYuNjY2NjY2NjY2NyU7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgd29yZC1icmVhazogYnJlYWstd29yZDtcbn1cblxuLnBhcmFtcy13cmFwcGVyIC5pbnRlbnQtcGFyYW1zOmZpcnN0LWNoaWxkIHtcbiAgcGFkZGluZy10b3A6IGNhbGModmFyKC0tc3BhY2UtdG9rZW4tZXZlbikgKiA0KTtcbn1cblxuLnBhcmFtcy13cmFwcGVyIC5pbnRlbnQtcGFyYW1zOmxhc3QtY2hpbGQge1xuICBwYWRkaW5nLWJvdHRvbTogMDtcbn0iLCJAdXNlIFwiLi4vLi4vLi4vLi4vYXNzZXRzL3N0eWxlcy92YXJpYWJsZXNcIiBhcyAqO1xuXG4uaXZyLWludGVudCB7XG4gIGJhY2tncm91bmQtY29sb3I6IHZhcigtLW1kLXByaW1hcnktYmctY29sb3IpO1xuICBwYWRkaW5nOiBjYWxjKHZhcigtLXNwYWNlLXRva2VuLWNhcmRpbmFsKSAqIDMpO1xuICBib3JkZXItcmFkaXVzOiB2YXIoLS1ib3JkZXItcmFkaXVzLWxhcmdlKTtcbiAgbWFyZ2luOiAwIGNhbGModmFyKC0tc3BhY2UtdG9rZW4tZXZlbikgKiA0KSBjYWxjKHZhcigtLXNwYWNlLXRva2VuLWV2ZW4pICogNCkgMDtcbn1cblxuLnRyYW5zY3JpcHQtdGltZXIge1xuICBmb250LWZhbWlseTogdmFyKC0tZm9udC1mYW1pbHktbGlnaHQpO1xuICBmb250LXNpemU6IHZhcigtLWZvbnQtc2l6ZS1zbWFsbCk7XG4gIGZsb2F0OiByaWdodDtcbiAgcGFkZGluZy1yaWdodDogY2FsYyh2YXIoLS1zcGFjZS10b2tlbi1ldmVuKSAqIDIpO1xufVxuXG4uaW50ZW50LXBhcmFtcyB7XG4gIHBhZGRpbmc6IGNhbGModmFyKC0tc3BhY2UtdG9rZW4tZXZlbikgKiAyKTtcbiAgZGlzcGxheTogZmxleDtcbn1cblxuLmludGVudC1wYXJhbXMgc3BhbjpmaXJzdC1jaGlsZCB7XG4gIHdpZHRoOiBjYWxjKDEwMCUgLyAzKTtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICBmb250LWZhbWlseTogdmFyKC0tZm9udC1mYW1pbHktbGlnaHQpO1xuICBvdmVyZmxvdzogaGlkZGVuO1xuICB3aGl0ZS1zcGFjZTogbm93cmFwO1xuICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbn1cblxuLmludGVudC1wYXJhbXMgc3BhbjpsYXN0LWNoaWxkIHtcbiAgcGFkZGluZy1sZWZ0OiBjYWxjKHZhcigtLXNwYWNlLXRva2VuLWV2ZW4pICogNCk7XG4gIHdpZHRoOiBjYWxjKDEwMCUgKiAoMiAvIDMpKTtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICB3b3JkLWJyZWFrOiBicmVhay13b3JkO1xufVxuXG4ucGFyYW1zLXdyYXBwZXIgLmludGVudC1wYXJhbXM6Zmlyc3QtY2hpbGQge1xuICBwYWRkaW5nLXRvcDogY2FsYyh2YXIoLS1zcGFjZS10b2tlbi1ldmVuKSAqIDQpO1xufVxuXG4ucGFyYW1zLXdyYXBwZXIgLmludGVudC1wYXJhbXM6bGFzdC1jaGlsZCB7XG4gIHBhZGRpbmctYm90dG9tOiAwO1xufVxuIl19 */`);
    

/***/ }),

/***/ "./src/components/IvrTranscripts/components/Intent/Intent.ts":
/*!*******************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/Intent/Intent.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Intent: () => (/* binding */ Intent)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _IvrTranscripts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../IvrTranscripts */ "./src/components/IvrTranscripts/IvrTranscripts.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/utils */ "./src/components/IvrTranscripts/utils/utils.ts");
/* harmony import */ var _ConfidenceBadge_ConfidenceBadge__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../ConfidenceBadge/ConfidenceBadge */ "./src/components/IvrTranscripts/components/ConfidenceBadge/ConfidenceBadge.ts");
/* harmony import */ var _Intent_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Intent.scss */ "./src/components/IvrTranscripts/components/Intent/Intent.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */









var Intent;
(function (Intent) {
    /**
     * @element agentx-wc-ivr-intent
     * @fires item-selected
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.confidence = 1;
            this.intentName = undefined;
            this.color = _IvrTranscripts__WEBPACK_IMPORTED_MODULE_5__.DEFAULT_TRANSCRIPT_COLOR;
            this.timestamp = new Date().getTime();
            this.params = {};
            this.renderSubParams = (subParams) => {
                const subParamKeys = subParams ? Object.keys(subParams) : [];
                return (0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_4__.repeat)(subParamKeys, (key) => {
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <div>${key}: ${subParams[key]}</div> `;
                });
            };
            this.renderParamValue = (value) => {
                return typeof value === "string" || typeof value === "number"
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <span>${value}</span> `
                    : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <span>${this.renderSubParams(value)}</span> `;
            };
            this.renderParams = () => {
                const params = Object.keys(this.params).length > 0 ? (0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__.removeEmptyValues)(this.params) : null;
                const paramKeys = params ? Object.keys(params) : [];
                return (0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_4__.repeat)(paramKeys, (key) => {
                    return (params &&
                        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <div class="intent-params">
              <span title=${key}>${key}</span>
              ${this.renderParamValue(params[key])}
            </div>
          `);
                });
            };
        }
        static get styles() {
            return _Intent_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="ivr-intent">
          <agentx-wc-confidence-badge
            intentName=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__.ifDefined)(this.intentName)}
            confidence=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__.ifDefined)(this.confidence)}
            color=${this.color}
          ></agentx-wc-confidence-badge>
          <span class="transcript-timer">${(0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__.getTime)(this.timestamp)}</span>
          <div class="params-wrapper">${this.renderParams()}</div>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
    ], Element.prototype, "confidence", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "intentName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "color", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
    ], Element.prototype, "timestamp", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "params", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-ivr-intent")
    ], Element);
    Intent.Element = Element;
})(Intent || (Intent = {}));


/***/ }),

/***/ "./src/components/IvrTranscripts/components/IntentWrapper/IntentWrapper.scss":
/*!***********************************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/IntentWrapper/IntentWrapper.scss ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.ivr-intent-wrapper {
  width: 373px;
  height: 100%;
}

.scroll-content {
  height: 100%;
  overflow: scroll;
  -ms-overflow-style: none;
}

.scroll-content::-webkit-scrollbar {
  display: none;
}

.ivr-intent-item {
  cursor: pointer;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=IntentWrapper.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/IvrTranscripts/components/IntentWrapper/IntentWrapper.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/IvrTranscripts/components/IntentWrapper/IntentWrapper.ts":
/*!*********************************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/IntentWrapper/IntentWrapper.ts ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   IntentWrapper: () => (/* binding */ IntentWrapper)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/utils */ "./src/components/IvrTranscripts/utils/utils.ts");
/* harmony import */ var _Intent_Intent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Intent/Intent */ "./src/components/IvrTranscripts/components/Intent/Intent.ts");
/* harmony import */ var _IntentWrapper_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./IntentWrapper.scss */ "./src/components/IvrTranscripts/components/IntentWrapper/IntentWrapper.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */









var IntentWrapper;
(function (IntentWrapper) {
    /**
     * @element agentx-wc-ivr-intent-wrapper
     * @fires on-intent-select
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.transcriptList = null;
            this.toggleIntentSelection = (index) => {
                this.dispatchEvent(new CustomEvent("on-intent-select", {
                    detail: {
                        index
                    }
                }));
            };
            this.renderIntentList = (transcriptList) => {
                let colorIndex = -1;
                return (0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_5__.repeat)(transcriptList, (transcript, index) => {
                    var _a, _b;
                    if (((_a = transcript.bot) === null || _a === void 0 ? void 0 : _a.parameters) && (0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__.hasParamData)(transcript.bot)) {
                        colorIndex++;
                    }
                    return ((_b = transcript.bot) === null || _b === void 0 ? void 0 : _b.parameters) && (0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__.hasParamData)(transcript.bot)
                        ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
              <agentx-wc-ivr-intent
                confidence=${transcript.bot.confidence}
                intentName=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(transcript.bot.intentName)}
                color=${(0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__.getColorByIndex)(colorIndex)}
                timestamp=${transcript.bot.timestamp}
                .params=${transcript.bot.parameters}
                tabindex=${0}
                class="ivr-intent-item"
                @focus="${() => this.toggleIntentSelection(index)}"
                @blur="${() => this.toggleIntentSelection(-1)}"
              ></agentx-wc-ivr-intent>
            `
                        : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing;
                });
            };
        }
        static get styles() {
            return _IntentWrapper_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
        }
        render() {
            return (this.transcriptList &&
                (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
          <div class="scroll-content">
            <div class="ivr-intent-wrapper">${this.renderIntentList(this.transcriptList)}</div>
          </div>
        `);
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
    ], Element.prototype, "transcriptList", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-ivr-intent-wrapper")
    ], Element);
    IntentWrapper.Element = Element;
})(IntentWrapper || (IntentWrapper = {}));


/***/ }),

/***/ "./src/components/IvrTranscripts/components/TranscriptItem/TranscriptItem.scss":
/*!*************************************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/TranscriptItem/TranscriptItem.scss ***!
  \*************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.transcript-item {
  font-size: var(--font-size-small);
  display: flex;
  margin-bottom: calc(var(--space-token-even) * 8);
}

.blur-content {
  filter: opacity(0.3);
}

.transcript-content {
  margin-left: calc(var(--space-token-cardinal) * 2);
}

.transcript-text {
  font-size: var(--font-size-medium);
  margin-bottom: calc(var(--space-token-even) * 4);
}

.transcript-head {
  font-family: var(--font-family-light);
}

.transcript-header {
  padding-right: calc(var(--space-token-even) * 7);
  text-transform: capitalize;
}

.transcript-avatar {
  padding-top: calc(var(--space-token-even) * 2);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=TranscriptItem.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/IvrTranscripts/components/TranscriptItem/TranscriptItem.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/IvrTranscripts/components/TranscriptItem/TranscriptItem.ts":
/*!***********************************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/TranscriptItem/TranscriptItem.ts ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TranscriptItem: () => (/* binding */ TranscriptItem)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _IvrTranscripts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../IvrTranscripts */ "./src/components/IvrTranscripts/IvrTranscripts.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/utils */ "./src/components/IvrTranscripts/utils/utils.ts");
/* harmony import */ var _TranscriptItem_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./TranscriptItem.scss */ "./src/components/IvrTranscripts/components/TranscriptItem/TranscriptItem.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */









const MIN_SENTIMENT = 0;
var TranscriptItem;
(function (TranscriptItem) {
    /**
     * @element agentx-wc-ivr-transcript-item
     * @fires item-selected
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.type = "customer";
            this.sentiment = undefined;
            this.confidence = undefined;
            this.intentName = undefined;
            this.content = "";
            this.timestamp = new Date().getTime();
            this.color = _IvrTranscripts__WEBPACK_IMPORTED_MODULE_6__.DEFAULT_TRANSCRIPT_COLOR;
            this.params = {};
            this.selected = true;
            this.botName = "";
            this.getLocalisedCustomerTitle = () => {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:ivrTranscripts.customer`);
            };
            this.getLocalisedBotTitle = () => {
                return this.botName ? this.botName : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:ivrTranscripts.bot`);
            };
            this.isBot = () => {
                return this.type === "bot";
            };
            this.isCustomer = () => {
                return this.type === "customer";
            };
            this.getTitle = () => {
                return this.isCustomer() ? this.getLocalisedCustomerTitle() : this.getLocalisedBotTitle();
            };
            this.getFormattedTime = () => {
                return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__.getDate)(luxon__WEBPACK_IMPORTED_MODULE_5__.DateTime.local().toMillis()) !== (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__.getDate)(this.timestamp)
                    ? (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__.getDateTime)(this.timestamp)
                    : (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__.getTime)(this.timestamp);
            };
            this.renderAvatar = () => {
                return this.isCustomer()
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <md-avatar
              aria-label=${this.getLocalisedCustomerTitle()}
              title=${this.getLocalisedCustomerTitle()}
              size=${28}
            ></md-avatar>
          `
                    : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <md-avatar
              aria-label=${this.getLocalisedBotTitle()}
              title=${this.getLocalisedBotTitle()}
              size=${28}
              icon-name="icon-bot_12"
            ></md-avatar>
          `;
            };
            this.renderSentimentBadgeText = () => {
                return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:ivrTranscripts.sentiment")}: ${(0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__.getRoundedValue)(this.sentiment ? this.sentiment : 0)}`;
            };
            this.renderBadge = () => {
                return this.isCustomer() && (this.sentiment || this.sentiment === 0)
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <md-badge
              color=${this.sentiment >= MIN_SENTIMENT ? "default" : "red"}
              textColor="var(--md-primary-text-color)"
              aria-label=${this.renderSentimentBadgeText()}
            >
              ${this.renderSentimentBadgeText()}
            </md-badge>
          `
                    : this.isBot() && (this.confidence || this.confidence === 0) && this.intentName
                        ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
              <agentx-wc-confidence-badge
                intentName=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(this.intentName)}
                confidence=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(this.confidence)}
                color=${this.color}
              ></agentx-wc-confidence-badge>
            `
                        : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing;
            };
        }
        static get styles() {
            return _TranscriptItem_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="transcript-item ${this.selected ? lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing : "blur-content"} ">
          <div class="transcript-avatar">${this.renderAvatar()}</div>
          <div class="transcript-content">
            <div class="transcript-head">
              <span class="transcript-header"> ${this.getTitle()} </span>
              <span class="transcript-timer"> ${this.getFormattedTime()} </span>
            </div>
            <div class="transcript-text">${(0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__.getHighlightedTranscriptContent)(this.params, this.content, this.color)}</div>
            ${this.renderBadge()}
          </div>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "type", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
    ], Element.prototype, "sentiment", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
    ], Element.prototype, "confidence", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "intentName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "content", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
    ], Element.prototype, "timestamp", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "color", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "params", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "selected", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "botName", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-ivr-transcript-item")
    ], Element);
    TranscriptItem.Element = Element;
})(TranscriptItem || (TranscriptItem = {}));


/***/ }),

/***/ "./src/components/IvrTranscripts/components/TranscriptWrapper/TranscriptWrapper.scss":
/*!*******************************************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/TranscriptWrapper/TranscriptWrapper.scss ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.transcript-wrapper {
  padding: var(--transcript-wrapper-padding);
  margin: var(--transcript-wrapper-margin);
  height: 100%;
}

.scroll-content {
  height: 100%;
  overflow: scroll;
  -ms-overflow-style: none;
  scroll-behavior: smooth;
  border-radius: var(--border-radius-large);
  background-color: var(--md-primary-bg-color);
}

.scroll-content::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  border-radius: 12px;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0 0 1px rgb(84, 84, 84);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=TranscriptWrapper.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/IvrTranscripts/components/TranscriptWrapper/TranscriptWrapper.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/IvrTranscripts/components/TranscriptWrapper/TranscriptWrapper.ts":
/*!*****************************************************************************************!*\
  !*** ./src/components/IvrTranscripts/components/TranscriptWrapper/TranscriptWrapper.ts ***!
  \*****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TranscriptWrapper: () => (/* binding */ TranscriptWrapper)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _IvrTranscripts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../IvrTranscripts */ "./src/components/IvrTranscripts/IvrTranscripts.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/utils */ "./src/components/IvrTranscripts/utils/utils.ts");
/* harmony import */ var _TranscriptItem_TranscriptItem__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../TranscriptItem/TranscriptItem */ "./src/components/IvrTranscripts/components/TranscriptItem/TranscriptItem.ts");
/* harmony import */ var _TranscriptWrapper_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./TranscriptWrapper.scss */ "./src/components/IvrTranscripts/components/TranscriptWrapper/TranscriptWrapper.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */










var TranscriptWrapper;
(function (TranscriptWrapper) {
    /**
     * @element agentx-wc-ivr-transcript-wrapper
     * @fires item-selected
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.transcriptList = null;
            this.selectedIntent = -1;
            this.renderCustomerTranscript = (transcript, color, selected, index) => {
                const templateId = `customer-transcript-${index}`;
                return transcript.customer
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <agentx-wc-ivr-transcript-item
              type="customer"
              .sentiment=${transcript.customer.sentiment}
              content=${transcript.customer.query}
              .params=${transcript.bot && transcript.bot.parameters ? transcript.bot.parameters : {}}
              color=${color}
              .timestamp=${transcript.customer.timestamp}
              .selected=${selected}
              id=${templateId}
            ></agentx-wc-ivr-transcript-item>
          `
                    : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing;
            };
            this.renderBotTranscript = (transcript, color, selected, index) => {
                const templateId = `bot-transcript-${index}`;
                return transcript.bot
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <agentx-wc-ivr-transcript-item
              type="bot"
              content=${transcript.bot.reply}
              .timestamp=${transcript.bot.timestamp}
              .confidence=${transcript.bot.confidence}
              intentName=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(transcript.bot.intentName)}
              color=${color}
              .selected=${selected}
              botName=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(transcript.bot.botName)}
              id=${templateId}
            ></agentx-wc-ivr-transcript-item>
          `
                    : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing;
            };
            this.renderTranscript = (transcript, color, selected, index) => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        ${this.renderCustomerTranscript(transcript, color, selected, index)}
        ${this.renderBotTranscript(transcript, color, selected, index)}
      `;
            };
            this.renderTranscriptList = (transcriptList) => {
                let colorIndex = -1;
                return (0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_5__.repeat)(transcriptList, (transcript, index) => {
                    var _a;
                    let color = _IvrTranscripts__WEBPACK_IMPORTED_MODULE_6__.DEFAULT_TRANSCRIPT_COLOR;
                    const selected = this.selectedIntent === index || this.selectedIntent === -1;
                    if (((_a = transcript.bot) === null || _a === void 0 ? void 0 : _a.parameters) && (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__.hasParamData)(transcript.bot)) {
                        colorIndex++;
                        color = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__.getColorByIndex)(colorIndex);
                    }
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` ${this.renderTranscript(transcript, color, selected, index)} `;
                });
            };
        }
        static get styles() {
            return _TranscriptWrapper_scss__WEBPACK_IMPORTED_MODULE_9__["default"];
        }
        updated() {
            var _a, _b, _c;
            if (this.selectedIntent >= 0) {
                const customerSelectedTemplateId = `#customer-transcript-${this.selectedIntent}`;
                const botSelectedTemplateId = `#bot-transcript-${this.selectedIntent}`;
                const selectedTemplate = ((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(customerSelectedTemplateId))
                    ? (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector(customerSelectedTemplateId)
                    : (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector(botSelectedTemplateId);
                if (selectedTemplate instanceof HTMLElement && this.scrollContainer) {
                    this.scrollContainer.scrollTop = selectedTemplate.offsetTop - this.scrollContainer.clientHeight / 4;
                }
            }
        }
        render() {
            return (this.transcriptList &&
                (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
          <div class="scroll-content" id="scroll-container">
            <div class="transcript-wrapper">${this.renderTranscriptList(this.transcriptList)}</div>
          </div>
        `);
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
    ], Element.prototype, "transcriptList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
    ], Element.prototype, "selectedIntent", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)("#scroll-container")
    ], Element.prototype, "scrollContainer", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-ivr-transcript-wrapper")
    ], Element);
    TranscriptWrapper.Element = Element;
})(TranscriptWrapper || (TranscriptWrapper = {}));


/***/ }),

/***/ "./src/components/IvrTranscripts/utils/utils.ts":
/*!******************************************************!*\
  !*** ./src/components/IvrTranscripts/utils/utils.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getColorByIndex: () => (/* binding */ getColorByIndex),
/* harmony export */   getDate: () => (/* binding */ getDate),
/* harmony export */   getDateTime: () => (/* binding */ getDateTime),
/* harmony export */   getHighlightedTranscriptContent: () => (/* binding */ getHighlightedTranscriptContent),
/* harmony export */   getRoundedValue: () => (/* binding */ getRoundedValue),
/* harmony export */   getTime: () => (/* binding */ getTime),
/* harmony export */   hasParamData: () => (/* binding */ hasParamData),
/* harmony export */   removeEmptyValues: () => (/* binding */ removeEmptyValues),
/* harmony export */   showIntent: () => (/* binding */ showIntent)
/* harmony export */ });
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_0__);

const MERIDIEM_TIME_FORMAT = "hh:mm a";
const DATE_TIME_FORMAT = "dd/LL/yy, hh:mm a";
const DATE_FORMAT = "dd/LL/yy";
const IVR_COLORS = [
    "blue",
    "purple",
    "orange",
    "cyan",
    "violet",
    "green",
    "mint",
    "yellow"
];
const getColorByIndex = (index) => {
    return IVR_COLORS[index % IVR_COLORS.length];
};
const getTime = (timestamp) => {
    return luxon__WEBPACK_IMPORTED_MODULE_0__.DateTime.fromMillis(timestamp).toFormat(MERIDIEM_TIME_FORMAT);
};
const getDateTime = (timestamp) => {
    return luxon__WEBPACK_IMPORTED_MODULE_0__.DateTime.fromMillis(timestamp).toFormat(DATE_TIME_FORMAT);
};
const getDate = (timestamp) => {
    return luxon__WEBPACK_IMPORTED_MODULE_0__.DateTime.fromMillis(timestamp).toFormat(DATE_FORMAT);
};
const getBgStyle = (color) => {
    return `background-color:var(--badge-${color}-bg-color)`;
};
const getHilightedText = (content, param, color) => {
    return param
        ? content.replace(new RegExp(param, "gi"), `<span style=${getBgStyle(color)} >${param}</span>`)
        : content;
};
const getSubContent = (content, params, color) => {
    const paramSubValues = params ? Object.values(params) : [];
    paramSubValues.forEach((param) => {
        param = typeof param === "string" ? param : param.toString();
        content = getHilightedText(content, param, color);
    });
    return content;
};
const getHighlightedTranscriptContent = (params, content, color) => {
    const paramValues = params
        ? Object.values(params)
        : [];
    let htmlContent = content;
    paramValues.forEach((param) => {
        if (typeof param === "string" || typeof param === "number") {
            param = typeof param === "string" ? param : param.toString();
            htmlContent = getHilightedText(htmlContent, param, color);
        }
        else {
            htmlContent = getSubContent(htmlContent, param, color);
        }
    });
    const contentHtml = document.createElement("div");
    contentHtml.innerHTML = htmlContent;
    return contentHtml;
};
const hasParamData = (botTranscript) => {
    return botTranscript.parameters
        ? Object.values(botTranscript.parameters).filter((value) => {
            return value !== "";
        }).length !== 0
        : false;
};
const getRoundedValue = (num) => {
    return Math.round((num + Number.EPSILON) * 100) / 100;
};
const showIntent = (data) => {
    // This method will check the parameters of the botTranscript and return true if any of the parameters is not empty.
    // This method will check first level and one nested object level.
    return data.some((item) => {
        var _a;
        const botParameters = (_a = item === null || item === void 0 ? void 0 : item.bot) === null || _a === void 0 ? void 0 : _a.parameters;
        if (!botParameters) {
            return false;
        }
        // Check direct properties of botParameters
        return Object.values(botParameters).some((value) => {
            if (typeof value === "object" && !Array.isArray(value)) {
                // If the value is an object, check its properties for emptiness
                return Object.values(value !== null && value !== void 0 ? value : {}).some((innerValue) => innerValue !== "");
            }
            // Otherwise, check if the value is not an empty string
            return value !== "";
        });
    });
};
const removeEmptyValues = (data) => {
    const cleanedIntentData = {};
    // Iterate over entries using forEach and add non-empty key-value pairs to the new object
    Object.entries(data).forEach(([key, value]) => {
        if (value && value !== "") {
            if (typeof value === "object" && !Array.isArray(value)) {
                // Validate the same in nested objects
                if (Object.keys(value).length > 0) {
                    const cleanedValues = removeEmptyValues(value);
                    if (cleanedValues && Object.keys(cleanedValues).length > 0) {
                        cleanedIntentData[key] = cleanedValues;
                    }
                }
            }
            else {
                cleanedIntentData[key] = value;
            }
        }
    });
    return cleanedIntentData;
};


/***/ }),

/***/ "./src/components/MenuNotifications/MenuNotifications.scss":
/*!*****************************************************************!*\
  !*** ./src/components/MenuNotifications/MenuNotifications.scss ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  display: inline-block;
}

.wc-menu-notification-wrap {
  height: 456px;
  padding: 1rem 0;
  width: 100%;
  overflow: hidden;
  position: relative;
}

.wc-menu-notification_list {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.wc-menu-notification_list md-list-item::part(list-item) {
  padding: 0;
  border-radius: 5px;
  background: none;
}
.wc-menu-notification_count {
  position: absolute;
  display: inline-flex;
  right: -4px;
  top: -4px;
}

.wc-menu-notification-icon_wrap {
  position: relative;
  display: inline-block;
}

.wc-full-menu-notification .wc-menu-notification_title {
  margin-top: 0px;
  margin-bottom: 13px;
  padding-left: 16px;
  font-size: var(--font-size-medium);
  font-weight: bold;
}
.wc-full-menu-notification .wc-menu-notification_list {
  width: 100%;
  max-height: 380px;
  overflow: hidden;
  overflow-y: auto;
}
.wc-full-menu-notification .wc-menu-cleaner {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid var(--md-primary-seperator-color);
  color: var(--md-alert-info-text-color);
}

.wc-empty-menu-notification {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
}

uuip-wc-empty-state::part(container) {
  background: transparent;
}

uuip-wc-empty-state::part(img) {
  max-width: 84px;
  margin: 0 auto;
}

agentx-wc-empty-state-wrapper::part(container) {
  background: transparent;
}

agentx-wc-empty-state-wrapper::part(img) {
  max-width: 84px;
  margin: 0 auto;
}

.wc-empty-menu-notification .empty-text {
  color: var(--md-primary-text-color);
}

.wc-menu-notification-item {
  margin: var(--space-token-cardinal);
  cursor: default;
  background-color: var(--alert-default-bg-color);
}

.wc-notification-datediff {
  font-size: var(--font-size-small);
  padding-right: 0.3rem;
  white-space: nowrap;
  color: var(--md-primary-text-color);
}

@media (forced-colors: active) {
  .wc-notification-datediff {
    forced-color-adjust: auto;
    color: CanvasText !important;
  }
  .wc-menu-notification_list {
    forced-color-adjust: auto;
    background-color: Canvas !important;
    color: CanvasText !important;
  }
  .wc-menu-notification_list md-list-item::part(list-item) {
    forced-color-adjust: auto;
    background-color: Canvas !important;
    color: CanvasText !important;
  }
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=MenuNotifications.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/MenuNotifications/MenuNotifications.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/MenuNotifications/MenuNotifications.ts":
/*!***************************************************************!*\
  !*** ./src/components/MenuNotifications/MenuNotifications.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MenuNotification: () => (/* binding */ MenuNotification)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! lit-html/directives/style-map */ "lit-html/directives/style-map");
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../assets/styles/common.scss */ "./src/assets/styles/common.scss");
/* harmony import */ var _Common_EmptyStateWrapper_EmptyStateWrapper_ts__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../Common/EmptyStateWrapper/EmptyStateWrapper.ts */ "./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.ts");
/* harmony import */ var _MenuNotifications_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./MenuNotifications.scss */ "./src/components/MenuNotifications/MenuNotifications.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};














var MenuNotification;
(function (MenuNotification) {
    const MAX_UNREAD_NOTIFICATIONS_NON_DISPLAY = 99; // Count
    const TIME_FROM_UPDATE_INTERVAL = 5000; // ms
    MenuNotification.webexNotificationType = "webex_message";
    MenuNotification.customerDisconnectNotificationType = "customer_disconnect_message";
    /**
     * @element agentx-wc-menu-notification
     * @fires clear-notifications
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_6__.LitElement) {
        constructor() {
            super(...arguments);
            this.isModalOpen = false;
            this.unreadNotifications = [];
            this.unreadNotificationsHash = {};
            this.notificationsTimesFrom = {};
            this.notificationTimeUpdateRef = undefined;
            this.updateCollections = () => {
                this.unreadNotifications = [...this.notificationsService.pended, ...this.notificationsService.activated].sort((n1, n2) => {
                    // Sorting from new to old
                    return n1.timestamp > n2.timestamp ? -1 : n1.timestamp < n2.timestamp ? 1 : 0;
                });
                this.unreadNotifications = this.unreadNotifications.filter(({ data }) => {
                    const { type } = data;
                    return type !== MenuNotification.webexNotificationType && type !== MenuNotification.customerDisconnectNotificationType;
                });
                this.unreadNotificationsHash = this.unreadNotifications.reduce((acc, n) => {
                    acc[n.timestamp] = n;
                    return acc;
                }, {});
                if (this.unreadNotifications.length) {
                    this.startTimeupdate();
                }
                else {
                    this.stopTimeupdate();
                }
            };
        }
        static get styles() {
            return [_MenuNotifications_scss__WEBPACK_IMPORTED_MODULE_13__["default"], _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_11__["default"]];
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.unbindServiceEvents();
            this.stopTimeupdate();
            if (this.stopListen) {
                this.stopListen();
            }
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            this.updateCollections();
            this.bindServiceEvents();
        }
        bindServiceEvents() {
            // Listening for all service status events
            _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_5__.Notifications.ServiceMeta.STATUS_EVENTS.forEach((eventName) => this.notificationsService.addEventListener(eventName, this.updateCollections));
        }
        unbindServiceEvents() {
            // Stop Listening for all service status events
            _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_5__.Notifications.ServiceMeta.STATUS_EVENTS.forEach((eventName) => this.notificationsService.removeEventListener(eventName, this.updateCollections));
        }
        startTimeupdate() {
            this.stopTimeupdate();
            this.notificationsTimesFrom = this.unreadNotifications.reduce((acc, n) => {
                acc[n.timestamp] = Math.round(luxon__WEBPACK_IMPORTED_MODULE_10__.DateTime.local().diff(luxon__WEBPACK_IMPORTED_MODULE_10__.DateTime.fromISO(n.timestamp), "minutes").minutes);
                return acc;
            }, {});
            this.notificationTimeUpdateRef = window.setTimeout(() => this.startTimeupdate(), TIME_FROM_UPDATE_INTERVAL);
        }
        stopTimeupdate() {
            window.clearTimeout(this.notificationTimeUpdateRef);
            this.notificationTimeUpdateRef = undefined;
        }
        get unreadNotificationsCount() {
            return this.unreadNotifications.length;
        }
        executeOpenMenuNotification(key) {
            if (key.data &&
                key.data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.MODIFIERS.CTRL_ALT &&
                key.data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.REGISTERED_KEYS.OPEN_NOTIFICATION_CENTER_KEY &&
                this.refMenuElem &&
                this.refMenuElem.firstElementChild) {
                this.refMenuElem.firstElementChild.click();
            }
        }
        connectedCallback() {
            super.connectedCallback();
            const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.event.listenKeyPress((key) => this.executeOpenMenuNotification(key));
            this.stopListen = stopListen;
        }
        handleClearAll() {
            // Deactivating => clear
            const deactivatedNotifications = this.notificationsService.deactivateAll(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_5__.Notifications.ItemMeta.DeactivateEventReason.UserNegative);
            // Notify outer
            this.dispatchEvent(new CustomEvent("clear-notifications", {
                detail: {
                    notifications: deactivatedNotifications
                }
            }));
            setTimeout(() => {
                if (this.liveRegion) {
                    this.liveRegion.textContent = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:menuNotifications.notificationMenuEmptyStateNew");
                }
            }, _constants__WEBPACK_IMPORTED_MODULE_0__.TIMEOUT_TEN_MS);
        }
        // like 10 or 99+
        get unreadNotificationsCountText() {
            return this.unreadNotificationsCount > 0
                ? this.unreadNotificationsCount > MAX_UNREAD_NOTIFICATIONS_NON_DISPLAY
                    ? `${MAX_UNREAD_NOTIFICATIONS_NON_DISPLAY}+`
                    : this.unreadNotificationsCount
                : null;
        }
        renderCount() {
            return this.unreadNotificationsCountText
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
            <md-badge class="wc-menu-notification_count" color="unreadcount" outlined>
              <span> ${this.unreadNotificationsCountText} </span>
            </md-badge>
          `
                : lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing;
        }
        render() {
            const unreadNotificationsCountText = `(${this.unreadNotificationsCount})`;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
        <md-menu-overlay
          id="menu-notification"
          @menu-overlay-open=${() => {
                this.isModalOpen = true;
            }}
          @menu-overlay-close=${() => {
                this.isModalOpen = false;
                if (this.liveRegion) {
                    this.liveRegion.textContent = "";
                }
            }}
        >
          <span slot="menu-trigger" class="wc-menu-notification-icon_wrap">
            <md-tooltip slot="menu-trigger" placement="bottom" message=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.notificationLable")}>
              <md-button
                class="notification-btn"
                variant="ghost"
                size="32"
                circle
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.notificationAriaLabel", "Notification Center", {
                count: this.unreadNotificationsCount
            })}
                ariaExpanded=${this.isModalOpen}
                ariaHaspopup="true"
                ><md-icon name="alert-bold" size="20" iconSet="momentumDesign"></md-icon
              ></md-button>
            </md-tooltip>

            ${this.renderCount()}
          </span>
          <div class="wc-menu-notification-wrap">
            ${this.unreadNotificationsCount > 0
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                  <div class="wc-full-menu-notification">
                    <h2 class="wc-menu-notification_title">
                      ${`${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:menuNotifications.notificationMenuTitle")} ${unreadNotificationsCountText}`}
                    </h2>
                    <md-list
                      class="wc-menu-notification_list"
                      label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:menuNotifications.notifications")}
                      role="list"
                    >
                      ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_8__.repeat)(this.unreadNotifications, (n) => n.timestamp, (n) => (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                          <md-list-item
                            class="wc-menu-notification-item"
                            slot="list-item"
                            role="listitem"
                            aria-label="${n.title}, ${this.notificationsTimesFrom[n.timestamp]} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.minutes")},  ${typeof n.data == "object" ? n.data.text : n.data} "
                          >
                            <uuip-wc-toaster-notification-item-content .notification=${n}>
                            </uuip-wc-toaster-notification-item-content>
                            <span class="wc-notification-datediff"
                              >${this.notificationsTimesFrom[n.timestamp]}
                              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:menuNotifications.notificationMenuTime")}</span
                            >
                          </md-list-item>
                        `)}
                    </md-list>
                    <div class="wc-menu-cleaner">
                      <md-button
                        color="color-none"
                        @click=${() => this.handleClearAll()}
                        ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:menuNotifications.notificationMenuClearBtn")}"
                      >
                        <md-icon
                          slot="icon"
                          name="check_16"
                          style=${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9__.styleMap)({ color: "var(--md-alert-info-text-color)" })}
                        ></md-icon>
                        <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:menuNotifications.notificationMenuClearBtn")}</span>
                      </md-button>
                    </div>
                  </div>
                `
                : (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                  <div class="wc-empty-menu-notification">
                    <agentx-wc-empty-state-wrapper illustration-type="empty-state">
                      <div id="live-region" class="sr-only" aria-live="polite"></div>
                      <p
                        class="empty-text"
                        aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:menuNotifications.notificationMenuEmptyStateNew")}
                        tabindex="0"
                      >
                        ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:menuNotifications.notificationMenuEmptyStateNew")}
                      </p>
                    </agentx-wc-empty-state-wrapper>
                  </div>
                `}
          </div>
        </md-menu-overlay>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Object })
    ], Element.prototype, "notificationsService", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.query)("#menu-notification")
    ], Element.prototype, "refMenuElem", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.query)("#live-region")
    ], Element.prototype, "liveRegion", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "unreadNotifications", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "notificationsTimesFrom", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.customElement)("agentx-wc-menu-notification")
    ], Element);
    MenuNotification.Element = Element;
})(MenuNotification || (MenuNotification = {}));


/***/ }),

/***/ "./src/components/MoreActions/components/MoreActionsContainer/MoreActionsWidget.ts":
/*!*****************************************************************************************!*\
  !*** ./src/components/MoreActions/components/MoreActionsContainer/MoreActionsWidget.ts ***!
  \*****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MoreActionsWidget: () => (/* binding */ MoreActionsWidget)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../styles.scss */ "./src/components/MoreActions/styles.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */





var MoreActionsWidget;
(function (MoreActionsWidget) {
    /**
     * @element agentx-wc-more-actions-widget
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.tabsUniqueId = "";
            this.isResetTabOrderEnabled = false;
            this.isMenuOpen = false;
        }
        static get styles() {
            return _styles_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-menu-overlay
          custom-width="226px"
          size="small"
          @menu-overlay-open="${() => {
                this.isMenuOpen = true;
                document.dispatchEvent(new CustomEvent("agentx-more-actions-opened"));
            }}"
          @menu-overlay-close="${() => {
                this.isMenuOpen = false;
            }}"
          class="more-actions-menu-overlay"
        >
          <md-tooltip placement="top" message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:notes.moreActions")}" slot="menu-trigger">
            <md-button
              circle
              type="button"
              ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:notes.moreActions")}"
              class="menu-trigger-button more-actions-header-button"
              ariaExpanded="${this.isMenuOpen ? "true" : "false"}"
            >
              <md-icon name="more-adr-bold" iconSet="momentumDesign" size="16"></md-icon>
            </md-button>
          </md-tooltip>
          <div class="show-more-actions-list">
            ${this.isResetTabOrderEnabled
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <agentx-wc-reset-tab-order tabs-unique-id=${this.tabsUniqueId}></agentx-wc-reset-tab-order> `
                : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
            <slot name="custom-action"></slot>
          </div>
        </md-menu-overlay>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ attribute: "tabs-unique-id" })
    ], Element.prototype, "tabsUniqueId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isResetTabOrderEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isMenuOpen", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-more-actions-widget")
    ], Element);
    MoreActionsWidget.Element = Element;
})(MoreActionsWidget || (MoreActionsWidget = {}));


/***/ }),

/***/ "./src/components/MoreActions/components/ResetTabOrderAction/ResetTabOrderAction.ts":
/*!******************************************************************************************!*\
  !*** ./src/components/MoreActions/components/ResetTabOrderAction/ResetTabOrderAction.ts ***!
  \******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ResetTabOrderAction: () => (/* binding */ ResetTabOrderAction)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../styles.scss */ "./src/components/MoreActions/styles.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */




var ResetTabOrderAction;
(function (ResetTabOrderAction) {
    /**
     * @element agentx-wc-reset-tab-order
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.tabsUniqueId = "";
        }
        handleResetTabs() {
            this.dispatchEvent(new CustomEvent("clear-tab-order-prefs", {
                detail: {
                    compUniqueId: this.tabsUniqueId
                },
                composed: true,
                bubbles: true
            }));
        }
        static get styles() {
            return _styles_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-button hasRemoveStyle class="reset-action-button" @click=${() => this.handleResetTabs()}>
          <md-icon slot="icon" aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:panelTwo.resetTabOrder")} name="icon-refresh_16"></md-icon
          ><span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:panelTwo.resetTabOrder")}</span>
        </md-button>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ attribute: "tabs-unique-id" })
    ], Element.prototype, "tabsUniqueId", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-reset-tab-order")
    ], Element);
    ResetTabOrderAction.Element = Element;
})(ResetTabOrderAction || (ResetTabOrderAction = {}));


/***/ }),

/***/ "./src/components/MoreActions/styles.scss":
/*!************************************************!*\
  !*** ./src/components/MoreActions/styles.scss ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --show-more-actions-padding: 4px;
  position: relative;
  height: 100%;
}

md-menu-overlay::part(overlay-content) {
  overflow: visible;
}

.reset-action-button::part(button) {
  font-size: var(--font-size-medium);
  padding: var(--show-more-actions-padding);
  width: 100%;
}
.reset-action-button::part(button):hover, .reset-action-button::part(button):focus {
  background-color: var(--md-alert-info-bg-color, --md-alert-info-bg-color-default);
}
.reset-action-button::part(button-children) {
  place-content: start;
}

.more-actions-header-button {
  background-color: rgba(0, 0, 0, 0);
}

.more-actions-header-button::part(button) {
  background-color: rgba(0, 0, 0, 0);
}
.more-actions-header-button::part(button):active {
  background-color: var(--button-white-pressed-bg-color);
}
.more-actions-header-button::part(button):focus, .more-actions-header-button::part(button):hover {
  background-color: var(--button-white-hover-bg-color);
  color: var(--button-secondary-text-color, #121212);
}

.more-actions-menu-overlay {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  margin-left: var(--more-actions-margin-left);
  margin-right: var(--more-actions-margin-right);
}

.show-more-actions-list {
  display: flex;
  width: 100%;
  flex-direction: column;
  text-align: left;
  max-height: 200px;
  overflow: auto;
  overflow-x: hidden;
  border-radius: 7px;
  border: 2px solid var(--md-focus-border-color);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/MoreActions/styles.scss */
/*# sourceURL=styles.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvTW9yZUFjdGlvbnMvc3R5bGVzLnNjc3MiLCJzdHlsZXMuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGdDQUFBO0VBQ0Esa0JBQUE7RUFDQSxZQUFBO0FDQ0Y7O0FERUE7RUFDRSxpQkFBQTtBQ0NGOztBREdFO0VBQ0Usa0NBQUE7RUFDQSx5Q0FBQTtFQUNBLFdBQUE7QUNBSjtBREVJO0VBRUUsaUZBQUE7QUNETjtBREtFO0VBQ0Usb0JBQUE7QUNISjs7QURPQTtFQUNFLGtDQUFBO0FDSkY7O0FET0E7RUFDRSxrQ0FBQTtBQ0pGO0FETUU7RUFDRSxzREFBQTtBQ0pKO0FET0U7RUFFRSxvREFBQTtFQUNBLGtEQUFBO0FDTko7O0FEVUE7RUFDRSxtQkFBQTtFQUNBLGFBQUE7RUFDQSxZQUFBO0VBQ0EsdUJBQUE7RUFDQSw0Q0FBQTtFQUNBLDhDQUFBO0FDUEY7O0FEVUE7RUFDRSxhQUFBO0VBQ0EsV0FBQTtFQUNBLHNCQUFBO0VBQ0EsZ0JBQUE7RUFDQSxpQkFBQTtFQUNBLGNBQUE7RUFDQSxrQkFBQTtFQUNBLGtCQUFBO0VBQ0EsOENBQUE7QUNQRiIsImZpbGUiOiJzdHlsZXMuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgLS1zaG93LW1vcmUtYWN0aW9ucy1wYWRkaW5nOiA0cHg7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgaGVpZ2h0OiAxMDAlO1xufVxuXG5tZC1tZW51LW92ZXJsYXk6OnBhcnQob3ZlcmxheS1jb250ZW50KSB7XG4gIG92ZXJmbG93OiB2aXNpYmxlO1xufVxuXG4ucmVzZXQtYWN0aW9uLWJ1dHRvbiB7XG4gICY6OnBhcnQoYnV0dG9uKSB7XG4gICAgZm9udC1zaXplOiB2YXIoLS1mb250LXNpemUtbWVkaXVtKTtcbiAgICBwYWRkaW5nOiB2YXIoLS1zaG93LW1vcmUtYWN0aW9ucy1wYWRkaW5nKTtcbiAgICB3aWR0aDogMTAwJTtcblxuICAgICY6aG92ZXIsXG4gICAgJjpmb2N1cyB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1tZC1hbGVydC1pbmZvLWJnLWNvbG9yLCAtLW1kLWFsZXJ0LWluZm8tYmctY29sb3ItZGVmYXVsdCk7XG4gICAgfVxuICB9XG5cbiAgJjo6cGFydChidXR0b24tY2hpbGRyZW4pIHtcbiAgICBwbGFjZS1jb250ZW50OiBzdGFydDtcbiAgfVxufVxuXG4ubW9yZS1hY3Rpb25zLWhlYWRlci1idXR0b24ge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDAsIDAsIDAsIDApO1xufVxuXG4ubW9yZS1hY3Rpb25zLWhlYWRlci1idXR0b246OnBhcnQoYnV0dG9uKSB7XG4gIGJhY2tncm91bmQtY29sb3I6IHJnYmEoMCwgMCwgMCwgMCk7XG5cbiAgJjphY3RpdmUge1xuICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLWJ1dHRvbi13aGl0ZS1wcmVzc2VkLWJnLWNvbG9yKTtcbiAgfVxuXG4gICY6Zm9jdXMsXG4gICY6aG92ZXIge1xuICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLWJ1dHRvbi13aGl0ZS1ob3Zlci1iZy1jb2xvcik7XG4gICAgY29sb3I6IHZhcigtLWJ1dHRvbi1zZWNvbmRhcnktdGV4dC1jb2xvciwgIzEyMTIxMik7XG4gIH1cbn1cblxuLm1vcmUtYWN0aW9ucy1tZW51LW92ZXJsYXkge1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBkaXNwbGF5OiBmbGV4O1xuICBoZWlnaHQ6IDEwMCU7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBtYXJnaW4tbGVmdDogdmFyKC0tbW9yZS1hY3Rpb25zLW1hcmdpbi1sZWZ0KTtcbiAgbWFyZ2luLXJpZ2h0OiB2YXIoLS1tb3JlLWFjdGlvbnMtbWFyZ2luLXJpZ2h0KTtcbn1cblxuLnNob3ctbW9yZS1hY3Rpb25zLWxpc3Qge1xuICBkaXNwbGF5OiBmbGV4O1xuICB3aWR0aDogMTAwJTtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgdGV4dC1hbGlnbjogbGVmdDtcbiAgbWF4LWhlaWdodDogMjAwcHg7XG4gIG92ZXJmbG93OiBhdXRvO1xuICBvdmVyZmxvdy14OiBoaWRkZW47XG4gIGJvcmRlci1yYWRpdXM6IDdweDtcbiAgYm9yZGVyOiAycHggc29saWQgdmFyKC0tbWQtZm9jdXMtYm9yZGVyLWNvbG9yKTtcbn1cbiIsIjpob3N0IHtcbiAgLS1zaG93LW1vcmUtYWN0aW9ucy1wYWRkaW5nOiA0cHg7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgaGVpZ2h0OiAxMDAlO1xufVxuXG5tZC1tZW51LW92ZXJsYXk6OnBhcnQob3ZlcmxheS1jb250ZW50KSB7XG4gIG92ZXJmbG93OiB2aXNpYmxlO1xufVxuXG4ucmVzZXQtYWN0aW9uLWJ1dHRvbjo6cGFydChidXR0b24pIHtcbiAgZm9udC1zaXplOiB2YXIoLS1mb250LXNpemUtbWVkaXVtKTtcbiAgcGFkZGluZzogdmFyKC0tc2hvdy1tb3JlLWFjdGlvbnMtcGFkZGluZyk7XG4gIHdpZHRoOiAxMDAlO1xufVxuLnJlc2V0LWFjdGlvbi1idXR0b246OnBhcnQoYnV0dG9uKTpob3ZlciwgLnJlc2V0LWFjdGlvbi1idXR0b246OnBhcnQoYnV0dG9uKTpmb2N1cyB7XG4gIGJhY2tncm91bmQtY29sb3I6IHZhcigtLW1kLWFsZXJ0LWluZm8tYmctY29sb3IsIC0tbWQtYWxlcnQtaW5mby1iZy1jb2xvci1kZWZhdWx0KTtcbn1cbi5yZXNldC1hY3Rpb24tYnV0dG9uOjpwYXJ0KGJ1dHRvbi1jaGlsZHJlbikge1xuICBwbGFjZS1jb250ZW50OiBzdGFydDtcbn1cblxuLm1vcmUtYWN0aW9ucy1oZWFkZXItYnV0dG9uIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogcmdiYSgwLCAwLCAwLCAwKTtcbn1cblxuLm1vcmUtYWN0aW9ucy1oZWFkZXItYnV0dG9uOjpwYXJ0KGJ1dHRvbikge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDAsIDAsIDAsIDApO1xufVxuLm1vcmUtYWN0aW9ucy1oZWFkZXItYnV0dG9uOjpwYXJ0KGJ1dHRvbik6YWN0aXZlIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tYnV0dG9uLXdoaXRlLXByZXNzZWQtYmctY29sb3IpO1xufVxuLm1vcmUtYWN0aW9ucy1oZWFkZXItYnV0dG9uOjpwYXJ0KGJ1dHRvbik6Zm9jdXMsIC5tb3JlLWFjdGlvbnMtaGVhZGVyLWJ1dHRvbjo6cGFydChidXR0b24pOmhvdmVyIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tYnV0dG9uLXdoaXRlLWhvdmVyLWJnLWNvbG9yKTtcbiAgY29sb3I6IHZhcigtLWJ1dHRvbi1zZWNvbmRhcnktdGV4dC1jb2xvciwgIzEyMTIxMik7XG59XG5cbi5tb3JlLWFjdGlvbnMtbWVudS1vdmVybGF5IHtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZGlzcGxheTogZmxleDtcbiAgaGVpZ2h0OiAxMDAlO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgbWFyZ2luLWxlZnQ6IHZhcigtLW1vcmUtYWN0aW9ucy1tYXJnaW4tbGVmdCk7XG4gIG1hcmdpbi1yaWdodDogdmFyKC0tbW9yZS1hY3Rpb25zLW1hcmdpbi1yaWdodCk7XG59XG5cbi5zaG93LW1vcmUtYWN0aW9ucy1saXN0IHtcbiAgZGlzcGxheTogZmxleDtcbiAgd2lkdGg6IDEwMCU7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIHRleHQtYWxpZ246IGxlZnQ7XG4gIG1heC1oZWlnaHQ6IDIwMHB4O1xuICBvdmVyZmxvdzogYXV0bztcbiAgb3ZlcmZsb3cteDogaGlkZGVuO1xuICBib3JkZXItcmFkaXVzOiA3cHg7XG4gIGJvcmRlcjogMnB4IHNvbGlkIHZhcigtLW1kLWZvY3VzLWJvcmRlci1jb2xvcik7XG59Il19 */`);
    

/***/ }),

/***/ "./src/components/Navigation/Navigation.scss":
/*!***************************************************!*\
  !*** ./src/components/Navigation/Navigation.scss ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

nav {
  --nav-size: var(--nav-bar-width, 56px);
  --nav-item-height: 48px;
  --header-size: 64px;
  --mobile-logo-size: 28px;
  --nav-item-bottom-padding: 2px;
  height: 100%;
  max-width: var(--nav-size);
}
nav.momentum-style {
  --nav-item-height: 40px;
  --nav-item-bottom-padding: 4px;
}
nav .container {
  flex: 1;
  justify-content: space-between;
  max-height: calc(100vh - var(--nav-item-height));
  padding-bottom: calc(var(--space-token-cardinal) * 2);
  box-sizing: border-box;
}

.column {
  display: flex;
  flex-direction: column;
  width: var(--nav-size);
}

.nav-list {
  overflow-y: auto;
  margin: 0;
  text-indent: 0;
  list-style-type: none;
  padding: 4px 0;
}
.nav-list.primary {
  flex: 1;
  overflow: hidden;
  min-height: 50%;
}
.nav-list.secondary {
  height: auto;
  overflow: hidden;
}
.nav-list__item {
  padding-left: 4px;
  padding-bottom: var(--nav-item-bottom-padding);
}

.scroll-button-placer {
  max-height: 0;
  width: 100%;
  position: relative;
}

.nav-scroll-button {
  height: var(--nav-item-height);
  width: 100%;
  position: absolute;
  left: 0;
  z-index: var(--z-overflow-scroll-button, 1);
  display: flex;
  justify-content: center;
  color: var(--button-secondary-text-color, #121212);
  backdrop-filter: blur(10px);
}
.nav-scroll-button:not(.visual-rebrand) {
  background-color: var(--md-secondary-white-bg-color);
}
.nav-scroll-button:not(.visual-rebrand):hover {
  background-color: var(--md-tertiary-bg-color, --md-tertiary-bg-color-default);
}
.nav-scroll-button:not(.visual-rebrand):active {
  background-color: var(--md-quaternary-bg-color, --md-quaternary-bg-color-default);
}
.nav-scroll-button.visual-rebrand {
  backdrop-filter: blur(12px);
}
.nav-scroll-button.visual-rebrand:hover {
  backdrop-filter: blur(16px);
}
.nav-scroll-button.visual-rebrand:active {
  backdrop-filter: blur(20px);
}
.nav-scroll-button::part(button) {
  width: 100%;
}
.nav-scroll-button.top {
  top: 0;
}
.nav-scroll-button.bottom {
  bottom: 100%;
}

.hamburger-container {
  width: var(--nav-size);
  height: var(--header-size);
  align-items: center;
  justify-content: center;
  display: none;
}

.hamburger-container-tooltip {
  display: none;
}

.hidable-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  background-color: var(--md-navigation-bg-color);
}
.hidable-container .logo {
  display: none;
}

.reload-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(var(--nav-size) - 8px);
  height: var(--nav-item-height);
  padding-left: 4px;
}
.reload-button .reload-icon {
  justify-content: center;
  color: var(--md-alert-success-text-color, var(--light-green-color));
}

@media (max-width: 736px) {
  :host {
    position: absolute;
    z-index: auto;
  }
  :host([shownavlist]) {
    z-index: var(--z-navigation-bar);
  }
  .shadow {
    box-shadow: var(--box-shadow-gray);
  }
  nav .logo--img {
    width: var(--mobile-logo-size);
    height: var(--mobile-logo-size);
    margin: calc(var(--space-token-cardinal) * 4);
  }
  nav .container {
    padding-bottom: 0;
  }
  nav .top-container .logo {
    display: none;
  }
  nav .hamburger-container {
    display: flex;
    background-color: var(--md-header-bg-color);
    color: var(--md-primary-text-color);
    border-bottom: 1px solid var(--md-header-separator-color);
  }
  nav .hamburger-container-tooltip {
    display: block;
  }
  nav .hidable-container {
    position: relative;
    left: -100%;
    pointer-events: none;
    display: none;
    background-color: var(--nav-overlay-bg-color, var(--md-secondary-white-bg-color));
  }
  nav .hidable-container.show-nav-list {
    left: 0;
    pointer-events: initial;
    display: block;
  }
  nav .hidable-container .logo {
    display: flex;
  }
  nav .hidable-container .nav-list .not-responsive {
    display: none;
  }
}
@media (forced-colors: active) {
  .column {
    outline: 1px solid CanvasText !important;
  }
  nav .hidable-container {
    border-right: 1px solid CanvasText;
  }
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=Navigation.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-services/dist/styles/z-index.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Navigation/Navigation.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Navigation/Navigation.ts":
/*!*************************************************!*\
  !*** ./src/components/Navigation/Navigation.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Navigation: () => (/* binding */ Navigation)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../constants */ "./src/constants.ts");
/* harmony import */ var _Navigation_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./Navigation.scss */ "./src/components/Navigation/Navigation.scss");
/* harmony import */ var _comp_NavigationItem__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./comp/NavigationItem */ "./src/components/Navigation/comp/NavigationItem.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */













var Navigation;
(function (Navigation) {
    const DIRECTION = {
        UP: -1,
        DOWN: 1
    };
    const SCROLL_MARGIN = 20;
    const localizedLabels = {
        scrollDown: "app:navigation.scrollDown",
        hideNav: "app:navigation.hideNav",
        showNav: "app:navigation.showNav",
        scrollUp: "app:navigation.scrollUp",
        reload: "app:navigation.reload",
        hamburgerLabel: "app:navigation.hamburgerLabel",
        navigationRegionLabel: "app:navigation.navigationRegionLabel"
    };
    let RouteName;
    (function (RouteName) {
        RouteName["TASK"] = "task";
        RouteName["TASKPANEL"] = "task-panel";
        RouteName["APS"] = "aps";
        RouteName["METRICS"] = "wxm-metrics";
        RouteName["DEFAULT_HOME"] = "defaulthome";
    })(RouteName = Navigation.RouteName || (Navigation.RouteName = {}));
    const NAVIGATION_CUSTOM_ELEMENT = "agentx-wc-navigation";
    const FEEDBACK = "app:navigation.shareFeedback";
    /**
     * @element agentx-wc-navigation
     * @fires item-selected
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__.MobxLitElement) {
        constructor() {
            super(...arguments);
            this.selectedNavigateTo = null;
            this.items = [];
            this.agentDetails = {};
            this.popoverCount = null;
            this.navtitle = "Cisco Systems Inc.";
            this.darkTheme = false;
            this.userRole = [];
            /**
             * The reload button will show if agentx is loaded in an iframe or this property is set to true.
             * The purpose of this is to be used in test environments to force the reload button to render.
             */
            this.showReload = false;
            this.top = [];
            this.bottom = [];
            this.itemSelectedIdx = 0;
            this.showNavList = false;
            this.showTopScrollButton = false;
            this.showBottomScrollButton = false;
            this.userRoleString = "";
            this.isAgent = () => {
                return this.userRoleString === _constants__WEBPACK_IMPORTED_MODULE_10__.AGENT;
            };
            this.newTabHelpMenu = () => {
                var _a, _b, _c;
                let url = this.isAgent() ? _constants__WEBPACK_IMPORTED_MODULE_10__.HELP_LINK.AGENT_HELP : _constants__WEBPACK_IMPORTED_MODULE_10__.HELP_LINK.SUPERVISOR_HELP;
                const langForUrl = (_b = (_a = this.agentDetails) === null || _a === void 0 ? void 0 : _a.selectedLanguage) === null || _b === void 0 ? void 0 : _b.toLowerCase();
                // Ensure langForUrl is a valid key in languageCodes
                if (langForUrl in _constants__WEBPACK_IMPORTED_MODULE_10__.helpPageLangCode) {
                    url = url.replace("en-us", _constants__WEBPACK_IMPORTED_MODULE_10__.helpPageLangCode[langForUrl]);
                }
                (_c = window.open(url, "_blank")) === null || _c === void 0 ? void 0 : _c.focus();
            };
            this.bottomClickHandler = (item) => {
                var _a;
                if (item.icon.indexOf("help") >= 0) {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.HELP_ICON_CLICKED);
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.HELP_ICON_CLICKED, {
                        Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS
                    });
                    this.newTabHelpMenu();
                }
                else if (item.label === FEEDBACK) {
                    const queryString = `&a=${this.agentDetails.orgId}&t=${this.agentDetails.teamId}&i=${this.agentDetails.agentId}&selectedLanguage=${this.agentDetails.selectedLanguage}`;
                    const url = `${item.navigateTo}${queryString}`;
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.SURVEY_ICON_CLICKED, {
                        Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS
                    });
                    (_a = window.open(url, "_blank")) === null || _a === void 0 ? void 0 : _a.focus();
                }
                else {
                    this.selected(item.navigateTo);
                }
            };
            this.onPrimaryScroll = (event) => {
                const target = event.target;
                this.showTopScrollButton = target.scrollTop >= SCROLL_MARGIN;
                this.showBottomScrollButton = target.scrollHeight - target.clientHeight - SCROLL_MARGIN >= target.scrollTop;
            };
            this.scrollNavList = (direction) => this.primaryNav.scrollBy({
                top: (direction * this.primaryNav.clientHeight) / 2,
                behavior: "smooth"
            });
            this.handleScrollButtonCreation = () => {
                // dispatching a custom event to initiate the scroll buttons
                if (this.primaryNav) {
                    this.primaryNav.dispatchEvent(new CustomEvent("scroll"));
                }
            };
        }
        connectedCallback() {
            super.connectedCallback();
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.shortcut.event.listenKeyPress((event) => {
                const { data } = event;
                if (data && data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.shortcut.MODIFIERS.CTRL_ALT) {
                    if (data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.shortcut.REGISTERED_KEYS.OPEN_NAVIGATION_TAB_KEY) {
                        this.showNavList = !this.showNavList;
                        this.getHamburgerButton(this.showNavList);
                    }
                    if (data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.shortcut.REGISTERED_KEYS.REFRESH_KEY && window !== window.top) {
                        location.reload();
                    }
                }
            });
            window.addEventListener("resize", this.handleScrollButtonCreation);
        }
        disconnectedCallback() {
            window.removeEventListener("resize", this.handleScrollButtonCreation);
            super.disconnectedCallback();
        }
        registerShortcutKey(topItems) {
            const registerKey = [];
            topItems.forEach((item, index) => {
                registerKey.push({
                    widgetElement: NAVIGATION_CUSTOM_ELEMENT,
                    group: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.navigation.componentName"),
                    action: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.open")} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(item.label)} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.page")}`,
                    modifierKeys: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.shortcut.MODIFIERS.CTRL_ALT,
                    key: (index + 1).toString(),
                    listenKeyPress: (event) => {
                        const { data } = event;
                        if (data) {
                            const { key, modifierKeys } = data;
                            const nav = Number(key);
                            if (modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.shortcut.MODIFIERS.CTRL_ALT && nav <= this.top.length && nav > 0) {
                                this.selected(this.items[nav - 1].navigateTo);
                            }
                        }
                    },
                    role: "all"
                });
            });
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.shortcut.register(registerKey);
        }
        handleFocusNavigation() {
            const navi = this.renderRoot.querySelector(".nav-selected");
            if (navi) {
                navi.scrollIntoView({ block: "center" });
            }
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            changedProperties.forEach((oldValue, name) => {
                if (name === "items" || name === "selectedNavigateTo" || name === "itemSelectedIdx") {
                    // Updating render collections
                    if (name === "items") {
                        this.top = this.items.filter((i) => i.align === "top");
                        if (Array.isArray(this.top) && this.top.length > 0) {
                            const isTaskContain = this.top.findIndex((item) => item.navigateTo === "task");
                            if (isTaskContain >= 0) {
                                this.top[isTaskContain].taskBadge = true;
                            }
                            else {
                                this.top[0].taskBadge = true;
                            }
                        }
                        this.bottom = this.items.filter((i) => i.align === "bottom");
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.shortcut.unregisterKeys(NAVIGATION_CUSTOM_ELEMENT);
                        this.registerShortcutKey(this.top);
                        this.handleFocusNavigation();
                    }
                    if (oldValue === -1) {
                        this.handleFocusNavigation();
                    }
                    // Updating Select
                    if (this.selectedNavigateTo) {
                        this.itemSelectedIdx = this.top.findIndex((i) => i.navigateTo === this.selectedNavigateTo);
                    }
                }
            });
            if (this.showNavList !== changedProperties.get("showNavList")) {
                this.evt("navbar-toggled", { showNavList: this.showNavList });
            }
            // dispatching a custom event to initiate the scroll buttons
            this.handleScrollButtonCreation();
            // setting the userRoleString on update of role
            this.setUserRoleString();
        }
        selected(navigateTo) {
            (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.checkForTelemetryTracking)(navigateTo);
            this.evt("item-selected", { navigateTo });
        }
        // ROST: create decorator fot custom event
        evt(name, detail) {
            this.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true, detail }));
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[Navigation]: Dispatching event", name, detail);
        }
        static get styles() {
            return _Navigation_scss__WEBPACK_IMPORTED_MODULE_11__["default"];
        }
        setUserRoleString() {
            this.userRoleString = this.userRole && this.userRole.length > 0 ? this.userRole.join("_") : "";
        }
        getScrollButtonClassMap(dir) {
            return {
                top: dir === DIRECTION.UP,
                bottom: DIRECTION.UP,
                "nav-scroll-button": true,
                "visual-rebrand": _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isVisualRebrandEnabled
            };
        }
        getScrollButton(dir) {
            const scrollBtnDirectionLabel = dir === DIRECTION.UP ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.scrollUp) : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.scrollDown);
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
        <md-button
          @click=${() => this.scrollNavList(dir)}
          ariaLabel="${scrollBtnDirectionLabel}"
          role="scrollbar"
          title="${scrollBtnDirectionLabel}"
          class="${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_8__.classMap)(this.getScrollButtonClassMap(dir))}"
          hasRemoveStyle
        >
          <md-icon
            class="nav-scroll-icon"
            name="${dir === DIRECTION.UP ? "arrow-up-bold" : "arrow-down-bold"}"
            size="24"
            iconSet="momentumDesign"
            title="${scrollBtnDirectionLabel}"
          ></md-icon>
        </md-button>
      `;
        }
        getHamburgerButton(isNavShown) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
        <md-button
          ariaLabel="${isNavShown ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.hideNav) : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.showNav)}"
          ariaExpanded="${isNavShown}"
          variant="ghost"
          class="nav-button"
          circle
          size="40"
          @click=${() => {
                this.showNavList = !isNavShown;
                if (this.showNavList) {
                    this.setAttribute("showNavList", "");
                }
                else {
                    this.removeAttribute("showNavList");
                }
            }}
        >
          <md-icon
            name="${isNavShown ? "cancel-bold" : "list-menu-bold"}"
            class="nav-button-content"
            iconSet="momentumDesign"
            size="24"
          ></md-icon>
        </md-button>
      `;
        }
        get navClassMap() {
            return {
                shadow: this.showNavList,
                "momentum-style": _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled
            };
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
        <nav aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.navigationRegionLabel)}" class="column ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_8__.classMap)(this.navClassMap)}">
          <div class="top-container">
            <md-tooltip
              slot="menu-trigger"
              placement="bottom"
              class="hamburger-container-tooltip"
              message=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.hamburgerLabel)}
            >
              <div class="hamburger-container">${this.getHamburgerButton(this.showNavList)}</div>
            </md-tooltip>
          </div>
          <div class="${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_8__.classMap)({ "show-nav-list": this.showNavList, "hidable-container": true })}">
            <div class="column container">
              <div class="scroll-button-placer">
                ${this.showTopScrollButton ? this.getScrollButton(DIRECTION.UP) : lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing}
              </div>
              <ul
                @scroll=${this.onPrimaryScroll}
                id="primaryNav"
                aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:navigation.mainSectionlabel")}"
                class="nav-list primary"
              >
                ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_9__.repeat)(this.top, (item, index) => (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                    <li
                      class="nav-list__item ${this.itemSelectedIdx === index ? "nav-selected" : ""}"
                      aria-label="${item.label.includes("home") && this.popoverCount
                ? `${this.popoverCount} contact requests`
                : ""}"
                    >
                      <md-tooltip message="${item.label.startsWith("app:") ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(item.label) : item.label}">
                        <agentx-wc-navigation-item
                          uid="${index}"
                          .item="${item}"
                          .popoverCount="${this.popoverCount}"
                          ?momentumStyle=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
                          ?selected="${this.itemSelectedIdx === index}"
                          @selected="${(e) => this.selected(e.detail.item.navigateTo)}"
                        ></agentx-wc-navigation-item>
                      </md-tooltip>
                    </li>
                  `)}
              </ul>

              <div class="scroll-button-placer">
                ${this.showBottomScrollButton ? this.getScrollButton(DIRECTION.DOWN) : lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing}
              </div>
              <div>
                <!-- Bottom of the navigation bar is designated for quick links - they will not have 'selected' state -->
                <ul class="nav-list secondary">
                  ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_9__.repeat)(this.bottom, (item) => (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                      <li class="nav-list__item">
                        <md-tooltip message="${item.label.startsWith("app:") ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(item.label) : item.label}">
                          <agentx-wc-navigation-item
                            .item="${item}"
                            .popoverCount="${this.popoverCount}"
                            .darkTheme="${this.darkTheme}"
                            ?selected="${false}"
                            ?momentumStyle=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
                            @selected="${(e) => this.bottomClickHandler(e.detail.item)}"
                          ></agentx-wc-navigation-item>
                        </md-tooltip>
                      </li>
                    `)}
                </ul>
                <!-- Display reload icon if agentx loaded in an iframe -->
                ${window !== window.top || this.showReload
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                      <md-tooltip message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.reload)}">
                        <md-button
                          @click=${() => location.reload()}
                          ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.reload)}"
                          class="reload-button"
                          size="40"
                          circle
                          variant="ghost"
                        >
                          <md-icon
                            aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.reload)}"
                            title="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(localizedLabels.reload)}"
                            name="refresh-bold"
                            class="reload-icon"
                            iconSet="momentumDesign"
                            size="24"
                          ></md-icon>
                        </md-button>
                      </md-tooltip>
                    `
                : ""}
              </div>
            </div>
          </div>
        </nav>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
    ], Element.prototype, "selectedNavigateTo", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Array })
    ], Element.prototype, "items", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Object })
    ], Element.prototype, "agentDetails", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Number })
    ], Element.prototype, "popoverCount", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
    ], Element.prototype, "navtitle", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Boolean })
    ], Element.prototype, "darkTheme", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Array })
    ], Element.prototype, "userRole", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Boolean, attribute: "show-reload" })
    ], Element.prototype, "showReload", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "top", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "bottom", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "itemSelectedIdx", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "showNavList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "showTopScrollButton", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "showBottomScrollButton", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
    ], Element.prototype, "userRoleString", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.query)("#primaryNav")
    ], Element.prototype, "primaryNav", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.customElement)(NAVIGATION_CUSTOM_ELEMENT)
    ], Element);
    Navigation.Element = Element;
})(Navigation || (Navigation = {}));


/***/ }),

/***/ "./src/components/Navigation/comp/NavigationItem.scss":
/*!************************************************************!*\
  !*** ./src/components/Navigation/comp/NavigationItem.scss ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  display: flex;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  text-indent: 0;
  list-style: none;
}

.nav-button {
  display: flex;
  border-radius: 3px;
  color: var(--md-primary-text-color);
  width: calc(var(--nav-size) - 8px);
  height: var(--nav-item-height);
  align-items: center;
  justify-content: center;
}
.nav-button:not(.nav-button__momentum):hover {
  background-color: var(--md-tertiary-bg-color);
}
.nav-button:not(.nav-button__momentum).nav-button__selected {
  position: relative;
  background-color: var(--md-quaternary-bg-color);
}
.nav-button:not(.nav-button__momentum).nav-button__selected::before {
  content: "";
  position: absolute;
  z-index: var(--z-index-expand-collapse, 2);
  width: 3px;
  height: 100%;
  background-color: var(--md-primary-text-color);
  top: 0;
  left: -3px;
  border-radius: 2px;
}
.nav-button:not(.nav-button__momentum) .wc-unread-popover-count {
  position: absolute;
  left: 1.3rem;
  top: 0.4rem;
  transform: translate(-20%, -10%);
}
.nav-button.nav-button__momentum {
  position: relative;
}
.nav-button.nav-button__momentum::before {
  content: "";
  position: absolute;
  z-index: var(--z-index-expand-collapse, 2);
  background-color: var(--md-primary-text-color);
  top: 50%;
  transform: translateY(-50%);
  left: -8px;
  border-radius: 0px 4px 4px 0px;
  width: 4px;
  height: 16px;
}
.nav-button.nav-button__momentum .wc-unread-popover-count {
  position: absolute;
  display: inline-flex;
  right: 2px;
  top: 2px;
}
.nav-button.nav-button__momentum:not(.nav-button__visual-rebrand).nav-button__selected::before {
  left: -4px;
}
.nav-button.nav-button__momentum.nav-button__visual-rebrand::before {
  transition: left 0.2s ease;
}
.nav-button.nav-button__momentum.nav-button__visual-rebrand:hover::before {
  left: -4px;
}
.nav-button.nav-button__momentum.nav-button__visual-rebrand:active::before {
  left: -8px;
}
.nav-button.nav-button__momentum.nav-button__visual-rebrand:active::part(button) {
  background-color: var(--button-primary-bg-color);
  color: var(--button-primary-text-color);
}
.nav-button .nav-scroll-icon {
  color: var(--md-primary-text-color);
}
.nav-button .nav-button-content {
  width: calc(var(--nav-size) - 0.125rem);
  height: calc(var(--nav-item-height) - 0.25rem);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 !important;
}
.nav-button .nav-button-content.hidden {
  display: none;
}
.nav-button .nav-button-content.img-loading {
  background-image: linear-gradient(-45deg, rgba(255, 255, 255, 0.125) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.125) 50%, rgba(255, 255, 255, 0.125) 75%, transparent 75%, transparent);
  background-size: calc(var(--nav-size) / 2) calc(var(--nav-size) / 2);
  animation: cssProgressActive 1s linear infinite;
}
@keyframes cssProgressActive {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: calc(var(--nav-size) / 2) calc(var(--nav-size) / 2);
  }
}

@media (forced-colors: active) {
  .nav-button.nav-button__selected::before {
    background-color: CanvasText !important;
  }
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=NavigationItem.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/Navigation/comp/NavigationItem.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Navigation/comp/NavigationItem.ts":
/*!**********************************************************!*\
  !*** ./src/components/Navigation/comp/NavigationItem.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NavigationItem: () => (/* binding */ NavigationItem)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html/directives/style-map */ "lit-html/directives/style-map");
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _NavigationItem_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./NavigationItem.scss */ "./src/components/Navigation/comp/NavigationItem.scss");
/* harmony import */ var _NavigationItemIconUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./NavigationItemIconUtils */ "./src/components/Navigation/comp/NavigationItemIconUtils.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_9__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};










const DEFAULT_ICON_SIZE = 24;
const DEFAULT_ICON_SIZE_LEGACY = 20;
const isImageUrl = (url) => {
    if (!url || url.length < 4) {
        return false;
    }
    const validImageExtensions = ["png", "gif", "jpg", "jpeg", "svg", "bmp", "ico"];
    const image = url.substring(url.lastIndexOf("/")).toLowerCase();
    return validImageExtensions.find((ext) => image.includes(ext));
};
var NavigationItem;
(function (NavigationItem) {
    /**
     * @element agentx-wc-navigation-item
     * @fires selected
     */
    let Element = class Element extends _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_9__.MobxLitElement {
        constructor() {
            super(...arguments);
            this.selected = false;
            this.darkTheme = false;
            this.momentumStyle = false;
            this.popoverCount = null;
            this.uid = null;
            this.isImgLoaded = false;
            this.isImgError = false;
            this.onBtnClick = () => {
                this.dispatchEvent(new CustomEvent("selected", {
                    detail: {
                        item: this.item
                    }
                }));
            };
        }
        connectedCallback() {
            super.connectedCallback();
        }
        get label() {
            var _a, _b;
            return (_b = (_a = this.item) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : "";
        }
        get iconSize() {
            var _a, _b;
            return (_b = (_a = this.item) === null || _a === void 0 ? void 0 : _a.iconSize) !== null && _b !== void 0 ? _b : DEFAULT_ICON_SIZE;
        }
        get legacyIconSize() {
            var _a, _b;
            return (_b = (_a = this.item) === null || _a === void 0 ? void 0 : _a.iconSize) !== null && _b !== void 0 ? _b : DEFAULT_ICON_SIZE_LEGACY;
        }
        get iconName() {
            return this.momentumStyle && this.selected && this.item.iconActive ? this.item.iconActive : this.item.icon;
        }
        get isMomentum() {
            return this.item && this.item.iconType === "momentum";
        }
        get isImg() {
            return this.item && this.item.iconType === "other" && !!isImageUrl(this.item.icon);
        }
        get isMomentumDesignIconSet() {
            return this.item && this.item.iconType.toLowerCase() === "momentumdesign";
        }
        get btnCssClassInfo() {
            return {
                "nav-button__imaged": this.isImg,
                "nav-button__selected": this.selected,
                "nav-button__momentum": this.momentumStyle,
                "nav-button__visual-rebrand": _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__.themeManager.isVisualRebrandEnabled
            };
        }
        static get styles() {
            return _NavigationItem_scss__WEBPACK_IMPORTED_MODULE_6__["default"];
        }
        get buttonVariant() {
            if (!this.momentumStyle) {
                return undefined;
            }
            if (!this.selected) {
                return "tab";
            }
            return _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__.themeManager.isVisualRebrandEnabled ? "primary" : "tab";
        }
        get computedAriaLabel() {
            if (this.label.startsWith("app:")) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(this.label, this.label, { count: this.popoverCount ? this.popoverCount : 0 });
            }
            else if (this.label.includes("Feedback")) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:navigation.shareFeedback");
            }
            return this.label;
        }
        render() {
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-button
          id="navigation-item-${this.uid}"
          ariaHaspopup="false"
          ariaLabel=${this.computedAriaLabel}
          @click=${this.onBtnClick}
          ?hasRemoveStyle=${!this.momentumStyle}
          ?circle="${this.momentumStyle}"
          size="${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(this.momentumStyle ? "40" : undefined)}"
          variant="${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(this.buttonVariant)}"
          ?isActive=${this.selected}
          class="nav-button ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__.classMap)(this.btnCssClassInfo)}"
          role="link"
          aria-current=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(this.selected ? "page" : undefined)}
        >
          ${this.renderIcon()} ${this.item.taskBadge ? this.renderBadge() : null}
        </md-button>
      `;
        }
        renderBadge() {
            if (this.popoverCount) {
                return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
          <md-badge class="wc-unread-popover-count" color="unreadcount" id="wc-unread-popover-count">
            <span>${this.popoverCount}</span>
          </md-badge>
        `;
            }
            return "";
        }
        renderMomentumIcon() {
            if (this.isMomentumDesignIconSet) {
                return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
          <md-icon
            name="${this.iconName}"
            class="nav-button-content"
            size=${this.iconSize}
            iconSet="momentumDesign"
          ></md-icon>
        `;
            }
            const mdIconName = (0,_NavigationItemIconUtils__WEBPACK_IMPORTED_MODULE_7__.getMomentumDesignIconName)(this.iconName, this.selected, this.momentumStyle && !this.item.iconActive);
            if (mdIconName) {
                return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
          <md-icon
            name="${mdIconName}"
            class="nav-button-content"
            size=${this.iconSize}
            iconSet="momentumDesign"
          ></md-icon>
        `;
            }
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) ` <md-icon name="icon-${this.iconName}_${this.legacyIconSize}" class="nav-button-content"></md-icon> `;
        }
        renderIcon() {
            if (this.isMomentum || this.isMomentumDesignIconSet) {
                return this.renderMomentumIcon();
            }
            if (this.isImg) {
                return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
          <div
            class="nav-button-content ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__.classMap)({
                    hidden: this.isImgError,
                    "img-loading": !this.isImgError && !this.isImgLoaded
                })}"
          >
            <img
              src="${this.item.icon}"
              alt="${this.label}"
              style="${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_5__.styleMap)({
                    "max-height": `${this.iconSize}px`,
                    "max-width": `${this.iconSize}px`
                })}"
              @load="${() => {
                    this.isImgError = false;
                    this.isImgLoaded = true;
                }}"
              @error="${() => (this.isImgError = true)}"
            />
          </div>
          <md-icon
            name="icon-warning_20"
            title=${this.label}
            class="nav-button-content ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__.classMap)({ hidden: !this.isImgError })}"
          ></md-icon>
        `;
            }
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) ` <span>${this.label}</span> `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "item", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "selected", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "darkTheme", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "momentumStyle", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
    ], Element.prototype, "popoverCount", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
    ], Element.prototype, "uid", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isImgLoaded", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isImgError", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-navigation-item")
    ], Element);
    NavigationItem.Element = Element;
})(NavigationItem || (NavigationItem = {}));


/***/ }),

/***/ "./src/components/Navigation/comp/NavigationItemIconUtils.ts":
/*!*******************************************************************!*\
  !*** ./src/components/Navigation/comp/NavigationItemIconUtils.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getMomentumDesignIconName: () => (/* binding */ getMomentumDesignIconName)
/* harmony export */ });
const iconMap = {
    survey: "survey-bold",
    team: "meetings-team-bold",
    "team-active": "meetings-team-filled",
    home: "home-bold",
    "home-active": "home-filled",
    waveform: "noise-removal-bold",
    note: "notes-bold",
    analysis: "analysis-bold",
    "analysis-active": "analysis-filled",
    "view-list": "view-list-bold",
    "queue-contact": "queue-contact-bold",
    "help-circle": "help-circle-bold",
    "help-circle-active": "help-circle-filled",
    headset: "headset-bold",
    "headset-selected": "headset-filled",
    inbox: "inbox-bold"
};
const momentumDesignIconNames = new Set([
    ...Object.values(iconMap),
    "queue-contact-filled",
    "inbox-filled",
    "survey-filled"
]);
function getIconFilledName(name) {
    return iconMap[name] ? iconMap[name].replace("-bold", "-filled") : `${name}-filled`;
}
function getMomentumDesignIconName(name, isSelected, autoFillIcon) {
    //If an active icon is not configured and its momentum style
    //auto map to filled version of icon
    if (isSelected && autoFillIcon) {
        const filledName = getIconFilledName(name);
        if (momentumDesignIconNames.has(filledName)) {
            return filledName;
        }
    }
    if (iconMap[name]) {
        return iconMap[name];
    }
    //To allow for users to specify momentum design names
    if (momentumDesignIconNames.has(name)) {
        return name;
    }
    return undefined;
}


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/QualityMonitoring.scss":
/*!***********************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/QualityMonitoring.scss ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

:host {
  --grid-header-height: 60px;
  --visualizer-title-width: 100px;
  --visualizer-title-margin-left: 24px;
  --visualizer-container-max-height: 40px;
  --visualizer-container-max-width: 900px;
  --visualizer-container-gap: 16px;
  --visualizer-bar-max-width: 577px;
  --visualizer-bar-max-height: 4px;
  --player-controls-row-height: 50px;
  --player-controls-gap: 8px;
  --volume-popover-width: 180px;
  --volume-popover-height: 21px;
  --volume-popover-gap: 12px;
  --volume-popover-top-offset: 120%;
  --volume-popover-left-offset: 50%;
  --volume-popover-padding: 12px;
  --seek-bar-height: 8px;
  --seek-bar-thumb-size: 16px;
  --seek-bar-top-margin: 16px;
  --seek-bar-bottom-margin: 8px;
  --popover-arrow-size: 10px;
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --interaction-details-height: 220px;
  --interaction-details-vertical-padding: 12px;
  --interaction-details-optional-horizontal-margin: 24px;
  --interaction-details-item-bottom-margin: 4px;
  --interaction-details-item-grid-template-columns: 150px auto;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  --chapters-container-height: 292px;
  --chapters-container-height-no-border: 250px;
  --chapters-container-height-hidden-tabs: 350px;
  --chapters-container-height: 292px;
  --chapters-container-height-hidden-tabs-no-border: 300px;
  --chapters-container-padding-right: 18px;
  --chapter-container-padding-top: 5px;
  --chapter-container-padding-bottom: 12px;
  --chapter-time-width: 60px;
  --chapter-title-width: 300px;
  --transcript-height: 285px;
  --transcript-height-no-chapters: 410px;
  --transcript-height-chapters-no-consults: 350px;
}

.qm-wrapper {
  height: 100%;
}

.qm-grid-header {
  height: var(--grid-header-height);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=QualityMonitoring.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-services/dist/styles/z-index.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/variables.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/QualityMonitoring.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/QualityMonitoring.ts":
/*!*********************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/QualityMonitoring.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QualityMonitoringWidget: () => (/* binding */ QualityMonitoringWidget)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_EmptyGrid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./components/EmptyGrid */ "./src/components/QualityMonitoringWidget/components/EmptyGrid.ts");
/* harmony import */ var _components_evaluations_EvaluationViewer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./components/evaluations/EvaluationViewer */ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationViewer.ts");
/* harmony import */ var _components_GridError__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./components/GridError */ "./src/components/QualityMonitoringWidget/components/GridError.ts");
/* harmony import */ var _components_GridHeader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./components/GridHeader */ "./src/components/QualityMonitoringWidget/components/GridHeader.ts");
/* harmony import */ var _components_Recording__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./components/Recording */ "./src/components/QualityMonitoringWidget/components/Recording.ts");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./config */ "./src/components/QualityMonitoringWidget/config.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./constants */ "./src/components/QualityMonitoringWidget/constants.ts");
/* harmony import */ var _QualityMonitoring_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./QualityMonitoring.scss */ "./src/components/QualityMonitoringWidget/QualityMonitoring.scss");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./utils */ "./src/components/QualityMonitoringWidget/utils.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};














var QualityMonitoringWidget;
(function (QualityMonitoringWidget) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        constructor() {
            super(...arguments);
            this.isDarkMode = false;
            this.isLoggedIntoStation = false;
            this.isQMWShowConsultRecordingsEnabled = false;
            this.isRecordingsRicherMetadataEnabled = false;
            this.isRecordingTranscriptionEnabled = false;
            this.isAutoCsatEnabled = false;
            this.isGridEmpty = false;
            // filter defaults to the last 24 hour period
            this.startTime = luxon__WEBPACK_IMPORTED_MODULE_4__.DateTime.local().minus({ days: 1 }).toMillis();
            this.endTime = luxon__WEBPACK_IMPORTED_MODULE_4__.DateTime.local().minus({ seconds: 1 }).toMillis();
            this.hasError = false;
            this.trackingID = "";
            this.activeSessionId = "";
            this.activeAni = "";
            this.activeAgentName = "";
            this.queue = "";
            this.isModalOpen = false;
            this.modalOpenTime = 0;
            this.activeSessionStartTime = 0;
            this.gridOptions = {};
            this.evaluationData = null;
            this.onGridReady = (event) => {
                var _a;
                (_a = event.api) === null || _a === void 0 ? void 0 : _a.setGridOption("serverSideDatasource", this.createDatasource());
            };
            this.getGridConfigs = () => {
                return {
                    isAutoCsatEnabled: this.isAutoCsatEnabled
                };
            };
            this.createDatasource = () => {
                const getPage = (startRow = 0) => {
                    if (startRow && startRow !== 0) {
                        return startRow / _constants__WEBPACK_IMPORTED_MODULE_11__.MAX_ROWS_IN_RESPONSE;
                    }
                    else {
                        return startRow;
                    }
                };
                const fetchData = (params) => __awaiter(this, void 0, void 0, function* () {
                    const startTime = this.startTime;
                    const endTime = this.endTime;
                    const pageNumber = getPage(params.request.startRow);
                    const searchData = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.qmw.fetchTasks({ startTime, endTime, pageNumber });
                    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[App:QMW] Fetched tahoe data succesfully");
                    const taskData = searchData.data.task.tasks;
                    const pageInfoData = searchData.data.task.pageInfo;
                    this.setHasError(false);
                    this.setIsGridEmpty(taskData.length ? false : true);
                    if (pageInfoData.hasNextPage) {
                        params.success({ rowData: taskData });
                    }
                    else {
                        let rowCount = taskData.length;
                        if (pageNumber !== 0) {
                            const previousRowCount = pageNumber * _constants__WEBPACK_IMPORTED_MODULE_11__.MAX_ROWS_IN_RESPONSE;
                            rowCount = rowCount + previousRowCount;
                        }
                        params.success({ rowData: taskData, rowCount });
                    }
                });
                return {
                    getRows: (params) => __awaiter(this, void 0, void 0, function* () {
                        try {
                            yield fetchData(params);
                        }
                        catch (err) {
                            if ((0,_utils__WEBPACK_IMPORTED_MODULE_13__.errorIsRetryable)(err === null || err === void 0 ? void 0 : err.details)) {
                                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Failed to fetch tahoe data due to rate limit. Retrying`);
                                yield (0,_utils__WEBPACK_IMPORTED_MODULE_13__.wait)(err === null || err === void 0 ? void 0 : err.details);
                                yield fetchData(params);
                            }
                            else {
                                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[App:QMW] Failed to fetch tahoe data`);
                                params.fail();
                                this.setHasError(true);
                                this.setTrackingID((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.getTrackingIdFromErrorObject)(err));
                            }
                        }
                    })
                };
            };
        }
        get gridApi() {
            var _a;
            return (_a = this.gridWidget) === null || _a === void 0 ? void 0 : _a.getGridApi();
        }
        static get styles() {
            return _QualityMonitoring_scss__WEBPACK_IMPORTED_MODULE_12__["default"];
        }
        connectedCallback() {
            var _a;
            super.connectedCallback();
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.POST_INTERACTION_VISITED, {}, [
                (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.SERVICE_PROVIDERS) === null || _a === void 0 ? void 0 : _a.webex_behavioral
            ]);
            this.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_ERR_RETRY, this.handleErrorResetTry);
            this.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_ACTIONS_BTN_CLICK, this.handlePlayBtnClick);
            this.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_EVALUATE_BTN_CLICK, this.handleEvaluateBtnClick);
            this.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_RECORDINGS_MODAL_CLOSE_BTN_CLK, this.handleModalCloseClick);
            this.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_FILTERS_UPDATED, this.handleFiltersUpdated);
            this.initializeGrid();
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            this.getLocalFilters();
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_ERR_RETRY, this.handleErrorResetTry);
            this.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_ACTIONS_BTN_CLICK, this.handlePlayBtnClick);
            this.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_EVALUATE_BTN_CLICK, this.handleEvaluateBtnClick);
            this.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_RECORDINGS_MODAL_CLOSE_BTN_CLK, this.handleModalCloseClick);
            this.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__.QMW_FILTERS_UPDATED, this.handleFiltersUpdated);
        }
        getLocalFilters() {
            const storedFilters = JSON.parse(localStorage.getItem("qmwFilters") || "{}");
            if (Object.keys(storedFilters).length) {
                this.startTime = storedFilters.startTime;
                this.endTime = storedFilters.endTime;
            }
        }
        setLocalFilters() {
            localStorage.setItem("qmwFilters", JSON.stringify({
                startTime: this.startTime,
                endTime: this.endTime
            }));
        }
        getHasError() {
            return this.hasError;
        }
        setHasError(hasError) {
            this.hasError = hasError;
        }
        getIsGridEmpty() {
            return this.isGridEmpty;
        }
        setIsGridEmpty(isGridEmpty) {
            this.isGridEmpty = isGridEmpty;
        }
        getTrackingId() {
            return this.trackingID;
        }
        setTrackingID(trackingID) {
            this.trackingID = trackingID;
        }
        getActiveSessionId() {
            return this.activeSessionId;
        }
        setActiveSessionId(sessionId) {
            this.activeSessionId = sessionId;
        }
        getActiveAni() {
            return this.activeAni;
        }
        setActiveAni(ani) {
            this.activeAni = ani;
        }
        getActiveAgentName() {
            return this.activeAgentName;
        }
        setActiveAgentName(agentName) {
            this.activeAgentName = agentName;
        }
        setQueue(queueName) {
            this.queue = queueName;
        }
        getIsModalOpen() {
            return this.isModalOpen;
        }
        setIsModalOpen(isModalOpen) {
            var _a;
            this.isModalOpen = isModalOpen;
            if (isModalOpen) {
                this.modalOpenTime = Date.now();
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.PI_RECORDING_DETAILS_MODAL_CLOSED, [
                    (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.SERVICE_PROVIDERS) === null || _a === void 0 ? void 0 : _a.webex_behavioral
                ]);
            }
        }
        initializeGrid() {
            this.gridOptions = Object.assign(Object.assign({}, (0,_config__WEBPACK_IMPORTED_MODULE_10__.getBaseGridConfigs)(this.getGridConfigs)), { onGridReady: (e) => this.onGridReady(e) });
        }
        handleErrorResetTry() {
            this.setHasError(false);
            this.setTrackingID("");
        }
        handlePlayBtnClick(e) {
            var _a, _b, _c, _d, _e;
            this.setActiveSessionId((_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.sessionId);
            this.setActiveAni((_b = e === null || e === void 0 ? void 0 : e.detail) === null || _b === void 0 ? void 0 : _b.ani);
            this.setActiveAgentName((_c = e === null || e === void 0 ? void 0 : e.detail) === null || _c === void 0 ? void 0 : _c.agentName);
            this.setQueue((_d = e === null || e === void 0 ? void 0 : e.detail) === null || _d === void 0 ? void 0 : _d.queueName);
            this.activeSessionStartTime = (_e = e === null || e === void 0 ? void 0 : e.detail) === null || _e === void 0 ? void 0 : _e.activeSessionStartTime;
            this.setIsModalOpen(true);
        }
        handleModalCloseClick(e) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
            this.setActiveSessionId("");
            this.setActiveAni("");
            this.setActiveAgentName("");
            this.setQueue("");
            this.activeSessionStartTime = 0;
            this.setIsModalOpen(false);
            if ((_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.showEnhancedRecordings) {
                const fields = {
                    ["numCustomerChapters"]: (_b = e === null || e === void 0 ? void 0 : e.detail) === null || _b === void 0 ? void 0 : _b.numCustomerChapters,
                    ["numConsultChapters"]: (_c = e === null || e === void 0 ? void 0 : e.detail) === null || _c === void 0 ? void 0 : _c.numConsultChapters,
                    ["numMultiPartyConferences"]: (_d = e === null || e === void 0 ? void 0 : e.detail) === null || _d === void 0 ? void 0 : _d.numMultiPartyConferences,
                    ["hasDataFetchError"]: (_e = e === null || e === void 0 ? void 0 : e.detail) === null || _e === void 0 ? void 0 : _e.hasDataFetchError,
                    ["hasRecordingPlaybackError"]: (_f = e === null || e === void 0 ? void 0 : e.detail) === null || _f === void 0 ? void 0 : _f.hasRecordingPlaybackError,
                    ["chapterClickedTimes"]: (_g = e === null || e === void 0 ? void 0 : e.detail) === null || _g === void 0 ? void 0 : _g.chapterClickedTimes,
                    ["visualizerClickedTimes"]: (_h = e === null || e === void 0 ? void 0 : e.detail) === null || _h === void 0 ? void 0 : _h.visualizerClickedTimes,
                    ["seekBarChangedTimes"]: (_j = e === null || e === void 0 ? void 0 : e.detail) === null || _j === void 0 ? void 0 : _j.seekBarChangedTimes,
                    ["volumeControlChangedTimes"]: (_k = e === null || e === void 0 ? void 0 : e.detail) === null || _k === void 0 ? void 0 : _k.volumeControlChangedTimes,
                    ["playbackRateControlChangedTimes"]: (_l = e === null || e === void 0 ? void 0 : e.detail) === null || _l === void 0 ? void 0 : _l.playbackRateControlChangedTimes,
                    ["playClickedTimes"]: (_m = e === null || e === void 0 ? void 0 : e.detail) === null || _m === void 0 ? void 0 : _m.playClickedTimes,
                    ["transcriptAvailable"]: (_o = e === null || e === void 0 ? void 0 : e.detail) === null || _o === void 0 ? void 0 : _o.transcriptAvailable,
                    ["hasTranscriptError"]: (_p = e === null || e === void 0 ? void 0 : e.detail) === null || _p === void 0 ? void 0 : _p.hasTranscriptError,
                    ["transcriptErrorMessage"]: (_q = e === null || e === void 0 ? void 0 : e.detail) === null || _q === void 0 ? void 0 : _q.transcriptErrorMessage,
                    ["transcriptChapterClickedTimes"]: (_r = e === null || e === void 0 ? void 0 : e.detail) === null || _r === void 0 ? void 0 : _r.transcriptChapterClickedTimes
                };
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.PI_RECORDING_DETAILS_MODAL_CLOSED, fields, [
                    (_s = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.SERVICE_PROVIDERS) === null || _s === void 0 ? void 0 : _s.webex_behavioral
                ]);
            }
        }
        handleEvaluateBtnClick(event) {
            this.evaluationData = event === null || event === void 0 ? void 0 : event.detail;
        }
        handleFiltersUpdated(e) {
            var _a, _b, _c, _d;
            this.startTime = (_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.startTime;
            this.endTime = (_b = e === null || e === void 0 ? void 0 : e.detail) === null || _b === void 0 ? void 0 : _b.endTime;
            this.setLocalFilters();
            (_c = this.gridApi) === null || _c === void 0 ? void 0 : _c.onFilterChanged();
            this.gridOptions = Object.assign({}, this.gridOptions);
            const totalTimeInSeconds = (this.endTime - this.startTime) / 1000;
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.PI_TIME_FILTER_SELECTED, {
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.PI_TIME_FILTER_DURATION_SELECTED]: totalTimeInSeconds
            }, [(_d = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.webex_behavioral]);
        }
        renderComponent() {
            if (this.hasError) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
          <agentx-wc-qmw-grid-error .trackingID=${this.trackingID} .errorElement=${_constants__WEBPACK_IMPORTED_MODULE_11__.GRID}></agentx-wc-qmw-grid-error>
        `;
            }
            else if (this.isGridEmpty) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <agentx-wc-qmw-empty-grid .emptyElement=${_constants__WEBPACK_IMPORTED_MODULE_11__.GRID}></agentx-wc-qmw-empty-grid> `;
            }
            else {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
          ${!this.evaluationData
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                <agentx-wc-ag-grid
                  .gridOptions=${this.gridOptions}
                  .isDarkMode=${this.isDarkMode}
                  .isLoggedIntoStation=${this.isLoggedIntoStation}
                ></agentx-wc-ag-grid>
              `
                    : (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                <agentx-wc-evaluation-viewer
                  @clear-evaluation-data=${this.clearEvaluationData}
                  .evaluationData=${this.evaluationData}
                ></agentx-wc-evaluation-viewer>
              `}
        `;
            }
        }
        clearEvaluationData() {
            // wip - this is logically done by the viewer but the parent can have knowledge of the state
            this.evaluationData = null;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="qm-wrapper">
          ${!this.evaluationData
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                <agentx-wc-qmw-filter-header
                  .startDate=${this.startTime}
                  .endDate=${this.endTime}
                ></agentx-wc-qmw-filter-header>
              `
                : ""}
          ${this.renderComponent()}
          <agentx-wc-qmw-recording-details
            .sessionId=${this.activeSessionId}
            .ani=${this.activeAni}
            .queue=${this.queue}
            .agentName=${this.activeAgentName}
            .isModalOpen=${this.isModalOpen}
            .startTimeFromGrid=${this.activeSessionStartTime}
            .showConsultRecordings=${this.isQMWShowConsultRecordingsEnabled}
            .showEnhancedRecordings=${this.isRecordingsRicherMetadataEnabled}
            .showTranscript=${this.isRecordingTranscriptionEnabled}
          ></agentx-wc-qmw-recording-details>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)("#agentx-wc-qm-grid-container")
    ], Element.prototype, "_gridDiv", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isDarkMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isLoggedIntoStation", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isQMWShowConsultRecordingsEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isRecordingsRicherMetadataEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isRecordingTranscriptionEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isAutoCsatEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isGridEmpty", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "startTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "endTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "hasError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "trackingID", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "activeSessionId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "activeAni", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "activeAgentName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "queue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "modalOpenTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "activeSessionStartTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "gridOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "evaluationData", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)("agentx-wc-ag-grid")
    ], Element.prototype, "gridWidget", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-quality-monitoring-grid")
    ], Element);
    QualityMonitoringWidget.Element = Element;
})(QualityMonitoringWidget || (QualityMonitoringWidget = {}));


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/ActionsRenderer.ts":
/*!******************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/ActionsRenderer.ts ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ActionsRenderer)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants */ "./src/components/QualityMonitoringWidget/constants.ts");


class ActionsRenderer {
    constructor() {
        this.eGui = document.createElement("div");
    }
    renderActionBtns(params) {
        var _a, _b;
        const actions = [
            {
                className: "qmw-play__btn",
                icon: "play-regular",
                tooltip: (_a = params.colDef) === null || _a === void 0 ? void 0 : _a.cellEditorParams.i18n.playRecording,
                eventName: _constants__WEBPACK_IMPORTED_MODULE_1__.QMW_ACTIONS_BTN_CLICK,
                handler: () => {
                    var _a, _b, _c, _d, _e, _f;
                    return ({
                        sessionId: (_a = params.data) === null || _a === void 0 ? void 0 : _a.id,
                        ani: (_b = params.data) === null || _b === void 0 ? void 0 : _b.origin,
                        agentName: (_c = params.data) === null || _c === void 0 ? void 0 : _c.owner.name,
                        activeSessionStartTime: (_d = params.data) === null || _d === void 0 ? void 0 : _d.createdTime,
                        queueName: (_f = (_e = params.data) === null || _e === void 0 ? void 0 : _e.lastQueue) === null || _f === void 0 ? void 0 : _f.name
                    });
                },
                shouldRender: true
            },
            {
                className: "qmw-evaluate__btn",
                icon: "webinar-light",
                tooltip: (_b = params.colDef) === null || _b === void 0 ? void 0 : _b.cellEditorParams.i18n.evaluateTask,
                eventName: _constants__WEBPACK_IMPORTED_MODULE_1__.QMW_EVALUATE_BTN_CLICK,
                handler: () => {
                    var _a, _b, _c, _d, _e, _f, _g;
                    return ({
                        sessionId: (_a = params.data) === null || _a === void 0 ? void 0 : _a.id,
                        ani: (_b = params.data) === null || _b === void 0 ? void 0 : _b.origin,
                        agentName: (_c = params.data) === null || _c === void 0 ? void 0 : _c.owner.name,
                        activeSessionStartTime: (_d = params.data) === null || _d === void 0 ? void 0 : _d.createdTime,
                        queueName: (_f = (_e = params.data) === null || _e === void 0 ? void 0 : _e.lastQueue) === null || _f === void 0 ? void 0 : _f.name,
                        interactionId: (_g = params.data) === null || _g === void 0 ? void 0 : _g.taskId
                    });
                },
                shouldRender: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.featureflag.isWxccDesktopQMEvaluationsEnabled()
            }
        ];
        const filteredActions = actions.filter((action) => action.shouldRender);
        this.eGui.classList.add("qmw-actions-cell");
        this.eGui.innerHTML = filteredActions
            .map((action) => `
      <md-tooltip message="${action.tooltip}" placement="bottom">
        <button class="md-button--none qmw-actions-btn ${action.className}" aria-label="${action.tooltip}">
          <md-icon
            slot="icon"
            name="${action.icon}"
            iconSet="momentumDesign"
            size="16"
            ></md-icon>
        </button>
      </md-tooltip>
    `)
            .join("");
        actions.forEach((action) => {
            const btn = this.eGui.querySelector(`.${action.className}`);
            const handleClick = () => {
                btn === null || btn === void 0 ? void 0 : btn.dispatchEvent(new CustomEvent(action.eventName, {
                    bubbles: true,
                    composed: true,
                    detail: action.handler()
                }));
            };
            btn === null || btn === void 0 ? void 0 : btn.addEventListener("click", handleClick);
            btn === null || btn === void 0 ? void 0 : btn.addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                    handleClick();
                }
            });
        });
    }
    init(params) {
        this.renderActionBtns(params);
    }
    refresh(params) {
        this.renderActionBtns(params);
        return true;
    }
    getGui() {
        return this.eGui;
    }
    destroy() {
        this.eGui.remove();
    }
}


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/AudioPlayer.scss":
/*!****************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/AudioPlayer.scss ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  --grid-header-height: 60px;
  --visualizer-title-width: 100px;
  --visualizer-title-margin-left: 24px;
  --visualizer-container-max-height: 40px;
  --visualizer-container-max-width: 900px;
  --visualizer-container-gap: 16px;
  --visualizer-bar-max-width: 577px;
  --visualizer-bar-max-height: 4px;
  --player-controls-row-height: 50px;
  --player-controls-gap: 8px;
  --volume-popover-width: 180px;
  --volume-popover-height: 21px;
  --volume-popover-gap: 12px;
  --volume-popover-top-offset: 120%;
  --volume-popover-left-offset: 50%;
  --volume-popover-padding: 12px;
  --seek-bar-height: 8px;
  --seek-bar-thumb-size: 16px;
  --seek-bar-top-margin: 16px;
  --seek-bar-bottom-margin: 8px;
  --popover-arrow-size: 10px;
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --interaction-details-height: 220px;
  --interaction-details-vertical-padding: 12px;
  --interaction-details-optional-horizontal-margin: 24px;
  --interaction-details-item-bottom-margin: 4px;
  --interaction-details-item-grid-template-columns: 150px auto;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  --chapters-container-height: 292px;
  --chapters-container-height-no-border: 250px;
  --chapters-container-height-hidden-tabs: 350px;
  --chapters-container-height: 292px;
  --chapters-container-height-hidden-tabs-no-border: 300px;
  --chapters-container-padding-right: 18px;
  --chapter-container-padding-top: 5px;
  --chapter-container-padding-bottom: 12px;
  --chapter-time-width: 60px;
  --chapter-title-width: 300px;
  --transcript-height: 285px;
  --transcript-height-no-chapters: 410px;
  --transcript-height-chapters-no-consults: 350px;
}

.controls-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: var(--player-controls-row-height);
}

.player-controls {
  display: flex;
  flex: 1;
  align-items: center;
  gap: var(--player-controls-gap);
}

.playback-controls {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.player-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  background-color: var(--md-primary-bg-color);
  border-radius: 4px;
  border: 1px solid var(--md-gray-20);
}

.audio-player-transcript-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  background-color: var(--md-primary-bg-color);
}
.audio-player-transcript-container .audio-player-tabs-view-container {
  padding-left: 4px;
}

.row {
  display: flex;
}

.column {
  flex: 1;
  width: 45%;
  margin: 5px;
}

li {
  list-style-type: none;
}

.controls-seekbar-container {
  display: block;
  padding-inline-end: 3em;
  width: -webkit-fill-available;
}

.controls-seekbar-container.consult-chapters {
  margin-inline-start: 11.4em;
}

.controls-seekbar-container.no-consult-chapters {
  margin-inline-start: 2.4em;
}

.chapter-manager {
  display: none;
}

md-slider {
  padding-top: var(--seek-bar-top-margin);
  padding-bottom: var(--seek-bar-bottom-margin);
}

.interaction-details.with-margin {
  margin: 0 var(--interaction-details-optional-horizontal-margin);
}

.audio-player-transcript-view {
  max-height: var(--transcript-height);
}
.audio-player-transcript-view.no-chapters {
  max-height: var(--transcript-height-no-chapters);
}
.audio-player-transcript-view.chapters-no-consults {
  max-height: var(--transcript-height-chapters-no-consults);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=AudioPlayer.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/variables.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/components/AudioPlayer.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/AudioPlayer.ts":
/*!**************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/AudioPlayer.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AudioPlayer: () => (/* binding */ AudioPlayer),
/* harmony export */   AudioPlayerControlClicked: () => (/* binding */ AudioPlayerControlClicked)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils */ "./src/components/QualityMonitoringWidget/utils.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./../constants */ "./src/components/QualityMonitoringWidget/constants.ts");
/* harmony import */ var _AudioPlayer_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./AudioPlayer.scss */ "./src/components/QualityMonitoringWidget/components/AudioPlayer.scss");
/* harmony import */ var _player_ChapterManager__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./player/ChapterManager */ "./src/components/QualityMonitoringWidget/components/player/ChapterManager.ts");
/* harmony import */ var _player_ChaptersListView__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./player/ChaptersListView */ "./src/components/QualityMonitoringWidget/components/player/ChaptersListView.ts");
/* harmony import */ var _player_InteractionDetailsView__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./player/InteractionDetailsView */ "./src/components/QualityMonitoringWidget/components/player/InteractionDetailsView.ts");
/* harmony import */ var _player_PlaybackRateView__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./player/PlaybackRateView */ "./src/components/QualityMonitoringWidget/components/player/PlaybackRateView.ts");
/* harmony import */ var _player_PlayerTime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./player/PlayerTime */ "./src/components/QualityMonitoringWidget/components/player/PlayerTime.ts");
/* harmony import */ var _player_TranscriptView__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./player/TranscriptView */ "./src/components/QualityMonitoringWidget/components/player/TranscriptView.ts");
/* harmony import */ var _player_VisualizerView__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./player/VisualizerView */ "./src/components/QualityMonitoringWidget/components/player/VisualizerView.ts");
/* harmony import */ var _player_VolumeControlView__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./player/VolumeControlView */ "./src/components/QualityMonitoringWidget/components/player/VolumeControlView.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
















var SeekDirection;
(function (SeekDirection) {
    SeekDirection["FORWARD"] = "forward";
    SeekDirection["BACKWARD"] = "backward";
})(SeekDirection || (SeekDirection = {}));
const ONE_SECOND_IN_MILLIS = 1000;
const TICK_INTERVAL_DEFAULT = 100;
var AudioPlayerControlClicked;
(function (AudioPlayerControlClicked) {
    AudioPlayerControlClicked[AudioPlayerControlClicked["CHAPTER_CLICKED"] = 0] = "CHAPTER_CLICKED";
    AudioPlayerControlClicked[AudioPlayerControlClicked["VISUALIZER_CLICKED"] = 1] = "VISUALIZER_CLICKED";
    AudioPlayerControlClicked[AudioPlayerControlClicked["SEEK_BAR_CHANGED"] = 2] = "SEEK_BAR_CHANGED";
    AudioPlayerControlClicked[AudioPlayerControlClicked["VOLUME_CONTROL_CHANGED"] = 3] = "VOLUME_CONTROL_CHANGED";
    AudioPlayerControlClicked[AudioPlayerControlClicked["PLAYBACK_RATE_CONTROL_CHANGED"] = 4] = "PLAYBACK_RATE_CONTROL_CHANGED";
    AudioPlayerControlClicked[AudioPlayerControlClicked["PLAY_CLICKED"] = 5] = "PLAY_CLICKED";
    AudioPlayerControlClicked[AudioPlayerControlClicked["TRANSCRIPT_CLICKED"] = 6] = "TRANSCRIPT_CLICKED";
})(AudioPlayerControlClicked || (AudioPlayerControlClicked = {}));
/**
 * @element agentx-wc-audio-player
 */
let AudioPlayer = class AudioPlayer extends lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement {
    constructor() {
        super(...arguments);
        this.customerChapters = [];
        this.consultChapters = [];
        this.interactionDetailInfo = new Map();
        this.agentName = "";
        this.transcriptAvailable = false;
        this.currentTime = 0;
        this.playPauseIcon = "icon-play_16";
        this.playbackRate = 1;
        this.tickInterval = 100;
        this.isSeeking = false;
        this.transcriptSeekTime = 0;
    }
    static get styles() {
        return _AudioPlayer_scss__WEBPACK_IMPORTED_MODULE_7__["default"];
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.interactionRecordingDetails !== undefined) {
            this.chapterManager = new _player_ChapterManager__WEBPACK_IMPORTED_MODULE_8__.ChapterManager(this.interactionRecordingDetails, this.customerChapters, this.consultChapters);
            this.chapterManager.registerCallback(this);
            this.currentChapter = this.chapterManager.getCustomerChapters()[0];
        }
    }
    getChapterManager() {
        return this.chapterManager;
    }
    dispatchControlClickedEvent(control) {
        this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_6__.QMW_AUDIO_PLAYER_CONTROL_CLICKED, { bubbles: true, composed: true, detail: { control } }));
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.onStop();
    }
    handleChapterClicked(event) {
        const isCustomerTrackType = (0,_utils__WEBPACK_IMPORTED_MODULE_5__.isCustomerTrack)(event.detail[1]);
        const clickedChapter = isCustomerTrackType
            ? this.chapterManager.getCustomerChapters()[event.detail[0]]
            : this.chapterManager.getConsultChapters()[event.detail[0]];
        if (clickedChapter !== this.currentChapter) {
            this.chapterManager.setCustomerWaveformSelected(clickedChapter.getIsCustomerChapter(), clickedChapter.startTimeMillis);
        }
        this.chapterManager.seek(clickedChapter.startTimeMillis);
        this.dispatchControlClickedEvent(AudioPlayerControlClicked.CHAPTER_CLICKED);
    }
    handleTranscriptClicked(event) {
        this.chapterManager.setCustomerWaveformSelected(true, event.detail.milliseconds);
        this.chapterManager.seek(event.detail.milliseconds);
        this.dispatchControlClickedEvent(AudioPlayerControlClicked.TRANSCRIPT_CLICKED);
    }
    handleVisualizerClicked(event) {
        this.chapterManager.setCustomerWaveformSelected(event.detail, this.currentTime);
        this.dispatchControlClickedEvent(AudioPlayerControlClicked.VISUALIZER_CLICKED);
    }
    handleSeekBarChanged(event) {
        this.chapterManager.seek(event.detail.newValue * ONE_SECOND_IN_MILLIS);
        this.dispatchControlClickedEvent(AudioPlayerControlClicked.SEEK_BAR_CHANGED);
    }
    handleVolumeControlChanged(event) {
        this.handleVolumeChanged(event.detail);
        this.dispatchControlClickedEvent(AudioPlayerControlClicked.VOLUME_CONTROL_CHANGED);
    }
    handlePlaybackRateControlChanged(event) {
        this.handlePlaybackRateChanged(event.detail);
        this.dispatchControlClickedEvent(AudioPlayerControlClicked.PLAYBACK_RATE_CONTROL_CHANGED);
    }
    handlePlayClicked() {
        const audioPlayers = this.getAudioPlayers();
        if (audioPlayers.length === 0) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.warn("[App:QMW] No audio players available to play.");
            return;
        }
        if (this.chapterManager.isRunning()) {
            this.chapterManager.stop();
        }
        else {
            this.chapterManager.start();
        }
        this.dispatchControlClickedEvent(AudioPlayerControlClicked.PLAY_CLICKED);
    }
    getAudioPlayers() {
        var _a, _b;
        return (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll("audio")) !== null && _b !== void 0 ? _b : [];
    }
    handlePlaybackRateChanged(speed) {
        this.playbackRate = speed;
        this.chapterManager.setPlaybackRate(speed);
        const audioPlayers = this.getAudioPlayers();
        audioPlayers.forEach((audioPlayer) => {
            audioPlayer.playbackRate = this.playbackRate;
        });
        this.tickInterval = TICK_INTERVAL_DEFAULT * this.playbackRate;
    }
    handleVolumeChanged(volume) {
        const audioPlayers = this.getAudioPlayers();
        audioPlayers.forEach((audioPlayer) => {
            audioPlayer.volume = volume / 100;
        });
    }
    seekTenSeconds(direction) {
        const tenSecondsInMilliseconds = 10 * ONE_SECOND_IN_MILLIS;
        this.chapterManager.seek(this.chapterManager.getCurrentTime() +
            (direction === SeekDirection.FORWARD ? tenSecondsInMilliseconds : -tenSecondsInMilliseconds));
    }
    getAudioPlayer(url) {
        const audioPlayers = this.getAudioPlayers();
        return Array.from(audioPlayers.values()).find((audioPlayer) => {
            return audioPlayer.id === url;
        });
    }
    playTrack(timeMillis) {
        var _a, _b;
        const targetChapter = this.chapterManager.getChapterByTime(timeMillis);
        const currentAudioPlayer = this.getCurrentlyPlayingAudioPlayer();
        const audioPlayer = this.getAudioPlayer((_a = targetChapter === null || targetChapter === void 0 ? void 0 : targetChapter.getDownloadUrl()) !== null && _a !== void 0 ? _a : "");
        if (audioPlayer && ((currentAudioPlayer === null || currentAudioPlayer === void 0 ? void 0 : currentAudioPlayer.src) !== audioPlayer.src || this.isSeeking)) {
            audioPlayer.currentTime = (timeMillis - ((_b = targetChapter === null || targetChapter === void 0 ? void 0 : targetChapter.getStartTimeInAudioFile()) !== null && _b !== void 0 ? _b : 0)) / ONE_SECOND_IN_MILLIS;
            const playPromise = audioPlayer.play();
            if (playPromise !== undefined) {
                playPromise
                    .then(function () {
                    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] QMW recording playback started`);
                })
                    .catch(function (error) {
                    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[App:QMW] exception while attempting to start playing the audio file ${error}`);
                });
            }
        }
        this.timeoutTimer = setInterval(() => {
            var _a, _b, _c;
            const mostCurrentAudioPlayer = this.getCurrentlyPlayingAudioPlayer();
            if (mostCurrentAudioPlayer === undefined) {
                const targetTime = this.chapterManager.getCurrentTime() + this.tickInterval;
                if (targetTime > ((_b = (_a = this.interactionRecordingDetails) === null || _a === void 0 ? void 0 : _a.endTimeMillis) !== null && _b !== void 0 ? _b : 0)) {
                    this.chapterManager.stop();
                    return;
                }
                this.chapterManager.audioPlayerTick(targetTime);
            }
            else {
                this.chapterManager.audioPlayerTick(mostCurrentAudioPlayer.currentTime * ONE_SECOND_IN_MILLIS + ((_c = targetChapter === null || targetChapter === void 0 ? void 0 : targetChapter.getStartTimeInAudioFile()) !== null && _c !== void 0 ? _c : 0));
            }
        }, this.tickInterval);
    }
    stopAllTracks() {
        if (this.timeoutTimer) {
            clearInterval(this.timeoutTimer);
        }
        const audioPlayers = this.getAudioPlayers();
        audioPlayers.forEach((audioPlayer) => {
            audioPlayer.pause();
        });
    }
    getPlayerAndPlay(chapterUrlToPlay = "") {
        const currentAudioPlayer = this.getCurrentlyPlayingAudioPlayer();
        const nextAudioPlayer = this.getAudioPlayer(chapterUrlToPlay);
        if (currentAudioPlayer !== undefined && currentAudioPlayer !== nextAudioPlayer) {
            this.stopAllTracks();
        }
        else if (this.timeoutTimer) {
            clearInterval(this.timeoutTimer);
        }
        this.playTrack(this.chapterManager.getCurrentTime());
    }
    getCurrentlyPlayingAudioPlayer() {
        const audioPlayers = this.getAudioPlayers();
        return Array.from(audioPlayers.values()).find((audioPlayer) => {
            return !audioPlayer.paused;
        });
    }
    // implement IChapterManagerCallback::onChapterChanged
    onChapterChanged(chapter) {
        var _a;
        this.currentChapter = chapter;
        if (!chapter) {
            this.stopAllTracks();
        }
        if (!this.chapterManager.isRunning()) {
            return;
        }
        this.getPlayerAndPlay((_a = chapter === null || chapter === void 0 ? void 0 : chapter.getDownloadUrl()) !== null && _a !== void 0 ? _a : "");
    }
    // implement IChapterManagerCallback::onTick
    onTick(time) {
        this.currentTime = time;
    }
    // implement IChapterManagerCallback::onSeek
    onSeek(time) {
        this.currentTime = time;
        this.transcriptSeekTime = time;
        if (!this.chapterManager.isRunning()) {
            return;
        }
        const chapterToPlay = this.chapterManager.getChapterByTime(time);
        this.isSeeking = true;
        this.getPlayerAndPlay(chapterToPlay === null || chapterToPlay === void 0 ? void 0 : chapterToPlay.getDownloadUrl());
        this.isSeeking = false;
    }
    // implement IChapterManagerCallback::onStart
    onStart(time) {
        this.playPauseIcon = "icon-pause_16";
        this.playTrack(time);
    }
    // implement IChapterManagerCallback::onStop
    onStop() {
        this.playPauseIcon = "icon-play_16";
        this.stopAllTracks();
    }
    displayMinimalView() {
        return this.chapterManager.getCustomerChapters().length <= 1;
    }
    displayLargerTranscriptView() {
        return this.chapterManager.getConsultChapters().length === 0 && !this.displayMinimalView();
    }
    getAudioPlayerComponent() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div class="player-container">
        <agentx-wc-visualizer-view
          ?hidden=${this.displayMinimalView()}
          .customerChapters=${this.chapterManager.getCustomerChapters()}
          .consultChapters=${this.chapterManager.getConsultChapters()}
          .currentChapter=${this.currentChapter}
          .mainChapterLength=${(_b = (_a = this.interactionRecordingDetails) === null || _a === void 0 ? void 0 : _a.getDuration()) !== null && _b !== void 0 ? _b : 0}
          @visualizer-clicked=${this.handleVisualizerClicked}
        ></agentx-wc-visualizer-view>

        <div
          class="controls-seekbar-container ${this.chapterManager.getConsultChapters().length > 0
            ? "consult-chapters"
            : "no-consult-chapters"}"
        >
          <md-slider
            @slider-changing=${this.handleSeekBarChanged}
            aria-Label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.seekBar")}
            hide-value="false"
            now=${this.currentTime / ONE_SECOND_IN_MILLIS}
            max=${((_d = (_c = this.interactionRecordingDetails) === null || _c === void 0 ? void 0 : _c.getDuration()) !== null && _d !== void 0 ? _d : 0) / ONE_SECOND_IN_MILLIS}
            .step="0.1"
          ></md-slider>

          <div class="controls-row">
            <div class="chapter-manager">
              ${this.chapterManager
            .getAudioUrls()
            .map((url) => (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) ` <audio src=${url} preload="metadata" id=${url} controls></audio> `)}
            </div>

            <div class="player-controls">
              <md-tooltip
                message="${this.chapterManager.isRunning() ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPauseBtn") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPlayBtn")}"
                placement="top-end"
              >
                <md-button
                  variant="ghost"
                  circle
                  id="playerPlayButton"
                  aria-Label="${this.chapterManager.isRunning()
            ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPauseBtn")
            : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPlayBtn")}"
                  size=${_constants__WEBPACK_IMPORTED_MODULE_6__.QMW_RECORDINGS_PLAYER_BUTTON_SIZE}
                  @click=${this.handlePlayClicked}
                >
                  <md-icon slot="icon" name="${this.playPauseIcon}"></md-icon>
                </md-button>
              </md-tooltip>
              <agentx-wc-audio-player-time
                .currentTime=${this.currentTime}
                .mainChapterLength=${(_f = (_e = this.interactionRecordingDetails) === null || _e === void 0 ? void 0 : _e.getDuration()) !== null && _f !== void 0 ? _f : 0}
              ></agentx-wc-audio-player-time>
              <div class="skip-time-container">
                <md-tooltip message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.rewind10")}" placement="top">
                  <md-button
                    variant="ghost"
                    circle
                    id="playerRewind10SecondsButton"
                    aria-Label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.rewindTenSeconds")}
                    size=${_constants__WEBPACK_IMPORTED_MODULE_6__.QMW_RECORDINGS_PLAYER_BUTTON_SIZE}
                    .disabled=${this.currentTime <= 0}
                    @click=${(event) => {
            this.currentTime <= 0 ? event.preventDefault() : this.seekTenSeconds(SeekDirection.BACKWARD);
        }}
                  >
                    <md-icon name="rewind-ten-sec-bold" class="icon" size="20" iconSet="momentumDesign"></md-icon>
                  </md-button>
                </md-tooltip>
                <md-tooltip message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.fastForward10")}" placement="top">
                  <md-button
                    variant="ghost"
                    circle
                    id="playerForward10SecondsButton"
                    aria-Label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.fastForward10")}
                    size=${_constants__WEBPACK_IMPORTED_MODULE_6__.QMW_RECORDINGS_PLAYER_BUTTON_SIZE}
                    .disabled=${this.currentTime >= ((_h = (_g = this.interactionRecordingDetails) === null || _g === void 0 ? void 0 : _g.getDuration()) !== null && _h !== void 0 ? _h : 0)}
                    @click=${(event) => {
            var _a, _b;
            this.currentTime >= ((_b = (_a = this.interactionRecordingDetails) === null || _a === void 0 ? void 0 : _a.getDuration()) !== null && _b !== void 0 ? _b : 0)
                ? event.preventDefault()
                : this.seekTenSeconds(SeekDirection.FORWARD);
        }}
                  >
                    <md-icon name="forward-ten-sec-bold" class="icon" size="20" iconSet="momentumDesign"></md-icon>
                  </md-button>
                </md-tooltip>
              </div>
              <agentx-wc-audio-player-playback-rate-control
                @playback-rate-changed=${this.handlePlaybackRateControlChanged}
                .playbackRate=${this.playbackRate}
              >
              </agentx-wc-audio-player-playback-rate-control>
              <div class="skip-chapter-container" ?hidden=${this.displayMinimalView()}>
                <md-tooltip message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.previousChapter")}" placement="top">
                  <md-button
                    variant="ghost"
                    circle
                    id="playerPreviousChapterButton"
                    aria-Label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.previousChapter")}
                    size=${_constants__WEBPACK_IMPORTED_MODULE_6__.QMW_RECORDINGS_PLAYER_BUTTON_SIZE}
                    .disabled=${!this.chapterManager.isPreviousChapterAvailable()}
                    @click=${() => {
            if (this.chapterManager.isPreviousChapterAvailable()) {
                this.chapterManager.seekToPreviousChapter();
            }
        }}
                  >
                    <md-icon name="arrow-left-bold" class="icon" size="20" iconSet="momentumDesign"></md-icon>
                  </md-button>
                </md-tooltip>
                <md-tooltip message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.nextChapter")}" placement="top">
                  <md-button
                    variant="ghost"
                    circle
                    id="playerNextChapterButton"
                    aria-Label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.nextChapter")}
                    size=${_constants__WEBPACK_IMPORTED_MODULE_6__.QMW_RECORDINGS_PLAYER_BUTTON_SIZE}
                    .disabled=${this.chapterManager.getNextChapter() === undefined}
                    @click=${() => {
            if (this.chapterManager.getNextChapter() !== undefined) {
                this.chapterManager.seekToNextChapter();
            }
        }}
                  >
                    <md-icon name="arrow-right-bold" class="icon" size="20" iconSet="momentumDesign"></md-icon>
                  </md-button>
                </md-tooltip>
              </div>
              <agentx-wc-audio-player-volume-control @volume-changed=${this.handleVolumeControlChanged}>
              </agentx-wc-audio-player-volume-control>
            </div>
          </div>
        </div>
      </div>
    `;
    }
    getChapterListComponent() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
      <agentx-wc-chapters-list
        .customerChapters=${this.chapterManager.getCustomerChapters()}
        .consultChapters=${this.chapterManager.getConsultChapters()}
        .currentChapter=${this.currentChapter}
        .mainChapter=${this.chapterManager.getInteractionRecordingDetails()}
        .agentName=${this.agentName}
        .transcriptAvailable=${this.transcriptAvailable}
        @chapter-clicked=${this.handleChapterClicked}
      ></agentx-wc-chapters-list>
    `;
    }
    getTranscriptComponent() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `<agentx-wc-transcript-view
      .customerTranscript=${this.customerTranscript}
      @transcript-clicked=${this.handleTranscriptClicked}
      .playbackTime=${this.currentTime}
      .seekTime=${this.transcriptSeekTime}
    ></agentx-wc-transcript-view>`;
    }
    getInteractionDetailsComponent() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
      <agentx-wc-interaction-details
        .interactionDetailInfo=${this.interactionDetailInfo}
      ></agentx-wc-interaction-details>
    `;
    }
    render() {
        if (!this.interactionRecordingDetails) {
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[App:QMW] Interaction record details not defined, cannot initialize chapters");
        }
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) ` ${this.interactionRecordingDetails
            ? (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
          <div class="audio-player-transcript-container">
            ${this.getAudioPlayerComponent()}
            ${this.transcriptAvailable
                ? (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
                  <div class="audio-player-tabs-view-container">
                    <md-tabs>
                      ${this.displayMinimalView()
                    ? lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing
                    : (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
                            <md-tab slot="tab" aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.chapters")}>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.chapters")}</md-tab>
                            <md-tab-panel class="panel-view" slot="panel">
                              ${this.getChapterListComponent()}
                            </md-tab-panel>
                          `}
                      <md-tab slot="tab" aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.transcript")}>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.transcript")}</md-tab>
                      <md-tab-panel
                        class="audio-player-transcript-view ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)({
                    "no-chapters": this.displayMinimalView(),
                    "chapters-no-consults": this.displayLargerTranscriptView()
                })}"
                        slot="panel"
                      >
                        ${this.getTranscriptComponent()}
                      </md-tab-panel>
                      <md-tab slot="tab" aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.interactionDetailsHeader")}
                        >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.interactionDetailsHeader")}</md-tab
                      >
                      <md-tab-panel
                        slot="panel"
                        class="audio-player-interactions-view ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)({ "no-chapters": this.displayMinimalView() })}"
                      >
                        ${this.getInteractionDetailsComponent()}
                      </md-tab-panel>
                    </md-tabs>
                  </div>
                `
                : (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
                  <div class="row">
                    <div class="column" ?hidden=${this.displayMinimalView()}>${this.getChapterListComponent()}</div>
                    <div class="column interaction-details ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)({ "with-margin": !this.displayMinimalView() })}">
                      ${this.getInteractionDetailsComponent()}
                    </div>
                  </div>
                `}
          </div>
        `
            : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
], AudioPlayer.prototype, "interactionRecordingDetails", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
], AudioPlayer.prototype, "customerChapters", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
], AudioPlayer.prototype, "consultChapters", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
], AudioPlayer.prototype, "customerTranscript", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
], AudioPlayer.prototype, "interactionDetailInfo", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
], AudioPlayer.prototype, "agentName", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
], AudioPlayer.prototype, "transcriptAvailable", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], AudioPlayer.prototype, "currentChapter", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], AudioPlayer.prototype, "currentTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], AudioPlayer.prototype, "playPauseIcon", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], AudioPlayer.prototype, "playbackRate", void 0);
AudioPlayer = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-audio-player")
], AudioPlayer);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/EmptyGrid.scss":
/*!**************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/EmptyGrid.scss ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --grid-header-height: 60px;
  --visualizer-title-width: 100px;
  --visualizer-title-margin-left: 24px;
  --visualizer-container-max-height: 40px;
  --visualizer-container-max-width: 900px;
  --visualizer-container-gap: 16px;
  --visualizer-bar-max-width: 577px;
  --visualizer-bar-max-height: 4px;
  --player-controls-row-height: 50px;
  --player-controls-gap: 8px;
  --volume-popover-width: 180px;
  --volume-popover-height: 21px;
  --volume-popover-gap: 12px;
  --volume-popover-top-offset: 120%;
  --volume-popover-left-offset: 50%;
  --volume-popover-padding: 12px;
  --seek-bar-height: 8px;
  --seek-bar-thumb-size: 16px;
  --seek-bar-top-margin: 16px;
  --seek-bar-bottom-margin: 8px;
  --popover-arrow-size: 10px;
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --interaction-details-height: 220px;
  --interaction-details-vertical-padding: 12px;
  --interaction-details-optional-horizontal-margin: 24px;
  --interaction-details-item-bottom-margin: 4px;
  --interaction-details-item-grid-template-columns: 150px auto;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  --chapters-container-height: 292px;
  --chapters-container-height-no-border: 250px;
  --chapters-container-height-hidden-tabs: 350px;
  --chapters-container-height: 292px;
  --chapters-container-height-hidden-tabs-no-border: 300px;
  --chapters-container-padding-right: 18px;
  --chapter-container-padding-top: 5px;
  --chapter-container-padding-bottom: 12px;
  --chapter-time-width: 60px;
  --chapter-title-width: 300px;
  --transcript-height: 285px;
  --transcript-height-no-chapters: 410px;
  --transcript-height-chapters-no-consults: 350px;
}

.agentx-wc-qmw-empty-grid {
  height: calc(100% - (var(--grid-header-height)));
  background-color: var(--md-secondary-bg-color);
}
.agentx-wc-qmw-empty-grid agentx-wc-empty-state-wrapper::part(img) {
  width: 120px;
}
.agentx-wc-qmw-empty-grid-container {
  height: 70%;
}
.agentx-wc-qmw-empty-grid-container-modal {
  height: 100%;
}
.agentx-wc-qmw-empty-grid-message {
  margin: 0;
  text-align: center;
  font-weight: 700;
  font-size: var(--font-size-large);
  color: var(--md-primary-text-color);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/variables.scss */
/*# sourceURL=EmptyGrid.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/components/EmptyGrid.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvUXVhbGl0eU1vbml0b3JpbmdXaWRnZXQvdmFyaWFibGVzLnNjc3MiLCJFbXB0eUdyaWQuc2NzcyIsIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvUXVhbGl0eU1vbml0b3JpbmdXaWRnZXQvY29tcG9uZW50cy9FbXB0eUdyaWQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLDBCQUFBO0VBR0EsK0JBQUE7RUFDQSxvQ0FBQTtFQUNBLHVDQUFBO0VBQ0EsdUNBQUE7RUFDQSxnQ0FBQTtFQUNBLGlDQUFBO0VBQ0EsZ0NBQUE7RUFHQSxrQ0FBQTtFQUNBLDBCQUFBO0VBR0EsNkJBQUE7RUFDQSw2QkFBQTtFQUNBLDBCQUFBO0VBQ0EsaUNBQUE7RUFDQSxpQ0FBQTtFQUNBLDhCQUFBO0VBR0Esc0JBQUE7RUFDQSwyQkFBQTtFQUNBLDJCQUFBO0VBQ0EsNkJBQUE7RUFHQSwwQkFBQTtFQUdBLHNCQUFBO0VBQ0EsdUJBQUE7RUFHQSxtQ0FBQTtFQUNBLDRDQUFBO0VBQ0Esc0RBQUE7RUFDQSw2Q0FBQTtFQUNBLDREQUFBO0VBRUEscURBQUE7RUFHQSxrQ0FBQTtFQUNBLDRDQUFBO0VBQ0EsOENBQUE7RUFDQSxrQ0FBQTtFQUNBLHdEQUFBO0VBRUEsd0NBQUE7RUFDQSxvQ0FBQTtFQUNBLHdDQUFBO0VBQ0EsMEJBQUE7RUFDQSw0QkFBQTtFQUdBLDBCQUFBO0VBQ0Esc0NBQUE7RUFDQSwrQ0FBQTtBQ25CRjs7QUN6Q0E7RUFDRSxnREFBQTtFQUNBLDhDQUFBO0FENENGO0FDMUNJO0VBQ0UsWUFBQTtBRDRDTjtBQ3hDRTtFQUNFLFdBQUE7QUQwQ0o7QUN2Q0U7RUFDRSxZQUFBO0FEeUNKO0FDdENFO0VBQ0UsU0FBQTtFQUNBLGtCQUFBO0VBQ0EsZ0JBQUE7RUFDQSxpQ0FBQTtFQUNBLG1DQUFBO0FEd0NKIiwiZmlsZSI6IkVtcHR5R3JpZC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3Qge1xuICAtLWdyaWQtaGVhZGVyLWhlaWdodDogNjBweDtcblxuICAvLyBwbGF5ZXIgdmlzdWFsaXplclxuICAtLXZpc3VhbGl6ZXItdGl0bGUtd2lkdGg6IDEwMHB4O1xuICAtLXZpc3VhbGl6ZXItdGl0bGUtbWFyZ2luLWxlZnQ6IDI0cHg7XG4gIC0tdmlzdWFsaXplci1jb250YWluZXItbWF4LWhlaWdodDogNDBweDtcbiAgLS12aXN1YWxpemVyLWNvbnRhaW5lci1tYXgtd2lkdGg6IDkwMHB4O1xuICAtLXZpc3VhbGl6ZXItY29udGFpbmVyLWdhcDogMTZweDtcbiAgLS12aXN1YWxpemVyLWJhci1tYXgtd2lkdGg6IDU3N3B4O1xuICAtLXZpc3VhbGl6ZXItYmFyLW1heC1oZWlnaHQ6IDRweDtcblxuICAvLyBwbGF5ZXIgY29udHJvbHNcbiAgLS1wbGF5ZXItY29udHJvbHMtcm93LWhlaWdodDogNTBweDtcbiAgLS1wbGF5ZXItY29udHJvbHMtZ2FwOiA4cHg7XG5cbiAgLy8gcGxheWVyIHZvbHVtZVxuICAtLXZvbHVtZS1wb3BvdmVyLXdpZHRoOiAxODBweDtcbiAgLS12b2x1bWUtcG9wb3Zlci1oZWlnaHQ6IDIxcHg7XG4gIC0tdm9sdW1lLXBvcG92ZXItZ2FwOiAxMnB4O1xuICAtLXZvbHVtZS1wb3BvdmVyLXRvcC1vZmZzZXQ6IDEyMCU7XG4gIC0tdm9sdW1lLXBvcG92ZXItbGVmdC1vZmZzZXQ6IDUwJTtcbiAgLS12b2x1bWUtcG9wb3Zlci1wYWRkaW5nOiAxMnB4O1xuXG4gIC8vIHBsYXllciBzZWVrYmFyXG4gIC0tc2Vlay1iYXItaGVpZ2h0OiA4cHg7XG4gIC0tc2Vlay1iYXItdGh1bWItc2l6ZTogMTZweDtcbiAgLS1zZWVrLWJhci10b3AtbWFyZ2luOiAxNnB4O1xuICAtLXNlZWstYmFyLWJvdHRvbS1tYXJnaW46IDhweDtcblxuICAvLyBwb3BvdmVyIGFycm93c1xuICAtLXBvcG92ZXItYXJyb3ctc2l6ZTogMTBweDtcblxuICAvLyBzY3JvbGwgYmFyXG4gIC0tc2Nyb2xsYmFyLXdpZHRoOiA2cHg7XG4gIC0tc2Nyb2xsYmFyLWhlaWdodDogOHB4O1xuXG4gIC8vIGludGVyYWN0aW9uIGRldGFpbHNcbiAgLS1pbnRlcmFjdGlvbi1kZXRhaWxzLWhlaWdodDogMjIwcHg7XG4gIC0taW50ZXJhY3Rpb24tZGV0YWlscy12ZXJ0aWNhbC1wYWRkaW5nOiAxMnB4O1xuICAtLWludGVyYWN0aW9uLWRldGFpbHMtb3B0aW9uYWwtaG9yaXpvbnRhbC1tYXJnaW46IDI0cHg7XG4gIC0taW50ZXJhY3Rpb24tZGV0YWlscy1pdGVtLWJvdHRvbS1tYXJnaW46IDRweDtcbiAgLS1pbnRlcmFjdGlvbi1kZXRhaWxzLWl0ZW0tZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiAxNTBweCBhdXRvO1xuXG4gIC0td2Via2l0LWJveC1zaGFkb3c6IDAgMCAxcHggcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjUpO1xuXG4gIC8vIGNoYXB0ZXJzIGxpc3Qgdmlld1xuICAtLWNoYXB0ZXJzLWNvbnRhaW5lci1oZWlnaHQ6IDI5MnB4O1xuICAtLWNoYXB0ZXJzLWNvbnRhaW5lci1oZWlnaHQtbm8tYm9yZGVyOiAyNTBweDtcbiAgLS1jaGFwdGVycy1jb250YWluZXItaGVpZ2h0LWhpZGRlbi10YWJzOiAzNTBweDtcbiAgLS1jaGFwdGVycy1jb250YWluZXItaGVpZ2h0OiAyOTJweDtcbiAgLS1jaGFwdGVycy1jb250YWluZXItaGVpZ2h0LWhpZGRlbi10YWJzLW5vLWJvcmRlcjogMzAwcHg7XG5cbiAgLS1jaGFwdGVycy1jb250YWluZXItcGFkZGluZy1yaWdodDogMThweDtcbiAgLS1jaGFwdGVyLWNvbnRhaW5lci1wYWRkaW5nLXRvcDogNXB4O1xuICAtLWNoYXB0ZXItY29udGFpbmVyLXBhZGRpbmctYm90dG9tOiAxMnB4O1xuICAtLWNoYXB0ZXItdGltZS13aWR0aDogNjBweDtcbiAgLS1jaGFwdGVyLXRpdGxlLXdpZHRoOiAzMDBweDtcblxuICAvLyBhdWRpbyBwbGF5ZXIgdHJhbnNjcmlwdFxuICAtLXRyYW5zY3JpcHQtaGVpZ2h0OiAyODVweDtcbiAgLS10cmFuc2NyaXB0LWhlaWdodC1uby1jaGFwdGVyczogNDEwcHg7XG4gIC0tdHJhbnNjcmlwdC1oZWlnaHQtY2hhcHRlcnMtbm8tY29uc3VsdHM6IDM1MHB4O1xufVxuIiwiOmhvc3Qge1xuICAtLWdyaWQtaGVhZGVyLWhlaWdodDogNjBweDtcbiAgLS12aXN1YWxpemVyLXRpdGxlLXdpZHRoOiAxMDBweDtcbiAgLS12aXN1YWxpemVyLXRpdGxlLW1hcmdpbi1sZWZ0OiAyNHB4O1xuICAtLXZpc3VhbGl6ZXItY29udGFpbmVyLW1heC1oZWlnaHQ6IDQwcHg7XG4gIC0tdmlzdWFsaXplci1jb250YWluZXItbWF4LXdpZHRoOiA5MDBweDtcbiAgLS12aXN1YWxpemVyLWNvbnRhaW5lci1nYXA6IDE2cHg7XG4gIC0tdmlzdWFsaXplci1iYXItbWF4LXdpZHRoOiA1NzdweDtcbiAgLS12aXN1YWxpemVyLWJhci1tYXgtaGVpZ2h0OiA0cHg7XG4gIC0tcGxheWVyLWNvbnRyb2xzLXJvdy1oZWlnaHQ6IDUwcHg7XG4gIC0tcGxheWVyLWNvbnRyb2xzLWdhcDogOHB4O1xuICAtLXZvbHVtZS1wb3BvdmVyLXdpZHRoOiAxODBweDtcbiAgLS12b2x1bWUtcG9wb3Zlci1oZWlnaHQ6IDIxcHg7XG4gIC0tdm9sdW1lLXBvcG92ZXItZ2FwOiAxMnB4O1xuICAtLXZvbHVtZS1wb3BvdmVyLXRvcC1vZmZzZXQ6IDEyMCU7XG4gIC0tdm9sdW1lLXBvcG92ZXItbGVmdC1vZmZzZXQ6IDUwJTtcbiAgLS12b2x1bWUtcG9wb3Zlci1wYWRkaW5nOiAxMnB4O1xuICAtLXNlZWstYmFyLWhlaWdodDogOHB4O1xuICAtLXNlZWstYmFyLXRodW1iLXNpemU6IDE2cHg7XG4gIC0tc2Vlay1iYXItdG9wLW1hcmdpbjogMTZweDtcbiAgLS1zZWVrLWJhci1ib3R0b20tbWFyZ2luOiA4cHg7XG4gIC0tcG9wb3Zlci1hcnJvdy1zaXplOiAxMHB4O1xuICAtLXNjcm9sbGJhci13aWR0aDogNnB4O1xuICAtLXNjcm9sbGJhci1oZWlnaHQ6IDhweDtcbiAgLS1pbnRlcmFjdGlvbi1kZXRhaWxzLWhlaWdodDogMjIwcHg7XG4gIC0taW50ZXJhY3Rpb24tZGV0YWlscy12ZXJ0aWNhbC1wYWRkaW5nOiAxMnB4O1xuICAtLWludGVyYWN0aW9uLWRldGFpbHMtb3B0aW9uYWwtaG9yaXpvbnRhbC1tYXJnaW46IDI0cHg7XG4gIC0taW50ZXJhY3Rpb24tZGV0YWlscy1pdGVtLWJvdHRvbS1tYXJnaW46IDRweDtcbiAgLS1pbnRlcmFjdGlvbi1kZXRhaWxzLWl0ZW0tZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiAxNTBweCBhdXRvO1xuICAtLXdlYmtpdC1ib3gtc2hhZG93OiAwIDAgMXB4IHJnYmEoMjU1LCAyNTUsIDI1NSwgMC41KTtcbiAgLS1jaGFwdGVycy1jb250YWluZXItaGVpZ2h0OiAyOTJweDtcbiAgLS1jaGFwdGVycy1jb250YWluZXItaGVpZ2h0LW5vLWJvcmRlcjogMjUwcHg7XG4gIC0tY2hhcHRlcnMtY29udGFpbmVyLWhlaWdodC1oaWRkZW4tdGFiczogMzUwcHg7XG4gIC0tY2hhcHRlcnMtY29udGFpbmVyLWhlaWdodDogMjkycHg7XG4gIC0tY2hhcHRlcnMtY29udGFpbmVyLWhlaWdodC1oaWRkZW4tdGFicy1uby1ib3JkZXI6IDMwMHB4O1xuICAtLWNoYXB0ZXJzLWNvbnRhaW5lci1wYWRkaW5nLXJpZ2h0OiAxOHB4O1xuICAtLWNoYXB0ZXItY29udGFpbmVyLXBhZGRpbmctdG9wOiA1cHg7XG4gIC0tY2hhcHRlci1jb250YWluZXItcGFkZGluZy1ib3R0b206IDEycHg7XG4gIC0tY2hhcHRlci10aW1lLXdpZHRoOiA2MHB4O1xuICAtLWNoYXB0ZXItdGl0bGUtd2lkdGg6IDMwMHB4O1xuICAtLXRyYW5zY3JpcHQtaGVpZ2h0OiAyODVweDtcbiAgLS10cmFuc2NyaXB0LWhlaWdodC1uby1jaGFwdGVyczogNDEwcHg7XG4gIC0tdHJhbnNjcmlwdC1oZWlnaHQtY2hhcHRlcnMtbm8tY29uc3VsdHM6IDM1MHB4O1xufVxuXG4uYWdlbnR4LXdjLXFtdy1lbXB0eS1ncmlkIHtcbiAgaGVpZ2h0OiBjYWxjKDEwMCUgLSAodmFyKC0tZ3JpZC1oZWFkZXItaGVpZ2h0KSkpO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1tZC1zZWNvbmRhcnktYmctY29sb3IpO1xufVxuLmFnZW50eC13Yy1xbXctZW1wdHktZ3JpZCBhZ2VudHgtd2MtZW1wdHktc3RhdGUtd3JhcHBlcjo6cGFydChpbWcpIHtcbiAgd2lkdGg6IDEyMHB4O1xufVxuLmFnZW50eC13Yy1xbXctZW1wdHktZ3JpZC1jb250YWluZXIge1xuICBoZWlnaHQ6IDcwJTtcbn1cbi5hZ2VudHgtd2MtcW13LWVtcHR5LWdyaWQtY29udGFpbmVyLW1vZGFsIHtcbiAgaGVpZ2h0OiAxMDAlO1xufVxuLmFnZW50eC13Yy1xbXctZW1wdHktZ3JpZC1tZXNzYWdlIHtcbiAgbWFyZ2luOiAwO1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gIGZvbnQtd2VpZ2h0OiA3MDA7XG4gIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplLWxhcmdlKTtcbiAgY29sb3I6IHZhcigtLW1kLXByaW1hcnktdGV4dC1jb2xvcik7XG59IiwiQHVzZSBcIi4uL3ZhcmlhYmxlc1wiIGFzICo7XG5cbi5hZ2VudHgtd2MtcW13LWVtcHR5LWdyaWQge1xuICBoZWlnaHQ6IGNhbGMoMTAwJSAtICh2YXIoLS1ncmlkLWhlYWRlci1oZWlnaHQpKSk7XG4gIGJhY2tncm91bmQtY29sb3I6IHZhcigtLW1kLXNlY29uZGFyeS1iZy1jb2xvcik7XG4gIGFnZW50eC13Yy1lbXB0eS1zdGF0ZS13cmFwcGVyIHtcbiAgICAmOjpwYXJ0KGltZykge1xuICAgICAgd2lkdGg6IDEyMHB4O1xuICAgIH1cbiAgfVxuXG4gICYtY29udGFpbmVyIHtcbiAgICBoZWlnaHQ6IDcwJTtcbiAgfVxuXG4gICYtY29udGFpbmVyLW1vZGFsIHtcbiAgICBoZWlnaHQ6IDEwMCU7XG4gIH1cblxuICAmLW1lc3NhZ2Uge1xuICAgIG1hcmdpbjogMDtcbiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gICAgZm9udC13ZWlnaHQ6IDcwMDtcbiAgICBmb250LXNpemU6IHZhcigtLWZvbnQtc2l6ZS1sYXJnZSk7XG4gICAgY29sb3I6IHZhcigtLW1kLXByaW1hcnktdGV4dC1jb2xvcik7XG4gIH1cbn1cbiJdfQ== */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/EmptyGrid.ts":
/*!************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/EmptyGrid.ts ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EmptyGrid: () => (/* binding */ EmptyGrid)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Common_EmptyStateWrapper_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../Common/EmptyStateWrapper/EmptyStateWrapper */ "./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../constants */ "./src/components/QualityMonitoringWidget/constants.ts");
/* harmony import */ var _EmptyGrid_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./EmptyGrid.scss */ "./src/components/QualityMonitoringWidget/components/EmptyGrid.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var EmptyGrid;
(function (EmptyGrid) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.emptyElement = "";
        }
        static get styles() {
            return _EmptyGrid_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        getMessageText() {
            if (this.emptyElement === _constants__WEBPACK_IMPORTED_MODULE_3__.RECORDING) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ` <p role="alert" class="agentx-wc-qmw-empty-grid-message">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.noRecording")}</p> `;
            }
            else {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
          <p role="alert" class="agentx-wc-qmw-empty-grid-message">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.noData")}</p>
          <p role="alert" class="agentx-wc-qmw-empty-grid-message">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.useFilterBtn")}</p>
        `;
            }
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <section class="agentx-wc-qmw-empty-grid">
        <div class=${this.emptyElement !== _constants__WEBPACK_IMPORTED_MODULE_3__.RECORDING
                ? "agentx-wc-qmw-empty-grid-container"
                : "agentx-wc-qmw-empty-grid-container-modal"}>
          <agentx-wc-empty-state-wrapper illustration-type="empty-state">
          ${this.getMessageText()}
          </agentx-wc-empty-state-wrapper>
        <div>
        </section>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "emptyElement", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-qmw-empty-grid")
    ], Element);
    EmptyGrid.Element = Element;
})(EmptyGrid || (EmptyGrid = {}));


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/GridError.scss":
/*!**************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/GridError.scss ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.grid-height {
  height: calc(100% - (var(--grid-header-height)));
}
.grid-height .agentx-wc-qmw-error-content {
  height: 70%;
}

.agentx-wc-qmw-error-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.agentx-wc-qmw-error-icon {
  height: 60px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--badge-red-bg-color);
  border-radius: var(--border-radius-circle);
}
.agentx-wc-qmw-error-heading {
  font-weight: 700;
  font-size: var(--font-size-large);
  color: var(--md-primary-text-color);
}
.agentx-wc-qmw-error-toggle {
  font-weight: 400;
  margin-top: 16px;
  color: var(--md-primary-text-color);
}
.agentx-wc-qmw-error-toggle-text {
  text-decoration: underline;
}
.agentx-wc-qmw-error-detail {
  font-size: var(--font-size-small);
  text-align: center;
  width: 400px;
  color: var(--md-primary-text-color);
}
.agentx-wc-qmw-error-tracking-id-wrapper {
  display: flex;
  align-items: center;
}
.agentx-wc-qmw-error-tracking-id-wrapper p {
  font-size: var(--font-size-small);
  color: var(--md-primary-text-color);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/components/GridError.scss */
/*# sourceURL=GridError.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/GridError.ts":
/*!************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/GridError.ts ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GridError: () => (/* binding */ GridError)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../constants */ "./src/components/QualityMonitoringWidget/constants.ts");
/* harmony import */ var _GridError_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./GridError.scss */ "./src/components/QualityMonitoringWidget/components/GridError.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var GridError;
(function (GridError) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.trackingID = "";
            this.errorElement = _constants__WEBPACK_IMPORTED_MODULE_4__.GRID;
            this.shouldKnowMore = false;
            this.isCopied = false;
            this.handleShowMoreBtnClick = () => {
                this.setShouldKnowMore(!this.getShouldKnowMore());
            };
            this.handleCopyClick = () => {
                const clipboard = window.navigator.clipboard;
                clipboard.writeText(this.trackingID);
                this.setIsCopied(true);
                setTimeout(() => {
                    this.setIsCopied(false);
                }, _constants__WEBPACK_IMPORTED_MODULE_4__.COPY_CLICK_TIMEOUT);
            };
            this.handleRetryBtnClick = () => {
                this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_4__.QMW_ERR_RETRY, {
                    bubbles: true,
                    composed: true,
                    detail: true
                }));
            };
        }
        static get styles() {
            return _GridError_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
        }
        getIsCopied() {
            return this.isCopied;
        }
        setIsCopied(isCopied) {
            this.isCopied = isCopied;
        }
        getShouldKnowMore() {
            return this.shouldKnowMore;
        }
        setShouldKnowMore(shouldKnowMore) {
            this.shouldKnowMore = shouldKnowMore;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <section class=${this.errorElement !== _constants__WEBPACK_IMPORTED_MODULE_4__.RECORDING ? "agentx-wc-qmw-error grid-height" : "agentx-wc-qmw-error"}>
          <div class="agentx-wc-qmw-error-content">
            <span class=${"agentx-wc-qmw-error-icon"}>
              <md-icon .name=${"icon-warning_32"} .color=${"var(--md-alert-error-text-color)"}></md-icon>
            </span>
            <h1 class="agentx-wc-qmw-error-heading">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.loadFail")}</h1>
            <md-button
              @click=${this.handleRetryBtnClick}
              variant="primary"
              .ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.tryAgain")}
              >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.tryAgain")}</md-button
            >

            ${this.trackingID
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <md-button @click=${this.handleShowMoreBtnClick} .color=${"color-none"} class=${"agentx-wc-qmw-error-toggle"}
            .ariaLabel= ${!this.shouldKnowMore ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorDetail.errorMoreButton") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorDetail.errorLessButton")}>
              <span class=${"agentx-wc-qmw-error-toggle-text"}>
              ${!this.shouldKnowMore ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorDetail.errorMoreButton") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorDetail.errorLessButton")}
              <span>
            </md-button>
            `
                : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
            ${this.trackingID && this.shouldKnowMore
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                  <div>
                    <p class="agentx-wc-qmw-error-detail">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.pleaseShare")}</p>
                    <div class="agentx-wc-qmw-error-tracking-id-wrapper">
                      <p>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorModal.trackingIdLabel")}: ${this.trackingID}</p>
                      <md-button
                        @click=${this.handleCopyClick}
                        .color=${"color-none"}
                        .ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorModal.copy")}
                      >
                        <md-icon .name=${!this.isCopied ? "copy_14" : "icon-check_12"}></md-icon>
                      </md-button>
                    </div>
                  </div>
                `
                : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
          </div>
        </section>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "trackingID", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "errorElement", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "shouldKnowMore", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isCopied", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-qmw-grid-error")
    ], Element);
    GridError.Element = Element;
})(GridError || (GridError = {}));


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/GridHeader.scss":
/*!***************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/GridHeader.scss ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.grid-header-container {
  padding: 1rem 1rem 0;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.grid-header-action-container {
  display: flex;
  margin-bottom: 1rem;
}

.filter-panel {
  display: block;
}

.filters-menu-header-wrapper {
  justify-content: flex-start;
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid var(--md-primary-seperator-color);
  color: var(--md-primary-text-color);
}

.date-range-container {
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  color: var(--md-primary-text-color);
}
.date-range-container div {
  display: flex;
}
.date-range-container span {
  padding-right: 0.25rem;
}
.date-range-container .date-time-wrapper {
  display: flex;
}
.date-range-container .date-time-container {
  display: block;
}
.date-range-container .date-time-container:first-child {
  padding-right: 1rem;
}
.date-range-container .date-range-label md-tooltip {
  display: flex;
  align-items: center;
}
.date-range-container .date-info-icon {
  display: flex;
}

.filters-footer-container {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 1.25rem 0;
  border-top: 1px solid var(--md-primary-seperator-color);
  display: flex;
  justify-content: flex-end;
}
.filters-footer-container .panel-button:last-child {
  padding-left: 1rem;
  padding-right: 1.25rem;
}

.custom-menu-overlay.overlay-container {
  border-radius: var(--border-radius-medium);
  box-shadow: var(--box-shadow-gray);
  box-sizing: border-box;
  display: block;
  position: absolute;
  z-index: 999;
  right: 0;
  height: calc(80% - var(--grid-header-height));
}
.custom-menu-overlay.overlay-container .overlay-content {
  background-color: var(--md-secondary-white-bg-color);
  border: 1px solid var(--md-menu-overlay-border-color, --gray-20);
  border-radius: var(--border-radius-medium);
  max-width: calc(100vw - var(--vw-padding) * 2);
  overflow-y: auto;
  height: 100%;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/components/GridHeader.scss */
/*# sourceURL=GridHeader.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/GridHeader.ts":
/*!*************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/GridHeader.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QualityMonitoringGridHeader: () => (/* binding */ QualityMonitoringGridHeader)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../constants */ "./src/components/QualityMonitoringWidget/constants.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils */ "./src/components/QualityMonitoringWidget/utils.ts");
/* harmony import */ var _GridHeader_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./GridHeader.scss */ "./src/components/QualityMonitoringWidget/components/GridHeader.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var QualityMonitoringGridHeader;
(function (QualityMonitoringGridHeader) {
    /**
     * @element agentx-wc-qmw-filter-header
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.startDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local().minus({ days: 1 }).toMillis();
            this.endDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local().minus({ seconds: 1 }).toMillis();
            this.activeFilters = [
                {
                    filterName: "date-filter",
                    displayIcon: "calendar-month-bold",
                    displayText: "",
                    tooltipTranslateLink: "app:qmw:dateRangeFilterTooltip"
                }
            ];
            this.filterPanelShow = false;
            this.startDatePickerValue = "";
            this.endDatePickerValue = "";
            this.maxStartDate = "";
            this.maxEndDate = "";
            this.minStartDate = "";
            this.minEndDate = "";
            this.boundHandleKeyDown = {};
            this.isFormInvalid = false;
            this.handleOutsideFilterPanelClick = (event) => {
                const path = event.composedPath();
                if (path.length) {
                    const insideSelfClick = !!path.find((element) => element.id === "qmw-filter-panel");
                    const btnClick = !!path.find((element) => element.id === "toggle-filter-button");
                    if (!btnClick && !insideSelfClick && this.filterPanelShow) {
                        this.toggleFilterPanel();
                    }
                }
            };
            this.handleKeyDown = (event) => {
                if (this.filterPanelShow && event.code === "Escape") {
                    this.toggleFilterPanel();
                }
            };
        }
        static get styles() {
            return _GridHeader_scss__WEBPACK_IMPORTED_MODULE_6__["default"];
        }
        connectedCallback() {
            super.connectedCallback();
            this.setInitialDatePickerBounds();
            this.boundHandleKeyDown = this.handleKeyDown;
            document.addEventListener("keydown", this.boundHandleKeyDown);
            document.addEventListener("click", this.handleOutsideFilterPanelClick);
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            this.updateDateFilterPillText();
            this.updateDatePickerValues();
        }
        update(changedProperties) {
            super.update(changedProperties);
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            document.removeEventListener("keydown", this.boundHandleKeyDown);
            document.removeEventListener("click", this.handleOutsideFilterPanelClick);
        }
        dateTimePickerBoundsFormat(date) {
            return luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(date).toISODate() || "";
        }
        updateDateFilterPillText() {
            const dateFilterIndex = this.activeFilters.map((filter) => filter.filterName).indexOf("date-filter");
            this.activeFilters[dateFilterIndex].displayText = `${(0,_utils__WEBPACK_IMPORTED_MODULE_5__.dateFormatterShortWithSeconds)(this.startDate)} - ${(0,_utils__WEBPACK_IMPORTED_MODULE_5__.dateFormatterShortWithSeconds)(this.endDate)}`;
        }
        updateDatePickerValues() {
            this.startDatePickerValue =
                luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(this.startDate).startOf("second").toISO({ suppressMilliseconds: true }) || "";
            this.endDatePickerValue =
                luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(this.endDate).startOf("second").toISO({ suppressMilliseconds: true }) || "";
        }
        toggleFilterPanel() {
            this.filterPanelShow = !this.filterPanelShow;
            const defaultStartDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local().minus({ days: 1 }).toMillis();
            const defaultEndDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local().minus({ days: 1 }).toMillis();
            // If a user wants to pick a new date range they shouldn't be restricted
            // within a month of the previous range
            if (this.filterPanelShow) {
                this.isFormInvalid = false;
                if (this.startDate !== defaultStartDate || this.endDate !== defaultEndDate) {
                    // If a previously applied filter is used, make sure its valid
                    // This will not cause an error state in the component because it is immediately followed
                    // by setting the 13 month bounds. Filter clearing and an error message for the user
                    // would make this better in the future
                    this.setDatePickerBounds("start", this.startDate);
                    this.setDatePickerBounds("end", this.endDate);
                }
                this.setInitialDatePickerBounds();
            }
            else {
                // If a user changed the dates but didn't apply them before closing,
                // reset dates to last applied
                this.startDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(this.startDatePickerValue).toMillis();
                this.endDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(this.endDatePickerValue).toMillis();
            }
        }
        handleApplyButton() {
            this.updateDateFilterPillText();
            this.updateDatePickerValues();
            this.toggleFilterPanel();
            this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_4__.QMW_FILTERS_UPDATED, {
                bubbles: true,
                composed: true,
                detail: {
                    startTime: this.startDate,
                    endTime: this.endDate
                }
            }));
        }
        setInitialDatePickerBounds() {
            const minDateObject = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local().minus({ months: 13 }).toMillis();
            this.minEndDate = this.dateTimePickerBoundsFormat(minDateObject);
            this.minStartDate = this.minEndDate;
            this.maxStartDate = this.dateTimePickerBoundsFormat(luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local().toMillis());
            this.maxEndDate = this.dateTimePickerBoundsFormat(luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local().toMillis());
        }
        setDatePickerBounds(datePicked, newDate) {
            if (datePicked === "start") {
                const today = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local().endOf("day").toMillis();
                // check if 31 days after new start date is after today
                const monthAfterStart = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(newDate).plus({ days: 30 }).endOf("day").toMillis();
                this.maxEndDate =
                    today < monthAfterStart
                        ? this.dateTimePickerBoundsFormat(today)
                        : this.dateTimePickerBoundsFormat(monthAfterStart);
                // set minimum end date to day after new start date
                this.minEndDate = this.dateTimePickerBoundsFormat(luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(newDate).plus({ minutes: 1 }).startOf("day").toMillis());
            }
            else if (datePicked === "end") {
                const minDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local().minus({ months: 13 }).startOf("day").toMillis();
                // check if 31 days before new end date is before 13 months ago
                const monthBeforeEnd = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(newDate).minus({ days: 30 }).startOf("day").toMillis();
                this.minStartDate =
                    minDate > monthBeforeEnd
                        ? this.dateTimePickerBoundsFormat(minDate)
                        : this.dateTimePickerBoundsFormat(monthBeforeEnd);
                // set maximum start date to day before new end date
                this.maxStartDate = this.dateTimePickerBoundsFormat(luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(newDate).minus({ minutes: 1 }).endOf("day").toMillis());
            }
            this.dateValidator(this.startDate, this.endDate);
        }
        dateValidator(startDate, endDate) {
            const minStartDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(this.minStartDate).startOf("day").toMillis();
            const maxStartDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(this.maxStartDate).endOf("day").toMillis();
            const minEndDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(this.minEndDate).startOf("day").toMillis();
            const maxEndDate = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(this.maxEndDate).endOf("day").toMillis();
            this.isFormInvalid =
                startDate >= endDate ||
                    !(minStartDate <= startDate && startDate <= maxStartDate) ||
                    !(minEndDate <= endDate && endDate <= maxEndDate);
            return this.isFormInvalid;
        }
        handleStartDate(e) {
            var _a;
            this.startDate = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.dateTime.toMillis();
            this.setDatePickerBounds("start", this.startDate);
        }
        handleEndDate(e) {
            var _a;
            this.endDate = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.dateTime.toMillis();
            this.setDatePickerBounds("end", this.endDate);
        }
        renderActiveFilters() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="active-filter-container">
          ${this.activeFilters.map((filter) => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
              <md-tooltip placement="bottom" message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(filter.tooltipTranslateLink)}">
                <md-badge color="grey" id="${filter.filterName}">
                  <md-icon name="${filter.displayIcon}" iconSet="momentumDesign" size="16"></md-icon>
                  ${filter.displayText}
                </md-badge>
              </md-tooltip>
            `;
            })}
        </div>
      `;
        }
        renderFilterPanel() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div id="qmw-filter-panel" class="filters-panel custom-menu-overlay overlay-container" role="dialog">
          <div class="filters-panel-container overlay-content" part="overlay-content">
            <div class="filters-menu-header-wrapper">
              <span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.filters")}</span>
            </div>
            <div class="date-range-container">
              <div class="date-range-label">
                <span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.dateRange")}</span>
                <md-tooltip placement="bottom" message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw:dateRangeLabelTooltip")}">
                  <md-icon class="date-info-icon" name="info-badge-filled" size="16" iconSet="momentumDesign"></md-icon>
                </md-tooltip>
              </div>
              <div class="date-time-wrapper">
                <div class="date-time-container">
                  <label>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.startDate")}</label>
                  <md-date-time-picker
                    id="start-date"
                    maxDate=${this.maxStartDate}
                    minDate=${this.minStartDate}
                    value=${this.startDatePickerValue}
                    @date-time-change=${this.handleStartDate}
                  ></md-date-time-picker>
                </div>
                <div class="date-time-container">
                  <label>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.endDate")}</label>
                  <md-date-time-picker
                    id="end-date"
                    maxDate=${this.maxEndDate}
                    minDate=${this.minEndDate}
                    value=${this.endDatePickerValue}
                    @date-time-change=${this.handleEndDate}
                  ></md-date-time-picker>
                </div>
              </div>
            </div>
            <div class="filters-footer-container">
              <md-button class="panel-button" variant="secondary" @button-click=${this.toggleFilterPanel}
                >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.close")}</md-button
              >
              <md-button
                class="panel-button"
                variant="primary"
                ?disabled=${this.isFormInvalid}
                @button-click=${this.handleApplyButton}
                >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.apply")}</md-button
              >
            </div>
          </div>
        </div>
      `;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="grid-header-container">
          ${this.renderActiveFilters()}
          <div class="grid-header-action-container">
            <md-button
              slot="menu-trigger"
              class="filter-button"
              variant="secondary"
              size="32"
              id="toggle-filter-button"
              @click=${() => this.toggleFilterPanel()}
            >
              <md-icon slot="icon" name="filter-bold" size="16" iconSet="momentumDesign"></md-icon>
              <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.filters")}</span>
            </md-button>
          </div>
        </div>
        ${this.filterPanelShow ? this.renderFilterPanel() : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
    ], Element.prototype, "startDate", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
    ], Element.prototype, "endDate", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "activeFilters", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "filterPanelShow", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "startDatePickerValue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "endDatePickerValue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "maxStartDate", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "maxEndDate", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "minStartDate", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "minEndDate", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "boundHandleKeyDown", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isFormInvalid", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-qmw-filter-header")
    ], Element);
    QualityMonitoringGridHeader.Element = Element;
})(QualityMonitoringGridHeader || (QualityMonitoringGridHeader = {}));


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/Recording.scss":
/*!**************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/Recording.scss ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.agentx-wc-qmw-recording-modal-properties-container {
  margin-bottom: 24px;
  margin-top: 0;
}
.agentx-wc-qmw-recording-modal-properties, .agentx-wc-qmw-recording-modal-consult-info {
  display: grid;
  grid-template-columns: 80px auto;
  margin: 10px 0;
  margin-top: 0;
}
.agentx-wc-qmw-recording-modal-properties dt, .agentx-wc-qmw-recording-modal-consult-info dt {
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}
.agentx-wc-qmw-recording-modal-playback-error-text {
  line-height: 125%;
  text-align: left;
  margin: 0;
}
.agentx-wc-qmw-recording-modal dd {
  margin-inline-start: 20px;
}
.agentx-wc-qmw-recording-modal #scrollable-content {
  overflow: hidden auto;
  max-height: 440px;
  padding-right: 10px;
  padding-top: 0;
}
.agentx-wc-qmw-recording-modal #scrollable-content::-webkit-scrollbar {
  width: calc(var(--space-token-even) * 4);
}
.agentx-wc-qmw-recording-modal #scrollable-content::-webkit-scrollbar-track {
  background: transparent;
}
.agentx-wc-qmw-recording-modal #scrollable-content::-webkit-scrollbar-thumb {
  background-color: var(--md-gray-20);
  border-radius: var(--border-radius-small);
}
.agentx-wc-qmw-recording-modal #scrollable-content .agentx-wc-qmw-recording-modal-consult-container {
  margin-bottom: 10px;
}
.agentx-wc-qmw-recording-modal #scrollable-content span {
  margin-left: 10px;
}
.agentx-wc-qmw-recording-modal #scrollable-content hr {
  color: var(--md-gray-20);
  opacity: 0.5;
}
.agentx-wc-qmw-recording-modal #scrollable-content #consult-recordings p {
  font-size: 14px;
  font-weight: 600;
}

md-modal::part(modal-body) {
  padding-right: 3px;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=Recording.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/components/Recording.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/Recording.ts":
/*!************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/Recording.ts ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   RecordingDetails: () => (/* binding */ RecordingDetails)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! axios */ "../../node_modules/axios/lib/axios.js");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../constants */ "./src/components/QualityMonitoringWidget/constants.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../utils */ "./src/components/QualityMonitoringWidget/utils.ts");
/* harmony import */ var _AudioPlayer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./AudioPlayer */ "./src/components/QualityMonitoringWidget/components/AudioPlayer.ts");
/* harmony import */ var _Recording_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Recording.scss */ "./src/components/QualityMonitoringWidget/components/Recording.scss");
/* harmony import */ var _player_Chapter__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./player/Chapter */ "./src/components/QualityMonitoringWidget/components/player/Chapter.ts");
/* harmony import */ var _player_Transcript__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./player/Transcript */ "./src/components/QualityMonitoringWidget/components/player/Transcript.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};













var RecordingLegType;
(function (RecordingLegType) {
    RecordingLegType["Main"] = "main";
    RecordingLegType["Consult"] = "consult";
})(RecordingLegType || (RecordingLegType = {}));
var InteractionDetailType;
(function (InteractionDetailType) {
    InteractionDetailType[InteractionDetailType["SessionId"] = 0] = "SessionId";
    InteractionDetailType[InteractionDetailType["Agent"] = 1] = "Agent";
    InteractionDetailType[InteractionDetailType["StartTime"] = 2] = "StartTime";
    InteractionDetailType[InteractionDetailType["EndTime"] = 3] = "EndTime";
    InteractionDetailType[InteractionDetailType["Ani"] = 4] = "Ani";
    InteractionDetailType[InteractionDetailType["Duration"] = 5] = "Duration";
    InteractionDetailType[InteractionDetailType["Queue"] = 6] = "Queue";
    InteractionDetailType[InteractionDetailType["ConsultedAgents"] = 7] = "ConsultedAgents";
    InteractionDetailType[InteractionDetailType["ConferenceAgents"] = 8] = "ConferenceAgents";
})(InteractionDetailType || (InteractionDetailType = {}));
var RecordingDetails;
(function (RecordingDetails) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        constructor() {
            super(...arguments);
            this.ani = "";
            this.queue = "";
            this.isModalOpen = false;
            this.showConsultRecordings = false;
            this.showEnhancedRecordings = false;
            this.showTranscript = false;
            this.startTimeFromGrid = 0;
            this.showInModal = true;
            this.seekEvaluationTime = 0;
            this.isLoading = false;
            this.absoluteStartTime = 0;
            this.absoluteStopTime = 0;
            this.consultAudioSources = [];
            this.hasDataFetchError = false;
            this.hasRecordingPlaybackError = false;
            this.trackingID = "";
            this.isEmpty = false;
            this.customerChaptersData = [];
            this.consultChaptersData = [];
            this.interactionDetailInfo = new Map();
            this.captureResults = null;
            this.captureMetaDataResults = null;
            this.audioPlayerControlsClicked = new Map();
            this.transcriptAvailable = false;
            this.hasTranscriptError = false;
            this.transcriptErrorMessage = "";
            this.audioLabels = {
                playBtn: {
                    ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPlayBtn"),
                    tooltipText: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPlayBtn")
                },
                pauseBtn: {
                    ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPauseBtn"),
                    tooltipText: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPauseBtn")
                },
                duration: {
                    ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioDuration"),
                    tooltipText: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioDuration")
                },
                timeline: {
                    ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioTimeline"),
                    tooltipText: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioTimeline")
                },
                volumeBtn: {
                    ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioVolumeBtn"),
                    tooltipText: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioVolumeBtn")
                },
                volumeSlider: {
                    ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioVolumeSlider"),
                    tooltipText: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioVolumeSlider")
                },
                playbackSpeedBtn: {
                    ariaLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPlaybackSpeed"),
                    tooltipText: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPlaybackSpeed")
                }
            };
        }
        static get styles() {
            return _Recording_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
        }
        processRequiredRecordingMediaData() {
            var _a, _b, _c;
            // Validate media data
            if (!this.captureResults) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Null capture (media) data for session id: ${this.sessionId}`);
                return false;
            }
            const mainRecordingMediaData = (_a = this.captureResults) === null || _a === void 0 ? void 0 : _a.data[0].recording.find((rec) => rec.attributes.callType === RecordingLegType.Main && rec.segment === false);
            if (!mainRecordingMediaData ||
                mainRecordingMediaData.attributes.filePath === "" ||
                mainRecordingMediaData.attributes.stopTime === 0) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Cannot find valid recording (RecordingLegType.Main, non-segment) in capture results for session id: ${this.sessionId}`);
                return false;
            }
            // Create main Interaction Recording object
            const { startTime, stopTime, filePath } = mainRecordingMediaData.attributes;
            this.absoluteStartTime = startTime;
            this.absoluteStopTime = stopTime;
            this.interactionRecordingData = new _player_Chapter__WEBPACK_IMPORTED_MODULE_9__.Chapter(filePath, 0, Math.abs(stopTime - startTime), [], _utils__WEBPACK_IMPORTED_MODULE_6__.ChapterType.Main);
            // Set interaction details
            this.interactionDetailInfo.set(this.getLocalizedString(InteractionDetailType.SessionId), (_b = this.sessionId) !== null && _b !== void 0 ? _b : "");
            this.interactionDetailInfo.set(this.getLocalizedString(InteractionDetailType.Agent), (_c = this.agentName) !== null && _c !== void 0 ? _c : "");
            this.interactionDetailInfo.set(this.getLocalizedString(InteractionDetailType.StartTime), (0,_utils__WEBPACK_IMPORTED_MODULE_6__.dateFormatterShortWithSeconds)(startTime));
            this.interactionDetailInfo.set(this.getLocalizedString(InteractionDetailType.EndTime), (0,_utils__WEBPACK_IMPORTED_MODULE_6__.dateFormatterShortWithSeconds)(stopTime));
            this.interactionDetailInfo.set(this.getLocalizedString(InteractionDetailType.Ani), this.ani);
            this.interactionDetailInfo.set(this.getLocalizedString(InteractionDetailType.Queue), this.queue);
            this.interactionDetailInfo.set(this.getLocalizedString(InteractionDetailType.Duration), (0,_utils__WEBPACK_IMPORTED_MODULE_6__.relativeTimeFormatter)(stopTime - startTime));
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Successfully processed capture data (media). Main recording start time: ${this.absoluteStartTime}, stop time: ${this.absoluteStopTime}`);
            return true;
        }
        processRicherMetadata() {
            var _a, _b;
            // Validate metadata
            if (!this.captureMetaDataResults ||
                !this.captureMetaDataResults.data ||
                !this.captureMetaDataResults.data.taskDetails ||
                this.captureMetaDataResults.data.taskDetails.tasks.length === 0 ||
                this.captureMetaDataResults.data.taskDetails.tasks[0].activities.nodes.length === 0) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Invalid capture metadata for session id: ${this.sessionId}`);
                return false;
            }
            if (!this.captureResults || !this.captureResults.data || !this.captureResults.data[0].recording) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Null capture (media) data for session id: ${this.sessionId}`);
                return false;
            }
            // Process metadata into chapter data
            const chapterData = (0,_utils__WEBPACK_IMPORTED_MODULE_6__.createCaptureData)(this.captureResults.data[0].recording, this.captureMetaDataResults.data.taskDetails.tasks[0].activities.nodes);
            if (chapterData.customerChaptersMetaData.length <= 0) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] No customer chapter metadata found in results for session id: ${this.sessionId}`);
                return false;
            }
            // Create chapter objects for customer and consult chapters
            const createChapterObj = (metaData, firstChapterStartTime) => {
                const startTimeRelative = Math.abs(metaData.startTime - firstChapterStartTime);
                const endTimeRelative = startTimeRelative + Math.abs(metaData.startTime - metaData.endTime);
                return new _player_Chapter__WEBPACK_IMPORTED_MODULE_9__.Chapter(metaData.fileLocation, startTimeRelative, endTimeRelative, metaData.involvedAgentNames, metaData.chapterType);
            };
            const firstChapterStartTime = chapterData.customerChaptersMetaData[0].startTime;
            chapterData.customerChaptersMetaData.forEach((metaData) => {
                this.customerChaptersData.push(createChapterObj(metaData, firstChapterStartTime));
            });
            chapterData.consultChaptersMetaData.forEach((metaData) => {
                this.consultChaptersData.push(createChapterObj(metaData, firstChapterStartTime));
            });
            // Set InteractionDetails for agents in consult and conference
            const consultedAgents = (0,_utils__WEBPACK_IMPORTED_MODULE_6__.createArrayOfAgents)((_a = this.agentName) !== null && _a !== void 0 ? _a : "", chapterData.consultChaptersMetaData, _utils__WEBPACK_IMPORTED_MODULE_6__.ChapterType.Consulting);
            if (consultedAgents.length > 0) {
                this.interactionDetailInfo.set(this.getLocalizedString(InteractionDetailType.ConsultedAgents), consultedAgents.join(", "));
            }
            const conferencedAgents = (0,_utils__WEBPACK_IMPORTED_MODULE_6__.createArrayOfAgents)((_b = this.agentName) !== null && _b !== void 0 ? _b : "", chapterData.customerChaptersMetaData, _utils__WEBPACK_IMPORTED_MODULE_6__.ChapterType.Conferencing);
            if (conferencedAgents.length > 0) {
                this.interactionDetailInfo.set(this.getLocalizedString(InteractionDetailType.ConferenceAgents), conferencedAgents.join(", "));
            }
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Successfully processed capture metadata. Customer/Consult chapters: ${this.customerChaptersData.length}/${this.consultChaptersData.length}`);
            return true;
        }
        processTranscriptionData() {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.captureResults && this.captureResults.data[0].transcription) {
                    try {
                        const transcriptJson = yield axios__WEBPACK_IMPORTED_MODULE_11__["default"].get(this.captureResults.data[0].transcription[0].filePath);
                        this.customerTranscript = new _player_Transcript__WEBPACK_IMPORTED_MODULE_10__.Transcript(transcriptJson.data);
                    }
                    catch (error) {
                        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[App:QMW] Failed to fetch transcription data`, error);
                        this.hasTranscriptError = true;
                        this.transcriptErrorMessage = error.message;
                        return false;
                    }
                    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Successfully fetched and created transcription data`);
                    this.transcriptAvailable = true;
                    return true;
                }
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[App:QMW] Failed to fetch transcription data. Capture data does not contain transcription data`);
                this.hasTranscriptError = true;
                this.transcriptErrorMessage = "Capture data does not contain transcription data";
                return false;
            });
        }
        fetchData() {
            return __awaiter(this, void 0, void 0, function* () {
                this.resetData();
                if (this.sessionId && this.sessionId.length > 0) {
                    if (this.showEnhancedRecordings) {
                        // Fetch capture data (media)
                        this.captureResults = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.qmw.fetchCapture({ taskId: this.sessionId });
                        const isMediaFetchSuccessful = this.captureResults.data.length > 0 && this.captureResults.data[0].recording.length > 0;
                        // Fetch capture metadata (events)
                        this.captureMetaDataResults = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.qmw.fetchCaptureMetaData({
                            taskId: this.sessionId,
                            startTime: this.startTimeFromGrid
                        });
                        return isMediaFetchSuccessful;
                    }
                    // Note: This is the old way of fetching data, we will deprecate this after GA for enhanced recordings feature
                    else {
                        const captureDataResponse = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.qmw.fetchCapture({ taskId: this.sessionId });
                        // captures API takes a list of task IDs and returns an array in data for each task, we are only passing in 1 task id and thus taking the first obj in the array
                        const capture = captureDataResponse.data[0];
                        const { recording } = capture;
                        if (recording.length) {
                            recording.forEach((rec) => {
                                if (rec.attributes.callType === RecordingLegType.Main && rec.segment === false) {
                                    this.mainAudioSource = {
                                        audioSrc: rec.attributes.filePath,
                                        absoluteStartTime: rec.attributes.startTime,
                                        absoluteEndTime: rec.attributes.stopTime
                                    };
                                }
                                else if (rec.attributes.callType === RecordingLegType.Consult && this.showConsultRecordings) {
                                    this.consultAudioSources.push({
                                        audioSrc: rec.attributes.filePath,
                                        absoluteStartTime: rec.attributes.startTime,
                                        absoluteEndTime: rec.attributes.stopTime
                                    });
                                }
                            });
                            this.consultAudioSources.sort((a, b) => a.absoluteStartTime - b.absoluteStartTime);
                            this.isEmpty = false;
                            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Fetched capture data successfully`);
                            return true;
                        }
                        else {
                            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[App:QMW] Fetched capture data successfully but failed to find a recording");
                            return true;
                        }
                    }
                }
                else {
                    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Invalid session id: ${this.sessionId}`);
                    return false;
                }
            });
        }
        resetData() {
            this.isEmpty = true;
            this.mainAudioSource = undefined;
            // Enhanced recording data
            this.captureResults = null;
            this.captureMetaDataResults = null;
            this.interactionDetailInfo.clear();
            this.consultAudioSources = [];
            this.consultChaptersData = [];
            this.customerChaptersData = [];
            this.interactionRecordingData = undefined;
            this.audioPlayerControlsClicked.clear();
        }
        getLocalizedString(detailType) {
            switch (detailType) {
                case InteractionDetailType.SessionId:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.sessionId");
                case InteractionDetailType.Agent:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.agent");
                case InteractionDetailType.StartTime:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.startTime");
                case InteractionDetailType.EndTime:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.endTime");
                case InteractionDetailType.Ani:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.ani");
                case InteractionDetailType.Duration:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.duration");
                case InteractionDetailType.Queue:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.queue");
                case InteractionDetailType.ConsultedAgents:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.consultedAgents");
                case InteractionDetailType.ConferenceAgents:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.conferenceAgents");
                default:
                    return "";
            }
        }
        handleCloseModal() {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_5__.QMW_RECORDINGS_MODAL_CLOSE_BTN_CLK, {
                bubbles: true,
                composed: true,
                detail: {
                    showEnhancedRecordings: this.showEnhancedRecordings,
                    numCustomerChapters: this.customerChaptersData.length,
                    numConsultChapters: this.consultChaptersData.length,
                    numMultiPartyConferences: this.customerChaptersData.filter((chapter) => chapter.chapterType === _utils__WEBPACK_IMPORTED_MODULE_6__.ChapterType.Conferencing).length,
                    chapterClickedTimes: (_a = this.audioPlayerControlsClicked.get(_AudioPlayer__WEBPACK_IMPORTED_MODULE_7__.AudioPlayerControlClicked.CHAPTER_CLICKED)) !== null && _a !== void 0 ? _a : 0,
                    visualizerClickedTimes: (_b = this.audioPlayerControlsClicked.get(_AudioPlayer__WEBPACK_IMPORTED_MODULE_7__.AudioPlayerControlClicked.VISUALIZER_CLICKED)) !== null && _b !== void 0 ? _b : 0,
                    seekBarChangedTimes: (_c = this.audioPlayerControlsClicked.get(_AudioPlayer__WEBPACK_IMPORTED_MODULE_7__.AudioPlayerControlClicked.SEEK_BAR_CHANGED)) !== null && _c !== void 0 ? _c : 0,
                    volumeControlChangedTimes: (_d = this.audioPlayerControlsClicked.get(_AudioPlayer__WEBPACK_IMPORTED_MODULE_7__.AudioPlayerControlClicked.VOLUME_CONTROL_CHANGED)) !== null && _d !== void 0 ? _d : 0,
                    playbackRateControlChangedTimes: (_e = this.audioPlayerControlsClicked.get(_AudioPlayer__WEBPACK_IMPORTED_MODULE_7__.AudioPlayerControlClicked.PLAYBACK_RATE_CONTROL_CHANGED)) !== null && _e !== void 0 ? _e : 0,
                    playClickedTimes: (_f = this.audioPlayerControlsClicked.get(_AudioPlayer__WEBPACK_IMPORTED_MODULE_7__.AudioPlayerControlClicked.PLAY_CLICKED)) !== null && _f !== void 0 ? _f : 0,
                    hasDataFetchError: this.getHasDataFetchError(),
                    hasRecordingPlaybackError: this.getHasRecordingPlaybackError(),
                    transcriptAvailable: this.transcriptAvailable,
                    hasTranscriptError: this.hasTranscriptError,
                    transcriptErrorMessage: (_g = this.transcriptErrorMessage) !== null && _g !== void 0 ? _g : "No Error Message",
                    transcriptChapterClickedTimes: (_h = this.audioPlayerControlsClicked.get(_AudioPlayer__WEBPACK_IMPORTED_MODULE_7__.AudioPlayerControlClicked.TRANSCRIPT_CLICKED)) !== null && _h !== void 0 ? _h : 0
                }
            }));
            this.setHasRecordingPlaybackError(false);
        }
        handleRecordingPlaybackError() {
            this.setHasRecordingPlaybackError(true);
        }
        handleDataFetchErrorRetry() {
            this.setHasDataFetchError(false);
            this.setTrackingID("");
        }
        audioPlayerControlClicked(e) {
            var _a, _b;
            const control = (_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.control;
            if (control !== undefined) {
                this.audioPlayerControlsClicked.set(control, ((_b = this.audioPlayerControlsClicked.get(control)) !== null && _b !== void 0 ? _b : 0) + 1);
            }
        }
        connectedCallback() {
            super.connectedCallback();
            this.addEventListener("playback-error", this.handleRecordingPlaybackError);
            this.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_5__.QMW_ERR_RETRY, this.handleDataFetchErrorRetry);
            this.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_5__.QMW_AUDIO_PLAYER_CONTROL_CLICKED, this.audioPlayerControlClicked);
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.removeEventListener("playback-error", this.handleRecordingPlaybackError);
            this.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_5__.QMW_ERR_RETRY, this.handleDataFetchErrorRetry);
            this.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_5__.QMW_AUDIO_PLAYER_CONTROL_CLICKED, this.audioPlayerControlClicked);
        }
        updated(changedProperties) {
            const _super = Object.create(null, {
                updated: { get: () => super.updated }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.updated.call(this, changedProperties);
                if (changedProperties.has("seekEvaluationTime") && this.audioPlayer) {
                    const chapterManager = this.audioPlayer.getChapterManager();
                    chapterManager.seek(this.seekEvaluationTime);
                }
                if (changedProperties.has("sessionId") ||
                    (changedProperties.has("hasDataFetchError") && changedProperties.get("hasDataFetchError"))) {
                    this.setIsLoading(true);
                    try {
                        if (this.showEnhancedRecordings) {
                            const isFetchSuccess = yield this.fetchData();
                            const isMediaDataValidated = this.processRequiredRecordingMediaData();
                            this.isEmpty = !isMediaDataValidated;
                            if (!this.isEmpty) {
                                this.processRicherMetadata();
                            }
                            if (!(this.showTranscript && (yield this.processTranscriptionData()))) {
                                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[App:QMW] Failed to create transcription for this Recording`);
                                this.transcriptAvailable = false;
                            }
                            this.setHasDataFetchError(!isFetchSuccess);
                        }
                        else {
                            yield this.fetchData();
                            this.setHasDataFetchError(false);
                        }
                    }
                    catch (err) {
                        if ((0,_utils__WEBPACK_IMPORTED_MODULE_6__.errorIsRetryable)(err === null || err === void 0 ? void 0 : err.details)) {
                            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[App:QMW] Failed to fetch capture data due to rate limit. Retrying`);
                            yield (0,_utils__WEBPACK_IMPORTED_MODULE_6__.wait)(err === null || err === void 0 ? void 0 : err.details);
                            yield this.fetchData();
                            if (this.showEnhancedRecordings) {
                                const isMediaDataValidated = this.processRequiredRecordingMediaData();
                                this.isEmpty = !isMediaDataValidated;
                                if (!this.isEmpty) {
                                    this.processRicherMetadata();
                                }
                            }
                        }
                        else {
                            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[App:QMW] Failed to fetch capture data`);
                            this.setHasDataFetchError(true);
                            this.setTrackingID((0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.getTrackingIdFromErrorObject)(err));
                        }
                    }
                    finally {
                        this.setIsLoading(false);
                    }
                }
            });
        }
        getHasDataFetchError() {
            return this.hasDataFetchError;
        }
        setHasDataFetchError(hasError) {
            this.hasDataFetchError = hasError;
        }
        getIsLoading() {
            return this.isLoading;
        }
        setIsLoading(isLoading) {
            this.isLoading = isLoading;
        }
        getTrackingId() {
            return this.trackingID;
        }
        setTrackingID(trackingID) {
            this.trackingID = trackingID;
        }
        getHasRecordingPlaybackError() {
            return this.hasRecordingPlaybackError;
        }
        setHasRecordingPlaybackError(hasRecordingPlaybackError) {
            this.hasRecordingPlaybackError = hasRecordingPlaybackError;
        }
        getRelativeTimesText(audioSource) {
            if (audioSource && this.mainAudioSource) {
                const startTimeDiff = audioSource.absoluteStartTime - this.mainAudioSource.absoluteStartTime;
                const endTimeDiff = audioSource.absoluteEndTime - this.mainAudioSource.absoluteStartTime;
                const startTimeFormatted = (0,_utils__WEBPACK_IMPORTED_MODULE_6__.relativeTimeFormatter)(startTimeDiff, endTimeDiff);
                const endTimeFormatted = (0,_utils__WEBPACK_IMPORTED_MODULE_6__.relativeTimeFormatter)(endTimeDiff, endTimeDiff);
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
          ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.startTime")} ${startTimeFormatted} <span></span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.endTime")} ${endTimeFormatted}
        `;
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ``;
        }
        getConsultRecordingsComponent() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        ${this.consultAudioSources.length > 0
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
              <div id="consult-recordings">
                <hr />
                <p>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.consultRecordings")} ${this.consultAudioSources.length}</p>
                ${this.consultAudioSources.slice(0).map((audioSource) => (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                    <dl class="agentx-wc-qmw-recording-modal-consult-container">
                      <div class="agentx-wc-qmw-recording-modal-consult-info">
                        <dt>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.consult")} ${this.consultAudioSources.indexOf(audioSource) + 1}</dt>
                        <dd>${this.getRelativeTimesText(audioSource)}</dd>
                      </div>
                    </dl>
                    <md-audio-player
                      class="audioplayer"
                      src=${audioSource.audioSrc}
                      .labelMap=${this.audioLabels}
                    ></md-audio-player>
                  `)}
              </div>
            `
                : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
      `;
        }
        getEnhancedAudioPlayerComponent() {
            var _a;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <agentx-wc-audio-player
          .interactionRecordingDetails=${this.interactionRecordingData}
          .customerChapters=${this.customerChaptersData}
          .consultChapters=${this.consultChaptersData}
          .interactionDetailInfo=${this.interactionDetailInfo}
          .agentName=${(_a = this.agentName) !== null && _a !== void 0 ? _a : ""}
          .customerTranscript=${this.customerTranscript}
          .transcriptAvailable=${this.transcriptAvailable}
        ></agentx-wc-audio-player>
      `;
        }
        getAudioSourceComponent() {
            const isDataValidForEnhancedView = this.showEnhancedRecordings && this.customerChaptersData.length > 0 && this.sessionId;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        ${isDataValidForEnhancedView
                ? this.getEnhancedAudioPlayerComponent()
                : this.mainAudioSource
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                <md-audio-player
                  class="audioplayer"
                  src=${this.mainAudioSource.audioSrc}
                  .labelMap=${this.audioLabels}
                ></md-audio-player>
                ${this.getConsultRecordingsComponent()}
              `
                    : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
      `;
        }
        renderRecordingModalComponent() {
            var _a, _b;
            if (this.hasDataFetchError && !this.isLoading) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
          <agentx-wc-qmw-grid-error
            .trackingID=${this.trackingID}
            .errorElement=${_constants__WEBPACK_IMPORTED_MODULE_5__.RECORDING}
          ></agentx-wc-qmw-grid-error>
        `;
            }
            if (this.isLoading) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <agentx-wc-widget-loader></agentx-wc-widget-loader> `;
            }
            if (this.isEmpty) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <agentx-wc-qmw-empty-grid .emptyElement=${_constants__WEBPACK_IMPORTED_MODULE_5__.RECORDING}></agentx-wc-qmw-empty-grid> `;
            }
            // Note: After GA for enhanced recordings feature, we will deprecate the HTML below and use the enhanced recording component
            if (!this.showEnhancedRecordings) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
          <div id="scrollable-content">
            <md-alert-banner .show=${this.hasRecordingPlaybackError} type="error">
              <p class="agentx-wc-qmw-recording-modal-playback-error-text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.recordingPlaybackError")}</p>
            </md-alert-banner>
            <dl class="agentx-wc-qmw-recording-modal-properties-container">
              <div class="agentx-wc-qmw-recording-modal-properties">
                <dt>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.sessionId")}</dt>
                <dd>${this.sessionId}</dd>
              </div>
              <div class="agentx-wc-qmw-recording-modal-properties">
                <dt>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.ani")}</dt>
                <dd>${this.ani}</dd>
              </div>
              <div class="agentx-wc-qmw-recording-modal-properties">
                <dt>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.startTime")}</dt>
                <dd>${(0,_utils__WEBPACK_IMPORTED_MODULE_6__.dateFormatterShortWithSeconds)(((_a = this.mainAudioSource) === null || _a === void 0 ? void 0 : _a.absoluteStartTime) || 0)}</dd>
              </div>
              <div class="agentx-wc-qmw-recording-modal-properties">
                <dt>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.endTime")}</dt>
                <dd>${(0,_utils__WEBPACK_IMPORTED_MODULE_6__.dateFormatterShortWithSeconds)(((_b = this.mainAudioSource) === null || _b === void 0 ? void 0 : _b.absoluteEndTime) || 0)}</dd>
              </div>
              <div class="agentx-wc-qmw-recording-modal-properties">
                <dt>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.agent")}</dt>
                <dd>${this.agentName}</dd>
              </div>
              ${this.getAudioSourceComponent()}
            </dl>
          </div>
        `;
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <md-alert-banner .show=${this.hasRecordingPlaybackError} type="error">
          <p class="agentx-wc-qmw-recording-modal-playback-error-text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.recordingPlaybackError")}</p>
        </md-alert-banner>
        ${this.getAudioSourceComponent()}
      `;
        }
        renderWithEnhancedRecordings() {
            const ariaLabelCloseText = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.close");
            if (!this.showInModal) {
                // Render only the recording modal content
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <section>${this.renderRecordingModalComponent()}</section> `;
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <md-modal
          .show=${this.isModalOpen}
          size="large"
          .hideFooter=${true}
          .showCloseButton=${true}
          ariaLabelClose=${ariaLabelCloseText}
          .backdropClickExit=${true}
          headerLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.recordingPlayback")}
          @close-modal=${() => this.handleCloseModal()}
          class="agentx-wc-qmw-recording-modal"
          .disableInitialFocus=${true}
        >
          <section>${this.renderRecordingModalComponent()}</section>
          <section slot="footer">
            <md-button variant="secondary" @click=${() => (this.isModalOpen = false)} ariaLabel=${ariaLabelCloseText}>
              ${ariaLabelCloseText}
            </md-button>
          </section>
        </md-modal>
      `;
        }
        render() {
            const ariaLabelCloseText = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.close");
            // Note: After GA for enhanced recordings feature, we will deprecate the HTML below and use the enhanced recording component
            if (!this.showEnhancedRecordings) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
          <md-modal
            .show=${this.isModalOpen}
            size="small"
            .hideFooter=${true}
            .showCloseButton=${true}
            ariaLabelClose=${ariaLabelCloseText}
            .backdropClickExit=${true}
            headerLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.recordingPlayback")}
            @close-modal=${() => this.handleCloseModal()}
            class="agentx-wc-qmw-recording-modal"
            .disableInitialFocus=${true}
          >
            ${this.renderRecordingModalComponent()}
            <section slot="footer">
              <md-button variant="secondary" @click=${() => (this.isModalOpen = false)} ariaLabel=${ariaLabelCloseText}>
                ${ariaLabelCloseText}
              </md-button>
            </section>
          </md-modal>
        `;
            }
            else {
                return this.renderWithEnhancedRecordings();
            }
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "sessionId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "ani", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "queue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "agentName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "showConsultRecordings", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "showEnhancedRecordings", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "showTranscript", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Number })
    ], Element.prototype, "startTimeFromGrid", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "showInModal", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Number })
    ], Element.prototype, "seekEvaluationTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "absoluteStartTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "absoluteStopTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "mainAudioSource", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "consultAudioSources", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "hasDataFetchError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "hasRecordingPlaybackError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "trackingID", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isEmpty", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "interactionRecordingData", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "customerChaptersData", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "consultChaptersData", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "customerTranscript", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "interactionDetailInfo", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "captureResults", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "captureMetaDataResults", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "audioPlayerControlsClicked", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)("agentx-wc-audio-player")
    ], Element.prototype, "audioPlayer", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-qmw-recording-details")
    ], Element);
    RecordingDetails.Element = Element;
})(RecordingDetails || (RecordingDetails = {}));


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationConfirmationModal.scss":
/*!********************************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/evaluations/EvaluationConfirmationModal.scss ***!
  \********************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.btn-wrapper .discard {
  margin-left: 10px;
}
.btn-wrapper .discard,
.btn-wrapper .return {
  float: right;
  margin-right: 10px;
}

.header-width {
  width: 100%;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/components/evaluations/EvaluationConfirmationModal.scss */
/*# sourceURL=EvaluationConfirmationModal.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvUXVhbGl0eU1vbml0b3JpbmdXaWRnZXQvY29tcG9uZW50cy9ldmFsdWF0aW9ucy9FdmFsdWF0aW9uQ29uZmlybWF0aW9uTW9kYWwuc2NzcyIsIkV2YWx1YXRpb25Db25maXJtYXRpb25Nb2RhbC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNFO0VBQ0UsaUJBQUE7QUNBSjtBREVFOztFQUVFLFlBQUE7RUFDQSxrQkFBQTtBQ0FKOztBRElBO0VBQ0UsV0FBQTtBQ0RGIiwiZmlsZSI6IkV2YWx1YXRpb25Db25maXJtYXRpb25Nb2RhbC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmJ0bi13cmFwcGVyIHtcbiAgLmRpc2NhcmQge1xuICAgIG1hcmdpbi1sZWZ0OiAxMHB4O1xuICB9XG4gIC5kaXNjYXJkLFxuICAucmV0dXJuIHtcbiAgICBmbG9hdDogcmlnaHQ7XG4gICAgbWFyZ2luLXJpZ2h0OiAxMHB4O1xuICB9XG59XG5cbi5oZWFkZXItd2lkdGgge1xuICB3aWR0aDogMTAwJTtcbn1cbiIsIi5idG4td3JhcHBlciAuZGlzY2FyZCB7XG4gIG1hcmdpbi1sZWZ0OiAxMHB4O1xufVxuLmJ0bi13cmFwcGVyIC5kaXNjYXJkLFxuLmJ0bi13cmFwcGVyIC5yZXR1cm4ge1xuICBmbG9hdDogcmlnaHQ7XG4gIG1hcmdpbi1yaWdodDogMTBweDtcbn1cblxuLmhlYWRlci13aWR0aCB7XG4gIHdpZHRoOiAxMDAlO1xufSJdfQ== */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationConfirmationModal.ts":
/*!******************************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/evaluations/EvaluationConfirmationModal.ts ***!
  \******************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EvaluationConfirmationModal: () => (/* binding */ EvaluationConfirmationModal)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html_lib_part__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html/lib/part */ "lit-html/lib/part");
/* harmony import */ var lit_html_lib_part__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html_lib_part__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _EvaluationConfirmationModal_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./EvaluationConfirmationModal.scss */ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationConfirmationModal.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let EvaluationConfirmationModal = class EvaluationConfirmationModal extends lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement {
    constructor() {
        super(...arguments);
        this.showModal = false;
    }
    static get styles() {
        return _EvaluationConfirmationModal_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    confirmExit() {
        this.dispatchEvent(new CustomEvent("confirm-exit"));
    }
    declineExit() {
        this.dispatchEvent(new CustomEvent("decline-exit"));
    }
    render() {
        return this.showModal
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
          <md-modal
            applicationId="evaluationConfirmation"
            ?show=${this.showModal}
            id="evaluationConfirmationModal"
            size="dialog"
            .hideFooter=${true}
            headerLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationConfirmation")}
            ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationConfirmation")}
            tabindex="${"-1"}"
            ?showclosebutton=${false}
            .ariaLabelClose=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationConfirmationReturn")}
          >
            <div class="modal-body">
              <span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationConfirmationMessage")}</span>
            </div>
            <div slot="footer" class="btn-wrapper">
              <md-button
                class="discard"
                variant="primary"
                @click="${this.confirmExit}"
                type="submit"
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationConfirmationDiscard")}
              >
                ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationConfirmationDiscard")}</md-button
              >
              <md-button
                class="return"
                variant="secondary"
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationConfirmationReturn")}
                type="reset"
                @click="${this.declineExit}"
              >
                ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationConfirmationReturn")}</md-button
              >
            </div>
          </md-modal>
        `
            : lit_html_lib_part__WEBPACK_IMPORTED_MODULE_2__.nothing;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], EvaluationConfirmationModal.prototype, "showModal", void 0);
EvaluationConfirmationModal = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-qmw-evaluation-confirmation-modal")
], EvaluationConfirmationModal);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationForm.scss":
/*!*******************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/evaluations/EvaluationForm.scss ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.form__container {
  display: grid;
  grid-template-rows: auto 1fr auto;
  height: 100%;
}
.form__container .form__content {
  overflow-y: auto;
}
.form__container .form__content .section {
  padding: 1rem 1rem 0px 1rem;
  border-radius: 5px;
}
.form__container .form__content .section h4 {
  background-color: var(--color-link);
  padding: 0.5rem 1rem;
  margin: -1rem -1rem 1rem -1rem;
  border-radius: 5px 5px 0 0;
  color: white;
}
.form__container .form__content .section .label__container {
  display: flex;
}
.form__container .form__content .section .label__container .tooltip__container {
  display: inline-block;
  top: 0.2rem;
  position: relative;
}
.form__container .form__content .section .options__container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.form__container .form__content .section .comment-btn__wrapper {
  display: flex;
  align-items: flex-end;
  margin-top: 50px;
}
.form__container .form__content .section .radio-group__wrapper {
  flex: 1;
}
.form__container .form__content .section .comment__input textarea {
  width: 95%;
  padding: 0.5rem;
  border: 1px solid var(--color-gray-border);
  border-radius: 5px;
  resize: none;
}
.form__container .form__content .ai-assist__container {
  border: solid 1px var(--color-gray-border);
  border-radius: 10px;
  padding: 5px;
  margin-bottom: 15px;
}
.form__container .form__content .ai-assist__container .detection-points__container {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding-left: 20px;
}
.form__container md-radiogroup {
  display: flex;
  padding: 1rem;
}
.form__container .form__footer {
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=EvaluationForm.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/components/evaluations/EvaluationForm.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationForm.ts":
/*!*****************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/evaluations/EvaluationForm.ts ***!
  \*****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EvaluationForm: () => (/* binding */ EvaluationForm)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! uuid */ "uuid");
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(uuid__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils */ "./src/components/QualityMonitoringWidget/utils.ts");
/* harmony import */ var _EvaluationForm_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./EvaluationForm.scss */ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationForm.scss");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









const DEBOUNCE_SAVE = 2000;
const COMMENT_INPUT_ROWS = 3;
let EvaluationForm = class EvaluationForm extends lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement {
    constructor() {
        super(...arguments);
        this.evaluationForm = {
            id: "",
            name: "",
            sections: [],
            status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.EvaluationStatus.ACTIVE
        };
        this.evaluationMode = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.EvaluationMode.CREATE;
        this.pendingAiEvaluationResults = false;
        this.radioAlignment = "vertical";
        this.commentVisibility = {};
        this.debouncedHandleAutoSave = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.debounce)(() => this.handleAutoSave(), DEBOUNCE_SAVE);
    }
    static get styles() {
        return _EvaluationForm_scss__WEBPACK_IMPORTED_MODULE_7__["default"];
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.evaluationForm) {
            this.commentVisibility = Object.fromEntries(this.evaluationForm.sections.flatMap((section) => section.questions.map((question) => {
                if (question.comment) {
                    return [question.id, true];
                }
                return [question.id, false];
            })));
        }
    }
    firstUpdated() {
        requestAnimationFrame(() => {
            const firstRadio = this.renderRoot.querySelector("md-radio");
            if (firstRadio) {
                firstRadio.focus();
            }
        });
    }
    render() {
        var _a;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div class="form__container">
        <!-- FORM-CONTENT -->
        <div class="form__content">
          ${(_a = this.evaluationForm) === null || _a === void 0 ? void 0 : _a.sections.map((section, sectionIndex) => (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
              <!-- FORM-SECTION -->
              <div class="section">
                <h4>${section.name}</h4>
                ${section.questions.map((question, questionIndex) => {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                    <!-- QUESTIONS -->
                    <div class="label__container">
                      <label class="question-label"
                        >${this.getQuestionNumber(sectionIndex, questionIndex)}. ${question.text}
                        (${this.getWeightForQuestion(question)})
                        ${question.tooltipText
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                              <div class="tooltip__container">
                                <md-tooltip message="${question.tooltipText}" placement="top">
                                  <md-icon name="info-circle-bold" size="16" iconSet="momentumDesign"></md-icon>
                                </md-tooltip>
                              </div>
                            `
                : ""}
                      </label>
                    </div>
                    <!-- OPTIONS -->
                    <div class="options__container">
                      ${this.getOptionsSection(question, sectionIndex)} ${this.renderCommentButton(question.id)}
                    </div>
                    ${this.renderAIAssistSection(question)} ${this.renderCommentSection(question, sectionIndex)}
                  `;
        })}
              </div>
            `)}
        </div>
        ${this.renderFormFooter()}
      </div>
    `;
    }
    handleSubmit(event) {
        this.setSubmissionInfo();
        event.preventDefault();
        this.dispatchEvent(new CustomEvent("evaluation-submit", {
            detail: { message: "Form submitted" },
            bubbles: true,
            composed: true
        }));
    }
    handleAutoSave() {
        _sdk__WEBPACK_IMPORTED_MODULE_8__.logger.info("[Evaluation Form] Auto save request firing");
        this.dispatchEvent(new CustomEvent("evaluation-auto-save", {
            detail: { message: "Auto save request" },
            bubbles: true,
            composed: true
        }));
    }
    setSubmissionInfo() {
        this.evaluationForm = Object.assign(Object.assign({}, this.evaluationForm), { submittedOn: new Date(), submittedBy: "", submissionId: (0,uuid__WEBPACK_IMPORTED_MODULE_5__.v4)() });
    }
    getQuestionNumber(sectionIndex, questionIndex) {
        var _a;
        const previousSections = (_a = this.evaluationForm) === null || _a === void 0 ? void 0 : _a.sections.slice(0, sectionIndex);
        const previousQuestionsCount = (previousSections === null || previousSections === void 0 ? void 0 : previousSections.reduce((count, section) => count + section.questions.length, 0)) || 0;
        return previousQuestionsCount + questionIndex + 1;
    }
    renderFormFooter() {
        if (this.evaluationMode === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.EvaluationMode.VIEW) {
            return lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div class="form__footer">
        <md-button type="button" variant="secondary" @click=${this.handleDiscard}> ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.discard")} </md-button>
        <md-button type="submit" variant="primary" @click=${this.handleSubmit}> ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.submit")} </md-button>
      </div>
    `;
    }
    handleDiscard() {
        this.dispatchEvent(new CustomEvent("evaluation-form-discard", {
            bubbles: true,
            composed: true
        }));
    }
    getOptionsSection(question, sectionIndex) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <md-form>
        <div class="radio-group__wrapper">
          <md-radiogroup
            group-label=${question.id}
            .alignment=${this.radioAlignment}
            ?disabled=${this.evaluationMode === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.EvaluationMode.VIEW}
            @radio-change=${(event) => this.handleRadioChange(event, sectionIndex, question.id)}
          >
            ${question.options.map((option) => (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                <md-radio slot="radio" .value=${option.text} .checked=${question.selectedAnswer === option.text}
                  >${option.text}</md-radio
                >
              `)}
          </md-radiogroup>
        </div>
      </md-form>
    `;
    }
    renderCommentSection(question, sectionIndex) {
        if (!this.commentVisibility[question.id]) {
            return lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div class="comment__input">
        <label>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.comment")}</label>
        <textarea
          ?disabled=${this.evaluationMode === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.EvaluationMode.VIEW}
          rows="${COMMENT_INPUT_ROWS}"
          @input=${(event) => this.handleCommentInput(event, sectionIndex, question.id)}
        >
${question.comment}</textarea
        >
      </div>
    `;
    }
    toggleCommentVisibility(questionId) {
        this.commentVisibility = Object.assign(Object.assign({}, this.commentVisibility), { [questionId]: !this.commentVisibility[questionId] });
    }
    handleRadioChange(event, sectionIndex, questionId) {
        const selectedAnswer = event.detail.selected;
        this.updateFormSubmission(sectionIndex, questionId, (question) => (Object.assign(Object.assign({}, question), { selectedAnswer })));
    }
    handleCommentInput(event, sectionIndex, questionId) {
        const text = event.target.value;
        this.updateFormSubmission(sectionIndex, questionId, (question) => (Object.assign(Object.assign({}, question), { comment: text })));
    }
    renderCommentButton(questionId) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <div>
      <div class="comment-btn__wrapper">
        <md-tooltip placement="top" message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.addComment")}">
          <md-button circle variant="secondary" size="28" @click=${() => this.toggleCommentVisibility(questionId)}>
            <md-icon name="commenting-light" size="16" iconSet="momentumDesign"></md-icon>
          </md-button>
        </md-tooltip>
      </div>
    </div>`;
    }
    getWeightForQuestion(question) {
        const maxWeight = Math.max(...question.options.map((option) => Number(option.weight) || 0));
        return `${maxWeight}%`;
    }
    dispatchChapterSelectedEvent(timestamp) {
        this.dispatchEvent(new CustomEvent("seek-audio", {
            bubbles: true,
            composed: true,
            detail: { seekTo: timestamp }
        }));
    }
    renderAIAssistSection(question) {
        var _a;
        if (this.pendingAiEvaluationResults) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<md-spinner size="36"></md-spinner>`;
        }
        if (!question.aiEvalDetails || this.evaluationMode === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.EvaluationMode.VIEW) {
            return lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing;
        }
        const aiEvalDetails = question.aiEvalDetails;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<div class="ai-assist__container">
      <div>
        <md-icon name="cisco-ai-assistant-solid-bold" size="16" iconSet="momentumDesign"></md-icon>
        <strong>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.aiAssistRecommendation", "", { defaultValue: aiEvalDetails === null || aiEvalDetails === void 0 ? void 0 : aiEvalDetails.recommendation })}</strong>
      </div>

      <div class="detection-points__container">
        <span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.aiAssistConfidence", "", { defaultValue: aiEvalDetails === null || aiEvalDetails === void 0 ? void 0 : aiEvalDetails.confidence })}</span>
        ${(_a = aiEvalDetails === null || aiEvalDetails === void 0 ? void 0 : aiEvalDetails.detectionPoints) === null || _a === void 0 ? void 0 : _a.map((detectionPoint) => (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
            <span>
              <md-link tag="span" @click=${() => this.dispatchChapterSelectedEvent(detectionPoint.timestamp)}>
                ${(0,_utils__WEBPACK_IMPORTED_MODULE_6__.relativeTimeFormatter)(detectionPoint.timestamp)}
              </md-link>
              <span>${detectionPoint.label}</span>
            </span>
          `)}
      </div>
    </div>`;
    }
    updateFormSubmission(sectionIndex, questionId, updateCallback) {
        this.evaluationForm = Object.assign(Object.assign({}, this.evaluationForm), { sections: this.evaluationForm.sections.map((section, index) => index === sectionIndex
                ? Object.assign(Object.assign({}, section), { questions: section.questions.map((question) => question.id === questionId ? updateCallback(question) : question) }) : section) });
        this.dispatchEvent(new CustomEvent("evaluation-updated", {
            detail: { evaluationForm: this.evaluationForm },
            bubbles: true,
            composed: true
        }));
        this.debouncedHandleAutoSave();
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
], EvaluationForm.prototype, "evaluationForm", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], EvaluationForm.prototype, "evaluationMode", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
], EvaluationForm.prototype, "pendingAiEvaluationResults", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], EvaluationForm.prototype, "radioAlignment", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], EvaluationForm.prototype, "commentVisibility", void 0);
EvaluationForm = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-evaluation-form")
], EvaluationForm);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationViewer.scss":
/*!*********************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/evaluations/EvaluationViewer.scss ***!
  \*********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.content {
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: 2fr 1fr;
  column-gap: 1rem;
  height: calc(100% - 15px);
  padding: 0 1rem 1rem 1rem;
  background-color: white;
}
.content .header {
  grid-column: 1/-1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.content .header span {
  font-weight: 400;
}
.content .loading__container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40%;
}
.content .empty-state__container {
  margin-top: 10rem;
}
.content .form-header__container {
  display: flex;
}
.content .form-header__container .form-header__name {
  margin-top: 0.2rem;
  font-size: 1rem;
  font-weight: 700;
  flex-grow: 1;
}
.content .form-header__container .form-header__name span {
  font-style: italic;
}
.content .loading__container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40%;
}
.content .empty-state__container {
  margin-top: 10rem;
}
.content .empty-state__header {
  display: flex;
  justify-content: flex-end;
}
.content .empty-state__header .close-icon {
  display: flex;
}
.content .left-panel,
.content .right-panel {
  padding: 1rem 1rem 0 1rem;
  border: 1px solid var(--color-gray-border);
  overflow-y: auto;
}

.saving-indicator {
  display: flex;
  align-items: center;
  gap: 3px;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=EvaluationViewer.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/components/evaluations/EvaluationViewer.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2Fzc2V0cy9zdHlsZXMvdmFyaWFibGVzLnNjc3MiLCJFdmFsdWF0aW9uVmlld2VyLnNjc3MiLCIvaG9tZS9qZW5raW5zL2FnZW50L3dvcmtzcGFjZS93eGNjLXNlcnZpY2UtbWFuYWdlbWVudC93eGNjLXNlcnZpY2UtbWFuYWdlbWVudC9wYWNrYWdlcy9hZ2VudHgtbWZlLXdjLWJhc2VkL3NyYy9jb21wb25lbnRzL1F1YWxpdHlNb25pdG9yaW5nV2lkZ2V0L2NvbXBvbmVudHMvZXZhbHVhdGlvbnMvRXZhbHVhdGlvblZpZXdlci5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsY0FBQTtFQUNBLHVCQUFBO0VBQ0Esd0JBQUE7RUFDQSx1QkFBQTtFQUVBLG1CQUFBO0VBQ0EsMkJBQUE7RUFDQSx1QkFBQTtFQUNBLDRCQUFBO0VBRUEsWUFBQTtFQUNBLDBCQUFBO0VBRUEsZ0JBQUE7RUFDQSx1QkFBQTtFQUNBLG9EQUFBO0VBQ0EsMkRBQUE7RUFFQSxnQkFBQTtFQUNBLDhEQUFBO0VBQ0E7O2NBQUE7RUFHQSxpSEFBQTtFQUVBLFdBQUE7RUFDQSw0QkFBQTtFQUNBLHdCQUFBO0VBQ0Esd0JBQUE7RUFDQSx3QkFBQTtFQUNBLHlCQUFBO0VBQ0Esd0JBQUE7RUFDQSxxQkFBQTtFQUNBLDZCQUFBO0VBQ0EseUJBQUE7RUFDQSwyQkFBQTtFQUNBLGlDQUFBO0VBRUEsa0JBQUE7RUFDQSwwQkFBQTtFQUNBLDJCQUFBO0VBQ0EsMkJBQUE7RUFDQSw0QkFBQTtFQUVBLGNBQUE7RUFDQSxtREFBQTtFQUNBLG1DQUFBO0VBQ0EsaUNBQUE7RUFFQSxlQUFBO0VBQ0Esc0JBQUE7RUFDQSx1QkFBQTtFQUVBLGVBQUE7RUFDQSxpREFBQTtFQUNBLGdEQUFBO0VBQ0Esd0JBQUE7RUFDQSxnREFBQTtFQUVBLG9CQUFBO0VBQ0EsWUFBQTtFQUNBLFlBQUE7RUFDQSxjQUFBO0VBRUEsc0JBQUE7RUFDQSxlQUFBO0VBQ0EsaUJBQUE7RUFDQSxpQkFBQTtFQUNBLGlCQUFBO0FDVkY7O0FDekRBO0VBQ0UsYUFBQTtFQUNBLDRCQUFBO0VBQ0EsOEJBQUE7RUFDQSxnQkFBQTtFQUNBLHlCQUFBO0VBQ0EseUJBQUE7RUFDQSx1QkFBQTtBRDRERjtBQzFERTtFQUNFLGlCQUFBO0VBQ0EsYUFBQTtFQUNBLDhCQUFBO0VBQ0EsbUJBQUE7QUQ0REo7QUMxREk7RUFDRSxnQkFBQTtBRDRETjtBQ3hERTtFQUNFLGFBQUE7RUFDQSx1QkFBQTtFQUNBLG1CQUFBO0VBQ0EsV0FBQTtBRDBESjtBQ3ZERTtFQUNFLGlCQUFBO0FEeURKO0FDdERFO0VBQ0UsYUFBQTtBRHdESjtBQ3RESTtFQUNFLGtCQUFBO0VBQ0EsZUFBQTtFQUNBLGdCQUFBO0VBQ0EsWUFBQTtBRHdETjtBQ3RETTtFQUNFLGtCQUFBO0FEd0RSO0FDbkRFO0VBQ0UsYUFBQTtFQUNBLHVCQUFBO0VBQ0EsbUJBQUE7RUFDQSxXQUFBO0FEcURKO0FDbERFO0VBQ0UsaUJBQUE7QURvREo7QUNqREU7RUFDRSxhQUFBO0VBQ0EseUJBQUE7QURtREo7QUNqREk7RUFDRSxhQUFBO0FEbUROO0FDL0NFOztFQUVFLHlCQUFBO0VBQ0EsMENBQUE7RUFDQSxnQkFBQTtBRGlESjs7QUM5Q0E7RUFDRSxhQUFBO0VBQ0EsbUJBQUE7RUFDQSxRQUFBO0FEaURGIiwiZmlsZSI6IkV2YWx1YXRpb25WaWV3ZXIuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgLyogRm9udCBTaXplICovXG4gIC0tZm9udC1zaXplLXNtYWxsOiAxMnB4O1xuICAtLWZvbnQtc2l6ZS1tZWRpdW06IDE0cHg7XG4gIC0tZm9udC1zaXplLWxhcmdlOiAxNnB4O1xuXG4gIC8qIFNwYWNpbmcgdG9rZW5zICovXG4gIC0tc3BhY2UtdG9rZW4tY2FyZGluYWw6IDVweDtcbiAgLS1zcGFjZS10b2tlbi1ldmVuOiAycHg7XG4gIC0tc3BhY2UtZXJyb3ItaW5wdXQ6IDRweCA4cHg7XG5cbiAgLyogSGVpZ2h0cyAqL1xuICAtLWVycm9yLWlucHV0LWhlaWdodDogMzJweDtcblxuICAvKiBGb250IFdlaWdodCAqL1xuICAtLWZvbnQtd2VpZ2h0LWxpdGU6IDMwMDtcbiAgLS1mb250LXdlaWdodDogdmFyKC0tYnJhbmQtZm9udC13ZWlnaHQtcmVndWxhciwgNDAwKTtcbiAgLS1mb250LXdlaWdodC1tZWRpdW06IHZhcigtLWJyYW5kLWZvbnQtd2VpZ2h0LXJlZ3VsYXIsIDUwMCk7XG5cbiAgLyogRm9udCBmYW1pbHkgKi9cbiAgLS1mb250LWZhbWlseS1ib2xkOiB2YXIoLS1icmFuZC1mb250LWJvbGQsIFwiQ2lzY29TYW5zVFQgQm9sZFwiKTtcbiAgLS1mb250LWZhbWlseTpcbiAgICB2YXIoLS1icmFuZC1mb250LXJlZ3VsYXIsIFwiQ2lzY29TYW5zVFQgUmVndWxhclwiKSwgXCJDaXNjb1NhbnNUVCBSZWd1bGFyXCIsIFwiSGVsdmV0aWNhIE5ldWVcIiwgSGVsdmV0aWNhLCBBcmlhbCxcbiAgICBzYW5zLXNlcmlmO1xuICAtLWZvbnQtZmFtaWx5LWxpZ2h0OiB2YXIoLS1icmFuZC1mb250LWxpZ2h0LCBcIkNpc2NvU2Fuc1RUIExpZ2h0XCIpLCBcIkhlbHZldGljYSBOZXVlXCIsIEhlbHZldGljYSwgQXJpYWwsIHNhbnMtc2VyaWY7XG5cbiAgLyogQ29sb3JzICovXG4gIC0tbGlnaHQtZ3JlZW4tY29sb3I6ICM0NGNmNTA7XG4gIC0tY29sb3ItZ3JheS0xMDogI2VkZWRlZDtcbiAgLS1jb2xvci1ncmF5LTMwOiAjZDJkNWQ2O1xuICAtLWNvbG9yLWdyYXktNzA6ICM1NDU0NTQ7XG4gIC0tY29sb3ItZ3JheS0xMDA6ICMxMjEyMTI7XG4gIC0tY29sb3ItYmx1ZS03MDogIzAwNWU3ZDtcbiAgLS1jb2xvci1saW5rOiAjMDBhMGQxO1xuICAtLWNvbG9yLWVycm9yLWRldGFpbDogIzUzNTc1OTtcbiAgLS1jb2xvci1ncmF5LWJvcmRlcjogI2NjYztcbiAgLS1jb2xvci1lcnJvci10ZXh0OiAjYTEyNTEyO1xuICAtLWNvbG9yLWNvdW50LW5vdGlmaWNhdGlvbnM6ICNmZmY7XG5cbiAgLyogQm9yZGVyIHJhZGl1cyAqL1xuICAtLWJvcmRlci1yYWRpdXMtc21hbGw6IDRweDtcbiAgLS1ib3JkZXItcmFkaXVzLW1lZGl1bTogOHB4O1xuICAtLWJvcmRlci1yYWRpdXMtbGFyZ2U6IDEycHg7XG4gIC0tYm9yZGVyLXJhZGl1cy1jaXJjbGU6IDEwMCU7XG5cbiAgLyogQW5pbWF0aW9uICovXG4gIC0tZWFzZS1pbi1vdXQtcXVpbnQ6IGN1YmljLWJlemllcigwLjgzLCAwLCAwLjE3LCAxKTtcbiAgLS1kZWZhdWx0LWFuaW1hdGlvbi1kdXJhdGlvbjogMzAwbXM7XG4gIC0tcXVpY2stYW5pbWF0aW9uLWR1cmF0aW9uOiAxNTBtcztcblxuICAvKiBzY3JvbGwgYmFyICovXG4gIC0tc2Nyb2xsYmFyLXdpZHRoOiA2cHg7XG4gIC0tc2Nyb2xsYmFyLWhlaWdodDogOHB4O1xuXG4gIC8qIEJveCBzaGFkb3cgKi9cbiAgLS1ib3gtc2hhZG93OiAwIDAgNHB4IDJweCByZ2JhKDAsIDE2MCwgMjA5LCAwLjc1KTtcbiAgLS1ib3gtc2hhZG93LWdyYXk6IDAgNHB4IDhweCByZ2JhKDAsIDAsIDAsIDAuMDgpO1xuICAtLXRwdy1maWx0ZXItaGVpZ2h0OiAwcHg7XG4gIC0td2Via2l0LWJveC1zaGFkb3c6IDAgMCAxcHggcmdiYSg4NCwgODQsIDg0LCAxKTtcblxuICAvKiBHYXAgYW5kIHBhZGRpbmcgKi9cbiAgLS1nYXAtNDogNHB4O1xuICAtLWdhcC04OiA4cHg7XG4gIC0tZ2FwLTEyOiAxMnB4O1xuXG4gIC8qIFdpZHRocyBhbmQgaGVpZ2h0cyovXG4gIC0tbGVuZ3RoLTQ6IDRweDtcbiAgLS1sZW5ndGgtMjA6IDIwcHg7XG4gIC0tbGVuZ3RoLTI0OiAyNHB4O1xuICAtLWxlbmd0aC0zMjogMzJweDtcbn1cbiIsIjpob3N0IHtcbiAgLyogRm9udCBTaXplICovXG4gIC0tZm9udC1zaXplLXNtYWxsOiAxMnB4O1xuICAtLWZvbnQtc2l6ZS1tZWRpdW06IDE0cHg7XG4gIC0tZm9udC1zaXplLWxhcmdlOiAxNnB4O1xuICAvKiBTcGFjaW5nIHRva2VucyAqL1xuICAtLXNwYWNlLXRva2VuLWNhcmRpbmFsOiA1cHg7XG4gIC0tc3BhY2UtdG9rZW4tZXZlbjogMnB4O1xuICAtLXNwYWNlLWVycm9yLWlucHV0OiA0cHggOHB4O1xuICAvKiBIZWlnaHRzICovXG4gIC0tZXJyb3ItaW5wdXQtaGVpZ2h0OiAzMnB4O1xuICAvKiBGb250IFdlaWdodCAqL1xuICAtLWZvbnQtd2VpZ2h0LWxpdGU6IDMwMDtcbiAgLS1mb250LXdlaWdodDogdmFyKC0tYnJhbmQtZm9udC13ZWlnaHQtcmVndWxhciwgNDAwKTtcbiAgLS1mb250LXdlaWdodC1tZWRpdW06IHZhcigtLWJyYW5kLWZvbnQtd2VpZ2h0LXJlZ3VsYXIsIDUwMCk7XG4gIC8qIEZvbnQgZmFtaWx5ICovXG4gIC0tZm9udC1mYW1pbHktYm9sZDogdmFyKC0tYnJhbmQtZm9udC1ib2xkLCBcIkNpc2NvU2Fuc1RUIEJvbGRcIik7XG4gIC0tZm9udC1mYW1pbHk6XG4gICAgdmFyKC0tYnJhbmQtZm9udC1yZWd1bGFyLCBcIkNpc2NvU2Fuc1RUIFJlZ3VsYXJcIiksIFwiQ2lzY29TYW5zVFQgUmVndWxhclwiLCBcIkhlbHZldGljYSBOZXVlXCIsIEhlbHZldGljYSwgQXJpYWwsXG4gICAgc2Fucy1zZXJpZjtcbiAgLS1mb250LWZhbWlseS1saWdodDogdmFyKC0tYnJhbmQtZm9udC1saWdodCwgXCJDaXNjb1NhbnNUVCBMaWdodFwiKSwgXCJIZWx2ZXRpY2EgTmV1ZVwiLCBIZWx2ZXRpY2EsIEFyaWFsLCBzYW5zLXNlcmlmO1xuICAvKiBDb2xvcnMgKi9cbiAgLS1saWdodC1ncmVlbi1jb2xvcjogIzQ0Y2Y1MDtcbiAgLS1jb2xvci1ncmF5LTEwOiAjZWRlZGVkO1xuICAtLWNvbG9yLWdyYXktMzA6ICNkMmQ1ZDY7XG4gIC0tY29sb3ItZ3JheS03MDogIzU0NTQ1NDtcbiAgLS1jb2xvci1ncmF5LTEwMDogIzEyMTIxMjtcbiAgLS1jb2xvci1ibHVlLTcwOiAjMDA1ZTdkO1xuICAtLWNvbG9yLWxpbms6ICMwMGEwZDE7XG4gIC0tY29sb3ItZXJyb3ItZGV0YWlsOiAjNTM1NzU5O1xuICAtLWNvbG9yLWdyYXktYm9yZGVyOiAjY2NjO1xuICAtLWNvbG9yLWVycm9yLXRleHQ6ICNhMTI1MTI7XG4gIC0tY29sb3ItY291bnQtbm90aWZpY2F0aW9uczogI2ZmZjtcbiAgLyogQm9yZGVyIHJhZGl1cyAqL1xuICAtLWJvcmRlci1yYWRpdXMtc21hbGw6IDRweDtcbiAgLS1ib3JkZXItcmFkaXVzLW1lZGl1bTogOHB4O1xuICAtLWJvcmRlci1yYWRpdXMtbGFyZ2U6IDEycHg7XG4gIC0tYm9yZGVyLXJhZGl1cy1jaXJjbGU6IDEwMCU7XG4gIC8qIEFuaW1hdGlvbiAqL1xuICAtLWVhc2UtaW4tb3V0LXF1aW50OiBjdWJpYy1iZXppZXIoMC44MywgMCwgMC4xNywgMSk7XG4gIC0tZGVmYXVsdC1hbmltYXRpb24tZHVyYXRpb246IDMwMG1zO1xuICAtLXF1aWNrLWFuaW1hdGlvbi1kdXJhdGlvbjogMTUwbXM7XG4gIC8qIHNjcm9sbCBiYXIgKi9cbiAgLS1zY3JvbGxiYXItd2lkdGg6IDZweDtcbiAgLS1zY3JvbGxiYXItaGVpZ2h0OiA4cHg7XG4gIC8qIEJveCBzaGFkb3cgKi9cbiAgLS1ib3gtc2hhZG93OiAwIDAgNHB4IDJweCByZ2JhKDAsIDE2MCwgMjA5LCAwLjc1KTtcbiAgLS1ib3gtc2hhZG93LWdyYXk6IDAgNHB4IDhweCByZ2JhKDAsIDAsIDAsIDAuMDgpO1xuICAtLXRwdy1maWx0ZXItaGVpZ2h0OiAwcHg7XG4gIC0td2Via2l0LWJveC1zaGFkb3c6IDAgMCAxcHggcmdiYSg4NCwgODQsIDg0LCAxKTtcbiAgLyogR2FwIGFuZCBwYWRkaW5nICovXG4gIC0tZ2FwLTQ6IDRweDtcbiAgLS1nYXAtODogOHB4O1xuICAtLWdhcC0xMjogMTJweDtcbiAgLyogV2lkdGhzIGFuZCBoZWlnaHRzKi9cbiAgLS1sZW5ndGgtNDogNHB4O1xuICAtLWxlbmd0aC0yMDogMjBweDtcbiAgLS1sZW5ndGgtMjQ6IDI0cHg7XG4gIC0tbGVuZ3RoLTMyOiAzMnB4O1xufVxuXG4uY29udGVudCB7XG4gIGRpc3BsYXk6IGdyaWQ7XG4gIGdyaWQtdGVtcGxhdGUtcm93czogYXV0byAxZnI7XG4gIGdyaWQtdGVtcGxhdGUtY29sdW1uczogMmZyIDFmcjtcbiAgY29sdW1uLWdhcDogMXJlbTtcbiAgaGVpZ2h0OiBjYWxjKDEwMCUgLSAxNXB4KTtcbiAgcGFkZGluZzogMCAxcmVtIDFyZW0gMXJlbTtcbiAgYmFja2dyb3VuZC1jb2xvcjogd2hpdGU7XG59XG4uY29udGVudCAuaGVhZGVyIHtcbiAgZ3JpZC1jb2x1bW46IDEvLTE7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbn1cbi5jb250ZW50IC5oZWFkZXIgc3BhbiB7XG4gIGZvbnQtd2VpZ2h0OiA0MDA7XG59XG4uY29udGVudCAubG9hZGluZ19fY29udGFpbmVyIHtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGhlaWdodDogNDAlO1xufVxuLmNvbnRlbnQgLmVtcHR5LXN0YXRlX19jb250YWluZXIge1xuICBtYXJnaW4tdG9wOiAxMHJlbTtcbn1cbi5jb250ZW50IC5mb3JtLWhlYWRlcl9fY29udGFpbmVyIHtcbiAgZGlzcGxheTogZmxleDtcbn1cbi5jb250ZW50IC5mb3JtLWhlYWRlcl9fY29udGFpbmVyIC5mb3JtLWhlYWRlcl9fbmFtZSB7XG4gIG1hcmdpbi10b3A6IDAuMnJlbTtcbiAgZm9udC1zaXplOiAxcmVtO1xuICBmb250LXdlaWdodDogNzAwO1xuICBmbGV4LWdyb3c6IDE7XG59XG4uY29udGVudCAuZm9ybS1oZWFkZXJfX2NvbnRhaW5lciAuZm9ybS1oZWFkZXJfX25hbWUgc3BhbiB7XG4gIGZvbnQtc3R5bGU6IGl0YWxpYztcbn1cbi5jb250ZW50IC5sb2FkaW5nX19jb250YWluZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgaGVpZ2h0OiA0MCU7XG59XG4uY29udGVudCAuZW1wdHktc3RhdGVfX2NvbnRhaW5lciB7XG4gIG1hcmdpbi10b3A6IDEwcmVtO1xufVxuLmNvbnRlbnQgLmVtcHR5LXN0YXRlX19oZWFkZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kO1xufVxuLmNvbnRlbnQgLmVtcHR5LXN0YXRlX19oZWFkZXIgLmNsb3NlLWljb24ge1xuICBkaXNwbGF5OiBmbGV4O1xufVxuLmNvbnRlbnQgLmxlZnQtcGFuZWwsXG4uY29udGVudCAucmlnaHQtcGFuZWwge1xuICBwYWRkaW5nOiAxcmVtIDFyZW0gMCAxcmVtO1xuICBib3JkZXI6IDFweCBzb2xpZCB2YXIoLS1jb2xvci1ncmF5LWJvcmRlcik7XG4gIG92ZXJmbG93LXk6IGF1dG87XG59XG5cbi5zYXZpbmctaW5kaWNhdG9yIHtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZ2FwOiAzcHg7XG59IiwiQHVzZSBcIkBjc3MvdmFyaWFibGVzXCIgYXMgKjtcblxuLmNvbnRlbnQge1xuICBkaXNwbGF5OiBncmlkO1xuICBncmlkLXRlbXBsYXRlLXJvd3M6IGF1dG8gMWZyO1xuICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IDJmciAxZnI7XG4gIGNvbHVtbi1nYXA6IDFyZW07XG4gIGhlaWdodDogY2FsYygxMDAlIC0gMTVweCk7XG4gIHBhZGRpbmc6IDAgMXJlbSAxcmVtIDFyZW07XG4gIGJhY2tncm91bmQtY29sb3I6IHdoaXRlO1xuXG4gIC5oZWFkZXIge1xuICAgIGdyaWQtY29sdW1uOiAxIC8gLTE7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcblxuICAgIHNwYW4ge1xuICAgICAgZm9udC13ZWlnaHQ6IDQwMDtcbiAgICB9XG4gIH1cblxuICAubG9hZGluZ19fY29udGFpbmVyIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgaGVpZ2h0OiA0MCU7XG4gIH1cblxuICAuZW1wdHktc3RhdGVfX2NvbnRhaW5lciB7XG4gICAgbWFyZ2luLXRvcDogMTByZW07XG4gIH1cblxuICAuZm9ybS1oZWFkZXJfX2NvbnRhaW5lciB7XG4gICAgZGlzcGxheTogZmxleDtcblxuICAgIC5mb3JtLWhlYWRlcl9fbmFtZSB7XG4gICAgICBtYXJnaW4tdG9wOiAwLjJyZW07XG4gICAgICBmb250LXNpemU6IDFyZW07XG4gICAgICBmb250LXdlaWdodDogNzAwO1xuICAgICAgZmxleC1ncm93OiAxO1xuXG4gICAgICBzcGFuIHtcbiAgICAgICAgZm9udC1zdHlsZTogaXRhbGljO1xuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gIC5sb2FkaW5nX19jb250YWluZXIge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBoZWlnaHQ6IDQwJTtcbiAgfVxuXG4gIC5lbXB0eS1zdGF0ZV9fY29udGFpbmVyIHtcbiAgICBtYXJnaW4tdG9wOiAxMHJlbTtcbiAgfVxuXG4gIC5lbXB0eS1zdGF0ZV9faGVhZGVyIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGp1c3RpZnktY29udGVudDogZmxleC1lbmQ7XG5cbiAgICAuY2xvc2UtaWNvbiB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgIH1cbiAgfVxuXG4gIC5sZWZ0LXBhbmVsLFxuICAucmlnaHQtcGFuZWwge1xuICAgIHBhZGRpbmc6IDFyZW0gMXJlbSAwIDFyZW07XG4gICAgYm9yZGVyOiAxcHggc29saWQgdmFyKC0tY29sb3ItZ3JheS1ib3JkZXIpO1xuICAgIG92ZXJmbG93LXk6IGF1dG87XG4gIH1cbn1cbi5zYXZpbmctaW5kaWNhdG9yIHtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZ2FwOiAzcHg7XG59XG4iXX0= */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationViewer.ts":
/*!*******************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/evaluations/EvaluationViewer.ts ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EvaluationViewer: () => (/* binding */ EvaluationViewer)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! mobx */ "mobx");
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(mobx__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils */ "./src/components/QualityMonitoringWidget/utils.ts");
/* harmony import */ var _EvaluationConfirmationModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./EvaluationConfirmationModal */ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationConfirmationModal.ts");
/* harmony import */ var _EvaluationForm__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./EvaluationForm */ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationForm.ts");
/* harmony import */ var _EvaluationViewer_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./EvaluationViewer.scss */ "./src/components/QualityMonitoringWidget/components/evaluations/EvaluationViewer.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};









var FormStatus;
(function (FormStatus) {
    FormStatus["LOADING"] = "loading";
    FormStatus["SUCCESS"] = "success";
    FormStatus["NOT_FOUND"] = "not_found";
    FormStatus["ERROR"] = "error";
    FormStatus["EVALUATION_NOT_FOUND"] = "evaluation_not_found";
})(FormStatus || (FormStatus = {}));
const EVALUATION_VIEWER = "Evaluation Viewer";
let EvaluationViewer = class EvaluationViewer extends lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement {
    constructor() {
        super(...arguments);
        this.evaluationData = {
            sessionId: "",
            agentName: "",
            activeSessionStartTime: 0,
            interactionId: "",
            ani: "",
            queueName: ""
        };
        this.evaluationTimestamp = 0;
        this.evaluationMode = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.EvaluationMode.CREATE;
        this.evaluationForm = {
            id: "",
            name: "",
            sections: [],
            status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.EvaluationStatus.ACTIVE
        };
        this.evaluationForms = { data: [] };
        this.formStatus = FormStatus.LOADING;
        this.pendingAiEvaluationResults = true;
        this.showExitConfirmationModal = false;
        this.formSaved = false;
        this.isSavingForm = false;
        this.evaluationNotFound = false;
        this.evaluation = {
            status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.EvaluationStatus.DRAFT,
            interaction: {
                interactionId: "",
                agent: {
                    userId: "",
                    ccUserId: "",
                    displayName: ""
                }
            },
            formId: "",
            createdAt: "",
            lastModifiedAt: "",
            answers: [],
            lastModifiedBy: {
                userId: "string",
                ccUserId: "string",
                displayName: "string"
            }
        };
    }
    static get styles() {
        return _EvaluationViewer_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
    }
    updateEvaluationFormQuestion(sectionIndex, questionIndex, aiEvalDetails) {
        this.evaluationForm.sections[sectionIndex].questions[questionIndex].aiEvalDetails = aiEvalDetails;
    }
    updateFormWithEvaluation() {
        var _a;
        (_a = this.evaluation.answers) === null || _a === void 0 ? void 0 : _a.forEach((answer) => {
            this.updateQuestionWithAnswer(answer);
        });
    }
    updateQuestionWithAnswer(answer) {
        this.evaluationForm.sections.forEach((section) => {
            section.questions.forEach((question) => {
                var _a;
                if (question.id === answer.questionId) {
                    question.comment = answer.comment;
                    question.selectedAnswer = (_a = answer.selectedOptions) === null || _a === void 0 ? void 0 : _a.map((option) => option.text).join(", ");
                }
            });
        });
    }
    attachAIAssistEvaluationsToForm(results) {
        results.forEach((result) => {
            var _a;
            (_a = this.evaluationForm.sections) === null || _a === void 0 ? void 0 : _a.forEach((section, sectionIndex) => {
                section.questions.forEach((question, questionIndex) => {
                    if (question.id === result.questionId) {
                        this.updateEvaluationFormQuestion(sectionIndex, questionIndex, result.aiEvalDetails);
                    }
                });
            });
        });
    }
    updateEvaluationWithFormAnswers() {
        this.evaluation.answers = this.getEvaluationAnswers();
    }
    getEvaluationAnswers() {
        var _a;
        return (_a = this.evaluationForm.sections) === null || _a === void 0 ? void 0 : _a.flatMap((section) => section.questions.map((question) => ({
            questionId: question.id,
            comment: question.comment,
            selectedOptions: this.getSelectedOptions(question)
        })));
    }
    getSelectedOptions(question) {
        return question.selectedAnswer
            ? question.selectedAnswer.split(", ").map((text) => {
                var _a, _b;
                return ({
                    id: ((_a = question.options.find((option) => option.text === text)) === null || _a === void 0 ? void 0 : _a.id) || 0,
                    weight: Number((_b = question.options.find((option) => option.text === text)) === null || _b === void 0 ? void 0 : _b.weight) || 0,
                    text
                });
            })
            : [];
    }
    createInMemoryEvaluation() {
        var _a;
        if (!this.evaluation) {
            return;
        }
        this.evaluation.interaction = {
            interactionId: this.evaluationData.interactionId,
            agent: {
                userId: this.evaluationData.agentName,
                ccUserId: this.evaluationData.agentName,
                displayName: this.evaluationData.agentName
            }
        };
        this.evaluation.formId = this.evaluationForm.id;
        this.evaluation.createdAt = this.evaluation.createdAt || new Date().toISOString();
        this.evaluation.lastModifiedAt = new Date().toISOString();
        this.evaluation.answers = (_a = this.evaluationForm.sections) === null || _a === void 0 ? void 0 : _a.flatMap((section) => section.questions.map((question) => ({
            questionId: question.id,
            comment: question.comment,
            selectedOptions: [
                {
                    id: Number(question.options[0].id),
                    weight: Number(question.options[0].weight),
                    text: question.options[0].text
                }
            ]
        })));
    }
    connectedCallback() {
        super.connectedCallback();
        this.getEvaluation(this.evaluationData.interactionId);
    }
    render() {
        return this.evaluationData
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
          <div class="content">
            <div class="header">
              <h3 class="header-left">${this.getEvaluationHeader()} ${this.getSubmissionDetails()}</h3>
              <h3 class="header-right">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.sessionId")}:<strong>${this.evaluationData.sessionId}</strong></h3>
            </div>
            <div class="left-panel">${this.getEnhancedAudioPlayerComponent(this.evaluationData)}</div>
            <div class="right-panel">${this.renderFormHeader()}${this.renderFormContent()}</div>
          </div>
          <agentx-wc-qmw-evaluation-confirmation-modal
            .showModal=${this.showExitConfirmationModal}
            @confirm-exit="${this.handleDiscard}"
            @decline-exit="${this.toggleModal}"
          ></agentx-wc-qmw-evaluation-confirmation-modal>
        `
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<agentx-wc-qmw-evaluation-confirmation-modal
          .showModal=${this.showExitConfirmationModal}
          @confirm-exit="${this.handleDiscard}"
          @decline-exit="${this.toggleModal}"
        ></agentx-wc-qmw-evaluation-confirmation-modal>`;
    }
    getEvaluation(interactionId) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            this.formStatus = FormStatus.LOADING;
            try {
                this.evaluation = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.agentPerformance.fetchEvaluation({
                    interactionId,
                    orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || ""
                });
                this.setupEvaluationForm((_b = this.evaluation) === null || _b === void 0 ? void 0 : _b.formId);
                if (this.evaluation.status === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.EvaluationStatus.PUBLISHED) {
                    this.evaluationMode = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.EvaluationMode.VIEW;
                }
            }
            catch (error) {
                this.formStatus = FormStatus.EVALUATION_NOT_FOUND;
                this.evaluationNotFound = true;
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] Failed to fetch submitted evaluation", error);
            }
        });
    }
    getOrgEvaluationForms() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.formStatus = FormStatus.LOADING;
            try {
                this.evaluationForms = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.agentPerformance.fetchOrgEvaluationForms({
                    orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || ""
                });
                this.formStatus = FormStatus.SUCCESS;
            }
            catch (error) {
                this.formStatus = FormStatus.ERROR;
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] Failed to fetch evaluation forms", error);
            }
        });
    }
    setupEvaluationForm(formId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getSelectedForm(formId);
            if (this.evaluationNotFound) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[Evaluation Viewer] Creating new evaluation form");
                this.createEvaluation();
            }
            else {
                this.updateFormWithEvaluation();
            }
            const aiAssistEvaluations = yield this.getAIAssistEvaluations();
            if (aiAssistEvaluations && aiAssistEvaluations.results) {
                this.attachAIAssistEvaluationsToForm(aiAssistEvaluations.results);
            }
            this.pendingAiEvaluationResults = false;
        });
    }
    getSelectedForm(formId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.formStatus = FormStatus.LOADING;
            try {
                this.evaluationForm = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.agentPerformance.fetchEvaluationForm({
                    orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || "",
                    formId
                });
                this.formStatus = this.evaluationForm.id ? FormStatus.SUCCESS : FormStatus.NOT_FOUND;
            }
            catch (error) {
                this.formStatus = FormStatus.ERROR;
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] Failed to fetch selected evaluation form", error);
            }
        });
    }
    getAIAssistEvaluations() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.agentPerformance.fetchAIAssistedEvaluations({
                    orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || "",
                    formId: this.evaluationForm.id,
                    interactionId: this.evaluationData.interactionId
                });
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] Failed to fetch AI evaluations", error);
                return {
                    results: []
                };
            }
        });
    }
    getEvaluationHeader() {
        const agentName = this.evaluationData.agentName || (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.agent");
        switch (this.evaluationMode) {
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.EvaluationMode.VIEW:
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.viewEvaluation", agentName);
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.EvaluationMode.EDIT:
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.editEvaluation", agentName);
            case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.EvaluationMode.CREATE:
            default:
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.newEvaluation", agentName);
        }
    }
    renderFormContent() {
        var _a;
        switch (this.formStatus) {
            case FormStatus.LOADING:
                return this.renderLoadingState();
            case FormStatus.ERROR:
                return this.renderErrorState();
            case FormStatus.NOT_FOUND:
                return this.renderEmptyState();
            case FormStatus.EVALUATION_NOT_FOUND:
                this.getOrgEvaluationForms();
                return this.renderLoadingState();
            default:
                return ((_a = this.evaluationForm) === null || _a === void 0 ? void 0 : _a.id) ? this.renderEvaluationForm() : this.renderSelectionDropdown();
        }
    }
    getSubmissionDetails() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      ${this.evaluationMode !== _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.EvaluationMode.CREATE
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
            ${this.evaluationForm.submittedBy
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.submittedBy", this.evaluationForm.submittedBy)}</span>`
                : ""}
            ${this.evaluationForm.submittedOn
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<span>
                  ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.submittedOn", "", {
                    defaultValue: (0,_utils__WEBPACK_IMPORTED_MODULE_5__.dateFormatterShortWithSeconds)(this.evaluationForm.submittedOn.getTime()),
                    interpolation: { escapeValue: false }
                })}
                </span>`
                : ""}
          `
            : ""}
    `;
    }
    renderLoadingState() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div class="loading__container">
        <md-loading size="small"></md-loading>
      </div>
    `;
    }
    renderEvaluationForm() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <agentx-wc-evaluation-form
        @evaluation-auto-save=${this.handleEvaluationAutoSave}
        @evaluation-submit=${this.handleEvaluationSubmit}
        @evaluation-updated=${this.handleEvaluationUpdated}
        @evaluation-form-discard=${this.toggleModal}
        @seek-audio=${this.seekToEvaluationAudio}
        .evaluationForm=${this.evaluationForm}
        .evaluationMode=${this.evaluationMode}
        .pendingAiEvaluationResults=${this.pendingAiEvaluationResults}
      ></agentx-wc-evaluation-form>
    `;
    }
    handleEvaluationSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.submitEvaluation();
            this.dispatchEvent(new CustomEvent("clear-evaluation-data", {
                bubbles: true,
                composed: true
            }));
        });
    }
    handleEvaluationAutoSave() {
        return __awaiter(this, void 0, void 0, function* () {
            this.updateEvaluationWithFormAnswers();
            yield this.saveEvaluation();
        });
    }
    saveEvaluation() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.formSaved = false;
            this.isSavingForm = true;
            let evaluation = this.evaluation;
            try {
                evaluation = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.agentPerformance.saveEvaluation({
                    orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || "",
                    evaluationId: evaluation.id || "",
                    data: this.evaluation
                });
                this.isSavingForm = false;
                this.formSaved = true;
                if (evaluation.id) {
                    this.evaluation = evaluation;
                    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[Evaluation Viewer] Evaluation form saved successfully");
                }
            }
            catch (error) {
                this.isSavingForm = false;
                this.formSaved = false;
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] Failed to save evaluation form", error);
            }
        });
    }
    submitEvaluation() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const evaluation = this.evaluation;
            try {
                this.evaluation = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.agentPerformance.publishEvaluation({
                    orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || "",
                    evaluationId: evaluation.id || "",
                    data: evaluation
                });
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] Failed to submit evaluation", error);
            }
        });
    }
    discardEvaluation() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const evaluation = this.evaluation;
            try {
                yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.agentPerformance.archiveEvaluation({
                    orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || "",
                    evaluationId: evaluation.id || ""
                });
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] Failed to discard evaluation", error);
            }
        });
    }
    createEvaluation() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.createInMemoryEvaluation();
            const evaluation = this.evaluation;
            try {
                this.evaluation = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.agentPerformance.createEvaluation({
                    orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || "",
                    data: evaluation
                });
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] Failed to create evaluation", error);
            }
        });
    }
    handleEvaluationUpdated(event) {
        this.evaluationForm = event.detail.evaluationForm;
    }
    renderSelectionDropdown() {
        var _a;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div class="evaluation__dropdown">
        <h3>Select Evaluation Form</h3>
        <md-dropdown
          .options="${this.evaluationForms.data}"
          title="${((_a = this.evaluationForms.data) === null || _a === void 0 ? void 0 : _a.length) ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.select") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.noFormsFound")}"
          option-id="id"
          option-value="name"
          @dropdown-selected="${(e) => {
            const option = e.detail.option;
            if (option && typeof option === "object") {
                this.setupEvaluationForm(option.id);
            }
            else {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[Evaluation Viewer] Unexpected option in evaluation form dropdown", option);
            }
        }}"
        ></md-dropdown>
      </div>
    `;
    }
    renderEmptyState() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div class="empty-state__container">
        <agentx-wc-empty-display-wrapper
          illustration-type="empty-result"
          title="Form not found"
          info-message="No form found for this team. Please contact your system administrator"
        ></agentx-wc-empty-display-wrapper>
      </div>
    `;
    }
    renderErrorState() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div class="empty-state__container">
        <agentx-wc-qmw-grid-error
          .errorElement=${EVALUATION_VIEWER}
          @qmw-error-retry=${() => this.getSelectedForm(this.evaluationData.interactionId)}
        ></agentx-wc-qmw-grid-error>
      </div>
    `;
    }
    renderFormSavingIndicator() {
        if (!this.isSavingForm && !this.formSaved) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ``;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <div class="saving-indicator">
        ${this.isSavingForm ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationSaving")}<md-spinner size="16"></md-spinner>` : ""}
        ${this.formSaved ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<div class="saved-indicator">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluationSaveSuccess")}</div>` : ""}
      </div>
    `;
    }
    renderFormHeader() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      ${this.renderFormSavingIndicator()}
      <div class="form-header__container">
        <h3 class="form-header__name">
          ${this.evaluationForm.name}
          <span>${this.isEditMode && this.evaluationForm.name ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.editing") : ""}</span>
        </h3>
        <div class="close-icon">
          <md-button variant="white" @click=${this.closeView} circle ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.close")}>
            <md-icon name="cancel-bold" iconSet="momentumDesign"></md-icon>
          </md-button>
        </div>
      </div>
    `;
    }
    toggleModal() {
        this.showExitConfirmationModal = !this.showExitConfirmationModal;
    }
    closeView() {
        this.dispatchEvent(new CustomEvent("clear-evaluation-data", {
            bubbles: true,
            composed: true
        }));
    }
    getEnhancedAudioPlayerComponent(evaluationData) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      <agentx-wc-qmw-recording-details
        .sessionId=${evaluationData.sessionId}
        .ani=${evaluationData.ani}
        .queue=${evaluationData.queueName}
        .agentName=${evaluationData.agentName}
        .startTimeFromGrid=${evaluationData.activeSessionStartTime}
        .showConsultRecordings=${true}
        .showEnhancedRecordings=${true}
        .showInModal=${false}
        .seekEvaluationTime="${this.evaluationTimestamp}"
        .showTranscript=${true}
      ></agentx-wc-qmw-recording-details>
    `;
    }
    get isEditMode() {
        return this.evaluationMode === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.AgentPerformanceTypes.EvaluationMode.EDIT;
    }
    handleDiscard() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.discardEvaluation();
            this.toggleModal();
            this.dispatchEvent(new CustomEvent("clear-evaluation-data", {
                bubbles: true,
                composed: true
            }));
        });
    }
    seekToEvaluationAudio(event) {
        this.evaluationTimestamp = event.detail.seekTo;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
], EvaluationViewer.prototype, "evaluationData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Number })
], EvaluationViewer.prototype, "evaluationTimestamp", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], EvaluationViewer.prototype, "evaluationMode", void 0);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_4__.observable
], EvaluationViewer.prototype, "evaluationForm", void 0);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_4__.action
], EvaluationViewer.prototype, "updateEvaluationFormQuestion", null);
__decorate([
    mobx__WEBPACK_IMPORTED_MODULE_4__.action
], EvaluationViewer.prototype, "updateFormWithEvaluation", null);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], EvaluationViewer.prototype, "evaluationForms", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], EvaluationViewer.prototype, "formStatus", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], EvaluationViewer.prototype, "pendingAiEvaluationResults", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], EvaluationViewer.prototype, "showExitConfirmationModal", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], EvaluationViewer.prototype, "formSaved", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], EvaluationViewer.prototype, "isSavingForm", void 0);
EvaluationViewer = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-evaluation-viewer")
], EvaluationViewer);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/Chapter.ts":
/*!*****************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/Chapter.ts ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Chapter: () => (/* binding */ Chapter)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../utils */ "./src/components/QualityMonitoringWidget/utils.ts");


class Chapter {
    constructor(url, startTimeMillis, endTimeMillis, otherParticipantNames, chapterType = _utils__WEBPACK_IMPORTED_MODULE_1__.ChapterType.Main) {
        this.startTimeMillis = 0;
        this.endTimeMillis = 0;
        this.chapterType = _utils__WEBPACK_IMPORTED_MODULE_1__.ChapterType.Main;
        this.url = url;
        this.startTimeMillis = startTimeMillis;
        this.endTimeMillis = endTimeMillis;
        this.otherParticipantNames = otherParticipantNames;
        this.chapterType = chapterType;
    }
    getStartTimeInAudioFile() {
        if (this.getIsCustomerChapter()) {
            return 0;
        }
        return this.startTimeMillis;
    }
    getEndTimeSeconds() {
        return Math.floor(this.endTimeMillis / 1000);
    }
    getStartTimeSeconds() {
        return Math.floor(this.startTimeMillis / 1000);
    }
    getDuration() {
        return this.endTimeMillis - this.startTimeMillis;
    }
    getIsCustomerChapter() {
        return (0,_utils__WEBPACK_IMPORTED_MODULE_1__.isCustomerTrack)(this.chapterType);
    }
    getTrackTitle(agentName) {
        switch (this.chapterType) {
            case _utils__WEBPACK_IMPORTED_MODULE_1__.ChapterType.Consulting:
                if (this.otherParticipantNames.length > 1) {
                    return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.consult")}: ${this.otherParticipantNames[0]} - ${this.otherParticipantNames[1]}`;
                }
                return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.consult")}: ${this.otherParticipantNames[0]}`;
            case _utils__WEBPACK_IMPORTED_MODULE_1__.ChapterType.Hold:
                return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.onHold")}`;
            case _utils__WEBPACK_IMPORTED_MODULE_1__.ChapterType.ConsultRequest:
                if (this.otherParticipantNames.length > 1) {
                    return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.consultRequest")}: ${this.otherParticipantNames[0]} - ${this.otherParticipantNames[1]}`;
                }
                return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.consultRequest")}: ${this.otherParticipantNames[0]}`;
            case _utils__WEBPACK_IMPORTED_MODULE_1__.ChapterType.Conferencing: {
                const joinConferenceAgents = this.otherParticipantNames.reduce((acc, name, index) => {
                    acc += ` ${index !== 0 ? "- " : ""}${name}`;
                    return acc;
                }, "");
                return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.conference")}:${joinConferenceAgents} - ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.customer")}`;
            }
            case _utils__WEBPACK_IMPORTED_MODULE_1__.ChapterType.Main:
            default:
                return `${agentName} - ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.customer")}`;
        }
    }
    getDownloadUrl() {
        return this.url;
    }
}


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/ChapterManager.ts":
/*!************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/ChapterManager.ts ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChapterManager: () => (/* binding */ ChapterManager)
/* harmony export */ });
class ChapterManager {
    constructor(interactionRecordingDetails, customerChapters, consultChapters) {
        this.customerChapters = [];
        this.consultChapters = [];
        this.callbacks = [];
        this.isCustomerWaveformSelected = true;
        this.time = 0;
        this.running = false;
        this.playbackRate = 1;
        this.interactionRecordingDetails = interactionRecordingDetails;
        this.customerChapters = customerChapters;
        this.consultChapters = consultChapters;
    }
    registerCallback(callback) {
        this.callbacks.push(callback);
    }
    getCurrentTime() {
        return this.time;
    }
    isRunning() {
        return this.running;
    }
    start() {
        this.running = true;
        for (const callback of this.callbacks) {
            callback.onStart(this.time);
        }
    }
    stop() {
        this.running = false;
        for (const callback of this.callbacks) {
            callback.onStop();
        }
    }
    seek(time) {
        var _a, _b;
        time = Math.max(0, time);
        time = Math.min((_b = (_a = this.interactionRecordingDetails) === null || _a === void 0 ? void 0 : _a.endTimeMillis) !== null && _b !== void 0 ? _b : 0, time);
        this.time = time;
        for (const callback of this.callbacks) {
            callback.onSeek(this.time);
        }
        this.hasChapterChanged(time, true);
    }
    audioPlayerTick(time) {
        this.time = time;
        for (const callback of this.callbacks) {
            callback.onTick(this.time);
        }
        this.hasChapterChanged(time);
    }
    getCustomerWaveformSelected() {
        return this.isCustomerWaveformSelected;
    }
    setCustomerWaveformSelected(customerWaveformSelected, time) {
        if (this.isCustomerWaveformSelected === customerWaveformSelected) {
            return;
        }
        this.isCustomerWaveformSelected = customerWaveformSelected;
        this.hasChapterChanged(time, true);
    }
    getCustomerChapters() {
        return this.customerChapters;
    }
    getConsultChapters() {
        return this.consultChapters;
    }
    getInteractionRecordingDetails() {
        return this.interactionRecordingDetails;
    }
    getChapterByTime(time) {
        var _a, _b, _c, _d, _e, _f;
        if (time < 0) {
            time = 0;
        }
        if (time >= ((_b = (_a = this.interactionRecordingDetails) === null || _a === void 0 ? void 0 : _a.endTimeMillis) !== null && _b !== void 0 ? _b : 0)) {
            time = (_d = (_c = this.interactionRecordingDetails) === null || _c === void 0 ? void 0 : _c.endTimeMillis) !== null && _d !== void 0 ? _d : 0;
            return (_f = (_e = this.getSelectedChapters()) === null || _e === void 0 ? void 0 : _e.slice(-1)[0]) !== null && _f !== void 0 ? _f : undefined;
        }
        return this.getSelectedChapters().find((chapter) => time >= chapter.startTimeMillis && time < chapter.endTimeMillis);
    }
    getAudioUrls() {
        const urlsSet = new Set();
        const allChapters = [...this.getCustomerChapters(), ...this.getConsultChapters()];
        allChapters.forEach((chapter) => {
            if (chapter.getDownloadUrl() === "") {
                return;
            }
            urlsSet.add(chapter.getDownloadUrl());
        });
        return Array.from(urlsSet.values());
    }
    setPlaybackRate(playbackRate) {
        if (this.playbackRate === playbackRate) {
            return;
        }
        this.playbackRate = playbackRate;
    }
    getCurrentChapter() {
        return this.getChapterByTime(this.getCurrentTime());
    }
    getNextChapter() {
        const currentChapter = this.getCurrentChapter();
        let chapters = this.consultChapters;
        if (currentChapter !== undefined) {
            chapters = currentChapter.getIsCustomerChapter() ? this.customerChapters : this.consultChapters;
        }
        return chapters.find((chapter) => chapter.startTimeMillis > this.getCurrentTime());
    }
    getPreviousChapter() {
        const currentChapter = this.getCurrentChapter();
        if (currentChapter !== undefined) {
            const chapters = currentChapter.getIsCustomerChapter() ? this.customerChapters : this.consultChapters;
            // choosing to loop instead of the reverse and find, to avoid creating a duplicate array
            for (let i = chapters.length - 1; i >= 0; i--) {
                if (chapters[i].endTimeMillis <= currentChapter.startTimeMillis) {
                    return chapters[i];
                }
            }
        }
        return undefined;
    }
    isPreviousChapterAvailable() {
        const currentChapter = this.getCurrentChapter();
        if (currentChapter !== undefined) {
            // If we've started the current chapter, return to start time of current chapter
            return this.getCurrentTime() > currentChapter.startTimeMillis ? true : this.getPreviousChapter() !== undefined;
        }
        return false;
    }
    seekToPreviousChapter() {
        let timeToSeek = this.getCurrentTime();
        const currentChapter = this.getCurrentChapter();
        if (currentChapter !== undefined) {
            // if we're within 1 second of the start of the current chapter, go to the previous chapter
            if (this.getCurrentTime() - currentChapter.startTimeMillis < 1000) {
                const previousChapter = this.getPreviousChapter();
                if (previousChapter !== undefined) {
                    timeToSeek = previousChapter.startTimeMillis;
                }
            }
            else {
                timeToSeek = currentChapter.startTimeMillis;
            }
            this.seek(timeToSeek);
        }
    }
    seekToNextChapter() {
        let timeToSeek = this.getCurrentTime();
        const nextChapter = this.getNextChapter();
        if (nextChapter !== undefined) {
            timeToSeek = nextChapter.startTimeMillis;
        }
        this.seek(timeToSeek);
    }
    hasChapterChanged(time, seekEvent = false) {
        const tickInterval = 100 * this.playbackRate;
        const currentChapter = this.getChapterByTime(time - 2 * tickInterval);
        const nextChapter = this.getChapterByTime(time);
        if (seekEvent || currentChapter !== nextChapter) {
            for (const callback of this.callbacks) {
                callback.onChapterChanged(nextChapter);
            }
        }
    }
    getSelectedChapters() {
        return this.isCustomerWaveformSelected ? this.customerChapters : this.consultChapters;
    }
}


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/ChaptersListView.scss":
/*!****************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/ChaptersListView.scss ***!
  \****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.chapters-container {
  border-right: 1px solid var(--md-menu-overlay-border-color, --gray-20);
  overflow-y: auto;
  height: var(--chapters-container-height);
  padding-right: var(--chapters-container-padding-right);
}
.chapters-container.no-border {
  height: var(--chapters-container-height-no-border);
  border-right: none;
}
.chapters-container.hidden-tabs {
  height: var(--chapters-container-height-hidden-tabs);
}
.chapters-container.hidden-tabs.no-border {
  height: var(--chapters-container-height-hidden-tabs-no-border);
}

.chapter-container {
  display: grid;
  padding-top: var(--chapter-container-padding-top);
  padding-bottom: var(--chapter-container-padding-bottom);
  grid-template-columns: 1fr 10fr;
}

.hidden-tabs md-tabs::part(tabs-list) {
  display: none;
}

.chapter-item {
  text-align: left;
}

.chapter-time {
  grid-column: 1;
  grid-row: 1/span 2;
  width: var(--chapter-time-width);
}

.chapter-title {
  grid-column: 2;
  grid-row: 1;
  width: var(--chapter-title-width);
}

.spacer {
  grid-column: 1;
  grid-row: 2;
}

.chapter-length {
  grid-column: 2/span 2;
  grid-row: 2;
}

.selected-chapter {
  font-weight: bold;
}

h4 {
  margin-bottom: 0;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/components/player/ChaptersListView.scss */
/*# sourceURL=ChaptersListView.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/ChaptersListView.ts":
/*!**************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/ChaptersListView.ts ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChaptersListView: () => (/* binding */ ChaptersListView)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils */ "./src/components/QualityMonitoringWidget/utils.ts");
/* harmony import */ var _ChaptersListView_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ChaptersListView.scss */ "./src/components/QualityMonitoringWidget/components/player/ChaptersListView.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







/**
 * @element agentx-wc-chapters-list
 * @fires chapter-clicked
 */
let ChaptersListView = class ChaptersListView extends lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement {
    constructor() {
        super(...arguments);
        this.customerChapters = [];
        this.consultChapters = [];
        this.agentName = "";
        this.selectedTabIndex = 0;
        this.transcriptAvailable = false;
        this.SCROLL_OFFSET = 16;
    }
    static get styles() {
        return _ChaptersListView_scss__WEBPACK_IMPORTED_MODULE_6__["default"];
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        this.selectedTabIndex = this.isCurrentChapterCustomer() ? 0 : 1;
        this.handleChapterChange(this.currentChapter);
    }
    handleChapterChange(currentChapter) {
        var _a;
        if (!currentChapter) {
            return;
        }
        const chaptersContainer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".chapters-container");
        const scrollableRect = chaptersContainer === null || chaptersContainer === void 0 ? void 0 : chaptersContainer.getBoundingClientRect();
        const { top: scrollableTop, height: scrollableHeight } = scrollableRect;
        requestAnimationFrame(() => {
            var _a;
            const content = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".selected-chapter");
            if (content) {
                const { top, bottom } = content.getBoundingClientRect();
                const isInView = top >= scrollableTop && bottom + this.SCROLL_OFFSET <= scrollableTop + scrollableHeight;
                if (!isInView && content.scrollIntoView) {
                    content.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }
        });
    }
    dispatchChapterSelectedEvent(chapterItem) {
        const isCustomerTrack = chapterItem.getIsCustomerChapter();
        const index = isCustomerTrack
            ? this.customerChapters.indexOf(chapterItem)
            : this.consultChapters.indexOf(chapterItem);
        this.dispatchEvent(new CustomEvent("chapter-clicked", {
            detail: [index, chapterItem.chapterType],
            bubbles: true,
            composed: true
        }));
    }
    isCurrentChapterCustomer() {
        return this.currentChapter !== undefined && this.customerChapters.includes(this.currentChapter);
    }
    getItemFontClass(chapterItem) {
        return this.currentChapter === chapterItem ? "selected-chapter" : "";
    }
    handleKeydownEvent(event, chapterItem) {
        if (event.code === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Space || event.code === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Enter) {
            this.dispatchChapterSelectedEvent(chapterItem);
        }
    }
    render() {
        const sections = [this.customerChapters, this.consultChapters];
        const customerSegmentsString = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:qmw.customerSegments");
        const consultSegmentsString = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:qmw.consultSegments");
        const chaptersString = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:qmw.chapters");
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
      <h4>${chaptersString} (${this.customerChapters.length + this.consultChapters.length})</h4>
      <div
        class="chapters-container ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)({
            "hidden-tabs": !this.consultChapters.length,
            "no-border": this.transcriptAvailable
        })}"
      >
        <md-tabs selected-index="${this.selectedTabIndex}">
          ${sections.map((section, index) => section.length === 0
            ? (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) ``
            : (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
                  <md-tab slot="tab">
                    <span>${index === 0 ? customerSegmentsString : consultSegmentsString} (${section.length})</span>
                  </md-tab>
                  <md-tab-panel slot="panel">
                    ${section.map((chapterItem) => {
                var _a, _b;
                return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
                        <div class="chapter-container ${this.getItemFontClass(chapterItem)}">
                          <div class="grid-item chapter-time">
                            <md-link
                              tag="span"
                              @click="${() => this.dispatchChapterSelectedEvent(chapterItem)}"
                              @keydown="${(event) => this.handleKeydownEvent(event, chapterItem)}"
                              aria-label="${chapterItem.getTrackTitle(this.agentName)}"
                            >
                              ${(0,_utils__WEBPACK_IMPORTED_MODULE_5__.relativeTimeFormatter)(chapterItem.startTimeMillis, (_a = this.mainChapter) === null || _a === void 0 ? void 0 : _a.endTimeMillis)}
                            </md-link>
                          </div>
                          <div class="chapter-item chapter-title">
                            <md-label>${chapterItem.getTrackTitle(this.agentName)}</md-label>
                          </div>
                          <div class="chapter-item chapter-length">
                            <md-label>
                              ${(0,_utils__WEBPACK_IMPORTED_MODULE_5__.relativeTimeFormatter)(chapterItem.getDuration(), (_b = this.mainChapter) === null || _b === void 0 ? void 0 : _b.endTimeMillis)}
                            </md-label>
                          </div>
                        </div>
                      `;
            })}
                  </md-tab-panel>
                `)}
        </md-tabs>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
], ChaptersListView.prototype, "customerChapters", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
], ChaptersListView.prototype, "consultChapters", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
], ChaptersListView.prototype, "mainChapter", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
], ChaptersListView.prototype, "currentChapter", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
], ChaptersListView.prototype, "agentName", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
], ChaptersListView.prototype, "selectedTabIndex", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
], ChaptersListView.prototype, "transcriptAvailable", void 0);
ChaptersListView = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-chapters-list")
], ChaptersListView);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/InteractionDetailsView.scss":
/*!**********************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/InteractionDetailsView.scss ***!
  \**********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --grid-header-height: 60px;
  --visualizer-title-width: 100px;
  --visualizer-title-margin-left: 24px;
  --visualizer-container-max-height: 40px;
  --visualizer-container-max-width: 900px;
  --visualizer-container-gap: 16px;
  --visualizer-bar-max-width: 577px;
  --visualizer-bar-max-height: 4px;
  --player-controls-row-height: 50px;
  --player-controls-gap: 8px;
  --volume-popover-width: 180px;
  --volume-popover-height: 21px;
  --volume-popover-gap: 12px;
  --volume-popover-top-offset: 120%;
  --volume-popover-left-offset: 50%;
  --volume-popover-padding: 12px;
  --seek-bar-height: 8px;
  --seek-bar-thumb-size: 16px;
  --seek-bar-top-margin: 16px;
  --seek-bar-bottom-margin: 8px;
  --popover-arrow-size: 10px;
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --interaction-details-height: 220px;
  --interaction-details-vertical-padding: 12px;
  --interaction-details-optional-horizontal-margin: 24px;
  --interaction-details-item-bottom-margin: 4px;
  --interaction-details-item-grid-template-columns: 150px auto;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  --chapters-container-height: 292px;
  --chapters-container-height-no-border: 250px;
  --chapters-container-height-hidden-tabs: 350px;
  --chapters-container-height: 292px;
  --chapters-container-height-hidden-tabs-no-border: 300px;
  --chapters-container-padding-right: 18px;
  --chapter-container-padding-top: 5px;
  --chapter-container-padding-bottom: 12px;
  --chapter-time-width: 60px;
  --chapter-title-width: 300px;
  --transcript-height: 285px;
  --transcript-height-no-chapters: 410px;
  --transcript-height-chapters-no-consults: 350px;
}

.metrics-tab {
  padding: var(--interaction-details-vertical-padding) 0;
  max-height: var(--interaction-details-height);
}

.detail-item {
  display: grid;
  grid-template-columns: var(--interaction-details-item-grid-template-columns);
  justify-content: start;
  margin-bottom: var(--interaction-details-item-bottom-margin);
  color: var(--md-secondary-text-color);
}

h4 {
  margin-bottom: 0;
}

.detail-value {
  text-align: left;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/variables.scss */
/*# sourceURL=InteractionDetailsView.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/components/player/InteractionDetailsView.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/InteractionDetailsView.ts":
/*!********************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/InteractionDetailsView.ts ***!
  \********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionDetailsView: () => (/* binding */ InteractionDetailsView)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _InteractionDetailsView_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./InteractionDetailsView.scss */ "./src/components/QualityMonitoringWidget/components/player/InteractionDetailsView.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




/**
 * @element agentx-wc-interaction-details
 */
let InteractionDetailsView = class InteractionDetailsView extends lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement {
    constructor() {
        super(...arguments);
        this.interactionDetailInfo = new Map();
    }
    static get styles() {
        return _InteractionDetailsView_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    render() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
      <h4>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.interactionDetailsHeader")}</h4>
      <div class="tab-content">
        <div class="metrics-tab">
          ${Array.from(this.interactionDetailInfo.entries()).map(([key, value]) => (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
              <div class="detail-item">
                <dt class="detail-key">${key}</dt>
                <dd class="detail-value">${value}</dd>
              </div>
            `)}
        </div>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
], InteractionDetailsView.prototype, "interactionDetailInfo", void 0);
InteractionDetailsView = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-interaction-details")
], InteractionDetailsView);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/PlaybackRateView.scss":
/*!****************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/PlaybackRateView.scss ***!
  \****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --grid-header-height: 60px;
  --visualizer-title-width: 100px;
  --visualizer-title-margin-left: 24px;
  --visualizer-container-max-height: 40px;
  --visualizer-container-max-width: 900px;
  --visualizer-container-gap: 16px;
  --visualizer-bar-max-width: 577px;
  --visualizer-bar-max-height: 4px;
  --player-controls-row-height: 50px;
  --player-controls-gap: 8px;
  --volume-popover-width: 180px;
  --volume-popover-height: 21px;
  --volume-popover-gap: 12px;
  --volume-popover-top-offset: 120%;
  --volume-popover-left-offset: 50%;
  --volume-popover-padding: 12px;
  --seek-bar-height: 8px;
  --seek-bar-thumb-size: 16px;
  --seek-bar-top-margin: 16px;
  --seek-bar-bottom-margin: 8px;
  --popover-arrow-size: 10px;
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --interaction-details-height: 220px;
  --interaction-details-vertical-padding: 12px;
  --interaction-details-optional-horizontal-margin: 24px;
  --interaction-details-item-bottom-margin: 4px;
  --interaction-details-item-grid-template-columns: 150px auto;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  --chapters-container-height: 292px;
  --chapters-container-height-no-border: 250px;
  --chapters-container-height-hidden-tabs: 350px;
  --chapters-container-height: 292px;
  --chapters-container-height-hidden-tabs-no-border: 300px;
  --chapters-container-padding-right: 18px;
  --chapter-container-padding-top: 5px;
  --chapter-container-padding-bottom: 12px;
  --chapter-time-width: 60px;
  --chapter-title-width: 300px;
  --transcript-height: 285px;
  --transcript-height-no-chapters: 410px;
  --transcript-height-chapters-no-consults: 350px;
}

.popover-arrow,
.popover-arrow-border {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  border-left: var(--popover-arrow-size) solid transparent;
  border-right: var(--popover-arrow-size) solid transparent;
}

.popover-arrow {
  top: -9px;
  border-bottom: var(--popover-arrow-size) solid var(--md-primary-bg-color);
}

.popover-arrow-border {
  top: -10px;
  border-bottom: var(--popover-arrow-size) solid var(--md-menu-overlay-border-color, --gray-20);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/variables.scss */
/*# sourceURL=PlaybackRateView.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/components/player/PlaybackRateView.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/PlaybackRateView.ts":
/*!**************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/PlaybackRateView.ts ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PlaybackRateView: () => (/* binding */ PlaybackRateView)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../constants */ "./src/constants.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../constants */ "./src/components/QualityMonitoringWidget/constants.ts");
/* harmony import */ var _PlaybackRateView_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./PlaybackRateView.scss */ "./src/components/QualityMonitoringWidget/components/player/PlaybackRateView.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * @element agentx-wc-audio-player-playback-rate-control
 * @fires playback-rate-changed
 */
let PlaybackRateView = class PlaybackRateView extends lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement {
    constructor() {
        super(...arguments);
        this.playbackRate = 1;
    }
    static get styles() {
        return _PlaybackRateView_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    handleKeydownEvent(event, speed) {
        var _a;
        if (event.code === _constants__WEBPACK_IMPORTED_MODULE_2__.Key.Space || event.code === _constants__WEBPACK_IMPORTED_MODULE_2__.Key.Enter) {
            this.handlePlaybackRateChanged(speed);
        }
        else if (event.code === _constants__WEBPACK_IMPORTED_MODULE_2__.Key.Escape) {
            const menuOverlay = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-menu-overlay");
            if (menuOverlay) {
                event.stopPropagation();
                menuOverlay.isOpen = false;
            }
        }
    }
    handlePlaybackRateChanged(speed) {
        var _a;
        this.dispatchEvent(new CustomEvent("playback-rate-changed", {
            detail: speed,
            bubbles: true,
            composed: true
        }));
        const menuOverlay = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-menu-overlay");
        if (menuOverlay) {
            menuOverlay.isOpen = false;
        }
    }
    get playbackOptions() {
        return _constants__WEBPACK_IMPORTED_MODULE_3__.QMW_RECORDINGS_PLAYBACK_RATES.map((speed) => {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-list-item
          slot="list-item"
          data-speed="${speed}"
          @click=${() => this.handlePlaybackRateChanged(speed)}
          @keydown="${(event) => this.handleKeydownEvent(event, speed)}}"
        >
          ${speed}X
        </md-list-item>
      `;
        });
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <md-tooltip message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPlaybackSpeed")}" placement="top">
        <md-menu-overlay class="playback-overlay" custom-width="130px" allow-hover-toggle>
          <md-button
            variant="ghost"
            slot="menu-trigger"
            size=${_constants__WEBPACK_IMPORTED_MODULE_3__.QMW_RECORDINGS_PLAYER_BUTTON_SIZE}
            circle
            ariaExpanded="false"
            ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioPlaybackSpeed")}"
          >
            ${this.playbackRate}X
          </md-button>
          <div class="speed-overlay-container">
            <md-list label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.selectAudioPlaybackSpeed")}>${this.playbackOptions}</md-list>
            <div class="popover-arrow-border"></div>
            <div class="popover-arrow"></div>
          </div>
        </md-menu-overlay>
      </md-tooltip>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], PlaybackRateView.prototype, "playbackRate", void 0);
PlaybackRateView = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-audio-player-playback-rate-control")
], PlaybackRateView);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/PlayerTime.scss":
/*!**********************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/PlayerTime.scss ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.player-time span {
  display: inline-block;
  min-width: 3em;
  text-align: center;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/components/player/PlayerTime.scss */
/*# sourceURL=PlayerTime.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvUXVhbGl0eU1vbml0b3JpbmdXaWRnZXQvY29tcG9uZW50cy9wbGF5ZXIvUGxheWVyVGltZS5zY3NzIiwiUGxheWVyVGltZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UscUJBQUE7RUFDQSxjQUFBO0VBQ0Esa0JBQUE7QUNDRiIsImZpbGUiOiJQbGF5ZXJUaW1lLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIucGxheWVyLXRpbWUgc3BhbiB7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgbWluLXdpZHRoOiAzZW07XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbn1cbiIsIi5wbGF5ZXItdGltZSBzcGFuIHtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICBtaW4td2lkdGg6IDNlbTtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xufSJdfQ== */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/PlayerTime.ts":
/*!********************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/PlayerTime.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PlayerTime: () => (/* binding */ PlayerTime)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils */ "./src/components/QualityMonitoringWidget/utils.ts");
/* harmony import */ var _PlayerTime_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./PlayerTime.scss */ "./src/components/QualityMonitoringWidget/components/player/PlayerTime.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




/**
 * @element agentx-wc-audio-player-time
 */
let PlayerTime = class PlayerTime extends lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement {
    constructor() {
        super(...arguments);
        this.currentTime = 0;
        this.mainChapterLength = 0;
    }
    static get styles() {
        return _PlayerTime_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    render() {
        const time = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.relativeTimeFormatter)(this.currentTime, this.mainChapterLength);
        const totalTime = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.relativeTimeFormatter)(this.mainChapterLength, this.mainChapterLength);
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_1__.html) `<output class="player-time"> <span>${time}</span>/<span>${totalTime}</span> </output>`;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Number })
], PlayerTime.prototype, "currentTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Number })
], PlayerTime.prototype, "mainChapterLength", void 0);
PlayerTime = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("agentx-wc-audio-player-time")
], PlayerTime);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/Transcript.ts":
/*!********************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/Transcript.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Transcript: () => (/* binding */ Transcript)
/* harmony export */ });
class Transcript {
    constructor(transcriptJson) {
        this.sentences = [];
        this.transcriptJson = transcriptJson;
        this.processTranscriptData();
    }
    processTranscriptData() {
        this.transcriptJson.responseContents.sort((a, b) => {
            var _a, _b, _c, _d;
            const aStartTime = ((_a = a.recognitionResult.alternatives[0].words[0]) === null || _a === void 0 ? void 0 : _a.start_time.seconds) * 1e9 +
                ((_b = a.recognitionResult.alternatives[0].words[0]) === null || _b === void 0 ? void 0 : _b.start_time.nanos);
            const bStartTime = ((_c = b.recognitionResult.alternatives[0].words[0]) === null || _c === void 0 ? void 0 : _c.start_time.seconds) * 1e9 +
                ((_d = b.recognitionResult.alternatives[0].words[0]) === null || _d === void 0 ? void 0 : _d.start_time.nanos);
            return aStartTime - bStartTime;
        });
        this.transcriptJson.responseContents.forEach((content) => {
            this.createSentence(content);
        });
    }
    createSentence(content) {
        content.recognitionResult.alternatives.forEach((alternative) => {
            var _a, _b, _c, _d;
            const sentence = {
                startTime: ((_a = alternative.words[0]) === null || _a === void 0 ? void 0 : _a.start_time.seconds) * 1000 + ((_b = alternative.words[0]) === null || _b === void 0 ? void 0 : _b.start_time.nanos) / 1e6,
                endTime: ((_c = alternative.words[alternative.words.length - 1]) === null || _c === void 0 ? void 0 : _c.end_time.seconds) * 1000 +
                    ((_d = alternative.words[alternative.words.length - 1]) === null || _d === void 0 ? void 0 : _d.end_time.nanos) / 1e6,
                speaker: content.recognitionResult.role,
                text: alternative.transcript
            };
            this.sentences.push(sentence);
        });
    }
    getSentences() {
        return this.sentences;
    }
}


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/TranscriptMessageView.scss":
/*!*********************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/TranscriptMessageView.scss ***!
  \*********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.transcript-message-container {
  display: grid;
  grid-template-columns: 1fr auto;
}
.transcript-message-container .message {
  margin-left: 32px;
}
.transcript-message-container .timestamp {
  margin-right: 10px;
}
.transcript-message-container .is-active {
  font-weight: bold;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/components/player/TranscriptMessageView.scss */
/*# sourceURL=TranscriptMessageView.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvUXVhbGl0eU1vbml0b3JpbmdXaWRnZXQvY29tcG9uZW50cy9wbGF5ZXIvVHJhbnNjcmlwdE1lc3NhZ2VWaWV3LnNjc3MiLCJUcmFuc2NyaXB0TWVzc2FnZVZpZXcuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQUE7RUFDQSwrQkFBQTtBQ0NGO0FEQ0U7RUFDRSxpQkFBQTtBQ0NKO0FEQ0U7RUFDRSxrQkFBQTtBQ0NKO0FEQ0U7RUFDRSxpQkFBQTtBQ0NKIiwiZmlsZSI6IlRyYW5zY3JpcHRNZXNzYWdlVmlldy5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnRyYW5zY3JpcHQtbWVzc2FnZS1jb250YWluZXIge1xuICBkaXNwbGF5OiBncmlkO1xuICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IDFmciBhdXRvO1xuXG4gIC5tZXNzYWdlIHtcbiAgICBtYXJnaW4tbGVmdDogMzJweDtcbiAgfVxuICAudGltZXN0YW1wIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDEwcHg7XG4gIH1cbiAgLmlzLWFjdGl2ZSB7XG4gICAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIH1cbn1cbiIsIi50cmFuc2NyaXB0LW1lc3NhZ2UtY29udGFpbmVyIHtcbiAgZGlzcGxheTogZ3JpZDtcbiAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiAxZnIgYXV0bztcbn1cbi50cmFuc2NyaXB0LW1lc3NhZ2UtY29udGFpbmVyIC5tZXNzYWdlIHtcbiAgbWFyZ2luLWxlZnQ6IDMycHg7XG59XG4udHJhbnNjcmlwdC1tZXNzYWdlLWNvbnRhaW5lciAudGltZXN0YW1wIHtcbiAgbWFyZ2luLXJpZ2h0OiAxMHB4O1xufVxuLnRyYW5zY3JpcHQtbWVzc2FnZS1jb250YWluZXIgLmlzLWFjdGl2ZSB7XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xufSJdfQ== */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/TranscriptMessageView.ts":
/*!*******************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/TranscriptMessageView.ts ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TranscriptMessageView: () => (/* binding */ TranscriptMessageView)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Common_CellRenderers_components_TableAgentNameElement__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../Common/CellRenderers/components/TableAgentNameElement */ "./src/components/Common/CellRenderers/components/TableAgentNameElement.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils */ "./src/components/QualityMonitoringWidget/utils.ts");
/* harmony import */ var _TranscriptMessageView_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./TranscriptMessageView.scss */ "./src/components/QualityMonitoringWidget/components/player/TranscriptMessageView.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * @element agentx-wc-transcript-message-view
 * @fires timestamp-clicked
 */
let TranscriptMessageView = class TranscriptMessageView extends lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement {
    constructor() {
        super(...arguments);
        this.playbackTime = 0;
        this.email = "";
    }
    static get styles() {
        return _TranscriptMessageView_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    dispatchTimestampClicked(milliseconds) {
        this.dispatchEvent(new CustomEvent("timestamp-clicked", {
            detail: { milliseconds },
            bubbles: true,
            composed: true
        }));
    }
    getIsActiveMessage() {
        return !!(this.transcriptSentence &&
            this.playbackTime >= this.transcriptSentence.startTime &&
            this.playbackTime <= this.transcriptSentence.endTime);
    }
    render() {
        var _a, _b, _c, _d;
        const hasValidTimes = !Number.isNaN((_a = this.transcriptSentence) === null || _a === void 0 ? void 0 : _a.startTime) && !Number.isNaN((_b = this.transcriptSentence) === null || _b === void 0 ? void 0 : _b.endTime);
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_1__.html) `
      ${this.transcriptSentence
            ? (0,lit_html__WEBPACK_IMPORTED_MODULE_1__.html) ` <div class="transcript-message-container">
            <div>
              <div class="agent-name">
                <agentx-wc-table-agent-name
                  .name=${(_c = this.transcriptSentence) === null || _c === void 0 ? void 0 : _c.speaker}
                  .email=${this.email}
                ></agentx-wc-table-agent-name>
              </div>
              <div class="message ${this.getIsActiveMessage() ? "is-active" : ""}">
                ${(_d = this.transcriptSentence) === null || _d === void 0 ? void 0 : _d.text}
              </div>
            </div>
            ${hasValidTimes
                ? (0,lit_html__WEBPACK_IMPORTED_MODULE_1__.html) `<md-link
                  class="timestamp ${this.getIsActiveMessage() ? "is-active" : ""}"
                  tag="span"
                  @click="${() => this.transcriptSentence && this.dispatchTimestampClicked(this.transcriptSentence.startTime)}"
                  >${(0,_utils__WEBPACK_IMPORTED_MODULE_3__.relativeTimeFormatter)(this.transcriptSentence.startTime)}</md-link
                >`
                : ""}
          </div>`
            : ""}
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Object })
], TranscriptMessageView.prototype, "transcriptSentence", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Number })
], TranscriptMessageView.prototype, "playbackTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: String })
], TranscriptMessageView.prototype, "email", void 0);
TranscriptMessageView = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("agentx-wc-transcript-message-view")
], TranscriptMessageView);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/TranscriptView.scss":
/*!**************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/TranscriptView.scss ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJUcmFuc2NyaXB0Vmlldy5zY3NzIn0= */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/TranscriptView.ts":
/*!************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/TranscriptView.ts ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TranscriptView: () => (/* binding */ TranscriptView)
/* harmony export */ });
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _TranscriptMessageView__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./TranscriptMessageView */ "./src/components/QualityMonitoringWidget/components/player/TranscriptMessageView.ts");
/* harmony import */ var _TranscriptView_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./TranscriptView.scss */ "./src/components/QualityMonitoringWidget/components/player/TranscriptView.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * @element agentx-wc-transcript-view
 * @fires transcript-clicked
 */
let TranscriptView = class TranscriptView extends lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement {
    constructor() {
        super(...arguments);
        this.playbackTime = 0;
        this.seekTime = 0;
        this.currentActiveElement = null;
    }
    updated(_changedProperties) {
        if (_changedProperties.has("seekTime")) {
            this.scrollToSentenceAtSeekTime();
        }
        super.updated(_changedProperties);
    }
    static get styles() {
        return _TranscriptView_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    scrollToSentenceAtSeekTime() {
        var _a;
        const transcriptMessages = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll("agentx-wc-transcript-message-view");
        if (transcriptMessages.length === 0) {
            _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error("No transcript messages found");
            return;
        }
        const newActiveElement = Array.from(transcriptMessages).find((sentenceElement) => {
            const transcriptSentence = sentenceElement.transcriptSentence;
            return (transcriptSentence &&
                transcriptSentence.startTime <= this.seekTime &&
                transcriptSentence.endTime >= this.seekTime);
        });
        if (newActiveElement && newActiveElement !== this.currentActiveElement) {
            this.currentActiveElement = newActiveElement;
            this.currentActiveElement.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }
    dispatchTranscriptClicked(event) {
        this.dispatchEvent(new CustomEvent("transcript-clicked", {
            detail: { milliseconds: event.detail.milliseconds },
            bubbles: true,
            composed: true
        }));
    }
    render() {
        var _a;
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) ` <div class="transcript-container">
      ${(_a = this.customerTranscript) === null || _a === void 0 ? void 0 : _a.getSentences().map((sentence) => (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
          <agentx-wc-transcript-message-view
            @timestamp-clicked=${this.dispatchTranscriptClicked}
            .transcriptSentence=${sentence}
            .playbackTime=${this.playbackTime}
          ></agentx-wc-transcript-message-view>
          <br />
        `)}
    </div>`;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
], TranscriptView.prototype, "customerTranscript", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], TranscriptView.prototype, "playbackTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], TranscriptView.prototype, "seekTime", void 0);
TranscriptView = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-transcript-view")
], TranscriptView);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/VisualizerView.scss":
/*!**************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/VisualizerView.scss ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  --grid-header-height: 60px;
  --visualizer-title-width: 100px;
  --visualizer-title-margin-left: 24px;
  --visualizer-container-max-height: 40px;
  --visualizer-container-max-width: 900px;
  --visualizer-container-gap: 16px;
  --visualizer-bar-max-width: 577px;
  --visualizer-bar-max-height: 4px;
  --player-controls-row-height: 50px;
  --player-controls-gap: 8px;
  --volume-popover-width: 180px;
  --volume-popover-height: 21px;
  --volume-popover-gap: 12px;
  --volume-popover-top-offset: 120%;
  --volume-popover-left-offset: 50%;
  --volume-popover-padding: 12px;
  --seek-bar-height: 8px;
  --seek-bar-thumb-size: 16px;
  --seek-bar-top-margin: 16px;
  --seek-bar-bottom-margin: 8px;
  --popover-arrow-size: 10px;
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --interaction-details-height: 220px;
  --interaction-details-vertical-padding: 12px;
  --interaction-details-optional-horizontal-margin: 24px;
  --interaction-details-item-bottom-margin: 4px;
  --interaction-details-item-grid-template-columns: 150px auto;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  --chapters-container-height: 292px;
  --chapters-container-height-no-border: 250px;
  --chapters-container-height-hidden-tabs: 350px;
  --chapters-container-height: 292px;
  --chapters-container-height-hidden-tabs-no-border: 300px;
  --chapters-container-padding-right: 18px;
  --chapter-container-padding-top: 5px;
  --chapter-container-padding-bottom: 12px;
  --chapter-time-width: 60px;
  --chapter-title-width: 300px;
  --transcript-height: 285px;
  --transcript-height-no-chapters: 410px;
  --transcript-height-chapters-no-consults: 350px;
}

.visualizers-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: var(--visualizer-container-gap);
  gap: var(--visualizer-container-gap);
}

.visualizer-container {
  display: flex;
  max-height: var(--visualizer-container-max-height);
  align-items: center;
  border-radius: 4px;
  border: 1px solid;
  cursor: pointer;
  border-color: var(--md-gray-20, #dedede);
  background-color: var(--md-primary-bg-color);
}

.visualizer-container:hover {
  background-color: var(--md-secondary-bg-color, #f7f7f7);
}

.visualizer-container:focus {
  border-color: var(--blue-40-color, #1170cf);
  background-color: var(--md-secondary-bg-color, #f7f7f7);
}

.containerSelected {
  border-color: var(--md-blue-60, #1170cf);
}

.visualizer-bar {
  flex-grow: 1;
  width: var(--visualizer-bar-max-width);
  height: var(--visualizer-bar-max-height);
  margin: 18px 21px;
  border-radius: 2px;
  background-color: var(--md-gray-20, #8d8f92);
}

.visualizer-title {
  flex: 1;
  max-width: var(--visualizer-title-width);
  margin-left: var(--visualizer-title-margin-left);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=VisualizerView.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/variables.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/components/player/VisualizerView.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/VisualizerView.ts":
/*!************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/VisualizerView.ts ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   VisualizerView: () => (/* binding */ VisualizerView)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _css_variables_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @css/variables.scss */ "./src/assets/styles/variables.scss");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils */ "./src/components/QualityMonitoringWidget/utils.ts");
/* harmony import */ var _VisualizerView_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./VisualizerView.scss */ "./src/components/QualityMonitoringWidget/components/player/VisualizerView.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






/**
 * @element agentx-wc-visualizer-view
 * @fires visualizer-clicked
 */
let VisualizerView = class VisualizerView extends lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement {
    constructor() {
        super(...arguments);
        this.customerChapters = [];
        this.consultChapters = [];
        this.currentChapter = undefined;
        this.mainChapterLength = 0;
    }
    static get styles() {
        return _VisualizerView_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        // Default first chapter to be selected
        this.currentChapter = this.customerChapters[0];
        // Update the visualizer bar styles based on the loaded chapters
        this.updateBarStyle();
        this.requestUpdate();
    }
    getVisualizerTitle(isCustomerVisualizer) {
        return isCustomerVisualizer ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.customer") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.consult");
    }
    handleVisualizerClick(isCustomerVisualizer) {
        this.dispatchEvent(new CustomEvent("visualizer-clicked", {
            detail: isCustomerVisualizer,
            bubbles: true,
            composed: true
        }));
    }
    updateBarStyle() {
        var _a, _b;
        const customerBar = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById("customer-bar");
        const consultBar = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.getElementById("consult-bar");
        const customerBarStyle = (0,_utils__WEBPACK_IMPORTED_MODULE_4__.generateLinearStylingForChaptersView)(true, this.customerChapters, this.mainChapterLength);
        const consultBarStyle = (0,_utils__WEBPACK_IMPORTED_MODULE_4__.generateLinearStylingForChaptersView)(false, this.consultChapters, this.mainChapterLength);
        if (customerBar) {
            customerBar.style.background = `linear-gradient(to right, ${customerBarStyle})`;
        }
        if (consultBar) {
            consultBar.style.background = `linear-gradient(to right, ${consultBarStyle})`;
        }
    }
    getVisualizerStyleClass(isCustomerVisualizer) {
        var _a, _b;
        return isCustomerVisualizer === ((_b = (_a = this.currentChapter) === null || _a === void 0 ? void 0 : _a.getIsCustomerChapter()) !== null && _b !== void 0 ? _b : false) ? "containerSelected" : "";
    }
    renderVisualizer(isCustomerVisualizer) {
        if (this.consultChapters.length > 0) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div
          class="visualizer-container ${this.getVisualizerStyleClass(isCustomerVisualizer)}"
          id="${isCustomerVisualizer ? "customer-container" : "consult-container"}"
          tabindex="0"
          aria-label=${this.getVisualizerTitle(isCustomerVisualizer)}
          @click="${() => this.handleVisualizerClick(isCustomerVisualizer)}"
          @keydown="${() => this.handleVisualizerClick(isCustomerVisualizer)}"
        >
          <h4 class="visualizer-title">${this.getVisualizerTitle(isCustomerVisualizer)}</h4>
          <div class="visualizer-bar" id=${isCustomerVisualizer ? "customer-bar" : "consult-bar"}></div>
        </div>
      `;
        }
        else {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="visualizer-container selected">
          <div class="visualizer-bar" id="customer-bar"></div>
        </div>
      `;
        }
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
      <div class="visualizers-container">
        ${this.renderVisualizer(true)} ${this.consultChapters.length > 0 ? this.renderVisualizer(false) : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
], VisualizerView.prototype, "customerChapters", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
], VisualizerView.prototype, "consultChapters", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
], VisualizerView.prototype, "currentChapter", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
], VisualizerView.prototype, "mainChapterLength", void 0);
VisualizerView = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-visualizer-view")
], VisualizerView);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/VolumeControlView.scss":
/*!*****************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/VolumeControlView.scss ***!
  \*****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  --grid-header-height: 60px;
  --visualizer-title-width: 100px;
  --visualizer-title-margin-left: 24px;
  --visualizer-container-max-height: 40px;
  --visualizer-container-max-width: 900px;
  --visualizer-container-gap: 16px;
  --visualizer-bar-max-width: 577px;
  --visualizer-bar-max-height: 4px;
  --player-controls-row-height: 50px;
  --player-controls-gap: 8px;
  --volume-popover-width: 180px;
  --volume-popover-height: 21px;
  --volume-popover-gap: 12px;
  --volume-popover-top-offset: 120%;
  --volume-popover-left-offset: 50%;
  --volume-popover-padding: 12px;
  --seek-bar-height: 8px;
  --seek-bar-thumb-size: 16px;
  --seek-bar-top-margin: 16px;
  --seek-bar-bottom-margin: 8px;
  --popover-arrow-size: 10px;
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  --interaction-details-height: 220px;
  --interaction-details-vertical-padding: 12px;
  --interaction-details-optional-horizontal-margin: 24px;
  --interaction-details-item-bottom-margin: 4px;
  --interaction-details-item-grid-template-columns: 150px auto;
  --webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  --chapters-container-height: 292px;
  --chapters-container-height-no-border: 250px;
  --chapters-container-height-hidden-tabs: 350px;
  --chapters-container-height: 292px;
  --chapters-container-height-hidden-tabs-no-border: 300px;
  --chapters-container-padding-right: 18px;
  --chapter-container-padding-top: 5px;
  --chapter-container-padding-bottom: 12px;
  --chapter-time-width: 60px;
  --chapter-title-width: 300px;
  --transcript-height: 285px;
  --transcript-height-no-chapters: 410px;
  --transcript-height-chapters-no-consults: 350px;
}

.volume-container {
  position: relative;
  display: inline-block;
  z-index: 1;
}

.volume-popover {
  display: none;
  position: absolute;
  top: var(--volume-popover-top-offset);
  left: var(--volume-popover-left-offset);
  transform: translateX(-50%);
  background-color: var(--md-primary-bg-color);
  border: 1px solid var(--md-menu-overlay-border-color, --gray-20);
  padding: var(--volume-popover-padding);
  width: var(--volume-popover-width);
  height: var(--volume-popover-height);
  border-radius: var(--border-radius-medium);
  align-items: center;
  justify-content: space-between;
  gap: var(--volume-popover-gap);
}

.volume-container:hover .volume-popover {
  display: flex;
}

.popover-arrow,
.popover-arrow-border {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  border-left: var(--popover-arrow-size) solid transparent;
  border-right: var(--popover-arrow-size) solid transparent;
}

.popover-arrow {
  top: -9px;
  border-bottom: var(--popover-arrow-size) solid var(--md-primary-bg-color);
}

.popover-arrow-border {
  top: -10px;
  border-bottom: var(--popover-arrow-size) solid var(--md-menu-overlay-border-color, --gray-20);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=VolumeControlView.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/variables.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QualityMonitoringWidget/components/player/VolumeControlView.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QualityMonitoringWidget/components/player/VolumeControlView.ts":
/*!***************************************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/components/player/VolumeControlView.ts ***!
  \***************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   VolumeControlView: () => (/* binding */ VolumeControlView)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../constants */ "./src/constants.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../constants */ "./src/components/QualityMonitoringWidget/constants.ts");
/* harmony import */ var _VolumeControlView_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./VolumeControlView.scss */ "./src/components/QualityMonitoringWidget/components/player/VolumeControlView.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * @element agentx-wc-audio-player-volume-control
 * @fires volume-changed
 */
let VolumeControlView = class VolumeControlView extends lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement {
    constructor() {
        super(...arguments);
        this.volume = 50;
        this.preMutedVolume = 50;
    }
    static get styles() {
        return _VolumeControlView_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    get buttonIcon() {
        return this.volume === 0 ? "icon-speaker-disconnected_16" : "icon-speaker_16";
    }
    dispatchVolumeControlChangeEvent() {
        this.dispatchEvent(new CustomEvent("volume-changed", {
            detail: this.volume,
            bubbles: true,
            composed: true
        }));
    }
    handleButtonClick() {
        if (this.volume === 0) {
            this.volume = this.preMutedVolume;
        }
        else {
            this.preMutedVolume = this.volume;
            this.volume = 0;
        }
        this.dispatchVolumeControlChangeEvent();
    }
    isMuted() {
        return this.volume === 0;
    }
    handleVolumeChanged(e) {
        var _a;
        const popover = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".volume-popover");
        const popoverStyle = window.getComputedStyle(popover);
        if (popoverStyle.display === "none") {
            return;
        }
        const newVolume = e.detail.value;
        this.volume = newVolume;
        this.dispatchVolumeControlChangeEvent();
    }
    handleKeydownEvent(event) {
        var _a, _b;
        const popover = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".volume-popover");
        const popoverStyle = window.getComputedStyle(popover);
        if (event.code === _constants__WEBPACK_IMPORTED_MODULE_2__.Key.Enter || event.code === _constants__WEBPACK_IMPORTED_MODULE_2__.Key.Space) {
            if (popoverStyle.display === "none") {
                event.stopPropagation();
                popover.style.display = "flex";
                const slider = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("md-slider");
                slider.focus();
                return;
            }
        }
        else if (event.code === _constants__WEBPACK_IMPORTED_MODULE_2__.Key.Escape) {
            event.stopPropagation();
            popover.style.display = "none";
        }
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <div class="volume-container">
        <md-tooltip
          message="${this.isMuted() ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioVolumeUnmuteBtn") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioVolumeMuteBtn")}"
          placement="top"
        >
          <md-button
            variant="ghost"
            circle
            class="volume-button"
            ariaLabel="${this.isMuted() ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioVolumeUnmuteBtn") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioVolumeMuteBtn")}"
            size=${_constants__WEBPACK_IMPORTED_MODULE_3__.QMW_RECORDINGS_PLAYER_BUTTON_SIZE}
            @click=${this.handleButtonClick}
            @keydown="${(event) => {
            this.handleKeydownEvent(event);
        }}"
          >
            <md-icon slot="icon" name=${this.buttonIcon}></md-icon>
          </md-button>
        </md-tooltip>
        <div class="volume-popover">
          <md-icon slot="icon" name="icon-speaker-disconnected_16"></md-icon>
          <md-slider
            @slider-change=${this.handleVolumeChanged}
            ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.audioVolumeSlider")}
            hide-value="true"
            now=${this.volume}
            @keydown="${this.handleKeydownEvent}"
          ></md-slider>
          <md-icon slot="icon" name="icon-speaker_16"></md-icon>
          <div class="popover-arrow-border"></div>
          <div class="popover-arrow"></div>
        </div>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
], VolumeControlView.prototype, "volume", void 0);
VolumeControlView = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-audio-player-volume-control")
], VolumeControlView);



/***/ }),

/***/ "./src/components/QualityMonitoringWidget/config.ts":
/*!**********************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/config.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   autoCSatTemplate: () => (/* binding */ autoCSatTemplate),
/* harmony export */   getAgent: () => (/* binding */ getAgent),
/* harmony export */   getAutoCsat: () => (/* binding */ getAutoCsat),
/* harmony export */   getBaseGridConfigs: () => (/* binding */ getBaseGridConfigs),
/* harmony export */   getDate: () => (/* binding */ getDate),
/* harmony export */   getDuration: () => (/* binding */ getDuration),
/* harmony export */   getQueue: () => (/* binding */ getQueue),
/* harmony export */   getTeam: () => (/* binding */ getTeam),
/* harmony export */   suppressKeyboardEvent: () => (/* binding */ suppressKeyboardEvent)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _TeamPerformanceWidget_utils_KeyboardNavigationUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../TeamPerformanceWidget/utils/KeyboardNavigationUtils */ "./src/components/TeamPerformanceWidget/utils/KeyboardNavigationUtils.ts");
/* harmony import */ var _components_ActionsRenderer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/ActionsRenderer */ "./src/components/QualityMonitoringWidget/components/ActionsRenderer.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./constants */ "./src/components/QualityMonitoringWidget/constants.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./utils */ "./src/components/QualityMonitoringWidget/utils.ts");






const getAgent = (params) => {
    return params.data.owner.name;
};
const getTeam = (params) => {
    return params.data.lastTeam.name;
};
const getAutoCsat = (params) => {
    var _a;
    return (_a = params.data.autoCsat) !== null && _a !== void 0 ? _a : 0;
};
const getQueue = (params) => {
    return params.data.lastQueue.name;
};
const getDuration = (params) => {
    return luxon__WEBPACK_IMPORTED_MODULE_1__.Duration.fromMillis(params.data.connectedDuration).shiftTo("hours", "minutes", "seconds").toFormat("hh:mm:ss");
};
const getDate = (params) => {
    return (0,_utils__WEBPACK_IMPORTED_MODULE_5__.dateFormatterShortWithSeconds)(params.data.createdTime);
};
const suppressKeyboardEvent = (params) => {
    const { event } = params;
    if (event.code === "Tab" || event.key === "Tab") {
        const cellElement = event.target instanceof HTMLElement ? event.target.closest(".ag-cell") : null;
        if (!cellElement) {
            return false; // Cell element not found, do not suppress
        }
        const focusableChildElements = cellElement.querySelectorAll('button, [href], input:not(.ag-hidden), select, textarea, [tabindex]:not([tabindex="-1"])');
        const forwardTab = !event.shiftKey;
        const reverseTab = event.shiftKey;
        const lastFocusableElement = focusableChildElements[focusableChildElements.length - 1];
        const firstFocusableElement = focusableChildElements[0];
        if (focusableChildElements.length === 0 ||
            (forwardTab && event.target === lastFocusableElement) ||
            (reverseTab && event.target === firstFocusableElement)) {
            return false; // Do not suppress
        }
        else if (reverseTab && event.target === cellElement) {
            event.preventDefault();
            firstFocusableElement.focus(); // Set focus on the first focusable child element
            return true; // Suppress
        }
        return true; // Suppress
    }
    else {
        return false; // Do not suppress by default
    }
};
const autoCSatTemplate = (params) => {
    return `<div class="ag-cell-label-container" role="presentation">
  <span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
  <span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button" aria-hidden="true"></span>
  <div data-ref="eLabel" class="ag-header-cell-label" role="presentation" style="display: flex; justify-content: space-between; align-items: center;">
    <span data-ref="eText" class="ag-header-cell-text">${params.text}</span>
    <md-tooltip placement="top" message="${params.tooltip}">
      <md-icon aria-label="${params.tooltip}" iconSet="momentumDesign" name="info-badge-filled"></md-icon>
    </md-tooltip>
  </div>
</div>`;
};
const getBaseGridConfigs = (configs) => {
    return {
        components: {
            actionsRenderer: _components_ActionsRenderer__WEBPACK_IMPORTED_MODULE_3__["default"]
        },
        columnDefs: [
            {
                field: "id",
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.sessionId")}`,
                suppressHeaderMenuButton: true,
                width: _constants__WEBPACK_IMPORTED_MODULE_4__.SESSION_ID_COLUMN_WIDTH
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.queue")}`,
                suppressHeaderMenuButton: true,
                valueGetter: getQueue
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.team")}`,
                suppressHeaderMenuButton: true,
                valueGetter: getTeam
            },
            {
                field: "autoCSAT",
                hide: !configs().isAutoCsatEnabled,
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.autoCsat")}`,
                suppressHeaderMenuButton: true,
                valueGetter: getAutoCsat,
                headerComponentParams: {
                    template: autoCSatTemplate({
                        text: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.autoCsat"),
                        tooltip: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.autoCsatTooltip")
                    })
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.agent")}`,
                suppressHeaderMenuButton: true,
                valueGetter: getAgent
            },
            {
                field: "origin",
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.ani")}`,
                suppressHeaderMenuButton: true
            },
            {
                field: "destination",
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.dnis")}`,
                suppressHeaderMenuButton: true
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.duration")}`,
                suppressHeaderMenuButton: true,
                valueGetter: getDuration
            },
            {
                field: "lastWrapupCodeName",
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.wrapupCodes")}`,
                suppressHeaderMenuButton: true
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.date")}`,
                suppressHeaderMenuButton: true,
                valueGetter: getDate
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.actions")}`,
                suppressHeaderMenuButton: true,
                pinned: "right",
                lockPinned: true,
                cellRenderer: "actionsRenderer",
                field: "actions",
                width: 117,
                cellEditorParams: {
                    i18n: {
                        playRecording: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.playRecording"),
                        evaluateTask: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.evaluateTask")
                    }
                }
            }
        ],
        defaultColDef: {
            suppressKeyboardEvent,
            suppressHeaderKeyboardEvent: _TeamPerformanceWidget_utils_KeyboardNavigationUtils__WEBPACK_IMPORTED_MODULE_2__.suppressHeaderKeyboardEvent,
            resizable: true,
            sortable: false
        },
        columnMenu: "legacy",
        rowModelType: "serverSide",
        cacheBlockSize: _constants__WEBPACK_IMPORTED_MODULE_4__.MAX_ROWS_IN_RESPONSE,
        maxBlocksInCache: 2,
        suppressContextMenu: true,
        blockLoadDebounceMillis: 1000,
        suppressAnimationFrame: true,
        animateRows: false,
        localeText: {
            loadingOoo: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:qmw.loading")
        }
    };
};


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/constants.ts":
/*!*************************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/constants.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   COPY_CLICK_TIMEOUT: () => (/* binding */ COPY_CLICK_TIMEOUT),
/* harmony export */   GRID: () => (/* binding */ GRID),
/* harmony export */   MAX_ROWS_IN_RESPONSE: () => (/* binding */ MAX_ROWS_IN_RESPONSE),
/* harmony export */   QMW_ACTIONS_BTN_CLICK: () => (/* binding */ QMW_ACTIONS_BTN_CLICK),
/* harmony export */   QMW_AUDIO_PLAYER_CONTROL_CLICKED: () => (/* binding */ QMW_AUDIO_PLAYER_CONTROL_CLICKED),
/* harmony export */   QMW_ERR_RETRY: () => (/* binding */ QMW_ERR_RETRY),
/* harmony export */   QMW_EVALUATE_BTN_CLICK: () => (/* binding */ QMW_EVALUATE_BTN_CLICK),
/* harmony export */   QMW_FILTERS_UPDATED: () => (/* binding */ QMW_FILTERS_UPDATED),
/* harmony export */   QMW_RECORDINGS_MODAL_CLOSE_BTN_CLK: () => (/* binding */ QMW_RECORDINGS_MODAL_CLOSE_BTN_CLK),
/* harmony export */   QMW_RECORDINGS_PLAYBACK_RATES: () => (/* binding */ QMW_RECORDINGS_PLAYBACK_RATES),
/* harmony export */   QMW_RECORDINGS_PLAYER_BUTTON_SIZE: () => (/* binding */ QMW_RECORDINGS_PLAYER_BUTTON_SIZE),
/* harmony export */   RECORDING: () => (/* binding */ RECORDING),
/* harmony export */   SESSION_ID_COLUMN_WIDTH: () => (/* binding */ SESSION_ID_COLUMN_WIDTH)
/* harmony export */ });
const COPY_CLICK_TIMEOUT = 500;
const GRID = "GRID";
const MAX_ROWS_IN_RESPONSE = 500;
const QMW_ACTIONS_BTN_CLICK = "qmw-play-btn-clicked";
const QMW_EVALUATE_BTN_CLICK = "qmw-evaluate-btn-clicked";
const QMW_ERR_RETRY = "qmw-error-retry";
const QMW_RECORDINGS_MODAL_CLOSE_BTN_CLK = "qmw-recordings-modal-close-btn-clicked";
const QMW_AUDIO_PLAYER_CONTROL_CLICKED = "qmw-audio-player-action-clicked";
const RECORDING = "RECORDING";
const SESSION_ID_COLUMN_WIDTH = 350;
const QMW_FILTERS_UPDATED = "qmw-filters-updated";
const QMW_RECORDINGS_PLAYBACK_RATES = [0.5, 0.75, 1, 1.25, 1.5, 2];
const QMW_RECORDINGS_PLAYER_BUTTON_SIZE = 40;


/***/ }),

/***/ "./src/components/QualityMonitoringWidget/utils.ts":
/*!*********************************************************!*\
  !*** ./src/components/QualityMonitoringWidget/utils.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChapterType: () => (/* binding */ ChapterType),
/* harmony export */   RecordingEvent: () => (/* binding */ RecordingEvent),
/* harmony export */   createArrayOfAgents: () => (/* binding */ createArrayOfAgents),
/* harmony export */   createCaptureData: () => (/* binding */ createCaptureData),
/* harmony export */   dateFormatterShortWithSeconds: () => (/* binding */ dateFormatterShortWithSeconds),
/* harmony export */   errorIsRetryable: () => (/* binding */ errorIsRetryable),
/* harmony export */   generateLinearStylingForChaptersView: () => (/* binding */ generateLinearStylingForChaptersView),
/* harmony export */   isCustomerTrack: () => (/* binding */ isCustomerTrack),
/* harmony export */   relativeTimeFormatter: () => (/* binding */ relativeTimeFormatter),
/* harmony export */   wait: () => (/* binding */ wait)
/* harmony export */ });
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_1__);


const dateFormatterShortWithSeconds = (dateInMilliseconds) => {
    return luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.fromMillis(dateInMilliseconds).toFormat("D tt");
};
const relativeTimeFormatter = (timeInMilliseconds, totalTimeInMilliSeconds = 0) => {
    if (totalTimeInMilliSeconds <= timeInMilliseconds) {
        totalTimeInMilliSeconds = timeInMilliseconds;
    }
    let format = "mm:ss";
    if (luxon__WEBPACK_IMPORTED_MODULE_1__.Duration.fromMillis(totalTimeInMilliSeconds).as("hours") >= 1) {
        format = "hh:mm:ss";
    }
    return luxon__WEBPACK_IMPORTED_MODULE_1__.Duration.fromMillis(timeInMilliseconds).shiftTo("hours", "minutes", "seconds").toFormat(format);
};
const errorIsRetryable = (errorDetails) => {
    const { statusCode, retryAfter } = errorDetails;
    return statusCode === 429 && !!retryAfter;
};
const wait = (errorDetails) => {
    const { retryAfter } = errorDetails;
    return new Promise((resolve) => setTimeout(resolve, retryAfter));
};
var ChapterType;
(function (ChapterType) {
    ChapterType["Main"] = "Main";
    ChapterType["Hold"] = "Hold";
    ChapterType["Customer"] = "Customer";
    ChapterType["ConsultRequest"] = "ConsultRequest";
    ChapterType["Consulting"] = "Consulting";
    ChapterType["Conferencing"] = "Conferencing";
})(ChapterType || (ChapterType = {}));
const isCustomerTrack = (chapterType) => {
    return (chapterType === ChapterType.Customer ||
        chapterType === ChapterType.Conferencing ||
        chapterType === ChapterType.Hold ||
        chapterType === ChapterType.Main);
};
var RecordingEvent;
(function (RecordingEvent) {
    RecordingEvent["JOIN_CONFERENCE"] = "join-conference";
    RecordingEvent["CONFERENCE_DONE"] = "conference-done";
    RecordingEvent["FABRICATED_CONFERENCE_LEAVE"] = "fabricated-conference-leave";
    RecordingEvent["FABRICATED_HOLD_DONE"] = "fabricated-hold-done";
    RecordingEvent["HOLD"] = "on-hold";
    RecordingEvent["ENDED"] = "ended";
    RecordingEvent["RECORDING_AVAILABLE"] = "recording-available";
    RecordingEvent["RECORDING_STARTED"] = "recording-started";
    RecordingEvent["CONSULT_REQUESTED"] = "consult";
    RecordingEvent["CONSULT_DONE"] = "consult-done";
    RecordingEvent["CONSULTING"] = "consulting";
})(RecordingEvent || (RecordingEvent = {}));
const createArrayOfAgents = (primaryAgentName, metaData, chapterType) => {
    if (metaData.length <= 0) {
        return [];
    }
    return Array.from(new Set(metaData
        .filter((chapterMetaData) => chapterMetaData.chapterType === chapterType)
        .flatMap((chapterMetaData) => chapterMetaData.involvedAgentNames)
        .filter((agentName) => agentName !== primaryAgentName)));
};
const MIN_NUMBER_AGENTS_IN_CONFERENCE = 2;
const MAXIMUM_SUPPORTED_EVENTS = 100;
/**
 * Generates fabricated leave conference and hold done events based on the given capture metadata.
 * The event fabrication mainly accounts for consuming events in chronological order to track 'involvedAgentsInConference' and 'lastChapter' correctly.
 * The events from /search endpoint may overlap in the case of conferences, such as hold events, agent leaving the call , or agent joining the call.
 * Reasons to fabricate:
 * - Leave conference event: because there is no explicit event for it from /search.
 * - Hold done event: because hold-done events from /search cannot be trusted (e.g., unexpected isolated hold-done event during conferences). Bug: CX-16318
 *
 * @param captureMetaDatas - The capture metadata containing the events.
 * @returns The fabricated leave conference and hold done events.
 */
const generateFabricatedLeaveConferenceAndHoldDoneEvents = (captureMetaDatas) => {
    const joinConferenceAndHoldEvents = captureMetaDatas.filter((captureMetaData) => captureMetaData.eventName === RecordingEvent.JOIN_CONFERENCE || captureMetaData.eventName === RecordingEvent.HOLD);
    const fabricatedLeaveConferenceAndHoldDoneEvents = [];
    joinConferenceAndHoldEvents.sort((a, b) => a.createdTime - b.createdTime);
    joinConferenceAndHoldEvents.forEach((event) => {
        if (event.eventName === RecordingEvent.JOIN_CONFERENCE) {
            fabricatedLeaveConferenceAndHoldDoneEvents.push({
                eventName: RecordingEvent.FABRICATED_CONFERENCE_LEAVE,
                createdTime: event.endedTime,
                endedTime: event.endedTime,
                agentName: event.agentName,
                duration: 0,
                destinationAgentName: event.destinationAgentName
            });
        }
        else if (event.eventName === RecordingEvent.HOLD) {
            fabricatedLeaveConferenceAndHoldDoneEvents.push({
                eventName: RecordingEvent.FABRICATED_HOLD_DONE,
                createdTime: event.endedTime,
                endedTime: event.endedTime,
                agentName: event.agentName,
                duration: 0,
                destinationAgentName: event.destinationAgentName
            });
        }
    });
    fabricatedLeaveConferenceAndHoldDoneEvents.sort((a, b) => a.createdTime - b.createdTime);
    return fabricatedLeaveConferenceAndHoldDoneEvents;
};
const addNewCustomerChapter = (startTime, endTime, mainRecordingFilePath, customerChaptersMetaData) => {
    customerChaptersMetaData.push({
        chapterType: ChapterType.Customer,
        startTime,
        endTime,
        involvedAgentNames: [],
        fileLocation: mainRecordingFilePath
    });
};
const removeAgentNameFromArray = (agentName, agentNames) => {
    const index = agentNames.indexOf(agentName);
    if (index > -1) {
        agentNames.splice(index, 1);
    }
};
const updateChapterEndTime = (chapter, endTime) => {
    if (chapter) {
        chapter.endTime = endTime;
    }
};
const handleEventDuringHold = (involvedAgentsInConference, event) => {
    if (event.eventName === RecordingEvent.JOIN_CONFERENCE) {
        involvedAgentsInConference.push(event.agentName);
    }
    else if (event.eventName === RecordingEvent.FABRICATED_CONFERENCE_LEAVE) {
        removeAgentNameFromArray(event.agentName, involvedAgentsInConference);
    }
};
const handleEventHoldDone = (lastChapter, customerChaptersMetaData, mainRecordingFilePath, involvedAgentsInConference, event) => {
    if (involvedAgentsInConference.length >= MIN_NUMBER_AGENTS_IN_CONFERENCE) {
        updateChapterEndTime(lastChapter, event.createdTime);
        customerChaptersMetaData.push({
            chapterType: ChapterType.Conferencing,
            startTime: event.createdTime,
            endTime: -1,
            involvedAgentNames: [...involvedAgentsInConference],
            fileLocation: mainRecordingFilePath
        });
    }
    else if ((lastChapter === null || lastChapter === void 0 ? void 0 : lastChapter.chapterType) === ChapterType.Customer) {
        updateChapterEndTime(lastChapter, event.endedTime);
    }
    else {
        updateChapterEndTime(lastChapter, event.createdTime);
        addNewCustomerChapter(event.createdTime, -1, mainRecordingFilePath, customerChaptersMetaData);
    }
};
const handleEventAgentJoinsConference = (lastChapter, customerChaptersMetaData, mainRecordingFilePath, involvedAgentsInConference, event) => {
    involvedAgentsInConference.push(event.agentName);
    if (lastChapter &&
        lastChapter.chapterType === ChapterType.Conferencing &&
        lastChapter.startTime === event.createdTime) {
        // Collapse two consecutive join-conference chapters together - this is the start of a new conference
        lastChapter.involvedAgentNames.push(event.agentName);
        return;
    }
    updateChapterEndTime(lastChapter, event.createdTime);
    customerChaptersMetaData.push({
        chapterType: ChapterType.Conferencing,
        startTime: event.createdTime,
        endTime: event.endedTime,
        involvedAgentNames: [...involvedAgentsInConference],
        fileLocation: mainRecordingFilePath
    });
};
const generateConsultChapters = (captureMetaDatas) => {
    const consultChaptersMetaData = [];
    const consultEvents = captureMetaDatas.filter((captureMetaData) => captureMetaData.eventName === RecordingEvent.CONSULT_REQUESTED ||
        captureMetaData.eventName === RecordingEvent.CONSULTING ||
        captureMetaData.eventName === RecordingEvent.CONSULT_DONE);
    consultEvents.sort((a, b) => a.createdTime - b.createdTime);
    consultEvents.forEach((currentEvent) => {
        const involvedAgents = [currentEvent.agentName].concat(currentEvent.destinationAgentName);
        if (currentEvent.eventName === RecordingEvent.CONSULT_REQUESTED) {
            consultChaptersMetaData.push({
                chapterType: ChapterType.ConsultRequest,
                startTime: currentEvent.createdTime,
                endTime: currentEvent.endedTime,
                involvedAgentNames: involvedAgents,
                fileLocation: ""
            });
        }
        else if (currentEvent.eventName === RecordingEvent.CONSULTING) {
            if (consultChaptersMetaData.length > 0) {
                updateChapterEndTime(consultChaptersMetaData[consultChaptersMetaData.length - 1], currentEvent.createdTime);
            }
            consultChaptersMetaData.push({
                chapterType: ChapterType.Consulting,
                startTime: currentEvent.createdTime,
                endTime: currentEvent.endedTime,
                involvedAgentNames: involvedAgents,
                fileLocation: ""
            });
        }
    });
    return consultChaptersMetaData;
};
const generateCustomerChapters = (captureMetaDatas, mainRecordingFilePath) => {
    const customerChaptersMetaData = [];
    const involvedAgentsInConference = [];
    const fabricatedLeaveConferenceAndHoldDoneEvents = generateFabricatedLeaveConferenceAndHoldDoneEvents(captureMetaDatas);
    let customerEvents = captureMetaDatas.filter((captureMetaData) => captureMetaData.eventName !== RecordingEvent.CONSULT_REQUESTED &&
        captureMetaData.eventName !== RecordingEvent.CONSULTING &&
        captureMetaData.eventName !== RecordingEvent.CONSULT_DONE);
    customerEvents = [...customerEvents, ...fabricatedLeaveConferenceAndHoldDoneEvents];
    customerEvents.sort((a, b) => a.createdTime - b.createdTime);
    customerEvents.forEach((event) => {
        const lastChapter = customerChaptersMetaData.length > 0 ? customerChaptersMetaData[customerChaptersMetaData.length - 1] : null;
        if (event.eventName === RecordingEvent.RECORDING_STARTED) {
            addNewCustomerChapter(event.createdTime, -1, mainRecordingFilePath, customerChaptersMetaData);
            return;
        }
        if (event.eventName === RecordingEvent.ENDED) {
            updateChapterEndTime(lastChapter, event.createdTime);
            return;
        }
        if (event.eventName === RecordingEvent.HOLD) {
            updateChapterEndTime(lastChapter, event.createdTime);
            customerChaptersMetaData.push({
                chapterType: ChapterType.Hold,
                startTime: event.createdTime,
                endTime: event.endedTime,
                involvedAgentNames: [],
                fileLocation: mainRecordingFilePath
            });
            return;
        }
        // Currently ongoing hold
        if (lastChapter && lastChapter.chapterType === ChapterType.Hold && event.createdTime < lastChapter.endTime) {
            handleEventDuringHold(involvedAgentsInConference, event);
            return;
        }
        // Customer/Conference off hold
        if (event.eventName === RecordingEvent.FABRICATED_HOLD_DONE) {
            handleEventHoldDone(lastChapter, customerChaptersMetaData, mainRecordingFilePath, involvedAgentsInConference, event);
            return;
        }
        // Agent leaves conference
        if (event.eventName === RecordingEvent.FABRICATED_CONFERENCE_LEAVE) {
            removeAgentNameFromArray(event.agentName, involvedAgentsInConference);
            // Check if the conference is still ongoing
            if (involvedAgentsInConference.length >= MIN_NUMBER_AGENTS_IN_CONFERENCE) {
                updateChapterEndTime(lastChapter, event.createdTime);
                customerChaptersMetaData.push({
                    chapterType: ChapterType.Conferencing,
                    startTime: event.createdTime,
                    endTime: -1,
                    involvedAgentNames: [...involvedAgentsInConference],
                    fileLocation: mainRecordingFilePath
                });
            }
            return;
        }
        // Conference ends
        if (event.eventName === RecordingEvent.CONFERENCE_DONE) {
            if (involvedAgentsInConference.length >= MIN_NUMBER_AGENTS_IN_CONFERENCE) {
                updateChapterEndTime(lastChapter, event.createdTime);
                addNewCustomerChapter(event.createdTime, event.endedTime, mainRecordingFilePath, customerChaptersMetaData);
                involvedAgentsInConference.splice(0, involvedAgentsInConference.length);
            }
            return;
        }
        // Agent joins conference
        if (event.eventName === RecordingEvent.JOIN_CONFERENCE) {
            handleEventAgentJoinsConference(lastChapter, customerChaptersMetaData, mainRecordingFilePath, involvedAgentsInConference, event);
        }
    });
    return customerChaptersMetaData;
};
const createCustomerChapterFromMainRecording = (recordingDatas) => {
    const customerChaptersMetaData = [];
    const mainRecording = recordingDatas.find((data) => data.segment === false && data.attributes.callType === "main");
    if (mainRecording) {
        addNewCustomerChapter(mainRecording.attributes.startTime, mainRecording.attributes.stopTime, mainRecording.attributes.filePath, customerChaptersMetaData);
    }
    return customerChaptersMetaData;
};
/**
 * Creates the capture data for the Quality Monitoring Widget.
 *
 * @param recordingDatas - An array of recording data.
 * @param captureMetaDatas - An array of capture metadata.
 * @returns The customer and consult chapter metadata.
 */
const createCaptureData = (recordingDatas, captureMetaDatas) => {
    var _a, _b;
    const returnChapterMetaDatas = {
        customerChaptersMetaData: [],
        consultChaptersMetaData: []
    };
    if (recordingDatas.length === 0) {
        return returnChapterMetaDatas;
    }
    // If the captureMetaData is >= 100, it means that the search endpoint has returned the maximum client-supported number of events
    // However, if the recording is available, we can generate a single customer chapter
    if (captureMetaDatas.length >= MAXIMUM_SUPPORTED_EVENTS &&
        captureMetaDatas.some((event) => event.eventName === RecordingEvent.RECORDING_AVAILABLE)) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info(`[App:QMW] Received maximum number client-supported events: ${MAXIMUM_SUPPORTED_EVENTS}. Generating single customer chapter with available recording data.`);
        returnChapterMetaDatas.customerChaptersMetaData = createCustomerChapterFromMainRecording(recordingDatas);
        return returnChapterMetaDatas;
    }
    // Get the customer legs
    const mainRecordingFilePath = (_b = (_a = recordingDatas.find((data) => data.segment === false && data.attributes.callType === "main")) === null || _a === void 0 ? void 0 : _a.attributes.filePath) !== null && _b !== void 0 ? _b : "";
    returnChapterMetaDatas.customerChaptersMetaData = generateCustomerChapters(captureMetaDatas, mainRecordingFilePath);
    // Get the consult legs
    returnChapterMetaDatas.consultChaptersMetaData = generateConsultChapters(captureMetaDatas);
    // Match recording media
    const consultMedia = recordingDatas.filter((recordingMedia) => recordingMedia.attributes.callType === "consult" && recordingMedia.segment === false);
    consultMedia.sort((a, b) => a.attributes.startTime - b.attributes.startTime);
    let consultIdx = 0;
    returnChapterMetaDatas.consultChaptersMetaData.forEach((consult) => {
        if (consult.chapterType === ChapterType.Consulting && consultIdx < consultMedia.length) {
            consult.fileLocation = consultMedia[consultIdx].attributes.filePath;
            consultIdx++;
        }
    });
    return returnChapterMetaDatas;
};
const generateLinearStylingForChaptersView = (isCustomerVisualizer, chapters, mainChapterLength) => {
    const noAudioTrackColor = "var(--md-gray-20, #DEDEDE)";
    const trackWithAudioColor = "var(--md-gray-60, #707070)";
    const mainColor = isCustomerVisualizer ? trackWithAudioColor : noAudioTrackColor;
    const chapterGap = 0.5;
    let prevEndMark = 0;
    let startMark = 0;
    let style = ``;
    if (mainChapterLength === 0) {
        return style;
    }
    // Open first chapter
    if (chapters[0]) {
        startMark = Number(((chapters[0].startTimeMillis / mainChapterLength) * 100).toFixed(2));
    }
    if (startMark > 0) {
        style += `${mainColor} 0%, ${mainColor} ${startMark - chapterGap}%, `;
        style += `${noAudioTrackColor} ${startMark - chapterGap}%, ${noAudioTrackColor} ${startMark}%, `;
        prevEndMark = startMark;
    }
    chapters.forEach((track, index) => {
        startMark = Number(((track.startTimeMillis / mainChapterLength) * 100).toFixed(2));
        const endMark = Number(((track.endTimeMillis / mainChapterLength) * 100).toFixed(2));
        // Close gap between this and previous end mark
        if (index > 0 && index < chapters.length - 1 && prevEndMark !== startMark) {
            style += `${mainColor} ${prevEndMark}%, ${mainColor} ${startMark}%, `;
        }
        // Check if add the gap
        if (Math.abs(endMark - startMark) > chapterGap && Math.abs(100 - endMark) > chapterGap) {
            style += `${trackWithAudioColor} ${startMark}%, ${trackWithAudioColor} ${endMark - chapterGap}%, `;
            style += `${noAudioTrackColor} ${endMark - chapterGap}%, ${noAudioTrackColor} ${endMark}%, `;
        }
        else {
            style += `${trackWithAudioColor} ${startMark}%, ${trackWithAudioColor} ${endMark}%, `;
        }
        prevEndMark = endMark;
    });
    // Close final chapter
    style += `${mainColor} ${prevEndMark}%, ${mainColor} 100%`;
    return style;
};


/***/ }),

/***/ "./src/components/QueueStatsTab/QueueStatsDetail/QueueStatsDetail.scss":
/*!*****************************************************************************!*\
  !*** ./src/components/QueueStatsTab/QueueStatsDetail/QueueStatsDetail.scss ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  overflow: auto;
  gap: 8px;
}

.overview-container {
  box-sizing: border-box;
  flex: 1;
  gap: 4px;
}

.content {
  gap: 8px;
}

.customize-button {
  margin: 8px;
}

.spacer {
  flex-grow: 1;
  display: flex;
}

.section-label {
  font-size: var(--font-size-large);
  font-weight: 700;
  font-family: var(--brand-font-regular, "CiscoSansTT Regular");
  line-height: 24px;
  align-items: center;
  color: var(--md-primary-text-color);
}

.section-info {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  line-height: 15px;
  height: 44px;
  margin: 8px 16px 4px 16px;
}

.breadcrumb-segment-bold {
  font-weight: 700;
  font-size: var(--font-size-heading-small, 20px);
  color: var(--md-primary-text-color);
  font-family: var(--brand-font-bold, "CiscoSansTT Regular");
  line-height: var(--font-lineheight-heading-small);
}

.breadcrumb-segment {
  font-weight: 400;
  font-size: var(--font-size-heading-small, 20px);
  color: var(--md-primary-text-color);
  font-family: var(--brand-font-regular, "CiscoSansTT Regular");
  line-height: var(--font-lineheight-heading-small);
}

.tab-header {
  display: flex;
  margin: 12px 0px;
  align-items: center;
  justify-content: space-between;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=QueueStatsDetail.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QueueStatsTab/QueueStatsDetail/QueueStatsDetail.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QueueStatsTab/QueueStatsDetail/QueueStatsDetail.ts":
/*!***************************************************************************!*\
  !*** ./src/components/QueueStatsTab/QueueStatsDetail/QueueStatsDetail.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueueStatsDetail: () => (/* binding */ QueueStatsDetail)
/* harmony export */ });
/* harmony import */ var _components_Common_CellRenderers_constants_channel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/CellRenderers/constants/channel */ "./src/components/Common/CellRenderers/constants/channel.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_if_defined_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/if-defined.js */ "lit-html/directives/if-defined.js");
/* harmony import */ var lit_html_directives_if_defined_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_QueueStatsHeader_QueueStatsHeader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../components/QueueStatsHeader/QueueStatsHeader */ "./src/components/QueueStatsTab/components/QueueStatsHeader/QueueStatsHeader.ts");
/* harmony import */ var _QueueStatsUtils_QueueStatsUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../QueueStatsUtils/QueueStatsUtils */ "./src/components/QueueStatsTab/QueueStatsUtils/QueueStatsUtils.ts");
/* harmony import */ var _QueueStatsDetail_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./QueueStatsDetail.scss */ "./src/components/QueueStatsTab/QueueStatsDetail/QueueStatsDetail.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};










const queueStatsDataSet = "wxcc.rtd.queuestats";
let QueueStatsDetail = class QueueStatsDetail extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_4__.LitElement) {
    constructor() {
        super(...arguments);
        this.queueId = "";
        this.orgId = "";
        this.isRTDIntialized = false;
        this.queueStatsSubscription = {};
        this.queueDataMap = new Map();
        this.subscribeQueueStatsDataSet = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[App:QSD] Subscribing to queue stats dataset");
            return (_a = window.wxcc) === null || _a === void 0 ? void 0 : _a.rtdwc.subscribe({
                datasetName: queueStatsDataSet,
                update: (queueStatsData, deltaData) => {
                    const updatedInfo = (0,_QueueStatsUtils_QueueStatsUtils__WEBPACK_IMPORTED_MODULE_8__.getQueueStatsData)(queueStatsData.datasetValues, this.queueDataMap, queueStatsData.type, deltaData === null || deltaData === void 0 ? void 0 : deltaData.datasetValues);
                    this.queueDataMap = updatedInfo.model;
                    this.filterQueueData();
                }
            });
        });
    }
    static get styles() {
        return _QueueStatsDetail_scss__WEBPACK_IMPORTED_MODULE_9__["default"];
    }
    connectedCallback() {
        _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[App:QSD] Connected callback");
        super.connectedCallback();
        this.setupQueueStatsSubscription();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.unsubscribeQueueStatsSubscription();
    }
    setupQueueStatsSubscription() {
        return __awaiter(this, void 0, void 0, function* () {
            _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[App:QSD] Setting up queue stats details subscription");
            if (!this.isRTDIntialized) {
                _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[App:QSD] QueueStats subscription skipped as RTD is not initialized");
                return;
            }
            try {
                const [queueStats] = yield Promise.all([this.subscribeQueueStatsDataSet()]);
                this.queueStatsSubscription = queueStats;
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("[App:QSD] QueueStats Details subscription failed", error);
            }
        });
    }
    unsubscribeQueueStatsSubscription() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if ((_a = this.queueStatsSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe) {
                _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[App:QSD] Unsubscribe queue stats dataset");
                this.queueStatsSubscription.unsubscribe();
            }
        });
    }
    filterQueueData() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.queueId) {
                const queueData = this.queueDataMap.get(this.queueId);
                if (queueData) {
                    this.queueData = queueData;
                    this.getQueueInfo();
                }
            }
        });
    }
    getQueueInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const queueInfo = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.cms.fetchQueueDetailsById({
                    orgId: this.orgId,
                    queueId: this.queueId
                });
                this.queueInfo = queueInfo;
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("[App:QSD] Failed to fetch queue info", error);
            }
        });
    }
    getIconForChannelType() {
        var _a, _b;
        return ((_b = _components_Common_CellRenderers_constants_channel__WEBPACK_IMPORTED_MODULE_0__.CHANNEL_TYPE_TO_ICON_MAP[(_a = this.queueData) === null || _a === void 0 ? void 0 : _a.channelType]) !== null && _b !== void 0 ? _b : "channel-call");
    }
    updated(_changedProperties) {
        if (_changedProperties.has("queueId")) {
            this.filterQueueData();
        }
        if (_changedProperties.has("isRTDIntialized")) {
            this.onRTDInitializedUpdated();
        }
    }
    onRTDInitializedUpdated() {
        // handle subscribe on page refresh for the queue stats tab
        if (this.isRTDIntialized) {
            this.setupQueueStatsSubscription();
        }
    }
    onCloseDetailsViewClicked() {
        this.dispatchEvent(new CustomEvent("header-close-clicked", {
            bubbles: true,
            composed: true
        }));
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_5__.html) `
      <div>
        <div class="tab-header">
          <div>
            <span class="breadcrumb-segment">Queues</span>
            <md-icon iconSet="momentumDesign" name="arrow-right-bold" size="16"></md-icon>
            <span class="breadcrumb-segment-bold">${(_a = this.queueData) === null || _a === void 0 ? void 0 : _a.queueName}</span>
          </div>
          <md-button id="close-details" circle size="28" variant="ghost" @click=${this.onCloseDetailsViewClicked}>
            <md-icon iconSet="momentumDesign" name="cancel-bold" size="16"></md-icon>
          </md-button>
        </div>
        <agentx-wc-queue-stats-header
          avatarChannelType=${this.getIconForChannelType()}
          queueName=${(0,lit_html_directives_if_defined_js__WEBPACK_IMPORTED_MODULE_6__.ifDefined)((_b = this.queueData) === null || _b === void 0 ? void 0 : _b.queueName)}
          .avgWaitTime=${Number((_d = (_c = this.queueData) === null || _c === void 0 ? void 0 : _c.avgWaitTime) !== null && _d !== void 0 ? _d : 0)}
          .agentAssignedBy=${(_f = (_e = this.queueInfo) === null || _e === void 0 ? void 0 : _e.queueRoutingType) !== null && _f !== void 0 ? _f : ""}
          .agentSelection=${(_h = (_g = this.queueInfo) === null || _g === void 0 ? void 0 : _g.routingType) !== null && _h !== void 0 ? _h : ""}
          .queueSkills=${(_k = (_j = this.queueInfo) === null || _j === void 0 ? void 0 : _j.queueSkillRequirements) !== null && _k !== void 0 ? _k : []}
        ></agentx-wc-queue-stats-header>
      </div>
      <div class="overview-container">
        <div class="section-info">
          <span class="section-label">Queue performance overview</span>
          <md-tooltip placement="top" message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("Tooltip text goes here")}">
            <md-button circle size="20" variant="ghost">
              <md-icon slot="icon" iconSet="momentumDesign" name="info-badge-filled" size="16"></md-icon>
            </md-button>
          </md-tooltip>
          <div class="spacer"></div>
          <md-button circle variant="ghost" class="customize-button">
            <md-icon slot="icon" aria-hidden="true" name="settings-bold" iconSet="momentumDesign"></md-icon>
          </md-button>
        </div>
        <div class="content">
          <slot name="widget-first-row"></slot>
          <!-- Interactions grid goes here... -->
        </div>
      </div>
      <div class="performance-details-container">
        <agentx-wc-queue-performance-details-view></agentx-wc-queue-performance-details-view>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
], QueueStatsDetail.prototype, "queueId", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
], QueueStatsDetail.prototype, "orgId", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
], QueueStatsDetail.prototype, "isRTDIntialized", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], QueueStatsDetail.prototype, "queueStatsSubscription", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], QueueStatsDetail.prototype, "queueDataMap", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], QueueStatsDetail.prototype, "queueInfo", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
], QueueStatsDetail.prototype, "queueData", void 0);
QueueStatsDetail = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("agentx-wc-queue-stats-detail")
], QueueStatsDetail);



/***/ }),

/***/ "./src/components/QueueStatsTab/QueueStatsLanding/QueueStatsLanding.scss":
/*!*******************************************************************************!*\
  !*** ./src/components/QueueStatsTab/QueueStatsLanding/QueueStatsLanding.scss ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  box-sizing: border-box;
  flex: 1;
  height: 100%;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=QueueStatsLanding.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QueueStatsTab/QueueStatsLanding/QueueStatsLanding.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QueueStatsTab/QueueStatsLanding/QueueStatsLanding.ts":
/*!*****************************************************************************!*\
  !*** ./src/components/QueueStatsTab/QueueStatsLanding/QueueStatsLanding.ts ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueueStatsLanding: () => (/* binding */ QueueStatsLanding)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _QueueStatsLanding_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./QueueStatsLanding.scss */ "./src/components/QueueStatsTab/QueueStatsLanding/QueueStatsLanding.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




/**
 * @element agentx-wc-queue-stats-landing
 */
let QueueStatsLanding = class QueueStatsLanding extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.isDarkMode = false;
        this.isExpanded = false;
        this.isRTDIntialized = false;
        this.selectedQueueId = "";
    }
    static get styles() {
        return _QueueStatsLanding_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    render() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
      <agentx-wc-queues-monitoring-grid
        .isDarkMode=${this.isDarkMode}
        .isTableExpanded=${!this.isExpanded}
        .isRTDIntialized=${this.isRTDIntialized}
        selectedQueueId=${this.selectedQueueId}
      ></agentx-wc-queues-monitoring-grid>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], QueueStatsLanding.prototype, "isDarkMode", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], QueueStatsLanding.prototype, "isExpanded", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], QueueStatsLanding.prototype, "isRTDIntialized", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], QueueStatsLanding.prototype, "selectedQueueId", void 0);
QueueStatsLanding = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-queue-stats-landing")
], QueueStatsLanding);



/***/ }),

/***/ "./src/components/QueueStatsTab/QueueStatsUtils/QueueStatsUtils.ts":
/*!*************************************************************************!*\
  !*** ./src/components/QueueStatsTab/QueueStatsUtils/QueueStatsUtils.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getQueueStatsData: () => (/* binding */ getQueueStatsData)
/* harmony export */ });
/* harmony import */ var _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../components/QueuesMonitoringWidget/QueueModelData */ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueueModelData.ts");

const REALTIME_FEED = "RealtimeFeed";
const SUBSCRIPTION_RESPONSE = "SubscriptionResponse";
function getMappedDataFromQueueStatus(updatedQueueStatus, oldQueueData) {
    return Object.assign(Object.assign(Object.assign({}, _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_0__.QueueModel.EMPTY_DATA), oldQueueData), { queueId: updatedQueueStatus.queueId, queueName: updatedQueueStatus.queueName, abandoned: updatedQueueStatus.totalContactsAbandoned.toString(), available: _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_0__.QueueModel.EMPTY_DATA.available, avgHandleTime: _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_0__.QueueModel.EMPTY_DATA.avgHandleTime, avgWaitTime: updatedQueueStatus.totalContactsHandled > 0
            ? (updatedQueueStatus.totalQueueDuration / updatedQueueStatus.totalQueuedContacts).toFixed(2)
            : "0", channelType: updatedQueueStatus.channelType, engaged: _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_0__.QueueModel.EMPTY_DATA.engaged, handledInteractions: updatedQueueStatus.totalContactsHandled.toString(), idle: _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_0__.QueueModel.EMPTY_DATA.idle, inQueue: updatedQueueStatus.queuedContactsCount.toString(), longestWaitTime: updatedQueueStatus.maxQueueDuration.toString(), presentedInteractions: updatedQueueStatus.totalQueuedContacts.toString(), rona: _components_QueuesMonitoringWidget_QueueModelData__WEBPACK_IMPORTED_MODULE_0__.QueueModel.EMPTY_DATA.rona, transferred: updatedQueueStatus.totalContactsDequeued.toString(), actions: "Actions" });
}
function convertQueueStatusArrayToMap(agentGlobalStatusData) {
    const rowDataMap = new Map();
    agentGlobalStatusData === null || agentGlobalStatusData === void 0 ? void 0 : agentGlobalStatusData.forEach((queueStats) => {
        rowDataMap.set(queueStats.data.queueId, getMappedDataFromQueueStatus(queueStats.data, undefined));
    });
    return rowDataMap;
}
const updateExistingMapFromQueueStatus = ({ newQueueStats, currentDataMap, updated, added }) => {
    const rowDataMap = new Map(currentDataMap);
    newQueueStats === null || newQueueStats === void 0 ? void 0 : newQueueStats.forEach((queueData) => {
        const existingData = currentDataMap.get(queueData.data.queueId);
        const newData = getMappedDataFromQueueStatus(queueData.data, existingData);
        if (existingData) {
            updated.push(newData);
        }
        else {
            added.push(newData);
        }
        rowDataMap.set(queueData.data.queueId, newData);
    });
    return rowDataMap;
};
function getQueueStatsData(newQueueStats, currentDataMap, type, deltaData) {
    const updated = [];
    const added = [];
    let model;
    if (type === SUBSCRIPTION_RESPONSE) {
        model =
            currentDataMap.size === 0
                ? convertQueueStatusArrayToMap(newQueueStats)
                : new Map([...currentDataMap, ...convertQueueStatusArrayToMap(newQueueStats)]);
    }
    else if (deltaData && type === REALTIME_FEED) {
        model = updateExistingMapFromQueueStatus({
            newQueueStats: deltaData,
            currentDataMap,
            updated,
            added
        });
    }
    else {
        model = updateExistingMapFromQueueStatus({
            newQueueStats,
            currentDataMap,
            updated,
            added
        });
    }
    return { model, updated, added };
}


/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueueStatsHeader/QueueStatsHeader.scss":
/*!****************************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueueStatsHeader/QueueStatsHeader.scss ***!
  \****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.header-container {
  display: flex;
  align-items: right;
  box-sizing: border-box;
  padding: 16px 12px;
  height: 124px;
  flex-grow: 1;
  background-color: var(--md-glass-overlay-bg-color);
  border-radius: 8px;
  gap: 8px;
}
.header-container .icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  background-color: lightgray;
  border-radius: 16px;
}
.header-container .text-body {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  min-width: 0px;
}
.header-container .text-body .primary-label {
  font-size: var(--font-size-large);
  font-family: var(--font-family-bold);
  color: var(--md-primary-text-color);
  line-height: 24px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 90%;
  min-height: fit-content;
}
.header-container .text-body .timer {
  font-size: var(--font-size-medium);
  color: var(--md-secondary-text-color);
  line-height: 20px;
  font-family: var(--font-family);
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 90%;
}
.header-container .details-container {
  display: flex;
  margin-top: 16px;
  flex-direction: row;
  gap: 8px;
  align-items: center;
}
.header-container .details-container .separator {
  width: 4px;
  height: 4px;
  background: var(--md-separator-primary);
  display: inline-block;
  margin: 0;
  padding: 0;
  border-radius: 50%;
}
.header-container .detail {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  line-height: 15px;
  color: var(--md-primary-text-color);
  font-family: var(--font-family);
}
.header-container .detail .detail-key {
  font-family: var(--font-family-bold);
  font-weight: bold;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=QueueStatsHeader.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QueueStatsTab/components/QueueStatsHeader/QueueStatsHeader.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueueStatsHeader/QueueStatsHeader.ts":
/*!**************************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueueStatsHeader/QueueStatsHeader.ts ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueueStatsHeader: () => (/* binding */ QueueStatsHeader)
/* harmony export */ });
/* harmony import */ var _components_Common_CellRenderers_components_TableDurationElement__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/CellRenderers/components/TableDurationElement */ "./src/components/Common/CellRenderers/components/TableDurationElement.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _QueueStatsHeader_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./QueueStatsHeader.scss */ "./src/components/QueueStatsTab/components/QueueStatsHeader/QueueStatsHeader.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





/**
 * @element agentx-wc-queue-stats-header
 */
let QueueStatsHeader = class QueueStatsHeader extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
    constructor() {
        super(...arguments);
        this.avatarChannelType = "";
        this.avgWaitTime = 0;
        this.agentAssignedBy = "";
        this.agentSelection = "";
        this.queueSkills = [];
        this.queueName = "";
    }
    get agentAssignedByLabel() {
        switch (this.agentAssignedBy) {
            case "TEAM_BASED":
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:agentAssignedByTeam");
            case "SKILLS_BASED":
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:agentAssignedBySkills");
            default:
                return "";
        }
    }
    get agentAssignedByTooltip() {
        switch (this.agentAssignedBy) {
            case "TEAM_BASED":
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:agentAssignedByTeamTooltip");
            case "SKILLS_BASED":
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:agentAssignedBySkillsTooltip");
            default:
                return "";
        }
    }
    get agentSelectedByLabel() {
        switch (this.agentSelection) {
            case "LONGEST_AVAILABLE_AGENT":
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:agentSelectionLongestAvailable");
            case "BEST_AVAILABLE_AGENT":
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:agentSelectionBestAvailable");
            default:
                return "";
        }
    }
    get agentSelectedByTooltip() {
        switch (this.agentSelection) {
            case "LONGEST_AVAILABLE_AGENT":
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:agentSelectionLongestAvailableTooltip");
            case "BEST_AVAILABLE_AGENT":
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:agentSelectionBestAvailableTooltip");
            default:
                return "";
        }
    }
    static get styles() {
        return _QueueStatsHeader_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    renderIcon() {
        return this.avatarChannelType !== ""
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<md-avatar type="${this.avatarChannelType}" size="32"></md-avatar>`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`;
    }
    renderAssignedBy(value) {
        return value !== ""
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <div class="detail">
          <span class="detail-key">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:agentAssignedBy")}</span>${this.agentAssignedByLabel}
          <md-tooltip placement="top" message="${this.agentAssignedByTooltip}">
            <md-button circle size="20" variant="ghost">
              <md-icon slot="icon" iconSet="momentumDesign" name="info-badge-filled" size="16"></md-icon>
            </md-button>
          </md-tooltip>
        </div>`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`;
    }
    renderAgentSelection(value) {
        return value !== ""
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <div class="detail">
          <span class="detail-key">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:agentSelection")}</span>${this.agentSelectedByLabel}
          <md-tooltip placement="top" message="${this.agentSelectedByTooltip}">
            <md-button circle size="20" variant="ghost">
              <md-icon slot="icon" iconSet="momentumDesign" name="info-badge-filled" size="16"></md-icon>
            </md-button>
          </md-tooltip>
        </div>`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`;
    }
    renderQueueSkills(skills) {
        if ((skills === null || skills === void 0 ? void 0 : skills.length) > 0) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <div class="detail">
        <span class="detail-key">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:queueStats:queueSkills")}</span>${skills[0]}${skills.length > 1 ? "," : ""}
        ${this.renderMoreSkills(skills)}
      </div>`;
        }
        else {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`;
        }
    }
    renderMoreSkills(skills) {
        return skills.length > 1
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <md-tooltip placement="top">
          <div slot="tooltip-content">${skills.slice(1).map((item) => (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<div>${item}</div>`)}</div>
          <md-link tag="span">+${skills.length - 1} more</md-link>
        </md-tooltip>`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`;
    }
    renderSeparator(show) {
        if (show) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<div class="separator"></div>`;
        }
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `${lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}`;
    }
    render() {
        var _a;
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
      <div class="header-container">
        <div class="icon-container">${this.renderIcon()}</div>
        <div class="text-body">
          <div class="primary-label">${this.queueName}</div>
          <span class="timer">
            <agentx-wc-table-duration
              no-padding
              duration=${this.avgWaitTime}
              .isActive=${false}
              ?hideTimerIcon=${true}
            ></agentx-wc-table-duration>
          </span>
          <div class="details-container">
            ${this.renderAssignedBy(this.agentAssignedBy)}
            ${this.renderSeparator(this.agentAssignedBy !== "" && this.agentSelection !== "")}
            ${this.renderAgentSelection(this.agentSelection)}
            ${this.renderSeparator(this.agentSelection !== "" && ((_a = this.queueSkills) === null || _a === void 0 ? void 0 : _a.length) > 0)}
            ${this.renderQueueSkills(this.queueSkills)}
          </div>
        </div>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String, reflect: true })
], QueueStatsHeader.prototype, "avatarChannelType", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Number })
], QueueStatsHeader.prototype, "avgWaitTime", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
], QueueStatsHeader.prototype, "agentAssignedBy", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
], QueueStatsHeader.prototype, "agentSelection", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
], QueueStatsHeader.prototype, "queueSkills", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
], QueueStatsHeader.prototype, "queueName", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], QueueStatsHeader.prototype, "agentAssignedByLabel", null);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], QueueStatsHeader.prototype, "agentAssignedByTooltip", null);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], QueueStatsHeader.prototype, "agentSelectedByLabel", null);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
], QueueStatsHeader.prototype, "agentSelectedByTooltip", null);
QueueStatsHeader = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-queue-stats-header")
], QueueStatsHeader);



/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueueStatsPerformanceDetailsView/QueueStatsPerformanceDetailsView.scss":
/*!************************************************************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueueStatsPerformanceDetailsView/QueueStatsPerformanceDetailsView.scss ***!
  \************************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  display: flex;
  height: 100%;
  margin: 10px;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=QueueStatsPerformanceDetailsView.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QueueStatsTab/components/QueueStatsPerformanceDetailsView/QueueStatsPerformanceDetailsView.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueueStatsPerformanceDetailsView/QueueStatsPerformanceDetailsView.ts":
/*!**********************************************************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueueStatsPerformanceDetailsView/QueueStatsPerformanceDetailsView.ts ***!
  \**********************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueueStatsPerformanceDetailsView: () => (/* binding */ QueueStatsPerformanceDetailsView)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _QueueStatsPerformanceDetailsView_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./QueueStatsPerformanceDetailsView.scss */ "./src/components/QueueStatsTab/components/QueueStatsPerformanceDetailsView/QueueStatsPerformanceDetailsView.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




/**
 * @element agentx-wc-queue-performance-details-view
 */
let QueueStatsPerformanceDetailsView = class QueueStatsPerformanceDetailsView extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
    constructor() {
        super(...arguments);
        this.queueId = "";
    }
    static get styles() {
        return _QueueStatsPerformanceDetailsView_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    render() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) ` <md-label></md-label> `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
], QueueStatsPerformanceDetailsView.prototype, "queueId", void 0);
QueueStatsPerformanceDetailsView = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-queue-performance-details-view")
], QueueStatsPerformanceDetailsView);



/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueueModelData.ts":
/*!******************************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueueModelData.ts ***!
  \******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueueModel: () => (/* binding */ QueueModel)
/* harmony export */ });
var QueueModel;
(function (QueueModel) {
    QueueModel.EMPTY_DATA = {
        queueId: "",
        queueName: "",
        abandoned: "0",
        available: "0",
        avgHandleTime: "0",
        avgWaitTime: "0",
        channelType: "",
        engaged: "0",
        handledInteractions: "0",
        idle: "0",
        inQueue: "0",
        longestWaitTime: "0",
        presentedInteractions: "0",
        rona: "",
        transferred: "",
        actions: ""
    };
})(QueueModel || (QueueModel = {}));


/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueuesMonitoring.scss":
/*!**********************************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueuesMonitoring.scss ***!
  \**********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: block;
  height: 100%;
}

.queues-monitoring-header {
  display: block;
  box-sizing: border-box;
  margin: 0px 0px 12px 0px;
}

.tab-header {
  display: flex;
  font-size: 20px;
  height: 52px;
  box-sizing: border-box;
  align-items: center;
  padding: 0 12px;
  font-weight: 700;
  font-family: var(--brand-font-regular, "CiscoSansTT Regular");
  color: var(--md-primary-text-color);
}

.separator {
  margin-right: 5px;
}

[slot=left-group] {
  display: inline-block;
  color: var(--md-secondary-text-color);
  font-size: var(--font-size-body-midsize);
}

wc-ag-grid.listView {
  --grid-container-h-padding: 0px;
  --md-table-cell-border-bottom: none;
  --grid-container-top-padding: 0px;
  --grid-header-display: none;
  --md-glass-overlay-bg-color: transparent;
  --grid-cell-border-radius: 8px;
  --grid-focus-border-radius: 8px;
}

.customize-menu-overlay {
  display: inline-block;
}

.customize-menu-overlay::part(overlay) {
  width: 600px;
  height: 725px;
}

md-menu-overlay::part(overlay-content) {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

agentx-wc-table-customization-menu {
  width: 100%;
  height: 100%;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueuesMonitoring.scss */
/*# sourceURL=QueuesMonitoring.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueuesMonitoringWidget.ts":
/*!**************************************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueuesMonitoringWidget.ts ***!
  \**************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GridState: () => (/* binding */ GridState),
/* harmony export */   QueuesMonitoringWidget: () => (/* binding */ QueuesMonitoringWidget)
/* harmony export */ });
/* harmony import */ var _components_Common_Table_TableManager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/Table/TableManager */ "./src/components/Common/Table/TableManager.ts");
/* harmony import */ var _components_Common_WcGrid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/components/Common/WcGrid */ "./src/components/Common/WcGrid/index.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Common_EmptyDisplayWrapper_EmptyDisplayWrapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../Common/EmptyDisplayWrapper/EmptyDisplayWrapper */ "./src/components/Common/EmptyDisplayWrapper/EmptyDisplayWrapper.ts");
/* harmony import */ var _Common_TableHeader_TableHeaderWidget_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../Common/TableHeader/TableHeaderWidget.scss */ "./src/components/Common/TableHeader/TableHeaderWidget.scss");
/* harmony import */ var _QueueStatsUtils_QueueStatsUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../QueueStatsUtils/QueueStatsUtils */ "./src/components/QueueStatsTab/QueueStatsUtils/QueueStatsUtils.ts");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./config */ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/config.ts");
/* harmony import */ var _QueuesMonitoring_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./QueuesMonitoring.scss */ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueuesMonitoring.scss");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./types */ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/types.ts");
/* harmony import */ var _components_Common_CellRenderers__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @/components/Common/CellRenderers */ "./src/components/Common/CellRenderers/index.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};














const queueStatsDataSet = "wxcc.rtd.queuestats";
var GridState;
(function (GridState) {
    GridState["Expanded"] = "expanded";
    GridState["Collapsed"] = "collapsed";
})(GridState || (GridState = {}));
const hasConnectionStatusChanged = (value, oldValue) => {
    return (value === null || value === void 0 ? void 0 : value.empty) !== (oldValue === null || oldValue === void 0 ? void 0 : oldValue.empty) || (value === null || value === void 0 ? void 0 : value.error) !== (oldValue === null || oldValue === void 0 ? void 0 : oldValue.error) || (value === null || value === void 0 ? void 0 : value.loading) !== (oldValue === null || oldValue === void 0 ? void 0 : oldValue.loading);
};
let QueuesMonitoringWidget = class QueuesMonitoringWidget extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_5__.LitElement) {
    constructor() {
        super(...arguments);
        this.tableManagers = {
            [GridState.Expanded]: new _components_Common_Table_TableManager__WEBPACK_IMPORTED_MODULE_0__.TableManager({
                cacheName: "wxcc_queues_monitoring_table",
                columnDefinitions: (0,_config__WEBPACK_IMPORTED_MODULE_10__.getGridConfigs)()
            }),
            [GridState.Collapsed]: new _components_Common_Table_TableManager__WEBPACK_IMPORTED_MODULE_0__.TableManager({
                columnDefinitions: (0,_config__WEBPACK_IMPORTED_MODULE_10__.getCollapsedGridConfigs)()
            })
        };
        this.isDarkMode = false;
        this.isTableExpanded = true;
        this.isRTDIntialized = false;
        this.selectedQueueId = "";
        this.state = {
            loading: true,
            empty: true,
            error: false
        };
        this.queueStatusData = [];
        this.queueDataMap = new Map();
        this.queueStatsSubscription = {};
        this.defaultRowHeight = 40;
        this.listViewRowHeight = 80;
        this.rowCount = 0;
        this.wcGridConfig = new _components_Common_WcGrid__WEBPACK_IMPORTED_MODULE_1__.WcGridConfig({
            tableName: "QueuesMonitoringWidget",
            enableCharts: false,
            headerConfig: {
                resetGridStateButton: false,
                filterButton: false,
                columnSelectButton: false,
                refreshButton: false,
                datePicker: false
            }
        });
        this.subscribeQueueStatsDataSet = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] Subscribing to queue stats dataset");
            this.state = Object.assign(Object.assign({}, this.state), { loading: true });
            const response = yield ((_a = window.wxcc) === null || _a === void 0 ? void 0 : _a.rtdwc.subscribe({
                datasetName: queueStatsDataSet,
                update: (data, deltaData) => {
                    this.setQueueStatsData(data.datasetValues, data.type, deltaData === null || deltaData === void 0 ? void 0 : deltaData.datasetValues);
                }
            }));
            _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] subscribed QueueStats successfully");
            return response;
        });
        this.updateRowCount = () => {
            var _a, _b, _c, _d;
            this.rowCount = (_b = (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.getDisplayedRowCount()) !== null && _b !== void 0 ? _b : 0;
            if (this.rowCount === 0) {
                (_c = this.gridApi) === null || _c === void 0 ? void 0 : _c.showNoRowsOverlay();
            }
            else {
                (_d = this.gridApi) === null || _d === void 0 ? void 0 : _d.hideOverlay();
            }
            _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info(`[App:QMW] displayedRowCount updated to ${this.rowCount}`);
        };
    }
    static get styles() {
        return [_Common_TableHeader_TableHeaderWidget_scss__WEBPACK_IMPORTED_MODULE_8__["default"], _QueuesMonitoring_scss__WEBPACK_IMPORTED_MODULE_11__["default"]];
    }
    connectedCallback() {
        _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] Connected callback");
        super.connectedCallback();
    }
    toggleTableView() {
        _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] Toggle expanded view");
        if (this.gridApi) {
            this.getTableManager().onGridReady(this.gridApi);
            this.gridApi.setGridOption("rowHeight", this.isTableExpanded ? this.defaultRowHeight : this.listViewRowHeight);
            this.gridApi.resetRowHeights();
            this.gridApi.closeToolPanel();
        }
    }
    onRTDInitializedUpdated() {
        // handle subscribe on page refresh for the queue stats tab
        if (this.isRTDIntialized) {
            this.setupQueueStatsSubscription();
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] Disconnected callback");
        this.unsubscribeQueueStatsSubscription();
    }
    getTableManager() {
        return this.tableManagers[this.isTableExpanded ? GridState.Expanded : GridState.Collapsed];
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has("isTableExpanded")) {
            this.toggleTableView();
        }
        if (changedProperties.has("isRTDIntialized")) {
            this.onRTDInitializedUpdated();
        }
    }
    setupQueueStatsSubscription() {
        return __awaiter(this, void 0, void 0, function* () {
            _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] Setting up queue stats subscription");
            if (!this.isRTDIntialized) {
                _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] QueueStats subscription skipped as RTD is not initialized");
                return;
            }
            try {
                this.queueStatsSubscription = yield this.subscribeQueueStatsDataSet();
            }
            catch (error) {
                _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[App:QMW] QueueStats subscription failed", error);
                this.state = Object.assign(Object.assign({}, this.state), { error: true });
            }
        });
    }
    unsubscribeQueueStatsSubscription() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if ((_a = this.queueStatsSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe) {
                _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] Unsubscribe queue stats dataset");
                this.queueStatsSubscription.unsubscribe();
            }
        });
    }
    setQueueStatsData(queueStatusData, type, deltaData) {
        var _a, _b;
        const updatedInfo = (0,_QueueStatsUtils_QueueStatsUtils__WEBPACK_IMPORTED_MODULE_9__.getQueueStatsData)(queueStatusData, this.queueDataMap, type, deltaData);
        this.queueDataMap = updatedInfo.model;
        this.state = Object.assign(Object.assign({}, this.state), { loading: false, empty: updatedInfo.model.size === 0 });
        if (updatedInfo.added.length > 0 || updatedInfo.updated.length > 0) {
            (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.applyTransactionAsync({ add: updatedInfo.added, update: updatedInfo.updated }, () => { var _a; return (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.refreshClientSideRowModel("group"); });
        }
        else {
            this.queueStatusData = Array.from(this.queueDataMap, (item) => item[1]);
            (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.setGridOption("rowData", this.queueStatusData);
        }
        this.setQueueSelected();
    }
    initializeGridOptions() {
        var _a;
        _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] Initializing");
        const gridOptions = Object.assign(Object.assign({}, (0,_config__WEBPACK_IMPORTED_MODULE_10__.getBaseGridConfigs)()), { rowHeight: this.isTableExpanded ? this.defaultRowHeight : this.listViewRowHeight, onColumnResized: (e) => this.getTableManager().onTableColumnResized(e), onSortChanged: (e) => this.getTableManager().onTableSortChanged(e), onColumnMoved: (e) => this.onColumnMoved(e), onModelUpdated: this.updateRowCount, getRowId: (params) => params.data.queueId, isFullWidthRow: () => !this.isTableExpanded, fullWidthCellRenderer: _components_Common_CellRenderers__WEBPACK_IMPORTED_MODULE_13__.QueueStatsListItemCellRenderer, onCellClicked: (params) => {
                if (params.column.getColId() === _types__WEBPACK_IMPORTED_MODULE_12__.QueueStatsTableColumnId.ListView) {
                    this.dispatchEvent(new CustomEvent("queue-selected", {
                        composed: true,
                        bubbles: true,
                        detail: { queueId: params.data.queueId }
                    }));
                }
            }, onToolPanelVisibleChanged: (e) => {
                this.dispatchEvent(new CustomEvent("grid-sidebar-toggled", {
                    composed: true,
                    bubbles: true,
                    detail: {
                        visible: e.visible
                    }
                }));
            } });
        (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.updateGridOptions(gridOptions);
    }
    onGridReady(gridApi) {
        var _a;
        _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:QMW] Grid ready");
        this.gridApi = gridApi;
        this.initializeGridOptions();
        this.getTableManager().onGridReady(gridApi);
        (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setGridOption("rowData", this.queueStatusData);
    }
    onColumnMoved(e) {
        if (!e.finished) {
            return;
        }
        const manager = this.getTableManager();
        manager.onTableColumnMoved(e);
    }
    onResetCustomization(e) {
        e.stopPropagation();
        const manager = this.getTableManager();
        manager.onReset();
    }
    setQueueSelected() {
        var _a, _b;
        if (!this.isTableExpanded && this.selectedQueueId.length > 0) {
            const allQueues = Array.from(this.queueDataMap, (item) => item[0]);
            const selectedQueueIndex = allQueues.indexOf(this.selectedQueueId);
            if (selectedQueueIndex !== -1) {
                (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.ensureIndexVisible(selectedQueueIndex, null);
                (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.setFocusedCell(selectedQueueIndex, _types__WEBPACK_IMPORTED_MODULE_12__.QueueStatsTableColumnId.ListView);
            }
        }
    }
    get renderToolbar() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_6__.html) `<table-header-widget class="queues-monitoring-header">
      <span slot="left-group">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:x_queues", undefined, { count: this.rowCount })}</span>
      <div slot="right-group">
        <md-button
          id="reset-customization-button"
          circle
          size="28"
          variant="ghost"
          @click=${this.onResetCustomization}
          ?hidden="${!this.isTableExpanded}"
          ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:reset")}
        >
          <md-icon slot="icon" name="reset-bold" iconSet="momentumDesign" size="16"></md-icon>
        </md-button>

        <md-button
          circle
          size="28"
          variant="ghost"
          ?hidden="${!this.isTableExpanded}"
          ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:customizeBtn")}
          @click=${() => this.onCustomizeButtonClicked()}
        >
          <md-icon slot="icon" iconSet="momentumDesign" name="settings-bold" size="16"></md-icon>
        </md-button>

        <div class="separator"></div>
        <md-button
          ?circle="${!this.isTableExpanded}"
          variant="${this.isTableExpanded ? "secondary" : "ghost"}"
          size="28"
          ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:filter")}
          @click=${() => this.onFilterButtonClicked()}
        >
          <md-icon slot="icon" iconSet="momentumDesign" name="filter-bold" size="16" ariaHidden="true"></md-icon>
          <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:filter")}</span>
        </md-button>
      </div>
    </table-header-widget>`;
    }
    get renderGrid() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_6__.html) `
      <wc-ag-grid
        class=${this.isTableExpanded ? "" : "listView"}
        .wcGridConfig=${this.wcGridConfig}
        .isDarkMode=${this.isDarkMode}
        .gridApiCallback=${
        //DO NOT USE, DO NOT COPY, This is temporary and will be removed (https://jira-eng-sjc12.cisco.com/jira/browse/CX-18449)
        (gridApi) => {
            this.onGridReady(gridApi);
        }}
      ></wc-ag-grid>
    `;
    }
    get renderEmptyGrid() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_6__.html) `
      <agentx-wc-empty-display-wrapper
        illustration-type="empty-state"
        title=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:emptyTitle")}
        info-message=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:emptyMessage")}
        .isDarkMode=${this.isDarkMode}
        .loading=${this.state.loading}
      >
      </agentx-wc-empty-display-wrapper>
    `;
    }
    get renderConnectionError() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_6__.html) `
      <agentx-wc-empty-display-wrapper
        illustration-type="error-cloud"
        title=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:errorTitle")}
        info-message=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:queueStats:errorMessage")}
      >
      </agentx-wc-empty-display-wrapper>
    `;
    }
    get renderContent() {
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_6__.html) `${this.renderToolbar}${this.renderGrid}`;
    }
    render() {
        if (this.state.error) {
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_6__.html) `${this.renderConnectionError}`;
        }
        if (this.state.empty) {
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_6__.html) `${this.renderEmptyGrid}`;
        }
        return (0,lit_html__WEBPACK_IMPORTED_MODULE_6__.html) `${this.renderContent}`;
    }
    onFilterButtonClicked() {
        const gridApi = this.gridApi;
        if (gridApi) {
            const openToolPanel = gridApi.getOpenedToolPanel();
            if (openToolPanel === "filters") {
                gridApi.closeToolPanel();
            }
            else {
                gridApi.openToolPanel("filters");
            }
        }
    }
    onCustomizeButtonClicked() {
        const gridApi = this.gridApi;
        if (gridApi) {
            const openToolPanel = gridApi.getOpenedToolPanel();
            if (openToolPanel === "columns") {
                gridApi.closeToolPanel();
            }
            else {
                gridApi.openToolPanel("columns");
            }
        }
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], QueuesMonitoringWidget.prototype, "tableManagers", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
], QueuesMonitoringWidget.prototype, "isDarkMode", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
], QueuesMonitoringWidget.prototype, "isTableExpanded", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
], QueuesMonitoringWidget.prototype, "isRTDIntialized", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
], QueuesMonitoringWidget.prototype, "selectedQueueId", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)({ hasChanged: hasConnectionStatusChanged })
], QueuesMonitoringWidget.prototype, "state", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], QueuesMonitoringWidget.prototype, "queueStatusData", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], QueuesMonitoringWidget.prototype, "queueDataMap", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], QueuesMonitoringWidget.prototype, "queueStatsSubscription", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], QueuesMonitoringWidget.prototype, "defaultRowHeight", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], QueuesMonitoringWidget.prototype, "listViewRowHeight", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], QueuesMonitoringWidget.prototype, "rowCount", void 0);
QueuesMonitoringWidget = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-queues-monitoring-grid")
], QueuesMonitoringWidget);



/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/config.ts":
/*!**********************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueuesMonitoringWidget/config.ts ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   actionsValueGetter: () => (/* binding */ actionsValueGetter),
/* harmony export */   channelValueGetter: () => (/* binding */ channelValueGetter),
/* harmony export */   compactViewValueGetter: () => (/* binding */ compactViewValueGetter),
/* harmony export */   getBaseGridConfigs: () => (/* binding */ getBaseGridConfigs),
/* harmony export */   getCollapsedGridConfigs: () => (/* binding */ getCollapsedGridConfigs),
/* harmony export */   getGridConfigs: () => (/* binding */ getGridConfigs),
/* harmony export */   timeValueGetter: () => (/* binding */ timeValueGetter)
/* harmony export */ });
/* harmony import */ var _components_Common_CellRenderers_constants_channel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/CellRenderers/constants/channel */ "./src/components/Common/CellRenderers/constants/channel.ts");
/* harmony import */ var _components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/components/Common/CellRenderers/constants/types */ "./src/components/Common/CellRenderers/constants/types.ts");
/* harmony import */ var _components_Common_CellRenderers_filters_TimestampFilter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/components/Common/CellRenderers/filters/TimestampFilter */ "./src/components/Common/CellRenderers/filters/TimestampFilter.ts");
/* harmony import */ var _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/components/Common/CellRenderers/Utils */ "./src/components/Common/CellRenderers/Utils.ts");
/* harmony import */ var _components_GridWidget_KeySuppressor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @/components/GridWidget/KeySuppressor */ "./src/components/GridWidget/KeySuppressor.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ag-grid-enterprise */ "ag-grid-enterprise");
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./types */ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/types.ts");









const keySuppressor = new _components_GridWidget_KeySuppressor__WEBPACK_IMPORTED_MODULE_4__.KeySuppressor(["actions"], "agentx-wc-table-action-buttons");
const theme = ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_7__.themeAlpine.withParams({
    sideBarBackgroundColor: "transparent",
    chromeBackgroundColor: "transparent",
    sidePanelBorder: false
});
function getGridConfigs() {
    const selectedColumns = [
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Id,
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.QueueName,
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Abandoned,
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.AvgWaitTime,
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.ChannelType,
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.HandledInteractions,
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.InQueue,
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.ListView,
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.LongestWaitTime,
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.PresentedInteractions,
        _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Transferred
    ];
    if (_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.SERVICE.featureflag.isQueueStatsDetailViewEnabled()) {
        selectedColumns.push(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Actions);
    }
    const baseColumns = [
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.QueueName,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.QueueName,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.name")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.QueueName),
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator,
            filter: "agSetColumnFilter",
            filterParams: {
                defaultToNothingSelected: true
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.ChannelType,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.ChannelType,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.channels")}`,
            valueGetter: channelValueGetter,
            cellRenderer: "channelRenderer",
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.ChannelType),
            comparator: (valueA, valueB) => (0,_components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator)(valueA.text, valueB.text),
            filter: "agSetColumnFilter",
            filterParams: {
                defaultToNothingSelected: true,
                suppressSelectAll: true
            },
            filterValueGetter: channelFilterValueGetter,
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.InQueue,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.InQueue,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.waiting")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.InQueue),
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator,
            filter: "agNumberColumnFilter",
            filterValueGetter: (params) => {
                return parseInt(params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.InQueue], 10) || 0;
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.AvgWaitTime,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.AvgWaitTime,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.avgWaitTime")}`,
            filter: _components_Common_CellRenderers_filters_TimestampFilter__WEBPACK_IMPORTED_MODULE_2__.TimestampFilter,
            valueGetter: timeValueGetter,
            cellRenderer: "durationRenderer",
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.AvgWaitTime),
            comparator: (valueA, valueB) => (0,_components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator)(valueA.duration, valueB.duration),
            filterParams: {
                defaultToNothingSelected: true,
                suppressSelectAll: true
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.LongestWaitTime,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.LongestWaitTime,
            valueGetter: timeValueGetter,
            cellRenderer: "durationRenderer",
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.longestWaitTime")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.LongestWaitTime),
            comparator: (valueA, valueB) => (0,_components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator)(valueA.duration, valueB.duration),
            filter: _components_Common_CellRenderers_filters_TimestampFilter__WEBPACK_IMPORTED_MODULE_2__.TimestampFilter,
            filterParams: {
                defaultToNothingSelected: true,
                suppressSelectAll: true
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Abandoned,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Abandoned,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.abandoned")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Abandoned),
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator,
            filter: "agNumberColumnFilter",
            filterValueGetter: (params) => {
                return parseInt(params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Abandoned], 10) || 0;
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.HandledInteractions,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.HandledInteractions,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.handled")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.HandledInteractions),
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator,
            filter: "agNumberColumnFilter",
            filterValueGetter: (params) => {
                return parseInt(params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.HandledInteractions], 10) || 0;
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.PresentedInteractions,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.PresentedInteractions,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.presented")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.PresentedInteractions),
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator,
            filter: "agNumberColumnFilter",
            filterValueGetter: (params) => {
                return parseInt(params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.PresentedInteractions], 10) || 0;
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        },
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Transferred,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Transferred,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.transferred")}`,
            flex: 1,
            hide: !selectedColumns.includes(_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Transferred),
            comparator: _components_Common_CellRenderers_Utils__WEBPACK_IMPORTED_MODULE_3__.naturalStringComparator,
            filter: "agNumberColumnFilter",
            filterValueGetter: (params) => {
                return parseInt(params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Transferred], 10) || 0;
            },
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        }
    ];
    const actionColumn = [
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Actions,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.Actions,
            headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats.actions")}`,
            sortable: false,
            pinned: "right",
            lockPosition: "right",
            lockPinned: true,
            cellRenderer: "actionButtonsRenderer",
            valueGetter: actionsValueGetter,
            cellClass: "actions-cell",
            width: 98,
            hide: !_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.SERVICE.featureflag.isQueueStatsDetailViewEnabled(),
            filter: false,
            suppressMovable: true,
            lockVisible: true,
            suppressHeaderMenuButton: true,
            suppressHeaderFilterButton: true
        }
    ];
    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_6__.SERVICE.featureflag.isQueueStatsDetailViewEnabled() ? [...baseColumns, ...actionColumn] : baseColumns;
}
function actionsValueGetter(params) {
    return {
        buttons: [{ type: _components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__.ActionButtons.view }, { type: _components_Common_CellRenderers_constants_types__WEBPACK_IMPORTED_MODULE_1__.ActionButtons.more }],
        context: { eventId: params.data["queueId"] }
    };
}
function timeValueGetter(params) {
    return {
        duration: params.data[params.colDef.field] || 0,
        createdTime: 0,
        isActive: false
    };
}
function channelValueGetter(params) {
    const channelType = params.data[params.colDef.field] || "";
    const type = channelType;
    const value = _components_Common_CellRenderers_constants_channel__WEBPACK_IMPORTED_MODULE_0__.CHANNEL_TYPE_TO_ICON_MAP[type];
    return {
        channelType: value
    };
}
function channelFilterValueGetter(params) {
    return params.data[params.colDef.field] || "";
}
function compactViewValueGetter(params) {
    const channelType = params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.ChannelType] || "";
    const type = channelType;
    const queueNameLabel = params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.QueueName];
    const waitInQueue = params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.InQueue];
    const averageWaitTime = params.data[_types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.AvgWaitTime];
    return {
        channelType: type,
        queueName: queueNameLabel,
        waitingInQueue: waitInQueue,
        avgWaitTime: averageWaitTime
    };
}
const getBaseGridConfigs = () => {
    const columnDefs = getGridConfigs();
    return {
        theme,
        columnDefs,
        defaultColDef: {
            resizable: true,
            suppressHeaderMenuButton: true,
            sortable: true,
            suppressKeyboardEvent: keySuppressor.suppressKeyboardEvent
        },
        suppressContextMenu: true,
        overlayNoRowsTemplate: `<agentx-wc-empty-display-wrapper
        illustration-type="empty-state"
        title="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats:emptyTitle")}"
        info-message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_5__.t)("app:queueStats:emptyMessage")}"
      >
      </agentx-wc-empty-display-wrapper>`,
        rowBuffer: 20,
        debug: location.hostname === "localhost",
        sideBar: {
            toolPanels: [
                {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel",
                    toolPanelParams: {
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivots: true,
                        suppressPivotMode: true,
                        suppressColumnFilter: true,
                        suppressColumnSelectAll: true,
                        suppressColumnExpandAll: true
                    },
                    minWidth: 200,
                    width: 200,
                    maxWidth: 200
                },
                {
                    id: "filters",
                    labelDefault: "Filters",
                    labelKey: "filters",
                    iconKey: "filter",
                    toolPanel: "agFiltersToolPanel",
                    toolPanelParams: {
                        suppressExpandAll: true,
                        suppressFilterSearch: true
                    },
                    minWidth: 200,
                    width: 200,
                    maxWidth: 200
                }
            ]
        }
    };
};
function getCollapsedGridConfigs() {
    return [
        ...getGridConfigs().map((colDef) => {
            return Object.assign(Object.assign({}, colDef), { hide: true });
        }),
        {
            colId: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.ListView,
            field: _types__WEBPACK_IMPORTED_MODULE_8__.QueueStatsTableColumnId.ListView,
            headerName: "List View",
            valueGetter: compactViewValueGetter,
            cellRenderer: "queueStatsListItemRenderer",
            flex: 1,
            autoHeight: true
        }
    ];
}


/***/ }),

/***/ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/types.ts":
/*!*********************************************************************************!*\
  !*** ./src/components/QueueStatsTab/components/QueuesMonitoringWidget/types.ts ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueueStatsTableColumnId: () => (/* binding */ QueueStatsTableColumnId)
/* harmony export */ });
var QueueStatsTableColumnId;
(function (QueueStatsTableColumnId) {
    QueueStatsTableColumnId["Id"] = "id";
    QueueStatsTableColumnId["QueueName"] = "queueName";
    QueueStatsTableColumnId["Abandoned"] = "abandoned";
    QueueStatsTableColumnId["Available"] = "available";
    QueueStatsTableColumnId["AvgHandleTime"] = "avgHandleTime";
    QueueStatsTableColumnId["AvgWaitTime"] = "avgWaitTime";
    QueueStatsTableColumnId["ChannelType"] = "channelType";
    QueueStatsTableColumnId["Engaged"] = "engaged";
    QueueStatsTableColumnId["HandledInteractions"] = "handledInteractions";
    QueueStatsTableColumnId["Idle"] = "idle";
    QueueStatsTableColumnId["InQueue"] = "inQueue";
    QueueStatsTableColumnId["ListView"] = "listView";
    QueueStatsTableColumnId["LongestWaitTime"] = "longestWaitTime";
    QueueStatsTableColumnId["PresentedInteractions"] = "presentedInteractions";
    QueueStatsTableColumnId["Rona"] = "rona";
    QueueStatsTableColumnId["Transferred"] = "transferred";
    QueueStatsTableColumnId["Actions"] = "actions";
})(QueueStatsTableColumnId || (QueueStatsTableColumnId = {}));


/***/ }),

/***/ "./src/components/QueueStatsTab/index.ts":
/*!***********************************************!*\
  !*** ./src/components/QueueStatsTab/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueueStatsDetail: () => (/* reexport safe */ _QueueStatsDetail_QueueStatsDetail__WEBPACK_IMPORTED_MODULE_4__.QueueStatsDetail),
/* harmony export */   QueueStatsHeader: () => (/* reexport safe */ _components_QueueStatsHeader_QueueStatsHeader__WEBPACK_IMPORTED_MODULE_3__.QueueStatsHeader),
/* harmony export */   QueueStatsLanding: () => (/* reexport safe */ _QueueStatsLanding_QueueStatsLanding__WEBPACK_IMPORTED_MODULE_5__.QueueStatsLanding),
/* harmony export */   QueueStatsPerformanceDetailsView: () => (/* reexport safe */ _components_QueueStatsPerformanceDetailsView_QueueStatsPerformanceDetailsView__WEBPACK_IMPORTED_MODULE_2__.QueueStatsPerformanceDetailsView),
/* harmony export */   QueuesMonitoringWidget: () => (/* reexport safe */ _components_QueuesMonitoringWidget_QueuesMonitoringWidget__WEBPACK_IMPORTED_MODULE_1__.QueuesMonitoringWidget),
/* harmony export */   TableHeaderWidget: () => (/* reexport safe */ _Common_TableHeader_TableHeaderWidget__WEBPACK_IMPORTED_MODULE_0__.TableHeaderWidget)
/* harmony export */ });
/* harmony import */ var _Common_TableHeader_TableHeaderWidget__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Common/TableHeader/TableHeaderWidget */ "./src/components/Common/TableHeader/TableHeaderWidget.ts");
/* harmony import */ var _components_QueuesMonitoringWidget_QueuesMonitoringWidget__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/QueuesMonitoringWidget/QueuesMonitoringWidget */ "./src/components/QueueStatsTab/components/QueuesMonitoringWidget/QueuesMonitoringWidget.ts");
/* harmony import */ var _components_QueueStatsPerformanceDetailsView_QueueStatsPerformanceDetailsView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components/QueueStatsPerformanceDetailsView/QueueStatsPerformanceDetailsView */ "./src/components/QueueStatsTab/components/QueueStatsPerformanceDetailsView/QueueStatsPerformanceDetailsView.ts");
/* harmony import */ var _components_QueueStatsHeader_QueueStatsHeader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/QueueStatsHeader/QueueStatsHeader */ "./src/components/QueueStatsTab/components/QueueStatsHeader/QueueStatsHeader.ts");
/* harmony import */ var _QueueStatsDetail_QueueStatsDetail__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./QueueStatsDetail/QueueStatsDetail */ "./src/components/QueueStatsTab/QueueStatsDetail/QueueStatsDetail.ts");
/* harmony import */ var _QueueStatsLanding_QueueStatsLanding__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./QueueStatsLanding/QueueStatsLanding */ "./src/components/QueueStatsTab/QueueStatsLanding/QueueStatsLanding.ts");








/***/ }),

/***/ "./src/components/RealtimeTranscript/RealtimeTranscript.scss":
/*!*******************************************************************!*\
  !*** ./src/components/RealtimeTranscript/RealtimeTranscript.scss ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.transcript-container {
  height: 100%;
}

.transcript-empty-state {
  height: 100%;
  width: 100%;
}
.transcript-empty-state uuip-wc-empty-state::part(img) {
  width: 192px;
  height: 192px;
}
.transcript-empty-state uuip-wc-empty-state::part(container) {
  background-color: transparent;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/RealtimeTranscript/RealtimeTranscript.scss */
/*# sourceURL=RealtimeTranscript.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvUmVhbHRpbWVUcmFuc2NyaXB0L1JlYWx0aW1lVHJhbnNjcmlwdC5zY3NzIiwiUmVhbHRpbWVUcmFuc2NyaXB0LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxZQUFBO0FDQ0Y7O0FERUE7RUFDRSxZQUFBO0VBQ0EsV0FBQTtBQ0NGO0FEQ0U7RUFDRSxZQUFBO0VBQ0EsYUFBQTtBQ0NKO0FERUU7RUFDRSw2QkFBQTtBQ0FKIiwiZmlsZSI6IlJlYWx0aW1lVHJhbnNjcmlwdC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnRyYW5zY3JpcHQtY29udGFpbmVyIHtcbiAgaGVpZ2h0OiAxMDAlO1xufVxuXG4udHJhbnNjcmlwdC1lbXB0eS1zdGF0ZSB7XG4gIGhlaWdodDogMTAwJTtcbiAgd2lkdGg6IDEwMCU7XG5cbiAgdXVpcC13Yy1lbXB0eS1zdGF0ZTo6cGFydChpbWcpIHtcbiAgICB3aWR0aDogMTkycHg7XG4gICAgaGVpZ2h0OiAxOTJweDtcbiAgfVxuXG4gIHV1aXAtd2MtZW1wdHktc3RhdGU6OnBhcnQoY29udGFpbmVyKSB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogdHJhbnNwYXJlbnQ7XG4gIH1cbn1cbiIsIi50cmFuc2NyaXB0LWNvbnRhaW5lciB7XG4gIGhlaWdodDogMTAwJTtcbn1cblxuLnRyYW5zY3JpcHQtZW1wdHktc3RhdGUge1xuICBoZWlnaHQ6IDEwMCU7XG4gIHdpZHRoOiAxMDAlO1xufVxuLnRyYW5zY3JpcHQtZW1wdHktc3RhdGUgdXVpcC13Yy1lbXB0eS1zdGF0ZTo6cGFydChpbWcpIHtcbiAgd2lkdGg6IDE5MnB4O1xuICBoZWlnaHQ6IDE5MnB4O1xufVxuLnRyYW5zY3JpcHQtZW1wdHktc3RhdGUgdXVpcC13Yy1lbXB0eS1zdGF0ZTo6cGFydChjb250YWluZXIpIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogdHJhbnNwYXJlbnQ7XG59Il19 */`);
    

/***/ }),

/***/ "./src/components/RealtimeTranscript/RealtimeTranscript.ts":
/*!*****************************************************************!*\
  !*** ./src/components/RealtimeTranscript/RealtimeTranscript.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   RealtimeTranscript: () => (/* binding */ RealtimeTranscript)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _RealtimeTranscript_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./RealtimeTranscript.scss */ "./src/components/RealtimeTranscript/RealtimeTranscript.scss");
/* harmony import */ var _utils_TranscriptUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./utils/TranscriptUtils */ "./src/components/RealtimeTranscript/utils/TranscriptUtils.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






/**
 * @element agentx-wc-realtime-transcript
 */
let RealtimeTranscript = class RealtimeTranscript extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
    constructor() {
        super(...arguments);
        this.isSingleAgent = false;
        this.selfAvatar = undefined;
        this.interactionId = "";
        this.transcripts = [];
        this.transcriptionStartTime = null;
        this.callStartTime = null;
        this.activeObserver = null;
        this.handleTranscriptionEvent = (event) => {
            if (event.data.data.conversationId !== this.interactionId) {
                return;
            }
            this.upsertNewTranscript(event);
        };
        this.handleConversationEnding = (event) => {
            if (event.data.interactionId !== this.interactionId) {
                return;
            }
            const terminatingParty = event.data.terminatingParty || (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.you");
            const endMessage = this.createMessageObject("END", "", "AGENT", terminatingParty + (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.callEnded"), Date.now());
            this.transcripts = [...this.transcripts, endMessage];
            this.sendMetric(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.REALTIME_TRANSCRIPTS_DURATION);
        };
        this.handleFeedbackClick = (event) => {
            this.sendMetric(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.REALTIME_TRANSCRIPTS_FEEDBACK_CLICKED, {
                type: event.detail.type
            });
        };
        this.handleJumpToBottomClick = () => {
            this.sendMetric(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.REALTIME_TRANSCRIPTS_JUMP_TO_BOTTOM_CLICKED);
        };
    }
    get transcriptionDurationSeconds() {
        if (!this.transcriptionStartTime) {
            return 0;
        }
        return (Date.now() - this.transcriptionStartTime) / 1000;
    }
    connectedCallback() {
        super.connectedCallback();
        this.callStartTime = Date.now();
        this.initializeTranscriptionListener();
        this.sendMetric(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.REALTIME_TRANSCRIPTS_LOADED);
        this.setupActiveObserver();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.aqm.aiAssistant.eRealtimeTranscriptionAvailable.stopListen(this.handleTranscriptionEvent);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.aqm.contact.eAgentContactEnded.stopListen(this.handleConversationEnding);
        if (this.activeObserver) {
            this.activeObserver.disconnect();
            this.activeObserver = null;
        }
    }
    setupActiveObserver() {
        this.activeObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    // Send telemetry when the component is actually visible
                    this.sendMetric(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.REALTIME_TRANSCRIPTS_VISIBLE);
                }
            });
        });
        this.activeObserver.observe(this);
    }
    initializeTranscriptionListener() {
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.aqm.aiAssistant.eRealtimeTranscriptionAvailable.listen(this.handleTranscriptionEvent);
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.aqm.contact.eAgentContactEnded.listen(this.handleConversationEnding);
    }
    static get styles() {
        return _RealtimeTranscript_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
    }
    getMessages() {
        return this.transcripts;
    }
    upsertNewTranscript(event) {
        const { messageId, publishTimestamp, content, role } = event.data.data;
        if (content === "") {
            return;
        }
        if (this.transcripts.length === 0 && this.callStartTime) {
            this.transcripts.push(this.createMessageObject("START", "", "", (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.callStarted"), this.callStartTime));
        }
        // Find existing message or insertion point
        const { existingIndex, insertPosition } = this.findMessagePosition(messageId, publishTimestamp);
        if (existingIndex >= 0) {
            // Replace the object at the existing index with a copy of it having the content changed
            if (this.transcripts[existingIndex].content === content) {
                return;
            }
            this.transcripts[existingIndex] = Object.assign(Object.assign({}, this.transcripts[existingIndex]), { content });
        }
        else {
            this.transcripts.splice(insertPosition + 1, 0, this.createMessageObject("CHAT", messageId, role, content, publishTimestamp));
        }
        this.transcripts = [...this.transcripts];
        // Send telemetry for the first transcription event
        if (!this.transcriptionStartTime) {
            this.transcriptionStartTime = Date.now();
            this.sendMetric(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.REALTIME_TRANSCRIPTS_AVAILABLE);
        }
    }
    findMessagePosition(messageId, timestamp) {
        let existingIndex = -1;
        let insertPosition = -1;
        for (let i = this.transcripts.length - 1; i >= 0; i--) {
            if (this.transcripts[i].id === messageId) {
                existingIndex = i;
                break;
            }
            if (insertPosition === -1 && this.transcripts[i].rawTimestamp <= timestamp) {
                insertPosition = i;
            }
        }
        return { existingIndex, insertPosition };
    }
    createMessageObject(type, messageId, role, content, timestamp) {
        const isSelfMessage = this.isSingleAgent && role === "AGENT" && type === "CHAT";
        const isLongTimestampFormat = type === "START" || type === "END";
        const avatarAvailable = !!this.selfAvatar;
        const title = role === "AGENT"
            ? isSelfMessage
                ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.you")
                : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.agent")
            : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.customer");
        return {
            id: messageId,
            rawTimestamp: timestamp,
            displayType: isSelfMessage && !avatarAvailable ? "SELF" : type,
            title,
            content,
            timestamp: (0,_utils_TranscriptUtils__WEBPACK_IMPORTED_MODULE_5__.FormatDateTime)(timestamp, isLongTimestampFormat),
            avatarUrl: isSelfMessage ? this.selfAvatar || "" : "",
            status: ""
        };
    }
    sendMetric(type, additionalData = {}) {
        const baseData = {
            interactionId: this.interactionId
        };
        if (type === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.REALTIME_TRANSCRIPTS_DURATION) {
            baseData.duration = this.transcriptionDurationSeconds;
        }
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(type, Object.assign(Object.assign({}, baseData), additionalData));
    }
    transcriptsAvailable() {
        return this.transcriptionStartTime !== null;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
      ${this.transcripts.length === 0
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<div class="transcript-empty-state">
            <uuip-wc-empty-state
              illustration-src="/images/illustrations/cliff-open-192-cobalt-lime.svg"
              class="empty-state-illustration"
              illustration-name="cliff-open-192-cobalt-lime"
            >
              <p>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.transcriptsNotAvailable")}</p>
            </uuip-wc-empty-state>
          </div>`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <div class="transcript-container">
            <uuip-wc-chat-message-list
              .messageList=${this.transcripts}
              .interactionId=${this.interactionId}
              .localization=${{
                tooltipHelpful: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.feedbackHelpful"),
                tooltipNotHelpful: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:realtimeTranscripts.feedbackNotHelpful")
            }}
              @feedback-clicked=${this.handleFeedbackClick}
              @jump-to-bottom-clicked=${this.handleJumpToBottomClick}
            ></uuip-wc-chat-message-list>
          </div>`}
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
], RealtimeTranscript.prototype, "isSingleAgent", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], RealtimeTranscript.prototype, "selfAvatar", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
], RealtimeTranscript.prototype, "interactionId", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
], RealtimeTranscript.prototype, "transcripts", void 0);
RealtimeTranscript = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-realtime-transcript")
], RealtimeTranscript);



/***/ }),

/***/ "./src/components/RealtimeTranscript/utils/TranscriptUtils.ts":
/*!********************************************************************!*\
  !*** ./src/components/RealtimeTranscript/utils/TranscriptUtils.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FormatDateTime: () => (/* binding */ FormatDateTime),
/* harmony export */   getLocaleTimezone: () => (/* binding */ getLocaleTimezone)
/* harmony export */ });
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");

function getLocaleTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function FormatDateTime(timestamp, longFormat = false) {
    const dateTime = new Date(timestamp);
    if (isNaN(dateTime.getTime())) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.warn("invalid timestamp");
        return "";
    }
    const timeOptions = {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: getLocaleTimezone()
    };
    if (longFormat) {
        const dateOptions = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        };
        const datePart = dateTime.toLocaleDateString("en-US", dateOptions);
        const timePart = dateTime.toLocaleTimeString("en-US", timeOptions);
        return `${datePart} ${timePart}`;
    }
    return dateTime.toLocaleTimeString("en-US", timeOptions);
}


/***/ }),

/***/ "./src/components/ScreenPop/ScreenPop.scss":
/*!*************************************************!*\
  !*** ./src/components/ScreenPop/ScreenPop.scss ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host .screen-pop {
  width: 100%;
  height: 100vh;
  border: 0;
}

.screen-pop-tab {
  overflow: hidden;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/ScreenPop/ScreenPop.scss */
/*# sourceURL=ScreenPop.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvU2NyZWVuUG9wL1NjcmVlblBvcC5zY3NzIiwiU2NyZWVuUG9wLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0U7RUFDRSxXQUFBO0VBQ0EsYUFBQTtFQUNBLFNBQUE7QUNBSjs7QURJQTtFQUNFLGdCQUFBO0FDREYiLCJmaWxlIjoiU2NyZWVuUG9wLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XG4gIC5zY3JlZW4tcG9wIHtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBoZWlnaHQ6IDEwMHZoO1xuICAgIGJvcmRlcjogMDtcbiAgfVxufVxuXG4uc2NyZWVuLXBvcC10YWIge1xuICBvdmVyZmxvdzogaGlkZGVuO1xufVxuIiwiOmhvc3QgLnNjcmVlbi1wb3Age1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDB2aDtcbiAgYm9yZGVyOiAwO1xufVxuXG4uc2NyZWVuLXBvcC10YWIge1xuICBvdmVyZmxvdzogaGlkZGVuO1xufSJdfQ== */`);
    

/***/ }),

/***/ "./src/components/ScreenPop/ScreenPop.ts":
/*!***********************************************!*\
  !*** ./src/components/ScreenPop/ScreenPop.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ScreenPop: () => (/* binding */ ScreenPop)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _IframeBase_IframeBase__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../IframeBase/IframeBase */ "./src/components/IframeBase/IframeBase.ts");
/* harmony import */ var _ScreenPop_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ScreenPop.scss */ "./src/components/ScreenPop/ScreenPop.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};







const HTTPS_PROTOCOL = "https://";
const HTTP_PROTOCOL = "http://";
const SCREEN_POP_CONFIG = "screenPopConfig";
var ScreenPop;
(function (ScreenPop) {
    ScreenPop.TARGET_INSIDE_DESKTOP = "insideDesktop";
    ScreenPop.TARGET_SAME_BROWSER_TAB = "sameBrowserTab";
    const ALLOWED_PARAMS = "battery *;camera *;display-capture *; encrypted-media *;fullscreen *;geolocation *;gyroscope *;microphone *;speaker-selection *;web-share *;clipboard-write; clipboard-read;";
    ScreenPop.getAlreadyOpenedScreenPopConfig = () => {
        const configStr = sessionStorage.getItem(SCREEN_POP_CONFIG);
        if (configStr) {
            return JSON.parse(configStr);
        }
        return null;
    };
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        constructor() {
            super(...arguments);
            this.screenPopUrl = null;
            this.selectedTab = 0;
        }
        static get styles() {
            return _ScreenPop_scss__WEBPACK_IMPORTED_MODULE_6__["default"];
        }
        connectedCallback() {
            const _super = Object.create(null, {
                connectedCallback: { get: () => super.connectedCallback }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.connectedCallback.call(this);
                this.addEventListener("selected-changed", this.preserveSelectedTab);
                this.selectedTab = this.setSelectedTab();
            });
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.removeEventListener("selected-changed", this.preserveSelectedTab);
        }
        setSelectedTab() {
            if (this.screenPopUrl) {
                this.screenPopUrl.forEach((data, index) => {
                    if (data.isSelected) {
                        this.selectedTab = index;
                    }
                });
            }
            return this.selectedTab;
        }
        telemetryTracker(screenPopData) {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.SCREEN_POP_INSIDE_DESKTOP_REFERRED, {
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.SCREEN_POP_INTERACTION]: screenPopData.interactionId,
                [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.MEDIA_TYPE]: screenPopData.mediaType
            });
        }
        preserveSelectedTab(e) {
            if (this.screenPopUrl) {
                const interactionId = e.detail.tabsOrder[e.detail.value];
                const screenPopData = JSON.parse(JSON.stringify(this.screenPopUrl));
                const modifiedData = screenPopData.map((data, index) => {
                    if (index === e.detail.value) {
                        data.isSelected = true;
                    }
                    else {
                        data.isSelected = false;
                    }
                    return data;
                });
                const existingScreenPopData = ScreenPop.getAlreadyOpenedScreenPopConfig() || [];
                let newData = existingScreenPopData.filter((data) => {
                    return data.interactionId !== interactionId;
                });
                newData = [...newData, ...modifiedData];
                sessionStorage.setItem(SCREEN_POP_CONFIG, JSON.stringify(newData));
                this.dispatchEvent(new CustomEvent("ax-update-screen-pop", {
                    bubbles: true,
                    composed: true,
                    detail: newData
                }));
                const selectedTabData = newData.filter((data) => data.isSelected);
                this.telemetryTracker(selectedTabData[0]);
            }
        }
        render() {
            return this.screenPopUrl
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
            <md-tabs selected=${this.setSelectedTab()}>
              ${this.screenPopUrl.map((data) => {
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                  <md-tab
                    name=${data.interactionId}
                    slot="tab"
                    class="widget-pane-tab"
                    aria-label=${data.screenPopDesktopLabel}
                    role="tab"
                  >
                    <span class="tab-header-content">
                      <span>${data.screenPopDesktopLabel}</span>
                    </span>
                  </md-tab>

                  <md-tab-panel class="screen-pop-tab" slot="panel">
                    <agentx-wc-iframe
                      allowedParams=${ALLOWED_PARAMS}
                      class="screen-pop"
                      src="${data.screenPopUrl}"
                    ></agentx-wc-iframe>
                  </md-tab-panel>
                `;
                })}
            </md-tabs>
          `
                : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Array })
    ], Element.prototype, "screenPopUrl", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Number })
    ], Element.prototype, "selectedTab", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-screen-pop")
    ], Element);
    ScreenPop.Element = Element;
    /**;
     * Open screen pop (i.e. browser window) after constructing final url based on Screen POP event
     * @param screenPopDetail
     */
    ScreenPop.constructScreenPopUrl = (screenPopDetail, mediaType, saveToSessionStorage = false) => {
        const settings = screenPopDetail.data;
        let screenPopUrl = "";
        if (settings) {
            const baseUrl = settings.screenPopUrl;
            const url = new URL(baseUrl.indexOf(HTTPS_PROTOCOL) > -1 || baseUrl.indexOf(HTTP_PROTOCOL) > -1
                ? baseUrl
                : HTTPS_PROTOCOL.concat(baseUrl));
            if (settings.queryParameters) {
                Object.keys(settings.queryParameters).forEach((paramKey) => {
                    url.searchParams.set(paramKey.trim(), settings.queryParameters[paramKey].trim());
                });
            }
            screenPopUrl = url.href;
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[ScreenPop] Final screen pop url", url);
            if (saveToSessionStorage) {
                const existingScreenPopData = ScreenPop.getAlreadyOpenedScreenPopConfig() || [];
                const screenPopConfig = {
                    interactionId: screenPopDetail.data.interactionId,
                    screenPopDesktopLabel: screenPopDetail.data.screenPopDesktopLabel || (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:notifications.screenPopDesktopDefaultLabel"),
                    screenPopUrl,
                    target: settings.target,
                    mediaType,
                    screenPopName: settings.screenPopName
                };
                // get duplicate screenPop event
                const filteredScreenPop = existingScreenPopData.filter((obj) => {
                    return (obj.screenPopName === screenPopConfig.screenPopName && obj.interactionId === screenPopConfig.interactionId);
                });
                // push screenPop if no duplicates found.
                if (filteredScreenPop.length === 0) {
                    existingScreenPopData.push(screenPopConfig);
                    sessionStorage.setItem(SCREEN_POP_CONFIG, JSON.stringify(existingScreenPopData));
                }
            }
        }
        return screenPopUrl;
    };
    ScreenPop.removeScreenPopFromSession = () => {
        return sessionStorage.removeItem(SCREEN_POP_CONFIG);
    };
    ScreenPop.screenPopNavConfig = {
        navRouteName: "screenpop",
        navRoutePath: "/screenpop",
        navIcon: {
            label: "Screen-pop",
            icon: "pop-out",
            iconType: "momentum",
            navigateTo: "screenpop",
            align: "bottom"
        },
        area: "main-routed"
    };
})(ScreenPop || (ScreenPop = {}));


/***/ }),

/***/ "./src/components/ShortcutKey/ShortcutKeyModal.scss":
/*!**********************************************************!*\
  !*** ./src/components/ShortcutKey/ShortcutKeyModal.scss ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

:host {
  --search-width: calc(var(--space-token-cardinal) * 52);
  --border-outline: 1px solid var(--md-quaternary-bg-color);
  --shortcut-header-height: calc(calc(var(--space-token-cardinal) * 12) + var(--space-token-even));
  --shortcut-header-conflict-height: calc(calc(var(--space-token-cardinal) * 25));
  --nav-header-height: 64px;
  color: var(--md-primary-text-color);
  font-family: var(--font-family);
}

.column-group,
.column-shortcut-key,
.column-action {
  overflow: hidden !important;
  display: flex;
  padding: calc(var(--space-token-cardinal) * 2) 0;
  padding-left: calc(var(--space-token-cardinal) * 4);
  padding-right: var(--space-token-cardinal);
  border-bottom: var(--border-outline);
  overflow-wrap: break-word;
  cursor: default !important;
}

.column-group,
.column-shortcut-key {
  width: 30%;
  border-left: var(--border-outline);
  border-right: var(--border-outline);
}

.column-action {
  width: 40%;
}

.input-search-field {
  max-width: var(--search-width);
}

.column-titles {
  display: flex;
  background-color: var(--md-secondary-bg-color);
  font-size: var(--font-size-medium);
  font-weight: bold;
  border-top: var(--border-outline);
  width: calc(100% - var(--space-token-even) * 6);
}

@supports (-moz-osx-font-smoothing: auto) {
  .column-titles {
    width: 100%;
  }
  .shortcut-key-list-item {
    margin-right: 0 !important;
  }
}
.group-sort-btn,
.action-sort-btn,
.shortcutkey-sort-btn {
  margin-left: calc(var(--space-token-even) * 4);
  cursor: pointer;
}

.shortcut-key-list-item {
  font-size: var(--font-size-small);
  border: 0 !important;
  margin-right: calc(var(--space-token-even) * 2);
}
.shortcut-key-list-item::part(list-item) {
  padding: 0;
  display: flex;
  align-items: stretch;
}

.shortcut-key-list-item > .column-group,
.shortcut-key-list-item > .column-shortcut-key,
.shortcut-key-list-item > .column-action {
  padding-top: calc(var(--space-token-even) * 6);
  padding-bottom: calc(var(--space-token-even) * 6);
}

.conflict-warning-icon {
  position: absolute;
  left: 70%;
}

.conflict-warning-message {
  background-color: var(--badge-red-bg-color);
  text-align: center;
  color: var(--badge-red-text-color);
  padding: calc(var(--space-token-cardinal) * 2) 0;
  margin: calc(var(--space-token-cardinal) * 2) 0;
}

.search-illustration {
  display: block;
  height: 50vh;
  padding-left: var(--space-token-even);
}

.search-message {
  padding: calc(var(--space-token-cardinal) * 2);
  color: var(--md-primary-text-color);
}

.search-result {
  width: 100% !important;
}

.icon-warning {
  color: var(--button-red-bg-color);
}

uuip-wc-empty-state::part(img) {
  width: 100px;
  background: transparent;
}

uuip-wc-empty-state::part(container) {
  background: transparent;
}

agentx-wc-empty-state-wrapper::part(img) {
  width: 100px;
  background: transparent;
}

agentx-wc-empty-state-wrapper::part(container) {
  background: transparent;
}

.shortcut-key-list-box {
  padding-bottom: var(--space-token-even);
}

.shortcut-list {
  overflow-y: scroll;
  height: calc(100% - var(--shortcut-header-height));
  scrollbar-width: thin;
  padding-left: var(--space-token-even);
  margin-bottom: 12px;
}
.shortcut-list::-webkit-scrollbar {
  width: calc(var(--space-token-even) * 4);
}
.shortcut-list::-webkit-scrollbar-thumb {
  border-radius: var(--border-radius-large);
  background-color: var(--md-presence-away-bg-color);
}

.shortcut-list-conflict {
  height: calc(100% - var(--shortcut-header-conflict-height));
  margin-bottom: 11px;
}

.shortcut-header {
  position: sticky;
  top: 0;
  background-color: var(--md-tertiary-white-bg-color);
  padding-left: var(--space-token-even);
}

.ellipsis-text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#shortcut-key-modal::part(floating) {
  overflow: hidden;
  height: 80%;
  width: 50%;
  left: 10%;
  top: 10%;
  z-index: calc(var(--z-index-task-collapse-area) + 1);
}

@media (max-width: 880px) {
  #shortcut-key-modal::part(floating) {
    overflow: hidden;
    height: 80%;
    width: 50%;
    left: 0;
    top: var(--nav-header-height);
  }
}
@media (max-width: 736px) {
  #shortcut-key-modal::part(floating) {
    overflow: hidden;
    height: calc(100% - var(--nav-header-height));
    width: 100%;
    left: 0;
    top: var(--nav-header-height);
  }
  [full-screen]#shortcut-key-modal::part(floating) {
    z-index: var(--z-index-shortcutkey-modal);
  }
}
md-floating-modal::part(floating) {
  min-width: 480px;
  min-height: 320px;
  user-select: text;
}

.sr-only {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=ShortcutKeyModal.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-services/dist/styles/z-index.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/ShortcutKey/ShortcutKeyModal.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/ShortcutKey/ShortcutKeyModal.ts":
/*!********************************************************!*\
  !*** ./src/components/ShortcutKey/ShortcutKeyModal.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ShortcutKey: () => (/* binding */ ShortcutKey)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Common_EmptyStateWrapper_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Common/EmptyStateWrapper/EmptyStateWrapper */ "./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.ts");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _ShortcutKeyModal_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./ShortcutKeyModal.scss */ "./src/components/ShortcutKey/ShortcutKeyModal.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};











var ShortcutKey;
(function (ShortcutKey) {
    let ShortcutKeyModal = class ShortcutKeyModal extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_8__.MobxLitElement) {
        constructor() {
            super(...arguments);
            this.isModalOpen = false;
            this.isShortcutKeyConflict = false;
            this.altOrOptionKey = "";
            this.shortcutKeyData = [];
            this.shortcutKeys = [];
            this.isSearchEmpty = false;
            this.ShortkeyTable = {
                config: {
                    isStickyHeader: true,
                    cellTemplates: {
                        _warn_: { templateName: "tmp2" }
                    },
                    default: {
                        sort: {
                            colId: "c1",
                            order: "ascending"
                        }
                    },
                    rows: {
                        isDraggable: false
                    },
                    cols: {
                        isResizable: true,
                        define: [
                            { id: "c1", title: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.group"), sorter: "byString", width: "30%" },
                            { id: "c2", title: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.action"), sorter: "byString", width: "40%" },
                            { id: "c3", title: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.shortcutKey"), sorter: "byString", width: "30%" }
                        ]
                    },
                    head: {
                        tableDescription: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.tableDescription")
                    }
                },
                data: {
                    list2d: [["", "", ""]]
                }
            };
            this.SEARCH = "";
            this.ACTION = "";
            this.GROUP = "";
            this.SHORTCUTKEY = "";
            this.resultsLabel = "{{count}} search results available";
            this.inputKeydownHandler = (event) => {
                const { srcEvent } = event.detail;
                if (this.shortcutList) {
                    if (srcEvent.code === "Tab") {
                        this.shortcutList.rovingPreventFocus = false;
                    }
                    else {
                        this.shortcutList.rovingPreventFocus = true;
                    }
                }
            };
        }
        updateConstant() {
            this.SEARCH = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.search");
            this.GROUP = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.group");
            this.ACTION = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.action");
            this.SHORTCUTKEY = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.shortcutKey");
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            this.updateConstant();
            changedProperties.forEach((oldValue, name) => {
                if (name === "isModalOpen") {
                    const regis = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.shortcut.getRegisteredKeys();
                    this.combineShortcutKey(regis);
                    this.requestUpdate();
                }
            });
            if (this.shortcutList) {
                this.shortcutList.rovingPreventFocus = true;
            }
            if (this.searchInput && this.searchInput.shadowRoot.querySelector("input")) {
                this.searchInput.shadowRoot.querySelector("input").focus();
            }
        }
        combineShortcutKey(regis) {
            this.shortcutKeyData = [];
            regis.forEach((value) => {
                const keyData = [];
                value.action = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(value.action);
                value.group = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(value.group);
                keyData.push(value.group, value.action, `${this.formatShortcutKey(value.modifierKeys)} + ${value.key.toUpperCase()}${value.isConflict ? " _warn_" : ""}`);
                this.shortcutKeyData.push(keyData);
                this.shortcutKeys = this.shortcutKeyData;
            });
            this.ShortkeyTable = Object.assign(Object.assign({}, this.ShortkeyTable), { data: {
                    list2d: this.shortcutKeyData
                } });
        }
        handleSearchInput(searchQuery) {
            const lowercasedValue = searchQuery.toLowerCase().trim();
            const filteredData = this.shortcutKeys.filter((item) => {
                return item.join().toLowerCase().indexOf(lowercasedValue) > -1 ? item : false;
            });
            this.ShortkeyTable = Object.assign(Object.assign({}, this.ShortkeyTable), { data: {
                    list2d: filteredData
                } });
            this.isSearchEmpty = !filteredData.length;
            if (this.isSearchEmpty) {
                this.liveRegion.textContent = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.noSearchResult");
            }
            else {
                const countLabel = this.ShortkeyTable.data.list2d.length;
                this.liveRegion.textContent = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys:searchResultsCount", this.resultsLabel, {
                    count: countLabel
                });
            }
            this.requestUpdate();
        }
        handleCloseModal() {
            const event = new CustomEvent("ax-close-shortcut-key-modal", {
                detail: false,
                bubbles: true,
                composed: true
            });
            this.dispatchEvent(event);
        }
        static get styles() {
            return _ShortcutKeyModal_scss__WEBPACK_IMPORTED_MODULE_9__["default"];
        }
        formatShortcutKey(keyCombination) {
            keyCombination = keyCombination.toUpperCase();
            this.altOrOptionKey = this.detectOS();
            keyCombination = keyCombination.replace(/CTRLKEY/gi, "Ctrl");
            keyCombination = keyCombination.replace(/SHIFTKEY/gi, "Shift");
            keyCombination = keyCombination.replace(/ALTKEY/gi, this.altOrOptionKey);
            keyCombination = keyCombination.replace(/_/gi, " + ");
            return keyCombination;
        }
        detectOS() {
            if (navigator.userAgent.indexOf("Mac") !== -1) {
                return "Option";
            }
            return "Alt";
        }
        renderSearchImage() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <div class="search-illustration">
          <agentx-wc-empty-state-wrapper illustration-type="empty-result">
            <span class="search-message">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.noSearchResult")}</span>
          </agentx-wc-empty-state-wrapper>
        </div>
      `;
        }
        renderConflict() {
            if (this.isShortcutKeyConflict) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) ` <div class="conflict-warning-message">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.conflict")}</div> `;
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) ``;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <md-floating-modal
          ?show=${this.isModalOpen}
          class="shortcut-key-modal"
          id="shortcut-key-modal"
          heading=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.keyboardShortcuts")}
          label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.keyboardShortcuts")}
          maximize-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.maximizeScreenLabel")}
          minimize-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.minimizeModal")}
          resize-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.restoreScreenLabel")}
          close-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:keyboardShortcutKeys.closeModal")}
          @floating-modal-close=${() => this.handleCloseModal()}
        >
          <div class="shortcut-header">
            ${this.renderConflict()}
            <div class="input-search-field">
              <md-input
                htmlid="inputSearchClearPill"
                class="input-field"
                placeholder=${this.SEARCH}
                ariaLabel=${this.SEARCH}
                searchable=""
                shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
                ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumV2Enabled}
                clear=""
                value=""
                autoFocus
                @input-keydown=${(event) => this.inputKeydownHandler(event)}
                @input-change=${(e) => this.handleSearchInput(e.detail.value)}
              ></md-input>
            </div>
          </div>
          ${!this.isSearchEmpty
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                <div class="shortcut-list ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5__.classMap)({ "shortcut-list-conflict": this.isShortcutKeyConflict })}">
                  <md-table-advanced
                    .config=${this.ShortkeyTable.config}
                    .data=${this.ShortkeyTable.data}
                    isRowFocusable="false"
                  >
                    <template id="tmp1">
                      <md-icon class="warn-icon" name="warning_20" color="blue"></md-icon>
                    </template>

                    <template id="tmp2">
                      <md-icon class="warn-icon" name="warning_20" color="yellow"></md-icon>
                    </template>

                    <template id="tmp3">
                      <md-icon class="warn-icon" name="error_20" color="red"></md-icon>
                    </template>
                  </md-table-advanced>
                </div>
              `
                : this.renderSearchImage()}
          <div id="live-region" class="sr-only" aria-live="polite"></div>
        </md-floating-modal>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], ShortcutKeyModal.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], ShortcutKeyModal.prototype, "isShortcutKeyConflict", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
    ], ShortcutKeyModal.prototype, "altOrOptionKey", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], ShortcutKeyModal.prototype, "shortcutKeyData", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], ShortcutKeyModal.prototype, "shortcutKeys", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], ShortcutKeyModal.prototype, "isSearchEmpty", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], ShortcutKeyModal.prototype, "ShortkeyTable", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.query)(".shortcut-key-list-box")
    ], ShortcutKeyModal.prototype, "shortcutList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.query)(".input-field")
    ], ShortcutKeyModal.prototype, "searchInput", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.query)("#live-region")
    ], ShortcutKeyModal.prototype, "liveRegion", void 0);
    ShortcutKeyModal = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("agentx-wc-shortcut-keys-modal")
    ], ShortcutKeyModal);
    ShortcutKey.ShortcutKeyModal = ShortcutKeyModal;
})(ShortcutKey || (ShortcutKey = {}));


/***/ }),

/***/ "./src/components/StationLogin/AppLoadingScreen.scss":
/*!***********************************************************!*\
  !*** ./src/components/StationLogin/AppLoadingScreen.scss ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

:host {
  background-color: white;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-index-app-full-overlay, 1050);
}

.loading-logo {
  animation: fadeIn 250ms linear forwards;
  margin-bottom: 20vh;
}

.md-loading {
  position: absolute;
  bottom: 20vh;
  margin-left: -1em;
  left: 50vw;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-services/dist/styles/z-index.scss */
/*# sourceURL=AppLoadingScreen.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/StationLogin/AppLoadingScreen.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/StationLogin/AppLoadingScreen.ts":
/*!*********************************************************!*\
  !*** ./src/components/StationLogin/AppLoadingScreen.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentXLoadingScreen: () => (/* binding */ AgentXLoadingScreen)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../assets/styles/common.scss */ "./src/assets/styles/common.scss");
/* harmony import */ var _AppLoadingScreen_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./AppLoadingScreen.scss */ "./src/components/StationLogin/AppLoadingScreen.scss");
/* harmony import */ var _src_logo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./src/logo */ "./src/components/StationLogin/src/logo.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let AgentXLoadingScreen = class AgentXLoadingScreen extends lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement {
    static get styles() {
        return [_AppLoadingScreen_scss__WEBPACK_IMPORTED_MODULE_2__["default"], _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_1__["default"]];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
      <div class="loading-screen">
        <span class="loading-logo" aria-hidden="true">${(0,_src_logo__WEBPACK_IMPORTED_MODULE_3__["default"])(150)}</span>
        <md-loading class="md-loading" aria-hidden="true"></md-loading>
        <span class="sr-only" role="status">Loading</span>
      </div>
    `;
    }
};
AgentXLoadingScreen = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("agentx-wc-loading-screen")
], AgentXLoadingScreen);



/***/ }),

/***/ "./src/components/StationLogin/src/logo.ts":
/*!*************************************************!*\
  !*** ./src/components/StationLogin/src/logo.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_0__);

/* eslint-disable max-len */
// sonar.issue.ignore.block
const appLogo = (size) => (0,lit_html__WEBPACK_IMPORTED_MODULE_0__.html) `
  <svg
    width=${size}
    height=${size}
    viewBox="0 0 ${size} ${size}"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <rect width=${size} height=${size} fill="url(#pattern0)" />
    <defs>
      <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlink:href="#image0" transform="translate(-0.000480307) scale(0.000960615)" />
      </pattern>
      <image
        id="image0"
        width="1042"
        height="1041"
        xlink:href="data:image/png;base64,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"
      />
    </defs>
  </svg>
`;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (appLogo);


/***/ }),

/***/ "./src/components/SupervisorFilters/ChannelFilter/ChannelFilter.ts":
/*!*************************************************************************!*\
  !*** ./src/components/SupervisorFilters/ChannelFilter/ChannelFilter.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChannelFilter: () => (/* binding */ ChannelFilter)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html/directives/style-map */ "lit-html/directives/style-map");
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./../../../utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./../index.scss */ "./src/components/SupervisorFilters/index.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};










let ChannelFilter = class ChannelFilter extends _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_2__.MobxLitElement {
    constructor() {
        super(...arguments);
        this.languageResources = "/i18n/{{lng}}/{{ns}}.json";
        this.selectedChannelList = [];
        this.selectedChannelListKey = "selected-channel-list";
        this.channelFilterSelectedEventKey = "channel-filter-selected";
        this.value = [];
        this.items = [];
        this.infiniteScrollingEnabled = false;
        this.lastSelectedIdByOrder = "";
        this.selectAllItems = false;
        this.arrowIcon = "arrow-down-bold";
        this.isMenuOverlayOpen = false;
        this.disableReset = false;
        this.channelList = _constants__WEBPACK_IMPORTED_MODULE_0__.channelList;
        this.changeHandler = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_8__.debounce)((e) => {
            let selectedItems = e.detail.selected;
            this.disableReset = selectedItems.length === 0;
            if (this.infiniteScrollingEnabled) {
                selectedItems = this.updateSelectedItem(e);
            }
            sessionStorage.setItem(this.selectedChannelListKey, JSON.stringify(selectedItems));
            window.dispatchEvent(new CustomEvent(this.channelFilterSelectedEventKey, {
                detail: selectedItems,
                bubbles: true,
                composed: true
            }));
        }, _constants__WEBPACK_IMPORTED_MODULE_0__.SELECTED_CHANGE_DELAY);
        this.getLocalizedChannelList = () => {
            const localizedChannelList = [];
            this.channelList.forEach((ent) => {
                localizedChannelList.push({ name: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(`app:agentProfile.${ent.name}`), value: ent.value });
            });
            return localizedChannelList;
        };
    }
    static get styles() {
        return _index_scss__WEBPACK_IMPORTED_MODULE_9__["default"];
    }
    connectedCallback() {
        super.connectedCallback();
        // getting the FF from the service, because the Channel filter is being configured from layout json. So if we add this FF in STORE then all the layouts need to be updated.
        this.infiniteScrollingEnabled = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.featureflag.isFeatureFlagEnabled(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.FEATURE_FLAGS.MANAGED_FILTER_INFINITE_SCROLLING);
        if (this.infiniteScrollingEnabled) {
            this.value = this.populateValueFromCache();
            //
            // this setTimeout is work around. advance list using infinite scrolling lit component, and it has bug of overlapping element.
            setTimeout(() => {
                this.items = this.generateAdvanceListTemplate();
                this.selectAllItems = this.value.length === this.channelList.length;
            }, 0);
        }
        this.disableReset = this.value.length === 0;
    }
    updateSelectedItem(e) {
        const selectedItems = [];
        e.detail.selected.forEach((name) => {
            const item = this.channelList.find((channel) => channel.name === name);
            selectedItems.push({ name: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(`app:agentProfile.${item === null || item === void 0 ? void 0 : item.name}`), value: item === null || item === void 0 ? void 0 : item.value });
        });
        this.value = e.detail.selected;
        if (this.value.length === this.items.length) {
            this.selectAllItems = true;
        }
        else {
            this.selectAllItems = false;
        }
        return selectedItems;
    }
    naturalSort(a, b) {
        return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
    }
    updateSelectAllCheckboxOnClick() {
        if (this.selectAllItems) {
            this.resetFilter();
        }
        else {
            this.selectAllItems = true;
        }
    }
    resetFilter() {
        this.selectAllItems = false;
        this.value = [];
        this.disableReset = true;
        sessionStorage.removeItem(this.selectedChannelListKey);
    }
    generateAdvanceListTemplate() {
        const items = [];
        this.channelList.forEach((channel) => {
            const id = `${channel.name}`;
            items.push({
                name: channel.name,
                id,
                index: items.length,
                ariaLabel: channel.name,
                template: (data, index) => (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `<div class="channel-filter-item" aria-hidden="true" indexing="${index}">
            <md-checkbox>${data.name}</md-checkbox>
          </div>`
            });
        });
        return items;
    }
    sortSelectedItem(sortedItems) {
        const selectedItems = sortedItems.filter((item) => this.value.includes(item.id));
        if (selectedItems.length > 0) {
            this.lastSelectedIdByOrder = selectedItems[selectedItems.length - 1].name;
        }
        else {
            this.lastSelectedIdByOrder = "";
        }
        return selectedItems;
    }
    sortUnSelectedItem(sortedItems) {
        return sortedItems.filter((item) => !this.value.includes(item.id));
    }
    populateValueFromCache() {
        const cachedValueStr = sessionStorage.getItem(this.selectedChannelListKey);
        if (!cachedValueStr) {
            return [];
        }
        try {
            const parsedValue = JSON.parse(cachedValueStr);
            return Array.isArray(parsedValue) ? parsedValue.map((item) => item.name) : [];
        }
        catch (_a) {
            return [];
        }
    }
    getSortedItems() {
        // sort all records in natural order
        const sortedItems = [...this.items].sort((a, b) => this.naturalSort(a.name, b.name));
        if (this.infiniteScrollingEnabled) {
            return [...this.sortSelectedItem(sortedItems), ...this.sortUnSelectedItem(sortedItems)];
        }
        else {
            return sortedItems;
        }
    }
    getDropdownHeader() {
        const { length } = this.value;
        const ALL_LABEL = `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.all")}`;
        if (length === _constants__WEBPACK_IMPORTED_MODULE_0__.channelList.length) {
            return `${ALL_LABEL} (${_constants__WEBPACK_IMPORTED_MODULE_0__.channelList.length})`;
        }
        if (length > 0) {
            return `${length} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.selected")}`;
        }
        if (_constants__WEBPACK_IMPORTED_MODULE_0__.channelList.length > 0) {
            return `${ALL_LABEL} (${_constants__WEBPACK_IMPORTED_MODULE_0__.channelList.length})`;
        }
        return `${ALL_LABEL}`;
    }
    getFilterIcon() {
        return _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `<md-icon name="filter-bold" class="filter-icon" size="16" iconSet="momentumDesign"></md-icon>`
            : "";
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `<div
      class="filter-container channel-filter"
      style=${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_7__.styleMap)({
            width: `${this.style.width || "250px"}`
        })}
    >
      ${!this.infiniteScrollingEnabled
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
            <md-combobox
              .options=${this.getLocalizedChannelList()}
              option-id="value"
              option-value="name"
              shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
              ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
              ?is-dropdown-arrow=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
              ?show-filter-icon=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
              ?compact=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
              is-multi
              show-selected-count
              no-clear-icon
              allow-select-all
              placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.selectChannel")}
              all-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.all")}
              selected-all-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.selected")}
              select-all-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.selectAll")}
              @change-selected=${this.changeHandler}
              .value=${this.selectedChannelList}
              ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:pageSubHeader.channelType")}
              comboboxId="inp-channelType"
            ></md-combobox>
          `
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
            <md-menu-overlay
              class="queueDropdown "
              size="small"
              @menu-overlay-open=${() => {
                this.items = this.getSortedItems();
                this.arrowIcon = "arrow-up-bold";
                this.isMenuOverlayOpen = true;
            }}
              @menu-overlay-close=${() => {
                this.arrowIcon = "arrow-down-bold";
                this.isMenuOverlayOpen = false;
            }}
            >
              <md-button
                variant="dropdown"
                is-placeholder-text
                slot="menu-trigger"
                width="250px"
                ariaHasPopup="listbox"
                ariaExpanded=${this.isMenuOverlayOpen}
                ariaLabel=${`${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:pageSubHeader.channelType")} ${this.getDropdownHeader()}`}
                .rounded=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
              >
                <div class="channel-filter-dropdown-button">
                  <span class="channel-filter-icon-text"> ${this.getFilterIcon()} ${this.getDropdownHeader()} </span>
                  <md-icon slot="input-section-right" name=${this.arrowIcon} iconset="momentumDesign"></md-icon>
                </div>
              </md-button>

              <div class="channel-filter-advance-list-container">
                <div class="channel-filter-select-all">
                  <md-checkbox
                    id="select-all"
                    @checkbox-change=${this.updateSelectAllCheckboxOnClick}
                    .checked=${this.selectAllItems}
                    >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.selectAll")}</md-checkbox
                  >
                </div>
                <md-advance-list
                  .items=${this.items}
                  .value=${this.value}
                  ariaRoleList="listbox"
                  containerHeight="165px"
                  ariaLabelList=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.selectChannel")}
                  .lastSelectedIdByOrder=${this.lastSelectedIdByOrder}
                  is-multi
                  .groupOnMultiSelect=${this.infiniteScrollingEnabled}
                  .selectAllItems=${this.selectAllItems}
                  @list-item-change=${this.changeHandler}
                >
                </md-advance-list>
                <div class="channel-filter-item-reset">
                  <md-button ?disabled=${this.disableReset} @button-click=${this.resetFilter} size="36"
                    >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.resetFilter")}</md-button
                  >
                </div>
              </div>
            </md-menu-overlay>
          `}
    </div>`;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
], ChannelFilter.prototype, "selectedChannelList", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
], ChannelFilter.prototype, "selectedChannelListKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
], ChannelFilter.prototype, "channelFilterSelectedEventKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
], ChannelFilter.prototype, "value", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
], ChannelFilter.prototype, "items", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], ChannelFilter.prototype, "infiniteScrollingEnabled", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], ChannelFilter.prototype, "lastSelectedIdByOrder", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], ChannelFilter.prototype, "selectAllItems", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], ChannelFilter.prototype, "arrowIcon", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], ChannelFilter.prototype, "isMenuOverlayOpen", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
], ChannelFilter.prototype, "disableReset", void 0);
ChannelFilter = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-channel-filter")
], ChannelFilter);



/***/ }),

/***/ "./src/components/SupervisorFilters/QueueFilter/QueueFilter.ts":
/*!*********************************************************************!*\
  !*** ./src/components/SupervisorFilters/QueueFilter/QueueFilter.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QueueFilter: () => (/* binding */ QueueFilter)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! lit-html/directives/style-map */ "lit-html/directives/style-map");
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _common_FilterDropdown__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../common/FilterDropdown */ "./src/components/SupervisorFilters/common/FilterDropdown.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./../../../utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./../index.scss */ "./src/components/SupervisorFilters/index.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};













let QueueFilter = class QueueFilter extends _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__.MobxLitElement {
    constructor() {
        super(...arguments);
        this.selectedQueueList = [];
        this.managedQueues = [];
        this.selectedQueueListKey = "selected-queue-list";
        this.queueFilterSelectedEventKey = "queue-filter-selected";
        this.fetchManagedQueueEventKey = "fetch-managed-queue";
        this.isLoading = true;
        this.isError = false;
        this.paginatedManagedQueues = [];
        this.filterManagedQueues = [];
        this.currentPage = 0;
        this.totalRecords = 0;
        this.infiniteScrollingEnabled = false;
        this.isPageLoading = false;
        this.pageFetchError = {
            isError: false,
            trackingId: ""
        };
        this.totalQueueRecords = 0;
        this.searchQuery = "";
        this.languageResources = "/i18n/{{lng}}/{{ns}}.json";
        this.changeHandler = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_11__.debounce)((e) => {
            sessionStorage.setItem(this.selectedQueueListKey, JSON.stringify(e.detail.selected));
            window.dispatchEvent(new CustomEvent(this.queueFilterSelectedEventKey, {
                detail: e.detail.selected,
                bubbles: true,
                composed: true
            }));
        }, _constants__WEBPACK_IMPORTED_MODULE_0__.SELECTED_CHANGE_DELAY);
        this.handleSearchQueryChange = (event) => {
            this.searchQuery = event.detail.searchQuery;
            if (this.searchQuery === "") {
                this.isPageLoading = false;
                this.filterManagedQueues = [];
                this.totalRecords = this.totalQueueRecords;
                return;
            }
            if (this.totalQueueRecords > 0 &&
                (this.paginatedManagedQueues.length === this.totalQueueRecords || this.totalQueueRecords <= 100)) {
                this.handleLocalSearch();
            }
            else {
                this.getManagedQueuesList(event);
            }
        };
    }
    static get styles() {
        return _index_scss__WEBPACK_IMPORTED_MODULE_12__["default"];
    }
    connectedCallback() {
        super.connectedCallback();
        this.infiniteScrollingEnabled = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.featureflag.isFeatureFlagEnabled(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.FEATURE_FLAGS.MANAGED_FILTER_INFINITE_SCROLLING);
        this.addEventListener("reload", this.fetchQueues);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener("reload", this.fetchQueues);
    }
    fetchQueues() {
        window.dispatchEvent(new CustomEvent(this.fetchManagedQueueEventKey, {
            detail: "",
            bubbles: true,
            composed: true
        }));
    }
    getFetchErrorMessage() {
        return JSON.stringify({
            header: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorDetail:errorTitle"),
            message: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorModal:trackingIdDescription"),
            trackingId: this.isError
        });
    }
    isFilterApplied() {
        return this.searchQuery && this.searchQuery.length > 0;
    }
    updateQueueData(data) {
        if (this.isFilterApplied()) {
            this.filterManagedQueues = [...this.filterManagedQueues, ...data];
        }
        else {
            this.paginatedManagedQueues = [...this.paginatedManagedQueues, ...data];
        }
    }
    resetQueueData(data) {
        if (this.isFilterApplied()) {
            this.filterManagedQueues = data;
        }
        else {
            this.paginatedManagedQueues = data;
        }
    }
    handleLoadPageSuccess(response, reset) {
        const formatQueue = response.data.map((queue) => {
            return {
                queueId: queue.id,
                queueName: queue.name
            };
        });
        if (reset) {
            this.resetQueueData(formatQueue);
        }
        else {
            this.updateQueueData(formatQueue);
        }
        this.currentPage = response.meta.page;
        this.totalRecords = response.meta.totalRecords;
        this.isPageLoading = false;
        if (!this.isFilterApplied()) {
            this.totalQueueRecords = response.meta.totalRecords;
        }
        this.pageFetchError = {
            isError: false,
            trackingId: ""
        };
        _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info(`event=getManagedQueuesList | Managed Queues page ${this.currentPage} fetched successfully`);
    }
    handleLoadPageError(error) {
        this.isPageLoading = false;
        this.pageFetchError = {
            isError: true,
            trackingId: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject)(error) : ""
        };
        _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("event=getManagedQueuesList | Error on fetching managed queues on ESD Queue Filters", error);
    }
    fetchManagedQueues(pageNumber, searchQuery) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.abs.fetchQueueList({
                payload: {
                    pageSize: _constants__WEBPACK_IMPORTED_MODULE_0__.RECORDS_ONE_HUNDRED,
                    pageNumber,
                    search: searchQuery !== null && searchQuery !== void 0 ? searchQuery : "",
                    desktopProfileFilter: false
                },
                orgId: ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || ""
            });
        });
    }
    handleLocalSearch() {
        if (this.paginatedManagedQueues.length > 0) {
            this.isPageLoading = true;
            const data = this.paginatedManagedQueues.filter((queue) => queue.queueName.toLowerCase().includes(this.searchQuery.toLowerCase()));
            this.isPageLoading = false;
            this.totalRecords = data.length;
            this.filterManagedQueues = data;
        }
        else {
            this.filterManagedQueues = [];
        }
    }
    getManagedQueuesList(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const { isFirstPageRequest, searchQuery } = event.detail;
            this.isPageLoading = true;
            this.searchQuery = searchQuery;
            const pageNumber = isFirstPageRequest ? 0 : this.currentPage + 1;
            try {
                const response = yield this.fetchManagedQueues(pageNumber, this.searchQuery);
                this.handleLoadPageSuccess(response, isFirstPageRequest);
            }
            catch (error) {
                this.handleLoadPageError(error);
            }
        });
    }
    getSelectedQueueIds() {
        return this.selectedQueueList.length === 0 ? [] : this.selectedQueueList.map((q) => q.queueId);
    }
    getPaginatedQueueList() {
        return this.isFilterApplied() ? this.filterManagedQueues : this.paginatedManagedQueues;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
      <div
        class="filter-container"
        style=${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9__.styleMap)({
            width: `${this.style.width || "250px"}`
        })}
      >
        ${!this.infiniteScrollingEnabled
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
              <md-combobox
                .options=${this.managedQueues}
                option-id="queueId"
                option-value="queueName"
                .value=${this.selectedQueueList}
                use-virtual-scroll
                shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
                ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
                ?is-dropdown-arrow=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
                ?show-filter-icon=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
                ?compact=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
                is-multi
                show-selected-count
                no-clear-icon
                allow-select-all
                placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.selectQueue")}
                all-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.all")}
                selected-all-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.selected")}
                select-all-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.selectAll")}
                @change-selected=${this.changeHandler}
                @combobox-on-expand=${this.fetchQueues}
                show-custom-error=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__.ifDefined)(this.isError ? true : undefined)}
                show-loader=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__.ifDefined)(this.isLoading ? true : undefined)}
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:pageSubHeader.queueName")}
                comboboxId="inp-queueName"
              >
                ${this.isLoading
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                      <div slot="custom-loader" part="custom-loader">
                        <agentx-wc-widget-loader></agentx-wc-widget-loader>
                      </div>
                    `
                : lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing}
                ${this.isError
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                      <div slot="custom-error" part="custom-error">
                        <agentx-wc-widget-error detail="${this.getFetchErrorMessage()}"></agentx-wc-widget-error>
                      </div>
                    `
                : lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing}
              </md-combobox>
            `
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
              <agentx-wc-filter-dropdown
                .data=${this.getPaginatedQueueList()}
                .meta=${{
                totalRecords: this.totalRecords,
                fieldNames: { name: "queueName", id: "queueId" }
            }}
                filterLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.selectQueue")}
                buttonLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:pageSubHeader.queueName")}
                .defaultHeaderLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.selectQueue")}
                .value=${this.getSelectedQueueIds()}
                .selectedItems=${this.selectedQueueList}
                .isPageLoading=${this.isPageLoading}
                .pageFetchError=${this.pageFetchError}
                selectedFilterKey=${this.selectedQueueListKey}
                filterSelectedEventKey=${this.queueFilterSelectedEventKey}
                .groupOnMultiSelect=${true}
                @load-data=${this.getManagedQueuesList}
                overallRecords=${this.totalQueueRecords}
                @search-query-change=${this.handleSearchQueryChange}
              >
              </agentx-wc-filter-dropdown>
            `}
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Array, reflect: true })
], QueueFilter.prototype, "selectedQueueList", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Array, reflect: true })
], QueueFilter.prototype, "managedQueues", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], QueueFilter.prototype, "selectedQueueListKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], QueueFilter.prototype, "queueFilterSelectedEventKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], QueueFilter.prototype, "fetchManagedQueueEventKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Boolean, reflect: true })
], QueueFilter.prototype, "isLoading", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Boolean, reflect: true })
], QueueFilter.prototype, "isError", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], QueueFilter.prototype, "paginatedManagedQueues", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], QueueFilter.prototype, "filterManagedQueues", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], QueueFilter.prototype, "currentPage", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], QueueFilter.prototype, "totalRecords", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], QueueFilter.prototype, "infiniteScrollingEnabled", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], QueueFilter.prototype, "isPageLoading", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], QueueFilter.prototype, "pageFetchError", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], QueueFilter.prototype, "totalQueueRecords", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], QueueFilter.prototype, "searchQuery", void 0);
QueueFilter = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.customElement)("agentx-wc-queue-filter")
], QueueFilter);



/***/ }),

/***/ "./src/components/SupervisorFilters/TeamFilter/TeamFilter.ts":
/*!*******************************************************************!*\
  !*** ./src/components/SupervisorFilters/TeamFilter/TeamFilter.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TeamFilter: () => (/* binding */ TeamFilter)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! lit-html/directives/style-map */ "lit-html/directives/style-map");
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _common_FilterDropdown__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../common/FilterDropdown */ "./src/components/SupervisorFilters/common/FilterDropdown.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./../../../utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./../index.scss */ "./src/components/SupervisorFilters/index.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};













let TeamFilter = class TeamFilter extends _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__.MobxLitElement {
    constructor() {
        super(...arguments);
        this.selectedTeamList = [];
        this.managedTeams = [];
        this.selectedTeamListKey = "selected-team-list";
        this.teamFilterSelectedEventKey = "team-filter-selected";
        this.fetchManagedTeamEventKey = "fetch-managed-team";
        this.isLoading = true;
        this.isError = false;
        this.paginatedManagedTeams = [];
        this.filterManagedTeams = [];
        this.currentPage = 0;
        this.totalRecords = 0;
        this.infiniteScrollingEnabled = false;
        this.isPageLoading = false;
        this.pageFetchError = {
            isError: false,
            trackingId: ""
        };
        this.totalTeamRecords = 0;
        this.searchQuery = "";
        this.languageResources = "/i18n/{{lng}}/{{ns}}.json";
        this.changeHandler = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_11__.debounce)((e) => {
            sessionStorage.setItem(this.selectedTeamListKey, JSON.stringify(e.detail.selected));
            window.dispatchEvent(new CustomEvent(this.teamFilterSelectedEventKey, {
                detail: e.detail.selected,
                bubbles: true,
                composed: true
            }));
        }, _constants__WEBPACK_IMPORTED_MODULE_0__.SELECTED_CHANGE_DELAY);
        this.handleSearchQueryChange = (event) => {
            this.searchQuery = event.detail.searchQuery;
            if (this.searchQuery === "") {
                this.isPageLoading = false;
                this.filterManagedTeams = [];
                this.totalRecords = this.totalTeamRecords;
                return;
            }
            if (this.totalTeamRecords > 0 &&
                (this.totalRecords === this.paginatedManagedTeams.length || this.totalTeamRecords <= 100)) {
                this.handleLocalSearch();
            }
            else {
                this.getTeamList(event);
            }
        };
    }
    static get styles() {
        return _index_scss__WEBPACK_IMPORTED_MODULE_12__["default"];
    }
    connectedCallback() {
        super.connectedCallback();
        this.infiniteScrollingEnabled = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.featureflag.isFeatureFlagEnabled(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.FEATURE_FLAGS.MANAGED_FILTER_INFINITE_SCROLLING);
        this.addEventListener("reload", this.fetchTeams);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener("reload", this.fetchTeams);
    }
    fetchTeams() {
        window.dispatchEvent(new CustomEvent(this.fetchManagedTeamEventKey, {
            detail: "",
            bubbles: true,
            composed: true
        }));
    }
    getFetchErrorMessage() {
        return JSON.stringify({
            header: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorDetail:errorTitle"),
            message: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorModal:trackingIdDescription"),
            trackingId: this.isError
        });
    }
    isFilterApplied() {
        return this.searchQuery && this.searchQuery.length > 0;
    }
    updateTeamData(data) {
        if (this.isFilterApplied()) {
            this.filterManagedTeams = [...this.filterManagedTeams, ...data];
        }
        else {
            this.paginatedManagedTeams = [...this.paginatedManagedTeams, ...data];
        }
    }
    resetTeamData(data) {
        if (this.isFilterApplied()) {
            this.filterManagedTeams = data;
        }
        else {
            this.paginatedManagedTeams = data;
        }
    }
    handleLoadPageSuccess(response, reset) {
        if (reset) {
            this.resetTeamData(response.data);
        }
        else {
            this.updateTeamData(response.data);
        }
        this.currentPage = response.meta.page;
        this.totalRecords = response.meta.totalRecords;
        this.isPageLoading = false;
        if (!this.isFilterApplied()) {
            this.totalTeamRecords = response.meta.totalRecords;
        }
        this.pageFetchError = {
            isError: false,
            trackingId: ""
        };
    }
    handleLoadPageError(error) {
        this.isPageLoading = false;
        this.pageFetchError = {
            isError: true,
            trackingId: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject)(error) : ""
        };
        _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("event=getTeamList | Error on fetching managed teams on ESD Team Filters", error);
    }
    fetchManagedTeams(pageNumber, reset, searchQuery) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const orgId = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId;
            return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.abs.fetchPaginatedTeamsList({
                orgId,
                page: pageNumber,
                pageSize: 100,
                search: searchQuery !== null && searchQuery !== void 0 ? searchQuery : "",
                customFilter: "",
                supervisorView: true
            });
        });
    }
    handleLocalSearch() {
        if (this.paginatedManagedTeams.length > 0) {
            this.isPageLoading = true;
            const data = this.paginatedManagedTeams.filter((team) => team.teamName.toLowerCase().includes(this.searchQuery.toLowerCase()));
            this.isPageLoading = false;
            this.totalRecords = data.length;
            this.filterManagedTeams = data;
        }
        else {
            this.filterManagedTeams = [];
        }
    }
    getTeamList(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const { isFirstPageRequest, searchQuery } = event.detail;
            this.isPageLoading = true;
            this.searchQuery = searchQuery;
            const pageNumber = isFirstPageRequest ? 0 : this.currentPage + 1;
            try {
                const response = yield this.fetchManagedTeams(pageNumber, isFirstPageRequest, this.searchQuery);
                this.handleLoadPageSuccess(response, isFirstPageRequest);
            }
            catch (error) {
                this.handleLoadPageError(error);
            }
        });
    }
    getSelectedTeamList() {
        return this.selectedTeamList.map((team) => team.teamId) || [];
    }
    getPaginatedTeamList() {
        if (this.isFilterApplied()) {
            return this.filterManagedTeams;
        }
        return this.paginatedManagedTeams;
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
      <div
        class="filter-container"
        style=${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_9__.styleMap)({
            width: `${this.style.width || "250px"}`
        })}
      >
        ${!this.infiniteScrollingEnabled
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) ` <md-combobox
              .options=${this.managedTeams}
              option-id="teamId"
              option-value="teamName"
              .value=${this.selectedTeamList}
              use-virtual-scroll
              shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
              ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
              ?is-dropdown-arrow=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
              ?show-filter-icon=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
              ?compact=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
              is-multi
              show-selected-count
              no-clear-icon
              allow-select-all
              placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.selectTeam")}
              all-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.all")}
              selected-all-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.selected")}
              select-all-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.selectAll")}
              @change-selected=${this.changeHandler}
              @combobox-on-expand=${this.fetchTeams}
              show-custom-error=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__.ifDefined)(this.isError ? true : undefined)}
              show-loader=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_8__.ifDefined)(this.isLoading ? true : undefined)}
              ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:pageSubHeader.managedTeams")}
              comboboxId="inp-managedTeams"
            >
              ${this.isLoading
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                    <div slot="custom-loader" part="custom-loader">
                      <agentx-wc-widget-loader></agentx-wc-widget-loader>
                    </div>
                  `
                : lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing}
              ${this.isError
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                    <div slot="custom-error" part="custom-error">
                      <agentx-wc-widget-error .detail="${this.getFetchErrorMessage()}"></agentx-wc-widget-error>
                    </div>
                  `
                : lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing}
            </md-combobox>`
            : (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) ` <agentx-wc-filter-dropdown
              .data=${this.getPaginatedTeamList()}
              .meta=${{
                totalRecords: this.totalRecords,
                fieldNames: { name: "teamName", id: "teamId" }
            }}
              filterLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.selectTeam")}
              buttonLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:pageSubHeader.managedTeams")}
              .defaultHeaderLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.selectTeam")}
              .value=${this.getSelectedTeamList()}
              .selectedItems=${this.selectedTeamList}
              .isPageLoading=${this.isPageLoading}
              .pageFetchError=${this.pageFetchError}
              selectedFilterKey=${this.selectedTeamListKey}
              filterSelectedEventKey=${this.teamFilterSelectedEventKey}
              .groupOnMultiSelect=${true}
              @load-data=${this.getTeamList}
              overAllRecords=${this.totalTeamRecords}
              @search-query-change=${this.handleSearchQueryChange}
            ></agentx-wc-filter-dropdown>`}
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Array, reflect: true })
], TeamFilter.prototype, "selectedTeamList", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Array, reflect: true })
], TeamFilter.prototype, "managedTeams", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], TeamFilter.prototype, "selectedTeamListKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], TeamFilter.prototype, "teamFilterSelectedEventKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], TeamFilter.prototype, "fetchManagedTeamEventKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Boolean, reflect: true })
], TeamFilter.prototype, "isLoading", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Boolean, reflect: true })
], TeamFilter.prototype, "isError", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], TeamFilter.prototype, "paginatedManagedTeams", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], TeamFilter.prototype, "filterManagedTeams", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], TeamFilter.prototype, "currentPage", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], TeamFilter.prototype, "totalRecords", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], TeamFilter.prototype, "infiniteScrollingEnabled", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], TeamFilter.prototype, "isPageLoading", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], TeamFilter.prototype, "pageFetchError", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], TeamFilter.prototype, "totalTeamRecords", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], TeamFilter.prototype, "searchQuery", void 0);
TeamFilter = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.customElement)("agentx-wc-team-filter")
], TeamFilter);



/***/ }),

/***/ "./src/components/SupervisorFilters/common/FilterDropdown.ts":
/*!*******************************************************************!*\
  !*** ./src/components/SupervisorFilters/common/FilterDropdown.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FilterDropdown: () => (/* binding */ FilterDropdown)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lit-html/directives/style-map */ "lit-html/directives/style-map");
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Common_SearchInput_searchInput__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../Common/SearchInput/searchInput */ "./src/components/Common/SearchInput/searchInput.ts");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./index.scss */ "./src/components/SupervisorFilters/common/index.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};











let FilterDropdown = class FilterDropdown extends _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_3__.MobxLitElement {
    constructor() {
        super(...arguments);
        this.languageResources = "/i18n/{{lng}}/{{ns}}.json";
        this.data = [];
        this.meta = {
            totalRecords: 0,
            fieldNames: {
                id: "id",
                name: "name"
            }
        };
        this.filterLabel = "";
        this.buttonLabel = "";
        this.value = [];
        this.selectedItems = [];
        this.selectedFilterKey = "";
        this.filterSelectedEventKey = "";
        this.isPageLoading = false;
        this.pageFetchError = {
            isError: false,
            trackingId: ""
        };
        this.defaultHeaderLabel = "";
        this.groupOnMultiSelect = true;
        this.overAllRecords = 0;
        this.items = [];
        this.lastSelectedIdByOrder = "";
        this.selectAllItems = false;
        this.arrowIcon = "arrow-down-bold";
        this.isMenuOverlayOpen = false;
        this.dropDownHeaderLabel = "";
        this.lastSelectedItems = [];
        this.isDataTemplateGenerating = false;
        this.searchQuery = "";
        this.isSearchQueryTooShort = false;
        this.setSearchQueryInInput = true;
        this.disableReset = false;
        this.changeHandler = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.debounce)((e) => {
            const selectedItems = this.updateSelectedItem(e.detail.selected);
            this.disableReset = selectedItems.length === 0;
            this.value = e.detail.selected;
            this.updateSelectAllState();
            this.updateCachedForSelectedValue(selectedItems);
            this.dropDownHeaderLabel = this.getDropdownHeader();
        }, _constants__WEBPACK_IMPORTED_MODULE_0__.SELECTED_CHANGE_DELAY);
        this.loadNextPage = (event, isFirstPageRequest = false) => {
            this.isDataTemplateGenerating = true;
            this.dispatchEvent(new CustomEvent("load-data", {
                detail: {
                    isFirstPageRequest,
                    searchQuery: this.searchQuery
                }
            }));
        };
        this.loadNextPageOnScroll = () => {
            if (this.isMenuOverlayOpen && this.data.length > 0) {
                this.loadNextPage(undefined, false);
            }
        };
    }
    static get styles() {
        return _index_scss__WEBPACK_IMPORTED_MODULE_10__["default"];
    }
    connectedCallback() {
        var _a;
        super.connectedCallback();
        this.dropDownHeaderLabel = this.getDropdownHeader();
        if ((_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) {
            this.loadNextPage(undefined, true);
        }
        this.disableReset = this.value.length === 0;
    }
    updated(_changedProperties) {
        if (_changedProperties.has("data")) {
            if (this.isMenuOverlayOpen) {
                this.items = this.generateAdvanceListTemplate();
                this.isDataTemplateGenerating = false;
            }
            this.dropDownHeaderLabel = this.getDropdownHeader();
        }
        if (_changedProperties.has("pageFetchError") && this.pageFetchError.isError) {
            this.isDataTemplateGenerating = false;
        }
        if ((_changedProperties.has("value") || _changedProperties.has("items")) && this.items.length !== 0) {
            this.updateSelectAllState();
        }
    }
    updateSelectAllState() {
        const allItemsIds = new Set(this.items.map((obj) => obj.id));
        this.selectAllItems = this.value.length === this.items.length && this.value.every((id) => allItemsIds.has(id));
    }
    naturalSort(a, b) {
        return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
    }
    getSortedItems(items) {
        return [...items].sort((a, b) => this.naturalSort(a[this.meta.fieldNames.name], b[this.meta.fieldNames.name]));
    }
    sortSelectedItems() {
        const sortedItems = this.getSortedItems(this.lastSelectedItems);
        this.findLastSelectedIdByOrder(sortedItems);
        return sortedItems;
    }
    removeUnSelectedItems(sortedItems, sortedSelectedItems) {
        return sortedItems.filter((item) => !sortedSelectedItems.some((selectedItem) => selectedItem[this.meta.fieldNames.id] === item[this.meta.fieldNames.id]));
    }
    findLastSelectedIdByOrder(sortedSelectedItems) {
        this.lastSelectedIdByOrder =
            sortedSelectedItems.length > 0
                ? sortedSelectedItems[sortedSelectedItems.length - 1][this.meta.fieldNames.id]
                : "";
    }
    sortAndMergeData() {
        var _a;
        if (((_a = this.searchQuery) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return this.data;
        }
        const sortedSelectedItems = this.sortSelectedItems();
        return [...sortedSelectedItems, ...this.removeUnSelectedItems(this.data, sortedSelectedItems)];
    }
    generateAdvanceListTemplate() {
        const items = [];
        if (this.data.length > 0) {
            this.sortAndMergeData().forEach((channel) => {
                const id = `${channel[this.meta.fieldNames.id]}`;
                items.push({
                    name: channel[this.meta.fieldNames.name],
                    id,
                    index: items.length,
                    ariaLabel: channel.name,
                    template: (data, index) => (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `<div class="common-filter-item" indexing="${index}">
              <md-checkbox>${data.name}</md-checkbox>
            </div>`
                });
            });
        }
        return items;
    }
    getDropdownHeader() {
        const { length } = this.value;
        const ALL_LABEL = `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.all")}`;
        if (length === this.overAllRecords) {
            return `${ALL_LABEL} (${this.overAllRecords})`;
        }
        if (length > 0) {
            return `${length} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.selected")}`;
        }
        if (this.overAllRecords > 0) {
            return `${ALL_LABEL} (${this.overAllRecords})`;
        }
        return `${ALL_LABEL}`;
    }
    updateSelectedItem(newUpdatedItems) {
        const selectedItems = [];
        newUpdatedItems.forEach((id) => {
            const item = this.lastSelectedItems.find((option) => option[this.meta.fieldNames.id] === id) ||
                this.data.find((option) => option[this.meta.fieldNames.id] === id);
            if (item) {
                selectedItems.push({
                    [this.meta.fieldNames.id]: item[this.meta.fieldNames.id],
                    [this.meta.fieldNames.name]: item[this.meta.fieldNames.name]
                });
            }
        });
        return selectedItems;
    }
    updateCachedForSelectedValue(value) {
        sessionStorage.setItem(this.selectedFilterKey, JSON.stringify(value));
        window.dispatchEvent(new CustomEvent(this.filterSelectedEventKey, {
            detail: value,
            bubbles: true,
            composed: true
        }));
    }
    resetSelectionFilters() {
        this.selectAllItems = false;
        this.value = [];
        this.disableReset = true;
        this.updateCachedForSelectedValue([]);
        this.dropDownHeaderLabel = this.getDropdownHeader();
    }
    resetFilter() {
        this.resetSelectionFilters();
        this.searchQuery = "";
        this.setSearchQueryInInput = false;
        this.isSearchQueryTooShort = false;
        this.handleSearch(true);
    }
    updateSelectAllCheckboxOnClick() {
        if (this.selectAllItems) {
            this.resetSelectionFilters();
        }
        else {
            this.selectAllItems = true;
        }
    }
    handleSearch(isFirstPageRequest = false) {
        if (this.searchQuery.length > 0) {
            this.isDataTemplateGenerating = true;
        }
        this.dispatchEvent(new CustomEvent("search-query-change", {
            detail: {
                isFirstPageRequest,
                searchQuery: this.searchQuery
            }
        }));
    }
    getDynamicHeight(itemsLength) {
        const minHeight = Math.max(itemsLength * 36.86, 0);
        return `${Math.min(minHeight, 260)}px`;
    }
    handleSearchCleared(e) {
        this.searchQuery = e.detail;
        this.isSearchQueryTooShort = false;
        this.lastSelectedItems = this.selectedItems;
        this.handleSearch(true);
    }
    handleSearchTooShort(e) {
        this.searchQuery = e.detail;
        this.setSearchQueryInInput = true;
        this.isSearchQueryTooShort = true;
    }
    handleSearchTermValid(e) {
        this.searchQuery = e.detail;
        this.setSearchQueryInInput = true;
        this.isSearchQueryTooShort = false;
        this.lastSelectedItems = this.selectedItems;
        this.handleSearch(true);
    }
    handleOverlayClose() {
        this.arrowIcon = "arrow-down-bold";
        this.isMenuOverlayOpen = false;
        this.selectAllItems = false;
        this.items = [];
        this.searchQuery = "";
        this.isSearchQueryTooShort = false;
        this.handleSearch(true);
    }
    handleOverlayOpen() {
        this.arrowIcon = "arrow-up-bold";
        this.isDataTemplateGenerating = true;
        this.isMenuOverlayOpen = true;
        this.lastSelectedItems = this.selectedItems;
        setTimeout(() => {
            this.items = this.generateAdvanceListTemplate();
            this.isDataTemplateGenerating = false;
            document.dispatchEvent(new CustomEvent("on-widget-update"));
        }, 0);
    }
    getLastSelectedItemIdByOrder() {
        return this.searchQuery && this.searchQuery.length > 0 ? "" : this.lastSelectedIdByOrder;
    }
    getFilterIcon() {
        return _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `<md-icon name="filter-bold" class="filter-icon" size="16" iconSet="momentumDesign"></md-icon>`
            : "";
    }
    renderState() {
        var _a;
        if (this.data.length === 0) {
            if (this.isPageLoading) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
          <div class="state-loading">
            <md-spinner size="24"></md-spinner>
          </div>
        `;
            }
            if (this.pageFetchError.isError) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
          <div class="state-error">
            <agentx-wc-empty-state-wrapper
              class="error-cloud-wrapper"
              illustration-type="error-cloud"
            ></agentx-wc-empty-state-wrapper>
            <div class="error-container">
              <p class="error-title">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorDetail:errorTitle")}</p>
            </div>
            <md-button @click=${() => this.loadNextPage(undefined, true)} id="reload-btn" color="blue">
              <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorDetail:reloadButton")}</span>
            </md-button>
          </div>
        `;
            }
            if (!this.isPageLoading && !this.pageFetchError.isError && ((_a = this.searchQuery) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
          <div class="state-no-match">
            <agentx-wc-empty-state-wrapper
              class="empty-state-wrapper"
              illustration-type="empty-result"
            ></agentx-wc-empty-state-wrapper>
            <span class="empty-title">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.nomatchfound")}</span>
          </div>
        `;
            }
        }
        else if (this.isSearchQueryTooShort) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
        <div class="search-block-error">
          <div class="search-error">
            <md-icon name="info-badge-filled" iconSet="momentumDesign" size="16" class="search-error-info"></md-icon>
            ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.searchError")}
          </div>
        </div>
      `;
        }
        return lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing;
    }
    renderSelectAllCheckbox() {
        if (this.overAllRecords <= 100 && this.data.length > 0 && !this.isSearchQueryTooShort) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
        <div class="common-filter-select-all">
          <md-checkbox
            id="select-all"
            @checkbox-change=${this.updateSelectAllCheckboxOnClick}
            .checked=${this.selectAllItems}
            >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.selectAll")}</md-checkbox
          >
        </div>
      `;
        }
        return lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing;
    }
    getStatusIndicator() {
        if (this.isDataTemplateGenerating && this.items.length > 0) {
            return [
                {
                    id: "status-indicator",
                    name: "loading",
                    template: () => (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `<div class="infinite-scroll-spinner" part="spinner"><md-spinner size="18"></md-spinner></div>`
                }
            ];
        }
        if (this.pageFetchError.isError && this.items.length > 0) {
            return [
                {
                    id: "status-indicator",
                    name: "error",
                    template: () => (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `<agent-state-selector-list-error
              class="fetch-error"
              style="color: red;"
              trackingId="${this.pageFetchError.trackingId}"
              @error-retry="${this.loadNextPage}"
            >
            </agent-state-selector-list-error>`
                }
            ];
        }
        return [];
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
      <div
        class="common-filter"
        style=${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_8__.styleMap)({
            width: `${this.style.width || "250px"}`
        })}
      >
        <md-menu-overlay
          class="common-filter-dropdown"
          size="small"
          @menu-overlay-open=${this.handleOverlayOpen}
          @menu-overlay-close=${this.handleOverlayClose}
        >
          <md-button
            variant="dropdown"
            is-placeholder-text
            slot="menu-trigger"
            width="250px"
            ariaHasPopup="listbox"
            ariaExpanded=${this.isMenuOverlayOpen}
            ariaLabel=${`${this.buttonLabel} ${this.dropDownHeaderLabel}`}
            .rounded=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
          >
            <div class="common-filter-dropdown-button">
              <span class="common-filter-icon-text"> ${this.getFilterIcon()} ${this.dropDownHeaderLabel} </span>
              <md-icon slot="input-section-right" name=${this.arrowIcon} iconset="momentumDesign"></md-icon>
            </div>
          </md-button>

          <search-input
            class="search-wrapper"
            .isPageLoading=${this.isPageLoading}
            .reset=${this.setSearchQueryInInput && this.isMenuOverlayOpen}
            @search-cleared="${this.handleSearchCleared}"
            @search-too-short="${this.handleSearchTooShort}"
            @search-term-valid="${this.handleSearchTermValid}"
          >
          </search-input>

          <div class="common-filter-advance-list-container">
            ${this.renderSelectAllCheckbox()} ${this.renderState()}
            ${this.isMenuOverlayOpen && !this.isSearchQueryTooShort
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.html) `
                  <md-advance-list
                    .items=${this.items.concat(this.getStatusIndicator())}
                    .value=${[...this.value]}
                    ariaRoleList="listbox"
                    containerHeight=${this.getDynamicHeight(this.items.length)}
                    ariaLabelList=${this.filterLabel}
                    totalRecords=${this.meta.totalRecords}
                    .lastSelectedIdByOrder=${this.getLastSelectedItemIdByOrder()}
                    is-multi
                    .groupOnMultiSelect=${this.groupOnMultiSelect}
                    .selectAllItems=${this.selectAllItems}
                    .isLoading=${this.isDataTemplateGenerating}
                    .isError=${this.pageFetchError.isError}
                    @list-item-change=${this.changeHandler}
                    @load-more=${this.loadNextPageOnScroll}
                  >
                  </md-advance-list>
                `
            : lit_html__WEBPACK_IMPORTED_MODULE_7__.nothing}
            <div class="common-filter-item-reset">
              <md-button ?disabled=${this.disableReset} @button-click=${this.resetFilter} size="36"
                >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:supervisorProfile.resetFilter")}</md-button
              >
            </div>
          </div>
        </md-menu-overlay>
      </div>
    `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Array })
], FilterDropdown.prototype, "data", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Object })
], FilterDropdown.prototype, "meta", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], FilterDropdown.prototype, "filterLabel", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], FilterDropdown.prototype, "buttonLabel", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Array })
], FilterDropdown.prototype, "value", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Array })
], FilterDropdown.prototype, "selectedItems", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], FilterDropdown.prototype, "selectedFilterKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], FilterDropdown.prototype, "filterSelectedEventKey", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Boolean })
], FilterDropdown.prototype, "isPageLoading", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Object })
], FilterDropdown.prototype, "pageFetchError", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: String })
], FilterDropdown.prototype, "defaultHeaderLabel", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Boolean })
], FilterDropdown.prototype, "groupOnMultiSelect", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.property)({ type: Number })
], FilterDropdown.prototype, "overAllRecords", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "items", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "lastSelectedIdByOrder", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "selectAllItems", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "arrowIcon", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "isMenuOverlayOpen", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "dropDownHeaderLabel", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "lastSelectedItems", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "isDataTemplateGenerating", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "searchQuery", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "isSearchQueryTooShort", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "setSearchQueryInInput", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.internalProperty)()
], FilterDropdown.prototype, "disableReset", void 0);
FilterDropdown = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_6__.customElement)("agentx-wc-filter-dropdown")
], FilterDropdown);



/***/ }),

/***/ "./src/components/SupervisorFilters/common/index.scss":
/*!************************************************************!*\
  !*** ./src/components/SupervisorFilters/common/index.scss ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --filter-min-width: 150px;
  --column-gap: 6px;
  --filter-min-height: 260px;
}

.common-filter {
  min-width: var(--filter-min-width);
}
.common-filter md-advance-list::part(advance-list-item-wrapper) {
  padding: 9px 12px;
  overflow: hidden;
}
.common-filter md-advance-list::part(spinner) {
  display: flex;
  justify-content: center;
}
.common-filter .common-filter-advance-list-container {
  width: 100%;
  overflow: hidden;
}
.common-filter .common-filter-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.common-filter .common-filter-select-all {
  padding: 6px 0 7px 14px;
  border-bottom: var(--line-separator);
}
.common-filter .common-filter-item-reset {
  border-top: var(--line-separator);
  padding: 8px 0 8px 20px;
}
.common-filter .common-filter-dropdown-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.common-filter .common-filter-icon-text {
  display: flex;
  column-gap: var(--column-gap);
}
.common-filter .common-filter-dropdown::part(overlay-content) {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.common-filter .search-wrapper {
  padding: 13px 16px 0px 16px;
  border-bottom: var(--line-separator);
}
.common-filter .state-loading {
  height: var(--filter-min-height);
  display: flex;
  align-items: center;
  justify-content: center;
}
.common-filter .state-error {
  padding: 30px 0 16px 0;
  display: grid;
}
.common-filter .state-error .error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.common-filter .state-error .error-title {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  font-weight: 600;
  text-align: center;
  padding: 0;
  color: var(--list-text-color, #121212);
}
.common-filter .state-error .error-subtitle {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  text-align: center;
  padding: 0;
}
.common-filter .state-error .error-cloud-wrapper {
  height: auto;
}
.common-filter .state-error .error-cloud-wrapper::part(container) {
  background-color: var(--md-secondary-white-bg-color);
}
.common-filter .state-error .error-cloud-wrapper::part(img) {
  display: block;
  margin: auto;
  width: auto;
}
.common-filter .state-error md-button {
  margin: 24px auto auto auto;
}
.common-filter .state-no-match {
  height: calc(var(--filter-min-height) - 48);
  padding: calc(var(--space-token-even) * 12) calc(var(--space-token-even) * 12);
  position: relative;
  text-align: center;
}
.common-filter .state-no-match .empty-title {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  color: var(--list-text-color, #121212);
}
.common-filter .state-no-match .empty-state-wrapper::part(container) {
  background-color: var(--md-secondary-white-bg-color);
}
.common-filter .state-no-match .empty-state-wrapper::part(img) {
  display: block;
  margin: auto;
  width: auto;
}

.search-block-error {
  display: flex;
  align-items: center;
  padding: 16px;
  min-height: 216px;
}

.search-error {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  font-size: var(--font-size-small);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/SupervisorFilters/common/index.scss */
/*# sourceURL=index.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/SupervisorFilters/index.scss":
/*!*****************************************************!*\
  !*** ./src/components/SupervisorFilters/index.scss ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --filter-min-width: 150px;
  --filter-count-width: 100px;
  --line-separator: 1px solid var(--md-gray-20, #dedede);
  --column-gap: 6px;
}

.filter-container {
  min-width: var(--filter-min-width);
}
.filter-container md-combobox::part(multiwrap-input) {
  width: calc(100% - var(--filter-count-width));
}
.filter-container md-combobox::part(custom-error),
.filter-container md-combobox::part(custom-loader) {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--md-primary-bg-color);
  padding: 30px 0px;
  min-height: 300px;
}
.filter-container md-advance-list::part(advance-list-item-wrapper) {
  padding: 9px 12px;
  overflow: hidden;
}
.filter-container md-advance-list::part(spinner) {
  display: flex;
  justify-content: center;
}
.filter-container .channel-filter-advance-list-container {
  width: 100%;
  overflow: hidden;
}
.filter-container .channel-filter-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.filter-container .channel-filter-select-all {
  padding: 6px 0 7px 14px;
  border-bottom: var(--line-separator);
}
.filter-container .channel-filter-item-reset {
  border-top: var(--line-separator);
  padding: 8px 0 8px 20px;
}
.filter-container .channel-filter-dropdown-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.filter-container .channel-filter-icon-text {
  display: flex;
  column-gap: var(--column-gap);
}
.filter-container .queue-filter-advance-list-container {
  width: 100%;
  overflow: hidden;
  padding-top: 10px;
}
.filter-container .queue-filter-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.filter-container .queue-filter-select-all {
  padding: 0 0 7px 14px;
  border-bottom: var(--line-separator);
}
.filter-container .queue-filter-item-reset {
  border-top: var(--line-separator);
  padding: 6px 0 6px 10px;
}
.filter-container .queue-filter-dropdown-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.filter-container .queue-filter-icon-text {
  display: flex;
  column-gap: var(--column-gap);
}
.filter-container .managed-queues-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--md-primary-bg-color);
  padding: 68px 0px;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/SupervisorFilters/index.scss */
/*# sourceURL=index.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TaskList/TaskList.scss":
/*!***********************************************!*\
  !*** ./src/components/TaskList/TaskList.scss ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  --border-color: rgba(0, 0, 0, 0.12);
  background-color: var(--md-task-list-bg-color, #f7f7f7);
  border-right: 1px solid var(--border-color);
  display: flex;
  height: 100%;
  width: clamp(rem-calc(270), 25%, rem-calc(570));
  overflow: auto;
  padding: var(--space-token-even);
}

.ax-activity-list-wrapper {
  animation: fadeIn 300ms 1 250ms forwards;
  opacity: 0;
  width: calc(100% - 3px * 2);
  margin-left: 3px;
  margin-right: 3px;
}

.ax-activity-list-item {
  box-sizing: border-box;
  margin-bottom: calc(var(--space-token-even) * 2);
  width: 100%;
}

.ax-activity-list-item::part(list-item) {
  background-color: transparent;
  padding: calc(var(--space-token-even) / 2);
  border-radius: 0.5rem;
}

.ax-activity-list-item::part(list-item):focus {
  background-color: transparent;
}

.ax-activity-list-item::part(list-item):hover {
  background-color: transparent;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
}
.empty-state uuip-wc-empty-state::part(container) {
  background-color: var(--md-task-list-bg-color);
}
.empty-state uuip-wc-empty-state::part(img) {
  width: 84px;
  height: 84px;
}
.empty-state .empty-text {
  color: var(--md-primary-text-color);
}

.empty-state::before {
  content: "";
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=TaskList.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/TaskList/TaskList.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TaskList/TaskList.ts":
/*!*********************************************!*\
  !*** ./src/components/TaskList/TaskList.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TaskList: () => (/* binding */ TaskList)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./../../constants */ "./src/constants.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./../../utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _TaskList_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./TaskList.scss */ "./src/components/TaskList/TaskList.scss");
/* harmony import */ var _comp_TaskListItem__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./comp/TaskListItem */ "./src/components/TaskList/comp/TaskListItem.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */











var TaskList;
(function (TaskList) {
    /**
     * @element agentx-wc-task-list
     * @fires task-selected
     * @fires task-removed
     * @fires handle-new-replies
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_5__.LitElement) {
        constructor() {
            super(...arguments);
            this.selectedId = null;
            this.agentId = "";
            this.taskList = [];
            this.unreadMessages = {};
            this.hasOfferContact = false;
            this.isInteractionModelOpen = false;
            this.clickEvent = false;
            this.newUnreadTaskMessage = {};
            this.isDarkMode = false;
            this.isProgressiveCampaignEnabled = false;
            this.isProgressiveCampaign1NEnabled = false;
            this.monitoringOwnerName = "";
            this.timerAriaLabel = "";
            this.newReplyList = new Map();
            this.handleNewReplies = "handle-new-replies";
            this.checkVisibilityScroll = () => {
                Array.from(this.newReplyList.keys()).forEach((key) => {
                    this.updateNewReplyList(key);
                });
                const isShowUp = !!this.newReplyList.size && [...this.newReplyList][0][1].value === "top";
                this.dispatchEvent(new CustomEvent(this.handleNewReplies, {
                    bubbles: true,
                    cancelable: false,
                    detail: { show: !!this.newReplyList.size, isShowUp }
                }));
            };
            this.onScrollHadler = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_8__.debounce)(this.checkVisibilityScroll, 300);
        }
        connectedCallback() {
            super.connectedCallback();
            this.handleShortcutKeyEvent();
            if (this.parentElement) {
                if (window.ResizeObserver) {
                    this.resizerObserver = new window.ResizeObserver(this.onScrollHadler);
                    this.resizerObserver.observe(this.parentElement);
                }
                this.parentElement.addEventListener("scroll", this.onScrollHadler);
            }
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.stopListen();
            if (this.parentElement && window.ResizeObserver && this.resizerObserver) {
                this.resizerObserver.unobserve(this.parentElement);
                this.parentElement.removeEventListener("scroll", this.onScrollHadler);
            }
        }
        handleShortcutKeyEvent() {
            const { stopListen } = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.event.listenKeyPress((event) => {
                const { data } = event;
                if (data &&
                    data.key === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.REGISTERED_KEYS.SWITCH_TASK_KEY &&
                    data.modifierKeys === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.MODIFIERS.CTRL_SHIFT) {
                    this.switchTask();
                }
            });
            this.stopListen = stopListen;
        }
        update(changedProperties) {
            var _a;
            super.update(changedProperties);
            if (changedProperties.has("clickEvent")) {
                this.highlightNewReplies();
            }
            if (changedProperties.has("newUnreadTaskMessage") &&
                ((_a = this.newUnreadTaskMessage) === null || _a === void 0 ? void 0 : _a.interactionId) &&
                !this.newReplyList.has(this.newUnreadTaskMessage.interactionId)) {
                this.updateNewReplyList(this.newUnreadTaskMessage.interactionId);
                const isShowUp = !!this.newReplyList.size && [...this.newReplyList][0][1].value === "top";
                this.dispatchEvent(new CustomEvent(this.handleNewReplies, {
                    bubbles: true,
                    cancelable: false,
                    detail: { show: !!this.newReplyList.size, isShowUp }
                }));
            }
        }
        highlightNewReplies() {
            if (this.taskListElement) {
                const element = this.taskListElement.querySelector(`#task-${[...this.newReplyList.keys()][0]}`);
                if (element) {
                    element.focus();
                }
            }
            const index = [...this.newReplyList.keys()];
            this.newReplyList.delete(index[0]);
            const isShowUp = !!this.newReplyList.size && [...this.newReplyList][0][1].value === "top";
            this.dispatchEvent(new CustomEvent(this.handleNewReplies, {
                bubbles: true,
                cancelable: false,
                detail: { show: !!this.newReplyList.size, isShowUp }
            }));
        }
        updateNewReplyList(key) {
            var _a;
            const element = (_a = this.taskListElement) === null || _a === void 0 ? void 0 : _a.querySelector(`#task-${key}`);
            if (element && this.parentElement) {
                const { isVisible, arrowDir } = Object.assign({}, (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_8__.isTaskItemCardVisible)(element, this.parentElement));
                if (!isVisible) {
                    this.newReplyList.set(key, { value: arrowDir });
                }
                else {
                    this.newReplyList.delete(key);
                }
            }
        }
        updated(changedProperties) {
            super.updated(changedProperties);
        }
        switchTask() {
            if (this.taskList.length > 0) {
                const index = this.taskList.findIndex((task) => task.interactionId === this.selectedId);
                if (index < 0 || index === this.taskList.length - 1) {
                    this.selectedTask(this.taskList[0].interactionId);
                }
                else {
                    this.selectedTask(this.taskList[index + 1].interactionId);
                }
            }
        }
        handleTaskItemKeyDown(event, taskId) {
            if (event.code === _constants__WEBPACK_IMPORTED_MODULE_7__.Key.Enter || event.code === _constants__WEBPACK_IMPORTED_MODULE_7__.Key.Space) {
                this.selectedTask(taskId);
            }
        }
        selectedTask(taskId) {
            if (this.isInteractionModelOpen) {
                return;
            }
            this.evt("task-selected", { taskId });
        }
        // ROST: create decorator fot custom event
        evt(name, detail) {
            this.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true, detail }));
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[TaskList] Dispatching event", name, detail);
        }
        get selectedListItem() {
            return this.taskList.findIndex((task) => task.interactionId === this.selectedId);
        }
        static get styles() {
            return _TaskList_scss__WEBPACK_IMPORTED_MODULE_9__["default"];
        }
        renderEmptyImage() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="empty-state">
          <uuip-wc-empty-state
            illustration-src="    /images/illustrations/horns-success-192.svg  "
            illustration-alt="empty-state"
          >
            <p class="empty-text" role="tooltip" aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:taskBar.emptyStateMessage")} tabindex="0">
              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:taskBar.emptyStateMessageNew")}
            </p>
          </uuip-wc-empty-state>
        </div>
      `;
        }
        render() {
            return this.taskList.length > 0
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
            <md-list
              label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:taskBar.taskList", "Agent Task List with {{count}} tasks", {
                    count: this.taskList.length
                })}"
              class="ax-activity-list-wrapper"
              .activated=${this.selectedListItem}
              role="listbox"
            >
              ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_6__.repeat)(this.taskList, (task) => {
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                  <md-list-item
                    slot="list-item"
                    id="task-${task.interactionId}"
                    @click=${() => this.selectedTask(task.interactionId)}
                    @keydown=${(event) => this.handleTaskItemKeyDown(event, task.interactionId)}
                    class="ax-activity-list-item"
                    role="option"
                    @focus=${() => {
                        this.timerAriaLabel = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_8__.updateTimerAriaLabel)(task.timeStamp);
                    }}
                  >
                    <agentx-wc-task-list-item
                      .task=${task}
                      .isProgressiveCampaignEnabled=${this.isProgressiveCampaignEnabled}
                      .isProgressiveCampaign1NEnabled=${this.isProgressiveCampaign1NEnabled}
                      ?selected=${task.interactionId === this.selectedId}
                      .unreadMessage="${this.unreadMessages[task.interactionId]
                        ? this.unreadMessages[task.interactionId]
                        : {}}"
                      .isInteractionModelOpen=${this.isInteractionModelOpen}
                      .isDarkMode=${this.isDarkMode}
                      .monitoringOwnerName=${this.monitoringOwnerName}
                      .timerAriaLabel=${this.timerAriaLabel}
                    ></agentx-wc-task-list-item>
                  </md-list-item>
                `;
                })}
            </md-list>
          `
                : !this.hasOfferContact
                    ? this.renderEmptyImage()
                    : null;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "selectedId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "agentId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
    ], Element.prototype, "taskList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
    ], Element.prototype, "unreadMessages", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "hasOfferContact", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isInteractionModelOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "clickEvent", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
    ], Element.prototype, "newUnreadTaskMessage", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDarkMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isProgressiveCampaignEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isProgressiveCampaign1NEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "monitoringOwnerName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "timerAriaLabel", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)(".ax-activity-list-wrapper")
    ], Element.prototype, "taskListElement", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-task-list")
    ], Element);
    TaskList.Element = Element;
})(TaskList || (TaskList = {}));


/***/ }),

/***/ "./src/components/TaskList/comp/TaskListItem.scss":
/*!********************************************************!*\
  !*** ./src/components/TaskList/comp/TaskListItem.scss ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --border-color: rgba(0, 0, 0, 0.12);
  --background-color: #b8f2ff;
  align-items: center;
  display: flex;
  font: inherit;
  max-height: 100%;
  width: 100%;
}

.ax-list-item {
  box-sizing: border-box;
  width: 100%;
  outline-offset: -3px;
}

.not-allowed-cursor,
.not-allowed-cursor::part(task-item-container) {
  cursor: not-allowed !important;
}

.channel-icon {
  position: relative;
  top: 0.1rem;
}

.ax-list-item::part(task-item-container) {
  margin: 2px;
}
.ax-list-item::part(task-item-container):focus {
  outline: none;
}
.ax-list-item::part(task-item-container):focus::after {
  box-shadow: none;
}

agentx-wc-task-list-timer {
  margin-bottom: 8.5px;
}

@media (forced-colors: active) {
  :host {
    --border-color: CanvasText !important;
    --background-color: Canvas !important;
  }
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/TaskList/comp/TaskListItem.scss */
/*# sourceURL=TaskListItem.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TaskList/comp/TaskListItem.ts":
/*!******************************************************!*\
  !*** ./src/components/TaskList/comp/TaskListItem.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TaskListItem: () => (/* binding */ TaskListItem)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _TaskListItem_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./TaskListItem.scss */ "./src/components/TaskList/comp/TaskListItem.scss");
/* harmony import */ var _TaskTimer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./TaskTimer */ "./src/components/TaskList/comp/TaskTimer.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};










let TaskListItem = class TaskListItem extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_4__.LitElement) {
    constructor() {
        super(...arguments);
        this.selected = false;
        this.unreadMessage = {};
        this.isInteractionModelOpen = false;
        this.isDarkMode = false;
        this.isProgressiveCampaignEnabled = false;
        this.isProgressiveCampaign1NEnabled = false;
        this.monitoringOwnerName = "";
        this.timerAriaLabel = "";
    }
    static get styles() {
        return _TaskListItem_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
    }
    static get meetingAlertCss() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.css) `
      :host .md-alert.md-alert--meeting {
        background-color: transparent;
        box-shadow: none;
        margin: 0;
        width: 100%;
        border-radius: 0;
        border: none;
      }
      :host .md-alert.md-alert--meeting.ax-list-item-content .md-alert__content--wide {
        width: auto;
      }
    `;
    }
    isProgressive1NCampaignCall(outboundType) {
        return ((outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUTBOUND_TYPE.CAMPAIGN_OUTDIAL_CUSTOMER ||
            outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUTBOUND_TYPE.OUTDIAL_RESERVATION ||
            outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUTBOUND_TYPE.CAMPAIGN_PREDICTIVE_OUTDIAL_CUSTOMER ||
            outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUTBOUND_TYPE.CAMPAIGN) &&
            this.isProgressiveCampaign1NEnabled);
    }
    isCampaignOutBoundTypes(outboundType) {
        return ((outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUTBOUND_TYPE.PROGRESSIVE_CAMPAIGN && this.isProgressiveCampaignEnabled) ||
            this.isProgressive1NCampaignCall(outboundType));
    }
    getChannelType() {
        switch (this.task.mediaType) {
            case _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.SOCIAL:
                return this.task.mediaChannel;
            case _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.VOICE: {
                if (this.task.outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUTBOUND_TYPE.CALLBACK ||
                    this.task.outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUTBOUND_TYPE.COURTESY_CALLBACK) {
                    return _constants__WEBPACK_IMPORTED_MODULE_0__.TASKLIST_ITEMSTATUS.CALLBACK_ICON;
                }
                else if (this.isCampaignOutBoundTypes(this.task.outboundType)) {
                    return _constants__WEBPACK_IMPORTED_MODULE_0__.TASKLIST_ITEMSTATUS.CAMPAIGN_ICON;
                }
                else if (this.task.contactDirection === _constants__WEBPACK_IMPORTED_MODULE_0__.CONTACT_DIRECTION.OUTBOUND) {
                    return _constants__WEBPACK_IMPORTED_MODULE_0__.TASKLIST_ITEMSTATUS.OUTBOUND_ICON;
                }
                else {
                    return this.task.mediaType;
                }
            }
            default:
                return this.task.mediaType;
        }
    }
    getStatus() {
        if (this.task.isConferencing) {
            return _constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE;
        }
        else if (this.task.state === _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTING) {
            return _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTING;
        }
        else if (this.task.isHold) {
            return _constants__WEBPACK_IMPORTED_MODULE_0__.Play;
        }
        else if (this.task.outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUTBOUND_TYPE.COURTESY_CALLBACK) {
            return "";
        }
        else {
            return "";
        }
    }
    getMediaTypeForMdTaskItem() {
        var _a;
        const mediaType = this.getChannelType();
        if ((0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.isIconSrc)(this.task.mediaType, this.task.mediaChannel, this.task.contactDirection, (_a = this.task.outboundType) !== null && _a !== void 0 ? _a : "")) {
            return _constants__WEBPACK_IMPORTED_MODULE_0__.ICON_SRC;
        }
        return mediaType;
    }
    getTaskTitle() {
        var _a;
        const mediaType = this.task.mediaType;
        if (mediaType === "telephony") {
            return this.task.contactDirection === "INBOUND" ? this.task.displayAni : this.task.dnis;
        }
        else if ((0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.isDigitalOutboundCase)(this.task.mediaChannel, this.task.contactDirection, (_a = this.task.outboundType) !== null && _a !== void 0 ? _a : "")) {
            return this.task.dnis;
        }
        else if (mediaType === "social") {
            return this.task.customerName ? this.task.customerName : this.task.appUser;
        }
        else if (mediaType === _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.MIDCALL_MONITORING) {
            return this.monitoringOwnerName || this.task.ownerName;
        }
        return this.task.customerName;
    }
    getTitleForAriaLabel() {
        const phoneNumberRegex = /^[0-9+-]+$/;
        const title = this.getTaskTitle() || "";
        if (phoneNumberRegex.test(title)) {
            return (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.makeTelephonyReadable)(title);
        }
        return this.getTaskTitle();
    }
    getTaskAriaLabel() {
        return `${this.getChannelType()}, ${this.getTitleForAriaLabel()}, ${this.task.virtualTeamName}, ${this.unreadMessage.unreadMessageCount
            ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:taskBar.newMessages", "{{count}} new messages", { count: this.unreadMessage.unreadMessageCount })
            : ""}, ${this.unreadMessage.lastUnreadMessage ? this.unreadMessage.lastUnreadMessage : ""} ${this.timerAriaLabel !== "" ? `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:outdial.outboundTaskTime")} ${this.timerAriaLabel}` : ""}`;
    }
    getAniTeamName() {
        var _a;
        if (this.task.mediaType === _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.MIDCALL_MONITORING) {
            return this.task.displayAni;
        }
        if ((0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.isDigitalOutboundCase)(this.task.mediaChannel, this.task.contactDirection, (_a = this.task.outboundType) !== null && _a !== void 0 ? _a : "")) {
            return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(_constants__WEBPACK_IMPORTED_MODULE_0__.DIGITAL_OUTBOUND);
        }
        return this.task.virtualTeamName;
    }
    render() {
        var _a;
        const listItemClassInfo = {
            "ax-activity-item-selected": this.selected,
            "not-allowed-cursor": this.isInteractionModelOpen && !this.selected
        };
        return this.task
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
          <md-task-item
            class="ax-list-item ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_6__.classMap)(listItemClassInfo)}"
            tabindex="-1"
            mediaType="${this.getMediaTypeForMdTaskItem()}"
            title="${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7__.ifDefined)(this.getTaskTitle())}"
            status="${this.getStatus()}"
            accepted
            ?selected="${this.selected}"
            lastmessage="${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7__.ifDefined)(this.unreadMessage.lastUnreadMessage ? this.unreadMessage.lastUnreadMessage : undefined)}"
            quantity="${this.unreadMessage.unreadMessageCount ? this.unreadMessage.unreadMessageCount : 0}"
            customAriaLabel="${this.getTaskAriaLabel()}"
            iconSrc="${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_7__.ifDefined)((0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.getImageSrcTaskList)(this.task.mediaType, this.task.mediaChannel, this.isDarkMode, this.selected, this.task.contactDirection, (_a = this.task.outboundType) !== null && _a !== void 0 ? _a : ""))}"
          >
            <span slot="queue">
              ${this.task.mediaType === _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.MIDCALL_MONITORING
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) ` <md-icon class="channel-icon" name="handset-active_10"></md-icon> `
                : lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing}
              <span className="queue-name"> ${this.getAniTeamName()} </span>
            </span>
            <agentx-wc-task-list-timer startTimestamp=${this.task.timeStamp}></agentx-wc-task-list-timer>
          </md-task-item>
        `
            : lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Object })
], TaskListItem.prototype, "task", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
], TaskListItem.prototype, "selected", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Object })
], TaskListItem.prototype, "unreadMessage", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
], TaskListItem.prototype, "isInteractionModelOpen", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
], TaskListItem.prototype, "isDarkMode", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
], TaskListItem.prototype, "isProgressiveCampaignEnabled", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
], TaskListItem.prototype, "isProgressiveCampaign1NEnabled", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
], TaskListItem.prototype, "monitoringOwnerName", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
], TaskListItem.prototype, "timerAriaLabel", void 0);
TaskListItem = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("agentx-wc-task-list-item")
], TaskListItem);



/***/ }),

/***/ "./src/components/TaskList/comp/TaskTimer.ts":
/*!***************************************************!*\
  !*** ./src/components/TaskList/comp/TaskTimer.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TaskTimer: () => (/* binding */ TaskTimer)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_1__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


const formatDuration = (diff) => {
    if (diff.shiftTo("hours", "minute").get("hours") < 1) {
        return diff.toFormat("mm:ss");
    }
    return diff.toFormat("hh:mm:ss");
};
let TaskTimer = class TaskTimer extends lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement {
    constructor() {
        super(...arguments);
        this.startTimestamp = 0;
    }
    connectedCallback() {
        super.connectedCallback();
        this.intervalId = window.setInterval(() => this.requestUpdate(), 100);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        clearInterval(this.intervalId);
    }
    render() {
        const start = luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.fromMillis(this.startTimestamp);
        const now = luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.utc();
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) ` <div role="timer" class="ax-activity-timer">${formatDuration(now.diff(start))}</div> `;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Number })
], TaskTimer.prototype, "startTimestamp", void 0);
TaskTimer = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("agentx-wc-task-list-timer")
], TaskTimer);



/***/ }),

/***/ "./src/components/TeamPerformanceWidget/CellRenderer/ActionRenderer.ts":
/*!*****************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/CellRenderer/ActionRenderer.ts ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AGENT_STATE_CHANGE: () => (/* binding */ AGENT_STATE_CHANGE),
/* harmony export */   REVIEW_AND_MONITOR: () => (/* binding */ REVIEW_AND_MONITOR),
/* harmony export */   SEND_MESSAGE: () => (/* binding */ SEND_MESSAGE),
/* harmony export */   SIGNOUT_AGENT: () => (/* binding */ SIGNOUT_AGENT),
/* harmony export */   "default": () => (/* binding */ ActionsRenderer)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/WebexChat.utils */ "./src/components/TeamPerformanceWidget/utils/WebexChat.utils.ts");
/* harmony import */ var _BaseComponent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./BaseComponent */ "./src/components/TeamPerformanceWidget/CellRenderer/BaseComponent.ts");





// Component names
const SEND_MESSAGE = "SEND_MESSAGE";
const AGENT_STATE_CHANGE = "AGENT_STATE_CHANGE";
const REVIEW_AND_MONITOR = "REVIEW_AND_MONITOR";
const SIGNOUT_AGENT = "SIGNOUT_AGENT";
const ACTION_ELEMENT_DEFAULT_WIDTH = 40; // 40px
const SHOW_TOOLTIP = "data-show-tooltip";
const ARIA_LABEL = "aria-label";
const ARIA_DESCRIPTION = "aria-description";
const TWP_CUSTOM_TOOLTIP = "tpw-custom-tooltip";
const DATA_MESSAGE = "data-message";
class ActionsRenderer extends _BaseComponent__WEBPACK_IMPORTED_MODULE_4__["default"] {
    constructor() {
        super();
        this.actionCellConfigs = {};
        this.paramsData = {};
        this.localization = {};
        this.contextMenuList = [];
        this.selectedModeClassName = () => {
            return this.actionCellConfigs.isDarkMode ? "dark-mode" : "light-mode";
        };
        this.getActionCellValues = () => {
            return Object.assign(Object.assign({}, this.paramsData), { agentId: this.actionCellConfigs.agentId, onActiveCall: this.actionCellConfigs.onActiveCall, contactStatus: this.actionCellConfigs.contactStatus });
        };
        this.getTooltipMessage = () => {
            if (this.actionCellConfigs.voiceChannelCount === 0) {
                return this.localization.notHaveChannels;
            }
            else if (this.actionCellConfigs.isConsultCall) {
                return this.localization.cannotMonitorConsult;
            }
            else if (this.isWrapUp) {
                return this.localization.cannotMonitorWrapUp;
            }
            else if (this.isMainCallInPostCall) {
                return this.localization.cannotMonitorPostCall;
            }
            else if (this.isWrapUpAssistance) {
                return this.localization.cannotMonitorWrapUpAssistance;
            }
            else if (this.actionCellConfigs.isMCMEnabled) {
                return this.localization.reviewAndMonitor;
            }
            else {
                return this.localization.review;
            }
        };
        this.handleOpenReviewAndMonitorModal = () => {
            var _a;
            if (!!this.actionCellConfigs.isReviewAndMonitorEnabled &&
                !this.actionCellConfigs.onActiveCall &&
                ((_a = this.actionCellConfigs) === null || _a === void 0 ? void 0 : _a.handleAIDModal)) {
                this.actionCellConfigs.handleAIDModal(this.actionCellConfigs.agentId);
            }
        };
        this.getWebexToolTip = () => {
            if (this.actionCellConfigs.isWebExSendingMessage) {
                return this.localization.webexChatSendingMessage;
            }
            else if (this.actionCellConfigs.isWebExSendingMessageError) {
                return this.localization.webexChatTPWErrorMessage;
            }
            else {
                return this.localization.webexChatSendMessage;
            }
        };
        this.removeAllChildNodes = (parent) => {
            while (parent.firstChild) {
                parent.removeChild(parent.firstChild);
            }
        };
        this.validateDarkToLightModeTransition = (element) => {
            var _a, _b, _c;
            const firstChild = element === null || element === void 0 ? void 0 : element.firstChild;
            if (firstChild instanceof Element) {
                const response = (_a = firstChild === null || firstChild === void 0 ? void 0 : firstChild.classList) === null || _a === void 0 ? void 0 : _a.contains(this.selectedModeClassName());
                if (!response) {
                    // On true, Update the class name list.
                    (_b = firstChild === null || firstChild === void 0 ? void 0 : firstChild.classList) === null || _b === void 0 ? void 0 : _b.remove("dark-mode", "light-mode"); // Remove the class name
                    (_c = firstChild === null || firstChild === void 0 ? void 0 : firstChild.classList) === null || _c === void 0 ? void 0 : _c.add(this.selectedModeClassName());
                }
                return !response;
            }
            return false;
        };
        this.eGui = document.createElement("div");
        // section-one - Is Used to show the monitor svg image and monitoring status text
        // section-two - Is used to show the chat, kebab, additional icons.
        this.eGui.innerHTML = `<div class="section-one"></div><div class="section-one"></div>`;
        this.eGui.classList.add("ActionCell");
    }
    get isWrapUp() {
        return this.actionCellConfigs.isMPCorPersistEnabled && this.actionCellConfigs.isWrapUp;
    }
    get isWrapUpAssistance() {
        return (this.actionCellConfigs.isMPCorPersistEnabled &&
            !this.actionCellConfigs.isPostCallEnabled &&
            this.actionCellConfigs.isWrapUpAssistance);
    }
    get isMainCallInPostCall() {
        return (this.actionCellConfigs.isMPCorPersistEnabled &&
            this.actionCellConfigs.isPostCallEnabled &&
            this.actionCellConfigs.isMainCallInPostCall);
    }
    getIsMonitoring() {
        return (this.actionCellConfigs.monitoredBy &&
            this.actionCellConfigs.monitoredBy !== "" &&
            this.actionCellConfigs.monitoredBy !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE);
    }
    getReviewMonitorIcon() {
        const iconElement = document.createElement("md-icon");
        iconElement.classList.add("aid-icon", this.selectedModeClassName());
        iconElement.iconSet = "momentumDesign";
        iconElement.name = "monitoring-regular";
        iconElement.size = "20";
        iconElement.ariaLabel = this.actionCellConfigs.isMCMEnabled
            ? this.localization.reviewAndMonitor
            : this.localization.review;
        return iconElement;
    }
    isReviewMonitorDisabled() {
        /*monitoredBy here is ensuring that the monitoring is successfully started,
         isSupervisorMonitoring can only ensure If same supervisor has started monitoring or not(not the successful landing
        isSuprvisorMonitoring is required to disable start monitoring button in AID for the phase of clicking start monitoring to successful monitoring  on supervisor desktop*/
        return ((this.actionCellConfigs.isSupervisorMonitoring && this.actionCellConfigs.monitoredBy) ||
            !this.actionCellConfigs.isReviewAndMonitorEnabled ||
            this.actionCellConfigs.onActiveCall ||
            this.actionCellConfigs.isConsultCall ||
            this.actionCellConfigs.voiceChannelCount === 0);
    }
    renderReviewAndMonitorIcon() {
        const monitorDisabled = this.isReviewMonitorDisabled();
        const toolTipMessage = this.getTooltipMessage();
        const customClassNames = ["review-monitor-icon", `review-monitor-${this.actionCellConfigs.agentId}`];
        const button = this.createButtonElement(customClassNames, monitorDisabled);
        if (this.actionCellConfigs.voiceChannelCount === 0 || this.actionCellConfigs.isConsultCall) {
            button.setAttribute(SHOW_TOOLTIP, "true");
        }
        // Append the Review Monitor SVG Icon.
        const childElement = this.getReviewMonitorIcon();
        button.appendChild(childElement);
        button.onclick = () => {
            this.handleOpenReviewAndMonitorModal();
        };
        button.setAttribute(ARIA_LABEL, `${toolTipMessage}`);
        button.classList.add(TWP_CUSTOM_TOOLTIP);
        button.setAttribute(DATA_MESSAGE, toolTipMessage);
        return button;
    }
    stateChangeError() {
        return this.actionCellConfigs.agentStateChangeError;
    }
    getStateChangeTooltip() {
        if (this.actionCellConfigs.agentStateChanging) {
            return this.localization.stateChange.progress;
        }
        else if (this.actionCellConfigs.agentStateChangeError) {
            return this.localization.stateChange.failed;
        }
        else {
            return this.localization.stateChange.default;
        }
    }
    isAgentStateChangeDisabled() {
        return this.actionCellConfigs.agentId === this.actionCellConfigs.supervisorId;
    }
    renderStateChangeIcon() {
        const customClassNames = ["state-change-action", `state-change-${this.actionCellConfigs.agentId}`];
        const stateChangeDisabled = this.isAgentStateChangeDisabled();
        const button = this.createButtonElement(customClassNames, stateChangeDisabled);
        if (this.actionCellConfigs.agentStateChanging) {
            const iconElement = this.createIconElement(["md-spinner", "md-spinner--14"]);
            button.appendChild(iconElement);
        }
        else {
            const iconElement = this.createIconElement(["icon-recurring_14"]);
            button.appendChild(iconElement);
            if (this.stateChangeError()) {
                const errorElement = document.createElement("div");
                errorElement.classList.add("error-icon");
                const errorIcon = this.createIconElement(["icon-priority-active-two_12"]);
                errorElement.appendChild(errorIcon);
                button.appendChild(errorElement);
            }
        }
        button.onclick = (e) => {
            e.stopPropagation();
            if (!stateChangeDisabled) {
                const actionCellValues = this.getActionCellValues();
                this.actionCellConfigs.handleStateChangeSelector(actionCellValues, button);
            }
        };
        const toolTipMessage = this.getStateChangeTooltip();
        button.setAttribute(ARIA_LABEL, `${toolTipMessage}`);
        button.classList.add(TWP_CUSTOM_TOOLTIP);
        button.setAttribute(DATA_MESSAGE, toolTipMessage);
        return button;
    }
    getMonitorLabel() {
        const paraElement = document.createElement("p");
        paraElement.classList.add("monitoring-label");
        paraElement.setAttribute(ARIA_LABEL, "");
        paraElement.setAttribute("role", "status");
        let toolTipMessage = "";
        if (this.actionCellConfigs.isSupervisorMonitoring) {
            if (this.actionCellConfigs.isBarged) {
                paraElement.innerText = this.localization.bargedIn;
                paraElement.setAttribute(ARIA_LABEL, `${this.localization.bargedIn} ${this.localization.alreadyBargedIn}`);
                toolTipMessage = this.localization.alreadyBargedIn;
            }
            else {
                paraElement.innerText = this.localization.monitoring;
                paraElement.setAttribute(ARIA_LABEL, `${this.localization.monitoring} ${this.localization.ownMonitoring}`);
                toolTipMessage = this.localization.ownMonitoring;
            }
        }
        else if (this.actionCellConfigs.isBarged) {
            paraElement.innerText = this.localization.bargedIn;
            paraElement.setAttribute(ARIA_LABEL, `${this.localization.bargedIn} ${this.actionCellConfigs.monitoredBy} ${this.localization.supervisorBargedIn}`);
            toolTipMessage = `${this.actionCellConfigs.monitoredBy} ${this.localization.supervisorBargedIn}`;
        }
        else {
            paraElement.innerText = this.localization.beingMonitored;
            paraElement.setAttribute(ARIA_LABEL, `${this.localization.beingMonitored} ${this.actionCellConfigs.monitoredBy} ${this.localization.supervisorMonitoring}`);
            toolTipMessage = `${this.actionCellConfigs.monitoredBy} ${this.localization.supervisorMonitoring}`;
        }
        const toolTipWrapper = this.toolTipElement(toolTipMessage);
        toolTipWrapper.appendChild(paraElement);
        return toolTipWrapper;
    }
    callMonitoringLabel() {
        const divElement = this.getMonitorLabel();
        divElement.classList.add("monitoring-container");
        divElement.style.width = `${this.actionCellConfigs.actionCellWidth}px`;
        return divElement;
    }
    renderKebabIcon() {
        var _a, _b;
        const customClassNames = ["kebab-action", `more-action-${this.actionCellConfigs.agentId}`];
        const button = this.createButtonElement(customClassNames);
        button.setAttribute("aria-haspopup", "true");
        button.title = (_a = this.localization) === null || _a === void 0 ? void 0 : _a.moreAction;
        button.ariaLabel = (_b = this.localization) === null || _b === void 0 ? void 0 : _b.moreAction;
        const iconElement = this.createIconElement(["icon-more-android_16", "kebab-menu-icon"]);
        button.appendChild(iconElement);
        button.onclick = (e) => {
            e.stopPropagation();
            const actionCellValues = this.getActionCellValues();
            this.actionCellConfigs.handleContextMenu(actionCellValues, button, this.contextMenuList);
        };
        const element = document.createElement("div");
        element.classList.add("more-actions");
        element.appendChild(button);
        return element;
    }
    renderKebabWrapper() {
        const element = document.createElement("div");
        element.classList.add("more-actions");
        const button = this.renderKebabIcon();
        element.appendChild(button);
        return element;
    }
    isWebexChatDisabled() {
        if (this.actionCellConfigs.isSupervisorySendMessageEnabled) {
            return (this.actionCellConfigs.agentId === this.actionCellConfigs.supervisorId ||
                this.actionCellConfigs.agentEmail === "");
        }
        // Disable webex chat
        return true;
    }
    webExMessageError() {
        return (this.actionCellConfigs.isWebExSendingMessageError ||
            (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_3__.getPersistedError)(this.actionCellConfigs.agentName, this.actionCellConfigs.agentEmail));
    }
    sectionTwoActionComponents() {
        // This method will return the list of components required
        const actionComponents = [];
        if (this.actionCellConfigs.webexEnabled) {
            // Webex Component is enabled.
            actionComponents.push(SEND_MESSAGE);
        }
        if (this.actionCellConfigs.isStateChangeBySupervisorEnabled) {
            // Agent state change Component is enabled.
            actionComponents.push(AGENT_STATE_CHANGE);
        }
        if (this.actionCellConfigs.isSignoutBySupervisorEnabled) {
            actionComponents.push(SIGNOUT_AGENT);
        }
        return actionComponents;
    }
    renderActionElement(componentName) {
        switch (componentName) {
            case SEND_MESSAGE:
                return this.renderChatIcon();
            case AGENT_STATE_CHANGE:
                return this.renderStateChangeIcon();
            case SIGNOUT_AGENT:
                return this.renderSignoutIcon();
            default:
                return null;
        }
    }
    showKebabMenu(sectionTwoActionComponents) {
        var _a, _b;
        // should only ever be reviewAndMonitor button but rather do this than have a magic number here
        const section1ChildCount = (_b = (_a = this.eGui.querySelector(".section-one")) === null || _a === void 0 ? void 0 : _a.childElementCount) !== null && _b !== void 0 ? _b : 0;
        const actionButtonCount = section1ChildCount + sectionTwoActionComponents.length;
        return ACTION_ELEMENT_DEFAULT_WIDTH * actionButtonCount >= this.actionCellConfigs.actionCellWidth;
    }
    getActionCellElements(sectionTwoActionComponents) {
        const elements = []; // Stores the array of action cell components
        let contextMenuList = [];
        const showKebabMenu = this.showKebabMenu(sectionTwoActionComponents);
        if (showKebabMenu) {
            // subtract ACTION_ELEMENT_DEFAULT_WIDTH to cater for the reviwAndMonitor Icon.
            // there seems to be a loop here where the width relies on the its own width and count of icons
            // sometimes things arent rendered yet so sizes are 0
            // ideally we would pull the sections widths from the sections directly, but there is possible race conditions.
            // this could be refactored not need the width to calculate the possible elements at all
            // `const noOfPossibleElements = this.eGui.querySelector(".section-one")?.childElementCount ?? 0;`
            const sectionTwoWidth = this.actionCellConfigs.actionCellWidth - ACTION_ELEMENT_DEFAULT_WIDTH;
            const noOfPossibleElements = Math.round(sectionTwoWidth / ACTION_ELEMENT_DEFAULT_WIDTH);
            if (noOfPossibleElements > 1) {
                const renderComponents = [];
                // Append the list of possible component to render this width.
                for (let i = 1; i < noOfPossibleElements; i++) {
                    const index = i - 1;
                    const componentName = sectionTwoActionComponents[index];
                    renderComponents.push(componentName);
                    const element = this.renderActionElement(componentName);
                    if (element) {
                        elements.push(element);
                    }
                }
                const kebabElements = sectionTwoActionComponents.filter((componentName) => !renderComponents.includes(componentName));
                contextMenuList = kebabElements;
            }
            else {
                contextMenuList = sectionTwoActionComponents;
            }
            // Append the kebab Icon
            const kebabIcon = this.renderKebabWrapper();
            elements.push(kebabIcon);
        }
        else {
            // Render all the action items in action cell, context menu list is not required
            sectionTwoActionComponents.forEach((componentName) => {
                const element = this.renderActionElement(componentName);
                if (element) {
                    elements.push(element);
                }
            });
        }
        return [elements, contextMenuList];
    }
    renderChatIcon() {
        const customClassNames = ["aid-chat", `agentx-webex-chat-${this.actionCellConfigs.agentId}`];
        const isDisabled = this.isWebexChatDisabled();
        const button = this.createButtonElement(customClassNames, isDisabled);
        if (this.actionCellConfigs.isWebExSendingMessage) {
            const iconElement = this.createIconElement(["md-spinner", "md-spinner--14"]);
            button.appendChild(iconElement);
        }
        else {
            const iconElement = this.createIconElement(["icon-chat_14"]);
            button.appendChild(iconElement);
            if (this.webExMessageError()) {
                const errorElement = document.createElement("div");
                errorElement.classList.add("error-icon");
                const webexErrorIcon = this.createIconElement(["icon-priority-active-two_12"]);
                errorElement.appendChild(webexErrorIcon);
                button.appendChild(errorElement);
            }
        }
        button.onclick = (e) => {
            e.stopPropagation();
            if (!isDisabled) {
                const actionCellValues = this.getActionCellValues();
                this.actionCellConfigs.handleWebexChat(actionCellValues, button);
            }
        };
        const toolTipMessage = this.getWebexToolTip();
        button.setAttribute("aria-label", `${toolTipMessage} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.to")} ${this.actionCellConfigs.agentName}`);
        button.classList.add(TWP_CUSTOM_TOOLTIP);
        button.setAttribute(DATA_MESSAGE, toolTipMessage);
        return button;
    }
    renderSignoutIcon() {
        const customClassNames = ["signout-icon", `signout-${this.actionCellConfigs.agentId}`];
        const isDisabled = (0,_Utils__WEBPACK_IMPORTED_MODULE_2__.isAgentSignoutDisabled)(this.actionCellConfigs);
        const button = this.createButtonElement(customClassNames, isDisabled);
        if (this.actionCellConfigs.signoutPending) {
            const iconElement = this.createIconElement(["md-spinner", "md-spinner--14"]);
            button.appendChild(iconElement);
        }
        else if (this.actionCellConfigs.signoutError) {
            const iconElement = this.createIconElement(["icon-sign-out_16"]);
            const errorElement = document.createElement("div");
            errorElement.classList.add("error-icon");
            const webexErrorIcon = this.createIconElement(["icon-priority-active-two_12"]);
            errorElement.appendChild(webexErrorIcon);
            iconElement.appendChild(errorElement);
            button.appendChild(iconElement);
        }
        else {
            const iconElement = this.createIconElement(["icon-sign-out_16"]);
            button.appendChild(iconElement);
        }
        button.onclick = (e) => {
            var _a;
            if (!isDisabled) {
                e.stopPropagation();
                const event = {
                    detail: {
                        agentId: (_a = this.actionCellConfigs) === null || _a === void 0 ? void 0 : _a.agentId
                    }
                };
                const actionCellValues = this.getActionCellValues();
                this.actionCellConfigs.handleAgentSignout(actionCellValues, event);
            }
        };
        const toolTipMessage = (0,_Utils__WEBPACK_IMPORTED_MODULE_2__.getSignoutTooltip)(this.actionCellConfigs, isDisabled);
        button.setAttribute(ARIA_LABEL, `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.signoutAgentMenu")} ${this.actionCellConfigs.agentName}`);
        button.setAttribute(ARIA_DESCRIPTION, `${toolTipMessage}`);
        button.classList.add(TWP_CUSTOM_TOOLTIP);
        button.setAttribute(DATA_MESSAGE, toolTipMessage);
        return button;
    }
    renderElement() {
        const element = document.createElement("div");
        element.classList.add("ActionCell");
        const section1 = document.createElement("div");
        section1.classList.add("section-one");
        const section2 = document.createElement("div");
        section2.classList.add("section-two");
        // SECTION ONE
        const isMonitoring = this.getIsMonitoring();
        if (!isMonitoring) {
            // There is no monitoring in progress.
            // Add the review and monitor icon
            const reviewAndMonitorButtonElement = this.renderReviewAndMonitorIcon();
            section1.appendChild(reviewAndMonitorButtonElement);
        }
        else {
            // Call monitoring in progress.
            // Show the monitoring label text.
            const labelElement = this.callMonitoringLabel();
            section1.appendChild(labelElement);
        }
        // SECTION TWO
        // Check whether we need to render the kebab icon or chat icon based on the action cell width
        const sectionTwoActionComponents = this.sectionTwoActionComponents();
        if (isMonitoring || sectionTwoActionComponents.length > 0) {
            if (isMonitoring) {
                // All the action components will added to the context menu list
                this.contextMenuList = sectionTwoActionComponents;
                const kebabWrapper = this.renderKebabWrapper();
                section2 === null || section2 === void 0 ? void 0 : section2.appendChild(kebabWrapper);
            }
            else {
                // Render action cell components
                const [elements, contextMenuList] = this.getActionCellElements(sectionTwoActionComponents);
                elements.forEach((el) => {
                    section2 === null || section2 === void 0 ? void 0 : section2.appendChild(el);
                });
                this.contextMenuList = contextMenuList;
            }
        }
        else {
            this.contextMenuList = [];
        }
        element.appendChild(section1);
        element.appendChild(section2);
        this.eGui = element;
    }
    init(params) {
        this.paramsData = params.value;
        this.setActionCellConfigs(params);
        this.renderElement();
    }
    getGui() {
        return this.eGui;
    }
    refreshElement() {
        // This method will execute when refresh function is called.
        const section1 = this.eGui.querySelector(".section-one");
        const isMonitoring = this.getIsMonitoring();
        if (!isMonitoring) {
            // There is no monitoring call in progress.
            // Update the monitor icon
            const reviewAndMonitorIcon = this.eGui.getElementsByClassName("review-monitor-icon");
            if (reviewAndMonitorIcon && reviewAndMonitorIcon.length > 0) {
                // Update the Icon...
                const reviewMonitorStatusDisabled = this.isReviewMonitorDisabled();
                const reviewMonitorSelectedIcon = reviewAndMonitorIcon[0];
                const hasDisabledAttribute = reviewMonitorSelectedIcon === null || reviewMonitorSelectedIcon === void 0 ? void 0 : reviewMonitorSelectedIcon.classList.contains("disabled");
                if (reviewMonitorStatusDisabled !== hasDisabledAttribute) {
                    if (reviewMonitorStatusDisabled) {
                        reviewMonitorSelectedIcon.classList.add("disabled");
                        reviewMonitorSelectedIcon.setAttribute("aria-disabled", "true");
                    }
                    else {
                        reviewMonitorSelectedIcon.classList.remove("disabled");
                        reviewMonitorSelectedIcon.removeAttribute("aria-disabled");
                    }
                }
                const toolTipMessage = this.getTooltipMessage();
                const ToolTipElement = section1.querySelector(`.${TWP_CUSTOM_TOOLTIP}`);
                if (ToolTipElement) {
                    ToolTipElement.setAttribute(DATA_MESSAGE, toolTipMessage);
                }
                if (this.actionCellConfigs.isConsultCall ||
                    this.isWrapUp ||
                    this.isWrapUpAssistance ||
                    this.isMainCallInPostCall ||
                    this.actionCellConfigs.voiceChannelCount === 0) {
                    reviewAndMonitorIcon[0].setAttribute(SHOW_TOOLTIP, "true");
                }
                else {
                    reviewMonitorSelectedIcon.removeAttribute(SHOW_TOOLTIP);
                }
            }
            else {
                // Render the monitor icon.'
                const reviewAndMonitorButtonElement = this.renderReviewAndMonitorIcon();
                section1 === null || section1 === void 0 ? void 0 : section1.replaceChildren(reviewAndMonitorButtonElement);
            }
        }
        else {
            // Call monitoring in progress, Render the monitoring label text
            const labelElement = this.callMonitoringLabel();
            section1 === null || section1 === void 0 ? void 0 : section1.replaceChildren(labelElement);
        }
        // Check whether we need to render the kebab icon or chat icon based on the action cell width
        const section2 = this.eGui.querySelector(".section-two");
        const sectionTwoActionComponents = this.sectionTwoActionComponents();
        if (isMonitoring || sectionTwoActionComponents.length > 0) {
            if (isMonitoring) {
                // All the action components will added to the context menu list
                this.contextMenuList = sectionTwoActionComponents;
                const kebabWrapper = this.renderKebabWrapper();
                section2 === null || section2 === void 0 ? void 0 : section2.replaceChildren(kebabWrapper);
            }
            else {
                // Render action cell components
                const [elements, contextMenuList] = this.getActionCellElements(sectionTwoActionComponents);
                section2 === null || section2 === void 0 ? void 0 : section2.replaceChildren(...elements);
                this.contextMenuList = contextMenuList;
            }
        }
        else {
            // Remove the child elements.
            // section2.removeChildren
            this.removeAllChildNodes(section2);
        }
    }
    setActionCellConfigs(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        const cellEditorParams = (_a = params === null || params === void 0 ? void 0 : params.colDef) === null || _a === void 0 ? void 0 : _a.cellEditorParams();
        const actionCellValues = ((_b = params === null || params === void 0 ? void 0 : params.data) === null || _b === void 0 ? void 0 : _b.actions) && Object.keys((_c = params === null || params === void 0 ? void 0 : params.data) === null || _c === void 0 ? void 0 : _c.actions).length > 0 ? (_d = params === null || params === void 0 ? void 0 : params.data) === null || _d === void 0 ? void 0 : _d.actions : {};
        this.actionCellConfigs = Object.assign(Object.assign({}, actionCellValues), { isDarkMode: (_e = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.isDarkMode) !== null && _e !== void 0 ? _e : false, webexEnabled: (_f = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.webexEnabled) !== null && _f !== void 0 ? _f : false, isMCMEnabled: (_g = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.isMCMEnabled) !== null && _g !== void 0 ? _g : false, isMPCorPersistEnabled: (_h = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.isMPCorPersistEnabled) !== null && _h !== void 0 ? _h : false, isPostCallEnabled: (_j = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.isPostCallEnabled) !== null && _j !== void 0 ? _j : false, isStateChangeBySupervisorEnabled: (_k = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.isStateChangeBySupervisorEnabled) !== null && _k !== void 0 ? _k : false, isSignoutBySupervisorEnabled: (_l = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.isSignoutBySupervisorEnabled) !== null && _l !== void 0 ? _l : false, isSupervisorySendMessageEnabled: (_m = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.isSupervisorySendMessageEnabled) !== null && _m !== void 0 ? _m : false, voiceChannelCount: (_o = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.voiceChannelCount) !== null && _o !== void 0 ? _o : 0, onActiveCall: (_p = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.onActiveCall) !== null && _p !== void 0 ? _p : false, handleAIDModal: cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.handleAIDModal, handleContextMenu: cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.handleContextMenu, handleStateChangeSelector: cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.handleStateChangeSelector, handleWebexChat: cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.handleWebexChat, actionCellWidth: cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.actionCellWidth, handleAgentSignout: cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.handleAgentSignout, contactStatus: (_r = (_q = params === null || params === void 0 ? void 0 : params.data) === null || _q === void 0 ? void 0 : _q.contactStatus) !== null && _r !== void 0 ? _r : "" });
        // i18nMixin was not extended in this function,
        // All the required localization text are received as a property from cellEditorParams
        this.localization = cellEditorParams === null || cellEditorParams === void 0 ? void 0 : cellEditorParams.actionCellLocalizationValues;
    }
    refresh(params) {
        // Update the params
        this.paramsData = params.value;
        this.setActionCellConfigs(params);
        this.refreshElement();
        return true;
    }
    destroy() {
        this.eGui.remove();
    }
}


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/CellRenderer/AgentStateRenderer.ts":
/*!*********************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/CellRenderer/AgentStateRenderer.ts ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ AgentStateRenderer)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../constants */ "./src/constants.ts");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _BaseComponent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./BaseComponent */ "./src/components/TeamPerformanceWidget/CellRenderer/BaseComponent.ts");




class AgentStateRenderer extends _BaseComponent__WEBPACK_IMPORTED_MODULE_3__["default"] {
    constructor() {
        super();
        this.supervisorId = "";
        this.agentState = "";
        this.getToolTipMessage = (params) => {
            if (params.data.reason === _constants__WEBPACK_IMPORTED_MODULE_1__.PRESENCE_SYNC) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.stateChangeByCollab");
            }
            const name = this.supervisorId === params.data.changedById ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.stateChange.you") : params.data.changedByName;
            return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.SetBy", "", { defaultValue: name })}`;
        };
        this.createInfoIconElement = (params) => {
            const iconElement = this.createIconElement(["agent-state-info", "icon-info_16"]);
            const toolTipMessage = this.getToolTipMessage(params);
            const infoToolTipWrapper = this.toolTipElement(toolTipMessage);
            infoToolTipWrapper.appendChild(iconElement);
            return infoToolTipWrapper;
        };
        this.updateParamsValues = (params) => {
            var _a, _b;
            this.supervisorId = (_a = params === null || params === void 0 ? void 0 : params.colDef) === null || _a === void 0 ? void 0 : _a.cellEditorParams.supervisorId;
            this.agentState = (_b = params === null || params === void 0 ? void 0 : params.data) === null || _b === void 0 ? void 0 : _b.agentState;
        };
        // This method will execute when state value is changed. Value will update using the element reference.
        this.refreshAgentStateRenderer = (params) => {
            this.updateParamsValues(params);
            // Update the agent state by element reference
            const agentStateName = this.eGui.querySelector(".agent-state-name");
            if (agentStateName) {
                agentStateName.textContent = (0,_Utils__WEBPACK_IMPORTED_MODULE_2__.localiseAvailableState)(this.agentState);
            }
            // Update the tooltip.
            const tooltipElement = this.eGui.querySelector(".tpw-custom-tooltip");
            if (this.checkExtStateChange(params)) {
                if (tooltipElement) {
                    // Update the existing tooltip message.
                    const toolTipMessage = this.getToolTipMessage(params);
                    tooltipElement.setAttribute("data-message", toolTipMessage);
                }
                else {
                    // Append the info element before the agent state name.
                    const infoIconElement = this.createInfoIconElement(params);
                    this.eGui.insertBefore(infoIconElement, agentStateName);
                }
            }
            else {
                // Remove the existing tooltip element
                tooltipElement === null || tooltipElement === void 0 ? void 0 : tooltipElement.remove();
            }
        };
        this.eGui = document.createElement("div");
    }
    renderAgentStateRenderer(params) {
        const element = document.createElement("div");
        element.classList.add("agent-state-container");
        // Check whether the info icon needs to be present or not
        if (this.checkExtStateChange(params)) {
            const infoIconElement = this.createInfoIconElement(params);
            element.appendChild(infoIconElement);
            element.setAttribute("aria-label", this.getToolTipMessage(params));
        }
        // Agent state indicator that shows the state of the agent
        element.appendChild(this.createStateElement());
        this.eGui = element;
    }
    // This method will check if state is changed by supervisor or PRESENCE_SYNC.
    checkExtStateChange(params) {
        if (params.data.reason === _constants__WEBPACK_IMPORTED_MODULE_1__.PRESENCE_SYNC) {
            return true;
        }
        const { changedBy, changedById, changedByName } = params.data;
        return changedBy ? changedBy !== _constants__WEBPACK_IMPORTED_MODULE_1__.CHANGED_BY_ROLE.SELF : changedById && changedByName;
    }
    createStateElement() {
        const element = document.createElement("span");
        element.classList.add("agent-state-name");
        element.textContent = (0,_Utils__WEBPACK_IMPORTED_MODULE_2__.localiseAvailableState)(this.agentState);
        return element;
    }
    init(params) {
        this.updateParamsValues(params);
        this.renderAgentStateRenderer(params);
    }
    refresh(params) {
        this.refreshAgentStateRenderer(params);
        return true;
    }
    getGui() {
        return this.eGui;
    }
    destroy() {
        this.eGui.remove();
    }
}


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/CellRenderer/BaseComponent.ts":
/*!****************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/CellRenderer/BaseComponent.ts ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ BaseComponent)
/* harmony export */ });
const BUTTON_DEFAULT_CLASSNAMES = ["aid-button", "btn-action"];
const ICON_DEFAULT_CLASSNAMES = ["md-icon", "icon"];
class BaseComponent {
    constructor() {
        var _a, _b;
        this.createIconElement = (classList) => {
            const iconElement = document.createElement("i");
            // Add Default momentum class names for icon element.
            iconElement.classList.add(...ICON_DEFAULT_CLASSNAMES);
            // Add custom class names.
            if (Array.isArray(classList)) {
                iconElement.classList.add(...classList);
            }
            return iconElement;
        };
        this.createToolTip = (reference, message, placement = "top") => {
            var _a;
            const popperElement = this.createToolTipContent(message);
            (_a = this.themeSelector) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent("tooltip-create", {
                bubbles: true,
                composed: true,
                detail: {
                    placement,
                    reference,
                    popper: popperElement
                }
            }));
        };
        this.destroyToolTip = () => {
            var _a;
            (_a = this.themeSelector) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent("tooltip-destroy", {
                bubbles: true,
                composed: true,
                detail: {}
            }));
        };
        this.createToolTipContent = (message) => {
            const popperElement = document.createElement("div");
            popperElement.classList.add("md-tooltip__popper");
            popperElement.innerHTML = `<div class="md-tooltip__content" part="tooltip-content">
                                ${message}
                               </div>
                               <div id="arrow" class="md-tooltip__arrow" data-popper-arrow></div>`;
            return popperElement;
        };
        this.toolTipElement = (message) => {
            const element = document.createElement("div");
            element.classList.add("tpw-custom-tooltip");
            element.setAttribute("data-message", message);
            element.onmouseenter = (event) => {
                var _a;
                if (!event.target.firstChild.disabled || ((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.firstChild.getAttribute("data-show-tooltip"))) {
                    const content = element.getAttribute("data-message");
                    if (content) {
                        this.createToolTip(event.target.firstChild, content);
                    }
                }
            };
            element.onmouseleave = () => {
                this.destroyToolTip();
            };
            element.onkeydown = () => {
                this.destroyToolTip();
            };
            return element;
        };
        this.themeSelector = (_b = (_a = document === null || document === void 0 ? void 0 : document.querySelector("agentx-app")) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("md-theme");
    }
    createButtonElement(classList, isDisabled = false) {
        const button = document.createElement("button");
        button.classList.add(...BUTTON_DEFAULT_CLASSNAMES);
        // Add custom class names.
        if (Array.isArray(classList)) {
            button.classList.add(...classList);
        }
        button.setAttribute("type", "button");
        button.tabIndex = 0;
        if (isDisabled) {
            button.classList.add("disabled");
            button.setAttribute("aria-disabled", "true");
        }
        const onmouseenter = (event) => {
            var _a;
            if (!event.target.firstChild.classList.contains("disabled") ||
                ((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.firstChild.getAttribute("data-show-tooltip"))) {
                const content = button.getAttribute("data-message");
                if (content) {
                    this.createToolTip(button, content);
                }
            }
        };
        button.onmouseleave = () => {
            this.destroyToolTip();
        };
        button.onkeydown = () => {
            this.destroyToolTip();
        };
        button.onmouseenter = onmouseenter;
        button.onfocus = onmouseenter;
        return button;
    }
}


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/CellRenderer/DurationRenderer.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/CellRenderer/DurationRenderer.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_1__);


class DurationRenderer {
    init(params) {
        this.oldTimestamp =
            typeof params.value === "string" && params.value !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE ? Number(params.value) : 0;
        this.display = document.createElement("div");
        this.display.classList.add("timer-display");
        this.getGui();
    }
    initiateInterval() {
        this.intervalId = setInterval(() => {
            if (this.oldTimestamp && this.display) {
                const diff = Date.now() >= this.oldTimestamp
                    ? luxon__WEBPACK_IMPORTED_MODULE_1__.Duration.fromMillis(Date.now() - this.oldTimestamp)
                    : luxon__WEBPACK_IMPORTED_MODULE_1__.Duration.fromMillis(0);
                this.display.textContent = diff.toFormat("hh:mm:ss");
            }
        }, 1000);
    }
    getGui() {
        const container = document.createElement("div");
        container.classList.add("timer-container");
        if (this.display) {
            container.appendChild(this.display);
        }
        if (this.oldTimestamp !== 0) {
            this.initiateInterval();
        }
        else if (this.display) {
            this.display.textContent = _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE;
        }
        return container;
    }
    refresh(params) {
        if ((params.value === _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE || params.value === "0") && this.display) {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
            this.display.textContent = _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE;
        }
        else {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
            this.initiateInterval();
        }
        this.oldTimestamp =
            typeof params.value === "string" && params.value !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE ? Number(params.value) : 0;
        return true;
    }
    destroy() {
        var _a;
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
        if (this.display) {
            (_a = this.display) === null || _a === void 0 ? void 0 : _a.remove();
        }
    }
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (DurationRenderer);


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/CellRenderer/GroupRowInnerRenderer.ts":
/*!************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/CellRenderer/GroupRowInnerRenderer.ts ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ GroupRowInnerRenderer)
/* harmony export */ });
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");

class GroupRowInnerRenderer {
    constructor() {
        this.eGui = document.createElement("div");
    }
    init(params) {
        this.updateValue(params);
    }
    updateValue(params) {
        var _a, _b, _c;
        this.eGui.innerHTML = `
      <span class="groupTitle">
        ${(0,_Utils__WEBPACK_IMPORTED_MODULE_0__.columnHeaderMapping)()[(_a = params.node) === null || _a === void 0 ? void 0 : _a.field]}: ${(0,_Utils__WEBPACK_IMPORTED_MODULE_0__.localiseAvailableState)((_b = params.node) === null || _b === void 0 ? void 0 : _b.key)} ( ${(_c = params.node) === null || _c === void 0 ? void 0 : _c.allChildrenCount} Agents )
      </span>
    `;
    }
    refresh(params) {
        this.updateValue(params);
        return true;
    }
    getGui() {
        return this.eGui;
    }
}


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/CellRenderer/NameRenderer.ts":
/*!***************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/CellRenderer/NameRenderer.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ NameRenderer)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);



class NameRenderer {
    constructor() {
        this.eGui = document.createElement("div");
        this.getAvatar = (id, className, agentName, title, type) => {
            const avatarDiv = `<div id="${id}" class="${className}" alt="${agentName}" aria-label="${agentName}" title="${agentName}">
                            <span class="md-avatar__letter">${title}</span>
                          </div>`;
            const avatar = `<md-avatar
        type="${type}"
        id="${id}"
        alt="${agentName}"
        aria-label="${agentName}"
        title="${agentName}"
        size="24"
        newMomentum
      >
      </md-avatar>`;
            return _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__.themeManager.isMomentumAvatarEnabled ? avatar : avatarDiv;
        };
        this.prettyTitle = (agentName) => {
            if (agentName === null || agentName === void 0 ? void 0 : agentName.length) {
                const fullName = agentName.trim().split(" ");
                if (fullName.length === 1) {
                    return fullName[0].charAt(0);
                }
                else {
                    return `${fullName[0].charAt(0)}${fullName[fullName.length - 1].charAt(0)}`;
                }
            }
            return "";
        };
        this.avatarType = (agentState) => {
            return agentState === (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.stateChange.available") ? "active" : "idle";
        };
    }
    renderNameRenderer(params) {
        var _a, _b, _c, _d;
        const title = this.prettyTitle((_a = params === null || params === void 0 ? void 0 : params.data) === null || _a === void 0 ? void 0 : _a.agentName);
        const type = this.avatarType((_b = params === null || params === void 0 ? void 0 : params.data) === null || _b === void 0 ? void 0 : _b.agentState);
        const agentId = (_c = params === null || params === void 0 ? void 0 : params.data) === null || _c === void 0 ? void 0 : _c.agentId;
        const agentName = ((_d = params === null || params === void 0 ? void 0 : params.data) === null || _d === void 0 ? void 0 : _d.agentName) || _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE;
        const id = `avatar-renderer-${agentId}`;
        const className = `md-avatar md-avatar--28 md-avatar--${type}`;
        const avatar = this.getAvatar(id, className, agentName, title, type);
        const agentNameSpan = `<span class="name-span-renderer">${agentName}</span>`;
        this.eGui.innerHTML = avatar + agentNameSpan;
    }
    init(params) {
        this.eGui.classList.add("avatar-center");
        this.renderNameRenderer(params);
    }
    refresh(params) {
        this.renderNameRenderer(params);
        return true;
    }
    getGui() {
        return this.eGui;
    }
}


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenu.scss":
/*!*************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenu.scss ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --column-menu-width: 260px;
}

.column-menu-wrapper {
  width: var(--column-menu-width);
  background-color: var(--md-secondary-white-bg-color);
}

.filter-tab-wrapper {
  width: 100%;
  background-color: var(--md-secondary-white-bg-color);
  display: block;
  overflow: hidden;
}

.filter-tab-header {
  padding: 1rem 1rem 0rem;
  border-bottom: 1px solid var(--md-menu-overlay-border-color);
  padding-bottom: 0.5rem;
}

.filter-tab-checkbox-group-wrapper .virtual-scroll {
  padding: 0 0 0 1rem;
  max-height: 240px;
}

.filter-tab-checkbox {
  margin: 0.5rem 0;
  padding-top: 3.5px;
  padding-bottom: 3px;
}

.select-all-checkbox {
  padding-right: 5.5rem;
}

.pin-tab-wrapper {
  padding: 0.5rem;
}

.pin-tab-radio-btn {
  margin-bottom: 0.5rem;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenu.scss */
/*# sourceURL=ColumnMenu.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenu.ts":
/*!***********************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenu.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ColumnMenu: () => (/* binding */ ColumnMenu)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ColumnMenu_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ColumnMenu.scss */ "./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenu.scss");
/* harmony import */ var _FilterColumnMenu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./FilterColumnMenu */ "./src/components/TeamPerformanceWidget/ColumnMenu/FilterColumnMenu.ts");
/* harmony import */ var _PinColumnMenu__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./PinColumnMenu */ "./src/components/TeamPerformanceWidget/ColumnMenu/PinColumnMenu.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};






var ColumnMenu;
(function (ColumnMenu) {
    /**
     * @element agentx-wc-tpw-column-menu
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this._columnParams = {};
            this._columnFilterModel = {};
            this.selectedTab = 0;
            this.handleTabFocus = (index = 0) => __awaiter(this, void 0, void 0, function* () {
                yield this.updateComplete;
                setTimeout(() => {
                    var _a, _b, _c, _d;
                    const element = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-tabs")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelectorAll("md-tab");
                    if (element && element[index]) {
                        (_d = element[index]) === null || _d === void 0 ? void 0 : _d.focus();
                    }
                }, 50);
            });
            this.handleTabSelection = (e) => {
                // selected-changed
                this.selectedTab = e.detail.value;
                this.handleTabFocus(e.detail.value);
            };
            this.handleTabPanelFocus = (e) => {
                if (e.code === "Tab") {
                    e.stopPropagation();
                    // Check active focus element
                    setTimeout(() => {
                        var _a;
                        const activeElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.activeElement;
                        if (!activeElement) {
                            // If focus elements are not there in Table panel, Focus to the selected tab header
                            this.handleTabFocus(this.selectedTab);
                        }
                    }, 50); //delay for modal to load
                }
            };
        }
        get columnParams() {
            return this._columnParams;
        }
        set columnParams(value) {
            const oldValue = this._columnParams;
            this._columnParams = value;
            this.requestUpdate("columnParams", oldValue);
        }
        get columnFilterModel() {
            return this._columnFilterModel;
        }
        set columnFilterModel(value) {
            const oldValue = this._columnFilterModel;
            this._columnFilterModel = value;
            this.requestUpdate("columnFilterModel", oldValue);
        }
        static get styles() {
            return _ColumnMenu_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
        }
        connectedCallback() {
            super.connectedCallback();
            this.handleTabFocus(this.selectedTab);
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            this.handleTabFocus(this.selectedTab);
        }
        handleTabKeyDown(e) {
            var _a;
            if (((_a = e.detail) === null || _a === void 0 ? void 0 : _a.key) === "Tab") {
                setTimeout(() => {
                    var _a, _b, _c;
                    // Focus to the tab panel - selected element.
                    const columnMenuEl = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-tabs md-tab-panel[selected] filter-column-menu");
                    const searchInputWrapper = (_b = columnMenuEl === null || columnMenuEl === void 0 ? void 0 : columnMenuEl.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("md-input");
                    const searchInput = (_c = searchInputWrapper === null || searchInputWrapper === void 0 ? void 0 : searchInputWrapper.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("input");
                    searchInput === null || searchInput === void 0 ? void 0 : searchInput.focus();
                }, 50); //delay for modal to load
            }
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="column-menu-wrapper">
          <md-tabs
            .selected="${this.selectedTab}"
            justified
            @selected-changed="${(e) => {
                this.handleTabSelection(e);
            }}"
            roving-prevent-focus
            @tab-keydown="${(e) => {
                this.handleTabKeyDown(e);
            }}"
          >
            ${!this.columnParams.suppressFilterTab
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
                  <md-tab
                    slot="tab"
                    name="Filter"
                    aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.filter")}
                    .disabled=${this.columnParams.showWarningTooltip}
                  >
                    <md-tooltip
                      message=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.FilterMenuWarning")}
                      placement="bottom"
                      .disabled=${!this.columnParams.showWarningTooltip}
                    >
                      <md-icon name="filter-bold" size="16" iconSet="momentumDesign"></md-icon>
                    </md-tooltip>
                  </md-tab>
                  <md-tab-panel
                    slot="panel"
                    .focusablePanel=${"false"}
                    @keydown="${(e) => {
                    this.handleTabPanelFocus(e);
                }}"
                  >
                    <filter-column-menu
                      .columnParams=${this.columnParams}
                      .columnFilterModel=${this.columnFilterModel}
                    ></filter-column-menu>
                  </md-tab-panel>
                `
                : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}
            <md-tab slot="tab" name="Pin" aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.pin")}>
              <md-icon name="pin-bold" size="16" iconSet="momentumDesign"></md-icon>
            </md-tab>
            <md-tab-panel
              slot="panel"
              @keydown="${(e) => {
                this.handleTabPanelFocus(e);
            }}"
            >
              <pin-column-menu .columnParams=${this.columnParams}></pin-column-menu>
            </md-tab-panel>
          </md-tabs>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "columnParams", null);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "columnFilterModel", null);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "selectedTab", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-tpw-column-menu")
    ], Element);
    ColumnMenu.Element = Element;
})(ColumnMenu || (ColumnMenu = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenuRenderer.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenuRenderer.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ColumnMenuRenderer)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../TeamPerformanceUtils */ "./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts");


class ColumnMenuRenderer {
    constructor() {
        this.params = {};
        this.filterModel = {};
        this.listener = (event) => {
            var _a, _b;
            if (event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Escape) {
                this.params.api.hidePopupMenu();
                document.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.COLUMN_MENU_FOCUS, { detail: (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.column) === null || _b === void 0 ? void 0 : _b.colId }));
            }
        };
        this.eGui = document.createElement("div");
    }
    init(params) {
        this.valueGetter = params.valueGetter;
        this.params = params;
        this.setupGui(params);
        this.eGui.addEventListener("keydown", this.listener);
    }
    destroy() {
        this.eGui.removeEventListener("keydown", this.listener);
    }
    setupGui(params) {
        this.eGui.innerHTML = `
        <agentx-wc-tpw-column-menu></agentx-wc-tpw-column-menu>
    `;
        this.columnMenuElement = this.eGui.querySelector("agentx-wc-tpw-column-menu");
        this.columnMenuElement.columnParams = params;
        this.columnMenuElement.columnFilterModel = this.filterModel;
    }
    getGui() {
        return this.eGui;
    }
    doesFilterPass(params) {
        let passed = true;
        Object.keys(this.filterModel).forEach((filterWord) => {
            const rowValue = this.valueGetter(params);
            if (rowValue === filterWord) {
                passed = this.filterModel[filterWord];
            }
        });
        return passed;
    }
    isFilterActive() {
        return typeof this.filterModel !== "undefined" && this.filterModel !== null
            ? !(0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_1__.checkIfFilterModelIsEmpty)(this.filterModel)
            : false;
    }
    getModel() {
        return this.filterModel;
    }
    setModel(newFilterModel) {
        var _a;
        this.filterModel = newFilterModel;
        if (this.columnMenuElement) {
            this.columnMenuElement.columnFilterModel = this.filterModel;
        }
        (_a = this.params) === null || _a === void 0 ? void 0 : _a.filterChangedCallback();
    }
}


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/ColumnMenu/FilterColumnMenu.ts":
/*!*****************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/ColumnMenu/FilterColumnMenu.ts ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FilterColumnMenu: () => (/* binding */ FilterColumnMenu)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_virtualizer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-virtualizer */ "lit-virtualizer");
/* harmony import */ var lit_virtualizer__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_virtualizer__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../assets/styles/common.scss */ "./src/assets/styles/common.scss");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _ColumnMenu_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./ColumnMenu.scss */ "./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenu.scss");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_10__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};











var FilterColumnMenu;
(function (FilterColumnMenu) {
    /**
     * @element filter-column-menu
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_10__.MobxLitElement) {
        constructor() {
            super(...arguments);
            this._columnParams = {};
            this._columnFilterModel = {};
            this.columnRowData = [];
            this.columnRowDataObj = {}; //RowData mapping to get on which data filter is applied
            this.filteredColumnRowData = [];
            this.handleFilterDataUpdate = (e) => {
                if (e.detail && e.detail.colId === this.columnParams.column.colId) {
                    this.updateColumnRowData();
                }
            };
            this.handleSearchFilters = (event) => __awaiter(this, void 0, void 0, function* () {
                const searchTerm = event.detail.value.toLowerCase();
                const updatedFilterList = [];
                this.columnRowData.forEach((data) => {
                    if (data === null || data === void 0 ? void 0 : data.toLowerCase().includes(searchTerm)) {
                        updatedFilterList.push(data);
                    }
                });
                this.filteredColumnRowData = [...updatedFilterList];
            });
            this.isSelectAllChecked = () => {
                let selectAll = true;
                Object.keys(this.columnRowDataObj).forEach((rowData) => {
                    if (!this.columnRowDataObj[rowData]) {
                        selectAll = false;
                    }
                });
                return selectAll;
            };
            this.localiseAvailableInFilterColumn = (key) => {
                return this.getColumnId() === "agentState" && key === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.stateChange.available") : key;
            };
            this.getCheckBoxLabel = (optionsList, rowData, currentIndex) => {
                const totalOptionsCount = Object.keys(optionsList).length;
                return `${rowData} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.optionsLabel")} ${currentIndex + 1} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.of")} ${totalOptionsCount}`;
            };
            this.renderColumnData = (rowData, index) => {
                const label = this.getCheckBoxLabel(this.columnRowDataObj, rowData, index);
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="filter-wrapper">
          <md-checkbox
            tabIndex="0"
            class="filter-tab-checkbox"
            slot="checkbox"
            ?checked=${this.columnRowDataObj[rowData]}
            @checkbox-change=${(event) => this.handleFiltering(event, false, rowData)}
            aria-label=${label}
            >${this.localiseAvailableInFilterColumn(rowData)}</md-checkbox
          >
        </div>
      `;
            };
        }
        get columnParams() {
            return this._columnParams;
        }
        set columnParams(value) {
            const oldValue = this._columnParams;
            this._columnParams = value;
            this.requestUpdate("columnParams", oldValue);
        }
        get columnFilterModel() {
            return this._columnFilterModel;
        }
        set columnFilterModel(value) {
            const oldValue = this._columnFilterModel;
            this._columnFilterModel = value;
            this.requestUpdate("columnFilterModel", oldValue);
        }
        static get styles() {
            return [_ColumnMenu_scss__WEBPACK_IMPORTED_MODULE_7__["default"], _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_5__["default"]];
        }
        getColumnId() {
            var _a, _b;
            if (((_a = this.columnParams.column) === null || _a === void 0 ? void 0 : _a.colId) === "agentNameDetails") {
                return "agentName";
            }
            return (_b = this.columnParams.column) === null || _b === void 0 ? void 0 : _b.colId;
        }
        getGridRowData() {
            var _a, _b;
            const currentColId = this.getColumnId();
            const rowMap = {};
            // to get all the row nodes without filtering
            (_b = (_a = this.columnParams) === null || _a === void 0 ? void 0 : _a.rowModel) === null || _b === void 0 ? void 0 : _b.forEachNode((row) => {
                if (!row.group) {
                    const key = row.data[currentColId];
                    rowMap[key] = false;
                }
            });
            // to select those row nodes which are selected by user i.e this.filterModel
            for (const key in this.columnFilterModel) {
                if (this.columnFilterModel[key]) {
                    rowMap[key] = true;
                }
            }
            return rowMap;
        }
        updateColumnRowData() {
            this.columnRowDataObj = this.getGridRowData();
            this.columnRowData = Object.keys(this.columnRowDataObj);
            this.filteredColumnRowData = [...this.columnRowData];
        }
        connectedCallback() {
            super.connectedCallback();
            window.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_0__.TPW_FILTER_DATA_UPDATE, this.handleFilterDataUpdate);
            this.updateColumnRowData();
            this.requestUpdate();
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.columnRowData = [];
            this.columnRowDataObj = {};
            this.filteredColumnRowData = [];
            this.liveRegion.textContent = "";
            window.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_0__.TPW_FILTER_DATA_UPDATE, this.handleFilterDataUpdate);
        }
        updateColumnFilterModel(event, isSelectAllChecked, rowData) {
            const isCheckboxChecked = (0,_Utils__WEBPACK_IMPORTED_MODULE_6__.getIsCheckboxChecked)(event);
            if (isSelectAllChecked === false && rowData) {
                this.columnRowDataObj[rowData] = isCheckboxChecked;
                this.setLiveRegionText(isCheckboxChecked, rowData);
            }
            else {
                Object.keys(this.columnRowDataObj).forEach((rowObjData) => {
                    this.columnRowDataObj[rowObjData] = isCheckboxChecked;
                });
                this.setLiveRegionText(isCheckboxChecked, (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.all"));
            }
        }
        setLiveRegionText(isChecked, count) {
            if (isChecked) {
                this.liveRegion.textContent = `${count} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.filterAppliedLabel")}`;
            }
            else {
                this.liveRegion.textContent = `${count} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.filterRemovedLabel")}`;
            }
        }
        handleFilterUpdateEventDispatch() {
            var _a;
            this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.TPW_FILTER_UPDATED, {
                bubbles: true,
                composed: true,
                detail: {
                    field: (_a = this.columnParams.colDef) === null || _a === void 0 ? void 0 : _a.field,
                    data: this.columnRowDataObj
                }
            }));
        }
        handleFiltering(event, isSelectAllChecked, rowData) {
            var _a, _b;
            if (event) {
                this.updateColumnFilterModel(event, isSelectAllChecked, rowData || "");
                this.handleFilterUpdateEventDispatch();
                this.filteredColumnRowData = [...this.columnRowData];
                const currentRow = this.getColumnId();
                (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.TPW_COLUMN_FILTERED, {
                    FilteredColumnName: currentRow
                }, [(_b = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_behavioral]);
                this.requestUpdate();
            }
        }
        renderSearchInput() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `<md-input
        clear
        clearAriaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common:clear")}"
        htmlId="pillSearchInput"
        name="pillSearchInput"
        shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_9__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
        ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__.themeManager.isMomentumV2Enabled}
        ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.search")}
        placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.search")}
        searchable
        class="search-filter-input"
        @input-change=${(event) => this.handleSearchFilters(event)}
      >
      </md-input>`;
        }
        renderSelectAllCheckbox() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <md-checkbox
          tabIndex="0"
          class="filter-tab-checkbox select-all-checkbox"
          ?checked=${this.isSelectAllChecked()}
          @checkbox-change=${(event) => this.handleFiltering(event, true)}
          >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.selectAll")}</md-checkbox
        >
      `;
        }
        renderVirtualColumnRowDataCheckbox() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <lit-virtualizer
          class="virtual-scroll"
          .renderItem=${this.renderColumnData}
          .items=${this.filteredColumnRowData}
        ></lit-virtualizer>
      `;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="filter-tab-wrapper">
          <div class="filter-tab-header">${this.renderSearchInput()} ${this.renderSelectAllCheckbox()}</div>
          <div class="filter-tab-checkbox-group-wrapper">${this.renderVirtualColumnRowDataCheckbox()}</div>
          <div id="live-region" class="sr-only" aria-live="polite"></div>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
    ], Element.prototype, "columnParams", null);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
    ], Element.prototype, "columnFilterModel", null);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "columnRowData", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "columnRowDataObj", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "filteredColumnRowData", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)(".search-filter-input")
    ], Element.prototype, "searchInputElement", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)("#live-region")
    ], Element.prototype, "liveRegion", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("filter-column-menu")
    ], Element);
    FilterColumnMenu.Element = Element;
})(FilterColumnMenu || (FilterColumnMenu = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/ColumnMenu/PinColumnMenu.ts":
/*!**************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/ColumnMenu/PinColumnMenu.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PinColumnMenu: () => (/* binding */ PinColumnMenu)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ColumnMenu_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ColumnMenu.scss */ "./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenu.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var PinColumnMenu;
(function (PinColumnMenu) {
    /**
     * @element pin-column-menu
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.pinnedDirection = ["left", "right", null];
            this.coulmnPinnedDirection = null;
        }
        get columnParams() {
            return this._columnParams;
        }
        set columnParams(value) {
            const oldValue = this._columnParams;
            this._columnParams = value;
            this.requestUpdate("columnParams", oldValue);
        }
        static get styles() {
            return _ColumnMenu_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
        }
        get columnPinnedDirectionIndex() {
            return this.pinnedDirection.indexOf(this.coulmnPinnedDirection);
        }
        getColumnPinnedDirectionValue(pinnedType) {
            var _a;
            return (_a = pinnedType === null || pinnedType === void 0 ? void 0 : pinnedType.toString()) !== null && _a !== void 0 ? _a : "";
        }
        handlePinnedDirectionChange(pinDirection) {
            var _a, _b, _c;
            if (!this.columnParams) {
                return;
            }
            (_a = this.columnParams.api) === null || _a === void 0 ? void 0 : _a.setColumnsPinned([this.columnParams.column.getColId()], pinDirection);
            (_b = this.columnParams.api) === null || _b === void 0 ? void 0 : _b.hidePopupMenu();
            this.coulmnPinnedDirection = (_c = this.columnParams.column) === null || _c === void 0 ? void 0 : _c.getPinned();
        }
        getCheckBoxLabel(pinDirection) {
            switch (pinDirection) {
                case "left":
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.pinToLeft");
                case "right":
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.pinToRight");
                default:
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.none");
            }
        }
        connectedCallback() {
            var _a, _b;
            super.connectedCallback();
            this.coulmnPinnedDirection = (_b = (_a = this.columnParams) === null || _a === void 0 ? void 0 : _a.column) === null || _b === void 0 ? void 0 : _b.getPinned();
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="pin-tab-wrapper">
          <md-radiogroup
            group-label="group_process"
            checked=${this.columnPinnedDirectionIndex}
            @radio-change=${(event) => this.handlePinnedDirectionChange(event.detail.selected)}
          >
            ${this.pinnedDirection.map((pinDirection) => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
                <md-radio
                  class="pin-tab-radio-btn"
                  slot="radio"
                  value=${this.getColumnPinnedDirectionValue(pinDirection)}
                >
                  ${this.getCheckBoxLabel(pinDirection)}
                </md-radio>
              `;
            })}
          </md-radiogroup>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "columnParams", null);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Array })
    ], Element.prototype, "pinnedDirection", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "coulmnPinnedDirection", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("pin-column-menu")
    ], Element);
    PinColumnMenu.Element = Element;
})(PinColumnMenu || (PinColumnMenu = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/ContextMenu.ts":
/*!*************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/ContextMenu.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TeamPerformanceContextMenu: () => (/* binding */ TeamPerformanceContextMenu)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CellRenderer/ActionRenderer */ "./src/components/TeamPerformanceWidget/CellRenderer/ActionRenderer.ts");
/* harmony import */ var _contextMenu_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./contextMenu.scss */ "./src/components/TeamPerformanceWidget/contextMenu.scss");
/* harmony import */ var _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./TeamPerformanceUtils */ "./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./utils/WebexChat.utils */ "./src/components/TeamPerformanceWidget/utils/WebexChat.utils.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









const cannotMonitorConsult = "app:tpw.cannotMonitorConsult";
const cannotMonitorWrapUp = "app:tpw.cannotMonitorWrapUp";
const cannotMonitorWrapUpAssistance = "app:tpw.cannotMonitorWrapUpAssistance";
const cannotMonitorPostCall = "app:tpw:cannotMonitorPostCall";
const reviewAndMonitor = "app:tpw.reviewAndMonitor";
const review = "app:tpw.review";
var TeamPerformanceContextMenu;
(function (TeamPerformanceContextMenu) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.isOpen = false;
            this.contextMenuList = [];
            this.listItems = [];
            this.isMCMEnabled = false;
            this.isMPCorPersistEnabled = false;
            this.isPostCallEnabled = false;
            this.webexEnabled = false;
            this.isSupervisorySendMessageEnabled = false;
            this.agentId = "";
            this.isSameSupervisorBarged = () => {
                return this.actionCellConfigs.isSupervisorMonitoring && this.actionCellConfigs.isBarged;
            };
            this.getIsMonitoring = () => {
                return (this.actionCellConfigs.monitoredBy &&
                    this.actionCellConfigs.monitoredBy !== "" &&
                    this.actionCellConfigs.monitoredBy !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE);
            };
            this.getTooltipMessage = () => {
                if (this.isWrapUp) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(cannotMonitorWrapUp);
                }
                else if (this.isMainCallInPostCall) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(cannotMonitorPostCall);
                }
                else if (this.isWrapUpAssistance) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(cannotMonitorWrapUpAssistance);
                }
                else if (this.actionCellConfigs.isConsultCall) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(cannotMonitorConsult);
                }
                else if (this.isSameSupervisorBarged()) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.alreadyBargedIn");
                }
                else if (this.actionCellConfigs.isSupervisorMonitoring) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.alreadyMonitoring");
                }
                else if (this.isMCMEnabled) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(reviewAndMonitor);
                }
                else {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(review);
                }
            };
            this.getReviewButton = (disabled = false) => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-button
          id=${this.actionCellConfigs.agentId}
          aria-colindex="12"
          tabIndex="-1"
          class="aid-button btn-action"
          ariaLabel="${this.isMCMEnabled ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(reviewAndMonitor) : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(review)}"
          size="size-none"
          .disabled=${disabled}
          color="color-none"
          @click=${(event) => {
                    if (disabled) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }}
        >
          <p class="rm-text ${disabled ? "disabled" : ""}">${this.isMCMEnabled ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(reviewAndMonitor) : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(review)}</p>
        </md-button>
      `;
            };
            this.getIsReviewAndMonitorTooltipNeeded = () => {
                return ((!this.actionCellConfigs.isSupervisorMonitoring &&
                    this.actionCellConfigs.isReviewAndMonitorEnabled &&
                    !this.actionCellConfigs.onActiveCall) ||
                    this.actionCellConfigs.isConsultCall ||
                    this.isWrapUp ||
                    this.isWrapUpAssistance ||
                    this.isMainCallInPostCall ||
                    this.isSameSupervisorBarged() ||
                    this.actionCellConfigs.isSupervisorMonitoring);
            };
            this.renderReviewAndMonitorWrapper = () => {
                // This Tooltip scanerio need to validate...
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="${`review-monitor-wrapper list `}">
          ${this.getIsReviewAndMonitorTooltipNeeded()
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                <md-tooltip class="aid-tooltip" message="${this.getTooltipMessage()}" placement="top">
                  ${this.getReviewButton(this.actionCellConfigs.isConsultCall ||
                        this.isWrapUp ||
                        this.isWrapUpAssistance ||
                        this.isMainCallInPostCall ||
                        this.isSameSupervisorBarged() ||
                        this.actionCellConfigs.isSupervisorMonitoring)}
                </md-tooltip>
              `
                    : this.getReviewButton(true)}
        </div>
      `;
            };
            this.webExMessageError = () => {
                var _a, _b;
                const agentEmail = (_b = (_a = this.actionCellConfigs) === null || _a === void 0 ? void 0 : _a.agentEmail) !== null && _b !== void 0 ? _b : "";
                return (this.actionCellConfigs.isWebExSendingMessageError ||
                    (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_8__.getPersistedError)(this.actionCellConfigs.agentName, agentEmail));
            };
            this.handleAidModal = () => {
                var _a, _b, _c;
                const selectChatElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-list-item.review-and-monitor");
                if (selectChatElement) {
                    const mdButton = selectChatElement === null || selectChatElement === void 0 ? void 0 : selectChatElement.querySelector("md-button");
                    if (mdButton) {
                        const isReviewAndMonitorDisabled = (_c = (_b = mdButton.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("button")) === null || _c === void 0 ? void 0 : _c.hasAttribute("disabled");
                        if (isReviewAndMonitorDisabled) {
                            return false;
                        }
                    }
                }
                this.dispatchEvent((0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_6__.createGenericEvent)(_constants__WEBPACK_IMPORTED_MODULE_0__.HANDLE_AID_MODAL_EVENT, {
                    agentId: this.actionCellConfigs.agentId
                }));
                return true;
            };
            this.handleSendMessage = () => {
                var _a;
                const selectChatElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-list-item.webex-send-message");
                if (selectChatElement) {
                    this.dispatchEvent((0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_6__.createGenericEvent)(_constants__WEBPACK_IMPORTED_MODULE_0__.HANDLE_WEBEX_CHAT_EVENT, {
                        event: selectChatElement
                    }));
                }
            };
            this.handleAgentStateChange = () => {
                var _a, _b;
                const selectChatElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-list-item.agent-state-change");
                this.dispatchEvent((0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_6__.createGenericEvent)(_constants__WEBPACK_IMPORTED_MODULE_0__.HANDLE_STATE_CHANGE_EVENT, {
                    event: selectChatElement,
                    agentId: (_b = this.actionCellConfigs) === null || _b === void 0 ? void 0 : _b.agentId
                }));
            };
            this.handleAgentSignout = () => {
                var _a, _b;
                const selectChatElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-list-item.agent-signout");
                this.dispatchEvent((0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_6__.createGenericEvent)(_constants__WEBPACK_IMPORTED_MODULE_0__.HANDLE_AGENT_SIGNOUT_EVENT, {
                    event: selectChatElement,
                    agentId: (_b = this.actionCellConfigs) === null || _b === void 0 ? void 0 : _b.agentId
                }));
            };
            this.handleSelection = (selected) => {
                const components = this.getComponents();
                if (components[selected]) {
                    if (components[selected] === _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.REVIEW_AND_MONITOR) {
                        this.handleAidModal();
                    }
                    else if (components[selected] === _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.SEND_MESSAGE) {
                        this.handleSendMessage();
                    }
                    else if (components[selected] === _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.AGENT_STATE_CHANGE) {
                        this.handleAgentStateChange();
                    }
                    else if (components[selected] === _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.SIGNOUT_AGENT) {
                        this.handleAgentSignout();
                    }
                }
                return true;
            };
            this.isAgentStateDisabled = () => {
                return this.actionCellConfigs.agentId === this.actionCellConfigs.supervisorId;
            };
            this.isWebexChatDisabled = () => {
                if (this.isSupervisorySendMessageEnabled) {
                    return (this.actionCellConfigs.agentId === this.actionCellConfigs.supervisorId ||
                        this.actionCellConfigs.agentEmail === "");
                }
                // Disable webex chat
                return true;
            };
            this.getComponents = () => {
                const isMonitoring = this.getIsMonitoring();
                const contextMenuList = Array.isArray(this.contextMenuList) ? this.contextMenuList : [];
                if (isMonitoring) {
                    return [_CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.REVIEW_AND_MONITOR, ...contextMenuList];
                }
                else {
                    return contextMenuList;
                }
            };
            this.focusLitItem = () => {
                var _a, _b, _c, _d, _e;
                const listItem = (_a = this.list) === null || _a === void 0 ? void 0 : _a.querySelector("md-list-item:not([disabled])");
                listItem === null || listItem === void 0 ? void 0 : listItem.focus();
                // Set the selected and activated index based on the list-item
                const listItems = (_b = this.list) === null || _b === void 0 ? void 0 : _b.querySelectorAll("md-list-item");
                const index = (_c = Array.from(listItems)) === null || _c === void 0 ? void 0 : _c.findIndex((it) => !it.disabled);
                if (index >= 0) {
                    (_d = this.list) === null || _d === void 0 ? void 0 : _d.setAttribute("activated", `${index}`);
                    (_e = this.list) === null || _e === void 0 ? void 0 : _e.setAttribute("selected", `${index}`);
                }
            };
            this.renderSpinner = () => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <md-spinner size="14"></md-spinner> `;
            };
            this.renderErrorElement = () => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="error-icon">
          <md-icon slot="icon" name="icon-priority-active-two_12"></md-icon>
        </div>
      `;
            };
            this.renderComponentName = (label, isDisabled, isLoading, isError, subMenu = false) => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="list-type-container">
          <div class="list-text-wrapper">
            <p class="list-text ${isDisabled ? "disabled" : ""}">
              ${label}
            </p>

            ${isLoading ? this.renderSpinner() : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
            ${!isLoading && isError ? this.renderErrorElement() : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}

          </div>
          ${subMenu ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <md-icon class="list-arrow-icon" iconSet="momentumDesign" name="arrow-right-bold"></md-icon> ` : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
          </div>
        </div>
      `;
            };
            this.handleReviewMonitorDisabled = () => {
                const { isReviewAndMonitorEnabled, isConsultCall, isSupervisorMonitoring, onActiveCall } = this.actionCellConfigs;
                if (!isReviewAndMonitorEnabled) {
                    return !isConsultCall;
                }
                else if (isSupervisorMonitoring) {
                    return false;
                }
                else if (onActiveCall) {
                    return true;
                }
                return false;
            };
            this.getLabelOnReviewAndMonitor = () => {
                const defaultLabel = this.isMCMEnabled ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(reviewAndMonitor) : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(review);
                if (this.actionCellConfigs.isConsultCall) {
                    return `${defaultLabel} - ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(cannotMonitorConsult)}`;
                }
                return defaultLabel;
            };
            this.isDisabledCursor = () => {
                return (this.isSameSupervisorBarged() ||
                    this.actionCellConfigs.isSupervisorMonitoring ||
                    this.actionCellConfigs.isConsultCall);
            };
            this.renderReviewAndMonitor = () => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-list-item
          class=${`review-and-monitor  ${this.isDisabledCursor() ? "disabled-cursor" : ""} `}
          .disabled="${this.handleReviewMonitorDisabled()}"
          aria-label="${this.getLabelOnReviewAndMonitor()}"
          slot="list-item"
          role="menuitem"
        >
          ${this.renderReviewAndMonitorWrapper()}
        </md-list-item>
      `;
            };
            this.renderSendMessage = () => {
                const isDisabled = this.isWebexChatDisabled();
                const label = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.webexChatSendMessage");
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-list-item class="webex-send-message" .disabled="${isDisabled}" slot="list-item" role="menuitem">
          ${this.renderComponentName(label, isDisabled, this.actionCellConfigs.isWebExSendingMessage || false, this.webExMessageError())}
        </md-list-item>
      `;
            };
            this.renderAgentStateChange = () => {
                const isDisabled = this.isAgentStateDisabled();
                const label = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.stateChange.default");
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-list-item class="agent-state-change" .disabled="${isDisabled}" slot="list-item" role="menuitem">
          ${this.renderComponentName(label, false, this.actionCellConfigs.agentStateChanging || false, this.actionCellConfigs.agentStateChangeError || false, true)}
        </md-list-item>
      `;
            };
            this.renderSignoutAgent = () => {
                const isDisabled = (0,_Utils__WEBPACK_IMPORTED_MODULE_7__.isAgentSignoutDisabled)(this.actionCellConfigs);
                const tooltipText = (0,_Utils__WEBPACK_IMPORTED_MODULE_7__.getSignoutTooltip)(this.actionCellConfigs, isDisabled);
                const label = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.signoutAgentMenu");
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-list-item
          class="agent-signout"
          slot="list-item"
          aria-label=${tooltipText}
          .disabled=${isDisabled}
          role="menuitem"
        >
          <md-tooltip message=${tooltipText} placement="left">
            ${this.renderComponentName(label, false, this.actionCellConfigs.signoutPending || false, this.actionCellConfigs.signoutError || false, false)}
          </md-tooltip>
        </md-list-item>
      `;
            };
            // Render the list items
            this.renderElements = (componentName) => {
                switch (componentName) {
                    case _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.REVIEW_AND_MONITOR:
                        return this.renderReviewAndMonitor();
                    case _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.SEND_MESSAGE:
                        return this.renderSendMessage();
                    case _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.AGENT_STATE_CHANGE:
                        return this.renderAgentStateChange();
                    case _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_4__.SIGNOUT_AGENT:
                        return this.renderSignoutAgent();
                    default:
                        return lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing;
                }
            };
        }
        static get styles() {
            return _contextMenu_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
        }
        get isWrapUp() {
            return this.isMPCorPersistEnabled && this.actionCellConfigs.isWrapUp;
        }
        get isWrapUpAssistance() {
            return this.isMPCorPersistEnabled && !this.isPostCallEnabled && this.actionCellConfigs.isWrapUpAssistance;
        }
        get isMainCallInPostCall() {
            return this.isMPCorPersistEnabled && this.isPostCallEnabled && this.actionCellConfigs.isMainCallInPostCall;
        }
        updated(_changedProperties) {
            super.updated(_changedProperties);
            if ((_changedProperties.has("agentId") ||
                _changedProperties.has("isOpen") ||
                _changedProperties.has("contextMenuList")) &&
                this.isOpen &&
                this.list) {
                setTimeout(() => {
                    this.focusLitItem();
                }, 0);
            }
        }
        render() {
            const items = this.getComponents();
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="overlay-content kebab-menu-container">
          <md-list
            label="Kebab Menu Items"
            @list-item-change="${(event) => {
                this.handleSelection(event.detail.selected);
            }}"
          >
            ${items.map((componentName) => {
                return this.renderElements(componentName);
            })}
          </md-list>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "actionCellConfigs", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
    ], Element.prototype, "contextMenuList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "listItems", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isMCMEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isMPCorPersistEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isPostCallEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "webexEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ attribute: false })
    ], Element.prototype, "handleWebexChat", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isSupervisorySendMessageEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "agentId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)("md-list")
    ], Element.prototype, "list", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-tpw-context-menu")
    ], Element);
    TeamPerformanceContextMenu.Element = Element;
})(TeamPerformanceContextMenu || (TeamPerformanceContextMenu = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/GridConfig.ts":
/*!************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/GridConfig.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   gridConfig: () => (/* binding */ gridConfig)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CellRenderer/ActionRenderer */ "./src/components/TeamPerformanceWidget/CellRenderer/ActionRenderer.ts");
/* harmony import */ var _CellRenderer_AgentStateRenderer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CellRenderer/AgentStateRenderer */ "./src/components/TeamPerformanceWidget/CellRenderer/AgentStateRenderer.ts");
/* harmony import */ var _CellRenderer_DurationRenderer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CellRenderer/DurationRenderer */ "./src/components/TeamPerformanceWidget/CellRenderer/DurationRenderer.ts");
/* harmony import */ var _CellRenderer_GroupRowInnerRenderer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./CellRenderer/GroupRowInnerRenderer */ "./src/components/TeamPerformanceWidget/CellRenderer/GroupRowInnerRenderer.ts");
/* harmony import */ var _CellRenderer_NameRenderer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./CellRenderer/NameRenderer */ "./src/components/TeamPerformanceWidget/CellRenderer/NameRenderer.ts");
/* harmony import */ var _ColumnMenu_ColumnMenuRenderer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./ColumnMenu/ColumnMenuRenderer */ "./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenuRenderer.ts");
/* harmony import */ var _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./TeamPerformanceUtils */ "./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _utils_KeyboardNavigationUtils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./utils/KeyboardNavigationUtils */ "./src/components/TeamPerformanceWidget/utils/KeyboardNavigationUtils.ts");











const gridConfig = (configs, isServerSidePaginated = false) => {
    const AGENT_NAME = `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.AgentName")}`;
    function template(header, tooltip, isAgentNameColumn = false) {
        const ariaLabel = `${header ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(header) : ""} ${tooltip ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(tooltip) : ""}`.trim();
        return `<div class="ag-cell-label-container" role="presentation">
        ${isServerSidePaginated && isAgentNameColumn
            ? `<md-tooltip message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.ColumnHeaderWarning")}" placement="bottom">`
            : ``}
          <div data-ref="eLabel" class="ag-header-cell-label" role="button">
            <span data-ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>
            <span data-ref="eText" class="ag-header-cell-text" role="columnheader" ${ariaLabel ? `aria-label="${ariaLabel}"` : ""}></span>
            <span data-ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.ascendingAriaLabel")}"></span>
            <span data-ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.descendingAriaLabel")}"></span>
            <span data-ref="eSortNone" class="ag-header-icon ag-sort-none-icon" aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.noSortAriaLabel")}"></span>
          </div>
        ${isServerSidePaginated && isAgentNameColumn ? `</md-tooltip>` : ``}
        <span data-ref="eFilter" class="ag-header-icon ag-filter-icon" aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnHeaderFilterIconLabel")}"></span>
        <span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnHeaderFilterMenuAriaLabel")}" role="button"></span>
        <span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button" aria-hidden="true"></span>
      </div>`;
    }
    return {
        components: {
            actionBtnsCellRenderer: _CellRenderer_ActionRenderer__WEBPACK_IMPORTED_MODULE_2__["default"],
            nameRenderer: _CellRenderer_NameRenderer__WEBPACK_IMPORTED_MODULE_6__["default"],
            columnMenuRenderer: _ColumnMenu_ColumnMenuRenderer__WEBPACK_IMPORTED_MODULE_7__["default"],
            groupRowInnerRenderer: _CellRenderer_GroupRowInnerRenderer__WEBPACK_IMPORTED_MODULE_5__["default"],
            durationRenderer: _CellRenderer_DurationRenderer__WEBPACK_IMPORTED_MODULE_4__["default"],
            agentStateRenderer: _CellRenderer_AgentStateRenderer__WEBPACK_IMPORTED_MODULE_3__["default"]
        },
        groupDisplayType: "groupRows",
        groupRowRendererParams: {
            innerRenderer: "groupRowInnerRenderer",
            suppressCount: true
        },
        pagination: false,
        rowBuffer: 20,
        suppressDragLeaveHidesColumns: true,
        suppressScrollOnNewData: true,
        suppressContextMenu: true,
        overlayLoadingTemplate: `<agentx-wc-widget-loader></agentx-wc-widget-loader>`,
        overlayNoRowsTemplate: `<agentx-wc-tpw-empty-grid is-error="${configs().isError ? "1" : "0"}"></agentx-wc-tpw-empty-grid>`,
        defaultColDef: {
            enableCellChangeFlash: false,
            resizable: true,
            enablePivot: false,
            enableRowGroup: true,
            enableValue: true,
            menuTabs: ["filterMenuTab"],
            sortable: true,
            rowGroup: false,
            sort: undefined,
            minWidth: 88,
            suppressKeyboardEvent: _utils_KeyboardNavigationUtils__WEBPACK_IMPORTED_MODULE_10__.suppressKeyboardEvent,
            suppressHeaderKeyboardEvent: _utils_KeyboardNavigationUtils__WEBPACK_IMPORTED_MODULE_10__.suppressHeaderKeyboardEvent,
            suppressHeaderFilterButton: true
        },
        columnMenu: "legacy",
        icons: {
            menu: '<md-icon name="settings-bold" iconSet="momentumDesign" size="16" class="settings-icon"></md-icon>',
            menuAlt: '<md-icon name="settings-bold" iconSet="momentumDesign" size="16" class="settings-icon"></md-icon>',
            filter: '<md-icon name="filter-bold" iconSet="momentumDesign" size="16" class="filter-icon"></md-icon>',
            sortAscending: `<div class="sorted up">
        <md-icon name="sort-descending-bold" iconSet="momentumDesign" size="16"></md-icon>
      </div>`,
            sortDescending: `<div class="sorted down">
        <md-icon name="sort-ascending-bold" iconSet="momentumDesign" size="16"></md-icon>
      </div>`,
            groupContracted: '<md-icon name="plus-bold" iconSet="momentumDesign" size="16" class="icon-group"></md-icon>',
            groupExpanded: '<md-icon name="minus-bold" iconSet="momentumDesign" size="16" class="icon-group"></md-icon>',
            clipboardCopy: '<md-icon name="copy-bold" iconSet="momentumDesign" size="16" class="icon-copy_16"></md-icon>'
        },
        alwaysShowHorizontalScroll: true,
        alwaysShowVerticalScroll: false,
        tabToNextCell: _utils_KeyboardNavigationUtils__WEBPACK_IMPORTED_MODULE_10__.onTabToNextCell,
        suppressAnimationFrame: true,
        animateRows: false,
        columnDefs: [
            {
                headerName: AGENT_NAME,
                headerComponentParams: {
                    template: template(AGENT_NAME, AGENT_NAME, true)
                },
                getQuickFilterText: (params) => {
                    return params.value ? params.value.agentName : "";
                },
                field: "agentNameDetails",
                keyCreator: (params) => params.value.agentName,
                resizable: true,
                cellClass: "suppress-movable-col",
                cellRenderer: "nameRenderer",
                filter: "columnMenuRenderer",
                sortable: true,
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__.agentNameComparator,
                filterParams: {
                    suppressFilterTab: false,
                    showWarningTooltip: isServerSidePaginated,
                    valueGetter: (params) => {
                        return params.data.agentName;
                    }
                },
                headerTooltip: AGENT_NAME,
                tooltipComponentParams: { color: "#ececec" },
                pinned: "left",
                lockPinned: true,
                tooltipField: "agentName",
                width: 300,
                hide: false,
                suppressMovable: true,
                lockPosition: true
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.AgentState")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.AgentState")}`,
                field: "agentState",
                sortable: !isServerSidePaginated,
                resizable: true,
                suppressHeaderMenuButton: true,
                filter: "columnMenuRenderer",
                filterParams: {
                    suppressFilterTab: false,
                    showWarningTooltip: isServerSidePaginated
                },
                cellRenderer: "agentStateRenderer",
                cellEditorParams: {
                    supervisorId: configs().supervisorId
                },
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__.stringComparator,
                tooltipValueGetter: (params) => {
                    var _a;
                    // CX-14895 : Available name is not showing in non-english languages when placing the cursor above the Agent Availability Status.
                    return (0,_Utils__WEBPACK_IMPORTED_MODULE_9__.localiseAvailableState)((_a = params === null || params === void 0 ? void 0 : params.value) !== null && _a !== void 0 ? _a : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE);
                },
                pinned: false,
                width: 200,
                hide: false,
                headerComponentParams: {
                    template: `${template()}`
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.AgentStateDuration")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.AgentStateDurationToolTip")}`,
                field: "agentStateDuration",
                resizable: true,
                sortable: !isServerSidePaginated,
                cellRenderer: "durationRenderer",
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__.durationComparator,
                filter: "columnMenuRenderer",
                pinned: undefined,
                width: 200,
                hide: false,
                filterParams: {
                    suppressFilterTab: true
                },
                getQuickFilterText: () => {
                    return "";
                },
                headerComponentParams: {
                    template: `${template("app:tpw.AgentStateDuration", "app:tpw.AgentStateDurationToolTip")}`
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.PhoneNumber")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.PhoneNumber")}`,
                field: "phoneNumber",
                sortable: !isServerSidePaginated,
                resizable: true,
                filter: "columnMenuRenderer",
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__.stringComparator,
                pinned: undefined,
                tooltipField: "phoneNumber",
                width: 200,
                hide: false,
                headerComponentParams: {
                    template: `${template()}`
                },
                filterParams: {
                    suppressFilterTab: false,
                    showWarningTooltip: isServerSidePaginated
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Site")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Site")}`,
                field: "siteName",
                sortable: !isServerSidePaginated,
                resizable: true,
                filter: "columnMenuRenderer",
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__.stringComparator,
                tooltipField: "siteName",
                pinned: undefined,
                hide: false,
                width: 104,
                headerComponentParams: {
                    template: `${template()}`
                },
                filterParams: {
                    suppressFilterTab: false,
                    showWarningTooltip: isServerSidePaginated
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Team")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Team")}`,
                field: "teamName",
                sortable: !isServerSidePaginated,
                resizable: true,
                filter: "columnMenuRenderer",
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__.stringComparator,
                tooltipField: "teamName",
                pinned: undefined,
                hide: false,
                width: 160,
                headerComponentParams: {
                    template: `${template()}`
                },
                filterParams: {
                    suppressFilterTab: false,
                    showWarningTooltip: isServerSidePaginated
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Channels")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Channels")}`,
                field: "channelsName",
                sortable: !isServerSidePaginated,
                resizable: true,
                filter: "columnMenuRenderer",
                filterParams: {
                    suppressFilterTab: false,
                    showWarningTooltip: isServerSidePaginated
                },
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__.stringComparator,
                tooltipField: "channelsName",
                pinned: undefined,
                hide: true,
                sort: undefined,
                width: 130,
                headerComponentParams: {
                    template: `${template()}`
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.ContactQueue")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.ContactQueue")}`,
                field: "contactQueueName",
                sortable: !isServerSidePaginated,
                resizable: true,
                filter: "columnMenuRenderer",
                filterParams: {
                    suppressFilterTab: false,
                    showWarningTooltip: isServerSidePaginated
                },
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__.stringComparator,
                tooltipField: "contactQueueName",
                pinned: undefined,
                hide: true,
                width: 130,
                headerComponentParams: {
                    template: `${template()}`
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.ContactStatus")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.ContactStatus")}`,
                field: "contactStatus",
                sortable: !isServerSidePaginated,
                resizable: true,
                filter: "columnMenuRenderer",
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__.stringComparator,
                tooltipField: "contactStatus",
                pinned: undefined,
                width: 224,
                hide: false,
                filterParams: {
                    suppressFilterTab: false,
                    showWarningTooltip: isServerSidePaginated
                },
                headerComponentParams: {
                    template: `${template()}`
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.TimeInContactStatus")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.TimeInContactStatusToolTip")}`,
                field: "contactStatusTime",
                sortable: !isServerSidePaginated,
                resizable: true,
                filter: "columnMenuRenderer",
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__.durationComparator,
                cellRenderer: "durationRenderer",
                rowGroup: false,
                pinned: undefined,
                width: 224,
                hide: false,
                filterParams: {
                    suppressFilterTab: true
                },
                getQuickFilterText: () => {
                    return "";
                },
                headerComponentParams: {
                    template: `${template("app:tpw.TimeInContactStatus", "app:tpw.TimeInContactStatusToolTip")}`
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.AgentInteractionTime")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.AgentInteractionTimeToolTip")}`,
                field: "agentInteractionTime",
                sortable: !isServerSidePaginated,
                resizable: true,
                cellRenderer: "durationRenderer",
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__.durationComparator,
                filter: "columnMenuRenderer",
                pinned: undefined,
                width: 224,
                hide: false,
                filterParams: {
                    suppressFilterTab: true
                },
                getQuickFilterText: () => {
                    return "";
                },
                headerComponentParams: {
                    template: `${template("app:tpw.AgentInteractionTime", "app:tpw.AgentInteractionTimeToolTip")}`
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.TotalContactDuration")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.TotalContactDurationToolTip")}`,
                field: "totalContactDuration",
                sortable: !isServerSidePaginated,
                resizable: true,
                cellRenderer: "durationRenderer",
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__.durationComparator,
                filter: "columnMenuRenderer",
                pinned: undefined,
                width: 224,
                hide: false,
                filterParams: {
                    suppressFilterTab: true
                },
                getQuickFilterText: () => {
                    return "";
                },
                headerComponentParams: {
                    template: `${template("app:tpw.TotalContactDuration", "app:tpw.TotalContactDurationToolTip")}`
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.SignInTime")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.SignInTime")}`,
                field: "loginTime",
                sortable: !isServerSidePaginated,
                resizable: true,
                filter: "columnMenuRenderer",
                tooltipField: "loginTime",
                comparator: _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__.dateComparator,
                pinned: undefined,
                width: 200,
                hide: false,
                sort: "asc",
                filterParams: {
                    suppressFilterTab: true
                },
                getQuickFilterText: () => {
                    return "";
                },
                headerComponentParams: {
                    template: `${template()}`
                }
            },
            {
                headerName: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Actions")}`,
                headerTooltip: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Actions")}`,
                field: "actions",
                sortable: false,
                resizable: true,
                cellRenderer: "actionBtnsCellRenderer",
                cellClass: "action-class",
                cellEditorParams: configs,
                pinned: "right",
                lockPinned: true,
                width: 117,
                hide: false,
                suppressMovable: true,
                filter: "columnMenuRenderer",
                filterParams: {
                    suppressFilterTab: true
                },
                getQuickFilterText: () => {
                    return "";
                },
                headerComponentParams: {
                    template: `<div class="ag-cell-label-container" role="presentation">
            <div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
              <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
            </div>
            <span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" role="button"></span>
          </div>`
                }
            }
        ]
    };
};


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/GridHeader/Customization/Customization.ts":
/*!****************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/GridHeader/Customization/Customization.ts ***!
  \****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Customization: () => (/* binding */ Customization)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _GridHeader_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../GridHeader.scss */ "./src/components/TeamPerformanceWidget/GridHeader/GridHeader.scss");
/* harmony import */ var _GroupByCustomization__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./GroupByCustomization */ "./src/components/TeamPerformanceWidget/GridHeader/Customization/GroupByCustomization.ts");
/* harmony import */ var _ShowHideCustomization__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ShowHideCustomization */ "./src/components/TeamPerformanceWidget/GridHeader/Customization/ShowHideCustomization.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};







var Customization;
(function (Customization) {
    /**
     * @element agentx-wc-tpw-customization
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.gridOptions = {};
            this.isServerSidePaginated = false;
            this.isModalOpen = false;
            this.visibleColumns = {};
            this.rowGroupedColumns = [];
            this.columnRowGroupChangedHandler = () => {
                this === null || this === void 0 ? void 0 : this.initializeRowGroupedColumns();
            };
            this.columnValueChangedHandler = () => {
                // reset visible columns.
                this.visibleColumns = {};
                this.initializeVisibleColumns();
            };
            this.handleVisibleColumnsUpdate = (event) => {
                this.visibleColumns = event.detail;
            };
        }
        static get styles() {
            return _GridHeader_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        initializeRowGroupedColumns() {
            var _a, _b;
            if (this.gridApi) {
                const rowGroupuColumns = (_b = (_a = this.gridApi.getRowGroupColumns()) === null || _a === void 0 ? void 0 : _a.map((column) => column.colId)) !== null && _b !== void 0 ? _b : [];
                const isChanged = (rowGroupuColumns.length === 0 && this.rowGroupedColumns.length === 0) === false;
                if (isChanged) {
                    this.rowGroupedColumns = rowGroupuColumns;
                }
            }
        }
        connectedCallback() {
            var _a, _b;
            super.connectedCallback();
            (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.addEventListener("columnRowGroupChanged", this.columnRowGroupChangedHandler);
            (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.addEventListener("gridColumnsChanged", this.columnValueChangedHandler);
            window.addEventListener("tpw-update-visible-columns", this.handleVisibleColumnsUpdate);
        }
        disconnectedCallback() {
            var _a, _b;
            super.disconnectedCallback();
            (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.removeEventListener("columnRowGroupChanged", this.columnRowGroupChangedHandler);
            (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.removeEventListener("gridColumnsChanged", this.columnValueChangedHandler);
            window.removeEventListener("tpw-update-visible-columns", this.handleVisibleColumnsUpdate);
        }
        initializeVisibleColumns() {
            if (Object.keys(this.visibleColumns).length === 0 && this.gridApi) {
                const columnsState = this.gridApi.getColumnState();
                columnsState === null || columnsState === void 0 ? void 0 : columnsState.forEach((column) => {
                    if (!_Utils__WEBPACK_IMPORTED_MODULE_3__.fixedColumns[column.colId]) {
                        this.visibleColumns[column.colId] = !column.hide;
                    }
                });
            }
        }
        updated(changedProperties) {
            const _super = Object.create(null, {
                updated: { get: () => super.updated }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.updated.call(this, changedProperties);
                if (Object.keys(this.visibleColumns).length === 0) {
                    this.initializeRowGroupedColumns();
                    this.initializeVisibleColumns();
                }
            });
        }
        handleKeyPressed(e) {
            var _a, _b, _c, _d;
            if (e.code === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Enter || e.code === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Space) {
                (_d = (_c = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.children[0]) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector(".menu-trigger-button")) === null || _d === void 0 ? void 0 : _d.click();
            }
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-menu-overlay
          custom-width="154px"
          @menu-overlay-open=${() => {
                this.isModalOpen = true;
            }}
          @menu-overlay-close=${() => {
                this.isModalOpen = false;
            }}
          class="customization"
        >
          <md-button slot="menu-trigger" variant="ghost" ariaExpanded=${this.isModalOpen} class="customization-btn"
            ><md-icon slot="icon" aria-hidden="true" name="icon-settings_16"></md-icon
            ><span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.customization")}</span></md-button
          >
          <div class="customization-menu-overlay">
            <md-list label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.customization")}" role="menu">
              <md-list-item
                class="custom-list"
                slot="list-item"
                aria-haspopup="menu"
                role="menuitem"
                @keypress=${(e) => this.handleKeyPressed(e)}
              >
                <agentx-wc-tpw-show-hide
                  .gridApi=${this.gridApi}
                  .gridOptions=${this.gridOptions}
                  .visibleColumns=${this.visibleColumns}
                ></agentx-wc-tpw-show-hide>
              </md-list-item>

              <md-list-item
                class="custom-list"
                slot="list-item"
                aria-haspopup="menu"
                role="menuitem"
                .disabled=${this.isServerSidePaginated}
                @keypress=${(e) => this.handleKeyPressed(e)}
              >
                <agentx-wc-tpw-group-by
                  .gridApi=${this.gridApi}
                  .gridOptions=${this.gridOptions}
                  .visibleColumns=${this.visibleColumns}
                  .rowGroupedColumns=${this.rowGroupedColumns}
                  .isServerSidePaginated=${this.isServerSidePaginated}
                ></agentx-wc-tpw-group-by>
              </md-list-item>
            </md-list>
          </div>
        </md-menu-overlay>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "gridOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "gridApi", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isServerSidePaginated", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "visibleColumns", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "rowGroupedColumns", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-tpw-customization")
    ], Element);
    Customization.Element = Element;
})(Customization || (Customization = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/GridHeader/Customization/GroupByCustomization.ts":
/*!***********************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/GridHeader/Customization/GroupByCustomization.ts ***!
  \***********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GroupByCustomization: () => (/* binding */ GroupByCustomization)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _GridHeader_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../GridHeader.scss */ "./src/components/TeamPerformanceWidget/GridHeader/GridHeader.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var GroupByCustomization;
(function (GroupByCustomization) {
    /**
     * @element agentx-wc-tpw-group-by
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4__.MobxLitElement) {
        constructor() {
            super(...arguments);
            this.gridOptions = {};
            this.rowGroupedColumns = [];
            this.visibleColumns = {};
            this.isServerSidePaginated = false;
            this.groupBySearchTerm = "";
            this.handleSearch = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.debounce)((event) => {
                var _a, _b;
                event.stopPropagation();
                const searchTerm = (_b = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.toLowerCase();
                this.groupBySearchTerm = searchTerm;
                setTimeout(() => {
                    this.handleFocus(event);
                }, 100);
                this.requestUpdate();
            }, 300);
        }
        static get styles() {
            return _GridHeader_scss__WEBPACK_IMPORTED_MODULE_7__["default"];
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.gridOptions = {};
            this.rowGroupedColumns = [];
            this.visibleColumns = {};
        }
        getColumnsHeaderName() {
            var _a, _b;
            return (_b = (_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.columnDefs) === null || _b === void 0 ? void 0 : _b.filter((column) => {
                var _a;
                return (_a = column.headerName) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase().includes(this.groupBySearchTerm);
            });
        }
        handleGroupByRowData(event, columnDetail) {
            var _a, _b;
            if (event) {
                const isCheckboxChecked = (0,_Utils__WEBPACK_IMPORTED_MODULE_3__.getIsCheckboxChecked)(event);
                if (isCheckboxChecked && columnDetail.field) {
                    this.rowGroupedColumns.push(columnDetail.field);
                }
                else {
                    this.rowGroupedColumns = this.rowGroupedColumns.filter((column) => {
                        return column !== columnDetail.field;
                    });
                }
                (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setRowGroupColumns(this.rowGroupedColumns);
                if (columnDetail.field && this.visibleColumns[columnDetail.field] === false) {
                    (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.setColumnsVisible([columnDetail.field], false);
                }
            }
        }
        handleFocus(event) {
            var _a, _b;
            const searchInput = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".group-by-header-wrapper md-input");
            const input = (_b = searchInput === null || searchInput === void 0 ? void 0 : searchInput.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("input");
            if (searchInput && input) {
                input.focus({ focusVisible: true });
            }
            event.stopPropagation();
        }
        handleClick(event) {
            // the click event, unless stopped from bubbling up to parent, will fire that handler and cause focus issues
            event.stopPropagation();
        }
        renderMenuTriggerButton() {
            const buttonStyle = this.isServerSidePaginated ? `color: var(--md-gray-40);` : ``;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <style>
          .menu-trigger-button {
            ${buttonStyle};
          }
        </style>
        <div class="menu-trigger-button" slot="menu-trigger">
          <md-tooltip
            message=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.CustomizeMenuWarning")}
            placement="bottom"
            .disabled=${!this.isServerSidePaginated}
          >
            <span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.groupBy")}</span>
          </md-tooltip>
          <div>
            <md-icon ariaHidden="true" slot="icon" name="arrow-right-bold" size="12" iconSet="momentumDesign"></md-icon>
          </div>
        </div>
      `;
        }
        render() {
            var _a;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-menu-overlay
          .disabled=${this.isServerSidePaginated}
          placement="right-start"
          size="small"
          @menu-overlay-open=${(event) => this.handleFocus(event)}
        >
          ${this.renderMenuTriggerButton()}
          <div class="overlay-container">
            <div class="group-by-header-wrapper">
              <md-input
                clear
                clearAriaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:clear")}"
                htmlId="pillSearchInput"
                name="pillSearchInput"
                shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
                ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
                placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.search")}
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.search")}
                searchable
                @input-change=${(event) => this.handleSearch(event)}
                @click=${(event) => this.handleClick(event)}
              >
              </md-input>
            </div>
            <div class="checkbox-container-group-column">
              <md-checkboxgroup group-label="column_titles">
                ${(_a = this.getColumnsHeaderName()) === null || _a === void 0 ? void 0 : _a.map((column) => {
                if (column.field && !_Utils__WEBPACK_IMPORTED_MODULE_3__.fixedColumns[column.field] && !_Utils__WEBPACK_IMPORTED_MODULE_3__.hiddenGroupColumn[column.field]) {
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                      <md-checkbox
                        class="checkbox"
                        slot="checkbox"
                        ?checked=${this.rowGroupedColumns.indexOf(column.field) !== -1}
                        @checkbox-change=${(event) => this.handleGroupByRowData(event, column)}
                        >${column.headerName}</md-checkbox
                      >
                    `;
                }
                else {
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ``;
                }
            })}
              </md-checkboxgroup>
            </div>
          </div>
        </md-menu-overlay>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "gridOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "gridApi", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
    ], Element.prototype, "rowGroupedColumns", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "visibleColumns", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isServerSidePaginated", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "groupBySearchTerm", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-tpw-group-by")
    ], Element);
    GroupByCustomization.Element = Element;
})(GroupByCustomization || (GroupByCustomization = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/GridHeader/Customization/ShowHideCustomization.ts":
/*!************************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/GridHeader/Customization/ShowHideCustomization.ts ***!
  \************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ShowHideCustomization: () => (/* binding */ ShowHideCustomization)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _GridHeader_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../GridHeader.scss */ "./src/components/TeamPerformanceWidget/GridHeader/GridHeader.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var ShowHideCustomization;
(function (ShowHideCustomization) {
    /**
     * @element agentx-wc-tpw-show-hide
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_4__.MobxLitElement) {
        constructor() {
            super(...arguments);
            this.gridOptions = {};
            this.visibleColumns = {};
            this.showHideSearchTerm = "";
            this.isSelectedAll = () => {
                return Object.values(this.visibleColumns).every(Boolean);
            };
            this.handleSearch = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.debounce)((event) => {
                var _a, _b;
                const searchTerm = (_b = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.toLowerCase();
                this.showHideSearchTerm = searchTerm;
                setTimeout(() => {
                    this.handleFocus(event);
                }, 100);
                this.requestUpdate();
            }, 300);
        }
        static get styles() {
            return _GridHeader_scss__WEBPACK_IMPORTED_MODULE_7__["default"];
        }
        handleFocus(event) {
            var _a, _b;
            const searchInput = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".show-hide-header-wrapper md-input");
            const input = (_b = searchInput === null || searchInput === void 0 ? void 0 : searchInput.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("input");
            if (searchInput && input) {
                input.focus({ focusVisible: true });
            }
            event.stopPropagation();
        }
        handleClick(event) {
            // the click event, unless stopped from bubbling up to parent, will fire that handler and cause focus issues
            event.stopPropagation();
        }
        getColumnsHeaderName() {
            var _a, _b;
            return (_b = (_a = this.gridOptions) === null || _a === void 0 ? void 0 : _a.columnDefs) === null || _b === void 0 ? void 0 : _b.filter((column) => {
                var _a;
                return (_a = column.headerName) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase().includes(this.showHideSearchTerm);
            });
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.gridOptions = {};
            this.visibleColumns = {};
        }
        dispatchVisibleColumnsUpdateEvent() {
            this.dispatchEvent(new CustomEvent("tpw-update-visible-columns", {
                bubbles: true,
                composed: true,
                detail: this.visibleColumns
            }));
        }
        handleShowHideColumn(event, columnDetail) {
            var _a, _b, _c;
            if (event) {
                const isCheckboxChecked = (0,_Utils__WEBPACK_IMPORTED_MODULE_3__.getIsCheckboxChecked)(event);
                if (columnDetail === null || columnDetail === void 0 ? void 0 : columnDetail.field) {
                    this.visibleColumns[columnDetail.field] = isCheckboxChecked;
                    (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setColumnsVisible([columnDetail.field], isCheckboxChecked);
                }
                else {
                    Object.keys(this.visibleColumns).forEach((column) => (this.visibleColumns[column] = isCheckboxChecked));
                    (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.setColumnsVisible(Object.keys(this.visibleColumns), isCheckboxChecked);
                }
                (_c = this.gridApi) === null || _c === void 0 ? void 0 : _c.sizeColumnsToFit();
                this.dispatchVisibleColumnsUpdateEvent();
                this.requestUpdate();
            }
        }
        renderMenuTriggerButton() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="menu-trigger-button" slot="menu-trigger">
          <span>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.showHide")}</span>
          <div>
            <md-icon ariaHidden="true" slot="icon" name="arrow-right-bold" size="12" iconSet="momentumDesign"></md-icon>
          </div>
        </div>
      `;
        }
        render() {
            var _a;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-menu-overlay
          max-height="344px"
          placement="right-start"
          size="small"
          @menu-overlay-open=${(event) => this.handleFocus(event)}
        >
          ${this.renderMenuTriggerButton()}
          <div class="overlay-container">
            <div class="show-hide-header-wrapper">
              <md-input
                clear
                clearAriaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:clear")}"
                htmlId="pillSearchInput"
                name="pillSearchInput"
                shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
                ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumV2Enabled}
                placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.search")}
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.search")}
                searchable
                @input-change=${(event) => this.handleSearch(event)}
                @click=${(event) => this.handleClick(event)}
              >
              </md-input>
              <md-checkbox
                class="checkbox select-all-checkbox"
                ?checked=${this.isSelectedAll()}
                @checkbox-change=${(event) => this.handleShowHideColumn(event)}
                >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.selectAll")}</md-checkbox
              >
            </div>
            <div class="checkbox-container-showhide-column">
              <md-checkboxgroup group-label="column_titles">
                ${(_a = this.getColumnsHeaderName()) === null || _a === void 0 ? void 0 : _a.map((column) => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                    <md-checkbox
                      class="checkbox"
                      slot="checkbox"
                      ?disabled=${!!(column.field && _Utils__WEBPACK_IMPORTED_MODULE_3__.fixedColumns[column.field])}
                      ?checked=${!!(column.field && (this.visibleColumns[column.field] || _Utils__WEBPACK_IMPORTED_MODULE_3__.fixedColumns[column.field]))}
                      @checkbox-change=${(event) => this.handleShowHideColumn(event, column)}
                      >${column.headerName}</md-checkbox
                    >
                  `;
            })}
              </md-checkboxgroup>
            </div>
          </div>
        </md-menu-overlay>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "gridOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "gridApi", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "visibleColumns", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "showHideSearchTerm", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-tpw-show-hide")
    ], Element);
    ShowHideCustomization.Element = Element;
})(ShowHideCustomization || (ShowHideCustomization = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/GridHeader/GridHeader.scss":
/*!*************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/GridHeader/GridHeader.scss ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.grid-header-container {
  padding: 1rem 1rem 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.grid-header-action-container {
  display: flex;
}

.search-wrapper {
  display: flex;
}

.grid-search-input::part(input) {
  width: 324px;
}

.result-count-wrapper {
  font-size: var(--font-size-medium);
  color: var(--md-secondary-text-color);
  margin: 4px 16px;
}

.customization::part(overlay-content) {
  overflow: visible;
}

.customization-menu-overlay {
  width: 100%;
  border-radius: var(--border-radius-medium);
  background-color: var(--md-secondary-white-bg-color);
}

.menu-trigger-button {
  padding: 0.5rem 1.25rem;
  justify-content: space-between;
  display: flex;
  font-size: var(--font-size-medium);
}

.overlay-container {
  width: 100%;
  background-color: var(--md-secondary-white-bg-color);
  display: block;
  overflow: hidden;
}

.show-hide-header-wrapper {
  padding: 1rem 1rem 0rem;
  border-bottom: 1px solid var(--md-primary-seperator-color);
  padding-bottom: 8px;
}

.group-by-header-wrapper {
  padding: 1rem 1rem 0rem;
}

.checkbox-container-group-column {
  padding: 0.5rem 1rem;
  overflow: auto;
  height: calc(100% - 80px);
}

.checkbox-container-showhide-column {
  padding: 0.5rem 1rem;
  overflow: auto;
  height: calc(100% - 130px);
}

.checkbox {
  margin: 0.5rem 0;
  padding-top: 3px;
  padding-bottom: 3px;
}

.select-all-checkbox {
  padding-right: 5.5rem;
}

.switch-view-button::part(button-group) {
  height: 2.25rem;
}

.reset-btn-wrapper .reset-submit {
  margin-left: 10px;
}
.reset-btn-wrapper .reset-submit,
.reset-btn-wrapper .reset-close {
  float: right;
}

.header-width {
  width: 100%;
}

.reset-header {
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
}

.conflict-warning {
  margin-right: 4px;
  vertical-align: middle;
}

.conflict-warning-info {
  margin-left: 4px;
  vertical-align: middle;
}

md-menu-overlay md-list md-list-item.custom-list::part(list-item) {
  display: block;
  padding: 0;
}

md-list-item.custom-list[disabled]::part(list-item) {
  pointer-events: auto;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/TeamPerformanceWidget/GridHeader/GridHeader.scss */
/*# sourceURL=GridHeader.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/GridHeader/GridHeader.ts":
/*!***********************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/GridHeader/GridHeader.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TableHeader: () => (/* binding */ TableHeader)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html/directives/style-map */ "lit-html/directives/style-map");
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Common_GridExportButton_GridExportButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../Common/GridExportButton/GridExportButton */ "./src/components/Common/GridExportButton/GridExportButton.ts");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./../TeamPerformanceUtils */ "./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts");
/* harmony import */ var _Customization_Customization__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Customization/Customization */ "./src/components/TeamPerformanceWidget/GridHeader/Customization/Customization.ts");
/* harmony import */ var _GridHeader_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./GridHeader.scss */ "./src/components/TeamPerformanceWidget/GridHeader/GridHeader.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};











const EXCEL_SHEET_NAME = "Team Performance Details";
const FILENAME_PREFIX = "TPW";
var TableHeader;
(function (TableHeader) {
    /**
     * @element agentx-wc-tpw-grid-header
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        constructor() {
            super(...arguments);
            this.gridOptions = {};
            this.displayedRowCount = 0;
            this.isServerSidePaginated = false;
            this.isModalOpen = false;
            this.debounceSearch = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.debounce)((searchTerm) => {
                this.dispatchSearchEvent({ searchTerm });
            }, 300);
        }
        static get styles() {
            return _GridHeader_scss__WEBPACK_IMPORTED_MODULE_10__["default"];
        }
        resetTable() {
            this.dispatchEvent(new CustomEvent("tpw-reset-table", {
                bubbles: true,
                composed: true,
                detail: { clearAllFilter: true }
            }));
            this.cancelModal();
        }
        showConfirmationModal() {
            this.isModalOpen = true;
        }
        cancelModal() {
            var _a, _b;
            this.isModalOpen = false;
            (_b = (_a = this.closeModalButton) === null || _a === void 0 ? void 0 : _a.shadowRoot.querySelector("button")) === null || _b === void 0 ? void 0 : _b.focus();
        }
        dispatchSearchEvent(detail) {
            this.dispatchEvent(new CustomEvent("tpw-search-updated", {
                bubbles: true,
                composed: true,
                detail
            }));
        }
        handleSearch(searchTerm) {
            var _a;
            if (!this.isServerSidePaginated) {
                (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setGridOption("quickFilterText", searchTerm);
                this.dispatchSearchEvent(true);
            }
            else {
                this.debounceSearch(searchTerm);
            }
            this.requestUpdate();
        }
        getExportParams() {
            return {
                allColumns: true,
                processCellCallback(params) {
                    var _a, _b, _c;
                    if (params.value &&
                        params.value !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE &&
                        _Utils__WEBPACK_IMPORTED_MODULE_7__.durationColumns.includes((_a = params === null || params === void 0 ? void 0 : params.column) === null || _a === void 0 ? void 0 : _a.colId)) {
                        return (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__.getTimerValue)(params.value, true);
                    }
                    if (((_b = params === null || params === void 0 ? void 0 : params.column) === null || _b === void 0 ? void 0 : _b.colId) === _constants__WEBPACK_IMPORTED_MODULE_0__.ACTIONS) {
                        return "";
                    }
                    if (((_c = params === null || params === void 0 ? void 0 : params.column) === null || _c === void 0 ? void 0 : _c.colId) === "agentNameDetails") {
                        return params.value.agentName;
                    }
                    else {
                        return params.value;
                    }
                },
                processRowGroupCallback(params) {
                    var _a;
                    return `row group: ${(_a = params === null || params === void 0 ? void 0 : params.node) === null || _a === void 0 ? void 0 : _a.key}`;
                },
                processHeaderCallback(params) {
                    var _a;
                    if (((_a = params === null || params === void 0 ? void 0 : params.column) === null || _a === void 0 ? void 0 : _a.colId) === _constants__WEBPACK_IMPORTED_MODULE_0__.ACTIONS) {
                        return "";
                    }
                    else {
                        return params.column.userProvidedColDef.headerName;
                    }
                }
            };
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.gridOptions = {};
        }
        warningTooltip() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <md-tooltip message=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.agentWarning")} placement="bottom">
          <md-icon style="cursor: pointer" class="conflict-warning-info" name="icon-info_14"></md-icon>
        </md-tooltip>
      `;
        }
        renderIcon() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <md-icon class="conflict-warning" name="icon-warning_14"></md-icon> `;
        }
        renderSearchRenderer() {
            const styles = { color: this.isServerSidePaginated ? "var(--md-yellow-70)" : "var(--md-secondary-text-color)" };
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="search-wrapper">
          <md-input
            htmlId="inputSearchClearPill"
            containerSize="small-12"
            placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.search")}
            ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.widgetTitle")}
            searchable
            clear
            clearAriaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common:clear")}"
            class="grid-search-input"
            @input-change=${(event) => this.handleSearch(event.detail.value)}
            newMomentum
          ></md-input>
          <span aria-live="polite" class="result-count-wrapper" style=${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_5__.styleMap)(styles)}>
            ${this.isServerSidePaginated ? this.renderIcon() : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
            ${(0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_8__.getDisplayedRowCountText)(this.displayedRowCount)}
            ${this.isServerSidePaginated ? this.warningTooltip() : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
          </span>
        </div>
      `;
        }
        renderResetTable() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <md-button class="reset-table" variant="ghost" @click=${() => this.showConfirmationModal()}
          ><md-icon slot="icon" name="reset_16" ariaHidden="true"></md-icon
          ><span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.resetTable")}</span></md-button
        >
        <md-modal
          applicationId="reset"
          ?show=${this.isModalOpen}
          id="actionModal"
          size="dialog"
          .hideFooter=${true}
          .hideHeader=${true}
          tabindex="${this.isModalOpen ? "0" : "-1"}"
          ?showclosebutton=${true}
          @close-modal=${this.cancelModal}
          .ariaLabelClose=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.closeResetToDefaultView")}
          aria-labelledby="reset-header"
          aria-label=""
        >
          <div slot="header" class="header-width">
            <span aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.resetToDefaultView")} id="reset-header" class="reset-header"
              >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.resetToDefaultView")}</span
            >
          </div>
          <div class="modal-body">
            <span>
              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.resetConfirmationText")} <br />
              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.resetConfirmationSubText")}
            </span>
          </div>
          <div slot="footer" class="reset-btn-wrapper">
            <md-button
              class="reset-submit"
              variant="primary"
              @click=${() => this.resetTable()}
              type="submit"
              ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.resetTable")}
            >
              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.resetTable")}</md-button
            >
            <md-button
              class="reset-close"
              variant="secondary"
              ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cancel")}
              type="reset"
              @click=${this.cancelModal}
            >
              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cancel")}</md-button
            >
          </div>
        </md-modal>
      `;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="grid-header-container">
          ${this.renderSearchRenderer()}
          <div class="grid-header-action-container">
            ${this.renderResetTable()}
            <agentx-wc-tpw-customization
              .gridApi=${this.gridApi}
              .gridOptions=${this.gridOptions}
              .isServerSidePaginated=${this.isServerSidePaginated}
            ></agentx-wc-tpw-customization>
            <agentx-wc-grid-export-button
              .gridApi=${this.gridApi}
              .exportParams=${this.getExportParams()}
              .sheetName=${EXCEL_SHEET_NAME}
              .exportFileNamePrefix=${FILENAME_PREFIX}
            >
              <md-button slot="menu-trigger" variant="ghost" class="download-btn">
                <md-icon slot="icon" name="export_16" ariaHidden="true"></md-icon>
                <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.download")}</span>
              </md-button>
            </agentx-wc-grid-export-button>
          </div>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
    ], Element.prototype, "gridOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
    ], Element.prototype, "gridApi", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Number, reflect: true })
    ], Element.prototype, "displayedRowCount", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isServerSidePaginated", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)(".reset-table")
    ], Element.prototype, "closeModalButton", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-tpw-grid-header")
    ], Element);
    TableHeader.Element = Element;
})(TableHeader || (TableHeader = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/TeamPerformance.scss":
/*!*******************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/TeamPerformance.scss ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

:host {
  --tpw-search-height: 66px;
  --tpw-h-padding: 12px;
}

.ag-theme-alpine,
.ag-theme-alpine-dark {
  --ag-row-hover-color: var(--grid-row-hover-color, rgba(33, 150, 243, 0.1));
  --ag-header-cell-moving-background-color: var(--ag-row-hover-color);
  --ag-input-focus-border-color: transparent;
}

:focus {
  box-shadow: none;
}

.tpw-wrapper {
  --ag-row-border-color: var(--list-focus-border-color);
  height: 100%;
}
.tpw-wrapper .grid-container {
  height: calc(100% - (var(--tpw-filter-height) + var(--tpw-search-height)));
  background-color: var(--md-glass-overlay-bg-color);
  border-top-left-radius: var(--grid-container-border-radius);
  border-top-right-radius: var(--grid-container-border-radius);
  padding-left: var(--grid-container-h-padding);
  padding-right: var(--grid-container-h-padding);
  padding-top: var(--grid-container-top-padding);
}
.tpw-wrapper .grid-container .ag-overlay-wrapper {
  display: block;
}
.tpw-wrapper .grid-container .ag-root-wrapper {
  border-right: 0px;
  border-left: 0px;
  border-bottom: 0px;
  border-color: var(--md-table-primary-bg-color);
  background-color: transparent;
}
.tpw-wrapper .grid-container .ag-row {
  border-color: var(--md-table-primary-bg-color);
  border-bottom: var(--md-table-cell-border-bottom);
  z-index: 0;
}
.tpw-wrapper .grid-container .ag-body-horizontal-scroll {
  overflow-x: auto;
  overflow-y: auto;
}
.tpw-wrapper .grid-container .ag-row,
.tpw-wrapper .grid-container .ag-body-viewport {
  background-color: transparent;
}
.tpw-wrapper .grid-container .ag-cell-focus {
  box-shadow: none;
}
.tpw-wrapper .grid-container .ag-cell-focus:focus-within {
  outline: 2px solid var(--list-focus-border-color) !important;
  outline-offset: -2px;
  border-radius: 4px;
}
.tpw-wrapper .grid-container .ag-cell,
.tpw-wrapper .grid-container .ag-pinned-left-header,
.tpw-wrapper .grid-container .ag-pinned-right-header,
.tpw-wrapper .grid-container .ag-pinned-right-cols-container {
  color: var(--md-primary-text-color);
  border: none;
  border-width: 1px;
  border-right-style: solid;
  border-color: var(--md-table-column-divider-color) !important;
}
.tpw-wrapper .grid-container .ag-cell.ag-cell-focus:focus-within,
.tpw-wrapper .grid-container .ag-pinned-left-header.ag-cell-focus:focus-within,
.tpw-wrapper .grid-container .ag-pinned-right-header.ag-cell-focus:focus-within,
.tpw-wrapper .grid-container .ag-pinned-right-cols-container.ag-cell-focus:focus-within {
  outline: 2px solid var(--list-focus-border-color) !important;
  outline-offset: -2px;
  border-radius: 4px;
}
.tpw-wrapper .grid-container .ag-cell {
  line-height: 38px;
  padding-left: var(--tpw-h-padding);
  padding-right: var(--tpw-h-padding);
}
.tpw-wrapper .grid-container .ag-cell-label-container {
  flex-direction: row !important;
  border: none;
  outline: none;
}
.tpw-wrapper .grid-container .ag-ltr .ag-cell-focus:not(.ag-cell-range-selected):focus-within,
.tpw-wrapper .grid-container .ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.tpw-wrapper .grid-container .ag-ltr .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,
.tpw-wrapper .grid-container .ag-ltr .ag-cell-range-single-cell,
.tpw-wrapper .grid-container .ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle,
.tpw-wrapper .grid-container .ag-rtl .ag-cell-focus:not(.ag-cell-range-selected):focus-within,
.tpw-wrapper .grid-container .ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.tpw-wrapper .grid-container .ag-rtl .ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group,
.tpw-wrapper .grid-container .ag-rtl .ag-cell-range-single-cell,
.tpw-wrapper .grid-container .ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle {
  border: none;
  outline: initial;
}
.tpw-wrapper .grid-container .ag-header {
  z-index: var(--z-index-tpw-header);
  border: none;
  border-width: 1px;
  border-right-style: var(--md-table-border-style);
  border-bottom-style: solid;
  color: var(--md-primary-text-color);
  background-color: var(--md-table-header-bg-color);
  border-color: var(--md-table-header-border-bottom-color);
}
.tpw-wrapper .grid-container .ag-header-cell-text {
  color: var(--md-table-header-text-color, var(--md-secondary-text-color));
  font-size: 14px;
  font-family: var(--brand-font-bold, "CiscoSansTT Regular"), sans-serif;
  font-weight: var(--brand-font-weight-bold, 400);
}
.tpw-wrapper .grid-container .ag-header-cell {
  padding-left: var(--tpw-h-padding);
  padding-right: var(--tpw-h-padding);
}
.tpw-wrapper .grid-container .ag-header-cell.ag-header-active {
  outline: 2px solid var(--list-focus-border-color) !important;
  outline-offset: -2px;
  border-radius: 4px;
}
.tpw-wrapper .grid-container .ag-header-cell.ag-header-active::after {
  border: none;
}
.tpw-wrapper .grid-container .ag-header-cell:focus {
  box-shadow: none;
}
.tpw-wrapper .grid-container .action-class {
  overflow: visible;
}
.tpw-wrapper .grid-container .ag-row.ag-row-focus {
  z-index: 1;
}
.tpw-wrapper .grid-container .ag-header-cell-resize {
  right: -5px;
}
.tpw-wrapper .grid-container .ag-pinned-left-header .ag-header-cell-resize {
  right: -4px;
}
.tpw-wrapper .grid-container .ag-header-cell-resize::after {
  height: 100%;
  top: 0;
  background-color: var(--md-table-primary-bg-color);
  width: 1px !important;
}
.tpw-wrapper .grid-container .ag-pinned-right-header .ag-header-cell-resize::after {
  left: calc(50% - 1px);
  width: 2px !important;
}
.tpw-wrapper .grid-container .ag-cell.ag-cell-last-left-pinned,
.tpw-wrapper .grid-container .ag-pinned-left-header {
  border-width: 1px;
  right: 0px;
  left: auto !important;
}
.tpw-wrapper .grid-container .ag-cell.ag-cell-last-left-pinned:has(.ag-header-active),
.tpw-wrapper .grid-container .ag-pinned-left-header:has(.ag-header-active) {
  border-right: 2px solid var(--list-focus-border-color) !important;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.tpw-wrapper .grid-container .ag-pinned-right-header {
  border-right: none;
  left: 0;
}
.tpw-wrapper .grid-container .ag-pinned-right-header:has(.ag-header-active) {
  border-right: 2px solid var(--list-focus-border-color) !important;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.tpw-wrapper .grid-container .ag-pinned-right-header,
.tpw-wrapper .grid-container .ag-pinned-right-cols-container {
  border-left-style: solid;
  border-left-color: var(--md-table-pinned-border-color) !important;
  border-left-width: 1px;
  box-shadow: var(--pinned-column-elevation);
}
.tpw-wrapper .grid-container .ag-pinned-right-header .ag-row,
.tpw-wrapper .grid-container .ag-pinned-right-cols-container .ag-row {
  background-color: var(--md-table-pinned-bg-color);
}
.tpw-wrapper .grid-container .ag-pinned-right-header .ag-row .ag-cell,
.tpw-wrapper .grid-container .ag-pinned-right-cols-container .ag-row .ag-cell {
  border-left-style: none;
}
.tpw-wrapper .grid-container .ag-pinned-right-header .ag-header-cell,
.tpw-wrapper .grid-container .ag-pinned-right-cols-container .ag-header-cell {
  background-color: var(--pinned-column-header-bg-color);
}
.tpw-wrapper .grid-container .ag-pinned-left-header,
.tpw-wrapper .grid-container .ag-pinned-left-cols-container {
  border-right-style: solid;
  border-right-width: 1px;
  border-right-color: var(--md-table-pinned-border-color) !important;
  box-shadow: var(--pinned-column-elevation);
}
.tpw-wrapper .grid-container .ag-pinned-left-header .ag-row,
.tpw-wrapper .grid-container .ag-pinned-left-cols-container .ag-row {
  background-color: var(--md-table-pinned-bg-color);
}
.tpw-wrapper .grid-container .ag-pinned-left-header .ag-row .ag-cell,
.tpw-wrapper .grid-container .ag-pinned-left-cols-container .ag-row .ag-cell {
  border-right-style: none;
}
.tpw-wrapper .grid-container .ag-pinned-left-header .ag-header-cell,
.tpw-wrapper .grid-container .ag-pinned-left-cols-container .ag-header-cell {
  background-color: var(--pinned-column-header-bg-color);
}
.tpw-wrapper .grid-container .ag-cell-expandable {
  font-weight: bold;
}
.tpw-wrapper .grid-container .ag-row.ag-row-level-0.ag-full-width-row {
  background-color: var(--md-tertiary-bg-color);
}
.tpw-wrapper .grid-container .ag-header-icon.ag-header-cell-menu-button {
  opacity: 1;
}
.tpw-wrapper .grid-container div.ag-row {
  font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", sans-serif;
}
.tpw-wrapper .grid-container .ag-theme-alpine .ag-menu-header,
.tpw-wrapper .grid-container .ag-theme-alpine-dark .ag-menu-header {
  display: none;
}
.tpw-wrapper .grid-container .ag-group-expanded,
.tpw-wrapper .grid-container .ag-group-contracted {
  margin-right: 20px;
}
.tpw-wrapper .ag-menu {
  border-radius: var(--border-radius-medium);
  color: var(--md-primary-text-color);
  border-color: var(--md-menu-overlay-border-color);
  box-shadow: 0 1px 4px 1px var(--md-menu-overlay-border-color);
  margin-top: 25px;
  margin-left: 15px;
}
.tpw-wrapper .ag-header-icon {
  color: var(--md-secondary-text-color);
  padding-left: 8px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.tpw-wrapper .ag-row.ag-row-level-0.ag-full-width-row .ag-row-group.ag-row-group-indent-0 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-1.ag-full-width-row .ag-row-group.ag-row-group-indent-1 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-2.ag-full-width-row .ag-row-group.ag-row-group-indent-2 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-3.ag-full-width-row .ag-row-group.ag-row-group-indent-3 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-4.ag-full-width-row .ag-row-group.ag-row-group-indent-4 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-5.ag-full-width-row .ag-row-group.ag-row-group-indent-5 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-6.ag-full-width-row .ag-row-group.ag-row-group-indent-6 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-7.ag-full-width-row .ag-row-group.ag-row-group-indent-7 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-8.ag-full-width-row .ag-row-group.ag-row-group-indent-8 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-9.ag-full-width-row .ag-row-group.ag-row-group-indent-9 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-10.ag-full-width-row .ag-row-group.ag-row-group-indent-10 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-11.ag-full-width-row .ag-row-group.ag-row-group-indent-11 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-12.ag-full-width-row .ag-row-group.ag-row-group-indent-12 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-13.ag-full-width-row .ag-row-group.ag-row-group-indent-13 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-14.ag-full-width-row .ag-row-group.ag-row-group-indent-14 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-15.ag-full-width-row .ag-row-group.ag-row-group-indent-15 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-16.ag-full-width-row .ag-row-group.ag-row-group-indent-16 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-17.ag-full-width-row .ag-row-group.ag-row-group-indent-17 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-18.ag-full-width-row .ag-row-group.ag-row-group-indent-18 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-19.ag-full-width-row .ag-row-group.ag-row-group-indent-19 {
  padding-left: 8px;
}
.tpw-wrapper .ag-row.ag-row-level-1 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-2 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-3 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-4 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-5 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-6 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-7 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-8 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-9 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-10 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-11 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-12 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-13 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-14 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-15 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-16 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-17 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-18 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .ag-row.ag-row-level-19 div[role=gridcell][aria-colindex="1"],
.tpw-wrapper .ag-header-cell[aria-colindex="1"] {
  padding-left: var(--tpw-h-padding);
}
.tpw-wrapper .tpw-action-wrapper {
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.tpw-wrapper .tpw-action-wrapper div:nth-child(2) {
  padding-bottom: 3px;
}
.tpw-wrapper .sorted {
  display: flex;
  flex-direction: column;
}
.tpw-wrapper .sorted md-icon {
  display: flex;
  color: var(--md-primary-text-color);
}
.tpw-wrapper .icon-group {
  border: 1px solid black;
  padding: 0px 3px;
  border-radius: 3px;
  border-color: var(--md-button-secondary-hover-bg-color);
  height: 18px;
  line-height: 18px;
  font-weight: bold;
}
.tpw-wrapper .ActionCell {
  display: flex;
  justify-content: left;
  width: calc(100% + 18px);
  margin-left: -10px;
  height: 100%;
}
.tpw-wrapper .ActionCell .more-actions {
  display: flex;
  margin-left: auto;
}
.tpw-wrapper .ActionCell .aid-icon {
  height: calc(var(--space-token-even) * 10);
  min-width: calc(var(--space-token-even) * 10);
}
.tpw-wrapper .ActionCell .btn-action {
  padding: 0px calc(var(--space-token-even) * 2);
  margin: 0px calc(var(--space-token-even) * 2);
}
.tpw-wrapper .ActionCell .aid-chat {
  position: relative;
}
.tpw-wrapper .ActionCell .state-change-action {
  position: relative;
}
.tpw-wrapper .ActionCell .kebab-menu {
  margin-left: auto;
}
.tpw-wrapper .ActionCell .kebab-menu-icon {
  cursor: pointer;
}
.tpw-wrapper .ActionCell .kebab-menu-container {
  padding: 0 !important;
}
.tpw-wrapper .ActionCell .monitoring-label {
  margin: 0 calc(var(--space-token-even) * 6);
  color: var(--md-default-focus-outline-color, #005e7d);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0;
  margin-top: 0;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  margin-right: 10px;
}
.tpw-wrapper .ActionCell .review-monitor-icon {
  min-width: calc(var(--space-token-even) * 10);
}
.tpw-wrapper .ActionCell .section-one {
  display: flex;
  height: 100%;
}
.tpw-wrapper .ActionCell .section-one .monitoring-container {
  max-width: max-content;
}
.tpw-wrapper .ActionCell .section-two {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
}
.tpw-wrapper .ActionCell .section-two .kebab-action {
  width: 1.5rem;
  margin: 0 0 0 auto;
  padding: 0;
}
.tpw-wrapper .ActionCell .aid-button {
  align-items: center;
  justify-content: center;
  display: flex;
  width: 2rem;
  border: none;
  background: none;
  cursor: pointer;
  vertical-align: middle;
  height: 100%;
}
.tpw-wrapper .ActionCell .aid-button.disabled {
  cursor: not-allowed;
  color: var(--md-button-disabled-text-color);
}
.tpw-wrapper .ActionCell .aid-button .error-icon {
  position: absolute;
  top: -9px;
  right: 6px;
  color: var(--md-input-chat-error-color, #a12512);
}
.tpw-wrapper .ActionCell .aid-button .error-icon .md-icon {
  background-color: white;
  border-radius: 50%;
}
.tpw-wrapper .ActionCell .aid-button:focus {
  box-shadow: 0 0 0 0.125rem var(--button-focus-ring-color, #007aa3);
  border-radius: 2px;
}
.tpw-wrapper .ActionCell .aid-button[disabled] {
  cursor: no-drop;
}

.grid-rendering {
  display: none;
}

.name-span-renderer {
  padding: 0px 38px 5px 10px;
  width: -webkit-fill-available;
  width: -moz-available;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  height: -webkit-fill-available;
  height: -moz-available;
}

.name-avatar-renderer {
  vertical-align: top;
}

.avatar-center {
  display: flex;
  align-items: center;
  height: 100%;
}
.avatar-center .md-avatar {
  font-size: 0.875rem;
  height: 2.5rem;
  line-height: 1.25rem;
  width: 2.5rem;
  border-radius: 100%;
  display: inline-flex;
  font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial, sans-serif;
  position: relative;
  text-transform: uppercase;
  user-select: none;
}
.avatar-center .md-avatar--28 {
  font-size: 0.6125rem;
  height: 1.75rem;
  line-height: 0.875rem;
  width: 1.75rem;
  min-width: 1.75rem;
}
.avatar-center .md-avatar__letter {
  place-content: center;
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  border-radius: 100%;
  height: 100%;
  width: 100%;
  background-color: var(--avatar-letter-legacy-bg-color, var(--avatar-letter-bg-color, #ededed));
  color: var(--avatar-letter-legacy-text-color, var(--avatar-letter-text-color, #292929));
}
.avatar-center .md-avatar--active::after {
  place-content: center;
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  border-radius: 100%;
  height: 100%;
  width: 100%;
  box-shadow: rgb(0, 171, 80) 0px 0px 0px 0.0625rem inset, var(--avatar-presence-cutout-bg-color, rgba(255, 255, 255, 0.24)) 0px 0px 0px 0.125rem inset;
  content: "";
  left: 0px;
  position: absolute;
}
.avatar-center .md-avatar--idle::after {
  place-content: center;
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  border-radius: 100%;
  height: 100%;
  width: 100%;
  box-shadow: rgb(204, 204, 204) 0px 0px 0px 0.0625rem inset, var(--avatar-presence-cutout-bg-color, rgba(255, 255, 255, 0.24)) 0px 0px 0px 0.125rem inset;
  content: "";
  left: 0px;
  position: absolute;
}

.agent-state-container {
  display: flex;
}
.agent-state-container .agent-state-info {
  margin-right: 5px;
  height: auto;
  padding-top: 10px;
  align-items: center;
}
.agent-state-container .agent-state-name {
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
}

webex-chat {
  width: 370px;
}

.context-menu-wrapper {
  width: max-content;
  overflow: visible;
}

.custom-menu-overlay.overlay-container {
  border-radius: 0.5rem;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.16), 0 0 1px rgba(0, 0, 0, 0.14);
  box-sizing: border-box;
  display: none;
  position: absolute;
  z-index: 1000;
}
.custom-menu-overlay.overlay-container[data-show] {
  display: block;
}
.custom-menu-overlay.overlay-container .overlay-content {
  background-color: var(--md-secondary-white-bg-color);
  border: 1px solid var(--md-menu-overlay-border-color, --gray-20);
  border-radius: 0.5rem;
  display: flex;
  justify-content: space-around;
  max-width: calc(100vw - var(--vw-padding) * 2);
  overflow-y: auto;
}

.agent-state-selector .overlay-content {
  width: 260px;
}
.agent-state-selector .overlay-content agentx-wc-tpw-agent-state-selector-infinite {
  width: 100%;
}
.agent-state-selector agentx-wc-tpw-agent-state-selector {
  width: 100%;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=TeamPerformance.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-services/dist/styles/z-index.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/TeamPerformanceWidget/TeamPerformance.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/TeamPerformance.ts":
/*!*****************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/TeamPerformance.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TeamPerformance: () => (/* binding */ TeamPerformance)
/* harmony export */ });
/* harmony import */ var _components_Common_Utils_GridUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/Utils/GridUtils */ "./src/components/Common/Utils/GridUtils.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @/utils/WindowListenersHub */ "./src/utils/WindowListenersHub.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _popperjs_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @popperjs/core */ "@popperjs/core");
/* harmony import */ var _popperjs_core__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_popperjs_core__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _popperjs_core_lib_popper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @popperjs/core/lib/popper */ "@popperjs/core/lib/popper");
/* harmony import */ var _popperjs_core_lib_popper__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_popperjs_core_lib_popper__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ag-grid-enterprise */ "ag-grid-enterprise");
/* harmony import */ var ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lit_html_lib_part__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! lit-html/lib/part */ "lit-html/lib/part");
/* harmony import */ var lit_html_lib_part__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lit_html_lib_part__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! lodash */ "../../node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! mobx */ "mobx");
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(mobx__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _Common_WidgetLoader_WidgetLoader__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../Common/WidgetLoader/WidgetLoader */ "./src/components/Common/WidgetLoader/WidgetLoader.ts");
/* harmony import */ var _ColumnMenu_ColumnMenu__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./ColumnMenu/ColumnMenu */ "./src/components/TeamPerformanceWidget/ColumnMenu/ColumnMenu.ts");
/* harmony import */ var _ContextMenu__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./ContextMenu */ "./src/components/TeamPerformanceWidget/ContextMenu.ts");
/* harmony import */ var _GridConfig__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./GridConfig */ "./src/components/TeamPerformanceWidget/GridConfig.ts");
/* harmony import */ var _GridHeader_GridHeader__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./GridHeader/GridHeader */ "./src/components/TeamPerformanceWidget/GridHeader/GridHeader.ts");
/* harmony import */ var _TeamPerformance_scss__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./TeamPerformance.scss */ "./src/components/TeamPerformanceWidget/TeamPerformance.scss");
/* harmony import */ var _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./TeamPerformanceUtils */ "./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _components_ActiveInteraction__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./components/ActiveInteraction */ "./src/components/TeamPerformanceWidget/components/ActiveInteraction.ts");
/* harmony import */ var _components_AppliedFilters__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./components/AppliedFilters */ "./src/components/TeamPerformanceWidget/components/AppliedFilters.ts");
/* harmony import */ var _components_EmptyGrid__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./components/EmptyGrid */ "./src/components/TeamPerformanceWidget/components/EmptyGrid.ts");
/* harmony import */ var _components_ReviewAndMonitorWrapper__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./components/ReviewAndMonitorWrapper */ "./src/components/TeamPerformanceWidget/components/ReviewAndMonitorWrapper.ts");
/* harmony import */ var _components_SignoutModal__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./components/SignoutModal */ "./src/components/TeamPerformanceWidget/components/SignoutModal.ts");
/* harmony import */ var _components_StateSelector__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./components/StateSelector */ "./src/components/TeamPerformanceWidget/components/StateSelector.ts");
/* harmony import */ var _components_WebexChat__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./components/WebexChat */ "./src/components/TeamPerformanceWidget/components/WebexChat.ts");
/* harmony import */ var _components_agentStateSelector__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./components/agentStateSelector */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/index.ts");
/* harmony import */ var _components_agentStateSelector_agentStateSelectorInfinite__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./components/agentStateSelector/agentStateSelectorInfinite */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/agentStateSelectorInfinite/index.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */



































var FocusComponent;
(function (FocusComponent) {
    FocusComponent["SEND_MESSAGE"] = "send-message";
    FocusComponent["STATE_CHANGE"] = "state-change";
    FocusComponent["SIGNOUT"] = "signout";
})(FocusComponent || (FocusComponent = {}));
const globalStatusDataSet = "wxcc.rtd.agentglobalstatus";
const agentChannelStatusDataSet = "wxcc.rtd.agentchannelstatus";
const contactStatsDataSet = "wxcc.rtd.contactstats";
var TeamPerformance;
(function (TeamPerformance) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_6__.MobxLitElement) {
        static get styles() {
            return _TeamPerformance_scss__WEBPACK_IMPORTED_MODULE_23__["default"];
        }
        //toggle subscription reset the subscription flags for future coming subscriptions
        toggleSubscriptionFlags() {
            this.isAgentGlobalSubscribed = false;
            this.isChannelStatusSubscribed = false;
            this.isContactStatusSubscribed = false;
        }
        //setRowDara convert map data to array data to make compatible for ag-grid
        setRowData() {
            var _a, _b, _c, _d;
            this.agentStatusData = Array.from(this.agentDataMap, (item) => item[1]);
            (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setGridOption("rowData", this.agentStatusData);
            (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.refreshHeader();
            (_c = this.gridApi) === null || _c === void 0 ? void 0 : _c.setGridOption("loading", false);
            (_d = this.gridApi) === null || _d === void 0 ? void 0 : _d.hideOverlay();
        }
        //isFirstSubscription checks whether the subscription_response received is the very first subscription
        isFirstSubscription(type) {
            return (!this.isChannelStatusSubscribed &&
                !this.isAgentGlobalSubscribed &&
                !this.isContactStatusSubscribed &&
                (type === _constants__WEBPACK_IMPORTED_MODULE_1__.SUBSCRIPTION_RESPONSE || this.agentStatusData.length === 0));
        }
        updateDisplayRowCountOnDataUpdate() {
            if (this.delayId) {
                _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_12__.clearInterval(this.delayId);
            }
            this.delayId = (0,mobx__WEBPACK_IMPORTED_MODULE_17__.toJS)(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_12__.setTimeout(() => {
                this.getDisplayedRowCount();
            }, 100));
        }
        setAgentGlobalStatusData(agentGlobalStatusData, type, deltaData) {
            if (this.isAgentGlobalSubscribed && type === _constants__WEBPACK_IMPORTED_MODULE_1__.SUBSCRIPTION_RESPONSE) {
                this.toggleSubscriptionFlags();
            }
            if (this.isFirstSubscription(type)) {
                //Directly map the value received if the received data is first subscription data
                this.agentDataMap = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.convertGlobalStatusArrayToMap)(agentGlobalStatusData, _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.i18n.language, this.tpwConfigs.supervisorAnalyserId);
                this.enrichCMSDataWithRTDData();
                this.setRowData();
                this.isAgentGlobalSubscribed = true;
            }
            else if (!this.isChannelStatusSubscribed && !this.isContactStatusSubscribed && this.isAgentGlobalSubscribed) {
                //Directly map the value received if the received data is chunked subscription data
                this.agentDataMap = new Map([
                    ...this.agentDataMap,
                    ...(0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.convertGlobalStatusArrayToMap)(agentGlobalStatusData, _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.i18n.language, this.tpwConfigs.supervisorAnalyserId)
                ]);
                this.enrichCMSDataWithRTDData();
                this.setRowData();
            }
            else if (this.isChannelStatusSubscribed || this.isContactStatusSubscribed || type === _constants__WEBPACK_IMPORTED_MODULE_1__.REALTIME_FEED) {
                if (type === _constants__WEBPACK_IMPORTED_MODULE_1__.SUBSCRIPTION_RESPONSE) {
                    this.isAgentGlobalSubscribed = true;
                }
                if (deltaData && type === _constants__WEBPACK_IMPORTED_MODULE_1__.REALTIME_FEED) {
                    this.agentDataMap = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.updateExistingMapFromGlobalStatus)({
                        agentGlobalStatusData: deltaData,
                        oldDataMap: this.agentDataMap,
                        browserLanguage: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.i18n.language,
                        gridApi: this.gridApi,
                        comp: this,
                        supervisorAnalyserId: this.tpwConfigs.supervisorAnalyserId,
                        isServerSideGrid: this.isServerSidePaginated,
                        isShowSignedOutAgentsEnabled: this.tpwConfigs.isShowSignedOutAgentsEnabled
                    });
                }
                else {
                    this.agentDataMap = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.updateExistingMapFromGlobalStatus)({
                        agentGlobalStatusData,
                        oldDataMap: this.agentDataMap,
                        browserLanguage: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.i18n.language,
                        gridApi: this.gridApi,
                        comp: this,
                        supervisorAnalyserId: this.tpwConfigs.supervisorAnalyserId,
                        isServerSideGrid: this.isServerSidePaginated,
                        isShowSignedOutAgentsEnabled: this.tpwConfigs.isShowSignedOutAgentsEnabled
                    });
                }
                this.enrichCMSDataWithRTDData();
                this.agentStatusData = Array.from(this.agentDataMap, (item) => item[1]);
            }
            if (this.appliedGroups && this.appliedGroups.length > 0) {
                this.updateGroupFilter();
            }
            this.updateDisplayRowCountOnDataUpdate();
        }
        setAgentContactStatsData(contactStatsData, type, deltaData) {
            if (!deltaData || (deltaData && deltaData.length > 0 && deltaData[0].operation !== "DELETE")) {
                let filteredData = [];
                if (deltaData) {
                    filteredData = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.filterContactStatsData)(deltaData);
                }
                else {
                    filteredData = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.filterContactStatsData)(contactStatsData);
                }
                if (filteredData && filteredData.length > 0) {
                    if (this.isContactStatusSubscribed && type === _constants__WEBPACK_IMPORTED_MODULE_1__.SUBSCRIPTION_RESPONSE) {
                        this.toggleSubscriptionFlags();
                    }
                    if (this.isFirstSubscription(type)) {
                        //Directly map the value received if the received data is first subscription data
                        this.agentDataMap = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.convertContactStatusArrayToMap)(contactStatsData, this.tpwConfigs.supervisorAnalyserId, this.tpwConfigs.isMPCorPersistEnabled);
                        this.enrichCMSDataWithRTDData();
                        this.setRowData();
                        this.isContactStatusSubscribed = true;
                    }
                    else if (this.isContactStatusSubscribed &&
                        !this.isChannelStatusSubscribed &&
                        !this.isAgentGlobalSubscribed) {
                        //Directly map the value received if the received data is chunked subscription data
                        //chunked data is new data so directly appending the data recieved in subscription
                        this.agentDataMap = new Map([
                            ...this.agentDataMap,
                            ...(0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.convertContactStatusArrayToMap)(filteredData, this.tpwConfigs.supervisorAnalyserId, this.tpwConfigs.isMPCorPersistEnabled)
                        ]);
                        this.enrichCMSDataWithRTDData();
                        this.setRowData();
                    }
                    else if (this.isAgentGlobalSubscribed || this.isChannelStatusSubscribed || type === _constants__WEBPACK_IMPORTED_MODULE_1__.REALTIME_FEED) {
                        if (type === _constants__WEBPACK_IMPORTED_MODULE_1__.SUBSCRIPTION_RESPONSE) {
                            this.isContactStatusSubscribed = true;
                        }
                        //updating the existing data id the subscription is not the first subscription or if the type of response is relatimefeed
                        this.agentDataMap = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.updateExistingMapFromContactStats)(filteredData, this.agentDataMap, this.gridApi, this.tpwConfigs.supervisorAnalyserId, this, this.tpwConfigs.isMPCorPersistEnabled, this.isServerSidePaginated);
                        this.enrichCMSDataWithRTDData();
                        this.agentStatusData = Array.from(this.agentDataMap, (item) => item[1]);
                        this.monitoringInProgress = this.agentStatusData.some((agentDetails) => { var _a; return (_a = agentDetails.actions) === null || _a === void 0 ? void 0 : _a.isSupervisorMonitoring; });
                    }
                    this.updateSelectedAgentDetails();
                }
                this.updateDisplayRowCountOnDataUpdate();
            }
        }
        setAgentChannelStatusData(agentChannelStatusData, type, deltaData) {
            if (!deltaData || (deltaData && deltaData.length > 0 && deltaData[0].operation !== "DELETE")) {
                let filteredData = [];
                if (deltaData) {
                    filteredData = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.filteredTelephonyChannelData)(deltaData);
                }
                else {
                    filteredData = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.filteredTelephonyChannelData)(agentChannelStatusData);
                }
                if (filteredData && filteredData.length > 0) {
                    if (this.isChannelStatusSubscribed && type === _constants__WEBPACK_IMPORTED_MODULE_1__.SUBSCRIPTION_RESPONSE) {
                        this.toggleSubscriptionFlags();
                    }
                    if (this.isFirstSubscription(type)) {
                        //Directly map the value received if the received data is first subscription data
                        this.agentDataMap = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.convertChannelStatusArrayToMap)(filteredData, this.tpwConfigs.supervisorAnalyserId);
                        this.enrichCMSDataWithRTDData();
                        this.setRowData();
                        this.isChannelStatusSubscribed = true;
                    }
                    else if (this.isChannelStatusSubscribed &&
                        !this.isAgentGlobalSubscribed &&
                        !this.isContactStatusSubscribed) {
                        //Directly map the value received if the received data is chunked subscription data
                        //chunked data is new data so directly appending the data recieved in subscription
                        this.agentDataMap = new Map([
                            ...this.agentDataMap,
                            ...(0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.convertChannelStatusArrayToMap)(filteredData, this.tpwConfigs.supervisorAnalyserId)
                        ]);
                        this.enrichCMSDataWithRTDData();
                        this.setRowData();
                    }
                    else if (this.isAgentGlobalSubscribed || this.isContactStatusSubscribed || type === _constants__WEBPACK_IMPORTED_MODULE_1__.REALTIME_FEED) {
                        if (type === _constants__WEBPACK_IMPORTED_MODULE_1__.SUBSCRIPTION_RESPONSE) {
                            this.isChannelStatusSubscribed = true;
                        }
                        //updating the existing data id the subscription is not the first subscription or if the type of response is relatimefeed
                        this.agentDataMap = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.updateExistingMapFromChannelStatus)(filteredData, this.agentDataMap, this.gridApi, this.tpwConfigs.supervisorAnalyserId, this, this.isServerSidePaginated);
                        this.enrichCMSDataWithRTDData();
                        this.agentStatusData = Array.from(this.agentDataMap, (item) => item[1]);
                        //updating the selectedAgentDetails to update the contact status change received from channel status when any AID modal is open
                        this.updateSelectedAgentDetails();
                    }
                    if (this.appliedGroups && this.appliedGroups.length > 0) {
                        this.updateGroupFilter();
                    }
                    this.updateDisplayRowCountOnDataUpdate();
                }
            }
        }
        fetchAllAgents(pageNumber = 0, searchValue = "", sortOrder = "") {
            return __awaiter(this, void 0, void 0, function* () {
                const allAgentsResponse = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.abs.fetchAgentsByOrgId({
                    orgId: this.tpwConfigs.orgId,
                    page: pageNumber,
                    pageSize: this.tpwConfigs.requestedPageSize,
                    searchValue,
                    sortOrder
                });
                const totalRecords = allAgentsResponse.meta.totalRecords;
                const fetchedAgents = allAgentsResponse.data;
                if (!this.isServerSidePaginated) {
                    this.isServerSidePaginated = totalRecords > this.tpwConfigs.requestedPageSize;
                }
                if (this.isServerSidePaginated) {
                    this.displayedRowCount = totalRecords;
                }
                this.cmsAgentData = [
                    ...fetchedAgents.map((agent) => ({
                        agentId: agent.id,
                        agentName: `${agent.firstName} ${agent.lastName}`,
                        agentEmail: agent.email
                    })),
                    ...this.cmsAgentData
                ];
                return (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.convertCmsAgentDataArrayToMap)([
                    ...fetchedAgents.map((agent) => ({
                        agentId: agent.id,
                        agentName: `${agent.firstName} ${agent.lastName}`,
                        agentEmail: agent.email
                    }))
                ]);
            });
        }
        fetchAgentStatus() {
            return __awaiter(this, void 0, void 0, function* () {
                this.requestTimerId = (0,mobx__WEBPACK_IMPORTED_MODULE_17__.toJS)(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_12__.setTimeout(() => {
                    var _a, _b;
                    if (this.agentStatusData.length === 0) {
                        // Show "No Records" if the data is not received within the timeout.
                        this.isRequestTimeout = true;
                        (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setGridOption("loading", false);
                        (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.showNoRowsOverlay();
                    }
                }, _constants__WEBPACK_IMPORTED_MODULE_1__.TPW_DATA_WAIT_TIME));
                try {
                    // subscribe to contact stats dataset
                    const [globalStatus, channelStatus, contactStats] = yield Promise.all([
                        this.subscribeGlobalStatusDataSet(),
                        this.subscribeAgentChannelStatusDataSet(),
                        this.subscribeContactStatsDataSet()
                    ]);
                    this.globalStatusSubscription = globalStatus;
                    this.channelStatusSubscription = channelStatus;
                    this.contactStatsSubscription = contactStats;
                }
                catch (error) {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[App:TPW] Subscription failed", error);
                    this.isError = true;
                }
            });
        }
        handleStateChangeContext(event) {
            var _a;
            const detail = { selectedAgentId: event.detail.agentId };
            this.updateSelectedAgentId(detail);
            this.closeOverlayContent({ closeContextMenu: false });
            (_a = this.stateSelector) === null || _a === void 0 ? void 0 : _a.toggleAttribute("data-show", true);
            setTimeout(() => {
                this.popperInstance = this.createPopperInstance(event.detail.event, this.stateSelector, "left-start");
                this.stateSelectorOpened = true;
                this.popperInstance.update();
            }, 0);
        }
        handleWebexChatContext(event) {
            var _a;
            this.closeOverlayContent({ closeContextMenu: false });
            (_a = this.overlayElement) === null || _a === void 0 ? void 0 : _a.toggleAttribute("data-show", true);
            setTimeout(() => {
                this.popperInstance = this.createPopperInstance(event.detail.event, this.overlayElement, "left-start");
                this.webexChatOpened = true;
                this.popperInstance.update();
            }, 0);
        }
        fireSignedOutAgentNotification(success, trackingId) {
            var _a;
            const event = new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_1__.AGENT_SIGNOUT_RESULT, {
                detail: { agentName: (_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.agentName, result: success, trackingId },
                bubbles: true,
                composed: true
            });
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_4__.WINDOW_LISTENERS_HUB.dispatch(event);
        }
        setSignoutState(pending, wasError) {
            this.isSigningOutAgent = pending;
            const updateCell = new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_1__.UPDATE_ACTION_CELL_VALUE_EVENT, {
                composed: true,
                bubbles: true,
                detail: {
                    agentId: this.selectedAgentId,
                    signoutError: wasError,
                    signoutPending: pending
                }
            });
            this.updateActionCellValue(updateCell, FocusComponent.SIGNOUT);
        }
        confirmAgentSignout() {
            var _a, _b, _c, _d, _e;
            return __awaiter(this, void 0, void 0, function* () {
                this.setSignoutState(true, false);
                this.isSignoutModalOpen = false;
                try {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:TPW] event=signoutAgentBySupervisor for agent ", this.selectedAgentId);
                    yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.aqm.supervisor.signoutAgent({
                        orgId: this.tpwConfigs.orgId,
                        data: { agentId: this.selectedAgentId, logoutReason: _constants__WEBPACK_IMPORTED_MODULE_1__.AGENT_SIGNOUT_REASON }
                    });
                    (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.TELEM_EVENT.SIGNOUT_REQUESTED, {
                        Status: "Success",
                        SignedoutAgentId: this.selectedAgentId
                    }, [(_b = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_behavioral]);
                    this.setSignoutState(false, false);
                    this.fireSignedOutAgentNotification(true);
                }
                catch (error) {
                    this.setSignoutState(false, true);
                    const trackingId = (_c = error.details.trackingId) === null || _c === void 0 ? void 0 : _c.split("_")[1];
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[App:TPW] event=signoutAgentBySupervisorFailed for agent ", this.selectedAgentId, error);
                    this.fireSignedOutAgentNotification(false, trackingId);
                    (_d = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry) === null || _d === void 0 ? void 0 : _d.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.TELEM_EVENT.SIGNOUT_REQUESTED, {
                        Status: "Failed",
                        SignedoutAgentId: this.selectedAgentId,
                        TrackingId: trackingId
                    }, [(_e = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.SERVICE_PROVIDERS) === null || _e === void 0 ? void 0 : _e.webex_behavioral]);
                }
            });
        }
        declineAgentSignout() {
            this.isSignoutModalOpen = false;
            if (!this.returnFocusToSignoutIcon()) {
                this.returnFocusToMoreActionIcon();
            }
        }
        closeOverlayContent(config = {
            closeWebexSendMessage: true,
            closeContextMenu: true,
            closeStateChange: true
        }) {
            if (!Object.prototype.hasOwnProperty.call(config, "closeWebexSendMessage") || config.closeWebexSendMessage) {
                this.closeWebExChat();
            }
            if (!Object.prototype.hasOwnProperty.call(config, "closeContextMenu") || config.closeContextMenu) {
                this.closeContextMenu();
            }
            if (!Object.prototype.hasOwnProperty.call(config, "closeStateChange") || config.closeStateChange) {
                this.closeStateChangeOverlay();
            }
        }
        createPopperInstance(reference, popper, placement = "auto") {
            return (0,_popperjs_core__WEBPACK_IMPORTED_MODULE_9__.createPopper)(reference, popper, {
                placement,
                modifiers: [
                    ..._popperjs_core_lib_popper__WEBPACK_IMPORTED_MODULE_10__.defaultModifiers,
                    _popperjs_core_lib_popper__WEBPACK_IMPORTED_MODULE_10__.flip,
                    _popperjs_core_lib_popper__WEBPACK_IMPORTED_MODULE_10__.offset,
                    _popperjs_core_lib_popper__WEBPACK_IMPORTED_MODULE_10__.preventOverflow,
                    _popperjs_core_lib_popper__WEBPACK_IMPORTED_MODULE_10__.arrow,
                    {
                        name: "preventOverflow",
                        options: {
                            altAxis: true,
                            padding: 16
                        }
                    },
                    {
                        name: "offset",
                        options: {
                            offset: (({ innerPlacement, innerReference }) => {
                                if (innerPlacement === "left-end" || innerPlacement === "right-end") {
                                    return [innerReference.height + innerReference.y + 3, 14];
                                }
                                else if (innerPlacement === "left") {
                                    return [100, 15];
                                }
                                else {
                                    return [0, 5];
                                }
                            })
                        }
                    },
                    {
                        name: "computeStyles",
                        options: {
                            adaptive: false // this will recompute popper position
                        }
                    }
                ]
            });
        }
        updated(changedProperties) {
            var _a;
            super.updated(changedProperties);
            if (this.isError) {
                _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_12__.setTimeout(() => {
                    // showing row count 0 if error occurs in any subscription
                    this.displayedRowCount = 0;
                    this.showFailedToLoadDataEmptyGrid();
                }, 50);
            }
            const previousTPWConfigValue = changedProperties.get("tpwConfigs");
            if (this.filters && (changedProperties.has("appliedFilters") || changedProperties.has("appliedGroups"))) {
                setTimeout(() => {
                    var _a;
                    this.style.setProperty("--tpw-filter-height", `${((_a = this.filters.getBoundingClientRect()) === null || _a === void 0 ? void 0 : _a.height) || 0}px`);
                }, 50);
            }
            if (changedProperties.has("isError") ||
                changedProperties.has("isRequestTimeout") ||
                changedProperties.has("agentStatusData")) {
                this.handleAccessibility();
            }
            const isStateChangeFeatureFlagUpdated = () => {
                return (previousTPWConfigValue["isStateChangeBySupervisorEnabled"] !==
                    this.tpwConfigs.isStateChangeBySupervisorEnabled);
            };
            if (changedProperties.has("tpwConfigs") &&
                previousTPWConfigValue &&
                (previousTPWConfigValue["isDarkMode"] !== this.tpwConfigs.isDarkMode ||
                    previousTPWConfigValue["onActiveCall"] !== this.tpwConfigs.onActiveCall ||
                    isStateChangeFeatureFlagUpdated())) {
                (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.refreshCells({ force: true, columns: ["actions"] });
                // If feature flag values are changed, Validate the context menu visibility
                if (isStateChangeFeatureFlagUpdated() && this.contextMenuOpened && this.selectedActionCellValue.agentId) {
                    // Context menu is already opened while updating the FF value. So Update the context menu values.
                    this.updateContextMenuValuesTimeout = setTimeout(() => this.updateContextMenuValues(), _constants__WEBPACK_IMPORTED_MODULE_1__.TIMEOUT_THOUSAND_MS);
                }
            }
            if ((changedProperties.has("gridId") || changedProperties.has("tpwConfigs")) &&
                !this.isGridInitialized &&
                this.gridId &&
                this.tpwConfigs.isStationLoginSuccess) {
                // Initialize the grid only if it hasn't been initialized yet
                // and if gridId is not empty and isStationLoginSuccess is true
                _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:TPW] initializing grid");
                this.initializeGrid();
                this.isGridInitialized = true; // Set the flag to true to prevent re-initialization
            }
        }
        updateContextMenuValues() {
            var _a, _b;
            // Check, Is context menu is required after FF Changes.
            const moreActionsElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`.more-action-${(_b = this.selectedActionCellValue) === null || _b === void 0 ? void 0 : _b.agentId}`);
            if (moreActionsElement) {
                // Update the values on existing opened context menu.
                moreActionsElement === null || moreActionsElement === void 0 ? void 0 : moreActionsElement.click();
            }
            else {
                // Context Menu is not required to display, Remove the Context menu and it's overlay contents.
                this.closeOverlayContent();
            }
        }
        // This method will be helpful to Screen Reader to read the "No Records" text.
        handleAccessibility() {
            var _a;
            const overlay = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".ag-overlay");
            if (this.isError || this.isRequestTimeout || this.agentStatusData.length === 0) {
                // error, no records
                overlay === null || overlay === void 0 ? void 0 : overlay.removeAttribute("aria-hidden");
            }
            else {
                // If records are exist
                overlay === null || overlay === void 0 ? void 0 : overlay.setAttribute("aria-hidden", "true");
            }
        }
        createHTMLLink(href) {
            const linkElement = document.createElement("link");
            linkElement.setAttribute("rel", "stylesheet");
            linkElement.setAttribute("href", href);
            return linkElement;
        }
        loadAGGridScript() {
            var _a;
            const agGridLink = this.createHTMLLink("ag-grid/ag-grid.css");
            const agThemeAlpineLink = this.createHTMLLink("ag-grid/ag-theme-alpine.css");
            const momentumIcons = this.createHTMLLink("/css/momentum-ui-icons.min.css");
            const momentumCore = this.createHTMLLink("/css/momentum-ui.min.css");
            const rootElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".tpw-wrapper");
            rootElement === null || rootElement === void 0 ? void 0 : rootElement.prepend(agThemeAlpineLink);
            rootElement === null || rootElement === void 0 ? void 0 : rootElement.prepend(agGridLink);
            rootElement === null || rootElement === void 0 ? void 0 : rootElement.prepend(momentumIcons);
            rootElement === null || rootElement === void 0 ? void 0 : rootElement.prepend(momentumCore);
            agGridLink.onload = () => {
                this.isAgGridLoaded = true;
            };
            agThemeAlpineLink.onload = () => {
                this.isAlpineLoaded = true;
            };
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            this.loadAGGridScript();
            this.gridId = this.tpwConfigs.gridId;
        }
        onRowGroupuOpened(event) {
            const { node } = event;
            if (node.field && node.key) {
                this.addGroupToState(node.expanded, { field: node.field, key: node.key });
            }
        }
        addGroupToState(status, node) {
            var _a;
            if (status) {
                this.expandedGroupState.push(`${node.field}:${node.key}`);
            }
            else {
                const index = this.expandedGroupState.indexOf(`${node.field}:${node.key}`);
                (_a = this.expandedGroupState) === null || _a === void 0 ? void 0 : _a.splice(index, 1);
            }
            this.saveGridConfigs();
        }
        initializeGrid() {
            const setGridOptions = (fetchedAgents = new Map()) => {
                this.gridOptions = Object.assign(Object.assign(Object.assign({}, (0,_GridConfig__WEBPACK_IMPORTED_MODULE_21__.gridConfig)(this.getGridConfigs, this.isServerSidePaginated)), { debounceVerticalScrollbar: true, suppressAnimationFrame: true, enableBrowserTooltips: true, tooltipShowDelay: 2, rowData: this.agentStatusData.length === 0 ? null : this.agentStatusData, onGridReady: () => this.onGridReady(fetchedAgents), onDisplayedColumnsChanged: this.saveGridConfigs, onColumnResized: this.refreshColumn, onColumnPinned: this.refreshColumn, onSortChanged: this.onSortChanged, getRowId: (params) => params.data.agentId, onRowGroupOpened: (event) => this.onRowGroupuOpened(event), isGroupOpenByDefault: (params) => { var _a; return (_a = this.expandedGroupState) === null || _a === void 0 ? void 0 : _a.includes(`${params.field}:${params.key}`); }, rowHeight: 40, suppressGroupChangesColumnVisibility: "suppressHideOnGroup", onBodyScroll: () => {
                        this.closeOverlayContent();
                    } }), (this.isServerSidePaginated && {
                    rowModelType: "serverSide",
                    cacheBlockSize: this.tpwConfigs.requestedPageSize,
                    maxBlocksInCache: 1,
                    animateRows: true,
                    maxConcurrentDatasourceRequests: 1
                }));
                this.gridApi = this.createGridInstance(this.eGridDiv, this.gridOptions);
            };
            if (this.tpwConfigs.isShowSignedOutAgentsEnabled) {
                this.fetchAllAgents()
                    .then((fetchedAgents) => {
                    setGridOptions(fetchedAgents);
                })
                    .catch((error) => {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[App:TPW]: Failed to fetch agents from CMS on initialize grid:", error.message);
                    setGridOptions();
                });
            }
            else {
                setGridOptions();
            }
        }
        createGridInstance(element, options) {
            return (0,ag_grid_enterprise__WEBPACK_IMPORTED_MODULE_13__.createGrid)(element, options);
        }
        getActionColumnWidth() {
            var _a, _b;
            const actionColumn = (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.getColumnState().find((col) => col.colId === "actions");
            if (actionColumn) {
                return (_b = actionColumn.width) !== null && _b !== void 0 ? _b : 0;
            }
            return 0;
        }
        enrichCMSDataWithRTDData(fetchedAgents) {
            if (this.tpwConfigs.isShowSignedOutAgentsEnabled) {
                if (this.isServerSidePaginated && fetchedAgents) {
                    this.agentDataMap.forEach((agent) => {
                        const agentId = agent.agentId;
                        if (fetchedAgents.has(agentId)) {
                            const existingAgentData = this.agentDataMap.get(agentId);
                            const mergedAgentData = Object.assign(Object.assign({}, existingAgentData), agent);
                            fetchedAgents.set(agentId, mergedAgentData);
                        }
                    });
                    return fetchedAgents;
                }
                else {
                    this.agentDataMap = new Map([...(0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.convertCmsAgentDataArrayToMap)(this.cmsAgentData), ...this.agentDataMap]);
                    this.agentStatusData = Array.from(this.agentDataMap, (item) => item[1]);
                }
            }
            return new Map();
        }
        updateSelectedAgentDetails() {
            var _a;
            this.selectedAgentDetails =
                (_a = this.agentStatusData.find((agentData) => agentData.agentId === this.selectedAgentId)) !== null && _a !== void 0 ? _a : {};
        }
        constructor() {
            super();
            this.tpwConfigs = {
                gridId: "tpw-configs",
                orgId: "",
                isDarkMode: false,
                webexEnabled: false,
                isMCMEnabled: false,
                supervisorId: "",
                supervisorName: "",
                isStateChangeBySupervisorEnabled: false,
                isSignoutBySupervisorEnabled: false,
                supervisorEmail: "",
                supervisorAnalyserId: "",
                role: "",
                onActiveCall: false,
                isSupervisorySendMessageEnabled: false,
                isStationLoginSuccess: false,
                isEnvironmentProd: false,
                idleCodes: { isFetchingSuccess: false, data: [] },
                voiceChannelCount: 0,
                isMPCorPersistEnabled: false,
                isShowSignedOutAgentsEnabled: false,
                isWxccCoreDisallowPendingLogoutStateChangeEnabled: false,
                requestedPageSize: 0,
                isDesktopAuxCodesInfiniteScrollEnabled: false,
                isPostCallEnabled: false
            };
            this.gridId = "tpw-configs";
            this.agentStatusData = [];
            this.agentStatusDataServer = [];
            this.isModalOpen = false;
            this.isSignoutModalOpen = false;
            this.isGridRendered = false;
            this.appliedFilters = _Utils__WEBPACK_IMPORTED_MODULE_25__.initialFilterModel;
            this.gridOptions = {};
            this.displayedRowCount = 0;
            this.isError = false;
            this.isRequestTimeout = false;
            this.requestTimerId = 0;
            this.delayId = 0;
            this.globalStatusSubscription = {};
            this.channelStatusSubscription = {};
            this.contactStatsSubscription = {};
            this.appliedGroups = [];
            this.selectedAgentId = "";
            this.expandedGroupState = [];
            this.agentDataMap = new Map();
            this.cmsAgentData = [];
            this.isAgentGlobalSubscribed = false;
            this.isChannelStatusSubscribed = false;
            this.isContactStatusSubscribed = false;
            this.popperInstance = null;
            this.contextMenuInstance = null;
            this.selectedActionCellValue = {};
            this.resizeObserver = null;
            this.monitoringInProgress = false;
            this.updateContextMenuValuesTimeout = null;
            this.isGridInitialized = false;
            this.contextMenuOpened = false;
            this.webexChatOpened = false;
            this.stateSelectorInstance = null;
            this.stateSelectorOpened = false;
            this.contextMenuList = [];
            this.isServerSidePaginated = false;
            this.searchTerm = "";
            this.isSigningOutAgent = false;
            this.isAgGridLoaded = false;
            this.isAlpineLoaded = false;
            this.isMomentumAvatarEnabledReactionDisposer = undefined;
            this.subscribeGlobalStatusDataSet = () => __awaiter(this, void 0, void 0, function* () {
                var _a;
                try {
                    // Subscribe to wxcc.rtd.globalstatus
                    const response = yield ((_a = window.wxcc) === null || _a === void 0 ? void 0 : _a.rtdwc.subscribe({
                        datasetName: globalStatusDataSet,
                        update: (data, deltaData) => {
                            this.setAgentGlobalStatusData(data.datasetValues, data.type, deltaData === null || deltaData === void 0 ? void 0 : deltaData.datasetValues);
                        }
                    }));
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:TPW] subscribed AgentGlobalStatus successfully");
                    return response;
                }
                catch (error) {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[App:TPW] Failed to subscribe AgentGlobalStatus", error);
                    throw error;
                }
            });
            this.subscribeAgentChannelStatusDataSet = () => __awaiter(this, void 0, void 0, function* () {
                var _b;
                try {
                    // Subscribe to wxcc.rtd.agentchannelstatus
                    const response = yield ((_b = window.wxcc) === null || _b === void 0 ? void 0 : _b.rtdwc.subscribe({
                        datasetName: agentChannelStatusDataSet,
                        update: (data, deltaData) => {
                            this.setAgentChannelStatusData(data === null || data === void 0 ? void 0 : data.datasetValues, data.type, deltaData === null || deltaData === void 0 ? void 0 : deltaData.datasetValues);
                        }
                    }));
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:TPW] subscribed AgentChannelStatus successfully");
                    return response;
                }
                catch (error) {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[App:TPW] Failed to subscribe AgentChannelStatus", error);
                    throw error;
                }
            });
            this.subscribeContactStatsDataSet = () => __awaiter(this, void 0, void 0, function* () {
                var _c;
                try {
                    // Subscribe to wxcc.rtd.contactstatus
                    const response = yield ((_c = window.wxcc) === null || _c === void 0 ? void 0 : _c.rtdwc.subscribe({
                        datasetName: contactStatsDataSet,
                        update: (data, deltaData) => {
                            this.setAgentContactStatsData(data === null || data === void 0 ? void 0 : data.datasetValues, data.type, deltaData === null || deltaData === void 0 ? void 0 : deltaData.datasetValues);
                        }
                    }));
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:TPW] subscribed ContactStats successfully");
                    return response;
                }
                catch (error) {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("[App:TPW] Failed to subscribe ContactStats", error);
                    throw error;
                }
            });
            this.handleAgentSignout = (values, event) => {
                this.selectedActionCellValue = values;
                const detail = { selectedAgentId: event.detail.agentId };
                this.updateSelectedAgentId(detail);
                this.isSignoutModalOpen = true;
            };
            this.handleAgentSignoutContext = (event) => {
                const detail = { selectedAgentId: event.detail.agentId };
                this.updateSelectedAgentId(detail);
                this.isSignoutModalOpen = true;
            };
            this.handleStateChangeSelector = (values, event) => __awaiter(this, void 0, void 0, function* () {
                var _d;
                const detail = { selectedAgentId: values.agentId };
                this.updateSelectedAgentId(detail);
                // Close the existing popper instance
                this.closeOverlayContent({ closeStateChange: false });
                this.selectedActionCellValue = values;
                (_d = this.stateSelector) === null || _d === void 0 ? void 0 : _d.toggleAttribute("data-show", true);
                this.stateSelectorInstance = this.createPopperInstance(event, this.stateSelector, "bottom");
                this.stateSelectorOpened = true;
                this.positionStateSelectorInstance();
            });
            this.handleAIDModal = (agentId) => {
                this.closeOverlayContent();
                this.handleModal({ detail: { modalIsOpen: true } });
                this.selectedAgentId = agentId;
                const detail = { selectedAgentId: agentId };
                this.updateSelectedAgentId(detail);
            };
            this.handleContextMenu = (values, event, contextMenuList) => {
                var _a;
                this.closeOverlayContent({ closeContextMenu: false });
                this.contextMenuList = contextMenuList;
                this.selectedActionCellValue = values;
                (_a = this.contextMenu) === null || _a === void 0 ? void 0 : _a.toggleAttribute("data-show", true);
                setTimeout(() => {
                    this.contextMenuInstance = this.createPopperInstance(event, this.contextMenu, "bottom");
                    this.contextMenuOpened = true;
                    this.contextMenuInstance.update();
                }, 0);
            };
            this.handleWebexChat = (values, event) => {
                var _a;
                this.closeOverlayContent({ closeWebexSendMessage: false });
                this.selectedActionCellValue = values;
                (_a = this.overlayElement) === null || _a === void 0 ? void 0 : _a.toggleAttribute("data-show", true);
                setTimeout(() => {
                    this.popperInstance = this.createPopperInstance(event, this.overlayElement, "bottom");
                    this.webexChatOpened = true;
                    this.popperInstance.update();
                }, 0);
            };
            this.closeOverlayContentHandler = (_event) => {
                this.closeOverlayContent();
            };
            this.getGridConfigs = () => {
                return {
                    webexEnabled: this.tpwConfigs.webexEnabled,
                    isDarkMode: this.tpwConfigs.isDarkMode,
                    isMCMEnabled: this.tpwConfigs.isMCMEnabled,
                    isError: this.isError,
                    supervisorId: this.tpwConfigs.supervisorId,
                    isStateChangeBySupervisorEnabled: this.tpwConfigs.isStateChangeBySupervisorEnabled,
                    isSignoutBySupervisorEnabled: this.tpwConfigs.isSignoutBySupervisorEnabled,
                    onActiveCall: this.tpwConfigs.onActiveCall,
                    isSupervisorySendMessageEnabled: this.tpwConfigs.isSupervisorySendMessageEnabled,
                    actionCellLocalizationValues: this.actionCellLocalizationValues(),
                    actionCellWidth: this.getActionColumnWidth(),
                    voiceChannelCount: this.tpwConfigs.voiceChannelCount,
                    isMPCorPersistEnabled: this.tpwConfigs.isMPCorPersistEnabled,
                    isPostCallEnabled: this.tpwConfigs.isPostCallEnabled,
                    isDesktopAuxCodesInfiniteScrollEnabled: this.tpwConfigs.isDesktopAuxCodesInfiniteScrollEnabled,
                    handleAIDModal: this.handleAIDModal,
                    handleStateChangeSelector: this.handleStateChangeSelector,
                    handleContextMenu: this.handleContextMenu,
                    handleWebexChat: this.handleWebexChat,
                    handleAgentSignout: this.handleAgentSignout
                };
            };
            this.actionCellLocalizationValues = () => {
                return {
                    monitoring: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.monitoring"),
                    ownMonitoring: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.ownMonitoring"),
                    supervisorMonitoring: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.supervisorMonitoring"),
                    beingMonitored: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.beingMonitored"),
                    cannotMonitorConsult: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.cannotMonitorConsult"),
                    reviewAndMonitor: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.reviewAndMonitor"),
                    review: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.review"),
                    signingoutTooltip: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.signingoutTooltip"),
                    signingoutErrorTooltip: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.signingoutErrorTooltip"),
                    selfSignoutWarningTooltip: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.selfSignoutWarningTooltip"),
                    signoutTooltip: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.signoutTooltip"),
                    signoutBlockedTooltip: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.signoutBlockedTooltip"),
                    webexChatSendMessage: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:notifications.webexChatSendMessage"),
                    webexChatSendingMessage: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:notifications.webexChatSendingMessage"),
                    webexChatTPWErrorMessage: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:notifications.webexChatTPWErrorMessage"),
                    moreAction: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:notes:moreActions"),
                    stateChange: {
                        default: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.stateChange.default"),
                        progress: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.stateChange.progress"),
                        failed: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.stateChange.failed")
                    },
                    alreadyBargedIn: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.alreadyBargedIn"),
                    supervisorBargedIn: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.supervisorBargedIn"),
                    cannotMonitorBargedcall: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.cannotMonitorBargedCall"),
                    bargedIn: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.bargedIn"),
                    notHaveChannels: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.notHaveChannels"),
                    cannotMonitorWrapUp: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.cannotMonitorWrapUp"),
                    cannotMonitorWrapUpAssistance: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.cannotMonitorWrapUpAssistance"),
                    cannotMonitorPostCall: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:tpw.cannotMonitorPostCall")
                };
            };
            this.showFailedToLoadDataEmptyGrid = () => {
                var _a, _b, _c;
                (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setGridOption("loading", false);
                (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.hideOverlay();
                (_c = this.gridApi) === null || _c === void 0 ? void 0 : _c.showNoRowsOverlay();
                this.emptyGrid.setAttribute("is-error", "1");
            };
            this.handleModal = (e) => {
                var _a;
                this.isModalOpen = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.modalIsOpen;
                if (this.isModalOpen) {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.TELEM_EVENT.AID_OPENED, {
                        SupervisorId: this.tpwConfigs.supervisorId,
                        Role: this.tpwConfigs.role
                    });
                }
            };
            this.positionStateSelectorInstance = () => {
                setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                    var _a;
                    yield ((_a = this.stateSelectorInstance) === null || _a === void 0 ? void 0 : _a.update());
                }), 0);
            };
            this.refreshColumn = (event) => {
                var _a, _b;
                const column = event.column;
                if (!column) {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error("Trying to refresh a column that doesn't exist!");
                    return;
                }
                const columnId = (_a = event.column) === null || _a === void 0 ? void 0 : _a.getColId();
                if (column && columnId === "actions") {
                    (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.refreshCells({ force: true, columns: [columnId] });
                }
                this.debouncedSaveGridConfigs();
            };
            this.onGridReady = (fetchedAgents = new Map()) => {
                var _a, _b, _c, _d, _e;
                const storedGridConfigs = JSON.parse((_a = localStorage.getItem(this.tpwConfigs.gridId)) !== null && _a !== void 0 ? _a : "{}");
                if (Object.keys(storedGridConfigs).length) {
                    this.expandedGroupState = storedGridConfigs.rowGroupState || [];
                    const defaultState = (_b = this.gridApi) === null || _b === void 0 ? void 0 : _b.getColumnState().filter((item) => item.colId !== "agentInteractionTime");
                    if (!lodash__WEBPACK_IMPORTED_MODULE_16___default().isEqual(storedGridConfigs.columnState, defaultState)) {
                        (_c = this.gridApi) === null || _c === void 0 ? void 0 : _c.applyColumnState({
                            state: storedGridConfigs.columnState,
                            applyOrder: true
                        });
                    }
                    this.updateFilterModel(storedGridConfigs.filterModel);
                }
                (_d = this.gridApi) === null || _d === void 0 ? void 0 : _d.setGridOption("loading", true);
                this.isGridRendered = true;
                this.fetchAgentStatus();
                if (this.tpwConfigs.isShowSignedOutAgentsEnabled) {
                    if (this.isServerSidePaginated) {
                        (_e = this.gridApi) === null || _e === void 0 ? void 0 : _e.setGridOption("serverSideDatasource", this.createDatasource());
                    }
                    else {
                        this.agentDataMap = fetchedAgents;
                        this.setRowData();
                    }
                }
                this.getDisplayedRowCount();
                this.requestUpdate();
                this.handleAccessibility();
            };
            this.createDatasource = () => {
                const getPage = (startRow = 1) => {
                    if (startRow && startRow !== 0) {
                        return Math.ceil(startRow / this.tpwConfigs.requestedPageSize);
                    }
                    else {
                        return startRow;
                    }
                };
                const getSortOrder = (sortOrder) => {
                    const order = sortOrder.find((order) => order.colId === "agentNameDetails");
                    if (order) {
                        return order.sort;
                    }
                    return "asc"; //default
                };
                const fetchData = (params) => __awaiter(this, void 0, void 0, function* () {
                    const pageNumber = getPage(params.request.startRow);
                    const sortOrder = getSortOrder(params.request.sortModel);
                    const fetchedAgents = yield this.fetchAllAgents(pageNumber, this.searchTerm, sortOrder);
                    const enrichedAgents = this.enrichCMSDataWithRTDData(fetchedAgents);
                    const lastRow = enrichedAgents.size < this.tpwConfigs.requestedPageSize
                        ? pageNumber * this.tpwConfigs.requestedPageSize + enrichedAgents.size
                        : -1;
                    params.success({ rowData: Array.from(enrichedAgents.values()), rowCount: lastRow });
                });
                return {
                    getRows: (params) => __awaiter(this, void 0, void 0, function* () {
                        try {
                            yield fetchData(params);
                        }
                        catch (err) {
                            _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error(`Failed to fetch data paginated data. Error: ${err}`);
                            params.fail();
                        }
                    })
                };
            };
            this.onSortChanged = () => {
                var _a;
                this.saveGridConfigs();
                const columnState = (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.getColumnState();
                if (columnState) {
                    const sortedColumns = columnState.filter((column) => column.sort != null);
                    sortedColumns.forEach((column) => {
                        var _a, _b;
                        (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.TELEM_EVENT.TPW_COLUMN_SORTED, {
                            ColumnName: column.colId,
                            ColumnSortOrder: column.sort
                        }, [(_b = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_behavioral]);
                    });
                }
            };
            this.saveGridConfigs = () => {
                var _a;
                const columnState = (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.getColumnState();
                if (columnState) {
                    const groupedRow = columnState.filter((a) => a.rowGroup);
                    this.appliedGroups = groupedRow;
                }
                if (this.isGridRendered) {
                    localStorage.setItem(this.tpwConfigs.gridId, JSON.stringify({
                        filterModel: this.appliedFilters,
                        columnState,
                        rowGroupState: this.expandedGroupState
                    }));
                }
            };
            this.debouncedSaveGridConfigs = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_5__.debounce)(this.saveGridConfigs, 300);
            this.updateSelectedAgentId = (detail) => {
                if (detail.selectedAgentId && this.agentStatusData && this.agentStatusData.length > 0) {
                    this.selectedAgentId = detail.selectedAgentId;
                    this.updateSelectedAgentDetails();
                }
            };
            this.handleOutSideClick = (event) => {
                let insideMenuClick = false;
                const path = event.composedPath();
                if (path.length) {
                    insideMenuClick = !!path.find((element) => element === this.overlayElement || element === this.contextMenu || element === this.stateSelector);
                    if (!insideMenuClick || event.code === "Escape") {
                        if (event.type === "keydown" && event.code === "Escape") {
                            if (this.contextMenuOpened) {
                                this.returnFocusToMoreActionIcon();
                            }
                            else if (this.webexChatOpened) {
                                this.returnFocusToChatIcon();
                            }
                            else if (this.stateSelectorOpened) {
                                this.returnFocusToChangeStateIcon();
                            }
                            else if (this.isModalOpen) {
                                this.handleFocusOnCloseOfReviewAndMonitor();
                            }
                        }
                        else if (event.type === "click" && this.isSigningOutAgent) {
                            this.returnFocusToSignoutIcon();
                            return; //while selecting sign out option ignore the click which interacts with the modal choice
                        }
                        this.closeOverlayContent();
                    }
                }
            };
            this.handleFocusOnEscape = (e) => {
                const headerElement = this.eGridDiv.querySelector(`.ag-header-cell[col-id="${e.detail}"]`);
                if (headerElement) {
                    headerElement.focus();
                }
            };
            this.handleTPWMonitorModal = (e) => {
                this.handleModal(e);
                this.handleFocusOnCloseOfReviewAndMonitor();
            };
            this.setUpdatedFilter = (event, fromRenderer) => {
                event.stopPropagation();
                let updatedFilter = {};
                if (fromRenderer) {
                    updatedFilter = Object.assign(Object.assign({}, this.appliedFilters), { [event.detail.field]: (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_24__.checkIfFilterModelIsEmpty)(event.detail.data)
                            ? {}
                            : Object.assign(Object.assign({}, this.appliedFilters[event.detail.field]), event.detail.data) });
                }
                else {
                    updatedFilter = event.detail.clearAllFilter
                        ? _Utils__WEBPACK_IMPORTED_MODULE_25__.initialFilterModel
                        : Object.assign(Object.assign({}, this.appliedFilters), { [event.detail.field]: event.detail.data });
                }
                this.updateFilterModel(updatedFilter);
                this.getDisplayedRowCount();
                this.saveGridConfigs();
                this.requestUpdate();
            };
            this.updateGroupState = (rowGroupCol) => {
                this.expandedGroupState = this.expandedGroupState.filter((item) => {
                    return rowGroupCol.some((col) => {
                        return item.includes(col);
                    });
                });
            };
            this.updateGroupStateAfterData = (rowGroupCol) => {
                let groups = [];
                rowGroupCol.forEach((col) => {
                    groups = [
                        ...groups,
                        ...new Set(this.agentStatusData.map((item) => {
                            if (col === "agentNameDetails") {
                                return `${col}:${item[col].agentName}`;
                            }
                            return `${col}:${item[col]}`;
                        }))
                    ];
                });
                this.expandedGroupState = this.expandedGroupState.filter((groupState) => {
                    return groups.includes(groupState);
                });
            };
            this.setUpdatedGroupFilter = (event) => {
                var _a;
                event.stopPropagation();
                const { clearAllFilter, field } = event.detail;
                let updatedFilter;
                if (clearAllFilter) {
                    updatedFilter = [];
                    this.appliedGroups = [];
                }
                else {
                    const updatedGroupTemp = this.appliedGroups.filter((a) => a.colId !== field);
                    updatedFilter = updatedGroupTemp.map((a) => a.colId);
                    this.appliedGroups = updatedGroupTemp;
                }
                (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setRowGroupColumns(updatedFilter);
                this.updateGroupState(updatedFilter);
                this.getDisplayedRowCount();
                this.saveGridConfigs();
                this.requestUpdate();
            };
            this.updateGroupFilter = () => {
                const updatedFilter = this.appliedGroups.map((a) => a.colId);
                this.updateGroupStateAfterData(updatedFilter);
            };
            this.closeContextMenu = () => {
                var _a, _b;
                (_a = this.contextMenu) === null || _a === void 0 ? void 0 : _a.toggleAttribute("data-show", false);
                (_b = this.contextMenuInstance) === null || _b === void 0 ? void 0 : _b.destroy();
                this.contextMenuOpened = false;
                setTimeout(() => {
                    this.contextMenuInstance = null;
                }, 0);
            };
            this.closeWebExChat = () => {
                var _a, _b;
                (_a = this.overlayElement) === null || _a === void 0 ? void 0 : _a.toggleAttribute("data-show", false);
                (_b = this.popperInstance) === null || _b === void 0 ? void 0 : _b.destroy();
                this.webexChatOpened = false;
                setTimeout(() => {
                    this.popperInstance = null;
                }, 0);
            };
            this.closeStateChangeOverlay = () => {
                var _a;
                if (this.stateSelectorOpened) {
                    (_a = this.stateSelector) === null || _a === void 0 ? void 0 : _a.toggleAttribute("data-show", false);
                    this.stateSelectorOpened = false;
                    setTimeout(() => {
                        var _a;
                        (_a = this.stateSelectorInstance) === null || _a === void 0 ? void 0 : _a.destroy();
                        this.stateSelectorInstance = null;
                    }, 0);
                }
            };
            this.updateActionCellValue = (params, focusComponent) => {
                var _a, _b, _c, _d, _e, _f;
                const rowNode = (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.getRowNode((_b = params.detail) === null || _b === void 0 ? void 0 : _b.agentId);
                rowNode === null || rowNode === void 0 ? void 0 : rowNode.setDataValue("actions", Object.assign(Object.assign({}, rowNode.data.actions), params === null || params === void 0 ? void 0 : params.detail));
                if (((_c = this.selectedActionCellValue) === null || _c === void 0 ? void 0 : _c.agentId) === ((_d = params.detail) === null || _d === void 0 ? void 0 : _d.agentId)) {
                    this.selectedActionCellValue = Object.assign(Object.assign({}, this.selectedActionCellValue), params === null || params === void 0 ? void 0 : params.detail);
                    this.focusOnComponent(focusComponent);
                }
                // Update Action Cell value to internal properties
                if (this.agentDataMap) {
                    const currentValue = this.agentDataMap.get((_e = params.detail) === null || _e === void 0 ? void 0 : _e.agentId);
                    if (currentValue === null || currentValue === void 0 ? void 0 : currentValue.actions) {
                        // Update only action cell values.
                        const mapValue = Object.assign(Object.assign({}, currentValue), { actions: Object.assign(Object.assign({}, currentValue.actions), params === null || params === void 0 ? void 0 : params.detail) });
                        this.agentDataMap.set((_f = params.detail) === null || _f === void 0 ? void 0 : _f.agentId, mapValue);
                    }
                }
            };
            (0,_components_Common_Utils_GridUtils__WEBPACK_IMPORTED_MODULE_0__.initializeGlobalGridProperties)();
        }
        connectedCallback() {
            const _super = Object.create(null, {
                connectedCallback: { get: () => super.connectedCallback }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.connectedCallback.call(this);
                window.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_1__.TPW_MONITOR_MODAL, this.handleTPWMonitorModal);
                window.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_1__.TPW_FILTER_MODAL_UPDATED, this.saveGridConfigs);
                window.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_1__.TPW_AGENT_STATE_SELECTOR_LOADING_CHANGED, this.positionStateSelectorInstance);
                document.addEventListener("click", this.handleOutSideClick);
                document.addEventListener("keydown", this.handleOutSideClick);
                document.addEventListener("scroll", this.closeOverlayContentHandler, { passive: true });
                document.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_1__.COLUMN_MENU_FOCUS, this.handleFocusOnEscape);
                this.isMomentumAvatarEnabledReactionDisposer = (0,mobx__WEBPACK_IMPORTED_MODULE_17__.reaction)(() => _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__.themeManager.isMomentumAvatarEnabled, () => {
                    var _a;
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("[App:TPW] isMomentumAvatarEnabled changed refreshing agentNameDetails: ", _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_8__.themeManager.isMomentumAvatarEnabled);
                    (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.refreshCells({ force: true, columns: ["agentNameDetails"] });
                });
            });
        }
        disconnectedCallback() {
            var _a, _b, _c;
            super.disconnectedCallback();
            if ((_a = this.contactStatsSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe) {
                this.contactStatsSubscription.unsubscribe();
            }
            if ((_b = this.channelStatusSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe) {
                this.channelStatusSubscription.unsubscribe();
            }
            if ((_c = this.globalStatusSubscription) === null || _c === void 0 ? void 0 : _c.unsubscribe) {
                this.globalStatusSubscription.unsubscribe();
            }
            _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_12__.clearTimeout(this.requestTimerId);
            _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_12__.clearTimeout(this.delayId);
            window.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_1__.TPW_MONITOR_MODAL, this.handleTPWMonitorModal);
            window.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_1__.TPW_FILTER_MODAL_UPDATED, this.saveGridConfigs);
            window.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_1__.TPW_AGENT_STATE_SELECTOR_LOADING_CHANGED, this.positionStateSelectorInstance);
            document.removeEventListener("click", this.handleOutSideClick);
            document.removeEventListener("keydown", this.handleOutSideClick);
            document.removeEventListener("scroll", this.closeOverlayContentHandler);
            document.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_1__.COLUMN_MENU_FOCUS, this.handleFocusOnEscape);
            this.agentDataMap = new Map();
            this.agentStatusData = [];
            this.tpwConfigs = {};
            if (this.updateContextMenuValuesTimeout) {
                clearTimeout(this.updateContextMenuValuesTimeout);
            }
            if (this.isMomentumAvatarEnabledReactionDisposer) {
                this.isMomentumAvatarEnabledReactionDisposer();
            }
        }
        updateFilterModel(filterModel) {
            var _a;
            this.appliedFilters = filterModel;
            (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setFilterModel(filterModel);
        }
        resetColumnState() {
            var _a;
            (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.resetColumnState();
        }
        getDisplayedRowCount() {
            var _a;
            if (this.isServerSidePaginated) {
                return;
            }
            let filteredRowCount = 0;
            (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.forEachNodeAfterFilter((rowNode, _index) => {
                if (rowNode.data) {
                    filteredRowCount++;
                }
            });
            this.displayedRowCount = filteredRowCount;
        }
        returnFocusToChatIcon() {
            var _a, _b, _c, _d, _e;
            // Focus back to the Chat Icon
            if (this.contextMenuOpened) {
                // Context Menu is opened.
                // Focus to the list
                if (this.contextMenu) {
                    const contextMenuElement = (_c = (_b = (_a = this.contextMenu) === null || _a === void 0 ? void 0 : _a.querySelector("agentx-wc-tpw-context-menu")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector(".webex-send-message");
                    if (contextMenuElement) {
                        contextMenuElement === null || contextMenuElement === void 0 ? void 0 : contextMenuElement.focus();
                    }
                }
            }
            else {
                // Focus to the chat icon inside action cell.
                const webexButtonElement = (_d = this.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector(`.agentx-webex-chat-${(_e = this.selectedActionCellValue) === null || _e === void 0 ? void 0 : _e.agentId}`);
                if (webexButtonElement) {
                    webexButtonElement === null || webexButtonElement === void 0 ? void 0 : webexButtonElement.focus();
                }
            }
        }
        returnFocusToMoreActionIcon() {
            var _a, _b;
            const moreActionsButtonElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`.more-action-${(_b = this.selectedActionCellValue) === null || _b === void 0 ? void 0 : _b.agentId}`);
            if (moreActionsButtonElement) {
                moreActionsButtonElement === null || moreActionsButtonElement === void 0 ? void 0 : moreActionsButtonElement.focus();
            }
        }
        returnFocusToChangeStateIcon() {
            var _a, _b;
            const stateChangeButtonElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`.state-change-${(_b = this.selectedActionCellValue) === null || _b === void 0 ? void 0 : _b.agentId}`);
            if (stateChangeButtonElement) {
                stateChangeButtonElement === null || stateChangeButtonElement === void 0 ? void 0 : stateChangeButtonElement.focus();
            }
        }
        returnFocusToSignoutIcon() {
            var _a, _b;
            const signoutButtonElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`.signout-${(_b = this.selectedActionCellValue) === null || _b === void 0 ? void 0 : _b.agentId}`);
            if (signoutButtonElement) {
                signoutButtonElement === null || signoutButtonElement === void 0 ? void 0 : signoutButtonElement.focus();
                return true;
            }
            return false;
        }
        handleFocusOnCloseOfReviewAndMonitor() {
            var _a;
            const reviewAndMonitorButton = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`.review-monitor-${this.selectedAgentId}`);
            if (reviewAndMonitorButton) {
                reviewAndMonitorButton === null || reviewAndMonitorButton === void 0 ? void 0 : reviewAndMonitorButton.focus();
            }
            else {
                this.returnFocusToMoreActionIcon();
            }
        }
        focusOnComponent(focusComponent) {
            switch (focusComponent) {
                case FocusComponent.SEND_MESSAGE:
                    this.returnFocusToChatIcon();
                    break;
                case FocusComponent.STATE_CHANGE:
                    this.returnFocusToChangeStateIcon();
                    break;
                case FocusComponent.SIGNOUT:
                    this.returnFocusToSignoutIcon();
                    break;
            }
        }
        render() {
            var _a, _b, _c, _d, _e, _f;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.html) `
        ${this.tpwConfigs.isSignoutBySupervisorEnabled
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.html) `
              <agentx-wc-tpw-signout-modal
                .isSignoutModalOpen=${this.isSignoutModalOpen}
                .selectedAgentDetails=${this.selectedAgentDetails}
                @confirm-signout="${this.confirmAgentSignout}"
                @decline-signout="${this.declineAgentSignout}"
              ></agentx-wc-tpw-signout-modal>
            `
                : lit_html_lib_part__WEBPACK_IMPORTED_MODULE_15__.nothing}
        <div class="tpw-wrapper">
          <agentx-wc-tpw-grid-header
            .gridApi=${this.gridApi}
            .gridOptions=${this.gridOptions}
            .displayedRowCount=${this.displayedRowCount}
            .isServerSidePaginated=${this.isServerSidePaginated}
            @tpw-search-updated=${(searchTerm) => {
                var _a;
                if (this.isServerSidePaginated) {
                    this.searchTerm = searchTerm.detail.searchTerm;
                    (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.refreshServerSide({ purge: true });
                }
                else {
                    this.getDisplayedRowCount();
                }
            }}
            @tpw-reset-table=${(event) => {
                this.expandedGroupState = [];
                this.setUpdatedFilter(event);
                this.resetColumnState();
            }}
          ></agentx-wc-tpw-grid-header>

          <agentx-wc-tpw-applied-filters
            id="filters"
            .appliedFilters=${this.appliedFilters}
            .appliedGroups=${this.appliedGroups}
            .gridOptions=${this.gridOptions}
            @tpw-group-filter-updated=${(event) => this.setUpdatedGroupFilter(event)}
            @tpw-filter-updated=${(event) => this.setUpdatedFilter(event)}
          ></agentx-wc-tpw-applied-filters>
          <div
            class=${`grid-container ${this.isGridRendered ? "" : "grid-rendering"} ${this.tpwConfigs.isDarkMode ? "ag-theme-alpine-dark" : "ag-theme-alpine"}`}
            id="agentx-wc-tpw-grid-container"
            @tpw-filter-updated=${(event) => this.setUpdatedFilter(event, true)}
          ></div>
          <agentx-wc-aid
            @tpw-monitor-modal=${(e) => {
                this.handleModal(e);
                this.handleFocusOnCloseOfReviewAndMonitor();
            }}
            .selectedAgentDetails=${this.selectedAgentDetails}
            .isModalOpen=${this.isModalOpen}
            .isMCMEnabled=${this.tpwConfigs.isMCMEnabled}
            .role=${this.tpwConfigs.role}
            .monitoringInProgress=${this.monitoringInProgress}
            .isMPCorPersistEnabled=${this.tpwConfigs.isMPCorPersistEnabled}
            .isPostCallEnabled=${this.tpwConfigs.isPostCallEnabled}
          ></agentx-wc-aid>

          <div class="tpw-chat-wrapper custom-menu-overlay overlay-container" role="dialog">
            <div class="overlay-content" part="overlay-content">
              <webex-chat
                .isOpen="${this.webexChatOpened}"
                name="${(_a = this.selectedActionCellValue) === null || _a === void 0 ? void 0 : _a.agentName}"
                agentId="${(_b = this.selectedActionCellValue) === null || _b === void 0 ? void 0 : _b.agentId}"
                agentEmail="${(_c = this.selectedActionCellValue) === null || _c === void 0 ? void 0 : _c.agentEmail}"
                @webexchat-overlay-close="${() => {
                this.closeWebExChat();
                this.returnFocusToChatIcon();
            }}"
                @update-actions-cell-value="${(event) => this.updateActionCellValue(event, FocusComponent.SEND_MESSAGE)}"
              ></webex-chat>
            </div>
          </div>

          <div class="context-menu-wrapper custom-menu-overlay overlay-container" role="menu">
            <agentx-wc-tpw-context-menu
              .isOpen="${this.contextMenuOpened}"
              .contextMenuList="${this.contextMenuList}"
              agentId="${(_d = this.selectedActionCellValue) === null || _d === void 0 ? void 0 : _d.agentId}"
              .actionCellConfigs="${this.selectedActionCellValue}"
              .isMCMEnabled=${this.tpwConfigs.isMCMEnabled}
              .webexEnabled=${this.tpwConfigs.webexEnabled}
              .isMPCorPersistEnabled=${this.tpwConfigs.isMPCorPersistEnabled}
              .isPostCallEnabled=${this.tpwConfigs.isPostCallEnabled}
              .isSupervisorySendMessageEnabled=${this.tpwConfigs.isSupervisorySendMessageEnabled}
              @handle-webex-chat=${this.handleWebexChatContext}
              @handle-state-change="${this.handleStateChangeContext}"
              @handle-agent-signout="${this.handleAgentSignoutContext}"
              @handle-aid-modal=${(event) => this.handleAIDModal(event.detail.agentId)}
            ></agentx-wc-tpw-context-menu>
          </div>

          ${this.tpwConfigs.isStateChangeBySupervisorEnabled
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.html) ` <div class="agent-state-selector custom-menu-overlay overlay-container" role="dialog">
                <div class="overlay-content" part="overlay-content">
                  ${this.tpwConfigs.isDesktopAuxCodesInfiniteScrollEnabled
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.html) ` <agentx-wc-tpw-agent-state-selector-infinite
                        .isWxccCoreDisallowPendingLogoutStateChangeEnabled="${this.tpwConfigs
                        .isWxccCoreDisallowPendingLogoutStateChangeEnabled}"
                        .orgId="${this.tpwConfigs.orgId}"
                        .selectedAgentDetails=${this.selectedAgentDetails}
                        .isOpen="${this.stateSelectorOpened}"
                        agentId="${(_e = this.selectedActionCellValue) === null || _e === void 0 ? void 0 : _e.agentId}"
                        @update-actions-cell-value="${(event) => this.updateActionCellValue(event, FocusComponent.STATE_CHANGE)}"
                        @state-change-overlay-close="${() => {
                        this.closeStateChangeOverlay();
                        this.returnFocusToChangeStateIcon();
                    }}"
                      ></agentx-wc-tpw-agent-state-selector-infinite>`
                    : (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.html) ` <agentx-wc-tpw-agent-state-selector
                        .isWxccCoreDisallowPendingLogoutStateChangeEnabled="${this.tpwConfigs
                        .isWxccCoreDisallowPendingLogoutStateChangeEnabled}"
                        .orgId="${this.tpwConfigs.orgId}"
                        .selectedAgentDetails=${this.selectedAgentDetails}
                        .orgIdleCodes="${this.tpwConfigs.idleCodes}"
                        .isOpen="${this.stateSelectorOpened}"
                        agentId="${(_f = this.selectedActionCellValue) === null || _f === void 0 ? void 0 : _f.agentId}"
                        @update-actions-cell-value="${(event) => this.updateActionCellValue(event, FocusComponent.STATE_CHANGE)}"
                        @state-change-overlay-close="${() => {
                        this.closeStateChangeOverlay();
                        this.returnFocusToChangeStateIcon();
                    }}"
                      ></agentx-wc-tpw-agent-state-selector>`}
                </div>
              </div>`
                : lit_html_lib_part__WEBPACK_IMPORTED_MODULE_15__.nothing}
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.property)({ type: Object })
    ], Element.prototype, "tpwConfigs", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "gridId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "agentStatusData", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "agentStatusDataServer", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isSignoutModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isGridRendered", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "appliedFilters", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "gridApi", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "gridOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "displayedRowCount", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isRequestTimeout", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "requestTimerId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "delayId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "selectedAgentDetails", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "globalStatusSubscription", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "channelStatusSubscription", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "contactStatsSubscription", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "appliedGroups", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "selectedAgentId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "expandedGroupState", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "agentDataMap", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "cmsAgentData", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isAgentGlobalSubscribed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isChannelStatusSubscribed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isContactStatusSubscribed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "popperInstance", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "contextMenuInstance", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "selectedActionCellValue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "resizeObserver", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "monitoringInProgress", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "updateContextMenuValuesTimeout", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isGridInitialized", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.query)("#agentx-wc-tpw-grid-container")
    ], Element.prototype, "eGridDiv", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.query)("agentx-wc-tpw-empty-grid")
    ], Element.prototype, "emptyGrid", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.query)("#filters")
    ], Element.prototype, "filters", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.query)(".tpw-chat-wrapper")
    ], Element.prototype, "overlayElement", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.query)(".context-menu-wrapper")
    ], Element.prototype, "contextMenu", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "contextMenuOpened", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "webexChatOpened", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "stateSelectorInstance", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.query)(".agent-state-selector")
    ], Element.prototype, "stateSelector", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "stateSelectorOpened", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "contextMenuList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isServerSidePaginated", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "searchTerm", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isSigningOutAgent", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isAgGridLoaded", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.internalProperty)()
    ], Element.prototype, "isAlpineLoaded", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_14__.customElement)("agentx-wc-team-performance-widget")
    ], Element);
    TeamPerformance.Element = Element;
})(TeamPerformance || (TeamPerformance = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts":
/*!**********************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   agentNameComparator: () => (/* binding */ agentNameComparator),
/* harmony export */   checkIfFilterModelIsEmpty: () => (/* binding */ checkIfFilterModelIsEmpty),
/* harmony export */   convertChannelStatusArrayToMap: () => (/* binding */ convertChannelStatusArrayToMap),
/* harmony export */   convertCmsAgentDataArrayToMap: () => (/* binding */ convertCmsAgentDataArrayToMap),
/* harmony export */   convertContactStatusArrayToMap: () => (/* binding */ convertContactStatusArrayToMap),
/* harmony export */   convertGlobalStatusArrayToMap: () => (/* binding */ convertGlobalStatusArrayToMap),
/* harmony export */   createGenericEvent: () => (/* binding */ createGenericEvent),
/* harmony export */   dateComparator: () => (/* binding */ dateComparator),
/* harmony export */   disptachFilterDataUpdateEvent: () => (/* binding */ disptachFilterDataUpdateEvent),
/* harmony export */   disptachFilterUpdateEvent: () => (/* binding */ disptachFilterUpdateEvent),
/* harmony export */   durationComparator: () => (/* binding */ durationComparator),
/* harmony export */   filterContactStatsData: () => (/* binding */ filterContactStatsData),
/* harmony export */   filteredTelephonyChannelData: () => (/* binding */ filteredTelephonyChannelData),
/* harmony export */   formatDuration: () => (/* binding */ formatDuration),
/* harmony export */   getAgentInteractionTime: () => (/* binding */ getAgentInteractionTime),
/* harmony export */   getAgentState: () => (/* binding */ getAgentState),
/* harmony export */   getAvatarUrlFromCache: () => (/* binding */ getAvatarUrlFromCache),
/* harmony export */   getContactStatsDetailsForAllParticipants: () => (/* binding */ getContactStatsDetailsForAllParticipants),
/* harmony export */   getDateFormat: () => (/* binding */ getDateFormat),
/* harmony export */   getDisplayedRowCountText: () => (/* binding */ getDisplayedRowCountText),
/* harmony export */   getFormattedDurationTime: () => (/* binding */ getFormattedDurationTime),
/* harmony export */   getParticipantsDetails: () => (/* binding */ getParticipantsDetails),
/* harmony export */   getTimerValue: () => (/* binding */ getTimerValue),
/* harmony export */   mapAgentContactStatus: () => (/* binding */ mapAgentContactStatus),
/* harmony export */   stringComparator: () => (/* binding */ stringComparator),
/* harmony export */   transformChannelStatus: () => (/* binding */ transformChannelStatus),
/* harmony export */   updateAvatarUrlCache: () => (/* binding */ updateAvatarUrlCache),
/* harmony export */   updateContactStatsForDestinationAgent: () => (/* binding */ updateContactStatsForDestinationAgent),
/* harmony export */   updateExistingMapFromChannelStatus: () => (/* binding */ updateExistingMapFromChannelStatus),
/* harmony export */   updateExistingMapFromContactStats: () => (/* binding */ updateExistingMapFromContactStats),
/* harmony export */   updateExistingMapFromGlobalStatus: () => (/* binding */ updateExistingMapFromGlobalStatus)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");




const cacheKey = (agentId) => `avt-${agentId}`;
const createGenericEvent = (key, detail) => {
    return new CustomEvent(key, {
        composed: true,
        bubbles: true,
        detail: Object.assign({}, detail)
    });
};
// on filter update save the grid configs to local storage
const disptachFilterUpdateEvent = (comp) => {
    comp.dispatchEvent(createGenericEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.TPW_FILTER_MODAL_UPDATED, {}));
};
const disptachFilterDataUpdateEvent = (key) => {
    window.dispatchEvent(createGenericEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.TPW_FILTER_DATA_UPDATE, { colId: key }));
};
/**
 * Checks if applied filters exists for that specific column key for which filter is applied
 * @param comp
 * @param key
 * @returns Boolean
 */
const checkIfFilterAppliedExists = (comp, key) => {
    return (comp.appliedFilters &&
        Object.prototype.hasOwnProperty.call(comp.appliedFilters, key) &&
        Object.keys(comp.appliedFilters[key]).length !== 0);
};
const isReviewAndMonitorEnabled = (contactStatus) => {
    return !!contactStatus && !_Utils__WEBPACK_IMPORTED_MODULE_3__.disableForContactStatus.includes(contactStatus);
};
/**
 * Add the new row entry data into the filter model
 * @param comp
 * @param key
 * @param rowData
 */
const updateAppliedFilter = (comp, key, rowData, oldData) => {
    if (checkIfFilterAppliedExists(comp, key)) {
        const k = rowData[key];
        if (oldData && oldData[key] === _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE && k !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE) {
            delete comp.appliedFilters[key][_constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE];
        }
        if (key === "agentNameDetails") {
            // agentNameDetails is a object, Contains the agentName property.
            if (!Object.prototype.hasOwnProperty.call(comp.appliedFilters[key], k.agentName)) {
                comp.appliedFilters[key][k.agentName] = false;
            }
        }
        else if (!Object.prototype.hasOwnProperty.call(comp.appliedFilters[key], k)) {
            comp.appliedFilters[key][k] = false;
        }
    }
};
const getDateFormat = (date, lang = "en-US") => {
    const dateTime = luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.fromJSDate(new Date(date)).setLocale(lang);
    if (lang.startsWith("ja")) {
        return `${dateTime.toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.DATE_SHORT)}, ${dateTime.toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.TIME_SIMPLE)}`;
    }
    else {
        return dateTime.toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.DATETIME_SHORT);
    }
};
const getAvatarUrlFromCache = (agentId) => {
    const url = sessionStorage.getItem(cacheKey(agentId));
    return (typeof url === "string" && url.trim() === "") || url ? url : undefined;
};
const updateAvatarUrlCache = (agentId, url) => {
    sessionStorage.setItem(cacheKey(agentId), url ? url : "");
};
const getDisplayedRowCountText = (displayedRowCount) => {
    return displayedRowCount === 1
        ? `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.displaying")} ${displayedRowCount} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.agent")}`
        : `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.displaying")} ${displayedRowCount} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.agents")}`;
};
const formatDuration = (duration, showDefaultHours = true) => {
    if (!showDefaultHours && duration.shiftTo("hours", "minute").get("hours") < 1) {
        return duration.toFormat("mm:ss");
    }
    return duration.toFormat("hh:mm:ss");
};
const getFormattedDurationTime = (durationTime, showDefaultHours) => {
    if (durationTime) {
        if (durationTime.shiftTo("seconds").seconds < 0) {
            return undefined;
        }
        const formattedDurationTime = formatDuration(durationTime, showDefaultHours);
        if (formattedDurationTime &&
            formattedDurationTime !== "Invalid DateTime" &&
            formattedDurationTime.split(":")[0].length === 1) {
            return `0${formattedDurationTime}`;
        }
        return formattedDurationTime;
    }
    return undefined;
};
const getTimerValue = (duration, showDefaultHours) => {
    if (duration === _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE) {
        return "Invalid Duration";
    }
    const start = luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.fromMillis(Number(duration));
    return getFormattedDurationTime(luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.utc().diff(start), showDefaultHours);
};
const getAgentState = (state, idleCodeName) => {
    if (state) {
        if (idleCodeName) {
            return idleCodeName;
        }
        else if (state === _constants__WEBPACK_IMPORTED_MODULE_0__.LOGGED_OUT) {
            return _constants__WEBPACK_IMPORTED_MODULE_0__.SIGNED_OUT;
        }
        else {
            return state;
        }
    }
    return _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE;
};
const stringComparator = (valueA, valueB) => {
    const nameA = valueA === null || valueA === void 0 ? void 0 : valueA.toLocaleLowerCase();
    const nameB = valueB === null || valueB === void 0 ? void 0 : valueB.toLocaleLowerCase();
    if (nameA < nameB) {
        return -1;
    }
    if (nameA > nameB) {
        return 1;
    }
    return 0;
};
const agentNameComparator = (valueA, valueB) => {
    const firstValue = typeof valueA === "object" ? valueA["agentName"] : valueA;
    const secondValue = typeof valueB === "object" ? valueB["agentName"] : valueB;
    const nameA = firstValue === null || firstValue === void 0 ? void 0 : firstValue.toLocaleLowerCase();
    const nameB = secondValue === null || secondValue === void 0 ? void 0 : secondValue.toLocaleLowerCase();
    if (nameA < nameB) {
        return -1;
    }
    if (nameA > nameB) {
        return 1;
    }
    return 0;
};
const durationComparator = (valueA, valueB) => {
    if (valueA < valueB) {
        return 1;
    }
    if (valueA > valueB) {
        return -1;
    }
    return 0;
};
const dateComparator = (valueA, valueB) => {
    if (valueA === _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE && valueB !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE) {
        return 1;
    }
    if (valueA !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE && valueB === _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE) {
        return -1;
    }
    if (valueA === _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE && valueB === _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE) {
        return 0;
    }
    if (valueA < valueB) {
        return -1;
    }
    if (valueA > valueB) {
        return 1;
    }
    return 0;
};
const checkIfFilterModelIsEmpty = (filterModel) => {
    return Object.values(filterModel).every((item) => !item);
};
const getParticipatedSupervisorName = (isSameSupervisor, monitoringSupervisorName) => {
    return isSameSupervisor ? `, ${monitoringSupervisorName} (${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.you")})` : `, ${monitoringSupervisorName}`;
};
const getParticipantsDetails = (agentContact, newEventName, isMPCorPersistEnabled, supervisorId) => {
    var _a;
    const destinationAgent = (_a = agentContact.destinationAgentName) !== null && _a !== void 0 ? _a : agentContact.destinationAgentDNIS;
    const bargedInSupervisor = agentContact.isBarged === "true" && agentContact.monitorFullName
        ? getParticipatedSupervisorName(!!supervisorId && supervisorId === agentContact.monitorUserId, agentContact.monitorFullName)
        : "";
    let participantDetails = {
        activeParticipantsName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
        consultedParticipantName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
        participants: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE
    };
    const participatingAgentList = agentContact.participatingAgentList
        ? JSON.parse(agentContact.participatingAgentList)
        : undefined;
    if (isMPCorPersistEnabled) {
        participantDetails.participants = participatingAgentList === null || participatingAgentList === void 0 ? void 0 : participatingAgentList.reduce((acc, participatingAgent) => {
            const value = participatingAgent.type === "agent" ? participatingAgent.name : participatingAgent.dn;
            if (value) {
                acc.push(value);
            }
            return acc;
        }, []).join(", ").concat(bargedInSupervisor);
    }
    else if (newEventName === _constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_REQUESTED ||
        newEventName === _constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_STARTED ||
        newEventName === _constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_COMPLETED_CONFERENCE ||
        newEventName === _constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_STARTED_CONFERENCE) {
        participantDetails = {
            activeParticipantsName: destinationAgent
                ? `${agentContact.agentName}, ${destinationAgent}${bargedInSupervisor}`
                : agentContact.agentName,
            consultedParticipantName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE
        };
    }
    else if (newEventName === _constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_COMPLETED) {
        participantDetails = {
            activeParticipantsName: !agentContact.destinationAgentName && agentContact.destinationAgentDNIS
                ? `${agentContact.destinationAgentDNIS}${bargedInSupervisor}`
                : agentContact.agentName,
            consultedParticipantName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE
        };
    }
    else {
        participantDetails = {
            activeParticipantsName: `${agentContact.agentName}${bargedInSupervisor}`,
            consultedParticipantName: destinationAgent !== null && destinationAgent !== void 0 ? destinationAgent : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE
        };
    }
    return participantDetails;
};
const mapAgentContactStatus = (contactStatus, oldContactStatus) => {
    if (contactStatus) {
        switch (contactStatus.toLowerCase()) {
            case _constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP_ASSISTANCE:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.POST_CALL_STARTED:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.POST_CALL_CONSULT_STARTED:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.ON_HOLD:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_DONE:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCING:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_ERROR:
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(`app:tpw.contactStatus.${contactStatus.toLowerCase()}`);
            case "":
                return _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE;
            case _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_CONSULTING:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED_CONSULTING:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.IDLE_CONSULTING:
            case _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTING:
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(`app:tpw.contactStatus.consulting`);
            default:
                return oldContactStatus;
        }
    }
    return _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE;
};
const getContactStatsDetailsForAllParticipants = (contactData, oldDataMap, newDataForPrimaryAgent, supervisorId) => {
    var _a;
    const newDataForParticipants = [];
    const existingDataForParticipants = [];
    const oldParticipantsList = (_a = oldDataMap === null || oldDataMap === void 0 ? void 0 : oldDataMap.get(newDataForPrimaryAgent.agentId)) === null || _a === void 0 ? void 0 : _a.participatingAgentList;
    const newParticipantsList = contactData.data.participatingAgentList
        ? JSON.parse(contactData.data.participatingAgentList)
        : undefined;
    const removedParticipants = oldParticipantsList === null || oldParticipantsList === void 0 ? void 0 : oldParticipantsList.filter((oldParticipant) => !(newParticipantsList === null || newParticipantsList === void 0 ? void 0 : newParticipantsList.some((newParticipant) => newParticipant.id === oldParticipant.id)));
    const isTransferredContact = newDataForPrimaryAgent.contactEventName === _constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_COMPLETED;
    const isMonitored = isTransferredContact ? "false" : newDataForPrimaryAgent.isMonitored;
    const isSupervisorMonitoring = !!supervisorId && !!newDataForPrimaryAgent.monitorUserId && supervisorId === newDataForPrimaryAgent.monitorUserId;
    newParticipantsList === null || newParticipantsList === void 0 ? void 0 : newParticipantsList.forEach((participant) => {
        const existingDataForParticipant = (oldDataMap === null || oldDataMap === void 0 ? void 0 : oldDataMap.has(participant.id)) ? oldDataMap.get(participant.id) : undefined;
        const actionCellDetails = Object.assign(Object.assign({}, existingDataForParticipant === null || existingDataForParticipant === void 0 ? void 0 : existingDataForParticipant.actions), { agentId: participant.id, agentName: participant.name, supervisorId, monitoredBy: isMonitored === "true" ? newDataForPrimaryAgent.monitorFullName : "", isBarged: !!newDataForPrimaryAgent.isBarged && newDataForPrimaryAgent.isBarged === "true", isSupervisorMonitoring });
        const newDataForParticipant = Object.assign(Object.assign(Object.assign({}, _Utils__WEBPACK_IMPORTED_MODULE_3__.EMPTY_AGENT_DETAILS), existingDataForParticipant), { agentId: participant.id, agentName: participant.name, interactionId: newDataForPrimaryAgent.interactionId, isMonitored: newDataForPrimaryAgent.isMonitored, isBarged: newDataForPrimaryAgent.isBarged, monitorFullName: newDataForPrimaryAgent.monitorFullName, monitorUserId: newDataForPrimaryAgent.monitorUserId, contactPhoneNumber: newDataForPrimaryAgent.contactPhoneNumber, contactQueueName: newDataForPrimaryAgent.contactQueueName, participatingAgentList: newDataForPrimaryAgent.participatingAgentList, participants: newDataForPrimaryAgent.participants, activeParticipantsName: newDataForPrimaryAgent.activeParticipantsName, consultedParticipantName: newDataForPrimaryAgent.consultedParticipantName, recording: newDataForPrimaryAgent.recording, contactEventName: newDataForPrimaryAgent.contactEventName, actions: actionCellDetails });
        newDataForParticipants.push(newDataForParticipant);
        if (existingDataForParticipant) {
            existingDataForParticipants.push(existingDataForParticipant);
        }
    });
    removedParticipants === null || removedParticipants === void 0 ? void 0 : removedParticipants.forEach((participant) => {
        const existingDataForParticipant = (oldDataMap === null || oldDataMap === void 0 ? void 0 : oldDataMap.has(participant.id)) ? oldDataMap.get(participant.id) : undefined;
        const actionCellDetails = Object.assign(Object.assign({}, existingDataForParticipant === null || existingDataForParticipant === void 0 ? void 0 : existingDataForParticipant.actions), { agentId: participant.id, agentName: participant.name, supervisorId, monitoredBy: "", isBarged: false, isSupervisorMonitoring: false });
        const newDataForParticipant = Object.assign(Object.assign(Object.assign({}, _Utils__WEBPACK_IMPORTED_MODULE_3__.EMPTY_AGENT_DETAILS), existingDataForParticipant), { agentId: participant.id, agentName: participant.name, interactionId: "", isMonitored: "false", isBarged: "false", monitorFullName: "", monitorUserId: "", contactPhoneNumber: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, contactQueueName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, participants: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, activeParticipantsName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, consultedParticipantName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, recording: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, contactEventName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, actions: actionCellDetails, participatingAgentList: newDataForPrimaryAgent.participatingAgentList });
        newDataForParticipants.push(newDataForParticipant);
        if (existingDataForParticipant) {
            existingDataForParticipants.push(existingDataForParticipant);
        }
    });
    return { newDataForParticipants, existingDataForParticipants };
};
const updateContactStatsForDestinationAgent = (contactData, oldDataMap, newDataForPrimaryAgent, supervisorId, existingDataForPrimaryAgent) => {
    let newDataForDestinationAgent = {};
    let existingDataForDestinationAgent;
    if (contactData.data.destinationAgentId !== null && contactData.data.destinationAgentName !== null) {
        /** This block of code is used for populating Agent 2 details from
        destinationAgentId present in Agent 1 details and copying only contact related information **/
        existingDataForDestinationAgent = (oldDataMap === null || oldDataMap === void 0 ? void 0 : oldDataMap.has(contactData.data.destinationAgentId))
            ? oldDataMap.get(contactData.data.destinationAgentId)
            : undefined;
        const actionCellDetails = Object.assign(Object.assign({}, newDataForPrimaryAgent.actions), { agentId: contactData.data.destinationAgentId, agentName: contactData.data.destinationAgentName, supervisorId });
        newDataForDestinationAgent = Object.assign(Object.assign(Object.assign({}, _Utils__WEBPACK_IMPORTED_MODULE_3__.EMPTY_AGENT_DETAILS), existingDataForDestinationAgent), { agentId: contactData.data.destinationAgentId, agentName: contactData.data.destinationAgentName, interactionId: newDataForPrimaryAgent.interactionId, isMonitored: newDataForPrimaryAgent.isMonitored, isBarged: newDataForPrimaryAgent.isBarged, monitorFullName: newDataForPrimaryAgent.monitorFullName, monitorUserId: newDataForPrimaryAgent.monitorUserId, contactPhoneNumber: newDataForPrimaryAgent.contactPhoneNumber, contactQueueName: newDataForPrimaryAgent.contactQueueName, activeParticipantsName: newDataForPrimaryAgent.activeParticipantsName, consultedParticipantName: newDataForPrimaryAgent.consultedParticipantName, recording: newDataForPrimaryAgent.recording, contactEventName: newDataForPrimaryAgent.contactEventName, actions: actionCellDetails });
    }
    else if (existingDataForPrimaryAgent &&
        existingDataForPrimaryAgent.destinationAgentId &&
        existingDataForPrimaryAgent.destinationAgentName &&
        newDataForPrimaryAgent.contactEventName !== _constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_COMPLETED) {
        // This block of code is used to reset the Agent2 details if consult/conference is over for Agent 2
        existingDataForDestinationAgent = (oldDataMap === null || oldDataMap === void 0 ? void 0 : oldDataMap.has(existingDataForPrimaryAgent === null || existingDataForPrimaryAgent === void 0 ? void 0 : existingDataForPrimaryAgent.destinationAgentId))
            ? oldDataMap.get(existingDataForPrimaryAgent === null || existingDataForPrimaryAgent === void 0 ? void 0 : existingDataForPrimaryAgent.destinationAgentId)
            : undefined;
        newDataForDestinationAgent = Object.assign(Object.assign(Object.assign({}, _Utils__WEBPACK_IMPORTED_MODULE_3__.EMPTY_AGENT_DETAILS), existingDataForDestinationAgent), { agentId: existingDataForPrimaryAgent.destinationAgentId, agentName: existingDataForPrimaryAgent.destinationAgentName, interactionId: "", isMonitored: "false", isBarged: "false", monitorFullName: "", monitorUserId: "", contactPhoneNumber: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, contactQueueName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, activeParticipantsName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, consultedParticipantName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, recording: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, contactEventName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, actions: { agentId: existingDataForPrimaryAgent.destinationAgentId, supervisorId } });
    }
    return {
        existingDataForDestinationAgent,
        newDataForDestinationAgent
    };
};
/**
 * Checks if row is removed , removes that object from the applied filters
 * @param comp
 * @param key
 * @param rowToRemove
 */
const deleteRemovedRowObjectFromFilter = (comp, key, rowToRemove) => {
    if (checkIfFilterAppliedExists(comp, key)) {
        const k = rowToRemove[key];
        if (Object.prototype.hasOwnProperty.call(comp.appliedFilters[key], k)) {
            delete comp.appliedFilters[key][k];
            disptachFilterDataUpdateEvent(key);
        }
    }
};
const refreshClientSideRowModel = (gridApi) => {
    gridApi === null || gridApi === void 0 ? void 0 : gridApi.refreshClientSideRowModel("everything");
};
const removeRowFromGrid = (rowToRemove, gridApi, comp, isServerSideGrid) => {
    isServerSideGrid
        ? gridApi === null || gridApi === void 0 ? void 0 : gridApi.applyServerSideTransactionAsync({ remove: rowToRemove })
        : gridApi === null || gridApi === void 0 ? void 0 : gridApi.applyTransactionAsync({ remove: rowToRemove }, () => refreshClientSideRowModel(gridApi));
    //update filters of column when row deleted
    rowToRemove.forEach((data) => {
        Object.keys(data).forEach((key) => {
            if (_Utils__WEBPACK_IMPORTED_MODULE_3__.filterColumnName.includes(key)) {
                deleteRemovedRowObjectFromFilter(comp, key, rowToRemove);
                updateAppliedFilter(comp, key, data);
                disptachFilterDataUpdateEvent(key);
            }
        });
        disptachFilterUpdateEvent(comp);
    });
};
const addRowInGrid = (newRowData, gridApi, comp, isServerSideGrid) => {
    isServerSideGrid
        ? gridApi === null || gridApi === void 0 ? void 0 : gridApi.applyServerSideTransactionAsync({ add: newRowData })
        : gridApi === null || gridApi === void 0 ? void 0 : gridApi.applyTransactionAsync({ add: newRowData }, () => refreshClientSideRowModel(gridApi));
    newRowData.forEach((newData) => {
        Object.keys(newData).forEach((key) => {
            if (_Utils__WEBPACK_IMPORTED_MODULE_3__.filterColumnName.includes(key)) {
                updateAppliedFilter(comp, key, newData);
                disptachFilterDataUpdateEvent(key);
            }
        });
        disptachFilterUpdateEvent(comp);
    });
};
const updateRowInGrid = (updatedRowData, gridApi, comp, isServerSideGrid) => {
    isServerSideGrid
        ? gridApi === null || gridApi === void 0 ? void 0 : gridApi.applyServerSideTransactionAsync({ update: updatedRowData })
        : gridApi === null || gridApi === void 0 ? void 0 : gridApi.applyTransactionAsync({ update: updatedRowData }, () => refreshClientSideRowModel(gridApi));
    updatedRowData.forEach((updatedData) => {
        Object.keys(updatedData).forEach((key) => {
            if (_Utils__WEBPACK_IMPORTED_MODULE_3__.filterColumnName.includes(key)) {
                updateAppliedFilter(comp, key, updatedData);
                disptachFilterDataUpdateEvent(key);
            }
        });
        disptachFilterUpdateEvent(comp);
    });
};
const isValidContactStats = (contactData) => {
    return (contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.CAPTURE_STARTED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_STARTED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_REQUESTED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_STARTED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_COMPLETED_CONFERENCE ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_STARTED_CONFERENCE ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_COMPLETED_CONSULT ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_STARTED_CONSULT ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.HOLD_COMPLETED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_COMPLETED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_COMPLETED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCE_COMPLETED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.AGENTCONNECT_COMPLETED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_STARTED ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.JOIN_CONFERENCE ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.EXIT_CONFERENCE ||
        contactData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.PRIMARY_OWNER_CHANGED ||
        contactData.monitorStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.MONITORING_ENDED);
};
const filterContactStatsData = (contactStatsData) => {
    return contactStatsData.filter((contactData) => contactData.data.channelType === _constants__WEBPACK_IMPORTED_MODULE_0__.TELEPHONY && isValidContactStats(contactData.data));
};
const getValidChannelDetails = (channelData) => {
    return (channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP_ASSISTANCE ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.POST_CALL_STARTED ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.POST_CALL_CONSULT_STARTED ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONFERENCING ||
        channelData.contactStatus === "" ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.ON_HOLD ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED_CONSULTING ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.IDLE_CONSULTING ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTING ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_CONSULTING ||
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_DONE || // remove consult-done after data changes
        channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_ERROR);
};
const filteredTelephonyChannelData = (channelStatusData) => {
    return channelStatusData.filter((channelData) => { var _a; return ((_a = channelData.data) === null || _a === void 0 ? void 0 : _a.channelType) === _constants__WEBPACK_IMPORTED_MODULE_0__.TELEPHONY && getValidChannelDetails(channelData.data); });
};
//getMappedDataFromGlobalStatus maps/updates the received globalstatus data with the TPW required format
const getMappedDataFromGlobalStatus = (newAgentData, oldAgentData, browserLanguage, supervisorAnalyserId) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const actionCellDetails = Object.assign(Object.assign({}, oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.actions), { agentEmail: newAgentData === null || newAgentData === void 0 ? void 0 : newAgentData.agentEmail, agentName: newAgentData === null || newAgentData === void 0 ? void 0 : newAgentData.agentName, agentId: newAgentData === null || newAgentData === void 0 ? void 0 : newAgentData.agentId, supervisorId: supervisorAnalyserId });
    const agentState = (0,_Utils__WEBPACK_IMPORTED_MODULE_3__.localiseAvailableState)(getAgentState(newAgentData.globalState, newAgentData.idleCodeName));
    const agentEmail = newAgentData.agentEmail ? newAgentData.agentEmail : oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.agentEmail;
    const changedBy = newAgentData.changedByRole ? newAgentData.changedByRole : null;
    const changedById = newAgentData.changedById ? newAgentData.changedById : null;
    const changedByName = newAgentData.changedByName ? newAgentData.changedByName : null;
    const reason = newAgentData.reason ? newAgentData.reason : null;
    const agentNameDetails = Object.assign(Object.assign({}, oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.agentNameDetails), { agentId: newAgentData.agentId, agentName: newAgentData.agentName, agentState,
        agentEmail });
    return Object.assign(Object.assign(Object.assign({}, _Utils__WEBPACK_IMPORTED_MODULE_3__.EMPTY_AGENT_DETAILS), oldAgentData), { agentId: newAgentData.agentId, agentName: newAgentData.agentName ? newAgentData.agentName : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, agentEmail, orgId: newAgentData.orgId, agentState, agentStateDuration: newAgentData.globalStateTimestamp !== 0 ? newAgentData.globalStateTimestamp.toString() : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, phoneNumber: newAgentData.agentPhone && newAgentData.agentPhone !== ""
            ? ((_a = newAgentData === null || newAgentData === void 0 ? void 0 : newAgentData.agentPhone) === null || _a === void 0 ? void 0 : _a.includes(_constants__WEBPACK_IMPORTED_MODULE_0__.WEB_RTC_PREFIX))
                ? `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:stationLogin.browser")}`
                : newAgentData.agentPhone
            : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, loginTime: newAgentData.lastLoginTime !== 0
            ? getDateFormat(newAgentData.lastLoginTime, browserLanguage !== null && browserLanguage !== void 0 ? browserLanguage : undefined)
            : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, siteName: newAgentData.siteName ? newAgentData.siteName : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, teamName: newAgentData.teamName ? newAgentData.teamName : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, 
        //marking channel status field as blank as they are received from different data set, will be appended nce that data set received
        channelsName: (_b = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.channelsName) !== null && _b !== void 0 ? _b : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, contactStatus: (_c = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.contactStatus) !== null && _c !== void 0 ? _c : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, contactStatusTime: (_d = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.contactStatusTime) !== null && _d !== void 0 ? _d : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, contactQueueName: (_e = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.contactQueueName) !== null && _e !== void 0 ? _e : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, totalContactDuration: (_f = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.totalContactDuration) !== null && _f !== void 0 ? _f : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, agentInteractionTime: (_g = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.agentInteractionTime) !== null && _g !== void 0 ? _g : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, interactionId: (_h = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.interactionId) !== null && _h !== void 0 ? _h : "", actions: actionCellDetails, changedBy,
        changedById,
        changedByName,
        reason,
        agentNameDetails });
};
const getMappedDataFromCmsAgentData = (agentData) => {
    return Object.assign(Object.assign({}, _Utils__WEBPACK_IMPORTED_MODULE_3__.EMPTY_AGENT_DETAILS), { agentId: agentData.agentId, agentName: agentData.agentName, agentEmail: agentData.agentEmail, agentState: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Signedout"), agentNameDetails: {
            agentId: agentData.agentId,
            agentName: agentData.agentName,
            agentEmail: agentData.agentEmail,
            agentState: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.Signedout")
        } });
};
const getAgentInteractionTime = (data, contactStatus) => {
    const timestamp = data === null || data === void 0 ? void 0 : data.agentInteractionTimestamp;
    return timestamp && contactStatus !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE ? timestamp.toString() : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE;
};
const transformChannelStatus = (channelData, supervisorAnalyserId) => {
    var _a, _b, _c;
    const contactStatus = mapAgentContactStatus(channelData.contactStatus, _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE);
    // pass old data
    const actionCellDetails = {
        agentId: channelData.agentId,
        agentName: channelData.agentName,
        supervisorId: supervisorAnalyserId,
        isConsultCall: channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED_CONSULTING ||
            channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.IDLE_CONSULTING ||
            channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTING ||
            channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_CONSULTING,
        isReviewAndMonitorEnabled: isReviewAndMonitorEnabled(channelData.contactStatus),
        isWrapUp: channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP,
        isWrapUpAssistance: channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP_ASSISTANCE,
        isMainCallInPostCall: channelData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.POST_CALL_STARTED
    };
    return Object.assign(Object.assign({}, _Utils__WEBPACK_IMPORTED_MODULE_3__.EMPTY_AGENT_DETAILS), { agentId: channelData.agentId, agentName: channelData.agentName, interactionId: (_a = channelData.interactionId) !== null && _a !== void 0 ? _a : "", teamName: (_b = channelData.teamName) !== null && _b !== void 0 ? _b : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, siteName: (_c = channelData.siteName) !== null && _c !== void 0 ? _c : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, channelsName: "Voice 1/1", // need to remove after all media is supported
        contactStatus, contactStatusCode: channelData.contactStatus, contactQueueName: channelData.contactQueueName, contactStatusTime: channelData.contactStatusTimestamp !== 0 && contactStatus !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE
            ? channelData.contactStatusTimestamp.toString()
            : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, totalContactDuration: channelData.contactIngestionTimestamp !== 0 && contactStatus !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE
            ? channelData.contactIngestionTimestamp.toString()
            : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, agentInteractionTime: getAgentInteractionTime(channelData, contactStatus), actions: actionCellDetails });
};
//getMappedDataFromGlobalStatus maps/updates the received channelstatus data with the TPW required format
const getMappedDataFromChannelStatus = (newAgentData, oldAgentData, supervisorAnalyserId) => {
    var _a;
    const contactStatus = mapAgentContactStatus(newAgentData.contactStatus, (_a = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.contactStatus) !== null && _a !== void 0 ? _a : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE);
    const actionCellDetails = Object.assign(Object.assign({}, oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.actions), { agentId: newAgentData.agentId, agentName: newAgentData.agentName, supervisorId: supervisorAnalyserId, isConsultCall: newAgentData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED_CONSULTING ||
            newAgentData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.IDLE_CONSULTING ||
            newAgentData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTING ||
            newAgentData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_CONSULTING, isReviewAndMonitorEnabled: isReviewAndMonitorEnabled(newAgentData.contactStatus), isWrapUp: newAgentData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP, isWrapUpAssistance: newAgentData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP_ASSISTANCE, isMainCallInPostCall: newAgentData.contactStatus === _constants__WEBPACK_IMPORTED_MODULE_0__.POST_CALL_STARTED });
    const agentNameDetails = Object.assign(Object.assign({}, oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.agentNameDetails), { agentId: newAgentData.agentId, agentName: newAgentData.agentName });
    return Object.assign(Object.assign(Object.assign({}, _Utils__WEBPACK_IMPORTED_MODULE_3__.EMPTY_AGENT_DETAILS), oldAgentData), { agentId: newAgentData.agentId, agentName: newAgentData.agentName, interactionId: newAgentData.interactionId, teamName: newAgentData.teamName, siteName: newAgentData.siteName, channelsName: "Voice 1/1", // need to remove after all media is supported
        contactStatus, contactStatusCode: newAgentData.contactStatus, contactQueueName: newAgentData.contactQueueName ? newAgentData.contactQueueName : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, contactStatusTime: newAgentData.contactStatusTimestamp !== 0 && contactStatus !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE
            ? newAgentData.contactStatusTimestamp.toString()
            : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, totalContactDuration: newAgentData.contactIngestionTimestamp !== 0 && contactStatus !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE
            ? newAgentData.contactIngestionTimestamp.toString()
            : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, agentInteractionTime: getAgentInteractionTime(newAgentData, contactStatus), actions: actionCellDetails, agentNameDetails });
};
//getMappedDataFromGlobalStatus maps/updates the received contactstats data with the TPW required format
const getMappedDataFromContactStats = (newAgentData, oldAgentData, supervisorId, isMPCorPersistEnabled) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const isTransferredContact = newAgentData.eventName === _constants__WEBPACK_IMPORTED_MODULE_0__.TRANSFER_COMPLETED;
    const isMonitored = isTransferredContact ? "false" : newAgentData.isMonitored;
    const isSupervisorMonitoring = !!supervisorId && !!newAgentData.monitorUserId && supervisorId === newAgentData.monitorUserId;
    const actionCellDetails = Object.assign(Object.assign({}, oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.actions), { agentId: newAgentData.agentId, agentName: newAgentData.agentName, monitoredBy: isMonitored === "true" ? newAgentData.monitorFullName : "", supervisorId, isBarged: !!newAgentData.isBarged && newAgentData.isBarged === "true", isSupervisorMonitoring });
    const participantDetails = getParticipantsDetails(newAgentData, newAgentData.eventName, isMPCorPersistEnabled, supervisorId);
    return Object.assign(Object.assign(Object.assign({}, _Utils__WEBPACK_IMPORTED_MODULE_3__.EMPTY_AGENT_DETAILS), oldAgentData), { agentId: newAgentData.agentId, agentName: newAgentData.agentName ? newAgentData.agentName : ((_a = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.agentName) !== null && _a !== void 0 ? _a : ""), interactionId: (_b = newAgentData.interactionId) !== null && _b !== void 0 ? _b : "", isMonitored, isBarged: newAgentData.isBarged, monitorFullName: isTransferredContact ? "" : newAgentData.monitorFullName, monitorUserId: isTransferredContact ? "" : newAgentData.monitorUserId, contactPhoneNumber: newAgentData.contactDirection === _constants__WEBPACK_IMPORTED_MODULE_0__.INBOUND
            ? newAgentData.origin
            : ((_c = newAgentData.destination) !== null && _c !== void 0 ? _c : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE), contactQueueName: (_d = newAgentData.queueName) !== null && _d !== void 0 ? _d : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, participatingAgentList: newAgentData.participatingAgentList ? JSON.parse(newAgentData.participatingAgentList) : [], activeParticipantsName: (_e = participantDetails.activeParticipantsName) !== null && _e !== void 0 ? _e : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, consultedParticipantName: (_f = participantDetails.consultedParticipantName) !== null && _f !== void 0 ? _f : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, participants: (_g = participantDetails.participants) !== null && _g !== void 0 ? _g : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, recording: newAgentData.recording === "true" ? "On" : "Off", contactStatusTime: (_h = oldAgentData === null || oldAgentData === void 0 ? void 0 : oldAgentData.contactStatusTime) !== null && _h !== void 0 ? _h : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE, contactEventName: newAgentData.eventName, actions: actionCellDetails, destinationAgentId: newAgentData.destinationAgentId && newAgentData.destinationAgentId !== newAgentData.agentId
            ? newAgentData.destinationAgentId
            : null, destinationAgentName: newAgentData.destinationAgentName && newAgentData.destinationAgentId !== newAgentData.agentId
            ? newAgentData.destinationAgentName
            : null });
};
const convertGlobalStatusArrayToMap = (agentGlobalStatusData, browserLanguage, supervisorAnalyserId) => {
    const rowDataMap = new Map();
    agentGlobalStatusData === null || agentGlobalStatusData === void 0 ? void 0 : agentGlobalStatusData.forEach((agentData) => {
        //adding logic to filter logged out agents for now , till we receive all agents.
        if (agentData.data.globalState !== _constants__WEBPACK_IMPORTED_MODULE_0__.LOGGED_OUT) {
            rowDataMap.set(agentData.data.agentId, getMappedDataFromGlobalStatus(agentData.data, undefined, browserLanguage, supervisorAnalyserId));
        }
    });
    return rowDataMap;
};
const convertContactStatusArrayToMap = (contactStats, supervisorId, isMPCorPersistEnabled) => {
    const rowDataMap = new Map();
    contactStats === null || contactStats === void 0 ? void 0 : contactStats.forEach((contactData) => {
        //adding logic to filter logged out agents for now , till we receive all agents.
        const newDataForPrimaryAgent = getMappedDataFromContactStats(contactData.data, undefined, supervisorId, isMPCorPersistEnabled);
        if (isMPCorPersistEnabled) {
            const destinationDetails = getContactStatsDetailsForAllParticipants(contactData, undefined, newDataForPrimaryAgent, supervisorId).newDataForParticipants;
            destinationDetails.forEach((newDataForDestinationAgent) => {
                if (newDataForDestinationAgent === null || newDataForDestinationAgent === void 0 ? void 0 : newDataForDestinationAgent.agentId) {
                    rowDataMap.set(newDataForDestinationAgent.agentId, newDataForDestinationAgent);
                }
            });
            rowDataMap.set(contactData.data.agentId, newDataForPrimaryAgent);
        }
        else {
            rowDataMap.set(contactData.data.agentId, newDataForPrimaryAgent);
            const destinationDetails = updateContactStatsForDestinationAgent(contactData, undefined, newDataForPrimaryAgent, supervisorId);
            const newDataForDestinationAgent = destinationDetails.newDataForDestinationAgent;
            if (newDataForDestinationAgent === null || newDataForDestinationAgent === void 0 ? void 0 : newDataForDestinationAgent.agentId) {
                rowDataMap.set(newDataForDestinationAgent.agentId, newDataForDestinationAgent);
            }
        }
    });
    return rowDataMap;
};
const convertCmsAgentDataArrayToMap = (cmsAgentData) => {
    const rowDataMap = new Map();
    cmsAgentData === null || cmsAgentData === void 0 ? void 0 : cmsAgentData.forEach((agentData) => {
        rowDataMap.set(agentData.agentId, getMappedDataFromCmsAgentData(agentData));
    });
    return rowDataMap;
};
const convertChannelStatusArrayToMap = (agentChannelStatus, supervisorAnalyserId) => {
    const rowDataMap = new Map();
    agentChannelStatus === null || agentChannelStatus === void 0 ? void 0 : agentChannelStatus.forEach((channelData) => {
        //adding logic to filter logged out agents for now , till we receive all agents.
        rowDataMap.set(channelData.data.agentId, transformChannelStatus(channelData.data, supervisorAnalyserId));
    });
    return rowDataMap;
};
function handleLoggedInState(agentData, existingData, browserLanguage, supervisorAnalyserId, rowToUpdate, rowToAdd, rowDataMap) {
    const newData = getMappedDataFromGlobalStatus(agentData.data, existingData, browserLanguage, supervisorAnalyserId);
    if (existingData) {
        rowToUpdate.push(newData);
    }
    else {
        rowToAdd.push(newData);
    }
    rowDataMap.set(agentData.data.agentId, newData);
}
function handleLoggedOutState(agentData, existingData, rowToUpdate, rowToAdd, rowToRemove, rowDataMap, isShowSignedOutAgentsEnabled) {
    const newData = convertCmsAgentDataArrayToMap([getMappedDataFromCmsAgentData(agentData.data)]);
    newData.forEach((value) => {
        if (existingData) {
            if (isShowSignedOutAgentsEnabled) {
                rowToUpdate.push(value);
            }
            else {
                rowToRemove.push(existingData);
                rowDataMap.delete(agentData.data.agentId);
            }
        }
        else if (isShowSignedOutAgentsEnabled) {
            rowToAdd.push(value);
        }
    });
}
const updateExistingMapFromGlobalStatus = ({ agentGlobalStatusData, oldDataMap, browserLanguage, gridApi, comp, supervisorAnalyserId, isServerSideGrid, isShowSignedOutAgentsEnabled }) => {
    const rowDataMap = oldDataMap;
    const rowToRemove = [];
    const rowToUpdate = [];
    const rowToAdd = [];
    agentGlobalStatusData === null || agentGlobalStatusData === void 0 ? void 0 : agentGlobalStatusData.forEach((agentData) => {
        const existingData = oldDataMap.has(agentData.data.agentId) ? oldDataMap.get(agentData.data.agentId) : undefined;
        if (agentData.data.globalState !== _constants__WEBPACK_IMPORTED_MODULE_0__.LOGGED_OUT) {
            handleLoggedInState(agentData, existingData, browserLanguage, supervisorAnalyserId, rowToUpdate, rowToAdd, rowDataMap);
        }
        else {
            handleLoggedOutState(agentData, existingData, rowToUpdate, rowToAdd, rowToRemove, rowDataMap, isShowSignedOutAgentsEnabled);
        }
    });
    //remove old agent data that has been logged out if signed out agents is disabled
    if (!isShowSignedOutAgentsEnabled && rowToRemove.length > 0) {
        removeRowFromGrid(rowToRemove, gridApi, comp, isServerSideGrid);
    }
    if (rowToAdd.length > 0) {
        addRowInGrid(rowToAdd, gridApi, comp, isServerSideGrid);
    }
    if (rowToUpdate.length > 0) {
        updateRowInGrid(rowToUpdate, gridApi, comp, isServerSideGrid);
    }
    return rowDataMap;
};
const updateExistingMapFromChannelStatus = (agentChannelStatus, oldDataMap, gridApi, supervisorAnalyserId, comp, isServerSideGrid) => {
    const rowDataMap = oldDataMap;
    const rowToUpdate = [];
    const rowToAdd = [];
    agentChannelStatus === null || agentChannelStatus === void 0 ? void 0 : agentChannelStatus.forEach((channelData) => {
        if (channelData.operation !== _constants__WEBPACK_IMPORTED_MODULE_0__.DELETE) {
            const existingData = oldDataMap.has(channelData.data.agentId)
                ? oldDataMap.get(channelData.data.agentId)
                : undefined;
            const newData = getMappedDataFromChannelStatus(channelData.data, existingData, supervisorAnalyserId);
            if (existingData) {
                rowToUpdate.push(newData);
            }
            else {
                rowToAdd.push(newData);
            }
            rowDataMap.set(channelData.data.agentId, newData);
        }
    });
    if (rowToAdd.length > 0) {
        addRowInGrid(rowToAdd, gridApi, comp, isServerSideGrid);
    }
    if (rowToUpdate.length > 0) {
        updateRowInGrid(rowToUpdate, gridApi, comp, isServerSideGrid);
    }
    return rowDataMap;
};
const updateExistingMapForMPCorPersist = (contactData, oldDataMap, newDataForPrimaryAgent, supervisorId, rowDataMap, rowToUpdate) => {
    const destinationDetails = getContactStatsDetailsForAllParticipants(contactData, oldDataMap, newDataForPrimaryAgent, supervisorId);
    const newDataForParticipants = destinationDetails.newDataForParticipants;
    const existingDataForParticipants = destinationDetails.existingDataForParticipants;
    if (!newDataForParticipants.length) {
        rowDataMap.set(contactData.data.agentId, newDataForPrimaryAgent);
    }
    else {
        newDataForParticipants.forEach((newDataForDestinationAgent) => {
            if (newDataForDestinationAgent === null || newDataForDestinationAgent === void 0 ? void 0 : newDataForDestinationAgent.agentId) {
                rowDataMap.set(newDataForDestinationAgent.agentId, newDataForDestinationAgent);
            }
            if (existingDataForParticipants.find((participantData) => participantData.agentId === newDataForDestinationAgent.agentId)) {
                rowToUpdate.push(newDataForDestinationAgent);
            }
        });
    }
};
const updateExistingMapFromContactStats = (agentContacts, oldDataMap, gridApi, supervisorId, comp, isMPCorPersistEnabled, isServerSideGrid) => {
    const rowToUpdate = [];
    const rowToAdd = [];
    const rowDataMap = oldDataMap;
    agentContacts === null || agentContacts === void 0 ? void 0 : agentContacts.forEach((contactData) => {
        const existingDataForPrimaryAgent = oldDataMap.has(contactData.data.agentId)
            ? oldDataMap.get(contactData.data.agentId)
            : undefined;
        const newDataForPrimaryAgent = getMappedDataFromContactStats(contactData.data, existingDataForPrimaryAgent, supervisorId, isMPCorPersistEnabled);
        if (isMPCorPersistEnabled) {
            updateExistingMapForMPCorPersist(contactData, oldDataMap, newDataForPrimaryAgent, supervisorId, rowDataMap, rowToUpdate);
        }
        else {
            if (existingDataForPrimaryAgent) {
                rowToUpdate.push(newDataForPrimaryAgent);
            }
            else {
                rowToAdd.push(newDataForPrimaryAgent);
            }
            rowDataMap.set(contactData.data.agentId, newDataForPrimaryAgent);
            const destinationDetails = updateContactStatsForDestinationAgent(contactData, oldDataMap, newDataForPrimaryAgent, supervisorId, existingDataForPrimaryAgent);
            const newDataForDestinationAgent = destinationDetails.newDataForDestinationAgent;
            const existingDataForDestinationAgent = destinationDetails.existingDataForDestinationAgent;
            if (newDataForDestinationAgent === null || newDataForDestinationAgent === void 0 ? void 0 : newDataForDestinationAgent.agentId) {
                if (existingDataForDestinationAgent) {
                    rowToUpdate.push(newDataForDestinationAgent);
                }
                rowDataMap.set(newDataForDestinationAgent.agentId, newDataForDestinationAgent);
            }
        }
    });
    if (rowToAdd.length > 0) {
        addRowInGrid(rowToAdd, gridApi, comp, isServerSideGrid);
    }
    if (rowToUpdate.length > 0) {
        updateRowInGrid(rowToUpdate, gridApi, comp, isServerSideGrid);
    }
    return rowDataMap;
};


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/Utils.ts":
/*!*******************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/Utils.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EMPTY_AGENT_DETAILS: () => (/* binding */ EMPTY_AGENT_DETAILS),
/* harmony export */   columnHeaderMapping: () => (/* binding */ columnHeaderMapping),
/* harmony export */   disableForContactStatus: () => (/* binding */ disableForContactStatus),
/* harmony export */   durationColumns: () => (/* binding */ durationColumns),
/* harmony export */   filterColumnName: () => (/* binding */ filterColumnName),
/* harmony export */   fixedColumns: () => (/* binding */ fixedColumns),
/* harmony export */   getIsCheckboxChecked: () => (/* binding */ getIsCheckboxChecked),
/* harmony export */   getSignoutTooltip: () => (/* binding */ getSignoutTooltip),
/* harmony export */   hiddenGroupColumn: () => (/* binding */ hiddenGroupColumn),
/* harmony export */   initialFilterModel: () => (/* binding */ initialFilterModel),
/* harmony export */   isAgentSignoutDisabled: () => (/* binding */ isAgentSignoutDisabled),
/* harmony export */   localiseAvailableState: () => (/* binding */ localiseAvailableState)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");


const fixedColumns = {
    agentName: true,
    actions: true
};
const hiddenGroupColumn = {
    agentStateDuration: true,
    contactStatusTime: true,
    totalContactDuration: true,
    agentInteractionTime: true,
    loginTime: true
};
const getIsCheckboxChecked = (event) => {
    const path = event.composedPath();
    const checkboxElement = Array.from(path).find((element) => element.nodeName.toLowerCase() === "md-checkbox");
    return checkboxElement.checked;
};
const EMPTY_AGENT_DETAILS = {
    agentId: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    agentName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    agentEmail: "",
    agentState: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    agentStateDuration: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    phoneNumber: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    channelsName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    contactStatus: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    contactStatusCode: "",
    contactStatusTime: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    contactQueueName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    totalContactDuration: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    agentInteractionTime: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    loginTime: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    siteName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    teamName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    interactionId: "",
    contactEventName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    isMonitored: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    monitorFullName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    contactPhoneNumber: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    activeParticipantsName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    consultedParticipantName: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    recording: _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    actions: {},
    destinationAgentId: null,
    destinationAgentName: null,
    changedBy: null,
    changedById: null,
    changedByName: null
};
const initialFilterModel = {
    agentName: {},
    siteName: {},
    teamName: {},
    loginTime: {},
    agentState: {},
    channelsName: {},
    phoneNumber: {},
    contactQueueName: {},
    contactStatus: {},
    agentNameDetails: {}
};
const columnHeaderMapping = () => {
    return {
        agentName: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.agentName"),
        agentState: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.agentState"),
        agentStateDuration: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.agentStateDuration"),
        phoneNumber: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.phoneNumber"),
        siteName: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.siteName"),
        teamName: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.teamName"),
        contactStatus: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.contactStatus"),
        contactStatusTime: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.contactStatusTime"),
        agentInteractionTime: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.agentInteractionTime"),
        totalContactDuration: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.totalContactDuration"),
        loginTime: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.loginTime"),
        channelsName: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.channelsName"),
        contactQueueName: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.contactQueueName"),
        agentNameDetails: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.columnName.agentName")
    };
};
const durationColumns = [
    "agentStateDuration",
    "agentInteractionTime",
    "totalContactDuration",
    "contactStatusTime"
];
const filterColumnName = [
    "agentState",
    "phoneNumber",
    "siteName",
    "teamName",
    "contactStatus",
    "loginTime",
    "channelsName",
    "contactQueueName",
    "agentNameDetails"
];
const disableForContactStatus = [
    _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP,
    _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP_ASSISTANCE,
    _constants__WEBPACK_IMPORTED_MODULE_0__.POST_CALL_STARTED,
    _constants__WEBPACK_IMPORTED_MODULE_0__.CONNECTED_CONSULTING,
    _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_CONSULTING,
    _constants__WEBPACK_IMPORTED_MODULE_0__.IDLE_CONSULTING,
    _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULTING,
    _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE,
    _constants__WEBPACK_IMPORTED_MODULE_0__.CONSULT_ERROR
];
const localiseAvailableState = (key) => {
    return key === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.stateChange.available") : key;
};
const isAgentSignoutDisabled = (actionCellConfigs) => {
    if (actionCellConfigs.agentName && actionCellConfigs.agentId !== actionCellConfigs.supervisorId) {
        return actionCellConfigs.contactStatus !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE;
    }
    else {
        return true;
    }
};
const isSelf = (actionCellConfigs) => {
    return actionCellConfigs.agentId === actionCellConfigs.supervisorId;
};
const getSignoutTooltip = (actionCellConfigs, disabled) => {
    if (disabled) {
        return isSelf(actionCellConfigs) ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.selfSignoutWarningTooltip") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.signoutBlockedTooltip");
    }
    else if (actionCellConfigs.signoutPending) {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.signingoutTooltip");
    }
    else if (actionCellConfigs.signoutError) {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.signingoutErrorTooltip");
    }
    else {
        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.signoutTooltip");
    }
};


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/ActiveInteraction.scss":
/*!********************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/ActiveInteraction.scss ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host .md-alert-banner {
  padding: 16px;
}

.aid-modal .aid-img-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid var(--md-primary-seperator-color);
  padding-bottom: 16px;
}
.aid-modal .aid-img {
  width: 36px;
  height: 36px;
  border-radius: 100%;
}
.aid-modal .aid-name {
  margin: 6px 0 0 16px;
}
.aid-modal .aid-body {
  height: 340px;
  overflow-y: scroll;
}
.aid-modal .aid-body-no-scroll {
  overflow: hidden;
}
.aid-modal .aid-data {
  margin: 16px 0 0 0;
  height: 100%;
}
.aid-modal .aid-data-height-auto {
  margin: 16px 0 0 0;
  height: auto;
}
.aid-modal .aid-details-wrapper {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 8px;
  color: var(--md-secondary-text-color);
}
.aid-modal .aid-value-second {
  margin-left: 6px;
}
.aid-modal .aid-field-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 164px;
}
.aid-modal .aid-value {
  margin: 0;
}
.aid-modal .aid-banner-text-wrapper {
  display: flex;
  margin-left: -1.75rem;
}
.aid-modal .aid-warning {
  color: var(--md-alert-text-warning);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  height: 36px;
  margin-top: 16px;
  display: flex;
  align-items: center;
}
.aid-modal .aid-banner-text-warning {
  color: var(--md-alert-text-warning);
  font-size: 14px;
  font-weight: 400;
  line-height: 17.5px;
  text-align: initial;
  width: 336px;
  margin-left: 8px;
}
.aid-modal .aid-banner-text {
  white-space: unset;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.aid-modal .aid-banner-text-info {
  color: var(--md-alert-text-theme);
  font-size: 14px;
  font-weight: 400;
  line-height: 17.5px;
  text-align: initial;
  width: 336px;
  margin-left: 8px;
}
.aid-modal .aid-banner-text-error {
  color: var(--md-alert-text-error);
  font-size: 14px;
  font-weight: 400;
  line-height: 17.5px;
  text-align: initial;
  width: 336px;
  margin-left: 8px;
}
.aid-modal .aid-banner-icon {
  height: 13.34px;
  width: 16px;
}
.aid-modal .md-alert-banner-wrapper {
  padding-right: 24px;
  padding-top: 16px;
  display: block;
}
.aid-modal .aid-error {
  color: var(--md-alert-error-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  height: 36px;
  margin-top: 16px;
  display: flex;
  align-items: center;
}
.aid-modal .aid-warning-icon,
.aid-modal .aid-error-icon {
  margin-right: 10px;
}
.aid-modal .aid-info-wrapper {
  background-color: #c7f6ff;
  padding: 12px 16px;
  color: var(--color-blue-70);
  display: flex;
  margin-top: 16px;
}
.aid-modal .aid-error-wrapper {
  background-color: var(--md-red-10);
  padding: 12px 16px;
  color: var(--md-red-70);
  display: flex;
  margin-top: 16px;
  line-height: 17.5px;
}
.aid-modal .aid-info-icon {
  margin: -2px 8px 0 0;
}
.aid-modal .aid-btn-wrapper {
  margin-top: 24px;
}
.aid-modal .aid-btn-wrapper .aid-start {
  margin-left: 10px;
}
.aid-modal .aid-btn-wrapper .aid-start,
.aid-modal .aid-btn-wrapper .aid-close {
  float: right;
}
.aid-modal .aid-btn-wrapper .aid-monitoring-icon {
  margin-right: 8px;
}
.aid-modal .aid-nodata-wrapper {
  height: 440px;
  padding-top: 80px;
}
.aid-modal .aid-details-wip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.aid-modal .aid-details-wip img {
  width: 96px;
  height: 78px;
}
.aid-modal .aid-details-wip-text {
  color: var(--md-primary-text-color);
}
.aid-modal .modal-header {
  font-size: var(--font-size-large);
  margin: 0;
}
@media (max-width: 736px) {
  .aid-modal .aid-body {
    height: 100%;
  }
  .aid-modal .aid-data {
    height: 100%;
  }
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=ActiveInteraction.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/TeamPerformanceWidget/components/ActiveInteraction.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/ActiveInteraction.ts":
/*!******************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/ActiveInteraction.ts ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ActiveInteraction: () => (/* binding */ ActiveInteraction)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../assets/styles/common.scss */ "./src/assets/styles/common.scss");
/* harmony import */ var _components_CountDownTimer_CountDownTimer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../components/CountDownTimer/CountDownTimer */ "./src/components/CountDownTimer/CountDownTimer.ts");
/* harmony import */ var _ActiveInteraction_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./ActiveInteraction.scss */ "./src/components/TeamPerformanceWidget/components/ActiveInteraction.scss");
/* harmony import */ var _AidValues__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./AidValues */ "./src/components/TeamPerformanceWidget/components/AidValues.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};











var ActiveInteraction;
(function (ActiveInteraction) {
    /**
     * @element agentx-wc-aid
     * @fires close-modal
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_4__.LitElement) {
        constructor() {
            super(...arguments);
            this.isModalOpen = false;
            this.isMCMEnabled = false;
            this.monitoringInProgress = false;
            this.errorText = "";
            this.role = "";
            this.isMPCorPersistEnabled = false;
            this.isPostCallEnabled = false;
            this.shouldTrackAid = true;
            this.startMonitoringTriggered = false;
            this.interactionDetails = {
                isDisconnected: false,
                interactionIsTransferred: false // Is interaction is closed by transfer or end
            };
            this.enableWarningTooltip = false;
            this.isStartMonitorFailed = false;
            this.liveRegionMessage = "";
            this.detail = {
                header: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.failedToLoad"),
                message: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.shareTrackId")
            };
            this.isDataUpdated = false;
            this.MONITORING_CALL_MESSAGE = "app:tpw.currentlyMonitoringCall";
            this.RACE_ERROR_REASON_CODE = 53;
            this.fixedVariables = [
                {
                    variableText: "app:tpw.ContactPhoneNumber",
                    variableName: "contactPhoneNumber"
                },
                {
                    variableText: "app:tpw.ContactQueue",
                    variableName: "contactQueueName"
                },
                {
                    variableText: "app:tpw.ActiveParticipants",
                    variableName: "activeParticipantsName"
                },
                {
                    variableText: "app:tpw.ConsultedParticipant",
                    variableName: "consultedParticipantName"
                },
                {
                    variableText: "app:tpw.ContactStatus",
                    variableName: "contactStatus"
                },
                {
                    variableText: "app:tpw.TimeInContactStatus",
                    variableName: "contactStatusTime"
                },
                {
                    variableText: "app:tpw.AgentInteractionTime",
                    variableName: "agentInteractionTime"
                },
                {
                    variableText: "app:tpw.TotalContactDuration",
                    variableName: "totalContactDuration"
                },
                {
                    variableText: "app:tpw.Recording",
                    variableName: "recording"
                }
            ];
            this.multiPartyFixedVariables = [
                {
                    variableText: "app:tpw.ContactPhoneNumber",
                    variableName: "contactPhoneNumber"
                },
                {
                    variableText: "app:tpw.ContactQueue",
                    variableName: "contactQueueName"
                },
                {
                    variableText: "app:tpw.Participants",
                    variableName: "participants"
                },
                {
                    variableText: "app:tpw.ContactStatus",
                    variableName: "contactStatus"
                },
                {
                    variableText: "app:tpw.TimeInContactStatus",
                    variableName: "contactStatusTime"
                },
                {
                    variableText: "app:tpw.AgentInteractionTime",
                    variableName: "agentInteractionTime"
                },
                {
                    variableText: "app:tpw.TotalContactDuration",
                    variableName: "totalContactDuration"
                },
                {
                    variableText: "app:tpw.Recording",
                    variableName: "recording"
                }
            ];
            this.closeAIDModal = () => {
                this.errorText = "";
                this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.TPW_MONITOR_MODAL, { detail: { modalIsOpen: false }, bubbles: false, composed: true }));
                this.isDataUpdated = false;
                this.startMonitoringTriggered = false;
                // Reset interaction details
                this.interactionDetails = Object.assign(Object.assign({}, this.interactionDetails), { isDisconnected: false, interactionIsTransferred: false // Weather check interaction closed by transfer or normal close
                 });
            };
            this.trackAIDClose = () => {
                var _a, _b;
                this.closeAIDModal();
                if (this.shouldTrackAid) {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.TELEM_EVENT.AID_CLOSED, {
                        SupervisorId: (_b = (_a = this.selectedAgentDetails.actions) === null || _a === void 0 ? void 0 : _a.supervisorId) !== null && _b !== void 0 ? _b : "",
                        Role: this.role
                    });
                }
            };
            this.closeAIDModalOnMonitoring = () => {
                this.shouldTrackAid = false;
                this.closeAIDModal();
            };
            this.setErrorText = (e) => __awaiter(this, void 0, void 0, function* () {
                const { reasonCode } = e.detail;
                this.shouldTrackAid = true;
                if (reasonCode === this.RACE_ERROR_REASON_CODE) {
                    this.errorText = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(this.MONITORING_CALL_MESSAGE);
                }
                else {
                    this.closeAIDModal();
                }
            });
            this.ariaLabelForMonitoringButton = () => {
                const disableTooltipMessage = this.getDisableTooltipMessage();
                const startMonitoringMessage = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.startMonitoring");
                let message;
                if (disableTooltipMessage) {
                    message = `${startMonitoringMessage}, ${disableTooltipMessage}`;
                }
                else {
                    message = startMonitoringMessage;
                }
                return message;
            };
            this.generateUUID = () => {
                let d = Date.now();
                return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
                    const r = (d + Math.random() * 16) % 16 | 0; // eslint-disable-line no-bitwise
                    d = Math.floor(d / 16);
                    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16); // eslint-disable-line no-bitwise
                });
            };
            this.isStartMonitoringDisabled = () => {
                var _a, _b, _c;
                return ((_c = (this.isInteractionDisconnected() ||
                    this.errorText !== "" ||
                    (this.selectedAgentDetails && ((_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.isMonitored) === "true") ||
                    this.monitoringInProgress ||
                    ((_b = this.selectedAgentDetails.actions) === null || _b === void 0 ? void 0 : _b.isConsultCall) ||
                    this.isInteractionInPostCall())) !== null && _c !== void 0 ? _c : false);
            };
            this.ifFixedVariablesAreUpdated = (oldValues) => {
                const newValues = this.selectedAgentDetails;
                return (oldValues.contactQueueName !== newValues.contactQueueName ||
                    oldValues.totalContactDuration !== newValues.totalContactDuration ||
                    oldValues.agentInteractionTime !== newValues.agentInteractionTime ||
                    oldValues.contactStatusTime !== newValues.contactStatusTime ||
                    oldValues.contactPhoneNumber !== newValues.contactPhoneNumber ||
                    oldValues.activeParticipantsName !== newValues.activeParticipantsName ||
                    oldValues.consultedParticipantName !== newValues.consultedParticipantName ||
                    oldValues.recording !== newValues.recording ||
                    oldValues.contactStatus !== newValues.contactStatus ||
                    oldValues.actions !== newValues.actions);
            };
            this.enableWarningContentTooltip = () => __awaiter(this, void 0, void 0, function* () {
                var _a;
                yield this.updateComplete;
                const element = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".aid-banner-text");
                if (element && this.isEllipsisActive(element)) {
                    // Enable the tooptip.
                    this.enableWarningTooltip = true;
                }
                else {
                    this.enableWarningTooltip = false;
                }
            });
            this.isEllipsisActive = (element) => {
                return element.offsetHeight < element.scrollHeight;
            };
        }
        attachEventListeners() {
            window.addEventListener("monitoring-offered", this.closeAIDModalOnMonitoring);
            window.addEventListener("monitoring-started", this.closeAIDModalOnMonitoring);
            window.addEventListener("monitoring-create-failed", this.setErrorText);
            window.addEventListener("monitoring-failed", this.setErrorText);
        }
        connectedCallback() {
            super.connectedCallback();
            this.attachEventListeners();
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            window.removeEventListener("monitoring-offered", this.closeAIDModalOnMonitoring);
            window.removeEventListener("monitoring-started", this.closeAIDModalOnMonitoring);
            window.removeEventListener("monitoring-create-failed", this.setErrorText);
            window.removeEventListener("monitoring-failed", this.setErrorText);
        }
        static get styles() {
            return [_ActiveInteraction_scss__WEBPACK_IMPORTED_MODULE_9__["default"], _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_7__["default"]];
        }
        isInteractionDisconnected() {
            // This function will return the interaction is disconnected or not.
            return this.interactionDetails.isDisconnected;
        }
        renderContent() {
            const agentDetails = this.selectedAgentDetails;
            const aidVariables = this.isMPCorPersistEnabled ? this.multiPartyFixedVariables : this.fixedVariables;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <dl>
          ${aidVariables.map((fixedVariable) => {
                var _a;
                const { variableName, variableText } = fixedVariable;
                // If interaction is disconnected, then will show the "-" only.
                const value = this.isInteractionDisconnected()
                    ? _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE
                    : ((_a = agentDetails[variableName]) !== null && _a !== void 0 ? _a : _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE);
                if (value !== _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE) {
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                <div class="aid-details-wrapper">
                  <dt class="aid-field-ellipsis">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(variableText)}</dt>
                  <dd class="aid-value">
                    <agentx-aid-value .variableName=${variableName} .variableValue=${value}></agentx-aid-value>
                  </dd>
                </div>
              `;
                }
                else {
                    return undefined;
                }
            })}
        </dl>
      `;
        }
        startMonitoring() {
            var _a, _b, _c, _d;
            this.liveRegionMessage = `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.ringingMonitoring")} ${(_b = (_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.agentNameDetails) === null || _b === void 0 ? void 0 : _b.agentName}`;
            if (!this.startMonitoringTriggered) {
                this.startMonitoringTriggered = true; // Set true, Once the click the start monitoring button. This prevent multiple clicks
                const monitoringRequest = {
                    id: this.generateUUID(),
                    monitorType: "midcall",
                    trackingId: this.generateUUID(),
                    taskId: (_c = this.selectedAgentDetails) === null || _c === void 0 ? void 0 : _c.interactionId
                };
                (_d = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.aqm.supervisor) === null || _d === void 0 ? void 0 : _d.startMonitoring({ data: monitoringRequest }).then((data) => {
                    _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("event= MonitoringRequestCreated:", data);
                }).catch(() => {
                    _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("event= MonitoringRequestCreatedFailed:");
                });
            }
        }
        retry() {
            //TODO
        }
        isConsultCall() {
            return (this.selectedAgentDetails.contactStatus === (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.contactStatus.consult").toString() ||
                this.selectedAgentDetails.contactStatus === (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.contactStatus.consulting").toString());
        }
        isInteractionInPostCall() {
            var _a;
            return this.isPostCallEnabled && ((_a = this.selectedAgentDetails.actions) === null || _a === void 0 ? void 0 : _a.isMainCallInPostCall);
        }
        isCallTransferred() {
            var _a, _b, _c, _d, _e;
            // Once receive transferred eventname, we need persist this.interactionDetails.interactionIsTransferred=true
            return (this.interactionDetails.interactionIsTransferred ||
                (!this.interactionDetails.interactionIsTransferred &&
                    _constants__WEBPACK_IMPORTED_MODULE_0__.CONTACT_TRANSFERRED_EVENTS.includes(((_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.contactEventName) || "") &&
                    !_constants__WEBPACK_IMPORTED_MODULE_0__.CONTACT_ACTIVE_EVENTS.includes(((_b = this.selectedAgentDetails) === null || _b === void 0 ? void 0 : _b.contactStatusCode) || "") &&
                    (((_c = this.selectedAgentDetails) === null || _c === void 0 ? void 0 : _c.contactStatusCode) === "" ||
                        ((_e = (_d = this.selectedAgentDetails) === null || _d === void 0 ? void 0 : _d.contactStatusCode) === null || _e === void 0 ? void 0 : _e.toLowerCase()) === _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP)));
        }
        updated(changedProperties) {
            var _a, _b, _c, _d, _e, _f;
            super.updated(changedProperties);
            const previousSelectedAgentDetails = changedProperties.get("selectedAgentDetails");
            if (changedProperties.has("selectedAgentDetails") &&
                previousSelectedAgentDetails &&
                !changedProperties.has("isModalOpen") &&
                this.isModalOpen &&
                !this.interactionDetails.isDisconnected) {
                this.isDataUpdated = this.ifFixedVariablesAreUpdated(previousSelectedAgentDetails) || this.isDataUpdated;
            }
            if (changedProperties.has("isModalOpen") && this.isModalOpen) {
                // While opening the modal reset the interaction error modal property values.
                this.interactionDetails = {
                    isDisconnected: false,
                    interactionIsTransferred: false
                };
            }
            if (changedProperties.has("selectedAgentDetails")) {
                if (previousSelectedAgentDetails &&
                    Object.keys(previousSelectedAgentDetails).length > 0 &&
                    ((_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.interactionId) !== "" &&
                    ((_b = this.selectedAgentDetails) === null || _b === void 0 ? void 0 : _b.interactionId) !== (previousSelectedAgentDetails === null || previousSelectedAgentDetails === void 0 ? void 0 : previousSelectedAgentDetails.interactionId)) {
                    // New interaction id are updated, So disable the warnings.
                    this.interactionDetails = {
                        isDisconnected: false,
                        interactionIsTransferred: false
                    };
                }
                else if (this.isCallTransferred()) {
                    // Interaction is Transferred.
                    this.interactionDetails = {
                        isDisconnected: true,
                        interactionIsTransferred: true
                    };
                }
                else if (((_c = this.selectedAgentDetails) === null || _c === void 0 ? void 0 : _c.contactEventName) === _constants__WEBPACK_IMPORTED_MODULE_0__.CONTACT_COMPLETED ||
                    ((_d = this.selectedAgentDetails) === null || _d === void 0 ? void 0 : _d.contactStatusCode) === _constants__WEBPACK_IMPORTED_MODULE_0__.WRAP_UP ||
                    ((_e = this.selectedAgentDetails) === null || _e === void 0 ? void 0 : _e.contactStatusCode) === _constants__WEBPACK_IMPORTED_MODULE_0__.CALL_ENDED ||
                    ((_f = this.selectedAgentDetails) === null || _f === void 0 ? void 0 : _f.interactionId) === "") {
                    // Interaction is disconnected.
                    this.interactionDetails = {
                        isDisconnected: true,
                        interactionIsTransferred: false
                    };
                }
                if (this.errorText !== "" &&
                    (!this.selectedAgentDetails.isMonitored || this.selectedAgentDetails.isMonitored === "false") &&
                    (!this.selectedAgentDetails.monitorFullName ||
                        this.selectedAgentDetails.monitorFullName === _constants__WEBPACK_IMPORTED_MODULE_0__.TPW_EMPTY_COLUMN_VALUE)) {
                    this.errorText = "";
                    this.startMonitoringTriggered = false;
                }
            }
            this.enableWarningContentTooltip();
        }
        renderStartMonitoringButton() {
            return this.isMCMEnabled
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
            <div aria-live="assertive" class="sr-only">${this.liveRegionMessage}</div>
            <md-button
              class="aid-start-btn"
              ?disabled=${this.isStartMonitoringDisabled()}
              variant="primary"
              @click="${!this.isStartMonitoringDisabled() ? this.startMonitoring : ""}"
              type="submit"
              ariaLabel=${this.ariaLabelForMonitoringButton()}
            >
              <md-icon class="aid-monitoring-icon" iconSet="momentumDesign" name="monitoring-regular" size="18">
              </md-icon>
              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.startMonitoring")}</md-button
            >
          `
                : ``;
        }
        getDisableTooltipMessage() {
            var _a, _b, _c, _d, _e;
            if ((_a = this.selectedAgentDetails.actions) === null || _a === void 0 ? void 0 : _a.isSupervisorMonitoring) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cannotMonitor");
            }
            else if (this.interactionDetails.isDisconnected) {
                // Interaction is closed, after AID modal is open
                if (this.interactionDetails.interactionIsTransferred) {
                    // Interaction is Transferred.
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.interactionTransferredButton");
                }
                // Interaction is Ended.
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.interactionEndButton");
            }
            else if (((_b = this.selectedAgentDetails) === null || _b === void 0 ? void 0 : _b.monitorFullName) &&
                (this.errorText === (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(this.MONITORING_CALL_MESSAGE) || this.selectedAgentDetails.isMonitored === "true")) {
                if ((_c = this.selectedAgentDetails.actions) === null || _c === void 0 ? void 0 : _c.isBarged) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cannotMonitorBargedCall");
                }
                else {
                    return ((_d = this.selectedAgentDetails) === null || _d === void 0 ? void 0 : _d.monitorFullName) + (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(this.MONITORING_CALL_MESSAGE);
                }
            }
            else if ((_e = this.selectedAgentDetails.actions) === null || _e === void 0 ? void 0 : _e.isConsultCall) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cannotMonitorConsult");
            }
            else if (this.isInteractionInPostCall()) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cannotMonitorPostCall");
            }
            return false;
        }
        renderModalFooter() {
            const toolTipMessage = this.getDisableTooltipMessage();
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <md-tooltip
          class="aid-start"
          placement="top"
          ?disabled=${!toolTipMessage ? true : false}
          message=${toolTipMessage || ""}
        >
          ${this.renderStartMonitoringButton()}
        </md-tooltip>
        <md-button
          class="aid-close"
          variant="secondary"
          ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cancel")}
          @click="${this.closeAIDModal}"
          type="reset"
        >
          ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cancel")}</md-button
        >
      `;
        }
        renderWarningElement() {
            const { errorMessage, bannerContent } = this.getWarningContent();
            if (errorMessage) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
          <md-tooltip class="aid-banner-content" message=${errorMessage} ?disabled=${!this.enableWarningTooltip}>
            ${bannerContent}
          </md-tooltip>
        `;
            }
            return lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing;
        }
        getWarningContent() {
            var _a, _b, _c, _d, _e, _f;
            if (this.errorText === (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(this.MONITORING_CALL_MESSAGE) &&
                ((_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.monitorFullName) &&
                (this.selectedAgentDetails.isMonitored === "false" || this.selectedAgentDetails.isMonitored === null)) {
                // <!-- error banner when monitoringcreatefailed event is received -->
                const errorMessage = `${(_b = this.selectedAgentDetails) === null || _b === void 0 ? void 0 : _b.monitorFullName} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(this.MONITORING_CALL_MESSAGE)}`;
                return {
                    errorMessage,
                    bannerContent: (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
            <md-alert-banner class="md-alert-banner-wrapper" show type="error">
              <div class="aid-banner-text-wrapper">
                <md-icon
                  aria-hidden="true"
                  name="error-legacy-badge-filled"
                  iconSet="momentumDesign"
                  size="14"
                ></md-icon>
                <div class="aid-banner-text aid-banner-text-error">
                  <span aria-label="${errorMessage}">${errorMessage}</span>
                </div>
              </div>
            </md-alert-banner>
          `
                };
            }
            else if (this.selectedAgentDetails.isMonitored === "true" &&
                !((_c = this.selectedAgentDetails.actions) === null || _c === void 0 ? void 0 : _c.isSupervisorMonitoring)) {
                // <!-- warning banner to notify supervisor that call is monitored/barged by another supervisor -->
                const errorMessage = ((_d = this.selectedAgentDetails.actions) === null || _d === void 0 ? void 0 : _d.isBarged)
                    ? `${(_e = this.selectedAgentDetails) === null || _e === void 0 ? void 0 : _e.monitorFullName} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.supervisorBargedIn")}`
                    : `${(_f = this.selectedAgentDetails) === null || _f === void 0 ? void 0 : _f.monitorFullName} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(this.MONITORING_CALL_MESSAGE)}`;
                return {
                    errorMessage,
                    bannerContent: (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
            <md-alert-banner class="md-alert-banner-wrapper" show type="warning">
              <div class="aid-banner-text-wrapper">
                <md-icon aria-hidden="true" name="warning-badge-filled" iconSet="momentumDesign" size="14"></md-icon>
                <div class="aid-banner-text aid-banner-text-warning" aria-label="${errorMessage}">${errorMessage}</div>
              </div>
            </md-alert-banner>
          `
                };
            }
            else if (this.isInteractionDisconnected()) {
                // <!-- warning/error banner to notify supervisor that interaction is closed or transferred -->
                // Before click start monitoring, The agent is completed the interaction or transferred the interaction, then showing the "warning" type modal
                // While click start monitoring, simultaneously the agent is completed the interaction or transferred the interaction, then showing the "error" type modal
                const modalType = this.startMonitoringTriggered ? "error" : "warning";
                const errorMessage = this.interactionDetails.interactionIsTransferred
                    ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.interactionTransferred")
                    : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.interactionEnd");
                return {
                    errorMessage,
                    bannerContent: (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
            <md-alert-banner class="md-alert-banner-wrapper" show type="${modalType}">
              <div class="aid-banner-text-wrapper">
                <md-icon
                  aria-hidden="true"
                  name="${modalType === "error" ? "error-legacy-badge-filled" : "warning-badge-filled"}"
                  iconSet="momentumDesign"
                  size="14"
                ></md-icon>
                <div
                  aria-label="${errorMessage}"
                  class="aid-banner-text ${modalType === "error" ? "aid-banner-text-error" : "aid-banner-text-warning"}"
                >
                  ${errorMessage}
                </div>
              </div>
            </md-alert-banner>
          `
                };
            }
            else if (this.monitoringInProgress && this.selectedAgentDetails.isMonitored === "true") {
                // info banner when supervisor is already monitoring this call
                const errorMessage = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cannotMonitor");
                return {
                    errorMessage,
                    bannerContent: (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
            <md-alert-banner class="md-alert-banner-wrapper" show type="default">
              <div class="aid-banner-text-wrapper">
                <md-icon aria-hidden="true" name="info-badge-filled" iconSet="momentumDesign" size="14"></md-icon>
                <div aria-label="${errorMessage}" class="aid-banner-text-info">${errorMessage}</div>
              </div>
            </md-alert-banner>
          `
                };
            }
            else {
                return lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing;
            }
        }
        render() {
            var _a, _b, _c, _d;
            const HeaderText = this.isMCMEnabled ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.reviewAndMonitor") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.review");
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <md-modal
          class="aid-modal"
          htmlId="modal-1"
          ?show=${this.isModalOpen}
          size="small"
          ariaLabelClose=${`${HeaderText} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.close")}`}
          headerLabel=${HeaderText}
          .hideFooter=${true}
          showCloseButton=${true}
          backdropClickExit=${true}
          @close-modal="${this.trackAIDClose}"
          >${this.selectedAgentDetails
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                <div class="aid-img-wrapper">
                  <div>
                    <md-avatar
                      alt=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__.ifDefined)((_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.agentName)}
                      class="aid-img md-avatar md-avatar--medium"
                      title=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__.ifDefined)((_b = this.selectedAgentDetails) === null || _b === void 0 ? void 0 : _b.agentName)}
                    >
                    </md-avatar>
                  </div>
                  <div aria-label=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__.ifDefined)((_c = this.selectedAgentDetails) === null || _c === void 0 ? void 0 : _c.agentName)} class="aid-name">
                    ${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_6__.ifDefined)((_d = this.selectedAgentDetails) === null || _d === void 0 ? void 0 : _d.agentName)}
                  </div>
                </div>
                <div tabindex="0" role="group" class=${`aid-body`}>
                  ${this.renderWarningElement()}
                  <div class="aid-data-height-auto">${this.selectedAgentDetails && this.renderContent()}</div>
                </div>
                ${this.isDataUpdated
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                      <div class="aid-warning">
                        <md-icon
                          class="aid-warning-icon"
                          name="warning-badge-filled"
                          iconSet="momentumDesign"
                          size="14"
                        ></md-icon
                        >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.isUpdated")}
                      </div>
                    `
                    : ``}
                ${this.errorText !== "" && this.errorText !== (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(this.MONITORING_CALL_MESSAGE)
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                      <div class="aid-error">
                        <md-icon
                          class="aid-error-icon"
                          name="error-legacy-badge-filled"
                          iconSet="momentumDesign"
                          size="14"
                        ></md-icon
                        >${this.errorText}
                      </div>
                    `
                    : ``}
                <div slot="footer" class="aid-btn-wrapper">${this.renderModalFooter()}</div>
              `
                : (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                <div class="aid-nodata-wrapper">
                  <agentx-wc-widget-error .detail=${this.detail} @reload=${this.retry}></agentx-wc-widget-error>
                </div>
              `}
        </md-modal>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], Element.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Object })
    ], Element.prototype, "selectedAgentDetails", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], Element.prototype, "isMCMEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], Element.prototype, "monitoringInProgress", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
    ], Element.prototype, "errorText", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
    ], Element.prototype, "role", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], Element.prototype, "isMPCorPersistEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], Element.prototype, "isPostCallEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "shouldTrackAid", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "startMonitoringTriggered", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "interactionDetails", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "enableWarningTooltip", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "isStartMonitorFailed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "liveRegionMessage", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "detail", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "isDataUpdated", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "fixedVariables", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "multiPartyFixedVariables", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("agentx-wc-aid")
    ], Element);
    ActiveInteraction.Element = Element;
})(ActiveInteraction || (ActiveInteraction = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/AidValues.scss":
/*!************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/AidValues.scss ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.aid-value {
  margin-left: 8px;
  width: 204px;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/TeamPerformanceWidget/components/AidValues.scss */
/*# sourceURL=AidValues.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvVGVhbVBlcmZvcm1hbmNlV2lkZ2V0L2NvbXBvbmVudHMvQWlkVmFsdWVzLnNjc3MiLCJBaWRWYWx1ZXMuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGdCQUFBO0VBQ0EsWUFBQTtFQUNBLDRCQUFBO0VBQ0Esb0JBQUE7RUFDQSxxQkFBQTtFQUNBLGdCQUFBO0VBQ0EsdUJBQUE7QUNDRiIsImZpbGUiOiJBaWRWYWx1ZXMuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5haWQtdmFsdWUge1xuICBtYXJnaW4tbGVmdDogOHB4O1xuICB3aWR0aDogMjA0cHg7XG4gIC13ZWJraXQtYm94LW9yaWVudDogdmVydGljYWw7XG4gIGRpc3BsYXk6IC13ZWJraXQtYm94O1xuICAtd2Via2l0LWxpbmUtY2xhbXA6IDM7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xufVxuIiwiLmFpZC12YWx1ZSB7XG4gIG1hcmdpbi1sZWZ0OiA4cHg7XG4gIHdpZHRoOiAyMDRweDtcbiAgLXdlYmtpdC1ib3gtb3JpZW50OiB2ZXJ0aWNhbDtcbiAgZGlzcGxheTogLXdlYmtpdC1ib3g7XG4gIC13ZWJraXQtbGluZS1jbGFtcDogMztcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7XG59Il19 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/AidValues.ts":
/*!**********************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/AidValues.ts ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AidValue: () => (/* binding */ AidValue)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_CountDownTimer_CountDownTimer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../components/CountDownTimer/CountDownTimer */ "./src/components/CountDownTimer/CountDownTimer.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../constants */ "./src/constants.ts");
/* harmony import */ var _AidValues_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./AidValues.scss */ "./src/components/TeamPerformanceWidget/components/AidValues.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





var AidValue;
(function (AidValue) {
    /**
     * @element agentx-aid-value
     * @fires close-modal
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.variableName = "";
            this.variableValue = "";
            this.toolTipDisabled = true;
            this.disableTooltip = () => {
                let isTooltipVisible;
                if (this.valueContainer) {
                    const divInsideValueField = this.valueContainer.querySelector("div");
                    if (divInsideValueField) {
                        isTooltipVisible = (divInsideValueField === null || divInsideValueField === void 0 ? void 0 : divInsideValueField.offsetHeight) < (divInsideValueField === null || divInsideValueField === void 0 ? void 0 : divInsideValueField.scrollHeight);
                    }
                    this.toolTipDisabled = !isTooltipVisible;
                }
            };
        }
        connectedCallback() {
            const _super = Object.create(null, {
                connectedCallback: { get: () => super.connectedCallback }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.connectedCallback.call(this);
            });
        }
        disconnectedCallback() {
            super.disconnectedCallback();
        }
        static get styles() {
            return _AidValues_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        updated(changedProperties) {
            if (changedProperties.has("variableValue")) {
                setTimeout(() => this.disableTooltip(), 300);
            }
        }
        firstUpdated() {
            setTimeout(() => this.disableTooltip(), 300);
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-tooltip
          message=${this.variableValue}
          ?disabled=${this.variableValue === _constants__WEBPACK_IMPORTED_MODULE_3__.TPW_EMPTY_COLUMN_VALUE || this.toolTipDisabled}
        >
          <div class="aid-value">
            ${_constants__WEBPACK_IMPORTED_MODULE_3__.TIMER_FIELDS.includes(this.variableName)
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
                  <agentx-wc-count-down-timer
                    duration="${this.variableValue}"
                    .isDurationTimer=${true}
                    .showDefaultHours=${false}
                  ></agentx-wc-count-down-timer>
                `
                : (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ` <div>${this.variableValue}</div> `}
          </div>
        </md-tooltip>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], Element.prototype, "variableName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], Element.prototype, "variableValue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "toolTipDisabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.query)(".aid-value")
    ], Element.prototype, "valueContainer", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-aid-value")
    ], Element);
    AidValue.Element = Element;
})(AidValue || (AidValue = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/AppliedFilters.ts":
/*!***************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/AppliedFilters.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AppliedFilters: () => (/* binding */ AppliedFilters)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../assets/styles/common.scss */ "./src/assets/styles/common.scss");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Utils */ "./src/components/TeamPerformanceWidget/Utils.ts");
/* harmony import */ var _style_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./style.scss */ "./src/components/TeamPerformanceWidget/components/style.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var AppliedFilters;
(function (AppliedFilters) {
    /**
     * @element agentx-wc-tpw-applied-filters
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        constructor() {
            super(...arguments);
            this.appliedFilters = {};
            this.gridOptions = {};
            this.appliedGroups = [];
            this.isFilterApplied = false;
            this.isExpanded = false;
            this.columnWiseFilterCount = {};
            this.columnWiseFilters = {};
            this.updateFiltersAndFilterCount = () => {
                Object.keys(this.appliedFilters).forEach((columnField) => {
                    let columnFilterCount = 0;
                    const columnFilters = [];
                    Object.keys(this.appliedFilters[columnField]).forEach((columnData) => {
                        if (this.appliedFilters[columnField][columnData]) {
                            columnFilterCount++;
                            columnFilters.push(columnData);
                        }
                    });
                    if (columnFilterCount) {
                        this.isFilterApplied = true;
                    }
                    this.columnWiseFilterCount[columnField] = columnFilterCount;
                    this.columnWiseFilters[columnField] = columnFilters;
                });
            };
            this.handleExpandAppliedFilters = (event) => {
                if (!this.checkKeyboardEventKey(event)) {
                    return;
                }
                event.preventDefault();
                this.isExpanded = !this.isExpanded;
            };
            this.handleClearAllFilters = (event) => {
                if (!this.checkKeyboardEventKey(event)) {
                    return;
                }
                event.preventDefault();
                this.dispatchFilterUpdateEvent({
                    clearAllFilter: true
                });
            };
        }
        static get styles() {
            return [_style_scss__WEBPACK_IMPORTED_MODULE_7__["default"], _assets_styles_common_scss__WEBPACK_IMPORTED_MODULE_5__["default"]];
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            if (changedProperties.has("appliedFilters")) {
                this.isFilterApplied = false;
                this.updateFiltersAndFilterCount();
                this.requestUpdate();
            }
        }
        checkKeyboardEventKey(event) {
            if (event.type === "keydown") {
                const { code } = event;
                if (code !== _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Space && code !== _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Enter) {
                    return false;
                }
            }
            return true;
        }
        dispatchFilterUpdateEvent(updatedColumnFilter) {
            this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.TPW_FILTER_UPDATED, {
                bubbles: true,
                composed: true,
                detail: updatedColumnFilter
            }));
        }
        dispatchGroupFilterUpdateEvent(updatedColumnFilter) {
            this.dispatchEvent(new CustomEvent("tpw-group-filter-updated", {
                bubbles: true,
                composed: true,
                detail: updatedColumnFilter
            }));
        }
        handleRemoveColumnAllFilters(event, columnField) {
            if (!this.checkKeyboardEventKey(event)) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            this.dispatchFilterUpdateEvent({
                field: columnField,
                data: {}
            });
        }
        handleRemoveColumnDataFilter(event, columnField, columnData) {
            if (!this.checkKeyboardEventKey(event)) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            const updatedColumnFilter = {
                field: columnField,
                data: Object.assign(Object.assign({}, this.appliedFilters[columnField]), { [columnData]: false })
            };
            this.dispatchFilterUpdateEvent(updatedColumnFilter);
        }
        renderCollapsedView() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        ${Object.keys(this.columnWiseFilterCount).map((columnField) => {
                if (this.columnWiseFilterCount[columnField]) {
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
              <md-chip
                role="button"
                aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.remove")} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.filter")} ${(0,_Utils__WEBPACK_IMPORTED_MODULE_6__.columnHeaderMapping)()[columnField]} (${this
                        .columnWiseFilterCount[columnField]}) "
                aria-describedby="filter-info-id"
                tooltipText=${this.columnWiseFilters[columnField].join(" ,")}
                tooltipPlacement="bottom"
                value="${`${(0,_Utils__WEBPACK_IMPORTED_MODULE_6__.columnHeaderMapping)()[columnField]} (${this.columnWiseFilterCount[columnField]})`}"
                class="applied-filters-chips filter-collapsed-view"
                @chip-interaction=${(event) => this.handleRemoveColumnAllFilters(event, columnField)}
                @click=${(event) => this.handleRemoveColumnAllFilters(event, columnField)}
                @keydown=${(event) => this.handleRemoveColumnAllFilters(event, columnField)}
              >
                <span class="sr-only" slot="custom-left-content" id="filter-info-id"
                  >${this.columnWiseFilters[columnField].join(" ,")}</span
                >
                <md-icon
                  name="icon-cancel_8"
                  slot="custom-right-content"
                  class="chip-cross-icon"
                  tabIndex="-1"
                ></md-icon>
              </md-chip>
            `;
                }
                else {
                    return lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing;
                }
            })}
      `;
        }
        renderExpandedView() {
            const appliedFiltersData = [];
            const columnsDataKeys = Object.keys(this.appliedFilters);
            for (const columnsDataKey of columnsDataKeys) {
                const columnsDataNestedKeys = this.appliedFilters[columnsDataKey];
                for (const i in columnsDataNestedKeys) {
                    if (columnsDataNestedKeys[i]) {
                        appliedFiltersData.push({
                            columnsDataKey,
                            colName: (0,_Utils__WEBPACK_IMPORTED_MODULE_6__.columnHeaderMapping)()[columnsDataKey],
                            colVal: i
                        });
                    }
                }
            }
            return appliedFiltersData.map((data) => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
          <md-chip
            role="button"
            aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.remove")} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.filter")} ${data.colName}: ${data.colVal}"
            aria-describedby="data-filter-info"
            class="applied-filters-chips filter-expanded-view"
            tooltipText="${data.colName}: ${data.colVal}"
            tooltipPlacement="bottom"
            value="${data.colName}: ${data.colVal}"
            @chip-interaction=${(event) => this.handleRemoveColumnDataFilter(event, data.columnsDataKey, data.colVal)}
          >
            <span class="sr-only" slot="custom-left-content" id="data-filter-info"
              >${data.colName}: ${data.colVal}</span
            >
            <md-icon
              name="icon-cancel_8"
              slot="custom-right-content"
              class="chip-cross-icon"
              tabIndex="-1"
              @click=${(event) => this.handleRemoveColumnDataFilter(event, data.columnsDataKey, data.colVal)}
              @keydown=${(event) => this.handleRemoveColumnDataFilter(event, data.columnsDataKey, data.colVal)}
            ></md-icon>
          </md-chip>
        `;
            });
        }
        renderFilterActionButtons() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <md-link
          tag="span"
          ariaRole="button"
          class="applied-filters-expandCollapse-btn applied-filters-action-btn"
          @click=${(event) => this.handleExpandAppliedFilters(event)}
          @keydown=${(event) => this.handleExpandAppliedFilters(event)}
        >
          ${this.isExpanded ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.collapse") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.expand")}
        </md-link>
        <md-link
          tag="span"
          ariaRole="button"
          class="applied-filters-action-btn"
          @click=${(event) => this.handleClearAllFilters(event)}
          @keydown=${(event) => this.handleClearAllFilters(event)}
        >
          ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.clearAll")}
        </md-link>
      `;
        }
        getAppliedGroupFilters(columnDefs, appliedGroupsBy) {
            const appliedGroupsData = appliedGroupsBy.map((a) => {
                var _a;
                return {
                    id: a.colId,
                    name: (_a = columnDefs === null || columnDefs === void 0 ? void 0 : columnDefs.find((b) => b.field === a.colId)) === null || _a === void 0 ? void 0 : _a.headerName
                };
            });
            return appliedGroupsData.map((data) => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
          <md-chip
            role="button"
            aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.remove")} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.group")} ${data.name}"
            aria-describedby="group-filter-info"
            class="applied-groups-chips filter-expanded-view"
            tooltipText=${data.name}
            tooltipPlacement="bottom"
            value=${data.name}
            @chip-interaction=${(event) => this.onGroupFilterClear(data.id, event)}
          >
            <span class="sr-only" slot="custom-left-content" id="group-filter-info">${data.name}</span>
            <md-icon
              name="icon-cancel_8"
              slot="custom-right-content"
              class="chip-cross-icon"
              tabIndex="-1"
              @click=${(event) => this.onGroupFilterClear(data.id, event)}
              @keydown=${(event) => this.onGroupFilterClear(data.id, event)}
            ></md-icon>
          </md-chip>
        `;
            });
        }
        onGroupFilterClearAll(event) {
            if (!this.checkKeyboardEventKey(event)) {
                return;
            }
            event.preventDefault();
            this.dispatchGroupFilterUpdateEvent({
                clearAllFilter: true
            });
        }
        onGroupFilterClear(fieldId, event) {
            if (!this.checkKeyboardEventKey(event)) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            this.dispatchGroupFilterUpdateEvent({
                field: fieldId
            });
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div>
          ${this.isFilterApplied
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                <div class="applied-filters-wrapper">
                  <span class="applied-filters__label">${`${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.filtersApplied")}:`} </span>
                  <span class="applied-group__chip">
                    ${this.isExpanded ? this.renderExpandedView() : this.renderCollapsedView()}
                  </span>
                  ${this.renderFilterActionButtons()}
                </div>
              `
                : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
          ${this.appliedGroups.length > 0
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                <div class="applied-group-wrapper">
                  <span class="applied-group__label">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.groupBy")}: </span>
                  <span class="applied-group__chip">
                    ${this.getAppliedGroupFilters(this.gridOptions.columnDefs, this.appliedGroups)}
                  </span>
                  ${this.appliedGroups.length > 1
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
                        <md-link
                          ariaRole="button"
                          data-testid="applied-group__clear-all"
                          class="applied-group__clear-all"
                          @click=${(event) => this.onGroupFilterClearAll(event)}
                          @keydown=${(event) => this.onGroupFilterClearAll(event)}
                          >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.clearAll")}
                        </md-link>
                      `
                    : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
                </div>
              `
                : lit_html__WEBPACK_IMPORTED_MODULE_4__.nothing}
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
    ], Element.prototype, "appliedFilters", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
    ], Element.prototype, "gridOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Array })
    ], Element.prototype, "appliedGroups", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isFilterApplied", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isExpanded", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "columnWiseFilterCount", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "columnWiseFilters", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("agentx-wc-tpw-applied-filters")
    ], Element);
    AppliedFilters.Element = Element;
})(AppliedFilters || (AppliedFilters = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/EmptyGrid.ts":
/*!**********************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/EmptyGrid.ts ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EmptyGrid: () => (/* binding */ EmptyGrid)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Common_EmptyStateWrapper_EmptyStateWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../Common/EmptyStateWrapper/EmptyStateWrapper */ "./src/components/Common/EmptyStateWrapper/EmptyStateWrapper.ts");
/* harmony import */ var _style_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./style.scss */ "./src/components/TeamPerformanceWidget/components/style.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var EmptyGrid;
(function (EmptyGrid) {
    /**
     * @element agentx-wc-tpw-empty-grid
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.isError = "1";
        }
        static get styles() {
            return _style_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        connectedCallback() {
            super.connectedCallback();
        }
        render() {
            return this.isError === "1"
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <div class="agentx-wc-tpw-empty-grid">
              <agentx-wc-empty-state-wrapper illustration-type="error-cloud">
                <div class="empty-grid-message-container">
                  <p class="empty-grid-message" role="alert">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.errorHeader")}</p>
                </div>
              </agentx-wc-empty-state-wrapper>
            </div>
          `
                : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
            <div class="agentx-wc-tpw-empty-grid">
              <agentx-wc-empty-state-wrapper illustration-type="empty-state">
                <span role="alert" class="empty-grid-message">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.noData")}</span>
              </agentx-wc-empty-state-wrapper>
            </div>
          `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ reflect: true, attribute: "is-error" })
    ], Element.prototype, "isError", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-tpw-empty-grid")
    ], Element);
    EmptyGrid.Element = Element;
})(EmptyGrid || (EmptyGrid = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/ReviewAndMonitorWrapper.scss":
/*!**************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/ReviewAndMonitorWrapper.scss ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

* {
  /* BASE LEVEL < 100 */
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-index-tpw-header: 1;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-index-task-collapse-area: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-navigation-bar: 12;
  --z-index-task-list: 12;
  --z-index-wrap-up: 13;
  --z-index-sticky-header: 14;
  --z-index-shortcutkey-modal: 15;
  /* MID LEVEL FLOATING > 100 < 1000 */
  --z-index-notification: 150;
  /* SUPER LEVEL > 1000 */
  --z-index-modal: 1040;
  --z-index-popover: 1041;
  /* This below order needs to be unchanged. Highest priority is for connection loss overlay,
         followed by error modal since error can occur during app load such as teams failure/register failure. */
  --z-index-app-full-overlay: 1050;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1200;
}

.review-monitor-wrapper md-button::part(button) {
  background-color: transparent;
}
.review-monitor-wrapper.list md-button {
  margin: 0;
}
.review-monitor-wrapper .rm-text {
  margin-top: 0;
  margin-bottom: 0;
  color: var(--md-primary-text-color);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
}
.review-monitor-wrapper .rm-text.disabled {
  color: var(--md-disabled-text-color);
}

.aid-tooltip {
  margin-top: 3px;
}

.aid-icon {
  height: calc(var(--space-token-even) * 10);
  width: calc(var(--space-token-even) * 10);
}

.btn-action {
  margin: calc(var(--space-token-even) * 6);
}

.aid-button:focus-visible {
  outline: none;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=ReviewAndMonitorWrapper.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-services/dist/styles/z-index.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/TeamPerformanceWidget/components/ReviewAndMonitorWrapper.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/ReviewAndMonitorWrapper.ts":
/*!************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/ReviewAndMonitorWrapper.ts ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ReviewAndMonitorWrapper: () => (/* binding */ ReviewAndMonitorWrapper)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ReviewAndMonitorWrapper_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./ReviewAndMonitorWrapper.scss */ "./src/components/TeamPerformanceWidget/components/ReviewAndMonitorWrapper.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





const reviewAndMonitor = "app:tpw.reviewAndMonitor";
const review = "app:tpw.review";
var ReviewAndMonitorWrapper;
(function (ReviewAndMonitorWrapper) {
    /**
     * @element agentx-wc-tpw-review-monitor-wrapper
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.agentId = "";
            this.isMCMEnabled = false;
            this.isList = false;
            this.isConsultCall = false;
            this.isDarkMode = false;
            this.isReviewMonitorEnabled = false;
        }
        static get styles() {
            return _ReviewAndMonitorWrapper_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        connectedCallback() {
            super.connectedCallback();
        }
        disconnectedCallback() {
            super.disconnectedCallback();
        }
        getReviewButton(disabled = false) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-button
          id=${this.agentId}
          aria-colindex="12"
          tabIndex="0"
          class="aid-button btn-action"
          ariaLabel="${this.isMCMEnabled ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(reviewAndMonitor) : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(review)}"
          size="size-none"
          .disabled=${disabled}
          color="color-none"
        >
          ${!disabled && !this.isList
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                <img
                  class="aid-icon"
                  alt="${this.isMCMEnabled ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(reviewAndMonitor) : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(review)}"
                  src="${this.isDarkMode ? _constants__WEBPACK_IMPORTED_MODULE_0__.REVIEW_BUTTON_DARK : _constants__WEBPACK_IMPORTED_MODULE_0__.REVIEW_BUTTON_LIGHT}"
                />
              `
                : disabled && !this.isList
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                  <img
                    class="aid-icon"
                    alt="${this.isMCMEnabled ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(reviewAndMonitor) : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(review)}"
                    src="${this.isDarkMode ? _constants__WEBPACK_IMPORTED_MODULE_0__.REVIEW_BUTTON_DARK_DISABLED : _constants__WEBPACK_IMPORTED_MODULE_0__.REVIEW_BUTTON_LIGHT_DISABLED}"
                  />
                `
                    : this.isList
                        ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                    <p class="rm-text ${disabled ? "disabled" : ""}">
                      ${this.isMCMEnabled ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(reviewAndMonitor) : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(review)}
                    </p>
                  `
                        : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
        </md-button>
      `;
        }
        getTooltipMessage() {
            if (this.isConsultCall) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.cannotMonitorConsult");
            }
            else if (this.isMCMEnabled) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(reviewAndMonitor);
            }
            else {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)(review);
            }
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="${`review-monitor-wrapper ${this.isList ? "list" : ""}`}">
          ${this.isReviewMonitorEnabled || this.isConsultCall
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                <md-tooltip class="aid-tooltip" message="${this.getTooltipMessage()}" placement="top">
                  ${this.isConsultCall ? this.getReviewButton(true) : this.getReviewButton(false)}
                </md-tooltip>
              `
                : this.getReviewButton(true)}
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "agentId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isMCMEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isConsultCall", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isDarkMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isReviewMonitorEnabled", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-tpw-review-monitor-wrapper")
    ], Element);
    ReviewAndMonitorWrapper.Element = Element;
})(ReviewAndMonitorWrapper || (ReviewAndMonitorWrapper = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/SignoutModal.scss":
/*!***************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/SignoutModal.scss ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.reset-table {
  color: var(--md-primary-text-color);
}
.reset-table::part(button):hover {
  background-color: var(--button-white-hover-bg-color);
  border-radius: var(--border-radius-large);
}

.signout-btn-wrapper .signout-submit {
  margin-left: 10px;
}
.signout-btn-wrapper .signout-submit,
.signout-btn-wrapper .signout-close {
  float: right;
  margin-right: 10px;
}

.header-width {
  width: 100%;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/TeamPerformanceWidget/components/SignoutModal.scss */
/*# sourceURL=SignoutModal.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvVGVhbVBlcmZvcm1hbmNlV2lkZ2V0L2NvbXBvbmVudHMvU2lnbm91dE1vZGFsLnNjc3MiLCJTaWdub3V0TW9kYWwuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLG1DQUFBO0FDQ0Y7QURDSTtFQUNFLG9EQUFBO0VBQ0EseUNBQUE7QUNDTjs7QURLRTtFQUNFLGlCQUFBO0FDRko7QURJRTs7RUFFRSxZQUFBO0VBQ0Esa0JBQUE7QUNGSjs7QURNQTtFQUNFLFdBQUE7QUNIRiIsImZpbGUiOiJTaWdub3V0TW9kYWwuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5yZXNldC10YWJsZSB7XG4gIGNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LXRleHQtY29sb3IpO1xuICAmOjpwYXJ0KGJ1dHRvbikge1xuICAgICY6aG92ZXIge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tYnV0dG9uLXdoaXRlLWhvdmVyLWJnLWNvbG9yKTtcbiAgICAgIGJvcmRlci1yYWRpdXM6IHZhcigtLWJvcmRlci1yYWRpdXMtbGFyZ2UpO1xuICAgIH1cbiAgfVxufVxuXG4uc2lnbm91dC1idG4td3JhcHBlciB7XG4gIC5zaWdub3V0LXN1Ym1pdCB7XG4gICAgbWFyZ2luLWxlZnQ6IDEwcHg7XG4gIH1cbiAgLnNpZ25vdXQtc3VibWl0LFxuICAuc2lnbm91dC1jbG9zZSB7XG4gICAgZmxvYXQ6IHJpZ2h0O1xuICAgIG1hcmdpbi1yaWdodDogMTBweDtcbiAgfVxufVxuXG4uaGVhZGVyLXdpZHRoIHtcbiAgd2lkdGg6IDEwMCU7XG59XG4iLCIucmVzZXQtdGFibGUge1xuICBjb2xvcjogdmFyKC0tbWQtcHJpbWFyeS10ZXh0LWNvbG9yKTtcbn1cbi5yZXNldC10YWJsZTo6cGFydChidXR0b24pOmhvdmVyIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tYnV0dG9uLXdoaXRlLWhvdmVyLWJnLWNvbG9yKTtcbiAgYm9yZGVyLXJhZGl1czogdmFyKC0tYm9yZGVyLXJhZGl1cy1sYXJnZSk7XG59XG5cbi5zaWdub3V0LWJ0bi13cmFwcGVyIC5zaWdub3V0LXN1Ym1pdCB7XG4gIG1hcmdpbi1sZWZ0OiAxMHB4O1xufVxuLnNpZ25vdXQtYnRuLXdyYXBwZXIgLnNpZ25vdXQtc3VibWl0LFxuLnNpZ25vdXQtYnRuLXdyYXBwZXIgLnNpZ25vdXQtY2xvc2Uge1xuICBmbG9hdDogcmlnaHQ7XG4gIG1hcmdpbi1yaWdodDogMTBweDtcbn1cblxuLmhlYWRlci13aWR0aCB7XG4gIHdpZHRoOiAxMDAlO1xufSJdfQ== */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/SignoutModal.ts":
/*!*************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/SignoutModal.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SignoutModal: () => (/* binding */ SignoutModal)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html_lib_part__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html/lib/part */ "lit-html/lib/part");
/* harmony import */ var lit_html_lib_part__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html_lib_part__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _SignoutModal_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./SignoutModal.scss */ "./src/components/TeamPerformanceWidget/components/SignoutModal.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




let SignoutModal = class SignoutModal extends lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement {
    constructor() {
        super(...arguments);
        this.isSignoutModalOpen = false;
    }
    static get styles() {
        return _SignoutModal_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
    }
    confirmAgentSignout() {
        this.dispatchEvent(new CustomEvent("confirm-signout"));
    }
    declineAgentSignout() {
        this.dispatchEvent(new CustomEvent("decline-signout"));
    }
    render() {
        var _a;
        return this.isSignoutModalOpen
            ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
          <md-modal
            applicationId="signout"
            ?show=${this.isSignoutModalOpen}
            id="signoutModal"
            size="dialog"
            .hideFooter=${true}
            headerLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.signoutAgentMenu")}
            ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.signoutAgentMenu")}
            tabindex="${"-1"}"
            ?showclosebutton=${false}
            .ariaLabelClose=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.closeSignoutAgentView")}
          >
            <div class="modal-body">
              <span
                >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.signoutAgentConfirmation", "", {
                defaultValue: (_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.agentName
            })}</span
              >
            </div>
            <div slot="footer" class="signout-btn-wrapper">
              <md-button
                class="signout-submit"
                variant="primary"
                @click="${this.confirmAgentSignout}"
                type="submit"
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.signout")}
              >
                ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.signout")}</md-button
              >
              <md-button
                class="signout-close"
                variant="secondary"
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.cancel")}
                type="reset"
                @click="${this.declineAgentSignout}"
              >
                ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:tpw.cancel")}</md-button
              >
            </div>
          </md-modal>
        `
            : lit_html_lib_part__WEBPACK_IMPORTED_MODULE_2__.nothing;
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
], SignoutModal.prototype, "isSignoutModalOpen", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
], SignoutModal.prototype, "selectedAgentDetails", void 0);
SignoutModal = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-tpw-signout-modal")
], SignoutModal);



/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/StateSelector.ts":
/*!**************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/StateSelector.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   StateSelector: () => (/* binding */ StateSelector)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _style_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./style.scss */ "./src/components/TeamPerformanceWidget/components/style.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




const AgentState = { Available: "Available", Idle: "Idle" };
var StateSelector;
(function (StateSelector) {
    /**
     * @element agentx-wc-tpw-state-selector
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.agentState = "";
        }
        static get styles() {
            return _style_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
        }
        getAgentStateDotClass() {
            switch (this.agentState) {
                case AgentState.Available:
                    return "agent-available-dot";
                case AgentState.Idle:
                    return "agent-idle-dot";
                default:
                    return "agent-idle-dot";
            }
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-chip
          class=${this.agentState === "Available" ? "agent-state-active" : "agent-state-idle"}
          value=${this.agentState}
        >
          <span slot="custom-left-content" class=${`agent-state-dot ${this.getAgentStateDotClass()}`}></span>
          <md-icon name="icon-arrow-down_16" slot="custom-right-content"></md-icon>
        </md-chip>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ reflect: true })
    ], Element.prototype, "agentState", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agentx-wc-tpw-state-selector")
    ], Element);
    StateSelector.Element = Element;
})(StateSelector || (StateSelector = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/WebexChat.scss":
/*!************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/WebexChat.scss ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.WebexChat {
  margin: 10rem;
  display: table-row;
}

.str-length {
  border: 1px solid var(--input-default-border-color, #ccc);
  padding: 8px 16px;
  display: flex;
  justify-content: flex-end;
  border-top: none;
  border-radius: 0 0 4px 4px;
  background-color: var(--md-input-chat-length-indicator-bg-color);
}
.str-length .length-label {
  font-size: 10px;
  line-height: 150%;
  color: var(--md-input-chat-length-indicator-color);
}
.str-length:hover {
  background-color: var(--md-input-chat-length-indicator-bg-color);
}
.str-length:focus {
  background-color: var(--md-input-chat-length-indicator-bg-color);
}

.btn-action {
  margin: calc(var(--space-token-even) * 6);
}
.btn-action::part(button) {
  height: 25px;
}

.action-container {
  margin-top: 25px;
  display: flex;
  justify-content: flex-end;
}
.action-container > md-button:first-child {
  order: 2;
}
.action-container > md-button:last-child {
  order: 1;
  margin-right: 8px;
}
.action-container > md-button.send-disabled::part(button) {
  cursor: not-allowed;
  background-color: var(--md-webex-chat-disable-bg-color, #dedede);
  color: var(--md-webex-chat-disable-color, #b2b2b2);
}
.action-container > md-button.send-disabled::part(button):focus, .action-container > md-button.send-disabled::part(button):focus-visible {
  border: none;
}

.icon-container .error-icon {
  position: absolute;
  top: -2px;
  right: -2px;
  color: var(--md-input-chat-error-color, #a12512);
}
.icon-container .error-icon md-icon::part(icon) {
  background-color: white;
  border-radius: 50%;
}

.header {
  display: flex;
  padding-bottom: 18px;
  justify-content: space-between;
}
.header .user-info {
  display: flex;
}
.header .user-info img {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}
.header .user-info md-label {
  margin-top: 4px;
}
.header .user-info .name {
  font-size: 16px;
  font-weight: 900;
  margin: 0 0 0 8px;
}
.header .close-icon {
  height: 30px;
}
.header .close-icon:focus,
.header .close-icon :focus-visible {
  outline: none;
}
.header .close-icon md-button {
  cursor: pointer;
}
.header .close-icon md-button::part(button) {
  position: relative;
  top: -5px;
  right: -5px;
}

.error-msg {
  height: 23px;
}
.error-msg .error-label {
  color: var(--md-input-chat-error-color);
  font-size: 12px;
  line-height: 125%;
  margin-top: 8px;
  margin-bottom: 8px;
}
.error-msg .error-label md-icon::part(icon) {
  font-size: 10px;
}
.error-msg .error-label .error {
  margin-bottom: 2px;
}

.webex-md-input::part(md-input-container) {
  margin-bottom: 0;
}
.webex-md-input::part(input) {
  border-bottom: none;
  background-color: var(--md-input-chat-bg-color);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: 8px 16px;
  max-height: 104px;
  height: 104px;
  font-size: 14px;
  line-height: 16px;
  color: var(--md-input-chat-color);
}
.webex-md-input::part(input):hover {
  background-color: var(--md-input-chat-bg-color);
}
.webex-md-input::part(input):focus {
  background-color: var(--md-input-chat-bg-color);
  border-color: var(--input-default-border-color, #ccc);
}

.webex-popup {
  padding: 16px;
  background-color: var(--md-input-bg-color);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/TeamPerformanceWidget/components/WebexChat.scss */
/*# sourceURL=WebexChat.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/WebexChat.ts":
/*!**********************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/WebexChat.ts ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WebexChat: () => (/* binding */ WebexChat)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../TeamPerformanceUtils */ "./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts");
/* harmony import */ var _utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils/WebexChat.utils */ "./src/components/TeamPerformanceWidget/utils/WebexChat.utils.ts");
/* harmony import */ var _WebexChat_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./WebexChat.scss */ "./src/components/TeamPerformanceWidget/components/WebexChat.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};







var WebexChat;
(function (WebexChat) {
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        constructor() {
            super(...arguments);
            this.isOpen = false;
            this.name = "";
            this.agentEmail = "";
            this.agentId = "";
            this.inputValue = "";
            this.error = "";
            this.isLoading = false;
            this.autoFocusEnabled = true;
            this.handleOnSend = () => __awaiter(this, void 0, void 0, function* () {
                if (this.inputValue !== "") {
                    this.isLoading = true;
                    const agentId = this.agentId;
                    let isWebExSendingMessageError = false;
                    this.updateActionCellValue({ isWebExSendingMessage: true, isWebExSendingMessageError, agentId });
                    this.closeOverlay();
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.WEBEX_CHAT_TPW_MESSAGE_SEND, {
                        agentEmail: this.agentEmail
                    });
                    const status = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.webex.sendMessage(this.agentEmail, this.inputValue);
                    if (status) {
                        this.error = "";
                        this.inputValue = "";
                        (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_5__.setPersistedText)(this.name, this.agentEmail, "");
                        (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_5__.setPersistedError)(this.name, this.agentEmail, false);
                    }
                    else {
                        this.error = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.webexChatTPWErrorMessage");
                        (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_5__.setPersistedError)(this.name, this.agentEmail, true);
                        isWebExSendingMessageError = true;
                    }
                    this.isLoading = false;
                    setTimeout(() => {
                        this.updateActionCellValue({ isWebExSendingMessage: false, isWebExSendingMessageError, agentId });
                    }, 0);
                }
            });
            this.returnFocusToChatIcon = () => {
                var _a;
                const tooltipElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-tooltip md-button");
                tooltipElement === null || tooltipElement === void 0 ? void 0 : tooltipElement.setAttribute("tabindex", "0");
                tooltipElement === null || tooltipElement === void 0 ? void 0 : tooltipElement.focus({ focusVisible: true });
            };
            this.handleOnCancel = () => {
                (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_5__.setPersistedText)(this.name, this.agentEmail, "");
                (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_5__.setPersistedError)(this.name, this.agentEmail, false);
                this.inputValue = "";
                this.error = "";
                this.updateActionCellValue({
                    isWebExSendingMessage: false,
                    isWebExSendingMessageError: false,
                    agentId: this.agentId
                });
                this.closeOverlay();
            };
            this.handleCloseIconClick = () => {
                this.closeOverlay();
            };
            this.handleInputChange = (event) => {
                this.inputValue = event.detail.value;
                (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_5__.setPersistedText)(this.name, this.agentEmail, event.detail.value);
            };
            this.handleKeyDown = (event) => {
                //stopPropagation() is called to fix keyboard actions(copying, cutting, selecting all) to prevent bubbling up the these keyboard events in the hierarchy.
                event.stopPropagation();
                if (event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Escape) {
                    this.handleCloseIconClick();
                    this.returnFocusToChatIcon();
                }
                else if (!event.shiftKey && (event.code === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Enter || event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Enter)) {
                    event.preventDefault();
                    this.handleOnSend();
                    this.returnFocusToChatIcon();
                }
            };
            // function to close webex chat popover on keyboard navigation of 'close' icon inside the popover.
            this.handleCloseIconKeydown = (event) => {
                var _a, _b, _c;
                event.preventDefault();
                event.stopPropagation();
                if (event.key === "Tab" && !event.shiftKey) {
                    this.focusInputField();
                }
                else if (event.shiftKey && event.key === "Tab") {
                    const discardIcon = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".discard-btn")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("button");
                    if (discardIcon) {
                        discardIcon === null || discardIcon === void 0 ? void 0 : discardIcon.focus();
                    }
                }
                else if (this.standardKeyCheck(event) || event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Escape) {
                    this.returnFocusToChatIcon();
                    event.preventDefault();
                    this.handleCloseIconClick();
                }
            };
            this.checkSendDisabled = (inputValue) => (inputValue === "" ? true : false);
            this.closeOverlay = () => {
                this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.HANDLE_WEBEX_CHAT_CLOSE_EVENT, {
                    composed: true,
                    bubbles: true
                }));
            };
            this.updateActionCellValue = (values) => {
                this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.UPDATE_ACTION_CELL_VALUE_EVENT, {
                    composed: true,
                    bubbles: true,
                    detail: Object.assign({}, values)
                }));
            };
        }
        static get styles() {
            return [_WebexChat_scss__WEBPACK_IMPORTED_MODULE_6__["default"]];
        }
        setAgentAvatarUrl() {
            this.agentAvatarUrl = (0,_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_4__.getAvatarUrlFromCache)(this.agentId);
        }
        connectedCallback() {
            super.connectedCallback();
            this.updatePersistedError();
            this.addCloseIconListener();
        }
        addCloseIconListener() {
            var _a;
            const closeIcon = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".close-icon");
            if (closeIcon && closeIcon.getAttribute("listener") !== "true") {
                closeIcon.addEventListener("keydown", this.handleCloseIconKeydown);
                closeIcon.setAttribute("listener", "true");
            }
        }
        updatePersistedError() {
            const isPersistedError = (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_5__.getPersistedError)(this.name, this.agentEmail);
            if (isPersistedError) {
                this.error = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.webexChatTPWErrorMessage");
            }
            else {
                this.error = "";
            }
        }
        update(changedProperties) {
            super.update(changedProperties);
            this.setAgentAvatarUrl();
            this.addCloseIconListener();
        }
        disconnectedCallback() {
            var _a, _b;
            (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".close-icon")) === null || _b === void 0 ? void 0 : _b.removeEventListener("keydown", this.handleCloseIconKeydown);
        }
        standardKeyCheck(event) {
            return event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Space || event.code === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Space || event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Enter || event.code === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Enter;
        }
        handleSendKeypress(event) {
            event.stopPropagation();
            if (this.standardKeyCheck(event)) {
                event.preventDefault();
                this.handleOnSend();
                this.returnFocusToChatIcon();
            }
            else if (event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Escape) {
                this.handleCloseIconClick();
                this.returnFocusToChatIcon();
            }
        }
        handleCancelKeypress(event) {
            var _a, _b, _c, _d, _e, _f, _g;
            event.preventDefault();
            event.stopPropagation();
            if (this.standardKeyCheck(event)) {
                this.handleOnCancel();
                this.returnFocusToChatIcon();
            }
            else if (event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Escape) {
                this.handleCloseIconClick();
                this.returnFocusToChatIcon();
            }
            else if (!(event === null || event === void 0 ? void 0 : event.shiftKey) && event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Tab) {
                const closeIconElement = (_d = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".close-icon")) === null || _b === void 0 ? void 0 : _b.querySelector("md-button")) === null || _c === void 0 ? void 0 : _c.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector("button");
                setTimeout(function () {
                    closeIconElement === null || closeIconElement === void 0 ? void 0 : closeIconElement.focus();
                }, 0);
            }
            else if (event.shiftKey && event.key === _constants__WEBPACK_IMPORTED_MODULE_0__.Key.Tab) {
                const sendButton = (_g = (_f = (_e = this.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector("md-button.send-btn")) === null || _f === void 0 ? void 0 : _f.shadowRoot) === null || _g === void 0 ? void 0 : _g.querySelector("button");
                if (sendButton) {
                    sendButton === null || sendButton === void 0 ? void 0 : sendButton.focus();
                }
                else {
                    this.focusInputField();
                }
            }
        }
        updated(_changedProperties) {
            super.updated(_changedProperties);
            if ((_changedProperties.has("agentEmail") || _changedProperties.has("isOpen")) && this.isOpen) {
                this.updatePersistedError();
                this.inputValue = (0,_utils_WebexChat_utils__WEBPACK_IMPORTED_MODULE_5__.getPersistedText)(this.name, this.agentEmail);
                setTimeout(() => {
                    this.focusInputField();
                }, 0);
            }
        }
        focusInputField() {
            var _a, _b, _c;
            const inputElement = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-input")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("textarea");
            inputElement === null || inputElement === void 0 ? void 0 : inputElement.focus();
        }
        handleInputBoxClicked(event) {
            event.stopPropagation();
        }
        render() {
            var _a;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="overlay-content webex-popup" role="dialog" aria-labelledby="webex-popup-title">
          <div class="header">
            <div class="user-info">
              <md-avatar
                title=${this.name}
                size=${28}
                src=${(_a = this.agentAvatarUrl) !== null && _a !== void 0 ? _a : ""}
                class="agent-avatar"
                aria-hidden="true"
              ></md-avatar>
              <md-label htmlFor="htmlId">
                <h3 id="webex-popup-title" class="name">${this.name}</h3>
              </md-label>
            </div>
            <div class="close-icon">
              <md-button
                variant="white"
                circle
                @button-click=${this.handleCloseIconClick}
                ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common.close")}
              >
                <md-icon slot="icon" name="icon-cancel_16"></md-icon>
              </md-button>
            </div>
          </div>
          <md-input
            tab-index="0"
            class="webex-md-input"
            value=${this.inputValue}
            @input-change=${this.handleInputChange}
            style="border-bottom: 0"
            ui-grid-row="5"
            maxLength="1000"
            multiline
            containerSize="small-12"
            autofocus
            @click=${this.handleInputBoxClicked}
            @keydown=${this.handleKeyDown}
            placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.webexChatPlaceHolder", "", { defaultValue: this.name })}
            ariaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.webexChatPlaceHolder", "", { defaultValue: this.name }) +
                (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.stringLengthText", "", { defaultValue: `${this.inputValue.length}` })}
          >
          </md-input>
          <div class="str-length">
            <md-label htmlFor="htmlId">
              <span class="length-label">${this.inputValue.length}/1000</span>
            </md-label>
          </div>
          <div class="error-msg">
            ${this.error &&
                (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
              <md-label>
                <span class="error-label">
                  <md-icon slot="icon" name="icon-error_12"></md-icon>
                  <span class="error">${this.error}</span></span
                >
              </md-label>
            `}
          </div>
          <div class="action-container">
            <md-button
              @button-click=${this.handleOnSend}
              @keydown="${(event) => {
                this.handleSendKeypress(event);
            }}"
              ?disabled=${this.checkSendDisabled(this.inputValue)}
              class="${this.inputValue === "" ? "send-disabled" : "send-btn"}"
              color="blue"
            >
              <span slot="text">
                ${this.error ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.webexChatReSend") : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.webexChatSend")}</span
              >
            </md-button>
            <md-button
              @button-click=${this.handleOnCancel}
              class="discard-btn"
              variant="secondary"
              @keydown="${(event) => {
                this.handleCancelKeypress(event);
            }}"
            >
              <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:notifications.webexChatDiscard")}</span>
            </md-button>
          </div>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean, attribute: "is-open" })
    ], Element.prototype, "isOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "name", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "agentEmail", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "agentId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "inputValue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "error", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "agentAvatarUrl", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "autoFocusEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "tooltipElement", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("webex-chat")
    ], Element);
    WebexChat.Element = Element;
})(WebexChat || (WebexChat = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/agentStateSelector/agentStateSelectorInfinite/index.ts":
/*!****************************************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/agentStateSelector/agentStateSelectorInfinite/index.ts ***!
  \****************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TPWAgentStateSelector: () => (/* binding */ TPWAgentStateSelector)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/utils/WindowListenersHub */ "./src/utils/WindowListenersHub.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _list__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../list */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/list.ts");
/* harmony import */ var _scss_main_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../scss/main.scss */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/main.scss");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../utils */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/utils/index.ts");
/* harmony import */ var _listError__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./listError */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/agentStateSelectorInfinite/listError.ts");
/* harmony import */ var _Common_SearchInput_searchInput__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../../Common/SearchInput/searchInput */ "./src/components/Common/SearchInput/searchInput.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};












var TPWAgentStateSelector;
(function (TPWAgentStateSelector) {
    /**
     * @element agentx-wc-tpw-agent-state-selector-infinite
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_5__.LitElement) {
        constructor() {
            super(...arguments);
            this.isWxccCoreDisallowPendingLogoutStateChangeEnabled = false;
            this.agentId = "";
            this.orgId = "";
            this.isOpen = false;
            this.items = [];
            this.searchQuery = "";
            this.searchMode = false;
            this.searchErrorForMinLength = false;
            this.currentPage = 0;
            this.totalRecords = 0;
            this.isPageLoading = false;
            this.isSearchPageLoading = false;
            this.pageFetchError = {
                isError: false,
                trackingId: ""
            };
            this.focusInputField = () => {
                var _a, _b, _c, _d;
                const inputElement = (_d = (_c = (_b = (_a = this.searchHandler) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("md-input")) === null || _c === void 0 ? void 0 : _c.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector("input");
                inputElement === null || inputElement === void 0 ? void 0 : inputElement.focus();
            };
            this.onStateSelectorOpen = () => __awaiter(this, void 0, void 0, function* () {
                this.loadNextPage();
                setTimeout(() => {
                    this.focusInputField();
                }, 0);
            });
            this.updateActionCellValue = (values) => {
                this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.UPDATE_ACTION_CELL_VALUE_EVENT, {
                    composed: true,
                    bubbles: true,
                    detail: Object.assign({}, values)
                }));
            };
            this.closeOverlay = () => {
                this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.STATE_CHANGE_OVERLAY_CLOSE_EVENT, {
                    composed: true,
                    bubbles: true
                }));
            };
            this.handleListItemChange = (event) => __awaiter(this, void 0, void 0, function* () {
                // agentStateChanging Flag is used to show the spinner on action cell component
                const agentId = this.agentId;
                this.updateActionCellValue({ agentStateChanging: true, agentId });
                this.closeOverlay();
                try {
                    const selectedValue = this.getSelectedAgentIdleCode(event.detail.selected[0]);
                    if (this.agentId) {
                        const payload = {
                            state: selectedValue.id === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_ID ? _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE : _constants__WEBPACK_IMPORTED_MODULE_0__.IDLE,
                            auxCodeId: selectedValue.id === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_ID ? " " : selectedValue.id,
                            lastStateChangeReason: "",
                            agentId: this.agentId
                        };
                        yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.aqm.supervisor.changeAgentState({ orgId: this.orgId, data: payload });
                        _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info(`[TPWAgentStateSelector] Agent state change success request}`);
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.AGENT_STATE_CHANGE, {
                            ChangedBy: _constants__WEBPACK_IMPORTED_MODULE_0__.SUPERVISOR,
                            CurrentState: selectedValue.name,
                            Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS
                        });
                        this.updateActionCellValue({
                            agentId,
                            agentStateChanging: false,
                            agentStateChangeError: false
                        });
                    }
                }
                catch (error) {
                    this.handleAgentStateChangeError(error, agentId);
                }
            });
            this.getFormattedIdleCodes = (item) => {
                return {
                    name: item.name,
                    id: item.id,
                    index: item.index,
                    ariaLabel: item.name,
                    template: (data) => {
                        return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `<agent-state-selector-list
            .isOpen=${this.isOpen}
            .agentStateOption=${data}
            .searchTerm="${this.searchQuery}"
          ></agent-state-selector-list>`;
                    }
                };
            };
            this.setLoadingState = (isSearchInitiatedNextPage, state) => {
                this.isPageLoading = state;
                if (isSearchInitiatedNextPage) {
                    this.isSearchPageLoading = state;
                }
            };
            this.setItems = (newItems, totalRecords, isSearchInitiatedNextPage) => {
                let availableRecordCount = 0;
                if (isSearchInitiatedNextPage) {
                    this.items = [];
                    this.totalRecords = 0;
                    this.currentPage = 0;
                }
                if (this.currentPage === 0 && (!this.searchQuery || (0,_utils__WEBPACK_IMPORTED_MODULE_9__.checkIfSearchMatchesAvailable)(this.searchQuery || ""))) {
                    const defaultItem = this.getFormattedIdleCodes((0,_utils__WEBPACK_IMPORTED_MODULE_9__.getDefaultAvailableIdleCode)((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.stateChange.available")));
                    this.items = [defaultItem];
                    availableRecordCount = 1;
                }
                if (!this.searchQuery) {
                    availableRecordCount = 1;
                }
                this.items = [...this.items, ...newItems];
                this.totalRecords = totalRecords + availableRecordCount;
                this.currentPage += 1;
            };
            this.loadNextPage = (event, isSearchInitiatedNextPage = false) => __awaiter(this, void 0, void 0, function* () {
                // Load more items
                if (this.isOpen === false) {
                    return;
                }
                try {
                    this.setLoadingState(isSearchInitiatedNextPage, true);
                    const { formattedListItems, totalRecords } = yield this.getListItems(this.currentPage, this.searchQuery);
                    if (this.isOpen && (this.searchMode || !this.searchErrorForMinLength)) {
                        this.setItems(formattedListItems, totalRecords, isSearchInitiatedNextPage);
                    }
                    this.setLoadingState(isSearchInitiatedNextPage, false);
                    this.pageFetchError = {
                        isError: false,
                        trackingId: ""
                    };
                }
                catch (error) {
                    this.setLoadingState(isSearchInitiatedNextPage, false);
                    this.pageFetchError = {
                        isError: true,
                        trackingId: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject)(error) : ""
                    };
                    _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("event=loadNextPage | Error on fetching idle codes on Team Performance Widget Agent State Change Module", error);
                }
                finally {
                    this.setLoadingState(isSearchInitiatedNextPage, false);
                }
            });
            this.handleInputKeyDown = (event) => {
                if (event.detail.srcEvent) {
                    const { srcEvent } = event.detail;
                    if (srcEvent.key === "Tab" && srcEvent.shiftKey) {
                        event.detail.srcEvent.preventDefault();
                        // Focus to the md-advance-list-container
                        this.focusListComponent();
                    }
                }
            };
            this.getReasonAndReasonCodeFromErrorObject = (errorObj) => {
                var _a, _b, _c, _d;
                const reason = ((_b = (_a = errorObj === null || errorObj === void 0 ? void 0 : errorObj.details) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.reason) || "";
                const reasonCode = ((_d = (_c = errorObj === null || errorObj === void 0 ? void 0 : errorObj.details) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.reasonCode) || "";
                return [reason, reasonCode];
            };
        }
        static get styles() {
            return _scss_main_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            if ((changedProperties.has("agentId") || changedProperties.has("isOpen")) && this.isOpen) {
                this.onStateSelectorOpen();
            }
            if (changedProperties.has("isOpen") && this.isOpen === false) {
                this.searchQuery = "";
                this.items = [];
                this.isPageLoading = false;
                this.currentPage = 0;
                this.totalRecords = 0;
                this.searchMode = false;
                this.searchErrorForMinLength = false;
                this.isSearchPageLoading = false;
                this.pageFetchError = {
                    isError: false,
                    trackingId: ""
                };
            }
        }
        getSelectedAgentIdleCodeId(filteredStateList) {
            const selectedIdleCodeId = filteredStateList === null || filteredStateList === void 0 ? void 0 : filteredStateList.find((stateOption) => {
                var _a;
                return stateOption.name === ((_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.agentState);
            });
            return (selectedIdleCodeId === null || selectedIdleCodeId === void 0 ? void 0 : selectedIdleCodeId.id) || "";
        }
        getSelectedAgentIdleCode(idleCodeId) {
            var _a;
            return (_a = this.items) === null || _a === void 0 ? void 0 : _a.find((stateOption) => {
                return stateOption.id === idleCodeId;
            });
        }
        handleAgentStateChangeError(error, agentId) {
            _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error(`event=agentStateChangeFailed | Tracking ID: ${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject)(error) : ""} | Updating agent state from team performance widget is failed : ${error}`, error);
            const [reason, reasonCode] = this.getReasonAndReasonCodeFromErrorObject(error);
            let message = "";
            if (this.isWxccCoreDisallowPendingLogoutStateChangeEnabled &&
                reason === _constants__WEBPACK_IMPORTED_MODULE_0__.STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON &&
                reasonCode === _constants__WEBPACK_IMPORTED_MODULE_0__.STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON_CODE) {
                message = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("tpw.stateChange.errorStateChangeInPendingLogout");
            }
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.AGENT_STATE_CHANGE, {
                ChangedBy: _constants__WEBPACK_IMPORTED_MODULE_0__.SUPERVISOR,
                Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED
            });
            this.updateActionCellValue({ agentId, agentStateChanging: false, agentStateChangeError: true });
            const failedEvent = new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.AGENT_STATE_CHANGE_FAILED, {
                detail: Object.assign(Object.assign({}, (this.isWxccCoreDisallowPendingLogoutStateChangeEnabled && { message: message || "" })), { trackingId: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject)(error) : null }),
                bubbles: true,
                composed: true
            });
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__.WINDOW_LISTENERS_HUB.dispatch(failedEvent);
        }
        getListItems(page, searchQuery = "") {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield (0,_utils__WEBPACK_IMPORTED_MODULE_9__.fetchItems)(this.orgId, this.agentId, page, searchQuery);
                    const formattedListItems = response.data.map((item) => this.getFormattedIdleCodes(item));
                    return { formattedListItems, totalRecords: response.meta.totalRecords };
                }
                catch (error) {
                    _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("event=getListItems | Error on fetching idle codes on Team Performance Widget Agent State Change Module", error);
                    throw error;
                }
            });
        }
        getStatusIndicator() {
            if (this.isPageLoading && this.items.length > 0) {
                return [
                    {
                        id: "status-indicator",
                        name: "loading",
                        template: () => (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `<div class="infinite-scroll-spinner" part="spinner"><md-spinner size="18"></md-spinner></div>`
                    }
                ];
            }
            if (this.pageFetchError.isError && this.items.length > 0) {
                return [
                    {
                        id: "status-indicator",
                        name: "error",
                        template: () => (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `<agent-state-selector-list-error
                class="fetch-error"
                style="color: red;"
                trackingId="${this.pageFetchError.trackingId}"
                @error-retry="${this.loadNextPage}"
              >
              </agent-state-selector-list-error>`
                    }
                ];
            }
            return [];
        }
        getSelectedIdleCodeItem() {
            var _a, _b;
            const selectedItem = (_b = (_a = this.listElement) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.default-wrapper[selected="true"]');
            return selectedItem;
        }
        focusListComponent() {
            var _a, _b;
            const selectedItem = this.getSelectedIdleCodeItem();
            if (selectedItem) {
                selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.focus();
            }
            else {
                const currentSelectedItem = (_b = (_a = this.listElement) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector(".md-advance-list-wrapper");
                currentSelectedItem === null || currentSelectedItem === void 0 ? void 0 : currentSelectedItem.focus();
            }
        }
        handleListKeyDown(event) {
            var _a, _b;
            if (event.key === "Tab" && !event.shiftKey) {
                const wrappers = Array.from(((_b = (_a = this.listElement) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelectorAll(".default-wrapper")) || []);
                const eventPath = event.composedPath();
                const fromListItem = wrappers.find((wrapper) => eventPath.includes(wrapper));
                if (fromListItem) {
                    event === null || event === void 0 ? void 0 : event.preventDefault();
                    // if on a list item focus on the input field
                    this.focusInputField();
                }
                else {
                    const selectedItem = this.getSelectedIdleCodeItem();
                    if (!selectedItem) {
                        event === null || event === void 0 ? void 0 : event.preventDefault();
                        this.focusInputField();
                    }
                }
            }
        }
        resetStates() {
            this.items = [];
            this.currentPage = 0;
            this.totalRecords = 0;
            this.pageFetchError = {
                isError: false,
                trackingId: ""
            };
        }
        renderState() {
            if (this.items.length === 0) {
                if (this.isPageLoading && (this.searchMode || !this.searchErrorForMinLength)) {
                    return (0,_utils__WEBPACK_IMPORTED_MODULE_9__.renderLoadingState)();
                }
                if (this.pageFetchError.isError) {
                    return (0,_utils__WEBPACK_IMPORTED_MODULE_9__.renderErrorState)((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorDetail:errorTitle"), (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorDetail:reloadButton"), this.onStateSelectorOpen);
                }
                if (this.searchErrorForMinLength) {
                    return (0,_utils__WEBPACK_IMPORTED_MODULE_9__.renderSearchError)((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.stateChange.searchError"));
                }
                if (this.searchMode) {
                    return (0,_utils__WEBPACK_IMPORTED_MODULE_9__.renderNoMatchFound)((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common:nomatchfound"));
                }
            }
            return lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing;
        }
        handleSearchCleared(event) {
            // Perform search without any search term
            this.resetStates();
            this.searchErrorForMinLength = false;
            this.searchMode = false;
            this.searchQuery = event.detail;
            this.loadNextPage(undefined, true);
        }
        handleSearchTooShort(event) {
            // Handle case when search term is less than 3 characters
            this.searchQuery = event.detail;
            this.resetStates();
            this.searchErrorForMinLength = true;
            this.searchMode = false;
        }
        handleSearchTermValid(event) {
            // Perform search with the valid search term
            this.resetStates();
            this.searchMode = true;
            this.searchErrorForMinLength = false;
            this.searchQuery = event.detail;
            this.loadNextPage(undefined, true);
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) ` <div class="tpw-agent-status">
        <search-input
          .isPageLoading=${this.isPageLoading}
          .isSearchPageLoading=${this.isSearchPageLoading}
          .reset=${this.isOpen}
          @input-keydown="${this.handleInputKeyDown}"
          @search-cleared="${this.handleSearchCleared}"
          @search-too-short="${this.handleSearchTooShort}"
          @search-term-valid="${this.handleSearchTermValid}"
        >
        </search-input>
        ${this.renderState()}
        ${this.isOpen
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
              <md-advance-list
                .items=${this.items.concat(this.getStatusIndicator())}
                .isLoading=${this.isPageLoading}
                .isError=${this.pageFetchError.isError}
                .value=${[this.getSelectedAgentIdleCodeId(this.items)]}
                containerHeight=${(0,_utils__WEBPACK_IMPORTED_MODULE_9__.getDynamicHeight)(this.items.length)}
                ariaRoleList="listbox"
                ariaLabelList="state selector"
                totalRecords=${this.totalRecords}
                @list-item-change=${this.handleListItemChange}
                @load-more=${this.loadNextPage}
                @keydown=${this.handleListKeyDown}
              >
              </md-advance-list>
            `
                : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
      </div>`;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ reflect: false, type: Boolean })
    ], Element.prototype, "isWxccCoreDisallowPendingLogoutStateChangeEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ reflect: true })
    ], Element.prototype, "agentId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ reflect: true })
    ], Element.prototype, "orgId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
    ], Element.prototype, "selectedAgentDetails", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ reflect: true, type: Boolean })
    ], Element.prototype, "isOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "items", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "searchQuery", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "searchMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "searchErrorForMinLength", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "currentPage", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "totalRecords", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isPageLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isSearchPageLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "pageFetchError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)("md-advance-list")
    ], Element.prototype, "listElement", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)("search-input")
    ], Element.prototype, "searchHandler", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-tpw-agent-state-selector-infinite")
    ], Element);
    TPWAgentStateSelector.Element = Element;
})(TPWAgentStateSelector || (TPWAgentStateSelector = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/agentStateSelector/agentStateSelectorInfinite/listError.ts":
/*!********************************************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/agentStateSelector/agentStateSelectorInfinite/listError.ts ***!
  \********************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChangeStateSelectorListError: () => (/* binding */ ChangeStateSelectorListError)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _scss_listError_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../scss/listError.scss */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/listError.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var ChangeStateSelectorListError;
(function (ChangeStateSelectorListError) {
    /**
     * @element agent-state-selector-list
     * also used in  agentx-wc-teams-list-infinite for error handling
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.trackingId = "";
        }
        static get styles() {
            return _scss_listError_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
        }
        onRetry(event) {
            event.stopPropagation();
            this.dispatchEvent(new CustomEvent("error-retry", {
                detail: {},
                bubbles: true,
                composed: true
            }));
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div>
          <md-help-text messageType="error" class="infinite-scroll-error" style="{style}" aria-live="polite">
            <div class="error-block">
              <span>
                <span class="error-span-padding">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.loadFail")}</span>
                <md-link
                  inline
                  class="infinite-scroll-retry-link"
                  aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.tryAgain")}
                  @click="${this.onRetry}"
                  @keydown="${this.onRetry}"
                  tag="span"
                  data-testid="retry-page"
                >
                  ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:commonWebComp.tryAgain")}
                </md-link>
              </span>
              ${this.trackingId && this.trackingId !== ""
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<span class="tracking-error-block"
                    >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorModal.trackingIdLabel")} ${this.trackingId}</span
                  >`
                : null}
            </div>
          </md-help-text>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], Element.prototype, "trackingId", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agent-state-selector-list-error")
    ], Element);
    ChangeStateSelectorListError.Element = Element;
})(ChangeStateSelectorListError || (ChangeStateSelectorListError = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/agentStateSelector/index.ts":
/*!*************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/agentStateSelector/index.ts ***!
  \*************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentChangeStateSelector: () => (/* binding */ AgentChangeStateSelector)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/utils/WindowListenersHub */ "./src/utils/WindowListenersHub.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _list__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./list */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/list.ts");
/* harmony import */ var _scss_main_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./scss/main.scss */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/main.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};










var AgentChangeStateSelector;
(function (AgentChangeStateSelector) {
    /**
     * @element agentx-wc-tpw-agent-state-selector
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_5__.LitElement) {
        constructor() {
            super(...arguments);
            this.isWxccCoreDisallowPendingLogoutStateChangeEnabled = false;
            this.agentId = "";
            this.orgId = "";
            this.isOpen = false;
            this.orgIdleCodes = { isFetchingSuccess: false, data: [] };
            this.searchTerm = "";
            this.isHighlightedItem = -1;
            this.selectedState = "";
            this.selectedIndex = 0;
            this.isLoading = false;
            this.isFetchError = false;
            this.list = [];
            this.filteredStateList = [];
            this.fetchOrganizationIdleCodes = () => __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.abs.fetchIdleCodes({ orgId: this.orgId, accessType: "ALL" });
                    const events = new CustomEvent("update-org-idle-codes", {
                        detail: { isFetchingSuccess: true, response },
                        bubbles: true,
                        composed: true
                    });
                    _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__.WINDOW_LISTENERS_HUB.dispatch(events);
                    _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info(`event=fetchOrganizationIdleCodes | Successfully fetched organization idle codes on Team Performance Widget`);
                    return response;
                }
                catch (error) {
                    _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("event=fetchOrganizationIdleCodes | Error on fetching organization idle codes on Team Performance Widget Agent State Change Module", error);
                    throw error;
                }
            });
            this.stateSelectorOpened = () => __awaiter(this, void 0, void 0, function* () {
                var _a;
                this.isLoading = true;
                try {
                    let idleCodes = [];
                    if (!this.orgIdleCodes.isFetchingSuccess) {
                        // Fetch the org idle codes in this component.
                        idleCodes = yield this.fetchOrganizationIdleCodes();
                    }
                    else {
                        idleCodes = (_a = this.orgIdleCodes.data) !== null && _a !== void 0 ? _a : [];
                    }
                    const { idleCodes: agentIdleCodes, accessIdleCode } = yield this.fetchAgentIdleCodes(this.orgId, this.agentId);
                    const defaultAvailableIdleCode = [
                        {
                            name: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.stateChange.available"),
                            id: _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_ID,
                            isDefault: false,
                            isSystem: false
                        }
                    ];
                    let visibleStates = []; // Variable for update the idle code list from the API.
                    if (agentIdleCodes.length === 0 && accessIdleCode === _constants__WEBPACK_IMPORTED_MODULE_0__.ACCESS_IDLE_CODES.ALL) {
                        visibleStates.push(...idleCodes.filter((agentStateOption) => agentStateOption.isSystem === false));
                    }
                    else {
                        for (const code of agentIdleCodes) {
                            const agentIdleCode = idleCodes.find((agentStateOption) => agentStateOption.id === code);
                            if (agentIdleCode && agentIdleCode.isSystem === false) {
                                visibleStates.push(agentIdleCode);
                            }
                        }
                    }
                    if (visibleStates.length > 0) {
                        // sorting the list
                        visibleStates = visibleStates.sort((a, b) => a.name.localeCompare(b.name));
                    }
                    // Keep the "Available" state at the top of the list after the sorting API response.
                    const idleCodesList = [...defaultAvailableIdleCode, ...visibleStates];
                    this.list = idleCodesList;
                    this.filteredStateList = idleCodesList;
                    this.getSelectedAgentId(this.filteredStateList);
                    this.isFetchError = false;
                    setTimeout(() => {
                        this.focusInputField();
                    }, 0);
                }
                catch (_b) {
                    this.isFetchError = true;
                    setTimeout(() => {
                        this.focusRetryButton();
                    }, 0);
                }
                finally {
                    this.isLoading = false;
                }
            });
            this.focusInputField = () => {
                var _a, _b, _c;
                const inputElement = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-input")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("input");
                inputElement === null || inputElement === void 0 ? void 0 : inputElement.focus();
            };
            this.focusRetryButton = () => {
                var _a, _b, _c;
                const buttonElement = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById("reload-btn")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("button");
                buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.focus();
            };
            // The function is used to attach tab press event to the clear input button
            this.focusWhenClearInputButtonTabPress = () => {
                var _a, _b, _c, _d, _e, _f;
                const clearButton = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-input")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("md-button");
                const inputElement = (_f = (_e = (_d = this.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector("md-input")) === null || _e === void 0 ? void 0 : _e.shadowRoot) === null || _f === void 0 ? void 0 : _f.querySelector("input");
                const listItem = this.listElement.querySelector("md-list-item");
                // Determine the element that should receive focus
                const focusElement = listItem || inputElement;
                clearButton === null || clearButton === void 0 ? void 0 : clearButton.addEventListener("keydown", (event) => {
                    if (event.key === "Tab") {
                        setTimeout(() => {
                            focusElement === null || focusElement === void 0 ? void 0 : focusElement.focus();
                        }, 0);
                    }
                });
            };
            this.setFilteredStateList = () => {
                if (this.searchTerm === "") {
                    this.filteredStateList = this.list;
                    // No item should be highlighted when it shows all states
                    this.isHighlightedItem = -1;
                    this.getSelectedAgentId(this.filteredStateList);
                }
                else {
                    const filterStateList = this.list.filter((status) => status.name.toLowerCase().includes(this.searchTerm.toLowerCase()));
                    const isSelectedReasonPresent = filterStateList === null || filterStateList === void 0 ? void 0 : filterStateList.filter((status) => this.selectedState === status.name);
                    if ((isSelectedReasonPresent === null || isSelectedReasonPresent === void 0 ? void 0 : isSelectedReasonPresent.length) < 1) {
                        this.selectedIndex = -1;
                    }
                    this.filteredStateList = filterStateList;
                    // As soon as list is filtered, first item should be highlighted
                    this.isHighlightedItem = 0;
                }
            };
            this.handleSearch = (event) => {
                this.searchTerm = event.target.value;
                this.setFilteredStateList();
                // The function is used to attach tab press event to the clear input button when search is done
                setTimeout(() => {
                    this.focusWhenClearInputButtonTabPress();
                }, 0);
            };
            this.updateActionCellValue = (values) => {
                this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.UPDATE_ACTION_CELL_VALUE_EVENT, {
                    composed: true,
                    bubbles: true,
                    detail: Object.assign({}, values)
                }));
            };
            this.closeOverlay = () => {
                this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.STATE_CHANGE_OVERLAY_CLOSE_EVENT, {
                    composed: true,
                    bubbles: true
                }));
            };
            this.handleSelectValue = (event) => __awaiter(this, void 0, void 0, function* () {
                // agentStateChanging Flag is used to show the spinner on action cell component
                const agentId = this.agentId;
                this.updateActionCellValue({ agentStateChanging: true, agentId });
                this.closeOverlay();
                try {
                    const selectedValue = this.filteredStateList[event.detail.selected];
                    if (this.agentId) {
                        const payload = {
                            state: selectedValue.id === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_ID ? _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE : _constants__WEBPACK_IMPORTED_MODULE_0__.IDLE,
                            auxCodeId: selectedValue.id === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_ID ? " " : selectedValue.id,
                            lastStateChangeReason: "",
                            agentId: this.agentId
                        };
                        yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.aqm.supervisor.changeAgentState({ orgId: this.orgId, data: payload });
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.AGENT_STATE_CHANGE, {
                            ChangedBy: _constants__WEBPACK_IMPORTED_MODULE_0__.SUPERVISOR,
                            CurrentState: selectedValue.name,
                            Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS
                        });
                        this.updateActionCellValue({
                            agentId,
                            agentStateChanging: false,
                            agentStateChangeError: false
                        });
                    }
                }
                catch (error) {
                    _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error(`event=agentStateChangeFailed | Tracking ID: ${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject)(error) : ""} | Updating agent state from team performance widget is failed : ${error}`, error);
                    const [reason, reasonCode] = this.getReasonAndReasonCodeFromErrorObject(error);
                    let message = "";
                    if (this.isWxccCoreDisallowPendingLogoutStateChangeEnabled &&
                        reason === _constants__WEBPACK_IMPORTED_MODULE_0__.STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON &&
                        reasonCode === _constants__WEBPACK_IMPORTED_MODULE_0__.STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON_CODE) {
                        message = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("tpw.stateChange.errorStateChangeInPendingLogout");
                    }
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.AGENT_STATE_CHANGE, {
                        ChangedBy: _constants__WEBPACK_IMPORTED_MODULE_0__.SUPERVISOR,
                        Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED
                    });
                    this.updateActionCellValue({
                        agentId,
                        agentStateChanging: false,
                        agentStateChangeError: true
                    });
                    // Dispatch the event to show the error notification for agent state change failures.
                    const failedEvent = new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.AGENT_STATE_CHANGE_FAILED, {
                        detail: Object.assign(Object.assign({}, (this.isWxccCoreDisallowPendingLogoutStateChangeEnabled && { message: message || "" })), { trackingId: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.getTrackingIdFromErrorObject)(error) : null }),
                        bubbles: true,
                        composed: true
                    });
                    _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__.WINDOW_LISTENERS_HUB.dispatch(failedEvent);
                }
            });
            this.renderStatesList = () => {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <md-list
          class="menu-list state-selector-list"
          role="listbox"
          selected="${this.selectedIndex}"
          activated="${this.selectedIndex}"
          roving-prevent-focus="false"
          @list-item-change="${this.handleSelectValue}"
          @keydown="${this.handleListkeyDown}"
          label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.agentStateSelector")}
        >
          ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_7__.repeat)(this.filteredStateList, (agentStateOption, index) => (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
              <md-list-item
                slot="list-item"
                role="option"
                class="status-menu-item ${this.isHighlightedItem === index ? "state-item-highlight" : ""}"
                aria-label="${agentStateOption.name}"
                aria-selected="${this.selectedIndex === index}"
              >
                <agent-state-selector-list
                  .isOpen=${this.isOpen}
                  .agentStateOption=${agentStateOption}
                  .searchTerm="${this.searchTerm}"
                ></agent-state-selector-list>
              </md-list-item>
            `)}
        </md-list>
      `;
            };
            this.getReasonAndReasonCodeFromErrorObject = (errorObj) => {
                var _a, _b, _c, _d;
                const reason = ((_b = (_a = errorObj === null || errorObj === void 0 ? void 0 : errorObj.details) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.reason) || "";
                const reasonCode = ((_d = (_c = errorObj === null || errorObj === void 0 ? void 0 : errorObj.details) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.reasonCode) || "";
                return [reason, reasonCode];
            };
            this.handleListkeyDown = (event) => {
                event === null || event === void 0 ? void 0 : event.preventDefault();
                if ((event === null || event === void 0 ? void 0 : event.key) === "Tab") {
                    this.focusInputField();
                }
            };
            this.handleInputFocus = () => {
                if (this.listElement) {
                    this.listElement.setAttribute("roving-prevent-focus", "false");
                }
            };
            this.handleInputBlur = () => {
                if (this.listElement) {
                    this.listElement.removeAttribute("roving-prevent-focus");
                }
            };
            this.handleInputKeyDown = (event) => {
                if (event.detail.srcEvent) {
                    const { srcEvent } = event.detail;
                    if (srcEvent.key === "Tab" && srcEvent.shiftKey) {
                        event.detail.srcEvent.preventDefault();
                        // Focus to the md-list
                        const currentSelectedItem = this.listElement.querySelector("md-list-item[selected]");
                        if (currentSelectedItem) {
                            currentSelectedItem === null || currentSelectedItem === void 0 ? void 0 : currentSelectedItem.focus();
                        }
                    }
                }
            };
        }
        static get styles() {
            return _scss_main_scss__WEBPACK_IMPORTED_MODULE_9__["default"];
        }
        getSelectedAgentId(filteredStateList) {
            this.selectedIndex = filteredStateList.findIndex((stateOption) => { var _a; return stateOption.name === ((_a = this.selectedAgentDetails) === null || _a === void 0 ? void 0 : _a.agentState); });
            this.selectedIndex = this.selectedIndex === -1 ? 0 : this.selectedIndex;
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            if ((changedProperties.has("agentId") || changedProperties.has("isOpen")) && this.isOpen) {
                this.stateSelectorOpened();
            }
            if (changedProperties.has("isLoading")) {
                window.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_0__.TPW_AGENT_STATE_SELECTOR_LOADING_CHANGED, {
                    detail: { isLoading: this.isLoading },
                    bubbles: true,
                    composed: true
                }));
            }
            if (changedProperties.has("isOpen") && this.isOpen === false) {
                this.searchTerm = "";
                this.filteredStateList = [];
                this.isHighlightedItem = -1;
                this.selectedState = "";
                this.selectedIndex = 0;
                this.list = [];
                this.isLoading = false;
            }
        }
        fetchAgentIdleCodes(orgId = "", agentId = "") {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.abs.fetchAgentIdleCodes({ orgId, agentId });
                return { idleCodes: response.idleCodes, accessIdleCode: response.accessIdleCode };
            });
        }
        connectedCallback() {
            var _a;
            super.connectedCallback();
            if (!((_a = this.orgIdleCodes) === null || _a === void 0 ? void 0 : _a.isFetchingSuccess)) {
                this.fetchOrganizationIdleCodes();
            }
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="tpw-agent-status ${!this.isLoading ? "suppress-loading" : ""}">
          ${!this.isLoading && this.list.length > 0
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                <div class="state-input-wrapper">
                  <md-input
                    id="pillSearchInput"
                    searchable
                    newMomentum
                    placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.search")}
                    clear
                    clearAriaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common:clear")}"
                    containerSize="medium-10"
                    htmlId="pillSearchInput"
                    name="pillSearchInput"
                    value="${this.searchTerm}"
                    type="text"
                    autoFocus
                    @input-change="${this.handleSearch}"
                    @input-focus="${this.handleInputFocus}"
                    @input-blur="${this.handleInputBlur}"
                    @input-keydown="${this.handleInputKeyDown}"
                  ></md-input>
                </div>
                ${this.renderStatesList()}
              `
                : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
          ${this.isLoading ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) ` <div class="state-loading"><md-spinner size="16"></md-spinner></div> ` : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
          ${!this.isLoading && (!this.filteredStateList || this.filteredStateList.length === 0) && this.list.length > 0
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                <div class="state-no-match">
                  <agentx-wc-empty-state-wrapper
                    class="empty-state-wrapper"
                    illustration-type="empty-result"
                  ></agentx-wc-empty-state-wrapper>
                  <span class="empty-title">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:common:nomatchfound")}</span>
                </div>
              `
                : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
          ${!this.isLoading && this.isFetchError
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                <div class="state-error">
                  <agentx-wc-empty-state-wrapper
                    class="error-cloud-wrapper"
                    illustration-type="error-cloud"
                  ></agentx-wc-empty-state-wrapper>
                  <div class="error-container">
                    <p class="error-title">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorDetail:errorTitle")}</p>
                  </div>
                  <md-button @click=${() => this.stateSelectorOpened()} id="reload-btn" color="blue">
                    <span slot="text">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:errorDetail:reloadButton")}</span>
                  </md-button>
                </div>
              `
                : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ reflect: false, type: Boolean })
    ], Element.prototype, "isWxccCoreDisallowPendingLogoutStateChangeEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ reflect: true })
    ], Element.prototype, "agentId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ reflect: true })
    ], Element.prototype, "orgId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
    ], Element.prototype, "selectedAgentDetails", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ reflect: true, type: Boolean })
    ], Element.prototype, "isOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
    ], Element.prototype, "orgIdleCodes", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "searchTerm", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isHighlightedItem", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "selectedState", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "selectedIndex", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isFetchError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "list", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "filteredStateList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)("md-list")
    ], Element.prototype, "listElement", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-tpw-agent-state-selector")
    ], Element);
    AgentChangeStateSelector.Element = Element;
})(AgentChangeStateSelector || (AgentChangeStateSelector = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/agentStateSelector/list.ts":
/*!************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/agentStateSelector/list.ts ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChangeStateSelectorList: () => (/* binding */ ChangeStateSelectorList)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _scss_list_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./scss/list.scss */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/list.scss");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./utils */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/utils/index.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var ChangeStateSelectorList;
(function (ChangeStateSelectorList) {
    /**
     * @element agent-state-selector-list
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.isOpen = false;
            this.agentStateOption = {
                name: "",
                isSystem: false,
                isDefault: false,
                id: "0"
            };
            this.searchTerm = "";
            this.isTextOverflow = true;
            this.HighlightText = (text = "", highlight = "") => {
                if (!highlight.trim()) {
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <span>${text}</span> `;
                }
                const regex = new RegExp(`(${(0,_utils__WEBPACK_IMPORTED_MODULE_4__.escapeRegExp)(highlight)})`, "gi");
                const parts = text.split(regex);
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <span class="highlight-span">
          ${parts
                    .filter((part) => part)
                    .map((part) => 
                // prettier-ignore
                regex.test(part)
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<b>${part}</b>`
                    : (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<span>${part}</span>`)}
        </span>
      `;
            };
            this.presenceIcon = (isAvailable) => {
                if (_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_5__.themeManager.isMomentumAvatarEnabled) {
                    const iconName = isAvailable ? "active-presence-small-filled" : "recents-presence-badge-filled";
                    const iconClass = isAvailable ? "available-indicator new-momentum" : "default-indicator new-momentum";
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<md-icon name="${iconName}" size="16" iconSet="momentumDesign" class=${iconClass}></md-icon>`;
                }
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `${(0,_utils__WEBPACK_IMPORTED_MODULE_4__.stateIndicator)(this.agentStateOption.id === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_ID ? _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE : this.agentStateOption.name)}`;
            };
        }
        static get styles() {
            return _scss_list_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            if (changedProperties.has("isOpen") && this.isOpen) {
                setTimeout(() => {
                    var _a;
                    const textContainer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".agent-status-option-text");
                    let isTextOverflowing = true;
                    if (textContainer) {
                        isTextOverflowing = textContainer.offsetWidth < textContainer.scrollWidth;
                        if (isTextOverflowing) {
                            this.isTextOverflow = undefined;
                        }
                    }
                }, 100);
            }
        }
        render() {
            const text = this.agentStateOption.name === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_1__.t)("app:tpw.stateChange.available") : this.agentStateOption.name;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <span class="agent-status-select-option-badge">
          <!-- Render the SVG Icon -->
          ${this.presenceIcon(this.agentStateOption.id === _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE_ID)}
        </span>
        <md-tooltip placement="top" message=${text} ?disabled=${this.isTextOverflow}>
          <div class="agent-status-option-text ellipsis-text">${this.HighlightText(text, this.searchTerm)}</div>
        </md-tooltip>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "agentStateOption", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "searchTerm", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isTextOverflow", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("agent-state-selector-list")
    ], Element);
    ChangeStateSelectorList.Element = Element;
})(ChangeStateSelectorList || (ChangeStateSelectorList = {}));


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/list.scss":
/*!*******************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/list.scss ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host(agent-state-selector-list) {
  display: flex;
  gap: 0.5rem;
}

.agent-status-select-option-badge {
  display: inline-flex;
  align-items: center;
  align-self: center;
  justify-content: center;
  border-radius: 50%;
  height: 16px;
  width: 16px;
}

.agent-status-select-option-badge .available-indicator {
  background-color: var(--md-primary-one-bg-color, --md-primary-bg-color);
  color: var(--avatar-presence-active);
  border-radius: 50%;
  position: absolute;
}

.agent-status-select-option-badge .default-indicator {
  background-color: var(--md-primary-one-bg-color, --md-primary-bg-color);
  color: var(--avatar-presence-inactive);
  border-radius: 50%;
  position: absolute;
}

.agent-status-select-option-badge .default-indicator .new-momentum,
.agent-status-select-option-badge .available-indicator .new-momentum {
  background-color: transparent;
}

.status-indicator {
  box-sizing: border-box;
  color: var(--md-presence-away-bg-color);
  margin: 0;
}
.status-indicator.green-status {
  color: var(--md-green-60);
}
.status-indicator.yellow-status {
  color: var(--md-yellow-60);
}
.status-indicator.red-status {
  color: var(--md-presence-do-not-disturb-bg-color);
}

.agent-status-option-text {
  display: block;
  font-size: var(--font-size-medium);
  width: var(--full-menu-item-width);
}

.ellipsis-text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.highlight-span {
  display: inline-table;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/TeamPerformanceWidget/components/agentStateSelector/scss/list.scss */
/*# sourceURL=list.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvVGVhbVBlcmZvcm1hbmNlV2lkZ2V0L2NvbXBvbmVudHMvYWdlbnRTdGF0ZVNlbGVjdG9yL3Njc3MvbGlzdC5zY3NzIiwibGlzdC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLFdBQUE7QUNDRjs7QURFQTtFQUNFLG9CQUFBO0VBQ0EsbUJBQUE7RUFDQSxrQkFBQTtFQUNBLHVCQUFBO0VBQ0Esa0JBQUE7RUFDQSxZQUFBO0VBQ0EsV0FBQTtBQ0NGOztBREVBO0VBQ0UsdUVBQUE7RUFDQSxvQ0FBQTtFQUNBLGtCQUFBO0VBQ0Esa0JBQUE7QUNDRjs7QURFQTtFQUNFLHVFQUFBO0VBQ0Esc0NBQUE7RUFDQSxrQkFBQTtFQUNBLGtCQUFBO0FDQ0Y7O0FERUE7O0VBRUUsNkJBQUE7QUNDRjs7QURFQTtFQUNFLHNCQUFBO0VBQ0EsdUNBQUE7RUFDQSxTQUFBO0FDQ0Y7QURDRTtFQUNFLHlCQUFBO0FDQ0o7QURFRTtFQUNFLDBCQUFBO0FDQUo7QURHRTtFQUNFLGlEQUFBO0FDREo7O0FES0E7RUFDRSxjQUFBO0VBQ0Esa0NBQUE7RUFDQSxrQ0FBQTtBQ0ZGOztBREtBO0VBQ0UsY0FBQTtFQUNBLGVBQUE7RUFDQSxnQkFBQTtFQUNBLHVCQUFBO0VBQ0EsbUJBQUE7QUNGRjs7QURLQTtFQUNFLHFCQUFBO0FDRkYiLCJmaWxlIjoibGlzdC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3QoYWdlbnQtc3RhdGUtc2VsZWN0b3ItbGlzdCkge1xuICBkaXNwbGF5OiBmbGV4O1xuICBnYXA6IDAuNXJlbTtcbn1cblxuLmFnZW50LXN0YXR1cy1zZWxlY3Qtb3B0aW9uLWJhZGdlIHtcbiAgZGlzcGxheTogaW5saW5lLWZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGFsaWduLXNlbGY6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgaGVpZ2h0OiAxNnB4O1xuICB3aWR0aDogMTZweDtcbn1cblxuLmFnZW50LXN0YXR1cy1zZWxlY3Qtb3B0aW9uLWJhZGdlIC5hdmFpbGFibGUtaW5kaWNhdG9yIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tbWQtcHJpbWFyeS1vbmUtYmctY29sb3IsIC0tbWQtcHJpbWFyeS1iZy1jb2xvcik7XG4gIGNvbG9yOiB2YXIoLS1hdmF0YXItcHJlc2VuY2UtYWN0aXZlKTtcbiAgYm9yZGVyLXJhZGl1czogNTAlO1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG59XG5cbi5hZ2VudC1zdGF0dXMtc2VsZWN0LW9wdGlvbi1iYWRnZSAuZGVmYXVsdC1pbmRpY2F0b3Ige1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LW9uZS1iZy1jb2xvciwgLS1tZC1wcmltYXJ5LWJnLWNvbG9yKTtcbiAgY29sb3I6IHZhcigtLWF2YXRhci1wcmVzZW5jZS1pbmFjdGl2ZSk7XG4gIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgcG9zaXRpb246IGFic29sdXRlO1xufVxuXG4uYWdlbnQtc3RhdHVzLXNlbGVjdC1vcHRpb24tYmFkZ2UgLmRlZmF1bHQtaW5kaWNhdG9yIC5uZXctbW9tZW50dW0sXG4uYWdlbnQtc3RhdHVzLXNlbGVjdC1vcHRpb24tYmFkZ2UgLmF2YWlsYWJsZS1pbmRpY2F0b3IgLm5ldy1tb21lbnR1bSB7XG4gIGJhY2tncm91bmQtY29sb3I6IHRyYW5zcGFyZW50O1xufVxuXG4uc3RhdHVzLWluZGljYXRvciB7XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIGNvbG9yOiB2YXIoLS1tZC1wcmVzZW5jZS1hd2F5LWJnLWNvbG9yKTtcbiAgbWFyZ2luOiAwO1xuXG4gICYuZ3JlZW4tc3RhdHVzIHtcbiAgICBjb2xvcjogdmFyKC0tbWQtZ3JlZW4tNjApO1xuICB9XG5cbiAgJi55ZWxsb3ctc3RhdHVzIHtcbiAgICBjb2xvcjogdmFyKC0tbWQteWVsbG93LTYwKTtcbiAgfVxuXG4gICYucmVkLXN0YXR1cyB7XG4gICAgY29sb3I6IHZhcigtLW1kLXByZXNlbmNlLWRvLW5vdC1kaXN0dXJiLWJnLWNvbG9yKTtcbiAgfVxufVxuXG4uYWdlbnQtc3RhdHVzLW9wdGlvbi10ZXh0IHtcbiAgZGlzcGxheTogYmxvY2s7XG4gIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplLW1lZGl1bSk7XG4gIHdpZHRoOiB2YXIoLS1mdWxsLW1lbnUtaXRlbS13aWR0aCk7XG59XG5cbi5lbGxpcHNpcy10ZXh0IHtcbiAgZGlzcGxheTogYmxvY2s7XG4gIG1heC13aWR0aDogMTAwJTtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG59XG5cbi5oaWdobGlnaHQtc3BhbiB7XG4gIGRpc3BsYXk6IGlubGluZS10YWJsZTtcbn1cbiIsIjpob3N0KGFnZW50LXN0YXRlLXNlbGVjdG9yLWxpc3QpIHtcbiAgZGlzcGxheTogZmxleDtcbiAgZ2FwOiAwLjVyZW07XG59XG5cbi5hZ2VudC1zdGF0dXMtc2VsZWN0LW9wdGlvbi1iYWRnZSB7XG4gIGRpc3BsYXk6IGlubGluZS1mbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBhbGlnbi1zZWxmOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBib3JkZXItcmFkaXVzOiA1MCU7XG4gIGhlaWdodDogMTZweDtcbiAgd2lkdGg6IDE2cHg7XG59XG5cbi5hZ2VudC1zdGF0dXMtc2VsZWN0LW9wdGlvbi1iYWRnZSAuYXZhaWxhYmxlLWluZGljYXRvciB7XG4gIGJhY2tncm91bmQtY29sb3I6IHZhcigtLW1kLXByaW1hcnktb25lLWJnLWNvbG9yLCAtLW1kLXByaW1hcnktYmctY29sb3IpO1xuICBjb2xvcjogdmFyKC0tYXZhdGFyLXByZXNlbmNlLWFjdGl2ZSk7XG4gIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgcG9zaXRpb246IGFic29sdXRlO1xufVxuXG4uYWdlbnQtc3RhdHVzLXNlbGVjdC1vcHRpb24tYmFkZ2UgLmRlZmF1bHQtaW5kaWNhdG9yIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tbWQtcHJpbWFyeS1vbmUtYmctY29sb3IsIC0tbWQtcHJpbWFyeS1iZy1jb2xvcik7XG4gIGNvbG9yOiB2YXIoLS1hdmF0YXItcHJlc2VuY2UtaW5hY3RpdmUpO1xuICBib3JkZXItcmFkaXVzOiA1MCU7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbn1cblxuLmFnZW50LXN0YXR1cy1zZWxlY3Qtb3B0aW9uLWJhZGdlIC5kZWZhdWx0LWluZGljYXRvciAubmV3LW1vbWVudHVtLFxuLmFnZW50LXN0YXR1cy1zZWxlY3Qtb3B0aW9uLWJhZGdlIC5hdmFpbGFibGUtaW5kaWNhdG9yIC5uZXctbW9tZW50dW0ge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB0cmFuc3BhcmVudDtcbn1cblxuLnN0YXR1cy1pbmRpY2F0b3Ige1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICBjb2xvcjogdmFyKC0tbWQtcHJlc2VuY2UtYXdheS1iZy1jb2xvcik7XG4gIG1hcmdpbjogMDtcbn1cbi5zdGF0dXMtaW5kaWNhdG9yLmdyZWVuLXN0YXR1cyB7XG4gIGNvbG9yOiB2YXIoLS1tZC1ncmVlbi02MCk7XG59XG4uc3RhdHVzLWluZGljYXRvci55ZWxsb3ctc3RhdHVzIHtcbiAgY29sb3I6IHZhcigtLW1kLXllbGxvdy02MCk7XG59XG4uc3RhdHVzLWluZGljYXRvci5yZWQtc3RhdHVzIHtcbiAgY29sb3I6IHZhcigtLW1kLXByZXNlbmNlLWRvLW5vdC1kaXN0dXJiLWJnLWNvbG9yKTtcbn1cblxuLmFnZW50LXN0YXR1cy1vcHRpb24tdGV4dCB7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBmb250LXNpemU6IHZhcigtLWZvbnQtc2l6ZS1tZWRpdW0pO1xuICB3aWR0aDogdmFyKC0tZnVsbC1tZW51LWl0ZW0td2lkdGgpO1xufVxuXG4uZWxsaXBzaXMtdGV4dCB7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBtYXgtd2lkdGg6IDEwMCU7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuICB3aGl0ZS1zcGFjZTogbm93cmFwO1xufVxuXG4uaGlnaGxpZ2h0LXNwYW4ge1xuICBkaXNwbGF5OiBpbmxpbmUtdGFibGU7XG59Il19 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/listError.scss":
/*!************************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/listError.scss ***!
  \************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host(agent-state-selector-list-error) {
  display: flex;
}

.infinite-scroll-error {
  display: flex;
  padding-left: 15px;
  font-size: var(--font-size-small);
  color: var(--md-alert-error-text-color, --red-70-color);
  flex-direction: column;
}
.infinite-scroll-error .error-block {
  display: flex;
  flex-direction: column;
}
.infinite-scroll-error .error-block .error-span-padding {
  padding-right: 8px;
}
.infinite-scroll-error .error-block .tracking-error-block {
  display: inline-flex;
}
.infinite-scroll-error .error-block .infinite-scroll-retry-link::part(link) {
  font-size: var(--font-size-small);
  color: var(--md-alert-error-text-color, --red-70-color);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/TeamPerformanceWidget/components/agentStateSelector/scss/listError.scss */
/*# sourceURL=listError.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/main.scss":
/*!*******************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/agentStateSelector/scss/main.scss ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`md-advance-list::part(spinner) {
  display: flex;
  justify-content: center;
}

.tpw-agent-status {
  --full-menu-item-width: calc(205px);
  --full-status-width: calc(260px);
  --full-half-width: calc(99px);
  --compact-status-width: calc(184px);
  --compact-menu-item-width: calc(150px);
  --compact-half-width: calc(61px);
  --state-input-height: calc(44px);
  --state-selector-height: calc(344px);
  --state-selector-min-height: calc(164px);
  --current-status-max-width: calc(1px);
  --agent-state-selector-padding: calc(8px);
  padding-top: 12px;
  padding-bottom: 8px;
  padding-left: 6px;
  padding-right: 6px;
}
.tpw-agent-status.suppress-loading {
  min-height: 150px;
}
.tpw-agent-status .menu-list {
  height: 100%;
  margin: 0;
  overflow-y: hidden;
  width: 98%;
}
.tpw-agent-status .status-menu-item {
  border: 0;
  border-radius: 0;
}
.tpw-agent-status .state-selector-list {
  align-content: flex-start;
  display: block;
  overflow: auto;
  overflow-x: hidden;
  max-height: 292px;
  padding-left: 2px;
  padding-right: 2px;
  padding-top: 2px;
}
.tpw-agent-status .state-selector-list md-list-item:last-child {
  padding-bottom: 0.125rem;
}
.tpw-agent-status .state-input-wrapper {
  height: var(--state-input-height);
  padding: 0px 2px;
}
.tpw-agent-status .state-input-wrapper md-input::part(md-input-container) {
  margin-bottom: 12px;
}
.tpw-agent-status .state-no-match {
  padding: 24px 24px;
  position: relative;
  top: 50%;
  text-align: center;
}
.tpw-agent-status .state-no-match .empty-title {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  color: var(--list-text-color, #121212);
}
.tpw-agent-status .state-no-match .empty-state-wrapper::part(container) {
  background-color: var(--md-secondary-white-bg-color);
}
.tpw-agent-status .state-no-match .empty-state-wrapper::part(img) {
  display: block;
  margin: auto;
  width: auto;
}
.tpw-agent-status .state-no-results {
  padding: 50px 0 40px 0;
  position: relative;
  top: 50%;
  text-align: center;
}
.tpw-agent-status .state-no-results span {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
}
.tpw-agent-status .state-no-results .empty-state-wrapper::part(container) {
  background-color: var(--md-secondary-white-bg-color);
}
.tpw-agent-status .state-no-results .empty-state-wrapper::part(img) {
  display: block;
  margin: auto;
  width: auto;
}
.tpw-agent-status .search-block-error {
  display: flex;
  align-items: center;
  padding: 16px;
  min-height: 200px;
}
.tpw-agent-status .search-error {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  font-size: var(--font-size-small);
}
.tpw-agent-status .state-item-highlight {
  background-color: var(--md-alert-info-bg-color, --md-alert-info-bg-color-default);
}
.tpw-agent-status .state-loading {
  height: 100px;
  min-height: 100px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tpw-agent-status .state-error {
  padding: 30px 0 16px 0;
  display: grid;
}
.tpw-agent-status .state-error .error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.tpw-agent-status .state-error .error-title {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  font-weight: 600;
  text-align: center;
  padding: 0;
  color: var(--list-text-color, #121212);
}
.tpw-agent-status .state-error .error-subtitle {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  text-align: center;
  padding: 0;
}
.tpw-agent-status .state-error .error-cloud-wrapper {
  height: auto;
}
.tpw-agent-status .state-error .error-cloud-wrapper::part(container) {
  background-color: var(--md-secondary-white-bg-color);
}
.tpw-agent-status .state-error .error-cloud-wrapper::part(img) {
  display: block;
  margin: auto;
  width: auto;
}
.tpw-agent-status .state-error md-button {
  margin: 24px auto auto auto;
}
@media (max-width: 736px) {
  .tpw-agent-status .agent-status .ax-current-status-label.half-width,
  .tpw-agent-status .agent-status .cumulativeStateTimer.ellipsis-timer {
    width: var(--compact-half-width);
  }
  .tpw-agent-status .state-menu-overlay::part(overlay-content) {
    width: var(--compact-status-width);
  }
  .tpw-agent-status .agent-state-button::part(button) {
    width: var(--compact-status-width);
  }
  .tpw-agent-status .agent-status-option-text {
    width: var(--compact-menu-item-width);
  }
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/TeamPerformanceWidget/components/agentStateSelector/scss/main.scss */
/*# sourceURL=main.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/agentStateSelector/utils/index.ts":
/*!*******************************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/agentStateSelector/utils/index.ts ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   checkIfSearchMatchesAvailable: () => (/* binding */ checkIfSearchMatchesAvailable),
/* harmony export */   escapeRegExp: () => (/* binding */ escapeRegExp),
/* harmony export */   fetchItems: () => (/* binding */ fetchItems),
/* harmony export */   getDefaultAvailableIdleCode: () => (/* binding */ getDefaultAvailableIdleCode),
/* harmony export */   getDynamicHeight: () => (/* binding */ getDynamicHeight),
/* harmony export */   renderErrorState: () => (/* binding */ renderErrorState),
/* harmony export */   renderLoadingState: () => (/* binding */ renderLoadingState),
/* harmony export */   renderNoMatchFound: () => (/* binding */ renderNoMatchFound),
/* harmony export */   renderSearchError: () => (/* binding */ renderSearchError),
/* harmony export */   stateIndicator: () => (/* binding */ stateIndicator)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




const reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
const reHasRegExpChar = RegExp(reRegExpChar.source);
const PAGE_SIZE = 100;
const escapeRegExp = (string) => {
    return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string || "";
};
const stateIndicator = (state) => {
    /* eslint-disable max-len */
    const getIndicator = () => {
        if (state === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.AgentState.Available) {
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
        <svg
          class="available-indicator"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          //sonar.issue.ignore.block.start
          <path
            d="M13.5 6.75C13.5 10.4779 10.4779 13.5 6.75 13.5C3.02208 13.5 0 10.4779 0 6.75C0 3.02208 3.02208 0 6.75 0C10.4779 0 13.5 3.02208 13.5 6.75ZM10.1084 3.65616L5.49972 8.26486L3.37523 6.14037C2.92891 5.69405 2.2053 5.69405 1.75898 6.14037C1.31267 6.58668 1.31267 7.3103 1.75898 7.75661L4.18335 10.181C4.19466 10.1923 4.20615 10.2033 4.21781 10.214L4.69229 10.6885C5.1386 11.1348 5.86222 11.1348 6.30854 10.6885L11.7247 5.27241C12.171 4.82609 12.171 4.10248 11.7247 3.65616C11.2783 3.20985 10.5547 3.20985 10.1084 3.65616Z"
            fill="currentColor"
          />
          //sonar.issue.ignore.block.end
        </svg>
      `;
        }
        else {
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
        <svg
          class="default-indicator"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          //sonar.issue.ignore.block.start
          <path
            d="M6.75 13.5C10.4779 13.5 13.5 10.4779 13.5 6.75C13.5 3.02208 10.4779 0 6.75 0C3.02208 0 0 3.02208 0 6.75C0 10.4779 3.02208 13.5 6.75 13.5ZM2.8125 5.625H10.6875C11.3088 5.625 11.8125 6.12868 11.8125 6.75C11.8125 7.37132 11.3088 7.875 10.6875 7.875H2.8125C2.19118 7.875 1.6875 7.37132 1.6875 6.75C1.6875 6.12868 2.19118 5.625 2.8125 5.625Z"
            fill="currentColor"
          />
          //sonar.issue.ignore.block.end
        </svg>
      `;
        }
    };
    return state ? getIndicator() : null;
};
const getDefaultAvailableIdleCode = (localizedName) => ({
    name: localizedName,
    id: "0",
    isDefault: false,
    isSystem: false
});
const getDynamicHeight = (itemsLength) => {
    const minHeight = Math.max(itemsLength * 40, 10);
    return `${Math.min(minHeight, 292)}px`;
};
const checkIfSearchMatchesAvailable = (searchQuery) => {
    if (searchQuery) {
        return _constants__WEBPACK_IMPORTED_MODULE_0__.AVAILABLE.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase());
    }
    return false;
};
const fetchItems = (orgId, agentId, page, searchTerm = "") => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const params = {
            orgId,
            page,
            search: searchTerm,
            pageSize: PAGE_SIZE,
            supervisedUserId: agentId,
            customFilter: "isSystemCode==false"
        };
        const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.abs.fetchPaginatedIdleCodes(params);
        return response;
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("event=fetchItems | Error on fetching idle codes on Team Performance Widget Agent State Change Module", error);
        throw error;
    }
});
const renderSearchError = (searchErrorMsg) => {
    return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
    <div class="search-block-error">
      <div class="search-error">
        <md-icon name="info-badge-filled" iconSet="momentumDesign" size="16" class="search-error-info"></md-icon>
        ${searchErrorMsg}
      </div>
    </div>
  `;
};
const renderNoMatchFound = (message) => {
    return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
    <div class="state-no-match">
      <agentx-wc-empty-state-wrapper
        class="empty-state-wrapper"
        illustration-type="empty-result"
      ></agentx-wc-empty-state-wrapper>
      <span class="empty-title">${message}</span>
    </div>
  `;
};
const renderLoadingState = () => {
    return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
    <div class="state-loading">
      <md-spinner size="18"></md-spinner>
    </div>
  `;
};
const renderErrorState = (message, retryButtonLabel, retryCB) => {
    return (0,lit_html__WEBPACK_IMPORTED_MODULE_3__.html) `
    <div class="state-error">
      <agentx-wc-empty-state-wrapper
        class="error-cloud-wrapper"
        illustration-type="error-cloud"
      ></agentx-wc-empty-state-wrapper>
      <div class="error-container">
        <p class="error-title">${message}</p>
      </div>
      <md-button @click=${() => retryCB()} id="reload-btn" color="blue">
        <span slot="text">${retryButtonLabel}</span>
      </md-button>
    </div>
  `;
};


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/components/style.scss":
/*!********************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/components/style.scss ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.applied-filters-wrapper {
  padding: 0 1rem 1rem;
}

.applied-filters__label {
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: var(--md-primary-text-color);
}

.applied-group-wrapper {
  padding: 0 1rem 1rem;
}

.applied-group__label {
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: var(--md-primary-text-color);
}

.applied-group__clear-all {
  text-decoration: underline;
  margin-left: 9px;
}

.applied-filters-chips::part(chip) {
  background-color: var(--md-button-secondary-bg-color);
  border: 2px solid var(--md-button-secondary-hover-bg-color);
  padding: 8px 12px;
  border-radius: 20px;
  margin: 4px 0.5px;
  height: fit-content;
  width: fit-content;
  max-width: unset;
}

.applied-groups-chips::part(chip) {
  background-color: var(--md-button-secondary-bg-color);
  border: 2px solid var(--md-button-secondary-hover-bg-color);
  padding: 8px 12px;
  border-radius: 20px;
  margin: 0px 3px;
  height: fit-content;
  width: fit-content;
}

.applied-filters-action-btn {
  text-decoration: underline;
  display: inline-grid;
}

.applied-filters-expandCollapse-btn {
  margin: 0rem 1rem;
}

.applied-filters-separator {
  margin: 0 0.5rem;
  color: var(--md-primary-seperator-color);
}

.chip-cross-icon {
  margin-left: 0.5rem !important;
}

.tpw-empty-grid::part(img) {
  width: 25rem !important;
}

.agent-state-dot {
  height: 12px;
  width: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 10px;
}

.agent-available-dot {
  background-color: var(--md-presence-active-bg-color);
}

.agent-idle-dot {
  background-color: var(--md-presence-away-bg-color);
}

.agent-state-active::part(chip) {
  background-color: var(--button-available-bg-color, #edfaf4) !important;
}

.agent-state-idle::part(chip) {
  background-color: var(--button-idle-bg-color, #f7f7f7) !important;
}

.agentx-wc-tpw-empty-grid {
  height: 100%;
}
.agentx-wc-tpw-empty-grid agentx-wc-empty-state-wrapper::part(img) {
  width: 85px;
}

.empty-grid-message {
  margin-top: 15px;
  text-align: center;
  margin-bottom: 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  color: var(--md-primary-text-color);
}

.empty-grid-message-container {
  display: block;
}

.empty-grid-sub-message {
  text-align: center;
  font-weight: bold;
  margin-bottom: 0;
  margin-top: 10px;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/TeamPerformanceWidget/components/style.scss */
/*# sourceURL=style.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/contextMenu.scss":
/*!***************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/contextMenu.scss ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.kebab-menu-container {
  padding: 0 !important;
  max-height: calc(100vh - 48px);
}
.kebab-menu-container.overlay-content {
  width: max-content;
  background-color: var(--md-secondary-white-bg-color);
  border: 1px solid var(--md-menu-overlay-border-color, --gray-20);
  border-radius: 0.5rem;
  display: flex;
  justify-content: space-around;
  max-width: calc(100vw - var(--vw-padding) * 2);
}
.kebab-menu-container.overlay-content md-list md-list-item.agent-signout[disabled] md-tooltip {
  pointer-events: auto;
}
.kebab-menu-container .review-and-monitor.disabled-cursor {
  cursor: not-allowed;
}
.kebab-menu-container .review-monitor-wrapper md-button::part(button) {
  background-color: transparent;
}
.kebab-menu-container .review-monitor-wrapper.list md-button {
  margin: 0;
}
.kebab-menu-container .review-monitor-wrapper .rm-text {
  margin-top: 0;
  margin-bottom: 0;
  color: var(--md-primary-text-color);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
}
.kebab-menu-container .review-monitor-wrapper .rm-text.disabled {
  color: var(--md-disabled-text-color);
}
.kebab-menu-container .aid-tooltip {
  margin-top: 3px;
}
.kebab-menu-container .list-type-container {
  display: flex;
  width: 165px;
  align-items: center;
  justify-content: space-between;
}
.kebab-menu-container .list-type-container md-spinner {
  margin-left: 3px;
}
.kebab-menu-container .list-type-container .list-arrow-icon {
  position: absolute;
  align-items: center;
  right: 8px;
}
.kebab-menu-container .list-type-container .list-text-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.kebab-menu-container .list-type-container .error-icon {
  color: var(--md-input-chat-error-color, #a12512);
  margin-left: 3px;
}
.kebab-menu-container .list-type-container .error-icon md-icon::part(icon) {
  background-color: white;
  border-radius: 50%;
  height: 0;
  margin-top: 9px;
}
.kebab-menu-container .list-type-container .list-text {
  margin-top: 0;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  text-transform: capitalize;
}
.kebab-menu-container .list-type-container .list-text.disabled {
  color: var(--md-disabled-text-color);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/TeamPerformanceWidget/contextMenu.scss */
/*# sourceURL=contextMenu.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/TeamPerformanceWidget/utils/KeyboardNavigationUtils.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/utils/KeyboardNavigationUtils.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   checkForwardTabbing: () => (/* binding */ checkForwardTabbing),
/* harmony export */   getAllFocusableElementsOf: () => (/* binding */ getAllFocusableElementsOf),
/* harmony export */   getRowDetails: () => (/* binding */ getRowDetails),
/* harmony export */   onTabToNextCell: () => (/* binding */ onTabToNextCell),
/* harmony export */   suppressHeaderKeyboardEvent: () => (/* binding */ suppressHeaderKeyboardEvent),
/* harmony export */   suppressKeyboardEvent: () => (/* binding */ suppressKeyboardEvent)
/* harmony export */ });
/* harmony import */ var _components_Common_CellRenderers_CustomKeyboardNav__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/components/Common/CellRenderers/CustomKeyboardNav */ "./src/components/Common/CellRenderers/CustomKeyboardNav.ts");

const GRID_CELL_CLASSNAME = "ag-cell";
const COLUMN_WIDTH_RESIZE = 2;
let rowDetails;
function getAllFocusableElementsOf(actionCell) {
    const focusableElements = [];
    if (actionCell) {
        const buttons = actionCell.querySelectorAll(".aid-button");
        if (buttons && buttons.length > 0) {
            buttons.forEach((element) => {
                if (!element.disabled) {
                    focusableElements.push(element);
                }
            });
        }
    }
    return focusableElements;
}
function getEventPath(event) {
    const path = [];
    let currentTarget = event.target;
    while (currentTarget) {
        path.push(currentTarget);
        currentTarget = currentTarget.parentElement;
    }
    return path;
}
function checkForwardTabbing(event, isTabForward, isTabBackward, focusableChildrenElements, actionCell, eGridCell) {
    var _a;
    let suppressEvent = false;
    const lastCellChildEl = focusableChildrenElements[focusableChildrenElements.length - 1];
    const firstCellChildEl = focusableChildrenElements[0];
    const activeElement = _components_Common_CellRenderers_CustomKeyboardNav__WEBPACK_IMPORTED_MODULE_0__["default"].getDeepActiveElement();
    // Suppress keyboard event if tabbing forward within the cell and the current focused element is not the last child
    if (isTabForward) {
        const isLastChildFocused = lastCellChildEl && activeElement === lastCellChildEl;
        if (!isLastChildFocused) {
            suppressEvent = true;
        }
        else {
            rowDetails = null;
        }
    }
    // Suppress keyboard event if tabbing backwards within the cell, and the current focused element is not the first child
    else if (isTabBackward) {
        const cellHasFocusedChildren = eGridCell !== activeElement;
        // Manually set focus to the last child element if cell doesn't have focused children
        if (!cellHasFocusedChildren) {
            lastCellChildEl === null || lastCellChildEl === void 0 ? void 0 : lastCellChildEl.focus();
            // Cancel keyboard press, so that it doesn't focus on the last child and then pass through the keyboard press to
            // move to the 2nd last child element
            event.preventDefault();
        }
        else {
            const getFocusableElements = getAllFocusableElementsOf(actionCell);
            let indexToFocus = -1; // Default index
            getFocusableElements.some((element, index) => {
                if (activeElement === element) {
                    indexToFocus = index - 1;
                    return true;
                }
                return false;
            });
            if (indexToFocus >= 0) {
                (_a = getFocusableElements[indexToFocus]) === null || _a === void 0 ? void 0 : _a.focus();
            }
            event.preventDefault();
        }
        const isFirstChildFocused = firstCellChildEl && activeElement === firstCellChildEl;
        if (!isFirstChildFocused) {
            suppressEvent = true;
        }
        else {
            rowDetails = null;
        }
    }
    return suppressEvent;
}
const suppressHeaderKeyboardEvent = (params) => {
    const { event, api, column } = params;
    const { key, altKey, shiftKey } = params.event;
    const isTabForward = key === "Tab" && shiftKey === false;
    const c = column;
    if (!c) {
        return false;
    }
    if (isTabForward && c.getColId() === "actions") {
        const actionCol = params.api.getAllDisplayedColumns().find((col) => col.getColId() === "actions");
        if (actionCol) {
            api.ensureColumnVisible(actionCol);
            // sets focus into the first grid cell
            setTimeout(() => {
                api.setFocusedCell(0, actionCol.getColId());
            }, 10);
        }
    }
    if (altKey && (key === "ArrowLeft" || key === "ArrowRight")) {
        event.preventDefault();
        const widthChange = key === "ArrowLeft" ? -COLUMN_WIDTH_RESIZE : COLUMN_WIDTH_RESIZE;
        const newWidth = params.column.getActualWidth() + widthChange;
        api.setColumnWidths([{ key: c, newWidth }]);
        return true;
    }
    return false;
};
const getRowDetails = (nodeRowIndex, api) => {
    var _a, _b;
    const lastRowIndex = api.getLastDisplayedRowIndex();
    return {
        currentRowIndex: nodeRowIndex,
        previousRowIndex: (_a = api.getDisplayedRowAtIndex(nodeRowIndex - 1)) === null || _a === void 0 ? void 0 : _a.rowIndex,
        nextRowIndex: (_b = api.getDisplayedRowAtIndex(nodeRowIndex + 1)) === null || _b === void 0 ? void 0 : _b.rowIndex,
        lastRowIndex
    };
};
function suppressKeyboardEvent(eventObj) {
    const { event, node, api } = eventObj;
    const { key, shiftKey } = event;
    const path = getEventPath(event);
    const isTabForward = key === "Tab" && shiftKey === false;
    const isTabBackward = key === "Tab" && shiftKey === true;
    let suppressEvent = false;
    rowDetails = getRowDetails(node.rowIndex, api);
    // Handle cell children tabbing
    if (isTabForward || isTabBackward) {
        const eGridCell = path.find((el) => {
            if (el.classList === undefined) {
                return false;
            }
            return el.classList.contains(GRID_CELL_CLASSNAME);
        });
        if (!eGridCell) {
            return suppressEvent;
        }
        const actionCell = eGridCell.querySelector(".ActionCell");
        const focusableChildrenElements = getAllFocusableElementsOf(actionCell);
        if (focusableChildrenElements.length > 0) {
            suppressEvent = checkForwardTabbing(event, isTabForward, isTabBackward, focusableChildrenElements, actionCell, eGridCell);
        }
        if (actionCell && focusableChildrenElements.length === 0) {
            rowDetails = null;
        }
    }
    return suppressEvent;
}
const onTabToNextCell = (params) => {
    const { previousCellPosition, nextCellPosition, backwards, api } = params;
    if (nextCellPosition) {
        const previousCell = previousCellPosition;
        const lastRowIndex = previousCell.rowIndex;
        let nextRowIndex = backwards ? lastRowIndex - 1 : lastRowIndex + 1;
        const lastIndex = api.getLastDisplayedRowIndex();
        if (nextRowIndex < 0) {
            nextRowIndex = -1;
        }
        if (nextRowIndex > lastIndex) {
            nextRowIndex = lastIndex;
        }
        const actionCol = params.api.getAllDisplayedColumns().find((col) => col.getColId() === "actions");
        if (!actionCol) {
            return false;
        }
        return {
            rowIndex: rowDetails ? rowDetails.currentRowIndex : nextRowIndex,
            column: actionCol,
            rowPinned: null
        };
    }
    return false;
};


/***/ }),

/***/ "./src/components/TeamPerformanceWidget/utils/WebexChat.utils.ts":
/*!***********************************************************************!*\
  !*** ./src/components/TeamPerformanceWidget/utils/WebexChat.utils.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WEBEX_CHAT_STORAGE_ERROR_KEY: () => (/* binding */ WEBEX_CHAT_STORAGE_ERROR_KEY),
/* harmony export */   WEBEX_CHAT_STORAGE_KEY: () => (/* binding */ WEBEX_CHAT_STORAGE_KEY),
/* harmony export */   getAgentKey: () => (/* binding */ getAgentKey),
/* harmony export */   getPersistedError: () => (/* binding */ getPersistedError),
/* harmony export */   getPersistedText: () => (/* binding */ getPersistedText),
/* harmony export */   setPersistedError: () => (/* binding */ setPersistedError),
/* harmony export */   setPersistedText: () => (/* binding */ setPersistedText)
/* harmony export */ });
const WEBEX_CHAT_STORAGE_KEY = "tpw-webex-chat";
const WEBEX_CHAT_STORAGE_ERROR_KEY = "tpw-webex-chat-error";
// TODO: Remove Agent name when implementing TPW API
const getAgentKey = (agentName, email) => {
    agentName = agentName.replace(/ /g, "-").toLowerCase();
    return `${agentName}-${email}`;
};
const getPersistedText = (agentName, email) => {
    try {
        const storageData = window.sessionStorage.getItem(WEBEX_CHAT_STORAGE_KEY);
        if (storageData) {
            const parsedStorage = JSON.parse(storageData);
            return parsedStorage[getAgentKey(agentName, email)] || "";
        }
        else {
            return "";
        }
    }
    catch (_a) {
        return "";
    }
};
const setPersistedText = (agentName, email, value) => {
    const agentKey = getAgentKey(agentName, email);
    try {
        const storageData = window.sessionStorage.getItem(WEBEX_CHAT_STORAGE_KEY);
        if (storageData) {
            const parsedStorage = JSON.parse(storageData);
            if (value) {
                parsedStorage[agentKey] = value;
            }
            else {
                delete parsedStorage[agentKey];
            }
            window.sessionStorage.setItem(WEBEX_CHAT_STORAGE_KEY, JSON.stringify(parsedStorage));
        }
        else if (value) {
            const data = {
                [agentKey]: value
            };
            window.sessionStorage.setItem(WEBEX_CHAT_STORAGE_KEY, JSON.stringify(data));
        }
    }
    catch (_a) {
        if (value) {
            const data = {
                [agentKey]: value
            };
            window.sessionStorage.setItem(WEBEX_CHAT_STORAGE_KEY, JSON.stringify(data));
        }
    }
};
const getPersistedError = (agentName, email) => {
    try {
        const storageData = window.sessionStorage.getItem(WEBEX_CHAT_STORAGE_ERROR_KEY);
        if (storageData) {
            const parsedStorage = JSON.parse(storageData);
            return !!parsedStorage[getAgentKey(agentName, email)];
        }
        else {
            return false;
        }
    }
    catch (_a) {
        return false;
    }
};
const setPersistedError = (agentName, email, value) => {
    const agentKey = getAgentKey(agentName, email);
    try {
        const storageData = window.sessionStorage.getItem(WEBEX_CHAT_STORAGE_ERROR_KEY);
        if (storageData) {
            const parsedStorage = JSON.parse(storageData);
            if (value) {
                parsedStorage[agentKey] = value;
            }
            else {
                delete parsedStorage[agentKey];
            }
            window.sessionStorage.setItem(WEBEX_CHAT_STORAGE_ERROR_KEY, JSON.stringify(parsedStorage));
        }
        else if (value) {
            const data = {
                [agentKey]: value
            };
            window.sessionStorage.setItem(WEBEX_CHAT_STORAGE_ERROR_KEY, JSON.stringify(data));
        }
    }
    catch (_a) {
        if (value) {
            const data = { [agentKey]: value };
            window.sessionStorage.setItem(WEBEX_CHAT_STORAGE_ERROR_KEY, JSON.stringify(data));
        }
    }
};


/***/ }),

/***/ "./src/components/WebexWrapper/WebexWrapper.scss":
/*!*******************************************************!*\
  !*** ./src/components/WebexWrapper/WebexWrapper.scss ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

:host {
  --nav-header-height: 64px;
  --commoon-space: 8px;
  --webex-header-width: 160px;
}

.webex-frame {
  border: none;
  width: 100%;
  height: 100%;
}

.webex-img {
  padding-right: calc(var(--space-token-even) * 6);
  vertical-align: bottom;
  height: calc(var(--space-token-even) * 8);
  width: calc(var(--space-token-even) * 10);
}

.modal-header {
  display: flex;
  align-items: center;
  max-width: var(--webex-header-width);
  overflow: hidden;
}

.camara-icon {
  margin-right: calc(var(--space-token-even) * 6);
  height: calc(var(--space-token-even) * 8);
}

#webex-wrapper-modal::part(minimize-floating) {
  right: --commoon-space;
  bottom: --commoon-space;
}

#webex-wrapper-modal::part(floating-body) {
  padding: 0;
  overflow: hidden;
}

#webex-wrapper-modal::part(floating) {
  min-width: 480px;
  min-height: 320px;
  user-select: text;
  overflow: hidden;
  z-index: calc(var(--z-index-task-collapse-area) + 1);
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=WebexWrapper.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/WebexWrapper/WebexWrapper.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/WebexWrapper/WebexWrapper.ts":
/*!*****************************************************!*\
  !*** ./src/components/WebexWrapper/WebexWrapper.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WebexWrapper: () => (/* binding */ WebexWrapper)
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/config */ "./src/config.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _img_teams_icon_color_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @img/teams-icon-color.svg */ "./src/assets/images/teams-icon-color.svg");
/* harmony import */ var _img_teams_icon_color_svg__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_img_teams_icon_color_svg__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @uuip/unified-ui-platform-common-components */ "@uuip/unified-ui-platform-common-components");
/* harmony import */ var _uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_common_components__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! axios */ "../../node_modules/axios/lib/axios.js");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./../../utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _WebexWrapper_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./WebexWrapper.scss */ "./src/components/WebexWrapper/WebexWrapper.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};











var WebexWrapper;
(function (WebexWrapper) {
    /**
     * @element agentx-webex-wrapper
     * @fires agentx-webex-wrapper-close
     * @fires agentx-webex-minimize-restore
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_7__.LitElement) {
        constructor() {
            super(...arguments);
            this.webexEnabled = false;
            this.showModal = false;
            this.darkMode = false;
            this.minimize = false;
            this.agentId = "";
            this.agentEmailId = "";
            this.orgId = "";
            this.webexMeetingTimeStamp = 0;
            this.isWebexLogoutRequested = false;
            this.params = "camera *;microphone *;audio *";
            this.defaultOriginPosition = { x: 0, y: 0 };
            this.webexUrl = "";
            this.currentWindowWidth = window.innerWidth;
            this.lessWidth = 734;
            this.midWidth = 920;
            this.defaultWidth = 900;
            this.initial = false;
            this.webexWrapperTitle = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:common.webex");
            this.windowResizeHandler = () => {
                var _a, _b;
                const isModalInFullScreen = ((_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("#webex-wrapper-modal")) === null || _b === void 0 ? void 0 : _b.hasAttribute("full-screen")) || false;
                if (this.initial && isModalInFullScreen !== true) {
                    if (!this.showModal || this.minimize) {
                        this.containerRect = this.getHeightWidth();
                        this.location = this.getLocation();
                    }
                    else if (this.showModal &&
                        (localStorage.getItem("location") === null ||
                            window.innerWidth < this.lessWidth ||
                            this.currentWindowWidth < this.lessWidth)) {
                        this.location = this.getLocation();
                        this.containerRect = this.getHeightWidth();
                    }
                    this.currentWindowWidth = window.innerWidth;
                    this.minLocation = this.defaultOriginPosition;
                }
                this.initial = true;
            };
            this.defaultPosition = this.getLocation();
            this.windowResize = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_8__.throttle)(() => this.windowResizeHandler());
            this.containerRect = localStorage.getItem("resize") !== null
                ? JSON.parse(localStorage.getItem("resize") || "")
                : this.getHeightWidth();
            this.location = localStorage.getItem("location") !== null
                ? JSON.parse(localStorage.getItem("location") || "")
                : this.defaultPosition;
            this.minLocation = localStorage.getItem("min-location") !== null
                ? JSON.parse(localStorage.getItem("min-location") || "")
                : this.defaultOriginPosition;
        }
        getLocation() {
            if (window.innerWidth < this.lessWidth) {
                return this.defaultOriginPosition;
            }
            else if (window.innerWidth < this.midWidth) {
                return { x: window.innerWidth - window.innerWidth * 0.8, y: -(window.innerHeight * 0.7) };
            }
            else {
                return { x: window.innerWidth - this.defaultWidth, y: -(window.innerHeight * 0.7) };
            }
        }
        getHeightWidth() {
            if (window.innerWidth < this.lessWidth) {
                return {
                    width: window.innerWidth,
                    height: window.innerHeight * 0.8
                };
            }
            else if (window.innerWidth < this.midWidth) {
                return {
                    width: window.innerWidth * 0.8,
                    height: window.innerHeight * 0.7
                };
            }
            else {
                return { width: this.defaultWidth, height: window.innerHeight * 0.7 };
            }
        }
        resize(event) {
            var _a, _b;
            this.containerRect = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.size;
            localStorage.setItem("resize", JSON.stringify((_b = event === null || event === void 0 ? void 0 : event.detail) === null || _b === void 0 ? void 0 : _b.size));
        }
        saveLocation(event) {
            var _a, _b;
            if (((_a = this.containerRect) === null || _a === void 0 ? void 0 : _a.y) < 0) {
                // reset location if modal header is out of viewPort.
                this.location = this.getLocation();
            }
            else {
                this.location = (_b = event === null || event === void 0 ? void 0 : event.detail) === null || _b === void 0 ? void 0 : _b.transform;
            }
            localStorage.setItem("location", JSON.stringify(this.location));
        }
        saveMinLocation(event) {
            var _a, _b;
            this.minLocation = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.transform;
            localStorage.setItem("min-location", JSON.stringify((_b = event === null || event === void 0 ? void 0 : event.detail) === null || _b === void 0 ? void 0 : _b.transform));
        }
        static get styles() {
            return _WebexWrapper_scss__WEBPACK_IMPORTED_MODULE_9__["default"];
        }
        connectedCallback() {
            const _super = Object.create(null, {
                connectedCallback: { get: () => super.connectedCallback }
            });
            return __awaiter(this, void 0, void 0, function* () {
                _super.connectedCallback.call(this);
                window.addEventListener("resize", this.windowResize);
                if (this.agentId !== "" && this.webexEnabled) {
                    yield this.setTheme();
                }
            });
        }
        disconnectedCallback() {
            window.removeEventListener("resize", this.windowResize);
        }
        updated(changedProperties) {
            changedProperties.forEach((oldValue, propName) => __awaiter(this, void 0, void 0, function* () {
                if (propName === "showModal" && oldValue !== undefined && this.showModal) {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.WEBEX_APP_OPENED);
                    this.setFocus();
                }
                else if (this.webexEnabled &&
                    this.agentId !== "" &&
                    (propName === "darkMode" || propName === "agentId" || propName === "webexEnabled") &&
                    oldValue !== undefined) {
                    yield this.setTheme();
                }
            }));
        }
        handleCloseModal() {
            var _a, _b;
            const event = new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_1__.AGENTX_WEBEX_WRAPPER_CLOSE, {
                detail: false,
                bubbles: true,
                composed: true
            });
            this.dispatchEvent(event);
            if (_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.webex) {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.webex.getUserStatusForWebex((_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.conf) === null || _a === void 0 ? void 0 : _a.profile) === null || _b === void 0 ? void 0 : _b.agentId);
            }
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.telemetry.TELEM_EVENT.WEBEX_APP_CLOSED);
        }
        handleMinimizeRestore() {
            var _a, _b;
            const event = new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_1__.AGENTX_WEBEX_MINIMIZE_RESTORE, {
                detail: false,
                bubbles: true,
                composed: true
            });
            this.dispatchEvent(event);
            if (_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.webex) {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.webex.getUserStatusForWebex((_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_4__.SERVICE.conf) === null || _a === void 0 ? void 0 : _a.profile) === null || _b === void 0 ? void 0 : _b.agentId);
            }
        }
        setTheme() {
            return __awaiter(this, void 0, void 0, function* () {
                const reqPayload = {
                    key: "web-color-theme-name",
                    value: this.darkMode ? "default" : "light",
                    orgId: this.orgId
                };
                const accToken = sessionStorage.getItem("accessToken");
                const url = `${_config__WEBPACK_IMPORTED_MODULE_0__.CONF.WEBEX_SETTING_SERVICE}/orgsettings/users/${this.agentId}`;
                const accessToken = `Bearer ${accToken}`;
                const headers = {
                    "Content-Type": "application/json",
                    Authorization: accessToken
                };
                return axios__WEBPACK_IMPORTED_MODULE_10__["default"]
                    .post(url, reqPayload, {
                    headers
                })
                    .then((response) => {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info(`[Webex] | Webex theme change success: ${response}`);
                })
                    .catch((error) => {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error(`[Webex] | Webex Theme change failed: ${error}`);
                });
            });
        }
        setFocus() {
            setTimeout(() => {
                var _a, _b, _c, _d, _e;
                const minBtn = (_e = (_d = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".webex-wrapper-modal")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("md-button.md-floating__minimize")) === null || _d === void 0 ? void 0 : _d.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector("button");
                if (minBtn) {
                    minBtn.focus();
                }
            }, 50); //delay for modal to load
        }
        render() {
            if (this.agentEmailId !== "" && _config__WEBPACK_IMPORTED_MODULE_0__.CONF.WEBEX_APP_URL) {
                const url = this.isWebexLogoutRequested
                    ? new URL(`${_config__WEBPACK_IMPORTED_MODULE_0__.CONF.WEBEX_APP_URL}/signout`)
                    : new URL(_config__WEBPACK_IMPORTED_MODULE_0__.CONF.WEBEX_APP_URL);
                url.searchParams.set("autosignin", this.agentEmailId);
                url.searchParams.set("ccParent", "true");
                this.webexUrl = url.href;
            }
            return this.webexEnabled
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.html) `
            <md-floating-modal
              id="webex-wrapper-modal"
              class="webex-wrapper-modal"
              label=${this.webexWrapperTitle}
              resize-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:common.restoreScreenLabel")}
              maximize-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:common.maximizeScreenLabel")}
              minimize-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:common.minimizeModal")}
              close-aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_2__.t)("app:keyboardShortcutKeys.closeModal")}
              ?show=${this.showModal}
              ?minimize=${this.minimize}
              .position=${this.location}
              .minPosition=${this.minLocation}
              .containerRect=${this.containerRect}
              minimizable
              @floating-modal-close=${this.handleCloseModal}
              @floating-modal-minimize=${this.handleMinimizeRestore}
              @floating-modal-minimize-location=${this.saveMinLocation}
              @floating-modal-location=${this.saveLocation}
              @floating-modal-resize=${this.resize}
            >
              <div slot="header" class="modal-header">
                <img class="webex-img" alt=${this.webexWrapperTitle} src="${(_img_teams_icon_color_svg__WEBPACK_IMPORTED_MODULE_5___default())}" />
                ${this.minimize && this.webexMeetingTimeStamp
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.html) `
                      <md-icon slot="icon" class="camara-icon" name="icon-camera_20"></md-icon>
                      <agentx-wc-task-list-timer startTimestamp=${this.webexMeetingTimeStamp}>
                      </agentx-wc-task-list-timer>
                    `
                    : (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.html) ` ${this.webexWrapperTitle} `}
              </div>
              ${this.webexUrl !== ""
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.html) `
                    <agentx-wc-iframe
                      src="${this.webexUrl}"
                      title=${this.webexWrapperTitle}
                      allowedParams="${this.params}"
                      ?is-dark-theme="${this.darkMode}"
                    >
                    </agentx-wc-iframe>
                  `
                    : null}
            </md-floating-modal>
          `
                : null;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.property)({ type: Boolean })
    ], Element.prototype, "webexEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.property)({ type: Boolean })
    ], Element.prototype, "showModal", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.property)({ type: Boolean })
    ], Element.prototype, "darkMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.property)({ type: Boolean })
    ], Element.prototype, "minimize", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.property)({ type: String })
    ], Element.prototype, "agentId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.property)({ type: String })
    ], Element.prototype, "agentEmailId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.property)({ type: String })
    ], Element.prototype, "orgId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.property)({ type: Number })
    ], Element.prototype, "webexMeetingTimeStamp", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.property)({ type: Boolean })
    ], Element.prototype, "isWebexLogoutRequested", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.internalProperty)()
    ], Element.prototype, "params", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.internalProperty)()
    ], Element.prototype, "defaultOriginPosition", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.internalProperty)()
    ], Element.prototype, "webexUrl", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.internalProperty)()
    ], Element.prototype, "currentWindowWidth", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.internalProperty)()
    ], Element.prototype, "lessWidth", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.internalProperty)()
    ], Element.prototype, "midWidth", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.internalProperty)()
    ], Element.prototype, "defaultWidth", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.internalProperty)()
    ], Element.prototype, "initial", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.internalProperty)()
    ], Element.prototype, "webexWrapperTitle", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.internalProperty)()
    ], Element.prototype, "defaultPosition", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.property)({ type: Object })
    ], Element.prototype, "containerRect", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.property)({ type: Object })
    ], Element.prototype, "location", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.property)({ type: Object })
    ], Element.prototype, "minLocation", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_7__.customElement)("agentx-webex-wrapper")
    ], Element);
    WebexWrapper.Element = Element;
})(WebexWrapper || (WebexWrapper = {}));


/***/ }),

/***/ "./src/components/teamsListInfiniteScroll/index.ts":
/*!*********************************************************!*\
  !*** ./src/components/teamsListInfiniteScroll/index.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TeamsListInfiniteScroll: () => (/* binding */ TeamsListInfiniteScroll)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _teamsList_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./teamsList.scss */ "./src/components/teamsListInfiniteScroll/teamsList.scss");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _userStationLogin_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../userStationLogin/utils */ "./src/components/userStationLogin/utils.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _teamListItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./teamListItem */ "./src/components/teamsListInfiniteScroll/teamListItem.ts");
/* harmony import */ var _TeamPerformanceWidget_components_agentStateSelector_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../TeamPerformanceWidget/components/agentStateSelector/utils */ "./src/components/TeamPerformanceWidget/components/agentStateSelector/utils/index.ts");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_9__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};










var TeamsListInfiniteScroll;
(function (TeamsListInfiniteScroll) {
    /**
     * @element agentx-wc-teams-list-infinite
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.orgId = "";
            this.agentDbId = "";
            this.selectedTeamName = "";
            this.paginatedTeamResponse = {
                meta: {
                    links: {},
                    orgid: "",
                    page: 0,
                    pageSize: 0,
                    totalPages: 0,
                    totalRecords: 0
                },
                data: []
            };
            this.teamsMeta = "";
            this.items = [];
            this.isTeamsListModalOpen = false;
            this.currentPage = 0;
            this.totalRecords = 0;
            this.isPageLoading = false;
            this.initialLoad = false;
            this.pageFetchError = {
                isError: false,
                trackingId: ""
            };
            this.isSearchPageLoading = false;
            this.searchQuery = "";
            this.isInputInSearchMode = false;
            this.isSearchQueryTooShort = false;
            this.getFormattedTeamItems = (item) => {
                return {
                    name: item.teamName,
                    id: item.teamId,
                    index: 1,
                    ariaLabel: item.teamName,
                    template: (data) => {
                        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<team-list-item
            .isOpen=${this.isTeamsListModalOpen}
            .teamOption=${data}
            .searchTerm="${this.searchQuery}"
          ></team-list-item>`;
                    }
                };
            };
            this.setLoadingStart = (hasSearchInitiatedPageLoad = false) => {
                this.isPageLoading = true;
                if (hasSearchInitiatedPageLoad) {
                    this.isSearchPageLoading = true;
                }
            };
            this.setLoadingComplete = (hasSearchInitiatedPageLoad = false) => {
                this.isPageLoading = false;
                if (hasSearchInitiatedPageLoad) {
                    this.isSearchPageLoading = false;
                }
            };
            this.setItemsForAdvancedList = (newItems, totalRecords, isNewPage, hasSearchInitiatedPageLoad = false) => {
                if (hasSearchInitiatedPageLoad) {
                    this.items = [];
                    this.totalRecords = 0;
                    this.currentPage = 0;
                }
                this.totalRecords = totalRecords;
                this.items = isNewPage ? [...this.items, ...newItems] : newItems;
            };
            this.populateTeamList = () => {
                var _a, _b, _c;
                const defaultTeamName = (_c = (_b = (_a = this.items) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : "";
                if (this.initialLoad) {
                    this.searchQuery = this.selectedTeamName;
                    this.initialLoad = false;
                    this.selectedTeamName || (this.selectedTeamName = defaultTeamName);
                }
                if (this.searchQuery.length > 0) {
                    if (this.isSearchQueryTooShort) {
                        return;
                    }
                    else if (this.searchQuery.length < 3) {
                        this.handleShortSearch(new CustomEvent("search-too-short", { detail: this.searchQuery }));
                    }
                    else if (this.searchQuery.length >= 3) {
                        this.handleValidSearch(new CustomEvent("search-term-valid", { detail: this.searchQuery }));
                    }
                }
                else {
                    this.items = this.getItemsFromPaginatedResponse(this.paginatedTeamResponse);
                }
                if (this.isTeamsListModalOpen) {
                    const teamsMeta = JSON.parse(this.teamsMeta);
                    this.setItemsForAdvancedList(this.items, teamsMeta.totalRecords, false);
                }
                this.pageFetchError = {
                    isError: false,
                    trackingId: ""
                };
            };
            this.focusInputField = () => {
                var _a, _b, _c, _d;
                const inputElement = (_d = (_c = (_b = (_a = this.searchHandler) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("md-input")) === null || _c === void 0 ? void 0 : _c.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector("input");
                inputElement === null || inputElement === void 0 ? void 0 : inputElement.focus();
            };
            this.setFocusOnInputField = () => {
                setTimeout(() => {
                    this.focusInputField();
                }, 0);
            };
            this.tryAgainLoadTeamData = () => __awaiter(this, void 0, void 0, function* () {
                this.loadNextPage();
                this.setFocusOnInputField();
            });
            this.loadNextPage = (hasSearchInitiatedPageLoad = false) => __awaiter(this, void 0, void 0, function* () {
                if (!this.isTeamsListModalOpen) {
                    return;
                }
                try {
                    this.setLoadingStart(hasSearchInitiatedPageLoad);
                    if (hasSearchInitiatedPageLoad) {
                        this.isInputInSearchMode = true;
                    }
                    const { formattedListItems, totalRecords } = yield this.getTeamList(this.currentPage, this.searchQuery);
                    if (this.isTeamsListModalOpen && (this.isInputInSearchMode || !this.isSearchQueryTooShort)) {
                        this.setItemsForAdvancedList(formattedListItems, totalRecords, true, hasSearchInitiatedPageLoad);
                    }
                    this.setLoadingComplete(hasSearchInitiatedPageLoad);
                    this.pageFetchError = {
                        isError: false,
                        trackingId: ""
                    };
                    if (hasSearchInitiatedPageLoad && this.items.length > 0) {
                        this.isInputInSearchMode = false;
                    }
                }
                catch (error) {
                    this.setLoadingComplete(hasSearchInitiatedPageLoad);
                    this.pageFetchError = {
                        isError: true,
                        trackingId: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.getTrackingIdFromErrorObject)(error) : ""
                    };
                    _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.error("event=loadNextPage | Error on fetching teams on station login module", error);
                }
                finally {
                    this.setLoadingComplete(hasSearchInitiatedPageLoad);
                }
            });
            this.handleListItemChange = (event) => {
                const selectedValue = this.getSelectedTeam(event.detail.selected[0]);
                /** Send the updated team details to user profile */
                this.selectedTeamName = selectedValue.name;
                this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_6__.TEAM_SELECT_EVENT, {
                    detail: { teamId: selectedValue.id, teamName: selectedValue.name },
                    bubbles: true,
                    composed: true
                }));
                this.searchQuery = this.selectedTeamName;
                this.toggleMenuOverlay(false);
            };
            this.setPageAndLoadData = () => {
                if (this.isPageLoading || this.items.length === 0) {
                    return;
                }
                this.currentPage += 1;
                this.loadNextPage();
            };
            this.handleSearchInputKeyDown = (event) => {
                const srcEvent = event.detail.srcEvent;
                if (srcEvent && srcEvent.key === "Tab" && srcEvent.shiftKey) {
                    event.detail.srcEvent.preventDefault();
                    // Focus to the md-advance-list-container
                    this.focusListComponent();
                }
            };
        }
        static get styles() {
            return [_teamsList_scss__WEBPACK_IMPORTED_MODULE_2__["default"]];
        }
        connectedCallback() {
            super.connectedCallback();
            this.initialLoad = true;
        }
        getItemsFromPaginatedResponse(paginatedTeamResponse) {
            return paginatedTeamResponse.data.map((item) => this.getFormattedTeamItems(item));
        }
        resetPropertiesForDisplay() {
            this.items = [];
            this.currentPage = 0;
            this.totalRecords = 0;
            this.pageFetchError = {
                isError: false,
                trackingId: ""
            };
            this.isInputInSearchMode = false;
        }
        onMenuOverlayClose(event) {
            event.stopPropagation();
            this.resetPropertiesForDisplay();
            this.isPageLoading = false;
            this.isSearchPageLoading = false;
            this.isTeamsListModalOpen = false;
        }
        onMenuOverlayOpen(event) {
            event.stopPropagation();
            this.isTeamsListModalOpen = true;
            this.populateTeamList();
            this.setFocusOnInputField();
        }
        getTeamList(page, searchQuery = "") {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield (0,_userStationLogin_utils__WEBPACK_IMPORTED_MODULE_4__.fetchTeamList)(this.orgId, page, this.agentDbId, searchQuery);
                    const formattedListItems = response.data.map((item) => this.getFormattedTeamItems(item));
                    return { formattedListItems, totalRecords: response.meta.totalRecords };
                }
                catch (error) {
                    _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.error("event=getTeamList | Error on fetching idle codes on Team Performance Widget Agent State Change Module", error);
                    throw error;
                }
            });
        }
        getSelectedTeamId(teamList) {
            const selectedTeamId = teamList === null || teamList === void 0 ? void 0 : teamList.find((team) => {
                return team.name === this.selectedTeamName;
            });
            return (selectedTeamId === null || selectedTeamId === void 0 ? void 0 : selectedTeamId.id) || "";
        }
        getSelectedTeam(teamId) {
            var _a;
            return (_a = this.items) === null || _a === void 0 ? void 0 : _a.find((team) => {
                return team.id === teamId;
            });
        }
        toggleMenuOverlay(toOpen) {
            const searchInputElement = this.menuOverlay.children[0];
            if (searchInputElement) {
                searchInputElement.click();
            }
            this.isTeamsListModalOpen = toOpen;
        }
        getStatusIndicator() {
            if (this.items.length > 0) {
                if (this.isPageLoading) {
                    return [
                        {
                            id: "status-indicator",
                            name: "loading",
                            template: () => (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<div class="infinite-scroll-spinner" part="spinner"><md-spinner size="18"></md-spinner></div>`
                        }
                    ];
                }
                if (this.pageFetchError.isError) {
                    return [
                        {
                            id: "status-indicator",
                            name: "error",
                            template: () => (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<agent-state-selector-list-error
                  class="fetch-error"
                  style="color: red;"
                  trackingId="${this.pageFetchError.trackingId}"
                  @error-retry="${this.loadNextPage}"
                >
                </agent-state-selector-list-error>`
                        }
                    ];
                }
            }
            return [];
        }
        renderList() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-advance-list
          .items=${this.items.concat(this.getStatusIndicator())}
          .value=${[this.getSelectedTeamId(this.items)]}
          .isLoading=${this.isPageLoading}
          .isError=${this.pageFetchError.isError}
          .focusReset=${!this.isTeamsListModalOpen || this.isPageLoading}
          containerHeight=${(0,_TeamPerformanceWidget_components_agentStateSelector_utils__WEBPACK_IMPORTED_MODULE_8__.getDynamicHeight)(this.items.length || 1)}
          ariaRoleList="listbox"
          ariaLabelList="Team list"
          totalRecords=${this.totalRecords}
          @list-item-change=${this.handleListItemChange}
          @load-more=${this.setPageAndLoadData}
        ></md-advance-list>
      `;
        }
        renderErrorOrLoading() {
            if (this.items.length === 0) {
                if (this.isPageLoading && (this.isInputInSearchMode || !this.isSearchQueryTooShort)) {
                    return (0,_TeamPerformanceWidget_components_agentStateSelector_utils__WEBPACK_IMPORTED_MODULE_8__.renderLoadingState)();
                }
                if (this.pageFetchError.isError) {
                    return (0,_TeamPerformanceWidget_components_agentStateSelector_utils__WEBPACK_IMPORTED_MODULE_8__.renderErrorState)((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorDetail:errorTitle"), (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorDetail:reloadButton"), this.tryAgainLoadTeamData);
                }
            }
            if (this.isSearchQueryTooShort) {
                return (0,_TeamPerformanceWidget_components_agentStateSelector_utils__WEBPACK_IMPORTED_MODULE_8__.renderSearchError)((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.teamsSearchError") || "Enter a minimum of three characters to search for teams.");
            }
            if (this.isInputInSearchMode) {
                return (0,_TeamPerformanceWidget_components_agentStateSelector_utils__WEBPACK_IMPORTED_MODULE_8__.renderNoMatchFound)((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common:nomatchfound"));
            }
            return lit_html__WEBPACK_IMPORTED_MODULE_9__.nothing;
        }
        handleSearchCleared(event) {
            this.dispatchEvent(new CustomEvent(_constants__WEBPACK_IMPORTED_MODULE_6__.TEAM_SELECT_EVENT, {
                detail: {},
                bubbles: true,
                composed: true
            }));
            this.resetPropertiesForDisplay();
            this.items = this.getItemsFromPaginatedResponse(this.paginatedTeamResponse);
            const teamsMeta = JSON.parse(this.teamsMeta);
            this.setItemsForAdvancedList(this.items, teamsMeta.totalRecords, false);
            this.searchQuery = event.detail;
            this.isSearchQueryTooShort = false;
            this.setFocusOnInputField();
        }
        handleValidSearch(event) {
            this.resetPropertiesForDisplay();
            if (!this.isTeamsListModalOpen) {
                this.toggleMenuOverlay(true);
            }
            this.searchQuery = event.detail;
            this.isSearchQueryTooShort = false;
            this.loadNextPage(true);
            this.setFocusOnInputField();
        }
        handleShortSearch(event) {
            this.resetPropertiesForDisplay();
            if (!this.isTeamsListModalOpen) {
                this.toggleMenuOverlay(true);
            }
            this.searchQuery = event.detail;
            this.isSearchQueryTooShort = true;
            this.setFocusOnInputField();
        }
        focusListComponent() {
            var _a, _b;
            const currentSelectedItem = (_b = (_a = this.listElement) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector(".md-advance-list-wrapper");
            setTimeout(() => {
                currentSelectedItem === null || currentSelectedItem === void 0 ? void 0 : currentSelectedItem.focus();
            }, 0);
        }
        renderSearchInput() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<search-input
        presetValue=${this.selectedTeamName}
        slot="menu-trigger"
        .isPageLoading=${this.isPageLoading}
        .isSearchPageLoading=${this.isSearchPageLoading}
        .reset=${false}
        placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.selectTeam")}"
        ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.selectTeam")}"
        @input-keydown="${this.handleSearchInputKeyDown}"
        @search-cleared="${this.handleSearchCleared}"
        @search-term-valid="${this.handleValidSearch}"
        @search-too-short="${this.handleShortSearch}"
      >
      </search-input>`;
        }
        render() {
            const res = this.renderErrorOrLoading();
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="teams-list-infinite">
          <md-menu-overlay
            max-height="calc(100vh - 266.5px)"
            position="bottom"
            @menu-overlay-open=${(event) => {
                this.onMenuOverlayOpen(event);
            }}
            @menu-overlay-close=${(event) => {
                this.onMenuOverlayClose(event);
            }}
          >
            ${this.renderSearchInput()} ${this.renderList()}
            ${res !== lit_html__WEBPACK_IMPORTED_MODULE_9__.nothing ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<div class="state-div">${this.renderErrorOrLoading()}</div>` : ""}
          </md-menu-overlay>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "orgId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "agentDbId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "selectedTeamName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "paginatedTeamResponse", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "teamsMeta", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "items", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isTeamsListModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "currentPage", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "totalRecords", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isPageLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "initialLoad", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "pageFetchError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isSearchPageLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "searchQuery", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isInputInSearchMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isSearchQueryTooShort", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.query)("md-advance-list")
    ], Element.prototype, "listElement", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.query)("search-input")
    ], Element.prototype, "searchHandler", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.query)("md-menu-overlay")
    ], Element.prototype, "menuOverlay", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("agentx-wc-teams-list-infinite")
    ], Element);
    TeamsListInfiniteScroll.Element = Element;
})(TeamsListInfiniteScroll || (TeamsListInfiniteScroll = {}));


/***/ }),

/***/ "./src/components/teamsListInfiniteScroll/teamListItem.ts":
/*!****************************************************************!*\
  !*** ./src/components/teamsListInfiniteScroll/teamListItem.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TeamListItem: () => (/* binding */ TeamListItem)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _teamsList_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./teamsList.scss */ "./src/components/teamsListInfiniteScroll/teamsList.scss");
/* harmony import */ var _Common_Utils_HighlightText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Common/Utils/HighlightText */ "./src/components/Common/Utils/HighlightText.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var TeamListItem;
(function (TeamListItem) {
    /**
     * @element team-list-item
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.isOpen = false;
            this.teamOption = {
                name: "",
                id: ""
            };
            this.searchTerm = "";
            this.isTextOverflow = false;
        }
        static get styles() {
            return _teamsList_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
        }
        render() {
            const text = this.teamOption.name;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-tooltip placement="top" message=${text} ?disabled=${!this.isTextOverflow}>
          <div class="team-list-item-text ellipsis-text">${(0,_Common_Utils_HighlightText__WEBPACK_IMPORTED_MODULE_3__.highlightText)(text, this.searchTerm)}</div>
        </md-tooltip>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "isOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "teamOption", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], Element.prototype, "searchTerm", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isTextOverflow", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("team-list-item")
    ], Element);
    TeamListItem.Element = Element;
})(TeamListItem || (TeamListItem = {}));


/***/ }),

/***/ "./src/components/teamsListInfiniteScroll/teamsList.scss":
/*!***************************************************************!*\
  !*** ./src/components/teamsListInfiniteScroll/teamsList.scss ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

.teams-list-infinite md-advance-list {
  width: 100%;
  min-height: fit-content;
  max-height: 292px;
}
.teams-list-infinite md-advance-list::part(advance-list-item-wrapper) {
  padding: calc(var(--space-token-even) * 4) calc(var(--space-token-even) * 6);
}
.teams-list-infinite :host(team-list-item) {
  display: flex;
}
.teams-list-infinite md-advance-list::part(spinner) {
  display: flex;
  justify-content: center;
  margin-top: 5px;
}
.teams-list-infinite md-menu-overlay::part(overlay) {
  top: -13px !important;
  width: 100% !important;
}
.teams-list-infinite md-menu-overlay::part(overlay-content) {
  width: 100% !important;
}
.teams-list-infinite .team-list-item-text {
  display: block;
  font-size: var(--font-size-medium);
  padding: 0 0 0 calc(var(--space-token-cardinal) * 2);
  width: var(--full-menu-item-width);
}
.teams-list-infinite .ellipsis-text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.teams-list-infinite .highlight-span {
  display: inline-table;
}
.teams-list-infinite .state-loading {
  height: 100px;
  min-height: 100px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.teams-list-infinite .state-error {
  padding: calc(var(--space-token-even) * 15) 0 calc(var(--space-token-even) * 8) 0;
  display: grid;
}
.teams-list-infinite .state-error .error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.teams-list-infinite .state-error .error-title {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  font-weight: 600;
  text-align: center;
  padding: 0;
  color: var(--list-text-color, #121212);
}
.teams-list-infinite .state-error .error-subtitle {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  text-align: center;
  padding: 0;
}
.teams-list-infinite .state-error .error-cloud-wrapper {
  height: auto;
}
.teams-list-infinite .state-error .error-cloud-wrapper::part(container) {
  background-color: var(--md-secondary-white-bg-color);
}
.teams-list-infinite .state-error .error-cloud-wrapper::part(img) {
  display: block;
  margin: auto;
  width: auto;
}
.teams-list-infinite .state-error md-button {
  margin: calc(var(--space-token-even) * 12) auto auto auto;
}
.teams-list-infinite .search-block-error {
  display: flex;
  align-items: center;
  padding: calc(var(--space-token-even) * 8);
}
.teams-list-infinite .search-error {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  font-size: var(--font-size-small);
}
.teams-list-infinite .state-no-match {
  padding: calc(var(--space-token-even) * 12) calc(var(--space-token-even) * 12);
  position: relative;
  text-align: center;
}
.teams-list-infinite .state-no-match .empty-title {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  margin-bottom: auto;
  color: var(--list-text-color, #121212);
}
.teams-list-infinite .state-no-match .empty-state-wrapper::part(container) {
  background-color: var(--md-secondary-white-bg-color);
}
.teams-list-infinite .state-no-match .empty-state-wrapper::part(img) {
  display: block;
  margin: auto;
  width: auto;
}
.teams-list-infinite md-menu-overlay search-input::part(search-input-wrapper) {
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
}
.teams-list-infinite .state-div {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  max-height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--md-secondary-white-bg-color);
  border-radius: var(--border-radius-medium);
  box-shadow: var(--common-box-shadow);
  min-height: 100px;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=teamsList.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/teamsListInfiniteScroll/teamsList.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/userProfile/userProfile.scss":
/*!*****************************************************!*\
  !*** ./src/components/userProfile/userProfile.scss ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  --font-weight: var(--brand-font-weight-regular, 400);
  --font-weight-medium: var(--brand-font-weight-regular, 500);
  /* Font family */
  --font-family-bold: var(--brand-font-bold, "CiscoSansTT Bold");
  --font-family:
    var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-30: #d2d5d6;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* scroll bar */
  --scrollbar-width: 6px;
  --scrollbar-height: 8px;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
  --tpw-filter-height: 0px;
  --webkit-box-shadow: 0 0 1px rgba(84, 84, 84, 1);
  /* Gap and padding */
  --gap-4: 4px;
  --gap-8: 8px;
  --gap-12: 12px;
  /* Widths and heights*/
  --length-4: 4px;
  --length-20: 20px;
  --length-24: 24px;
  --length-32: 32px;
}

md-modal::part(modal-body) {
  overflow: visible;
}

.error-message {
  padding-left: 4px;
  margin-top: calc(var(--space-token-even) * 4);
}

.md-loading {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

.form {
  align-items: stretch;
  display: flex;
  flex-direction: column;
}

.sl-phone-format-container {
  display: flex;
}

.sl-phone-format-option {
  padding: 1em 1em 0.25em 0;
}

.sl-dn-input {
  margin-bottom: 1.5em;
}

.sl-tabs-container {
  height: auto;
}

.modal-content {
  padding: 0 24px;
}

.phone-format {
  padding: 16px 0 8px;
  color: var(--md-primary-text-color, #171b1f);
}
.phone-format md-radio {
  display: inline-block;
  margin-right: 14px;
}

.station-login-radio {
  color: var(--md-primary-text-color, #171b1f);
}
.station-login-radio md-radiogroup {
  display: inline-block;
  margin: 16px 0;
}

md-link::part(link) {
  color: var(--link-default);
  font-size: 12px;
}

.emergency-help-tooltip md-button::part(button) {
  width: 0;
  height: 0;
  margin: 5px 14px 0 5px;
}

.browser-label-container-emergency md-tooltip::part(tooltip_reference), .browser-label-container-emergency-helpText md-tooltip::part(tooltip_reference), .browser-label-container md-tooltip::part(tooltip_reference) {
  display: flex;
}

.station-login-radio-min md-radio:nth-child(1) {
  margin-right: 4rem;
}
.station-login-radio-min md-radio:nth-child(2) {
  margin-right: 0;
}

.station-login-radio-max md-radio::part(radio-label) {
  white-space: normal;
}
.station-login-radio-max md-radio::part(radio-wrapper) {
  max-height: 4rem;
}
.station-login-radio-max md-radio {
  margin-right: 1rem;
}

.remember-me-checkbox-wrapper {
  padding-top: 24px;
}

.remember-me-checkbox::part(checkbox-label) {
  z-index: 0;
}

.extension-format {
  padding-top: 5px;
}

.sl-combobox {
  color: var(--md-primary-text-color, #171b1f);
  padding: 0 2px;
}

.roles-combobox {
  margin-bottom: 20px;
}

.btn-submit {
  display: flex;
  justify-content: flex-end;
}

.teams-label {
  padding: 0 0 10px;
}

.footer-btn {
  margin-left: 0.75rem;
}

.browser-label-container-emergency, .browser-label-container-emergency-helpText, .browser-label-container {
  color: var(--md-secondary-text-color);
}

.browser-label-container {
  margin-bottom: 24px;
}

.browser-label-container-emergency-helpText {
  font-size: 12px;
  margin-top: 8px;
  margin-bottom: 24px;
}

@media screen and (max-height: 540px) {
  md-modal::part(modal-container) {
    max-height: calc(100vh - 2%);
  }
  md-modal::part(modal-content) {
    min-height: 100%;
    max-height: 100vh;
    overflow-y: auto;
  }
}
.phone-format md-radio::part(radio-label) {
  width: fit-content;
  max-width: 140px;
}

.info-icon {
  vertical-align: sub;
  margin-left: calc(var(--space-token-even) * 1.5);
}

.international-checkbox-wrapper {
  display: flex;
  color: var(--md-primary-text-color, #171b1f);
}
.international-checkbox-wrapper md-checkbox {
  margin-bottom: 12px;
}

.dial-number-label {
  display: flex;
}

.label-with-bottom-margin {
  margin-bottom: 10px;
}

md-phone-input::part(combobox) {
  width: 114px;
}
md-phone-input::part(md-input) {
  width: 100%;
}
md-phone-input::part(option) {
  justify-content: space-between;
}

.read-the-notification-wrapper {
  padding: 16px 2px 2px;
}

.read-the-notification::part(checkbox-label) {
  z-index: 0;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/assets/styles/variables.scss */
/*# sourceURL=userProfile.scss */
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/userProfile/userProfile.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2Fzc2V0cy9zdHlsZXMvdmFyaWFibGVzLnNjc3MiLCJ1c2VyUHJvZmlsZS5zY3NzIiwiL2hvbWUvamVua2lucy9hZ2VudC93b3Jrc3BhY2Uvd3hjYy1zZXJ2aWNlLW1hbmFnZW1lbnQvd3hjYy1zZXJ2aWNlLW1hbmFnZW1lbnQvcGFja2FnZXMvYWdlbnR4LW1mZS13Yy1iYXNlZC9zcmMvY29tcG9uZW50cy91c2VyUHJvZmlsZS91c2VyUHJvZmlsZS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsY0FBQTtFQUNBLHVCQUFBO0VBQ0Esd0JBQUE7RUFDQSx1QkFBQTtFQUVBLG1CQUFBO0VBQ0EsMkJBQUE7RUFDQSx1QkFBQTtFQUNBLDRCQUFBO0VBRUEsWUFBQTtFQUNBLDBCQUFBO0VBRUEsZ0JBQUE7RUFDQSx1QkFBQTtFQUNBLG9EQUFBO0VBQ0EsMkRBQUE7RUFFQSxnQkFBQTtFQUNBLDhEQUFBO0VBQ0E7O2NBQUE7RUFHQSxpSEFBQTtFQUVBLFdBQUE7RUFDQSw0QkFBQTtFQUNBLHdCQUFBO0VBQ0Esd0JBQUE7RUFDQSx3QkFBQTtFQUNBLHlCQUFBO0VBQ0Esd0JBQUE7RUFDQSxxQkFBQTtFQUNBLDZCQUFBO0VBQ0EseUJBQUE7RUFDQSwyQkFBQTtFQUNBLGlDQUFBO0VBRUEsa0JBQUE7RUFDQSwwQkFBQTtFQUNBLDJCQUFBO0VBQ0EsMkJBQUE7RUFDQSw0QkFBQTtFQUVBLGNBQUE7RUFDQSxtREFBQTtFQUNBLG1DQUFBO0VBQ0EsaUNBQUE7RUFFQSxlQUFBO0VBQ0Esc0JBQUE7RUFDQSx1QkFBQTtFQUVBLGVBQUE7RUFDQSxpREFBQTtFQUNBLGdEQUFBO0VBQ0Esd0JBQUE7RUFDQSxnREFBQTtFQUVBLG9CQUFBO0VBQ0EsWUFBQTtFQUNBLFlBQUE7RUFDQSxjQUFBO0VBRUEsc0JBQUE7RUFDQSxlQUFBO0VBQ0EsaUJBQUE7RUFDQSxpQkFBQTtFQUNBLGlCQUFBO0FDVkY7O0FDN0NBO0VBQ0UsaUJBQUE7QURnREY7O0FDN0NBO0VBQ0UsaUJBQUE7RUFDQSw2Q0FBQTtBRGdERjs7QUM3Q0E7RUFDRSxTQXRCUztFQXVCVCxrQkFBQTtFQUNBLFFBeEJTO0VBeUJULGdDQUFBO0FEZ0RGOztBQzFDQTtFQUNFLG9CQUFBO0VBQ0EsYUFBQTtFQUNBLHNCQUFBO0FENkNGOztBQzFDQTtFQUNFLGFBQUE7QUQ2Q0Y7O0FDMUNBO0VBQ0UseUJBQUE7QUQ2Q0Y7O0FDMUNBO0VBQ0Usb0JBQUE7QUQ2Q0Y7O0FDMUNBO0VBQ0UsWUFBQTtBRDZDRjs7QUMxQ0E7RUFDRSxlQUFBO0FENkNGOztBQzFDQTtFQUNFLG1CQUFBO0VBQ0EsNENBQUE7QUQ2Q0Y7QUMzQ0U7RUFDRSxxQkFBQTtFQUNBLGtCQXJEZTtBRGtHbkI7O0FDekNBO0VBQ0UsNENBQUE7QUQ0Q0Y7QUMzQ0U7RUFDRSxxQkFBQTtFQUNBLGNBQUE7QUQ2Q0o7O0FDekNBO0VBQ0UsMEJBQUE7RUFDQSxlQUFBO0FENENGOztBQ3hDRTtFQUNFLFFBQUE7RUFDQSxTQUFBO0VBQ0Esc0JBQUE7QUQyQ0o7O0FDdENFO0VBQ0UsYUFBQTtBRHlDSjs7QUNwQ0U7RUFDRSxrQkFBQTtBRHVDSjtBQ3BDRTtFQUNFLGVBQUE7QURzQ0o7O0FDakNFO0VBQ0UsbUJBQUE7QURvQ0o7QUNsQ0U7RUFDRSxnQkFBQTtBRG9DSjtBQ2pDRTtFQUNFLGtCQUFBO0FEbUNKOztBQy9CQTtFQUNFLGlCQUFBO0FEa0NGOztBQy9CQTtFQUNFLFVBQUE7QURrQ0Y7O0FDL0JBO0VBQ0UsZ0JBQUE7QURrQ0Y7O0FDL0JBO0VBQ0UsNENBQUE7RUFDQSxjQUFBO0FEa0NGOztBQy9CQTtFQUNFLG1CQUFBO0FEa0NGOztBQy9CQTtFQUNFLGFBQUE7RUFDQSx5QkFBQTtBRGtDRjs7QUMvQkE7RUFDRSxpQkFBQTtBRGtDRjs7QUMvQkE7RUFDRSxvQkFBQTtBRGtDRjs7QUMvQkE7RUFDRSxxQ0FBQTtBRGtDRjs7QUMvQkE7RUFFRSxtQkFBQTtBRGlDRjs7QUM5QkE7RUFFRSxlQUFBO0VBQ0EsZUFBQTtFQUNBLG1CQUFBO0FEZ0NGOztBQzdCQTtFQUNFO0lBQ0UsNEJBQUE7RURnQ0Y7RUM3QkE7SUFDRSxnQkFBQTtJQUNBLGlCQUFBO0lBQ0EsZ0JBQUE7RUQrQkY7QUFDRjtBQzVCQTtFQUNFLGtCQUFBO0VBQ0EsZ0JBQUE7QUQ4QkY7O0FDM0JBO0VBQ0UsbUJBQUE7RUFDQSxnREFBQTtBRDhCRjs7QUMzQkE7RUFDRSxhQUFBO0VBQ0EsNENBQUE7QUQ4QkY7QUM1QkU7RUFDRSxtQkFBQTtBRDhCSjs7QUMxQkE7RUFDRSxhQUFBO0FENkJGOztBQzFCQTtFQUNFLG1CQUFBO0FENkJGOztBQ3pCRTtFQUNFLFlBQUE7QUQ0Qko7QUN6QkU7RUFDRSxXQUFBO0FEMkJKO0FDeEJFO0VBQ0UsOEJBQUE7QUQwQko7O0FDdEJBO0VBQ0UscUJBQUE7QUR5QkY7O0FDdEJBO0VBQ0UsVUFBQTtBRHlCRiIsImZpbGUiOiJ1c2VyUHJvZmlsZS5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3Qge1xuICAvKiBGb250IFNpemUgKi9cbiAgLS1mb250LXNpemUtc21hbGw6IDEycHg7XG4gIC0tZm9udC1zaXplLW1lZGl1bTogMTRweDtcbiAgLS1mb250LXNpemUtbGFyZ2U6IDE2cHg7XG5cbiAgLyogU3BhY2luZyB0b2tlbnMgKi9cbiAgLS1zcGFjZS10b2tlbi1jYXJkaW5hbDogNXB4O1xuICAtLXNwYWNlLXRva2VuLWV2ZW46IDJweDtcbiAgLS1zcGFjZS1lcnJvci1pbnB1dDogNHB4IDhweDtcblxuICAvKiBIZWlnaHRzICovXG4gIC0tZXJyb3ItaW5wdXQtaGVpZ2h0OiAzMnB4O1xuXG4gIC8qIEZvbnQgV2VpZ2h0ICovXG4gIC0tZm9udC13ZWlnaHQtbGl0ZTogMzAwO1xuICAtLWZvbnQtd2VpZ2h0OiB2YXIoLS1icmFuZC1mb250LXdlaWdodC1yZWd1bGFyLCA0MDApO1xuICAtLWZvbnQtd2VpZ2h0LW1lZGl1bTogdmFyKC0tYnJhbmQtZm9udC13ZWlnaHQtcmVndWxhciwgNTAwKTtcblxuICAvKiBGb250IGZhbWlseSAqL1xuICAtLWZvbnQtZmFtaWx5LWJvbGQ6IHZhcigtLWJyYW5kLWZvbnQtYm9sZCwgXCJDaXNjb1NhbnNUVCBCb2xkXCIpO1xuICAtLWZvbnQtZmFtaWx5OlxuICAgIHZhcigtLWJyYW5kLWZvbnQtcmVndWxhciwgXCJDaXNjb1NhbnNUVCBSZWd1bGFyXCIpLCBcIkNpc2NvU2Fuc1RUIFJlZ3VsYXJcIiwgXCJIZWx2ZXRpY2EgTmV1ZVwiLCBIZWx2ZXRpY2EsIEFyaWFsLFxuICAgIHNhbnMtc2VyaWY7XG4gIC0tZm9udC1mYW1pbHktbGlnaHQ6IHZhcigtLWJyYW5kLWZvbnQtbGlnaHQsIFwiQ2lzY29TYW5zVFQgTGlnaHRcIiksIFwiSGVsdmV0aWNhIE5ldWVcIiwgSGVsdmV0aWNhLCBBcmlhbCwgc2Fucy1zZXJpZjtcblxuICAvKiBDb2xvcnMgKi9cbiAgLS1saWdodC1ncmVlbi1jb2xvcjogIzQ0Y2Y1MDtcbiAgLS1jb2xvci1ncmF5LTEwOiAjZWRlZGVkO1xuICAtLWNvbG9yLWdyYXktMzA6ICNkMmQ1ZDY7XG4gIC0tY29sb3ItZ3JheS03MDogIzU0NTQ1NDtcbiAgLS1jb2xvci1ncmF5LTEwMDogIzEyMTIxMjtcbiAgLS1jb2xvci1ibHVlLTcwOiAjMDA1ZTdkO1xuICAtLWNvbG9yLWxpbms6ICMwMGEwZDE7XG4gIC0tY29sb3ItZXJyb3ItZGV0YWlsOiAjNTM1NzU5O1xuICAtLWNvbG9yLWdyYXktYm9yZGVyOiAjY2NjO1xuICAtLWNvbG9yLWVycm9yLXRleHQ6ICNhMTI1MTI7XG4gIC0tY29sb3ItY291bnQtbm90aWZpY2F0aW9uczogI2ZmZjtcblxuICAvKiBCb3JkZXIgcmFkaXVzICovXG4gIC0tYm9yZGVyLXJhZGl1cy1zbWFsbDogNHB4O1xuICAtLWJvcmRlci1yYWRpdXMtbWVkaXVtOiA4cHg7XG4gIC0tYm9yZGVyLXJhZGl1cy1sYXJnZTogMTJweDtcbiAgLS1ib3JkZXItcmFkaXVzLWNpcmNsZTogMTAwJTtcblxuICAvKiBBbmltYXRpb24gKi9cbiAgLS1lYXNlLWluLW91dC1xdWludDogY3ViaWMtYmV6aWVyKDAuODMsIDAsIDAuMTcsIDEpO1xuICAtLWRlZmF1bHQtYW5pbWF0aW9uLWR1cmF0aW9uOiAzMDBtcztcbiAgLS1xdWljay1hbmltYXRpb24tZHVyYXRpb246IDE1MG1zO1xuXG4gIC8qIHNjcm9sbCBiYXIgKi9cbiAgLS1zY3JvbGxiYXItd2lkdGg6IDZweDtcbiAgLS1zY3JvbGxiYXItaGVpZ2h0OiA4cHg7XG5cbiAgLyogQm94IHNoYWRvdyAqL1xuICAtLWJveC1zaGFkb3c6IDAgMCA0cHggMnB4IHJnYmEoMCwgMTYwLCAyMDksIDAuNzUpO1xuICAtLWJveC1zaGFkb3ctZ3JheTogMCA0cHggOHB4IHJnYmEoMCwgMCwgMCwgMC4wOCk7XG4gIC0tdHB3LWZpbHRlci1oZWlnaHQ6IDBweDtcbiAgLS13ZWJraXQtYm94LXNoYWRvdzogMCAwIDFweCByZ2JhKDg0LCA4NCwgODQsIDEpO1xuXG4gIC8qIEdhcCBhbmQgcGFkZGluZyAqL1xuICAtLWdhcC00OiA0cHg7XG4gIC0tZ2FwLTg6IDhweDtcbiAgLS1nYXAtMTI6IDEycHg7XG5cbiAgLyogV2lkdGhzIGFuZCBoZWlnaHRzKi9cbiAgLS1sZW5ndGgtNDogNHB4O1xuICAtLWxlbmd0aC0yMDogMjBweDtcbiAgLS1sZW5ndGgtMjQ6IDI0cHg7XG4gIC0tbGVuZ3RoLTMyOiAzMnB4O1xufVxuIiwiOmhvc3Qge1xuICAvKiBGb250IFNpemUgKi9cbiAgLS1mb250LXNpemUtc21hbGw6IDEycHg7XG4gIC0tZm9udC1zaXplLW1lZGl1bTogMTRweDtcbiAgLS1mb250LXNpemUtbGFyZ2U6IDE2cHg7XG4gIC8qIFNwYWNpbmcgdG9rZW5zICovXG4gIC0tc3BhY2UtdG9rZW4tY2FyZGluYWw6IDVweDtcbiAgLS1zcGFjZS10b2tlbi1ldmVuOiAycHg7XG4gIC0tc3BhY2UtZXJyb3ItaW5wdXQ6IDRweCA4cHg7XG4gIC8qIEhlaWdodHMgKi9cbiAgLS1lcnJvci1pbnB1dC1oZWlnaHQ6IDMycHg7XG4gIC8qIEZvbnQgV2VpZ2h0ICovXG4gIC0tZm9udC13ZWlnaHQtbGl0ZTogMzAwO1xuICAtLWZvbnQtd2VpZ2h0OiB2YXIoLS1icmFuZC1mb250LXdlaWdodC1yZWd1bGFyLCA0MDApO1xuICAtLWZvbnQtd2VpZ2h0LW1lZGl1bTogdmFyKC0tYnJhbmQtZm9udC13ZWlnaHQtcmVndWxhciwgNTAwKTtcbiAgLyogRm9udCBmYW1pbHkgKi9cbiAgLS1mb250LWZhbWlseS1ib2xkOiB2YXIoLS1icmFuZC1mb250LWJvbGQsIFwiQ2lzY29TYW5zVFQgQm9sZFwiKTtcbiAgLS1mb250LWZhbWlseTpcbiAgICB2YXIoLS1icmFuZC1mb250LXJlZ3VsYXIsIFwiQ2lzY29TYW5zVFQgUmVndWxhclwiKSwgXCJDaXNjb1NhbnNUVCBSZWd1bGFyXCIsIFwiSGVsdmV0aWNhIE5ldWVcIiwgSGVsdmV0aWNhLCBBcmlhbCxcbiAgICBzYW5zLXNlcmlmO1xuICAtLWZvbnQtZmFtaWx5LWxpZ2h0OiB2YXIoLS1icmFuZC1mb250LWxpZ2h0LCBcIkNpc2NvU2Fuc1RUIExpZ2h0XCIpLCBcIkhlbHZldGljYSBOZXVlXCIsIEhlbHZldGljYSwgQXJpYWwsIHNhbnMtc2VyaWY7XG4gIC8qIENvbG9ycyAqL1xuICAtLWxpZ2h0LWdyZWVuLWNvbG9yOiAjNDRjZjUwO1xuICAtLWNvbG9yLWdyYXktMTA6ICNlZGVkZWQ7XG4gIC0tY29sb3ItZ3JheS0zMDogI2QyZDVkNjtcbiAgLS1jb2xvci1ncmF5LTcwOiAjNTQ1NDU0O1xuICAtLWNvbG9yLWdyYXktMTAwOiAjMTIxMjEyO1xuICAtLWNvbG9yLWJsdWUtNzA6ICMwMDVlN2Q7XG4gIC0tY29sb3ItbGluazogIzAwYTBkMTtcbiAgLS1jb2xvci1lcnJvci1kZXRhaWw6ICM1MzU3NTk7XG4gIC0tY29sb3ItZ3JheS1ib3JkZXI6ICNjY2M7XG4gIC0tY29sb3ItZXJyb3ItdGV4dDogI2ExMjUxMjtcbiAgLS1jb2xvci1jb3VudC1ub3RpZmljYXRpb25zOiAjZmZmO1xuICAvKiBCb3JkZXIgcmFkaXVzICovXG4gIC0tYm9yZGVyLXJhZGl1cy1zbWFsbDogNHB4O1xuICAtLWJvcmRlci1yYWRpdXMtbWVkaXVtOiA4cHg7XG4gIC0tYm9yZGVyLXJhZGl1cy1sYXJnZTogMTJweDtcbiAgLS1ib3JkZXItcmFkaXVzLWNpcmNsZTogMTAwJTtcbiAgLyogQW5pbWF0aW9uICovXG4gIC0tZWFzZS1pbi1vdXQtcXVpbnQ6IGN1YmljLWJlemllcigwLjgzLCAwLCAwLjE3LCAxKTtcbiAgLS1kZWZhdWx0LWFuaW1hdGlvbi1kdXJhdGlvbjogMzAwbXM7XG4gIC0tcXVpY2stYW5pbWF0aW9uLWR1cmF0aW9uOiAxNTBtcztcbiAgLyogc2Nyb2xsIGJhciAqL1xuICAtLXNjcm9sbGJhci13aWR0aDogNnB4O1xuICAtLXNjcm9sbGJhci1oZWlnaHQ6IDhweDtcbiAgLyogQm94IHNoYWRvdyAqL1xuICAtLWJveC1zaGFkb3c6IDAgMCA0cHggMnB4IHJnYmEoMCwgMTYwLCAyMDksIDAuNzUpO1xuICAtLWJveC1zaGFkb3ctZ3JheTogMCA0cHggOHB4IHJnYmEoMCwgMCwgMCwgMC4wOCk7XG4gIC0tdHB3LWZpbHRlci1oZWlnaHQ6IDBweDtcbiAgLS13ZWJraXQtYm94LXNoYWRvdzogMCAwIDFweCByZ2JhKDg0LCA4NCwgODQsIDEpO1xuICAvKiBHYXAgYW5kIHBhZGRpbmcgKi9cbiAgLS1nYXAtNDogNHB4O1xuICAtLWdhcC04OiA4cHg7XG4gIC0tZ2FwLTEyOiAxMnB4O1xuICAvKiBXaWR0aHMgYW5kIGhlaWdodHMqL1xuICAtLWxlbmd0aC00OiA0cHg7XG4gIC0tbGVuZ3RoLTIwOiAyMHB4O1xuICAtLWxlbmd0aC0yNDogMjRweDtcbiAgLS1sZW5ndGgtMzI6IDMycHg7XG59XG5cbm1kLW1vZGFsOjpwYXJ0KG1vZGFsLWJvZHkpIHtcbiAgb3ZlcmZsb3c6IHZpc2libGU7XG59XG5cbi5lcnJvci1tZXNzYWdlIHtcbiAgcGFkZGluZy1sZWZ0OiA0cHg7XG4gIG1hcmdpbi10b3A6IGNhbGModmFyKC0tc3BhY2UtdG9rZW4tZXZlbikgKiA0KTtcbn1cblxuLm1kLWxvYWRpbmcge1xuICBsZWZ0OiA1MCU7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiA1MCU7XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlKC01MCUsIC01MCUpO1xufVxuXG4uZm9ybSB7XG4gIGFsaWduLWl0ZW1zOiBzdHJldGNoO1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xufVxuXG4uc2wtcGhvbmUtZm9ybWF0LWNvbnRhaW5lciB7XG4gIGRpc3BsYXk6IGZsZXg7XG59XG5cbi5zbC1waG9uZS1mb3JtYXQtb3B0aW9uIHtcbiAgcGFkZGluZzogMWVtIDFlbSAwLjI1ZW0gMDtcbn1cblxuLnNsLWRuLWlucHV0IHtcbiAgbWFyZ2luLWJvdHRvbTogMS41ZW07XG59XG5cbi5zbC10YWJzLWNvbnRhaW5lciB7XG4gIGhlaWdodDogYXV0bztcbn1cblxuLm1vZGFsLWNvbnRlbnQge1xuICBwYWRkaW5nOiAwIDI0cHg7XG59XG5cbi5waG9uZS1mb3JtYXQge1xuICBwYWRkaW5nOiAxNnB4IDAgOHB4O1xuICBjb2xvcjogdmFyKC0tbWQtcHJpbWFyeS10ZXh0LWNvbG9yLCAjMTcxYjFmKTtcbn1cbi5waG9uZS1mb3JtYXQgbWQtcmFkaW8ge1xuICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gIG1hcmdpbi1yaWdodDogMTRweDtcbn1cblxuLnN0YXRpb24tbG9naW4tcmFkaW8ge1xuICBjb2xvcjogdmFyKC0tbWQtcHJpbWFyeS10ZXh0LWNvbG9yLCAjMTcxYjFmKTtcbn1cbi5zdGF0aW9uLWxvZ2luLXJhZGlvIG1kLXJhZGlvZ3JvdXAge1xuICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gIG1hcmdpbjogMTZweCAwO1xufVxuXG5tZC1saW5rOjpwYXJ0KGxpbmspIHtcbiAgY29sb3I6IHZhcigtLWxpbmstZGVmYXVsdCk7XG4gIGZvbnQtc2l6ZTogMTJweDtcbn1cblxuLmVtZXJnZW5jeS1oZWxwLXRvb2x0aXAgbWQtYnV0dG9uOjpwYXJ0KGJ1dHRvbikge1xuICB3aWR0aDogMDtcbiAgaGVpZ2h0OiAwO1xuICBtYXJnaW46IDVweCAxNHB4IDAgNXB4O1xufVxuXG4uYnJvd3Nlci1sYWJlbC1jb250YWluZXItZW1lcmdlbmN5IG1kLXRvb2x0aXA6OnBhcnQodG9vbHRpcF9yZWZlcmVuY2UpLCAuYnJvd3Nlci1sYWJlbC1jb250YWluZXItZW1lcmdlbmN5LWhlbHBUZXh0IG1kLXRvb2x0aXA6OnBhcnQodG9vbHRpcF9yZWZlcmVuY2UpLCAuYnJvd3Nlci1sYWJlbC1jb250YWluZXIgbWQtdG9vbHRpcDo6cGFydCh0b29sdGlwX3JlZmVyZW5jZSkge1xuICBkaXNwbGF5OiBmbGV4O1xufVxuXG4uc3RhdGlvbi1sb2dpbi1yYWRpby1taW4gbWQtcmFkaW86bnRoLWNoaWxkKDEpIHtcbiAgbWFyZ2luLXJpZ2h0OiA0cmVtO1xufVxuLnN0YXRpb24tbG9naW4tcmFkaW8tbWluIG1kLXJhZGlvOm50aC1jaGlsZCgyKSB7XG4gIG1hcmdpbi1yaWdodDogMDtcbn1cblxuLnN0YXRpb24tbG9naW4tcmFkaW8tbWF4IG1kLXJhZGlvOjpwYXJ0KHJhZGlvLWxhYmVsKSB7XG4gIHdoaXRlLXNwYWNlOiBub3JtYWw7XG59XG4uc3RhdGlvbi1sb2dpbi1yYWRpby1tYXggbWQtcmFkaW86OnBhcnQocmFkaW8td3JhcHBlcikge1xuICBtYXgtaGVpZ2h0OiA0cmVtO1xufVxuLnN0YXRpb24tbG9naW4tcmFkaW8tbWF4IG1kLXJhZGlvIHtcbiAgbWFyZ2luLXJpZ2h0OiAxcmVtO1xufVxuXG4ucmVtZW1iZXItbWUtY2hlY2tib3gtd3JhcHBlciB7XG4gIHBhZGRpbmctdG9wOiAyNHB4O1xufVxuXG4ucmVtZW1iZXItbWUtY2hlY2tib3g6OnBhcnQoY2hlY2tib3gtbGFiZWwpIHtcbiAgei1pbmRleDogMDtcbn1cblxuLmV4dGVuc2lvbi1mb3JtYXQge1xuICBwYWRkaW5nLXRvcDogNXB4O1xufVxuXG4uc2wtY29tYm9ib3gge1xuICBjb2xvcjogdmFyKC0tbWQtcHJpbWFyeS10ZXh0LWNvbG9yLCAjMTcxYjFmKTtcbiAgcGFkZGluZzogMCAycHg7XG59XG5cbi5yb2xlcy1jb21ib2JveCB7XG4gIG1hcmdpbi1ib3R0b206IDIwcHg7XG59XG5cbi5idG4tc3VibWl0IHtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbn1cblxuLnRlYW1zLWxhYmVsIHtcbiAgcGFkZGluZzogMCAwIDEwcHg7XG59XG5cbi5mb290ZXItYnRuIHtcbiAgbWFyZ2luLWxlZnQ6IDAuNzVyZW07XG59XG5cbi5icm93c2VyLWxhYmVsLWNvbnRhaW5lci1lbWVyZ2VuY3ksIC5icm93c2VyLWxhYmVsLWNvbnRhaW5lci1lbWVyZ2VuY3ktaGVscFRleHQsIC5icm93c2VyLWxhYmVsLWNvbnRhaW5lciB7XG4gIGNvbG9yOiB2YXIoLS1tZC1zZWNvbmRhcnktdGV4dC1jb2xvcik7XG59XG5cbi5icm93c2VyLWxhYmVsLWNvbnRhaW5lciB7XG4gIG1hcmdpbi1ib3R0b206IDI0cHg7XG59XG5cbi5icm93c2VyLWxhYmVsLWNvbnRhaW5lci1lbWVyZ2VuY3ktaGVscFRleHQge1xuICBmb250LXNpemU6IDEycHg7XG4gIG1hcmdpbi10b3A6IDhweDtcbiAgbWFyZ2luLWJvdHRvbTogMjRweDtcbn1cblxuQG1lZGlhIHNjcmVlbiBhbmQgKG1heC1oZWlnaHQ6IDU0MHB4KSB7XG4gIG1kLW1vZGFsOjpwYXJ0KG1vZGFsLWNvbnRhaW5lcikge1xuICAgIG1heC1oZWlnaHQ6IGNhbGMoMTAwdmggLSAyJSk7XG4gIH1cbiAgbWQtbW9kYWw6OnBhcnQobW9kYWwtY29udGVudCkge1xuICAgIG1pbi1oZWlnaHQ6IDEwMCU7XG4gICAgbWF4LWhlaWdodDogMTAwdmg7XG4gICAgb3ZlcmZsb3cteTogYXV0bztcbiAgfVxufVxuLnBob25lLWZvcm1hdCBtZC1yYWRpbzo6cGFydChyYWRpby1sYWJlbCkge1xuICB3aWR0aDogZml0LWNvbnRlbnQ7XG4gIG1heC13aWR0aDogMTQwcHg7XG59XG5cbi5pbmZvLWljb24ge1xuICB2ZXJ0aWNhbC1hbGlnbjogc3ViO1xuICBtYXJnaW4tbGVmdDogY2FsYyh2YXIoLS1zcGFjZS10b2tlbi1ldmVuKSAqIDEuNSk7XG59XG5cbi5pbnRlcm5hdGlvbmFsLWNoZWNrYm94LXdyYXBwZXIge1xuICBkaXNwbGF5OiBmbGV4O1xuICBjb2xvcjogdmFyKC0tbWQtcHJpbWFyeS10ZXh0LWNvbG9yLCAjMTcxYjFmKTtcbn1cbi5pbnRlcm5hdGlvbmFsLWNoZWNrYm94LXdyYXBwZXIgbWQtY2hlY2tib3gge1xuICBtYXJnaW4tYm90dG9tOiAxMnB4O1xufVxuXG4uZGlhbC1udW1iZXItbGFiZWwge1xuICBkaXNwbGF5OiBmbGV4O1xufVxuXG4ubGFiZWwtd2l0aC1ib3R0b20tbWFyZ2luIHtcbiAgbWFyZ2luLWJvdHRvbTogMTBweDtcbn1cblxubWQtcGhvbmUtaW5wdXQ6OnBhcnQoY29tYm9ib3gpIHtcbiAgd2lkdGg6IDExNHB4O1xufVxubWQtcGhvbmUtaW5wdXQ6OnBhcnQobWQtaW5wdXQpIHtcbiAgd2lkdGg6IDEwMCU7XG59XG5tZC1waG9uZS1pbnB1dDo6cGFydChvcHRpb24pIHtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xufVxuXG4ucmVhZC10aGUtbm90aWZpY2F0aW9uLXdyYXBwZXIge1xuICBwYWRkaW5nOiAxNnB4IDJweCAycHg7XG59XG5cbi5yZWFkLXRoZS1ub3RpZmljYXRpb246OnBhcnQoY2hlY2tib3gtbGFiZWwpIHtcbiAgei1pbmRleDogMDtcbn0iLCJAdXNlIFwiLi4vLi4vYXNzZXRzL3N0eWxlcy92YXJpYWJsZXNcIiBhcyAqO1xuXG4kZmlmdHktcGM6IDUwJTtcbiRjbHItd2hpdGU6ICNmZmY7XG4kc2wtd2lkdGg6IDQ4MHB4O1xuJGZvbnQtMTY6IDE2cHg7XG4kbGluZS1oZWlnaHQtMjQ6IDI0cHg7XG4kbGluZS1oZWlnaHQtMjI6IDIycHg7XG5cbiRzbC1oZWlnaHQ6IDM2MHB4O1xuJHNsLW1heC1oZWlnaHQ6IDUwMHB4O1xuJHNsLWxhYmVsLWNvbG9yOiAjMTcxYjFmO1xuJGxzLXJhZGlvLXBhZGRpbmc6IDE0cHg7XG5cbm1kLW1vZGFsOjpwYXJ0KG1vZGFsLWJvZHkpIHtcbiAgb3ZlcmZsb3c6IHZpc2libGU7XG59XG5cbi5lcnJvci1tZXNzYWdlIHtcbiAgcGFkZGluZy1sZWZ0OiA0cHg7XG4gIG1hcmdpbi10b3A6IGNhbGModmFyKC0tc3BhY2UtdG9rZW4tZXZlbikgKiA0KTtcbn1cblxuLm1kLWxvYWRpbmcge1xuICBsZWZ0OiAkZmlmdHktcGM7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAkZmlmdHktcGM7XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlKC0kZmlmdHktcGMsIC0kZmlmdHktcGMpO1xufVxuXG4vLyBmcm9tIEZPUk0gY29tcG9uZW50XG4vLyAtLS0tLS0tLS0tLS0tLS0tLS0tLVxuXG4uZm9ybSB7XG4gIGFsaWduLWl0ZW1zOiBzdHJldGNoO1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xufVxuXG4uc2wtcGhvbmUtZm9ybWF0LWNvbnRhaW5lciB7XG4gIGRpc3BsYXk6IGZsZXg7XG59XG5cbi5zbC1waG9uZS1mb3JtYXQtb3B0aW9uIHtcbiAgcGFkZGluZzogMWVtIDFlbSAwLjI1ZW0gMDtcbn1cblxuLnNsLWRuLWlucHV0IHtcbiAgbWFyZ2luLWJvdHRvbTogMS41ZW07XG59XG5cbi5zbC10YWJzLWNvbnRhaW5lciB7XG4gIGhlaWdodDogYXV0bztcbn1cblxuLm1vZGFsLWNvbnRlbnQge1xuICBwYWRkaW5nOiAwIDI0cHg7XG59XG5cbi5waG9uZS1mb3JtYXQge1xuICBwYWRkaW5nOiAxNnB4IDAgOHB4O1xuICBjb2xvcjogdmFyKC0tbWQtcHJpbWFyeS10ZXh0LWNvbG9yLCAkc2wtbGFiZWwtY29sb3IpO1xuXG4gIG1kLXJhZGlvIHtcbiAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gICAgbWFyZ2luLXJpZ2h0OiAkbHMtcmFkaW8tcGFkZGluZztcbiAgfVxufVxuXG4uc3RhdGlvbi1sb2dpbi1yYWRpbyB7XG4gIGNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LXRleHQtY29sb3IsICRzbC1sYWJlbC1jb2xvcik7XG4gIG1kLXJhZGlvZ3JvdXAge1xuICAgIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgICBtYXJnaW46IDE2cHggMDtcbiAgfVxufVxuXG5tZC1saW5rOjpwYXJ0KGxpbmspIHtcbiAgY29sb3I6IHZhcigtLWxpbmstZGVmYXVsdCk7XG4gIGZvbnQtc2l6ZTogMTJweDtcbn1cblxuLmVtZXJnZW5jeS1oZWxwLXRvb2x0aXAge1xuICBtZC1idXR0b246OnBhcnQoYnV0dG9uKSB7XG4gICAgd2lkdGg6IDA7XG4gICAgaGVpZ2h0OiAwO1xuICAgIG1hcmdpbjogNXB4IDE0cHggMCA1cHg7XG4gIH1cbn1cblxuLmJyb3dzZXItbGFiZWwtY29udGFpbmVyLWVtZXJnZW5jeSB7XG4gIG1kLXRvb2x0aXA6OnBhcnQodG9vbHRpcF9yZWZlcmVuY2UpIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICB9XG59XG5cbi5zdGF0aW9uLWxvZ2luLXJhZGlvLW1pbiB7XG4gIG1kLXJhZGlvOm50aC1jaGlsZCgxKSB7XG4gICAgbWFyZ2luLXJpZ2h0OiA0cmVtO1xuICB9XG5cbiAgbWQtcmFkaW86bnRoLWNoaWxkKDIpIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDA7XG4gIH1cbn1cblxuLnN0YXRpb24tbG9naW4tcmFkaW8tbWF4IHtcbiAgbWQtcmFkaW86OnBhcnQocmFkaW8tbGFiZWwpIHtcbiAgICB3aGl0ZS1zcGFjZTogbm9ybWFsO1xuICB9XG4gIG1kLXJhZGlvOjpwYXJ0KHJhZGlvLXdyYXBwZXIpIHtcbiAgICBtYXgtaGVpZ2h0OiA0cmVtO1xuICB9XG5cbiAgbWQtcmFkaW8ge1xuICAgIG1hcmdpbi1yaWdodDogMXJlbTtcbiAgfVxufVxuXG4ucmVtZW1iZXItbWUtY2hlY2tib3gtd3JhcHBlciB7XG4gIHBhZGRpbmctdG9wOiAyNHB4O1xufVxuXG4ucmVtZW1iZXItbWUtY2hlY2tib3g6OnBhcnQoY2hlY2tib3gtbGFiZWwpIHtcbiAgei1pbmRleDogMDtcbn1cblxuLmV4dGVuc2lvbi1mb3JtYXQge1xuICBwYWRkaW5nLXRvcDogNXB4O1xufVxuXG4uc2wtY29tYm9ib3gge1xuICBjb2xvcjogdmFyKC0tbWQtcHJpbWFyeS10ZXh0LWNvbG9yLCAkc2wtbGFiZWwtY29sb3IpO1xuICBwYWRkaW5nOiAwIDJweDtcbn1cblxuLnJvbGVzLWNvbWJvYm94IHtcbiAgbWFyZ2luLWJvdHRvbTogMjBweDtcbn1cblxuLmJ0bi1zdWJtaXQge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kO1xufVxuXG4udGVhbXMtbGFiZWwge1xuICBwYWRkaW5nOiAwIDAgMTBweDtcbn1cblxuLmZvb3Rlci1idG4ge1xuICBtYXJnaW4tbGVmdDogMC43NXJlbTtcbn1cblxuLmJyb3dzZXItbGFiZWwtY29udGFpbmVyLWVtZXJnZW5jeSB7XG4gIGNvbG9yOiB2YXIoLS1tZC1zZWNvbmRhcnktdGV4dC1jb2xvcik7XG59XG5cbi5icm93c2VyLWxhYmVsLWNvbnRhaW5lciB7XG4gIEBleHRlbmQgLmJyb3dzZXItbGFiZWwtY29udGFpbmVyLWVtZXJnZW5jeTtcbiAgbWFyZ2luLWJvdHRvbTogMjRweDtcbn1cblxuLmJyb3dzZXItbGFiZWwtY29udGFpbmVyLWVtZXJnZW5jeS1oZWxwVGV4dCB7XG4gIEBleHRlbmQgLmJyb3dzZXItbGFiZWwtY29udGFpbmVyLWVtZXJnZW5jeTtcbiAgZm9udC1zaXplOiAxMnB4O1xuICBtYXJnaW4tdG9wOiA4cHg7XG4gIG1hcmdpbi1ib3R0b206IDI0cHg7XG59XG5cbkBtZWRpYSBzY3JlZW4gYW5kIChtYXgtaGVpZ2h0OiA1NDBweCkge1xuICBtZC1tb2RhbDo6cGFydChtb2RhbC1jb250YWluZXIpIHtcbiAgICBtYXgtaGVpZ2h0OiBjYWxjKDEwMHZoIC0gMiUpO1xuICB9XG5cbiAgbWQtbW9kYWw6OnBhcnQobW9kYWwtY29udGVudCkge1xuICAgIG1pbi1oZWlnaHQ6IDEwMCU7XG4gICAgbWF4LWhlaWdodDogY2FsYygxMDB2aCk7XG4gICAgb3ZlcmZsb3cteTogYXV0bztcbiAgfVxufVxuXG4ucGhvbmUtZm9ybWF0IG1kLXJhZGlvOjpwYXJ0KHJhZGlvLWxhYmVsKSB7XG4gIHdpZHRoOiBmaXQtY29udGVudDtcbiAgbWF4LXdpZHRoOiAxNDBweDtcbn1cblxuLmluZm8taWNvbiB7XG4gIHZlcnRpY2FsLWFsaWduOiBzdWI7XG4gIG1hcmdpbi1sZWZ0OiBjYWxjKHZhcigtLXNwYWNlLXRva2VuLWV2ZW4pICogMS41KTtcbn1cblxuLmludGVybmF0aW9uYWwtY2hlY2tib3gtd3JhcHBlciB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LXRleHQtY29sb3IsICRzbC1sYWJlbC1jb2xvcik7XG5cbiAgbWQtY2hlY2tib3gge1xuICAgIG1hcmdpbi1ib3R0b206IDEycHg7XG4gIH1cbn1cblxuLmRpYWwtbnVtYmVyLWxhYmVsIHtcbiAgZGlzcGxheTogZmxleDtcbn1cblxuLmxhYmVsLXdpdGgtYm90dG9tLW1hcmdpbiB7XG4gIG1hcmdpbi1ib3R0b206IDEwcHg7XG59XG5cbm1kLXBob25lLWlucHV0IHtcbiAgJjo6cGFydChjb21ib2JveCkge1xuICAgIHdpZHRoOiAxMTRweDtcbiAgfVxuXG4gICY6OnBhcnQobWQtaW5wdXQpIHtcbiAgICB3aWR0aDogMTAwJTtcbiAgfVxuXG4gICY6OnBhcnQob3B0aW9uKSB7XG4gICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICB9XG59XG5cbi5yZWFkLXRoZS1ub3RpZmljYXRpb24td3JhcHBlciB7XG4gIHBhZGRpbmc6IDE2cHggMnB4IDJweDtcbn1cblxuLnJlYWQtdGhlLW5vdGlmaWNhdGlvbjo6cGFydChjaGVja2JveC1sYWJlbCkge1xuICB6LWluZGV4OiAwO1xufVxuIl19 */`);
    

/***/ }),

/***/ "./src/components/userProfile/userProfile.ts":
/*!***************************************************!*\
  !*** ./src/components/userProfile/userProfile.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UserProfile: () => (/* binding */ UserProfile)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../constants */ "./src/constants.ts");
/* harmony import */ var _userProfile_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./userProfile.scss */ "./src/components/userProfile/userProfile.scss");
/* harmony import */ var _teamsListInfiniteScroll__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./../teamsListInfiniteScroll */ "./src/components/teamsListInfiniteScroll/index.ts");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @adobe/lit-mobx */ "@adobe/lit-mobx");
/* harmony import */ var _adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_13__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};















const trackingIdLabel = "app:errorModal:trackingIdLabel";
const extensionPlaceHolder = "app:stationLogin:extensionPlaceHolder";
const clearAriaLabel = "app:stationLogin.clear";
const dnStationLogin = "app:stationLogin.stationDnLabel";
const phoneInput = "md-phone-input";
const hiddenBtn = "#hiddenBtn";
const extensionInfo = "app:stationLogin.extensionInfo";
const modeOptionslabel = "app:stationLogin:modeOptionsLabel";
const phoneFormats = { international: "International", us: "US", other: "Other" };
var UserProfile;
(function (UserProfile) {
    /**
     * @element agentx-wc-user-profile
     * @fires selected-user-role
     * @fires login-start
     * @fires submit-busy
     * @fires on-component-update
     * @fires modal-initialized
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(_adobe_lit_mobx__WEBPACK_IMPORTED_MODULE_12__.MobxLitElement) {
        constructor() {
            super(...arguments);
            this.userRole = "";
            this.isMonitoringEnabled = false;
            this.isSubmit = false;
            this.selectedRoleName = _constants__WEBPACK_IMPORTED_MODULE_9__.AGENT;
            this.teamName = "";
            this.teamId = "";
            this.dialNumber = "";
            this.isExtensionUsed = false;
            this.isDefaultDnSet = false;
            this.extensionNumber = "";
            this.dialNumberValueForNonUS = "";
            this.defaultDn = "";
            this.isDefaultDnSetFromProfile = false;
            this.isInternational = false;
            this.isInternationalFromProfile = false;
            this.countryCallingCode = "";
            this.countryCodeValue = "";
            this.isRememberMyCredentials = false;
            this.auxCodeError = false;
            this.fetchUniqueTeamIdError = false;
            this.orgId = "";
            this.agentDbId = "";
            this.isSubmitProfile = "";
            this.teams = []; // From User Station Login.
            this.filteredTeamList = ""; // From Menu Component for Profile Settings.
            this.teamsMeta = ""; // From Menu Component for Profile Settings.
            this.isErrUnknown = false;
            this.isErrDNRegister = false;
            this.reasonCode = "";
            this.isDesktopReasonCodeEnabled = false;
            this.getErrorMsgForReasonCode = Function;
            this.isDNAlreadyInUse = false;
            this.isErrPhone = false;
            this.isErrPhoneExt = false;
            this.isExtAlreadyInUse = false;
            this.isErrExtRegister = false;
            this.isDNRegisterTimeOut = false;
            this.isTeamsEmpty = false;
            this.usesOtherDN = false;
            this.trackingId = "";
            this.isStationlogin = false;
            this.isExtensionUsedFromProfile = false;
            this.usesOtherDNFromProfile = false;
            this.isMonitoringEnabledFromProfile = false;
            this.phoneFormat = phoneFormats.other;
            this.phoneNumber = "";
            this.isMaximumSessionsReached = false;
            this.loginVoiceOptions = [];
            this.deviceType = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.AGENT_DN;
            this.deviceId = "";
            this.isWebRTCEnabled = false;
            this.isWebRtcUnsupportedBrowser = false;
            this.isMicrophoneAccessDenied = false;
            this.showEmergencyNotificationWebrtc = false;
            this.isEmergencyModalAlreadyDisplayed = false;
            this.isConsultTransferInfiniteScrollEnabled = false;
            this.isErrTeam = false;
            this.mode = "DN";
            this.isErrRole = false;
            this.displayRoleDropdown = true;
            this.displayTeamsDropdown = true;
            this.displayDNExtension = true;
            this.radioSelection = 0;
            this.isExtensionTooltipOpened = false;
            this.isIntenationalTooltipOpened = false;
            this.roleInfo = null;
            this.paginatedTeamResponse = {
                meta: {
                    links: {},
                    orgid: "",
                    page: 0,
                    pageSize: 0,
                    totalPages: 0,
                    totalRecords: 0
                },
                data: []
            };
            /**
             * Inserting hidden button inside the form so that autocomplete works
             * for firefox
             */
            this.hiddenAutoFillBtnDN = document.createElement("button");
            this.team = null;
            this.profile = null;
            // TODO: this should come from i18N.
            this.roles = [
                { roleId: "1", roleName: _constants__WEBPACK_IMPORTED_MODULE_9__.SUPERVISOR, roleDisplay: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:supervisorRole") },
                { roleId: "2", roleName: _constants__WEBPACK_IMPORTED_MODULE_9__.AGENT_AND_SUPERVISOR, roleDisplay: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:supervisorAndAgentRole") }
            ];
            this.defaultAuxCode = "";
            this.insertFromPaste = "insertFromPaste";
            this.teamsArray = [];
            this.defaultCountryCallingCode = "+1, United States of America, US";
            this.defaultCountryCodeValue = "+1";
            this.isValidISD = false;
            /** Handling team select from advance list */
            this.onTeamSelect = (e) => {
                const { teamName, teamId } = e.detail;
                this.teamName = teamName;
                this.teamId = teamId;
                this.team = teamName && teamId ? { teamId, teamName } : null;
                this.dispatchEventWhenComponentUpdates();
            };
        }
        connectedCallback() {
            super.connectedCallback();
            this.init();
            this.attachHiddenAttributesButton();
        }
        init() {
            var _a, _b;
            this.teams = this.filteredTeamList ? JSON.parse(this.filteredTeamList) : this.teams;
            if (this.isConsultTransferInfiniteScrollEnabled) {
                this.paginatedTeamResponse.data = this.teams;
                if (this.teamsMeta) {
                    try {
                        this.paginatedTeamResponse.meta = JSON.parse(this.teamsMeta);
                    }
                    catch (e) {
                        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("Failed to parse teamsMeta", e);
                        this.paginatedTeamResponse.meta = {
                            links: {},
                            orgid: "",
                            page: 0,
                            pageSize: 0,
                            totalPages: 0,
                            totalRecords: 0
                        };
                    }
                }
            }
            this.teamsArray = (_a = this.teams) === null || _a === void 0 ? void 0 : _a.map((team) => team.teamName);
            const defaultTeam = this.teams && this.teams.length > 0 ? this.teams[0].teamName : "";
            this.teamName = this.teamName ? this.teamName : defaultTeam;
            if (this.isConsultTransferInfiniteScrollEnabled) {
                this.team = {
                    teamId: this.teamId,
                    teamName: this.teamName
                };
            }
            this.setValuesFromProfile();
            this.displayControlsBasedOnRole();
            //Without this check if we have only one option with webrtc disabled,
            //devicetype will never be updated and will render the wrong section
            if (this.loginVoiceOptions.length === 1) {
                this.deviceType = this.loginVoiceOptions[0];
                this.setDeviceType();
            }
            if (this.isWebRTCEnabled) {
                // remove toUpperCase check when webrtc ff is GA
                if (this.deviceType === null ||
                    this.loginVoiceOptions.indexOf((_b = this.deviceType) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === -1 ||
                    !this.isRememberMyCredentials) {
                    this.deviceType = this.loginVoiceOptions[0];
                }
                this.setDeviceType();
            }
            else {
                this.setRadioButtonSelection();
            }
            this.getSelectedRole();
            // Adding a timeout as phone input takes some time to load and then the values will be populated from Preferences, focus needs to be done after that
            setTimeout(() => {
                this.handleInitialFocus();
                this.getRoleSelection();
            }, 10);
            this.dispatchEventWhenComponentUpdates();
        }
        /**
         * As profile is React component, boolean values doesn't apply correctly when passed from there
         * thus as a workaround setting it as string here
         */
        setValuesFromProfile() {
            if (!this.isStationlogin) {
                this.usesOtherDN = this.usesOtherDNFromProfile;
                this.isExtensionUsed = this.isExtensionUsedFromProfile;
                this.isMonitoringEnabled = this.isMonitoringEnabledFromProfile;
                this.isDefaultDnSet = this.isDefaultDnSetFromProfile;
                this.isInternational = this.isInternationalFromProfile;
            }
        }
        getDn() {
            if (this.isExtensionUsed) {
                return this.extensionNumber;
            }
            let countryCodeValueVar = "";
            if (this.phoneNumber !== "") {
                // send dn as empty if phonenumber is empty instead of +1 so that DN register failure doesnt happen
                countryCodeValueVar = this.countryCodeValue || this.defaultCountryCodeValue;
            }
            return this.ifInternationalFormat()
                ? `${countryCodeValueVar}${(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.stripSpecialChar)(this.phoneNumber)}`
                : this.dialNumberValueForNonUS;
        }
        isUsesOtherFormat() {
            return this.phoneFormat === phoneFormats.other || this.countryCodeValue !== "+1";
        }
        setRadioButtonSelection() {
            this.radioSelection = this.isExtensionUsed ? 1 : 0;
            const format = this.isExtensionUsed ? "Extension" : "DN";
            this.setValuesOnRadioChange(format);
        }
        setDeviceType() {
            var _a;
            // remove toUpperCase check when webrtc ff is GA
            if (this.deviceType !== null) {
                this.radioSelection = this.loginVoiceOptions.indexOf((_a = this.deviceType) === null || _a === void 0 ? void 0 : _a.toUpperCase());
            }
            this.isExtensionUsed = this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.EXTENSION;
            this.isErrUnknown = false;
        }
        setValuesOnRadioChange(format) {
            this.mode = format;
            this.isExtensionUsed = format === "Extension";
            this.radioSelection = this.isExtensionUsed ? 1 : 0;
            this.isErrUnknown = false;
            this.isErrPhoneExt = false;
            this.isErrPhone = false;
        }
        displayControlsBasedOnRole() {
            const userRoleString = this.userRole;
            switch (userRoleString) {
                case _constants__WEBPACK_IMPORTED_MODULE_9__.AGENT: {
                    this.displayRoleDropdown = false;
                    this.displayTeamsDropdown = true;
                    this.displayDNExtension = true;
                    break;
                }
                case _constants__WEBPACK_IMPORTED_MODULE_9__.SUPERVISOR: {
                    this.displayDNExtension = this.isMonitoringEnabled;
                    this.displayRoleDropdown = false;
                    this.displayTeamsDropdown = false;
                    break;
                }
                // TODO: remove SUPERVISOR_AND_AGENT as UI determines the user role.
                case _constants__WEBPACK_IMPORTED_MODULE_9__.SUPERVISOR_AND_AGENT.replace(/\s/g, "").toLocaleLowerCase():
                case _constants__WEBPACK_IMPORTED_MODULE_9__.AGENT_AND_SUPERVISOR: {
                    if (this.selectedRoleName) {
                        this.handleDisplayOnRoleChange(this.selectedRoleName.toLocaleLowerCase());
                    }
                    else {
                        this.displayRoleDropdown = true;
                        this.displayTeamsDropdown = false;
                        this.displayDNExtension = false;
                    }
                    break;
                }
            }
        }
        /**
         * Toggles the display of UI Elements based upon Role coming from STORE and
         * when user changes role from the dropdown
         * @param selectedRoleName
         */
        handleDisplayOnRoleChange(selectedRoleName) {
            if (selectedRoleName === _constants__WEBPACK_IMPORTED_MODULE_9__.SUPERVISOR) {
                this.displayTeamsDropdown = false;
                this.displayRoleDropdown = true;
                this.displayDNExtension = this.isMonitoringEnabled;
            }
            else if (selectedRoleName === _constants__WEBPACK_IMPORTED_MODULE_9__.AGENT_AND_SUPERVISOR) {
                this.displayRoleDropdown = true;
                this.displayTeamsDropdown = true;
                this.displayDNExtension = true;
            }
        }
        attachHiddenAttributesButton() {
            this.hiddenAutoFillBtnDN.id = "hiddenBtn";
            this.hiddenAutoFillBtnDN.type = "submit";
            this.hiddenAutoFillBtnDN.onclick = (e) => {
                e.preventDefault();
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("hiddenAutoFillBtnDN clicked");
            };
            this.hiddenAutoFillBtnDN.style.display = "none";
        }
        attachAutoCompleteConditionally() {
            return this.ifInternationalFormat() ? "tel-national" : "tel";
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            changedProperties.forEach((oldValue, name) => {
                if (name === "isSubmit" && oldValue !== undefined) {
                    this.submitFromStationLogin();
                }
                if (name === "isSubmitProfile" && oldValue !== undefined) {
                    this.submitFromProfileSettings();
                }
            });
            this.setRovingPreventFocus();
            let inp;
            setTimeout(() => {
                var _a, _b, _c, _d;
                // setTimeout required as md-phone-input does not render
                if (this.isExtensionUsed || !this.ifInternationalFormat()) {
                    inp = (_a = this.form) === null || _a === void 0 ? void 0 : _a.querySelector("md-input");
                }
                else {
                    inp = (_c = (_b = this.internationalForm) === null || _b === void 0 ? void 0 : _b.querySelector(phoneInput)) === null || _c === void 0 ? void 0 : _c.shadowRoot.querySelector("md-input");
                    if (inp && !(inp === null || inp === void 0 ? void 0 : inp.shadowRoot.querySelector("form"))) {
                        // create form element and append to input element to support auto suggestion for md-phone-input component
                        const input = inp.shadowRoot.querySelector("input");
                        if (input) {
                            input.name = input.id = "input-name";
                            input.autocomplete = this.attachAutoCompleteConditionally();
                            const inputParent = input.parentElement;
                            if (inputParent) {
                                const formElement = document.createElement("form");
                                inputParent.insertBefore(formElement, input);
                                formElement.append(input);
                            }
                        }
                    }
                }
                if (!((_d = inp === null || inp === void 0 ? void 0 : inp.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector(hiddenBtn))) {
                    const form = inp === null || inp === void 0 ? void 0 : inp.shadowRoot.querySelector("form");
                    if (form) {
                        const input = inp.shadowRoot.querySelector("input");
                        input.autocomplete = this.attachAutoCompleteConditionally();
                        form.append(this.hiddenAutoFillBtnDN);
                    }
                }
            }, 50); // delay required for md-phone-input to render
        }
        setRovingPreventFocus() {
            if (this.telephonyRadio && !this.rolesDropDown) {
                this.telephonyRadio.rovingPreventFocus = true;
            }
        }
        handleRememberMeCheckBoxChange() {
            this.isRememberMyCredentials = !this.isRememberMyCredentials;
            this.dispatchEventWhenComponentUpdates();
        }
        handleSelectedRole(e) {
            var _a;
            if (e.detail.option) {
                this.roleInfo = e.detail.option;
            }
            else {
                this.roleInfo = null;
            }
            const selectedRoleName = (_a = this.roleInfo) === null || _a === void 0 ? void 0 : _a.roleName;
            selectedRoleName && this.handleDisplayOnRoleChange(selectedRoleName.toLocaleLowerCase());
            this.isErrUnknown = false;
            setTimeout(() => {
                this.handleInputFocus();
            }, 10);
            this.dispatchEventWhenComponentUpdates();
        }
        handleSelectedTeam(e) {
            if (e.detail.value) {
                const selectedTeam = this.teams.find((teamObj) => teamObj.teamName === e.detail.value);
                if (selectedTeam) {
                    this.team = selectedTeam;
                }
            }
            else {
                this.team = null;
                this.teamName = "";
            }
            this.dispatchEventWhenComponentUpdates();
        }
        setDialNumber(e) {
            var _a, _b;
            if (((_b = (_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.srcEvent) === null || _b === void 0 ? void 0 : _b.inputType) === this.insertFromPaste) {
                e.target.value = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.stripSpecialChar)(e.target.value);
            }
            this.dialNumberValueForNonUS = e.target.value;
            this.dispatchEventWhenComponentUpdates();
        }
        onDialNumberOrExtBlur() {
            this.dispatchEventWhenComponentUpdates();
        }
        setExtensionNumber(e) {
            var _a, _b;
            if (((_b = (_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.srcEvent) === null || _b === void 0 ? void 0 : _b.inputType) === this.insertFromPaste) {
                e.target.value = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.stripSpecialChar)(e.target.value);
            }
            this.extensionNumber = e.target.value;
            this.dispatchEventWhenComponentUpdates();
        }
        handleInputFocus() {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const inputField = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-input")) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("input");
            const phoneField = (_h = (_g = (_f = (_e = (_d = this.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector(phoneInput)) === null || _e === void 0 ? void 0 : _e.shadowRoot) === null || _f === void 0 ? void 0 : _f.querySelector("md-input")) === null || _g === void 0 ? void 0 : _g.shadowRoot) === null || _h === void 0 ? void 0 : _h.querySelector("input");
            setTimeout(() => {
                if (inputField) {
                    inputField.focus();
                }
                else {
                    phoneField === null || phoneField === void 0 ? void 0 : phoneField.focus();
                }
            }, 1);
        }
        handleInitialFocus() {
            setTimeout(() => {
                var _a, _b, _c, _d, _e, _f;
                if (this.displayRoleDropdown) {
                    (_c = (_b = (_a = this.rolesDropDown) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("label")) === null || _c === void 0 ? void 0 : _c.focus();
                }
                else {
                    (_f = (_e = (_d = this.dnInfoIconButton) === null || _d === void 0 ? void 0 : _d.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector("button")) === null || _f === void 0 ? void 0 : _f.focus();
                }
            }, 1);
        }
        submitLogin() {
            if (this.isStationlogin) {
                this.evt("submit-busy", { submitProperty: true });
                this.submitFromStationLogin();
            }
            else {
                this.submitFromProfileSettings();
            }
        }
        handleEnterKeypress(e) {
            if (e.key === _constants__WEBPACK_IMPORTED_MODULE_9__.Key.Enter) {
                this.submitLogin();
            }
        }
        handlePhoneInputKeydown(e) {
            const keyboardEvent = e.detail.srcEvent;
            if (keyboardEvent.key === _constants__WEBPACK_IMPORTED_MODULE_9__.Key.Enter) {
                this.submitLogin();
            }
        }
        handleUnSupportedBrowserError() {
            this.isErrUnknown = true;
            this.isWebRtcUnsupportedBrowser = true;
            this.trackingId = "";
            this.evt(_constants__WEBPACK_IMPORTED_MODULE_9__.PROFILE_SETTING_INVALID_DATA_EVENT, { isValid: false });
        }
        handleMicrophoneAccessDenied() {
            this.isErrUnknown = true;
            this.isMicrophoneAccessDenied = true;
            this.trackingId = "";
            this.evt(_constants__WEBPACK_IMPORTED_MODULE_9__.PROFILE_SETTING_INVALID_DATA_EVENT, { isValid: false });
        }
        /***
         * When Updating User Profile Settings
         */
        submitFromProfileSettings() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            return __awaiter(this, void 0, void 0, function* () {
                if ((this.displayRoleDropdown && !this.roleInfo) || (this.displayTeamsDropdown && !this.team)) {
                    return;
                }
                let selectedRoleName = (_a = this.roleInfo) === null || _a === void 0 ? void 0 : _a.roleName;
                if (selectedRoleName) {
                    selectedRoleName = selectedRoleName === "agent_supervisor" ? "supervisorAgent" : selectedRoleName;
                    localStorage.setItem("userRole", selectedRoleName);
                }
                if (this.isWebRTCEnabled && this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.BROWSER) {
                    if (!this.isEmergencyModalAlreadyDisplayed && _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.featureflag.isDesktopEmergencyNotificationEnabled()) {
                        this.renderEmergencyNotificationBody();
                    }
                    this.setErrorFlags();
                    this.isErrUnknown = false;
                    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[WebRtc] : Station Login Request from profile");
                    if (!(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.isWebRtcSupportedBrowser)()) {
                        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[WebRtc] Unsupported Browser error");
                        this.handleUnSupportedBrowserError();
                        return;
                    }
                    try {
                        const mediaStream = yield navigator.mediaDevices.getUserMedia({ audio: true });
                        if (!mediaStream) {
                            this.handleMicrophoneAccessDenied();
                            return;
                        }
                        else {
                            mediaStream.getTracks().forEach((track) => track.stop());
                        }
                    }
                    catch (error) {
                        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[WebRtc] micrpophone access error", error);
                        this.handleMicrophoneAccessDenied();
                        return;
                    }
                }
                else if (this.displayDNExtension && !this.valid()) {
                    const inputField = this.isExtensionUsed && !this.ifInternationalFormat()
                        ? (_e = (_d = (_c = (_b = this.form) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector("md-input")) === null || _d === void 0 ? void 0 : _d.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector("input")
                        : (_l = (_k = (_j = (_h = (_g = (_f = this.form) === null || _f === void 0 ? void 0 : _f.shadowRoot) === null || _g === void 0 ? void 0 : _g.querySelector(phoneInput)) === null || _h === void 0 ? void 0 : _h.shadowRoot) === null || _j === void 0 ? void 0 : _j.querySelector("md-input")) === null || _k === void 0 ? void 0 : _k.shadowRoot) === null || _l === void 0 ? void 0 : _l.querySelector("input");
                    setTimeout(() => inputField === null || inputField === void 0 ? void 0 : inputField.focus(), 1);
                    this.evt(_constants__WEBPACK_IMPORTED_MODULE_9__.PROFILE_SETTING_INVALID_DATA_EVENT, { isValid: false });
                    return;
                }
                this.evt(_constants__WEBPACK_IMPORTED_MODULE_9__.PROFILE_SETTING_INVALID_DATA_EVENT, { isValid: true });
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.shortcut.updateRegisterKeys();
                this.isWebRTCEnabled && this.deviceType === "BROWSER" ? (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.registerWebRTCShortcuts)() : (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.removeWebRTCShortcuts)();
                this.dispatchEventWhenComponentUpdates();
            });
        }
        setInternationalPhNumber(e) {
            this.phoneNumber = e.detail.phoneNumber;
            this.isValidISD = e.detail.phoneNumber && e.detail.isValid;
            this.dispatchEventWhenComponentUpdates();
        }
        submitFromStationLogin() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            //storing original role here as to compare for role switch for telemetry
            const loggedInRole = this.selectedRoleName;
            // Update selectedRoleName in STORE.agent in case of Supervisor And Agent
            const selectedRoleName = (_a = this.roleInfo) === null || _a === void 0 ? void 0 : _a.roleName;
            if (this.displayRoleDropdown && selectedRoleName) {
                const roleData = { selectedRoleName };
                this.evt("selected-user-role", roleData);
            }
            if (this.isWebRTCEnabled && this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.BROWSER) {
                _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[WebRtc] : Station Login Request from StationLogin PopUP");
            }
            else {
                let inp;
                if (this.isExtensionUsed) {
                    inp = (_d = (_c = (_b = this.extForm) === null || _b === void 0 ? void 0 : _b.querySelector("md-input")) === null || _c === void 0 ? void 0 : _c.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector("input");
                }
                else {
                    inp = this.ifInternationalFormat()
                        ? (_g = (_f = (_e = this.form) === null || _e === void 0 ? void 0 : _e.querySelector(phoneInput)) === null || _f === void 0 ? void 0 : _f.shadowRoot) === null || _g === void 0 ? void 0 : _g.querySelector("md-input")
                        : (_k = (_j = (_h = this.form) === null || _h === void 0 ? void 0 : _h.querySelector("md-input")) === null || _j === void 0 ? void 0 : _j.shadowRoot) === null || _k === void 0 ? void 0 : _k.querySelector("input");
                }
                if (this.displayDNExtension && !this.valid()) {
                    const inputField = (_l = inp === null || inp === void 0 ? void 0 : inp.shadowRoot) === null || _l === void 0 ? void 0 : _l.querySelector("input");
                    setTimeout(() => inputField === null || inputField === void 0 ? void 0 : inputField.focus(), 1);
                    this.evt("submit-busy", { submitProperty: false });
                    this.handleInputFocus();
                    return;
                }
                if ((this.displayRoleDropdown && !this.roleInfo) || (this.displayTeamsDropdown && !this.team)) {
                    this.evt("submit-busy", { submitProperty: false });
                    return;
                }
            }
            this.evt("login-start", {
                profileDetail: this.getProfileDetails(),
                loggedInRole
            });
        }
        isValidPhone() {
            // Validate the phone number for international format
            if (this.ifInternationalFormat()) {
                return this.isValidISD && this.phoneNumber;
            }
            return this.dialNumberValueForNonUS;
        }
        valid() {
            this.setErrorFlags();
            // hardcoded check for US phone - was requested
            // "this.profile.regexUS" must be used later
            const regexUS = new RegExp("^(\\+1|1)?\\d{10}$");
            const regexOther = new RegExp("([A-Za-z0-9-_]+)");
            //regex for extension number validation (2 to 13 digits only allowed)
            // eslint-disable-next-line sonarjs/concise-regex
            const regexExtension = new RegExp("^[0-9]{2,18}$");
            this.isErrTeam = this.displayTeamsDropdown ? !this.team : false;
            this.isErrRole = this.displayRoleDropdown ? !this.roleInfo : false;
            if (this.isExtensionUsed) {
                this.isErrPhoneExt = !this.extensionNumber;
                if (this.isErrPhoneExt || this.isErrTeam || this.isErrRole) {
                    this.isErrUnknown = false;
                    this.isExtAlreadyInUse = false;
                    this.isErrExtRegister = false;
                    return false;
                }
                if (!regexExtension.test(this.extensionNumber)) {
                    this.isErrPhoneExt = true;
                    this.isErrUnknown = false;
                    this.isErrExtRegister = false;
                    this.isExtAlreadyInUse = false;
                    return false;
                }
            }
            else {
                if (this.phoneFormat === "US") {
                    if (regexUS.test(this.dialNumberValueForNonUS)) {
                        if (this.dialNumberValueForNonUS.length === 11) {
                            // only +1 prefix allowed not just 1
                            // hardcoded add "+" if 11 digits
                            this.dialNumberValueForNonUS = `+${this.dialNumberValueForNonUS}`;
                        }
                        else if (_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.featureflag.isSteeringDigitsAppendEnabled() &&
                            this.dialNumberValueForNonUS.length === 10) {
                            // hardcoded +1 for CX-6490.
                            this.dialNumberValueForNonUS = `+1${this.dialNumberValueForNonUS}`;
                        }
                    }
                    else {
                        this.isErrPhone = true;
                        this.isErrUnknown = false;
                        this.isErrDNRegister = false;
                        this.isDNAlreadyInUse = false;
                        return false;
                    }
                }
                if (this.ifInternationalFormat()) {
                    this.isErrPhone = !this.isValidPhone();
                }
                else if (this.isUsesOtherFormat() && !regexOther.test(this.dialNumberValueForNonUS)) {
                    this.isErrPhone = true;
                    this.isErrUnknown = false;
                    this.isErrDNRegister = false;
                    this.isDNAlreadyInUse = false;
                    return false;
                }
                if (this.isErrPhone || this.isErrTeam) {
                    this.isErrUnknown = false;
                    this.isErrDNRegister = false;
                    this.isErrExtRegister = false;
                    this.isDNAlreadyInUse = false;
                    this.isErrPhoneExt = false;
                    return false;
                }
            }
            if (this.isErrUnknown) {
                this.isErrUnknown = false;
            }
            if (this.isErrDNRegister) {
                this.isErrDNRegister = false;
            }
            if (this.isErrPhone) {
                this.isErrPhone = false;
            }
            if (this.isErrExtRegister) {
                this.isErrExtRegister = false;
            }
            if (this.isErrPhoneExt) {
                this.isErrPhoneExt = false;
            }
            return true;
        }
        onDNExtensionRadioChange(e) {
            const format = e.detail.selected;
            this.deviceType = e.detail.selected;
            this.setValuesOnRadioChange(format);
            this.dispatchEventWhenComponentUpdates();
        }
        onVoiceOptionChange(e) {
            this.deviceType = e.detail.selected;
            this.setDeviceType();
            this.dispatchEventWhenComponentUpdates();
        }
        handleKeyDown(e) {
            e.stopImmediatePropagation();
        }
        ifInternationalFormat() {
            return this.phoneFormat === phoneFormats.international;
        }
        handleFormatChange() {
            document.dispatchEvent(new CustomEvent("on-widget-update"));
            this.setErrorFlags();
            this.isErrUnknown = false;
            this.phoneFormat = this.ifInternationalFormat() ? phoneFormats.other : phoneFormats.international;
            this.isInternational = this.ifInternationalFormat();
            this.dispatchEventWhenComponentUpdates();
        }
        handleCountryChange(e) {
            var _a;
            const event = e.detail.srcEvent;
            if (event && event.detail) {
                if (!event.detail.value || !event.detail.value.id) {
                    this.countryCodeValue = "+1";
                    this.countryCallingCode = "";
                    return;
                }
                this.countryCodeValue = (_a = event.detail.selected[0]) === null || _a === void 0 ? void 0 : _a.value;
                this.countryCallingCode = event.detail.value.id;
                this.isValidISD = e.detail.isValid;
                if (e.detail.isValid) {
                    this.setErrorFlags();
                    this.isErrUnknown = false;
                }
                this.dispatchEventWhenComponentUpdates();
            }
        }
        getErrorMessage() {
            if (this.isErrPhone) {
                return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:stationLoginInvalidNumber")}`;
            }
            else if (this.isErrDNRegister) {
                if (this.isDNAlreadyInUse) {
                    return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnAlreadyInUse")} (${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(trackingIdLabel)}: ${this.trackingId})`;
                }
                return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnRegisterFailure")} (${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(trackingIdLabel)}: ${this.trackingId})`;
            }
            return `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:stationLoginInvalidNumber")}`;
        }
        radioChange(e) {
            const format = e.detail.selected;
            this.deviceType = e.detail.selected;
            this.phoneFormat = format;
            this.dispatchEventWhenComponentUpdates();
        }
        setErrorFlags() {
            this.isErrUnknown = true;
            this.isErrDNRegister = false;
            this.isDNAlreadyInUse = false;
            this.isErrPhone = false;
            this.isErrPhoneExt = false;
            this.isExtAlreadyInUse = false;
            this.isErrExtRegister = false;
            this.isWebRtcUnsupportedBrowser = false;
            this.isMicrophoneAccessDenied = false;
        }
        // ROST: create decorator for custom event
        evt(name, detail) {
            this.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true, detail }));
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[User Profile]: Dispatching event", name, detail);
        }
        static get styles() {
            return _userProfile_scss__WEBPACK_IMPORTED_MODULE_10__["default"];
        }
        getSelectedRole() {
            if (!this.roleInfo) {
                const selectedRoleOption = this.roles.filter((role) => role.roleName.toLocaleLowerCase() === this.selectedRoleName.toLocaleLowerCase());
                this.roleInfo = selectedRoleOption[0];
            }
            return this.roleInfo;
        }
        getRoleSelection() {
            let focusRoleDropdown;
            if (this.selectedRoleName !== "agent" && this.selectedRoleName !== "" && this.isMonitoringEnabled === true) {
                focusRoleDropdown = false;
            }
            else {
                focusRoleDropdown = true;
            }
            return focusRoleDropdown;
        }
        getProfileDetails() {
            var _a, _b, _c, _d, _e, _f;
            return {
                roles: this.displayRoleDropdown
                    ? ((_b = (_a = this.roleInfo) === null || _a === void 0 ? void 0 : _a.roleName) === null || _b === void 0 ? void 0 : _b.split("_")) || ((_c = this.userRole) === null || _c === void 0 ? void 0 : _c.split("_"))
                    : (_d = this.userRole) === null || _d === void 0 ? void 0 : _d.split("_"),
                teamName: ((_e = this.team) === null || _e === void 0 ? void 0 : _e.teamName) ? this.team.teamName : this.teamName,
                teamId: ((_f = this.team) === null || _f === void 0 ? void 0 : _f.teamId) ? this.team.teamId : this.teamId,
                dnNumber: this.getDn(),
                isExtension: this.isExtensionUsed,
                usesOtherDN: this.isUsesOtherFormat() || this.countryCodeValue !== "+1",
                extensionNumber: this.extensionNumber || this.defaultDn || "",
                dialNumberValueForNonUS: this.dialNumberValueForNonUS,
                defaultDn: this.defaultDn,
                isDefaultDnSet: this.isDefaultDnSet,
                isInternational: this.ifInternationalFormat(),
                phoneNumber: this.isInternational ? this.phoneNumber : this.defaultDn || "",
                countryCallingCode: this.isInternational ? this.countryCallingCode || this.defaultCountryCallingCode : "",
                countryCodeValue: this.isInternational ? this.countryCodeValue || this.defaultCountryCodeValue : "",
                isRememberMyCredentials: this.isRememberMyCredentials,
                deviceType: this.deviceType,
                deviceId: this.deviceId,
                isEmergencyModalAlreadyDisplayed: this.isEmergencyModalAlreadyDisplayed
            };
        }
        /**
         * On any input field change dispatch event and handle in profile settings
         */
        dispatchEventWhenComponentUpdates() {
            const checkRole = this.displayRoleDropdown ? this.roleInfo : true;
            const dnInputValue = this.getDn();
            const checkDN = this.displayDNExtension ? dnInputValue : true;
            const checkTeam = this.displayTeamsDropdown ? this.team : true;
            const isDeviceTypeBrowser = this.isWebRTCEnabled && this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.BROWSER;
            const flg = checkRole && (checkDN || isDeviceTypeBrowser) && checkTeam ? false : true;
            const profileDetail = this.getProfileDetails();
            this.evt("on-component-update", {
                submitProperty: flg,
                profileDetail
            });
        }
        errorCodesCheck() {
            const errMsg = this.getErrorMsgForReasonCode(this.reasonCode);
            if (this.isDesktopReasonCodeEnabled && this.reasonCode && errMsg) {
                return [
                    {
                        type: "error",
                        message: `${errMsg}`
                    }
                ];
            }
            if (this.isErrPhone) {
                return [
                    {
                        type: "error",
                        message: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:stationLoginInvalidNumber")}`
                    }
                ];
            }
            if (this.isErrDNRegister) {
                if (this.isDNAlreadyInUse) {
                    return [
                        {
                            type: "error",
                            message: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnAlreadyInUse")} (${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(trackingIdLabel)}: ${this.trackingId})`
                        }
                    ];
                }
                return [
                    {
                        type: "error",
                        message: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnRegisterFailure")} (${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(trackingIdLabel)}: ${this.trackingId})`
                    }
                ];
            }
            if (this.isErrPhoneExt) {
                return [
                    {
                        type: "error",
                        message: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:stationLoginInvalidExtNumber")}`
                    }
                ];
            }
            if (this.isErrExtRegister) {
                if (this.isExtAlreadyInUse) {
                    return [
                        {
                            type: "error",
                            message: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnAlreadyInUse")} (${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(trackingIdLabel)}: ${this.trackingId})`
                        }
                    ];
                }
                return [
                    {
                        type: "error",
                        message: `${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnRegisterFailure")} (${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(trackingIdLabel)}: ${this.trackingId})`
                    }
                ];
            }
            return [];
        }
        renderExtensionForm() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="extension-format">
          <md-form class="form-class" id="ext-form">
            <md-input
              clear
              clearAriaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.clearExtensionLabel")}"
              htmlId="dial-extension"
              ariaDescribedBy="dial-extension"
              ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(extensionInfo)}"
              type="tel"
              id="ext"
              placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(extensionPlaceHolder)}
              ?readOnly=${this.isDefaultDnSet}
              shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_13__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
              ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
              class=${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_7__.classMap)({ err: this.isErrPhoneExt })}
              .value=${this.extensionNumber ? this.extensionNumber : ""}
              .secondaryLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(extensionInfo)}"
              @input-change=${this.setExtensionNumber}
              @input-blur=${this.onDialNumberOrExtBlur}
              @keypress=${this.handleEnterKeypress}
              .messageArr=${this.errorCodesCheck()}
            ></md-input>
          </md-form>
        </div>
      `;
        }
        renderDnForm() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <md-form class="form-class">
          <md-input
            clear
            clearAriaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(clearAriaLabel)} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(dnStationLogin)}"
            type="tel"
            id="dn"
            placeholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(dnStationLogin)}
            ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(dnStationLogin)}"
            class=${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_7__.classMap)({ err: this.isErrPhone })}
            ?readOnly=${this.isDefaultDnSet}
            ?disabled=${this.isDefaultDnSet}
            .value=${this.dialNumberValueForNonUS ? this.dialNumberValueForNonUS : ""}
            shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_13__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
            ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
            @keydown=${this.handleKeyDown}
            @keypress=${this.handleEnterKeypress}
            @input-change=${this.setDialNumber}
            @input-blur=${this.onDialNumberOrExtBlur}
            .messageArr=${this.errorCodesCheck()}
          ></md-input>
        </md-form>
      `;
        }
        renderInternationalForm() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <md-form class="form-class" id="international-form">
          <md-phone-input
            type="tel"
            ?pill=${!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
            ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
            id="international"
            name="international-value"
            .errorMessage=${this.getErrorMessage()}
            .value="${this.phoneNumber}"
            .countryCallingCode=${this.countryCallingCode}
            .numberPlaceholder=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:stationDnPlaceholder")}
            .countryCodeAriaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.countryCode")}
            .dialNumberAriaLabel=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationDnLabelAriaLabel")}
            ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(dnStationLogin)}"
            ?showErrorMessage=${this.ifInternationalFormat() &&
                (this.isErrPhone || this.isErrDNRegister || this.isDNAlreadyInUse)}
            @phoneinput-keydown="${(e) => {
                e.stopImmediatePropagation();
                this.handlePhoneInputKeydown(e.detail.srcEvent);
            }}"
            @phoneinput-change="${(e) => {
                e.stopImmediatePropagation();
                this.setInternationalPhNumber(e);
                this.setErrorFlags();
                this.isErrUnknown = false;
            }}"
            @phoneinput-blur="${(e) => {
                e.stopImmediatePropagation();
                this.setInternationalPhNumber(e);
            }}"
            @countrycode-change="${(e) => this.handleCountryChange(e)}"
            clear-icon-height="12px"
            clearAriaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(clearAriaLabel)} ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(dnStationLogin)}"
          ></md-phone-input>
        </md-form>
      `;
        }
        renderTeam() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="md-input-container sl-combobox" tabindex="-1">
          <label class="teams-label" for="teams" tabindex="-1">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationLoginTeamLabel")}</label>
          ${
            /** retaining the check here,
             * however when no team is present its a config error and agent has to sign out
             * even before the app loads. This logic is taken care. */
            this.isConsultTransferInfiniteScrollEnabled
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                  <agentx-wc-teams-list-infinite
                    selectedTeamName="${this.teamName ? this.teamName : ""}"
                    agentDbId="${this.agentDbId}"
                    orgId="${this.orgId}"
                    teamsMeta="${this.teamsMeta}"
                    .paginatedTeamResponse="${this.paginatedTeamResponse}"
                    @on-team-selected="${this.onTeamSelect}"
                  ></agentx-wc-teams-list-infinite>
                `
                : !this.isTeamsEmpty
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                    <md-combobox
                      placeholder="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.selectTeam")}"
                      ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.selectTeam")}"
                      search-result-aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.selectTeamOnSearch")}"
                      ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
                      .options=${this.teamsArray}
                      .value=${[this.teamsArray.find((teamName) => teamName === this.teamName) || this.teamName]}
                      option-id="teamId"
                      option-value="teamName"
                      .visibleOptions=${3}
                      @change-selected="${this.handleSelectedTeam}"
                      no-options-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.noOptions")}
                      no-results-i18n=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.noResults")}
                      clear-icon-height="12px"
                      shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_13__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
                      clear-aria-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.clearTeamLabel")}"
                    ></md-combobox>
                  `
                    : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
        </div>
      `;
        }
        getUnknownErrorMessage() {
            if (this.isWebRTCEnabled && this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.BROWSER) {
                if (this.isMicrophoneAccessDenied) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:microphoneAccessDeniedError");
                }
                if (this.isWebRtcUnsupportedBrowser) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:browserUnsupportedError");
                }
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:stationLoginFailed");
            }
            if (this.isMaximumSessionsReached) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:maximumSessionsReachedError");
            }
            if (this.auxCodeError) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:auxiliaryCodeFailed");
            }
            if (this.fetchUniqueTeamIdError) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:fetchTeamIdFailed");
            }
            return this.isDNRegisterTimeOut
                ? this.isExtensionUsed
                    ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:extNumberRegisterTimeout")
                    : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnRegisterTimeout")
                : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:stationLoginFailed");
        }
        renderUnknownError() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div part="message" class="error-message">
          <md-help-text .messageType=${"error"}>
            ${this.getUnknownErrorMessage()} ${this.trackingId ? `(${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(trackingIdLabel)}: ${this.trackingId})` : ""}
          </md-help-text>
        </div>
      `;
        }
        getLabel() {
            if (this.loginVoiceOptions.length === 1) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:stationLogin.${this.loginVoiceOptions[0].toLowerCase()}Label`);
            }
            return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationLoginVoiceLabel");
        }
        getToolTipInfoByLoginVoiceOptions() {
            if (this.loginVoiceOptions.length === 2) {
                if (this.loginVoiceOptions[0] === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.AGENT_DN) {
                    if (this.loginVoiceOptions[1] === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.EXTENSION) {
                        return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(extensionInfo);
                    }
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.loginVoiceDnBrowserInfo");
                }
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.loginVoiceExtBrowserInfo");
            }
            return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.loginVoiceInfo");
        }
        getTooltipInfo() {
            if (this.isWebRTCEnabled) {
                return this.getToolTipInfoByLoginVoiceOptions();
            }
            return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(extensionInfo);
        }
        dispatchAnnouncement(message) {
            window.dispatchEvent(new CustomEvent("ax-announcement-update", {
                detail: {
                    thisEvent: {
                        message
                    }
                }
            }));
        }
        getLabelSection() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="dial-number-label">
          ${(0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
            <label
              tabindex="-1"
              class="${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_7__.classMap)({ "label-with-bottom-margin": this.loginVoiceOptions.length === 1 })}"
              >${this.getLabel()}</label
            >
          `}
          ${this.loginVoiceOptions.length > 1
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                <md-tooltip
                  ?opened=${this.isExtensionTooltipOpened}
                  message=${this.getTooltipInfo()}
                  placement="bottom"
                >
                  <md-button
                    ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.extensionInfoButtonLabel")}"
                    circle
                    variant="ghost"
                    class="info-icon dn-info-icon-button"
                    size="20"
                    @focus=${() => {
                    this.isExtensionTooltipOpened = true;
                    this.dispatchAnnouncement(this.getTooltipInfo());
                }}
                    @blur=${() => (this.isExtensionTooltipOpened = false)}
                  >
                    <md-icon name="info-badge-filled" size="16" iconSet="momentumDesign"></md-icon>
                  </md-button>
                </md-tooltip>
              `
                : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
        </div>
      `;
        }
        handleKeyDownRadio(e) {
            if (this.telephonyRadio) {
                this.telephonyRadio.rovingPreventFocus = false;
            }
            this.handleEnterKeypress(e);
        }
        getRadioList() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <md-radiogroup
          class="station-login-radio-group"
          group-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(modeOptionslabel)}"
          alignment="horizontal"
          checked="${this.radioSelection}"
          @keydown=${this.handleKeyDownRadio}
          @radio-change=${(e) => this.onVoiceOptionChange(e)}
        >
          ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_8__.repeat)(this.loginVoiceOptions, (option) => (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
              <md-radio
                slot="radio"
                value="${option}"
                ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:stationLogin.${option.toLocaleLowerCase()}`)}"
                title="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:stationLogin.${option.toLocaleLowerCase()}`)}"
                >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(`app:stationLogin.${option.toLocaleLowerCase()}`)}
              </md-radio>
            `)}
        </md-radiogroup>
      `;
        }
        renderBrowserSection() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="browser-label-container">
          <label>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.browserInfo")}</label>
        </div>
      `;
        }
        renderEmergencyInfoSectionOnSecondLogin() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div>
          <div class="browser-label-container-emergency">
            <label>${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.browserInfo")}</label>
          </div>
          <div class="browser-label-container-emergency-helpText">
            <md-tooltip
              class="emergency-help-tooltip"
              placement="top"
              message=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.updateCurrentAddInfoOnSecondSignIn")}
            >
              <md-button
                aria-label=${this.getTooltipInfo()}
                circle
                variant="ghost"
                class="info-icon"
                role="tooltip"
                size="16"
                @focus=${() => (this.isExtensionTooltipOpened = true)}
                @blur=${() => (this.isExtensionTooltipOpened = false)}
              >
                <md-icon name="info-badge-filled" size="16" iconSet="momentumDesign"></md-icon>
              </md-button>
              <label
                >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.updateCurrentAddInfoOnSecondSignIn")}
                <md-link
                  inline
                  class="help-section-link"
                  aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.seeHelpSection")}
                  tag="a"
                  href=${_constants__WEBPACK_IMPORTED_MODULE_9__.emergency911HelpLink}
                  target="_blank"
                  >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.seeHelpSection")}</md-link
                >
              </label>
            </md-tooltip>
          </div>
        </div>
      `;
        }
        getInputField() {
            switch (this.deviceType) {
                case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.EXTENSION: {
                    return this.renderExtensionForm();
                }
                case _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.constants.LoginVoiceOptions.BROWSER: {
                    if (_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_3__.SERVICE.featureflag.isDesktopEmergencyNotificationEnabled() && this.isEmergencyModalAlreadyDisplayed) {
                        return this.renderEmergencyInfoSectionOnSecondLogin();
                    }
                    return this.renderBrowserSection();
                }
                default:
                    return this.renderDNSection();
            }
        }
        renderVoiceOptionSection() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        ${this.displayDNExtension // role base
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
              <div
                class="station-login-radio 
                ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_7__.classMap)({
                    "station-login-radio-min": this.loginVoiceOptions.length === 1,
                    "station-login-radio-max": this.loginVoiceOptions.length === 3
                })}"
              >
                ${this.getLabelSection()} ${this.loginVoiceOptions.length > 1 ? this.getRadioList() : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
              </div>
              ${this.getInputField()}
            `
                : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
      `;
        }
        renderDNSection() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <!-- International Checkbox -->
        <div class="international-checkbox-wrapper">
          <md-checkbox
            slot="checkbox"
            ?disabled="${this.isDefaultDnSet}"
            .checked="${this.ifInternationalFormat()}"
            @checkbox-change=${this.handleFormatChange}
            ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.internationalDialingFormat")}"
            >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.internationalDialingFormat")}</md-checkbox
          >
          <md-tooltip
            ?opened=${this.isIntenationalTooltipOpened}
            ?disabled="${this.isDefaultDnSet}"
            message="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.internationalDialingFormatInfo")}"
            placement="top"
            ><md-button
              ?disabled="${this.isDefaultDnSet}"
              ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.internationalDialingFormatInfoButtonLabel")}"
              circle
              variant="ghost"
              class="info-icon international-info-btn"
              size="20"
              @focus=${() => {
                this.isIntenationalTooltipOpened = true;
                this.dispatchAnnouncement((0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.internationalDialingFormatInfo"));
            }}
              @blur=${() => (this.isIntenationalTooltipOpened = false)}
            >
              <md-icon name="info-badge-filled" size="16" iconSet="momentumDesign"></md-icon>
            </md-button>
          </md-tooltip>
        </div>

        <!-- phone input -->
        ${this.ifInternationalFormat() ? this.renderInternationalForm() : this.renderDnForm()}
      `;
        }
        handleCheckboxChange(e) {
            const checkbox = e.target;
            this.dispatchEvent(new CustomEvent("checkbox-state-changed", {
                detail: { checked: checkbox.checked },
                bubbles: true,
                composed: true
            }));
        }
        renderEmergencyNotificationBody() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="emergency-notification-body">
          <agentx-wc-emergency-notification-content> </agentx-wc-emergency-notification-content>
          <div class="read-the-notification-wrapper">
            <md-checkbox
              id="readNotificationCheckbox"
              slot="checkbox"
              class="read-the-notification"
              @checkbox-change=${this.handleCheckboxChange}
            >
              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.readNotification")}
            </md-checkbox>
          </div>
        </div>
      `;
        }
        renderUserProfileContent() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="user-profile">
          ${(0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
            <!-- Role Select -->
            ${this.displayRoleDropdown
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                  <div class="md-input-container sl-combobox roles-combobox">
                    <label class="teams-label">${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationLoginRoleLabel")}</label>
                    <md-dropdown
                      class="roles-dropdown"
                      .title="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.selectRole")}"
                      .options="${this.roles}"
                      option-id="roleId"
                      option-value="roleDisplay"
                      ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
                      ?pill=${!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_4__.themeManager.isMomentumV2Enabled}
                      .visibleOptions=${2}
                      @dropdown-selected="${this.handleSelectedRole}"
                      .defaultOption=${this.getSelectedRole()}
                      custom-tab-index=${-1}
                      .autofocus=${this.getRoleSelection()}
                    ></md-dropdown>
                  </div>
                `
                : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}

            <!-- Agent_DN | Extension Section -->
            ${this.isWebRTCEnabled
                ? this.renderVoiceOptionSection()
                : this.displayDNExtension
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                    <div class="station-login-radio station-login-radio-min">
                      <div class="dial-number-label">
                        <label tabindex="-1" for="dial-number-label"
                          >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationLoginDNExtension")}</label
                        >
                        <md-tooltip
                          ?opened=${this.isExtensionTooltipOpened}
                          message=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(extensionInfo)}
                          placement="bottom"
                        >
                          <md-button
                            aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(extensionInfo)}
                            circle
                            variant="white"
                            class="info-icon dn-info-icon-button"
                            role="tooltip"
                            size="20"
                            @focus=${() => (this.isExtensionTooltipOpened = true)}
                            @blur=${() => (this.isExtensionTooltipOpened = false)}
                            @keydown=${this.handleKeyDown}
                          >
                            <md-icon name="info-badge-filled" size="16" iconSet="momentumDesign"></md-icon>
                          </md-button>
                        </md-tooltip>
                      </div>
                      <md-radiogroup
                        class="station-login-radio-group"
                        group-label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationLoginDNExtension")}"
                        alignment="horizontal"
                        checked="${this.radioSelection}"
                        id="dial-number-label"
                        @keydown=${this.handleKeyDownRadio}
                        @radio-change=${(e) => this.onDNExtensionRadioChange(e)}
                      >
                        <md-radio slot="radio" value="DN" ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(dnStationLogin)}" title="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(dnStationLogin)}"
                          >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(dnStationLogin)}</md-radio
                        >
                        <md-radio
                          slot="radio"
                          value="Extension"
                          ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.extension")}"
                          title="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.extension")}"
                          >${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.extension")}
                        </md-radio>
                      </md-radiogroup>
                    </div>

                    ${this.mode === "Extension" ? this.renderExtensionForm() : this.renderDNSection()}
                  `
                    : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
          `}
          <!-- team select -->
          ${this.displayTeamsDropdown ? this.renderTeam() : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
          <!-- For React Agent Profile Component -->
          ${!this.isStationlogin
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                <div class="remember-me-checkbox-wrapper">
                  <md-checkbox
                    slot="checkbox"
                    ?checked=${this.isRememberMyCredentials}
                    label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.rememberMeProfile")}"
                    class="remember-me-checkbox"
                    @checkbox-change=${() => this.handleRememberMeCheckBoxChange()}
                  >
                    ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.rememberMeProfile")}
                  </md-checkbox>
                </div>
              `
                : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
          <!-- Error Message -->
          ${this.isErrUnknown ? this.renderUnknownError() : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
        </div>
      `;
        }
        render() {
            return this.showEmergencyNotificationWebrtc && !this.isEmergencyModalAlreadyDisplayed
                ? this.renderEmergencyNotificationBody()
                : this.renderUserProfileContent();
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "userRole", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isMonitoringEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isSubmit", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "selectedRoleName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "teamName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "teamId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "dialNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isExtensionUsed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDefaultDnSet", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "extensionNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "dialNumberValueForNonUS", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "defaultDn", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDefaultDnSetFromProfile", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isInternational", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isInternationalFromProfile", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "countryCallingCode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "countryCodeValue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isRememberMyCredentials", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "auxCodeError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "fetchUniqueTeamIdError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "orgId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "agentDbId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "isSubmitProfile", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
    ], Element.prototype, "teams", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "filteredTeamList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "teamsMeta", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isErrUnknown", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isErrDNRegister", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "reasonCode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDesktopReasonCodeEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Function })
    ], Element.prototype, "getErrorMsgForReasonCode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDNAlreadyInUse", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isErrPhone", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isErrPhoneExt", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isExtAlreadyInUse", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isErrExtRegister", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDNRegisterTimeOut", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isTeamsEmpty", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "usesOtherDN", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "trackingId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isStationlogin", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isExtensionUsedFromProfile", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "usesOtherDNFromProfile", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isMonitoringEnabledFromProfile", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "phoneFormat", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "phoneNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isMaximumSessionsReached", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
    ], Element.prototype, "loginVoiceOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "deviceType", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "deviceId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isWebRTCEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isWebRtcUnsupportedBrowser", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isMicrophoneAccessDenied", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "showEmergencyNotificationWebrtc", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isEmergencyModalAlreadyDisplayed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isConsultTransferInfiniteScrollEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isErrTeam", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "mode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isErrRole", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "displayRoleDropdown", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "displayTeamsDropdown", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "displayDNExtension", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "radioSelection", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isExtensionTooltipOpened", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isIntenationalTooltipOpened", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "roleInfo", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "paginatedTeamResponse", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)(".form-class")
    ], Element.prototype, "form", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)("#international-form")
    ], Element.prototype, "internationalForm", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)("#ext-form")
    ], Element.prototype, "extForm", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)(".footer-buttons")
    ], Element.prototype, "continueButton", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)(".dn-info-icon-button")
    ], Element.prototype, "dnInfoIconButton", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)(".roles-dropdown")
    ], Element.prototype, "rolesDropDown", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.query)(".station-login-radio-group")
    ], Element.prototype, "telephonyRadio", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-user-profile")
    ], Element);
    UserProfile.Element = Element;
})(UserProfile || (UserProfile = {}));


/***/ }),

/***/ "./src/components/userStationLogin/userStationLogin.scss":
/*!***************************************************************!*\
  !*** ./src/components/userStationLogin/userStationLogin.scss ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.sl-footer {
  padding-top: 11px;
  display: flex;
  flex-direction: column;
  width: 100%;
}

@media screen and (max-height: 540px) {
  md-modal::part(modal-container) {
    max-height: calc(100vh - 2%);
  }
  md-modal::part(modal-content) {
    min-height: 100%;
    max-height: 100vh;
    overflow-y: auto;
  }
}
.sl-form-label {
  color: var(--md-primary-text-color, #171b1f);
  display: block;
  font-family: "CiscoSansTT Regular", sans-serif;
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
  margin: 0;
  text-align: center;
}

md-modal::part(modal-body) {
  overflow: visible;
}

.md-loading {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

.modal-content {
  padding: 0 24px;
}

.btn-submit {
  display: flex;
  justify-content: flex-end;
}

.footer-btn {
  margin-left: 0.75rem;
}

.footer-buttons {
  display: flex;
  justify-content: flex-end;
}

.remember-me-checkbox-wrapper {
  padding-bottom: 15px;
}

.remember-me-checkbox::part(checkbox-label) {
  z-index: 0;
}
/*# sourceURL=/home/jenkins/agent/workspace/wxcc-service-management/wxcc-service-management/packages/agentx-mfe-wc-based/src/components/userStationLogin/userStationLogin.scss */
/*# sourceURL=userStationLogin.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3d4Y2Mtc2VydmljZS1tYW5hZ2VtZW50L3BhY2thZ2VzL2FnZW50eC1tZmUtd2MtYmFzZWQvc3JjL2NvbXBvbmVudHMvdXNlclN0YXRpb25Mb2dpbi91c2VyU3RhdGlvbkxvZ2luLnNjc3MiLCJ1c2VyU3RhdGlvbkxvZ2luLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBVUE7RUFDRSxpQkFBQTtFQUNBLGFBQUE7RUFDQSxzQkFBQTtFQUNBLFdBQUE7QUNURjs7QURZQTtFQUNFO0lBQ0UsNEJBQUE7RUNURjtFRFlBO0lBQ0UsZ0JBQUE7SUFDQSxpQkFBQTtJQUNBLGdCQUFBO0VDVkY7QUFDRjtBRGFBO0VBQ0UsNENBQUE7RUFDQSxjQUFBO0VBQ0EsOENBQUE7RUFDQSxlQTlCUTtFQStCUixnQkFBQTtFQUNBLGlCQS9CZTtFQWdDZixTQUFBO0VBQ0Esa0JBQUE7QUNYRjs7QURjQTtFQUNFLGlCQUFBO0FDWEY7O0FEY0E7RUFDRSxTQTdDUztFQThDVCxrQkFBQTtFQUNBLFFBL0NTO0VBZ0RULGdDQUFBO0FDWEY7O0FEY0E7RUFDRSxlQUFBO0FDWEY7O0FEY0E7RUFDRSxhQUFBO0VBQ0EseUJBQUE7QUNYRjs7QURjQTtFQUNFLG9CQUFBO0FDWEY7O0FEY0E7RUFDRSxhQUFBO0VBQ0EseUJBQUE7QUNYRjs7QURjQTtFQUNFLG9CQUFBO0FDWEY7O0FEY0E7RUFDRSxVQUFBO0FDWEYiLCJmaWxlIjoidXNlclN0YXRpb25Mb2dpbi5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiJGZpZnR5LXBjOiA1MCU7XG4kY2xyLXdoaXRlOiAjZmZmO1xuJHNsLXdpZHRoOiA0ODBweDtcbiRmb250LTE2OiAxNnB4O1xuJGxpbmUtaGVpZ2h0LTI0OiAyNHB4O1xuXG4kc2wtaGVpZ2h0OiAzNjBweDtcbiRzbC1tYXgtaGVpZ2h0OiA1MDBweDtcbiRzbC1sYWJlbC1jb2xvcjogIzE3MWIxZjtcblxuLnNsLWZvb3RlciB7XG4gIHBhZGRpbmctdG9wOiAxMXB4O1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICB3aWR0aDogMTAwJTtcbn1cblxuQG1lZGlhIHNjcmVlbiBhbmQgKG1heC1oZWlnaHQ6IDU0MHB4KSB7XG4gIG1kLW1vZGFsOjpwYXJ0KG1vZGFsLWNvbnRhaW5lcikge1xuICAgIG1heC1oZWlnaHQ6IGNhbGMoMTAwdmggLSAyJSk7XG4gIH1cblxuICBtZC1tb2RhbDo6cGFydChtb2RhbC1jb250ZW50KSB7XG4gICAgbWluLWhlaWdodDogMTAwJTtcbiAgICBtYXgtaGVpZ2h0OiBjYWxjKDEwMHZoKTtcbiAgICBvdmVyZmxvdy15OiBhdXRvO1xuICB9XG59XG5cbi5zbC1mb3JtLWxhYmVsIHtcbiAgY29sb3I6IHZhcigtLW1kLXByaW1hcnktdGV4dC1jb2xvciwgJHNsLWxhYmVsLWNvbG9yKTtcbiAgZGlzcGxheTogYmxvY2s7XG4gIGZvbnQtZmFtaWx5OiBcIkNpc2NvU2Fuc1RUIFJlZ3VsYXJcIiwgc2Fucy1zZXJpZjtcbiAgZm9udC1zaXplOiAkZm9udC0xNjtcbiAgZm9udC13ZWlnaHQ6IDgwMDtcbiAgbGluZS1oZWlnaHQ6ICRsaW5lLWhlaWdodC0yNDtcbiAgbWFyZ2luOiAwO1xuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG59XG5cbm1kLW1vZGFsOjpwYXJ0KG1vZGFsLWJvZHkpIHtcbiAgb3ZlcmZsb3c6IHZpc2libGU7XG59XG5cbi5tZC1sb2FkaW5nIHtcbiAgbGVmdDogJGZpZnR5LXBjO1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogJGZpZnR5LXBjO1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgtJGZpZnR5LXBjLCAtJGZpZnR5LXBjKTtcbn1cblxuLm1vZGFsLWNvbnRlbnQge1xuICBwYWRkaW5nOiAwIDI0cHg7XG59XG5cbi5idG4tc3VibWl0IHtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbn1cblxuLmZvb3Rlci1idG4ge1xuICBtYXJnaW4tbGVmdDogMC43NXJlbTtcbn1cblxuLmZvb3Rlci1idXR0b25zIHtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbn1cblxuLnJlbWVtYmVyLW1lLWNoZWNrYm94LXdyYXBwZXIge1xuICBwYWRkaW5nLWJvdHRvbTogMTVweDtcbn1cblxuLnJlbWVtYmVyLW1lLWNoZWNrYm94OjpwYXJ0KGNoZWNrYm94LWxhYmVsKSB7XG4gIHotaW5kZXg6IDA7XG59XG4iLCIuc2wtZm9vdGVyIHtcbiAgcGFkZGluZy10b3A6IDExcHg7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIHdpZHRoOiAxMDAlO1xufVxuXG5AbWVkaWEgc2NyZWVuIGFuZCAobWF4LWhlaWdodDogNTQwcHgpIHtcbiAgbWQtbW9kYWw6OnBhcnQobW9kYWwtY29udGFpbmVyKSB7XG4gICAgbWF4LWhlaWdodDogY2FsYygxMDB2aCAtIDIlKTtcbiAgfVxuICBtZC1tb2RhbDo6cGFydChtb2RhbC1jb250ZW50KSB7XG4gICAgbWluLWhlaWdodDogMTAwJTtcbiAgICBtYXgtaGVpZ2h0OiAxMDB2aDtcbiAgICBvdmVyZmxvdy15OiBhdXRvO1xuICB9XG59XG4uc2wtZm9ybS1sYWJlbCB7XG4gIGNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LXRleHQtY29sb3IsICMxNzFiMWYpO1xuICBkaXNwbGF5OiBibG9jaztcbiAgZm9udC1mYW1pbHk6IFwiQ2lzY29TYW5zVFQgUmVndWxhclwiLCBzYW5zLXNlcmlmO1xuICBmb250LXNpemU6IDE2cHg7XG4gIGZvbnQtd2VpZ2h0OiA4MDA7XG4gIGxpbmUtaGVpZ2h0OiAyNHB4O1xuICBtYXJnaW46IDA7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbn1cblxubWQtbW9kYWw6OnBhcnQobW9kYWwtYm9keSkge1xuICBvdmVyZmxvdzogdmlzaWJsZTtcbn1cblxuLm1kLWxvYWRpbmcge1xuICBsZWZ0OiA1MCU7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiA1MCU7XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlKC01MCUsIC01MCUpO1xufVxuXG4ubW9kYWwtY29udGVudCB7XG4gIHBhZGRpbmc6IDAgMjRweDtcbn1cblxuLmJ0bi1zdWJtaXQge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kO1xufVxuXG4uZm9vdGVyLWJ0biB7XG4gIG1hcmdpbi1sZWZ0OiAwLjc1cmVtO1xufVxuXG4uZm9vdGVyLWJ1dHRvbnMge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kO1xufVxuXG4ucmVtZW1iZXItbWUtY2hlY2tib3gtd3JhcHBlciB7XG4gIHBhZGRpbmctYm90dG9tOiAxNXB4O1xufVxuXG4ucmVtZW1iZXItbWUtY2hlY2tib3g6OnBhcnQoY2hlY2tib3gtbGFiZWwpIHtcbiAgei1pbmRleDogMDtcbn0iXX0= */`);
    

/***/ }),

/***/ "./src/components/userStationLogin/userStationLogin.ts":
/*!*************************************************************!*\
  !*** ./src/components/userStationLogin/userStationLogin.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UserStationLogin: () => (/* binding */ UserStationLogin)
/* harmony export */ });
/* harmony import */ var _mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18nMixin */ "./src/mixins/i18nMixin.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../constants */ "./src/constants.ts");
/* harmony import */ var _EmergencyNotification_EmergencyNotificationContent__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../EmergencyNotification/EmergencyNotificationContent */ "./src/components/EmergencyNotification/EmergencyNotificationContent.ts");
/* harmony import */ var _teamsListInfiniteScroll__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./../teamsListInfiniteScroll */ "./src/components/teamsListInfiniteScroll/index.ts");
/* harmony import */ var _userStationLogin_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./userStationLogin.scss */ "./src/components/userStationLogin/userStationLogin.scss");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./utils */ "./src/components/userStationLogin/utils.ts");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_12__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};













const cancelButtonLabel = "app:common.cancelButton";
const signOutButtonLabel = "app:common.signOutButton";
const EventLogoutConfirm = "logout-confirm";
const ErrId = "Service.aqm.configs.application";
const EventNameError = "login-error";
const phoneFormats = { international: "International", us: "US", other: "Other" };
var UserStationLogin;
(function (UserStationLogin) {
    /**
     * @element agentx-wc-user-station-login
     * @fires login-success
     * @fires @login-error
     */
    let Element = class Element extends (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_5__.LitElement) {
        constructor() {
            super(...arguments);
            this.isModalOpen = false;
            this.isAdvancedHeader = false;
            this.isDesktopReasonCodeEnabled = false;
            this.getErrorMsgForReasonCode = Function;
            this.roleFromMe = "";
            this.organizationId = "";
            this.meUserId = "";
            this.isMonitoringEnabled = false;
            this.selectedRoleName = _constants__WEBPACK_IMPORTED_MODULE_7__.AGENT;
            this.isDesktopMaxSessionLimitsEnabled = false;
            this.isDesktopMaerskAcqueonTeamId = false;
            this.isDesktopMSStateSyncEnabled = false;
            this.isDesktopEmergencyNotificationEnabled = false;
            this.isDesktopEnhancedSignInEnabled = false;
            this.phoneFormat = phoneFormats.international;
            this.phoneNumber = "";
            this.isRememberMyCredentials = false;
            this.isWebRTCEnabled = false;
            this.deviceType = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.AGENT_DN;
            this.deviceId = "";
            this.reasonCode = "";
            this.isMaerskEnabled = false; // Default FF value is turned OFF.
            this.isDesktopAuxCodesInfiniteScrollEnabled = false;
            this.isConsultTransferInfiniteScrollEnabled = false;
            this.showEmergencyNotificationWebrtc = false;
            this.isEmergencyModalAlreadyDisplayed = false;
            this.availableExtensions = [];
            this.isInitializing = true;
            this.isSubmitBusy = false;
            this.isSubmitDisabled = true;
            this.isSubmitClicked = false;
            this.teamName = "";
            this.teamId = "";
            this.isTeamsEmpty = false;
            this.dialNumber = "";
            this.deviceTypeName = "";
            this.isDefaultDnSet = false;
            this.userRole = [];
            this.loginType = "DN"; // Used for telemetry.
            this.usesOtherDN = false;
            this.dialNumberValueForNonUS = "";
            this.defaultDn = "";
            this.isInternational = true;
            this.isPreferenceSaved = false;
            this.loginVoiceOptions = [];
            this.auxCodeConfig = {
                isError: false,
                fetchCompleted: false
            };
            this.fetchUniqueTeamIdError = false;
            // Station Login Error Flags
            this.isErrUnknown = false;
            this.isErrDNRegister = false;
            this.isDNAlreadyInUse = false;
            this.isErrPhone = false;
            this.isErrPhoneExt = false;
            this.isExtAlreadyInUse = false;
            this.isErrExtRegister = false;
            this.isDNRegisterTimeOut = false;
            this.isMaximumSessionsReached = false;
            this.isWebRtcUnsupportedBrowser = false;
            this.isMicrophoneAccessDenied = false;
            this.paginatedTeamResponse = {
                meta: {
                    links: {},
                    orgid: "",
                    page: 0,
                    pageSize: 0,
                    totalPages: 0,
                    totalRecords: 0
                },
                data: []
            };
            this.autoLoginType = _constants__WEBPACK_IMPORTED_MODULE_7__.AutoLoginType.None;
            this.profileChanged = false;
            // TODO: The types from Service.Conf holds good for Agent. Supervisor might not have all fields.
            this.profile = null;
            this.teams = [];
            this.selectedTeam = { teamId: "", teamName: "" };
            this.defaultAuxCode = "";
            this.extensionNumber = "";
            this.trackingId = "";
            this.isExtensionUsed = false;
            this.countryCodeValue = "+1"; // initial country code of US.
            this.countryCallingCode = "+1, United States of America, US";
            this.lang = localStorage.getItem("lng") || "en";
            this.getAuxCodeParameters = () => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                return {
                    idleCodeConfig: {
                        accessType: (_a = this.profile) === null || _a === void 0 ? void 0 : _a.idleCodesAccess,
                        ids: (_b = this.profile) === null || _b === void 0 ? void 0 : _b.idleCodesList
                    },
                    wrapUpCodeConfig: {
                        accessType: (_e = (_d = (_c = this.profile) === null || _c === void 0 ? void 0 : _c.wrapUpData) === null || _d === void 0 ? void 0 : _d.wrapUpProps) === null || _e === void 0 ? void 0 : _e.wrapUpCodeAccess,
                        ids: ((_h = (_g = (_f = this.profile) === null || _f === void 0 ? void 0 : _f.wrapUpData) === null || _g === void 0 ? void 0 : _g.wrapUpProps) === null || _h === void 0 ? void 0 : _h.wrapUpCodesList) || []
                    }
                };
            };
            this.getDefaultWorkTypeCode = (auxCodesList, workTypeCode) => {
                var _a, _b;
                const response = auxCodesList.find((auxCode) => auxCode.workTypeCode === workTypeCode);
                return {
                    id: (_a = response === null || response === void 0 ? void 0 : response.id) !== null && _a !== void 0 ? _a : "",
                    name: (_b = response === null || response === void 0 ? void 0 : response.name) !== null && _b !== void 0 ? _b : ""
                };
            };
            // Handling team selection from infinite scroll team selection component
            this.onTeamSelect = (e) => {
                const { teamName, teamId } = e.detail;
                this.selectedTeam = { teamId, teamName };
            };
            this.isOnlySupervisor = () => {
                return this.getIfSupervisorRole() && this.isTeamsEmpty;
            };
            this.dispatchLoginError = (ctx, details, errorID) => {
                ctx.evt(EventNameError, {
                    id: errorID,
                    message: details.status && details.status === 400 && details.type === "Unauthorized"
                        ? "Token Unauthorized"
                        : "Config Failed",
                    trackingId: this.getTrackingID(details.trackingId)
                });
            };
            this.autologin = () => {
                var _a;
                this.autoLoginType = _constants__WEBPACK_IMPORTED_MODULE_7__.AutoLoginType.Supervisor;
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/Supervisor/AutoLogin/Init");
                const stationLoginData = {
                    dnNumber: "",
                    isExtension: false,
                    teamId: null,
                    teamName: null,
                    roles: ["supervisor"],
                    usesOtherDN: false,
                    extensionNumber: "",
                    dialNumberValueForNonUS: "",
                    defaultDn: "",
                    isDefaultDnSet: false,
                    isInternational: false,
                    phoneNumber: "",
                    countryCallingCode: "",
                    countryCodeValue: "",
                    isRememberMyCredentials: false,
                    deviceType: null,
                    deviceId: ""
                };
                this.handleStationLoginSubmit({ profileDetail: stationLoginData, loggedInRole: (_a = this.userRole) === null || _a === void 0 ? void 0 : _a.join("_") }, true);
            };
            this.getSpecificIdleCode = (auxCodeId) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.abs.fetchIdleCodes({
                        orgId: this.organizationId,
                        accessType: "SPECIFIC",
                        ids: [auxCodeId]
                    });
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.debug("Login/Station/FetchIdleCodes/Success");
                    return response;
                }
                catch (error) {
                    if (error instanceof Error) {
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/FetchIdleCodes/Error", error.message);
                    }
                    else {
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/FetchIdleCodes/Error", "unknown error");
                    }
                    throw error;
                }
            });
            this.requestCILogout = () => {
                this.evt("ci-logout", {
                    userLogout: "station"
                });
            };
            this.cancelLogout = () => {
                this.isModalOpen = true;
            };
            this.logout = () => {
                const logoutResponse = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.agent.logout({ data: { logoutReason: "User requested logout" } });
                logoutResponse
                    .then(() => __awaiter(this, void 0, void 0, function* () {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.debug("Login/Station/Logout/Success");
                    if (this.isWebRTCEnabled && this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.BROWSER) {
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/WebRtc/DeregisterWebCalling");
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.webCalling.deregisterWebCalling();
                    }
                }))
                    .catch((err) => {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/Logout/Error", `${err}`);
                })
                    .finally(() => {
                    this.requestCILogout();
                });
            };
        }
        get dialPlanRegexes() {
            var _a, _b;
            return ((_b = (_a = this.dialPlan) === null || _a === void 0 ? void 0 : _a.dialPlanEntity) === null || _b === void 0 ? void 0 : _b.map((dialPlan) => dialPlan.regex)) || [];
        }
        get availableLoginVoiceOptions() {
            return this.isWebRTCEnabled
                ? this.loginVoiceOptions
                : this.loginVoiceOptions.filter((entry) => entry !== "BROWSER");
        }
        get preferenceVoiceOption() {
            if (!this.deviceType) {
                return this.isExtensionUsed ? "EXTENSION" : "AGENT_DN";
            }
            return this.deviceType === "BROWSER" ? "BROWSER" : this.deviceType === "EXTENSION" ? "EXTENSION" : "AGENT_DN";
        }
        get loginVoiceInfoTooltipMessage() {
            const voiceOptionInfoMessageMapping = {
                AGENT_DN: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.dialNumberInfoTooltip"),
                EXTENSION: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.extensionInfoTooltip"),
                BROWSER: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.desktopInfoTooltip")
            };
            const tooltipMessages = this.availableLoginVoiceOptions.map((option) => voiceOptionInfoMessageMapping[option]);
            return tooltipMessages.join(" / ");
        }
        get userStationLoginLocalization() {
            return {
                stationCredentials: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationCredentials"),
                confirmInteractionProperties: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.confirmInteractionProperties"),
                checkDetails: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.checkDetails"),
                rememberMe: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.enhancedRememberMe"),
                signOutButton: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.signOut"),
                confirmButton: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.confirm"),
                cancelButton: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.cancelButton"),
                continueButton: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.continueButton"),
                dialNumberSelectionTitle: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.dialNumberSelectionTitle"),
                dialNumberPlaceholder: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.dialNumberPlaceHolder"),
                dialNumberInvalid: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationLoginInvalidNumber"),
                extensionInfo: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.extensionInfo"),
                extensionPlaceHolder: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.extensionPlaceHolder"),
                extensionSelectionTitle: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.extension"),
                extensionInvalid: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationLoginInvalidExtNumber"),
                teamSelectionTitle: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.teamSelectionTitle"),
                selectTeam: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.selectTeam"),
                roleSelectionTitle: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.roleSelectionTitle"),
                selectRole: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.selectRole"),
                supervisorRole: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.supervisorRole"),
                supervisorAndAgentRole: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.supervisorAndAgentRole"),
                loginVoiceInfoButtonLabel: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.loginVoiceInfoButtonLabel"),
                loginVoiceInfo: this.loginVoiceInfoTooltipMessage,
                voiceSelectionTitle: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.voiceSelectionTitle"),
                voiceOptionDialNumber: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.agent_dn"),
                voiceOptionExtension: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.extension"),
                voiceOptionDesktop: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.browser"),
                emergencyNotificationTitle: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.emergencyServiceNotification"),
                emergencyNotificationSubTitle: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.dialingEmergencyServices"),
                emergencyNotificationContent: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.dialingEmergencyServicesContent"),
                emergencyNotificationWarningMessage: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.updateCurrentAddInfoOnSecondSignIn"),
                emergencyNotificationWarningLinkText: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.seeHelpSection"),
                emergencyNotificationAcknowledgement: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.readNotification")
            };
        }
        getTelephonyErrorInfo() {
            let errorType = "none";
            let errorMessage = "";
            const errMsg = this.getErrorMsgForReasonCode(this.reasonCode);
            if (this.isDesktopReasonCodeEnabled && this.reasonCode && errMsg) {
                if (this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.AGENT_DN) {
                    errorType = "dialNumberError";
                }
                else if (this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.EXTENSION) {
                    errorType = "extensionError";
                }
                return { errorType, errorMessage: errMsg };
            }
            if (this.isErrDNRegister) {
                errorType = "dialNumberError";
                errorMessage = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnRegisterFailure");
                if (this.isDNAlreadyInUse) {
                    errorMessage = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnAlreadyInUse");
                }
            }
            if (this.isErrExtRegister) {
                errorType = "extensionError";
                errorMessage = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnRegisterFailure");
                if (this.isExtAlreadyInUse) {
                    errorMessage = (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnAlreadyInUse");
                }
            }
            return { errorType, errorMessage };
        }
        getUnknownErrorMessage() {
            if (this.isWebRTCEnabled && this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.BROWSER) {
                if (this.isMicrophoneAccessDenied) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:microphoneAccessDeniedError");
                }
                if (this.isWebRtcUnsupportedBrowser) {
                    return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:browserUnsupportedError");
                }
            }
            if (this.isMaximumSessionsReached) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:maximumSessionsReachedError");
            }
            if (this.fetchUniqueTeamIdError) {
                return (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:fetchTeamIdFailed");
            }
            return this.isDNRegisterTimeOut
                ? this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.EXTENSION
                    ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:extNumberRegisterTimeout")
                    : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:dnRegisterTimeout")
                : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:stationLoginFailed");
        }
        get errorInfo() {
            const error = this.getTelephonyErrorInfo();
            if (error.errorType === "none" && this.isErrUnknown) {
                error.errorType = "unknown";
                error.errorMessage = this.getUnknownErrorMessage();
            }
            if (error.errorMessage.length > 0) {
                const trackingIdEntry = `${this.trackingId ? ` (${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorModal:trackingIdLabel")}: ${this.trackingId})` : ""}`;
                error.errorMessage = `${error.errorMessage}${trackingIdEntry}`;
            }
            return { errorType: error.errorType, errorMessage: error.errorMessage };
        }
        advanceHeaderTracker() {
            if (this.isAdvancedHeader) {
                return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.ADVANCED_HEADER_ENABLED;
            }
            else {
                return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.ADVANCED_HEADER_DISABLED;
            }
        }
        // ROST: create decorator for custom event
        evt(name, detail) {
            this.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true, detail }));
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace(`Login/Event/Dispatch/${name}`, "", detail);
        }
        // TODO: login type in case of reload might not send correct data. Check.
        success(data, isReload) {
            data.loginType = this.loginType;
            data.advancedHeader = this.advanceHeaderTracker();
            data.isReload = isReload;
            if (this.isDesktopAuxCodesInfiniteScrollEnabled) {
                data.initialIdleCodes = this.initialIdleCodes;
            }
            data.systemIdleCodes = this.systemIdleCodes;
            this.evt("login-success", data);
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.DARK_MODE_TOGGLE);
            this.isModalOpen = false;
        }
        static get styles() {
            return _userStationLogin_scss__WEBPACK_IMPORTED_MODULE_10__["default"];
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            changedProperties.forEach((oldValue, name) => {
                if (name === "isModalOpen" && oldValue !== undefined) {
                    if (this.isModalOpen) {
                        //Adding this logs to debug StaionLogin issues CX-5123
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/Modal/Opened");
                    }
                    else if (this.isModalOpen === false) {
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/Modal/Closed");
                    }
                }
            });
        }
        setDefaultAuxCode() {
            var _a;
            if (this.profile) {
                const defaultStateOption = (_a = this.profile.idleCodes) === null || _a === void 0 ? void 0 : _a.find((option) => option.isDefault);
                if (defaultStateOption) {
                    this.defaultAuxCode = defaultStateOption.id.toString();
                }
            }
        }
        updateWrapUpCodeConfig(currentDefaultAuxCodes, wrapUpCodes) {
            if (this.profile) {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.updateWrapUpCodeConfig(wrapUpCodes);
                // Set default wrap up code to conf-service
                if (currentDefaultAuxCodes && (currentDefaultAuxCodes === null || currentDefaultAuxCodes === void 0 ? void 0 : currentDefaultAuxCodes.length) > 0) {
                    const defaultWrapUpCode = this.getDefaultWorkTypeCode(currentDefaultAuxCodes, "WRAP_UP_CODE");
                    if (defaultWrapUpCode) {
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.setDefaultWrapUpCode(defaultWrapUpCode);
                    }
                    else {
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.warn("Login/Station/FetchAuxCodes/DefaultWrapUpCodeNotFound");
                    }
                }
                this.profile = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile; // Update the profile values after fetching the aux codes.
            }
        }
        updateAuxCodes(idleCodes, wrapUpCodes) {
            if (this.profile) {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.updateAuxCodeConfig(idleCodes, wrapUpCodes);
                this.profile = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile; // Update the profile values after fetching the aux codes.
                if (!this.isDesktopAuxCodesInfiniteScrollEnabled) {
                    this.setDefaultAuxCode();
                }
            }
        }
        fetchTeamDataById(selectTeamDbId) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.profile) {
                    return false;
                }
                try {
                    const filterPayload = { dbId: selectTeamDbId };
                    const team = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.cms.fetchAllTeams(this.profile.orgId, filterPayload);
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.debug("Login/Station/FetchTeamById/Success", "", Object.assign({ orgId: this.profile.orgId, teamId: selectTeamDbId }, team));
                    if (Array.isArray(team) && team.length > 0) {
                        return team[0].id;
                    }
                    else {
                        this.isErrUnknown = true;
                        this.fetchUniqueTeamIdError = true;
                        return false;
                    }
                }
                catch (_error) {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/FetchTeamById/Error", "", {
                        orgId: this.profile.orgId,
                        teamId: selectTeamDbId,
                        error: _error
                    });
                    this.isErrUnknown = true;
                    this.fetchUniqueTeamIdError = true;
                    return false;
                }
            });
        }
        setDefaultAuxCodes(currentDefaultAuxCodes, agentStateIdleCodes) {
            var _a;
            this.initialIdleCodes = agentStateIdleCodes;
            if (currentDefaultAuxCodes && (currentDefaultAuxCodes === null || currentDefaultAuxCodes === void 0 ? void 0 : currentDefaultAuxCodes.length) > 0) {
                // Set default idle code to conf-service
                const defaultIdleCode = this.getDefaultWorkTypeCode(currentDefaultAuxCodes, "IDLE_CODE");
                if (defaultIdleCode) {
                    this.defaultAuxCode = (_a = defaultIdleCode === null || defaultIdleCode === void 0 ? void 0 : defaultIdleCode.id.toString()) !== null && _a !== void 0 ? _a : "";
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.setDefaultIdleCode(defaultIdleCode);
                }
                else {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.warn("Login/Station/FetchAuxCodes/DefaultIdleCodeNotFound");
                }
            }
        }
        fetchAuxCodes(shouldFetchDefaultIdleCode = false) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const { idleCodeConfig, wrapUpCodeConfig } = this.getAuxCodeParameters();
                    const response = yield (0,_utils__WEBPACK_IMPORTED_MODULE_11__.fetchAuxCodeValues)(this.organizationId, idleCodeConfig, wrapUpCodeConfig, this.isDesktopAuxCodesInfiniteScrollEnabled, shouldFetchDefaultIdleCode);
                    const [idleCodes, wrapUpCodes, defaultAuxCodes, systemIdleCodes] = response;
                    const allWrapUpCodes = wrapUpCodes;
                    if (this.isDesktopAuxCodesInfiniteScrollEnabled) {
                        const currentDefaultAuxCodes = defaultAuxCodes;
                        const agentStateIdleCodes = idleCodes;
                        const agentWrapUpCodes = wrapUpCodes;
                        this.setDefaultAuxCodes(currentDefaultAuxCodes, agentStateIdleCodes);
                        this.updateWrapUpCodeConfig(currentDefaultAuxCodes, agentWrapUpCodes);
                    }
                    else {
                        const allIdleCodes = idleCodes;
                        this.updateAuxCodes(allIdleCodes, allWrapUpCodes);
                    }
                    this.systemIdleCodes = systemIdleCodes;
                    this.auxCodeConfig.fetchCompleted = true;
                    this.auxCodeConfig.isError = false;
                    return true;
                }
                catch (error) {
                    this.trackingId = (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.getTrackingIdFromErrorObject)(error);
                    this.auxCodeConfig.fetchCompleted = false;
                    this.auxCodeConfig.isError = true;
                    this.isErrUnknown = true;
                    return false;
                }
            });
        }
        connectedCallback() {
            super.connectedCallback();
            this.init();
            window.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_7__.SUPERVISOR_AUTO_LOGIN_EVENT, this.autologin);
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            window.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_7__.SUPERVISOR_AUTO_LOGIN_EVENT, this.autologin);
        }
        getTrackingID(trackingIdValue) {
            return trackingIdValue.split("_").length > 1 ? trackingIdValue.split("_")[1] : trackingIdValue.split("_")[0];
        }
        getIfSupervisorRole() {
            return this.roleFromMe.toLocaleLowerCase() === _constants__WEBPACK_IMPORTED_MODULE_7__.SUPERVISOR.toLocaleLowerCase();
        }
        getDeviceType(deviceType, isExtension) {
            if (deviceType) {
                return this.isWebRTCEnabled ? deviceType === null || deviceType === void 0 ? void 0 : deviceType.toUpperCase() : deviceType;
            }
            return isExtension ? _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.EXTENSION : _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.AGENT_DN;
        }
        getLoginType(isExtension, roles) {
            const mode = isExtension ? "EXT" : "DN";
            // Agent & Agent + Supervisor: DN and Team should be present.
            // Only Supervisor: If monitoring enabled DN/EXT should be present.
            const isDnExtEnabled = (roles === null || roles === void 0 ? void 0 : roles.includes(_constants__WEBPACK_IMPORTED_MODULE_7__.AGENT)) || this.isMonitoringEnabled;
            return isDnExtEnabled ? mode : "NA";
        }
        /**
         * Determine userRole and update STORE.agent.userRole.
         * userRole possible values: ["agent"], ["supervisor"], and ["agent", "supervisor"]
         * Order ["agent", "supervisor"] is important for comparison done later.
         */
        updateUserRole() {
            let newUserRole;
            if (this.getIfSupervisorRole()) {
                newUserRole = this.isTeamsEmpty ? [_constants__WEBPACK_IMPORTED_MODULE_7__.SUPERVISOR] : [_constants__WEBPACK_IMPORTED_MODULE_7__.AGENT, _constants__WEBPACK_IMPORTED_MODULE_7__.SUPERVISOR];
            }
            else {
                newUserRole = [_constants__WEBPACK_IMPORTED_MODULE_7__.AGENT];
            }
            this.userRole = newUserRole;
        }
        // Error Handlers For SERVICE.conf.fetchProfile()
        init() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
            return __awaiter(this, void 0, void 0, function* () {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.debug("Login/Station/Init");
                this.profile = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile
                    ? _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.profile
                    : yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.fetchProfile(this.organizationId, this.meUserId, this.getIfSupervisorRole());
                if (this.isConsultTransferInfiniteScrollEnabled) {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.conf.updateProfileTeamsMeta((_a = this.profile) === null || _a === void 0 ? void 0 : _a.teamsMeta);
                }
                if (this.isWebRTCEnabled && ((_b = this.profile.loginVoiceOptions) === null || _b === void 0 ? void 0 : _b.length) === 0) {
                    this.evt("no-voice-options-error", {
                        header: "",
                        message: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.noLoginVoiceOptionsError"),
                        noExitOnEsc: true,
                        buttons: [{ type: "ok", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(signOutButtonLabel), onClick: this.logout }]
                    });
                    return;
                }
                this.loginVoiceOptions = this.profile.loginVoiceOptions || _constants__WEBPACK_IMPORTED_MODULE_7__.DEFAULT_DEVICE_TYPE;
                this.evt("update-analyser-id", {
                    analyzerId: (_c = this.profile.analyserUserId) !== null && _c !== void 0 ? _c : this.profile.agentDbId
                });
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.register({
                    AgentId: this.profile.agentId,
                    TenantId: this.profile.enterpriseId,
                    SiteId: this.profile.siteId,
                    OrgId: this.profile.orgId,
                    Locale: navigator.language,
                    [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.PLATFORM_TYPE]: window.matchMedia("(display-mode: standalone)").matches
                        ? "App"
                        : "Browser"
                });
                this.profile.teams.sort((t1, t2) => {
                    return t1.teamName.localeCompare(t2.teamName);
                });
                this.teams = this.profile.teams;
                this.isTeamsEmpty = !(this.teams && this.teams.length > 0 && ((_d = this.teams[0]) === null || _d === void 0 ? void 0 : _d.teamId));
                const defaultTeam = this.teams && this.teams.length > 0 ? this.teams[0].teamName : "";
                this.teamName = this.isTeamsEmpty ? "" : defaultTeam;
                this.teamId = this.isTeamsEmpty ? "" : this.teams[0].teamId;
                this.selectedTeam = { teamId: this.teamId, teamName: this.teamName };
                if (this.isConsultTransferInfiniteScrollEnabled) {
                    this.paginatedTeamResponse.data = this.teams;
                    this.paginatedTeamResponse.meta = (_e = this.profile.teamsMeta) !== null && _e !== void 0 ? _e : {
                        links: {},
                        orgid: "",
                        page: 0,
                        pageSize: 0,
                        totalPages: 0,
                        totalRecords: 0
                    };
                }
                this.defaultDn = this.profile.defaultDn || "";
                this.dialNumber = this.dialNumberValueForNonUS = this.extensionNumber = this.phoneNumber = this.defaultDn;
                this.isDefaultDnSet = ((_f = this.profile.defaultDn) === null || _f === void 0 ? void 0 : _f.length) > 0 ? this.profile.forceDefaultDnForAgent : false;
                this.dialPlan = this.profile.dialPlan;
                this.isMonitoringEnabled = this.profile.isCallMonitoringEnabled || false;
                this.isInternational = ((_g = this.profile.defaultDn) === null || _g === void 0 ? void 0 : _g.length) > 0 ? false : true;
                if (!this.isOnlySupervisor() &&
                    (((_j = (_h = this.profile) === null || _h === void 0 ? void 0 : _h.microsoftConfig) === null || _j === void 0 ? void 0 : _j.showUserDetailsMS) ||
                        (this.isDesktopMSStateSyncEnabled && ((_l = (_k = this.profile) === null || _k === void 0 ? void 0 : _k.microsoftConfig) === null || _l === void 0 ? void 0 : _l.stateSynchronizationMS)))) {
                    // Show user details in MS
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/Dispatch/InitiateMSAuthFlow");
                    this.evt(_constants__WEBPACK_IMPORTED_MODULE_7__.INITIATE_MS_AUTH_LOGIN, { orgId: this.profile.orgId, microsoftConfig: (_m = this.profile) === null || _m === void 0 ? void 0 : _m.microsoftConfig });
                }
                if (!this.isMaerskEnabled) {
                    this.setDefaultAuxCode();
                }
                this.phoneFormat =
                    this.isDefaultDnSet || ((_o = this.profile.defaultDn) === null || _o === void 0 ? void 0 : _o.length) > 0 ? phoneFormats.other : phoneFormats.international;
                this.updateUserRole();
                this.requestUpdate();
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATION_LOGIN, [
                    (_q = (_p = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _p === void 0 ? void 0 : _p.SERVICE_PROVIDERS) === null || _q === void 0 ? void 0 : _q.webex_behavioral,
                    (_s = (_r = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _r === void 0 ? void 0 : _r.SERVICE_PROVIDERS) === null || _s === void 0 ? void 0 : _s.webex_business
                ]);
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/Reload");
                yield this.agentReload();
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.agent.eAgentDNRegisterFailure.listen((data) => {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/AgentDNRegisterFailure", "", data);
                    this.isSubmitBusy = false;
                    const isNumberAlreadyInUse = data.data.reason === "DUPLICATE_LOCATION" && data.data.reasonCode === 400;
                    this.reasonCode = data.data.reasonCode;
                    if (this.isExtensionUsed) {
                        this.isErrExtRegister = true;
                        if (isNumberAlreadyInUse) {
                            this.isExtAlreadyInUse = true;
                        }
                        this.isErrPhoneExt = false;
                    }
                    else {
                        this.isErrDNRegister = true;
                        if (isNumberAlreadyInUse) {
                            this.isDNAlreadyInUse = true;
                        }
                        this.isErrPhone = false;
                    }
                    this.isErrUnknown = false;
                    this.trackingId = this.getTrackingID(data.data.trackingId);
                });
            });
        }
        fetchSavedPreferences() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const userPreferences = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.userPrefs.fetchUserPreferences({
                        orgId: this.organizationId,
                        userId: this.meUserId
                    });
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/FetchUserPreferences/Success", "", userPreferences);
                    if (userPreferences) {
                        this.isPreferenceSaved = true;
                        const desktopPreference = JSON.parse(userPreferences.desktopPreference);
                        this.evt("update-user-preference-storage", userPreferences);
                        if (desktopPreference) {
                            yield this.processCommonFetchedPreferences(desktopPreference);
                            if (this.isDesktopEnhancedSignInEnabled) {
                                this.processEnhancedFetchedPreferences(desktopPreference);
                            }
                            else {
                                this.processLegacyFetchedPreferences(desktopPreference);
                            }
                        }
                    }
                    else {
                        this.isPreferenceSaved = false;
                    }
                }
                catch (_error) {
                    this.isPreferenceSaved = false;
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/FetchUserPreferences/Error", `${_error}`);
                    this.evt("save-update-user-prefs-failed", {
                        isPrefSaved: this.isPreferenceSaved
                    });
                }
                // Updating this flag here to know if preferences are already saved or not.
                // Using this flag to perform save/update action when called from user station login & user profile settings
                this.evt("update-flag-user-prefs-saved", {
                    isPrefSaved: this.isPreferenceSaved
                });
            });
        }
        processCommonFetchedPreferences(desktopPreference) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                this.selectedRoleName = desktopPreference.selectedRoleName;
                let teamName = ((_a = this.teams.find((team) => team.teamId === desktopPreference.teamId)) === null || _a === void 0 ? void 0 : _a.teamName) || "";
                if (teamName === "" && this.isConsultTransferInfiniteScrollEnabled) {
                    const { teamName: fetchedTeamName, teamId: fetchedTeamId } = yield this.getTeamNameAndId(desktopPreference.teamId);
                    teamName = fetchedTeamName || "";
                    desktopPreference.teamId = fetchedTeamId || "";
                    this.selectedRoleName = teamName;
                }
                if (teamName) {
                    this.teamName = teamName;
                    this.teamId = desktopPreference.teamId;
                    this.selectedTeam = { teamId: this.teamId, teamName: this.teamName };
                }
                this.extensionNumber = this.isDefaultDnSet
                    ? (_b = this.profile) === null || _b === void 0 ? void 0 : _b.defaultDn
                    : desktopPreference.extensionNumber || ((_c = this.profile) === null || _c === void 0 ? void 0 : _c.defaultDn);
                this.isExtensionUsed = desktopPreference.isExtension;
                this.isRememberMyCredentials = desktopPreference.isRememberMyCredentials;
                this.deviceType = this.getDeviceType(desktopPreference.deviceType, desktopPreference.isExtension);
                this.deviceId = desktopPreference.deviceId;
                this.isEmergencyModalAlreadyDisplayed = desktopPreference.isEmergencyModalAlreadyDisplayed;
            });
        }
        processEnhancedFetchedPreferences(desktopPreference) {
            var _a, _b;
            this.dialNumber = this.isDefaultDnSet
                ? (_a = this.profile) === null || _a === void 0 ? void 0 : _a.defaultDn
                : desktopPreference.dialNumber || ((_b = this.profile) === null || _b === void 0 ? void 0 : _b.defaultDn);
            this.dialNumberValueForNonUS = "";
            this.isInternational = false;
            this.phoneNumber = "";
            this.phoneFormat = phoneFormats.other;
            this.countryCallingCode = "";
            this.countryCodeValue = "";
        }
        processLegacyFetchedPreferences(desktopPreference) {
            var _a, _b, _c;
            this.dialNumberValueForNonUS = this.isDefaultDnSet
                ? (_a = this.profile) === null || _a === void 0 ? void 0 : _a.defaultDn
                : desktopPreference.dialNumberValueForNonUS || ((_b = this.profile) === null || _b === void 0 ? void 0 : _b.defaultDn);
            this.isInternational = this.isDefaultDnSet ? false : desktopPreference.isInternational;
            this.phoneNumber = this.isInternational ? desktopPreference.internationalPhoneNumber : (_c = this.profile) === null || _c === void 0 ? void 0 : _c.defaultDn;
            this.phoneFormat =
                !this.isDefaultDnSet && desktopPreference.isInternational ? phoneFormats.international : phoneFormats.other;
            this.countryCallingCode = desktopPreference.countryCallingCode || this.countryCallingCode;
            this.countryCodeValue = desktopPreference.countryCodeValue || this.countryCodeValue;
        }
        getUserProfileData() {
            return {
                role: this.userRole.join("_"),
                loginOption: this.preferenceVoiceOption,
                dialNumber: this.preferenceVoiceOption === "AGENT_DN" ? this.dialNumber : "",
                extensionNumber: this.preferenceVoiceOption === "EXTENSION" ? this.extensionNumber : "",
                team: { teamId: this.teamId, teamName: this.teamName }
            };
        }
        agentAutoLogin() {
            this.autoLoginType = _constants__WEBPACK_IMPORTED_MODULE_7__.AutoLoginType.Agent;
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/Agent/AutoLogin/Init");
            const profileData = this.getUserProfileData();
            this.handleUserProfileDataAvailable(profileData);
        }
        // Error Handlers For SERVICE.aqm.agent.reload()
        agentReload() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.profile) {
                    return;
                }
                const reload = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.agent.reload();
                const shouldFetchAuxCodes = yield this.shouldFetchAuxCodes();
                if (shouldFetchAuxCodes && !this.auxCodeConfig.fetchCompleted && !this.isOnlySupervisor()) {
                    // For pure supervisor aux codes are not required.
                    const isAuxCodeUpdated = yield this.fetchAuxCodes(true);
                    if (!isAuxCodeUpdated) {
                        // Prevent the station login, Show the error message.
                        this.evt("aux-code-error", {});
                        return;
                    }
                }
                const { dn, agentId, teamId, auxCodeId, lastStateChangeTimestamp, lastIdleCodeChangeTimestamp, lastStateChangeReason, profileType, channelsMap, interactionIds, isExtension, roles, deviceType, deviceId } = reload.data;
                this.loginType = this.getLoginType(isExtension, undefined);
                // Load the team unique id, when isDesktopMaerskAcqueonTeamId FF is on.
                // This ID is required to use the acquon team id.
                let teamUniqueId = "";
                if (this.isDesktopMaerskAcqueonTeamId && teamId) {
                    teamUniqueId = yield this.fetchTeamDataById(teamId);
                    if (!teamUniqueId) {
                        // On Reload, Prevent the station login, Show the error message.
                        this.evt("acqueon-fetch-team-id-error", {});
                        return;
                    }
                }
                let subStatus = "Available";
                if (auxCodeId !== "0") {
                    if (this.isDesktopAuxCodesInfiniteScrollEnabled) {
                        const idleCodeStatus = (_d = (_c = (_b = (_a = this.initialIdleCodes) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.find((c) => c.id.toString() === auxCodeId)) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : "";
                        if (!idleCodeStatus) {
                            const response = yield this.getSpecificIdleCode(auxCodeId);
                            if (response && (response === null || response === void 0 ? void 0 : response.length) > 0) {
                                subStatus = response[0].name;
                            }
                        }
                        else {
                            subStatus = idleCodeStatus;
                        }
                    }
                    else {
                        subStatus = (_f = (_e = this.profile.idleCodes.find((c) => c.id.toString() === auxCodeId)) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : "";
                    }
                }
                let teamName = ((_g = this.profile.teams.find((team) => team.teamId === teamId)) === null || _g === void 0 ? void 0 : _g.teamName) || "";
                /** check if team exists */
                if (teamName === "" && this.isConsultTransferInfiniteScrollEnabled) {
                    const response = yield (0,_utils__WEBPACK_IMPORTED_MODULE_11__.fetchTeamList)(this.profile.orgId, 0, ((_h = this.profile) === null || _h === void 0 ? void 0 : _h.analyserUserId) || ((_j = this.profile) === null || _j === void 0 ? void 0 : _j.agentDbId), "", teamId);
                    teamName = response ? (_k = response.data[0]) === null || _k === void 0 ? void 0 : _k.teamName : "";
                }
                if (!teamName && !this.getIfSupervisorRole()) {
                    this.evt(EventLogoutConfirm, {
                        header: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorModal.header"),
                        message: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.teamDeletedError"),
                        noExitOnEsc: true,
                        buttons: [{ type: "ok", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(signOutButtonLabel), onClick: this.logout }]
                    });
                    return;
                }
                this.success({
                    dn,
                    agentId,
                    usesOtherDN: this.usesOtherDN,
                    isExtension,
                    teamId,
                    teamUniqueId,
                    teamName,
                    subStatus,
                    lastStateChangeTimestamp,
                    lastIdleCodeChangeTimestamp,
                    lastStateChangeReason: lastStateChangeReason ? lastStateChangeReason : "",
                    profileType,
                    interactionIds,
                    mmProfile: {
                        voiceCount: (_l = channelsMap["telephony"]) === null || _l === void 0 ? void 0 : _l.length,
                        chatCount: (_m = channelsMap["chat"]) === null || _m === void 0 ? void 0 : _m.length,
                        emailCount: (_o = channelsMap["email"]) === null || _o === void 0 ? void 0 : _o.length,
                        socialCount: (_p = channelsMap["social"]) === null || _p === void 0 ? void 0 : _p.length
                    },
                    defaultDn: this.defaultDn,
                    isDefaultDnSet: this.isDefaultDnSet,
                    userRole: this.userRole,
                    deviceType,
                    deviceId,
                    selectedRoleName: roles ? roles.join("_") : ""
                }, true);
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.debug("Login/Station/AgentReload/Success", "", {
                    isWebRTCEnabled: this.isWebRTCEnabled,
                    _deviceType: deviceType,
                    isWebRtcSupportedBrowser: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.isWebRtcSupportedBrowser)()
                });
                if (this.isWebRTCEnabled &&
                    deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.BROWSER &&
                    !(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.isWebRtcSupportedBrowser)()) {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/UnsuportedBrowser/Logout/Confim", "", {
                        isWebRtcSupportedBrowser: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.isWebRtcSupportedBrowser)()
                    });
                    this.evt(EventLogoutConfirm, {
                        header: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:errorModal.header"),
                        message: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin:browserUnsupportedError"),
                        noExitOnEsc: true,
                        buttons: [{ type: "ok", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(signOutButtonLabel), onClick: this.logout }]
                    });
                    return;
                }
                this.isInitializing = false;
            });
        }
        showEmergencyModal() {
            return (this.isDesktopEmergencyNotificationEnabled &&
                this.deviceTypeName === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.BROWSER &&
                !this.isEmergencyModalAlreadyDisplayed);
        }
        /** Inform UserProfile to start station login validation. */
        onSubmit() {
            if (!this.profile) {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.warn("Login/Station/OnSubmit/NoProfile", "No Config profile after StationLogin");
                return;
            }
            /** On click of 'Continue' button on the emergency modal after 1st login, isEmergencyModalAlreadyDisplayed to be set to true.
            If true, the modal is NOT to be displayed again. If false, modal to be displayed again*/
            if (this.showEmergencyModal()) {
                this.isEmergencyModalAlreadyDisplayed = true;
            }
            this.isSubmitBusy = true;
            this.isSubmitClicked = !this.isSubmitClicked;
        }
        addTelemetryOnRoleSwitch(roleName, loggedInRole) {
            var _a, _b, _c, _d;
            if (loggedInRole && loggedInRole !== roleName) {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.SWITCH_USER_ROLE, {
                    status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS,
                    LastUserRole: loggedInRole === _constants__WEBPACK_IMPORTED_MODULE_7__.AGENT_AND_SUPERVISOR ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.formRoleNameForTelemetry)(loggedInRole) : loggedInRole,
                    SwitchedRole: roleName === _constants__WEBPACK_IMPORTED_MODULE_7__.AGENT_AND_SUPERVISOR ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.formRoleNameForTelemetry)(roleName) : roleName,
                    Reason: "[Station Login] User switched Role",
                    AdvancedHeader: this.advanceHeaderTracker()
                }, [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_behavioral, (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.prometheus]);
            }
        }
        setErrorFlags() {
            this.isErrUnknown = true;
            this.isErrDNRegister = false;
            this.isDNAlreadyInUse = false;
            this.isErrPhone = false;
            this.isErrPhoneExt = false;
            this.isExtAlreadyInUse = false;
            this.isErrExtRegister = false;
            this.isSubmitBusy = false;
            this.isMaximumSessionsReached = false;
            this.isWebRtcUnsupportedBrowser = false;
            this.isMicrophoneAccessDenied = false;
        }
        isUsesOtherFormat() {
            return this.phoneFormat === phoneFormats.other;
        }
        handleUnSupportedBrowserError() {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/WebRtc/UnsupportedBrowser");
            setTimeout(() => {
                this.isSubmitBusy = false;
                this.isErrUnknown = true;
                this.isWebRtcUnsupportedBrowser = true;
                this.trackingId = "";
            }, 200); // need a delay to update the attributes.
        }
        handleMicrophoneAccessDenied() {
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Login/Station/WebRtc/MicrophoneAccessDenied");
            this.isSubmitBusy = false;
            this.isErrUnknown = true;
            this.isMicrophoneAccessDenied = true;
            this.trackingId = "";
        }
        shouldFetchAuxCodes() {
            if (this.isDesktopAuxCodesInfiniteScrollEnabled) {
                return true;
            }
            else {
                return this.isMaerskEnabled;
            }
        }
        submitLoginPreCheck() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.profile) {
                    this.isSubmitBusy = false;
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.warn("Login/Station/OnSubmit/NoProfile", "No Config profile after StationLogin");
                    return false;
                }
                this.isSubmitBusy = true;
                this.isErrUnknown = false;
                this.auxCodeConfig.isError = false;
                this.fetchUniqueTeamIdError = false;
                const shouldFetchAuxCodes = yield this.shouldFetchAuxCodes();
                if (shouldFetchAuxCodes && !this.auxCodeConfig.fetchCompleted && !this.isOnlySupervisor()) {
                    // For pure supervisor aux codes are not required.
                    const isAuxCodeUpdated = yield this.fetchAuxCodes(true);
                    if (!isAuxCodeUpdated) {
                        return false;
                    }
                }
                return true;
            });
        }
        checkForTeamId(selectedProfile) {
            return __awaiter(this, void 0, void 0, function* () {
                // Load the team unique ID when isDesktopMaerskAcqueonTeamId feature flag is on.
                // This ID is required to use the Acqueon team ID.
                if (this.isDesktopMaerskAcqueonTeamId && selectedProfile.teamId) {
                    const teamUniqueId = yield this.fetchTeamDataById(selectedProfile.teamId);
                    if (!teamUniqueId) {
                        // Prevent the station login and return an error.
                        return new Error();
                    }
                    return teamUniqueId;
                }
                return "";
            });
        }
        buildStationLoginData(initialDeviceId, selectedProfile) {
            var _a, _b, _c, _d, _e;
            return __awaiter(this, void 0, void 0, function* () {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.register({
                    TeamId: selectedProfile.teamId,
                    TeamName: selectedProfile.teamName,
                    OrgId: this.organizationId
                });
                const ifSupervisorOnly = selectedProfile.roles.join("_") === "supervisor";
                const stationLoginData = {
                    dialNumber: (_a = selectedProfile.dnNumber) === null || _a === void 0 ? void 0 : _a.replace(/ /g, ""),
                    usesOtherDN: selectedProfile.usesOtherDN,
                    teamId: ifSupervisorOnly ? null : selectedProfile.teamId || "",
                    teamName: ifSupervisorOnly ? null : selectedProfile.teamName || "",
                    siteId: this.profile.siteId,
                    auxCodeId: this.defaultAuxCode.toString(),
                    isExtension: selectedProfile.isExtension,
                    roles: selectedProfile.roles
                };
                let didOverwriteDeviceId = false;
                if (this.isWebRTCEnabled) {
                    if (selectedProfile.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.BROWSER) {
                        // check BrowserCompatible for webRtc
                        if (!(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.isWebRtcSupportedBrowser)()) {
                            this.handleUnSupportedBrowserError();
                            return null;
                        }
                        // ask Media microphone access / check access allowed
                        try {
                            const mediaStream = yield navigator.mediaDevices.getUserMedia({ audio: true });
                            if (!mediaStream) {
                                this.handleMicrophoneAccessDenied();
                                return null;
                            }
                            else {
                                mediaStream.getTracks().forEach((track) => track.stop());
                            }
                        }
                        catch (error) {
                            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/WebRtc/MicrophoneAccessDenied", `${error}`);
                            this.handleMicrophoneAccessDenied();
                            return null;
                        }
                        initialDeviceId = `${_constants__WEBPACK_IMPORTED_MODULE_7__.WEB_RTC_PREFIX}${this.profile.agentId}`;
                        didOverwriteDeviceId = true;
                    }
                    stationLoginData.deviceId = initialDeviceId;
                    stationLoginData.deviceType = this.getDeviceType(selectedProfile.deviceType, selectedProfile.isExtension);
                    stationLoginData.dialNumber = initialDeviceId; // keep this for backward compatible. remove while FF cleanup.
                }
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATION_LOGIN_CLICKED, {
                    LoginType: this.loginType,
                    DeviceType: this.deviceType
                });
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.timeEvent(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATION_LOGIN, [
                    (_c = (_b = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _b === void 0 ? void 0 : _b.SERVICE_PROVIDERS) === null || _c === void 0 ? void 0 : _c.webex_behavioral,
                    (_e = (_d = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _d === void 0 ? void 0 : _d.SERVICE_PROVIDERS) === null || _e === void 0 ? void 0 : _e.webex_business
                ]);
                if (this.profile.skillProfileId &&
                    this.profile.skillProfileId !== "0" &&
                    this.profile.skillProfileId !== "null") {
                    stationLoginData.skillProfileId = this.profile.skillProfileId;
                }
                return { didOverwriteDeviceId, stationLoginData };
            });
        }
        checkAndSaveCredentials(deviceId, selectedProfile, updatedStationLoginData, autologin) {
            if (!autologin) {
                // Save Preferences only if Remember me checkbox is checked and its not an autologin
                /* Autologin scenario occurs when:
                 * Role is Supervisor only
                 * No teams are assigned
                 * Call Monitoring is disabled
                 */
                if (this.isRememberMyCredentials) {
                    const saveUpdateUserPref = this.isDesktopEnhancedSignInEnabled
                        ? this.getUserPreferencesToSaveEnhanced(updatedStationLoginData, selectedProfile, deviceId)
                        : this.getUserPreferencesToSave(updatedStationLoginData, selectedProfile, deviceId);
                    if (this.isDesktopEmergencyNotificationEnabled) {
                        const saveUpdateUserPrefEmergency = Object.assign(Object.assign({}, saveUpdateUserPref), { isEmergencyModalAlreadyDisplayed: this.isEmergencyModalAlreadyDisplayed });
                        this.evt("save-update-user-prefs", saveUpdateUserPrefEmergency);
                    }
                    else {
                        this.evt("save-update-user-prefs", saveUpdateUserPref);
                    }
                }
                else if (this.isDesktopEmergencyNotificationEnabled) {
                    // If remember me button is not checked save only isEmergencyModalAlreadyDisplayed flag
                    const saveUpdateUserPref = { isEmergencyModalAlreadyDisplayed: this.isEmergencyModalAlreadyDisplayed };
                    this.evt("save-update-user-prefs", saveUpdateUserPref);
                    this.evt("delete-user-preference-storage", {});
                }
                else {
                    // delete prefs
                    this.evt("delete-user-prefs", {});
                    this.evt("delete-user-preference-storage", {});
                }
            }
        }
        getUserPreferencesToSave(updatedStationLoginData, selectedProfile, deviceId) {
            var _a, _b;
            return {
                selectedRoleName: (_a = updatedStationLoginData.roles) === null || _a === void 0 ? void 0 : _a.join("_"),
                teamName: selectedProfile.teamName,
                teamId: selectedProfile.teamId,
                dialNumber: updatedStationLoginData.dialNumber,
                isExtension: updatedStationLoginData.isExtension || false,
                extensionNumber: selectedProfile.extensionNumber,
                dialNumberValueForNonUS: (_b = selectedProfile.dialNumberValueForNonUS) === null || _b === void 0 ? void 0 : _b.replace(/ /g, ""),
                isInternational: selectedProfile.isInternational ? true : false,
                internationalPhoneNumber: selectedProfile.isInternational ? (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.stripSpecialChar)(selectedProfile.phoneNumber) : "",
                countryCallingCode: selectedProfile.isInternational ? selectedProfile.countryCallingCode : "",
                countryCodeValue: selectedProfile.isInternational ? selectedProfile.countryCodeValue : "",
                isRememberMyCredentials: selectedProfile.isRememberMyCredentials,
                deviceType: selectedProfile.deviceType,
                deviceId
            };
        }
        getUserPreferencesToSaveEnhanced(updatedStationLoginData, selectedProfile, deviceId) {
            var _a;
            return {
                selectedRoleName: (_a = updatedStationLoginData.roles) === null || _a === void 0 ? void 0 : _a.join("_"),
                teamName: selectedProfile.teamName,
                teamId: selectedProfile.teamId,
                dialNumber: updatedStationLoginData.deviceType === "AGENT_DN" ? updatedStationLoginData.dialNumber : "",
                isExtension: updatedStationLoginData.isExtension || false,
                extensionNumber: selectedProfile.extensionNumber,
                dialNumberValueForNonUS: "",
                isInternational: false,
                internationalPhoneNumber: "",
                countryCallingCode: "",
                countryCodeValue: "",
                isRememberMyCredentials: selectedProfile.isRememberMyCredentials,
                deviceType: selectedProfile.deviceType,
                deviceId
            };
        }
        /**
         * Fetch the team unique team name from the team id
         * @param selectedTeamId
         * @returns
         */
        getTeamNameAndId(selectedTeamId) {
            var _a, _b, _c, _d;
            return __awaiter(this, void 0, void 0, function* () {
                const agentDBId = ((_a = this.profile) === null || _a === void 0 ? void 0 : _a.analyserUserId) || ((_b = this.profile) === null || _b === void 0 ? void 0 : _b.agentDbId);
                try {
                    const response = yield (0,_utils__WEBPACK_IMPORTED_MODULE_11__.fetchTeamList)(this.organizationId, 0, agentDBId, "", selectedTeamId);
                    const teamName = response ? ((_c = response.data[0]) === null || _c === void 0 ? void 0 : _c.teamName) || "" : "";
                    let teamId = "";
                    if (selectedTeamId !== "" && selectedTeamId !== undefined) {
                        teamId = selectedTeamId;
                    }
                    else if (response) {
                        teamId = ((_d = response.data[0]) === null || _d === void 0 ? void 0 : _d.teamId) || "";
                    }
                    return { teamName, teamId };
                }
                catch (error) {
                    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/FetchTeamDataById/Error", `${error}`);
                    throw error;
                }
            });
        }
        finishAndNotifySuccess(loggedInRole, teamUniqueId, deviceId, selectedProfile, login, teamName) {
            var _a, _b, _c, _d, _e;
            return __awaiter(this, void 0, void 0, function* () {
                // to capture event only when role switch is in between supervisor or agent+supervisor
                if (loggedInRole === _constants__WEBPACK_IMPORTED_MODULE_7__.AGENT_AND_SUPERVISOR || loggedInRole === _constants__WEBPACK_IMPORTED_MODULE_7__.SUPERVISOR) {
                    this.addTelemetryOnRoleSwitch(selectedProfile.roles.join("_"), loggedInRole);
                }
                const { teamId, lastStateChangeTimestamp, lastIdleCodeChangeTimestamp, profileType, channelsMap, agentId, interactionIds } = login.data;
                const teamNameProfile = teamName;
                this.success({
                    dn: (_a = selectedProfile.dnNumber) === null || _a === void 0 ? void 0 : _a.replace(/ /g, ""),
                    agentId,
                    usesOtherDN: this.isUsesOtherFormat(),
                    isExtension: selectedProfile.isExtension,
                    teamId,
                    teamUniqueId,
                    teamName: teamNameProfile,
                    subStatus: this.profile.defaultIdleName,
                    profileType,
                    defaultDn: selectedProfile.defaultDn,
                    isDefaultDnSet: selectedProfile.isDefaultDnSet,
                    mmProfile: {
                        voiceCount: (_b = channelsMap["telephony"]) === null || _b === void 0 ? void 0 : _b.length,
                        chatCount: (_c = channelsMap["chat"]) === null || _c === void 0 ? void 0 : _c.length,
                        emailCount: (_d = channelsMap["email"]) === null || _d === void 0 ? void 0 : _d.length,
                        socialCount: (_e = channelsMap["social"]) === null || _e === void 0 ? void 0 : _e.length
                    },
                    lastIdleCodeChangeTimestamp,
                    lastStateChangeTimestamp,
                    interactionIds,
                    userRole: this.userRole,
                    deviceType: selectedProfile.deviceType,
                    deviceId,
                    selectedRoleName: selectedProfile.roles ? selectedProfile.roles.join("_") : ""
                }, false);
                this.evt("remove-state-change-banner", {});
            });
        }
        wasProfileChanged(role, onSubmitProfileDetails) {
            const previousProfile = this.getCurrentProfileDetails();
            if (!previousProfile) {
                return true;
            }
            const profileTheSame = onSubmitProfileDetails.deviceType === previousProfile.deviceType &&
                onSubmitProfileDetails.deviceId === previousProfile.deviceId &&
                onSubmitProfileDetails.teamId === previousProfile.teamId &&
                onSubmitProfileDetails.isExtension === previousProfile.isExtension &&
                onSubmitProfileDetails.extensionNumber === previousProfile.extensionNumber &&
                onSubmitProfileDetails.dialNumberValueForNonUS === previousProfile.dialNumberValueForNonUS &&
                onSubmitProfileDetails.isInternational === previousProfile.isInternational &&
                onSubmitProfileDetails.phoneNumber === previousProfile.phoneNumber;
            return !profileTheSame;
        }
        // Error Handlers For SERVICE.aqm.agent.stationLogin()
        handleStationLoginSubmit(stationLoginDetails, autologin = false) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                const success = yield this.submitLoginPreCheck();
                if (!success) {
                    return;
                }
                const loggedInRole = stationLoginDetails.loggedInRole;
                const selectedProfile = Object.assign({}, stationLoginDetails.profileDetail);
                let deviceId = (_a = selectedProfile.dnNumber) === null || _a === void 0 ? void 0 : _a.replace(/ /g, "");
                const teamUniqueId = yield this.checkForTeamId(selectedProfile);
                if (teamUniqueId instanceof Error) {
                    return;
                }
                let teamName = ((_b = this.profile.teams.find((team) => team.teamId === selectedProfile.teamId)) === null || _b === void 0 ? void 0 : _b.teamName) || "";
                if (teamName === "" && this.isConsultTransferInfiniteScrollEnabled) {
                    const { teamName: fetchedTeamName } = yield this.getTeamNameAndId(selectedProfile.teamId || "");
                    teamName = fetchedTeamName || "";
                }
                const stationLoginResult = yield this.buildStationLoginData(deviceId, selectedProfile);
                if (!stationLoginResult) {
                    return;
                }
                const { didOverwriteDeviceId, stationLoginData } = stationLoginResult;
                if (didOverwriteDeviceId) {
                    deviceId = stationLoginData === null || stationLoginData === void 0 ? void 0 : stationLoginData.deviceId;
                }
                this.profileChanged = this.wasProfileChanged(loggedInRole, selectedProfile);
                // TODO: API Dependency (1) Send Role (2) Empty DN/Team (3) Supervisor Only.
                const loginResult = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.aqm.agent.stationLogin({
                    data: stationLoginData
                });
                this.checkAndSaveCredentials(deviceId, selectedProfile, stationLoginData, autologin);
                this.finishAndNotifySuccess(loggedInRole, teamUniqueId.toString(), deviceId, selectedProfile, loginResult, teamName);
            });
        }
        handleUserProfileDataAvailable(data) {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.isDesktopEmergencyNotificationEnabled &&
                    data.loginOption === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.BROWSER &&
                    !this.isEmergencyModalAlreadyDisplayed) {
                    this.isEmergencyModalAlreadyDisplayed = true;
                }
                if (data.isRememberMeChecked !== undefined) {
                    this.isRememberMyCredentials = data.isRememberMeChecked;
                }
                const isExtension = data.loginOption === "EXTENSION";
                this.isExtensionUsed = isExtension;
                const selectedTeam = this.isConsultTransferInfiniteScrollEnabled ? this.selectedTeam : data.team;
                const stationLoginDetails = {
                    profileDetail: {
                        roles: this.userRole,
                        teamName: selectedTeam.teamName,
                        teamId: selectedTeam.teamId,
                        dnNumber: isExtension ? data.extensionNumber : data.dialNumber,
                        isExtension,
                        usesOtherDN: this.isUsesOtherFormat(),
                        extensionNumber: data.extensionNumber || this.defaultDn || "",
                        dialNumberValueForNonUS: this.defaultDn,
                        defaultDn: this.defaultDn,
                        isDefaultDnSet: this.isDefaultDnSet,
                        isInternational: this.isInternational,
                        phoneNumber: this.defaultDn,
                        countryCallingCode: "",
                        countryCodeValue: "",
                        isRememberMyCredentials: this.isRememberMyCredentials,
                        deviceType: data.loginOption,
                        deviceId: this.deviceId,
                        isEmergencyModalAlreadyDisplayed: this.isEmergencyModalAlreadyDisplayed
                    },
                    loggedInRole: data.role
                };
                this.handleStationLoginSubmit(stationLoginDetails);
            });
        }
        cancelStationLogin() {
            this.isModalOpen = false;
            this.isSubmitBusy = false;
            // Trigger confirmation modal for sign out
            this.evt(EventLogoutConfirm, {
                header: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.signoutConfirmHeader"),
                message: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.signoutConfirmMsg"),
                noExitOnEsc: true,
                buttons: [
                    {
                        type: "cancel",
                        label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(cancelButtonLabel),
                        variant: "secondary",
                        onClick: this.cancelLogout
                    },
                    { type: "ok", label: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(signOutButtonLabel), onClick: this.requestCILogout }
                ]
            });
        }
        stationLoginSubmitClick() {
            if (this.showEmergencyModal()) {
                this.setEmergencyNotificationAlert(true);
            }
            else {
                this.onSubmit();
            }
        }
        handleRememberMeCheckBoxChange() {
            this.isRememberMyCredentials = !this.isRememberMyCredentials;
        }
        updateContinueButtonDisabledState(isDisabled) {
            var _a;
            const button = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById("continueButton");
            if (button) {
                button.disabled = isDisabled;
            }
            // On checkbox change, update the focusable elements
            this.resetFocusableElements();
        }
        setEmergencyNotificationAlert(show) {
            this.showEmergencyNotificationWebrtc = show;
            this.resetFocusableElements();
        }
        resetFocusableElements() {
            document.dispatchEvent(new CustomEvent("on-widget-update"));
        }
        renderEmergencyNotificationFooter() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="footer-buttons" slot="footer">
          <md-button
            class="footer-btn"
            variant="secondary"
            @button-click="${() => this.setEmergencyNotificationAlert(false)}"
          >
            ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.cancelButton")}
          </md-button>
          <md-button
            @button-click="${() => this.onSubmit()}"
            id="continueButton"
            class="footer-btn"
            variant="primary"
            ?disabled=${true}
          >
            ${this.isSubmitBusy
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                  <md-loading></md-loading>
                  ${this.updateContinueButtonDisabledState(true)}
                `
                : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:common.continueButton")}
          </md-button>
        </div>
      `;
        }
        renderStationLoginFooter() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <div class="sl-footer" slot="footer">
          <div class="remember-me-checkbox-wrapper">
            <md-checkbox
              slot="checkbox"
              ?checked=${this.isRememberMyCredentials}
              label="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.rememberMe")}"
              class="remember-me-checkbox"
              @checkbox-change=${() => this.handleRememberMeCheckBoxChange()}
            >
              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.rememberMe")}
            </md-checkbox>
          </div>

          <div class="footer-buttons">
            <md-button
              class="footer-btn"
              variant="secondary"
              @click="${this.cancelStationLogin}"
              ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(cancelButtonLabel)}"
            >
              ${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)(cancelButtonLabel)}
            </md-button>
            <md-button
              class="footer-btn"
              @button-click="${this.stationLoginSubmitClick}"
              variant="primary"
              ariaLabel="${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.submit")}"
              ?disabled=${this.isSubmitDisabled || this.isSubmitBusy}
            >
              ${this.isSubmitBusy ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) ` <md-loading></md-loading> ` : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.submit")}
            </md-button>
          </div>
        </div>
      `;
        }
        renderFooter() {
            return this.showEmergencyNotificationWebrtc && !this.isEmergencyModalAlreadyDisplayed
                ? this.renderEmergencyNotificationFooter()
                : this.renderStationLoginFooter();
        }
        getStationModalLayout() {
            var _a, _b, _c;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <md-modal
          lang=${this.lang}
          .show=${this.isModalOpen}
          size="small"
          .hideFooter=${true}
          .hideHeader=${true}
          noExitOnEsc
          disableInitialFocus
          aria-label=${(0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationCredentials")}
        >
          <div slot="header">
            <h2 class="sl-form-label">
              ${this.showEmergencyNotificationWebrtc && !this.isEmergencyModalAlreadyDisplayed
                ? (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:emergencyServiceNotification.emergencyServiceNotification")
                : (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.stationCredentials")}
            </h2>
          </div>
          <agentx-wc-user-profile
            .isSubmit="${this.isSubmitClicked}"
            .reasonCode="${this.reasonCode}"
            .isDesktopReasonCodeEnabled="${this.isDesktopReasonCodeEnabled}"
            .getErrorMsgForReasonCode="${this.getErrorMsgForReasonCode}"
            .userRole="${this.userRole.join("_")}"
            .isExtensionUsed="${this.isExtensionUsed}"
            ?isMonitoringEnabled="${this.isMonitoringEnabled}"
            selectedRoleName="${this.selectedRoleName}"
            orgId="${this.organizationId}"
            agentDbId="${((_a = this.profile) === null || _a === void 0 ? void 0 : _a.analyserUserId) || ((_b = this.profile) === null || _b === void 0 ? void 0 : _b.agentDbId) || ""}"
            .dialNumber="${this.dialNumber}"
            ?isDefaultDnSet="${this.isDefaultDnSet}"
            .teams="${this.teams}"
            .teamsMeta=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_12__.ifDefined)(this.isConsultTransferInfiniteScrollEnabled ? JSON.stringify((_c = this.profile) === null || _c === void 0 ? void 0 : _c.teamsMeta) : undefined)}
            teamName="${this.teamName}"
            teamId="${this.teamId}"
            .usesOtherDN="${this.usesOtherDN}"
            defaultDn="${this.defaultDn}"
            extensionNumber="${this.extensionNumber}"
            .dialNumberValueForNonUS="${this.dialNumberValueForNonUS}"
            ?isInternational="${this.isInternational}"
            countryCallingCode="${this.countryCallingCode}"
            countryCodeValue="${this.countryCodeValue}"
            ?isRememberMyCredentials="${this.isRememberMyCredentials}"
            ?isErrUnknown="${this.isErrUnknown}"
            ?auxCodeError="${this.auxCodeConfig.isError}"
            ?fetchUniqueTeamIdError="${this.fetchUniqueTeamIdError}"
            ?isErrDNRegister="${this.isErrDNRegister}"
            ?isDNAlreadyInUse="${this.isDNAlreadyInUse}"
            ?isErrPhone="${this.isErrPhone}"
            ?isErrPhoneExt="${this.isErrPhoneExt}"
            ?isExtAlreadyInUse="${this.isExtAlreadyInUse}"
            ?isErrExtRegister="${this.isErrExtRegister}"
            ?isDNRegisterTimeOut="${this.isDNRegisterTimeOut}"
            ?isMaximumSessionsReached="${this.isDesktopMaxSessionLimitsEnabled && this.isMaximumSessionsReached}"
            ?isTeamsEmpty="${this.isTeamsEmpty}"
            trackingId="${this.trackingId}"
            ?isStationlogin=${true}
            phoneFormat="${this.phoneFormat}"
            phoneNumber="${this.phoneNumber}"
            deviceType=${this.getDeviceType(this.deviceType, this.isExtensionUsed)}
            deviceId=${this.deviceId}
            .loginVoiceOptions=${this.loginVoiceOptions}
            ?isWebRTCEnabled=${this.isWebRTCEnabled}
            ?isConsultTransferInfiniteScrollEnabled=${this.isConsultTransferInfiniteScrollEnabled}
            ?isWebRtcUnsupportedBrowser=${this.isWebRTCEnabled && this.isWebRtcUnsupportedBrowser}
            ?isMicrophoneAccessDenied=${this.isWebRTCEnabled && this.isMicrophoneAccessDenied}
            ?showEmergencyNotificationWebrtc=${this.showEmergencyNotificationWebrtc}
            ?isEmergencyModalAlreadyDisplayed=${this.isEmergencyModalAlreadyDisplayed}
            @submit-busy="${(e) => {
                this.isSubmitBusy = e.detail.submitProperty;
            }}"
            @on-component-update="${(e) => {
                this.isSubmitDisabled = e.detail.submitProperty;
                this.deviceTypeName = e.detail.profileDetail.deviceType;
            }}"
            @login-start="${(e) => this.handleStationLoginSubmit(e.detail)}"
            @checkbox-state-changed="${(e) => this.updateContinueButtonDisabledState(!e.detail.checked)}"
            @on-team-selected="${this.onTeamSelect}"
          ></agentx-wc-user-profile>

          <!-- Footer -->
          ${this.renderFooter()}
        </md-modal>
      `;
        }
        getCurrentProfileDetails() {
            return {
                roles: this.role ? [this.role] : [],
                teamName: this.teamName,
                teamId: this.teamId,
                dnNumber: this.dialNumber,
                isExtension: this.isExtensionUsed,
                usesOtherDN: this.usesOtherDN,
                extensionNumber: this.extensionNumber,
                dialNumberValueForNonUS: this.dialNumberValueForNonUS,
                defaultDn: this.defaultDn,
                isDefaultDnSet: this.isDefaultDnSet,
                isInternational: this.isInternational,
                phoneNumber: this.phoneNumber,
                countryCallingCode: this.countryCallingCode,
                countryCodeValue: this.countryCodeValue,
                isRememberMyCredentials: this.isRememberMyCredentials,
                deviceType: this.deviceType,
                deviceId: this.deviceId,
                isEmergencyModalAlreadyDisplayed: this.isEmergencyModalAlreadyDisplayed
            };
        }
        getEnhancedStationModalLayout() {
            var _a, _b, _c;
            const { errorType, errorMessage } = this.errorInfo;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <uuip-wc-user-station-login
          ?isModalOpen=${this.isModalOpen}
          ?isRememberMeChecked=${this.isRememberMyCredentials}
          ?isSubmitBusy=${this.isSubmitBusy}
          ?isDesktopEmergencyNotificationEnabled=${this.isDesktopEmergencyNotificationEnabled}
          ?isEmergencyNotificationAlreadyDisplayed=${this.isEmergencyModalAlreadyDisplayed}
          ?isExternalTeamSelection=${this.isConsultTransferInfiniteScrollEnabled}
          .defaultDialNumber=${this.dialNumber}
          ?isReadonlyNumber=${this.isDefaultDnSet}
          .defaultTeam=${{ teamId: this.teamId, teamName: this.teamName }}
          .errorType=${errorType}
          .errorMessage=${errorMessage}
          .dialPlanRegexStrings=${this.dialPlanRegexes}
          .extensions=${this.availableExtensions}
          .defaultExtension=${this.extensionNumber}
          ?isCallMonitoringEnabled=${this.isMonitoringEnabled}
          .loginVoiceOptions=${this.availableLoginVoiceOptions}
          .defaultVoiceOption=${this.preferenceVoiceOption}
          .preferenceRoleName=${this.selectedRoleName}
          .teams=${this.teams}
          .userRoles=${this.userRole}
          .localization=${this.userStationLoginLocalization}
          @signout-clicked=${this.cancelStationLogin}
          @confirm-clicked=${(e) => this.handleUserProfileDataAvailable(e.detail.data)}
          @component-updated=${(e) => {
                this.deviceType = e.detail.data.loginOption;
                this.isExtensionUsed = this.deviceType === _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.LoginVoiceOptions.EXTENSION;
                this.isErrUnknown = false;
            }}
        >
          ${this.isConsultTransferInfiniteScrollEnabled
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
                <div slot="external-team-selection">
                  <agentx-wc-teams-list-infinite
                    selectedTeamName=${this.selectedTeam.teamName}
                    agentDbId=${((_a = this.profile) === null || _a === void 0 ? void 0 : _a.analyserUserId) || ((_b = this.profile) === null || _b === void 0 ? void 0 : _b.agentDbId) || ""}
                    orgId=${this.organizationId}
                    teamsMeta=${JSON.stringify((_c = this.profile) === null || _c === void 0 ? void 0 : _c.teamsMeta)}
                    .paginatedTeamResponse=${this.paginatedTeamResponse}
                  ></agentx-wc-teams-list-infinite>
                </div>
              `
                : lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing}
        </uuip-wc-user-station-login>
      `;
        }
        getLoadingScreen() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) ` <agentx-wc-loading-screen></agentx-wc-loading-screen> `;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        ${this.isInitializing
                ? this.getLoadingScreen()
                : this.isDesktopEnhancedSignInEnabled
                    ? this.getEnhancedStationModalLayout()
                    : this.getStationModalLayout()}
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ attribute: false })
    ], Element.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isAdvancedHeader", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDesktopReasonCodeEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)()
    ], Element.prototype, "getErrorMsgForReasonCode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "roleFromMe", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)()
    ], Element.prototype, "organizationId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)()
    ], Element.prototype, "meUserId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isMonitoringEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "selectedRoleName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDesktopMaxSessionLimitsEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDesktopMaerskAcqueonTeamId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDesktopMSStateSyncEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDesktopEmergencyNotificationEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDesktopEnhancedSignInEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)()
    ], Element.prototype, "phoneFormat", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "phoneNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isRememberMyCredentials", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isWebRTCEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "deviceType", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "deviceId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "reasonCode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isMaerskEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isDesktopAuxCodesInfiniteScrollEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isConsultTransferInfiniteScrollEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "showEmergencyNotificationWebrtc", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Boolean })
    ], Element.prototype, "isEmergencyModalAlreadyDisplayed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Array })
    ], Element.prototype, "availableExtensions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isInitializing", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isSubmitBusy", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isSubmitDisabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isSubmitClicked", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "teamName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "teamId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isTeamsEmpty", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "dialNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "deviceTypeName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isDefaultDnSet", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "userRole", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "loginType", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "usesOtherDN", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "dialNumberValueForNonUS", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "defaultDn", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isInternational", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isPreferenceSaved", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "loginVoiceOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "auxCodeConfig", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "initialIdleCodes", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "systemIdleCodes", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "fetchUniqueTeamIdError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "dialPlan", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isErrUnknown", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isErrDNRegister", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isDNAlreadyInUse", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isErrPhone", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isErrPhoneExt", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isExtAlreadyInUse", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isErrExtRegister", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isDNRegisterTimeOut", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isMaximumSessionsReached", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isWebRtcUnsupportedBrowser", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isMicrophoneAccessDenied", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "paginatedTeamResponse", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "autoLoginType", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "profileChanged", void 0);
    __decorate([
        _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__.Decorator.Handle({
            "Service.aqm.configs.application": ({ ctx, details }) => {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/Config/Error", "", details);
                ctx.dispatchLoginError(ctx, details, ErrId);
            },
            "Service.abs.fetchCmsInitConfig": ({ ctx, details }) => {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/CMSConfig/Error", "", details);
                ctx.dispatchLoginError(ctx, details, "Service.abs.fetchCmsInitConfig");
            },
            "Service.aqm.reqs.TimeoutEvent": ({ ctx, details }) => {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/Profile/TimeoutEvent", "", details);
                const errorDetails = {
                    type: "Timeout",
                    status: 408,
                    trackingId: "" // To do to fetch tracking id on timeout of updateAgentProfile
                };
                ctx.dispatchLoginError(ctx, errorDetails, ErrId);
            },
            "Service.aqm.reqs.Timeout": ({ ctx, details }) => {
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/AgentPropertyEvent/Timeout", "", { key: details === null || details === void 0 ? void 0 : details.key });
                const errorDetails = {
                    type: "Timeout",
                    status: 408,
                    trackingId: (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.getTrackingIdFromErrorObject)(details)
                };
                ctx.dispatchLoginError(ctx, errorDetails, ErrId);
            }
        })
    ], Element.prototype, "init", null);
    __decorate([
        _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__.Decorator.Handle(function () {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.userRole.join("_") === _constants__WEBPACK_IMPORTED_MODULE_7__.AGENT && this.isTeamsEmpty) {
                    this.evt(EventNameError, {
                        id: "Service.aqm.configs.teams",
                        message: (0,_mixins_i18nMixin__WEBPACK_IMPORTED_MODULE_0__.t)("app:stationLogin.initialProfileTeamFailed"),
                        trackingId: ""
                    });
                }
                else if (!(this.userRole.join("_") === _constants__WEBPACK_IMPORTED_MODULE_7__.SUPERVISOR && !this.isMonitoringEnabled)) {
                    yield this.fetchSavedPreferences();
                    this.requestUpdate();
                    if (this.isDesktopEnhancedSignInEnabled && this.isPreferenceSaved && this.isRememberMyCredentials) {
                        this.agentAutoLogin();
                        return;
                    }
                    this.isModalOpen = true;
                    this.isInitializing = false;
                }
                else {
                    this.isModalOpen = false;
                    this.autologin();
                }
            });
        })
    ], Element.prototype, "agentReload", null);
    __decorate([
        _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__.Decorator.Exec(({ ctx, isExec }) => (ctx.isSubmitBusy = isExec), false),
        _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__.Decorator.Handle(({ ctx, id, message }) => {
            ctx.isErrUnknown = true;
            ctx.isErrDNRegister = false;
            ctx.isDNAlreadyInUse = false;
            ctx.isErrPhone = false;
            ctx.isErrExtRegister = false;
            ctx.isExtAlreadyInUse = false;
            ctx.isErrPhoneExt = false;
            ctx.isSubmitBusy = false;
            ctx.evt(EventNameError, { id, message, trackingId: "" });
        }),
        _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__.Decorator.Handle({
            "Service.aqm.agent.stationLogin": ({ ctx, details }) => {
                var _a, _b, _c, _d;
                ctx.setErrorFlags();
                ctx.isSubmitBusy = false;
                if (ctx.isDesktopEnhancedSignInEnabled && ctx.autoLoginType === _constants__WEBPACK_IMPORTED_MODULE_7__.AutoLoginType.Agent) {
                    ctx.isInitializing = false;
                    ctx.isModalOpen = true;
                }
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/StationLogin/Error", "", details);
                ctx.trackingId = ctx.getTrackingID(details.trackingId);
                if (ctx.isModalOpen) {
                    ctx.evt(EventNameError, {
                        id: "Service.aqm.agent.stationLogin",
                        message: "Station Login API failed",
                        trackingId: ctx.trackingId
                    });
                }
                else {
                    ctx.evt(EventNameError, {
                        id: "Service.aqm.supervisor.stationLogin",
                        message: "Supervisor Station Login API failed",
                        trackingId: ctx.trackingId
                    });
                }
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATION_LOGIN, {
                    LoginType: ctx.loginType,
                    Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                    [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.SIGN_IN_FAILURE_REASON]: "Station Login API failed",
                    Reason: "Station Login API failed",
                    AdvancedHeader: ctx.advanceHeaderTracker()
                }, [(_b = (_a = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_behavioral, (_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.webex_business]);
            },
            "Service.aqm.agent.stationLoginFailed": ({ ctx, details }) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/StationLoginNotifs/Error", "", details);
                ctx.isSubmitBusy = false;
                if (ctx.isDesktopEnhancedSignInEnabled && ctx.autoLoginType === _constants__WEBPACK_IMPORTED_MODULE_7__.AutoLoginType.Agent) {
                    ctx.isInitializing = false;
                    ctx.isModalOpen = true;
                }
                if (_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.featureflag.isFeatureFlagEnabled(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_ENABLE_LOGIN_1035_RECOVERY) &&
                    ((_a = details === null || details === void 0 ? void 0 : details.data) === null || _a === void 0 ? void 0 : _a.reasonCode) === 1035) {
                    if (!ctx.profileChanged) {
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.debug("Login/Station/AgentAlreadyExists/Reload", "Try reload since agent already exists and no change to Login Details");
                        ctx.agentReload();
                        ctx.profileChanged = true; // In the case of a reload resulting in a 1035, lets terminate the loop and logout
                    }
                    else {
                        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/AgentAlreadyExists/Error", "Login Details changed - show error screen", details);
                        ctx.logout();
                    }
                    return;
                }
                ctx.setErrorFlags();
                ctx.reasonCode = (_b = details === null || details === void 0 ? void 0 : details.data) === null || _b === void 0 ? void 0 : _b.reasonCode;
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/StationLoginNotifs/Error", "", details);
                if (((_c = details === null || details === void 0 ? void 0 : details.data) === null || _c === void 0 ? void 0 : _c.reasonCode) === 41) {
                    ctx.isDNRegisterTimeOut = true;
                }
                if (((_d = details === null || details === void 0 ? void 0 : details.data) === null || _d === void 0 ? void 0 : _d.reasonCode) === 1019) {
                    ctx.isMaximumSessionsReached = true;
                }
                ctx.trackingId = (_e = details.data) === null || _e === void 0 ? void 0 : _e.trackingId;
                if (ctx.isModalOpen) {
                    ctx.evt(EventNameError, {
                        id: "Service.aqm.agent.stationLoginFailed",
                        message: "Station Login Notifs failed",
                        trackingId: ctx.trackingId,
                        reasonCode: (_f = details.data) === null || _f === void 0 ? void 0 : _f.reasonCode
                    });
                }
                else {
                    ctx.evt(EventNameError, {
                        id: "Service.aqm.supervisor.stationLoginFailed",
                        message: "Station Login Notifs failed",
                        trackingId: ctx.trackingId,
                        reasonCode: (_g = details.data) === null || _g === void 0 ? void 0 : _g.reasonCode
                    });
                }
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATION_LOGIN, {
                    LoginType: ctx.loginType,
                    Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                    [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.SIGN_IN_FAILURE_REASON]: "Station Login Notifs failed",
                    AdvancedHeader: ctx.advanceHeaderTracker(),
                    Reason: (_h = details === null || details === void 0 ? void 0 : details.data) === null || _h === void 0 ? void 0 : _h.reason,
                    ReasonCode: (_j = details === null || details === void 0 ? void 0 : details.data) === null || _j === void 0 ? void 0 : _j.reasonCode
                }, [(_l = (_k = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _k === void 0 ? void 0 : _k.SERVICE_PROVIDERS) === null || _l === void 0 ? void 0 : _l.webex_behavioral, (_o = (_m = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _m === void 0 ? void 0 : _m.SERVICE_PROVIDERS) === null || _o === void 0 ? void 0 : _o.webex_business]);
            },
            "Service.aqm.reqs.Timeout": ({ ctx, details }) => {
                var _a, _b, _c, _d, _e, _f;
                ctx.setErrorFlags();
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Login/Station/StationLogin/Timeout", "", details);
                ctx.trackingId = ctx.getTrackingID((_b = (_a = details === null || details === void 0 ? void 0 : details.resAxios) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.trackingid);
                ctx.evt(EventNameError, {
                    id: "Service.aqm.reqs.Timeout",
                    message: "Station Login failed",
                    trackingId: ctx.trackingId
                });
                _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATION_LOGIN, {
                    LoginType: ctx.loginType,
                    Status: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                    [_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.SIGN_IN_FAILURE_REASON]: "Station Login failed",
                    Reason: "Station Login failed",
                    AdvancedHeader: ctx.advanceHeaderTracker()
                }, [(_d = (_c = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.webex_behavioral, (_f = (_e = _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry) === null || _e === void 0 ? void 0 : _e.SERVICE_PROVIDERS) === null || _f === void 0 ? void 0 : _f.webex_business]);
            }
        })
    ], Element.prototype, "handleStationLoginSubmit", null);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("agentx-wc-user-station-login")
    ], Element);
    UserStationLogin.Element = Element;
})(UserStationLogin || (UserStationLogin = {}));


/***/ }),

/***/ "./src/components/userStationLogin/utils.ts":
/*!**************************************************!*\
  !*** ./src/components/userStationLogin/utils.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FIRST_PAGE: () => (/* binding */ FIRST_PAGE),
/* harmony export */   IDLE_CODE: () => (/* binding */ IDLE_CODE),
/* harmony export */   escapeRegExp: () => (/* binding */ escapeRegExp),
/* harmony export */   fetchAuxCodeValues: () => (/* binding */ fetchAuxCodeValues),
/* harmony export */   fetchIdleCodes: () => (/* binding */ fetchIdleCodes),
/* harmony export */   fetchTeamList: () => (/* binding */ fetchTeamList),
/* harmony export */   fetchWrapUpCodes: () => (/* binding */ fetchWrapUpCodes)
/* harmony export */ });
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


const IDLE_CODE = "IDLE_CODE";
const FIRST_PAGE = 0;
const reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
const reHasRegExpChar = RegExp(reRegExpChar.source);
const PAGE_SIZE = 100;
const fetchIdleCodes = (orgId, idleCodeConfig, isDesktopAuxCodesInfiniteScrollEnabled) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        if (isDesktopAuxCodesInfiniteScrollEnabled) {
            const params = { orgId, page: 0, pageSize: 100 };
            // This block will execute when "desktop-aux-codes-infinite-scrolling" feature flag is ON.
            const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs.fetchPaginatedIdleCodes(params);
            _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info(`event=fetchIdleCodes Successfully fetched ${response.data.length} idle codes for page: ${params.page} `);
            return response;
        }
        else {
            const params = { orgId, accessType: idleCodeConfig.accessType, ids: idleCodeConfig.ids };
            // This block will execute when "desktop-maersk-CX-11355" feature flag is ON and "desktop-aux-codes-infinite-scrolling" is OFF.
            const response = (yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs.fetchIdleCodes(params));
            _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info(`event=fetchIdleCodes Successfully fetched ${response.length} idle codes`);
            return Array.isArray(response) ? response : [];
        }
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error(`event=fetchIdleCodes | Tracking ID: ${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error) : ""} | Fetching idle codes from aux code is failed : ${error}`, error);
        throw error;
    }
});
const fetchDefaultAuxCodes = (orgId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const params = { orgId };
        const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs.fetchDefaultAuxCodes(params);
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info(`event=fetchDefaultAuxCodes : Successfully fetched ${response.length} default aux codes`);
        return response;
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error(`event=fetchDefaultIdleCodes | Tracking ID: ${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error) : ""} | Fetching default aux code is failed : ${error}`, error);
        throw error;
    }
});
const fetchFilteredIdleCodes = (orgId, customFilter, desktopProfileFilter) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const params = {
            orgId,
            page: 0,
            pageSize: 100,
            customFilter,
            desktopProfileFilter
        };
        const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs.fetchPaginatedIdleCodes(params);
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info(`event=fetchPaginatedIdleCodes Successfully fetched ${response.data.length} system idle codes for page: ${params.page} `);
        return response;
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error(`event=fetchPaginatedIdleCodes | Tracking ID: ${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error) : ""} | Fetching system idle codes has failed : ${error}`, error);
        throw error;
    }
});
const fetchWrapUpCodes = (orgId, wrapUpCodeConfig, isDesktopAuxCodesInfiniteScrollEnabled) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        if (isDesktopAuxCodesInfiniteScrollEnabled) {
            const params = { orgId, page: FIRST_PAGE, pageSize: 100 };
            const response = yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs.fetchPaginatedWrapUpCodes(params);
            _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info(`event=fetchWrapUpCodes Successfully fetched ${response.data.length} wrap up codes for page: ${params.page}`);
            return response;
        }
        else {
            const params = { orgId, accessType: wrapUpCodeConfig.accessType, ids: wrapUpCodeConfig.ids };
            const response = (yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs.fetchWrapUpCodes(params));
            _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info(`event=fetchWrapUpCodes Successfully fetched ${response.length} wrap up codes`);
            return Array.isArray(response) ? response : [];
        }
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error(`event=fetchWrapUpCodes | Tracking ID: ${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error) : ""} | Fetching wrap up codes from aux code is failed : ${error}`, error);
        throw error;
    }
});
const fetchAuxCodeValues = (orgId, idleCodeConfig, wrapUpCodeConfig, isDesktopAuxCodesInfiniteScrollEnabled, shouldFetchDefaultIdleCode) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const apiCalls = [
            fetchIdleCodes(orgId, idleCodeConfig, isDesktopAuxCodesInfiniteScrollEnabled),
            fetchWrapUpCodes(orgId, wrapUpCodeConfig, isDesktopAuxCodesInfiniteScrollEnabled)
        ];
        if (isDesktopAuxCodesInfiniteScrollEnabled && shouldFetchDefaultIdleCode) {
            // fetch default aux code from api incase of infinite scroll
            apiCalls.push(fetchDefaultAuxCodes(orgId));
        }
        apiCalls.push(fetchFilteredIdleCodes(orgId, "isSystemCode==true", false)); // fetch ALL system idle codes
        const [idleCodes, wrapUpCodes, defaultAuxCodes, systemIdleCodes] = yield Promise.all(apiCalls);
        return [idleCodes, wrapUpCodes, defaultAuxCodes, systemIdleCodes];
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error(`event=fetchAuxCodeValues | Tracking ID: ${_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject ? (0,_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.getTrackingIdFromErrorObject)(error) : ""} | Fetching fetchAuxCodeValues is failed : ${error}`, error);
        throw error;
    }
});
const fetchTeamList = (orgId, page, agentDbId, searchTerm = "", teamId = "") => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const params = {
            orgId,
            page,
            search: searchTerm,
            pageSize: PAGE_SIZE,
            customFilter: teamId !== "" ? `userId=="${agentDbId}";id=="${teamId}"` : `userId=="${agentDbId}"`
        };
        return yield _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs.fetchPaginatedTeamsList(params);
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error("event=fetchTeams | Error on fetching Teams List in Station Login Module", error);
        throw error;
    }
});
const escapeRegExp = (string) => {
    return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string || "";
};


/***/ }),

/***/ "./src/config.ts":
/*!***********************!*\
  !*** ./src/config.ts ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CONF: () => (/* binding */ CONF),
/* harmony export */   setAgentxMfeWcBasedConfig: () => (/* binding */ setAgentxMfeWcBasedConfig)
/* harmony export */ });
/* eslint-disable @typescript-eslint/no-explicit-any */
const CONF = {};
function setAgentxMfeWcBasedConfig(config) {
    Object.keys(config).forEach((k) => (CONF[k] = config[k]));
}


/***/ }),

/***/ "./src/constants.ts":
/*!**************************!*\
  !*** ./src/constants.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ACCESS_IDLE_CODES: () => (/* binding */ ACCESS_IDLE_CODES),
/* harmony export */   ACTIONS: () => (/* binding */ ACTIONS),
/* harmony export */   AGENT: () => (/* binding */ AGENT),
/* harmony export */   AGENTCONNECT_COMPLETED: () => (/* binding */ AGENTCONNECT_COMPLETED),
/* harmony export */   AGENTX_WEBEX_MINIMIZE_RESTORE: () => (/* binding */ AGENTX_WEBEX_MINIMIZE_RESTORE),
/* harmony export */   AGENTX_WEBEX_WRAPPER_CLOSE: () => (/* binding */ AGENTX_WEBEX_WRAPPER_CLOSE),
/* harmony export */   AGENT_AND_SUPERVISOR: () => (/* binding */ AGENT_AND_SUPERVISOR),
/* harmony export */   AGENT_SIGNOUT_REASON: () => (/* binding */ AGENT_SIGNOUT_REASON),
/* harmony export */   AGENT_SIGNOUT_RESULT: () => (/* binding */ AGENT_SIGNOUT_RESULT),
/* harmony export */   AGENT_STATE_CHANGE_FAILED: () => (/* binding */ AGENT_STATE_CHANGE_FAILED),
/* harmony export */   APPLE_MESSAGE_DARK_SVG: () => (/* binding */ APPLE_MESSAGE_DARK_SVG),
/* harmony export */   APPLE_MESSAGE_LIGHT_SVG: () => (/* binding */ APPLE_MESSAGE_LIGHT_SVG),
/* harmony export */   AVAILABLE: () => (/* binding */ AVAILABLE),
/* harmony export */   AVAILABLE_CONSULTING: () => (/* binding */ AVAILABLE_CONSULTING),
/* harmony export */   AVAILABLE_ID: () => (/* binding */ AVAILABLE_ID),
/* harmony export */   AutoLoginType: () => (/* binding */ AutoLoginType),
/* harmony export */   BLIND_TRANSFER_COMPLETED: () => (/* binding */ BLIND_TRANSFER_COMPLETED),
/* harmony export */   CALLBACK_ACTIONS_LIST: () => (/* binding */ CALLBACK_ACTIONS_LIST),
/* harmony export */   CALLBACK_LIST_ITEM_SIZE: () => (/* binding */ CALLBACK_LIST_ITEM_SIZE),
/* harmony export */   CALL_ENDED: () => (/* binding */ CALL_ENDED),
/* harmony export */   CAPTURE_STARTED: () => (/* binding */ CAPTURE_STARTED),
/* harmony export */   CHANGED_BY_ROLE: () => (/* binding */ CHANGED_BY_ROLE),
/* harmony export */   CHEVRON_ICON: () => (/* binding */ CHEVRON_ICON),
/* harmony export */   COLUMN_MENU_FOCUS: () => (/* binding */ COLUMN_MENU_FOCUS),
/* harmony export */   CONFERENCE: () => (/* binding */ CONFERENCE),
/* harmony export */   CONFERENCE_COMPLETED: () => (/* binding */ CONFERENCE_COMPLETED),
/* harmony export */   CONFERENCE_REQUESTED: () => (/* binding */ CONFERENCE_REQUESTED),
/* harmony export */   CONFERENCE_STARTED: () => (/* binding */ CONFERENCE_STARTED),
/* harmony export */   CONFERENCING: () => (/* binding */ CONFERENCING),
/* harmony export */   CONNECTED: () => (/* binding */ CONNECTED),
/* harmony export */   CONNECTED_CONSULTING: () => (/* binding */ CONNECTED_CONSULTING),
/* harmony export */   CONSULTING: () => (/* binding */ CONSULTING),
/* harmony export */   CONSULT_COMPLETED: () => (/* binding */ CONSULT_COMPLETED),
/* harmony export */   CONSULT_DONE: () => (/* binding */ CONSULT_DONE),
/* harmony export */   CONSULT_ERROR: () => (/* binding */ CONSULT_ERROR),
/* harmony export */   CONSULT_REQUESTED: () => (/* binding */ CONSULT_REQUESTED),
/* harmony export */   CONSULT_STARTED: () => (/* binding */ CONSULT_STARTED),
/* harmony export */   CONTACT_ACTIVE_EVENTS: () => (/* binding */ CONTACT_ACTIVE_EVENTS),
/* harmony export */   CONTACT_COMPLETED: () => (/* binding */ CONTACT_COMPLETED),
/* harmony export */   CONTACT_DIRECTION: () => (/* binding */ CONTACT_DIRECTION),
/* harmony export */   CONTACT_STATS_HISTORICAL_EVENTS: () => (/* binding */ CONTACT_STATS_HISTORICAL_EVENTS),
/* harmony export */   CONTACT_TRANSFERRED_EVENTS: () => (/* binding */ CONTACT_TRANSFERRED_EVENTS),
/* harmony export */   DEFAULT_DEVICE_TYPE: () => (/* binding */ DEFAULT_DEVICE_TYPE),
/* harmony export */   DELETE: () => (/* binding */ DELETE),
/* harmony export */   DESKTOP: () => (/* binding */ DESKTOP),
/* harmony export */   DIGITAL_OUTBOUND: () => (/* binding */ DIGITAL_OUTBOUND),
/* harmony export */   EP_TRANSFER_COMPLETED: () => (/* binding */ EP_TRANSFER_COMPLETED),
/* harmony export */   EXIT_CONFERENCE: () => (/* binding */ EXIT_CONFERENCE),
/* harmony export */   FILTER_CHANGE_DELAY: () => (/* binding */ FILTER_CHANGE_DELAY),
/* harmony export */   FLOW_ACTIVITY: () => (/* binding */ FLOW_ACTIVITY),
/* harmony export */   HANDLE_AGENT_SIGNOUT_EVENT: () => (/* binding */ HANDLE_AGENT_SIGNOUT_EVENT),
/* harmony export */   HANDLE_AID_MODAL_EVENT: () => (/* binding */ HANDLE_AID_MODAL_EVENT),
/* harmony export */   HANDLE_STATE_CHANGE_EVENT: () => (/* binding */ HANDLE_STATE_CHANGE_EVENT),
/* harmony export */   HANDLE_WEBEX_CHAT_CLOSE_EVENT: () => (/* binding */ HANDLE_WEBEX_CHAT_CLOSE_EVENT),
/* harmony export */   HANDLE_WEBEX_CHAT_EVENT: () => (/* binding */ HANDLE_WEBEX_CHAT_EVENT),
/* harmony export */   HELP_LINK: () => (/* binding */ HELP_LINK),
/* harmony export */   HOLD_COMPLETED: () => (/* binding */ HOLD_COMPLETED),
/* harmony export */   HOLD_COMPLETED_CONFERENCE: () => (/* binding */ HOLD_COMPLETED_CONFERENCE),
/* harmony export */   HOLD_COMPLETED_CONSULT: () => (/* binding */ HOLD_COMPLETED_CONSULT),
/* harmony export */   HOLD_STARTED: () => (/* binding */ HOLD_STARTED),
/* harmony export */   HOLD_STARTED_CONFERENCE: () => (/* binding */ HOLD_STARTED_CONFERENCE),
/* harmony export */   HOLD_STARTED_CONSULT: () => (/* binding */ HOLD_STARTED_CONSULT),
/* harmony export */   ICON_SRC: () => (/* binding */ ICON_SRC),
/* harmony export */   IDLE: () => (/* binding */ IDLE),
/* harmony export */   IDLE_CONSULTING: () => (/* binding */ IDLE_CONSULTING),
/* harmony export */   INBOUND: () => (/* binding */ INBOUND),
/* harmony export */   INITIATE_MS_AUTH_LOGIN: () => (/* binding */ INITIATE_MS_AUTH_LOGIN),
/* harmony export */   JOIN_CONFERENCE: () => (/* binding */ JOIN_CONFERENCE),
/* harmony export */   Key: () => (/* binding */ Key),
/* harmony export */   LOGGED_OUT: () => (/* binding */ LOGGED_OUT),
/* harmony export */   MAX_CALLBACK_LIST_ITEMS: () => (/* binding */ MAX_CALLBACK_LIST_ITEMS),
/* harmony export */   MEDIA_TYPES: () => (/* binding */ MEDIA_TYPES),
/* harmony export */   MIN_CALLBACK_LIST_ITEMS: () => (/* binding */ MIN_CALLBACK_LIST_ITEMS),
/* harmony export */   MIN_WIDTH: () => (/* binding */ MIN_WIDTH),
/* harmony export */   MONITORING_ENDED: () => (/* binding */ MONITORING_ENDED),
/* harmony export */   MONITORING_ERROR: () => (/* binding */ MONITORING_ERROR),
/* harmony export */   MONITORING_HOLD: () => (/* binding */ MONITORING_HOLD),
/* harmony export */   MONITORING_REGULAR_DARK: () => (/* binding */ MONITORING_REGULAR_DARK),
/* harmony export */   MONITORING_REGULAR_LIGHT: () => (/* binding */ MONITORING_REGULAR_LIGHT),
/* harmony export */   MONITORING_REQUESTED: () => (/* binding */ MONITORING_REQUESTED),
/* harmony export */   MONITORING_STARTED: () => (/* binding */ MONITORING_STARTED),
/* harmony export */   MONITORING_UNHOLD: () => (/* binding */ MONITORING_UNHOLD),
/* harmony export */   ON_HOLD: () => (/* binding */ ON_HOLD),
/* harmony export */   OPEN_REVIEW_AND_MONITOR_MODAL: () => (/* binding */ OPEN_REVIEW_AND_MONITOR_MODAL),
/* harmony export */   OPEN_SEND_MESSAGE_MODAL: () => (/* binding */ OPEN_SEND_MESSAGE_MODAL),
/* harmony export */   OUTBOUND_TYPE: () => (/* binding */ OUTBOUND_TYPE),
/* harmony export */   OUTDIAL: () => (/* binding */ OUTDIAL),
/* harmony export */   OUT_DIAL: () => (/* binding */ OUT_DIAL),
/* harmony export */   POST_CALL_CONSULT_STARTED: () => (/* binding */ POST_CALL_CONSULT_STARTED),
/* harmony export */   POST_CALL_STARTED: () => (/* binding */ POST_CALL_STARTED),
/* harmony export */   PRESENCE_SYNC: () => (/* binding */ PRESENCE_SYNC),
/* harmony export */   PRIMARY_OWNER_CHANGED: () => (/* binding */ PRIMARY_OWNER_CHANGED),
/* harmony export */   PROFILE_SETTING_INVALID_DATA_EVENT: () => (/* binding */ PROFILE_SETTING_INVALID_DATA_EVENT),
/* harmony export */   Play: () => (/* binding */ Play),
/* harmony export */   QUEUE_TRANSFER_COMPLETED: () => (/* binding */ QUEUE_TRANSFER_COMPLETED),
/* harmony export */   REALTIME_FEED: () => (/* binding */ REALTIME_FEED),
/* harmony export */   RECORDS_ONE_HUNDRED: () => (/* binding */ RECORDS_ONE_HUNDRED),
/* harmony export */   REVIEW_BUTTON_DARK: () => (/* binding */ REVIEW_BUTTON_DARK),
/* harmony export */   REVIEW_BUTTON_DARK_DISABLED: () => (/* binding */ REVIEW_BUTTON_DARK_DISABLED),
/* harmony export */   REVIEW_BUTTON_LIGHT: () => (/* binding */ REVIEW_BUTTON_LIGHT),
/* harmony export */   REVIEW_BUTTON_LIGHT_DISABLED: () => (/* binding */ REVIEW_BUTTON_LIGHT_DISABLED),
/* harmony export */   SEARCH_THRESHOLD: () => (/* binding */ SEARCH_THRESHOLD),
/* harmony export */   SELECTED_CHANGE_DELAY: () => (/* binding */ SELECTED_CHANGE_DELAY),
/* harmony export */   SIGNED_OUT: () => (/* binding */ SIGNED_OUT),
/* harmony export */   STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON: () => (/* binding */ STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON),
/* harmony export */   STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON_CODE: () => (/* binding */ STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON_CODE),
/* harmony export */   STATE_CHANGE_OVERLAY_CLOSE_EVENT: () => (/* binding */ STATE_CHANGE_OVERLAY_CLOSE_EVENT),
/* harmony export */   SUBSCRIPTION_RESPONSE: () => (/* binding */ SUBSCRIPTION_RESPONSE),
/* harmony export */   SUPERVISOR: () => (/* binding */ SUPERVISOR),
/* harmony export */   SUPERVISOR_AND_AGENT: () => (/* binding */ SUPERVISOR_AND_AGENT),
/* harmony export */   SUPERVISOR_AUTO_LOGIN_EVENT: () => (/* binding */ SUPERVISOR_AUTO_LOGIN_EVENT),
/* harmony export */   TASKLIST_ITEMSTATUS: () => (/* binding */ TASKLIST_ITEMSTATUS),
/* harmony export */   TEAM_SELECT_EVENT: () => (/* binding */ TEAM_SELECT_EVENT),
/* harmony export */   TELEPHONY: () => (/* binding */ TELEPHONY),
/* harmony export */   TIMEOUT_TEN_MS: () => (/* binding */ TIMEOUT_TEN_MS),
/* harmony export */   TIMEOUT_THOUSAND_MS: () => (/* binding */ TIMEOUT_THOUSAND_MS),
/* harmony export */   TIMER_FIELDS: () => (/* binding */ TIMER_FIELDS),
/* harmony export */   TPW_AGENT_STATE_SELECTOR_LOADING_CHANGED: () => (/* binding */ TPW_AGENT_STATE_SELECTOR_LOADING_CHANGED),
/* harmony export */   TPW_CONTACT_UPDATE: () => (/* binding */ TPW_CONTACT_UPDATE),
/* harmony export */   TPW_DATA_WAIT_TIME: () => (/* binding */ TPW_DATA_WAIT_TIME),
/* harmony export */   TPW_EMPTY_COLUMN_VALUE: () => (/* binding */ TPW_EMPTY_COLUMN_VALUE),
/* harmony export */   TPW_FILTER_DATA_UPDATE: () => (/* binding */ TPW_FILTER_DATA_UPDATE),
/* harmony export */   TPW_FILTER_MODAL_UPDATED: () => (/* binding */ TPW_FILTER_MODAL_UPDATED),
/* harmony export */   TPW_FILTER_UPDATED: () => (/* binding */ TPW_FILTER_UPDATED),
/* harmony export */   TPW_MONITOR_MODAL: () => (/* binding */ TPW_MONITOR_MODAL),
/* harmony export */   TRANSFER_COMPLETED: () => (/* binding */ TRANSFER_COMPLETED),
/* harmony export */   UPDATE_ACTION_CELL_VALUE_EVENT: () => (/* binding */ UPDATE_ACTION_CELL_VALUE_EVENT),
/* harmony export */   WEBRTC_SHORTCUT_KEYS: () => (/* binding */ WEBRTC_SHORTCUT_KEYS),
/* harmony export */   WEB_RTC_PREFIX: () => (/* binding */ WEB_RTC_PREFIX),
/* harmony export */   WEB_RTC_STATUS: () => (/* binding */ WEB_RTC_STATUS),
/* harmony export */   WRAP_UP: () => (/* binding */ WRAP_UP),
/* harmony export */   WRAP_UP_ASSISTANCE: () => (/* binding */ WRAP_UP_ASSISTANCE),
/* harmony export */   WRAP_UP_COMPLETED: () => (/* binding */ WRAP_UP_COMPLETED),
/* harmony export */   channelList: () => (/* binding */ channelList),
/* harmony export */   emergency911HelpLink: () => (/* binding */ emergency911HelpLink),
/* harmony export */   helpPageLangCode: () => (/* binding */ helpPageLangCode)
/* harmony export */ });
const CONFERENCE = "conference";
const CONSULTING = "consulting";
const Play = "play";
var Key;
(function (Key) {
    Key["End"] = "End";
    Key["Home"] = "Home";
    Key["Enter"] = "Enter";
    Key["Tab"] = "Tab";
    Key["ArrowDown"] = "ArrowDown";
    Key["ArrowLeft"] = "ArrowLeft";
    Key["ArrowRight"] = "ArrowRight";
    Key["ArrowUp"] = "ArrowUp";
    Key["Delete"] = "Delete";
    Key["Space"] = "Space";
    Key["Escape"] = "Escape";
})(Key || (Key = {}));
const MEDIA_TYPES = {
    CHAT: "chat",
    EMAIL: "email",
    VOICE: "telephony",
    SOCIAL: "social",
    SMS: "sms",
    FACEBOOK: "facebook",
    WHATSAPP: "whatsapp",
    MIDCALL_MONITORING: "midcall telephony",
    APPLE_BUSINESS_CHAT: "appleMessages",
    GOOGLE_BUSINESS_CHAT: "googleMessages",
    OUTBOUND_AGENT_INITIATED_EMAIL: "outboundEmail",
    OUTBOUND_AGENT_INITIATED_SMS: "outboundSms"
};
const DEFAULT_DEVICE_TYPE = ["AGENT_DN", "EXTENSION"];
const WEB_RTC_PREFIX = "webrtc-";
const TASKLIST_ITEMSTATUS = {
    OUTBOUND_ICON: "outbound telephony",
    CALLBACK_ICON: "callback",
    CAMPAIGN_ICON: "progressive_campaign"
};
const CONTACT_DIRECTION = {
    INBOUND: "INBOUND",
    OUTBOUND: "OUTBOUND"
};
const OUTBOUND_TYPE = {
    CAMPAIGN: "CAMPAIGN",
    COURTESY_CALLBACK: "COURTESY_CALLBACK",
    CALLBACK: "CALLBACK",
    PROGRESSIVE_CAMPAIGN: "PROGRESSIVE_CAMPAIGN",
    CAMPAIGN_OUTDIAL_CUSTOMER: "CAMPAIGN_OUTDIAL_CUSTOMER",
    CAMPAIGN_PREDICTIVE_OUTDIAL_CUSTOMER: "CAMPAIGN_PREDICTIVE_OUTDIAL_CUSTOMER",
    OUTDIAL_RESERVATION: "OUTDIAL_RESERVATION"
};
const SUPERVISOR = "supervisor";
const AGENT = "agent";
const SUPERVISOR_AND_AGENT = "supervisor and agent";
const AGENT_AND_SUPERVISOR = "agent_supervisor";
const channelList = [
    { name: "Voice", value: "telephony" },
    { name: "Chat", value: "chat" },
    { name: "Email", value: "email" },
    { name: "Social", value: "social" }
];
const LOGGED_OUT = "LoggedOut";
const SIGNED_OUT = "Signed Out";
const AVAILABLE = "Available";
const AVAILABLE_ID = "0";
const IDLE = "Idle";
const DELETE = "DELETE";
const TELEPHONY = "telephony";
const TIMER_FIELDS = ["contactStatusTime", "totalContactDuration", "agentInteractionTime"];
//tpw custom events
const TPW_FILTER_DATA_UPDATE = "tpw-filter-data-update";
const TPW_FILTER_UPDATED = "tpw-filter-updated";
const TPW_MONITOR_MODAL = "tpw-monitor-modal";
const TPW_EMPTY_COLUMN_VALUE = "-";
const TPW_CONTACT_UPDATE = "tpw-contact-update";
const TPW_FILTER_MODAL_UPDATED = "tpw-applied-filters-updated";
const TPW_AGENT_STATE_SELECTOR_LOADING_CHANGED = "tpw-agent-state-selector-loading-changed";
const ACTIONS = "actions";
const FLOW_ACTIVITY = "flow-activity";
const MONITORING_STARTED = "monitoring-started";
const MONITORING_ENDED = "monitoring-ended";
const MONITORING_REQUESTED = "monitoring-requested";
const MONITORING_HOLD = "monitoring-hold";
const MONITORING_UNHOLD = "monitoring-unhold";
const MONITORING_ERROR = "monitoring-error";
const CONTACT_COMPLETED = "contact-completed";
const CONTACT_STATS_HISTORICAL_EVENTS = [CONTACT_COMPLETED, "wrapup-completed", "treatment-completed", "parked"];
const INBOUND = "inbound";
const CONFERENCE_REQUESTED = "conference-requested";
const CONFERENCE_STARTED = "conference-started";
const HOLD_COMPLETED = "hold-completed";
const HOLD_COMPLETED_CONFERENCE = "hold-completed-conference";
const HOLD_COMPLETED_CONSULT = "hold-completed-consult";
const HOLD_STARTED_CONFERENCE = "hold-started-conference";
const CONSULT_REQUESTED = "consult-requested";
const CONSULT_STARTED = "consult-started";
const JOIN_CONFERENCE = "join-conference";
const EXIT_CONFERENCE = "exit-conference";
const PRIMARY_OWNER_CHANGED = "primary-owner-changed";
const TRANSFER_COMPLETED = "transfer-completed";
const QUEUE_TRANSFER_COMPLETED = "queueTransfer-completed";
const EP_TRANSFER_COMPLETED = "epTransfer-complete";
const BLIND_TRANSFER_COMPLETED = "blindTransfer-completed";
const WRAP_UP = "wrapup";
const WRAP_UP_ASSISTANCE = "wrapup-assistance";
const CALL_ENDED = "call-ended";
const OPEN_REVIEW_AND_MONITOR_MODAL = "open-review-and-monitor-modal";
const OPEN_SEND_MESSAGE_MODAL = "open-send-message-modal";
const FILTER_CHANGE_DELAY = 500;
const SELECTED_CHANGE_DELAY = 200;
const REALTIME_FEED = "RealtimeFeed";
const SUBSCRIPTION_RESPONSE = "SubscriptionResponse";
const CONNECTED_CONSULTING = "connected-consulting";
const IDLE_CONSULTING = "idle-consulting";
const AVAILABLE_CONSULTING = "available-consulting";
const CONNECTED = "connected";
const ON_HOLD = "on-hold";
const CONFERENCING = "conferencing";
const CONSULT_DONE = "consult-done";
const CONSULT_ERROR = "consult-error";
const CAPTURE_STARTED = "capture-started";
const HOLD_STARTED = "hold-started";
const HOLD_STARTED_CONSULT = "hold-completed-consult";
const WRAP_UP_COMPLETED = "wraup-completed";
const CONSULT_COMPLETED = "consult-completed";
const CONFERENCE_COMPLETED = "conference-completed";
const AGENTCONNECT_COMPLETED = "agentConnect-completed";
const POST_CALL_STARTED = "postcall-started-main";
const POST_CALL_CONSULT_STARTED = "postcall-started-consult";
const SEARCH_THRESHOLD = 3;
const PROFILE_SETTING_INVALID_DATA_EVENT = "profile-settings-invalid-data";
const HANDLE_AID_MODAL_EVENT = "handle-aid-modal";
const HANDLE_WEBEX_CHAT_EVENT = "handle-webex-chat";
const HANDLE_WEBEX_CHAT_CLOSE_EVENT = "webexchat-overlay-close";
const HANDLE_STATE_CHANGE_EVENT = "handle-state-change";
const HANDLE_AGENT_SIGNOUT_EVENT = "handle-agent-signout";
const UPDATE_ACTION_CELL_VALUE_EVENT = "update-actions-cell-value";
const STATE_CHANGE_OVERLAY_CLOSE_EVENT = "state-change-overlay-close";
const STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON = "STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT";
const STATE_CHANGE_DISALLOWED_IN_PENDING_LOGOUT_REASON_CODE = 1087;
const REVIEW_BUTTON_LIGHT = "/images/illustrations/Monitoring-regular-light.svg";
const REVIEW_BUTTON_DARK = "/images/illustrations/Monitoring-regular-dark.svg";
const REVIEW_BUTTON_LIGHT_DISABLED = "/images/illustrations/LightMode-Monitoring-Disabled.svg";
const REVIEW_BUTTON_DARK_DISABLED = "/images/illustrations/DarkMode-Monitoring-Disabled.svg";
const SUPERVISOR_AUTO_LOGIN_EVENT = "supervisor-auto-login";
const CONTACT_TRANSFERRED_EVENTS = [
    TRANSFER_COMPLETED,
    QUEUE_TRANSFER_COMPLETED,
    EP_TRANSFER_COMPLETED,
    BLIND_TRANSFER_COMPLETED
];
// List of Contact status events, that define the interaction is active.
const CONTACT_ACTIVE_EVENTS = [
    "connected",
    "consulting",
    "on-hold",
    "hold-done",
    "consult-done",
    "consult",
    "conferencing",
    "available-consulting",
    "connected-consulting",
    "idle-consulting"
];
const AGENTX_WEBEX_WRAPPER_CLOSE = "agentx-webex-wrapper-close";
const AGENTX_WEBEX_MINIMIZE_RESTORE = "agentx-webex-minimize-restore";
const AGENT_STATE_CHANGE_FAILED = "agent-state-change-failed";
const AGENT_SIGNOUT_RESULT = "agent-signout-result";
const AGENT_SIGNOUT_REASON = "SupervisorSignout";
const HELP_LINK = {
    AGENT_HELP: "https://help.webex.com/en-us/landing/ld-sxjj9p-WebexContactCenter/Agent",
    SUPERVISOR_HELP: "https://help.webex.com/en-us/landing/ld-sxjj9p-WebexContactCenter/Supervisor"
};
const WEB_RTC_STATUS = {
    WEB_RTC_CONNECTED: "webRtcConnected",
    WEB_RTC_REGISTERING: "webRtcRegistering",
    WEB_RTC_DISCONNECTED: "webRtcDisconnected"
};
const ACCESS_IDLE_CODES = {
    ALL: "ALL",
    SPECIFIC: "SPECIFIC"
};
const CHANGED_BY_ROLE = {
    SELF: "SELF",
    SUPERVISOR: "SUPERVISOR",
    ADMIN: "ADMIN",
    SYSTEM: "SYSTEM"
};
const DESKTOP = "Desktop";
const APPLE_MESSAGE_DARK_SVG = "/images/illustrations/apple-messages-dark.svg";
const APPLE_MESSAGE_LIGHT_SVG = "/images/illustrations/apple-messages-light.svg";
const MONITORING_REGULAR_DARK = "/images/illustrations/Monitoring-regular-dark.svg";
const MONITORING_REGULAR_LIGHT = "/images/illustrations/Monitoring-regular-light.svg";
const TIMEOUT_THOUSAND_MS = 1000;
const MIN_WIDTH = "227px";
const INITIATE_MS_AUTH_LOGIN = "initiate-microsoft-auth-flow";
const TPW_DATA_WAIT_TIME = 20000;
const PRESENCE_SYNC = "PRESENCE_SYNC";
const emergency911HelpLink = "https://help.webex.com/mwjlgk";
const WEBRTC_SHORTCUT_KEYS = [
    {
        widgetElement: "agentx-react-interaction-control",
        group: "app:keyboardShortcutKeys.interactionControl.componentName",
        action: "app:keyboardShortcutKeys.interactionControl.muteOrUnmuteWebCall",
        modifierKeys: "ctrlKey_shiftKey",
        key: "n",
        role: "agent",
        deviceType: "BROWSER"
    },
    {
        widgetElement: "agentx-react-interaction-control",
        group: "app:keyboardShortcutKeys.interactionControl.componentName",
        action: "app:keyboardShortcutKeys.interactionControl.openKeyboard",
        modifierKeys: "ctrlKey_altKey",
        key: "k",
        role: "agent",
        deviceType: "BROWSER"
    }
];
const ICON_SRC = "icon src";
const DIGITAL_OUTBOUND = "app:outboundMessage";
const OUT_DIAL = "OUTDIAL";
const COLUMN_MENU_FOCUS = "column-menu-focus";
const OUTDIAL = "outdial";
const TIMEOUT_TEN_MS = 10;
const TEAM_SELECT_EVENT = "on-team-selected";
const CHEVRON_ICON = {
    UP: "arrow-up-bold",
    DOWN: "arrow-down-bold"
};
const RECORDS_ONE_HUNDRED = 100;
const helpPageLangCode = {
    bg: "bg-bg",
    // ca: "ca-es", // Catalan - Spain help page is not working so commented for fallback - en us
    "zh-cn": "zh-cn",
    "zh-tw": "zh-tw",
    hr: "hr-hr",
    cs: "cs-cz",
    da: "da-dk",
    uk: "uk-ua",
    nl: "nl-nl",
    en: "en-us",
    // "en-gb": "en-gb", // English - United Kingdom commented for fall back en us
    fi: "fi-fi",
    "fr-fr": "fr-fr",
    "de-de": "de-de",
    hu: "hu-hu",
    it: "it-it",
    ja: "ja-jp",
    ko: "ko-kr",
    no: "no-no",
    nb: "no-no",
    pl: "pl-pl",
    pt: "pt-br",
    "pt-br": "pt-br",
    ro: "ro-ro",
    ru: "ru-ru",
    sr: "sr-rs",
    sk: "sk-sk",
    sl: "sl-si",
    "es-co": "es-co",
    sv: "sv-se",
    tr: "tr-tr" // Turkish - Turkey
};
var AutoLoginType;
(function (AutoLoginType) {
    AutoLoginType["None"] = "none";
    AutoLoginType["Agent"] = "agent";
    AutoLoginType["Supervisor"] = "supervisor";
})(AutoLoginType || (AutoLoginType = {}));
const CALLBACK_LIST_ITEM_SIZE = 86;
const MIN_CALLBACK_LIST_ITEMS = 2;
const MAX_CALLBACK_LIST_ITEMS = 8;
const CALLBACK_ACTIONS_LIST = ["delete", "edit"];


/***/ }),

/***/ "./src/mixins/i18nMixin.ts":
/*!*********************************!*\
  !*** ./src/mixins/i18nMixin.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i18nMixin: () => (/* binding */ i18nMixin),
/* harmony export */   t: () => (/* binding */ t)
/* harmony export */ });
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__);


const i18nMixin = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__.I18N.createMixin({ i18n: _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.i18n });
function t(...args) {
    // Testing
    if (false) {}
    return _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_0__.SERVICE.i18n.t(...args);
}


/***/ }),

/***/ "./src/sdk.ts":
/*!********************!*\
  !*** ./src/sdk.ts ***!
  \********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   logger: () => (/* binding */ logger),
/* harmony export */   notifications: () => (/* binding */ notifications)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);

const objKeysToBeMasked = {
    ani: true,
    dn: true,
    agent_ani: true,
    dnis: true,
    email: true,
    callAssociatedData: true,
    title: true,
    text: true,
    agentName: true,
    agentMailId: true,
    userName: true,
    emails: true,
    sipAddresses: true
};
const logger = (0,_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.createLogger)("agentx-mfe-wc-based", objKeysToBeMasked);
const notifications = (0,_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.createNotifications)();


/***/ }),

/***/ "./src/utils/WindowListenersHub.ts":
/*!*****************************************!*\
  !*** ./src/utils/WindowListenersHub.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WINDOW_LISTENERS_HUB: () => (/* binding */ WINDOW_LISTENERS_HUB)
/* harmony export */ });
class WindowListenersHub {
    constructor() {
        this.listeners = {};
        this.listenersWrappers = {};
    }
    on(eventName, listener) {
        // One window listener per eventName
        if (!this.listeners[eventName]) {
            this.listeners[eventName] = [];
            this.listenersWrappers[eventName] = (e) => this.listeners[eventName].forEach((registeredListener) => registeredListener.call(registeredListener, e));
            window.addEventListener(eventName, this.listenersWrappers[eventName]);
        }
        this.listeners[eventName].push(listener);
        return () => this.off(eventName, listener);
    }
    off(eventName, listener) {
        if (this.listeners[eventName]) {
            const idx = this.listeners[eventName].findIndex((l) => l === listener);
            if (idx !== -1) {
                this.listeners[eventName].splice(idx, 1);
                if (this.listeners[eventName].length < 1) {
                    window.removeEventListener(eventName, this.listenersWrappers[eventName]);
                    delete this.listeners[eventName];
                    delete this.listenersWrappers[eventName];
                }
            }
        }
    }
    once(eventName, listener, onceConditionChecker) {
        const _listener = (...args) => {
            let res = true;
            if (typeof onceConditionChecker === "function") {
                res = onceConditionChecker(...args);
            }
            if (res) {
                listener(...args);
                this.off(eventName, _listener);
            }
        };
        this.on(eventName, _listener);
        return () => this.off(eventName, _listener);
    }
    dispatch(e) {
        window.dispatchEvent(e);
    }
    allOff(eventName) {
        const offEventName = (_eventName) => {
            if (_eventName in this.listeners) {
                let i = this.listeners[_eventName].length;
                while (i) {
                    const listener = this.listeners[_eventName][i - 1];
                    this.off(_eventName, listener);
                    i--;
                }
            }
        };
        if (eventName) {
            offEventName(eventName);
        }
        else {
            Object.keys(this.listeners).forEach((registeredEvent) => offEventName(registeredEvent));
        }
    }
}
const WINDOW_LISTENERS_HUB = new WindowListenersHub();


/***/ }),

/***/ "./src/utils/helpers.ts":
/*!******************************!*\
  !*** ./src/utils/helpers.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   checkForTelemetryTracking: () => (/* binding */ checkForTelemetryTracking),
/* harmony export */   debounce: () => (/* binding */ debounce),
/* harmony export */   formatTimeRangeForCallbackTitle: () => (/* binding */ formatTimeRangeForCallbackTitle),
/* harmony export */   getImageSrcTaskList: () => (/* binding */ getImageSrcTaskList),
/* harmony export */   getMediaChannelForTaskList: () => (/* binding */ getMediaChannelForTaskList),
/* harmony export */   getTimerLabel: () => (/* binding */ getTimerLabel),
/* harmony export */   isDigitalOutboundCase: () => (/* binding */ isDigitalOutboundCase),
/* harmony export */   isIconSrc: () => (/* binding */ isIconSrc),
/* harmony export */   isMicrophoneAccessDenied: () => (/* binding */ isMicrophoneAccessDenied),
/* harmony export */   isOutboundContact: () => (/* binding */ isOutboundContact),
/* harmony export */   isRegistered: () => (/* binding */ isRegistered),
/* harmony export */   isTaskItemCardVisible: () => (/* binding */ isTaskItemCardVisible),
/* harmony export */   isWebRtcSupportedBrowser: () => (/* binding */ isWebRtcSupportedBrowser),
/* harmony export */   makeAlphaNumericReadable: () => (/* binding */ makeAlphaNumericReadable),
/* harmony export */   makeTelephonyReadable: () => (/* binding */ makeTelephonyReadable),
/* harmony export */   naturalSort: () => (/* binding */ naturalSort),
/* harmony export */   registerWebRTCShortcuts: () => (/* binding */ registerWebRTCShortcuts),
/* harmony export */   removeWebRTCShortcuts: () => (/* binding */ removeWebRTCShortcuts),
/* harmony export */   stripSpecialChar: () => (/* binding */ stripSpecialChar),
/* harmony export */   throttle: () => (/* binding */ throttle),
/* harmony export */   updateTimerAriaLabel: () => (/* binding */ updateTimerAriaLabel)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/constants */ "./src/constants.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @agentx/agentx-services */ "@agentx/agentx-services");
/* harmony import */ var _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_3__);
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




const throttle = (fn, delay = 1000 / 60) => {
    let lastTimeoutRef = undefined;
    let last = Date.now();
    // Throttling
    const next = (...args) => {
        const now = Date.now();
        window.clearTimeout(lastTimeoutRef);
        if (!last || now - last >= delay) {
            last = now;
            fn.call(fn, ...args);
        }
        else {
            lastTimeoutRef = window.setTimeout(() => next(...args), delay - (now - last));
        }
    };
    return (...args) => next(...args);
};
const isRegistered = (name) => {
    return document.createElement(name).constructor !== HTMLElement;
};
const isTaskItemCardVisible = (cardElement, cardContainerElement) => {
    const data = {
        arrowDir: "",
        isVisible: false
    };
    if (cardElement.getBoundingClientRect().top < 65 && cardContainerElement instanceof HTMLElement) {
        data.isVisible = false;
        data.arrowDir = "top";
    }
    else if (cardElement.getBoundingClientRect().top > cardContainerElement.clientHeight) {
        data.isVisible = false;
        data.arrowDir = "down";
    }
    else {
        data.isVisible = true;
    }
    return data;
};
/**
 * Debounce method to avoid repetative  call
 */
const debounce = (fn, time) => {
    let timer;
    return function (...args) {
        const func = () => fn.call({}, args[0]);
        clearTimeout(timer);
        timer = window.setTimeout(func, time);
    };
};
const checkForTelemetryTracking = (navigateTo) => {
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.setValueInCache(navigateTo, new Date().getTime());
};
const stripSpecialChar = (str) => {
    /*eslint no-useless-escape: "off"*/
    return str.replace(/[^\+?\d]/gi, "");
};
const checkSupportedBrowsers = () => {
    if (!navigator) {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[WebRTC]: navigator is not available");
    }
    const userAgent = (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) || "";
    _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[WebRTC]: User Agent: ${userAgent}`);
    const supportedBrowsers = ["Chrome", "Edg", "Firefox"];
    const isSupported = !!supportedBrowsers.find((browser) => {
        return userAgent.includes(browser);
    });
    const isLegacyEdge = userAgent.includes("Edge");
    return isSupported && !isLegacyEdge;
};
const isWebRtcSupportedBrowser = () => {
    return checkSupportedBrowsers();
};
const isMicrophoneAccessDenied = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const mediaStream = yield navigator.mediaDevices.getUserMedia({ audio: true });
        if (!mediaStream) {
            return true;
        }
        else {
            mediaStream.getTracks().forEach((track) => track.stop());
        }
    }
    catch (error) {
        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[WebRtc] microphone access error", error);
        return true;
    }
    return false;
});
const registerWebRTCShortcuts = () => {
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.register(_constants__WEBPACK_IMPORTED_MODULE_0__.WEBRTC_SHORTCUT_KEYS);
};
const removeWebRTCShortcuts = () => {
    const shortcutKeyMap = Array.from(_agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.getRegisteredKeys().values());
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.unregisterAllKeys();
    _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.shortcut.register(shortcutKeyMap.filter((data) => !data.deviceType || data.deviceType !== "BROWSER"));
};
const isOutboundContact = (direction, outboundType) => {
    return direction === _constants__WEBPACK_IMPORTED_MODULE_0__.CONTACT_DIRECTION.OUTBOUND && outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUT_DIAL;
};
const getMediaChannelForTaskList = (mediaChannel, direction, outboundType) => {
    if (isOutboundContact(direction, outboundType !== null && outboundType !== void 0 ? outboundType : "")) {
        if (mediaChannel && mediaChannel === _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.EMAIL) {
            return _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.OUTBOUND_AGENT_INITIATED_EMAIL;
        }
        if (mediaChannel && mediaChannel === _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.SMS) {
            return _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.OUTBOUND_AGENT_INITIATED_SMS;
        }
        return mediaChannel;
    }
    return mediaChannel;
};
/**
 *
 * @param mediaType
 * @param mediaChannel
 * @returns
 */
const getImageSrcTaskList = (mediaType, mediaChannel, isDarkMode, selected = false, contactDirection, outboundType) => {
    let imgSrc;
    const derivedMediaChannel = getMediaChannelForTaskList(mediaChannel, contactDirection, outboundType);
    if (mediaType === _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.MIDCALL_MONITORING) {
        imgSrc = isDarkMode ? _constants__WEBPACK_IMPORTED_MODULE_0__.MONITORING_REGULAR_DARK : _constants__WEBPACK_IMPORTED_MODULE_0__.MONITORING_REGULAR_LIGHT;
    }
    else if (derivedMediaChannel &&
        _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel]) {
        if (selected) {
            imgSrc = isDarkMode
                ? _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel]["normal"].dark
                : _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel]["normal"].light;
        }
        else {
            imgSrc = isDarkMode
                ? _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel]["unselected"].dark
                : _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[derivedMediaChannel]["unselected"].light;
        }
    }
    return imgSrc;
};
const isDigitalOutboundCase = (mediaChannel, contactDirection, outboundType) => {
    return (contactDirection === _constants__WEBPACK_IMPORTED_MODULE_0__.CONTACT_DIRECTION.OUTBOUND &&
        outboundType === _constants__WEBPACK_IMPORTED_MODULE_0__.OUT_DIAL &&
        (mediaChannel === _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.EMAIL || mediaChannel === _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.SMS));
};
/**
 *
 * @param mediaType
 * @param mediaChannel
 * @returns
 */
const isIconSrc = (mediaType, mediaChannel, contactDirection, outboundType) => {
    return (mediaType === _constants__WEBPACK_IMPORTED_MODULE_0__.MEDIA_TYPES.MIDCALL_MONITORING ||
        isDigitalOutboundCase(mediaChannel !== null && mediaChannel !== void 0 ? mediaChannel : "", contactDirection, outboundType) ||
        (mediaChannel &&
            _agentx_agentx_services__WEBPACK_IMPORTED_MODULE_2__.SERVICE.constants.MEDIA_SUBCHANNEL_TYPES[mediaChannel]
            ? true
            : false));
};
const getTimerLabel = (timer) => {
    const timeUnits = ["hour", "minute", "second"];
    const parts = timer
        .split(":")
        .map(Number)
        .map((value, i) => (value > 0 ? `${value} ${timeUnits[i]}${value !== 1 ? "s" : ""}` : ""))
        .filter(Boolean);
    return `${parts.join(", ")}`;
};
const makeTelephonyReadable = (num) => {
    return num ? num.split("").join(" ").replace(/ {2}/g, " ") : "";
};
const updateTimerAriaLabel = (timeStamp) => {
    const now = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.utc();
    const taskTime = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromMillis(timeStamp);
    const diff = now.diff(taskTime);
    const formattedDifference = diff.toFormat("hh:mm:ss");
    return getTimerLabel(formattedDifference);
};
const makeAlphaNumericReadable = (inputString) => {
    if (!inputString) {
        return "";
    }
    const isDigit = (char) => /\d/.test(char);
    const modifiedStr = inputString
        .split("")
        .map((char) => {
        if (isDigit(char)) {
            return ` ${char} `;
        }
        return char;
    })
        .join("");
    return modifiedStr.replace(/\s+/g, " ").trim();
};
const naturalSort = (a, b) => {
    return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
};
const formatTimeRangeForCallbackTitle = (startTime, endTime) => {
    const startParts = startTime.split(":");
    let startHour = parseInt(startParts[0], 10);
    const startMinutes = startParts[1];
    const startPeriod = startHour >= 12 ? "PM" : "AM";
    startHour = startHour % 12 || 12;
    const endParts = endTime.split(":");
    let endHour = parseInt(endParts[0], 10);
    const endMinutes = endParts[1];
    const endPeriod = endHour >= 12 ? "PM" : "AM";
    endHour = endHour % 12 || 12;
    return `${startHour}:${startMinutes}${startPeriod}-${endHour}:${endMinutes}${endPeriod}`;
};
/**
 * Validates the use-case for digital outbound contacts for auto-accept.
 * @param mediaChannel - i.e. email, sms etc.
 * @param contactDirection - i.e. INBOUND, OUTBOUND etc.
 * @param outboundType - i.e. OUTDIAL etc.
 * Returns a boolean.
 */


/***/ }),

/***/ "@adobe/lit-mobx":
/*!**********************************!*\
  !*** external "@adobe/lit-mobx" ***!
  \**********************************/
/***/ ((module) => {

"use strict";
module.exports = require("@adobe/lit-mobx");

/***/ }),

/***/ "@agentx/agentx-services":
/*!******************************************!*\
  !*** external "@agentx/agentx-services" ***!
  \******************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@agentx/agentx-services");

/***/ }),

/***/ "@momentum-ui/web-components":
/*!**********************************************!*\
  !*** external "@momentum-ui/web-components" ***!
  \**********************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@momentum-ui/web-components");

/***/ }),

/***/ "@open-wc/testing-helpers":
/*!*******************************************!*\
  !*** external "@open-wc/testing-helpers" ***!
  \*******************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@open-wc/testing-helpers");

/***/ }),

/***/ "@popperjs/core":
/*!*********************************!*\
  !*** external "@popperjs/core" ***!
  \*********************************/
/***/ ((module) => {

"use strict";
module.exports = require("@popperjs/core");

/***/ }),

/***/ "@popperjs/core/lib/popper":
/*!********************************************!*\
  !*** external "@popperjs/core/lib/popper" ***!
  \********************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@popperjs/core/lib/popper");

/***/ }),

/***/ "@uuip/unified-ui-platform-common-components":
/*!**************************************************************!*\
  !*** external "@uuip/unified-ui-platform-common-components" ***!
  \**************************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@uuip/unified-ui-platform-common-components");

/***/ }),

/***/ "@uuip/unified-ui-platform-sdk":
/*!************************************************!*\
  !*** external "@uuip/unified-ui-platform-sdk" ***!
  \************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@uuip/unified-ui-platform-sdk");

/***/ }),

/***/ "ag-charts-enterprise":
/*!***************************************!*\
  !*** external "ag-charts-enterprise" ***!
  \***************************************/
/***/ ((module) => {

"use strict";
module.exports = require("ag-charts-enterprise");

/***/ }),

/***/ "ag-grid-enterprise":
/*!*************************************!*\
  !*** external "ag-grid-enterprise" ***!
  \*************************************/
/***/ ((module) => {

"use strict";
module.exports = require("ag-grid-enterprise");

/***/ }),

/***/ "lit-element":
/*!******************************!*\
  !*** external "lit-element" ***!
  \******************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-element");

/***/ }),

/***/ "lit-html":
/*!***************************!*\
  !*** external "lit-html" ***!
  \***************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html");

/***/ }),

/***/ "lit-html/directives/class-map":
/*!************************************************!*\
  !*** external "lit-html/directives/class-map" ***!
  \************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/directives/class-map");

/***/ }),

/***/ "lit-html/directives/if-defined":
/*!*************************************************!*\
  !*** external "lit-html/directives/if-defined" ***!
  \*************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/directives/if-defined");

/***/ }),

/***/ "lit-html/directives/if-defined.js":
/*!****************************************************!*\
  !*** external "lit-html/directives/if-defined.js" ***!
  \****************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/directives/if-defined.js");

/***/ }),

/***/ "lit-html/directives/repeat":
/*!*********************************************!*\
  !*** external "lit-html/directives/repeat" ***!
  \*********************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/directives/repeat");

/***/ }),

/***/ "lit-html/directives/style-map":
/*!************************************************!*\
  !*** external "lit-html/directives/style-map" ***!
  \************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/directives/style-map");

/***/ }),

/***/ "lit-html/lib/part":
/*!************************************!*\
  !*** external "lit-html/lib/part" ***!
  \************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/lib/part");

/***/ }),

/***/ "lit-virtualizer":
/*!**********************************!*\
  !*** external "lit-virtualizer" ***!
  \**********************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-virtualizer");

/***/ }),

/***/ "luxon":
/*!************************!*\
  !*** external "luxon" ***!
  \************************/
/***/ ((module) => {

"use strict";
module.exports = require("luxon");

/***/ }),

/***/ "mobx":
/*!***********************!*\
  !*** external "mobx" ***!
  \***********************/
/***/ ((module) => {

"use strict";
module.exports = require("mobx");

/***/ }),

/***/ "process/browser.js":
/*!*************************************!*\
  !*** external "process/browser.js" ***!
  \*************************************/
/***/ ((module) => {

"use strict";
module.exports = require("process/browser.js");

/***/ }),

/***/ "uuid":
/*!***********************!*\
  !*** external "uuid" ***!
  \***********************/
/***/ ((module) => {

"use strict";
module.exports = require("uuid");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "/";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentPerformanceReports: () => (/* reexport safe */ _components_AgentPerformanceReports_AgentPerformanceReports__WEBPACK_IMPORTED_MODULE_6__.AgentPerformanceReports),
/* harmony export */   AgentPerformanceWidget: () => (/* reexport safe */ _components_AgentPerformanceWidget_AgentPerformanceWidget__WEBPACK_IMPORTED_MODULE_8__.AgentPerformanceWidget),
/* harmony export */   AgentXLoadingScreen: () => (/* reexport safe */ _components_StationLogin_AppLoadingScreen__WEBPACK_IMPORTED_MODULE_37__.AgentXLoadingScreen),
/* harmony export */   ChannelFilter: () => (/* reexport safe */ _components_SupervisorFilters_ChannelFilter_ChannelFilter__WEBPACK_IMPORTED_MODULE_38__.ChannelFilter),
/* harmony export */   CollapseArea: () => (/* reexport safe */ _components_CollapseArea_CollapseArea__WEBPACK_IMPORTED_MODULE_9__.CollapseArea),
/* harmony export */   CollapseToggler: () => (/* reexport safe */ _components_CollapseArea_components_CollapseToggler__WEBPACK_IMPORTED_MODULE_10__.CollapseToggler),
/* harmony export */   CountDownTimer: () => (/* reexport safe */ _components_CountDownTimer_CountDownTimer__WEBPACK_IMPORTED_MODULE_21__.CountDownTimer),
/* harmony export */   EvaluationManagerForm: () => (/* reexport safe */ _components_EvaluationManager_EvaluationManagerForm__WEBPACK_IMPORTED_MODULE_22__.EvaluationManagerForm),
/* harmony export */   EvaluationManagerTable: () => (/* reexport safe */ _components_EvaluationManager_EvaluationManagerTable__WEBPACK_IMPORTED_MODULE_23__.EvaluationManagerTable),
/* harmony export */   Frame: () => (/* reexport safe */ _components_Common_Frame_Frame__WEBPACK_IMPORTED_MODULE_11__.Frame),
/* harmony export */   GridWidget: () => (/* reexport safe */ _components_GridWidget_Grid__WEBPACK_IMPORTED_MODULE_24__.GridWidget),
/* harmony export */   IframeBase: () => (/* reexport safe */ _components_IframeBase_IframeBase__WEBPACK_IMPORTED_MODULE_25__.IframeBase),
/* harmony export */   IframeLogin: () => (/* reexport safe */ _components_IframeLogin_IframeLogin__WEBPACK_IMPORTED_MODULE_26__.IframeLogin),
/* harmony export */   ImiChatWrapper: () => (/* reexport safe */ _components_ImiChatWrapper_ImiChatWrapper__WEBPACK_IMPORTED_MODULE_27__.ImiChatWrapper),
/* harmony export */   InteractionsTabDetailsWidget: () => (/* reexport safe */ _components_InteractionsTab_index__WEBPACK_IMPORTED_MODULE_3__.InteractionsTabDetailsWidget),
/* harmony export */   InteractionsTabTableHeader: () => (/* reexport safe */ _components_InteractionsTab_index__WEBPACK_IMPORTED_MODULE_3__.InteractionsTabTableHeader),
/* harmony export */   InteractionsTabWidget: () => (/* reexport safe */ _components_InteractionsTab_index__WEBPACK_IMPORTED_MODULE_3__.InteractionsTabWidget),
/* harmony export */   IvrTranscripts: () => (/* reexport safe */ _components_IvrTranscripts_IvrTranscripts__WEBPACK_IMPORTED_MODULE_28__.IvrTranscripts),
/* harmony export */   MenuNotification: () => (/* reexport safe */ _components_MenuNotifications_MenuNotifications__WEBPACK_IMPORTED_MODULE_29__.MenuNotification),
/* harmony export */   MoreActionsWidget: () => (/* reexport safe */ _components_MoreActions_components_MoreActionsContainer_MoreActionsWidget__WEBPACK_IMPORTED_MODULE_30__.MoreActionsWidget),
/* harmony export */   Navigation: () => (/* reexport safe */ _components_Navigation_Navigation__WEBPACK_IMPORTED_MODULE_32__.Navigation),
/* harmony export */   PageHeader: () => (/* reexport safe */ _components_Common_Headers_index__WEBPACK_IMPORTED_MODULE_0__.PageHeader),
/* harmony export */   PanelFrame: () => (/* reexport safe */ _components_Common_Panel_index__WEBPACK_IMPORTED_MODULE_1__.PanelFrame),
/* harmony export */   PanelHeader: () => (/* reexport safe */ _components_Common_Headers_index__WEBPACK_IMPORTED_MODULE_0__.PanelHeader),
/* harmony export */   PanelLayout: () => (/* reexport safe */ _components_Common_Panel_index__WEBPACK_IMPORTED_MODULE_1__.PanelLayout),
/* harmony export */   QualityMonitoringWidget: () => (/* reexport safe */ _components_QualityMonitoringWidget_QualityMonitoring__WEBPACK_IMPORTED_MODULE_33__.QualityMonitoringWidget),
/* harmony export */   QueueFilter: () => (/* reexport safe */ _components_SupervisorFilters_QueueFilter_QueueFilter__WEBPACK_IMPORTED_MODULE_39__.QueueFilter),
/* harmony export */   QueueStatsDetail: () => (/* reexport safe */ _components_QueueStatsTab_index__WEBPACK_IMPORTED_MODULE_4__.QueueStatsDetail),
/* harmony export */   QueueStatsHeader: () => (/* reexport safe */ _components_QueueStatsTab_index__WEBPACK_IMPORTED_MODULE_4__.QueueStatsHeader),
/* harmony export */   QueueStatsLanding: () => (/* reexport safe */ _components_QueueStatsTab_index__WEBPACK_IMPORTED_MODULE_4__.QueueStatsLanding),
/* harmony export */   QueueStatsPerformanceDetailsView: () => (/* reexport safe */ _components_QueueStatsTab_index__WEBPACK_IMPORTED_MODULE_4__.QueueStatsPerformanceDetailsView),
/* harmony export */   QueuesMonitoringWidget: () => (/* reexport safe */ _components_QueueStatsTab_index__WEBPACK_IMPORTED_MODULE_4__.QueuesMonitoringWidget),
/* harmony export */   RealtimeTranscript: () => (/* reexport safe */ _components_RealtimeTranscript_RealtimeTranscript__WEBPACK_IMPORTED_MODULE_34__.RealtimeTranscript),
/* harmony export */   ResetTabOrderAction: () => (/* reexport safe */ _components_MoreActions_components_ResetTabOrderAction_ResetTabOrderAction__WEBPACK_IMPORTED_MODULE_31__.ResetTabOrderAction),
/* harmony export */   ScreenPop: () => (/* reexport safe */ _components_ScreenPop_ScreenPop__WEBPACK_IMPORTED_MODULE_35__.ScreenPop),
/* harmony export */   ShortcutKey: () => (/* reexport safe */ _components_ShortcutKey_ShortcutKeyModal__WEBPACK_IMPORTED_MODULE_36__.ShortcutKey),
/* harmony export */   TableActiveCustomizationsRow: () => (/* reexport safe */ _components_Common_TableActiveCustomizationsRow_TableActiveCustomizationsRow__WEBPACK_IMPORTED_MODULE_12__.TableActiveCustomizationsRow),
/* harmony export */   TableCustomizationMenu: () => (/* reexport safe */ _components_Common_TableCustomizationMenu_TableCustomizationMenu__WEBPACK_IMPORTED_MODULE_13__.TableCustomizationMenu),
/* harmony export */   TableCustomizeColumnsMenu: () => (/* reexport safe */ _components_Common_TableCustomizationMenu_TableCustomizeColumnsMenu_TableCustomizeColumnsMenu__WEBPACK_IMPORTED_MODULE_14__.TableCustomizeColumnsMenu),
/* harmony export */   TableCustomizeColumnsRow: () => (/* reexport safe */ _components_Common_TableCustomizationMenu_TableCustomizeColumnsMenu_TableCustomizeColumnsRow_TableCustomizeColumnsRow__WEBPACK_IMPORTED_MODULE_15__.TableCustomizeColumnsRow),
/* harmony export */   TableCustomizeGroupByMenu: () => (/* reexport safe */ _components_Common_TableCustomizationMenu_TableCustomizeGroupByMenu_TableCustomizeGroupByMenu__WEBPACK_IMPORTED_MODULE_16__.TableCustomizeGroupByMenu),
/* harmony export */   TableFilterCategoriesMenu: () => (/* reexport safe */ _components_Common_TableFilterMenu_TableFilterCategoriesMenu_TableFilterCategoriesMenu__WEBPACK_IMPORTED_MODULE_17__.TableFilterCategoriesMenu),
/* harmony export */   TableFilterMenu: () => (/* reexport safe */ _components_Common_TableFilterMenu_index__WEBPACK_IMPORTED_MODULE_2__.TableFilterMenu),
/* harmony export */   TableFilterMultiSelectMenu: () => (/* reexport safe */ _components_Common_TableFilterMenu_index__WEBPACK_IMPORTED_MODULE_2__.TableFilterMultiSelectMenu),
/* harmony export */   TableFilterTimeRangeCategoriesMenu: () => (/* reexport safe */ _components_Common_TableFilterMenu_index__WEBPACK_IMPORTED_MODULE_2__.TableFilterTimeRangeCategoriesMenu),
/* harmony export */   TableHeaderWidget: () => (/* reexport safe */ _components_QueueStatsTab_index__WEBPACK_IMPORTED_MODULE_4__.TableHeaderWidget),
/* harmony export */   TaskList: () => (/* reexport safe */ _components_TaskList_TaskList__WEBPACK_IMPORTED_MODULE_41__.TaskList),
/* harmony export */   TeamFilter: () => (/* reexport safe */ _components_SupervisorFilters_TeamFilter_TeamFilter__WEBPACK_IMPORTED_MODULE_40__.TeamFilter),
/* harmony export */   TeamPerformance: () => (/* reexport safe */ _components_TeamPerformanceWidget_TeamPerformance__WEBPACK_IMPORTED_MODULE_42__.TeamPerformance),
/* harmony export */   TeamsListInfiniteScroll: () => (/* reexport safe */ _components_teamsListInfiniteScroll__WEBPACK_IMPORTED_MODULE_44__.TeamsListInfiniteScroll),
/* harmony export */   UserProfile: () => (/* reexport safe */ _components_userProfile_userProfile__WEBPACK_IMPORTED_MODULE_45__.UserProfile),
/* harmony export */   UserStationLogin: () => (/* reexport safe */ _components_userStationLogin_userStationLogin__WEBPACK_IMPORTED_MODULE_46__.UserStationLogin),
/* harmony export */   WcGridDateRangePicker: () => (/* reexport safe */ _components_Common_WcGrid_WcGridDateRangePicker_WcGridDateRangePicker__WEBPACK_IMPORTED_MODULE_19__.WcGridDateRangePicker),
/* harmony export */   WcGridWidget: () => (/* reexport safe */ _components_Common_WcGrid__WEBPACK_IMPORTED_MODULE_18__.WcGridWidget),
/* harmony export */   WebexWrapper: () => (/* reexport safe */ _components_WebexWrapper_WebexWrapper__WEBPACK_IMPORTED_MODULE_47__.WebexWrapper),
/* harmony export */   WidgetError: () => (/* reexport safe */ _components_Common_WidgetError_WidgetError__WEBPACK_IMPORTED_MODULE_20__.WidgetError),
/* harmony export */   analyzerSessionHelper: () => (/* reexport safe */ _components_AgentPerformanceReports_AnalyzerSessionHelper__WEBPACK_IMPORTED_MODULE_7__.analyzerSessionHelper),
/* harmony export */   getAgentInteractionTime: () => (/* reexport safe */ _components_TeamPerformanceWidget_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_43__.getAgentInteractionTime),
/* harmony export */   getParticipantsDetails: () => (/* reexport safe */ _components_TeamPerformanceWidget_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_43__.getParticipantsDetails),
/* harmony export */   initAgentxMfeWcBased: () => (/* binding */ initAgentxMfeWcBased),
/* harmony export */   isMicrophoneAccessDenied: () => (/* reexport safe */ _utils_helpers__WEBPACK_IMPORTED_MODULE_48__.isMicrophoneAccessDenied),
/* harmony export */   isWebRtcSupportedBrowser: () => (/* reexport safe */ _utils_helpers__WEBPACK_IMPORTED_MODULE_48__.isWebRtcSupportedBrowser),
/* harmony export */   makeAlphaNumericReadable: () => (/* reexport safe */ _utils_helpers__WEBPACK_IMPORTED_MODULE_48__.makeAlphaNumericReadable),
/* harmony export */   mapAgentContactStatus: () => (/* reexport safe */ _components_TeamPerformanceWidget_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_43__.mapAgentContactStatus)
/* harmony export */ });
/* harmony import */ var _components_Common_Headers_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./components/Common/Headers/index */ "./src/components/Common/Headers/index.ts");
/* harmony import */ var _components_Common_Panel_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/Common/Panel/index */ "./src/components/Common/Panel/index.ts");
/* harmony import */ var _components_Common_TableFilterMenu_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components/Common/TableFilterMenu/index */ "./src/components/Common/TableFilterMenu/index.ts");
/* harmony import */ var _components_InteractionsTab_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/InteractionsTab/index */ "./src/components/InteractionsTab/index.ts");
/* harmony import */ var _components_QueueStatsTab_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/QueueStatsTab/index */ "./src/components/QueueStatsTab/index.ts");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./config */ "./src/config.ts");
/* harmony import */ var _components_AgentPerformanceReports_AgentPerformanceReports__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./components/AgentPerformanceReports/AgentPerformanceReports */ "./src/components/AgentPerformanceReports/AgentPerformanceReports.ts");
/* harmony import */ var _components_AgentPerformanceReports_AnalyzerSessionHelper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./components/AgentPerformanceReports/AnalyzerSessionHelper */ "./src/components/AgentPerformanceReports/AnalyzerSessionHelper.ts");
/* harmony import */ var _components_AgentPerformanceWidget_AgentPerformanceWidget__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./components/AgentPerformanceWidget/AgentPerformanceWidget */ "./src/components/AgentPerformanceWidget/AgentPerformanceWidget.ts");
/* harmony import */ var _components_CollapseArea_CollapseArea__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./components/CollapseArea/CollapseArea */ "./src/components/CollapseArea/CollapseArea.ts");
/* harmony import */ var _components_CollapseArea_components_CollapseToggler__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./components/CollapseArea/components/CollapseToggler */ "./src/components/CollapseArea/components/CollapseToggler.ts");
/* harmony import */ var _components_Common_Frame_Frame__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./components/Common/Frame/Frame */ "./src/components/Common/Frame/Frame.ts");
/* harmony import */ var _components_Common_TableActiveCustomizationsRow_TableActiveCustomizationsRow__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./components/Common/TableActiveCustomizationsRow/TableActiveCustomizationsRow */ "./src/components/Common/TableActiveCustomizationsRow/TableActiveCustomizationsRow.ts");
/* harmony import */ var _components_Common_TableCustomizationMenu_TableCustomizationMenu__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./components/Common/TableCustomizationMenu/TableCustomizationMenu */ "./src/components/Common/TableCustomizationMenu/TableCustomizationMenu.ts");
/* harmony import */ var _components_Common_TableCustomizationMenu_TableCustomizeColumnsMenu_TableCustomizeColumnsMenu__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./components/Common/TableCustomizationMenu/TableCustomizeColumnsMenu/TableCustomizeColumnsMenu */ "./src/components/Common/TableCustomizationMenu/TableCustomizeColumnsMenu/TableCustomizeColumnsMenu.ts");
/* harmony import */ var _components_Common_TableCustomizationMenu_TableCustomizeColumnsMenu_TableCustomizeColumnsRow_TableCustomizeColumnsRow__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./components/Common/TableCustomizationMenu/TableCustomizeColumnsMenu/TableCustomizeColumnsRow/TableCustomizeColumnsRow */ "./src/components/Common/TableCustomizationMenu/TableCustomizeColumnsMenu/TableCustomizeColumnsRow/TableCustomizeColumnsRow.ts");
/* harmony import */ var _components_Common_TableCustomizationMenu_TableCustomizeGroupByMenu_TableCustomizeGroupByMenu__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./components/Common/TableCustomizationMenu/TableCustomizeGroupByMenu/TableCustomizeGroupByMenu */ "./src/components/Common/TableCustomizationMenu/TableCustomizeGroupByMenu/TableCustomizeGroupByMenu.ts");
/* harmony import */ var _components_Common_TableFilterMenu_TableFilterCategoriesMenu_TableFilterCategoriesMenu__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./components/Common/TableFilterMenu/TableFilterCategoriesMenu/TableFilterCategoriesMenu */ "./src/components/Common/TableFilterMenu/TableFilterCategoriesMenu/TableFilterCategoriesMenu.ts");
/* harmony import */ var _components_Common_WcGrid__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./components/Common/WcGrid */ "./src/components/Common/WcGrid/index.ts");
/* harmony import */ var _components_Common_WcGrid_WcGridDateRangePicker_WcGridDateRangePicker__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./components/Common/WcGrid/WcGridDateRangePicker/WcGridDateRangePicker */ "./src/components/Common/WcGrid/WcGridDateRangePicker/WcGridDateRangePicker.ts");
/* harmony import */ var _components_Common_WidgetError_WidgetError__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./components/Common/WidgetError/WidgetError */ "./src/components/Common/WidgetError/WidgetError.ts");
/* harmony import */ var _components_CountDownTimer_CountDownTimer__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./components/CountDownTimer/CountDownTimer */ "./src/components/CountDownTimer/CountDownTimer.ts");
/* harmony import */ var _components_EvaluationManager_EvaluationManagerForm__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./components/EvaluationManager/EvaluationManagerForm */ "./src/components/EvaluationManager/EvaluationManagerForm.ts");
/* harmony import */ var _components_EvaluationManager_EvaluationManagerTable__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./components/EvaluationManager/EvaluationManagerTable */ "./src/components/EvaluationManager/EvaluationManagerTable.ts");
/* harmony import */ var _components_GridWidget_Grid__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./components/GridWidget/Grid */ "./src/components/GridWidget/Grid.ts");
/* harmony import */ var _components_IframeBase_IframeBase__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./components/IframeBase/IframeBase */ "./src/components/IframeBase/IframeBase.ts");
/* harmony import */ var _components_IframeLogin_IframeLogin__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./components/IframeLogin/IframeLogin */ "./src/components/IframeLogin/IframeLogin.ts");
/* harmony import */ var _components_ImiChatWrapper_ImiChatWrapper__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./components/ImiChatWrapper/ImiChatWrapper */ "./src/components/ImiChatWrapper/ImiChatWrapper.ts");
/* harmony import */ var _components_IvrTranscripts_IvrTranscripts__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./components/IvrTranscripts/IvrTranscripts */ "./src/components/IvrTranscripts/IvrTranscripts.ts");
/* harmony import */ var _components_MenuNotifications_MenuNotifications__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./components/MenuNotifications/MenuNotifications */ "./src/components/MenuNotifications/MenuNotifications.ts");
/* harmony import */ var _components_MoreActions_components_MoreActionsContainer_MoreActionsWidget__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./components/MoreActions/components/MoreActionsContainer/MoreActionsWidget */ "./src/components/MoreActions/components/MoreActionsContainer/MoreActionsWidget.ts");
/* harmony import */ var _components_MoreActions_components_ResetTabOrderAction_ResetTabOrderAction__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./components/MoreActions/components/ResetTabOrderAction/ResetTabOrderAction */ "./src/components/MoreActions/components/ResetTabOrderAction/ResetTabOrderAction.ts");
/* harmony import */ var _components_Navigation_Navigation__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./components/Navigation/Navigation */ "./src/components/Navigation/Navigation.ts");
/* harmony import */ var _components_QualityMonitoringWidget_QualityMonitoring__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./components/QualityMonitoringWidget/QualityMonitoring */ "./src/components/QualityMonitoringWidget/QualityMonitoring.ts");
/* harmony import */ var _components_RealtimeTranscript_RealtimeTranscript__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./components/RealtimeTranscript/RealtimeTranscript */ "./src/components/RealtimeTranscript/RealtimeTranscript.ts");
/* harmony import */ var _components_ScreenPop_ScreenPop__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./components/ScreenPop/ScreenPop */ "./src/components/ScreenPop/ScreenPop.ts");
/* harmony import */ var _components_ShortcutKey_ShortcutKeyModal__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./components/ShortcutKey/ShortcutKeyModal */ "./src/components/ShortcutKey/ShortcutKeyModal.ts");
/* harmony import */ var _components_StationLogin_AppLoadingScreen__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./components/StationLogin/AppLoadingScreen */ "./src/components/StationLogin/AppLoadingScreen.ts");
/* harmony import */ var _components_SupervisorFilters_ChannelFilter_ChannelFilter__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./components/SupervisorFilters/ChannelFilter/ChannelFilter */ "./src/components/SupervisorFilters/ChannelFilter/ChannelFilter.ts");
/* harmony import */ var _components_SupervisorFilters_QueueFilter_QueueFilter__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./components/SupervisorFilters/QueueFilter/QueueFilter */ "./src/components/SupervisorFilters/QueueFilter/QueueFilter.ts");
/* harmony import */ var _components_SupervisorFilters_TeamFilter_TeamFilter__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./components/SupervisorFilters/TeamFilter/TeamFilter */ "./src/components/SupervisorFilters/TeamFilter/TeamFilter.ts");
/* harmony import */ var _components_TaskList_TaskList__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./components/TaskList/TaskList */ "./src/components/TaskList/TaskList.ts");
/* harmony import */ var _components_TeamPerformanceWidget_TeamPerformance__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./components/TeamPerformanceWidget/TeamPerformance */ "./src/components/TeamPerformanceWidget/TeamPerformance.ts");
/* harmony import */ var _components_TeamPerformanceWidget_TeamPerformanceUtils__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./components/TeamPerformanceWidget/TeamPerformanceUtils */ "./src/components/TeamPerformanceWidget/TeamPerformanceUtils.ts");
/* harmony import */ var _components_teamsListInfiniteScroll__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./components/teamsListInfiniteScroll */ "./src/components/teamsListInfiniteScroll/index.ts");
/* harmony import */ var _components_userProfile_userProfile__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./components/userProfile/userProfile */ "./src/components/userProfile/userProfile.ts");
/* harmony import */ var _components_userStationLogin_userStationLogin__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./components/userStationLogin/userStationLogin */ "./src/components/userStationLogin/userStationLogin.ts");
/* harmony import */ var _components_WebexWrapper_WebexWrapper__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./components/WebexWrapper/WebexWrapper */ "./src/components/WebexWrapper/WebexWrapper.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./utils/helpers */ "./src/utils/helpers.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

















































function initAgentxMfeWcBased(config) {
    return __awaiter(this, void 0, void 0, function* () {
        (0,_config__WEBPACK_IMPORTED_MODULE_5__.setAgentxMfeWcBasedConfig)(config);
    });
}

})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map